
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("gP1fu", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $f7f2b18b91bed6f1$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $f7f2b18b91bed6f1$export$2e2bcd8739ae039 = {
    'act.action.dismissalMessage.common.text': "You won\u2019t see this here as often.",
    'act.action.notInterested.button.text': 'Not interested',
    'act.action.notInterestedFlag.flag.text': 'Got it, thanks for letting us know',
    'act.action.reasonsModalOkButton.common.text': 'OK',
    'act.action.showReasons.common.text': 'Why am I seeing this?'
};

});

parcelRegister("7gWdR", function(module, exports) {

$parcel$export(module.exports, "draggable", () => (parcelRequire("40DDD")).draggable);
$parcel$export(module.exports, "dropTargetForElements", () => (parcelRequire("40DDD")).dropTargetForElements);
$parcel$export(module.exports, "monitorForElements", () => (parcelRequire("40DDD")).monitorForElements);

var $40DDD = parcelRequire("40DDD");

});
parcelRegister("40DDD", function(module, exports) {

$parcel$export(module.exports, "dropTargetForElements", () => $0b9136830a524a8f$export$e7140b68045b5036);
$parcel$export(module.exports, "monitorForElements", () => $0b9136830a524a8f$export$59a074bac4c54f54);
$parcel$export(module.exports, "draggable", () => $0b9136830a524a8f$export$c746a5152d4ba26c);

var $cBeZP = parcelRequire("cBeZP");

var $kKgsQ = parcelRequire("kKgsQ");

var $8d5CE = parcelRequire("8d5CE");

var $iiVLC = parcelRequire("iiVLC");

var $3zl3q = parcelRequire("3zl3q");

var $lzZrl = parcelRequire("lzZrl");

var $6XFIM = parcelRequire("6XFIM");

var $aWzmz = parcelRequire("aWzmz");



const $0b9136830a524a8f$var$draggableRegistry = new WeakMap();
function $0b9136830a524a8f$var$addToRegistry(args) {
    $0b9136830a524a8f$var$draggableRegistry.set(args.element, args);
    return function cleanup() {
        $0b9136830a524a8f$var$draggableRegistry.delete(args.element);
    };
}
const $0b9136830a524a8f$var$honeyPotFix = (0, $8d5CE.makeHoneyPotFix)();
const $0b9136830a524a8f$var$adapter = (0, $iiVLC.makeAdapter)({
    typeKey: 'element',
    defaultDropEffect: 'move',
    mount (api) {
        /**  Binding event listeners the `document` rather than `window` so that
		 * this adapter always gets preference over the text adapter.
		 * `document` is the first `EventTarget` under `window`
		 * https://twitter.com/alexandereardon/status/1604658588311465985
		 */ return (0, $3zl3q.combine)($0b9136830a524a8f$var$honeyPotFix.bindEvents(), (0, $cBeZP.bind)(document, {
            type: 'dragstart',
            listener (event) {
                if (!api.canStart(event)) return;
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Technically `dataTransfer` can be `null` according to the types
                // But that behaviour does not seem to appear in the spec.
                // If there is not `dataTransfer`, we can assume something is wrong and not
                // start a drag
                if (!event.dataTransfer) return;
                // the closest parent that is a draggable element will be marked as
                // the `event.target` for the event
                const target = event.target;
                // this source is only for elements
                // Note: only HTMLElements can have the "draggable" attribute
                if (!(target instanceof HTMLElement)) return null;
                // see if the thing being dragged is owned by us
                const entry = $0b9136830a524a8f$var$draggableRegistry.get(target);
                // no matching element found
                // → dragging an element with `draggable="true"` that is not controlled by us
                if (!entry) return null;
                /**
					 * A text selection drag _can_ have the `draggable` element be
					 * the `event.target` if the user is dragging the text selection
					 * from the `draggable`.
					 *
					 * To know if the `draggable` is being dragged, we look at whether any
					 * `"text/plain"` data is being dragged. If it is, then a text selection
					 * drag is occurring.
					 *
					 * This behaviour has been validated on:
					 *
					 * - Chrome@128 on Android@14
					 * - Chrome@128 on iOS@17.6.1
					 * - Chrome@128 on Windows@11
					 * - Chrome@128 on MacOS@14.6.1
					 * - Firefox@129 on Windows@11 (not possible for user to select text in a draggable)
					 * - Firefox@129 on MacOS@14.6.1 (not possible for user to select text in a draggable)
					 *
					 * Note: Could usually just use: `event.dataTransfer.types.includes(textMediaType)`
					 * but unfortunately ProseMirror is always setting `""` as the dragged text
					 *
					 * Note: Unfortunately editor is (heavily) leaning on the current functionality today
					 * and unwinding it will be a decent amount of effort. So for now, a text selection
					 * where the `event.target` is a `draggable` element will still trigger the
					 * element adapter.
					 *
					 * // Future state:
					 * if(event.dataTransfer.getData(textMediaType)) {
					 * 	return;
					 * }
					 *
					 */ const input = (0, $aWzmz.getInput)(event);
                const feedback = {
                    element: entry.element,
                    dragHandle: entry.dragHandle ?? null,
                    input: input
                };
                // Check: does the draggable want to allow dragging?
                if (entry.canDrag && !entry.canDrag(feedback)) {
                    // cancel drag operation if we cannot drag
                    event.preventDefault();
                    return null;
                }
                // Check: is there a drag handle and is the user using it?
                if (entry.dragHandle) {
                    // technically don't need this util, but just being
                    // consistent with how we look up what is under the users
                    // cursor.
                    const over = (0, $kKgsQ.getElementFromPointWithoutHoneypot)({
                        x: input.clientX,
                        y: input.clientY
                    });
                    // if we are not dragging from the drag handle (or something inside the drag handle)
                    // then we will cancel the active drag
                    if (!entry.dragHandle.contains(over)) {
                        event.preventDefault();
                        return null;
                    }
                }
                /**
					 *  **Goal**
					 *  Pass information to other applications
					 *
					 * **Approach**
					 *  Put data into the native data store
					 *
					 *  **What about the native adapter?**
					 *  When the element adapter puts native data into the native data store
					 *  the native adapter is not triggered in the current window,
					 *  but a native adapter in an external window _can_ be triggered
					 *
					 *  **Why bake this into core?**
					 *  This functionality could be pulled out and exposed inside of
					 *  `onGenerateDragPreview`. But decided to make it a part of the
					 *  base API as it felt like a common enough use case and ended
					 *  up being a similar amount of code to include this function as
					 *  it was to expose the hook for it
					 */ const nativeData = entry.getInitialDataForExternal?.(feedback) ?? null;
                if (nativeData) for (const [key, data] of Object.entries(nativeData))event.dataTransfer.setData(key, data ?? '');
                /**
					 *  📱 For Android devices, a drag operation will not start unless
					 * "text/plain" or "text/uri-list" data exists in the native data store
					 * https://twitter.com/alexandereardon/status/1732189803754713424
					 *
					 * Tested on:
					 * Device: Google Pixel 5
					 * Android version: 14 (November 5, 2023)
					 * Chrome version: 120.0
					 */ if ((0, $6XFIM.isAndroid)() && !event.dataTransfer.types.includes((0, $511ea0f8ed5a789e$export$fd3d00026297c0ad)) && !event.dataTransfer.types.includes((0, $8b5b4a812d80efb4$export$4c44a460f123106))) event.dataTransfer.setData((0, $511ea0f8ed5a789e$export$fd3d00026297c0ad), (0, $6XFIM.androidFallbackText));
                /**
					 * 1. Must set any media type for `iOS15` to work
					 * 2. We are also doing adding data so that the native adapter
					 * can know that the element adapter has handled this drag
					 *
					 * We used to wrap this `setData()` in a `try/catch` for Firefox,
					 * but it looks like that was not needed.
					 *
					 * Tested using: https://codesandbox.io/s/checking-firefox-throw-behaviour-on-dragstart-qt8h4f
					 *
					 * - ✅ Firefox@70.0 (Oct 2019) on macOS Sonoma
					 * - ✅ Firefox@70.0 (Oct 2019) on macOS Big Sur
					 * - ✅ Firefox@70.0 (Oct 2019) on Windows 10
					 *
					 * // just checking a few more combinations to be super safe
					 *
					 * - ✅ Chrome@78 (Oct 2019) on macOS Big Sur
					 * - ✅ Chrome@78 (Oct 2019) on Windows 10
					 * - ✅ Safari@14.1 on macOS Big Sur
					 */ event.dataTransfer.setData((0, $dad94f2a683170ce$export$c9c4cc54e73b125d), '');
                const payload = {
                    element: entry.element,
                    dragHandle: entry.dragHandle ?? null,
                    data: entry.getInitialData?.(feedback) ?? {}
                };
                const dragType = {
                    type: 'element',
                    payload: payload,
                    startedFrom: 'internal'
                };
                api.start({
                    event: event,
                    dragType: dragType
                });
            }
        }));
    },
    dispatchEventToSource: ({ eventName: eventName, payload: payload })=>{
        // During a drag operation, a draggable can be:
        // - remounted with different functions
        // - removed completely
        // So we need to get the latest entry from the registry in order
        // to call the latest event functions
        $0b9136830a524a8f$var$draggableRegistry.get(payload.source.element)?.[eventName]?.(// I cannot seem to get the types right here.
        // TS doesn't seem to like that one event can need `nativeSetDragImage`
        // @ts-expect-error
        payload);
    },
    onPostDispatch: $0b9136830a524a8f$var$honeyPotFix.getOnPostDispatch()
});
const $0b9136830a524a8f$export$e7140b68045b5036 = $0b9136830a524a8f$var$adapter.dropTarget;
const $0b9136830a524a8f$export$59a074bac4c54f54 = $0b9136830a524a8f$var$adapter.monitor;
function $0b9136830a524a8f$export$c746a5152d4ba26c(args) {
    return (0, $3zl3q.combine)(// making the draggable register the adapter rather than drop targets
    // this is because you *must* have a draggable element to start a drag
    // but you _might_ not have any drop targets immediately
    // (You might create drop targets async)
    $0b9136830a524a8f$var$adapter.registerUsage(), $0b9136830a524a8f$var$addToRegistry(args), (0, $lzZrl.addAttribute)(args.element, {
        attribute: 'draggable',
        value: 'true'
    }));
}

});
parcelRegister("kKgsQ", function(module, exports) {

$parcel$export(module.exports, "getElementFromPointWithoutHoneypot", () => $5328a4a0c6bbab12$export$81d0353f25f5dd);

var $dkX0L = parcelRequire("dkX0L");
function $5328a4a0c6bbab12$export$81d0353f25f5dd(client) {
    // eslint-disable-next-line no-restricted-syntax
    const [top, second] = document.elementsFromPoint(client.x, client.y);
    if (!top) return null;
    if ((0, $dkX0L.isHoneyPotElement)(top)) return second ?? null;
    return top;
}

});
parcelRegister("dkX0L", function(module, exports) {

$parcel$export(module.exports, "isHoneyPotElement", () => $b72c0efc16556d78$export$821bdcd739a2706b);

function $b72c0efc16556d78$export$821bdcd739a2706b(target) {
    return target instanceof Element && target.hasAttribute((0, $777d0e5bd42bc367$export$6eafea55f7947469));
}

});
// pulling this into a separate file so adapter(s) that don't
// need the honey pot can pay as little as possible for it.
const $777d0e5bd42bc367$export$6eafea55f7947469 = 'data-pdnd-honey-pot';



parcelRegister("8d5CE", function(module, exports) {

$parcel$export(module.exports, "makeHoneyPotFix", () => $e63f81f9f360c6d0$export$8ecad27c959e89e0);

var $cBeZP = parcelRequire("cBeZP");


const $e63f81f9f360c6d0$var$honeyPotSize = 2;
const $e63f81f9f360c6d0$var$halfHoneyPotSize = $e63f81f9f360c6d0$var$honeyPotSize / 2;
/**
 * `clientX` and `clientY` can be in sub pixels (eg `2.332`)
 * However, browser hitbox testing is commonly do to the closest pixel.
 *
 * → https://issues.chromium.org/issues/40940531
 *
 * To be sure that the honey pot will be over the `client` position,
 * we `.floor()` `clientX` and`clientY` and then make it `2px` in size.
 **/ function $e63f81f9f360c6d0$var$floorToClosestPixel(point) {
    return {
        x: Math.floor(point.x),
        y: Math.floor(point.y)
    };
}
/**
 * We want to make sure the honey pot sits around the users position.
 * This seemed to be the most resilient while testing.
 */ function $e63f81f9f360c6d0$var$pullBackByHalfHoneyPotSize(point) {
    return {
        x: point.x - $e63f81f9f360c6d0$var$halfHoneyPotSize,
        y: point.y - $e63f81f9f360c6d0$var$halfHoneyPotSize
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function $e63f81f9f360c6d0$var$preventGoingBackwardsOffScreen(point) {
    return {
        x: Math.max(point.x, 0),
        y: Math.max(point.y, 0)
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function $e63f81f9f360c6d0$var$preventGoingForwardsOffScreen(point) {
    return {
        x: Math.min(point.x, window.innerWidth - $e63f81f9f360c6d0$var$honeyPotSize),
        y: Math.min(point.y, window.innerHeight - $e63f81f9f360c6d0$var$honeyPotSize)
    };
}
/**
 * Create a `2x2` `DOMRect` around the `client` position
 */ function $e63f81f9f360c6d0$var$getHoneyPotRectFor({ client: client }) {
    const point = $e63f81f9f360c6d0$var$preventGoingForwardsOffScreen($e63f81f9f360c6d0$var$preventGoingBackwardsOffScreen($e63f81f9f360c6d0$var$pullBackByHalfHoneyPotSize($e63f81f9f360c6d0$var$floorToClosestPixel(client))));
    // When debugging, it is helpful to
    // make this element a bit bigger
    return DOMRect.fromRect({
        x: point.x,
        y: point.y,
        width: $e63f81f9f360c6d0$var$honeyPotSize,
        height: $e63f81f9f360c6d0$var$honeyPotSize
    });
}
function $e63f81f9f360c6d0$var$getRectStyles({ clientRect: clientRect }) {
    return {
        left: `${clientRect.left}px`,
        top: `${clientRect.top}px`,
        width: `${clientRect.width}px`,
        height: `${clientRect.height}px`
    };
}
function $e63f81f9f360c6d0$var$isWithin({ client: client, clientRect: clientRect }) {
    return(// is within horizontal bounds
    client.x >= clientRect.x && client.x <= clientRect.x + clientRect.width && // is within vertical bounds
    client.y >= clientRect.y && client.y <= clientRect.y + clientRect.height);
}
/**
 * The honey pot fix is designed to get around a painful bug in all browsers.
 *
 * [Overview](https://www.youtube.com/watch?v=udE9qbFTeQg)
 *
 * **Background**
 *
 * When a drag starts, browsers incorrectly think that the users pointer is
 * still depressed where the drag started. Any element that goes under this position
 * will be entered into, causing `"mouseenter"` events and `":hover"` styles to be applied.
 *
 * _This is a violation of the spec_
 *
 * > "From the moment that the user agent is to initiate the drag-and-drop operation,
 * > until the end 	of the drag-and-drop operation, device input events
 * > (e.g. mouse and keyboard events) must be suppressed."
 * >
 * > - https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
 *
 * _Some impacts_
 *
 * - `":hover"` styles being applied where they shouldn't (looks messy)
 * - components such as tooltips responding to `"mouseenter"` can show during a drag,
 *   and on an element the user isn't even over
 *
 * Bug: https://issues.chromium.org/issues/41129937
 *
 * **Honey pot fix**
 *
 * 1. Create an element where the browser thinks the depressed pointer is
 *    to absorb the incorrect pointer events
 * 2. Remove that element when it is no longer needed
 */ function $e63f81f9f360c6d0$var$mountHoneyPot({ initial: initial }) {
    const element = document.createElement('div');
    element.setAttribute((0, $777d0e5bd42bc367$export$6eafea55f7947469), 'true');
    // can shift during the drag thanks to Firefox
    let clientRect = $e63f81f9f360c6d0$var$getHoneyPotRectFor({
        client: initial
    });
    Object.assign(element.style, {
        // Setting a background color explicitly to avoid any inherited styles.
        // Looks like this could be `opacity: 0`, but worried that _might_
        // cause the element to be ignored on some platforms.
        // When debugging, set backgroundColor to something like "red".
        backgroundColor: 'transparent',
        position: 'fixed',
        // Being explicit to avoid inheriting styles
        padding: 0,
        margin: 0,
        boxSizing: 'border-box',
        ...$e63f81f9f360c6d0$var$getRectStyles({
            clientRect: clientRect
        }),
        // We want this element to absorb pointer events,
        // it's kind of the whole point 😉
        pointerEvents: 'auto',
        // Want to make sure the honey pot is top of everything else.
        // Don't need to worry about native drag previews, as they will
        // have been rendered (and removed) before the honey pot is rendered
        zIndex: (0, $ff68169bc3de57ec$export$7d0a15ee70427305)
    });
    document.body.appendChild(element);
    /**
	 *  🦊 In firefox we can get `"pointermove"` events after the drag
	 * has started, which is a spec violation.
	 * The final `"pointermove"` will reveal where the "depressed" position
	 * is for our honey pot fix.
	 */ const unbindPointerMove = (0, $cBeZP.bind)(window, {
        type: 'pointermove',
        listener (event) {
            const client = {
                x: event.clientX,
                y: event.clientY
            };
            clientRect = $e63f81f9f360c6d0$var$getHoneyPotRectFor({
                client: client
            });
            Object.assign(element.style, $e63f81f9f360c6d0$var$getRectStyles({
                clientRect: clientRect
            }));
        },
        // using capture so we are less likely to be impacted by event stopping
        options: {
            capture: true
        }
    });
    return function finish({ current: current }) {
        // Don't need this any more
        unbindPointerMove();
        // If the user is hover the honey pot, we remove it
        // so that the user can continue to interact with the page normally.
        if ($e63f81f9f360c6d0$var$isWithin({
            client: current,
            clientRect: clientRect
        })) {
            element.remove();
            return;
        }
        function cleanup() {
            unbindPostDragEvents();
            element.remove();
        }
        const unbindPostDragEvents = (0, $cBeZP.bindAll)(window, [
            {
                type: 'pointerdown',
                listener: cleanup
            },
            {
                type: 'pointermove',
                listener: cleanup
            },
            {
                type: 'focusin',
                listener: cleanup
            },
            {
                type: 'focusout',
                listener: cleanup
            },
            // a 'pointerdown' should happen before 'dragstart', but just being super safe
            {
                type: 'dragstart',
                listener: cleanup
            },
            // if the user has dragged something out of the window
            // and then is dragging something back into the window
            // the first events we will see are "dragenter" (and then "dragover").
            // So if we see any of these we need to clear the post drag fix.
            {
                type: 'dragenter',
                listener: cleanup
            },
            {
                type: 'dragover',
                listener: cleanup
            }
        ], {
            // Using `capture` so less likely to be impacted by other code stopping events
            capture: true
        });
    };
}
function $e63f81f9f360c6d0$export$8ecad27c959e89e0() {
    let latestPointerMove = null;
    function bindEvents() {
        // For sanity, only collecting this value from when events are first bound.
        // This prevents the case where a super old "pointermove" could be used
        // from a prior interaction.
        latestPointerMove = null;
        return (0, $cBeZP.bind)(window, {
            type: 'pointermove',
            listener (event) {
                latestPointerMove = {
                    x: event.clientX,
                    y: event.clientY
                };
            },
            // listening for pointer move in capture phase
            // so we are less likely to be impacted by events being stopped.
            options: {
                capture: true
            }
        });
    }
    function getOnPostDispatch() {
        let finish = null;
        return function onPostEvent({ eventName: eventName, payload: payload }) {
            // We are adding the honey pot `onDragStart` so we don't
            // impact the creation of the native drag preview.
            if (eventName === 'onDragStart') {
                const { input: input } = payload.location.initial;
                // Sometimes there will be no latest "pointermove" (eg iOS).
                // In which case, we use the start position of the drag.
                const initial = latestPointerMove ?? {
                    x: input.clientX,
                    y: input.clientY
                };
                // Don't need to defensively call `finish()` as `onDrop` from
                // one interaction is guaranteed to be called before `onDragStart`
                // of the next.
                finish = $e63f81f9f360c6d0$var$mountHoneyPot({
                    initial: initial
                });
            }
            if (eventName === 'onDrop') {
                const { input: input } = payload.location.current;
                finish?.({
                    current: {
                        x: input.clientX,
                        y: input.clientY
                    }
                });
                finish = null;
                // this interaction is finished, we want to use
                // the latest "pointermove" for each interaction
                latestPointerMove = null;
            }
        };
    }
    return {
        bindEvents: bindEvents,
        getOnPostDispatch: getOnPostDispatch
    };
}

});
// Maximum possible z-index
// https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
const $ff68169bc3de57ec$export$7d0a15ee70427305 = 2147483647;


parcelRegister("iiVLC", function(module, exports) {

$parcel$export(module.exports, "makeAdapter", () => $77e910c1e7be5898$export$2aa3a33160990d96);

var $ik6C6 = parcelRequire("ik6C6");

var $dSShi = parcelRequire("dSShi");

var $c7Wsm = parcelRequire("c7Wsm");

var $7Q7eZ = parcelRequire("7Q7eZ");
function $77e910c1e7be5898$export$2aa3a33160990d96({ typeKey: typeKey, mount: mount, dispatchEventToSource: dispatchEventToSource, onPostDispatch: onPostDispatch, defaultDropEffect: defaultDropEffect }) {
    const monitorAPI = (0, $7Q7eZ.makeMonitor)();
    const dropTargetAPI = (0, $c7Wsm.makeDropTarget)({
        typeKey: typeKey,
        defaultDropEffect: defaultDropEffect
    });
    function dispatchEvent(args) {
        // 1. forward the event to source
        dispatchEventToSource?.(args);
        // 2. forward the event to relevant dropTargets
        dropTargetAPI.dispatchEvent(args);
        // 3. forward event to monitors
        monitorAPI.dispatchEvent(args);
        // 4. post consumer dispatch (used for honey pot fix)
        onPostDispatch?.(args);
    }
    function start({ event: event, dragType: dragType }) {
        (0, $ik6C6.lifecycle).start({
            event: event,
            dragType: dragType,
            getDropTargetsOver: dropTargetAPI.getIsOver,
            dispatchEvent: dispatchEvent
        });
    }
    function registerUsage() {
        function mountAdapter() {
            const api = {
                canStart: (0, $ik6C6.lifecycle).canStart,
                start: start
            };
            return mount(api);
        }
        return (0, $dSShi.register)({
            typeKey: typeKey,
            mount: mountAdapter
        });
    }
    return {
        registerUsage: registerUsage,
        dropTarget: dropTargetAPI.dropTargetForConsumers,
        monitor: monitorAPI.monitorForConsumers
    };
}

});
parcelRegister("ik6C6", function(module, exports) {

$parcel$export(module.exports, "lifecycle", () => $018f6c08d2a1465a$export$3efdceeb8ca25c51);

var $cBeZP = parcelRequire("cBeZP");

var $kKgsQ = parcelRequire("kKgsQ");

var $dkX0L = parcelRequire("dkX0L");

var $9uGIN = parcelRequire("9uGIN");

var $h5V4I = parcelRequire("h5V4I");

var $aWzmz = parcelRequire("aWzmz");

var $18GOV = parcelRequire("18GOV");
const $018f6c08d2a1465a$var$globalState = {
    isActive: false
};
function $018f6c08d2a1465a$var$canStart() {
    return !$018f6c08d2a1465a$var$globalState.isActive;
}
function $018f6c08d2a1465a$var$getNativeSetDragImage(event) {
    if (event.dataTransfer) // need to use `.bind` as `setDragImage` is required
    // to be run with `event.dataTransfer` as the "this" context
    return event.dataTransfer.setDragImage.bind(event.dataTransfer);
    return null;
}
function $018f6c08d2a1465a$var$hasHierarchyChanged({ current: current, next: next }) {
    if (current.length !== next.length) return true;
    // not checking stickiness, data or dropEffect,
    // just whether the hierarchy has changed
    for(let i = 0; i < current.length; i++){
        if (current[i].element !== next[i].element) return true;
    }
    return false;
}
function $018f6c08d2a1465a$var$start({ event: event, dragType: dragType, getDropTargetsOver: getDropTargetsOver, dispatchEvent: dispatchEvent }) {
    if (!$018f6c08d2a1465a$var$canStart()) return;
    const initial = $018f6c08d2a1465a$var$getStartLocation({
        event: event,
        dragType: dragType,
        getDropTargetsOver: getDropTargetsOver
    });
    $018f6c08d2a1465a$var$globalState.isActive = true;
    const state = {
        current: initial
    };
    // Setting initial drop effect for the drag
    $018f6c08d2a1465a$var$setDropEffectOnEvent({
        event: event,
        current: initial.dropTargets
    });
    const dispatch = (0, $18GOV.makeDispatch)({
        source: dragType.payload,
        dispatchEvent: dispatchEvent,
        initial: initial
    });
    function updateState(next) {
        // only looking at whether hierarchy has changed to determine whether something as 'changed'
        const hasChanged = $018f6c08d2a1465a$var$hasHierarchyChanged({
            current: state.current.dropTargets,
            next: next.dropTargets
        });
        // Always updating the state to include latest data, dropEffect and stickiness
        // Only updating consumers if the hierarchy has changed in some way
        // Consumers can get the latest data by using `onDrag`
        state.current = next;
        if (hasChanged) dispatch.dragUpdate({
            current: state.current
        });
    }
    function onUpdateEvent(event) {
        const input = (0, $aWzmz.getInput)(event);
        // If we are over the honey pot, we need to get the element
        // that the user would have been over if not for the honey pot
        const target = (0, $dkX0L.isHoneyPotElement)(event.target) ? (0, $kKgsQ.getElementFromPointWithoutHoneypot)({
            x: input.clientX,
            y: input.clientY
        }) : event.target;
        const nextDropTargets = getDropTargetsOver({
            target: target,
            input: input,
            source: dragType.payload,
            current: state.current.dropTargets
        });
        if (nextDropTargets.length) {
            // 🩸 must call `event.preventDefault()` to allow a browser drop to occur
            event.preventDefault();
            $018f6c08d2a1465a$var$setDropEffectOnEvent({
                event: event,
                current: nextDropTargets
            });
        }
        updateState({
            dropTargets: nextDropTargets,
            input: input
        });
    }
    function cancel() {
        // The spec behaviour is that when a drag is cancelled, or when dropping on no drop targets,
        // a "dragleave" event is fired on the active drop target before a "dragend" event.
        // We are replicating that behaviour in `cancel` if there are any active drop targets to
        // ensure consistent behaviour.
        //
        // Note: When cancelling, or dropping on no drop targets, a "dragleave" event
        // will have already cleared the dropTargets to `[]` (as that particular "dragleave" has a `relatedTarget` of `null`)
        if (state.current.dropTargets.length) updateState({
            dropTargets: [],
            input: state.current.input
        });
        dispatch.drop({
            current: state.current,
            updatedSourcePayload: null
        });
        finish();
    }
    function finish() {
        $018f6c08d2a1465a$var$globalState.isActive = false;
        unbindEvents();
    }
    const unbindEvents = (0, $cBeZP.bindAll)(window, [
        {
            // 👋 Note: we are repurposing the `dragover` event as our `drag` event
            // this is because firefox does not publish pointer coordinates during
            // a `drag` event, but does for every other type of drag event
            // `dragover` fires on all elements that are being dragged over
            // Because we are binding to `window` - our `dragover` is effectively the same as a `drag`
            // 🦊😤
            type: 'dragover',
            listener (event) {
                // We need to regularly calculate the drop targets in order to allow:
                //  - dynamic `canDrop()` checks
                //  - rapid updating `getData()` calls to attach data in response to user input (eg for edge detection)
                // Sadly we cannot schedule inspecting changes resulting from this event
                // we need to be able to conditionally cancel the event with `event.preventDefault()`
                // to enable the correct native drop experience.
                // 1. check to see if anything has changed
                onUpdateEvent(event);
                // 2. let consumers know a move has occurred
                // This will include the latest 'input' values
                dispatch.drag({
                    current: state.current
                });
            }
        },
        {
            type: 'dragenter',
            listener: onUpdateEvent
        },
        {
            type: 'dragleave',
            listener (event) {
                if (!(0, $9uGIN.isLeavingWindow)({
                    dragLeave: event
                })) return;
                /**
					 * At this point we don't know if a drag is being cancelled,
					 * or if a drag is leaving the `window`.
					 *
					 * Both have:
					 *   1. "dragleave" (with `relatedTarget: null`)
					 *   2. "dragend" (a "dragend" can occur when outside the `window`)
					 *
					 * **Clearing drop targets**
					 *
					 * For either case we are clearing the the drop targets
					 *
					 * - cancelling: we clear drop targets in `"dragend"` anyway
					 * - leaving the `window`: we clear the drop targets (to clear stickiness)
					 *
					 * **Leaving the window and finishing the drag**
					 *
					 * _internal drags_
					 *
					 * - The drag continues when the user is outside the `window`
					 *   and can resume if the user drags back over the `window`,
					 *   or end when the user drops in an external `window`.
					 * - We will get a `"dragend"`, or we can listen for other
					 *   events to determine the drag is finished when the user re-enters the `window`).
					 *
					 * _external drags_
					 *
					 * - We conclude the drag operation.
					 * - We have no idea if the user will drag back over the `window`,
					 *   or if the drag ends elsewhere.
					 * - We will create a new drag if the user re-enters the `window`.
					 *
					 * **Not updating `input`**
					 *
					 * 🐛 Bug[Chrome] the final `"dragleave"` has default input values (eg `clientX == 0`)
					 * Workaround: intentionally not updating `input` in "dragleave"
					 * rather than the users current input values
					 * - [Conversation](https://twitter.com/alexandereardon/status/1642697633864241152)
					 * - [Bug](https://bugs.chromium.org/p/chromium/issues/detail?id=1429937)
					 **/ updateState({
                    input: state.current.input,
                    dropTargets: []
                });
                if (dragType.startedFrom === 'external') cancel();
            }
        },
        {
            // A "drop" can only happen if the browser allowed the drop
            type: 'drop',
            listener (event) {
                // Capture the final input.
                // We are capturing the final `input` for the
                // most accurate honey pot experience
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, $aWzmz.getInput)(event)
                };
                /** If there are no drop targets, then we will get
					 * a "drop" event if:
					 * - `preventUnhandled()` is being used
					 * - there is an unmanaged drop target (eg another library)
					 * In these cases, it's up to the consumer
					 * to handle the drop if it's not over one of our drop targets
					 * - `preventUnhandled()` will cancel the "drop"
					 * - unmanaged drop targets can handle the "drop" how they want to
					 * We won't call `event.preventDefault()` in this call path */ if (!state.current.dropTargets.length) {
                    cancel();
                    return;
                }
                event.preventDefault();
                // applying the latest drop effect to the event
                $018f6c08d2a1465a$var$setDropEffectOnEvent({
                    event: event,
                    current: state.current.dropTargets
                });
                dispatch.drop({
                    current: state.current,
                    // When dropping something native, we need to extract the latest
                    // `.items` from the "drop" event as it is now accessible
                    updatedSourcePayload: dragType.type === 'external' ? dragType.getDropPayload(event) : null
                });
                finish();
            }
        },
        {
            // "dragend" fires when on the drag source (eg a draggable element)
            // when the drag is finished.
            // "dragend" will fire after "drop" (if there was a successful drop)
            // "dragend" does not fire if the draggable source has been removed during the drag
            // or for external drag sources (eg files)
            // This "dragend" listener will not fire if there was a successful drop
            // as we will have already removed the event listener
            type: 'dragend',
            listener (event) {
                // In firefox, the position of the "dragend" event can
                // be a bit different to the last "dragover" event.
                // Updating the input so we can get the best possible
                // information for the honey pot.
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, $aWzmz.getInput)(event)
                };
                cancel();
            }
        },
        ...(0, $h5V4I.getBindingsForBrokenDrags)({
            onDragEnd: cancel
        })
    ], // Once we have started a managed drag operation it is important that we see / own all drag events
    // We got one adoption bug pop up where some code was stopping (`event.stopPropagation()`)
    // all "drop" events in the bubble phase on the `document.body`.
    // This meant that we never saw the "drop" event.
    {
        capture: true
    });
    dispatch.start({
        nativeSetDragImage: $018f6c08d2a1465a$var$getNativeSetDragImage(event)
    });
}
function $018f6c08d2a1465a$var$setDropEffectOnEvent({ event: event, current: current }) {
    // setting the `dropEffect` to be the innerMost drop targets dropEffect
    const innerMost = current[0]?.dropEffect;
    if (innerMost != null && event.dataTransfer) event.dataTransfer.dropEffect = innerMost;
}
function $018f6c08d2a1465a$var$getStartLocation({ event: event, dragType: dragType, getDropTargetsOver: getDropTargetsOver }) {
    const input = (0, $aWzmz.getInput)(event);
    // When dragging from outside of the browser,
    // the drag is not being sourced from any local drop targets
    if (dragType.startedFrom === 'external') return {
        input: input,
        dropTargets: []
    };
    const dropTargets = getDropTargetsOver({
        input: input,
        source: dragType.payload,
        target: event.target,
        current: []
    });
    return {
        input: input,
        dropTargets: dropTargets
    };
}
const $018f6c08d2a1465a$export$3efdceeb8ca25c51 = {
    canStart: $018f6c08d2a1465a$var$canStart,
    start: $018f6c08d2a1465a$var$start
};

});
parcelRegister("9uGIN", function(module, exports) {

$parcel$export(module.exports, "isLeavingWindow", () => $37e271cec761dcee$export$57d220c74e84a273);

var $bYN8w = parcelRequire("bYN8w");

var $6aABs = parcelRequire("6aABs");

var $apnEk = parcelRequire("apnEk");

var $9Mj6M = parcelRequire("9Mj6M");
function $37e271cec761dcee$export$57d220c74e84a273({ dragLeave: dragLeave }) {
    const { type: type, relatedTarget: relatedTarget } = dragLeave;
    if (type !== 'dragleave') return false;
    if ((0, $6aABs.isSafari)()) return (0, $apnEk.isLeavingWindowInSafari)({
        dragLeave: dragLeave
    });
    // Standard check: if going to `null` we are leaving the `window`
    if (relatedTarget == null) return true;
    /**
	 * 🦊 Exception: `iframe` in Firefox (`125.0`)
	 *
	 * Case 1: parent `window` → child `iframe`
	 * `dragLeave.relatedTarget` is element _inside_ the child `iframe`
	 * (foreign element)
	 *
	 * Case 2: child `iframe` → parent `window`
	 * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
	 * (foreign element)
	 */ if ((0, $bYN8w.isFirefox)()) return (0, $9Mj6M.isFromAnotherWindow)(relatedTarget);
    /**
	 * 🌏 Exception: `iframe` in Chrome (`124.0`)
	 *
	 * Case 1: parent `window` → child `iframe`
	 * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
	 *
	 * Case 2: child `iframe` → parent `window`
	 * `dragLeave.relatedTarget` is `null` *(standard check)*
	 */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return relatedTarget instanceof HTMLIFrameElement;
}

});
parcelRegister("bYN8w", function(module, exports) {

$parcel$export(module.exports, "isFirefox", () => $d91d4bdc8d92ad8d$export$b7d78993b74f766d);

var $jjNE9 = parcelRequire("jjNE9");
const $d91d4bdc8d92ad8d$export$b7d78993b74f766d = (0, $jjNE9.once)(function isFirefox() {
    return navigator.userAgent.includes('Firefox');
});

});
parcelRegister("jjNE9", function(module, exports) {

$parcel$export(module.exports, "once", () => $b679dfdbd4fba3f1$export$d2de3aaeafa91619);
/** Provide a function that you only ever want to be called a single time */ function $b679dfdbd4fba3f1$export$d2de3aaeafa91619(fn) {
    let cache = null;
    return function wrapped(...args) {
        if (!cache) {
            const result = fn.apply(this, args);
            cache = {
                result: result
            };
        }
        return cache.result;
    };
}

});


parcelRegister("6aABs", function(module, exports) {

$parcel$export(module.exports, "isSafari", () => $13856bb4e07cde59$export$95df08bae54cb4df);

var $jjNE9 = parcelRequire("jjNE9");
const $13856bb4e07cde59$export$95df08bae54cb4df = (0, $jjNE9.once)(function isSafari() {
    const { userAgent: userAgent } = navigator;
    return userAgent.includes('AppleWebKit') && !userAgent.includes('Chrome');
});

});

parcelRegister("apnEk", function(module, exports) {

$parcel$export(module.exports, "isEnteringWindowInSafari", () => $b3bca8f40bde8fa5$export$de68634bd94ed596);
$parcel$export(module.exports, "isLeavingWindowInSafari", () => $b3bca8f40bde8fa5$export$f21837c338005454);

var $cBeZP = parcelRequire("cBeZP");

var $6aABs = parcelRequire("6aABs");
/* For "dragenter" events, the browser should set `relatedTarget` to the previous element.
 * For external drag operations, our first "dragenter" event should have a `event.relatedTarget` of `null`.
 *
 *  Unfortunately in Safari `event.relatedTarget` is *always* set to `null`
 *  Safari bug: https://bugs.webkit.org/show_bug.cgi?id=242627
 *  To work around this we count "dragenter" and "dragleave" events */ // Using symbols for event properties so we don't clash with
// anything on the `event` object
const $b3bca8f40bde8fa5$var$symbols = {
    isLeavingWindow: Symbol('leaving'),
    isEnteringWindow: Symbol('entering')
};
function $b3bca8f40bde8fa5$export$de68634bd94ed596({ dragEnter: dragEnter }) {
    if (!(0, $6aABs.isSafari)()) return false;
    return dragEnter.hasOwnProperty($b3bca8f40bde8fa5$var$symbols.isEnteringWindow);
}
function $b3bca8f40bde8fa5$export$f21837c338005454({ dragLeave: dragLeave }) {
    if (!(0, $6aABs.isSafari)()) return false;
    return dragLeave.hasOwnProperty($b3bca8f40bde8fa5$var$symbols.isLeavingWindow);
}
(function fixSafari() {
    // Don't do anything when server side rendering
    if (typeof window === 'undefined') return;
    if (!(0, $6aABs.isSafari)()) return;
    function getInitialState() {
        return {
            enterCount: 0,
            isOverWindow: false
        };
    }
    let state = getInitialState();
    function resetState() {
        state = getInitialState();
    }
    // These event listeners are bound _forever_ and _never_ removed
    // We don't bother cleaning up these event listeners (for now)
    // as this workaround is only for Safari
    // This is how the event count works:
    //
    // lift (+1 enterCount)
    // - dragstart(draggable) [enterCount: 0]
    // - dragenter(draggable) [enterCount: 1]
    // leaving draggable (+0 enterCount)
    // - dragenter(document.body) [enterCount: 2]
    // - dragleave(draggable) [enterCount: 1]
    // leaving window (-1 enterCount)
    // - dragleave(document.body) [enterCount: 0] {leaving the window}
    // Things to note:
    // - dragenter and dragleave bubble
    // - the first dragenter when entering a window might not be on `window`
    //   - it could be on an element that is pressed up against the window
    //   - (so we cannot rely on `event.target` values)
    (0, $cBeZP.bindAll)(window, [
        {
            type: 'dragstart',
            listener: ()=>{
                state.enterCount = 0;
                // drag start occurs in the source window
                state.isOverWindow = true;
            // When a drag first starts it will also trigger a "dragenter" on the draggable element
            }
        },
        {
            type: 'drop',
            listener: resetState
        },
        {
            type: 'dragend',
            listener: resetState
        },
        {
            type: 'dragenter',
            listener: (event)=>{
                if (!state.isOverWindow && state.enterCount === 0) // Patching the `event` object
                // The `event` object is shared with all event listeners for the event
                // @ts-expect-error: adding property to the event object
                event[$b3bca8f40bde8fa5$var$symbols.isEnteringWindow] = true;
                state.isOverWindow = true;
                state.enterCount++;
            }
        },
        {
            type: 'dragleave',
            listener: (event)=>{
                state.enterCount--;
                if (state.isOverWindow && state.enterCount === 0) {
                    // Patching the `event` object as it is shared with all event listeners
                    // The `event` object is shared with all event listeners for the event
                    // @ts-expect-error: adding property to the event object
                    event[$b3bca8f40bde8fa5$var$symbols.isLeavingWindow] = true;
                    state.isOverWindow = false;
                }
            }
        }
    ], // using `capture: true` so that adding event listeners
    // in bubble phase will have the correct symbols
    {
        capture: true
    });
})();

});

parcelRegister("9Mj6M", function(module, exports) {

$parcel$export(module.exports, "isFromAnotherWindow", () => $e0983a74206d410e$export$e46810fef53b5b0e);
/**
 * Does the `EventTarget` look like a `Node` based on "duck typing".
 *
 * Helpful when the `Node` might be outside of the current document
 * so we cannot to an `target instanceof Node` check.
 */ function $e0983a74206d410e$var$isNodeLike(target) {
    return 'nodeName' in target;
}
function $e0983a74206d410e$export$e46810fef53b5b0e(eventTarget) {
    return $e0983a74206d410e$var$isNodeLike(eventTarget) && eventTarget.ownerDocument !== document;
}

});


parcelRegister("h5V4I", function(module, exports) {

$parcel$export(module.exports, "getBindingsForBrokenDrags", () => $50c75a295ab659e5$export$ac5e5b0daf997b2);
function $50c75a295ab659e5$export$ac5e5b0daf997b2({ onDragEnd: onDragEnd }) {
    return [
        // ## Detecting drag ending for removed draggables
        //
        // If a draggable element is removed during a drag and the user drops:
        // 1. if over a valid drop target: we get a "drop" event to know the drag is finished
        // 2. if not over a valid drop target (or cancelled): we get nothing
        // The "dragend" event will not fire on the source draggable if it has been
        // removed from the DOM.
        // So we need to figure out if a drag operation has finished by looking at other events
        // We can do this by looking at other events
        // ### First detection: "pointermove" events
        // 1. "pointermove" events cannot fire during a drag and drop operation
        // according to the spec. So if we get a "pointermove" it means that
        // the drag and drop operations has finished. So if we get a "pointermove"
        // we know that the drag is over
        // 2. 🦊😤 Drag and drop operations are _supposed_ to suppress
        // other pointer events. However, firefox will allow a few
        // pointer event to get through after a drag starts.
        // The most I've seen is 3
        {
            type: 'pointermove',
            listener: (()=>{
                let callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    onDragEnd();
                };
            })()
        },
        // ### Second detection: "pointerdown" events
        // If we receive this event then we know that a drag operation has finished
        // and potentially another one is about to start.
        // Note: `pointerdown` fires on all browsers / platforms before "dragstart"
        {
            type: 'pointerdown',
            listener: onDragEnd
        }
    ];
}

});

parcelRegister("aWzmz", function(module, exports) {

$parcel$export(module.exports, "getInput", () => $8d49417dc8e95872$export$7c112ceec8941e67);
function $8d49417dc8e95872$export$7c112ceec8941e67(event) {
    return {
        altKey: event.altKey,
        button: event.button,
        buttons: event.buttons,
        ctrlKey: event.ctrlKey,
        metaKey: event.metaKey,
        shiftKey: event.shiftKey,
        clientX: event.clientX,
        clientY: event.clientY,
        pageX: event.pageX,
        pageY: event.pageY
    };
}

});

parcelRegister("18GOV", function(module, exports) {

$parcel$export(module.exports, "makeDispatch", () => $9912bec6db707047$export$9f13ecc44e83d682);

var $7nRxN = parcelRequire("7nRxN");
const $9912bec6db707047$var$scheduleOnDrag = (0, $7nRxN.default)((fn)=>fn());
const $9912bec6db707047$var$dragStart = (()=>{
    let scheduled = null;
    function schedule(fn) {
        const frameId = requestAnimationFrame(()=>{
            scheduled = null;
            fn();
        });
        scheduled = {
            frameId: frameId,
            fn: fn
        };
    }
    function flush() {
        if (scheduled) {
            cancelAnimationFrame(scheduled.frameId);
            scheduled.fn();
            scheduled = null;
        }
    }
    return {
        schedule: schedule,
        flush: flush
    };
})();
function $9912bec6db707047$export$9f13ecc44e83d682({ source: source, initial: initial, dispatchEvent: dispatchEvent }) {
    let previous = {
        dropTargets: []
    };
    function safeDispatch(args) {
        dispatchEvent(args);
        previous = {
            dropTargets: args.payload.location.current.dropTargets
        };
    }
    const dispatch = {
        start ({ nativeSetDragImage: nativeSetDragImage }) {
            // Ensuring that both `onGenerateDragPreview` and `onDragStart` get the same location.
            // We do this so that `previous` is`[]` in `onDragStart` (which is logical)
            const location = {
                current: initial,
                previous: previous,
                initial: initial
            };
            // a `onGenerateDragPreview` does _not_ add another entry for `previous`
            // onDragPreview
            safeDispatch({
                eventName: 'onGenerateDragPreview',
                payload: {
                    source: source,
                    location: location,
                    nativeSetDragImage: nativeSetDragImage
                }
            });
            $9912bec6db707047$var$dragStart.schedule(()=>{
                safeDispatch({
                    eventName: 'onDragStart',
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        dragUpdate ({ current: current }) {
            $9912bec6db707047$var$dragStart.flush();
            $9912bec6db707047$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: 'onDropTargetChange',
                payload: {
                    source: source,
                    location: {
                        initial: initial,
                        previous: previous,
                        current: current
                    }
                }
            });
        },
        drag ({ current: current }) {
            $9912bec6db707047$var$scheduleOnDrag(()=>{
                $9912bec6db707047$var$dragStart.flush();
                const location = {
                    initial: initial,
                    previous: previous,
                    current: current
                };
                safeDispatch({
                    eventName: 'onDrag',
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        drop ({ current: current, updatedSourcePayload: updatedSourcePayload }) {
            $9912bec6db707047$var$dragStart.flush();
            $9912bec6db707047$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: 'onDrop',
                payload: {
                    source: updatedSourcePayload ?? source,
                    location: {
                        current: current,
                        previous: previous,
                        initial: initial
                    }
                }
            });
        }
    };
    return dispatch;
}

});
parcelRegister("7nRxN", function(module, exports) {

$parcel$export(module.exports, "default", () => $560437209e674614$export$2e2bcd8739ae039);
var $560437209e674614$var$rafSchd = function rafSchd(fn) {
    var lastArgs = [];
    var frameId = null;
    var wrapperFn = function wrapperFn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        lastArgs = args;
        if (frameId) return;
        frameId = requestAnimationFrame(function() {
            frameId = null;
            fn.apply(void 0, lastArgs);
        });
    };
    wrapperFn.cancel = function() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
    };
    return wrapperFn;
};
var $560437209e674614$export$2e2bcd8739ae039 = $560437209e674614$var$rafSchd;

});



parcelRegister("dSShi", function(module, exports) {

$parcel$export(module.exports, "register", () => $9449928287939c74$export$6503ec6e8aabbaf);
const $9449928287939c74$var$ledger = new Map();
function $9449928287939c74$var$registerUsage({ typeKey: typeKey, mount: mount }) {
    const entry = $9449928287939c74$var$ledger.get(typeKey);
    if (entry) {
        entry.usageCount++;
        return entry;
    }
    const initial = {
        typeKey: typeKey,
        unmount: mount(),
        usageCount: 1
    };
    $9449928287939c74$var$ledger.set(typeKey, initial);
    return initial;
}
function $9449928287939c74$export$6503ec6e8aabbaf(args) {
    const entry = $9449928287939c74$var$registerUsage(args);
    return function unregister() {
        entry.usageCount--;
        if (entry.usageCount > 0) return;
        // Only a single usage left, remove it
        entry.unmount();
        $9449928287939c74$var$ledger.delete(args.typeKey);
    };
}

});

parcelRegister("c7Wsm", function(module, exports) {

$parcel$export(module.exports, "makeDropTarget", () => $c9c066c5732074b2$export$47d10e7bd9c81890);

var $3zl3q = parcelRequire("3zl3q");

var $lzZrl = parcelRequire("lzZrl");
function $c9c066c5732074b2$var$copyReverse(array) {
    return array.slice(0).reverse();
}
function $c9c066c5732074b2$export$47d10e7bd9c81890({ typeKey: typeKey, defaultDropEffect: defaultDropEffect }) {
    const registry = new WeakMap();
    const dropTargetDataAtt = `data-drop-target-for-${typeKey}`;
    const dropTargetSelector = `[${dropTargetDataAtt}]`;
    function addToRegistry(args) {
        registry.set(args.element, args);
        return ()=>registry.delete(args.element);
    }
    function dropTargetForConsumers(args) {
        return (0, $3zl3q.combine)((0, $lzZrl.addAttribute)(args.element, {
            attribute: dropTargetDataAtt,
            value: 'true'
        }), addToRegistry(args));
    }
    function getActualDropTargets({ source: source, target: target, input: input, result: result = [] }) {
        if (target == null) return result;
        if (!(target instanceof Element)) {
            // For "text-selection" drags, the original `target`
            // is not an `Element`, so we need to start looking from
            // the parent element
            if (target instanceof Node) return getActualDropTargets({
                source: source,
                target: target.parentElement,
                input: input,
                result: result
            });
            // not sure what we are working with,
            // so we can exit.
            return result;
        }
        const closest = target.closest(dropTargetSelector);
        // Cannot find anything else
        if (closest == null) return result;
        const args = registry.get(closest);
        // error: something had a dropTargetSelector but we could not
        // find a match. For now, failing silently
        if (args == null) return result;
        const feedback = {
            input: input,
            source: source,
            element: args.element
        };
        // if dropping is not allowed, skip this drop target
        // and continue looking up the DOM tree
        if (args.canDrop && !args.canDrop(feedback)) return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            result: result
        });
        // calculate our new record
        const data = args.getData?.(feedback) ?? {};
        const dropEffect = args.getDropEffect?.(feedback) ?? defaultDropEffect;
        const record = {
            data: data,
            element: args.element,
            dropEffect: dropEffect,
            // we are collecting _actual_ drop targets, so these are
            // being applied _not_ due to stickiness
            isActiveDueToStickiness: false
        };
        return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            // Using bubble ordering. Same ordering as `event.getPath()`
            result: [
                ...result,
                record
            ]
        });
    }
    function notifyCurrent({ eventName: eventName, payload: payload }) {
        for (const record of payload.location.current.dropTargets){
            const entry = registry.get(record.element);
            const args = {
                ...payload,
                self: record
            };
            entry?.[eventName]?.(// I cannot seem to get the types right here.
            // TS doesn't seem to like that one event can need `nativeSetDragImage`
            // @ts-expect-error
            args);
        }
    }
    const actions = {
        onGenerateDragPreview: notifyCurrent,
        onDrag: notifyCurrent,
        onDragStart: notifyCurrent,
        onDrop: notifyCurrent,
        onDropTargetChange: ({ payload: payload })=>{
            const isCurrent = new Set(payload.location.current.dropTargets.map((record)=>record.element));
            const visited = new Set();
            for (const record of payload.location.previous.dropTargets){
                visited.add(record.element);
                const entry = registry.get(record.element);
                const isOver = isCurrent.has(record.element);
                const args = {
                    ...payload,
                    self: record
                };
                entry?.onDropTargetChange?.(args);
                // if we cannot find the drop target in the current array, then it has been left
                if (!isOver) entry?.onDragLeave?.(args);
            }
            for (const record of payload.location.current.dropTargets){
                // already published an update to this drop target
                if (visited.has(record.element)) continue;
                // at this point we have a new drop target that is being entered into
                const args = {
                    ...payload,
                    self: record
                };
                const entry = registry.get(record.element);
                entry?.onDropTargetChange?.(args);
                entry?.onDragEnter?.(args);
            }
        }
    };
    function dispatchEvent(args) {
        actions[args.eventName](args);
    }
    function getIsOver({ source: source, target: target, input: input, current: current }) {
        const actual = getActualDropTargets({
            source: source,
            target: target,
            input: input
        });
        // stickiness is only relevant when we have less
        // drop targets than we did before
        if (actual.length >= current.length) return actual;
        // less 'actual' drop targets than before,
        // we need to see if 'stickiness' applies
        // An old drop target will continue to be dropped on if:
        // 1. it has the same parent
        // 2. nothing exists in it's previous index
        const lastCaptureOrdered = $c9c066c5732074b2$var$copyReverse(current);
        const actualCaptureOrdered = $c9c066c5732074b2$var$copyReverse(actual);
        const resultCaptureOrdered = [];
        for(let index = 0; index < lastCaptureOrdered.length; index++){
            const last = lastCaptureOrdered[index];
            const fresh = actualCaptureOrdered[index];
            // if a record is in the new index -> use that
            // it will have the latest data + dropEffect
            if (fresh != null) {
                resultCaptureOrdered.push(fresh);
                continue;
            }
            // At this point we have no drop target in the old spot
            // Check to see if we can use a previous sticky drop target
            // The "parent" is the one inside of `resultCaptureOrdered`
            // (the parent might be a drop target that was sticky)
            const parent = resultCaptureOrdered[index - 1];
            const lastParent = lastCaptureOrdered[index - 1];
            // Stickiness is based on parent relationships, so if the parent relationship has change
            // then we can stop our search
            if (parent?.element !== lastParent?.element) break;
            // We need to check whether the old drop target can still be dropped on
            const argsForLast = registry.get(last.element);
            // We cannot drop on a drop target that is no longer mounted
            if (!argsForLast) break;
            const feedback = {
                input: input,
                source: source,
                element: argsForLast.element
            };
            // We cannot drop on a drop target that no longer allows being dropped on
            if (argsForLast.canDrop && !argsForLast.canDrop(feedback)) break;
            // We cannot drop on a drop target that is no longer sticky
            if (!argsForLast.getIsSticky?.(feedback)) break;
            // Note: intentionally not recollecting `getData()` or `getDropEffect()`
            // Previous values for `data` and `dropEffect` will be borrowed
            // This is to prevent things like the 'closest edge' changing when
            // no longer over a drop target.
            // We could change our mind on this behaviour in the future
            resultCaptureOrdered.push({
                ...last,
                // making it clear to consumers this drop target is active due to stickiness
                isActiveDueToStickiness: true
            });
        }
        // return bubble ordered result
        return $c9c066c5732074b2$var$copyReverse(resultCaptureOrdered);
    }
    return {
        dropTargetForConsumers: dropTargetForConsumers,
        getIsOver: getIsOver,
        dispatchEvent: dispatchEvent
    };
}

});
parcelRegister("3zl3q", function(module, exports) {

$parcel$export(module.exports, "combine", () => $a6751ba2eb2acc9f$export$1be1fc439b849fdf);
function $a6751ba2eb2acc9f$export$1be1fc439b849fdf(...fns) {
    return function cleanup() {
        fns.forEach((fn)=>fn());
    };
}

});

parcelRegister("lzZrl", function(module, exports) {

$parcel$export(module.exports, "addAttribute", () => $e43023517e6b167a$export$5dcb5c23b6ba980a);
function $e43023517e6b167a$export$5dcb5c23b6ba980a(element, { attribute: attribute, value: value }) {
    element.setAttribute(attribute, value);
    return ()=>element.removeAttribute(attribute);
}

});


parcelRegister("7Q7eZ", function(module, exports) {

$parcel$export(module.exports, "makeMonitor", () => $f3636ae745ab6f9c$export$5dd4ed888d5b12ca);
function $f3636ae745ab6f9c$export$5dd4ed888d5b12ca() {
    const registry = new Set();
    let dragging = null;
    function tryAddToActive(monitor) {
        if (!dragging) return;
        // Monitor is allowed to monitor events if:
        // 1. It has no `canMonitor` function (default is that a monitor can listen to everything)
        // 2. `canMonitor` returns true
        if (!monitor.canMonitor || monitor.canMonitor(dragging.canMonitorArgs)) dragging.active.add(monitor);
    }
    function monitorForConsumers(args) {
        // We are giving each `args` a new reference so that you
        // can create multiple monitors with the same `args`.
        const entry = {
            ...args
        };
        registry.add(entry);
        // if there is an active drag we need to see if this new monitor is relevant
        tryAddToActive(entry);
        return function cleanup() {
            registry.delete(entry);
            // We need to stop publishing events during a drag to this monitor!
            if (dragging) dragging.active.delete(entry);
        };
    }
    function dispatchEvent({ eventName: eventName, payload: payload }) {
        if (eventName === 'onGenerateDragPreview') {
            dragging = {
                canMonitorArgs: {
                    initial: payload.location.initial,
                    source: payload.source
                },
                active: new Set()
            };
            for (const monitor of registry)tryAddToActive(monitor);
        }
        // This should never happen.
        if (!dragging) return;
        // Creating an array from the set _before_ iterating
        // This is so that monitors added during the current event will not be called.
        // This behaviour matches native EventTargets where an event listener
        // cannot add another event listener during an active event to the same
        // event target in the same event (for us we have a single global event target)
        const active = Array.from(dragging.active);
        for (const monitor of active)// A monitor can be removed by another monitor during an event.
        // We need to check that the monitor is still registered before calling it
        if (dragging.active.has(monitor)) // @ts-expect-error: I cannot get this type working!
        monitor[eventName]?.(payload);
        if (eventName === 'onDrop') {
            dragging.active.clear();
            dragging = null;
        }
    }
    return {
        dispatchEvent: dispatchEvent,
        monitorForConsumers: monitorForConsumers
    };
}

});


parcelRegister("6XFIM", function(module, exports) {

$parcel$export(module.exports, "isAndroid", () => $66dca49a44fee398$export$a11b0059900ceec8);
$parcel$export(module.exports, "androidFallbackText", () => $66dca49a44fee398$export$aceb3ed8b7f7bd2c);

var $jjNE9 = parcelRequire("jjNE9");
const $66dca49a44fee398$export$a11b0059900ceec8 = (0, $jjNE9.once)(function isAndroid() {
    return navigator.userAgent.toLocaleLowerCase().includes('android');
});
const $66dca49a44fee398$export$aceb3ed8b7f7bd2c = 'pdnd:android-fallback';

});

// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
const $511ea0f8ed5a789e$export$fd3d00026297c0ad = 'text/plain';

// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
const $8b5b4a812d80efb4$export$4c44a460f123106 = 'text/uri-list';

/**
 * This key has been pulled into a separate module
 * so that the external adapter does not need to import
 * the element adapter
 */ const $dad94f2a683170ce$export$c9c4cc54e73b125d = 'application/vnd.pdnd';



parcelRegister("4hDdm", function(module, exports) {

$parcel$export(module.exports, "combine", () => (parcelRequire("3zl3q")).combine);

var $3zl3q = parcelRequire("3zl3q");

});

parcelRegister("22Gxp", function(module, exports) {

$parcel$export(module.exports, "useUID", () => $17ccc3ce11c8a1a0$export$87d05f07e65211f1);
$parcel$export(module.exports, "useUIDSeed", () => $17ccc3ce11c8a1a0$export$bb5ca5fba6fb4f1f);

var $5uXOq = parcelRequire("5uXOq");

var $7aHWJ = parcelRequire("7aHWJ");
var $17ccc3ce11c8a1a0$var$generateUID = function(context) {
    var quartz = context || (0, $7aHWJ.counter);
    var prefix = (0, $7aHWJ.getPrefix)(quartz);
    var id = (0, $7aHWJ.getId)(quartz);
    var uid = prefix + id;
    var gen = function(item) {
        return uid + quartz.uid(item);
    };
    return {
        uid: uid,
        gen: gen
    };
};
var $17ccc3ce11c8a1a0$var$useUIDState = function() {
    // @ts-ignore
    return $5uXOq.useState($17ccc3ce11c8a1a0$var$generateUID($5uXOq.useContext((0, $7aHWJ.source))));
};
var $17ccc3ce11c8a1a0$export$87d05f07e65211f1 = function() {
    var uid = $17ccc3ce11c8a1a0$var$useUIDState()[0].uid;
    return uid;
};
var $17ccc3ce11c8a1a0$export$bb5ca5fba6fb4f1f = function() {
    var gen = $17ccc3ce11c8a1a0$var$useUIDState()[0].gen;
    return gen;
};

});
parcelRegister("7aHWJ", function(module, exports) {

$parcel$export(module.exports, "counter", () => $538b8e680858bf13$export$e575061ef2a070eb);
$parcel$export(module.exports, "source", () => $538b8e680858bf13$export$b4d5da5f34fb77ad);
$parcel$export(module.exports, "getId", () => $538b8e680858bf13$export$218c8c3169c024d2);
$parcel$export(module.exports, "getPrefix", () => $538b8e680858bf13$export$36e24695f02d4503);

var $5uXOq = parcelRequire("5uXOq");

var $8e3lA = parcelRequire("8e3lA");
var $538b8e680858bf13$export$1921362e86c73c88 = function(prefix) {
    if (prefix === void 0) prefix = '';
    return {
        value: 1,
        prefix: prefix,
        uid: (0, $8e3lA.generateUID)()
    };
};
var $538b8e680858bf13$export$e575061ef2a070eb = $538b8e680858bf13$export$1921362e86c73c88();
var $538b8e680858bf13$export$b4d5da5f34fb77ad = $5uXOq.createContext($538b8e680858bf13$export$1921362e86c73c88());
var $538b8e680858bf13$export$218c8c3169c024d2 = function(source) {
    return source.value++;
};
var $538b8e680858bf13$export$36e24695f02d4503 = function(source) {
    return source ? source.prefix : '';
};

});
parcelRegister("8e3lA", function(module, exports) {

$parcel$export(module.exports, "generateUID", () => $5fd23a338f882896$export$bdbb4cbb3078e58d);
$parcel$export(module.exports, "uid", () => $5fd23a338f882896$export$e2a22331486dcca0);
/**
 * generates a UID factory
 * @internal
 * @example
 * const uid = generateUID();
 * uid(object) = 1;
 * uid(object) = 1;
 * uid(anotherObject) = 2;
 */ var $5fd23a338f882896$export$bdbb4cbb3078e58d = function() {
    var counter = 1;
    var map = new WeakMap();
    /**
     * @borrows {uid}
     */ var uid = function(item, index) {
        if (typeof item === 'number' || typeof item === 'string') return index ? "idx-" + index : "val-" + item;
        if (!map.has(item)) {
            map.set(item, counter++);
            return uid(item);
        }
        return 'uid' + map.get(item);
    };
    return uid;
};
var $5fd23a338f882896$export$e2a22331486dcca0 = $5fd23a338f882896$export$bdbb4cbb3078e58d();

});



parcelRegister("7uUwQ", function(module, exports) {
/**
 * This allows you to work with object hierarchies that have been frozen
 * with Object.freeze().  "get" operations can use the normal JS syntax,
 * but operations that modify the data will have to return partial copies of
 * the structure. The portions of the structure that did not change will
 * === their previous values.
 *
 * Inspired by clojure/mori and Immutable.js
 */ "use strict";
var $57572f31ed5f364f$var$i = module.exports;
// we only care about objects or arrays for now
function $57572f31ed5f364f$var$weCareAbout(val) {
    return null !== val && (Array.isArray(val) || // This will skip objects created with `new Foo()`
    // and objects created with `Object.create(proto)`
    // The benefit is ignoring DOM elements and event emitters,
    // which are often circular.
    $57572f31ed5f364f$var$isObjectLike(val));
}
function $57572f31ed5f364f$var$isObjectLike(val) {
    return typeof val === "object" && val.constructor === Object && Object.getPrototypeOf(val) === Object.prototype;
}
function $57572f31ed5f364f$var$arrayClone(arr) {
    var index = 0, length = arr.length, result = Array(length);
    for(; index < length; index += 1)result[index] = arr[index];
    return result;
}
function $57572f31ed5f364f$var$objClone(obj) {
    var index = 0, keys = Object.keys(obj), length = keys.length, key, result = {};
    for(; index < length; index += 1){
        key = keys[index];
        result[key] = obj[key];
    }
    return result;
}
function $57572f31ed5f364f$var$clone(coll) {
    if (Array.isArray(coll)) return $57572f31ed5f364f$var$arrayClone(coll);
    else return $57572f31ed5f364f$var$objClone(coll);
}
function $57572f31ed5f364f$var$freezeIfNeeded(coll) {
    $57572f31ed5f364f$var$weCareAbout(coll) && Object.isFrozen(coll);
    return coll;
}
function $57572f31ed5f364f$var$_freeze(coll) {
    return coll;
}
function $57572f31ed5f364f$var$baseFreeze(coll, prevNodes) {
    if (prevNodes.some(function(node) {
        return node === coll;
    })) throw new Error("object has a reference cycle");
    Object.freeze(coll);
    prevNodes.push(coll);
    Object.keys(coll).forEach(function(key) {
        var prop = coll[key];
        if ($57572f31ed5f364f$var$weCareAbout(prop)) $57572f31ed5f364f$var$baseFreeze(prop, prevNodes);
    });
    prevNodes.pop();
    return coll;
}
/**
 * recrursively freeze an object and all its child objects
 * @param  {Object|Array} coll
 * @return {Object|Array}
 */ module.exports.freeze = function freeze(coll) {
    return coll;
};
/**
 * recursively un-freeze an object, by cloning frozen collections
 * @param  {[type]} coll [description]
 * @return {[type]}      [description]
 */ module.exports.thaw = function thaw(coll) {
    if ($57572f31ed5f364f$var$weCareAbout(coll) && Object.isFrozen(coll)) {
        var newColl = $57572f31ed5f364f$var$clone(coll);
        Object.keys(newColl).forEach(function(key) {
            newColl[key] = thaw(newColl[key]);
        });
        return newColl;
    }
    return coll;
};
/**
 * set a value on an object or array
 * @param  {Object|Array}  coll
 * @param  {String|Number} key   Key or index
 * @param  {Object}        value
 * @return {Object|Array}        new object hierarchy with modifications
 */ module.exports.assoc = function assoc(coll, key, value) {
    if (coll[key] === value) return $57572f31ed5f364f$var$_freeze(coll);
    var newObj = $57572f31ed5f364f$var$clone(coll);
    newObj[key] = $57572f31ed5f364f$var$freezeIfNeeded(value);
    return $57572f31ed5f364f$var$_freeze(newObj);
};
module.exports.set = module.exports.assoc;
/**
 * un-set a value on an object or array
 * @param  {Object|Array}  coll
 * @param  {String|Number} key  Key or Index
 * @return {Object|Array}       New object or array
 */ module.exports.dissoc = function dissoc(coll, key) {
    var newObj = $57572f31ed5f364f$var$clone(coll);
    delete newObj[key];
    return $57572f31ed5f364f$var$_freeze(newObj);
};
module.exports.unset = module.exports.dissoc;
/**
 * set a value deep in a hierarchical structure
 * @param  {Object|Array} coll
 * @param  {Array}        path    A list of keys to traverse
 * @param  {Object}       value
 * @return {Object|Array}       new object hierarchy with modifications
 */ module.exports.assocIn = function assocIn(coll, path, value) {
    var key0 = path[0];
    if (path.length === 1) // simplest case is a 1-element array.  Just a simple assoc.
    return $57572f31ed5f364f$var$i.assoc(coll, key0, value);
    else // break the problem down.  Assoc this object with the first key
    // and the result of assocIn with the rest of the keys
    return $57572f31ed5f364f$var$i.assoc(coll, key0, assocIn(coll[key0] || {}, path.slice(1), value));
};
module.exports.setIn = module.exports.assocIn;
/**
 * get an object from a hierachy based on an array of keys
 * @param  {Object|Array} coll
 * @param  {Array}        path    list of keys
 * @return {Object}       value, or undefined
 */ function $57572f31ed5f364f$var$baseGet(coll, path) {
    return (path || []).reduce(function(curr, key) {
        if (!curr) return;
        return curr[key];
    }, coll);
}
module.exports.getIn = $57572f31ed5f364f$var$baseGet;
/**
 * Update a value in a hierarchy
 * @param  {Object|Array}   coll
 * @param  {Array}          path     list of keys
 * @param  {Function} callback The existing value with be passed to this.
 *                             Return the new value to set
 * @return {Object|Array}      new object hierarchy with modifications
 */ module.exports.updateIn = function updateIn(coll, path, callback) {
    var existingVal = $57572f31ed5f364f$var$baseGet(coll, path);
    return $57572f31ed5f364f$var$i.assocIn(coll, path, callback(existingVal));
};
// generate wrappers for the mutative array methods
[
    "push",
    "unshift",
    "pop",
    "shift",
    "reverse",
    "sort"
].forEach(function(methodName) {
    module.exports[methodName] = function(arr, val) {
        var newArr = $57572f31ed5f364f$var$arrayClone(arr);
        newArr[methodName]($57572f31ed5f364f$var$freezeIfNeeded(val));
        return $57572f31ed5f364f$var$_freeze(newArr);
    };
    module.exports[methodName].displayName = "icepick." + methodName;
});
// splice is special because it is variadic
module.exports.splice = function splice(arr /*, args*/ ) {
    var newArr = $57572f31ed5f364f$var$arrayClone(arr), args = $57572f31ed5f364f$var$rest(arguments).map($57572f31ed5f364f$var$freezeIfNeeded);
    newArr.splice.apply(newArr, args);
    return $57572f31ed5f364f$var$_freeze(newArr);
};
// slice is non-mutative
module.exports.slice = function slice(arr, arg1, arg2) {
    var newArr = arr.slice(arg1, arg2);
    return $57572f31ed5f364f$var$_freeze(newArr);
};
[
    "map",
    "filter"
].forEach(function(methodName) {
    module.exports[methodName] = function(fn, arr) {
        var newArr = arr[methodName](fn);
        return $57572f31ed5f364f$var$_freeze(newArr);
    };
    module.exports[methodName].displayName = "icepick." + methodName;
});
module.exports.extend = module.exports.assign = function assign() {
    var newObj = $57572f31ed5f364f$var$rest(arguments).reduce($57572f31ed5f364f$var$singleAssign, arguments[0]);
    return $57572f31ed5f364f$var$_freeze(newObj);
};
function $57572f31ed5f364f$var$singleAssign(obj1, obj2) {
    return Object.keys(obj2).reduce(function(obj, key) {
        return $57572f31ed5f364f$var$i.assoc(obj, key, obj2[key]);
    }, obj1);
}
module.exports.merge = $57572f31ed5f364f$var$merge;
function $57572f31ed5f364f$var$merge(target, source, resolver) {
    if (target == null || source == null) return target;
    return Object.keys(source).reduce(function(obj, key) {
        var sourceVal = source[key];
        var targetVal = obj[key];
        var resolvedSourceVal = resolver ? resolver(targetVal, sourceVal, key) : sourceVal;
        if ($57572f31ed5f364f$var$weCareAbout(sourceVal) && $57572f31ed5f364f$var$weCareAbout(targetVal)) {
            // if they are both frozen and reference equal, assume they are deep equal
            if (Object.isFrozen(resolvedSourceVal) && Object.isFrozen(targetVal), resolvedSourceVal === targetVal) return obj;
            if (Array.isArray(sourceVal)) return $57572f31ed5f364f$var$i.assoc(obj, key, resolvedSourceVal);
            // recursively merge pairs of objects
            return $57572f31ed5f364f$var$assocIfDifferent(obj, key, $57572f31ed5f364f$var$merge(targetVal, resolvedSourceVal, resolver));
        }
        // primitive values, stuff with prototypes
        return $57572f31ed5f364f$var$assocIfDifferent(obj, key, resolvedSourceVal);
    }, target);
}
function $57572f31ed5f364f$var$assocIfDifferent(target, key, value) {
    if (target[key] === value) return target;
    return $57572f31ed5f364f$var$i.assoc(target, key, value);
}
function $57572f31ed5f364f$var$_slice(array, start) {
    var begin = start || 0;
    var len = array.length;
    len -= begin;
    len = len < 0 ? 0 : len;
    var result = new Array(len);
    for(var i = 0; i < len; i += 1)result[i] = array[i + begin];
    return result;
}
function $57572f31ed5f364f$var$rest(args) {
    return $57572f31ed5f364f$var$_slice(args, 1);
}
var $57572f31ed5f364f$var$chainProto = {
    value: function value() {
        return this.val;
    },
    thru: function thru(fn) {
        this.val = $57572f31ed5f364f$var$freezeIfNeeded(fn(this.val));
        return this;
    }
};
Object.keys(module.exports).forEach(function(methodName) {
    $57572f31ed5f364f$var$chainProto[methodName] = function() {
        var args = $57572f31ed5f364f$var$_slice(arguments);
        args.unshift(this.val);
        this.val = module.exports[methodName].apply(null, args);
        return this;
    };
});
module.exports.chain = function chain(val) {
    var wrapped = Object.create($57572f31ed5f364f$var$chainProto);
    wrapped.val = val;
    return wrapped;
};
// for testing
module.exports._weCareAbout = $57572f31ed5f364f$var$weCareAbout;
module.exports._slice = $57572f31ed5f364f$var$_slice;

});

parcelRegister("bSOOm", function(module, exports) {

$parcel$export(module.exports, "ExperienceTrackerContext", () => $0be6218364f10f40$export$a7b0697657ed8bd0);

var $5uXOq = parcelRequire("5uXOq");
const $0be6218364f10f40$export$a7b0697657ed8bd0 = (0, $5uXOq.createContext)({
    abort () {},
    fail () {},
    start () {},
    succeed () {},
    stopOnError () {},
    subscribe () {
        return ()=>{};
    }
});

});

parcelRegister("eCZ6m", function(module, exports) {

$parcel$export(module.exports, "getAggEndpoint", () => $3d812b79ec4c2140$export$fd126d8de571b77d);
$parcel$export(module.exports, "getRequestBody", () => $3d812b79ec4c2140$export$55bce18df99af758);

var $6cAn5 = parcelRequire("6cAn5");
const $3d812b79ec4c2140$var$branchSlug = typeof $6cAn5 !== 'undefined' && $6cAn5.env ? undefined : undefined;
const $3d812b79ec4c2140$var$aggPathname = `/gateway/api/graphql${$3d812b79ec4c2140$var$branchSlug ? `/${$3d812b79ec4c2140$var$branchSlug}/graphql` : ''}`;
const $3d812b79ec4c2140$export$fd126d8de571b77d = (request, cacheConfig = {})=>{
    let endpoint = $3d812b79ec4c2140$var$aggPathname;
    if (cacheConfig.metadata?.META_SLOW_ENDPOINT) endpoint = `${endpoint}/slow`;
    if (request.id != null) endpoint = `${endpoint}/pq/${request.id}`;
    return `${endpoint}?operation=${request.name}`;
};
const $3d812b79ec4c2140$export$55bce18df99af758 = (request, variables)=>{
    const requestBody = {
        operationName: request.name,
        variables: variables
    };
    return JSON.stringify(requestBody);
};

});

parcelRegister("4pgHP", function(module, exports) {

$parcel$export(module.exports, "startCapturingExtensions", () => $2dde2e1ea361345d$export$8656ba3981c6f6c1);
$parcel$export(module.exports, "stopCapturingExtensions", () => $2dde2e1ea361345d$export$f16fa6040161f056);
$parcel$export(module.exports, "putExtensions", () => $2dde2e1ea361345d$export$17dc47fdf278de21);
$parcel$export(module.exports, "getExtensions", () => $2dde2e1ea361345d$export$7c6ea4184129ef74);
const $2dde2e1ea361345d$var$OperationExtensionsMap = {};
const $2dde2e1ea361345d$export$8656ba3981c6f6c1 = (operationName)=>{
    $2dde2e1ea361345d$var$OperationExtensionsMap[operationName] = $2dde2e1ea361345d$var$OperationExtensionsMap[operationName] || [];
};
const $2dde2e1ea361345d$export$f16fa6040161f056 = (operationName)=>{
    $2dde2e1ea361345d$var$OperationExtensionsMap[operationName] = undefined;
};
const $2dde2e1ea361345d$export$17dc47fdf278de21 = (operationName, extension)=>{
    if (extension !== undefined) {
        const extensionsForOperation = $2dde2e1ea361345d$var$OperationExtensionsMap[operationName];
        if (extensionsForOperation !== undefined) extensionsForOperation.push(extension);
    }
};
const $2dde2e1ea361345d$export$7c6ea4184129ef74 = (operationName)=>$2dde2e1ea361345d$var$OperationExtensionsMap[operationName] || [];

});

parcelRegister("5Wobd", function(module, exports) {

$parcel$export(module.exports, "startCapturingTraceIds", () => $4d54017c044669f2$export$a2bcb2fac360646c);
$parcel$export(module.exports, "stopCapturingTraceIds", () => $4d54017c044669f2$export$559128bdc4352001);
$parcel$export(module.exports, "addTraceId", () => $4d54017c044669f2$export$fcaa732775f12226);
$parcel$export(module.exports, "getTraceIds", () => $4d54017c044669f2$export$5113e470f5c95670);
const $4d54017c044669f2$var$OperationTraceIdMap = {};
const $4d54017c044669f2$export$a2bcb2fac360646c = (operationName)=>{
    $4d54017c044669f2$var$OperationTraceIdMap[operationName] = $4d54017c044669f2$var$OperationTraceIdMap[operationName] || [];
};
const $4d54017c044669f2$export$559128bdc4352001 = (operationName)=>{
    $4d54017c044669f2$var$OperationTraceIdMap[operationName] = undefined;
};
const $4d54017c044669f2$export$fcaa732775f12226 = (operationName, traceId)=>{
    if (traceId !== undefined) {
        const traceIdsForOperation = $4d54017c044669f2$var$OperationTraceIdMap[operationName];
        if (traceIdsForOperation !== undefined) traceIdsForOperation.push(traceId);
    }
};
const $4d54017c044669f2$export$5113e470f5c95670 = (operationName)=>$4d54017c044669f2$var$OperationTraceIdMap[operationName] || [];

});

parcelRegister("aB8eX", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.batchActions = $7b73c06d66cb3e3d$var$batchActions;
module.exports.enableBatching = $7b73c06d66cb3e3d$var$enableBatching;
module.exports.batchDispatchMiddleware = $7b73c06d66cb3e3d$var$batchDispatchMiddleware;
var $7b73c06d66cb3e3d$var$BATCH = module.exports.BATCH = 'BATCHING_REDUCER.BATCH';
function $7b73c06d66cb3e3d$var$batchActions(actions) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $7b73c06d66cb3e3d$var$BATCH;
    return {
        type: type,
        meta: {
            batch: true
        },
        payload: actions
    };
}
function $7b73c06d66cb3e3d$var$enableBatching(reduce) {
    return function batchingReducer(state, action) {
        if (action && action.meta && action.meta.batch) return action.payload.reduce(batchingReducer, state);
        return reduce(state, action);
    };
}
function $7b73c06d66cb3e3d$var$batchDispatchMiddleware(store) {
    function dispatchChildActions(store, action) {
        if (action.meta && action.meta.batch) action.payload.forEach(function(childAction) {
            dispatchChildActions(store, childAction);
        });
        else store.dispatch(action);
    }
    return function(next) {
        return function(action) {
            if (action && action.meta && action.meta.batch) dispatchChildActions(store, action);
            return next(action);
        };
    };
}

});

parcelRegister("korqb", function(module, exports) {
!function(e, t) {
    t(module.exports);
}(module.exports, function(e) {
    "use strict";
    function t(e, t) {
        e.super_ = t, e.prototype = Object.create(t.prototype, {
            constructor: {
                value: e,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        });
    }
    function r(e, t) {
        Object.defineProperty(this, "kind", {
            value: e,
            enumerable: !0
        }), t && t.length && Object.defineProperty(this, "path", {
            value: t,
            enumerable: !0
        });
    }
    function n(e, t, r) {
        n.super_.call(this, "E", e), Object.defineProperty(this, "lhs", {
            value: t,
            enumerable: !0
        }), Object.defineProperty(this, "rhs", {
            value: r,
            enumerable: !0
        });
    }
    function o(e, t) {
        o.super_.call(this, "N", e), Object.defineProperty(this, "rhs", {
            value: t,
            enumerable: !0
        });
    }
    function i(e, t) {
        i.super_.call(this, "D", e), Object.defineProperty(this, "lhs", {
            value: t,
            enumerable: !0
        });
    }
    function a(e, t, r) {
        a.super_.call(this, "A", e), Object.defineProperty(this, "index", {
            value: t,
            enumerable: !0
        }), Object.defineProperty(this, "item", {
            value: r,
            enumerable: !0
        });
    }
    function f(e, t, r) {
        var n = e.slice((r || t) + 1 || e.length);
        return e.length = t < 0 ? e.length + t : t, e.push.apply(e, n), e;
    }
    function u(e) {
        var t = "undefined" == typeof e ? "undefined" : N(e);
        return "object" !== t ? t : e === Math ? "math" : null === e ? "null" : Array.isArray(e) ? "array" : "[object Date]" === Object.prototype.toString.call(e) ? "date" : "function" == typeof e.toString && /^\/.*\//.test(e.toString()) ? "regexp" : "object";
    }
    function l(e, t, r, c, s, d, p) {
        s = s || [], p = p || [];
        var g = s.slice(0);
        if ("undefined" != typeof d) {
            if (c) {
                if ("function" == typeof c && c(g, d)) return;
                if ("object" === ("undefined" == typeof c ? "undefined" : N(c))) {
                    if (c.prefilter && c.prefilter(g, d)) return;
                    if (c.normalize) {
                        var h = c.normalize(g, d, e, t);
                        h && (e = h[0], t = h[1]);
                    }
                }
            }
            g.push(d);
        }
        "regexp" === u(e) && "regexp" === u(t) && (e = e.toString(), t = t.toString());
        var y = "undefined" == typeof e ? "undefined" : N(e), v = "undefined" == typeof t ? "undefined" : N(t), b = "undefined" !== y || p && p[p.length - 1].lhs && p[p.length - 1].lhs.hasOwnProperty(d), m = "undefined" !== v || p && p[p.length - 1].rhs && p[p.length - 1].rhs.hasOwnProperty(d);
        if (!b && m) r(new o(g, t));
        else if (!m && b) r(new i(g, e));
        else if (u(e) !== u(t)) r(new n(g, e, t));
        else if ("date" === u(e) && e - t !== 0) r(new n(g, e, t));
        else if ("object" === y && null !== e && null !== t) {
            if (p.filter(function(t) {
                return t.lhs === e;
            }).length) e !== t && r(new n(g, e, t));
            else {
                if (p.push({
                    lhs: e,
                    rhs: t
                }), Array.isArray(e)) {
                    var w;
                    e.length;
                    for(w = 0; w < e.length; w++)w >= t.length ? r(new a(g, w, new i(void 0, e[w]))) : l(e[w], t[w], r, c, g, w, p);
                    for(; w < t.length;)r(new a(g, w, new o(void 0, t[w++])));
                } else {
                    var x = Object.keys(e), S = Object.keys(t);
                    x.forEach(function(n, o) {
                        var i = S.indexOf(n);
                        i >= 0 ? (l(e[n], t[n], r, c, g, n, p), S = f(S, i)) : l(e[n], void 0, r, c, g, n, p);
                    }), S.forEach(function(e) {
                        l(void 0, t[e], r, c, g, e, p);
                    });
                }
                p.length = p.length - 1;
            }
        } else e !== t && ("number" === y && isNaN(e) && isNaN(t) || r(new n(g, e, t)));
    }
    function c(e, t, r, n) {
        return n = n || [], l(e, t, function(e) {
            e && n.push(e);
        }, r), n.length ? n : void 0;
    }
    function s(e, t, r) {
        if (r.path && r.path.length) {
            var n, o = e[t], i = r.path.length - 1;
            for(n = 0; n < i; n++)o = o[r.path[n]];
            switch(r.kind){
                case "A":
                    s(o[r.path[n]], r.index, r.item);
                    break;
                case "D":
                    delete o[r.path[n]];
                    break;
                case "E":
                case "N":
                    o[r.path[n]] = r.rhs;
            }
        } else switch(r.kind){
            case "A":
                s(e[t], r.index, r.item);
                break;
            case "D":
                e = f(e, t);
                break;
            case "E":
            case "N":
                e[t] = r.rhs;
        }
        return e;
    }
    function d(e, t, r) {
        if (e && t && r && r.kind) {
            for(var n = e, o = -1, i = r.path ? r.path.length - 1 : 0; ++o < i;)"undefined" == typeof n[r.path[o]] && (n[r.path[o]] = "number" == typeof r.path[o] ? [] : {}), n = n[r.path[o]];
            switch(r.kind){
                case "A":
                    s(r.path ? n[r.path[o]] : n, r.index, r.item);
                    break;
                case "D":
                    delete n[r.path[o]];
                    break;
                case "E":
                case "N":
                    n[r.path[o]] = r.rhs;
            }
        }
    }
    function p(e, t, r) {
        if (r.path && r.path.length) {
            var n, o = e[t], i = r.path.length - 1;
            for(n = 0; n < i; n++)o = o[r.path[n]];
            switch(r.kind){
                case "A":
                    p(o[r.path[n]], r.index, r.item);
                    break;
                case "D":
                    o[r.path[n]] = r.lhs;
                    break;
                case "E":
                    o[r.path[n]] = r.lhs;
                    break;
                case "N":
                    delete o[r.path[n]];
            }
        } else switch(r.kind){
            case "A":
                p(e[t], r.index, r.item);
                break;
            case "D":
                e[t] = r.lhs;
                break;
            case "E":
                e[t] = r.lhs;
                break;
            case "N":
                e = f(e, t);
        }
        return e;
    }
    function g(e, t, r) {
        if (e && t && r && r.kind) {
            var n, o, i = e;
            for(o = r.path.length - 1, n = 0; n < o; n++)"undefined" == typeof i[r.path[n]] && (i[r.path[n]] = {}), i = i[r.path[n]];
            switch(r.kind){
                case "A":
                    p(i[r.path[n]], r.index, r.item);
                    break;
                case "D":
                    i[r.path[n]] = r.lhs;
                    break;
                case "E":
                    i[r.path[n]] = r.lhs;
                    break;
                case "N":
                    delete i[r.path[n]];
            }
        }
    }
    function h(e, t, r) {
        if (e && t) {
            var n = function(n) {
                r && !r(e, t, n) || d(e, t, n);
            };
            l(e, t, n);
        }
    }
    function y(e) {
        return "color: " + F[e].color + "; font-weight: bold";
    }
    function v(e) {
        var t = e.kind, r = e.path, n = e.lhs, o = e.rhs, i = e.index, a = e.item;
        switch(t){
            case "E":
                return [
                    r.join("."),
                    n,
                    "\u2192",
                    o
                ];
            case "N":
                return [
                    r.join("."),
                    o
                ];
            case "D":
                return [
                    r.join(".")
                ];
            case "A":
                return [
                    r.join(".") + "[" + i + "]",
                    a
                ];
            default:
                return [];
        }
    }
    function b(e, t, r, n) {
        var o = c(e, t);
        try {
            n ? r.groupCollapsed("diff") : r.group("diff");
        } catch (e) {
            r.log("diff");
        }
        o ? o.forEach(function(e) {
            var t = e.kind, n = v(e);
            r.log.apply(r, [
                "%c " + F[t].text,
                y(t)
            ].concat(P(n)));
        }) : r.log("\u2014\u2014 no diff \u2014\u2014");
        try {
            r.groupEnd();
        } catch (e) {
            r.log("\u2014\u2014 diff end \u2014\u2014 ");
        }
    }
    function m(e, t, r, n) {
        switch("undefined" == typeof e ? "undefined" : N(e)){
            case "object":
                return "function" == typeof e[n] ? e[n].apply(e, P(r)) : e[n];
            case "function":
                return e(t);
            default:
                return e;
        }
    }
    function w(e) {
        var t = e.timestamp, r = e.duration;
        return function(e, n, o) {
            var i = [
                "action"
            ];
            return i.push("%c" + String(e.type)), t && i.push("%c@ " + n), r && i.push("%c(in " + o.toFixed(2) + " ms)"), i.join(" ");
        };
    }
    function x(e, t) {
        var r = t.logger, n = t.actionTransformer, o = t.titleFormatter, i = void 0 === o ? w(t) : o, a = t.collapsed, f = t.colors, u = t.level, l = t.diff, c = "undefined" == typeof t.titleFormatter;
        e.forEach(function(o, s) {
            var d = o.started, p = o.startedTime, g = o.action, h = o.prevState, y = o.error, v = o.took, w = o.nextState, x = e[s + 1];
            x && (w = x.prevState, v = x.started - d);
            var S = n(g), k = "function" == typeof a ? a(function() {
                return w;
            }, g, o) : a, j = D(p), E = f.title ? "color: " + f.title(S) + ";" : "", A = [
                "color: gray; font-weight: lighter;"
            ];
            A.push(E), t.timestamp && A.push("color: gray; font-weight: lighter;"), t.duration && A.push("color: gray; font-weight: lighter;");
            var O = i(S, j, v);
            try {
                k ? f.title && c ? r.groupCollapsed.apply(r, [
                    "%c " + O
                ].concat(A)) : r.groupCollapsed(O) : f.title && c ? r.group.apply(r, [
                    "%c " + O
                ].concat(A)) : r.group(O);
            } catch (e) {
                r.log(O);
            }
            var N = m(u, S, [
                h
            ], "prevState"), P = m(u, S, [
                S
            ], "action"), C = m(u, S, [
                y,
                h
            ], "error"), F = m(u, S, [
                w
            ], "nextState");
            if (N) {
                if (f.prevState) {
                    var L = "color: " + f.prevState(h) + "; font-weight: bold";
                    r[N]("%c prev state", L, h);
                } else r[N]("prev state", h);
            }
            if (P) {
                if (f.action) {
                    var T = "color: " + f.action(S) + "; font-weight: bold";
                    r[P]("%c action    ", T, S);
                } else r[P]("action    ", S);
            }
            if (y && C) {
                if (f.error) {
                    var M = "color: " + f.error(y, h) + "; font-weight: bold;";
                    r[C]("%c error     ", M, y);
                } else r[C]("error     ", y);
            }
            if (F) {
                if (f.nextState) {
                    var _ = "color: " + f.nextState(w) + "; font-weight: bold";
                    r[F]("%c next state", _, w);
                } else r[F]("next state", w);
            }
            l && b(h, w, r, k);
            try {
                r.groupEnd();
            } catch (e) {
                r.log("\u2014\u2014 log end \u2014\u2014");
            }
        });
    }
    function S() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = Object.assign({}, L, e), r = t.logger, n = t.stateTransformer, o = t.errorTransformer, i = t.predicate, a = t.logErrors, f = t.diffPredicate;
        if ("undefined" == typeof r) return function() {
            return function(e) {
                return function(t) {
                    return e(t);
                };
            };
        };
        if (e.getState && e.dispatch) return console.error("[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n// Logger with default options\nimport { logger } from 'redux-logger'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from 'redux-logger'\nconst logger = createLogger({\n  // ...options\n});\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n"), function() {
            return function(e) {
                return function(t) {
                    return e(t);
                };
            };
        };
        var u = [];
        return function(e) {
            var r = e.getState;
            return function(e) {
                return function(l) {
                    if ("function" == typeof i && !i(r, l)) return e(l);
                    var c = {};
                    u.push(c), c.started = O.now(), c.startedTime = new Date, c.prevState = n(r()), c.action = l;
                    var s = void 0;
                    if (a) try {
                        s = e(l);
                    } catch (e) {
                        c.error = o(e);
                    }
                    else s = e(l);
                    c.took = O.now() - c.started, c.nextState = n(r());
                    var d = t.diff && "function" == typeof f ? f(r, l) : t.diff;
                    if (x(u, Object.assign({}, t, {
                        diff: d
                    })), u.length = 0, c.error) throw c.error;
                    return s;
                };
            };
        };
    }
    var k, j, E = function(e, t) {
        return new Array(t + 1).join(e);
    }, A = function(e, t) {
        return E("0", t - e.toString().length) + e;
    }, D = function(e) {
        return A(e.getHours(), 2) + ":" + A(e.getMinutes(), 2) + ":" + A(e.getSeconds(), 2) + "." + A(e.getMilliseconds(), 3);
    }, O = "undefined" != typeof performance && null !== performance && "function" == typeof performance.now ? performance : Date, N = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
        return typeof e;
    } : function(e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    }, P = function(e) {
        if (Array.isArray(e)) {
            for(var t = 0, r = Array(e.length); t < e.length; t++)r[t] = e[t];
            return r;
        }
        return Array.from(e);
    }, C = [];
    k = "object" === ("undefined" == typeof $parcel$global ? "undefined" : N($parcel$global)) && $parcel$global ? $parcel$global : "undefined" != typeof window ? window : {}, j = k.DeepDiff, j && C.push(function() {
        "undefined" != typeof j && k.DeepDiff === c && (k.DeepDiff = j, j = void 0);
    }), t(n, r), t(o, r), t(i, r), t(a, r), Object.defineProperties(c, {
        diff: {
            value: c,
            enumerable: !0
        },
        observableDiff: {
            value: l,
            enumerable: !0
        },
        applyDiff: {
            value: h,
            enumerable: !0
        },
        applyChange: {
            value: d,
            enumerable: !0
        },
        revertChange: {
            value: g,
            enumerable: !0
        },
        isConflict: {
            value: function() {
                return "undefined" != typeof j;
            },
            enumerable: !0
        },
        noConflict: {
            value: function() {
                return C && (C.forEach(function(e) {
                    e();
                }), C = null), c;
            },
            enumerable: !0
        }
    });
    var F = {
        E: {
            color: "#2196F3",
            text: "CHANGED:"
        },
        N: {
            color: "#4CAF50",
            text: "ADDED:"
        },
        D: {
            color: "#F44336",
            text: "DELETED:"
        },
        A: {
            color: "#2196F3",
            text: "ARRAY:"
        }
    }, L = {
        level: "log",
        logger: console,
        logErrors: !0,
        collapsed: void 0,
        predicate: void 0,
        duration: !1,
        timestamp: !0,
        stateTransformer: function(e) {
            return e;
        },
        actionTransformer: function(e) {
            return e;
        },
        errorTransformer: function(e) {
            return e;
        },
        colors: {
            title: function() {
                return "inherit";
            },
            prevState: function() {
                return "#9E9E9E";
            },
            action: function() {
                return "#03A9F4";
            },
            nextState: function() {
                return "#4CAF50";
            },
            error: function() {
                return "#F20404";
            }
        },
        diff: !1,
        diffPredicate: void 0,
        transformer: void 0
    }, T = function() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = e.dispatch, r = e.getState;
        return "function" == typeof t || "function" == typeof r ? S()({
            dispatch: t,
            getState: r
        }) : void console.error("\n[redux-logger v3] BREAKING CHANGE\n[redux-logger v3] Since 3.0.0 redux-logger exports by default logger with default settings.\n[redux-logger v3] Change\n[redux-logger v3] import createLogger from 'redux-logger'\n[redux-logger v3] to\n[redux-logger v3] import { createLogger } from 'redux-logger'\n");
    };
    e.defaults = L, e.createLogger = S, e.logger = T, e.default = T, Object.defineProperty(e, "__esModule", {
        value: !0
    });
});

});

parcelRegister("ifg6x", function(module, exports) {

var $4CZTG = parcelRequire("4CZTG");
/**
 * Creates an array of elements split into two groups, the first of which
 * contains elements `predicate` returns truthy for, the second of which
 * contains elements `predicate` returns falsey for. The predicate is
 * invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of grouped elements.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': false },
 *   { 'user': 'fred',    'age': 40, 'active': true },
 *   { 'user': 'pebbles', 'age': 1,  'active': false }
 * ];
 *
 * _.partition(users, function(o) { return o.active; });
 * // => objects for [['fred'], ['barney', 'pebbles']]
 *
 * // The `_.matches` iteratee shorthand.
 * _.partition(users, { 'age': 1, 'active': false });
 * // => objects for [['pebbles'], ['barney', 'fred']]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.partition(users, ['active', false]);
 * // => objects for [['barney', 'pebbles'], ['fred']]
 *
 * // The `_.property` iteratee shorthand.
 * _.partition(users, 'active');
 * // => objects for [['fred'], ['barney', 'pebbles']]
 */ var $d4861eb268113e50$var$partition = $4CZTG(function(result, value, key) {
    result[key ? 0 : 1].push(value);
}, function() {
    return [
        [],
        []
    ];
});
module.exports = $d4861eb268113e50$var$partition;

});
parcelRegister("4CZTG", function(module, exports) {

var $hBvrS = parcelRequire("hBvrS");

var $fqzo0 = parcelRequire("fqzo0");

var $bxDef = parcelRequire("bxDef");

var $8LQ84 = parcelRequire("8LQ84");
/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */ function $35eab98708747af8$var$createAggregator(setter, initializer) {
    return function(collection, iteratee) {
        var func = $8LQ84(collection) ? $hBvrS : $fqzo0, accumulator = initializer ? initializer() : {};
        return func(collection, setter, $bxDef(iteratee, 2), accumulator);
    };
}
module.exports = $35eab98708747af8$var$createAggregator;

});
parcelRegister("hBvrS", function(module, exports) {
/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $cd0e496a488f8bed$var$arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        var value = array[index];
        setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
}
module.exports = $cd0e496a488f8bed$var$arrayAggregator;

});

parcelRegister("fqzo0", function(module, exports) {

var $e7pfQ = parcelRequire("e7pfQ");
/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $b3b4bba991f8eee5$var$baseAggregator(collection, setter, iteratee, accumulator) {
    $e7pfQ(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
    });
    return accumulator;
}
module.exports = $b3b4bba991f8eee5$var$baseAggregator;

});
parcelRegister("e7pfQ", function(module, exports) {

var $hDnyx = parcelRequire("hDnyx");

var $bogqY = parcelRequire("bogqY");
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $a4754f2fa2dabe99$var$baseEach = $bogqY($hDnyx);
module.exports = $a4754f2fa2dabe99$var$baseEach;

});
parcelRegister("hDnyx", function(module, exports) {

var $et7t4 = parcelRequire("et7t4");

var $66FNL = parcelRequire("66FNL");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $cd6859e7c62c7d41$var$baseForOwn(object, iteratee) {
    return object && $et7t4(object, iteratee, $66FNL);
}
module.exports = $cd6859e7c62c7d41$var$baseForOwn;

});

parcelRegister("bogqY", function(module, exports) {

var $hTJwX = parcelRequire("hTJwX");
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $84aeaf14b55f70e4$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$hTJwX(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = $84aeaf14b55f70e4$var$createBaseEach;

});





parcelRegister("5euJh", function(module, exports) {

$parcel$export(module.exports, "getATLContextDomain", () => $4999809f6856da20$export$b5ce351acdc48c2a);
$parcel$export(module.exports, "getATLContextUrl", () => $4999809f6856da20$export$45d6512913ef41b4);


var $k8H7R = parcelRequire("k8H7R");

var $6hv9b = parcelRequire("6hv9b");
function $4999809f6856da20$export$8d21e34596265fa2(data) {
    if (!data || Object.keys(data).length < 1) throw new Error('Data are not available');
    // @ts-ignore - This is causing ts errors when this package is being enrolled into jira local consumption so temporarily ts ignoring this line for now
    globalThis.ATL_CONTEXT_DOMAIN = data;
}
function $4999809f6856da20$var$isValidDomainKey(domainKey) {
    if (!(0, $6hv9b.AllowedDomains).includes(domainKey)) return false;
    return true;
}
function $4999809f6856da20$export$b5ce351acdc48c2a(domain, environment) {
    // Validate this is a valid domain
    if (!$4999809f6856da20$var$isValidDomainKey(domain)) throw new Error(`Domain ${domain} is not supported.
      Supported domains: ${(0, $6hv9b.AllowedDomains).join(', ')}`);
    // First priority, always return the global context if the product has onboarded
    // @ts-ignore - This is causing ts errors when this package is being enrolled into jira local consumption so temporarily ts ignoring this line for now
    const data = globalThis.ATL_CONTEXT_DOMAIN;
    if (data) return data[domain];
    const [env, perimeter] = environment ?? $4999809f6856da20$export$509d18a5fd824839();
    // Second priority, return if there is a full domain override
    const override = (0, $k8H7R.fullDomainOverride)[domain];
    if (override) return(// Exact match preferred
    override[perimeter]?.[env] ?? override[0, $5f2d1e7b8a614058$export$f005e2e9f707cb5f][0, $5f2d1e7b8a614058$export$42dd0cdd351a4a9] // Fallback to mandatory commercial production
    );
    // Third priority, join the subdomain
    const tld = (0, $k8H7R.domainMap)[perimeter]?.[env] ?? (0, $k8H7R.domainMap)[0, $5f2d1e7b8a614058$export$f005e2e9f707cb5f][0, $5f2d1e7b8a614058$export$42dd0cdd351a4a9];
    const subdomain = (0, $k8H7R.subdomainOverride)[domain] ?? domain;
    return `${subdomain}.${tld}`;
}
function $4999809f6856da20$export$45d6512913ef41b4(domain) {
    return `${globalThis.location.protocol}//${$4999809f6856da20$export$b5ce351acdc48c2a(domain)}`;
}
function $4999809f6856da20$export$509d18a5fd824839() {
    const hostname = globalThis.location?.hostname;
    if (!hostname) // default if no location available
    return [
        (0, $5f2d1e7b8a614058$export$42dd0cdd351a4a9),
        (0, $5f2d1e7b8a614058$export$f005e2e9f707cb5f)
    ];
    // *.atlassian-fex.com
    if (hostname.match(/atlassian-fex\.com/)) return [
        (0, $5f2d1e7b8a614058$export$a739cd5aac835909),
        (0, $5f2d1e7b8a614058$export$bd6b5a7802d76127)
    ];
    // *.stg.atlassian-us-gov-mod.com OR *.stg.atlassian-us-gov-mod.net
    if (hostname.match(/stg\.atlassian-us-gov-mod\.(com|net)/)) return [
        (0, $5f2d1e7b8a614058$export$a739cd5aac835909),
        (0, $5f2d1e7b8a614058$export$ce553301d55c2fd8)
    ];
    // *.atlassian-stg-fedm.net
    if (hostname.match(/atlassian-stg-fedm\.net/)) return [
        (0, $5f2d1e7b8a614058$export$a739cd5aac835909),
        (0, $5f2d1e7b8a614058$export$ce553301d55c2fd8)
    ];
    // *.atlassian-us-gov-mod.com OR *.atlassian-us-gov-mod.net
    if (hostname.match(/atlassian-us-gov-mod\.(com|net)/)) return [
        (0, $5f2d1e7b8a614058$export$42dd0cdd351a4a9),
        (0, $5f2d1e7b8a614058$export$ce553301d55c2fd8)
    ];
    // *.stg.atlassian.com OR *.stg.internal.atlassian.com
    if (hostname.match(/stg(\.internal)?\.atlassian\.com/)) return [
        (0, $5f2d1e7b8a614058$export$a739cd5aac835909),
        (0, $5f2d1e7b8a614058$export$f005e2e9f707cb5f)
    ];
    // *.jira-dev.com
    if (hostname.match(/jira-dev\.com/)) return [
        (0, $5f2d1e7b8a614058$export$a739cd5aac835909),
        (0, $5f2d1e7b8a614058$export$f005e2e9f707cb5f)
    ];
    // default fallthrough
    return [
        (0, $5f2d1e7b8a614058$export$42dd0cdd351a4a9),
        (0, $5f2d1e7b8a614058$export$f005e2e9f707cb5f)
    ];
}

});
const $5f2d1e7b8a614058$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $5f2d1e7b8a614058$export$f005e2e9f707cb5f = 'commercial';
const $5f2d1e7b8a614058$export$bd6b5a7802d76127 = 'fedramp-fedex';
const $5f2d1e7b8a614058$export$a739cd5aac835909 = 'stg';
const $5f2d1e7b8a614058$export$42dd0cdd351a4a9 = 'prod';
const $5f2d1e7b8a614058$export$404582bc18fe4d9e = 'dev';

parcelRegister("k8H7R", function(module, exports) {

$parcel$export(module.exports, "domainMap", () => $85d3c71d4c30886b$export$6836b090dbaa813a);
$parcel$export(module.exports, "subdomainOverride", () => $85d3c71d4c30886b$export$c6ab20d0ac4d06b2);
$parcel$export(module.exports, "fullDomainOverride", () => $85d3c71d4c30886b$export$4723232b625f823e);

const $85d3c71d4c30886b$export$6836b090dbaa813a = {
    [(0, $5f2d1e7b8a614058$export$f005e2e9f707cb5f)]: {
        [(0, $5f2d1e7b8a614058$export$a739cd5aac835909)]: 'stg.atlassian.com',
        [(0, $5f2d1e7b8a614058$export$42dd0cdd351a4a9)]: 'atlassian.com'
    },
    [(0, $5f2d1e7b8a614058$export$bd6b5a7802d76127)]: {
        [(0, $5f2d1e7b8a614058$export$a739cd5aac835909)]: 'atlassian-fex.com'
    },
    [(0, $5f2d1e7b8a614058$export$ce553301d55c2fd8)]: {
        [(0, $5f2d1e7b8a614058$export$a739cd5aac835909)]: 'stg.atlassian-us-gov-mod.com',
        [(0, $5f2d1e7b8a614058$export$42dd0cdd351a4a9)]: 'atlassian-us-gov-mod.com'
    }
};
const $85d3c71d4c30886b$export$c6ab20d0ac4d06b2 = {};
const $85d3c71d4c30886b$export$4723232b625f823e = {
    analytics: {
        [(0, $5f2d1e7b8a614058$export$f005e2e9f707cb5f)]: {
            [(0, $5f2d1e7b8a614058$export$42dd0cdd351a4a9)]: 'analytics.atlassian.com'
        }
    },
    // Marketing site
    confluence: {
        [(0, $5f2d1e7b8a614058$export$f005e2e9f707cb5f)]: {
            [(0, $5f2d1e7b8a614058$export$42dd0cdd351a4a9)]: 'confluence.atlassian.com'
        }
    },
    // Atlassian design system documentation
    design: {
        [(0, $5f2d1e7b8a614058$export$f005e2e9f707cb5f)]: {
            [(0, $5f2d1e7b8a614058$export$42dd0cdd351a4a9)]: 'design.atlassian.com'
        }
    },
    // Old staff intranet (now hello.atlassian.net)
    extranet: {
        [(0, $5f2d1e7b8a614058$export$f005e2e9f707cb5f)]: {
            [(0, $5f2d1e7b8a614058$export$42dd0cdd351a4a9)]: 'extranet.atlassian.com'
        }
    },
    // Go links
    go: {
        [(0, $5f2d1e7b8a614058$export$f005e2e9f707cb5f)]: {
            [(0, $5f2d1e7b8a614058$export$42dd0cdd351a4a9)]: 'go.atlassian.com'
        }
    },
    my: {
        [(0, $5f2d1e7b8a614058$export$f005e2e9f707cb5f)]: {
            [(0, $5f2d1e7b8a614058$export$42dd0cdd351a4a9)]: 'my.atlassian.com'
        }
    },
    schema: {
        [(0, $5f2d1e7b8a614058$export$f005e2e9f707cb5f)]: {
            [(0, $5f2d1e7b8a614058$export$42dd0cdd351a4a9)]: 'schema.atlassian.com'
        }
    },
    start: {
        [(0, $5f2d1e7b8a614058$export$f005e2e9f707cb5f)]: {
            [(0, $5f2d1e7b8a614058$export$42dd0cdd351a4a9)]: 'start.atlassian.com',
            [(0, $5f2d1e7b8a614058$export$a739cd5aac835909)]: 'start.stg.atlassian.com'
        },
        [(0, $5f2d1e7b8a614058$export$ce553301d55c2fd8)]: {
            [(0, $5f2d1e7b8a614058$export$42dd0cdd351a4a9)]: 'start.atlassian-us-gov-mod.com',
            [(0, $5f2d1e7b8a614058$export$a739cd5aac835909)]: 'start.stg.atlassian-us-gov-mod.com'
        }
    },
    surveys: {
        [(0, $5f2d1e7b8a614058$export$f005e2e9f707cb5f)]: {
            [(0, $5f2d1e7b8a614058$export$42dd0cdd351a4a9)]: 'surveys.atlassian.com'
        }
    },
    'wac-cdn': {
        [(0, $5f2d1e7b8a614058$export$f005e2e9f707cb5f)]: {
            [(0, $5f2d1e7b8a614058$export$42dd0cdd351a4a9)]: 'wac-cdn.atlassian.com'
        }
    },
    integrations: {
        [(0, $5f2d1e7b8a614058$export$f005e2e9f707cb5f)]: {
            [(0, $5f2d1e7b8a614058$export$42dd0cdd351a4a9)]: 'integrations.atlassian.com'
        }
    },
    permalink: {
        [(0, $5f2d1e7b8a614058$export$f005e2e9f707cb5f)]: {
            [(0, $5f2d1e7b8a614058$export$42dd0cdd351a4a9)]: 'permalink.atlassian.com'
        }
    },
    id: {
        [(0, $5f2d1e7b8a614058$export$f005e2e9f707cb5f)]: {
            [(0, $5f2d1e7b8a614058$export$42dd0cdd351a4a9)]: 'id.atlassian.com',
            [(0, $5f2d1e7b8a614058$export$a739cd5aac835909)]: 'id.stg.internal.atlassian.com',
            [(0, $5f2d1e7b8a614058$export$404582bc18fe4d9e)]: 'id.dev.internal.atlassian.com'
        },
        [(0, $5f2d1e7b8a614058$export$ce553301d55c2fd8)]: {
            [(0, $5f2d1e7b8a614058$export$42dd0cdd351a4a9)]: 'id.atlassian-us-gov-mod.com',
            [(0, $5f2d1e7b8a614058$export$a739cd5aac835909)]: 'id.stg.atlassian-us-gov-mod.com'
        }
    },
    support: {
        [(0, $5f2d1e7b8a614058$export$f005e2e9f707cb5f)]: {
            [(0, $5f2d1e7b8a614058$export$42dd0cdd351a4a9)]: 'support.atlassian.com'
        }
    }
};

});

parcelRegister("6hv9b", function(module, exports) {

$parcel$export(module.exports, "AllowedDomains", () => $3e2a7375a344cb09$export$b450288891b9771b);
/* *NOTE*: please ensure any changes made to Perimeter and DomainKey type is copied in typings/atl-context.globals.d.ts */ const $3e2a7375a344cb09$export$b450288891b9771b = [
    'admin',
    'analytics',
    'api',
    'api.media',
    'api-private',
    'as',
    'atl-global',
    'atlaskit',
    'auth',
    'automation',
    'cassi.internal',
    'cc-import-sources.services',
    'confluence',
    'confluence-chats-integr.services',
    'confluence-cloud-bamboo.internal',
    'confluence-questions.services',
    'data-portal.internal',
    'design',
    'developer',
    'extranet',
    'go',
    'id',
    'id-mail-assets',
    'integrations',
    'ja',
    'jira',
    'jsd-widget',
    'jsd-widget-staging',
    'marketplace',
    'my',
    'my-reminders.services',
    'partners',
    'permalink',
    'permalink.stg',
    'schema',
    'start',
    'support',
    'surveys',
    'team',
    'wac-cdn',
    'xxid',
    'home'
];

});


parcelRegister("2I8bw", function(module, exports) {

$parcel$export(module.exports, "getInstance", () => $1a9f4d6c6e9968ea$export$8bedcca5bbd73999);

var $5euJh = parcelRequire("5euJh");

var $6WW6B = parcelRequire("6WW6B");

var $kBAuL = parcelRequire("kBAuL");
const $1a9f4d6c6e9968ea$var$redirect = ()=>{
    const identity = (0, $5euJh.getATLContextDomain)('id');
    // Hardcoding to Jira as this will be the only adopter of this service for now.
    const redirectUrl = `https://${identity}/login?application=jira&continue=${encodeURIComponent(window.location.href)}`;
    window.location.assign(redirectUrl);
};
const $1a9f4d6c6e9968ea$var$DEFAULT_ENDPOINT = '/gateway/api/session/heartbeat';
const $1a9f4d6c6e9968ea$var$DEFAULT_IDLE_TIME = 60000;
const $1a9f4d6c6e9968ea$var$timeIsBeforeNow = (dateTime)=>{
    return !!(dateTime && dateTime.getTime() <= Date.now());
};
const $1a9f4d6c6e9968ea$var$HeartbeatService = ()=>{
    let timer;
    let heartBeatInterval;
    let nextCallTimestamp;
    let sessionExpiryTimestamp;
    let initialized = false;
    let authenticated = false;
    let userActive = true;
    let tabActive = true;
    const isAuthenticated = ()=>{
        return authenticated;
    };
    const isInitialized = ()=>{
        return initialized;
    };
    const init = ()=>{
        // Initial heartbeat
        beat();
        heartBeatInterval = setupHeartbeatInterval();
        timer = setupBrowserInteractionTime();
    };
    const cleanup = ()=>{
        clearHeartbeatInterval();
        clearBrowserInteractionTime();
    };
    const beat = async ()=>{
        try {
            const response = await (0, $kBAuL.postHeartbeat)($1a9f4d6c6e9968ea$var$DEFAULT_ENDPOINT, $1a9f4d6c6e9968ea$var$redirect);
            if (!initialized) initialized = true;
            if (response) {
                const { nextCallTimestamp: nextCallT, sessionExpiryTime: sessionExpiryT } = response;
                nextCallTimestamp = new Date(nextCallT);
                sessionExpiryTimestamp = sessionExpiryT ? new Date(sessionExpiryT) : undefined;
                authenticated = true;
            }
        } catch (error) {
            authenticated = false;
            clearHeartbeatInterval();
        }
    };
    const setupHeartbeatInterval = ()=>setInterval(()=>{
            if ($1a9f4d6c6e9968ea$var$timeIsBeforeNow(sessionExpiryTimestamp) || userActive && tabActive && $1a9f4d6c6e9968ea$var$timeIsBeforeNow(nextCallTimestamp)) beat();
        }, 10000);
    const clearHeartbeatInterval = ()=>{
        clearInterval(heartBeatInterval);
        heartBeatInterval = undefined;
    };
    const setupBrowserInteractionTime = ()=>{
        const timer = new (0, $6WW6B.default)({
            idleTimeoutMs: $1a9f4d6c6e9968ea$var$DEFAULT_IDLE_TIME,
            stopTimerOnTabchange: false,
            browserTabActiveCallbacks: [
                ()=>tabActive = true
            ],
            browserTabInactiveCallbacks: [
                ()=>tabActive = false
            ],
            idleCallbacks: [
                ()=>{
                    // Beat once when the user goes idle and the tab is active
                    if (tabActive) beat();
                    userActive = false;
                }
            ],
            activeCallbacks: [
                ()=>userActive = true
            ]
        });
        timer.startTimer();
        return timer;
    };
    const clearBrowserInteractionTime = ()=>{
        timer && timer.destroy();
        timer = undefined;
    };
    return {
        isAuthenticated: isAuthenticated,
        isInitialized: isInitialized,
        init: init,
        cleanup: cleanup
    };
};
let $1a9f4d6c6e9968ea$var$instance = null;
const $1a9f4d6c6e9968ea$export$8bedcca5bbd73999 = ()=>{
    if (!$1a9f4d6c6e9968ea$var$instance) {
        $1a9f4d6c6e9968ea$var$instance = $1a9f4d6c6e9968ea$var$HeartbeatService();
        $1a9f4d6c6e9968ea$var$instance.init();
    }
    return $1a9f4d6c6e9968ea$var$instance;
};

});
parcelRegister("6WW6B", function(module, exports) {

$parcel$export(module.exports, "default", () => $02c9d75fd1e73e43$export$2e2bcd8739ae039);

var $34ck9 = parcelRequire("34ck9");
const $02c9d75fd1e73e43$var$windowIdleEvents = [
    'scroll',
    'resize'
];
const $02c9d75fd1e73e43$var$documentIdleEvents = [
    'wheel',
    'keydown',
    'keyup',
    'mousedown',
    'mousemove',
    'touchstart',
    'touchmove',
    'click',
    'contextmenu'
];
class $02c9d75fd1e73e43$export$2e2bcd8739ae039 {
    constructor({ timeIntervalEllapsedCallbacks: timeIntervalEllapsedCallbacks = [], absoluteTimeEllapsedCallbacks: absoluteTimeEllapsedCallbacks = [], checkCallbacksIntervalMs: checkCallbacksIntervalMs = 100, browserTabInactiveCallbacks: browserTabInactiveCallbacks = [], idleCallbacks: idleCallbacks = [], stopTimerOnTabchange: stopTimerOnTabchange = true, activeCallbacks: activeCallbacks = [], browserTabActiveCallbacks: browserTabActiveCallbacks = [], idleTimeoutMs: idleTimeoutMs = 3000 }){
        this.onBrowserTabInactive = ()=>{
            // if running pause timer
            if (this.isRunning() && this.stopTimerOnTabchange) this.stopTimer();
            this.browserTabInactiveCallbacks.forEach((fn)=>fn(this.getTimeInMilliseconds()));
        };
        this.onBrowserTabActive = ()=>{
            // if not running start timer
            if (!this.isRunning()) this.startTimer();
            this.browserTabActiveCallbacks.forEach((fn)=>fn(this.getTimeInMilliseconds()));
        };
        this.onBrowserActiveChange = ()=>{
            if (document.visibilityState === 'visible') this.onBrowserTabActive();
            else this.onBrowserTabInactive();
        };
        this.onTimePassed = ()=>{
            // check all callbacks time and if passed execute callback
            this.absoluteTimeEllapsedCallbacks.forEach(({ callback: callback, pending: pending, timeInMilliseconds: timeInMilliseconds }, index)=>{
                if (pending && timeInMilliseconds <= this.getTimeInMilliseconds()) {
                    callback(this.getTimeInMilliseconds());
                    this.absoluteTimeEllapsedCallbacks[index].pending = false;
                }
            });
            this.timeIntervalEllapsedCallbacks.forEach(({ callback: callback, timeInMilliseconds: timeInMilliseconds, multiplier: multiplier }, index)=>{
                if (timeInMilliseconds <= this.getTimeInMilliseconds()) {
                    callback(this.getTimeInMilliseconds());
                    this.timeIntervalEllapsedCallbacks[index].timeInMilliseconds = multiplier(timeInMilliseconds);
                }
            });
            if (this.currentIdleTimeMs >= this.idleTimeoutMs && this.isRunning()) {
                this.idle = true;
                this.stopTimer();
                this.idleCallbacks.forEach((fn)=>fn(this.getTimeInMilliseconds()));
            } else this.currentIdleTimeMs += this.checkCallbacksIntervalMs;
        };
        this.resetIdleTime = ()=>{
            if (this.idle) this.startTimer();
            this.activeCallbacks.forEach((fn)=>fn(this.getTimeInMilliseconds()));
            this.idle = false;
            this.currentIdleTimeMs = 0;
        };
        this.registerEventListeners = ()=>{
            const documentListenerOptions = {
                passive: true
            };
            const windowListenerOptions = {
                ...documentListenerOptions,
                capture: true
            };
            document.addEventListener('visibilitychange', this.onBrowserActiveChange);
            const throttleResetIdleTime = (0, (/*@__PURE__*/$parcel$interopDefault($34ck9)))(this.resetIdleTime, 2000, {
                leading: true,
                trailing: false
            });
            $02c9d75fd1e73e43$var$windowIdleEvents.forEach((event)=>{
                window.addEventListener(event, throttleResetIdleTime, windowListenerOptions);
            });
            $02c9d75fd1e73e43$var$documentIdleEvents.forEach((event)=>document.addEventListener(event, throttleResetIdleTime, documentListenerOptions));
        };
        this.unregisterEventListeners = ()=>{
            document.removeEventListener('visibilitychange', this.onBrowserActiveChange);
            $02c9d75fd1e73e43$var$windowIdleEvents.forEach((event)=>window.removeEventListener(event, this.resetIdleTime));
            $02c9d75fd1e73e43$var$documentIdleEvents.forEach((event)=>document.removeEventListener(event, this.resetIdleTime));
        };
        this.checkCallbacksOnInterval = ()=>{
            this.checkCallbackIntervalId = window.setInterval(()=>{
                this.onTimePassed();
            }, this.checkCallbacksIntervalMs);
        };
        this.startTimer = ()=>{
            if (!this.checkCallbackIntervalId) this.checkCallbacksOnInterval();
            const last = this.times[this.times.length - 1];
            if (last && last.stop === null) return;
            this.times.push({
                start: performance.now(),
                stop: null
            });
            this.running = true;
        };
        this.stopTimer = ()=>{
            if (!this.times.length) return;
            this.times[this.times.length - 1].stop = performance.now();
            this.running = false;
        };
        this.addTimeIntervalEllapsedCallback = (timeIntervalEllapsedCallback)=>{
            this.timeIntervalEllapsedCallbacks.push(timeIntervalEllapsedCallback);
        };
        this.addAbsoluteTimeEllapsedCallback = (absoluteTimeEllapsedCallback)=>{
            this.absoluteTimeEllapsedCallbacks.push(absoluteTimeEllapsedCallback);
        };
        this.addBrowserTabInactiveCallback = (browserTabInactiveCallback)=>{
            this.browserTabInactiveCallbacks.push(browserTabInactiveCallback);
        };
        this.addBrowserTabActiveCallback = (browserTabActiveCallback)=>{
            this.browserTabActiveCallbacks.push(browserTabActiveCallback);
        };
        this.addIdleCallback = (inactiveCallback)=>{
            this.idleCallbacks.push(inactiveCallback);
        };
        this.addActiveCallback = (activeCallback)=>{
            this.activeCallbacks.push(activeCallback);
        };
        this.getTimeInMilliseconds = ()=>{
            return this.times.reduce((acc, current)=>{
                if (current.stop) acc = acc + (current.stop - current.start);
                else acc = acc + (performance.now() - current.start);
                return acc;
            }, 0);
        };
        this.isRunning = ()=>{
            return this.running;
        };
        this.isIdle = ()=>{
            return this.idle;
        };
        this.reset = ()=>{
            this.times = [];
        };
        this.destroy = ()=>{
            this.unregisterEventListeners();
            if (this.checkCallbackIntervalId) window.clearInterval(this.checkCallbackIntervalId);
        };
        this.running = false;
        this.times = [];
        this.idle = false;
        this.currentIdleTimeMs = 0;
        this.marks = {};
        this.measures = {};
        this.stopTimerOnTabchange = stopTimerOnTabchange;
        this.browserTabActiveCallbacks = browserTabActiveCallbacks;
        this.browserTabInactiveCallbacks = browserTabInactiveCallbacks;
        this.checkCallbacksIntervalMs = checkCallbacksIntervalMs;
        this.idleTimeoutMs = idleTimeoutMs;
        this.timeIntervalEllapsedCallbacks = timeIntervalEllapsedCallbacks;
        this.absoluteTimeEllapsedCallbacks = absoluteTimeEllapsedCallbacks;
        this.idleCallbacks = idleCallbacks;
        this.activeCallbacks = activeCallbacks;
        this.registerEventListeners();
    }
    mark(key) {
        if (!this.marks[key]) this.marks[key] = [];
        this.marks[key].push({
            time: this.getTimeInMilliseconds()
        });
    }
    getMarks(name) {
        if (this.marks[name].length < 1) return;
        return this.marks[name];
    }
    measure(name, startMarkName, endMarkName) {
        const startMarks = this.marks[startMarkName];
        const startMark = startMarks[startMarks.length - 1];
        const endMarks = this.marks[endMarkName];
        const endMark = endMarks[endMarks.length - 1];
        if (!this.measures[name]) this.measures[name] = [];
        this.measures[name].push({
            name: name,
            startTime: startMark.time,
            duration: endMark.time - startMark.time
        });
    }
    getMeasures(name) {
        if (!this.measures[name] && this.measures[name].length < 1) return;
        return this.measures[name];
    }
}

});
parcelRegister("34ck9", function(module, exports) {

var $lFKmC = parcelRequire("lFKmC");

var $k0qYG = parcelRequire("k0qYG");
/** Error message constants. */ var $23bb4e171ff15bc1$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $23bb4e171ff15bc1$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($23bb4e171ff15bc1$var$FUNC_ERROR_TEXT);
    if ($k0qYG(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return $lFKmC(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
module.exports = $23bb4e171ff15bc1$var$throttle;

});


parcelRegister("kBAuL", function(module, exports) {

$parcel$export(module.exports, "postHeartbeat", () => $7cff47c821db2dad$export$931f43089f67754c);
const $7cff47c821db2dad$var$RETRY_HTTP_CODES = [
    408,
    500,
    502,
    503,
    504,
    522,
    524
];
function $7cff47c821db2dad$var$timeout(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}
async function $7cff47c821db2dad$var$fetchRetry(url, options = {}, retries = 5, backoff = 300) {
    const response = await fetch(url, options);
    if (response.ok || response.status === 401) return response;
    if (retries > 0 && $7cff47c821db2dad$var$RETRY_HTTP_CODES.includes(response.status)) {
        await $7cff47c821db2dad$var$timeout(backoff);
        return await $7cff47c821db2dad$var$fetchRetry(url, options, retries - 1, backoff * 2);
    } else return Promise.reject(response);
}
const $7cff47c821db2dad$export$931f43089f67754c = async (endpoint, onAuthenticationFailed, onBadRequest)=>{
    try {
        const response = await $7cff47c821db2dad$var$fetchRetry(endpoint, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        if (response && response.ok) return response.json();
        if (response && response.status === 401 && onAuthenticationFailed) {
            onAuthenticationFailed();
            return;
        }
    } catch (e) {
        const errorResponse = e;
        if (errorResponse.status === 400) {
            onBadRequest?.();
            return Promise.reject(errorResponse);
        }
        if ($7cff47c821db2dad$var$RETRY_HTTP_CODES.includes(errorResponse.status)) console.warn('Heartbeat: Retried 5x, stopped to call api');
    }
};

});


parcelRegister("4U1PW", function(module, exports) {

$parcel$export(module.exports, "createClient", () => $391dd11e177a8b61$export$5d730b7aed1a3eb0);
/**
 *
 * client
 *
 */ 
var $l7Jgj = parcelRequire("l7Jgj");

var $7Tywk = parcelRequire("7Tywk");
var $391dd11e177a8b61$var$__await = undefined && undefined.__await || function(v) {
    return this instanceof $391dd11e177a8b61$var$__await ? (this.v = v, this) : new $391dd11e177a8b61$var$__await(v);
};
var $391dd11e177a8b61$var$__asyncGenerator = undefined && undefined.__asyncGenerator || function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $391dd11e177a8b61$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
function $391dd11e177a8b61$export$5d730b7aed1a3eb0(options) {
    const { url: url, connectionParams: connectionParams, lazy: lazy = true, onNonLazyError: onNonLazyError = console.error, lazyCloseTimeout: lazyCloseTimeoutMs = 0, keepAlive: keepAlive = 0, disablePong: disablePong, connectionAckWaitTimeout: connectionAckWaitTimeout = 0, retryAttempts: retryAttempts = 5, retryWait: retryWait = async function randomisedExponentialBackoff(retries) {
        let retryDelay = 1000; // start with 1s delay
        for(let i = 0; i < retries; i++)retryDelay *= 2;
        await new Promise((resolve)=>setTimeout(resolve, retryDelay + // add random timeout from 300ms to 3s
            Math.floor(Math.random() * 2700 + 300)));
    }, shouldRetry: shouldRetry = $391dd11e177a8b61$var$isLikeCloseEvent, isFatalConnectionProblem: isFatalConnectionProblem, on: on, webSocketImpl: webSocketImpl, generateID: /**
     * Generates a v4 UUID to be used as the ID using `Math`
     * as the random number generator. Supply your own generator
     * in case you need more uniqueness.
     *
     * Reference: https://gist.github.com/jed/982883
     */ generateID = function generateUUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
            const r = Math.random() * 16 | 0, v = c == 'x' ? r : r & 0x3 | 0x8;
            return v.toString(16);
        });
    }, jsonMessageReplacer: replacer, jsonMessageReviver: reviver } = options;
    let ws;
    if (webSocketImpl) {
        if (!$391dd11e177a8b61$var$isWebSocket(webSocketImpl)) throw new Error('Invalid WebSocket implementation provided');
        ws = webSocketImpl;
    } else if (typeof WebSocket !== 'undefined') ws = WebSocket;
    else if (typeof $parcel$global !== 'undefined') ws = $parcel$global.WebSocket || // @ts-expect-error: Support more browsers
    $parcel$global.MozWebSocket;
    else if (typeof window !== 'undefined') ws = window.WebSocket || // @ts-expect-error: Support more browsers
    window.MozWebSocket;
    if (!ws) throw new Error("WebSocket implementation missing; on Node you can `import WebSocket from 'ws';` and pass `webSocketImpl: WebSocket` to `createClient`");
    const WebSocketImpl = ws;
    // websocket status emitter, subscriptions are handled differently
    const emitter = (()=>{
        const message = (()=>{
            const listeners = {};
            return {
                on (id, listener) {
                    listeners[id] = listener;
                    return ()=>{
                        delete listeners[id];
                    };
                },
                emit (message) {
                    var _a;
                    if ('id' in message) (_a = listeners[message.id]) === null || _a === void 0 || _a.call(listeners, message);
                }
            };
        })();
        const listeners = {
            connecting: (on === null || on === void 0 ? void 0 : on.connecting) ? [
                on.connecting
            ] : [],
            opened: (on === null || on === void 0 ? void 0 : on.opened) ? [
                on.opened
            ] : [],
            connected: (on === null || on === void 0 ? void 0 : on.connected) ? [
                on.connected
            ] : [],
            ping: (on === null || on === void 0 ? void 0 : on.ping) ? [
                on.ping
            ] : [],
            pong: (on === null || on === void 0 ? void 0 : on.pong) ? [
                on.pong
            ] : [],
            message: (on === null || on === void 0 ? void 0 : on.message) ? [
                message.emit,
                on.message
            ] : [
                message.emit
            ],
            closed: (on === null || on === void 0 ? void 0 : on.closed) ? [
                on.closed
            ] : [],
            error: (on === null || on === void 0 ? void 0 : on.error) ? [
                on.error
            ] : []
        };
        return {
            onMessage: message.on,
            on (event, listener) {
                const l = listeners[event];
                l.push(listener);
                return ()=>{
                    l.splice(l.indexOf(listener), 1);
                };
            },
            emit (event, ...args) {
                // we copy the listeners so that unlistens dont "pull the rug under our feet"
                for (const listener of [
                    ...listeners[event]
                ])// @ts-expect-error: The args should fit
                listener(...args);
            }
        };
    })();
    // invokes the callback either when an error or closed event is emitted,
    // first one that gets called prevails, other emissions are ignored
    function errorOrClosed(cb) {
        const listening = [
            // errors are fatal and more critical than close events, throw them first
            emitter.on('error', (err)=>{
                listening.forEach((unlisten)=>unlisten());
                cb(err);
            }),
            // closes can be graceful and not fatal, throw them second (if error didnt throw)
            emitter.on('closed', (event)=>{
                listening.forEach((unlisten)=>unlisten());
                cb(event);
            })
        ];
    }
    let connecting, locks = 0, lazyCloseTimeout, retrying = false, retries = 0, disposed = false;
    async function connect() {
        // clear the lazy close timeout immediatelly so that close gets debounced
        // see: https://github.com/enisdenjo/graphql-ws/issues/388
        clearTimeout(lazyCloseTimeout);
        const [socket, throwOnClose] = await (connecting !== null && connecting !== void 0 ? connecting : connecting = new Promise((connected, denied)=>(async ()=>{
                if (retrying) {
                    await retryWait(retries);
                    // subscriptions might complete while waiting for retry
                    if (!locks) {
                        connecting = undefined;
                        return denied({
                            code: 1000,
                            reason: 'All Subscriptions Gone'
                        });
                    }
                    retries++;
                }
                emitter.emit('connecting');
                const socket = new WebSocketImpl(typeof url === 'function' ? await url() : url, (0, $l7Jgj.GRAPHQL_TRANSPORT_WS_PROTOCOL));
                let connectionAckTimeout, queuedPing;
                function enqueuePing() {
                    if (isFinite(keepAlive) && keepAlive > 0) {
                        clearTimeout(queuedPing); // in case where a pong was received before a ping (this is valid behaviour)
                        queuedPing = setTimeout(()=>{
                            if (socket.readyState === WebSocketImpl.OPEN) {
                                socket.send((0, $l7Jgj.stringifyMessage)({
                                    type: (0, $l7Jgj.MessageType).Ping
                                }));
                                emitter.emit('ping', false, undefined);
                            }
                        }, keepAlive);
                    }
                }
                errorOrClosed((errOrEvent)=>{
                    connecting = undefined;
                    clearTimeout(connectionAckTimeout);
                    clearTimeout(queuedPing);
                    denied(errOrEvent);
                    if ($391dd11e177a8b61$var$isLikeCloseEvent(errOrEvent) && errOrEvent.code === 4499) {
                        socket.close(4499, 'Terminated'); // close event is artificial and emitted manually, see `Client.terminate()` below
                        socket.onerror = null;
                        socket.onclose = null;
                    }
                });
                socket.onerror = (err)=>emitter.emit('error', err);
                socket.onclose = (event)=>emitter.emit('closed', event);
                socket.onopen = async ()=>{
                    try {
                        emitter.emit('opened', socket);
                        const payload = typeof connectionParams === 'function' ? await connectionParams() : connectionParams;
                        // connectionParams might take too long causing the server to kick off the client
                        // the necessary error/close event is already reported - simply stop execution
                        if (socket.readyState !== WebSocketImpl.OPEN) return;
                        socket.send((0, $l7Jgj.stringifyMessage)(payload ? {
                            type: (0, $l7Jgj.MessageType).ConnectionInit,
                            payload: payload
                        } : {
                            type: (0, $l7Jgj.MessageType).ConnectionInit
                        }, replacer));
                        if (isFinite(connectionAckWaitTimeout) && connectionAckWaitTimeout > 0) connectionAckTimeout = setTimeout(()=>{
                            socket.close((0, $l7Jgj.CloseCode).ConnectionAcknowledgementTimeout, 'Connection acknowledgement timeout');
                        }, connectionAckWaitTimeout);
                        enqueuePing(); // enqueue ping (noop if disabled)
                    } catch (err) {
                        emitter.emit('error', err);
                        socket.close((0, $l7Jgj.CloseCode).InternalClientError, (0, $7Tywk.limitCloseReason)(err instanceof Error ? err.message : new Error(err).message, 'Internal client error'));
                    }
                };
                let acknowledged = false;
                socket.onmessage = ({ data: data })=>{
                    try {
                        const message = (0, $l7Jgj.parseMessage)(data, reviver);
                        emitter.emit('message', message);
                        if (message.type === 'ping' || message.type === 'pong') {
                            emitter.emit(message.type, true, message.payload); // received
                            if (message.type === 'pong') enqueuePing(); // enqueue next ping (noop if disabled)
                            else if (!disablePong) {
                                // respond with pong on ping
                                socket.send((0, $l7Jgj.stringifyMessage)(message.payload ? {
                                    type: (0, $l7Jgj.MessageType).Pong,
                                    payload: message.payload
                                } : {
                                    type: (0, $l7Jgj.MessageType).Pong
                                }));
                                emitter.emit('pong', false, message.payload);
                            }
                            return; // ping and pongs can be received whenever
                        }
                        if (acknowledged) return; // already connected and acknowledged
                        if (message.type !== (0, $l7Jgj.MessageType).ConnectionAck) throw new Error(`First message cannot be of type ${message.type}`);
                        clearTimeout(connectionAckTimeout);
                        acknowledged = true;
                        emitter.emit('connected', socket, message.payload); // connected = socket opened + acknowledged
                        retrying = false; // future lazy connects are not retries
                        retries = 0; // reset the retries on connect
                        connected([
                            socket,
                            new Promise((_, reject)=>errorOrClosed(reject))
                        ]);
                    } catch (err) {
                        socket.onmessage = null; // stop reading messages as soon as reading breaks once
                        emitter.emit('error', err);
                        socket.close((0, $l7Jgj.CloseCode).BadResponse, (0, $7Tywk.limitCloseReason)(err instanceof Error ? err.message : new Error(err).message, 'Bad response'));
                    }
                };
            })()));
        // if the provided socket is in a closing state, wait for the throw on close
        if (socket.readyState === WebSocketImpl.CLOSING) await throwOnClose;
        let release = ()=>{
        // releases this connection
        };
        const released = new Promise((resolve)=>release = resolve);
        return [
            socket,
            release,
            Promise.race([
                // wait for
                released.then(()=>{
                    if (!locks) {
                        // and if no more locks are present, complete the connection
                        const complete = ()=>socket.close(1000, 'Normal Closure');
                        if (isFinite(lazyCloseTimeoutMs) && lazyCloseTimeoutMs > 0) // if the keepalive is set, allow for the specified calmdown time and
                        // then complete if the socket is still open.
                        lazyCloseTimeout = setTimeout(()=>{
                            if (socket.readyState === WebSocketImpl.OPEN) complete();
                        }, lazyCloseTimeoutMs);
                        else // otherwise complete immediately
                        complete();
                    }
                }),
                // or
                throwOnClose
            ])
        ];
    }
    /**
     * Checks the `connect` problem and evaluates if the client should retry.
     */ function shouldRetryConnectOrThrow(errOrCloseEvent) {
        // some close codes are worth reporting immediately
        if ($391dd11e177a8b61$var$isLikeCloseEvent(errOrCloseEvent) && ($391dd11e177a8b61$var$isFatalInternalCloseCode(errOrCloseEvent.code) || [
            (0, $l7Jgj.CloseCode).InternalServerError,
            (0, $l7Jgj.CloseCode).InternalClientError,
            (0, $l7Jgj.CloseCode).BadRequest,
            (0, $l7Jgj.CloseCode).BadResponse,
            (0, $l7Jgj.CloseCode).Unauthorized,
            // CloseCode.Forbidden, might grant access out after retry
            (0, $l7Jgj.CloseCode).SubprotocolNotAcceptable,
            // CloseCode.ConnectionInitialisationTimeout, might not time out after retry
            // CloseCode.ConnectionAcknowledgementTimeout, might not time out after retry
            (0, $l7Jgj.CloseCode).SubscriberAlreadyExists,
            (0, $l7Jgj.CloseCode).TooManyInitialisationRequests
        ].includes(errOrCloseEvent.code))) throw errOrCloseEvent;
        // client was disposed, no retries should proceed regardless
        if (disposed) return false;
        // normal closure (possibly all subscriptions have completed)
        // if no locks were acquired in the meantime, shouldnt try again
        if ($391dd11e177a8b61$var$isLikeCloseEvent(errOrCloseEvent) && errOrCloseEvent.code === 1000) return locks > 0;
        // retries are not allowed or we tried to many times, report error
        if (!retryAttempts || retries >= retryAttempts) throw errOrCloseEvent;
        // throw non-retryable connection problems
        if (!shouldRetry(errOrCloseEvent)) throw errOrCloseEvent;
        // @deprecated throw fatal connection problems immediately
        if (isFatalConnectionProblem === null || isFatalConnectionProblem === void 0 ? void 0 : isFatalConnectionProblem(errOrCloseEvent)) throw errOrCloseEvent;
        // looks good, start retrying
        return retrying = true;
    }
    // in non-lazy (hot?) mode always hold one connection lock to persist the socket
    if (!lazy) (async ()=>{
        locks++;
        for(;;)try {
            const [, , throwOnClose] = await connect();
            await throwOnClose; // will always throw because releaser is not used
        } catch (errOrCloseEvent) {
            try {
                if (!shouldRetryConnectOrThrow(errOrCloseEvent)) return;
            } catch (errOrCloseEvent) {
                // report thrown error, no further retries
                return onNonLazyError === null || onNonLazyError === void 0 ? void 0 : onNonLazyError(errOrCloseEvent);
            }
        }
    })();
    return {
        on: emitter.on,
        subscribe (payload, sink) {
            const id = generateID(payload);
            let done = false, errored = false, releaser = ()=>{
                // for handling completions before connect
                locks--;
                done = true;
            };
            (async ()=>{
                locks++;
                for(;;)try {
                    const [socket, release, waitForReleaseOrThrowOnClose] = await connect();
                    // if done while waiting for connect, release the connection lock right away
                    if (done) return release();
                    const unlisten = emitter.onMessage(id, (message)=>{
                        switch(message.type){
                            case (0, $l7Jgj.MessageType).Next:
                                // eslint-disable-next-line @typescript-eslint/no-explicit-any -- payload will fit type
                                sink.next(message.payload);
                                return;
                            case (0, $l7Jgj.MessageType).Error:
                                errored = true, done = true;
                                sink.error(message.payload);
                                releaser();
                                return;
                            case (0, $l7Jgj.MessageType).Complete:
                                done = true;
                                releaser(); // release completes the sink
                                return;
                        }
                    });
                    socket.send((0, $l7Jgj.stringifyMessage)({
                        id: id,
                        type: (0, $l7Jgj.MessageType).Subscribe,
                        payload: payload
                    }, replacer));
                    releaser = ()=>{
                        if (!done && socket.readyState === WebSocketImpl.OPEN) // if not completed already and socket is open, send complete message to server on release
                        socket.send((0, $l7Jgj.stringifyMessage)({
                            id: id,
                            type: (0, $l7Jgj.MessageType).Complete
                        }, replacer));
                        locks--;
                        done = true;
                        release();
                    };
                    // either the releaser will be called, connection completed and
                    // the promise resolved or the socket closed and the promise rejected.
                    // whatever happens though, we want to stop listening for messages
                    await waitForReleaseOrThrowOnClose.finally(unlisten);
                    return; // completed, shouldnt try again
                } catch (errOrCloseEvent) {
                    if (!shouldRetryConnectOrThrow(errOrCloseEvent)) return;
                }
            })().then(()=>{
                // delivering either an error or a complete terminates the sequence
                if (!errored) sink.complete();
            }) // resolves on release or normal closure
            .catch((err)=>{
                sink.error(err);
            }); // rejects on close events and errors
            return ()=>{
                // dispose only of active subscriptions
                if (!done) releaser();
            };
        },
        iterate (request) {
            const pending = [];
            const deferred = {
                done: false,
                error: null,
                resolve: ()=>{
                // noop
                }
            };
            const dispose = this.subscribe(request, {
                next (val) {
                    pending.push(val);
                    deferred.resolve();
                },
                error (err) {
                    deferred.done = true;
                    deferred.error = err;
                    deferred.resolve();
                },
                complete () {
                    deferred.done = true;
                    deferred.resolve();
                }
            });
            const iterator = function iterator() {
                return $391dd11e177a8b61$var$__asyncGenerator(this, arguments, function* iterator_1() {
                    for(;;){
                        if (!pending.length) // only wait if there are no pending messages available
                        yield $391dd11e177a8b61$var$__await(new Promise((resolve)=>deferred.resolve = resolve));
                        // first flush
                        while(pending.length)// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        yield yield $391dd11e177a8b61$var$__await(pending.shift());
                        // then error
                        if (deferred.error) throw deferred.error;
                        // or complete
                        if (deferred.done) return yield $391dd11e177a8b61$var$__await(void 0);
                    }
                });
            }();
            iterator.throw = async (err)=>{
                if (!deferred.done) {
                    deferred.done = true;
                    deferred.error = err;
                    deferred.resolve();
                }
                return {
                    done: true,
                    value: undefined
                };
            };
            iterator.return = async ()=>{
                dispose();
                return {
                    done: true,
                    value: undefined
                };
            };
            return iterator;
        },
        async dispose () {
            disposed = true;
            if (connecting) {
                // if there is a connection, close it
                const [socket] = await connecting;
                socket.close(1000, 'Normal Closure');
            }
        },
        terminate () {
            if (connecting) // only if there is a connection
            emitter.emit('closed', {
                code: 4499,
                reason: 'Terminated',
                wasClean: false
            });
        }
    };
}
function $391dd11e177a8b61$var$isLikeCloseEvent(val) {
    return (0, $7Tywk.isObject)(val) && 'code' in val && 'reason' in val;
}
function $391dd11e177a8b61$var$isFatalInternalCloseCode(code) {
    if ([
        1000,
        1001,
        1006,
        1005,
        1012,
        1013,
        1014
    ].includes(code)) return false;
    // all other internal errors are fatal
    return code >= 1000 && code <= 1999;
}
function $391dd11e177a8b61$var$isWebSocket(val) {
    return typeof val === 'function' && 'constructor' in val && 'CLOSED' in val && 'CLOSING' in val && 'CONNECTING' in val && 'OPEN' in val;
}

});
parcelRegister("l7Jgj", function(module, exports) {

$parcel$export(module.exports, "GRAPHQL_TRANSPORT_WS_PROTOCOL", () => $f60d5c8886e0651e$export$5c0a4edfedc7c457);
$parcel$export(module.exports, "CloseCode", () => $f60d5c8886e0651e$export$777128f41f6616ec);
$parcel$export(module.exports, "MessageType", () => $f60d5c8886e0651e$export$80edbf15fa61a4db);
$parcel$export(module.exports, "parseMessage", () => $f60d5c8886e0651e$export$f2f615077a189f21);
$parcel$export(module.exports, "stringifyMessage", () => $f60d5c8886e0651e$export$77896e5b47bfd50b);
/**
 *
 * common
 *
 */ 
var $7Tywk = parcelRequire("7Tywk");
const $f60d5c8886e0651e$export$5c0a4edfedc7c457 = 'graphql-transport-ws';
const $f60d5c8886e0651e$export$ec743af8bb66f3be = 'graphql-ws';
var $f60d5c8886e0651e$export$777128f41f6616ec;
(function(CloseCode) {
    CloseCode[CloseCode["InternalServerError"] = 4500] = "InternalServerError";
    CloseCode[CloseCode["InternalClientError"] = 4005] = "InternalClientError";
    CloseCode[CloseCode["BadRequest"] = 4400] = "BadRequest";
    CloseCode[CloseCode["BadResponse"] = 4004] = "BadResponse";
    /** Tried subscribing before connect ack */ CloseCode[CloseCode["Unauthorized"] = 4401] = "Unauthorized";
    CloseCode[CloseCode["Forbidden"] = 4403] = "Forbidden";
    CloseCode[CloseCode["SubprotocolNotAcceptable"] = 4406] = "SubprotocolNotAcceptable";
    CloseCode[CloseCode["ConnectionInitialisationTimeout"] = 4408] = "ConnectionInitialisationTimeout";
    CloseCode[CloseCode["ConnectionAcknowledgementTimeout"] = 4504] = "ConnectionAcknowledgementTimeout";
    /** Subscriber distinction is very important */ CloseCode[CloseCode["SubscriberAlreadyExists"] = 4409] = "SubscriberAlreadyExists";
    CloseCode[CloseCode["TooManyInitialisationRequests"] = 4429] = "TooManyInitialisationRequests";
})($f60d5c8886e0651e$export$777128f41f6616ec || ($f60d5c8886e0651e$export$777128f41f6616ec = {}));
var $f60d5c8886e0651e$export$80edbf15fa61a4db;
(function(MessageType) {
    MessageType["ConnectionInit"] = "connection_init";
    MessageType["ConnectionAck"] = "connection_ack";
    MessageType["Ping"] = "ping";
    MessageType["Pong"] = "pong";
    MessageType["Subscribe"] = "subscribe";
    MessageType["Next"] = "next";
    MessageType["Error"] = "error";
    MessageType["Complete"] = "complete";
})($f60d5c8886e0651e$export$80edbf15fa61a4db || ($f60d5c8886e0651e$export$80edbf15fa61a4db = {}));
function $f60d5c8886e0651e$export$c17861b159b1b673(val) {
    if (!(0, $7Tywk.isObject)(val)) throw new Error(`Message is expected to be an object, but got ${(0, $7Tywk.extendedTypeof)(val)}`);
    if (!val.type) throw new Error(`Message is missing the 'type' property`);
    if (typeof val.type !== 'string') throw new Error(`Message is expects the 'type' property to be a string, but got ${(0, $7Tywk.extendedTypeof)(val.type)}`);
    switch(val.type){
        case $f60d5c8886e0651e$export$80edbf15fa61a4db.ConnectionInit:
        case $f60d5c8886e0651e$export$80edbf15fa61a4db.ConnectionAck:
        case $f60d5c8886e0651e$export$80edbf15fa61a4db.Ping:
        case $f60d5c8886e0651e$export$80edbf15fa61a4db.Pong:
            if (val.payload != null && !(0, $7Tywk.isObject)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object or nullish or missing, but got "${val.payload}"`);
            break;
        case $f60d5c8886e0651e$export$80edbf15fa61a4db.Subscribe:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $7Tywk.extendedTypeof)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            if (!(0, $7Tywk.isObject)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object, but got ${(0, $7Tywk.extendedTypeof)(val.payload)}`);
            if (typeof val.payload.query !== 'string') throw new Error(`"${val.type}" message payload expects the 'query' property to be a string, but got ${(0, $7Tywk.extendedTypeof)(val.payload.query)}`);
            if (val.payload.variables != null && !(0, $7Tywk.isObject)(val.payload.variables)) throw new Error(`"${val.type}" message payload expects the 'variables' property to be a an object or nullish or missing, but got ${(0, $7Tywk.extendedTypeof)(val.payload.variables)}`);
            if (val.payload.operationName != null && (0, $7Tywk.extendedTypeof)(val.payload.operationName) !== 'string') throw new Error(`"${val.type}" message payload expects the 'operationName' property to be a string or nullish or missing, but got ${(0, $7Tywk.extendedTypeof)(val.payload.operationName)}`);
            if (val.payload.extensions != null && !(0, $7Tywk.isObject)(val.payload.extensions)) throw new Error(`"${val.type}" message payload expects the 'extensions' property to be a an object or nullish or missing, but got ${(0, $7Tywk.extendedTypeof)(val.payload.extensions)}`);
            break;
        case $f60d5c8886e0651e$export$80edbf15fa61a4db.Next:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $7Tywk.extendedTypeof)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            if (!(0, $7Tywk.isObject)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object, but got ${(0, $7Tywk.extendedTypeof)(val.payload)}`);
            break;
        case $f60d5c8886e0651e$export$80edbf15fa61a4db.Error:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $7Tywk.extendedTypeof)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            if (!(0, $7Tywk.areGraphQLErrors)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an array of GraphQL errors, but got ${JSON.stringify(val.payload)}`);
            break;
        case $f60d5c8886e0651e$export$80edbf15fa61a4db.Complete:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $7Tywk.extendedTypeof)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            break;
        default:
            throw new Error(`Invalid message 'type' property "${val.type}"`);
    }
    return val;
}
function $f60d5c8886e0651e$export$9e0e49e75fa7d548(val) {
    try {
        $f60d5c8886e0651e$export$c17861b159b1b673(val);
        return true;
    } catch (_a) {
        return false;
    }
}
function $f60d5c8886e0651e$export$f2f615077a189f21(data, reviver) {
    return $f60d5c8886e0651e$export$c17861b159b1b673(typeof data === 'string' ? JSON.parse(data, reviver) : data);
}
function $f60d5c8886e0651e$export$77896e5b47bfd50b(msg, replacer) {
    $f60d5c8886e0651e$export$c17861b159b1b673(msg);
    return JSON.stringify(msg, replacer);
}

});
parcelRegister("7Tywk", function(module, exports) {

$parcel$export(module.exports, "extendedTypeof", () => $5bf872794d14d281$export$573326049e1b1c6b);
$parcel$export(module.exports, "isObject", () => $5bf872794d14d281$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "areGraphQLErrors", () => $5bf872794d14d281$export$e6262fbc2e92290);
$parcel$export(module.exports, "limitCloseReason", () => $5bf872794d14d281$export$2937fa0c8dddae54);
/** @private */ function $5bf872794d14d281$export$573326049e1b1c6b(val) {
    if (val === null) return 'null';
    if (Array.isArray(val)) return 'array';
    return typeof val;
}
function $5bf872794d14d281$export$a6cdc56e425d0d0a(val) {
    return $5bf872794d14d281$export$573326049e1b1c6b(val) === 'object';
}
function $5bf872794d14d281$export$edb10ab8dd75a915(val) {
    return typeof Object(val)[Symbol.asyncIterator] === 'function';
}
function $5bf872794d14d281$export$92bd080471bc30f1(val) {
    return $5bf872794d14d281$export$a6cdc56e425d0d0a(val) && typeof Object(val)[Symbol.asyncIterator] === 'function' && typeof val.return === 'function';
}
function $5bf872794d14d281$export$e6262fbc2e92290(obj) {
    return Array.isArray(obj) && // must be at least one error
    obj.length > 0 && // error has at least a message
    obj.every((ob)=>'message' in ob);
}
function $5bf872794d14d281$export$2937fa0c8dddae54(reason, whenTooLong) {
    return reason.length < 124 ? reason : whenTooLong;
}

});



parcelRegister("6LmWt", function(module, exports) {

$parcel$export(module.exports, "getDefaultRelayEnvironmentConfig", () => $61f65a0ea311dd12$export$6c790f07f4ef6a59);

var $eiowN = parcelRequire("eiowN");

var $65GpI = parcelRequire("65GpI");

var $iJZ8l = parcelRequire("iJZ8l");

var $dj5to = parcelRequire("dj5to");

var $3Z1I9 = parcelRequire("3Z1I9");

var $iExP6 = parcelRequire("iExP6");
const $61f65a0ea311dd12$var$createStore = (source, options)=>{
    (0, $eiowN.RelayFeatureFlags).ENABLE_RELAY_RESOLVERS = true;
    return new (0, (/*@__PURE__*/$parcel$interopDefault($65GpI)))(source, options);
};
const $61f65a0ea311dd12$export$6c790f07f4ef6a59 = ({ log: log, requiredFieldLogger: requiredFieldLogger, network: network })=>({
        configName: 'Atlassian Graphql Gateway',
        network: network || (0, $3Z1I9.network),
        store: $61f65a0ea311dd12$var$createStore(new (0, $eiowN.RecordSource)(), {
            log: log ?? undefined,
            getDataID: (0, $iJZ8l.default)
        }),
        log: log,
        relayFieldLogger: requiredFieldLogger,
        getDataID: (0, $iJZ8l.default),
        scheduler: (0, $iExP6.default),
        missingFieldHandlers: (0, $dj5to.default)
    });

});
parcelRegister("65GpI", function(module, exports) {
'use strict';

var $7gV6J = parcelRequire("7gV6J");
var $46f41c2f1ec2be63$var$_interopRequireDefault = $7gV6J.default;

var $46f41c2f1ec2be63$var$_createForOfIteratorHelper2 = $46f41c2f1ec2be63$var$_interopRequireDefault((parcelRequire("8utPl")));

var $46f41c2f1ec2be63$var$_defineProperty2 = $46f41c2f1ec2be63$var$_interopRequireDefault((parcelRequire("2KFWS")));

var $g6Qtb = parcelRequire("g6Qtb");
var $46f41c2f1ec2be63$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE = $g6Qtb.INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, $46f41c2f1ec2be63$var$assertInternalActorIdentifier = $g6Qtb.assertInternalActorIdentifier;
parcelRequire("259Mc");

var $1zFTi = parcelRequire("1zFTi");

var $h7JIX = parcelRequire("h7JIX");

var $4FKGD = parcelRequire("4FKGD");

var $jeujn = parcelRequire("jeujn");

var $ja41X = parcelRequire("ja41X");

var $9miei = parcelRequire("9miei");

var $5DcbW = parcelRequire("5DcbW");

var $hWkm3 = parcelRequire("hWkm3");

var $dfBRB = parcelRequire("dfBRB");

var $dfBRB = parcelRequire("dfBRB");
var $46f41c2f1ec2be63$var$ROOT_ID = $dfBRB.ROOT_ID, $46f41c2f1ec2be63$var$ROOT_TYPE = $dfBRB.ROOT_TYPE;

var $edMta = parcelRequire("edMta");
var $46f41c2f1ec2be63$var$LiveResolverCache = $edMta.LiveResolverCache, $46f41c2f1ec2be63$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY = $edMta.RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY, $46f41c2f1ec2be63$var$getUpdatedDataIDs = $edMta.getUpdatedDataIDs;

var $aE1Lc = parcelRequire("aE1Lc");
var $46f41c2f1ec2be63$var$DEFAULT_RELEASE_BUFFER_SIZE = 10;
var $46f41c2f1ec2be63$var$LiveResolverStore = /*#__PURE__*/ function() {
    function LiveResolverStore(source, options) {
        var _this = this;
        var _options$gcReleaseBuf, _options$gcScheduler, _options$getDataID, _options$log, _options$operationLoa, _options$treatMissing, _options$shouldProces;
        (0, $46f41c2f1ec2be63$var$_defineProperty2["default"])(this, "_gcStep", function() {
            if (_this._gcRun) {
                if (_this._gcRun.next().done) _this._gcRun = null;
                else _this._gcScheduler(_this._gcStep);
            }
        });
        var storeIDs, ii, record;
        this._currentWriteEpoch = 0;
        this._gcHoldCounter = 0;
        this._gcReleaseBufferSize = (_options$gcReleaseBuf = options === null || options === void 0 ? void 0 : options.gcReleaseBufferSize) !== null && _options$gcReleaseBuf !== void 0 ? _options$gcReleaseBuf : $46f41c2f1ec2be63$var$DEFAULT_RELEASE_BUFFER_SIZE;
        this._gcRun = null;
        this._gcScheduler = (_options$gcScheduler = options === null || options === void 0 ? void 0 : options.gcScheduler) !== null && _options$gcScheduler !== void 0 ? _options$gcScheduler : $1zFTi;
        this._getDataID = (_options$getDataID = options === null || options === void 0 ? void 0 : options.getDataID) !== null && _options$getDataID !== void 0 ? _options$getDataID : $4FKGD;
        this._globalInvalidationEpoch = null;
        this._invalidationSubscriptions = new Set();
        this._invalidatedRecordIDs = new Set();
        this.__log = (_options$log = options === null || options === void 0 ? void 0 : options.log) !== null && _options$log !== void 0 ? _options$log : null;
        this._queryCacheExpirationTime = options === null || options === void 0 ? void 0 : options.queryCacheExpirationTime;
        this._operationLoader = (_options$operationLoa = options === null || options === void 0 ? void 0 : options.operationLoader) !== null && _options$operationLoa !== void 0 ? _options$operationLoa : null;
        this._optimisticSource = null;
        this._recordSource = source;
        this._releaseBuffer = [];
        this._roots = new Map();
        this._shouldScheduleGC = false;
        this._resolverCache = new $46f41c2f1ec2be63$var$LiveResolverCache(function() {
            return _this._getMutableRecordSource();
        }, this);
        this._storeSubscriptions = new $hWkm3(options === null || options === void 0 ? void 0 : options.log, this._resolverCache);
        this._updatedRecordIDs = new Set();
        this._treatMissingFieldsAsNull = (_options$treatMissing = options === null || options === void 0 ? void 0 : options.treatMissingFieldsAsNull) !== null && _options$treatMissing !== void 0 ? _options$treatMissing : false;
        this._actorIdentifier = options === null || options === void 0 ? void 0 : options.actorIdentifier;
        this._shouldProcessClientComponents = (_options$shouldProces = options === null || options === void 0 ? void 0 : options.shouldProcessClientComponents) !== null && _options$shouldProces !== void 0 ? _options$shouldProces : false;
        $46f41c2f1ec2be63$var$initializeRecordSource(this._recordSource);
    }
    var _proto = LiveResolverStore.prototype;
    _proto.getSource = function getSource() {
        var _this$_optimisticSour;
        return (_this$_optimisticSour = this._optimisticSource) !== null && _this$_optimisticSour !== void 0 ? _this$_optimisticSour : this._recordSource;
    };
    _proto._getMutableRecordSource = function _getMutableRecordSource() {
        var _this$_optimisticSour2;
        return (_this$_optimisticSour2 = this._optimisticSource) !== null && _this$_optimisticSour2 !== void 0 ? _this$_optimisticSour2 : this._recordSource;
    };
    _proto.getLiveResolverPromise = function getLiveResolverPromise(recordID) {
        return this._resolverCache.getLiveResolverPromise(recordID);
    };
    _proto.batchLiveStateUpdates = function batchLiveStateUpdates(callback) {
        if (this.__log != null) this.__log({
            name: 'liveresolver.batch.start'
        });
        try {
            this._resolverCache.batchLiveStateUpdates(callback);
        } finally{
            if (this.__log != null) this.__log({
                name: 'liveresolver.batch.end'
            });
        }
    };
    _proto.check = function check(operation, options) {
        var _options$handlers, _options$getSourceFor, _options$getTargetFor, _options$defaultActor;
        var selector = operation.root;
        var source = this._getMutableRecordSource();
        var globalInvalidationEpoch = this._globalInvalidationEpoch;
        var rootEntry = this._roots.get(operation.request.identifier);
        var operationLastWrittenAt = rootEntry != null ? rootEntry.epoch : null;
        if (globalInvalidationEpoch != null) {
            if (operationLastWrittenAt == null || operationLastWrittenAt <= globalInvalidationEpoch) return {
                status: 'stale'
            };
        }
        var handlers = (_options$handlers = options === null || options === void 0 ? void 0 : options.handlers) !== null && _options$handlers !== void 0 ? _options$handlers : [];
        var getSourceForActor = (_options$getSourceFor = options === null || options === void 0 ? void 0 : options.getSourceForActor) !== null && _options$getSourceFor !== void 0 ? _options$getSourceFor : function(actorIdentifier) {
            $46f41c2f1ec2be63$var$assertInternalActorIdentifier(actorIdentifier);
            return source;
        };
        var getTargetForActor = (_options$getTargetFor = options === null || options === void 0 ? void 0 : options.getTargetForActor) !== null && _options$getTargetFor !== void 0 ? _options$getTargetFor : function(actorIdentifier) {
            $46f41c2f1ec2be63$var$assertInternalActorIdentifier(actorIdentifier);
            return source;
        };
        var operationAvailability = $h7JIX.check(getSourceForActor, getTargetForActor, (_options$defaultActor = options === null || options === void 0 ? void 0 : options.defaultActorIdentifier) !== null && _options$defaultActor !== void 0 ? _options$defaultActor : $46f41c2f1ec2be63$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, selector, handlers, this._operationLoader, this._getDataID, this._shouldProcessClientComponents);
        return $46f41c2f1ec2be63$var$getAvailabilityStatus(operationAvailability, operationLastWrittenAt, rootEntry === null || rootEntry === void 0 ? void 0 : rootEntry.fetchTime, this._queryCacheExpirationTime);
    };
    _proto.retain = function retain(operation) {
        var _this2 = this;
        var id = operation.request.identifier;
        var disposed = false;
        var dispose = function dispose() {
            if (disposed) return;
            disposed = true;
            var rootEntry = _this2._roots.get(id);
            if (rootEntry == null) return;
            rootEntry.refCount--;
            if (rootEntry.refCount === 0) {
                var _queryCacheExpirationTime = _this2._queryCacheExpirationTime;
                var rootEntryIsStale = rootEntry.fetchTime != null && _queryCacheExpirationTime != null && rootEntry.fetchTime <= Date.now() - _queryCacheExpirationTime;
                if (rootEntryIsStale) {
                    _this2._roots["delete"](id);
                    _this2.scheduleGC();
                } else {
                    _this2._releaseBuffer.push(id);
                    if (_this2._releaseBuffer.length > _this2._gcReleaseBufferSize) {
                        var _id = _this2._releaseBuffer.shift();
                        _this2._roots["delete"](_id);
                        _this2.scheduleGC();
                    }
                }
            }
        };
        var rootEntry = this._roots.get(id);
        if (rootEntry != null) {
            if (rootEntry.refCount === 0) this._releaseBuffer = this._releaseBuffer.filter(function(_id) {
                return _id !== id;
            });
            rootEntry.refCount += 1;
        } else this._roots.set(id, {
            operation: operation,
            refCount: 1,
            epoch: null,
            fetchTime: null
        });
        return {
            dispose: dispose
        };
    };
    _proto.lookup = function lookup(selector) {
        var source = this.getSource();
        var snapshot = $9miei.read(source, selector, this._resolverCache);
        return snapshot;
    };
    _proto.notify = function notify(sourceOperation, invalidateStore) {
        var _this3 = this;
        var log = this.__log;
        if (log != null) log({
            name: 'store.notify.start',
            sourceOperation: sourceOperation
        });
        this._currentWriteEpoch++;
        if (invalidateStore === true) this._globalInvalidationEpoch = this._currentWriteEpoch;
        this._resolverCache.invalidateDataIDs(this._updatedRecordIDs);
        var source = this.getSource();
        var updatedOwners = [];
        this._storeSubscriptions.updateSubscriptions(source, this._updatedRecordIDs, updatedOwners, sourceOperation);
        this._invalidationSubscriptions.forEach(function(subscription) {
            _this3._updateInvalidationSubscription(subscription, invalidateStore === true);
        });
        if (log != null) log({
            name: 'store.notify.complete',
            sourceOperation: sourceOperation,
            updatedRecordIDs: this._updatedRecordIDs,
            invalidatedRecordIDs: this._invalidatedRecordIDs
        });
        this._updatedRecordIDs.clear();
        this._invalidatedRecordIDs.clear();
        if (sourceOperation != null) {
            var id = sourceOperation.request.identifier;
            var rootEntry = this._roots.get(id);
            if (rootEntry != null) {
                rootEntry.epoch = this._currentWriteEpoch;
                rootEntry.fetchTime = Date.now();
            } else if (sourceOperation.request.node.params.operationKind === 'query' && this._gcReleaseBufferSize > 0 && this._releaseBuffer.length < this._gcReleaseBufferSize) {
                var temporaryRootEntry = {
                    operation: sourceOperation,
                    refCount: 0,
                    epoch: this._currentWriteEpoch,
                    fetchTime: Date.now()
                };
                this._releaseBuffer.push(id);
                this._roots.set(id, temporaryRootEntry);
            }
        }
        return updatedOwners;
    };
    _proto.publish = function publish(source, idsMarkedForInvalidation) {
        var target = this._getMutableRecordSource();
        $46f41c2f1ec2be63$var$updateTargetFromSource(target, source, this._currentWriteEpoch + 1, idsMarkedForInvalidation, this._updatedRecordIDs, this._invalidatedRecordIDs);
        var log = this.__log;
        if (log != null) log({
            name: 'store.publish',
            source: source,
            optimistic: target === this._optimisticSource
        });
    };
    _proto.subscribe = function subscribe(snapshot, callback) {
        return this._storeSubscriptions.subscribe(snapshot, callback);
    };
    _proto.holdGC = function holdGC() {
        var _this4 = this;
        if (this._gcRun) {
            this._gcRun = null;
            this._shouldScheduleGC = true;
        }
        this._gcHoldCounter++;
        var dispose = function dispose() {
            if (_this4._gcHoldCounter > 0) {
                _this4._gcHoldCounter--;
                if (_this4._gcHoldCounter === 0 && _this4._shouldScheduleGC) {
                    _this4.scheduleGC();
                    _this4._shouldScheduleGC = false;
                }
            }
        };
        return {
            dispose: dispose
        };
    };
    _proto.toJSON = function toJSON() {
        return 'LiveResolverStore()';
    };
    _proto.getEpoch = function getEpoch() {
        return this._currentWriteEpoch;
    };
    _proto.__getUpdatedRecordIDs = function __getUpdatedRecordIDs() {
        return this._updatedRecordIDs;
    };
    _proto.lookupInvalidationState = function lookupInvalidationState(dataIDs) {
        var _this5 = this;
        var invalidations = new Map();
        dataIDs.forEach(function(dataID) {
            var _RelayModernRecord$ge;
            var record = _this5.getSource().get(dataID);
            invalidations.set(dataID, (_RelayModernRecord$ge = $jeujn.getInvalidationEpoch(record)) !== null && _RelayModernRecord$ge !== void 0 ? _RelayModernRecord$ge : null);
        });
        invalidations.set('global', this._globalInvalidationEpoch);
        var invalidationState = {
            dataIDs: dataIDs,
            invalidations: invalidations
        };
        return invalidationState;
    };
    _proto.checkInvalidationState = function checkInvalidationState(prevInvalidationState) {
        var latestInvalidationState = this.lookupInvalidationState(prevInvalidationState.dataIDs);
        var currentInvalidations = latestInvalidationState.invalidations;
        var prevInvalidations = prevInvalidationState.invalidations;
        if (currentInvalidations.get('global') !== prevInvalidations.get('global')) return true;
        var _iterator = (0, $46f41c2f1ec2be63$var$_createForOfIteratorHelper2["default"])(prevInvalidationState.dataIDs), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var dataID = _step.value;
                if (currentInvalidations.get(dataID) !== prevInvalidations.get(dataID)) return true;
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return false;
    };
    _proto.subscribeToInvalidationState = function subscribeToInvalidationState(invalidationState, callback) {
        var _this6 = this;
        var subscription = {
            callback: callback,
            invalidationState: invalidationState
        };
        var dispose = function dispose() {
            _this6._invalidationSubscriptions["delete"](subscription);
        };
        this._invalidationSubscriptions.add(subscription);
        return {
            dispose: dispose
        };
    };
    _proto._updateInvalidationSubscription = function _updateInvalidationSubscription(subscription, invalidatedStore) {
        var _this7 = this;
        var callback = subscription.callback, invalidationState = subscription.invalidationState;
        var dataIDs = invalidationState.dataIDs;
        var isSubscribedToInvalidatedIDs = invalidatedStore || dataIDs.some(function(dataID) {
            return _this7._invalidatedRecordIDs.has(dataID);
        });
        if (!isSubscribedToInvalidatedIDs) return;
        callback();
    };
    _proto.snapshot = function snapshot() {
        !(this._optimisticSource == null) && $aE1Lc(false);
        var log = this.__log;
        if (log != null) log({
            name: 'store.snapshot'
        });
        this._storeSubscriptions.snapshotSubscriptions(this.getSource());
        if (this._gcRun) {
            this._gcRun = null;
            this._shouldScheduleGC = true;
        }
        this._optimisticSource = $ja41X.create(this.getSource());
    };
    _proto.restore = function restore() {
        var optimisticSource = this._optimisticSource;
        !optimisticSource && $aE1Lc(false);
        var log = this.__log;
        if (log != null) log({
            name: 'store.restore'
        });
        var optimisticIDs = $ja41X.getOptimisticRecordIDs(optimisticSource);
        this._resolverCache.unsubscribeFromLiveResolverRecords(optimisticIDs);
        this._optimisticSource = null;
        if (this._shouldScheduleGC) this.scheduleGC();
        this._storeSubscriptions.restoreSubscriptions();
        this._resolverCache.invalidateResolverRecords(optimisticIDs);
    };
    _proto.scheduleGC = function scheduleGC() {
        if (this._gcHoldCounter > 0) {
            this._shouldScheduleGC = true;
            return;
        }
        if (this._gcRun) return;
        this._gcRun = this._collect();
        this._gcScheduler(this._gcStep);
    };
    _proto.__gc = function __gc() {
        if (this._optimisticSource != null) return;
        var gcRun = this._collect();
        while(!gcRun.next().done);
    };
    _proto._collect = function* _collect() {
        top: while(true){
            var startEpoch = this._currentWriteEpoch;
            var references = new Set();
            var _iterator2 = (0, $46f41c2f1ec2be63$var$_createForOfIteratorHelper2["default"])(this._roots.values()), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var operation = _step2.value.operation;
                    var selector = operation.root;
                    $5DcbW.mark(this._recordSource, selector, references, this._operationLoader, this._shouldProcessClientComponents);
                    yield;
                    if (startEpoch !== this._currentWriteEpoch) continue top;
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            var log = this.__log;
            if (log != null) log({
                name: 'store.gc',
                references: references
            });
            if (references.size === 0) this._recordSource.clear();
            else {
                var storeIDs = this._recordSource.getRecordIDs();
                for(var ii = 0; ii < storeIDs.length; ii++){
                    var dataID = storeIDs[ii];
                    if (!references.has(dataID)) {
                        var record = this._recordSource.get(dataID);
                        if (record != null) {
                            var maybeResolverSubscription = $jeujn.getValue(record, $46f41c2f1ec2be63$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY);
                            if (maybeResolverSubscription != null) maybeResolverSubscription();
                        }
                        this._recordSource.remove(dataID);
                    }
                }
            }
            return;
        }
    };
    _proto.__getNormalizationOptions = function __getNormalizationOptions(path) {
        return {
            path: path,
            getDataID: this._getDataID,
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents,
            actorIdentifier: this._actorIdentifier
        };
    };
    _proto.__notifyUpdatedSubscribers = function __notifyUpdatedSubscribers(updatedRecords) {
        var nextUpdatedRecordIDs = $46f41c2f1ec2be63$var$getUpdatedDataIDs(updatedRecords);
        var prevUpdatedRecordIDs = this._updatedRecordIDs;
        this._updatedRecordIDs = nextUpdatedRecordIDs;
        this.notify();
        this._updatedRecordIDs = prevUpdatedRecordIDs;
    };
    return LiveResolverStore;
}();
function $46f41c2f1ec2be63$var$initializeRecordSource(target) {
    if (!target.has($46f41c2f1ec2be63$var$ROOT_ID)) {
        var rootRecord = $jeujn.create($46f41c2f1ec2be63$var$ROOT_ID, $46f41c2f1ec2be63$var$ROOT_TYPE);
        target.set($46f41c2f1ec2be63$var$ROOT_ID, rootRecord);
    }
}
function $46f41c2f1ec2be63$var$updateTargetFromSource(target, source, currentWriteEpoch, idsMarkedForInvalidation, updatedRecordIDs, invalidatedRecordIDs) {
    if (idsMarkedForInvalidation) idsMarkedForInvalidation.forEach(function(dataID) {
        var targetRecord = target.get(dataID);
        var sourceRecord = source.get(dataID);
        if (sourceRecord === null) return;
        var nextRecord;
        if (targetRecord != null) nextRecord = $jeujn.clone(targetRecord);
        else nextRecord = sourceRecord != null ? $jeujn.clone(sourceRecord) : null;
        if (!nextRecord) return;
        $jeujn.setValue(nextRecord, $dfBRB.INVALIDATED_AT_KEY, currentWriteEpoch);
        invalidatedRecordIDs.add(dataID);
        target.set(dataID, nextRecord);
    });
    var dataIDs = source.getRecordIDs();
    for(var ii = 0; ii < dataIDs.length; ii++){
        var dataID = dataIDs[ii];
        var sourceRecord = source.get(dataID);
        var targetRecord = target.get(dataID);
        if (sourceRecord && targetRecord) {
            var nextRecord = $jeujn.update(targetRecord, sourceRecord);
            if (nextRecord !== targetRecord) {
                updatedRecordIDs.add(dataID);
                target.set(dataID, nextRecord);
            }
        } else if (sourceRecord === null) {
            target["delete"](dataID);
            if (targetRecord !== null) updatedRecordIDs.add(dataID);
        } else if (sourceRecord) {
            target.set(dataID, sourceRecord);
            updatedRecordIDs.add(dataID);
        }
    }
}
function $46f41c2f1ec2be63$var$getAvailabilityStatus(operationAvailability, operationLastWrittenAt, operationFetchTime, queryCacheExpirationTime) {
    var mostRecentlyInvalidatedAt = operationAvailability.mostRecentlyInvalidatedAt, status = operationAvailability.status;
    if (typeof mostRecentlyInvalidatedAt === 'number') {
        if (operationLastWrittenAt == null || mostRecentlyInvalidatedAt > operationLastWrittenAt) return {
            status: 'stale'
        };
    }
    if (status === 'missing') return {
        status: 'missing'
    };
    if (operationFetchTime != null && queryCacheExpirationTime != null) {
        var isStale = operationFetchTime <= Date.now() - queryCacheExpirationTime;
        if (isStale) return {
            status: 'stale'
        };
    }
    return {
        status: 'available',
        fetchTime: operationFetchTime !== null && operationFetchTime !== void 0 ? operationFetchTime : null
    };
}
module.exports = $46f41c2f1ec2be63$var$LiveResolverStore;

});
parcelRegister("edMta", function(module, exports) {
'use strict';

var $7gV6J = parcelRequire("7gV6J");
var $a5a7e09f792afd36$var$_interopRequireDefault = $7gV6J.default;

var $a5a7e09f792afd36$var$_createForOfIteratorHelper2 = $a5a7e09f792afd36$var$_interopRequireDefault((parcelRequire("8utPl")));

var $b2CqU = parcelRequire("b2CqU");

var $7AO8k = parcelRequire("7AO8k");
var $a5a7e09f792afd36$var$RELAY_LIVE_RESOLVER = $7AO8k.RELAY_LIVE_RESOLVER;

var $brVAm = parcelRequire("brVAm");

var $dFCzs = parcelRequire("dFCzs");

var $dgkLD = parcelRequire("dgkLD");
var $a5a7e09f792afd36$var$generateClientID = $dgkLD.generateClientID, $a5a7e09f792afd36$var$generateClientObjectClientID = $dgkLD.generateClientObjectClientID;

var $jeujn = parcelRequire("jeujn");

var $hqAuM = parcelRequire("hqAuM");
var $a5a7e09f792afd36$var$createNormalizationSelector = $hqAuM.createNormalizationSelector;

var $67IX0 = parcelRequire("67IX0");

var $ggNiN = parcelRequire("ggNiN");
var $a5a7e09f792afd36$var$normalize = $ggNiN.normalize;

var $dfBRB = parcelRequire("dfBRB");
var $a5a7e09f792afd36$var$RELAY_RESOLVER_ERROR_KEY = $dfBRB.RELAY_RESOLVER_ERROR_KEY, $a5a7e09f792afd36$var$RELAY_RESOLVER_INVALIDATION_KEY = $dfBRB.RELAY_RESOLVER_INVALIDATION_KEY, $a5a7e09f792afd36$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS = $dfBRB.RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS, $a5a7e09f792afd36$var$RELAY_RESOLVER_SNAPSHOT_KEY = $dfBRB.RELAY_RESOLVER_SNAPSHOT_KEY, $a5a7e09f792afd36$var$RELAY_RESOLVER_VALUE_KEY = $dfBRB.RELAY_RESOLVER_VALUE_KEY, $a5a7e09f792afd36$var$getStorageKey = $dfBRB.getStorageKey;

var $24A8O = parcelRequire("24A8O");

var $1ct6Z = parcelRequire("1ct6Z");

var $9a00R = parcelRequire("9a00R");
var $a5a7e09f792afd36$var$isSuspenseSentinel = $9a00R.isSuspenseSentinel;

var $aE1Lc = parcelRequire("aE1Lc");
parcelRequire("1srSR");
var $a5a7e09f792afd36$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY = '__resolverLiveStateSubscription';
var $a5a7e09f792afd36$var$RELAY_RESOLVER_LIVE_STATE_VALUE = '__resolverLiveStateValue';
var $a5a7e09f792afd36$var$RELAY_RESOLVER_LIVE_STATE_DIRTY = '__resolverLiveStateDirty';
var $a5a7e09f792afd36$var$RELAY_RESOLVER_RECORD_TYPENAME = '__RELAY_RESOLVER__';
var $a5a7e09f792afd36$var$MODEL_PROPERTY_NAME = '__relay_model_instance';
function $a5a7e09f792afd36$var$addDependencyEdge(edges, from, to) {
    var set = edges.get(from);
    if (!set) {
        set = new Set();
        edges.set(from, set);
    }
    set.add(to);
}
var $a5a7e09f792afd36$var$LiveResolverCache = /*#__PURE__*/ function() {
    function LiveResolverCache(getRecordSource, store) {
        this._resolverIDToRecordIDs = new Map();
        this._recordIDToResolverIDs = new Map();
        this._getRecordSource = getRecordSource;
        this._store = store;
        this._handlingBatch = false;
        this._liveResolverBatchRecordSource = null;
    }
    var _proto = LiveResolverCache.prototype;
    _proto.readFromCacheOrEvaluate = function readFromCacheOrEvaluate(recordID, field, variables, evaluate, getDataForResolverFragment) {
        var recordSource = this._getRecordSource();
        var record = $a5a7e09f792afd36$var$expectRecord(recordSource, recordID);
        var storageKey = $a5a7e09f792afd36$var$getStorageKey(field, variables);
        var linkedID = $jeujn.getLinkedRecordID(record, storageKey);
        var linkedRecord = linkedID == null ? null : recordSource.get(linkedID);
        var updatedDataIDs;
        if (linkedRecord == null || this._isInvalid(linkedRecord, getDataForResolverFragment)) {
            var _linkedID;
            if (linkedRecord != null) $a5a7e09f792afd36$var$maybeUnsubscribeFromLiveState(linkedRecord);
            linkedID = (_linkedID = linkedID) !== null && _linkedID !== void 0 ? _linkedID : $a5a7e09f792afd36$var$generateClientID(recordID, storageKey);
            linkedRecord = $jeujn.create(linkedID, $a5a7e09f792afd36$var$RELAY_RESOLVER_RECORD_TYPENAME);
            var evaluationResult = evaluate();
            $jeujn.setValue(linkedRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_SNAPSHOT_KEY, evaluationResult.snapshot);
            $jeujn.setValue(linkedRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_ERROR_KEY, evaluationResult.error);
            if (field.kind === $a5a7e09f792afd36$var$RELAY_LIVE_RESOLVER) {
                if (evaluationResult.resolverResult != null) {
                    !(evaluationResult.error == null) && $aE1Lc(false);
                    var liveState = evaluationResult.resolverResult;
                    updatedDataIDs = this._setLiveStateValue(linkedRecord, linkedID, liveState, field, variables);
                } else var _evaluationResult$sna;
            } else updatedDataIDs = this._setResolverValue(linkedRecord, evaluationResult.resolverResult, field, variables);
            recordSource.set(linkedID, linkedRecord);
            var currentRecord = $a5a7e09f792afd36$var$expectRecord(recordSource, recordID);
            var nextRecord = $jeujn.clone(currentRecord);
            $jeujn.setLinkedRecordID(nextRecord, storageKey, linkedID);
            recordSource.set(recordID, nextRecord);
            if (field.fragment != null) {
                var _evaluationResult$sna2;
                var fragmentStorageKey = $a5a7e09f792afd36$var$getStorageKey(field.fragment, variables);
                var resolverID = $a5a7e09f792afd36$var$generateClientID(recordID, fragmentStorageKey);
                $a5a7e09f792afd36$var$addDependencyEdge(this._resolverIDToRecordIDs, resolverID, linkedID);
                $a5a7e09f792afd36$var$addDependencyEdge(this._recordIDToResolverIDs, recordID, resolverID);
                var seenRecordIds = (_evaluationResult$sna2 = evaluationResult.snapshot) === null || _evaluationResult$sna2 === void 0 ? void 0 : _evaluationResult$sna2.seenRecords;
                if (seenRecordIds != null) {
                    var _iterator = (0, $a5a7e09f792afd36$var$_createForOfIteratorHelper2["default"])(seenRecordIds), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var seenRecordID = _step.value;
                            $a5a7e09f792afd36$var$addDependencyEdge(this._recordIDToResolverIDs, seenRecordID, resolverID);
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
            }
        } else if (field.kind === $a5a7e09f792afd36$var$RELAY_LIVE_RESOLVER && $jeujn.getValue(linkedRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_LIVE_STATE_DIRTY)) {
            var _linkedID2;
            linkedID = (_linkedID2 = linkedID) !== null && _linkedID2 !== void 0 ? _linkedID2 : $a5a7e09f792afd36$var$generateClientID(recordID, storageKey);
            linkedRecord = $jeujn.clone(linkedRecord);
            var _liveState = $jeujn.getValue(linkedRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_LIVE_STATE_VALUE);
            if (!$1ct6Z(_liveState)) $aE1Lc(false);
            updatedDataIDs = this._setLiveResolverValue(linkedRecord, _liveState, field, variables);
            $jeujn.setValue(linkedRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_LIVE_STATE_DIRTY, false);
            recordSource.set(linkedID, linkedRecord);
        }
        var answer = this._getResolverValue(linkedRecord);
        var snapshot = $jeujn.getValue(linkedRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_SNAPSHOT_KEY);
        var error = $jeujn.getValue(linkedRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_ERROR_KEY);
        var suspenseID = null;
        if ($a5a7e09f792afd36$var$isSuspenseSentinel(answer)) {
            var _linkedID3;
            suspenseID = (_linkedID3 = linkedID) !== null && _linkedID3 !== void 0 ? _linkedID3 : $a5a7e09f792afd36$var$generateClientID(recordID, storageKey);
        }
        return [
            answer,
            linkedID,
            error,
            snapshot,
            suspenseID,
            updatedDataIDs
        ];
    };
    _proto.getLiveResolverPromise = function getLiveResolverPromise(liveStateID) {
        var recordSource = this._getRecordSource();
        var liveStateRecord = recordSource.get(liveStateID);
        !(liveStateRecord != null) && $aE1Lc(false);
        var liveState = $jeujn.getValue(liveStateRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_LIVE_STATE_VALUE);
        return new Promise(function(resolve) {
            var unsubscribe = liveState.subscribe(function() {
                unsubscribe();
                resolve();
            });
        });
    };
    _proto._setLiveStateValue = function _setLiveStateValue(linkedRecord, linkedID, liveState, field, variables) {
        var handler = this._makeLiveStateHandler(linkedID);
        var unsubscribe = liveState.subscribe(handler);
        $jeujn.setValue(linkedRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_LIVE_STATE_VALUE, liveState);
        var updatedDataIDs = this._setLiveResolverValue(linkedRecord, liveState, field, variables);
        $jeujn.setValue(linkedRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_LIVE_STATE_DIRTY, false);
        $jeujn.setValue(linkedRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY, unsubscribe);
        return updatedDataIDs;
    };
    _proto._makeLiveStateHandler = function _makeLiveStateHandler(linkedID) {
        var _this = this;
        return function() {
            var currentSource = _this._getRecordSource();
            var currentRecord = currentSource.get(linkedID);
            if (!currentRecord) return;
            if (!$jeujn.hasValue(currentRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_LIVE_STATE_VALUE)) return;
            var nextRecord = $jeujn.clone(currentRecord);
            $jeujn.setValue(nextRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_LIVE_STATE_DIRTY, true);
            _this._setLiveResolverUpdate(linkedID, nextRecord);
        };
    };
    _proto._setLiveResolverUpdate = function _setLiveResolverUpdate(linkedId, record) {
        if (this._handlingBatch) {
            if (this._liveResolverBatchRecordSource == null) this._liveResolverBatchRecordSource = $67IX0.create();
            this._liveResolverBatchRecordSource.set(linkedId, record);
        } else {
            var nextSource = $67IX0.create();
            nextSource.set(linkedId, record);
            this._store.publish(nextSource);
            this._store.notify();
        }
    };
    _proto.batchLiveStateUpdates = function batchLiveStateUpdates(callback) {
        !!this._handlingBatch && $aE1Lc(false);
        this._handlingBatch = true;
        try {
            callback();
        } finally{
            if (this._liveResolverBatchRecordSource != null) {
                this._store.publish(this._liveResolverBatchRecordSource);
                this._store.notify();
            }
            this._liveResolverBatchRecordSource = null;
            this._handlingBatch = false;
        }
    };
    _proto._setLiveResolverValue = function _setLiveResolverValue(resolverRecord, liveValue, field, variables) {
        var value = null;
        var resolverError = null;
        try {
            value = liveValue.read();
        } catch (e) {
            resolverError = e;
        }
        $jeujn.setValue(resolverRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_ERROR_KEY, resolverError);
        return this._setResolverValue(resolverRecord, value, field, variables);
    };
    _proto._setResolverValue = function _setResolverValue(resolverRecord, value, field, variables) {
        var normalizationInfo = field.normalizationInfo;
        var updatedDataIDs = null;
        if (value != null && normalizationInfo != null && !$a5a7e09f792afd36$var$isSuspenseSentinel(value)) {
            var resolverValue;
            var prevOutputTypeRecordIDs = $24A8O(resolverRecord);
            var nextOutputTypeRecordIDs = new Set();
            var currentSource = this._getRecordSource();
            if (normalizationInfo.plural) {
                !Array.isArray(value) && $aE1Lc(false);
                resolverValue = [];
                var nextSource = $67IX0.create();
                for(var ii = 0; ii < value.length; ii++){
                    var currentValue = value[ii];
                    if (currentValue == null) continue;
                    !(typeof currentValue === 'object') && $aE1Lc(false);
                    var typename = $a5a7e09f792afd36$var$getConcreteTypename(normalizationInfo, currentValue);
                    var outputTypeDataID = $a5a7e09f792afd36$var$generateClientObjectClientID(typename, $jeujn.getDataID(resolverRecord), ii);
                    var source = this._normalizeOutputTypeValue(outputTypeDataID, currentValue, variables, normalizationInfo, [
                        field.path,
                        String(ii)
                    ], typename);
                    var _iterator2 = (0, $a5a7e09f792afd36$var$_createForOfIteratorHelper2["default"])(source.getRecordIDs()), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var recordID = _step2.value;
                            nextSource.set(recordID, $a5a7e09f792afd36$var$expectRecord(source, recordID));
                            nextOutputTypeRecordIDs.add(recordID);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                    resolverValue.push(outputTypeDataID);
                }
                updatedDataIDs = $a5a7e09f792afd36$var$updateCurrentSource(currentSource, nextSource, prevOutputTypeRecordIDs);
            } else {
                !(typeof value === 'object') && $aE1Lc(false);
                var _typename = $a5a7e09f792afd36$var$getConcreteTypename(normalizationInfo, value);
                var _outputTypeDataID = $a5a7e09f792afd36$var$generateClientObjectClientID(_typename, $jeujn.getDataID(resolverRecord));
                var _nextSource = this._normalizeOutputTypeValue(_outputTypeDataID, value, variables, normalizationInfo, [
                    field.path
                ], _typename);
                var _iterator3 = (0, $a5a7e09f792afd36$var$_createForOfIteratorHelper2["default"])(_nextSource.getRecordIDs()), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var _recordID = _step3.value;
                        nextOutputTypeRecordIDs.add(_recordID);
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
                resolverValue = _outputTypeDataID;
                updatedDataIDs = $a5a7e09f792afd36$var$updateCurrentSource(currentSource, _nextSource, prevOutputTypeRecordIDs);
            }
            $jeujn.setValue(resolverRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS, nextOutputTypeRecordIDs);
            $dFCzs(resolverValue);
            $jeujn.setValue(resolverRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_VALUE_KEY, resolverValue);
        } else {
            $dFCzs(value);
            $jeujn.setValue(resolverRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_VALUE_KEY, value);
        }
        return updatedDataIDs;
    };
    _proto.notifyUpdatedSubscribers = function notifyUpdatedSubscribers(updatedDataIDs) {
        this._store.__notifyUpdatedSubscribers(updatedDataIDs);
    };
    _proto._getResolverValue = function _getResolverValue(resolverRecord) {
        return $jeujn.getValue(resolverRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_VALUE_KEY);
    };
    _proto.invalidateDataIDs = function invalidateDataIDs(updatedDataIDs) {
        var recordSource = this._getRecordSource();
        var visited = new Set();
        var recordsToVisit = Array.from(updatedDataIDs);
        while(recordsToVisit.length){
            var recordID = recordsToVisit.pop();
            updatedDataIDs.add(recordID);
            var fragmentSet = this._recordIDToResolverIDs.get(recordID);
            if (fragmentSet == null) continue;
            var _iterator4 = (0, $a5a7e09f792afd36$var$_createForOfIteratorHelper2["default"])(fragmentSet), _step4;
            try {
                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                    var fragment = _step4.value;
                    if (!visited.has(fragment)) {
                        var recordSet = this._resolverIDToRecordIDs.get(fragment);
                        if (recordSet == null) continue;
                        var _iterator5 = (0, $a5a7e09f792afd36$var$_createForOfIteratorHelper2["default"])(recordSet), _step5;
                        try {
                            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                                var anotherRecordID = _step5.value;
                                $a5a7e09f792afd36$var$markInvalidatedResolverRecord(anotherRecordID, recordSource);
                                if (!visited.has(anotherRecordID)) recordsToVisit.push(anotherRecordID);
                            }
                        } catch (err) {
                            _iterator5.e(err);
                        } finally{
                            _iterator5.f();
                        }
                    }
                }
            } catch (err) {
                _iterator4.e(err);
            } finally{
                _iterator4.f();
            }
        }
    };
    _proto._isInvalid = function _isInvalid(record, getDataForResolverFragment) {
        if (!$jeujn.getValue(record, $a5a7e09f792afd36$var$RELAY_RESOLVER_INVALIDATION_KEY)) return false;
        var snapshot = $jeujn.getValue(record, $a5a7e09f792afd36$var$RELAY_RESOLVER_SNAPSHOT_KEY);
        var originalInputs = snapshot === null || snapshot === void 0 ? void 0 : snapshot.data;
        var readerSelector = snapshot === null || snapshot === void 0 ? void 0 : snapshot.selector;
        if (originalInputs == null || readerSelector == null) return true;
        var _getDataForResolverFr = getDataForResolverFragment(readerSelector), latestValues = _getDataForResolverFr.data;
        var recycled = $b2CqU(originalInputs, latestValues);
        if (recycled !== originalInputs) return true;
        if ($brVAm.MARK_RESOLVER_VALUES_AS_CLEAN_AFTER_FRAGMENT_REREAD) {
            var nextRecord = $jeujn.clone(record);
            $jeujn.setValue(nextRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_INVALIDATION_KEY, false);
            var recordSource = this._getRecordSource();
            recordSource.set($jeujn.getDataID(record), nextRecord);
        }
        return false;
    };
    _proto._normalizeOutputTypeValue = function _normalizeOutputTypeValue(outputTypeDataID, value, variables, normalizationInfo, fieldPath, typename) {
        var source = $67IX0.create();
        switch(normalizationInfo.kind){
            case 'OutputType':
                var record = $jeujn.create(outputTypeDataID, typename);
                source.set(outputTypeDataID, record);
                var selector = $a5a7e09f792afd36$var$createNormalizationSelector(normalizationInfo.normalizationNode, outputTypeDataID, variables);
                var normalizationOptions = this._store.__getNormalizationOptions(fieldPath);
                return $a5a7e09f792afd36$var$normalize(source, selector, value, normalizationOptions).source;
            case 'WeakModel':
                var _record = $jeujn.create(outputTypeDataID, typename);
                $jeujn.setValue(_record, $a5a7e09f792afd36$var$MODEL_PROPERTY_NAME, value);
                source.set(outputTypeDataID, _record);
                return source;
            default:
                normalizationInfo.kind;
                $aE1Lc(false);
        }
    };
    _proto.ensureClientRecord = function ensureClientRecord(id, typeName) {
        var key = $a5a7e09f792afd36$var$generateClientObjectClientID(typeName, id);
        var recordSource = this._getRecordSource();
        if (!recordSource.has(key)) {
            var newRecord = $jeujn.create(key, typeName);
            $jeujn.setValue(newRecord, 'id', id);
            recordSource.set(key, newRecord);
        }
        return key;
    };
    _proto.unsubscribeFromLiveResolverRecords = function unsubscribeFromLiveResolverRecords(invalidatedDataIDs) {
        return $a5a7e09f792afd36$var$unsubscribeFromLiveResolverRecordsImpl(this._getRecordSource(), invalidatedDataIDs);
    };
    _proto.invalidateResolverRecords = function invalidateResolverRecords(invalidatedDataIDs) {
        if (invalidatedDataIDs.size === 0) return;
        var _iterator6 = (0, $a5a7e09f792afd36$var$_createForOfIteratorHelper2["default"])(invalidatedDataIDs), _step6;
        try {
            for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                var dataID = _step6.value;
                var record = this._getRecordSource().get(dataID);
                if (record != null && $a5a7e09f792afd36$var$isResolverRecord(record)) this._getRecordSource()["delete"](dataID);
            }
        } catch (err) {
            _iterator6.e(err);
        } finally{
            _iterator6.f();
        }
    };
    return LiveResolverCache;
}();
function $a5a7e09f792afd36$var$updateCurrentSource(currentSource, nextSource, prevOutputTypeRecordIDs) {
    var updatedDataIDs = new Set();
    if (prevOutputTypeRecordIDs != null) {
        var _iterator7 = (0, $a5a7e09f792afd36$var$_createForOfIteratorHelper2["default"])(prevOutputTypeRecordIDs), _step7;
        try {
            for(_iterator7.s(); !(_step7 = _iterator7.n()).done;){
                var recordID = _step7.value;
                if (!nextSource.has(recordID)) {
                    updatedDataIDs.add(recordID);
                    currentSource.remove(recordID);
                }
            }
        } catch (err) {
            _iterator7.e(err);
        } finally{
            _iterator7.f();
        }
    }
    var _iterator8 = (0, $a5a7e09f792afd36$var$_createForOfIteratorHelper2["default"])(nextSource.getRecordIDs()), _step8;
    try {
        for(_iterator8.s(); !(_step8 = _iterator8.n()).done;){
            var _recordID2 = _step8.value;
            var nextRecord = $a5a7e09f792afd36$var$expectRecord(nextSource, _recordID2);
            if (currentSource.has(_recordID2)) {
                var currentRecord = $a5a7e09f792afd36$var$expectRecord(currentSource, _recordID2);
                var updatedRecord = $jeujn.update(currentRecord, nextRecord);
                if (updatedRecord !== currentRecord) {
                    updatedDataIDs.add(_recordID2);
                    currentSource.set(_recordID2, updatedRecord);
                    $a5a7e09f792afd36$var$markInvalidatedLinkedResolverRecords(currentRecord, currentSource);
                }
            } else currentSource.set(_recordID2, nextRecord);
        }
    } catch (err) {
        _iterator8.e(err);
    } finally{
        _iterator8.f();
    }
    return updatedDataIDs;
}
function $a5a7e09f792afd36$var$getAllLinkedRecordIds(record) {
    var linkedRecordIDs = new Set();
    $jeujn.getFields(record).forEach(function(field) {
        if ($jeujn.hasLinkedRecordID(record, field)) {
            var linkedRecordID = $jeujn.getLinkedRecordID(record, field);
            if (linkedRecordID != null) linkedRecordIDs.add(linkedRecordID);
        } else if ($jeujn.hasLinkedRecordIDs(record, field)) {
            var _RelayModernRecord$ge;
            (_RelayModernRecord$ge = $jeujn.getLinkedRecordIDs(record, field)) === null || _RelayModernRecord$ge === void 0 || _RelayModernRecord$ge.forEach(function(linkedRecordID) {
                if (linkedRecordID != null) linkedRecordIDs.add(linkedRecordID);
            });
        }
    });
    return linkedRecordIDs;
}
function $a5a7e09f792afd36$var$markInvalidatedResolverRecord(dataID, recordSource) {
    var record = recordSource.get(dataID);
    if (!record) return;
    var nextRecord = $jeujn.clone(record);
    $jeujn.setValue(nextRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_INVALIDATION_KEY, true);
    recordSource.set(dataID, nextRecord);
}
function $a5a7e09f792afd36$var$markInvalidatedLinkedResolverRecords(record, recordSource) {
    var currentLinkedDataIDs = $a5a7e09f792afd36$var$getAllLinkedRecordIds(record);
    var _iterator9 = (0, $a5a7e09f792afd36$var$_createForOfIteratorHelper2["default"])(currentLinkedDataIDs), _step9;
    try {
        for(_iterator9.s(); !(_step9 = _iterator9.n()).done;){
            var recordID = _step9.value;
            var _record2 = recordSource.get(recordID);
            if (_record2 != null && $a5a7e09f792afd36$var$isResolverRecord(_record2)) $a5a7e09f792afd36$var$markInvalidatedResolverRecord(recordID, recordSource);
        }
    } catch (err) {
        _iterator9.e(err);
    } finally{
        _iterator9.f();
    }
}
function $a5a7e09f792afd36$var$unsubscribeFromLiveResolverRecordsImpl(recordSource, invalidatedDataIDs) {
    if (invalidatedDataIDs.size === 0) return;
    var _iterator10 = (0, $a5a7e09f792afd36$var$_createForOfIteratorHelper2["default"])(invalidatedDataIDs), _step10;
    try {
        for(_iterator10.s(); !(_step10 = _iterator10.n()).done;){
            var dataID = _step10.value;
            var record = recordSource.get(dataID);
            if (record != null && $a5a7e09f792afd36$var$isResolverRecord(record)) $a5a7e09f792afd36$var$maybeUnsubscribeFromLiveState(record);
        }
    } catch (err) {
        _iterator10.e(err);
    } finally{
        _iterator10.f();
    }
}
function $a5a7e09f792afd36$var$isResolverRecord(record) {
    return $jeujn.getType(record) === $a5a7e09f792afd36$var$RELAY_RESOLVER_RECORD_TYPENAME;
}
function $a5a7e09f792afd36$var$maybeUnsubscribeFromLiveState(linkedRecord) {
    var previousUnsubscribe = $jeujn.getValue(linkedRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY);
    if (previousUnsubscribe != null) previousUnsubscribe();
}
function $a5a7e09f792afd36$var$expectRecord(source, recordID) {
    var record = source.get(recordID);
    !(record != null) && $aE1Lc(false);
    return record;
}
function $a5a7e09f792afd36$var$getUpdatedDataIDs(updatedRecords) {
    return updatedRecords;
}
function $a5a7e09f792afd36$var$getConcreteTypename(normalizationInfo, currentValue) {
    var _normalizationInfo$co;
    var typename = (_normalizationInfo$co = normalizationInfo.concreteType) !== null && _normalizationInfo$co !== void 0 ? _normalizationInfo$co : currentValue.__typename;
    !(typename != null) && $aE1Lc(false);
    return typename;
}
module.exports = {
    LiveResolverCache: $a5a7e09f792afd36$var$LiveResolverCache,
    getUpdatedDataIDs: $a5a7e09f792afd36$var$getUpdatedDataIDs,
    RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY: $a5a7e09f792afd36$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY
};

});
parcelRegister("1ct6Z", function(module, exports) {
'use strict';
function $0dfd7e67afc3bafd$var$isLiveStateValue(v) {
    return v != null && typeof v === 'object' && typeof v.read === 'function' && typeof v.subscribe === 'function';
}
module.exports = $0dfd7e67afc3bafd$var$isLiveStateValue;

});



parcelRegister("iJZ8l", function(module, exports) {

$parcel$export(module.exports, "default", () => $b125dd4fe380c966$export$2e2bcd8739ae039);

var $VSDnB = parcelRequire("VSDnB");

var $k43Wt = parcelRequire("k43Wt");
const $b125dd4fe380c966$var$idTypeMap = new Map();
function $b125dd4fe380c966$export$2e2bcd8739ae039(fieldValue, typeName) {
    const { id: id } = fieldValue;
    if (id == null) return undefined;
    if ((0, $VSDnB.fg)('platform_log_relay_duplicate_identifiers')) {
        const idString = String(id);
        if ($b125dd4fe380c966$var$idTypeMap.has(idString)) {
            const entry = $b125dd4fe380c966$var$idTypeMap.get(idString);
            if (entry) {
                const { typeName: existingTypeName, hasLoggedConflict: hasLoggedConflict } = entry;
                if (existingTypeName !== typeName && !hasLoggedConflict) {
                    (0, $k43Wt.safeWarnWithoutCustomerData)('relaydataid.generator', `RelayDataID: conflicting type names for the same ID: ${idString} with type names: ${existingTypeName} and ${typeName}.`, {
                        id: idString,
                        types: `${existingTypeName}, ${typeName}`
                    });
                    entry.hasLoggedConflict = true;
                }
            }
        } else $b125dd4fe380c966$var$idTypeMap.set(idString, {
            typeName: typeName,
            hasLoggedConflict: false
        });
    }
    return `${String(id)}:::::${typeName}`;
}

});
parcelRegister("k43Wt", function(module, exports) {

$parcel$export(module.exports, "safeWarnWithoutCustomerData", () => $6955024b7a0709f2$export$b8c037155fd57aaf);
const $6955024b7a0709f2$var$defaultOptions = {
    credentials: 'same-origin',
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json, text/javascript, */*'
    }
};
const $6955024b7a0709f2$var$isProduction = ()=>true;
const $6955024b7a0709f2$var$MAX_REQUESTS_PER_INTERVAL = 5;
const $6955024b7a0709f2$var$INTERVAL_MS = 1000;
let $6955024b7a0709f2$var$requestQueue = [];
let $6955024b7a0709f2$var$isProcessingQueue = false;
const $6955024b7a0709f2$var$processQueue = ()=>{
    if ($6955024b7a0709f2$var$isProcessingQueue) return;
    $6955024b7a0709f2$var$isProcessingQueue = true;
    const processNextBatch = ()=>{
        if ($6955024b7a0709f2$var$requestQueue.length === 0) {
            $6955024b7a0709f2$var$isProcessingQueue = false;
            return;
        }
        const batch = $6955024b7a0709f2$var$requestQueue.splice(0, $6955024b7a0709f2$var$MAX_REQUESTS_PER_INTERVAL);
        batch.forEach(({ body: body, endpoint: endpoint })=>{
            fetch(endpoint, {
                ...$6955024b7a0709f2$var$defaultOptions,
                method: 'POST',
                body: body
            });
        });
        setTimeout(processNextBatch, $6955024b7a0709f2$var$INTERVAL_MS);
    };
    processNextBatch();
};
const $6955024b7a0709f2$var$sendToServerBatched = (body, endpoint)=>{
    $6955024b7a0709f2$var$requestQueue.push({
        body: body,
        endpoint: endpoint
    });
    // Start processing the logging queue if not already started
    $6955024b7a0709f2$var$processQueue();
};
const $6955024b7a0709f2$var$sendToConsole = (body, endpoint, level, message, eventType, event)=>{
    // eslint-disable-next-line no-console
    console[level]('%c%s %c(POST %s)\n%cMessage\n%c%s\n\n%cEvent body\n%c%s\n\n%cException object and Stack trace (expand to jump to source)\n', 'font-size: 14px; font-weight: bold;', level.toUpperCase(), 'font-size: 10px; font-family: monospace;', endpoint, 'font-family: sans-serif; font-weight: bold; font-size: 12px', 'font-family: sans-serif; font-weight: initial;', message, 'font-family: sans-serif; font-weight: bold;', 'font-family: monospace; font-weight: initial;', body, 'font-family: sans-serif; font-size: 12px; font-weight: bold;', event);
    const currentWindow = window;
    if (!$6955024b7a0709f2$var$isProduction() && currentWindow.Cypress) {
        if (!currentWindow.cypressSafeErrorsLog) currentWindow.cypressSafeErrorsLog = [];
        currentWindow.cypressSafeErrorsLog.push({
            body: body,
            endpoint: endpoint,
            level: level,
            message: message
        });
    }
    if (eventType !== 'object') {
        const errorMessage = `Invalid log API usage: expected event of type 'object', but was ${eventType}`;
        // eslint-disable-next-line no-console
        console.error(errorMessage);
    }
    if (typeof body !== 'string') {
        const errorMessage = `Invalid log API usage: expected event of type 'string', but was ${eventType}; message will be replaced by: ${String(message)}`;
        // eslint-disable-next-line no-console
        console.error(errorMessage);
    }
    return Promise.resolve();
};
const $6955024b7a0709f2$var$transformData = (location, message, event)=>{
    return {
        sentFrom: location,
        message: String(message),
        event: event,
        buildKey: window?.BUILD_KEY,
        logTime: new Date().toISOString()
    };
};
const $6955024b7a0709f2$var$sendData = (level, location, message, event = {})=>{
    const data = $6955024b7a0709f2$var$transformData(location, message, event);
    const body = JSON.stringify(data);
    const endpoint = `/rest/internal/2/log/safe/${level}`;
    if ($6955024b7a0709f2$var$isProduction()) return $6955024b7a0709f2$var$sendToServerBatched(body, endpoint);
    return $6955024b7a0709f2$var$sendToConsole(body, endpoint, level, message, typeof event, event);
};
const $6955024b7a0709f2$export$b8c037155fd57aaf = (location, message, event)=>{
    $6955024b7a0709f2$var$sendData('warn', location, message, event);
};

});


parcelRegister("dj5to", function(module, exports) {

$parcel$export(module.exports, "default", () => $e597542b503a321e$export$2e2bcd8739ae039);

var $gbLWS = parcelRequire("gbLWS");

var $iJZ8l = parcelRequire("iJZ8l");
const $e597542b503a321e$var$isCustomFilter = (filterId)=>/^\d+$/.test(filterId);
const $e597542b503a321e$var$isSystemFilter = (filterId)=>/^-\d+$/.test(filterId);
const $e597542b503a321e$export$77232ec02db7a24a = {
    handle: (field, record, argValues)=>{
        // https://relay.dev/docs/guided-tour/reusing-cached-data/filling-in-missing-data/
        // This lets relay know that a query of
        // JiraQuery.filter(id: ID!)
        // can return:
        //   - a JiraCustomFilter object
        //   - a JiraSystemFilter object
        // determined by the type encoded within the id field (which is an ARI type).
        // By providing the id that relay would refer to those objects by, it is able to check it's
        // store to see if they are already fetched, and avoid refetching them if it is unnecessary
        if (record != null && record.getType() === 'JiraQuery' && field.name === 'filter' && argValues.id != null) {
            const { id: id } = argValues;
            const filterId = (0, $gbLWS.JiraFilterAri).parse(id).filterId;
            if ($e597542b503a321e$var$isCustomFilter(filterId)) return (0, $iJZ8l.default)({
                id: id
            }, 'JiraCustomFilter');
            if ($e597542b503a321e$var$isSystemFilter(filterId)) return (0, $iJZ8l.default)({
                id: id
            }, 'JiraSystemFilter');
            return undefined;
        }
        return undefined;
    },
    kind: 'linked'
};
const $e597542b503a321e$var$MissingFieldHandlers = [
    $e597542b503a321e$export$77232ec02db7a24a
];
var $e597542b503a321e$export$2e2bcd8739ae039 = $e597542b503a321e$var$MissingFieldHandlers;

});
parcelRegister("gbLWS", function(module, exports) {

$parcel$export(module.exports, "JiraFilterAri", () => $bc92de03879804aa$export$3cfb6cc809e835bd);

var $TjnT5 = parcelRequire("TjnT5");

var $9KGzW = parcelRequire("9KGzW");

var $1C2Ux = parcelRequire("1C2Ux");
// src/jira/filter/manifest.ts
var $bc92de03879804aa$var$jiraFilterAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $TjnT5.JiraFilterAriResourceOwner),
    resourceType: (0, $TjnT5.JiraFilterAriResourceType),
    resourceIdSlug: "activation/{activationId}/{filterId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        filterId: /[!a-zA-Z0-9\-_.~@:{}=]+(\/[!a-zA-Z0-9\-_.~@:{}=]+)*/
    }
};
// src/jira/filter/index.ts
var $bc92de03879804aa$export$3cfb6cc809e835bd = class _JiraFilterAri extends (0, $9KGzW.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._filterId = opts.resourceIdSegmentValues.filterId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get filterId() {
        return this._filterId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $bc92de03879804aa$var$jiraFilterAriStaticOpts.qualifier,
            platformQualifier: $bc92de03879804aa$var$jiraFilterAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $bc92de03879804aa$var$jiraFilterAriStaticOpts.resourceOwner,
            resourceType: $bc92de03879804aa$var$jiraFilterAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.filterId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                filterId: opts.filterId
            }
        }, ariOpts = (0, $1C2Ux.AriParser).fromOpts(derivedOpts, $bc92de03879804aa$var$jiraFilterAriStaticOpts);
        return new _JiraFilterAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $1C2Ux.AriParser).fromString(maybeAri, $bc92de03879804aa$var$jiraFilterAriStaticOpts);
        return new _JiraFilterAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            filterId: this.filterId
        };
    }
};

});
parcelRegister("TjnT5", function(module, exports) {

$parcel$export(module.exports, "JiraFilterAriResourceOwner", () => $0a642c7bb6f094f8$export$e6199848f52f1119);
$parcel$export(module.exports, "JiraFilterAriResourceType", () => $0a642c7bb6f094f8$export$3c64de4ae038e3ae);
// src/jira/filter/types.ts
var $0a642c7bb6f094f8$export$e6199848f52f1119 = "jira", $0a642c7bb6f094f8$export$3c64de4ae038e3ae = "filter";

});

parcelRegister("9KGzW", function(module, exports) {

$parcel$export(module.exports, "RegisteredAri", () => $71997031dd676429$export$579ee78b1dcf0a11);

var $1Jl81 = parcelRequire("1Jl81");
// src/core/registered-ari.ts
var $71997031dd676429$export$579ee78b1dcf0a11 = class extends (0, $1Jl81.Ari) {
    static check(maybeAri) {
        try {
            return this.parse(maybeAri.toString()), !0;
        } catch (err) {
            return !1;
        }
    }
    asAnyAri() {
        return (0, $1Jl81.AnyAri).parse(this.toString());
    }
};

});
parcelRegister("1Jl81", function(module, exports) {

$parcel$export(module.exports, "Ari", () => $142a620f899fb689$export$3a4885701291260b);
$parcel$export(module.exports, "AnyAri", () => $142a620f899fb689$export$44a7af7122933d6b);

var $1C2Ux = parcelRequire("1C2Ux");
// src/core/ari.ts
var $142a620f899fb689$export$3a4885701291260b = class {
    constructor(opts){
        this._ati = (0, $1C2Ux.Ati).create({
            platformQualifier: opts.platformQualifier || "cloud",
            resourceOwner: opts.resourceOwner,
            resourceType: opts.resourceType
        }), this._cloudId = opts.cloudId !== "" ? opts.cloudId : void 0, this._resourceId = opts.resourceId;
    }
    get platformQualifier() {
        return this._ati.platformQualifier;
    }
    get cloudId() {
        return this._cloudId;
    }
    get resourceOwner() {
        return this._ati.resourceOwner;
    }
    get resourceType() {
        return this._ati.resourceType;
    }
    get resourceId() {
        return this._resourceId;
    }
    get ati() {
        return this._ati;
    }
    equals(other) {
        return this.toString() === other.toString();
    }
    toString() {
        return `ari:${this.platformQualifier}:${this.resourceOwner}:${this.cloudId || ""}:${this.resourceType}/${this.resourceId}`;
    }
    toJSON() {
        return this.toString();
    }
    toOpts() {
        return {
            platformQualifier: this.platformQualifier,
            resourceOwner: this.resourceOwner,
            cloudId: this.cloudId,
            resourceType: this.resourceType,
            resourceId: this.resourceId
        };
    }
};
// src/any-ari.ts
var $142a620f899fb689$export$44a7af7122933d6b = class _AnyAri extends $142a620f899fb689$export$3a4885701291260b {
    constructor(opts){
        super(opts);
    }
    static create(ariOpts, ariStaticOpts) {
        let ariOptsWithDefaults = {
            ...ariOpts,
            resourceIdSegmentValues: {}
        }, validatedOpts = (0, $1C2Ux.AriParser).fromOpts(ariOptsWithDefaults, ariStaticOpts);
        return new _AnyAri(validatedOpts);
    }
    static parse(maybeAri, ariStaticOpts) {
        let validatedOpts = (0, $1C2Ux.AriParser).fromString(maybeAri, ariStaticOpts);
        return new _AnyAri(validatedOpts);
    }
    static check(maybeAri) {
        try {
            return _AnyAri.parse(maybeAri.toString()), !0;
        } catch (err) {
            return !1;
        }
    }
    asAnyAri() {
        return this;
    }
};

});
parcelRegister("1C2Ux", function(module, exports) {

$parcel$export(module.exports, "AriParser", () => $12cb9916f0aaeeed$export$4c3a8cde7a55740b);
$parcel$export(module.exports, "Ati", () => $12cb9916f0aaeeed$export$ab4b293d0121b8ee);

var $fo7u7 = parcelRequire("fo7u7");

var $ed4UU = parcelRequire("ed4UU");
// src/core/rules/cloud-id.ts
function $12cb9916f0aaeeed$var$validateCloudId(cloudId, format = new RegExp("^[a-zA-Z0-9_\\-.]{0,255}$")) {
    if (!cloudId.match(format)) throw new (0, $ed4UU.ValidationError)(`Invalid cloud ID, expected ID of format ${format}.`);
}
// src/core/rules/resource-id.ts
function $12cb9916f0aaeeed$var$validateResourceId(id, format = new RegExp("[!a-zA-Z0-9\\-_.~@:{}=]+(/[!a-zA-Z0-9\\-_.~@:{}=]+)*" /* ANY_RESOURCE_ID */ ), key = "resourceId") {
    let formatWithCarets = new RegExp(`^${format.source}$`);
    if (!id.match(formatWithCarets)) throw new (0, $ed4UU.ValidationError)(`Invalid ${key} - ${id}, expected ID of format ${formatWithCarets}.`);
}
// src/core/rules/resource-id-segments.ts
function $12cb9916f0aaeeed$var$validateResourceIdSegments(resourceIdSegmentValues, resourceIdSegmentFormats) {
    Object.entries(resourceIdSegmentValues).forEach(([resourceIdKey, resourceIdValue])=>{
        $12cb9916f0aaeeed$var$validateResourceId(resourceIdValue, resourceIdSegmentFormats == null ? void 0 : resourceIdSegmentFormats[resourceIdKey], resourceIdKey);
    });
}
// src/core/rules/resource-owner.ts
function $12cb9916f0aaeeed$var$validateResourceOwner(owner, expectedResourceOwner) {
    if (expectedResourceOwner && owner !== expectedResourceOwner) throw new (0, $ed4UU.ValidationError)(`Invalid resource owner - ${owner}, expected ${expectedResourceOwner}.`);
}
// src/core/rules/resource-type.ts
function $12cb9916f0aaeeed$var$validateResourceType(type, expectedResourceType) {
    if (expectedResourceType && type !== expectedResourceType) throw new (0, $ed4UU.ValidationError)(`Invalid resource type - ${type}, expected ${expectedResourceType}.`);
}
// src/core/parser/ari.ts
var $12cb9916f0aaeeed$var$NUMBER_OF_ARI_SEGMENTS = 5, $12cb9916f0aaeeed$export$4c3a8cde7a55740b = class extends (0, $fo7u7.BaseParser) {
    static fromString(maybeAri, ariProperties) {
        let segments = this.getIdentifierSegments(maybeAri, $12cb9916f0aaeeed$var$NUMBER_OF_ARI_SEGMENTS), [qualifier, platformQualifier, resourceOwner, cloudId, resourceTypeAndId] = segments, [resourceType, ...resourceIdSegments] = resourceTypeAndId.split("/"), maybeAriDerivedProperties = {
            qualifier: qualifier,
            platformQualifier: platformQualifier,
            cloudId: cloudId,
            resourceOwner: resourceOwner,
            resourceType: resourceType,
            resourceId: resourceIdSegments.join("/"),
            resourceIdSegmentValues: ariProperties != null && ariProperties.resourceIdSlug ? this.ariSegmentValuesFromSlug(ariProperties.resourceIdSlug, resourceIdSegments.join("/"), Object.keys(ariProperties.resourceIdSegmentFormats)) : {}
        };
        return this.fromOpts(maybeAriDerivedProperties, ariProperties);
    }
    static fromOpts(maybeAriOpts, ariProperties) {
        let { qualifier: qualifier = "ari", platformQualifier: platformQualifier = "cloud", resourceOwner: resourceOwner, cloudId: cloudId, resourceId: resourceId, resourceIdSegmentValues: resourceIdSegmentValues, resourceType: resourceType } = maybeAriOpts;
        return (0, $fo7u7.validateAriQualifier)(qualifier), (0, $fo7u7.validatePlatformQualifier)(platformQualifier), $12cb9916f0aaeeed$var$validateCloudId(maybeAriOpts.cloudId || "", ariProperties == null ? void 0 : ariProperties.cloudId), $12cb9916f0aaeeed$var$validateResourceOwner(resourceOwner, ariProperties == null ? void 0 : ariProperties.resourceOwner), $12cb9916f0aaeeed$var$validateResourceType(resourceType, ariProperties == null ? void 0 : ariProperties.resourceType), $12cb9916f0aaeeed$var$validateResourceIdSegments(resourceIdSegmentValues, ariProperties == null ? void 0 : ariProperties.resourceIdSegmentFormats), {
            qualifier: qualifier,
            resourceOwner: resourceOwner,
            resourceType: resourceType,
            platformQualifier: platformQualifier,
            cloudId: cloudId,
            resourceId: resourceId,
            resourceIdSegmentValues: resourceIdSegmentValues
        };
    }
    static ariSegmentValuesFromSlug(slug, incomingSegments, expectedKeys) {
        let regexpResult = new RegExp("^" + slug.replace(/\{(.*?)\}/g, "(?<$1>.*?)") + "$").exec(incomingSegments);
        if (!regexpResult) throw new (0, $ed4UU.ValidationError)(`Segment '${incomingSegments}' don't match expected slug: ${slug}`);
        return expectedKeys.forEach((expectedKey)=>{
            var _a;
            if (!((_a = regexpResult.groups) != null && _a[expectedKey])) throw new (0, $ed4UU.ValidationError)(`No value supplied for '${expectedKey}' based on slug ${slug}`);
        }), regexpResult.groups || {};
    }
};
// src/core/parser/ati.ts
var $12cb9916f0aaeeed$var$NUMBER_OF_ATI_SEGMENTS = 4, $12cb9916f0aaeeed$var$AtiParser = class extends (0, $fo7u7.BaseParser) {
    static fromString(inputStr, atiOpts) {
        let segments = this.getIdentifierSegments(inputStr, $12cb9916f0aaeeed$var$NUMBER_OF_ATI_SEGMENTS), [qualifier = "ati", platformQualifier = "cloud", resourceOwner, resourceType] = segments;
        return (0, $fo7u7.validateAtiQualifier)(qualifier), (0, $fo7u7.validatePlatformQualifier)(platformQualifier), $12cb9916f0aaeeed$var$validateResourceOwner(resourceOwner, atiOpts == null ? void 0 : atiOpts.resourceOwner), $12cb9916f0aaeeed$var$validateResourceType(resourceType, atiOpts == null ? void 0 : atiOpts.resourceType), {
            platformQualifier: platformQualifier,
            resourceOwner: resourceOwner,
            resourceType: resourceType
        };
    }
    static fromOpts(maybeAtiOpts, atiOpts) {
        let { qualifier: qualifier, platformQualifier: platformQualifier, resourceOwner: resourceOwner, resourceType: resourceType } = maybeAtiOpts;
        return (0, $fo7u7.validateAtiQualifier)(qualifier), (0, $fo7u7.validatePlatformQualifier)(platformQualifier), $12cb9916f0aaeeed$var$validateResourceOwner(resourceOwner, atiOpts == null ? void 0 : atiOpts.resourceOwner), $12cb9916f0aaeeed$var$validateResourceType(resourceType, atiOpts == null ? void 0 : atiOpts.resourceType), {
            platformQualifier: platformQualifier,
            resourceOwner: resourceOwner,
            resourceType: resourceType
        };
    }
};
// src/ati.ts
var $12cb9916f0aaeeed$export$ab4b293d0121b8ee = class _Ati {
    constructor(platformQualifier, resourceOwner, resourceType){
        this._platformQualifier = platformQualifier, this._resourceOwner = resourceOwner, this._resourceType = resourceType;
    }
    get platformQualifier() {
        return this._platformQualifier;
    }
    get resourceOwner() {
        return this._resourceOwner;
    }
    get resourceType() {
        return this._resourceType;
    }
    static create(opts) {
        return new _Ati(opts.platformQualifier || "cloud", opts.resourceOwner, opts.resourceType);
    }
    static parse(maybeAti, atiOpts) {
        let opts = $12cb9916f0aaeeed$var$AtiParser.fromString(maybeAti, atiOpts);
        return new _Ati(opts.platformQualifier, opts.resourceOwner, opts.resourceType);
    }
    toString() {
        return `ati:${this.platformQualifier}:${this.resourceOwner}:${this.resourceType}`;
    }
    toJSON() {
        return this.toString();
    }
    toOpts() {
        return {
            platformQualifier: this._platformQualifier,
            resourceOwner: this._resourceOwner,
            resourceType: this._resourceType
        };
    }
};

});
parcelRegister("fo7u7", function(module, exports) {

$parcel$export(module.exports, "validatePlatformQualifier", () => $b33ee73cfb749d69$export$4f6e8fa90a16fdc4);
$parcel$export(module.exports, "validateAtiQualifier", () => $b33ee73cfb749d69$export$da331df28ad1f3d9);
$parcel$export(module.exports, "validateAriQualifier", () => $b33ee73cfb749d69$export$822bcd2b6f6774a1);
$parcel$export(module.exports, "BaseParser", () => $b33ee73cfb749d69$export$3d09a5c28ff3e040);

var $ed4UU = parcelRequire("ed4UU");
// src/core/rules/platform-qualifier.ts
function $b33ee73cfb749d69$export$4f6e8fa90a16fdc4(qualifier) {
    if (qualifier !== "cloud" && qualifier !== "third-party") throw new (0, $ed4UU.ValidationError)(`Identifier must have a qualifier of 'cloud' or 'third-party'. Received: ${qualifier}`);
}
// src/core/rules/qualifier.ts
function $b33ee73cfb749d69$export$da331df28ad1f3d9(qualifier) {
    if (qualifier !== "ati") throw new (0, $ed4UU.ValidationError)(`ATI must have a qualifier of 'ati'. Received: ${qualifier}`);
}
function $b33ee73cfb749d69$export$822bcd2b6f6774a1(qualifier) {
    if (qualifier !== "ari") throw new (0, $ed4UU.ValidationError)(`ARI must have a qualifier of 'ari'. Received: ${qualifier}`);
}
function $b33ee73cfb749d69$export$277c2bbc487e609d(qualifier) {
    if (qualifier !== "arm") throw new (0, $ed4UU.ValidationError)(`ARM must have a qualifier of 'arm'. Received: ${qualifier}`);
}
// src/core/parser/base.ts
var $b33ee73cfb749d69$var$NUMBER_OF_BASE_SEGMENTS = 5, $b33ee73cfb749d69$var$SEGMENT_SEPARATOR = ":", $b33ee73cfb749d69$export$3d09a5c28ff3e040 = class {
    static getIdentifierSegments(inputStr, numberOfSegmentsRequired) {
        let allSegments = inputStr.split($b33ee73cfb749d69$var$SEGMENT_SEPARATOR);
        if (allSegments.length < numberOfSegmentsRequired) throw new (0, $ed4UU.ValidationError)(`Input string must have ${numberOfSegmentsRequired} segments.`);
        if (allSegments.length > numberOfSegmentsRequired) {
            let segments = allSegments.slice(0, $b33ee73cfb749d69$var$NUMBER_OF_BASE_SEGMENTS - 1), segmentsForResourceId = allSegments.slice($b33ee73cfb749d69$var$NUMBER_OF_BASE_SEGMENTS - 1, allSegments.length);
            return [
                ...segments,
                segmentsForResourceId.join($b33ee73cfb749d69$var$SEGMENT_SEPARATOR)
            ];
        }
        return allSegments;
    }
};

});
parcelRegister("ed4UU", function(module, exports) {

$parcel$export(module.exports, "ValidationError", () => $a58617fff8cdca9e$export$2191b9da168c6cf0);
// src/errors.ts
var $a58617fff8cdca9e$export$2191b9da168c6cf0 = class extends Error {
};

});







parcelRegister("3Z1I9", function(module, exports) {

$parcel$export(module.exports, "network", () => $d27a06de13f76964$export$21fcfd9d5c6ebbd4);

var $eiowN = parcelRequire("eiowN");

var $eCZ6m = parcelRequire("eCZ6m");

var $fuqQp = parcelRequire("fuqQp");
function $d27a06de13f76964$var$fetchQuery(request, variables, cacheConfig) {
    const endpoint = (0, $eCZ6m.getAggEndpoint)(request, cacheConfig);
    const body = (0, $eCZ6m.getRequestBody)(request, variables);
    return fetch(endpoint, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            // Add authentication and other headers here
            'content-type': 'application/json',
            'X-ExperimentalApi': (0, $fuqQp.RelayExperimentalApis).join(',')
        },
        body: body
    }).then((response)=>{
        return response.json();
    });
}
const $d27a06de13f76964$export$21fcfd9d5c6ebbd4 = (0, $eiowN.Network).create($d27a06de13f76964$var$fetchQuery);

});
parcelRegister("fuqQp", function(module, exports) {

$parcel$export(module.exports, "RelayExperimentalApis", () => $844757ca53e86821$export$ebe3a775ce3053a5);
// Please add your Experimental API name below
// You do not need to wait for approval to add to this list
const $844757ca53e86821$export$ebe3a775ce3053a5 = [
    'ariGraph',
    'boardCardMove',
    'deleteCard',
    'JiraJqlBuilder',
    'SoftwareCardTypeTransitions',
    'jira-releases-v0',
    'JiraDevOps',
    'JiraDevOpsProviders',
    'createCustomFilter',
    'updateCustomFilter',
    'deleteCustomFilter',
    'customFilters',
    'PermissionScheme',
    'JiraIssue',
    'projectStyle',
    'startSprintPrototype',
    'AddIssuesToFixVersion',
    'JiraVersionResult',
    'JiraIssueConnectionJql',
    'JiraFieldOptionSearching',
    'JiraIssueFieldMutations',
    'JiraIssueDevInfoDetails',
    'JiraIssueDevSummaryCache',
    'JiraVersionWarningConfig',
    'JiraReleaseNotesConfiguration',
    'JiraUpdateReleaseNotesConfiguration',
    'ReleaseNotes',
    'ReleaseNotesOptions',
    'DeploymentsFeaturePrecondition',
    'UpdateVersionWarningConfig',
    'UpdateVersionName',
    'UpdateVersionDescription',
    'UpdateVersionStartDate',
    'UpdateVersionReleaseDate',
    'VersionsForProject',
    'RelatedWork',
    'SuggestedRelatedWorkCategories',
    'setIssueMediaVisibility',
    'toggleBoardFeature',
    'DevOpsProvider',
    'DevOpsSummarisedDeployments',
    'JiraProject',
    'DevOpsSummarisedEntities',
    'RoadmapsMutation',
    'RoadmapsQuery',
    'JiraApplicationProperties',
    'JiraIssueSearch',
    'JiraFilter',
    'featureGroups',
    'setBoardEstimationType',
    'devOps',
    'softwareBoards',
    'name',
    'AddRelatedWorkToVersion',
    'RemoveRelatedWorkFromVersion',
    'admins',
    'canAdministerBoard',
    'jql',
    'globalCardCreateAdditionalFields',
    'GlobalTimeTrackingSettings',
    'ReleaseNotesOptions',
    'search-experience',
    'MoveOrRemoveIssuesToFixVersion',
    'compass-beta',
    'JiraIssueSearchStatus',
    'Townsquare',
    'JiraNavigationItems',
    'JiraVersionsForProjects',
    'columnConfigs'
];

});


parcelRegister("iExP6", function(module, exports) {

$parcel$export(module.exports, "default", () => $42dcb07af95a04bd$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$42dcb07af95a04bd$export$2e2bcd8739ae039 = {
    cancel: ()=>{},
    schedule: (fn)=>{
        // react 16.x
        if (// `unstable_batchedUpdates` is defined in all currently supported versions
        // but could be removed in the future.
        // This check is defensive and not currently necessary.
        typeof (0, (/*@__PURE__*/$parcel$interopDefault($7nsd3))).unstable_batchedUpdates === 'function' && // The version export was only introduced in `react-dom@16.13.0`
        // but we need to support `react-dom@^16.8.0`
        // so we need to handle when the version is `undefined`
        (typeof (0, $7nsd3.version) === 'undefined' || (0, $7nsd3.version).startsWith('16'))) (0, (/*@__PURE__*/$parcel$interopDefault($7nsd3))).unstable_batchedUpdates(()=>{
            fn();
        });
        else if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).startTransition === 'function') // @ts-ignore-error React.startTransition does not exist in react-16
        (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).startTransition(()=>{
            fn();
        });
        else fn();
        return '';
    }
};

});


parcelRegister("1ciso", function(module, exports) {

$parcel$export(module.exports, "useUFOTransitionCompleter", () => $438df80413aa7a79$export$369f0ded13ce6c50);
$parcel$export(module.exports, "default", () => $438df80413aa7a79$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7Jxgt = parcelRequire("7Jxgt");

var $5gx4p = parcelRequire("5gx4p");

var $fe1wc = parcelRequire("fe1wc");

var $tcn7E = parcelRequire("tcn7E");

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");

var $9AgLs = parcelRequire("9AgLs");

var $g2MbB = parcelRequire("g2MbB");
function $438df80413aa7a79$var$traceUFOTransition(ufoName, routeName = ufoName) {
    const pressInteractionsList = (0, $fe1wc.getDoNotAbortActivePressInteractionOnTransition)();
    const interaction = (0, $bFU4G.getActiveInteraction)();
    if (pressInteractionsList && interaction) {
        if (pressInteractionsList.includes(interaction.ufoName)) return;
    }
    (0, $bFU4G.abortAll)('transition', ufoName ?? undefined);
    if (ufoName) {
        (0, $9AgLs.default).current = ufoName;
        const rate = (0, $fe1wc.getInteractionRate)(ufoName, 'transition');
        if ((0, $5gx4p.default)(rate)) {
            const newId = (0, $7Jxgt.v4)();
            (0, $g2MbB.setInteractionActiveTrace)(newId);
            (0, $1u4q7.DefaultInteractionID).current = newId;
            (0, $bFU4G.addNewInteraction)(newId, ufoName, 'transition', performance.now(), rate, null, routeName, (0, $tcn7E.getActiveTrace)());
        }
    }
}
function $438df80413aa7a79$export$369f0ded13ce6c50() {
    const interactionId = (0, $5uXOq.useContext)((0, $1u4q7.default));
    const capturedInteractionId = interactionId.current;
    (0, $5uXOq.useEffect)(()=>{
        // If we have a current interaction set...
        if (capturedInteractionId != null) {
            let cancel = requestAnimationFrame(()=>{
                cancel = requestAnimationFrame(()=>{
                    if (capturedInteractionId === interactionId.current) (0, $bFU4G.tryComplete)(capturedInteractionId);
                });
            });
            (0, $bFU4G.addOnCancelCallback)(capturedInteractionId, ()=>{
                cancelAnimationFrame(cancel);
            });
        }
    }, [
        capturedInteractionId,
        interactionId
    ]);
}
var $438df80413aa7a79$export$2e2bcd8739ae039 = $438df80413aa7a79$var$traceUFOTransition;

});
parcelRegister("9AgLs", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8d26e69bb020063$export$2e2bcd8739ae039);
// The UFORouteName object is a global singleton
const $c8d26e69bb020063$var$UFORouteName = {
    current: null
};
var $c8d26e69bb020063$export$2e2bcd8739ae039 = $c8d26e69bb020063$var$UFORouteName;

});

parcelRegister("g2MbB", function(module, exports) {

$parcel$export(module.exports, "setInteractionActiveTrace", () => $ccb60b9a6e8b8304$export$f2e521e495a88544);

var $tcn7E = parcelRequire("tcn7E");

var $hIIZV = parcelRequire("hIIZV");
function $ccb60b9a6e8b8304$export$f2e521e495a88544(newId) {
    (0, $tcn7E.setActiveTrace)(newId.replace(/-/g, ''), (0, $hIIZV.generateSpanId)(), 'transition');
}

});
parcelRegister("hIIZV", function(module, exports) {

$parcel$export(module.exports, "generateSpanId", () => $633f98d7288c3c20$export$295213bc4d0c54ad);
function $633f98d7288c3c20$export$295213bc4d0c54ad() {
    return Array.from(new Array(16), ()=>Math.floor(Math.random() * 16).toString(16)).join('');
}

});



parcelRegister("1AZST", function(module, exports) {

$parcel$export(module.exports, "GlobalPageLoadExperience", () => $58d2d6be5127a354$export$bf7c1e56255f1467);

var $gjd6t = parcelRequire("gjd6t");

var $4wnip = parcelRequire("4wnip");

var $atdLB = parcelRequire("atdLB");

var $8OuDJ = parcelRequire("8OuDJ");
class $58d2d6be5127a354$var$UFOGlobalPageLoadExperience extends (0, $4wnip.UFOAbstractExperience) {
    startPageLoad(id, initial = false, startTime) {
        const result = super.start(initial ? 0 : (0, $4wnip.perfNowOrTimestamp)(startTime));
        this.setPageLoadId(id);
        this.initial = initial;
        return result;
    }
    updateConfig(config) {
        Object.assign(this.config, config);
    }
    setPageLoadId(id) {
        this.loadingPageLoadId = id;
    }
    async getId() {
        return this.loadingPageLoadId;
    }
    async exportData() {
        const data = await super.exportData();
        return {
            ...data,
            initial: this.initial
        };
    }
    constructor(...args){
        super(...args), this.loadingPageLoadId = 'UNKNOWN', this.type = (0, $atdLB.ExperienceTypes).Load, this.performanceType = (0, $atdLB.ExperiencePerformanceTypes).PageLoad, this.initial = true;
    }
}
const $58d2d6be5127a354$export$bf7c1e56255f1467 = new $58d2d6be5127a354$var$UFOGlobalPageLoadExperience('UFO_GLOBAL_PAGE_LOAD', {
    type: (0, $atdLB.ExperienceTypes).Load,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).PageLoad,
    // this should come from global config
    until: (0, $gjd6t.untilAll)([
        {
            category: (0, $8OuDJ.PageSegmentExperienceTypes).PRODUCT
        }
    ])
});

});
parcelRegister("gjd6t", function(module, exports) {

$parcel$export(module.exports, "untilAll", () => $8203c6dc9cf3beaa$export$44695628831598be);

var $eoXiD = parcelRequire("eoXiD");

var $lc9Xi = parcelRequire("lc9Xi");
const $8203c6dc9cf3beaa$var$isUntilExperience = (until)=>{
    return until.experience !== undefined;
};
const $8203c6dc9cf3beaa$var$isUntilCategory = (until)=>{
    return until.category !== undefined;
};
const $8203c6dc9cf3beaa$export$44695628831598be = (deps)=>()=>{
        const notMet = [
            ...deps
        ];
        return (data)=>{
            if (notMet.length > 0) {
                const doneIndexes = notMet.reduce((acc, dep, i)=>{
                    // validation logic
                    if ($8203c6dc9cf3beaa$var$isUntilExperience(dep) && dep.experience.uuid === data.uuid) acc.push(i);
                    else if ($8203c6dc9cf3beaa$var$isUntilCategory(dep) && dep.category === data.category) acc.push(i);
                    return acc;
                }, []);
                const priorityStateFound = data.state === (0, $lc9Xi.UFOExperienceState).ABORTED || data.state === (0, $lc9Xi.UFOExperienceState).FAILED;
                if (priorityStateFound) {
                    notMet.length = 0;
                    return {
                        done: true,
                        state: data.state
                    };
                }
                doneIndexes.reverse().forEach((i)=>{
                    notMet.splice(i, 1);
                });
                (0, $eoXiD.ufolog)('untilAll deps left:', notMet.length, notMet);
                if (notMet.length === 0) return {
                    done: true,
                    state: (0, $lc9Xi.UFOExperienceState).SUCCEEDED
                };
            }
            return {
                done: false
            };
        };
    };

});
parcelRegister("lc9Xi", function(module, exports) {

$parcel$export(module.exports, "UFOExperienceState", () => $afba37b3d9fab1f5$export$81b70111112841a0);
const $afba37b3d9fab1f5$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};

});


parcelRegister("4wnip", function(module, exports) {

$parcel$export(module.exports, "perfNowOrTimestamp", () => $feec6df92685c668$export$c753e8669d30c8ad);
$parcel$export(module.exports, "UFOAbstractExperience", () => $feec6df92685c668$export$d31c89db257648c);

var $7Jxgt = parcelRequire("7Jxgt");


var $8Nn2p = parcelRequire("8Nn2p");

var $iJHxx = parcelRequire("iJHxx");

var $eoXiD = parcelRequire("eoXiD");

var $3aRrh = parcelRequire("3aRrh");

var $fSTSz = parcelRequire("fSTSz");

var $ijH9f = parcelRequire("ijH9f");

var $lc9Xi = parcelRequire("lc9Xi");

var $aqfim = parcelRequire("aqfim");

var $atdLB = parcelRequire("atdLB");
const $feec6df92685c668$var$getPageVisibleState = ()=>{
    return !(0, $8Nn2p.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, $fSTSz.PageVisibleState).VISIBLE : (0, $fSTSz.PageVisibleState).HIDDEN;
};
const $feec6df92685c668$export$c753e8669d30c8ad = (timestamp)=>{
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $ijH9f.roundPerfNow)();
};
class $feec6df92685c668$export$d31c89db257648c {
    constructor(id, config, instanceId = null){
        this.state = (0, $lc9Xi.UFOExperienceState).NOT_STARTED;
        this.instanceId = null // for concurrent
        ;
        this.parent = null;
        this.category = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.explicitTimings = {};
        // @todo move to page load experience when proper classes/inheritance prepared
        this.isSSROutputAsFMP = false;
        this.uuid = null;
        this._until = null;
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this.performanceConfig = {};
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = (0, $fSTSz.PageVisibleState).MIXED;
            (0, $3aRrh.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        };
        this.id = id;
        this.category = config?.category || null;
        this.until = config?.until || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $feec6df92685c668$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $atdLB.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $atdLB.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
    async transition(newState, timestamp) {
        (0, $eoXiD.ufolog)('async transition', this.id, this.state.id, newState.id);
        if ((0, $aqfim.canTransition)(this.state, newState)) {
            (0, $eoXiD.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} successful`, this.state.final, !newState.final);
            if (newState === (0, $lc9Xi.UFOExperienceState).STARTED) this._reset();
            if (this.state.final && !newState.final) {
                this.metrics.startTime = $feec6df92685c668$export$c753e8669d30c8ad(timestamp);
                this.uuid = (0, $7Jxgt.v4)();
            }
            this.state = newState;
            if (newState.final) {
                this.metrics.endTime = $feec6df92685c668$export$c753e8669d30c8ad(timestamp);
                if (!this._isManualStateEnabled()) (0, $iJHxx.getGlobalEventStream)().push((0, $iJHxx.unsubscribeEvent)((0, $fSTSz.SUBSCRIBE_ALL), this.handleDoneBind));
                const data = await this.exportData();
                (0, $eoXiD.ufolog)('this.parent', this.parent);
                (0, $iJHxx.getGlobalEventStream)().push((0, $iJHxx.experiencePayloadEvent)(data));
            }
            return true;
        }
        (0, $eoXiD.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} unsuccessful`);
        (0, $eoXiD.ufowarn)(`transition of ${this.id} from ${this.state} to ${newState} is not possible`);
        return false;
    }
    async start(startTime) {
        const transitionSuccessful = await this.transition((0, $lc9Xi.UFOExperienceState).STARTED, startTime);
        if (transitionSuccessful) {
            this.pageVisibleState = $feec6df92685c668$var$getPageVisibleState();
            (0, $3aRrh.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
            if (!this._isManualStateEnabled()) {
                (0, $eoXiD.ufolog)('subscribed', this.id);
                (0, $iJHxx.getGlobalEventStream)().push((0, $iJHxx.subscribeEvent)((0, $fSTSz.SUBSCRIBE_ALL), this.handleDoneBind));
            }
        }
    }
    mark(name, timestamp) {
        if (name !== (0, $fSTSz.FMP_MARK) && name !== (0, $fSTSz.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
        else (0, $eoXiD.ufowarn)('please use markFMP or markInlineResponse for specialised marks');
    }
    _mark(name, timestamp) {
        this.metrics.marks.push({
            name: name,
            time: $feec6df92685c668$export$c753e8669d30c8ad(timestamp)
        });
        this.transition((0, $lc9Xi.UFOExperienceState).IN_PROGRESS);
    }
    markFMP(timestamp) {
        this._mark((0, $fSTSz.FMP_MARK), timestamp);
    }
    markInlineResponse(timestamp) {
        this._mark((0, $fSTSz.INLINE_RESPONSE_MARK), timestamp);
    }
    _isManualStateEnabled() {
        return this.until === null;
    }
    _validateManualState() {
        if (!this._isManualStateEnabled()) {
            (0, $eoXiD.ufowarn)('manual change of state not allowed as "until" is defined');
            return false;
        }
        return true;
    }
    switchToEndState(state, config) {
        if (!config?.force && !this._validateManualState()) return null;
        if (config?.metadata) this.addMetadata(config.metadata);
        (0, $3aRrh.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        return this.transition(state);
    }
    async success(config) {
        return this.switchToEndState((0, $lc9Xi.UFOExperienceState).SUCCEEDED, config);
    }
    async failure(config) {
        return this.switchToEndState((0, $lc9Xi.UFOExperienceState).FAILED, config);
    }
    async abort(config) {
        return this.switchToEndState((0, $lc9Xi.UFOExperienceState).ABORTED, config);
    }
    addMetadata(data) {
        Object.assign(this.metadata, data);
    }
    _handleDoneExperience(data) {
        (0, $eoXiD.ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
        if (data.state.final) {
            if (this._until !== null) {
                const { done: done, state: state } = this._until(data);
                if (done && !this.state.final) this.transition(state);
            }
        }
    }
    async getId() {
        return this.id;
    }
    async exportData() {
        return {
            id: await this.getId(),
            uuid: this.uuid,
            type: this.type,
            schemaVersion: (0, $356a3e48ee714997$export$2295b861f318254a) || 'unknown',
            performanceType: this.performanceType,
            category: this.category,
            state: this.state,
            metadata: {
                ...this.metadata
            },
            metrics: {
                ...this.metrics
            },
            children: [
                ...this.childExperiences
            ],
            result: {
                success: !!this.state.success,
                startTime: this.metrics.startTime,
                duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
            },
            platform: this.config.platform || null,
            pageVisibleState: this.pageVisibleState,
            featureFlags: this.featureFlags,
            isSSROutputAsFMP: this.isSSROutputAsFMP,
            timings: this.timings,
            explicitTimings: this.explicitTimings,
            performanceConfig: this.performanceConfig
        };
    }
    _reset() {
        this.parent = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this._until = this.until ? this.until() : null;
    }
}

});
// temp solution until we can get it automated
const $356a3e48ee714997$export$2295b861f318254a = '0.1.5';

parcelRegister("ijH9f", function(module, exports) {

$parcel$export(module.exports, "roundPerfNow", () => $0b1119ad19ca6f95$export$5f490af6b2b115cf);
const $0b1119ad19ca6f95$export$5f490af6b2b115cf = ()=>~~performance.now();

});

parcelRegister("aqfim", function(module, exports) {

$parcel$export(module.exports, "canTransition", () => $1ad4fd296053ba67$export$178881f329fdb81f);

var $lc9Xi = parcelRequire("lc9Xi");
const $1ad4fd296053ba67$var$UFOStateAvailableTransitions = {
    [(0, $lc9Xi.UFOExperienceState).NOT_STARTED.id]: [
        (0, $lc9Xi.UFOExperienceState).STARTED.id
    ],
    [(0, $lc9Xi.UFOExperienceState).STARTED.id]: [
        (0, $lc9Xi.UFOExperienceState).IN_PROGRESS.id,
        (0, $lc9Xi.UFOExperienceState).BLOCKED.id,
        (0, $lc9Xi.UFOExperienceState).SUCCEEDED.id,
        (0, $lc9Xi.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $lc9Xi.UFOExperienceState).FAILED.id,
        (0, $lc9Xi.UFOExperienceState).ABORTED.id
    ],
    [(0, $lc9Xi.UFOExperienceState).IN_PROGRESS.id]: [
        (0, $lc9Xi.UFOExperienceState).BLOCKED.id,
        (0, $lc9Xi.UFOExperienceState).SUCCEEDED.id,
        (0, $lc9Xi.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $lc9Xi.UFOExperienceState).FAILED.id,
        (0, $lc9Xi.UFOExperienceState).ABORTED.id
    ],
    [(0, $lc9Xi.UFOExperienceState).BLOCKED.id]: [
        (0, $lc9Xi.UFOExperienceState).RECOVERED.id,
        (0, $lc9Xi.UFOExperienceState).ABORTED.id
    ],
    [(0, $lc9Xi.UFOExperienceState).RECOVERED.id]: [
        (0, $lc9Xi.UFOExperienceState).STARTED.id,
        (0, $lc9Xi.UFOExperienceState).SUCCEEDED.id,
        (0, $lc9Xi.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $lc9Xi.UFOExperienceState).FAILED.id,
        (0, $lc9Xi.UFOExperienceState).ABORTED.id
    ],
    [(0, $lc9Xi.UFOExperienceState).SUCCEEDED.id]: [
        (0, $lc9Xi.UFOExperienceState).STARTED.id
    ],
    [(0, $lc9Xi.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id]: [
        (0, $lc9Xi.UFOExperienceState).SUCCEEDED.id,
        (0, $lc9Xi.UFOExperienceState).FAILED.id,
        (0, $lc9Xi.UFOExperienceState).ABORTED.id
    ],
    [(0, $lc9Xi.UFOExperienceState).FAILED.id]: [
        (0, $lc9Xi.UFOExperienceState).STARTED.id
    ],
    [(0, $lc9Xi.UFOExperienceState).ABORTED.id]: [
        (0, $lc9Xi.UFOExperienceState).STARTED.id
    ]
};
const $1ad4fd296053ba67$export$178881f329fdb81f = (state1, state2)=>{
    return $1ad4fd296053ba67$var$UFOStateAvailableTransitions[state1.id] && $1ad4fd296053ba67$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};

});


parcelRegister("8OuDJ", function(module, exports) {

$parcel$export(module.exports, "PageSegmentExperienceTypes", () => $d503287aeff5c694$export$17d97452062ccf73);
const $d503287aeff5c694$export$17d97452062ccf73 = {
    NAVIGATION: 'NAVIGATION',
    PRODUCT: 'PRODUCT',
    COMPONENT: 'COMPONENT'
};

});


parcelRegister("dGrdR", function(module, exports) {

$parcel$export(module.exports, "metrics", () => $61d987f8a2b40232$export$b0c5c2fac8144e54);

var $e0JCa = parcelRequire("e0JCa");

var $FEKPs = parcelRequire("FEKPs");
const $61d987f8a2b40232$export$b0c5c2fac8144e54 = {
    pageLoad: $FEKPs.pageLoad,
    pageSegmentLoad: $FEKPs.pageSegmentLoad,
    interaction: $FEKPs.interaction,
    custom: $FEKPs.custom,
    concurrent: $e0JCa.concurrent
};

});
parcelRegister("e0JCa", function(module, exports) {

$parcel$export(module.exports, "concurrent", () => $50ff45ae01d4cc6c$export$370df09ecc3de059);

var $2OjhD = parcelRequire("2OjhD");

var $FEKPs = parcelRequire("FEKPs");
const $50ff45ae01d4cc6c$var$concurrentMetrics = {};
const $50ff45ae01d4cc6c$var$getKey = (config, type)=>`${type}--${config.key}`;
const $50ff45ae01d4cc6c$var$validateConfig = (config)=>{
    if (config.include) throw new Error('"include" is not supported in concurrent actions');
    if (config.until) throw new Error('"until" is not supported in concurrent actions');
};
const $50ff45ae01d4cc6c$var$ensurePath = (config, type)=>{
    const key = $50ff45ae01d4cc6c$var$getKey(config, type);
    if (!(key in $50ff45ae01d4cc6c$var$concurrentMetrics)) $50ff45ae01d4cc6c$var$concurrentMetrics[key] = {};
};
const $50ff45ae01d4cc6c$var$getMetricFromCache = (concurrentId, config, type)=>{
    const concurrentKey = $50ff45ae01d4cc6c$var$getKey(config, type);
    if (concurrentKey in $50ff45ae01d4cc6c$var$concurrentMetrics && $50ff45ae01d4cc6c$var$concurrentMetrics[concurrentKey][String(concurrentId)]) return $50ff45ae01d4cc6c$var$concurrentMetrics[concurrentKey][String(concurrentId)];
    if (!(concurrentKey in $50ff45ae01d4cc6c$var$concurrentMetrics)) $50ff45ae01d4cc6c$var$concurrentMetrics[concurrentKey] = {};
};
const $50ff45ae01d4cc6c$var$makeConcurrentMetric = (concurrentId, config, type)=>{
    $50ff45ae01d4cc6c$var$validateConfig(config);
    $50ff45ae01d4cc6c$var$ensurePath(config, type);
    const metricFromCache = $50ff45ae01d4cc6c$var$getMetricFromCache(concurrentId, config, type);
    if (metricFromCache) return metricFromCache;
    const metricFactory = type === (0, $2OjhD.BMEventsType).INLINE_RESULT ? (0, $FEKPs.interaction) : (0, $FEKPs.custom);
    const metric = metricFactory(config);
    $50ff45ae01d4cc6c$var$concurrentMetrics[$50ff45ae01d4cc6c$var$getKey(config, type)][String(concurrentId)] = metric;
    return metric;
};
const $50ff45ae01d4cc6c$export$370df09ecc3de059 = {
    pageSegmentLoad: (config)=>(concurrentId)=>$50ff45ae01d4cc6c$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $2OjhD.BMEventsType).PAGE_SEGMENT_LOAD),
    interaction: (config)=>(concurrentId)=>$50ff45ae01d4cc6c$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $2OjhD.BMEventsType).INLINE_RESULT),
    custom: (config)=>(concurrentId)=>$50ff45ae01d4cc6c$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $2OjhD.BMEventsType).CUSTOM)
};

});
parcelRegister("FEKPs", function(module, exports) {

$parcel$export(module.exports, "pageLoad", () => $2453836fd9363fae$export$791d520f7e8058a5);
$parcel$export(module.exports, "pageSegmentLoad", () => $2453836fd9363fae$export$94114666844d5f66);
$parcel$export(module.exports, "interaction", () => $2453836fd9363fae$export$92473e6020ad89b4);
$parcel$export(module.exports, "custom", () => $2453836fd9363fae$export$4c00f665f0d4b443);

var $7WP2K = parcelRequire("7WP2K");

var $5jIc1 = parcelRequire("5jIc1");

var $5JtK5 = parcelRequire("5JtK5");

var $2OjhD = parcelRequire("2OjhD");
const $2453836fd9363fae$export$791d520f7e8058a5 = (config)=>{
    return new (0, $5jIc1.PageLoadMetric)({
        ...config,
        type: (0, $2OjhD.BMEventsType).PAGE_LOAD
    });
};
const $2453836fd9363fae$export$94114666844d5f66 = (config)=>{
    return new (0, $5JtK5.PageSegmentLoadMetric)({
        ...config,
        type: (0, $2OjhD.BMEventsType).PAGE_SEGMENT_LOAD
    });
};
const $2453836fd9363fae$export$92473e6020ad89b4 = (config)=>{
    return new (0, $7WP2K.Metric)({
        ...config,
        type: (0, $2OjhD.BMEventsType).INLINE_RESULT
    });
};
const $2453836fd9363fae$export$4c00f665f0d4b443 = (config)=>{
    return new (0, $7WP2K.Metric)({
        ...config,
        type: (0, $2OjhD.BMEventsType).CUSTOM
    });
};

});
parcelRegister("7WP2K", function(module, exports) {

$parcel$export(module.exports, "Metric", () => $8418d1a2eefca193$export$efdd3e096bc27746);

var $dNz07 = parcelRequire("dNz07");

var $9mLUv = parcelRequire("9mLUv");

var $faqZ3 = parcelRequire("faqZ3");
class $8418d1a2eefca193$export$efdd3e096bc27746 extends (0, $faqZ3.BaseMetric) {
    start({ startTime: startTime } = {}) {
        super.start({
            startTime: startTime
        });
        this.route = (0, $dNz07.Route).getRoute();
    }
    stop(params = {}) {
        const stoppedSuccessfully = super.stop(params);
        if (stoppedSuccessfully && !this.config.virtual) (0, $9mLUv.submitter).queue(this.getData());
        return stoppedSuccessfully;
    }
}

});

parcelRegister("5jIc1", function(module, exports) {

$parcel$export(module.exports, "PageLoadMetric", () => $c2cc5063230743d5$export$3c51073271a9eac3);

var $Y0qGc = parcelRequire("Y0qGc");

var $1a316 = parcelRequire("1a316");

var $dNz07 = parcelRequire("dNz07");

var $9mLUv = parcelRequire("9mLUv");

var $2OjhD = parcelRequire("2OjhD");

var $hjsyZ = parcelRequire("hjsyZ");

var $7cRo8 = parcelRequire("7cRo8");

var $3bF54 = parcelRequire("3bF54");
class $c2cc5063230743d5$export$3c51073271a9eac3 extends (0, $hjsyZ.BasePageLoadMetric) {
    startPageLoad(params = {
        isInitial: false
    }) {
        (0, $7cRo8.pageLoadMetaMetric).startPageLoad({
            ...params,
            cancelStarted: 'startTime' in params
        });
        this.watchUntil();
    }
    stop(params = {}) {
        const stopTime = params.stopTime || window.performance.now();
        const pageLoadData = (0, $7cRo8.pageLoadMetaMetric).getDataToMerge();
        const metaMetricStopped = (0, $7cRo8.pageLoadMetaMetric).stop(params);
        if (!metaMetricStopped) return false;
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[(0, $hjsyZ.BasePageLoadMetric).FMP]) {
                const mark = (0, $Y0qGc.SSRGetDoneMark).getDoneMark();
                if (mark) (0, $7cRo8.pageLoadMetaMetric).markFMP(mark);
            } else (0, $7cRo8.pageLoadMetaMetric).markFMP(this.marks[(0, $hjsyZ.BasePageLoadMetric).FMP]);
        }
        this.route = (0, $dNz07.Route).getRoute();
        const metricStopped = this.stopPageLoad(pageLoadData, {
            ...params,
            stopTime: stopTime
        });
        if (!metricStopped) return false;
        const data = this.getData();
        if (!this.config.virtual) (0, $9mLUv.submitter).queue(data);
        (0, $1a316.logger).logCond(!!this.config.debug, 'page-load', 'stop', this.getData);
        this.enqueueWebVitals();
        return true;
    }
    mark(mark, timestamp = window.performance.now()) {
        (0, $7cRo8.pageLoadMetaMetric).mark(mark, timestamp);
    }
    markFMP(timestamp) {
        (0, $7cRo8.pageLoadMetaMetric).markFMP(timestamp);
    }
    getData() {
        const pageLoadMetaData = (0, $7cRo8.pageLoadMetaMetric).getData();
        return {
            ...super.getData(),
            // marks and explicitTimings are available only in pageLoadMeta
            marks: pageLoadMetaData.marks,
            explicitTimings: pageLoadMetaData.explicitTimings
        };
    }
    async enqueueWebVitals() {
        if (this.config.virtual || !this.isInitial) return false;
        const configChunk = await (0, $9mLUv.submitter).config.configChunk;
        if (!configChunk?.[(0, $2OjhD.BMEventsType).WEB_VITALS].webVitals?.enabled) return false;
        const webVitalMetric = new (0, $3bF54.WebVitalsMetric)({
            key: this.config.key,
            route: this.route,
            startTime: this.startTime,
            stopTime: this.stopTime,
            pageVisibleState: this.pageVisibleState
        });
        (0, $9mLUv.submitter).queue(webVitalMetric.getData());
        (0, $1a316.logger).logCond(!!this.config.debug, 'web-vitals', webVitalMetric.getData);
        return true;
    }
}

});
parcelRegister("3bF54", function(module, exports) {

$parcel$export(module.exports, "WebVitalsMetric", () => $e10632e38915f687$export$dc0d85d4d6503cd7);

var $2OjhD = parcelRequire("2OjhD");

var $faqZ3 = parcelRequire("faqZ3");
class $e10632e38915f687$export$dc0d85d4d6503cd7 extends (0, $faqZ3.BaseMetric) {
    constructor({ key: key, route: route, startTime: startTime, stopTime: stopTime, pageVisibleState: pageVisibleState }){
        super({
            type: (0, $2OjhD.BMEventsType).WEB_VITALS,
            key: key
        });
        this.route = route;
        this.startTime = startTime;
        this.stopTime = stopTime;
        this.state = (0, $faqZ3.MetricState).FINISHED;
        this.pageVisibleState = pageVisibleState;
    }
}

});


parcelRegister("5JtK5", function(module, exports) {

$parcel$export(module.exports, "PageSegmentLoadMetric", () => $868251c1eede1606$export$24c8bfcd77494cc1);

var $Y0qGc = parcelRequire("Y0qGc");

var $2OjhD = parcelRequire("2OjhD");

var $faqZ3 = parcelRequire("faqZ3");

var $7WP2K = parcelRequire("7WP2K");

var $7cRo8 = parcelRequire("7cRo8");
class $868251c1eede1606$export$24c8bfcd77494cc1 extends (0, $7WP2K.Metric) {
    static{
        this.FMP = 'fmp';
    }
    constructor(config){
        super(config), this.isInitial = true;
        this.config = config;
    }
    startFromPageLoad() {
        const pageLoadMetaData = (0, $7cRo8.pageLoadMetaMetric).getData();
        this.start({
            startTime: pageLoadMetaData.start ?? undefined
        });
        this.isInitial = pageLoadMetaData.isInitial;
        this.pageVisibleState = pageLoadMetaData.pageVisibleState;
    }
    mark(mark, timestamp = window.performance.now()) {
        if (mark === $868251c1eede1606$export$24c8bfcd77494cc1.FMP) return;
        super.mark(mark, timestamp);
    }
    markFMP(timestamp) {
        super.mark($868251c1eede1606$export$24c8bfcd77494cc1.FMP, timestamp);
    }
    getPageSegmentLoadData() {
        return {
            isInitial: this.isInitial
        };
    }
    getData() {
        return {
            ...super.getData(),
            ...this.getPageSegmentLoadData()
        };
    }
    getDataToMerge() {
        return {
            ...super.getDataToMerge(),
            ...this.getPageSegmentLoadData()
        };
    }
    merge(mergeData) {
        super.merge(mergeData);
        this.isInitial = mergeData.isInitial;
    }
    stop(params = {}) {
        const pageLoadData = (0, $7cRo8.pageLoadMetaMetric).getData();
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[$868251c1eede1606$export$24c8bfcd77494cc1.FMP]) {
                const mark = (0, $Y0qGc.SSRGetDoneMark).getDoneMark();
                if (mark) this.markFMP(mark);
            }
        }
        if (this.config.includePageLoadTimings !== (0, $2OjhD.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT || pageLoadData.state === (0, $faqZ3.MetricState).FINISHED) return super.stop(params);
        const now = performance.now();
        if (pageLoadData.state === (0, $faqZ3.MetricState).STARTED) (0, $7cRo8.pageLoadMetaMetric).onStop(()=>{
            super.stop({
                ...params,
                stopTime: params.stopTime || now
            });
        }, ()=>{
            this.cancel();
        });
        return true;
    }
}

});




parcelRegister("dGvGJ", function(module, exports) {

$parcel$export(module.exports, "defaultMemoize", () => $9f67c73d64e1d92a$export$281bff7f05488aa2, (v) => $9f67c73d64e1d92a$export$281bff7f05488aa2 = v);
$parcel$export(module.exports, "createSelectorCreator", () => $9f67c73d64e1d92a$export$5943f4447f6ef248, (v) => $9f67c73d64e1d92a$export$5943f4447f6ef248 = v);
$parcel$export(module.exports, "createStructuredSelector", () => $9f67c73d64e1d92a$export$75979cfcd91bf38f, (v) => $9f67c73d64e1d92a$export$75979cfcd91bf38f = v);
$parcel$export(module.exports, "createSelector", () => $9f67c73d64e1d92a$export$595d22ed68ca2841, (v) => $9f67c73d64e1d92a$export$595d22ed68ca2841 = v);
var $9f67c73d64e1d92a$export$1e511d4a378977f5;
var $9f67c73d64e1d92a$export$281bff7f05488aa2;
var $9f67c73d64e1d92a$export$5943f4447f6ef248;
var $9f67c73d64e1d92a$export$75979cfcd91bf38f;
var $9f67c73d64e1d92a$export$595d22ed68ca2841;
'use strict';
$9f67c73d64e1d92a$export$1e511d4a378977f5 = true;
$9f67c73d64e1d92a$export$281bff7f05488aa2 = $9f67c73d64e1d92a$var$defaultMemoize;
$9f67c73d64e1d92a$export$5943f4447f6ef248 = $9f67c73d64e1d92a$var$createSelectorCreator;
$9f67c73d64e1d92a$export$75979cfcd91bf38f = $9f67c73d64e1d92a$var$createStructuredSelector;
function $9f67c73d64e1d92a$var$defaultEqualityCheck(a, b) {
    return a === b;
}
function $9f67c73d64e1d92a$var$areArgumentsShallowlyEqual(equalityCheck, prev, next) {
    if (prev === null || next === null || prev.length !== next.length) return false;
    // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
    var length = prev.length;
    for(var i = 0; i < length; i++){
        if (!equalityCheck(prev[i], next[i])) return false;
    }
    return true;
}
function $9f67c73d64e1d92a$var$defaultMemoize(func) {
    var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $9f67c73d64e1d92a$var$defaultEqualityCheck;
    var lastArgs = null;
    var lastResult = null;
    // we reference arguments instead of spreading them for performance reasons
    return function() {
        if (!$9f67c73d64e1d92a$var$areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) // apply arguments instead of spreading for performance.
        lastResult = func.apply(null, arguments);
        lastArgs = arguments;
        return lastResult;
    };
}
function $9f67c73d64e1d92a$var$getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === 'function';
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep;
        }).join(', ');
        throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
    }
    return dependencies;
}
function $9f67c73d64e1d92a$var$createSelectorCreator(memoize) {
    for(var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptions[_key - 1] = arguments[_key];
    return function() {
        for(var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var recomputations = 0;
        var resultFunc = funcs.pop();
        var dependencies = $9f67c73d64e1d92a$var$getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(undefined, [
            function() {
                recomputations++;
                // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(memoizeOptions));
        // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = $9f67c73d64e1d92a$var$defaultMemoize(function() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            params.push(dependencies[i].apply(null, arguments));
            // apply arguments instead of spreading for performance.
            return memoizedResultFunc.apply(null, params);
        });
        selector.resultFunc = resultFunc;
        selector.recomputations = function() {
            return recomputations;
        };
        selector.resetRecomputations = function() {
            return recomputations = 0;
        };
        return selector;
    };
}
var $9f67c73d64e1d92a$var$createSelector = $9f67c73d64e1d92a$export$595d22ed68ca2841 = $9f67c73d64e1d92a$var$createSelectorCreator($9f67c73d64e1d92a$var$defaultMemoize);
function $9f67c73d64e1d92a$var$createStructuredSelector(selectors) {
    var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $9f67c73d64e1d92a$var$createSelector;
    if (typeof selectors !== 'object') throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
    var objectKeys = Object.keys(selectors);
    return selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
}

});

parcelRegister("jI6pi", function(module, exports) {

$parcel$export(module.exports, "addTimingFromPerformanceMark", () => $0d5c580691017430$export$758b9a33800fa436);
$parcel$export(module.exports, "getTimings", () => $0d5c580691017430$export$6d488733a547304);
const $0d5c580691017430$var$timings = [];
function $0d5c580691017430$export$758b9a33800fa436(name, startMark, stopMark, cleanStart = false, cleanStop = false) {
    $0d5c580691017430$var$timings.push({
        name: name,
        startMark: startMark,
        stopMark: stopMark,
        cleanStart: cleanStart,
        cleanStop: cleanStop
    });
}
function $0d5c580691017430$export$6d488733a547304() {
    const reportedTimingsObj = {};
    $0d5c580691017430$var$timings.forEach(({ name: name, startMark: startMark, stopMark: stopMark, cleanStart: cleanStart, cleanStop: cleanStop })=>{
        const startEntryList = performance.getEntriesByName(startMark);
        const stopEntryList = performance.getEntriesByName(stopMark);
        if (startEntryList?.length > 0 && stopEntryList?.length > 0) {
            const startEntry = startEntryList[startEntryList.length - 1];
            const stopEntry = stopEntryList[stopEntryList.length - 1];
            const { startTime: startTime } = startEntry;
            const duration = stopEntry.startTime - startTime;
            const timing = {
                startTime: Math.round(startTime),
                duration: Math.round(duration)
            };
            reportedTimingsObj[name] = timing;
        }
        if (cleanStart) performance.clearMarks(startMark);
        if (cleanStop) performance.clearMarks(stopMark);
    });
    return reportedTimingsObj;
}

});

parcelRegister("fKgem", function(module, exports) {
module.exports = $b767bdf46d56eeb2$var$defaultsPlugin;
function $b767bdf46d56eeb2$var$defaultsPlugin() {
    var defaultValues = {};
    return {
        defaults: defaults,
        get: get
    };
    function defaults(_, values) {
        defaultValues = values;
    }
    function get(super_fn, key) {
        var val = super_fn();
        return val !== undefined ? val : defaultValues[key];
    }
}

});

parcelRegister("bHibm", function(module, exports) {

$parcel$export(module.exports, "AtlBrowserStorageLocal", () => $77ca41164f368d83$export$c8cc3ffd3f2c1d2f);
$parcel$export(module.exports, "AtlBrowserStorageSession", () => $77ca41164f368d83$export$edbae459bdf957a5);
$parcel$export(module.exports, "findStorageTarget", () => $77ca41164f368d83$export$14921bfc334334c0);
$parcel$export(module.exports, "WebStorageType", () => (parcelRequire("3iwZ5")).WebStorageType);

var $gMWuT = parcelRequire("gMWuT");
var $ljmYJ = parcelRequire("ljmYJ");

var $Dyz2r = parcelRequire("Dyz2r");

var $8FFpF = parcelRequire("8FFpF");

var $3uyrZ = parcelRequire("3uyrZ");

var $3iwZ5 = parcelRequire("3iwZ5");

var $3KKvX = parcelRequire("3KKvX");
var $3jvQx = parcelRequire("3jvQx");
var $Ux8bG = parcelRequire("Ux8bG");
class $77ca41164f368d83$export$8e4a3cf07a10930b {
    constructor(storage, storageType){
        this.isAvailable = false;
        this.checkIfSetByPackage = async ({ itemKey: itemKey, isSetCallback: isSetCallback = ()=>{}, isNotSetCallback: isNotSetCallback = ()=>{} })=>{
            // As IDB is asynchronous in nature, when this in invoked, we need to rely on the callbacks
            // to actually do something with the result.
            try {
                const record = await (0, $3uyrZ.BSCIndexedDB).getRecord(itemKey);
                if (record) {
                    isSetCallback();
                    return true;
                } else {
                    isNotSetCallback();
                    return false;
                }
            } catch (e) {
                // If it fails to pull from IDB, we can't validate that it's been set by our package or not, so log the error
                // and assume it hasn't been set by our package. This will only impact our analytics correctness.
                (0, $Dyz2r.Logger).errorWithOperationalEvent({
                    action: 'usedCheckIfSetByPackageError',
                    message: `IDB lookup failed to check if item was set by package. ${e.message || ''}`,
                    attributes: {
                        itemKey: itemKey
                    }
                });
                isNotSetCallback();
                return false;
            }
        };
        this.storage = storage;
        this.storageType = storageType;
        this.isAvailable = this.isStorageAvailable();
    }
    get isWebStorageEnabled() {
        // Note: outside of user configuration, webStoragedEnabled is also feature gated by
        // 1. platform_moonjelly_bsc_master_killswitch
        // 2. platform_moonjelly_bsc_web_storage_killswitch
        if ((0, $gMWuT.getBscGlobalState)().webStorageEnabled) return true;
        (0, $Dyz2r.Logger).debug('WebStorage config is disabled, cannot proceed.');
        return false;
    }
    // Core API
    getItem(key) {
        if (!this.isWebStorageEnabled) return this.storage.getItem(key);
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $Dyz2r.Logger).warn(`${this.storageType} is unavailable. Failed to get item ${key}`);
            return null;
        }
        const retrievedItem = (0, $3KKvX.getStorageItem)(key, this.storageType, this.storage);
        return retrievedItem;
    }
    async setItem(key, value) {
        if (!this.isWebStorageEnabled) {
            this.storage.setItem(key, value);
            return;
        }
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $Dyz2r.Logger).warn(`${this.storageType} is unavailable. Failed to set item ${key}`);
            return;
        }
        const globalStateProduct = (0, $gMWuT.getBscGlobalState)().product;
        const itemSetStatus = await (0, $3jvQx.setStorageItem)(key, value, this.storageType, globalStateProduct, this.storage);
        (0, $Dyz2r.Logger).debug(`${itemSetStatus === (0, $8FFpF.Status).SUCCESS ? 'Successfully' : 'Failed to'} set item ${key} with value ${value}`);
    }
    setStrictlyNecessaryItem(key, value) {
        if (!this.isWebStorageEnabled) {
            this.storage.setItem(key, value);
            return;
        }
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $Dyz2r.Logger).warn(`${this.storageType} is unavailable. Failed to set strictly necessary item ${key}`);
            return;
        }
        const itemSetStatus = (0, $Ux8bG.setStrictlyNecessaryStorageItem)(key, value, this.storageType, this.storage);
        (0, $Dyz2r.Logger).debug(`${itemSetStatus === (0, $8FFpF.Status).SUCCESS ? 'Successfully' : 'Failed to'} set strictly necessary item ${key} with value ${value}`);
    }
    // Native Utilities
    removeItem(key) {
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $Dyz2r.Logger).warn(`${this.storageType} is unavailable. Failed to remove item ${key}`);
            return;
        }
        this.storage.removeItem(key);
    }
    key(index) {
        if (!this.isAvailable) return null;
        return this.storage.key(index);
    }
    length() {
        if (!this.isAvailable) return 0;
        return this.storage.length;
    }
    clear() {
        if (!this.isAvailable) return;
        this.storage.clear();
    }
    // Utilities
    isStorageAvailable() {
        if ((0, $ljmYJ.isSSR)()) return false;
        try {
            const x = '__storage_test__';
            this.storage.setItem(x, x);
            this.storage.removeItem(x);
            return true;
        } catch (e) {
            return e instanceof DOMException && // everything except Firefox
            (e.code === 22 || // Firefox
            e.code === 1014 || // test name field too, because code might not be present
            // everything except Firefox
            e.name === 'QuotaExceededError' || // Firefox
            e.name === 'NS_ERROR_DOM_QUOTA_REACHED') && // acknowledge QuotaExceededError only if there's something already stored
            this.storage && this.storage.length !== 0;
        }
    }
}
const $77ca41164f368d83$export$c8cc3ffd3f2c1d2f = new $77ca41164f368d83$export$8e4a3cf07a10930b(window?.localStorage, (0, $3iwZ5.WebStorageType).LocalStorage);
const $77ca41164f368d83$export$edbae459bdf957a5 = new $77ca41164f368d83$export$8e4a3cf07a10930b(window?.sessionStorage, (0, $3iwZ5.WebStorageType).SessionStorage);
const $77ca41164f368d83$export$14921bfc334334c0 = (type)=>{
    return ({
        [(0, $3iwZ5.WebStorageType).LocalStorage]: $77ca41164f368d83$export$c8cc3ffd3f2c1d2f,
        [(0, $3iwZ5.WebStorageType).SessionStorage]: $77ca41164f368d83$export$edbae459bdf957a5
    })[type];
};

});
parcelRegister("gMWuT", function(module, exports) {

$parcel$export(module.exports, "getBscGlobalState", () => $d8e2f6a273855d4e$export$3b78a1ea01f5ec28);
$parcel$export(module.exports, "initializeGlobalState", () => $d8e2f6a273855d4e$export$882c4530c58781d8);

var $eYli8 = parcelRequire("eYli8");

var $VSDnB = parcelRequire("VSDnB");

var $8FFpF = parcelRequire("8FFpF");

var $ijunp = parcelRequire("ijunp");

var $Dyz2r = parcelRequire("Dyz2r");
let $d8e2f6a273855d4e$var$analyticsEnabledGlobalState;
let $d8e2f6a273855d4e$var$productGlobalState;
let $d8e2f6a273855d4e$var$webStorageControlsEnabledGlobalState;
let $d8e2f6a273855d4e$var$localConsentModeGlobalState;
let $d8e2f6a273855d4e$var$packageDebugModeEnabledGlobalState;
let $d8e2f6a273855d4e$var$allowUncategorizedCookiesInOverridesGlobalState;
let $d8e2f6a273855d4e$var$hasInitialized = false;
let $d8e2f6a273855d4e$var$cookiesCacheLoader;
let $d8e2f6a273855d4e$var$localStorageCacheLoader;
let $d8e2f6a273855d4e$var$sessionStorageCacheLoader;
let $d8e2f6a273855d4e$var$loadCache = async (storageType)=>{
    switch(storageType){
        case (0, $8FFpF.CategoryStorageType).Cookies:
            return await $d8e2f6a273855d4e$var$cookiesCacheLoader?.loadStorageControlsData();
        case (0, $8FFpF.CategoryStorageType).LocalStorage:
            return await $d8e2f6a273855d4e$var$localStorageCacheLoader?.loadStorageControlsData();
        case (0, $8FFpF.CategoryStorageType).SessionStorage:
            return await $d8e2f6a273855d4e$var$sessionStorageCacheLoader?.loadStorageControlsData();
        default:
            return undefined;
    }
};
const $d8e2f6a273855d4e$export$3b78a1ea01f5ec28 = ()=>{
    return {
        analyticsEnabled: $d8e2f6a273855d4e$var$analyticsEnabledGlobalState ?? true,
        product: $d8e2f6a273855d4e$var$productGlobalState,
        webStorageEnabled: $d8e2f6a273855d4e$var$webStorageControlsEnabledGlobalState ?? false,
        localConsentMode: $d8e2f6a273855d4e$var$localConsentModeGlobalState ?? false,
        packageDebugMode: $d8e2f6a273855d4e$var$packageDebugModeEnabledGlobalState,
        allowUncategorizedCookiesInOverrides: $d8e2f6a273855d4e$var$allowUncategorizedCookiesInOverridesGlobalState ?? false,
        cookiesCacheLoader: $d8e2f6a273855d4e$var$cookiesCacheLoader,
        localStorageCacheLoader: $d8e2f6a273855d4e$var$localStorageCacheLoader,
        sessionStorageCacheLoader: $d8e2f6a273855d4e$var$sessionStorageCacheLoader,
        loadCache: $d8e2f6a273855d4e$var$loadCache,
        hasInitialized: $d8e2f6a273855d4e$var$hasInitialized
    };
};
const $d8e2f6a273855d4e$export$882c4530c58781d8 = ({ webStorageEnabled: webStorageEnabled, allowUncategorizedCookiesInOverrides: allowUncategorizedCookiesInOverrides, localConsentMode: localConsentMode = false, product: product = 'all', analyticsEnabled: analyticsEnabled = true } = {})=>{
    (0, $Dyz2r.Logger).debug('Initialize global state invoked');
    // If the app provides a value for product only in one place,
    // we want that value to be sticky and to override the default if necessary
    if ((!$d8e2f6a273855d4e$var$productGlobalState || $d8e2f6a273855d4e$var$productGlobalState == null || $d8e2f6a273855d4e$var$productGlobalState === 'all') && product) $d8e2f6a273855d4e$var$productGlobalState = product;
    // Treating webStorageEnabled and allowUncategorizedCookiesInOverrides differently
    // because they are only passed through initializeControls and
    // we don't want it to be defaulted to false via a call from the ConsentBanner
    if (webStorageEnabled !== undefined && $d8e2f6a273855d4e$var$webStorageControlsEnabledGlobalState === undefined) $d8e2f6a273855d4e$var$webStorageControlsEnabledGlobalState = webStorageEnabled && !(0, $VSDnB.fg)('platform_moonjelly_bsc_master_killswitch') && !(0, $VSDnB.fg)('platform_moonjelly_bsc_web_storage_killswitch');
    if (allowUncategorizedCookiesInOverrides !== undefined && $d8e2f6a273855d4e$var$allowUncategorizedCookiesInOverridesGlobalState === undefined) $d8e2f6a273855d4e$var$allowUncategorizedCookiesInOverridesGlobalState = allowUncategorizedCookiesInOverrides;
    // All other state can only be initialized once and is defaulted if not passed on the first initialization
    if ($d8e2f6a273855d4e$var$hasInitialized) return;
    $d8e2f6a273855d4e$var$localConsentModeGlobalState = localConsentMode;
    $d8e2f6a273855d4e$var$analyticsEnabledGlobalState = analyticsEnabled;
    $d8e2f6a273855d4e$var$cookiesCacheLoader = new (0, $ijunp.CacheLoader)((0, $8FFpF.CategoryStorageType).Cookies);
    $d8e2f6a273855d4e$var$localStorageCacheLoader = new (0, $ijunp.CacheLoader)((0, $8FFpF.CategoryStorageType).LocalStorage);
    $d8e2f6a273855d4e$var$sessionStorageCacheLoader = new (0, $ijunp.CacheLoader)((0, $8FFpF.CategoryStorageType).SessionStorage);
    if ((0, $VSDnB.fg)('platform_moonjelly_bsc_debug_mode')) $d8e2f6a273855d4e$var$packageDebugModeEnabledGlobalState = Boolean((0, (/*@__PURE__*/$parcel$interopDefault($eYli8))).get('atl-bsc-debug-mode'));
    $d8e2f6a273855d4e$var$hasInitialized = true;
};
const $d8e2f6a273855d4e$export$f86e17381f699baf = ({ loadCache: overrideLoadCache, product: overrideProduct })=>{
    if (overrideLoadCache) $d8e2f6a273855d4e$var$loadCache = overrideLoadCache;
    if (overrideProduct) $d8e2f6a273855d4e$var$productGlobalState = overrideProduct;
};
const $d8e2f6a273855d4e$export$ac7c2edd09656c05 = ()=>{
    $d8e2f6a273855d4e$var$analyticsEnabledGlobalState = undefined;
    $d8e2f6a273855d4e$var$productGlobalState = undefined;
    $d8e2f6a273855d4e$var$webStorageControlsEnabledGlobalState = undefined;
    $d8e2f6a273855d4e$var$localConsentModeGlobalState = undefined;
    $d8e2f6a273855d4e$var$packageDebugModeEnabledGlobalState = undefined;
    $d8e2f6a273855d4e$var$allowUncategorizedCookiesInOverridesGlobalState = undefined;
    $d8e2f6a273855d4e$var$cookiesCacheLoader = undefined;
    $d8e2f6a273855d4e$var$localStorageCacheLoader = undefined;
    $d8e2f6a273855d4e$var$sessionStorageCacheLoader = undefined;
    $d8e2f6a273855d4e$var$hasInitialized = false;
};

});
parcelRegister("8FFpF", function(module, exports) {

$parcel$export(module.exports, "PreferenceCategory", () => $36d7d553dbfdd9f7$export$ba064dbfe4bb66d7);
$parcel$export(module.exports, "ConsentPreferenceV2", () => $36d7d553dbfdd9f7$export$cdef20bac194f235);
$parcel$export(module.exports, "ContextualConsentProperty", () => $36d7d553dbfdd9f7$export$fac80ad19b60e313);
$parcel$export(module.exports, "PrefetchedPreferenceState", () => $36d7d553dbfdd9f7$export$5d6594a0bba4ab8a);
$parcel$export(module.exports, "CategoryStorageType", () => $36d7d553dbfdd9f7$export$2506b012eb637f61);
$parcel$export(module.exports, "Status", () => $36d7d553dbfdd9f7$export$96e9906d6d93a972);
var $36d7d553dbfdd9f7$export$ba064dbfe4bb66d7 = /*#__PURE__*/ function(PreferenceCategory) {
    PreferenceCategory["StrictlyNecessary"] = "STRICTLY_NECESSARY";
    PreferenceCategory["Functional"] = "FUNCTIONAL";
    PreferenceCategory["Marketing"] = "MARKETING";
    PreferenceCategory["Analytics"] = "ANALYTICS";
    PreferenceCategory["Unknown"] = "UNKNOWN";
    return PreferenceCategory;
}({});
var $36d7d553dbfdd9f7$export$cdef20bac194f235 = /*#__PURE__*/ function(ConsentPreferenceV2) {
    ConsentPreferenceV2["ConsentDataUnavailable"] = "CONSENT_DATA_UNAVAILABLE";
    ConsentPreferenceV2["ConsentedUnderGDPR"] = "CONSENTS_SAVED_IN_GDPR_LOCALE";
    ConsentPreferenceV2["ConsentedUnderCPRA"] = "CONSENTS_SAVED_IN_CPRA_LOCALE";
    ConsentPreferenceV2["ConsentedUnderLGPD"] = "CONSENTS_SAVED_IN_LGPD_LOCALE";
    ConsentPreferenceV2["ConsentedUnderFADP"] = "CONSENTS_SAVED_IN_FADP_LOCALE";
    return ConsentPreferenceV2;
}({});
var $36d7d553dbfdd9f7$export$fac80ad19b60e313 = /*#__PURE__*/ function(ContextualConsentProperty) {
    ContextualConsentProperty["ConsentsAreDefault"] = "DEFAULT_CONSENTS";
    ContextualConsentProperty["UserIsAuthenticated"] = "USER_AUTHENTICATED";
    ContextualConsentProperty["ConsentDataUnavailable"] = "CONSENT_DATA_UNAVAILABLE";
    return ContextualConsentProperty;
}({});
var $36d7d553dbfdd9f7$export$4fda8eb914d6791c = /*#__PURE__*/ function(CachedKeysDataPropertyLegacy) {
    CachedKeysDataPropertyLegacy["LocalStorage"] = "localStorageKeys";
    CachedKeysDataPropertyLegacy["SessionStorage"] = "sessionStorageKeys";
    CachedKeysDataPropertyLegacy["Cookies"] = "keys";
    CachedKeysDataPropertyLegacy["ThirdParty"] = "thirdPartyKeys";
    return CachedKeysDataPropertyLegacy;
}({});
var $36d7d553dbfdd9f7$export$5d6594a0bba4ab8a = /*#__PURE__*/ function(PrefetchedPreferenceState) {
    PrefetchedPreferenceState[PrefetchedPreferenceState["INTERNAL"] = 0] = "INTERNAL";
    return PrefetchedPreferenceState;
}({});
var $36d7d553dbfdd9f7$export$2506b012eb637f61 = /*#__PURE__*/ function(CategoryStorageType) {
    CategoryStorageType["Cookies"] = "Cookies";
    CategoryStorageType["LocalStorage"] = "LocalStorage";
    CategoryStorageType["SessionStorage"] = "SessionStorage";
    return CategoryStorageType;
}({});
var $36d7d553dbfdd9f7$export$96e9906d6d93a972 = /*#__PURE__*/ function(Status) {
    Status["SUCCESS"] = "SUCCESS";
    Status["BLOCKED"] = "BLOCKED";
    Status["FAILED"] = "FAILED";
    return Status;
}({});
var $36d7d553dbfdd9f7$export$eefdbcf75990494a = /*#__PURE__*/ function(BSC_PACKAGE_KILLSWITCHES) {
    BSC_PACKAGE_KILLSWITCHES["MASTER_KILLSWITCH"] = "platform_moonjelly_bsc_master_killswitch";
    BSC_PACKAGE_KILLSWITCHES["UI_KILLSWITCH"] = "platform_moonjelly_bsc_ui_killswitch";
    BSC_PACKAGE_KILLSWITCHES["SSR_KILLSWITCH"] = "platform_moonjelly_bsc_ssr_killswitch";
    BSC_PACKAGE_KILLSWITCHES["WEB_STORAGE_KILLSWITCH"] = "platform_moonjelly_bsc_web_storage_killswitch";
    return BSC_PACKAGE_KILLSWITCHES;
}({});

});

parcelRegister("ijunp", function(module, exports) {

$parcel$export(module.exports, "CacheLoader", () => $8f6d0a2fa14daa2d$export$e479342c697b82a9);

var $8FFpF = parcelRequire("8FFpF");

var $Dyz2r = parcelRequire("Dyz2r");

class $8f6d0a2fa14daa2d$export$e479342c697b82a9 {
    constructor(storageType){
        switch(storageType){
            case (0, $8FFpF.CategoryStorageType).Cookies:
                this.cacheUrl = (0, $84558f51b42056b1$export$ab0619f627170401);
                break;
            case (0, $8FFpF.CategoryStorageType).LocalStorage:
                this.cacheUrl = (0, $84558f51b42056b1$export$38bed9fd9923fef3);
                break;
            case (0, $8FFpF.CategoryStorageType).SessionStorage:
                this.cacheUrl = (0, $84558f51b42056b1$export$4f73a4b5fdb7ed6c);
                break;
            default:
                this.cacheUrl = (0, $84558f51b42056b1$export$194c34963e6f0bc6);
        }
    }
    clearStorageControlsDataCache() {
        this.localResponseCache = undefined;
        this.localResponsePromiseCache = undefined;
        this.localResponseJsonPromiseCache = undefined;
    }
    /**
	 * Unpacks the response promise from the categories CDN
	 *
	 * errors if that request was unsuccessful, returns the categories data otherwise
	 *
	 */ async handleCategoriesResponse(responsePromise) {
        if (!responsePromise) throw new Error(`Failed to fetch Cookies Cache! Cached promise was undefined`);
        const response = await responsePromise;
        if (!response.ok) throw new Error(`Failed to fetch Cookies Cache! status: ${response.status}`);
        // Checks if we've already fired the response.json() promise
        this.localResponseJsonPromiseCache = this.localResponseJsonPromiseCache || response?.json();
        return this.localResponseJsonPromiseCache;
    }
    async loadStorageControlsData() {
        if (this.localResponseCache) return this.localResponseCache;
        else // Always use Prod CDN for prod/local/dev/staging environments, but stub the route for automation tests
        try {
            if (!this.localResponsePromiseCache) {
                (0, $Dyz2r.Logger).debug(`Loading cache ${this.cacheUrl}`);
                // invoke CDN and cache the promise
                this.localResponsePromiseCache = fetch(this.cacheUrl);
            }
            // unpack response
            this.localResponseCache = await this.handleCategoriesResponse(this.localResponsePromiseCache);
            return this.localResponseCache;
        } catch (e) {
            (0, $Dyz2r.Logger).errorWithOperationalEvent({
                action: 'loadStorageControlsError',
                message: e.message || ''
            });
            this.clearStorageControlsDataCache();
        }
    }
}

});
parcelRegister("Dyz2r", function(module, exports) {

$parcel$export(module.exports, "Logger", () => $11d6f9521ae04599$export$efa9a398d6368992);
/* eslint-disable no-console */ 
var $VSDnB = parcelRequire("VSDnB");

var $3MsQ9 = parcelRequire("3MsQ9");

var $gMWuT = parcelRequire("gMWuT");
const $11d6f9521ae04599$var$LOG_PREFIX = '[browser-storage-controls]';
class $11d6f9521ae04599$export$efa9a398d6368992 {
    static info(message, metadata) {
        console.log(`${$11d6f9521ae04599$var$LOG_PREFIX}: ${message}`, metadata ? JSON.stringify(metadata) : '');
    }
    static error(message, metadata) {
        console.error(`${$11d6f9521ae04599$var$LOG_PREFIX}: ${message}`, metadata ? JSON.stringify(metadata) : '');
    }
    static errorWithOperationalEvent({ action: action, attributes: attributes = {}, message: message, metadata: metadata }) {
        try {
            (0, $3MsQ9.sendPackageOperationalEvent)({
                action: action,
                attributes: {
                    error: message,
                    ...attributes
                }
            });
        } catch (e) {
            this.error(`Failed to send operational event on error: ${action}. ${e.message || ''}`);
        }
        this.error(message, metadata ? JSON.stringify(metadata) : '');
    }
    static warn(message, metadata) {
        console.warn(`${$11d6f9521ae04599$var$LOG_PREFIX}: ${message}`, metadata ? JSON.stringify(metadata) : '');
    }
    /**
	 * Logger for additional debugging of the package. Debug logs are only sent when the
	 * atl-bsc-debug-mode cookie is set on the browser. This is evaluated via global state
	 */ static debug(message, metadata) {
        if ((0, $gMWuT.getBscGlobalState)().packageDebugMode && (0, $VSDnB.fg)('platform_moonjelly_bsc_debug_mode')) console.debug(`${$11d6f9521ae04599$var$LOG_PREFIX}: DEBUG ${message}`, metadata ? JSON.stringify(metadata) : '');
    }
}

});
parcelRegister("3MsQ9", function(module, exports) {

$parcel$export(module.exports, "getAnalyticsClient", () => $ab4acd6241b053c1$export$fde53e78fd93a54d);
$parcel$export(module.exports, "sendPackageOperationalEvent", () => $ab4acd6241b053c1$export$5bfe55348e7aebc1);
$parcel$export(module.exports, "sendUIEvent", () => $ab4acd6241b053c1$export$1aecf263098db667);
$parcel$export(module.exports, "sendScreenEvent", () => $ab4acd6241b053c1$export$22a3b1671f38a193);
$parcel$export(module.exports, "sendTrackEvent", () => $ab4acd6241b053c1$export$1ba525b8a711eaac);

var $buAWB = parcelRequire("buAWB");
var $iZhen = parcelRequire("iZhen");

var $gMWuT = parcelRequire("gMWuT");

var $Dyz2r = parcelRequire("Dyz2r");

var $dNWuc = parcelRequire("dNWuc");

var $cSola = parcelRequire("cSola");
const $ab4acd6241b053c1$var$getEnvironment = ()=>{
    const { hostname: hostname } = window.location;
    if (hostname.includes('.dev.') || hostname.includes('.stg.')) return (0, $iZhen.envType).STAGING;
    if (hostname.includes('localhost') || hostname.includes('ngrok') || hostname.includes('atlastunnel')) return (0, $iZhen.envType).DEV;
    return (0, $iZhen.envType).PROD;
};
const $ab4acd6241b053c1$export$78d7c0236b4fece9 = (path)=>{
    let subPath = '';
    if (!path) return subPath;
    const checkPath = (match)=>{
        return new RegExp(`^${match}(/|$)`).test(String(path));
    };
    if (checkPath('/wiki')) subPath = '/wiki';
    if (checkPath('/jira')) subPath = '/jira';
    if (checkPath('/compass')) subPath = '/compass';
    if (checkPath('/canvas')) subPath = '/canvas';
    if (checkPath('/servicedesk') || checkPath('/jira/servicedesk')) subPath = '/servicedesk';
    return subPath;
};
const $ab4acd6241b053c1$var$getProductFromDomain = (domain)=>{
    if (domain === 'https://trello.com') return 'trello';
    return null;
};
const $ab4acd6241b053c1$export$fce3dd735e04d566 = ()=>{
    const { origin: origin, pathname: pathname } = window.location;
    const productPath = $ab4acd6241b053c1$export$78d7c0236b4fece9(pathname);
    const domain = `${origin}${productPath}`;
    const product = $ab4acd6241b053c1$var$getProductFromDomain(domain) || productPath.slice(1);
    return {
        domain: domain,
        product: product
    };
};
const $ab4acd6241b053c1$var$decorateEventAttributes = (attributes)=>{
    const { domain: domain, product: product } = $ab4acd6241b053c1$export$fce3dd735e04d566();
    return {
        packageName: $dNWuc.packageName,
        packageVersion: $dNWuc.packageVersion,
        domain: domain,
        product: (0, $gMWuT.getBscGlobalState)().product?.toLowerCase() ?? product,
        ...attributes && attributes
    };
};
const $ab4acd6241b053c1$export$fde53e78fd93a54d = (()=>{
    let instance;
    return ()=>{
        try {
            if (!instance && (0, $gMWuT.getBscGlobalState)().analyticsEnabled) instance = new (0, $buAWB.default)({
                env: $ab4acd6241b053c1$var$getEnvironment(),
                product: 'atlassianCookies'
            }, {
                // useLegacyUrl tells the analytics client to make calls directly to Global Analytics Service.
                // When set to false, the client will use a stargate proxy for the current URL to send events
                // to GAS. Said another way:
                // true => events are sent to https://api-private.stg.atlassian.com/gasv3/api/v1/batch
                // false => events are sent to <the current domain>/gasv3/api/v1/batch
                //
                // By default, this should be set to false.  If you need to validate that analytics events
                // are being transmitted correctly in local dev, you can temporarily enable it since localhost
                // won't be able to proxy to GAS via stargate.
                useLegacyUrl: false,
                disableCookiePersistence: true
            });
        } catch (e) {
            // Log  errors thrown in constructor initialization for the AnalyticsWebClient
            (0, $Dyz2r.Logger).error(`Failed to initialize AnalyticsWebClient. ${e}`);
        }
        if (!(0, $gMWuT.getBscGlobalState)().analyticsEnabled) return undefined;
        // Return the instance, even if it is undefined
        return instance;
    };
})();
function $ab4acd6241b053c1$export$5bfe55348e7aebc1(properties) {
    (0, $cSola.withAnalyticsEventSampling)(properties.action, ()=>$ab4acd6241b053c1$export$fde53e78fd93a54d()?.sendOperationalEvent({
            source: 'package',
            actionSubject: 'package',
            action: properties.action,
            attributes: $ab4acd6241b053c1$var$decorateEventAttributes(properties.attributes)
        }));
}
function $ab4acd6241b053c1$export$1aecf263098db667(properties) {
    $ab4acd6241b053c1$export$fde53e78fd93a54d()?.sendUIEvent({
        ...properties,
        attributes: $ab4acd6241b053c1$var$decorateEventAttributes(properties.attributes)
    });
}
function $ab4acd6241b053c1$export$22a3b1671f38a193(properties) {
    $ab4acd6241b053c1$export$fde53e78fd93a54d()?.sendScreenEvent({
        ...properties,
        attributes: $ab4acd6241b053c1$var$decorateEventAttributes(properties.attributes)
    });
}
function $ab4acd6241b053c1$export$1ba525b8a711eaac(properties) {
    $ab4acd6241b053c1$export$fde53e78fd93a54d()?.sendTrackEvent({
        ...properties,
        attributes: $ab4acd6241b053c1$var$decorateEventAttributes(properties.attributes)
    });
}

});
parcelRegister("dNWuc", function(module, exports) {

$parcel$export(module.exports, "packageName", () => $c97fd3879a87db8b$export$9345d7360ffe0722);
$parcel$export(module.exports, "packageVersion", () => $c97fd3879a87db8b$export$91546b032799aa40);

var $6cAn5 = parcelRequire("6cAn5");
const $c97fd3879a87db8b$export$9345d7360ffe0722 = $6cAn5?.env._PACKAGE_NAME_ ?? '';
const $c97fd3879a87db8b$export$91546b032799aa40 = $6cAn5?.env._PACKAGE_VERSION_ ?? '';

});

parcelRegister("cSola", function(module, exports) {

$parcel$export(module.exports, "withAnalyticsEventSampling", () => $8a7d44aac8b41a46$export$67b6e87f323cb6ad);

var $8FFpF = parcelRequire("8FFpF");

var $gMWuT = parcelRequire("gMWuT");

var $lYuNP = parcelRequire("lYuNP");

var $ljmYJ = parcelRequire("ljmYJ");
const $8a7d44aac8b41a46$export$1138592b3c099377 = {
    usedGetCookie: 100000,
    usedGetCookieError: 1,
    usedSetCookie: 1000,
    usedSetCookieError: 1,
    usedSetStrictlyNecessaryCookie: 10000,
    usedSetStrictlyNecessaryCookieError: 1,
    usedDeleteCookie: 10,
    usedDeleteCookieError: 1,
    usedCheckThirdParty: 100000,
    checkThirdPartyError: 1,
    usedDocumentCookie: 100,
    usedDocumentCookieError: 1,
    initializeControlsError: 1,
    loadStorageControlsError: 1,
    updatePreferencesError: 1,
    fetchConsentPreferencesError: 1,
    saveConsentPreferencesError: 1,
    usedAtlBrowserStorageGetItem: 100,
    usedAtlBrowserStorageGetItemError: 1,
    usedAtlBrowserStorageSetItem: 100,
    usedAtlBrowserStorageSetItemError: 1,
    usedAtlBrowserStorageSetStrictlyNecessaryItem: 100,
    usedAtlBrowserStorageSetStrictlyNecessaryItemError: 1,
    usedCheckIfSetByPackageError: 1,
    renderConsentBannerError: 1,
    bannerAppearanceAfterDismissal: 1
};
// This short-circuits finding a sampling ratio from the remote config. Useful for things like
// `loadStorageControlsError` which itself tries to log an event on error, causing an infinite
// recursion as each lookup fails, logging another event, etc.
const $8a7d44aac8b41a46$var$localOnlySamplingKeys = [
    'loadStorageControlsError'
];
async function $8a7d44aac8b41a46$var$loadSamplingConfig() {
    if ((0, $lYuNP.cache).cachedSamplingConfig) return (0, $lYuNP.cache).cachedSamplingConfig;
    if ((0, $ljmYJ.isSSR)()) return undefined;
    const { loadCache: loadCache } = (0, $gMWuT.getBscGlobalState)();
    const controlsData = await loadCache((0, $8FFpF.CategoryStorageType).Cookies);
    const analyticsSamplingRatioConfigs = controlsData?.analyticsSamplingRatio;
    (0, $lYuNP.cache).cachedSamplingConfig = analyticsSamplingRatioConfigs;
    return analyticsSamplingRatioConfigs;
}
async function $8a7d44aac8b41a46$export$b286f5e8716d11ad(analyticsEventKey) {
    if ($8a7d44aac8b41a46$var$localOnlySamplingKeys.includes(analyticsEventKey)) return $8a7d44aac8b41a46$export$1138592b3c099377[analyticsEventKey];
    const remoteSamplingConfig = await $8a7d44aac8b41a46$var$loadSamplingConfig();
    const samplingConfig = remoteSamplingConfig ?? $8a7d44aac8b41a46$export$1138592b3c099377;
    const samplingRatio = samplingConfig?.[analyticsEventKey] !== undefined ? samplingConfig[analyticsEventKey] : $8a7d44aac8b41a46$export$1138592b3c099377[analyticsEventKey];
    return samplingRatio;
}
function $8a7d44aac8b41a46$export$dc2f0946255b3f89(samplingRatio, cb) {
    /* Only run if rolling the samplingRatio-sized die lands on a 0
       ________
      /\       \
     /()\   ()  \
    /    \_______\
    \    /()     /
     \()/   ()  /
      \/_____()/
  */ const shouldRun = !Math.floor(Math.random() * samplingRatio);
    shouldRun && cb();
}
async function $8a7d44aac8b41a46$export$67b6e87f323cb6ad(analyticsEventKey, cb) {
    const ratio = await $8a7d44aac8b41a46$export$b286f5e8716d11ad(analyticsEventKey);
    $8a7d44aac8b41a46$export$dc2f0946255b3f89(ratio, cb);
}

});
parcelRegister("lYuNP", function(module, exports) {

$parcel$export(module.exports, "cache", () => $8cd0e183ff7dc01a$export$69a3209f1a06c04d);

var $3HP97 = parcelRequire("3HP97");
const $8cd0e183ff7dc01a$export$69a3209f1a06c04d = new (0, $3HP97.CachedSamplingConfig)();

});
parcelRegister("3HP97", function(module, exports) {

$parcel$export(module.exports, "CachedSamplingConfig", () => $44a8c306b7f02367$export$b886edaf6623554a);
class $44a8c306b7f02367$export$b886edaf6623554a {
    get cachedSamplingConfig() {
        return this.cache;
    }
    set cachedSamplingConfig(value) {
        this.cache = value;
    }
}

});


parcelRegister("ljmYJ", function(module, exports) {

$parcel$export(module.exports, "isSSR", () => $5603064d730f5120$export$48d7c418edadb60c);

var $buAWB = parcelRequire("buAWB");

var $VSDnB = parcelRequire("VSDnB");

var $Dyz2r = parcelRequire("Dyz2r");
const $5603064d730f5120$export$48d7c418edadb60c = ()=>{
    const isMissingNecessaryBrowserUtils = typeof document === 'undefined' || typeof window === 'undefined' || !Document || !Document.prototype || !Object || !Object.defineProperty;
    const isMissingBooleanFF = !(0, $VSDnB.fg);
    const isMissingAnalyticsWebClient = !Boolean((0, $buAWB.default));
    // When rendering from the server document/window may not be available
    if (isMissingNecessaryBrowserUtils) (0, $Dyz2r.Logger).warn('Browser context is not available.');
    if (isMissingBooleanFF) (0, $Dyz2r.Logger).warn('Platform Feature Flag library is not available');
    if (!(0, $buAWB.default)) (0, $Dyz2r.Logger).warn('analytics-web-client is not available');
    if (isMissingNecessaryBrowserUtils || isMissingBooleanFF || isMissingAnalyticsWebClient) return true;
    else return false;
};

});




const $84558f51b42056b1$export$194c34963e6f0bc6 = 'https://atlassian-cookies--categories.us-east-1.prod.public.atl-paas.net/categories.json';
const $84558f51b42056b1$export$ab0619f627170401 = 'https://atlassian-cookies--categories.us-east-1.prod.public.atl-paas.net/categories_COOKIE.json';
const $84558f51b42056b1$export$38bed9fd9923fef3 = 'https://atlassian-cookies--categories.us-east-1.prod.public.atl-paas.net/categories_LOCAL_STORAGE.json';
const $84558f51b42056b1$export$4f73a4b5fdb7ed6c = 'https://atlassian-cookies--categories.us-east-1.prod.public.atl-paas.net/categories_SESSION_STORAGE.json';



parcelRegister("3uyrZ", function(module, exports) {

$parcel$export(module.exports, "BSCIndexedDB", () => $dcdcaa8b6a3e20dd$export$36328b3bcbe4623a);

var $ljmYJ = parcelRequire("ljmYJ");

var $Dyz2r = parcelRequire("Dyz2r");
class $dcdcaa8b6a3e20dd$export$fde2a4e0e57f47e {
    constructor(dbName, storeName){
        this.db = null;
        this.isBooted = false;
        this.isAvailable = false;
        this.onConnectionErrorHandler = (reject)=>(event)=>{
                (0, $Dyz2r.Logger).warn('Error opening database.');
                reject(event);
            };
        this.onConnectionSuccessHandler = (connection, resolve)=>()=>{
                this.db = connection.result;
                resolve();
            };
        this.onConnectionUpgradeNeededHandler = (request)=>()=>{
                this.db = request.result;
                this.db.createObjectStore(this.storeName, {
                    keyPath: 'id'
                });
            };
        this.onGetRecordErrorHandler = (reject)=>()=>{
                const getErrorMessage = `Failed to perform a get transaction on IndexedDB: ${this.dbName} + ${this.storeName}`;
                (0, $Dyz2r.Logger).warn(getErrorMessage);
                reject(getErrorMessage);
            };
        this.onGetRecordSuccessHandler = (getRequest, resolve)=>()=>{
                resolve(getRequest.result);
            };
        this.onSetRecordErrorHandler = (reject)=>()=>{
                const errorMessage = `Failed to perform a set transaction on IndexedDB: ${this.dbName} + ${this.storeName}`;
                (0, $Dyz2r.Logger).warn(errorMessage);
                reject(errorMessage);
            };
        this.onSetRecordSuccessHandler = (resolve)=>()=>{
                resolve();
            };
        this.dbName = dbName;
        this.storeName = storeName;
        this.isAvailable = this.getIsDBAvailable();
        this.isBooted = false;
        this.bootUpPromiseCache = null;
    }
    async boot() {
        if (!this.isAvailable) {
            (0, $Dyz2r.Logger).warn('IndexedDB is not available');
            return;
        }
        if (this.isBooted) // Short circuit if we've already booted once
        return;
        // Only boot once, even if we've been called numerous times sequentially
        if (!this.bootUpPromiseCache) {
            this.bootUpPromiseCache = this.openDB();
            try {
                await this.bootUpPromiseCache;
                this.isBooted = true;
            } catch (e) {
                this.isBooted = false;
                (0, $Dyz2r.Logger).warn('Error booting up IndexedDB.');
                throw e;
            }
        }
    }
    getIsDBAvailable() {
        return !(0, $ljmYJ.isSSR)() && !!window.indexedDB;
    }
    async openDB() {
        return new Promise((resolve, reject)=>{
            let request = indexedDB.open(this.dbName, 2);
            request.onerror = this.onConnectionErrorHandler(reject);
            request.onsuccess = this.onConnectionSuccessHandler(request, resolve);
            request.onupgradeneeded = this.onConnectionUpgradeNeededHandler(request);
        });
    }
    async getRecord(recordKey) {
        try {
            if (!this.isBooted) await this.boot();
            if (!this.db) throw new Error('Database is not opened');
            let fetchTransaction = this.db.transaction([
                this.storeName
            ]);
            let recordStore = fetchTransaction.objectStore(this.storeName);
            const fetchedRecord = new Promise((resolve, reject)=>{
                let request = recordStore.get(recordKey);
                request.onerror = this.onGetRecordErrorHandler(reject);
                request.onsuccess = this.onGetRecordSuccessHandler(request, resolve);
            });
            return fetchedRecord;
        } catch (e) {
            (0, $Dyz2r.Logger).error(`Error fetching record from database. ${e.message || ''}`);
            throw e;
        }
    }
    async setRecord(recordKey) {
        try {
            if (!this.isBooted) await this.boot();
            if (!this.db) throw new Error('Database is not opened');
            const setRecord = new Promise((resolve, reject)=>{
                let setTransaction = this.db.transaction([
                    this.storeName
                ], 'readwrite');
                let objectStore = setTransaction.objectStore(this.storeName);
                const newAtlRecord = {
                    atlSetItem: 'SET-BY-PACKAGE',
                    id: recordKey
                };
                let request = objectStore.put(newAtlRecord);
                request.onerror = this.onSetRecordErrorHandler(reject);
                request.onsuccess = this.onSetRecordSuccessHandler(resolve);
            });
            return setRecord;
        } catch (e) {
            (0, $Dyz2r.Logger).warn(`Error setting record in database. ${e.message || ''}`);
            throw e;
        }
    }
}
const $dcdcaa8b6a3e20dd$export$36328b3bcbe4623a = new $dcdcaa8b6a3e20dd$export$fde2a4e0e57f47e('BSCIndexedDB', 'InternalStorageKeys');

});

parcelRegister("3iwZ5", function(module, exports) {

$parcel$export(module.exports, "WebStorageType", () => $18b68d89ab611c47$export$259e3a861f28589b);
var $18b68d89ab611c47$export$259e3a861f28589b = /*#__PURE__*/ function(WebStorageType) {
    WebStorageType["LocalStorage"] = "LocalStorage";
    WebStorageType["SessionStorage"] = "SessionStorage";
    return WebStorageType;
}({});

});

parcelRegister("3KKvX", function(module, exports) {

$parcel$export(module.exports, "getStorageItem", () => $623537d2033163f5$export$e612bb1301d659de);

var $3MsQ9 = parcelRequire("3MsQ9");

var $Dyz2r = parcelRequire("Dyz2r");
const $623537d2033163f5$export$e612bb1301d659de = (itemKey, storageType, browserStorage)=>{
    const eventAttributes = {
        itemKey: itemKey,
        storageType: storageType
    };
    try {
        (0, $3MsQ9.sendPackageOperationalEvent)({
            action: 'usedAtlBrowserStorageGetItem',
            attributes: eventAttributes
        });
        return browserStorage.getItem(itemKey);
    } catch (e) {
        (0, $Dyz2r.Logger).errorWithOperationalEvent({
            action: 'usedAtlBrowserStorageGetItemError',
            attributes: eventAttributes,
            message: `Failed to get ${storageType} item. ${e.message || ''}`
        });
        return null;
    }
};

});

parcelRegister("3jvQx", function(module, exports) {

$parcel$export(module.exports, "setStorageItem", () => $772d1d6fa1013d33$export$5ee8760f703d9d62);

var $3MsQ9 = parcelRequire("3MsQ9");

var $giZBC = parcelRequire("giZBC");

var $Dyz2r = parcelRequire("Dyz2r");

var $3uyrZ = parcelRequire("3uyrZ");

var $8FFpF = parcelRequire("8FFpF");

var $3iwZ5 = parcelRequire("3iwZ5");
const $772d1d6fa1013d33$export$5ee8760f703d9d62 = async (itemKey, value, storageType, productName, browserStorage)=>{
    // user belongs to an org that opted into cookies management and we should respect their preferences
    // Flag enabled, user belongs to an org that opted into cookies management and we should respect their preferences
    const shouldSetItem = await (0, $giZBC.isProcessingAllowedByPreferences)({
        itemKey: itemKey,
        storageType: storageType === (0, $3iwZ5.WebStorageType).LocalStorage ? (0, $8FFpF.CategoryStorageType).LocalStorage : (0, $8FFpF.CategoryStorageType).SessionStorage,
        productName: productName
    });
    const eventAttributes = {
        wasRejected: !shouldSetItem,
        itemKey: itemKey,
        storageType: storageType
    };
    try {
        (0, $3MsQ9.sendPackageOperationalEvent)({
            action: 'usedAtlBrowserStorageSetItem',
            attributes: eventAttributes
        });
        if (shouldSetItem) {
            // Store the item as a record in our IDB service to track that we've seen it before.
            // That way, when we can confirm/deny that this has been set by our service when we check again.
            // If it fails for some reason, it will be caught before actually setting the item
            await (0, $3uyrZ.BSCIndexedDB).setRecord(itemKey);
            browserStorage.setItem(itemKey, value);
            return (0, $8FFpF.Status).SUCCESS;
        } else return (0, $8FFpF.Status).BLOCKED;
    } catch (e) {
        (0, $Dyz2r.Logger).errorWithOperationalEvent({
            action: 'usedAtlBrowserStorageSetItemError',
            attributes: eventAttributes,
            message: `Failed to set ${storageType} item. ${e.message || ''}`
        });
        return (0, $8FFpF.Status).BLOCKED;
    }
};

});
parcelRegister("giZBC", function(module, exports) {

$parcel$export(module.exports, "isProcessingAllowedByPreferences", () => $c95606615c03285c$export$e7a3dca206fec6e2);
// eslint-disable-next-line @atlassian/tangerine/import/no-restricted-paths

var $waH4c = parcelRequire("waH4c");

var $8FFpF = parcelRequire("8FFpF");

var $gMWuT = parcelRequire("gMWuT");
const $c95606615c03285c$export$2c141b1c00f3e482 = (itemKey, startsWith)=>{
    // Setup initial pattern step and position
    let currentStep = startsWith;
    let position = 0;
    // Iterate through item key symbol by symbol
    while(position < itemKey.length){
        // The value of item character at the position
        const currentStepValue = currentStep[itemKey[position]];
        // If there is no match for item symbol in cache, this means there is no
        // pattern match for the item key
        if (currentStepValue === undefined) return null;
        // If current step value is a number, this means we reached the end of the pattern
        // and should return category number
        if (typeof currentStepValue === 'number') return currentStepValue;
        // Continue to going through pattern
        currentStep = currentStepValue;
        position++;
    }
    // No pattern match - all patterns longer or shorter than item key
    return null;
};
const $c95606615c03285c$export$c4a1dd71bbd8954c = (itemKey, endsWith)=>{
    // Return category number if str is found in the trie, otherwise return undefined
    const trieSearch = (str)=>{
        let currentStep = endsWith;
        let foundString = '';
        let terminalNumber;
        for(let i = 0; i < str.length; i++){
            const char = str[i];
            currentStep = currentStep[char];
            if (currentStep === undefined) break;
            foundString += char;
            if (typeof currentStep === 'number') {
                terminalNumber = currentStep;
                break;
            }
        }
        if (foundString === str) // Trie contained the complete string
        return terminalNumber;
        else // Trie did not contain the complete string
        return undefined;
    };
    let position = 0;
    // Iterate through item key symbol by symbol
    while(position < itemKey.length){
        const remainderMatch = trieSearch(itemKey.slice(position));
        if (remainderMatch !== undefined) return remainderMatch;
        position++;
    }
    return null;
};
const $c95606615c03285c$export$69d5b68d01f4a366 = (itemKey, storageControlsData, productName)=>{
    const downcasedProduct = productName?.toLowerCase();
    let itemCategoryNumber = null;
    const { categories: categories, patterns: patterns } = storageControlsData;
    let productKeys = {
        ...storageControlsData['keys']['all'],
        ...downcasedProduct ? storageControlsData['keys'][downcasedProduct] : {}
    };
    const productStartsWithPatterns = {
        ...patterns.startsWith['all'],
        ...downcasedProduct ? patterns.startsWith[downcasedProduct] : {}
    };
    const productEndsWithPatterns = {
        ...patterns.endsWith['all'],
        ...downcasedProduct ? patterns.endsWith[downcasedProduct] : {}
    };
    // Find direct match in keys
    if (Object.keys(productKeys).includes(itemKey)) itemCategoryNumber = productKeys[itemKey];
    else {
        // Find pattern match or null
        itemCategoryNumber = $c95606615c03285c$export$2c141b1c00f3e482(itemKey, productStartsWithPatterns);
        if (itemCategoryNumber === null) itemCategoryNumber = $c95606615c03285c$export$c4a1dd71bbd8954c(itemKey, productEndsWithPatterns);
    }
    const numToCategoryMap = {
        [categories.STRICTLY_NECESSARY]: (0, $8FFpF.PreferenceCategory).StrictlyNecessary,
        [categories.FUNCTIONAL]: (0, $8FFpF.PreferenceCategory).Functional,
        [categories.ANALYTICS]: (0, $8FFpF.PreferenceCategory).Analytics,
        [categories.MARKETING]: (0, $8FFpF.PreferenceCategory).Marketing,
        [categories.UNKNOWN]: (0, $8FFpF.PreferenceCategory).Unknown
    };
    return itemCategoryNumber !== null ? numToCategoryMap[itemCategoryNumber] : null;
};
const $c95606615c03285c$export$ec8ce5237293e4a4 = async (itemKey, storageType, productName)=>{
    const storageControlsData = await (0, $gMWuT.getBscGlobalState)().loadCache(storageType);
    if (!storageControlsData) return null;
    else return $c95606615c03285c$export$69d5b68d01f4a366(itemKey, storageControlsData, productName);
};
const $c95606615c03285c$export$e7a3dca206fec6e2 = async ({ itemKey: itemKey, allowedCallback: allowedCallback = ()=>{}, blockedCallback: blockedCallback = ()=>{}, storageType: storageType, productName: productName })=>{
    let shouldProcessItem;
    const itemCategory = await $c95606615c03285c$export$ec8ce5237293e4a4(itemKey, storageType, productName);
    if (itemCategory === (0, $8FFpF.PreferenceCategory).StrictlyNecessary) shouldProcessItem = true;
    else {
        const preferences = await (0, $waH4c.getPreferences)();
        let hasPreferencesForCategory = false;
        if (!!preferences) {
            if (!!itemCategory) hasPreferencesForCategory = preferences[itemCategory];
        }
        shouldProcessItem = hasPreferencesForCategory;
    }
    if (shouldProcessItem) allowedCallback?.();
    else blockedCallback?.({
        itemHasCategory: itemCategory != null
    });
    return shouldProcessItem;
};

});
parcelRegister("waH4c", function(module, exports) {

$parcel$export(module.exports, "getPreferences", () => $8c176073ed5e2709$export$1de6a888ae076ff8);

var $gMWuT = parcelRequire("gMWuT");
var $ljmYJ = parcelRequire("ljmYJ");

var $21KEY = parcelRequire("21KEY");

var $jgJYT = parcelRequire("jgJYT");

var $4uHy1 = parcelRequire("4uHy1");

var $gHrGQ = parcelRequire("gHrGQ");
async function $8c176073ed5e2709$export$1de6a888ae076ff8() {
    // when localConsentMode is on, don't make calls to ConsentHub
    if ((0, $gMWuT.getBscGlobalState)().localConsentMode) {
        const packedPrefs = (0, $4uHy1.getCookie)((0, $21KEY.LEGACY_ATLASSIAN_GDPR_COOKIE_KEY));
        if (!packedPrefs) return undefined;
        return (0, $gHrGQ.unpackUserPreferencesCookie)(packedPrefs);
    } else {
        let packedLocalPrefs = (0, $4uHy1.getCookie)((0, $21KEY.ATLASSIAN_CONSENT_COOKIE_KEY));
        if (!packedLocalPrefs) {
            const consentToken = await (0, $jgJYT.getConsentToken)();
            if ((0, $ljmYJ.isSSR)() && consentToken) window.__COOKIE_CONSENT_PREFERENCES__ = Object.assign(window.__COOKIE_CONSENT_PREFERENCES__ || {}, {
                consentToken: consentToken
            });
            return consentToken ? (0, $gHrGQ.unpackUserPreferencesCookie)(consentToken) : undefined;
        }
        return (0, $gHrGQ.unpackUserPreferencesCookie)(packedLocalPrefs);
    }
}

});
parcelRegister("21KEY", function(module, exports) {

$parcel$export(module.exports, "LEGACY_ATLASSIAN_GDPR_COOKIE_KEY", () => $ef0dec1a357b404c$export$10d7db8e1a856fd8);
$parcel$export(module.exports, "ATLASSIAN_CONSENT_COOKIE_KEY", () => $ef0dec1a357b404c$export$435de28e5b000487);
$parcel$export(module.exports, "ATLASSIAN_SHOW_BANNER_COOKIE_KEY", () => $ef0dec1a357b404c$export$4b17acc0e875ba2a);
$parcel$export(module.exports, "ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY", () => $ef0dec1a357b404c$export$23a1e02c3c0b0d08);
$parcel$export(module.exports, "TESTING_TOKEN_OVERRIDE_COOKIE_KEY", () => $ef0dec1a357b404c$export$37073d560ecebada);
$parcel$export(module.exports, "ATLASSIAN_BANNER_LAST_DISMISSED_TIME_COOKIE_KEY", () => $ef0dec1a357b404c$export$5dc0026db06844f3);
$parcel$export(module.exports, "ACCEPT_ALL_PREFERENCES", () => $ef0dec1a357b404c$export$b28b5d760fe14a21);
$parcel$export(module.exports, "ONLY_NECESSARY_PREFERENCES", () => $ef0dec1a357b404c$export$4a12f9e99971760a);
$parcel$export(module.exports, "DEFAULT_PREFERENCES", () => $ef0dec1a357b404c$export$f0fd1d13ec1d48f2);
$parcel$export(module.exports, "V001_SCHEMA_KEY", () => $ef0dec1a357b404c$export$f95182b7aa141c57);
$parcel$export(module.exports, "V002_SCHEMA_KEY", () => $ef0dec1a357b404c$export$1f25427b34f9c405);
$parcel$export(module.exports, "V003_SCHEMA_KEY", () => $ef0dec1a357b404c$export$31deaeaebce525bb);

var $8FFpF = parcelRequire("8FFpF");
const $ef0dec1a357b404c$export$10d7db8e1a856fd8 = 'atl-gdpr-consent';
const $ef0dec1a357b404c$export$435de28e5b000487 = 'atl-bsc-consent-token';
const $ef0dec1a357b404c$export$4b17acc0e875ba2a = 'atl-bsc-show-banner';
const $ef0dec1a357b404c$export$f57af01b64fc97b8 = 'atl-bsc-current-locale';
const $ef0dec1a357b404c$export$23a1e02c3c0b0d08 = 'atl-bsc-consent-token-fallback';
const $ef0dec1a357b404c$export$37073d560ecebada = 'atl-testing-consents';
const $ef0dec1a357b404c$export$5dc0026db06844f3 = 'atl-bsc-banner-dismissed-time';
const $ef0dec1a357b404c$export$b28b5d760fe14a21 = {
    [(0, $8FFpF.PreferenceCategory).StrictlyNecessary]: true,
    [(0, $8FFpF.PreferenceCategory).Functional]: true,
    [(0, $8FFpF.PreferenceCategory).Marketing]: true,
    [(0, $8FFpF.PreferenceCategory).Analytics]: true,
    [(0, $8FFpF.PreferenceCategory).Unknown]: true
};
const $ef0dec1a357b404c$export$4a12f9e99971760a = {
    [(0, $8FFpF.PreferenceCategory).StrictlyNecessary]: true,
    [(0, $8FFpF.PreferenceCategory).Functional]: false,
    [(0, $8FFpF.PreferenceCategory).Marketing]: false,
    [(0, $8FFpF.PreferenceCategory).Analytics]: false,
    [(0, $8FFpF.PreferenceCategory).Unknown]: false
};
const $ef0dec1a357b404c$export$f0fd1d13ec1d48f2 = {
    ...$ef0dec1a357b404c$export$4a12f9e99971760a,
    [(0, $8FFpF.ContextualConsentProperty).ConsentsAreDefault]: true,
    [(0, $8FFpF.ContextualConsentProperty).UserIsAuthenticated]: false,
    [(0, $8FFpF.ContextualConsentProperty).ConsentDataUnavailable]: true
};
const $ef0dec1a357b404c$export$f95182b7aa141c57 = '001';
const $ef0dec1a357b404c$export$1f25427b34f9c405 = '002';
const $ef0dec1a357b404c$export$31deaeaebce525bb = '003';

});

parcelRegister("jgJYT", function(module, exports) {

$parcel$export(module.exports, "getConsentToken", () => $cec0aa330286c26c$export$f1b8f2ca713fca08);

var $21KEY = parcelRequire("21KEY");

var $4uHy1 = parcelRequire("4uHy1");

var $j60lH = parcelRequire("j60lH");

var $2BKtx = parcelRequire("2BKtx");

var $9C321 = parcelRequire("9C321");
const $cec0aa330286c26c$export$f1b8f2ca713fca08 = async ()=>{
    const fallbackConsentToken = (0, $4uHy1.getCookie)((0, $21KEY.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
    const consentData = await (0, $9C321.getValidConsentData)(fallbackConsentToken);
    if (consentData) {
        const { consentToken: consentToken, consentTimestamp: consentTimestamp } = consentData;
        /*** TESTING OVERRIDES ***/ const potentiallyOverriddenConsentToken = (0, $j60lH.overrideConsentTokenForLiveTesting)(consentToken);
        const testingConsentOverride = (0, $4uHy1.getCookie)((0, $21KEY.TESTING_TOKEN_OVERRIDE_COOKIE_KEY));
        const hasTestingConsents = !!(testingConsentOverride || testingConsentOverride === '');
        if (hasTestingConsents) {
            // If testing, set the cookies accordingly so we can test with any overridden token data.
            (0, $2BKtx.setShouldShowBannerCookie)(potentiallyOverriddenConsentToken);
            (0, $2BKtx.setConsentTokenCookie)(potentiallyOverriddenConsentToken);
            // Unfortunately, if you've previously saved to ConsentHub, that data will always resolve, so to simulate ConsentHub
            // being down, or the token data being bunk/invalid, we must set the testing token to an empty string. This will
            // return undefined here and skip any unpacking of the token. Otherwise, it will use the overridden token value.
            return potentiallyOverriddenConsentToken === '' ? undefined : potentiallyOverriddenConsentToken;
        }
        // At this point, all data should be valid and overridden for testing as needed, so set those cookies!
        (0, $2BKtx.setRequiredConsentCookies)(potentiallyOverriddenConsentToken, consentTimestamp);
        return consentToken;
    }
    return undefined;
};

});
parcelRegister("4uHy1", function(module, exports) {

$parcel$export(module.exports, "getCookie", () => $558963795707b831$export$4be65e66cfa2648a);

var $eYli8 = parcelRequire("eYli8");

var $VSDnB = parcelRequire("VSDnB");

var $3MsQ9 = parcelRequire("3MsQ9");

var $Dyz2r = parcelRequire("Dyz2r");
function $558963795707b831$export$4be65e66cfa2648a(key) {
    if ((0, $VSDnB.fg)('platform_moonjelly_bsc_master_killswitch')) // Get the cookie without package operational events
    // when master killswitch is enabled
    return key ? (0, (/*@__PURE__*/$parcel$interopDefault($eYli8))).get(key) : (0, (/*@__PURE__*/$parcel$interopDefault($eYli8))).get();
    try {
        (0, $3MsQ9.sendPackageOperationalEvent)({
            action: 'usedGetCookie',
            attributes: {
                cookieKey: key
            }
        });
        return key ? (0, (/*@__PURE__*/$parcel$interopDefault($eYli8))).get(key) : (0, (/*@__PURE__*/$parcel$interopDefault($eYli8))).get();
    } catch (e) {
        (0, $Dyz2r.Logger).errorWithOperationalEvent({
            action: 'usedGetCookieError',
            attributes: {
                cookieKey: key
            },
            message: `Failed to use get cookie. ${e.message || ''}`
        });
    }
}

});

parcelRegister("j60lH", function(module, exports) {

$parcel$export(module.exports, "overrideConsentTokenForLiveTesting", () => $e9046a37be8b2859$export$b5282052fc15e1ae);

var $21KEY = parcelRequire("21KEY");

var $4uHy1 = parcelRequire("4uHy1");
const $e9046a37be8b2859$export$b5282052fc15e1ae = (genuineConsentToken)=>{
    // The existence of this cookie will make it look like fetched ConsentHub data is missing
    // You can set it to undefined yourself/empty string, or an actual default value.
    const tokenOverride = (0, $4uHy1.getCookie)((0, $21KEY.TESTING_TOKEN_OVERRIDE_COOKIE_KEY));
    // Note: Clear this cookie out of your browser when you're done testing empty data sets
    // Or you'll be stuck seeing the banner and never actually consenting on the UI
    return tokenOverride || genuineConsentToken;
};

});

parcelRegister("2BKtx", function(module, exports) {

$parcel$export(module.exports, "setConsentTokenCookie", () => $12571e54e3352b77$export$8e560d0760f733a2);
$parcel$export(module.exports, "setConsentTokenFallbackCookie", () => $12571e54e3352b77$export$133cd762b0f705a2);
$parcel$export(module.exports, "setShouldShowBannerCookie", () => $12571e54e3352b77$export$99ecece88c58d938);
$parcel$export(module.exports, "setRequiredConsentCookies", () => $12571e54e3352b77$export$b3365240280cb3c3);

var $fp1RH = parcelRequire("fp1RH");
var $Dyz2r = parcelRequire("Dyz2r");

var $21KEY = parcelRequire("21KEY");

var $bKAlw = parcelRequire("bKAlw");

var $7RRGT = parcelRequire("7RRGT");
const $12571e54e3352b77$export$8e560d0760f733a2 = (consentToken)=>{
    const inTenMinutes = new Date();
    inTenMinutes.setTime(inTenMinutes.getTime() + 600000);
    (0, $7RRGT.setStrictlyNecessaryCookie)((0, $21KEY.ATLASSIAN_CONSENT_COOKIE_KEY), consentToken, {
        expires: inTenMinutes,
        path: '/'
    });
    (0, $Dyz2r.Logger).debug(`Set Consent Token ${(0, $21KEY.ATLASSIAN_CONSENT_COOKIE_KEY)} ${consentToken}`);
};
const $12571e54e3352b77$export$133cd762b0f705a2 = (consentToken)=>{
    const inOneYear = new Date();
    inOneYear.setFullYear(inOneYear.getFullYear() + 1);
    (0, $7RRGT.setStrictlyNecessaryCookie)((0, $21KEY.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY), consentToken, {
        expires: inOneYear,
        path: '/'
    });
    (0, $Dyz2r.Logger).debug(`set fallback consent token: ${(0, $21KEY.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY)} ${consentToken}`);
};
const $12571e54e3352b77$export$99ecece88c58d938 = (consentToken, consentTimestamp)=>{
    // Since we have no good way to reference this as a global state object, we want to precompute and store the
    // banner visibility in a temporary, session-scope cookie (same expiry as the other cookies), which we can
    // lookup in the UI as needed
    const bannerVisibility = (0, $bKAlw.getBannerVisibility)({
        consentToken: consentToken,
        consentTimestamp: consentTimestamp
    });
    const shouldShowBanner = (0, $fp1RH.getBitValueFromBool)(!!bannerVisibility);
    const inTenMinutes = new Date();
    inTenMinutes.setTime(inTenMinutes.getTime() + 600000);
    (0, $7RRGT.setStrictlyNecessaryCookie)((0, $21KEY.ATLASSIAN_SHOW_BANNER_COOKIE_KEY), shouldShowBanner, {
        expires: inTenMinutes,
        path: '/'
    });
    (0, $Dyz2r.Logger).debug(`set shouldShowBannerCookie: ${(0, $21KEY.ATLASSIAN_SHOW_BANNER_COOKIE_KEY)} ${shouldShowBanner}`);
};
const $12571e54e3352b77$export$b3365240280cb3c3 = (consentToken, consentTimestamps)=>{
    $12571e54e3352b77$export$8e560d0760f733a2(consentToken);
    $12571e54e3352b77$export$99ecece88c58d938(consentToken, consentTimestamps);
};

});
parcelRegister("fp1RH", function(module, exports) {

$parcel$export(module.exports, "getBitValueFromBool", () => $ef15319bdc068a40$export$929f1500428a1fc8);
$parcel$export(module.exports, "getBoolFromBitValue", () => $ef15319bdc068a40$export$27647458f3cf29d2);
const $ef15319bdc068a40$export$929f1500428a1fc8 = (value)=>{
    return Number(value).toString();
};
const $ef15319bdc068a40$export$27647458f3cf29d2 = (bitValue)=>{
    if (bitValue) return !!Number(bitValue);
};

});

parcelRegister("bKAlw", function(module, exports) {

$parcel$export(module.exports, "getBannerVisibility", () => $1263eb185d4160b0$export$bfdb9f82a9194c1e);

var $ljmYJ = parcelRequire("ljmYJ");

var $fp1RH = parcelRequire("fp1RH");

var $21KEY = parcelRequire("21KEY");

var $bF6aU = parcelRequire("bF6aU");

var $4uHy1 = parcelRequire("4uHy1");

var $gHrGQ = parcelRequire("gHrGQ");
const $1263eb185d4160b0$var$getUserIsAuthenticatedBit = (consentToken)=>{
    const { isV002: isV002 } = (0, $gHrGQ.checkTokenVersionValidity)(consentToken);
    let userIsAuthenticatedBit = consentToken[8]; // V3 position
    if (isV002) {
        // Schema has changed in V3, V2 had this bit in a different position. Logged out users will have this bit set to 1
        const legacyV2ConsentDataUnavailableBit = consentToken[7];
        // We can backfill the UserIsAuthenticated bit by flipping the bit value. If ConsentHub was unavailable, that means they were logged out.
        userIsAuthenticatedBit = legacyV2ConsentDataUnavailableBit === '1' ? '0' : '1';
    }
    return userIsAuthenticatedBit;
};
const $1263eb185d4160b0$var$shouldShowBannerForLoggedOutDefaultToken = (fallbackConsentToken)=>{
    // Logged out + default consents + fallback: we have a discrepancy where ConsentHub is down/unavailable, or they're just logged out,
    // but the user has actually consented previously (which essentially the only way to save to the fallback to begin with)
    if (fallbackConsentToken) {
        const fallbackUserIsAuthenticatedBit = $1263eb185d4160b0$var$getUserIsAuthenticatedBit(fallbackConsentToken);
        const isLoggedOutFallbackConsents = !(0, $fp1RH.getBoolFromBitValue)(fallbackUserIsAuthenticatedBit);
        const fallbackTokenHasGenuineConsents = !(0, $bF6aU.checkIfTokenIsDefault)(fallbackConsentToken);
        const localOnlyUsersHasGenuineConsents = isLoggedOutFallbackConsents && fallbackTokenHasGenuineConsents;
        // If the fallback is from a logged out consent (localOnlyConsent), they're currently
        // logged out and also saved while logged out, so don't show the banner
        if (localOnlyUsersHasGenuineConsents) return !fallbackTokenHasGenuineConsents;
        const loggedOutUserPreviouslyConsentedWhileLoggedIn = !isLoggedOutFallbackConsents && fallbackTokenHasGenuineConsents;
        if (loggedOutUserPreviouslyConsentedWhileLoggedIn) // Or if it is from a logged in consent, and they've consented somewhere (they must have)
        // then we should not show the banner, as their consents aren't "stale", we're just in a situation
        // where the original token has expired so they get a default set, but we should hide the banner
        return false;
    }
    // Defaults consents + unauthed + missing a fallback, show the banner, as they haven't consented in the past year
    return true;
};
const $1263eb185d4160b0$var$shouldShowBannerForLoggedOutUser = ({ consentToken: consentToken, fallbackConsentToken: fallbackConsentToken })=>{
    const tokenIsADefaultConsent = !!(0, $bF6aU.checkIfTokenIsDefault)(consentToken);
    // Handle default token flow
    if (tokenIsADefaultConsent) return $1263eb185d4160b0$var$shouldShowBannerForLoggedOutDefaultToken(fallbackConsentToken);
    // Handle genuine token flow
    // If they're a legacy/V2 user who hasn't consented, this will have checked the V3 "is default" bit to note they've consented or not
    const localOnlyUserHasConsented = (0, $bF6aU.hasLegacyV2TokenConsentedPreviously)(consentToken) || !tokenIsADefaultConsent;
    if (localOnlyUserHasConsented) // LocalOnly users will never have a timestamp to validate against since they can't talk to ConsentHub
    // Existence of fallback consents means they've consented in the past year and do not have stale consents, do not show banner
    return fallbackConsentToken ? false : true;
    // This case should never be hit: if it's not a default, but they haven't consented... what is it? Add a catch-all "show banner"
    return true;
};
const $1263eb185d4160b0$var$shouldShowBannerForLoggedInDefaultToken = (fallbackConsentToken)=>{
    // Defaults + fallback + logged in, but they consented while they were previously logged out:
    if (fallbackConsentToken) {
        const fallbackUserIsAuthenticatedBit = $1263eb185d4160b0$var$getUserIsAuthenticatedBit(fallbackConsentToken);
        const isLoggedOutFallbackConsents = !(0, $fp1RH.getBoolFromBitValue)(fallbackUserIsAuthenticatedBit);
        const fallbackTokenHasGenuineConsents = !(0, $bF6aU.checkIfTokenIsDefault)(fallbackConsentToken);
        if (fallbackTokenHasGenuineConsents) {
            // Defaults + logged in user + consented <1yr ago, but while logged out
            if (isLoggedOutFallbackConsents) /*
        They've consented, and thus stored a fallback while logged out (fallback's CH bit is 1),
        then fetched from CH but get empty data (since they couldn't save to CH on their initial "save"), which sets authed consent defaults (bit 0)

        UX Problem:
        Since they have genuinely consented within the past year, the ideal UX would be to not show the banner...
        But if we do not re-prompt here in an effort to recapture their consents, the opportunity for them/us to actually get consents in the DB
        is infrequent (either via Account Privacy Page or once this fallback expires in a year).

        Example:
        While logged out, they consent in Trello, so we store the unauthed fallback token, then log in on Trello. If we hide the banner when the
        fallback exists, if that user later goes to Confluence's cookie domain (where they have no fallback), it would show the banner
        because they have no stored consents on CH, and no fallback in that domain, but are logged in. Repeat for every new domain...

        We could be fancy and save under the hood for them if they have a fallback, but to ensure we don't copy stale/different consents saved in a fallback
        to ConsentHub on their behalf, we should just re-prompt them for consents now that they're logged in. This way, they will actually
        persist their choices, and when loading other domains/products, there will be a Source of Truth to reference and not show the banner.

        Ultimately, this feels like the more "correct" way to handle this situation, as the cost of showing the banner again to officially capture
        consents feels lower than the potential cost of relying on fallbacks in all situations/across all domains for this user for the next whole year

        Result: Show the banner again and hope we officially recapture consents this time around
      */ return true;
            // Defaults + logged in user + consented <1yr ago, but while logged in
            // This scenario shouldn't happen, or if it does, it's in a phase where we haven't fetched preferences
            // yet, so hide the banner for now
            return false;
        }
        // Default token + default fallback (authed or unauthed) mean we've likely stored this
        // fallback from SSR's initialPreferences flow in. Fallbacks should not be saved with defaults intentionally
        // But sometimes we copy an existing token to the fallback via SSR flow, so let's treat this
        // as an bunk fallback, and show the banner as they haven't consented
        return true;
    }
    // Default consent token + logged in user + no fallback = they haven't consented in the past year, show banner
    return true;
};
const $1263eb185d4160b0$var$shouldShowBannerForLoggedInUser = ({ consentToken: consentToken, consentTimestamp: consentTimestamp, fallbackConsentToken: fallbackConsentToken })=>{
    // Handle default token flow
    const tokenIsADefaultConsent = !!(0, $bF6aU.checkIfTokenIsDefault)(consentToken);
    if (tokenIsADefaultConsent) return $1263eb185d4160b0$var$shouldShowBannerForLoggedInDefaultToken(fallbackConsentToken);
    // Handle genuine token flow
    if (consentTimestamp) {
        // If the user has genuine consents, and a timestamp, check if they're stale (> 1yr old), show the banner if they're stale
        const showBannerIfStale = (0, $bF6aU.checkIfConsentsAreStale)(consentTimestamp);
        return showBannerIfStale;
    }
    // Genuine consents + no timestamp— we're in a situation where we've been passed cached cookie data instead of CH response data,
    // so the only way to determine staleness is through the absence of the fallback.
    // Technically, we could assume since they've consented recently, we don't have to show the banner here but... to be safe we should
    return fallbackConsentToken ? false : true;
};
const $1263eb185d4160b0$export$bfdb9f82a9194c1e = ({ consentToken: consentToken, consentTimestamp: consentTimestamp, fallbackConsentToken: fallbackConsents })=>{
    // Consent tokens are either a set of defaults, or genuine (persisted to the remote, or saved in an entire local-only flow via fallbacks).
    // the deciding factor is whether or not your consents are stale/fresh, either via the existence/absence of a fallback (a.k.a consented within a year or not)
    // or if the ConsentHub response data of a user's consent has a timestamp that is older than a year
    const fallbackConsentToken = (0, $ljmYJ.isSSR)() ? fallbackConsents // When coming from SSR, we don't want to invoke `getCookie` since it will error
     : fallbackConsents || (0, $4uHy1.getCookie)((0, $21KEY.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
    let userIsAuthenticatedBit = $1263eb185d4160b0$var$getUserIsAuthenticatedBit(consentToken);
    const isLoggedOutConsentToken = !(0, $fp1RH.getBoolFromBitValue)(userIsAuthenticatedBit);
    let isBannerVisible = true; // By default, show the banner to every user
    // Unauthed/logged out user flow, should never receive a timestamp because logged out users can't communicate to ConsentHub
    if (isLoggedOutConsentToken) isBannerVisible = $1263eb185d4160b0$var$shouldShowBannerForLoggedOutUser({
        consentToken: consentToken,
        fallbackConsentToken: fallbackConsentToken
    });
    else // Authed/logged in user flow
    isBannerVisible = $1263eb185d4160b0$var$shouldShowBannerForLoggedInUser({
        consentToken: consentToken,
        fallbackConsentToken: fallbackConsentToken,
        consentTimestamp: consentTimestamp
    });
    return isBannerVisible;
};

});
parcelRegister("bF6aU", function(module, exports) {

$parcel$export(module.exports, "hasLegacyV2TokenConsentedPreviously", () => $abdac33f3c79bf2f$export$42b0ca8aba2631e4);
$parcel$export(module.exports, "checkIfTokenIsDefault", () => $abdac33f3c79bf2f$export$497a647f0eb30ef4);
$parcel$export(module.exports, "serializeConsents", () => $abdac33f3c79bf2f$export$92ba0b2fe50f90df);
$parcel$export(module.exports, "deserializeConsents", () => $abdac33f3c79bf2f$export$bfa0c91662787fb0);
$parcel$export(module.exports, "getConsentTimestamp", () => $abdac33f3c79bf2f$export$13e4cff933f26b03);
$parcel$export(module.exports, "checkIfConsentsAreStale", () => $abdac33f3c79bf2f$export$3387347b75450ae1);
$parcel$export(module.exports, "StatusCodeError", () => $abdac33f3c79bf2f$export$a79c0ea3d7c2444a);

var $fp1RH = parcelRequire("fp1RH");

var $21KEY = parcelRequire("21KEY");

var $4uHy1 = parcelRequire("4uHy1");

var $8FFpF = parcelRequire("8FFpF");

var $hqc2A = parcelRequire("hqc2A");
const $abdac33f3c79bf2f$var$isLegacyGeoTargetingV2Token = (consentToken)=>{
    const version = consentToken[0] + consentToken[1] + consentToken[2];
    const isV2Schema = version === (0, $21KEY.V002_SCHEMA_KEY);
    return isV2Schema;
};
const $abdac33f3c79bf2f$var$isLegacyV1Token = (consentToken)=>{
    const version = consentToken[0] + consentToken[1] + consentToken[2];
    const isV1Schema = version === (0, $21KEY.V001_SCHEMA_KEY);
    return isV1Schema;
};
const $abdac33f3c79bf2f$export$42b0ca8aba2631e4 = (consentToken)=>{
    if ($abdac33f3c79bf2f$var$isLegacyGeoTargetingV2Token(consentToken)) {
        // If we're looking at a V2 token and they have ANY saved 'consentedUnderXX' bits,
        // we know it must be a set of valid consents instead of defaults
        const consentedUnderGDPR = consentToken[8] === '1';
        const consentedUnderCPRA = consentToken[9] === '1';
        const consentedUnderLGPD = consentToken[10] === '1';
        const consentedUnderFADP = consentToken[11] === '1';
        const hasConsentedPreviously = consentedUnderGDPR || consentedUnderCPRA || consentedUnderLGPD || consentedUnderFADP;
        return hasConsentedPreviously;
    }
    return false;
};
const $abdac33f3c79bf2f$export$497a647f0eb30ef4 = (consentToken)=>{
    const isLegacyV1ConsentToken = $abdac33f3c79bf2f$var$isLegacyV1Token(consentToken);
    const isLegacyV2ConsentToken = $abdac33f3c79bf2f$var$isLegacyGeoTargetingV2Token(consentToken);
    if (isLegacyV1ConsentToken) // We only add a legacy `atl-gdpr-consents` cookie if a user has consented,
    // so if we see a V1 token, we know it must be a set of valid consents
    // instead of default consents
    return false;
    if (isLegacyV2ConsentToken) {
        const legacyTokenHasConsents = $abdac33f3c79bf2f$export$42b0ca8aba2631e4(consentToken);
        return !legacyTokenHasConsents;
    }
    // Check 'isDefaultConsentBit' bit for V003 Schema tokens
    const isDefaultTokenV3 = (0, $fp1RH.getBoolFromBitValue)(consentToken[7]);
    return isDefaultTokenV3;
};
const $abdac33f3c79bf2f$export$c42e1a74e60f4d73 = (consentsUnavailable)=>{
    const version = (0, $21KEY.V003_SCHEMA_KEY);
    // DEFAULT_PREFERENCES now has the default boolean baked into it, so we don't need to set it here
    const serializedBits = Object.entries((0, $21KEY.DEFAULT_PREFERENCES)).reduce((acc, [key, val])=>{
        // Skip the STRICTLY_NECESSARY as it's always allowed
        if (key === (0, $8FFpF.PreferenceCategory).StrictlyNecessary) return acc;
        if (key === (0, $8FFpF.ContextualConsentProperty).UserIsAuthenticated) {
            // If consents are missing when setting these defaults, the user will be logged out,
            // so pack this info into the consent token bits
            const userIsAuthed = !consentsUnavailable;
            return acc + (0, $fp1RH.getBitValueFromBool)(userIsAuthed);
        }
        if (key === (0, $8FFpF.ContextualConsentProperty).ConsentDataUnavailable) // If consents are missing when setting these defaults, the user will be logged out,
        // so pack this info into the consent token bits
        return acc + (0, $fp1RH.getBitValueFromBool)(!!consentsUnavailable);
        return acc + (0, $fp1RH.getBitValueFromBool)(val);
    }, '');
    return `${version}${serializedBits}`;
};
const $abdac33f3c79bf2f$export$42a0b3fb1e53e7b9 = (consents)=>{
    const version = (0, $21KEY.V003_SCHEMA_KEY);
    // As 'strictlyNecessaryConsent' would always be allowed, we don't store it in the cookie or use ConsentHub
    const functionalConsent = (0, $fp1RH.getBitValueFromBool)(!!consents.find((key)=>key.key === (0, $hqc2A.ConsentHubKey).Functional)?.granted);
    const analyticsConsent = (0, $fp1RH.getBitValueFromBool)(!!consents.find((key)=>key.key === (0, $hqc2A.ConsentHubKey).Analytics)?.granted);
    const marketingConsent = (0, $fp1RH.getBitValueFromBool)(!!consents.find((key)=>key.key === (0, $hqc2A.ConsentHubKey).Marketing)?.granted);
    const unknownConsent = (0, $fp1RH.getBitValueFromBool)(!!consents.find((key)=>key.key === (0, $hqc2A.ConsentHubKey).Unknown)?.granted);
    // As these consents were returned from the server, ConsentHub is obviously available, they're logged in, and aren't defaults
    const isDefaultToken = 0;
    const userIsAuthenticated = 1;
    const consentHubDataUnavailable = 0;
    return [
        version,
        functionalConsent,
        analyticsConsent,
        marketingConsent,
        unknownConsent,
        isDefaultToken,
        userIsAuthenticated,
        consentHubDataUnavailable
    ].join('');
};
const $abdac33f3c79bf2f$export$92ba0b2fe50f90df = ({ consents: consents })=>{
    if (!consents) {
        // When generating consents for an unauthenticated user, use the fallback token if it exists
        // This circumvents us setting defaults for them if their token has expired, but they have consented previously
        const existingFallbackToken = (0, $4uHy1.getCookie)((0, $21KEY.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
        if (existingFallbackToken) return existingFallbackToken;
        // User is unauthed, will only use local consenting, consent data will also be unavailable
        return $abdac33f3c79bf2f$export$c42e1a74e60f4d73(true); // e.g. 0030000101
    } else if (consents.length === 0) // User is authed but has no consents in the system, so use defaults in the interim, consentData must be available
    return $abdac33f3c79bf2f$export$c42e1a74e60f4d73(); // e.g. 0030000110
    else // User is authed and has consents in the system
    return $abdac33f3c79bf2f$export$42a0b3fb1e53e7b9(consents); // e.g. 0030110110
};
const $abdac33f3c79bf2f$export$bfa0c91662787fb0 = (unpackedUserPreferences, displayedTextMap)=>{
    const validConsentHubCookieConsents = [
        (0, $8FFpF.PreferenceCategory).StrictlyNecessary,
        (0, $8FFpF.PreferenceCategory).Functional,
        (0, $8FFpF.PreferenceCategory).Analytics,
        (0, $8FFpF.PreferenceCategory).Marketing,
        (0, $8FFpF.PreferenceCategory).Unknown
    ];
    const consentKeyMap = {
        [(0, $8FFpF.PreferenceCategory).StrictlyNecessary]: (0, $hqc2A.ConsentHubKey).StrictlyNecessary,
        [(0, $8FFpF.PreferenceCategory).Functional]: (0, $hqc2A.ConsentHubKey).Functional,
        [(0, $8FFpF.PreferenceCategory).Analytics]: (0, $hqc2A.ConsentHubKey).Analytics,
        [(0, $8FFpF.PreferenceCategory).Marketing]: (0, $hqc2A.ConsentHubKey).Marketing,
        [(0, $8FFpF.PreferenceCategory).Unknown]: (0, $hqc2A.ConsentHubKey).Unknown
    };
    const consentRecords = validConsentHubCookieConsents.map((consentKey)=>{
        const key = consentKeyMap[consentKey];
        return {
            key: key,
            granted: !!unpackedUserPreferences[consentKey],
            gatheredTs: new Date().toISOString(),
            displayedText: displayedTextMap[consentKey]
        };
    });
    return consentRecords;
};
const $abdac33f3c79bf2f$export$13e4cff933f26b03 = ({ consents: consents })=>{
    if (consents && consents.length) {
        // As consents can be updated individually, we need to find the most recent timestamp to use as "most recent consent"
        const timestamps = consents.map((consent)=>{
            return new Date(consent.updatedTs).getTime();
        });
        const maxTimestamp = Math.max(...timestamps);
        const mostRecentConsentTimestamp = new Date(maxTimestamp).toISOString();
        return mostRecentConsentTimestamp;
    }
};
const $abdac33f3c79bf2f$export$3387347b75450ae1 = (consentTimestamp)=>{
    // Privacy has determined that we should re-prompt users for consent if they haven't
    // consented in over a year regardless, because they're legally stale/expired
    let consentedOverAYearAgo = false;
    if (consentTimestamp) {
        const oneYearAgo = new Date();
        oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
        consentedOverAYearAgo = new Date(consentTimestamp) < oneYearAgo;
    }
    return consentedOverAYearAgo;
};
class $abdac33f3c79bf2f$export$a79c0ea3d7c2444a extends Error {
    constructor(message, status){
        super(message);
        this.status = status;
        Object.setPrototypeOf(this, $abdac33f3c79bf2f$export$a79c0ea3d7c2444a.prototype);
        // Captures the stack trace (for environments that support it)
        if (Error.captureStackTrace) Error.captureStackTrace(this, $abdac33f3c79bf2f$export$a79c0ea3d7c2444a);
        this.name = 'StatusCodeError';
    }
}

});
parcelRegister("hqc2A", function(module, exports) {

$parcel$export(module.exports, "ConsentHubKey", () => $2d8cccb1496bcaa8$export$31140359b1e505cf);
var $2d8cccb1496bcaa8$export$31140359b1e505cf = /*#__PURE__*/ function(ConsentHubKey) {
    ConsentHubKey["StrictlyNecessary"] = "strictlyNecessaryCookies";
    ConsentHubKey["Functional"] = "functionalCookies";
    ConsentHubKey["Analytics"] = "performanceCookies";
    ConsentHubKey["Marketing"] = "targetingCookies";
    ConsentHubKey["Unknown"] = "unknownCookies";
    return ConsentHubKey;
}({});

});


parcelRegister("gHrGQ", function(module, exports) {

$parcel$export(module.exports, "checkTokenVersionValidity", () => $f95b7e0a4ae57e4e$export$64b31470e8522819);
$parcel$export(module.exports, "packUserPreferences", () => $f95b7e0a4ae57e4e$export$3199823fec979bd1);
$parcel$export(module.exports, "unpackUserPreferencesCookie", () => $f95b7e0a4ae57e4e$export$8d213cb390bab4fa);
$parcel$export(module.exports, "initialPreferencesAreMissing", () => $f95b7e0a4ae57e4e$export$67f70eb55341bd29);
$parcel$export(module.exports, "initializePreferencesData", () => $f95b7e0a4ae57e4e$export$7962405c3ca274b1);

var $gMWuT = parcelRequire("gMWuT");

var $fp1RH = parcelRequire("fp1RH");

var $21KEY = parcelRequire("21KEY");

var $bF6aU = parcelRequire("bF6aU");

var $8FFpF = parcelRequire("8FFpF");
const $f95b7e0a4ae57e4e$export$64b31470e8522819 = (consentToken)=>{
    // A token can technically be bad data (alphanumeric instead of binary) but we should fail gracefully if so
    if (consentToken.length < 3) // Wrong format, no version
    return {
        isValid: false,
        isV001: false,
        isV002: false,
        isV003: false
    };
    const version = consentToken[0] + consentToken[1] + consentToken[2];
    const isV001 = version === (0, $21KEY.V001_SCHEMA_KEY) && consentToken.length === 7;
    const isV002 = version === (0, $21KEY.V002_SCHEMA_KEY) && consentToken.length === 12;
    const isV003 = version === (0, $21KEY.V003_SCHEMA_KEY) && consentToken.length === 10;
    // We support version 001, 002, 003 only
    const isSupportedVersion = [
        (0, $21KEY.V001_SCHEMA_KEY),
        (0, $21KEY.V002_SCHEMA_KEY),
        (0, $21KEY.V003_SCHEMA_KEY)
    ].includes(version);
    const isValid = isSupportedVersion && (isV001 || isV002 || isV003);
    return {
        isValid: isValid,
        isV001: isV001,
        isV002: isV002,
        isV003: isV003
    };
};
/* Schema Version 001:
---------------------------------------------------
  - Format 0000000
  - 001 (schema version 3 digits)
  - 0/1 (1 digit, FUNCTIONAL cookies disabled/enabled)
  - 0/1 (1 digit, ANALYTICS cookies disabled/enabled)
  - 0/1 (1 digit, MARKETING cookies disabled/enabled)
  - 0/1 (1 digit, UNKNOWN cookies disabled/enabled)
*/ const $f95b7e0a4ae57e4e$var$packPrefsVersion001 = (userPreferences)=>{
    const version = (0, $21KEY.V001_SCHEMA_KEY);
    return [
        version,
        (0, $fp1RH.getBitValueFromBool)(userPreferences.FUNCTIONAL),
        (0, $fp1RH.getBitValueFromBool)(userPreferences.ANALYTICS),
        (0, $fp1RH.getBitValueFromBool)(userPreferences.MARKETING),
        (0, $fp1RH.getBitValueFromBool)(userPreferences.UNKNOWN)
    ].join('');
};
const $f95b7e0a4ae57e4e$var$unpackPrefsVersion001 = (userPreferencesCookie)=>{
    if (userPreferencesCookie.length !== 7) // Wrong length for version 001
    return;
    return {
        [(0, $8FFpF.PreferenceCategory).StrictlyNecessary]: true,
        [(0, $8FFpF.PreferenceCategory).Functional]: userPreferencesCookie[3] === '1',
        [(0, $8FFpF.PreferenceCategory).Analytics]: userPreferencesCookie[4] === '1',
        [(0, $8FFpF.PreferenceCategory).Marketing]: userPreferencesCookie[5] === '1',
        [(0, $8FFpF.PreferenceCategory).Unknown]: userPreferencesCookie[6] === '1'
    };
};
/* Schema Version 002 ***** DEPRECATED *****
---------------------------------------------------
  - Format 000000000000
  - 002 (schema version, 3 digits)
  - 0/1 (1 digit, FUNCTIONAL cookies - disabled/enabled)
  - 0/1 (1 digit, ANALYTICS cookies - disabled/enabled)
  - 0/1 (1 digit, MARKETING cookies - disabled/enabled)
  - 0/1 (1 digit, UNKNOWN cookies - disabled/enabled)
  - 0/1 (1 digit, consent records are unavailable from ConsentHub (logged out) - yes/no)
  - 0/1 (1 digit, consents saved while in GDPR locale (Europe) - yes/no)
  - 0/1 (1 digit, consents saved while in CPRA locale (CPRA will act as 'all USA' bucket) - yes/no)
  - 0/1 (1 digit, consents saved while in LGPD locale (Brazil) - yes/no)
  - 0/1 (1 digit, consents saved while in FADP locale (Switzerland) - yes/no)
*/ const $f95b7e0a4ae57e4e$var$packPrefsVersion002 = (userPreferences)=>{
    // As we want to slowly kill off any V002 preferences, if we're provided one for some reason
    // internally convert it to a V003 preference to drop contextual GeoIP details
    const version = (0, $21KEY.V003_SCHEMA_KEY);
    const hasConsentedPreviously = userPreferences[(0, $8FFpF.ConsentPreferenceV2).ConsentedUnderGDPR] || userPreferences[(0, $8FFpF.ConsentPreferenceV2).ConsentedUnderCPRA] || userPreferences[(0, $8FFpF.ConsentPreferenceV2).ConsentedUnderLGPD] || userPreferences[(0, $8FFpF.ConsentPreferenceV2).ConsentedUnderFADP];
    const isDefaultConsentBit = !hasConsentedPreviously;
    // As we've broken out authentication insights/context from "ConsentDataUnavailable" bit in V3,
    // and it does not exist, we will backfill the value based on the previous bit state
    const existingConsentDataUnavailableBit = userPreferences[(0, $8FFpF.ContextualConsentProperty).ConsentDataUnavailable];
    const userIsAuthenticatedBit = !existingConsentDataUnavailableBit;
    return [
        version,
        (0, $fp1RH.getBitValueFromBool)(userPreferences[(0, $8FFpF.PreferenceCategory).Functional]),
        (0, $fp1RH.getBitValueFromBool)(userPreferences[(0, $8FFpF.PreferenceCategory).Analytics]),
        (0, $fp1RH.getBitValueFromBool)(userPreferences[(0, $8FFpF.PreferenceCategory).Marketing]),
        (0, $fp1RH.getBitValueFromBool)(userPreferences[(0, $8FFpF.PreferenceCategory).Unknown]),
        (0, $fp1RH.getBitValueFromBool)(isDefaultConsentBit),
        (0, $fp1RH.getBitValueFromBool)(userIsAuthenticatedBit),
        (0, $fp1RH.getBitValueFromBool)(existingConsentDataUnavailableBit)
    ].join('');
};
const $f95b7e0a4ae57e4e$var$unpackPrefsVersion002 = (userPreferencesCookie)=>{
    // If the provided V002 token has consented anywhere, we'll drop the contextual GeoIP bits and
    // convert it to a V003 schema
    const isADefaultConsentToken = (0, $bF6aU.checkIfTokenIsDefault)(userPreferencesCookie);
    // Backfill the value based on the previous "ConsentDataUnavailable" bit state as we've broken this contextual info out
    const consentDataUnavailable = userPreferencesCookie[7] === '1';
    const userIsDeemedAuthenticated = !consentDataUnavailable;
    return {
        ...$f95b7e0a4ae57e4e$var$unpackPrefsVersion003(userPreferencesCookie),
        [(0, $8FFpF.ContextualConsentProperty).ConsentsAreDefault]: !!isADefaultConsentToken,
        [(0, $8FFpF.ContextualConsentProperty).UserIsAuthenticated]: userIsDeemedAuthenticated,
        [(0, $8FFpF.ContextualConsentProperty).ConsentDataUnavailable]: consentDataUnavailable
    };
};
/* Schema Version 003
---------------------------------------------------
  - Format 0000000000
  - 003 (schema version, 3 digits)
  - 0/1 (1 digit, FUNCTIONAL cookies - disabled/enabled)
  - 0/1 (1 digit, ANALYTICS cookies - disabled/enabled)
  - 0/1 (1 digit, MARKETING cookies - disabled/enabled)
  - 0/1 (1 digit, UNKNOWN cookies - disabled/enabled)
  - 0/1 (1 digit, Consent token in a default state, user has yet to consent) - no/yes)
  - 0/1 (1 digit, User is authenticated, did not 401 during save) - no/yes)
  - 0/1 (1 digit, ConsentHub records are unavailable (CH is down, errored while saving, etc) - no/yes)
*/ const $f95b7e0a4ae57e4e$var$packPrefsVersion003 = (userPreferences)=>{
    const version = (0, $21KEY.V003_SCHEMA_KEY);
    return [
        version,
        (0, $fp1RH.getBitValueFromBool)(userPreferences[(0, $8FFpF.PreferenceCategory).Functional]),
        (0, $fp1RH.getBitValueFromBool)(userPreferences[(0, $8FFpF.PreferenceCategory).Analytics]),
        (0, $fp1RH.getBitValueFromBool)(userPreferences[(0, $8FFpF.PreferenceCategory).Marketing]),
        (0, $fp1RH.getBitValueFromBool)(userPreferences[(0, $8FFpF.PreferenceCategory).Unknown]),
        (0, $fp1RH.getBitValueFromBool)(userPreferences[(0, $8FFpF.ContextualConsentProperty).ConsentsAreDefault]),
        (0, $fp1RH.getBitValueFromBool)(userPreferences[(0, $8FFpF.ContextualConsentProperty).UserIsAuthenticated]),
        (0, $fp1RH.getBitValueFromBool)(userPreferences[(0, $8FFpF.ContextualConsentProperty).ConsentDataUnavailable])
    ].join('');
};
const $f95b7e0a4ae57e4e$var$unpackPrefsVersion003 = (userPreferencesCookie)=>{
    return {
        [(0, $8FFpF.PreferenceCategory).StrictlyNecessary]: true,
        [(0, $8FFpF.PreferenceCategory).Functional]: userPreferencesCookie[3] === '1',
        [(0, $8FFpF.PreferenceCategory).Analytics]: userPreferencesCookie[4] === '1',
        [(0, $8FFpF.PreferenceCategory).Marketing]: userPreferencesCookie[5] === '1',
        [(0, $8FFpF.PreferenceCategory).Unknown]: userPreferencesCookie[6] === '1',
        [(0, $8FFpF.ContextualConsentProperty).ConsentsAreDefault]: userPreferencesCookie[7] === '1',
        [(0, $8FFpF.ContextualConsentProperty).UserIsAuthenticated]: userPreferencesCookie[8] === '1',
        [(0, $8FFpF.ContextualConsentProperty).ConsentDataUnavailable]: userPreferencesCookie[9] === '1'
    };
};
const $f95b7e0a4ae57e4e$var$V002SpecificBitKeys = [
    (0, $8FFpF.ContextualConsentProperty).ConsentDataUnavailable,
    (0, $8FFpF.ConsentPreferenceV2).ConsentedUnderGDPR,
    (0, $8FFpF.ConsentPreferenceV2).ConsentedUnderCPRA,
    (0, $8FFpF.ConsentPreferenceV2).ConsentedUnderLGPD,
    (0, $8FFpF.ConsentPreferenceV2).ConsentedUnderFADP
];
const $f95b7e0a4ae57e4e$var$V003SpecificBitKeys = [
    (0, $8FFpF.ContextualConsentProperty).ConsentsAreDefault,
    (0, $8FFpF.ContextualConsentProperty).UserIsAuthenticated,
    (0, $8FFpF.ContextualConsentProperty).ConsentDataUnavailable
];
function $f95b7e0a4ae57e4e$export$3199823fec979bd1(userPreferences) {
    if ((0, $gMWuT.getBscGlobalState)().localConsentMode) return $f95b7e0a4ae57e4e$var$packPrefsVersion001(userPreferences);
    const isV002 = $f95b7e0a4ae57e4e$var$V002SpecificBitKeys.every((key)=>key in userPreferences);
    if (isV002) // As V002 is deprecated, if we've been provided V002 set of "legacy" prefs, internally
    // convert them to V003 to drop the unnecessary contextual details
    return $f95b7e0a4ae57e4e$var$packPrefsVersion002(userPreferences);
    const isV003 = $f95b7e0a4ae57e4e$var$V003SpecificBitKeys.every((key)=>key in userPreferences);
    if (isV003) return $f95b7e0a4ae57e4e$var$packPrefsVersion003(userPreferences);
    // Fallback to V001
    return $f95b7e0a4ae57e4e$var$packPrefsVersion001(userPreferences);
}
function $f95b7e0a4ae57e4e$export$8d213cb390bab4fa(userPreferencesCookie) {
    if ((0, $gMWuT.getBscGlobalState)().localConsentMode) {
        if (userPreferencesCookie.length < 3) // Wrong format, no version
        return;
        const version = userPreferencesCookie[0] + userPreferencesCookie[1] + userPreferencesCookie[2];
        if (version === (0, $21KEY.V001_SCHEMA_KEY)) return $f95b7e0a4ae57e4e$var$unpackPrefsVersion001(userPreferencesCookie);
        return;
    }
    const { isValid: isValid, isV001: isV001, isV002: isV002, isV003: isV003 } = $f95b7e0a4ae57e4e$export$64b31470e8522819(userPreferencesCookie);
    if (!isValid) // We support version 001, 002, 003 only
    return;
    if (isV001) return $f95b7e0a4ae57e4e$var$unpackPrefsVersion001(userPreferencesCookie);
    if (isV002) // Deprecated, so this will unpack to 003 to drop the contextual GeoIP bits
    return $f95b7e0a4ae57e4e$var$unpackPrefsVersion002(userPreferencesCookie);
    if (isV003) return $f95b7e0a4ae57e4e$var$unpackPrefsVersion003(userPreferencesCookie);
}
const $f95b7e0a4ae57e4e$export$67f70eb55341bd29 = (initialPreferences)=>{
    if (!initialPreferences) return true;
    const prefExistButAreEmpty = Object.keys(initialPreferences).length === 0;
    return prefExistButAreEmpty;
};
const $f95b7e0a4ae57e4e$export$7962405c3ca274b1 = (initialPreferences)=>{
    if (initialPreferences !== (0, $8FFpF.PrefetchedPreferenceState).INTERNAL) {
        if ($f95b7e0a4ae57e4e$export$67f70eb55341bd29(initialPreferences)) // Failsafe handling: Consumer failed to provide data even though they have prefetched, so we need to fetch again
        // This may occur if a consumer's prefetch requests fails, or if they fail to implement the system correctly
        return {
            prefs: undefined,
            isPrefetchedPrefsInternalState: true
        };
        // If initialPreferences is not INTERNAL on first render, we have been provided a pre-fetched
        // value, which means we don't need to make a fetch to storage or ConsentHub to get it.
        // If that preference is defined, we persist it to our local cookie set
        // If the data is a ConsentHubResponse/PrefetchedConsentCookieData, we'll need to transform it properly before consumption
        const consentToken = initialPreferences && 'consentToken' in initialPreferences && initialPreferences.consentToken;
        if (consentToken) {
            // We already have a consent cookie that was passed in, let's not override it by setting it again
            const unpackedExistingPrefs = $f95b7e0a4ae57e4e$export$8d213cb390bab4fa(consentToken);
            return {
                prefs: unpackedExistingPrefs,
                isPrefetchedPrefsInternalState: !Boolean(unpackedExistingPrefs)
            };
        }
        // This type guard protects the below casting of ConsentHubResponse ensuring we have the correct shape
        if (initialPreferences && 'consents' in initialPreferences) {
            const serializedPrefetchedConsentToken = (0, $bF6aU.serializeConsents)(initialPreferences);
            const unpackedPrefetchedPrefs = $f95b7e0a4ae57e4e$export$8d213cb390bab4fa(serializedPrefetchedConsentToken);
            return {
                prefs: unpackedPrefetchedPrefs,
                isPrefetchedPrefsInternalState: !Boolean(unpackedPrefetchedPrefs)
            };
        }
    }
    // If we've fallen into this, EMPTY implies we have no data at all
    // INTERNAL implies we still need to fetch new data, so trigger a refetch
    if (initialPreferences === (0, $8FFpF.PrefetchedPreferenceState).INTERNAL) return {
        prefs: undefined,
        isPrefetchedPrefsInternalState: true
    };
    return {
        prefs: undefined,
        isPrefetchedPrefsInternalState: false
    };
};

});


parcelRegister("7RRGT", function(module, exports) {

$parcel$export(module.exports, "setStrictlyNecessaryCookie", () => $e697b6ca6ca66a2d$export$93509ff9a62ee022);

var $eYli8 = parcelRequire("eYli8");

var $VSDnB = parcelRequire("VSDnB");

var $3MsQ9 = parcelRequire("3MsQ9");

var $Dyz2r = parcelRequire("Dyz2r");
const $e697b6ca6ca66a2d$export$93509ff9a62ee022 = (key, value, attributes)=>{
    if ((0, $VSDnB.fg)('platform_moonjelly_bsc_master_killswitch')) // Set the cookie without package operational events
    // when master killswitch is enabled
    (0, (/*@__PURE__*/$parcel$interopDefault($eYli8))).set(key, value, {
        ...attributes,
        'atl-set-cookie': true
    });
    else try {
        (0, $3MsQ9.sendPackageOperationalEvent)({
            action: 'usedSetStrictlyNecessaryCookie',
            attributes: {
                cookieKey: key
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($eYli8))).set(key, value, {
            ...attributes,
            'atl-set-cookie': true
        });
    } catch (e) {
        (0, $Dyz2r.Logger).errorWithOperationalEvent({
            action: 'usedSetStrictlyNecessaryCookieError',
            attributes: {
                cookieKey: key
            },
            message: `Failed to use set strictly necessary cookie. ${e.message || ''}`
        });
    }
};

});


parcelRegister("9C321", function(module, exports) {

$parcel$export(module.exports, "getValidConsentData", () => $f9f5f5b5132e3785$export$c515de1cc9cebc71);

var $VSDnB = parcelRequire("VSDnB");

var $21KEY = parcelRequire("21KEY");

var $jhSue = parcelRequire("jhSue");

var $gHrGQ = parcelRequire("gHrGQ");
const $f9f5f5b5132e3785$export$c515de1cc9cebc71 = async (fallbackConsentToken)=>{
    // Fetches preferences from ConsentHub and returns serialized token data if possible
    const consentData = await (0, $jhSue.fetchConsentPreferences)();
    let { consentToken: consentToken, consentTimestamp: consentTimestamp, consentHubInaccessible: consentHubInaccessible } = consentData;
    let { isValid: isValid } = (0, $gHrGQ.checkTokenVersionValidity)(consentToken);
    if (isValid && consentHubInaccessible) {
        if (fallbackConsentToken) // `consentHubInaccessible`: ConsentHub request failed (e.g. service is down/bad request/etc). Attempt to use
        // any previously set consents in the interim if we have them.
        consentToken = fallbackConsentToken;
        else if ((0, $VSDnB.fg)('platform_moonjelly_bsc_fallback_token_audit')) {
            const version = (0, $21KEY.V003_SCHEMA_KEY);
            const consents = consentToken.slice(3, 7);
            // V003 BSC bits set to reflect default consent token status, authenticated user status,
            // and unavailable consentHub records status)
            const serviceBits = '111';
            // Temporary: Sets a default token with V003 properties
            // when ConsentHub is inaccessible and there is not fallback token. This
            // will ensure the banner isn't shown when ConsentHub is down.
            consentToken = `${version}${consents}${serviceBits}`;
        } else // Temporary: Sets the default token to have true consentedUnderXXXX bits
        // when ConsentHub is inaccessible and there is not fallback token. This
        // will ensure the banner isn't shown when ConsentHub is down.
        consentToken = `${consentToken.slice(0, 8)}1111`;
    }
    return isValid ? {
        consentToken: consentToken,
        consentTimestamp: consentTimestamp
    } : undefined;
};

});
parcelRegister("jhSue", function(module, exports) {

$parcel$export(module.exports, "buildConsentPreferences", () => $356623899ad2d63f$export$bd9f5bcbf9cd947c);
$parcel$export(module.exports, "fetchConsentPreferences", () => $356623899ad2d63f$export$86467566615ab85e);
$parcel$export(module.exports, "saveConsentPreferences", () => $356623899ad2d63f$export$f8422650c3dec8b2);

var $Dyz2r = parcelRequire("Dyz2r");

var $bF6aU = parcelRequire("bF6aU");
const $356623899ad2d63f$var$BASE_CONSENTS_URL = '/gateway/api/consenthub/session';
const $356623899ad2d63f$var$POST_CONSENTS_URL = `${$356623899ad2d63f$var$BASE_CONSENTS_URL}/user`;
const $356623899ad2d63f$var$GET_CONSENTS_URL = `${$356623899ad2d63f$var$POST_CONSENTS_URL}/consents/cookies`;
const $356623899ad2d63f$export$bd9f5bcbf9cd947c = (consentData)=>{
    if (consentData) {
        const serializedConsents = (0, $bF6aU.serializeConsents)(consentData);
        const consentTimestamp = (0, $bF6aU.getConsentTimestamp)(consentData);
        return {
            consentToken: serializedConsents,
            consentTimestamp: consentTimestamp
        };
    }
    // Without consent data (due to server failure or unauthenticated user), set defaults illustrating that absence
    return {
        consentToken: (0, $bF6aU.serializeConsents)({}),
        consentHubInaccessible: true
    };
};
const $356623899ad2d63f$export$86467566615ab85e = async ()=>{
    const { origin: origin } = window.location;
    const getFromConsentHubURL = `${origin}${$356623899ad2d63f$var$GET_CONSENTS_URL}`;
    try {
        const response = await fetch(getFromConsentHubURL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        if (!response.ok) throw new Error(`Failed to fetch preferences from ConsentHub with status: ${response.status}`);
        const consentData = await response.json();
        return $356623899ad2d63f$export$bd9f5bcbf9cd947c(consentData);
    } catch (err) {
        (0, $Dyz2r.Logger).errorWithOperationalEvent({
            action: 'fetchConsentPreferencesError',
            message: err.message || ''
        });
        return $356623899ad2d63f$export$bd9f5bcbf9cd947c();
    }
};
const $356623899ad2d63f$var$buildConsentRequestBody = (unpackedUserPreferences, displayedTextMap)=>{
    const { origin: origin, pathname: pathname } = window.location;
    const deserializedConsents = (0, $bF6aU.deserializeConsents)(unpackedUserPreferences, displayedTextMap);
    // Type guard here so TS knows we're working with ConsentPreferenceV003
    const action = 'CONSENT_DATA_UNAVAILABLE' in unpackedUserPreferences && unpackedUserPreferences.CONSENT_DATA_UNAVAILABLE ? 'FORM_FILL' : 'UPDATE_PREFERENCES';
    const consentRequestBody = {
        action: action,
        consents: deserializedConsents,
        formUrl: `${origin}${pathname}`,
        locale: 'UNKNOWN',
        site: 'atlassian',
        source: 'COOKIE_PREFERENCES'
    };
    return JSON.stringify(consentRequestBody);
};
const $356623899ad2d63f$export$f8422650c3dec8b2 = async (unpackedUserPreferences, displayedTextMap)=>{
    const saveToConsentHubURL = `${window.location.origin}${$356623899ad2d63f$var$POST_CONSENTS_URL}`;
    try {
        const response = await fetch(saveToConsentHubURL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: $356623899ad2d63f$var$buildConsentRequestBody(unpackedUserPreferences, displayedTextMap)
        });
        // Saving is an async API (we don't know if the save succeeds) so returns 202 Accepted.
        // 401 = User is unauthenticated
        // 5xx = ConsentHub is unavailable
        if (!response.ok || response.status !== 202 && response.status !== 200) {
            const errMsg = `Failed to save preferences to ConsentHub with status: ${response.status}`;
            const errWithStatusCode = new (0, $bF6aU.StatusCodeError)(errMsg, response.status);
            throw errWithStatusCode;
        }
    } catch (err) {
        (0, $Dyz2r.Logger).errorWithOperationalEvent({
            action: 'saveConsentPreferencesError',
            message: err.message || ''
        });
        // Re-throw to any encapsulating logic, a la `setConsentToken()`
        throw err;
    }
};

});






parcelRegister("Ux8bG", function(module, exports) {

$parcel$export(module.exports, "setStrictlyNecessaryStorageItem", () => $c4f157f4fba696fa$export$f1b0c189562aa9fd);

var $3MsQ9 = parcelRequire("3MsQ9");

var $Dyz2r = parcelRequire("Dyz2r");

var $8FFpF = parcelRequire("8FFpF");

var $3uyrZ = parcelRequire("3uyrZ");
const $c4f157f4fba696fa$export$f1b0c189562aa9fd = (itemKey, value, storageType, browserStorage)=>{
    // Flag disabled, allow all items.
    const eventAttributes = {
        itemKey: itemKey,
        storageType: storageType
    };
    try {
        (0, $3MsQ9.sendPackageOperationalEvent)({
            action: 'usedAtlBrowserStorageSetStrictlyNecessaryItem',
            attributes: eventAttributes
        });
        // Store the item as a record in our IDB service to track that we've seen it before.
        // That way, when we can confirm/deny that this has been set by our service when we check again.
        // If it fails for some reason, it will be caught before actually setting the item
        // As setting Strictly Necessary requires synchronous operation, wait on the promise in an OG fashion
        (0, $3uyrZ.BSCIndexedDB).setRecord(itemKey).then(()=>{
        // NOTE: Should this just no-op/be removed? It already set and returned the item theoretically since this main func is sync
        }).catch((e)=>{
            // Rethrow to the above catch clause since this is async within a sync func
            throw new Error(e.message || '');
        });
        browserStorage.setItem(itemKey, value);
        return (0, $8FFpF.Status).SUCCESS;
    } catch (e) {
        (0, $Dyz2r.Logger).errorWithOperationalEvent({
            action: 'usedAtlBrowserStorageSetStrictlyNecessaryItemError',
            attributes: eventAttributes,
            message: `Failed to set strictly necessary ${storageType} item. ${e.message || ''}`
        });
        return (0, $8FFpF.Status).FAILED;
    }
};

});


parcelRegister("kzObv", function(module, exports) {
var $efae012046e18468$var$namespace = 'expire_mixin';
module.exports = $efae012046e18468$var$expirePlugin;
function $efae012046e18468$var$expirePlugin() {
    var expirations = this.createStore(this.storage, null, this._namespacePrefix + $efae012046e18468$var$namespace);
    return {
        set: expire_set,
        get: expire_get,
        remove: expire_remove,
        getExpiration: getExpiration,
        removeExpiredKeys: removeExpiredKeys
    };
    function expire_set(super_fn, key, val, expiration) {
        if (!this.hasNamespace($efae012046e18468$var$namespace)) expirations.set(key, expiration);
        return super_fn();
    }
    function expire_get(super_fn, key) {
        if (!this.hasNamespace($efae012046e18468$var$namespace)) _checkExpiration.call(this, key);
        return super_fn();
    }
    function expire_remove(super_fn, key) {
        if (!this.hasNamespace($efae012046e18468$var$namespace)) expirations.remove(key);
        return super_fn();
    }
    function getExpiration(_, key) {
        return expirations.get(key);
    }
    function removeExpiredKeys(_) {
        var keys = [];
        this.each(function(val, key) {
            keys.push(key);
        });
        for(var i = 0; i < keys.length; i++)_checkExpiration.call(this, keys[i]);
    }
    function _checkExpiration(key) {
        var expiration = expirations.get(key, Number.MAX_VALUE);
        if (expiration <= new Date().getTime()) {
            this.raw.remove(key);
            expirations.remove(key);
        }
    }
}

});

parcelRegister("c4CII", function(module, exports) {

var $dgvY6 = parcelRequire("dgvY6");
var $8ca3e4c5fdf5089f$var$slice = $dgvY6.slice;
var $8ca3e4c5fdf5089f$var$pluck = $dgvY6.pluck;
var $8ca3e4c5fdf5089f$var$each = $dgvY6.each;
var $8ca3e4c5fdf5089f$var$bind = $dgvY6.bind;
var $8ca3e4c5fdf5089f$var$create = $dgvY6.create;
var $8ca3e4c5fdf5089f$var$isList = $dgvY6.isList;
var $8ca3e4c5fdf5089f$var$isFunction = $dgvY6.isFunction;
var $8ca3e4c5fdf5089f$var$isObject = $dgvY6.isObject;
module.exports = {
    createStore: $8ca3e4c5fdf5089f$var$createStore
};
var $8ca3e4c5fdf5089f$var$storeAPI = {
    version: '2.0.12',
    enabled: false,
    // get returns the value of the given key. If that value
    // is undefined, it returns optionalDefaultValue instead.
    get: function(key, optionalDefaultValue) {
        var data = this.storage.read(this._namespacePrefix + key);
        return this._deserialize(data, optionalDefaultValue);
    },
    // set will store the given value at key and returns value.
    // Calling set with value === undefined is equivalent to calling remove.
    set: function(key, value) {
        if (value === undefined) return this.remove(key);
        this.storage.write(this._namespacePrefix + key, this._serialize(value));
        return value;
    },
    // remove deletes the key and value stored at the given key.
    remove: function(key) {
        this.storage.remove(this._namespacePrefix + key);
    },
    // each will call the given callback once for each key-value pair
    // in this store.
    each: function(callback) {
        var self = this;
        this.storage.each(function(val, namespacedKey) {
            callback.call(self, self._deserialize(val), (namespacedKey || '').replace(self._namespaceRegexp, ''));
        });
    },
    // clearAll will remove all the stored key-value pairs in this store.
    clearAll: function() {
        this.storage.clearAll();
    },
    // additional functionality that can't live in plugins
    // ---------------------------------------------------
    // hasNamespace returns true if this store instance has the given namespace.
    hasNamespace: function(namespace) {
        return this._namespacePrefix == '__storejs_' + namespace + '_';
    },
    // createStore creates a store.js instance with the first
    // functioning storage in the list of storage candidates,
    // and applies the the given mixins to the instance.
    createStore: function() {
        return $8ca3e4c5fdf5089f$var$createStore.apply(this, arguments);
    },
    addPlugin: function(plugin) {
        this._addPlugin(plugin);
    },
    namespace: function(namespace) {
        return $8ca3e4c5fdf5089f$var$createStore(this.storage, this.plugins, namespace);
    }
};
function $8ca3e4c5fdf5089f$var$_warn() {
    var _console = typeof console == 'undefined' ? null : console;
    if (!_console) return;
    var fn = _console.warn ? _console.warn : _console.log;
    fn.apply(_console, arguments);
}
function $8ca3e4c5fdf5089f$var$createStore(storages, plugins, namespace) {
    if (!namespace) namespace = '';
    if (storages && !$8ca3e4c5fdf5089f$var$isList(storages)) storages = [
        storages
    ];
    if (plugins && !$8ca3e4c5fdf5089f$var$isList(plugins)) plugins = [
        plugins
    ];
    var namespacePrefix = namespace ? '__storejs_' + namespace + '_' : '';
    var namespaceRegexp = namespace ? new RegExp('^' + namespacePrefix) : null;
    var legalNamespaces = /^[a-zA-Z0-9_\-]*$/ // alpha-numeric + underscore and dash
    ;
    if (!legalNamespaces.test(namespace)) throw new Error('store.js namespaces can only have alphanumerics + underscores and dashes');
    var _privateStoreProps = {
        _namespacePrefix: namespacePrefix,
        _namespaceRegexp: namespaceRegexp,
        _testStorage: function(storage) {
            try {
                var testStr = '__storejs__test__';
                storage.write(testStr, testStr);
                var ok = storage.read(testStr) === testStr;
                storage.remove(testStr);
                return ok;
            } catch (e) {
                return false;
            }
        },
        _assignPluginFnProp: function(pluginFnProp, propName) {
            var oldFn = this[propName];
            this[propName] = function pluginFn() {
                var args = $8ca3e4c5fdf5089f$var$slice(arguments, 0);
                var self = this;
                // super_fn calls the old function which was overwritten by
                // this mixin.
                function super_fn() {
                    if (!oldFn) return;
                    $8ca3e4c5fdf5089f$var$each(arguments, function(arg, i) {
                        args[i] = arg;
                    });
                    return oldFn.apply(self, args);
                }
                // Give mixing function access to super_fn by prefixing all mixin function
                // arguments with super_fn.
                var newFnArgs = [
                    super_fn
                ].concat(args);
                return pluginFnProp.apply(self, newFnArgs);
            };
        },
        _serialize: function(obj) {
            return JSON.stringify(obj);
        },
        _deserialize: function(strVal, defaultVal) {
            if (!strVal) return defaultVal;
            // It is possible that a raw string value has been previously stored
            // in a storage without using store.js, meaning it will be a raw
            // string value instead of a JSON serialized string. By defaulting
            // to the raw string value in case of a JSON parse error, we allow
            // for past stored values to be forwards-compatible with store.js
            var val = '';
            try {
                val = JSON.parse(strVal);
            } catch (e) {
                val = strVal;
            }
            return val !== undefined ? val : defaultVal;
        },
        _addStorage: function(storage) {
            if (this.enabled) return;
            if (this._testStorage(storage)) {
                this.storage = storage;
                this.enabled = true;
            }
        },
        _addPlugin: function(plugin) {
            var self = this;
            // If the plugin is an array, then add all plugins in the array.
            // This allows for a plugin to depend on other plugins.
            if ($8ca3e4c5fdf5089f$var$isList(plugin)) {
                $8ca3e4c5fdf5089f$var$each(plugin, function(plugin) {
                    self._addPlugin(plugin);
                });
                return;
            }
            // Keep track of all plugins we've seen so far, so that we
            // don't add any of them twice.
            var seenPlugin = $8ca3e4c5fdf5089f$var$pluck(this.plugins, function(seenPlugin) {
                return plugin === seenPlugin;
            });
            if (seenPlugin) return;
            this.plugins.push(plugin);
            // Check that the plugin is properly formed
            if (!$8ca3e4c5fdf5089f$var$isFunction(plugin)) throw new Error('Plugins must be function values that return objects');
            var pluginProperties = plugin.call(this);
            if (!$8ca3e4c5fdf5089f$var$isObject(pluginProperties)) throw new Error('Plugins must return an object of function properties');
            // Add the plugin function properties to this store instance.
            $8ca3e4c5fdf5089f$var$each(pluginProperties, function(pluginFnProp, propName) {
                if (!$8ca3e4c5fdf5089f$var$isFunction(pluginFnProp)) throw new Error('Bad plugin property: ' + propName + ' from plugin ' + plugin.name + '. Plugins should only return functions.');
                self._assignPluginFnProp(pluginFnProp, propName);
            });
        },
        // Put deprecated properties in the private API, so as to not expose it to accidential
        // discovery through inspection of the store object.
        // Deprecated: addStorage
        addStorage: function(storage) {
            $8ca3e4c5fdf5089f$var$_warn('store.addStorage(storage) is deprecated. Use createStore([storages])');
            this._addStorage(storage);
        }
    };
    var store = $8ca3e4c5fdf5089f$var$create(_privateStoreProps, $8ca3e4c5fdf5089f$var$storeAPI, {
        plugins: []
    });
    store.raw = {};
    $8ca3e4c5fdf5089f$var$each(store, function(prop, propName) {
        if ($8ca3e4c5fdf5089f$var$isFunction(prop)) store.raw[propName] = $8ca3e4c5fdf5089f$var$bind(store, prop);
    });
    $8ca3e4c5fdf5089f$var$each(storages, function(storage) {
        store._addStorage(storage);
    });
    $8ca3e4c5fdf5089f$var$each(plugins, function(plugin) {
        store._addPlugin(plugin);
    });
    return store;
}

});
parcelRegister("dgvY6", function(module, exports) {
var $9a85913e079cf886$var$assign = $9a85913e079cf886$var$make_assign();
var $9a85913e079cf886$var$create = $9a85913e079cf886$var$make_create();
var $9a85913e079cf886$var$trim = $9a85913e079cf886$var$make_trim();
var $9a85913e079cf886$var$Global = typeof window !== 'undefined' ? window : $parcel$global;
module.exports = {
    assign: $9a85913e079cf886$var$assign,
    create: $9a85913e079cf886$var$create,
    trim: $9a85913e079cf886$var$trim,
    bind: $9a85913e079cf886$var$bind,
    slice: $9a85913e079cf886$var$slice,
    each: $9a85913e079cf886$var$each,
    map: $9a85913e079cf886$var$map,
    pluck: $9a85913e079cf886$var$pluck,
    isList: $9a85913e079cf886$var$isList,
    isFunction: $9a85913e079cf886$var$isFunction,
    isObject: $9a85913e079cf886$var$isObject,
    Global: $9a85913e079cf886$var$Global
};
function $9a85913e079cf886$var$make_assign() {
    if (Object.assign) return Object.assign;
    else return function shimAssign(obj, props1, props2, etc) {
        for(var i = 1; i < arguments.length; i++)$9a85913e079cf886$var$each(Object(arguments[i]), function(val, key) {
            obj[key] = val;
        });
        return obj;
    };
}
function $9a85913e079cf886$var$make_create() {
    if (Object.create) return function create(obj, assignProps1, assignProps2, etc) {
        var assignArgsList = $9a85913e079cf886$var$slice(arguments, 1);
        return $9a85913e079cf886$var$assign.apply(this, [
            Object.create(obj)
        ].concat(assignArgsList));
    };
    else {
        function F() {} // eslint-disable-line no-inner-declarations
        return function create(obj, assignProps1, assignProps2, etc) {
            var assignArgsList = $9a85913e079cf886$var$slice(arguments, 1);
            F.prototype = obj;
            return $9a85913e079cf886$var$assign.apply(this, [
                new F()
            ].concat(assignArgsList));
        };
    }
}
function $9a85913e079cf886$var$make_trim() {
    if (String.prototype.trim) return function trim(str) {
        return String.prototype.trim.call(str);
    };
    else return function trim(str) {
        return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
    };
}
function $9a85913e079cf886$var$bind(obj, fn) {
    return function() {
        return fn.apply(obj, Array.prototype.slice.call(arguments, 0));
    };
}
function $9a85913e079cf886$var$slice(arr, index) {
    return Array.prototype.slice.call(arr, index || 0);
}
function $9a85913e079cf886$var$each(obj, fn) {
    $9a85913e079cf886$var$pluck(obj, function(val, key) {
        fn(val, key);
        return false;
    });
}
function $9a85913e079cf886$var$map(obj, fn) {
    var res = $9a85913e079cf886$var$isList(obj) ? [] : {};
    $9a85913e079cf886$var$pluck(obj, function(v, k) {
        res[k] = fn(v, k);
        return false;
    });
    return res;
}
function $9a85913e079cf886$var$pluck(obj, fn) {
    if ($9a85913e079cf886$var$isList(obj)) for(var i = 0; i < obj.length; i++){
        if (fn(obj[i], i)) return obj[i];
    }
    else {
        for(var key in obj)if (obj.hasOwnProperty(key)) {
            if (fn(obj[key], key)) return obj[key];
        }
    }
}
function $9a85913e079cf886$var$isList(val) {
    return val != null && typeof val != 'function' && typeof val.length == 'number';
}
function $9a85913e079cf886$var$isFunction(val) {
    return val && ({}).toString.call(val) === '[object Function]';
}
function $9a85913e079cf886$var$isObject(val) {
    return val && ({}).toString.call(val) === '[object Object]';
}

});


parcelRegister("4Zgux", function(module, exports) {

var $dgvY6 = parcelRequire("dgvY6");
var $3a19a6cea530455f$var$Global = $dgvY6.Global;
module.exports = {
    name: 'localStorage',
    read: $3a19a6cea530455f$var$read,
    write: $3a19a6cea530455f$var$write,
    each: $3a19a6cea530455f$var$each,
    remove: $3a19a6cea530455f$var$remove,
    clearAll: $3a19a6cea530455f$var$clearAll
};
function $3a19a6cea530455f$var$localStorage() {
    return $3a19a6cea530455f$var$Global.localStorage;
}
function $3a19a6cea530455f$var$read(key) {
    return $3a19a6cea530455f$var$localStorage().getItem(key);
}
function $3a19a6cea530455f$var$write(key, data) {
    return $3a19a6cea530455f$var$localStorage().setItem(key, data);
}
function $3a19a6cea530455f$var$each(fn) {
    for(var i = $3a19a6cea530455f$var$localStorage().length - 1; i >= 0; i--){
        var key = $3a19a6cea530455f$var$localStorage().key(i);
        fn($3a19a6cea530455f$var$read(key), key);
    }
}
function $3a19a6cea530455f$var$remove(key) {
    return $3a19a6cea530455f$var$localStorage().removeItem(key);
}
function $3a19a6cea530455f$var$clearAll() {
    return $3a19a6cea530455f$var$localStorage().clear();
}

});

parcelRegister("2NjNT", function(module, exports) {
// memoryStorage is a useful last fallback to ensure that the store
// is functions (meaning store.get(), store.set(), etc will all function).
// However, stored values will not persist when the browser navigates to
// a new page or reloads the current page.
module.exports = {
    name: 'memoryStorage',
    read: $208f84ff41bcb720$var$read,
    write: $208f84ff41bcb720$var$write,
    each: $208f84ff41bcb720$var$each,
    remove: $208f84ff41bcb720$var$remove,
    clearAll: $208f84ff41bcb720$var$clearAll
};
var $208f84ff41bcb720$var$memoryStorage = {};
function $208f84ff41bcb720$var$read(key) {
    return $208f84ff41bcb720$var$memoryStorage[key];
}
function $208f84ff41bcb720$var$write(key, data) {
    $208f84ff41bcb720$var$memoryStorage[key] = data;
}
function $208f84ff41bcb720$var$each(callback) {
    for(var key in $208f84ff41bcb720$var$memoryStorage)if ($208f84ff41bcb720$var$memoryStorage.hasOwnProperty(key)) callback($208f84ff41bcb720$var$memoryStorage[key], key);
}
function $208f84ff41bcb720$var$remove(key) {
    delete $208f84ff41bcb720$var$memoryStorage[key];
}
function $208f84ff41bcb720$var$clearAll(key) {
    $208f84ff41bcb720$var$memoryStorage = {};
}

});

parcelRegister("561FV", function(module, exports) {

var $kBZUL = parcelRequire("kBZUL");

var $abMfl = parcelRequire("abMfl");
/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */ function $3b5ecfeebeaba989$var$has(object, path) {
    return object != null && $abMfl(object, path, $kBZUL);
}
module.exports = $3b5ecfeebeaba989$var$has;

});
parcelRegister("kBZUL", function(module, exports) {
/** Used for built-in method references. */ var $f0174a4434851129$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f0174a4434851129$var$hasOwnProperty = $f0174a4434851129$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $f0174a4434851129$var$baseHas(object, key) {
    return object != null && $f0174a4434851129$var$hasOwnProperty.call(object, key);
}
module.exports = $f0174a4434851129$var$baseHas;

});


parcelRegister("9SRAA", function(module, exports) {

var $183uB = parcelRequire("183uB");

var $e0aIo = parcelRequire("e0aIo");

var $8pgNR = parcelRequire("8pgNR");
/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $7322b9dc1e5079b9$var$flatRest(func) {
    return $8pgNR($e0aIo(func, undefined, $183uB), func + '');
}
module.exports = $7322b9dc1e5079b9$var$flatRest;

});

parcelRegister("84Tib", function(module, exports) {

var $beQoo = parcelRequire("beQoo");

var $fC1Kz = parcelRequire("fC1Kz");
/** `Object#toString` result references. */ var $5e19965b98ae8a50$var$boolTag = '[object Boolean]';
/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */ function $5e19965b98ae8a50$var$isBoolean(value) {
    return value === true || value === false || $fC1Kz(value) && $beQoo(value) == $5e19965b98ae8a50$var$boolTag;
}
module.exports = $5e19965b98ae8a50$var$isBoolean;

});

parcelRegister("duUGa", function(module, exports) {

$parcel$export(module.exports, "UFOExperience", () => $785cd7675432925d$export$c00d22927c60484a);

var $4wnip = parcelRequire("4wnip");
class $785cd7675432925d$export$c00d22927c60484a extends (0, $4wnip.UFOAbstractExperience) {
}

});

parcelRegister("dMEgP", function(module, exports) {

var $2MIs9 = parcelRequire("2MIs9");

var $66FNL = parcelRequire("66FNL");
/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */ function $a08efee9347d14dc$var$values(object) {
    return object == null ? [] : $2MIs9(object, $66FNL(object));
}
module.exports = $a08efee9347d14dc$var$values;

});
parcelRegister("2MIs9", function(module, exports) {

var $1nIHN = parcelRequire("1nIHN");
/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */ function $20728bee5205c23b$var$baseValues(object, props) {
    return $1nIHN(props, function(key) {
        return object[key];
    });
}
module.exports = $20728bee5205c23b$var$baseValues;

});


parcelRegister("ebyGx", function(module, exports) {

$parcel$export(module.exports, "extract", () => $a53cff7e93c16c2c$export$f9380c9a627682d3, (v) => $a53cff7e93c16c2c$export$f9380c9a627682d3 = v);
$parcel$export(module.exports, "parse", () => $a53cff7e93c16c2c$export$98e6a39c04603d36, (v) => $a53cff7e93c16c2c$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "stringify", () => $a53cff7e93c16c2c$export$fac44ee5b035f737, (v) => $a53cff7e93c16c2c$export$fac44ee5b035f737 = v);
$parcel$export(module.exports, "parseUrl", () => $a53cff7e93c16c2c$export$7a5253c0f62e0150, (v) => $a53cff7e93c16c2c$export$7a5253c0f62e0150 = v);
var $a53cff7e93c16c2c$export$f9380c9a627682d3;
var $a53cff7e93c16c2c$export$98e6a39c04603d36;
var $a53cff7e93c16c2c$export$fac44ee5b035f737;
var $a53cff7e93c16c2c$export$7a5253c0f62e0150;
'use strict';

var $2kldK = parcelRequire("2kldK");

var $9rcQv = parcelRequire("9rcQv");

var $aCrRe = parcelRequire("aCrRe");
function $a53cff7e93c16c2c$var$encoderForArrayFormat(opts) {
    switch(opts.arrayFormat){
        case 'index':
            return function(key, value, index) {
                return value === null ? [
                    $a53cff7e93c16c2c$var$encode(key, opts),
                    '[',
                    index,
                    ']'
                ].join('') : [
                    $a53cff7e93c16c2c$var$encode(key, opts),
                    '[',
                    $a53cff7e93c16c2c$var$encode(index, opts),
                    ']=',
                    $a53cff7e93c16c2c$var$encode(value, opts)
                ].join('');
            };
        case 'bracket':
            return function(key, value) {
                return value === null ? $a53cff7e93c16c2c$var$encode(key, opts) : [
                    $a53cff7e93c16c2c$var$encode(key, opts),
                    '[]=',
                    $a53cff7e93c16c2c$var$encode(value, opts)
                ].join('');
            };
        default:
            return function(key, value) {
                return value === null ? $a53cff7e93c16c2c$var$encode(key, opts) : [
                    $a53cff7e93c16c2c$var$encode(key, opts),
                    '=',
                    $a53cff7e93c16c2c$var$encode(value, opts)
                ].join('');
            };
    }
}
function $a53cff7e93c16c2c$var$parserForArrayFormat(opts) {
    var result;
    switch(opts.arrayFormat){
        case 'index':
            return function(key, value, accumulator) {
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case 'bracket':
            return function(key, value, accumulator) {
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                } else if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        default:
            return function(key, value, accumulator) {
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $a53cff7e93c16c2c$var$encode(value, opts) {
    if (opts.encode) return opts.strict ? $2kldK(value) : encodeURIComponent(value);
    return value;
}
function $a53cff7e93c16c2c$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    else if (typeof input === 'object') return $a53cff7e93c16c2c$var$keysSorter(Object.keys(input)).sort(function(a, b) {
        return Number(a) - Number(b);
    }).map(function(key) {
        return input[key];
    });
    return input;
}
function $a53cff7e93c16c2c$var$extract(str) {
    var queryStart = str.indexOf('?');
    if (queryStart === -1) return '';
    return str.slice(queryStart + 1);
}
function $a53cff7e93c16c2c$var$parse(str, opts) {
    opts = $9rcQv({
        arrayFormat: 'none'
    }, opts);
    var formatter = $a53cff7e93c16c2c$var$parserForArrayFormat(opts);
    // Create an object with no prototype
    // https://github.com/sindresorhus/query-string/issues/47
    var ret = Object.create(null);
    if (typeof str !== 'string') return ret;
    str = str.trim().replace(/^[?#&]/, '');
    if (!str) return ret;
    str.split('&').forEach(function(param) {
        var parts = param.replace(/\+/g, ' ').split('=');
        // Firefox (pre 40) decodes `%3D` to `=`
        // https://github.com/sindresorhus/query-string/pull/37
        var key = parts.shift();
        var val = parts.length > 0 ? parts.join('=') : undefined;
        // missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        val = val === undefined ? null : $aCrRe(val);
        formatter($aCrRe(key), val, ret);
    });
    return Object.keys(ret).sort().reduce(function(result, key) {
        var val = ret[key];
        if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) // Sort object keys, not values
        result[key] = $a53cff7e93c16c2c$var$keysSorter(val);
        else result[key] = val;
        return result;
    }, Object.create(null));
}
$a53cff7e93c16c2c$export$f9380c9a627682d3 = $a53cff7e93c16c2c$var$extract;
$a53cff7e93c16c2c$export$98e6a39c04603d36 = $a53cff7e93c16c2c$var$parse;
$a53cff7e93c16c2c$export$fac44ee5b035f737 = function(obj, opts) {
    var defaults = {
        encode: true,
        strict: true,
        arrayFormat: 'none'
    };
    opts = $9rcQv(defaults, opts);
    if (opts.sort === false) opts.sort = function() {};
    var formatter = $a53cff7e93c16c2c$var$encoderForArrayFormat(opts);
    return obj ? Object.keys(obj).sort(opts.sort).map(function(key) {
        var val = obj[key];
        if (val === undefined) return '';
        if (val === null) return $a53cff7e93c16c2c$var$encode(key, opts);
        if (Array.isArray(val)) {
            var result = [];
            val.slice().forEach(function(val2) {
                if (val2 === undefined) return;
                result.push(formatter(key, val2, result.length));
            });
            return result.join('&');
        }
        return $a53cff7e93c16c2c$var$encode(key, opts) + '=' + $a53cff7e93c16c2c$var$encode(val, opts);
    }).filter(function(x) {
        return x.length > 0;
    }).join('&') : '';
};
$a53cff7e93c16c2c$export$7a5253c0f62e0150 = function(str, opts) {
    return {
        url: str.split('?')[0] || '',
        query: $a53cff7e93c16c2c$var$parse($a53cff7e93c16c2c$var$extract(str), opts)
    };
};

});
parcelRegister("2kldK", function(module, exports) {
'use strict';
module.exports = function(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
};

});

parcelRegister("9rcQv", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $6df099941a738cfd$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $6df099941a738cfd$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $6df099941a738cfd$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $6df099941a738cfd$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $6df099941a738cfd$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $6df099941a738cfd$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $6df099941a738cfd$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($6df099941a738cfd$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($6df099941a738cfd$var$getOwnPropertySymbols) {
            symbols = $6df099941a738cfd$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($6df099941a738cfd$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});


parcelRegister("4zICj", function(module, exports) {

$parcel$export(module.exports, "choreographerFactory", () => $66410bab62c95f4d$export$55d2aeb17c4cfbe);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $TTRxY = parcelRequire("TTRxY");

var $atotX = parcelRequire("atotX");

var $2Mf0U = parcelRequire("2Mf0U");
var $cA3S0 = parcelRequire("cA3S0");
var $aUNbN = parcelRequire("aUNbN");
var $lVEk7 = parcelRequire("lVEk7");
var $bNT5z = parcelRequire("bNT5z");
var $gVhsA = parcelRequire("gVhsA");
var $8ekle = parcelRequire("8ekle");
var $kmPbm = parcelRequire("kmPbm");
var $by50B = parcelRequire("by50B");
var $9Pw7n = parcelRequire("9Pw7n");
function $66410bab62c95f4d$export$55d2aeb17c4cfbe(productId, env, metaMetricsData = {}, choreographerOptions = {
    enableChoreographer: true
}) {
    // Instantiate our plugin instance, passing the productId through for segmenting any messageId's from any other plugins
    const plugin = new (0, $atotX.ProductChoreographerPlugin)(productId, env, metaMetricsData);
    /**
	 * React hook that provides startMessage and stopMessage functions that call through the plugin API with the provided messageId, for easy assignment to React event handlers.
	 *
	 * @param messageId The messageId to be provided to the choreographer API whenever the startMessage and stopMessage callbacks are invoked.
	 * @param startCallback A callback to be used to set local state that determines whether a message should be shown, e.g. a callback to a useState setter, or that dispatches to a reducer function.
	 * @param stopCallback A callback to be used to set local state that determines whether a message should be hidden, e.g. a callback to a useState setter, or that dispatches to a reducer function.
	 * @returns An object with startMessage and stopMessage callbacks, which contain references to the messageId to be passed to the choreographer API, so that the consumer no longer needs to specify that at call time.
	 */ const useChoreographer = (messageId, { [(0, $TTRxY.MessageEventType).START]: startCallback, [(0, $TTRxY.MessageEventType).STOP]: stopCallback } = {})=>{
        const isMessageStarted = (0, $5uXOq.useRef)(false);
        const startRef = (0, $5uXOq.useRef)(startCallback);
        const stopRef = (0, $5uXOq.useRef)(stopCallback);
        // Callback that uses a ref to track any changes in the received startCallback parameter, so the caller doesn't have to worry about memoization
        const startMessageCallback = (0, $5uXOq.useCallback)(async (...args)=>{
            const didMessageStart = await startRef.current?.(...args) ?? true;
            isMessageStarted.current = didMessageStart;
            return didMessageStart;
        }, [
            isMessageStarted
        ]);
        // Stable function reference that invokes the plugin's startMessage function, for use in components.
        const startMessage = (0, $5uXOq.useCallback)((...args)=>{
            plugin.onStart(messageId, ()=>startMessageCallback(...args));
            return plugin.startMessage(messageId);
        }, [
            messageId,
            startMessageCallback
        ]);
        // Callback that uses a ref to track any changes in the received stopCallback parameter, so the caller doesn't have to worry about memoization
        const stopMessageCallback = (0, $5uXOq.useCallback)(async (...args)=>{
            const didMessageStop = await stopRef.current?.(...args) ?? true;
            isMessageStarted.current = !didMessageStop;
            return didMessageStop;
        }, [
            isMessageStarted
        ]);
        // Stable function reference that invokes the plugin's stopMessage function, for use in components.
        const stopMessage = (0, $5uXOq.useCallback)((...args)=>{
            if (isMessageStarted.current) {
                plugin.onStop(messageId, ()=>stopMessageCallback(...args));
                return plugin.stopMessage(messageId);
            }
            return Promise.resolve((0, $TTRxY.MessageDeliveryStatus).STOPPED);
        }, [
            isMessageStarted,
            messageId,
            stopMessageCallback
        ]);
        // Stable function reference that invokes whichever start or stop handler is appropriate for the message's current display state.
        // Tracking this state with a ref allows us to know the current display state in real-time, so that potentially subsequent calls
        // can be made to toggle its state, without requiring tracking a useState value and requiring rerenders to update the callback
        // with the latest display state, and without generating false blocked messages from cached/outdated toggleMessage references.
        const toggleMessage = (0, $5uXOq.useCallback)(()=>{
            return isMessageStarted.current ? stopMessage() : startMessage();
        }, [
            isMessageStarted,
            startMessage,
            stopMessage
        ]);
        // Syncs any incoming startCallback and stopCallback functions as the latest version to be invoked when a startMessage or stopMessage call is issued through the choreographer API
        (0, $5uXOq.useLayoutEffect)(()=>{
            startRef.current = startCallback;
            stopRef.current = stopCallback;
        }, [
            startCallback,
            stopCallback
        ]);
        /**
		 * At component mount, we want to default a start and stop function, which invokes these functions with no additional parameters,
		 * just to supply some sane defaults. If startMessage or stopMessage are called explicitly, they can optionally supply some extra
		 * parameters, at which point, a just-in-time registration of a new callback version will be supplied to the choreographer, which
		 * will proxy those parameter through to the target state-setter functions. But if they are not called explicitly, such as in the
		 * case where a message is started and never stopped, and is timed out from the Choreographer, we want to have a default version
		 * available to execute against.
		 *
		 * At component unmount, stop the current message, if it's displayed, and unsubscribe the stop callback for this messageId within
		 * the plugin.
		 */ (0, $5uXOq.useLayoutEffect)(()=>{
            plugin.on(messageId, {
                start: async ()=>{
                    return await startMessage() === (0, $TTRxY.MessageDeliveryStatus).STARTED;
                },
                stop: async ()=>{
                    return await stopMessage() === (0, $TTRxY.MessageDeliveryStatus).STOPPED;
                }
            });
            return ()=>{
                // If unsubscribing, fire the stopMessageCallback one last time to ensure the component can clear the local state responsible for displaying its message
                stopMessage(messageId);
                plugin.off(messageId);
            };
        }, [
            messageId,
            startMessage,
            stopMessage
        ]);
        // Return the wrapped startMessage and stopMessage functions to the consumer, which will route their requests through the choreographer API with the messageId proxied straight through on behalf of the caller
        return (0, $5uXOq.useMemo)(()=>({
                startMessage: startMessage,
                stopMessage: stopMessage,
                toggleMessage: toggleMessage
            }), [
            startMessage,
            stopMessage,
            toggleMessage
        ]);
    };
    const shouldBeChoreographed = (props)=>{
        return (0, $kmPbm.shouldBeChoreographed)(props, choreographerOptions);
    };
    const useChoreographedRender = ({ messageId: messageId, onMessageDisposition: onMessageDisposition })=>{
        const [shouldRender, setShouldRender] = (0, $5uXOq.useState)(false);
        const { startMessage: startMessage, stopMessage: stopMessage } = useChoreographer(messageId, {
            start: ()=>setShouldRender(true),
            stop: ()=>setShouldRender(false)
        });
        (0, $5uXOq.useLayoutEffect)(()=>{
            const startMessageAsync = async ()=>{
                const disposition = await startMessage();
                onMessageDisposition?.(disposition);
            };
            const stopMessageAsync = async ()=>{
                const disposition = await stopMessage();
                onMessageDisposition?.(disposition);
            };
            startMessageAsync();
            return ()=>void stopMessageAsync();
        }, [
            messageId,
            onMessageDisposition,
            startMessage,
            stopMessage
        ]);
        return shouldRender;
    };
    const withChoreographedRender = (Component)=>{
        function ChoreographedComponent({ messageId: messageId, onMessageDisposition: onMessageDisposition, ...props }) {
            const shouldRender = useChoreographedRender({
                messageId: messageId,
                onMessageDisposition: onMessageDisposition
            });
            if (shouldRender) // Need to cast "props" as unknown to avoid TS error because it can't infer that
            // Omit<ChoreographedComponentProps & T, "messageId" | "onMessageDisposition"> is the same as T
            return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                ...props
            });
            return null;
        }
        ChoreographedComponent.displayName = `Choreographed${Component.displayName ?? 'Component'}`;
        return ChoreographedComponent;
    };
    const withChoreographedToggle = (Component, toggleableProp)=>{
        function ChoreographedComponent({ messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest }) {
            // Need to cast "rest" as unknown to avoid TS error because it can't infer that
            // Omit<ChoreographedComponentProps & T, "messageId" | "onMessageDisposition"> is the same as T
            const props = rest;
            const toggleablePropValue = props[toggleableProp];
            const [shouldRender, setShouldRender] = (0, $5uXOq.useState)(false);
            const { startMessage: startMessage, stopMessage: stopMessage } = useChoreographer(messageId, {
                start: ()=>setShouldRender(true),
                stop: ()=>setShouldRender(false)
            });
            (0, $5uXOq.useLayoutEffect)(()=>{
                const startMessageAsync = async ()=>{
                    const disposition = await startMessage();
                    onMessageDisposition?.(disposition);
                };
                const stopMessageAsync = async ()=>{
                    const disposition = await stopMessage();
                    onMessageDisposition?.(disposition);
                };
                if (toggleablePropValue && !shouldRender) startMessageAsync();
                else if (!toggleablePropValue && shouldRender) stopMessageAsync();
                return ()=>{
                    if (!toggleablePropValue && shouldRender) stopMessageAsync();
                };
            }, [
                messageId,
                onMessageDisposition,
                shouldRender,
                startMessage,
                stopMessage,
                toggleablePropValue
            ]);
            return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                ...props,
                [toggleableProp]: shouldRender
            });
        }
        return ChoreographedComponent;
    };
    function wrapWithFactoryFunctions(MaybeChoreographedComponent) {
        function Component(props) {
            return /*#__PURE__*/ (0, $2OMIu.jsx)(MaybeChoreographedComponent, {
                ...props,
                shouldBeChoreographed: shouldBeChoreographed,
                withChoreographedRender: withChoreographedRender
            });
        }
        Component.displayName = MaybeChoreographedComponent.displayName = `ChoreographerFactory(${MaybeChoreographedComponent.displayName})`;
        return Component;
    }
    function wrapWithToggleFactoryFunctions(MaybeChoreographedComponent) {
        function Component(props) {
            return /*#__PURE__*/ (0, $2OMIu.jsx)(MaybeChoreographedComponent, {
                ...props,
                shouldBeChoreographed: shouldBeChoreographed,
                withChoreographedToggle: withChoreographedToggle
            });
        }
        Component.displayName = MaybeChoreographedComponent.displayName = `ChoreographerFactory(${MaybeChoreographedComponent.displayName})`;
        return Component;
    }
    const AutoDismissFlag = wrapWithFactoryFunctions((0, $2Mf0U.AutoDismissFlag));
    const Banner = wrapWithFactoryFunctions((0, $cA3S0.Banner));
    const Flag = wrapWithFactoryFunctions((0, $aUNbN.Flag));
    const Modal = wrapWithFactoryFunctions((0, $bNT5z.Modal));
    const Popper = wrapWithFactoryFunctions((0, $gVhsA.Popper));
    const Spotlight = wrapWithFactoryFunctions((0, $by50B.Spotlight));
    const SpotlightCard = wrapWithFactoryFunctions((0, $9Pw7n.SpotlightCard));
    const InlineDialog = wrapWithToggleFactoryFunctions((0, $lVEk7.InlineDialog));
    // Would ideally like to use wrapWithToggleFactoryFunctions here, but the Popup component's props is a union
    // type, and that for some reason causes ToggleableChoreographerUtilities to be passed through to the
    // consumer-exposed Popup component's prop type, which is not what we want, so we'll just wrap it manually here
    const Popup = function() {
        function WrappedPopup(props) {
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8ekle.Popup), {
                ...props,
                shouldBeChoreographed: shouldBeChoreographed,
                withChoreographedToggle: withChoreographedToggle
            });
        }
        WrappedPopup.displayName = `ChoreographerFactory(${(0, $8ekle.Popup).displayName})`;
        return WrappedPopup;
    }();
    // Return these items from the factory function for use within React products
    return {
        plugin: plugin,
        useChoreographer: useChoreographer,
        shouldBeChoreographed: shouldBeChoreographed,
        useChoreographedRender: useChoreographedRender,
        withChoreographedRender: withChoreographedRender,
        withChoreographedToggle: withChoreographedToggle,
        AutoDismissFlag: AutoDismissFlag,
        Banner: Banner,
        Flag: Flag,
        InlineDialog: InlineDialog,
        Modal: Modal,
        Popper: Popper,
        Popup: Popup,
        Spotlight: Spotlight,
        SpotlightCard: SpotlightCard
    };
}

});
parcelRegister("atotX", function(module, exports) {

$parcel$export(module.exports, "ProductChoreographerPlugin", () => $5652f56fa664d481$export$44bee9c9373d59fb);

var $4YUjU = parcelRequire("4YUjU");
class $5652f56fa664d481$export$44bee9c9373d59fb extends (0, $4YUjU.ChoreographerPlugin) {
    constructor(product, env, metaMetricsData = {}){
        super(product, env, metaMetricsData);
    }
}

});

parcelRegister("2Mf0U", function(module, exports) {

$parcel$export(module.exports, "AutoDismissFlag", () => $2d28883873c8f74f$export$9879a8e0db317538);

var $fWXJB = parcelRequire("fWXJB");

var $kmPbm = parcelRequire("kmPbm");
const $2d28883873c8f74f$export$9879a8e0db317538 = (0, $kmPbm.wrapComponentForChoreographer)((0, $fWXJB.default));

});

parcelRegister("cA3S0", function(module, exports) {

$parcel$export(module.exports, "Banner", () => $403a80a08d6d2f6a$export$3b4e64e77073e307);

var $lkmWu = parcelRequire("lkmWu");

var $kmPbm = parcelRequire("kmPbm");
const $403a80a08d6d2f6a$export$3b4e64e77073e307 = (0, $kmPbm.wrapComponentForChoreographer)((0, $lkmWu.default));

});

parcelRegister("aUNbN", function(module, exports) {

$parcel$export(module.exports, "Flag", () => $4e5c7ea548d20989$export$48ea269755562084);

var $epfFv = parcelRequire("epfFv");

var $kmPbm = parcelRequire("kmPbm");
const $4e5c7ea548d20989$export$48ea269755562084 = (0, $kmPbm.wrapComponentForChoreographer)((0, $epfFv.default));

});

parcelRegister("lVEk7", function(module, exports) {

$parcel$export(module.exports, "InlineDialog", () => $c56e25d30c4b39ec$export$c7313f750e9cbc9d);

var $ctg8C = parcelRequire("ctg8C");

var $kmPbm = parcelRequire("kmPbm");
const $c56e25d30c4b39ec$export$c7313f750e9cbc9d = (0, $kmPbm.wrapToggleableComponentForChoreographer)((0, $ctg8C.default), 'isOpen');

});

parcelRegister("bNT5z", function(module, exports) {

$parcel$export(module.exports, "Modal", () => $0650c9f08266e4ad$export$2b77a92f1a5ad772);

var $1R1Ge = parcelRequire("1R1Ge");

var $kmPbm = parcelRequire("kmPbm");
const $0650c9f08266e4ad$export$2b77a92f1a5ad772 = (0, $kmPbm.wrapComponentForChoreographer)((0, $1R1Ge.default));

});

parcelRegister("gVhsA", function(module, exports) {

$parcel$export(module.exports, "Popper", () => $bdc96b866a7df877$export$badac9ada3a0bdf9);

var $4oNEb = parcelRequire("4oNEb");

var $kmPbm = parcelRequire("kmPbm");
const $bdc96b866a7df877$export$badac9ada3a0bdf9 = (0, $kmPbm.wrapComponentForChoreographer)((0, $4oNEb.Popper));

});

parcelRegister("8ekle", function(module, exports) {

$parcel$export(module.exports, "Popup", () => $fda7f9cfac28a5c8$export$129a32eedafa97c5);

var $1I7E8 = parcelRequire("1I7E8");

var $kmPbm = parcelRequire("kmPbm");
const $fda7f9cfac28a5c8$export$129a32eedafa97c5 = (0, $kmPbm.wrapToggleableComponentForChoreographer)((0, $1I7E8.Popup), 'isOpen');

});

parcelRegister("by50B", function(module, exports) {

$parcel$export(module.exports, "Spotlight", () => $13a98b6d24c00d08$export$1033c28b5e1c2deb);

var $7gs1W = parcelRequire("7gs1W");

var $kmPbm = parcelRequire("kmPbm");
const $13a98b6d24c00d08$export$1033c28b5e1c2deb = (0, $kmPbm.wrapComponentForChoreographer)((0, $7gs1W.default));

});

parcelRegister("9Pw7n", function(module, exports) {

$parcel$export(module.exports, "SpotlightCard", () => $ae524700441ee7eb$export$14710e13fc01d383);

var $5ujeO = parcelRequire("5ujeO");

var $kmPbm = parcelRequire("kmPbm");
const $ae524700441ee7eb$export$14710e13fc01d383 = (0, $kmPbm.wrapComponentForChoreographer)((0, $5ujeO.default));

});


parcelRegister("dI393", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1o9RP = parcelRequire("1o9RP");
Object.defineProperty(module.exports, 'default', {
    enumerable: true,
    get: function get() {
        return $9fb1d2f148532de5$var$_interopRequireDefault($1o9RP).default;
    }
});
function $9fb1d2f148532de5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("1o9RP", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $102fafc31c1e58cf$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");
function $102fafc31c1e58cf$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $102fafc31c1e58cf$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $102fafc31c1e58cf$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $102fafc31c1e58cf$var$NodeResolver = function(_Component) {
    $102fafc31c1e58cf$var$_inherits(NodeResolver, _Component);
    function NodeResolver() {
        $102fafc31c1e58cf$var$_classCallCheck(this, NodeResolver);
        return $102fafc31c1e58cf$var$_possibleConstructorReturn(this, (NodeResolver.__proto__ || Object.getPrototypeOf(NodeResolver)).apply(this, arguments));
    }
    $102fafc31c1e58cf$var$_createClass(NodeResolver, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.props.innerRef((0, $7nsd3.findDOMNode)(this));
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.props.innerRef(null);
            }
        },
        {
            key: 'render',
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return NodeResolver;
}($5uXOq.Component);
module.exports.default = $102fafc31c1e58cf$var$NodeResolver;

});


parcelRegister("ao4Ml", function(module, exports) {

$parcel$export(module.exports, "default", () => $78ffda35a3cd2a5c$export$2e2bcd8739ae039);

var $cIaXu = parcelRequire("cIaXu");

var $78ffda35a3cd2a5c$export$2e2bcd8739ae039 = (0, $cIaXu.default);

});
parcelRegister("cIaXu", function(module, exports) {

$parcel$export(module.exports, "default", () => $9412183d03dc0dc5$export$2e2bcd8739ae039);

var $ddEsc = parcelRequire("ddEsc");

var $bS32t = parcelRequire("bS32t");

var $5uXOq = parcelRequire("5uXOq");

var $iK0nX = parcelRequire("iK0nX");

var $1jdvF = parcelRequire("1jdvF");
var $9412183d03dc0dc5$var$FocusLockCombination = /*#__PURE__*/ $5uXOq.forwardRef(function FocusLockUICombination(props, ref) {
    return /*#__PURE__*/ $5uXOq.createElement((0, $iK0nX.default), (0, $bS32t.default)({
        sideCar: (0, $1jdvF.default),
        ref: ref
    }, props));
});
var $9412183d03dc0dc5$var$_ref = (0, $iK0nX.default).propTypes || {}, $9412183d03dc0dc5$var$sideCar = $9412183d03dc0dc5$var$_ref.sideCar, $9412183d03dc0dc5$var$propTypes = (0, $ddEsc.default)($9412183d03dc0dc5$var$_ref, [
    "sideCar"
]);
$9412183d03dc0dc5$var$FocusLockCombination.propTypes = {};
var $9412183d03dc0dc5$export$2e2bcd8739ae039 = $9412183d03dc0dc5$var$FocusLockCombination;

});
parcelRegister("iK0nX", function(module, exports) {

$parcel$export(module.exports, "default", () => $da4cd26ce8b7c545$export$2e2bcd8739ae039);

var $bS32t = parcelRequire("bS32t");

var $5uXOq = parcelRequire("5uXOq");


var $26Cgu = parcelRequire("26Cgu");

var $3Du7S = parcelRequire("3Du7S");

var $hs7HE = parcelRequire("hs7HE");

var $i2hbO = parcelRequire("i2hbO");

var $lTS5V = parcelRequire("lTS5V");
var $da4cd26ce8b7c545$var$emptyArray = [];
var $da4cd26ce8b7c545$var$FocusLock = /*#__PURE__*/ $5uXOq.forwardRef(function FocusLockUI(props, parentRef) {
    var _extends2;
    var _React$useState = $5uXOq.useState(), realObserved = _React$useState[0], setObserved = _React$useState[1];
    var observed = $5uXOq.useRef();
    var isActive = $5uXOq.useRef(false);
    var originalFocusedElement = $5uXOq.useRef(null);
    var _React$useState2 = $5uXOq.useState({}), update = _React$useState2[1];
    var children = props.children, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$noFocusGuards = props.noFocusGuards, noFocusGuards = _props$noFocusGuards === void 0 ? false : _props$noFocusGuards, _props$persistentFocu = props.persistentFocus, persistentFocus = _props$persistentFocu === void 0 ? false : _props$persistentFocu, _props$crossFrame = props.crossFrame, crossFrame = _props$crossFrame === void 0 ? true : _props$crossFrame, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, allowTextSelection = props.allowTextSelection, group = props.group, className = props.className, whiteList = props.whiteList, hasPositiveIndices = props.hasPositiveIndices, _props$shards = props.shards, shards = _props$shards === void 0 ? $da4cd26ce8b7c545$var$emptyArray : _props$shards, _props$as = props.as, Container = _props$as === void 0 ? 'div' : _props$as, _props$lockProps = props.lockProps, containerProps = _props$lockProps === void 0 ? {} : _props$lockProps, SideCar = props.sideCar, _props$returnFocus = props.returnFocus, shouldReturnFocus = _props$returnFocus === void 0 ? false : _props$returnFocus, focusOptions = props.focusOptions, onActivationCallback = props.onActivation, onDeactivationCallback = props.onDeactivation;
    var _React$useState3 = $5uXOq.useState({}), id = _React$useState3[0];
    var onActivation = $5uXOq.useCallback(function(_ref) {
        var captureFocusRestore = _ref.captureFocusRestore;
        if (!originalFocusedElement.current) {
            var _document;
            var activeElement = (_document = document) == null ? void 0 : _document.activeElement;
            originalFocusedElement.current = activeElement;
            if (activeElement !== document.body) originalFocusedElement.current = captureFocusRestore(activeElement);
        }
        if (observed.current && onActivationCallback) onActivationCallback(observed.current);
        isActive.current = true;
        update();
    }, [
        onActivationCallback
    ]);
    var onDeactivation = $5uXOq.useCallback(function() {
        isActive.current = false;
        if (onDeactivationCallback) onDeactivationCallback(observed.current);
        update();
    }, [
        onDeactivationCallback
    ]);
    var returnFocus = $5uXOq.useCallback(function(allowDefer) {
        var focusRestore = originalFocusedElement.current;
        if (focusRestore) {
            var returnFocusTo = (typeof focusRestore === 'function' ? focusRestore() : focusRestore) || document.body;
            var howToReturnFocus = typeof shouldReturnFocus === 'function' ? shouldReturnFocus(returnFocusTo) : shouldReturnFocus;
            if (howToReturnFocus) {
                var returnFocusOptions = typeof howToReturnFocus === 'object' ? howToReturnFocus : undefined;
                originalFocusedElement.current = null;
                if (allowDefer) Promise.resolve().then(function() {
                    return returnFocusTo.focus(returnFocusOptions);
                });
                else returnFocusTo.focus(returnFocusOptions);
            }
        }
    }, [
        shouldReturnFocus
    ]);
    var onFocus = $5uXOq.useCallback(function(event) {
        if (isActive.current) (0, $i2hbO.mediumFocus).useMedium(event);
    }, []);
    var onBlur = (0, $i2hbO.mediumBlur).useMedium;
    var setObserveNode = $5uXOq.useCallback(function(newObserved) {
        if (observed.current !== newObserved) {
            observed.current = newObserved;
            setObserved(newObserved);
        }
    }, []);
    var lockProps = (0, $bS32t.default)((_extends2 = {}, _extends2[$26Cgu.FOCUS_DISABLED] = disabled && 'disabled', _extends2[$26Cgu.FOCUS_GROUP] = group, _extends2), containerProps);
    var hasLeadingGuards = noFocusGuards !== true;
    var hasTailingGuards = hasLeadingGuards && noFocusGuards !== 'tail';
    var mergedRef = (0, $3Du7S.useMergeRefs)([
        parentRef,
        setObserveNode
    ]);
    var focusScopeValue = $5uXOq.useMemo(function() {
        return {
            observed: observed,
            shards: shards,
            enabled: !disabled,
            active: isActive.current
        };
    }, [
        disabled,
        isActive.current,
        shards,
        realObserved
    ]);
    return /*#__PURE__*/ $5uXOq.createElement($5uXOq.Fragment, null, hasLeadingGuards && [
        /*#__PURE__*/ $5uXOq.createElement("div", {
            key: "guard-first",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 0,
            style: (0, $hs7HE.hiddenGuard)
        }),
        hasPositiveIndices ? /*#__PURE__*/ $5uXOq.createElement("div", {
            key: "guard-nearest",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 1,
            style: (0, $hs7HE.hiddenGuard)
        }) : null
    ], !disabled && /*#__PURE__*/ $5uXOq.createElement(SideCar, {
        id: id,
        sideCar: (0, $i2hbO.mediumSidecar),
        observed: realObserved,
        disabled: disabled,
        persistentFocus: persistentFocus,
        crossFrame: crossFrame,
        autoFocus: autoFocus,
        whiteList: whiteList,
        shards: shards,
        onActivation: onActivation,
        onDeactivation: onDeactivation,
        returnFocus: returnFocus,
        focusOptions: focusOptions
    }), /*#__PURE__*/ $5uXOq.createElement(Container, (0, $bS32t.default)({
        ref: mergedRef
    }, lockProps, {
        className: className,
        onBlur: onBlur,
        onFocus: onFocus
    }), /*#__PURE__*/ $5uXOq.createElement((0, $lTS5V.focusScope).Provider, {
        value: focusScopeValue
    }, children)), hasTailingGuards && /*#__PURE__*/ $5uXOq.createElement("div", {
        "data-focus-guard": true,
        tabIndex: disabled ? -1 : 0,
        style: (0, $hs7HE.hiddenGuard)
    }));
});
$da4cd26ce8b7c545$var$FocusLock.propTypes = {};
var $da4cd26ce8b7c545$export$2e2bcd8739ae039 = $da4cd26ce8b7c545$var$FocusLock;

});
parcelRegister("26Cgu", function(module, exports) {

$parcel$export(module.exports, "FOCUS_GROUP", () => $1889d2ef999b3988$export$4f9a06cb7441a087);
$parcel$export(module.exports, "FOCUS_DISABLED", () => $1889d2ef999b3988$export$aeda8252e54b50f7);
$parcel$export(module.exports, "FOCUS_ALLOW", () => $1889d2ef999b3988$export$54ecf528c58f9ef6);
$parcel$export(module.exports, "FOCUS_AUTO", () => $1889d2ef999b3988$export$70e9b4a1820af101);
$parcel$export(module.exports, "FOCUS_NO_AUTOFOCUS", () => $1889d2ef999b3988$export$134ebef29fd94853);
/**
 * defines a focus group
 */ var $1889d2ef999b3988$export$4f9a06cb7441a087 = 'data-focus-lock';
var $1889d2ef999b3988$export$aeda8252e54b50f7 = 'data-focus-lock-disabled';
var $1889d2ef999b3988$export$54ecf528c58f9ef6 = 'data-no-focus-lock';
var $1889d2ef999b3988$export$70e9b4a1820af101 = 'data-autofocus-inside';
var $1889d2ef999b3988$export$134ebef29fd94853 = 'data-no-autofocus';

});

parcelRegister("3Du7S", function(module, exports) {

$parcel$export(module.exports, "useMergeRefs", () => $2a5c6201d8713c67$export$74665b213cb5c4cf);

var $5uXOq = parcelRequire("5uXOq");

var $dv0OY = parcelRequire("dv0OY");

var $5Gf1j = parcelRequire("5Gf1j");
const $2a5c6201d8713c67$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' ? $5uXOq.useLayoutEffect : $5uXOq.useEffect;
const $2a5c6201d8713c67$var$currentValues = new WeakMap();
function $2a5c6201d8713c67$export$74665b213cb5c4cf(refs, defaultValue) {
    const callbackRef = (0, $5Gf1j.useCallbackRef)(defaultValue || null, (newValue)=>refs.forEach((ref)=>(0, $dv0OY.assignRef)(ref, newValue)));
    // handle refs changes - added or removed
    $2a5c6201d8713c67$var$useIsomorphicLayoutEffect(()=>{
        const oldValue = $2a5c6201d8713c67$var$currentValues.get(callbackRef);
        if (oldValue) {
            const prevRefs = new Set(oldValue);
            const nextRefs = new Set(refs);
            const current = callbackRef.current;
            prevRefs.forEach((ref)=>{
                if (!nextRefs.has(ref)) (0, $dv0OY.assignRef)(ref, null);
            });
            nextRefs.forEach((ref)=>{
                if (!prevRefs.has(ref)) (0, $dv0OY.assignRef)(ref, current);
            });
        }
        $2a5c6201d8713c67$var$currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}

});
parcelRegister("dv0OY", function(module, exports) {

$parcel$export(module.exports, "assignRef", () => $9d3eceb3bd1bde87$export$d734136a7b018efe);
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $9d3eceb3bd1bde87$export$d734136a7b018efe(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
    return ref;
}

});

parcelRegister("5Gf1j", function(module, exports) {

$parcel$export(module.exports, "useCallbackRef", () => $422c86adb7367c4f$export$25bec8c6f54ee79a);

var $5uXOq = parcelRequire("5uXOq");
function $422c86adb7367c4f$export$25bec8c6f54ee79a(initialValue, callback) {
    const [ref] = (0, $5uXOq.useState)(()=>({
            // value
            value: initialValue,
            callback: // last callback
            callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    const last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        }));
    // update callback
    ref.callback = callback;
    return ref.facade;
}

});


parcelRegister("hs7HE", function(module, exports) {

$parcel$export(module.exports, "hiddenGuard", () => $cb4b06d97dec25c1$export$b8c7b07253306600);

var $5uXOq = parcelRequire("5uXOq");

var $cb4b06d97dec25c1$export$b8c7b07253306600 = {
    width: '1px',
    height: '0px',
    padding: 0,
    overflow: 'hidden',
    position: 'fixed',
    top: '1px',
    left: '1px'
};
var $cb4b06d97dec25c1$var$InFocusGuard = function InFocusGuard(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? null : _ref$children;
    return /*#__PURE__*/ $5uXOq.createElement($5uXOq.Fragment, null, /*#__PURE__*/ $5uXOq.createElement("div", {
        key: "guard-first",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $cb4b06d97dec25c1$export$b8c7b07253306600
    }), children, children && /*#__PURE__*/ $5uXOq.createElement("div", {
        key: "guard-last",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $cb4b06d97dec25c1$export$b8c7b07253306600
    }));
};
$cb4b06d97dec25c1$var$InFocusGuard.propTypes = {};
var $cb4b06d97dec25c1$export$2e2bcd8739ae039 = $cb4b06d97dec25c1$var$InFocusGuard;

});

parcelRegister("i2hbO", function(module, exports) {

$parcel$export(module.exports, "mediumFocus", () => $d215bf5dba6c52c4$export$5733e022b1d538cb);
$parcel$export(module.exports, "mediumBlur", () => $d215bf5dba6c52c4$export$b3e9a9312f73723c);
$parcel$export(module.exports, "mediumEffect", () => $d215bf5dba6c52c4$export$3a1d52767cbc07b8);
$parcel$export(module.exports, "mediumSidecar", () => $d215bf5dba6c52c4$export$892cbf28e5518020);

var $bzFTo = parcelRequire("bzFTo");
var $d215bf5dba6c52c4$export$5733e022b1d538cb = (0, $bzFTo.createMedium)({}, function(_ref) {
    var target = _ref.target, currentTarget = _ref.currentTarget;
    return {
        target: target,
        currentTarget: currentTarget
    };
});
var $d215bf5dba6c52c4$export$b3e9a9312f73723c = (0, $bzFTo.createMedium)();
var $d215bf5dba6c52c4$export$3a1d52767cbc07b8 = (0, $bzFTo.createMedium)();
var $d215bf5dba6c52c4$export$892cbf28e5518020 = (0, $bzFTo.createSidecarMedium)({
    async: true,
    ssr: typeof document !== 'undefined'
});

});
parcelRegister("bzFTo", function(module, exports) {

$parcel$export(module.exports, "createMedium", () => $86d3758a1af7e127$export$9ffbfcaf067b02c6);
$parcel$export(module.exports, "createSidecarMedium", () => $86d3758a1af7e127$export$e13ec7dd7a14088d);
function $86d3758a1af7e127$var$ItoI(a) {
    return a;
}
function $86d3758a1af7e127$var$innerCreateMedium(defaults, middleware = $86d3758a1af7e127$var$ItoI) {
    let buffer = [];
    let assigned = false;
    const medium = {
        read () {
            if (assigned) throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium (data) {
            const item = middleware(data, assigned);
            buffer.push(item);
            return ()=>{
                buffer = buffer.filter((x)=>x !== item);
            };
        },
        assignSyncMedium (cb) {
            assigned = true;
            while(buffer.length){
                const cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: (x)=>cb(x),
                filter: ()=>buffer
            };
        },
        assignMedium (cb) {
            assigned = true;
            let pendingQueue = [];
            if (buffer.length) {
                const cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            const executeQueue = ()=>{
                const cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            const cycle = ()=>Promise.resolve().then(executeQueue);
            cycle();
            buffer = {
                push: (x)=>{
                    pendingQueue.push(x);
                    cycle();
                },
                filter: (filter)=>{
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $86d3758a1af7e127$export$9ffbfcaf067b02c6(defaults, middleware = $86d3758a1af7e127$var$ItoI) {
    return $86d3758a1af7e127$var$innerCreateMedium(defaults, middleware);
}
function $86d3758a1af7e127$export$e13ec7dd7a14088d(options = {}) {
    const medium = $86d3758a1af7e127$var$innerCreateMedium(null);
    medium.options = {
        async: true,
        ssr: false,
        ...options
    };
    return medium;
}

});


parcelRegister("lTS5V", function(module, exports) {

$parcel$export(module.exports, "focusScope", () => $ff18b21b414ba800$export$f5272e9b1168239c);

var $5uXOq = parcelRequire("5uXOq");
var $ff18b21b414ba800$export$f5272e9b1168239c = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);

});


parcelRegister("1jdvF", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f420b8ec0f9848e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");


var $6mqio = parcelRequire("6mqio");

var $j4988 = parcelRequire("j4988");
var $2RQOj = parcelRequire("2RQOj");
var $1q0r0 = parcelRequire("1q0r0");
var $5x9g9 = parcelRequire("5x9g9");
var $jl7aa = parcelRequire("jl7aa");parcelRequire("cCk2L");
var $9wlSW = parcelRequire("9wlSW");

var $1mLS6 = parcelRequire("1mLS6");

var $i2hbO = parcelRequire("i2hbO");
var $0f420b8ec0f9848e$var$focusOnBody = function focusOnBody() {
    return document && document.activeElement === document.body;
};
var $0f420b8ec0f9848e$var$isFreeFocus = function isFreeFocus() {
    return $0f420b8ec0f9848e$var$focusOnBody() || (0, $jl7aa.focusIsHidden)();
};
var $0f420b8ec0f9848e$var$lastActiveTrap = null;
var $0f420b8ec0f9848e$var$lastActiveFocus = null;
var $0f420b8ec0f9848e$var$lastPortaledElement = null;
var $0f420b8ec0f9848e$var$focusWasOutsideWindow = false;
var $0f420b8ec0f9848e$var$defaultWhitelist = function defaultWhitelist() {
    return true;
};
var $0f420b8ec0f9848e$var$focusWhitelisted = function focusWhitelisted(activeElement) {
    return ($0f420b8ec0f9848e$var$lastActiveTrap.whiteList || $0f420b8ec0f9848e$var$defaultWhitelist)(activeElement);
};
var $0f420b8ec0f9848e$var$recordPortal = function recordPortal(observerNode, portaledElement) {
    $0f420b8ec0f9848e$var$lastPortaledElement = {
        observerNode: observerNode,
        portaledElement: portaledElement
    };
};
var $0f420b8ec0f9848e$var$focusIsPortaledPair = function focusIsPortaledPair(element) {
    return $0f420b8ec0f9848e$var$lastPortaledElement && $0f420b8ec0f9848e$var$lastPortaledElement.portaledElement === element;
};
function $0f420b8ec0f9848e$var$autoGuard(startIndex, end, step, allNodes) {
    var lastGuard = null;
    var i = startIndex;
    do {
        var item = allNodes[i];
        if (item.guard) {
            if (item.node.dataset.focusAutoGuard) lastGuard = item;
        } else if (item.lockItem) {
            if (i !== startIndex) return;
            lastGuard = null;
        } else break;
    }while ((i += step) !== end);
    if (lastGuard) lastGuard.node.tabIndex = 0;
}
var $0f420b8ec0f9848e$var$focusWasOutside = function focusWasOutside(crossFrameOption) {
    if (crossFrameOption) return Boolean($0f420b8ec0f9848e$var$focusWasOutsideWindow);
    return $0f420b8ec0f9848e$var$focusWasOutsideWindow === 'meanwhile';
};
var $0f420b8ec0f9848e$var$checkInHost = function checkInHost(check, el, boundary) {
    return el && (el.host === check && (!el.activeElement || boundary.contains(el.activeElement)) || el.parentNode && checkInHost(check, el.parentNode, boundary));
};
var $0f420b8ec0f9848e$var$withinHost = function withinHost(activeElement, workingArea) {
    return workingArea.some(function(area) {
        return $0f420b8ec0f9848e$var$checkInHost(activeElement, area, area);
    });
};
var $0f420b8ec0f9848e$var$activateTrap = function activateTrap() {
    var result = false;
    if ($0f420b8ec0f9848e$var$lastActiveTrap) {
        var _lastActiveTrap = $0f420b8ec0f9848e$var$lastActiveTrap, observed = _lastActiveTrap.observed, persistentFocus = _lastActiveTrap.persistentFocus, autoFocus = _lastActiveTrap.autoFocus, shards = _lastActiveTrap.shards, crossFrame = _lastActiveTrap.crossFrame, focusOptions = _lastActiveTrap.focusOptions;
        var workingNode = observed || $0f420b8ec0f9848e$var$lastPortaledElement && $0f420b8ec0f9848e$var$lastPortaledElement.portaledElement;
        var activeElement = document && document.activeElement;
        if (workingNode) {
            var workingArea = [
                workingNode
            ].concat(shards.map((0, $1mLS6.extractRef)).filter(Boolean));
            if (!activeElement || $0f420b8ec0f9848e$var$focusWhitelisted(activeElement)) {
                if (persistentFocus || $0f420b8ec0f9848e$var$focusWasOutside(crossFrame) || !$0f420b8ec0f9848e$var$isFreeFocus() || !$0f420b8ec0f9848e$var$lastActiveFocus && autoFocus) {
                    if (workingNode && !((0, $5x9g9.focusInside)(workingArea) || activeElement && $0f420b8ec0f9848e$var$withinHost(activeElement, workingArea) || $0f420b8ec0f9848e$var$focusIsPortaledPair(activeElement, workingNode))) {
                        if (document && !$0f420b8ec0f9848e$var$lastActiveFocus && activeElement && !autoFocus) {
                            if (activeElement.blur) activeElement.blur();
                            document.body.focus();
                        } else {
                            result = (0, $9wlSW.moveFocusInside)(workingArea, $0f420b8ec0f9848e$var$lastActiveFocus, {
                                focusOptions: focusOptions
                            });
                            $0f420b8ec0f9848e$var$lastPortaledElement = {};
                        }
                    }
                    $0f420b8ec0f9848e$var$focusWasOutsideWindow = false;
                    $0f420b8ec0f9848e$var$lastActiveFocus = document && document.activeElement;
                }
            }
            if (document && activeElement !== document.activeElement && document.querySelector('[data-focus-auto-guard]')) {
                var newActiveElement = document && document.activeElement;
                var allNodes = (0, $2RQOj.expandFocusableNodes)(workingArea);
                var focusedIndex = allNodes.map(function(_ref) {
                    var node = _ref.node;
                    return node;
                }).indexOf(newActiveElement);
                if (focusedIndex > -1) {
                    allNodes.filter(function(_ref2) {
                        var guard = _ref2.guard, node = _ref2.node;
                        return guard && node.dataset.focusAutoGuard;
                    }).forEach(function(_ref3) {
                        var node = _ref3.node;
                        return node.removeAttribute('tabIndex');
                    });
                    $0f420b8ec0f9848e$var$autoGuard(focusedIndex, allNodes.length, 1, allNodes);
                    $0f420b8ec0f9848e$var$autoGuard(focusedIndex, -1, -1, allNodes);
                }
            }
        }
    }
    return result;
};
var $0f420b8ec0f9848e$var$onTrap = function onTrap(event) {
    if ($0f420b8ec0f9848e$var$activateTrap() && event) {
        event.stopPropagation();
        event.preventDefault();
    }
};
var $0f420b8ec0f9848e$var$onBlur = function onBlur() {
    return (0, $1mLS6.deferAction)($0f420b8ec0f9848e$var$activateTrap);
};
var $0f420b8ec0f9848e$var$onFocus = function onFocus(event) {
    var source = event.target;
    var currentNode = event.currentTarget;
    if (!currentNode.contains(source)) $0f420b8ec0f9848e$var$recordPortal(currentNode, source);
};
var $0f420b8ec0f9848e$var$FocusWatcher = function FocusWatcher() {
    return null;
};
var $0f420b8ec0f9848e$var$FocusTrap = function FocusTrap(_ref4) {
    var children = _ref4.children;
    return /*#__PURE__*/ $5uXOq.createElement("div", {
        onBlur: $0f420b8ec0f9848e$var$onBlur,
        onFocus: $0f420b8ec0f9848e$var$onFocus
    }, children);
};
$0f420b8ec0f9848e$var$FocusTrap.propTypes = {};
var $0f420b8ec0f9848e$var$onWindowBlur = function onWindowBlur() {
    $0f420b8ec0f9848e$var$focusWasOutsideWindow = 'just';
    (0, $1mLS6.deferAction)(function() {
        $0f420b8ec0f9848e$var$focusWasOutsideWindow = 'meanwhile';
    });
};
var $0f420b8ec0f9848e$var$attachHandler = function attachHandler() {
    document.addEventListener('focusin', $0f420b8ec0f9848e$var$onTrap);
    document.addEventListener('focusout', $0f420b8ec0f9848e$var$onBlur);
    window.addEventListener('blur', $0f420b8ec0f9848e$var$onWindowBlur);
};
var $0f420b8ec0f9848e$var$detachHandler = function detachHandler() {
    document.removeEventListener('focusin', $0f420b8ec0f9848e$var$onTrap);
    document.removeEventListener('focusout', $0f420b8ec0f9848e$var$onBlur);
    window.removeEventListener('blur', $0f420b8ec0f9848e$var$onWindowBlur);
};
function $0f420b8ec0f9848e$var$reducePropsToState(propsList) {
    return propsList.filter(function(_ref5) {
        var disabled = _ref5.disabled;
        return !disabled;
    });
}
var $0f420b8ec0f9848e$var$focusLockAPI = {
    moveFocusInside: (0, $9wlSW.moveFocusInside),
    focusInside: (0, $5x9g9.focusInside),
    focusNextElement: (0, $1q0r0.focusNextElement),
    focusPrevElement: (0, $1q0r0.focusPrevElement),
    focusFirstElement: (0, $1q0r0.focusFirstElement),
    focusLastElement: (0, $1q0r0.focusLastElement),
    captureFocusRestore: (0, $j4988.captureFocusRestore)
};
function $0f420b8ec0f9848e$var$handleStateChangeOnClient(traps) {
    var trap = traps.slice(-1)[0];
    if (trap && !$0f420b8ec0f9848e$var$lastActiveTrap) $0f420b8ec0f9848e$var$attachHandler();
    var lastTrap = $0f420b8ec0f9848e$var$lastActiveTrap;
    var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
    $0f420b8ec0f9848e$var$lastActiveTrap = trap;
    if (lastTrap && !sameTrap) {
        lastTrap.onDeactivation();
        if (!traps.filter(function(_ref6) {
            var id = _ref6.id;
            return id === lastTrap.id;
        }).length) lastTrap.returnFocus(!trap);
    }
    if (trap) {
        $0f420b8ec0f9848e$var$lastActiveFocus = null;
        if (!sameTrap || lastTrap.observed !== trap.observed) trap.onActivation($0f420b8ec0f9848e$var$focusLockAPI);
        $0f420b8ec0f9848e$var$activateTrap(true);
        (0, $1mLS6.deferAction)($0f420b8ec0f9848e$var$activateTrap);
    } else {
        $0f420b8ec0f9848e$var$detachHandler();
        $0f420b8ec0f9848e$var$lastActiveFocus = null;
    }
}
(0, $i2hbO.mediumFocus).assignSyncMedium($0f420b8ec0f9848e$var$onFocus);
(0, $i2hbO.mediumBlur).assignMedium($0f420b8ec0f9848e$var$onBlur);
(0, $i2hbO.mediumEffect).assignMedium(function(cb) {
    return cb($0f420b8ec0f9848e$var$focusLockAPI);
});
var $0f420b8ec0f9848e$export$2e2bcd8739ae039 = (0, $6mqio.default)($0f420b8ec0f9848e$var$reducePropsToState, $0f420b8ec0f9848e$var$handleStateChangeOnClient)($0f420b8ec0f9848e$var$FocusWatcher);

});
parcelRegister("6mqio", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a1931e6e98edb22$export$2e2bcd8739ae039);

var $2jS8g = parcelRequire("2jS8g");

var $eHiP8 = parcelRequire("eHiP8");

var $5uXOq = parcelRequire("5uXOq");
function $4a1931e6e98edb22$var$withSideEffect(reducePropsToState, handleStateChangeOnClient) {
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }
    return function wrap(WrappedComponent) {
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            handleStateChangeOnClient(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            (0, $2jS8g.default)(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            SideEffect.peek = function peek() {
                return state;
            };
            var _proto = SideEffect.prototype;
            _proto.componentDidMount = function componentDidMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }((0, $5uXOq.PureComponent));
        (0, $eHiP8.default)(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        return SideEffect;
    };
}
var $4a1931e6e98edb22$export$2e2bcd8739ae039 = $4a1931e6e98edb22$var$withSideEffect;

});
parcelRegister("eHiP8", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab33aeddc06e5aed$export$2e2bcd8739ae039);

var $586Rz = parcelRequire("586Rz");
function $ab33aeddc06e5aed$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $586Rz.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("586Rz", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bc305fa7a392472$export$2e2bcd8739ae039);

var $eKtAb = parcelRequire("eKtAb");

var $kGKYI = parcelRequire("kGKYI");
function $3bc305fa7a392472$export$2e2bcd8739ae039(t) {
    var i = (0, $kGKYI.default)(t, "string");
    return "symbol" == (0, $eKtAb.default)(i) ? i : i + "";
}

});
parcelRegister("eKtAb", function(module, exports) {

$parcel$export(module.exports, "default", () => $abcc4f12e9e8c580$export$2e2bcd8739ae039);
function $abcc4f12e9e8c580$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $abcc4f12e9e8c580$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $abcc4f12e9e8c580$export$2e2bcd8739ae039(o);
}

});

parcelRegister("kGKYI", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0fc2bce6211f5a4$export$2e2bcd8739ae039);

var $eKtAb = parcelRequire("eKtAb");
function $f0fc2bce6211f5a4$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $eKtAb.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $eKtAb.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});




parcelRegister("j4988", function(module, exports) {

$parcel$export(module.exports, "captureFocusRestore", () => $de15791afd27bb83$export$d357db6e554ff59a);

var $l1lpg = parcelRequire("l1lpg");
function $de15791afd27bb83$var$weakRef(value) {
    if (!value) return null;
    // #68 Safari 14.1 dont have it yet
    // FIXME: remove in 2025
    if (typeof WeakRef === 'undefined') return function() {
        return value || null;
    };
    var w = value ? new WeakRef(value) : null;
    return function() {
        return (w === null || w === void 0 ? void 0 : w.deref()) || null;
    };
}
var $de15791afd27bb83$export$5061a7725be48ff9 = function(element) {
    if (!element) return null;
    var stack = [];
    var currentElement = element;
    while(currentElement && currentElement !== document.body){
        stack.push({
            current: $de15791afd27bb83$var$weakRef(currentElement),
            parent: $de15791afd27bb83$var$weakRef(currentElement.parentElement),
            left: $de15791afd27bb83$var$weakRef(currentElement.previousElementSibling),
            right: $de15791afd27bb83$var$weakRef(currentElement.nextElementSibling)
        });
        currentElement = currentElement.parentElement;
    }
    return {
        element: $de15791afd27bb83$var$weakRef(element),
        stack: stack,
        ownerDocument: element.ownerDocument
    };
};
var $de15791afd27bb83$var$restoreFocusTo = function(location) {
    var _a, _b, _c, _d, _e;
    if (!location) return undefined;
    var stack = location.stack, ownerDocument = location.ownerDocument;
    var visibilityCache = new Map();
    for(var _i = 0, stack_1 = stack; _i < stack_1.length; _i++){
        var line = stack_1[_i];
        var parent_1 = (_a = line.parent) === null || _a === void 0 ? void 0 : _a.call(line);
        // is it still here?
        if (parent_1 && ownerDocument.contains(parent_1)) {
            var left = (_b = line.left) === null || _b === void 0 ? void 0 : _b.call(line);
            var savedCurrent = line.current();
            var current = parent_1.contains(savedCurrent) ? savedCurrent : undefined;
            var right = (_c = line.right) === null || _c === void 0 ? void 0 : _c.call(line);
            var focusables = (0, $l1lpg.getTabbableNodes)([
                parent_1
            ], visibilityCache);
            var aim = // that is element itself
            (_e = (_d = current !== null && current !== void 0 ? current : // or something in it's place
            left === null || left === void 0 ? void 0 : left.nextElementSibling) !== null && _d !== void 0 ? _d : // or somebody to the right, still close enough
            right) !== null && _e !== void 0 ? _e : // or somebody to the left, something?
            left;
            while(aim){
                for(var _f = 0, focusables_1 = focusables; _f < focusables_1.length; _f++){
                    var focusable = focusables_1[_f];
                    if (aim === null || aim === void 0 ? void 0 : aim.contains(focusable.node)) return focusable.node;
                }
                aim = aim.nextElementSibling;
            }
            if (focusables.length) // if parent contains a focusable - move there
            return focusables[0].node;
        }
    }
    // nothing matched
    return undefined;
};
var $de15791afd27bb83$export$d357db6e554ff59a = function(targetElement) {
    var location = $de15791afd27bb83$export$5061a7725be48ff9(targetElement);
    return function() {
        return $de15791afd27bb83$var$restoreFocusTo(location);
    };
};

});
parcelRegister("l1lpg", function(module, exports) {

$parcel$export(module.exports, "filterAutoFocusable", () => $03f3013918b31c29$export$2f70373d403a5d2b);
$parcel$export(module.exports, "getTabbableNodes", () => $03f3013918b31c29$export$3738e313571e2ad2);
$parcel$export(module.exports, "getFocusableNodes", () => $03f3013918b31c29$export$493d05a3a8e6532d);
$parcel$export(module.exports, "parentAutofocusables", () => $03f3013918b31c29$export$dc26309a71d1ce47);
$parcel$export(module.exports, "contains", () => $03f3013918b31c29$export$2344b14b097df817);

var $649lM = parcelRequire("649lM");

var $jlIIa = parcelRequire("jlIIa");

var $hPwd3 = parcelRequire("hPwd3");

var $detSP = parcelRequire("detSP");
var $03f3013918b31c29$export$6266a5cd5915dc33 = function(nodes, visibilityCache) {
    return (0, $649lM.toArray)(nodes).filter(function(node) {
        return (0, $jlIIa.isVisibleCached)(visibilityCache, node);
    }).filter(function(node) {
        return (0, $jlIIa.notHiddenInput)(node);
    });
};
var $03f3013918b31c29$export$2f70373d403a5d2b = function(nodes, cache) {
    if (cache === void 0) cache = new Map();
    return (0, $649lM.toArray)(nodes).filter(function(node) {
        return (0, $jlIIa.isAutoFocusAllowedCached)(cache, node);
    });
};
var $03f3013918b31c29$export$3738e313571e2ad2 = function(topNodes, visibilityCache, withGuards) {
    return (0, $hPwd3.orderByTabIndex)($03f3013918b31c29$export$6266a5cd5915dc33((0, $detSP.getFocusables)(topNodes, withGuards), visibilityCache), true, withGuards);
};
var $03f3013918b31c29$export$493d05a3a8e6532d = function(topNodes, visibilityCache) {
    return (0, $hPwd3.orderByTabIndex)($03f3013918b31c29$export$6266a5cd5915dc33((0, $detSP.getFocusables)(topNodes), visibilityCache), false);
};
var $03f3013918b31c29$export$dc26309a71d1ce47 = function(topNode, visibilityCache) {
    return $03f3013918b31c29$export$6266a5cd5915dc33((0, $detSP.getParentAutofocusables)(topNode), visibilityCache);
};
var $03f3013918b31c29$export$2344b14b097df817 = function(scope, element) {
    if (scope.shadowRoot) return $03f3013918b31c29$export$2344b14b097df817(scope.shadowRoot, element);
    else {
        if (Object.getPrototypeOf(scope).contains !== undefined && Object.getPrototypeOf(scope).contains.call(scope, element)) return true;
        return (0, $649lM.toArray)(scope.children).some(function(child) {
            var _a;
            if (child instanceof HTMLIFrameElement) {
                var iframeBody = (_a = child.contentDocument) === null || _a === void 0 ? void 0 : _a.body;
                if (iframeBody) return $03f3013918b31c29$export$2344b14b097df817(iframeBody, element);
                return false;
            }
            return $03f3013918b31c29$export$2344b14b097df817(child, element);
        });
    }
};

});
parcelRegister("649lM", function(module, exports) {

$parcel$export(module.exports, "toArray", () => $46aa5e8f7fb698d8$export$45b10814cc054894);
$parcel$export(module.exports, "asArray", () => $46aa5e8f7fb698d8$export$75093a47a9fa838d);
$parcel$export(module.exports, "getFirst", () => $46aa5e8f7fb698d8$export$bcd7afcd904dce14);
/*
IE11 support
 */ var $46aa5e8f7fb698d8$export$45b10814cc054894 = function(a) {
    var ret = Array(a.length);
    for(var i = 0; i < a.length; ++i)ret[i] = a[i];
    return ret;
};
var $46aa5e8f7fb698d8$export$75093a47a9fa838d = function(a) {
    return Array.isArray(a) ? a : [
        a
    ];
};
var $46aa5e8f7fb698d8$export$bcd7afcd904dce14 = function(a) {
    return Array.isArray(a) ? a[0] : a;
};

});

parcelRegister("jlIIa", function(module, exports) {

$parcel$export(module.exports, "isVisibleCached", () => $e162a936fc2d012a$export$3c9dc299685ad160);
$parcel$export(module.exports, "isAutoFocusAllowedCached", () => $e162a936fc2d012a$export$bcaa50628f6a736e);
$parcel$export(module.exports, "getDataset", () => $e162a936fc2d012a$export$698b339b0c8edae3);
$parcel$export(module.exports, "isRadioElement", () => $e162a936fc2d012a$export$9d74f6fbc6f469d0);
$parcel$export(module.exports, "notHiddenInput", () => $e162a936fc2d012a$export$8197b0ea56b3b055);
$parcel$export(module.exports, "isGuard", () => $e162a936fc2d012a$export$d94b8b58ec2f30eb);
$parcel$export(module.exports, "isNotAGuard", () => $e162a936fc2d012a$export$602e5a0d338d7750);
$parcel$export(module.exports, "isDefined", () => $e162a936fc2d012a$export$4e62c701997796c1);

var $26Cgu = parcelRequire("26Cgu");
var $e162a936fc2d012a$var$isElementHidden = function(node) {
    // we can measure only "elements"
    // consider others as "visible"
    if (node.nodeType !== Node.ELEMENT_NODE) return false;
    var computedStyle = window.getComputedStyle(node, null);
    if (!computedStyle || !computedStyle.getPropertyValue) return false;
    return computedStyle.getPropertyValue('display') === 'none' || computedStyle.getPropertyValue('visibility') === 'hidden';
};
var $e162a936fc2d012a$var$getParentNode = function(node) {
    // DOCUMENT_FRAGMENT_NODE can also point on ShadowRoot. In this case .host will point on the next node
    return node.parentNode && node.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? node.parentNode.host : node.parentNode;
};
var $e162a936fc2d012a$var$isTopNode = function(node) {
    // @ts-ignore
    return node === document || node && node.nodeType === Node.DOCUMENT_NODE;
};
var $e162a936fc2d012a$var$isInert = function(node) {
    return node.hasAttribute('inert');
};
/**
 * @see https://github.com/testing-library/jest-dom/blob/main/src/to-be-visible.js
 */ var $e162a936fc2d012a$var$isVisibleUncached = function(node, checkParent) {
    return !node || $e162a936fc2d012a$var$isTopNode(node) || !$e162a936fc2d012a$var$isElementHidden(node) && !$e162a936fc2d012a$var$isInert(node) && checkParent($e162a936fc2d012a$var$getParentNode(node));
};
var $e162a936fc2d012a$export$3c9dc299685ad160 = function(visibilityCache, node) {
    var cached = visibilityCache.get(node);
    if (cached !== undefined) return cached;
    var result = $e162a936fc2d012a$var$isVisibleUncached(node, $e162a936fc2d012a$export$3c9dc299685ad160.bind(undefined, visibilityCache));
    visibilityCache.set(node, result);
    return result;
};
var $e162a936fc2d012a$var$isAutoFocusAllowedUncached = function(node, checkParent) {
    return node && !$e162a936fc2d012a$var$isTopNode(node) ? $e162a936fc2d012a$export$b8550e27de209d85(node) ? checkParent($e162a936fc2d012a$var$getParentNode(node)) : false : true;
};
var $e162a936fc2d012a$export$bcaa50628f6a736e = function(cache, node) {
    var cached = cache.get(node);
    if (cached !== undefined) return cached;
    var result = $e162a936fc2d012a$var$isAutoFocusAllowedUncached(node, $e162a936fc2d012a$export$bcaa50628f6a736e.bind(undefined, cache));
    cache.set(node, result);
    return result;
};
var $e162a936fc2d012a$export$698b339b0c8edae3 = function(node) {
    // @ts-ignore
    return node.dataset;
};
var $e162a936fc2d012a$export$65aad1b6bc934b11 = function(node) {
    return node.tagName === 'BUTTON';
};
var $e162a936fc2d012a$export$88a6ceeed5737ba3 = function(node) {
    return node.tagName === 'INPUT';
};
var $e162a936fc2d012a$export$9d74f6fbc6f469d0 = function(node) {
    return $e162a936fc2d012a$export$88a6ceeed5737ba3(node) && node.type === 'radio';
};
var $e162a936fc2d012a$export$8197b0ea56b3b055 = function(node) {
    return !(($e162a936fc2d012a$export$88a6ceeed5737ba3(node) || $e162a936fc2d012a$export$65aad1b6bc934b11(node)) && (node.type === 'hidden' || node.disabled));
};
var $e162a936fc2d012a$export$b8550e27de209d85 = function(node) {
    var attribute = node.getAttribute((0, $26Cgu.FOCUS_NO_AUTOFOCUS));
    return ![
        true,
        'true',
        ''
    ].includes(attribute);
};
var $e162a936fc2d012a$export$d94b8b58ec2f30eb = function(node) {
    var _a;
    return Boolean(node && ((_a = $e162a936fc2d012a$export$698b339b0c8edae3(node)) === null || _a === void 0 ? void 0 : _a.focusGuard));
};
var $e162a936fc2d012a$export$602e5a0d338d7750 = function(node) {
    return !$e162a936fc2d012a$export$d94b8b58ec2f30eb(node);
};
var $e162a936fc2d012a$export$4e62c701997796c1 = function(x) {
    return Boolean(x);
};

});

parcelRegister("hPwd3", function(module, exports) {

$parcel$export(module.exports, "orderByTabIndex", () => $cfb02f3dbbab37c3$export$cb40ee071f0d5226);

var $649lM = parcelRequire("649lM");
var $cfb02f3dbbab37c3$export$350ee6c095d98996 = function(a, b) {
    var aTab = Math.max(0, a.tabIndex);
    var bTab = Math.max(0, b.tabIndex);
    var tabDiff = aTab - bTab;
    var indexDiff = a.index - b.index;
    if (tabDiff) {
        if (!aTab) return 1;
        if (!bTab) return -1;
    }
    return tabDiff || indexDiff;
};
var $cfb02f3dbbab37c3$var$getTabIndex = function(node) {
    if (node.tabIndex < 0) {
        // all "focusable" elements are already preselected
        // but some might have implicit negative tabIndex
        // return 0 for <audio without tabIndex attribute - it is "tabbable"
        if (!node.hasAttribute('tabindex')) return 0;
    }
    return node.tabIndex;
};
var $cfb02f3dbbab37c3$export$cb40ee071f0d5226 = function(nodes, filterNegative, keepGuards) {
    return (0, $649lM.toArray)(nodes).map(function(node, index) {
        var tabIndex = $cfb02f3dbbab37c3$var$getTabIndex(node);
        return {
            node: node,
            index: index,
            tabIndex: keepGuards && tabIndex === -1 ? (node.dataset || {}).focusGuard ? 0 : -1 : tabIndex
        };
    }).filter(function(data) {
        return !filterNegative || data.tabIndex >= 0;
    }).sort($cfb02f3dbbab37c3$export$350ee6c095d98996);
};

});

parcelRegister("detSP", function(module, exports) {

$parcel$export(module.exports, "getFocusables", () => $9a23c35cb23add47$export$f6768025e418420e);
$parcel$export(module.exports, "getParentAutofocusables", () => $9a23c35cb23add47$export$853fa94d922e78b9);

var $26Cgu = parcelRequire("26Cgu");

var $649lM = parcelRequire("649lM");

var $h8JFa = parcelRequire("h8JFa");
var $9a23c35cb23add47$var$queryTabbables = (0, $h8JFa.tabbables).join(',');
var $9a23c35cb23add47$var$queryGuardTabbables = "".concat($9a23c35cb23add47$var$queryTabbables, ", [data-focus-guard]");
var $9a23c35cb23add47$var$getFocusablesWithShadowDom = function(parent, withGuards) {
    return (0, $649lM.toArray)((parent.shadowRoot || parent).children).reduce(function(acc, child) {
        return acc.concat(child.matches(withGuards ? $9a23c35cb23add47$var$queryGuardTabbables : $9a23c35cb23add47$var$queryTabbables) ? [
            child
        ] : [], $9a23c35cb23add47$var$getFocusablesWithShadowDom(child));
    }, []);
};
var $9a23c35cb23add47$var$getFocusablesWithIFrame = function(parent, withGuards) {
    var _a;
    // contentDocument of iframe will be null if current origin cannot access it
    if (parent instanceof HTMLIFrameElement && ((_a = parent.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) return $9a23c35cb23add47$export$f6768025e418420e([
        parent.contentDocument.body
    ], withGuards);
    return [
        parent
    ];
};
var $9a23c35cb23add47$export$f6768025e418420e = function(parents, withGuards) {
    return parents.reduce(function(acc, parent) {
        var _a;
        var focusableWithShadowDom = $9a23c35cb23add47$var$getFocusablesWithShadowDom(parent, withGuards);
        var focusableWithIframes = (_a = []).concat.apply(_a, focusableWithShadowDom.map(function(node) {
            return $9a23c35cb23add47$var$getFocusablesWithIFrame(node, withGuards);
        }));
        return acc.concat(// add all tabbables inside and within shadow DOMs in DOM order
        focusableWithIframes, // add if node is tabbable itself
        parent.parentNode ? (0, $649lM.toArray)(parent.parentNode.querySelectorAll($9a23c35cb23add47$var$queryTabbables)).filter(function(node) {
            return node === parent;
        }) : []);
    }, []);
};
var $9a23c35cb23add47$export$853fa94d922e78b9 = function(parent) {
    var parentFocus = parent.querySelectorAll("[".concat((0, $26Cgu.FOCUS_AUTO), "]"));
    return (0, $649lM.toArray)(parentFocus).map(function(node) {
        return $9a23c35cb23add47$export$f6768025e418420e([
            node
        ]);
    }).reduce(function(acc, nodes) {
        return acc.concat(nodes);
    }, []);
};

});
parcelRegister("h8JFa", function(module, exports) {

$parcel$export(module.exports, "tabbables", () => $c7a69abaf19a3f41$export$8555f4622e95784);
/**
 * list of the object to be considered as focusable
 */ var $c7a69abaf19a3f41$export$8555f4622e95784 = [
    'button:enabled',
    'select:enabled',
    'textarea:enabled',
    'input:enabled',
    // elements with explicit roles will also use explicit tabindex
    // '[role="button"]',
    'a[href]',
    'area[href]',
    'summary',
    'iframe',
    'object',
    'embed',
    'audio[controls]',
    'video[controls]',
    '[tabindex]',
    '[contenteditable]',
    '[autofocus]'
];

});




parcelRegister("2RQOj", function(module, exports) {

$parcel$export(module.exports, "expandFocusableNodes", () => $21697f119bba8faa$export$f89ac71e91767111);

var $1kBVR = parcelRequire("1kBVR");

var $jlIIa = parcelRequire("jlIIa");

var $3jtrL = parcelRequire("3jtrL");

var $hPwd3 = parcelRequire("hPwd3");

var $detSP = parcelRequire("detSP");
var $21697f119bba8faa$export$f89ac71e91767111 = function(topNode) {
    var entries = (0, $1kBVR.getAllAffectedNodes)(topNode).filter((0, $jlIIa.isNotAGuard));
    var commonParent = (0, $3jtrL.getTopCommonParent)(topNode, topNode, entries);
    var outerNodes = (0, $hPwd3.orderByTabIndex)((0, $detSP.getFocusables)([
        commonParent
    ], true), true, true);
    var innerElements = (0, $detSP.getFocusables)(entries, false);
    return outerNodes.map(function(_a) {
        var node = _a.node, index = _a.index;
        return {
            node: node,
            index: index,
            lockItem: innerElements.indexOf(node) >= 0,
            guard: (0, $jlIIa.isGuard)(node)
        };
    });
};

});
parcelRegister("1kBVR", function(module, exports) {

$parcel$export(module.exports, "getAllAffectedNodes", () => $0f851546d68da0ab$export$7e87c4720b9b279b);

var $26Cgu = parcelRequire("26Cgu");

var $649lM = parcelRequire("649lM");
/**
 * in case of multiple nodes nested inside each other
 * keeps only top ones
 * this is O(nlogn)
 * @param nodes
 * @returns {*}
 */ var $0f851546d68da0ab$var$filterNested = function(nodes) {
    var contained = new Set();
    var l = nodes.length;
    for(var i = 0; i < l; i += 1)for(var j = i + 1; j < l; j += 1){
        var position = nodes[i].compareDocumentPosition(nodes[j]);
        /* eslint-disable no-bitwise */ if ((position & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0) contained.add(j);
        if ((position & Node.DOCUMENT_POSITION_CONTAINS) > 0) contained.add(i);
    /* eslint-enable */ }
    return nodes.filter(function(_, index) {
        return !contained.has(index);
    });
};
/**
 * finds top most parent for a node
 * @param node
 * @returns {*}
 */ var $0f851546d68da0ab$var$getTopParent = function(node) {
    return node.parentNode ? $0f851546d68da0ab$var$getTopParent(node.parentNode) : node;
};
var $0f851546d68da0ab$export$7e87c4720b9b279b = function(node) {
    var nodes = (0, $649lM.asArray)(node);
    return nodes.filter(Boolean).reduce(function(acc, currentNode) {
        var group = currentNode.getAttribute((0, $26Cgu.FOCUS_GROUP));
        acc.push.apply(acc, group ? $0f851546d68da0ab$var$filterNested((0, $649lM.toArray)($0f851546d68da0ab$var$getTopParent(currentNode).querySelectorAll("[".concat((0, $26Cgu.FOCUS_GROUP), "=\"").concat(group, "\"]:not([").concat((0, $26Cgu.FOCUS_DISABLED), "=\"disabled\"])")))) : [
            currentNode
        ]);
        return acc;
    }, []);
};

});

parcelRegister("3jtrL", function(module, exports) {

$parcel$export(module.exports, "getTopCommonParent", () => $2699fcfa1a3b19bb$export$a9a7252b5f2e280e);
$parcel$export(module.exports, "allParentAutofocusables", () => $2699fcfa1a3b19bb$export$8f99714c70a37db1);

var $l1lpg = parcelRequire("l1lpg");

var $649lM = parcelRequire("649lM");
var $2699fcfa1a3b19bb$var$getParents = function(node, parents) {
    if (parents === void 0) parents = [];
    parents.push(node);
    if (node.parentNode) $2699fcfa1a3b19bb$var$getParents(node.parentNode.host || node.parentNode, parents);
    return parents;
};
var $2699fcfa1a3b19bb$export$a08e5f53769bce53 = function(nodeA, nodeB) {
    var parentsA = $2699fcfa1a3b19bb$var$getParents(nodeA);
    var parentsB = $2699fcfa1a3b19bb$var$getParents(nodeB);
    // tslint:disable-next-line:prefer-for-of
    for(var i = 0; i < parentsA.length; i += 1){
        var currentParent = parentsA[i];
        if (parentsB.indexOf(currentParent) >= 0) return currentParent;
    }
    return false;
};
var $2699fcfa1a3b19bb$export$a9a7252b5f2e280e = function(baseActiveElement, leftEntry, rightEntries) {
    var activeElements = (0, $649lM.asArray)(baseActiveElement);
    var leftEntries = (0, $649lM.asArray)(leftEntry);
    var activeElement = activeElements[0];
    var topCommon = false;
    leftEntries.filter(Boolean).forEach(function(entry) {
        topCommon = $2699fcfa1a3b19bb$export$a08e5f53769bce53(topCommon || entry, entry) || topCommon;
        rightEntries.filter(Boolean).forEach(function(subEntry) {
            var common = $2699fcfa1a3b19bb$export$a08e5f53769bce53(activeElement, subEntry);
            if (common) {
                if (!topCommon || (0, $l1lpg.contains)(common, topCommon)) topCommon = common;
                else topCommon = $2699fcfa1a3b19bb$export$a08e5f53769bce53(common, topCommon);
            }
        });
    });
    // TODO: add assert here?
    return topCommon;
};
var $2699fcfa1a3b19bb$export$8f99714c70a37db1 = function(entries, visibilityCache) {
    return entries.reduce(function(acc, node) {
        return acc.concat((0, $l1lpg.parentAutofocusables)(node, visibilityCache));
    }, []);
};

});


parcelRegister("1q0r0", function(module, exports) {

$parcel$export(module.exports, "focusNextElement", () => $10888e6d50ae918b$export$3b0237e8566c8d65);
$parcel$export(module.exports, "focusPrevElement", () => $10888e6d50ae918b$export$33b47db07a82b2fb);
$parcel$export(module.exports, "focusFirstElement", () => $10888e6d50ae918b$export$2a791d8097a66406);
$parcel$export(module.exports, "focusLastElement", () => $10888e6d50ae918b$export$6a79073ddabfd6c3);

var $jfQb7 = parcelRequire("jfQb7");

var $l1lpg = parcelRequire("l1lpg");

var $649lM = parcelRequire("649lM");
var $10888e6d50ae918b$export$1b42c72592537703 = function(element, scope, useTabbables) {
    if (!element || !scope) {
        console.error('no element or scope given');
        return {};
    }
    var shards = (0, $649lM.asArray)(scope);
    if (shards.every(function(shard) {
        return !(0, $l1lpg.contains)(shard, element);
    })) {
        console.error('Active element is not contained in the scope');
        return {};
    }
    var focusables = useTabbables ? (0, $l1lpg.getTabbableNodes)(shards, new Map()) : (0, $l1lpg.getFocusableNodes)(shards, new Map());
    var current = focusables.findIndex(function(_a) {
        var node = _a.node;
        return node === element;
    });
    if (current === -1) // an edge case, when anchor element is not found
    return undefined;
    return {
        prev: focusables[current - 1],
        next: focusables[current + 1],
        first: focusables[0],
        last: focusables[focusables.length - 1]
    };
};
var $10888e6d50ae918b$var$getBoundary = function(shards, useTabbables) {
    var set = useTabbables ? (0, $l1lpg.getTabbableNodes)((0, $649lM.asArray)(shards), new Map()) : (0, $l1lpg.getFocusableNodes)((0, $649lM.asArray)(shards), new Map());
    return {
        first: set[0],
        last: set[set.length - 1]
    };
};
var $10888e6d50ae918b$var$defaultOptions = function(options) {
    return Object.assign({
        scope: document.body,
        cycle: true,
        onlyTabbable: true
    }, options);
};
var $10888e6d50ae918b$var$moveFocus = function(fromElement, options, cb) {
    if (options === void 0) options = {};
    var newOptions = $10888e6d50ae918b$var$defaultOptions(options);
    var solution = $10888e6d50ae918b$export$1b42c72592537703(fromElement, newOptions.scope, newOptions.onlyTabbable);
    if (!solution) return;
    var target = cb(solution, newOptions.cycle);
    if (target) (0, $jfQb7.focusOn)(target.node, newOptions.focusOptions);
};
var $10888e6d50ae918b$export$3b0237e8566c8d65 = function(fromElement, options) {
    if (options === void 0) options = {};
    $10888e6d50ae918b$var$moveFocus(fromElement, options, function(_a, cycle) {
        var next = _a.next, first = _a.first;
        return next || cycle && first;
    });
};
var $10888e6d50ae918b$export$33b47db07a82b2fb = function(fromElement, options) {
    if (options === void 0) options = {};
    $10888e6d50ae918b$var$moveFocus(fromElement, options, function(_a, cycle) {
        var prev = _a.prev, last = _a.last;
        return prev || cycle && last;
    });
};
var $10888e6d50ae918b$var$pickBoundary = function(scope, options, what) {
    var _a;
    var boundary = $10888e6d50ae918b$var$getBoundary(scope, (_a = options.onlyTabbable) !== null && _a !== void 0 ? _a : true);
    var node = boundary[what];
    if (node) (0, $jfQb7.focusOn)(node.node, options.focusOptions);
};
var $10888e6d50ae918b$export$2a791d8097a66406 = function(scope, options) {
    if (options === void 0) options = {};
    $10888e6d50ae918b$var$pickBoundary(scope, options, 'first');
};
var $10888e6d50ae918b$export$6a79073ddabfd6c3 = function(scope, options) {
    if (options === void 0) options = {};
    $10888e6d50ae918b$var$pickBoundary(scope, options, 'last');
};

});
parcelRegister("jfQb7", function(module, exports) {

$parcel$export(module.exports, "focusOn", () => $e047e48fcca0b3b0$export$c12b3da842c43a8);
var $e047e48fcca0b3b0$export$c12b3da842c43a8 = function(target, focusOptions) {
    if (!target) // not clear how, but is possible https://github.com/theKashey/focus-lock/issues/53
    return;
    if ('focus' in target) target.focus(focusOptions);
    if ('contentWindow' in target && target.contentWindow) target.contentWindow.focus();
};

});


parcelRegister("5x9g9", function(module, exports) {

$parcel$export(module.exports, "focusInside", () => $4077379349d4c74a$export$20115f8da7baa6fa);

var $l1lpg = parcelRequire("l1lpg");

var $1kBVR = parcelRequire("1kBVR");

var $649lM = parcelRequire("649lM");

var $33cOt = parcelRequire("33cOt");
var $4077379349d4c74a$var$focusInFrame = function(frame, activeElement) {
    return frame === activeElement;
};
var $4077379349d4c74a$var$focusInsideIframe = function(topNode, activeElement) {
    return Boolean((0, $649lM.toArray)(topNode.querySelectorAll('iframe')).some(function(node) {
        return $4077379349d4c74a$var$focusInFrame(node, activeElement);
    }));
};
var $4077379349d4c74a$export$20115f8da7baa6fa = function(topNode, activeElement) {
    // const activeElement = document && getActiveElement();
    if (activeElement === void 0) activeElement = (0, $33cOt.getActiveElement)((0, $649lM.getFirst)(topNode).ownerDocument);
    if (!activeElement || activeElement.dataset && activeElement.dataset.focusGuard) return false;
    return (0, $1kBVR.getAllAffectedNodes)(topNode).some(function(node) {
        return (0, $l1lpg.contains)(node, activeElement) || $4077379349d4c74a$var$focusInsideIframe(node, activeElement);
    });
};

});
parcelRegister("33cOt", function(module, exports) {

$parcel$export(module.exports, "getActiveElement", () => $238b9756ed43b48b$export$cd4e5573fbe2b576);
/**
 * returns active element from document or from nested shadowdoms
 */ 
var $513Q1 = parcelRequire("513Q1");
var $238b9756ed43b48b$export$cd4e5573fbe2b576 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    if (!inDocument || !inDocument.activeElement) return undefined;
    var activeElement = inDocument.activeElement;
    return activeElement.shadowRoot ? $238b9756ed43b48b$export$cd4e5573fbe2b576(activeElement.shadowRoot) : activeElement instanceof HTMLIFrameElement && (0, $513Q1.safeProbe)(function() {
        return activeElement.contentWindow.document;
    }) ? $238b9756ed43b48b$export$cd4e5573fbe2b576(activeElement.contentWindow.document) : activeElement;
};

});
parcelRegister("513Q1", function(module, exports) {

$parcel$export(module.exports, "safeProbe", () => $3a7005e711f25367$export$78d20aae35adef88);
var $3a7005e711f25367$export$78d20aae35adef88 = function(cb) {
    try {
        return cb();
    } catch (e) {
        return undefined;
    }
};

});



parcelRegister("jl7aa", function(module, exports) {

$parcel$export(module.exports, "focusIsHidden", () => $e14588ebb2dd3a92$export$be6b21806d3fd485);

var $26Cgu = parcelRequire("26Cgu");

var $l1lpg = parcelRequire("l1lpg");

var $649lM = parcelRequire("649lM");

var $33cOt = parcelRequire("33cOt");
var $e14588ebb2dd3a92$export$be6b21806d3fd485 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    var activeElement = (0, $33cOt.getActiveElement)(inDocument);
    if (!activeElement) return false;
    // this does not support setting FOCUS_ALLOW within shadow dom
    return (0, $649lM.toArray)(inDocument.querySelectorAll("[".concat((0, $26Cgu.FOCUS_ALLOW), "]"))).some(function(node) {
        return (0, $l1lpg.contains)(node, activeElement);
    });
};

});

parcelRegister("cCk2L", function(module, exports) {

$parcel$export(module.exports, "moveFocusInside", () => (parcelRequire("9wlSW")).moveFocusInside);

var $26Cgu = parcelRequire("26Cgu");

var $5x9g9 = parcelRequire("5x9g9");

var $jl7aa = parcelRequire("jl7aa");


var $2RQOj = parcelRequire("2RQOj");

var $9wlSW = parcelRequire("9wlSW");

var $j4988 = parcelRequire("j4988");

var $1q0r0 = parcelRequire("1q0r0");

var $l1lpg = parcelRequire("l1lpg");
/**
 * magic symbols to control focus behavior from DOM
 * see description of every particular one
 */ var $92f894e236277f1c$export$1a988e7317c65621 = $26Cgu;
/**
 * @deprecated - please use {@link moveFocusInside} named export
 */ var $92f894e236277f1c$var$deprecated_default_moveFocusInside = (0, $9wlSW.moveFocusInside);
var $92f894e236277f1c$export$2e2bcd8739ae039 //
 = $92f894e236277f1c$var$deprecated_default_moveFocusInside;

});
parcelRegister("9wlSW", function(module, exports) {

$parcel$export(module.exports, "moveFocusInside", () => $6ee8142619db9ef1$export$cd599851e879a025);

var $jfQb7 = parcelRequire("jfQb7");

var $kKJqK = parcelRequire("kKJqK");
var $6ee8142619db9ef1$var$guardCount = 0;
var $6ee8142619db9ef1$var$lockDisabled = false;
var $6ee8142619db9ef1$export$cd599851e879a025 = function(topNode, lastNode, options) {
    if (options === void 0) options = {};
    var focusable = (0, $kKJqK.focusSolver)(topNode, lastNode);
    // global local side effect to countain recursive lock activation and resolve focus-fighting
    if ($6ee8142619db9ef1$var$lockDisabled) return;
    if (focusable) {
        /** +FOCUS-FIGHTING prevention **/ if ($6ee8142619db9ef1$var$guardCount > 2) {
            // we have recursive entered back the lock activation
            console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting");
            $6ee8142619db9ef1$var$lockDisabled = true;
            setTimeout(function() {
                $6ee8142619db9ef1$var$lockDisabled = false;
            }, 1);
            return;
        }
        $6ee8142619db9ef1$var$guardCount++;
        (0, $jfQb7.focusOn)(focusable.node, options.focusOptions);
        $6ee8142619db9ef1$var$guardCount--;
    }
};

});
parcelRegister("kKJqK", function(module, exports) {

$parcel$export(module.exports, "focusSolver", () => $f1bb580dea56dbbd$export$305758c744b57f6f);

var $6e7nq = parcelRequire("6e7nq");

var $l1lpg = parcelRequire("l1lpg");

var $1kBVR = parcelRequire("1kBVR");

var $649lM = parcelRequire("649lM");

var $6QUqp = parcelRequire("6QUqp");

var $33cOt = parcelRequire("33cOt");

var $jlIIa = parcelRequire("jlIIa");

var $3jtrL = parcelRequire("3jtrL");
var $f1bb580dea56dbbd$var$reorderNodes = function(srcNodes, dstNodes) {
    var remap = new Map();
    // no Set(dstNodes) for IE11 :(
    dstNodes.forEach(function(entity) {
        return remap.set(entity.node, entity);
    });
    // remap to dstNodes
    return srcNodes.map(function(node) {
        return remap.get(node);
    }).filter((0, $jlIIa.isDefined));
};
var $f1bb580dea56dbbd$export$305758c744b57f6f = function(topNode, lastNode) {
    var activeElement = (0, $33cOt.getActiveElement)((0, $649lM.asArray)(topNode).length > 0 ? document : (0, $649lM.getFirst)(topNode).ownerDocument);
    var entries = (0, $1kBVR.getAllAffectedNodes)(topNode).filter((0, $jlIIa.isNotAGuard));
    var commonParent = (0, $3jtrL.getTopCommonParent)(activeElement || topNode, topNode, entries);
    var visibilityCache = new Map();
    var anyFocusable = (0, $l1lpg.getFocusableNodes)(entries, visibilityCache);
    var innerElements = anyFocusable.filter(function(_a) {
        var node = _a.node;
        return (0, $jlIIa.isNotAGuard)(node);
    });
    if (!innerElements[0]) return undefined;
    var outerNodes = (0, $l1lpg.getFocusableNodes)([
        commonParent
    ], visibilityCache).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var orderedInnerElements = $f1bb580dea56dbbd$var$reorderNodes(outerNodes, innerElements);
    // collect inner focusable and separately tabbables
    var innerFocusables = orderedInnerElements.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var innerTabbable = orderedInnerElements.filter(function(_a) {
        var tabIndex = _a.tabIndex;
        return tabIndex >= 0;
    }).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var newId = (0, $6e7nq.newFocus)(innerFocusables, innerTabbable, outerNodes, activeElement, lastNode);
    if (newId === (0, $6e7nq.NEW_FOCUS)) {
        var focusNode = // first try only tabbable, and the fallback to all focusable, as long as at least one element should be picked for focus
        (0, $6QUqp.pickAutofocus)(anyFocusable, innerTabbable, (0, $3jtrL.allParentAutofocusables)(entries, visibilityCache)) || (0, $6QUqp.pickAutofocus)(anyFocusable, innerFocusables, (0, $3jtrL.allParentAutofocusables)(entries, visibilityCache));
        if (focusNode) return {
            node: focusNode
        };
        else {
            console.warn('focus-lock: cannot find any node to move focus into');
            return undefined;
        }
    }
    if (newId === undefined) return newId;
    return orderedInnerElements[newId];
};

});
parcelRegister("6e7nq", function(module, exports) {

$parcel$export(module.exports, "NEW_FOCUS", () => $4889c5c91be25c0a$export$85710b12cf912438);
$parcel$export(module.exports, "newFocus", () => $4889c5c91be25c0a$export$65842178e9bb4205);

var $2aoIt = parcelRequire("2aoIt");

var $ee0vg = parcelRequire("ee0vg");

var $jlIIa = parcelRequire("jlIIa");
var $4889c5c91be25c0a$export$85710b12cf912438 = 'NEW_FOCUS';
var $4889c5c91be25c0a$export$65842178e9bb4205 = function(innerNodes, innerTabbables, outerNodes, activeElement, lastNode) {
    var cnt = innerNodes.length;
    var firstFocus = innerNodes[0];
    var lastFocus = innerNodes[cnt - 1];
    var isOnGuard = (0, $jlIIa.isGuard)(activeElement);
    // focus is inside
    if (activeElement && innerNodes.indexOf(activeElement) >= 0) return undefined;
    var activeIndex = activeElement !== undefined ? outerNodes.indexOf(activeElement) : -1;
    var lastIndex = lastNode ? outerNodes.indexOf(lastNode) : activeIndex;
    var lastNodeInside = lastNode ? innerNodes.indexOf(lastNode) : -1;
    // no active focus (or focus is on the body)
    if (activeIndex === -1) {
        // known fallback
        if (lastNodeInside !== -1) return lastNodeInside;
        return $4889c5c91be25c0a$export$85710b12cf912438;
    }
    // new focus, nothing to calculate
    if (lastNodeInside === -1) return $4889c5c91be25c0a$export$85710b12cf912438;
    var indexDiff = activeIndex - lastIndex;
    var firstNodeIndex = outerNodes.indexOf(firstFocus);
    var lastNodeIndex = outerNodes.indexOf(lastFocus);
    var correctedNodes = (0, $2aoIt.correctNodes)(outerNodes);
    var correctedIndex = activeElement !== undefined ? correctedNodes.indexOf(activeElement) : -1;
    var correctedIndexDiff = correctedIndex - (lastNode ? correctedNodes.indexOf(lastNode) : activeIndex);
    // old focus
    if (!indexDiff && lastNodeInside >= 0) return lastNodeInside;
    // no tabbable elements, autofocus is not possible
    if (innerTabbables.length === 0) // an edge case with no tabbable elements
    // return the last focusable one
    // with some probability this will prevent focus from cycling across the lock, but there is no tabbale elements to cycle to
    return lastNodeInside;
    var returnFirstNode = (0, $ee0vg.pickFocusable)(innerNodes, innerTabbables[0]);
    var returnLastNode = (0, $ee0vg.pickFocusable)(innerNodes, innerTabbables[innerTabbables.length - 1]);
    // first element
    if (activeIndex <= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnLastNode;
    // last element
    if (activeIndex >= lastNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnFirstNode;
    // jump out, but not on the guard
    if (indexDiff && Math.abs(correctedIndexDiff) > 1) return lastNodeInside;
    // focus above lock
    if (activeIndex <= firstNodeIndex) return returnLastNode;
    // focus below lock
    if (activeIndex > lastNodeIndex) return returnFirstNode;
    // index is inside tab order, but outside Lock
    if (indexDiff) {
        if (Math.abs(indexDiff) > 1) return lastNodeInside;
        return (cnt + lastNodeInside + indexDiff) % cnt;
    }
    // do nothing
    return undefined;
};

});
parcelRegister("2aoIt", function(module, exports) {

$parcel$export(module.exports, "correctNode", () => $193fb011be33b1b6$export$5261662167ad7ced);
$parcel$export(module.exports, "correctNodes", () => $193fb011be33b1b6$export$4a5a72a7124e45f9);

var $jlIIa = parcelRequire("jlIIa");
var $193fb011be33b1b6$var$findSelectedRadio = function(node, nodes) {
    return nodes.filter((0, $jlIIa.isRadioElement)).filter(function(el) {
        return el.name === node.name;
    }).filter(function(el) {
        return el.checked;
    })[0] || node;
};
var $193fb011be33b1b6$export$5261662167ad7ced = function(node, nodes) {
    if ((0, $jlIIa.isRadioElement)(node) && node.name) return $193fb011be33b1b6$var$findSelectedRadio(node, nodes);
    return node;
};
var $193fb011be33b1b6$export$4a5a72a7124e45f9 = function(nodes) {
    // IE11 has no Set(array) constructor
    var resultSet = new Set();
    nodes.forEach(function(node) {
        return resultSet.add($193fb011be33b1b6$export$5261662167ad7ced(node, nodes));
    });
    // using filter to support IE11
    return nodes.filter(function(node) {
        return resultSet.has(node);
    });
};

});

parcelRegister("ee0vg", function(module, exports) {

$parcel$export(module.exports, "pickFirstFocus", () => $a5b2c367f9c3daa0$export$f4e86cfa0679b9cc);
$parcel$export(module.exports, "pickFocusable", () => $a5b2c367f9c3daa0$export$e06728ee87c96122);

var $2aoIt = parcelRequire("2aoIt");
var $a5b2c367f9c3daa0$export$f4e86cfa0679b9cc = function(nodes) {
    if (nodes[0] && nodes.length > 1) return (0, $2aoIt.correctNode)(nodes[0], nodes);
    return nodes[0];
};
var $a5b2c367f9c3daa0$export$e06728ee87c96122 = function(nodes, node) {
    return nodes.indexOf((0, $2aoIt.correctNode)(node, nodes));
};

});


parcelRegister("6QUqp", function(module, exports) {

$parcel$export(module.exports, "pickAutofocus", () => $4fd35e3fd3ef884c$export$cfb742983e257555);

var $l1lpg = parcelRequire("l1lpg");

var $ee0vg = parcelRequire("ee0vg");

var $jlIIa = parcelRequire("jlIIa");
var $4fd35e3fd3ef884c$var$findAutoFocused = function(autoFocusables) {
    return function(node) {
        var _a;
        var autofocus = (_a = (0, $jlIIa.getDataset)(node)) === null || _a === void 0 ? void 0 : _a.autofocus;
        return(// @ts-expect-error
        node.autofocus || //
        autofocus !== undefined && autofocus !== 'false' || //
        autoFocusables.indexOf(node) >= 0);
    };
};
var $4fd35e3fd3ef884c$export$cfb742983e257555 = function(nodesIndexes, orderedNodes, groups) {
    var nodes = nodesIndexes.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var autoFocusable = (0, $l1lpg.filterAutoFocusable)(nodes.filter($4fd35e3fd3ef884c$var$findAutoFocused(groups)));
    if (autoFocusable && autoFocusable.length) return (0, $ee0vg.pickFirstFocus)(autoFocusable);
    return (0, $ee0vg.pickFirstFocus)((0, $l1lpg.filterAutoFocusable)(orderedNodes));
};

});




parcelRegister("1mLS6", function(module, exports) {

$parcel$export(module.exports, "deferAction", () => $0fecfad02351d8b0$export$6523025722806278);
$parcel$export(module.exports, "extractRef", () => $0fecfad02351d8b0$export$c613fed06e332533);
function $0fecfad02351d8b0$export$6523025722806278(action) {
    setTimeout(action, 1);
}
var $0fecfad02351d8b0$export$db10c343af3f20fa = function inlineProp(name, value) {
    var obj = {};
    obj[name] = value;
    return obj;
};
var $0fecfad02351d8b0$export$c613fed06e332533 = function extractRef(ref) {
    return ref && 'current' in ref ? ref.current : ref;
};

});




parcelRegister("cwc7f", function(module, exports) {

$parcel$export(module.exports, "default", () => $91d1df2d50ef438b$export$2e2bcd8739ae039);

var $iK0nX = parcelRequire("iK0nX");






var $91d1df2d50ef438b$export$2e2bcd8739ae039 = (0, $iK0nX.default);

});

parcelRegister("2alJM", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dejU7 = parcelRequire("dejU7");
Object.defineProperty(module.exports, 'default', {
    enumerable: true,
    get: function get() {
        return $193d608c8a4c8c43$var$_interopRequireDefault($dejU7).default;
    }
});

var $fUXdf = parcelRequire("fUXdf");
Object.defineProperty(module.exports, 'TouchScrollable', {
    enumerable: true,
    get: function get() {
        return $fUXdf.TouchScrollable;
    }
});
function $193d608c8a4c8c43$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("dejU7", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $9a1c05b159231ce4$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $5uXOq = parcelRequire("5uXOq");
var $9a1c05b159231ce4$var$_react2 = $9a1c05b159231ce4$var$_interopRequireDefault($5uXOq);

var $lv4Ny = parcelRequire("lv4Ny");

var $fUXdf = parcelRequire("fUXdf");

var $bdRWg = parcelRequire("bdRWg");
var $9a1c05b159231ce4$var$_withLockSheet2 = $9a1c05b159231ce4$var$_interopRequireDefault($bdRWg);

var $fjsmD = parcelRequire("fjsmD");
var $9a1c05b159231ce4$var$_withTouchListeners2 = $9a1c05b159231ce4$var$_interopRequireDefault($fjsmD);

var $1sALq = parcelRequire("1sALq");
function $9a1c05b159231ce4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9a1c05b159231ce4$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $9a1c05b159231ce4$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $9a1c05b159231ce4$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $9a1c05b159231ce4$var$ScrollLock = function(_PureComponent) {
    $9a1c05b159231ce4$var$_inherits(ScrollLock, _PureComponent);
    function ScrollLock() {
        $9a1c05b159231ce4$var$_classCallCheck(this, ScrollLock);
        return $9a1c05b159231ce4$var$_possibleConstructorReturn(this, (ScrollLock.__proto__ || Object.getPrototypeOf(ScrollLock)).apply(this, arguments));
    }
    $9a1c05b159231ce4$var$_createClass(ScrollLock, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (!$lv4Ny.canUseDOM) return;
                this.initialHeight = window.innerHeight;
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                var offset = window.innerHeight - this.initialHeight;
                // adjust scroll if the window has been resized since the lock was engaged
                // e.g. mobile safari dynamic chrome heights
                if (offset) window.scrollTo(0, window.pageYOffset + offset);
                // reset the initial height in case this scroll lock is used again
                this.initialHeight = window.innerHeight;
            }
        },
        {
            key: 'render',
            value: function render() {
                var children = this.props.children;
                return children ? $9a1c05b159231ce4$var$_react2.default.createElement($fUXdf.TouchScrollable, null, children) : null;
            }
        }
    ]);
    return ScrollLock;
}($5uXOq.PureComponent);
// attach the stylesheet and inject styles on [un]mount
var $9a1c05b159231ce4$var$compose = (0, $1sALq.pipe)($9a1c05b159231ce4$var$_withTouchListeners2.default, $9a1c05b159231ce4$var$_withLockSheet2.default);
var $9a1c05b159231ce4$var$SheetLock = $9a1c05b159231ce4$var$compose($9a1c05b159231ce4$var$ScrollLock);
// toggle the lock based on `isActive` prop
var $9a1c05b159231ce4$var$LockToggle = function LockToggle(props) {
    return props.isActive ? $9a1c05b159231ce4$var$_react2.default.createElement($9a1c05b159231ce4$var$SheetLock, props) : props.children;
};
$9a1c05b159231ce4$var$LockToggle.defaultProps = {
    accountForScrollbars: true,
    children: null,
    isActive: true
};
module.exports.default = $9a1c05b159231ce4$var$LockToggle;

});
parcelRegister("lv4Ny", function(module, exports) {
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/ /* global define */ (function() {
    'use strict';
    var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
    var ExecutionEnvironment = {
        canUseDOM: canUseDOM,
        canUseWorkers: typeof Worker !== 'undefined',
        canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
        canUseViewport: canUseDOM && !!window.screen
    };
    if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) define(function() {
        return ExecutionEnvironment;
    });
    else if (0, module.exports) module.exports = ExecutionEnvironment;
    else window.ExecutionEnvironment = ExecutionEnvironment;
})();

});

parcelRegister("fUXdf", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TouchScrollable = undefined;
var $b96a046705879057$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $b96a046705879057$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $5uXOq = parcelRequire("5uXOq");

var $lv4Ny = parcelRequire("lv4Ny");

var $1sALq = parcelRequire("1sALq");
function $b96a046705879057$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $b96a046705879057$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $b96a046705879057$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $b96a046705879057$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $b96a046705879057$var$TouchScrollable = module.exports.TouchScrollable = function(_PureComponent) {
    $b96a046705879057$var$_inherits(TouchScrollable, _PureComponent);
    function TouchScrollable() {
        var _ref;
        var _temp, _this, _ret;
        $b96a046705879057$var$_classCallCheck(this, TouchScrollable);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $b96a046705879057$var$_possibleConstructorReturn(this, (_ref = TouchScrollable.__proto__ || Object.getPrototypeOf(TouchScrollable)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.getScrollableArea = function(ref) {
            _this.scrollableArea = ref;
        }, _temp), $b96a046705879057$var$_possibleConstructorReturn(_this, _ret);
    }
    $b96a046705879057$var$_createClass(TouchScrollable, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (!$lv4Ny.canUseEventListeners) return;
                this.scrollableArea.addEventListener('touchstart', $1sALq.preventInertiaScroll, $1sALq.listenerOptions);
                this.scrollableArea.addEventListener('touchmove', $1sALq.allowTouchMove, $1sALq.listenerOptions);
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                if (!$lv4Ny.canUseEventListeners) return;
                this.scrollableArea.removeEventListener('touchstart', $1sALq.preventInertiaScroll, $1sALq.listenerOptions);
                this.scrollableArea.removeEventListener('touchmove', $1sALq.allowTouchMove, $1sALq.listenerOptions);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, children = _props.children, rest = $b96a046705879057$var$_objectWithoutProperties(_props, [
                    'children'
                ]);
                return typeof children === 'function' ? children(this.getScrollableArea) : (0, $5uXOq.cloneElement)(children, $b96a046705879057$var$_extends({
                    ref: this.getScrollableArea
                }, rest));
            }
        }
    ]);
    return TouchScrollable;
}($5uXOq.PureComponent);

});
parcelRegister("1sALq", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pipe = module.exports.listenerOptions = undefined;
module.exports.preventTouchMove = $1104ec85449a533c$var$preventTouchMove;
module.exports.allowTouchMove = $1104ec85449a533c$var$allowTouchMove;
module.exports.preventInertiaScroll = $1104ec85449a533c$var$preventInertiaScroll;
module.exports.isTouchDevice = $1104ec85449a533c$var$isTouchDevice;
module.exports.camelToKebab = $1104ec85449a533c$var$camelToKebab;
module.exports.parse = $1104ec85449a533c$var$parse;
module.exports.getPadding = $1104ec85449a533c$var$getPadding;
module.exports.getWindowHeight = $1104ec85449a533c$var$getWindowHeight;
module.exports.getDocumentHeight = $1104ec85449a533c$var$getDocumentHeight;
module.exports.makeStyleTag = $1104ec85449a533c$var$makeStyleTag;
module.exports.injectStyles = $1104ec85449a533c$var$injectStyles;
module.exports.insertStyleTag = $1104ec85449a533c$var$insertStyleTag;

var $lv4Ny = parcelRequire("lv4Ny");
var $1104ec85449a533c$var$listenerOptions = module.exports.listenerOptions = {
    capture: false,
    passive: false
};
// ==============================
// Touch Helpers
// ==============================
function $1104ec85449a533c$var$preventTouchMove(e) {
    e.preventDefault();
    return false;
}
function $1104ec85449a533c$var$allowTouchMove(e) {
    var target = e.currentTarget;
    if (target.scrollHeight > target.clientHeight) {
        e.stopPropagation();
        return true;
    }
    e.preventDefault();
    return false;
}
function $1104ec85449a533c$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $1104ec85449a533c$var$isTouchDevice() {
    if (!$lv4Ny.canUseDOM) return false;
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
// ==============================
// Misc.
// ==============================
function $1104ec85449a533c$var$camelToKebab(str) {
    return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}
function $1104ec85449a533c$var$parse(val) {
    return isNaN(val) ? val : val + 'px';
}
// Take a list of functions and return a function that applies the list of
// functions from left to right
var $1104ec85449a533c$var$pipeFns = function pipeFns(a, b) {
    return function() {
        return b(a.apply(undefined, arguments));
    };
};
var $1104ec85449a533c$var$pipe = module.exports.pipe = function pipe() {
    for(var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return fns.reduce($1104ec85449a533c$var$pipeFns);
};
// ==============================
// Document Helpers
// ==============================
function $1104ec85449a533c$var$getPadding() {
    if (!$lv4Ny.canUseDOM) return 0;
    var paddingRight = parseInt(window.getComputedStyle(document.body).paddingRight, 10);
    var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    return paddingRight + scrollbarWidth;
}
function $1104ec85449a533c$var$getWindowHeight() {
    var multiplier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    if ($lv4Ny.canUseDOM) return window.innerHeight * multiplier;
}
function $1104ec85449a533c$var$getDocumentHeight() {
    if ($lv4Ny.canUseDOM) return document.body.clientHeight;
}
// ==============================
// Style Sheets
// ==============================
function $1104ec85449a533c$var$makeStyleTag() {
    if (!$lv4Ny.canUseDOM) return;
    var tag = document.createElement('style');
    tag.type = 'text/css';
    tag.setAttribute('data-react-scrolllock', '');
    return tag;
}
function $1104ec85449a533c$var$injectStyles(tag, css) {
    if (!$lv4Ny.canUseDOM) return;
    if (tag.styleSheet) tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $1104ec85449a533c$var$insertStyleTag(tag) {
    if (!$lv4Ny.canUseDOM) return;
    var head = document.head || document.getElementsByTagName('head')[0];
    head.appendChild(tag);
}

});


parcelRegister("bdRWg", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $82babfbe1d9118db$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
module.exports.default = $82babfbe1d9118db$var$withLockSheet;

var $5uXOq = parcelRequire("5uXOq");
var $82babfbe1d9118db$var$_react2 = $82babfbe1d9118db$var$_interopRequireDefault($5uXOq);

var $1sALq = parcelRequire("1sALq");
function $82babfbe1d9118db$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $82babfbe1d9118db$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $82babfbe1d9118db$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $82babfbe1d9118db$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $82babfbe1d9118db$var$withLockSheet(WrappedComponent) {
    return function(_PureComponent) {
        $82babfbe1d9118db$var$_inherits(SheetProvider, _PureComponent);
        function SheetProvider() {
            var _ref;
            var _temp, _this, _ret;
            $82babfbe1d9118db$var$_classCallCheck(this, SheetProvider);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $82babfbe1d9118db$var$_possibleConstructorReturn(this, (_ref = SheetProvider.__proto__ || Object.getPrototypeOf(SheetProvider)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.addSheet = function() {
                var styles = _this.getStyles();
                var sheet = (0, $1sALq.makeStyleTag)();
                if (!sheet) return;
                (0, $1sALq.injectStyles)(sheet, styles);
                (0, $1sALq.insertStyleTag)(sheet);
                _this.sheet = sheet;
            }, _this.getStyles = function() {
                var accountForScrollbars = _this.props.accountForScrollbars;
                var height = (0, $1sALq.getDocumentHeight)();
                var paddingRight = accountForScrollbars ? (0, $1sALq.getPadding)() : null;
                var styles = 'body {\n        box-sizing: border-box !important;\n        overflow: hidden !important;\n        position: relative !important;\n        ' + (height ? 'height: ' + height + 'px !important;' : '') + '\n        ' + (paddingRight ? 'padding-right: ' + paddingRight + 'px !important;' : '') + '\n      }';
                return styles;
            }, _temp), $82babfbe1d9118db$var$_possibleConstructorReturn(_this, _ret);
        }
        $82babfbe1d9118db$var$_createClass(SheetProvider, [
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    this.addSheet();
                }
            },
            {
                key: 'removeSheet',
                value: function removeSheet() {
                    if (!this.sheet) return;
                    // $FlowFixMe
                    this.sheet.parentNode.removeChild(this.sheet);
                    this.sheet = null;
                }
            },
            {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    this.removeSheet();
                }
            },
            {
                key: 'render',
                value: function render() {
                    return $82babfbe1d9118db$var$_react2.default.createElement(WrappedComponent, this.props);
                }
            }
        ]);
        return SheetProvider;
    }($5uXOq.PureComponent);
}

});

parcelRegister("fjsmD", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $b25ea1e2c8dc8373$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
module.exports.default = $b25ea1e2c8dc8373$var$withTouchListeners;

var $5uXOq = parcelRequire("5uXOq");
var $b25ea1e2c8dc8373$var$_react2 = $b25ea1e2c8dc8373$var$_interopRequireDefault($5uXOq);

var $lv4Ny = parcelRequire("lv4Ny");

var $1sALq = parcelRequire("1sALq");
function $b25ea1e2c8dc8373$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b25ea1e2c8dc8373$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $b25ea1e2c8dc8373$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $b25ea1e2c8dc8373$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
// Mobile Safari ignores { overflow: hidden } declaration on the body,
// so we have to prevent touchmove events via JS
function $b25ea1e2c8dc8373$var$withTouchListeners(WrappedComponent) {
    return function(_PureComponent) {
        $b25ea1e2c8dc8373$var$_inherits(TouchProvider, _PureComponent);
        function TouchProvider() {
            $b25ea1e2c8dc8373$var$_classCallCheck(this, TouchProvider);
            return $b25ea1e2c8dc8373$var$_possibleConstructorReturn(this, (TouchProvider.__proto__ || Object.getPrototypeOf(TouchProvider)).apply(this, arguments));
        }
        $b25ea1e2c8dc8373$var$_createClass(TouchProvider, [
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    if (!$lv4Ny.canUseDOM || !(0, $1sALq.isTouchDevice)()) return;
                    document.addEventListener('touchmove', $1sALq.preventTouchMove, $1sALq.listenerOptions);
                }
            },
            {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    if (!$lv4Ny.canUseDOM || !(0, $1sALq.isTouchDevice)()) return;
                    document.removeEventListener('touchmove', $1sALq.preventTouchMove, $1sALq.listenerOptions);
                }
            },
            {
                key: 'render',
                value: function render() {
                    return $b25ea1e2c8dc8373$var$_react2.default.createElement(WrappedComponent, this.props);
                }
            }
        ]);
        return TouchProvider;
    }($5uXOq.PureComponent);
}

});



parcelRegister("61IPU", function(module, exports) {

$parcel$export(module.exports, "monitorForExternal", () => (parcelRequire("iPCNN")).monitorForExternal);
$parcel$export(module.exports, "dropTargetForExternal", () => (parcelRequire("iPCNN")).dropTargetForExternal);

var $iPCNN = parcelRequire("iPCNN");

});
parcelRegister("iPCNN", function(module, exports) {

$parcel$export(module.exports, "dropTargetForExternal", () => $f377df4064e10188$export$9edc779df9a85289);
$parcel$export(module.exports, "monitorForExternal", () => $f377df4064e10188$export$bb1740f3194979c1);

var $cBeZP = parcelRequire("cBeZP");

var $iiVLC = parcelRequire("iiVLC");

var $6XFIM = parcelRequire("6XFIM");

var $e2Xjq = parcelRequire("e2Xjq");

var $h5V4I = parcelRequire("h5V4I");


function $f377df4064e10188$export$a8e56a860d7957c7({ type: type, value: value }) {
    // We don't want to expose our private elementAdapter key / value
    if (type === (0, $dad94f2a683170ce$export$c9c4cc54e73b125d)) return false;
    // Not exposing "text/plain" if it contains the android fallback text
    // We _could_ add an `isAndroid()` check, but it's probably safest
    // to trim this data out, regardless of what OS we see it on.
    if (type === (0, $511ea0f8ed5a789e$export$fd3d00026297c0ad) && value === (0, $6XFIM.androidFallbackText)) return false;
    return true;
}
function $f377df4064e10188$export$8c257a3856120a77(transfer) {
    return Array.from(transfer.types).filter((type)=>$f377df4064e10188$export$a8e56a860d7957c7({
            type: type,
            value: transfer.getData(type)
        }));
}
function $f377df4064e10188$export$8d28cfecded8dcab(dataTransfer) {
    // item.kind is 'string' | 'file'
    // For 'string' item.type is the mimeType (eg 'text/plain')
    // For 'file' item.type is the file type (eg 'image/jpg')
    return Array.from(dataTransfer.items).filter((item)=>item.kind === 'file' || $f377df4064e10188$export$a8e56a860d7957c7({
            type: item.type,
            value: dataTransfer.getData(item.type)
        }));
}
let $f377df4064e10188$var$didDragStartLocally = false;
const $f377df4064e10188$var$adapter = (0, $iiVLC.makeAdapter)({
    typeKey: 'external',
    // for external drags, we are generally making a copy of something that is being dragged
    defaultDropEffect: 'copy',
    mount (api) {
        // Binding to the `window` so that the element adapter
        // has a chance to get in first on the`document`.
        // We are giving preference to the element adapter.
        return (0, $cBeZP.bind)(window, {
            type: 'dragenter',
            listener (event) {
                // drag operation was started within the document, it won't be an "external" drag
                if ($f377df4064e10188$var$didDragStartLocally) return;
                // Note: not checking if event was cancelled (`event.defaultPrevented`) as
                // cancelling a "dragenter" accepts the drag operation (not prevent it)
                // Something has gone wrong with our drag event
                if (!event.dataTransfer) return;
                if (!api.canStart(event)) return;
                if (!(0, $e2Xjq.isEnteringWindow)({
                    dragEnter: event
                })) return;
                // Note: not checking types for `elementAdapterNativeDataKey` as we expect to see that
                // key when pdnd started the drag in another document
                const types = $f377df4064e10188$export$8c257a3856120a77(event.dataTransfer);
                if (!types.length) return;
                const locked = {
                    types: types,
                    items: [],
                    getStringData: ()=>null
                };
                api.start({
                    event: event,
                    dragType: {
                        type: 'external',
                        startedFrom: 'external',
                        payload: locked,
                        getDropPayload (event) {
                            // this would be a platform error
                            // trying to handle it gracefully rather than throwing (for now)
                            if (!event.dataTransfer) return locked;
                            const items = $f377df4064e10188$export$8d28cfecded8dcab(event.dataTransfer);
                            // need to use `.bind` as `getData` is required
                            // to be run with `event.dataTransfer` as the "this" context
                            const nativeGetData = event.dataTransfer.getData.bind(event.dataTransfer);
                            return {
                                types: types,
                                items: items,
                                // return `null` if there is no result, otherwise string
                                getStringData (mediaType) {
                                    // not dragging the requested type
                                    // return `null` (no result)
                                    if (!types.includes(mediaType)) return null;
                                    // nativeGetData will return `""` when there is no value,
                                    // but at this point we know we will only get explicitly set
                                    // values back as we have checked the `types`.
                                    // `""` can be an explicitly set value.
                                    const value = nativeGetData(mediaType);
                                    // not exposing data for unavailable types
                                    if (!$f377df4064e10188$export$a8e56a860d7957c7({
                                        type: mediaType,
                                        value: value
                                    })) return null;
                                    return value;
                                }
                            };
                        }
                    }
                });
            }
        });
    }
});
function $f377df4064e10188$export$9edc779df9a85289(args) {
    // not removing unused events, just leaning on the type system
    return $f377df4064e10188$var$adapter.dropTarget(args);
}
function $f377df4064e10188$export$bb1740f3194979c1(args) {
    // not removing unused events, just leaning on the type system
    return $f377df4064e10188$var$adapter.monitor(args);
}
(function startup() {
    // server side rendering check
    if (typeof window === 'undefined') return;
    // A shared single usage registration as we want to capture
    // all external drag operations, even if there are no drop targets
    // on the page yet
    $f377df4064e10188$var$adapter.registerUsage();
    // independent of pdnd, we need to keep track of
    // all drag operations so that we can know if a drag operation
    // has started locally
    const idle = {
        type: 'idle'
    };
    let state = idle;
    function clear() {
        if (state.type !== 'dragging') return;
        $f377df4064e10188$var$didDragStartLocally = false;
        state.cleanup();
        state = idle;
    }
    function bindEndEvents() {
        return (0, $cBeZP.bindAll)(window, [
            {
                type: 'dragend',
                listener: clear
            },
            ...(0, $h5V4I.getBindingsForBrokenDrags)({
                onDragEnd: clear
            })
        ], // we want to make sure we get all the events,
        // and this helps avoid not seeing events when folks stop
        // them later on the event path
        {
            capture: true
        });
    }
    // we always keep this event listener active
    (0, $cBeZP.bind)(window, {
        type: 'dragstart',
        listener () {
            // something bad has happened if this is true!
            if (state.type !== 'idle') return;
            // set our global flag
            $f377df4064e10188$var$didDragStartLocally = true;
            state = {
                type: 'dragging',
                cleanup: bindEndEvents()
            };
        },
        // binding in the capture phase so these listeners are called
        // before our listeners in the adapters `mount` function
        options: {
            capture: true
        }
    });
})();

});
parcelRegister("e2Xjq", function(module, exports) {

$parcel$export(module.exports, "isEnteringWindow", () => $ad99df0f18a6cc64$export$d1c6f249e893cdf4);

var $bYN8w = parcelRequire("bYN8w");

var $6aABs = parcelRequire("6aABs");

var $apnEk = parcelRequire("apnEk");

var $9Mj6M = parcelRequire("9Mj6M");
function $ad99df0f18a6cc64$export$d1c6f249e893cdf4({ dragEnter: dragEnter }) {
    const { type: type, relatedTarget: relatedTarget } = dragEnter;
    if (type !== 'dragenter') return false;
    if ((0, $6aABs.isSafari)()) return (0, $apnEk.isEnteringWindowInSafari)({
        dragEnter: dragEnter
    });
    // standard check
    if (relatedTarget == null) return true;
    /**
	 * 🦊 Exception: `iframe` in Firefox (`125.0`)
	 *
	 * Case 1: parent `window` → child `iframe`
	 * `relatedTarget` is the `iframe` element in the parent `window`
	 * (foreign element)
	 *
	 * Case 2: child `iframe` → parent `window`
	 * `relatedTarget` is an element inside the child `iframe`
	 * (foreign element)
	 */ if ((0, $bYN8w.isFirefox)()) return (0, $9Mj6M.isFromAnotherWindow)(relatedTarget);
    /**
	 * 🌏 Exception: `iframe` in Chrome (`124.0`)
	 *
	 * Case 1: parent `window` → child `iframe`
	 * `relatedTarget` is `null` *(standard check)*
	 *
	 * Case 2: child `iframe` → parent `window`
	 * `relatedTarget` is the `iframe` element in the parent `window`
	 */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return relatedTarget instanceof HTMLIFrameElement;
}

});



parcelRegister("dOXu7", function(module, exports) {

$parcel$export(module.exports, "monitorForTextSelection", () => (parcelRequire("eU6JV")).monitorForTextSelection);

var $eU6JV = parcelRequire("eU6JV");

});
parcelRegister("eU6JV", function(module, exports) {

$parcel$export(module.exports, "monitorForTextSelection", () => $6ec1b195aeff981f$export$2e178e3647f5e6e9);

var $cBeZP = parcelRequire("cBeZP");

var $8d5CE = parcelRequire("8d5CE");

var $iiVLC = parcelRequire("iiVLC");

var $3zl3q = parcelRequire("3zl3q");

var $6aABs = parcelRequire("6aABs");



function $6ec1b195aeff981f$var$findTextNode(event) {
    // Standard: the `event.target` should be the closest `Text` node.
    if (event.target instanceof Text) return event.target;
    // Structuring things this way so that if Safari fixes their bug
    // then the standard check will start working
    if (!(0, $6aABs.isSafari)()) return null;
    /**
	 * According to the spec, `event.target` should be the `Text` node that
	 * the drag started from when dragging a text selection.
	 *
	 * → https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
	 *
	 * However, in Safari the closest `HTMLElement` is returned.
	 * So we need to figure out if text is dragging ourselves.
	 *
	 * → https://bugs.webkit.org/show_bug.cgi?id=268959
	 */ if (!(event.target instanceof HTMLElement)) return null;
    // Unlikely that this particular drag is a text selection drag
    if (event.target.draggable) return null;
    // if the drag contains no text data, then not dragging selected text
    // return `null` if there is no dataTransfer, or if `getData()` returns ""
    if (!event.dataTransfer?.getData((0, $511ea0f8ed5a789e$export$fd3d00026297c0ad))) return null;
    /**
	 * Grab the first Text node and use that.
	 * Only doing a single level search as that is all we need for this bug.
	 */ const text = Array.from(event.target.childNodes).find((node)=>node.nodeType === Node.TEXT_NODE);
    return text ?? null;
}
const $6ec1b195aeff981f$var$honeyPotFix = (0, $8d5CE.makeHoneyPotFix)();
const $6ec1b195aeff981f$var$adapter = (0, $iiVLC.makeAdapter)({
    typeKey: 'text-selection',
    // for text selection, we will usually be making a copy of the text
    defaultDropEffect: 'copy',
    mount (api) {
        // Binding to the `window` so that the element adapter has a
        // chance to get in first on the `document`.
        // We are giving preference to the element adapter.
        return (0, $3zl3q.combine)($6ec1b195aeff981f$var$honeyPotFix.bindEvents(), (0, $cBeZP.bind)(window, {
            type: 'dragstart',
            listener (event) {
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Something has gone wrong with our drag event
                if (!event.dataTransfer) return;
                // Drag is being handled by the element adapter
                if (event.dataTransfer.types.includes((0, $dad94f2a683170ce$export$c9c4cc54e73b125d))) return;
                // Something else is handling this drag
                if (!api.canStart(event)) return;
                // no text being dragged
                if (!event.dataTransfer.types.includes((0, $511ea0f8ed5a789e$export$fd3d00026297c0ad))) return;
                const target = $6ec1b195aeff981f$var$findTextNode(event);
                // could not find `Text` node that is being dragged from
                if (!target) return;
                const payload = {
                    target: // The `Text` node that is the `target` is the `Text` node
                    // that the user started the drag from.
                    // The full text being dragged can be looked up from the `dataTransfer`.
                    target,
                    plain: event.dataTransfer.getData((0, $511ea0f8ed5a789e$export$fd3d00026297c0ad)),
                    HTML: event.dataTransfer.getData((0, $832d2a5d5849f305$export$338a9f6c7a1f02b0))
                };
                api.start({
                    event: event,
                    dragType: {
                        type: 'text-selection',
                        startedFrom: 'internal',
                        payload: payload
                    }
                });
            }
        }));
    },
    onPostDispatch: $6ec1b195aeff981f$var$honeyPotFix.getOnPostDispatch()
});
function $6ec1b195aeff981f$export$9bfaa8eb182300d1(args) {
    // note: not removing `onGenerateDragPreview`; just leaning on the type system
    return $6ec1b195aeff981f$var$adapter.dropTarget(args);
}
// A shared single usage registration as any text can be dragged at any time
(function register() {
    // server side rendering check
    if (typeof window === 'undefined') return;
    $6ec1b195aeff981f$var$adapter.registerUsage();
})();
function $6ec1b195aeff981f$export$2e178e3647f5e6e9(args) {
    // note: not removing `onGenerateDragPreview`; just leaning on the type system
    return $6ec1b195aeff981f$var$adapter.monitor(args);
}

});
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
const $832d2a5d5849f305$export$338a9f6c7a1f02b0 = 'text/html';



parcelRegister("fGOj2", function(module, exports) {

var $ku1fk = parcelRequire("ku1fk");
var $b6c1ccfb8fc1be45$var$listeningFocusTrap = null;
function $b6c1ccfb8fc1be45$var$focusTrap(element, userOptions) {
    var tabbableNodes = [];
    var firstTabbableNode = null;
    var lastTabbableNode = null;
    var nodeFocusedBeforeActivation = null;
    var active = false;
    var paused = false;
    var tabEvent = null;
    var container = typeof element === 'string' ? document.querySelector(element) : element;
    var config = userOptions || {};
    config.returnFocusOnDeactivate = userOptions && userOptions.returnFocusOnDeactivate !== undefined ? userOptions.returnFocusOnDeactivate : true;
    config.escapeDeactivates = userOptions && userOptions.escapeDeactivates !== undefined ? userOptions.escapeDeactivates : true;
    var trap = {
        activate: activate,
        deactivate: deactivate,
        pause: pause,
        unpause: unpause
    };
    return trap;
    function activate(activateOptions) {
        if (active) return;
        var defaultedActivateOptions = {
            onActivate: activateOptions && activateOptions.onActivate !== undefined ? activateOptions.onActivate : config.onActivate
        };
        active = true;
        paused = false;
        nodeFocusedBeforeActivation = document.activeElement;
        if (defaultedActivateOptions.onActivate) defaultedActivateOptions.onActivate();
        addListeners();
        return trap;
    }
    function deactivate(deactivateOptions) {
        if (!active) return;
        var defaultedDeactivateOptions = {
            returnFocus: deactivateOptions && deactivateOptions.returnFocus !== undefined ? deactivateOptions.returnFocus : config.returnFocusOnDeactivate,
            onDeactivate: deactivateOptions && deactivateOptions.onDeactivate !== undefined ? deactivateOptions.onDeactivate : config.onDeactivate
        };
        removeListeners();
        if (defaultedDeactivateOptions.onDeactivate) defaultedDeactivateOptions.onDeactivate();
        if (defaultedDeactivateOptions.returnFocus) setTimeout(function() {
            $b6c1ccfb8fc1be45$var$tryFocus(nodeFocusedBeforeActivation);
        }, 0);
        active = false;
        paused = false;
        return this;
    }
    function pause() {
        if (paused || !active) return;
        paused = true;
        removeListeners();
    }
    function unpause() {
        if (!paused || !active) return;
        paused = false;
        addListeners();
    }
    function addListeners() {
        if (!active) return;
        // There can be only one listening focus trap at a time
        if ($b6c1ccfb8fc1be45$var$listeningFocusTrap) $b6c1ccfb8fc1be45$var$listeningFocusTrap.pause();
        $b6c1ccfb8fc1be45$var$listeningFocusTrap = trap;
        updateTabbableNodes();
        // Ensure that the focused element doesn't capture the event that caused the focus trap activation
        setTimeout(function() {
            $b6c1ccfb8fc1be45$var$tryFocus(firstFocusNode());
        }, 0);
        document.addEventListener('focus', checkFocus, true);
        document.addEventListener('click', checkClick, true);
        document.addEventListener('mousedown', checkPointerDown, true);
        document.addEventListener('touchstart', checkPointerDown, true);
        document.addEventListener('keydown', checkKey, true);
        return trap;
    }
    function removeListeners() {
        if (!active || $b6c1ccfb8fc1be45$var$listeningFocusTrap !== trap) return;
        document.removeEventListener('focus', checkFocus, true);
        document.removeEventListener('click', checkClick, true);
        document.removeEventListener('mousedown', checkPointerDown, true);
        document.removeEventListener('touchstart', checkPointerDown, true);
        document.removeEventListener('keydown', checkKey, true);
        $b6c1ccfb8fc1be45$var$listeningFocusTrap = null;
        return trap;
    }
    function getNodeForOption(optionName) {
        var optionValue = config[optionName];
        var node = optionValue;
        if (!optionValue) return null;
        if (typeof optionValue === 'string') {
            node = document.querySelector(optionValue);
            if (!node) throw new Error('`' + optionName + '` refers to no known node');
        }
        if (typeof optionValue === 'function') {
            node = optionValue();
            if (!node) throw new Error('`' + optionName + '` did not return a node');
        }
        return node;
    }
    function firstFocusNode() {
        var node;
        if (getNodeForOption('initialFocus') !== null) node = getNodeForOption('initialFocus');
        else if (container.contains(document.activeElement)) node = document.activeElement;
        else node = tabbableNodes[0] || getNodeForOption('fallbackFocus');
        if (!node) throw new Error('You can\'t have a focus-trap without at least one focusable element');
        return node;
    }
    // This needs to be done on mousedown and touchstart instead of click
    // so that it precedes the focus event
    function checkPointerDown(e) {
        if (config.clickOutsideDeactivates && !container.contains(e.target)) deactivate({
            returnFocus: false
        });
    }
    function checkClick(e) {
        if (config.clickOutsideDeactivates) return;
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
    }
    function checkFocus(e) {
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        // Checking for a blur method here resolves a Firefox issue (#15)
        if (typeof e.target.blur === 'function') e.target.blur();
        if (tabEvent) readjustFocus(tabEvent);
    }
    function checkKey(e) {
        if (e.key === 'Tab' || e.keyCode === 9) handleTab(e);
        if (config.escapeDeactivates !== false && $b6c1ccfb8fc1be45$var$isEscapeEvent(e)) deactivate();
    }
    function handleTab(e) {
        updateTabbableNodes();
        if (e.target.hasAttribute('tabindex') && Number(e.target.getAttribute('tabindex')) < 0) return tabEvent = e;
        e.preventDefault();
        var currentFocusIndex = tabbableNodes.indexOf(e.target);
        if (e.shiftKey) {
            if (e.target === firstTabbableNode || tabbableNodes.indexOf(e.target) === -1) return $b6c1ccfb8fc1be45$var$tryFocus(lastTabbableNode);
            return $b6c1ccfb8fc1be45$var$tryFocus(tabbableNodes[currentFocusIndex - 1]);
        }
        if (e.target === lastTabbableNode) return $b6c1ccfb8fc1be45$var$tryFocus(firstTabbableNode);
        $b6c1ccfb8fc1be45$var$tryFocus(tabbableNodes[currentFocusIndex + 1]);
    }
    function updateTabbableNodes() {
        tabbableNodes = $ku1fk(container);
        firstTabbableNode = tabbableNodes[0];
        lastTabbableNode = tabbableNodes[tabbableNodes.length - 1];
    }
    function readjustFocus(e) {
        if (e.shiftKey) return $b6c1ccfb8fc1be45$var$tryFocus(lastTabbableNode);
        $b6c1ccfb8fc1be45$var$tryFocus(firstTabbableNode);
    }
}
function $b6c1ccfb8fc1be45$var$isEscapeEvent(e) {
    return e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
}
function $b6c1ccfb8fc1be45$var$tryFocus(node) {
    if (!node || !node.focus) return;
    if (node === document.activeElement) return;
    node.focus();
    if (node.tagName.toLowerCase() === 'input') node.select();
}
module.exports = $b6c1ccfb8fc1be45$var$focusTrap;

});
parcelRegister("ku1fk", function(module, exports) {
module.exports = function(el, options) {
    options = options || {};
    var elementDocument = el.ownerDocument || el;
    var basicTabbables = [];
    var orderedTabbables = [];
    // A node is "available" if
    // - it's computed style
    var isUnavailable = $ee97937178da774c$var$createIsUnavailable(elementDocument);
    var candidateSelectors = [
        'input',
        'select',
        'a[href]',
        'textarea',
        'button',
        '[tabindex]'
    ];
    var candidates = el.querySelectorAll(candidateSelectors.join(','));
    if (options.includeContainer) {
        var matches = Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
        if (candidateSelectors.some(function(candidateSelector) {
            return matches.call(el, candidateSelector);
        })) {
            candidates = Array.prototype.slice.apply(candidates);
            candidates.unshift(el);
        }
    }
    var candidate, candidateIndexAttr, candidateIndex;
    for(var i = 0, l = candidates.length; i < l; i++){
        candidate = candidates[i];
        candidateIndexAttr = parseInt(candidate.getAttribute('tabindex'), 10);
        candidateIndex = isNaN(candidateIndexAttr) ? candidate.tabIndex : candidateIndexAttr;
        if (candidateIndex < 0 || candidate.tagName === 'INPUT' && candidate.type === 'hidden' || candidate.disabled || isUnavailable(candidate, elementDocument)) continue;
        if (candidateIndex === 0) basicTabbables.push(candidate);
        else orderedTabbables.push({
            index: i,
            tabIndex: candidateIndex,
            node: candidate
        });
    }
    var tabbableNodes = orderedTabbables.sort(function(a, b) {
        return a.tabIndex === b.tabIndex ? a.index - b.index : a.tabIndex - b.tabIndex;
    }).map(function(a) {
        return a.node;
    });
    Array.prototype.push.apply(tabbableNodes, basicTabbables);
    return tabbableNodes;
};
function $ee97937178da774c$var$createIsUnavailable(elementDocument) {
    // Node cache must be refreshed on every check, in case
    // the content of the element has changed
    var isOffCache = [];
    // "off" means `display: none;`, as opposed to "hidden",
    // which means `visibility: hidden;`. getComputedStyle
    // accurately reflects visiblity in context but not
    // "off" state, so we need to recursively check parents.
    function isOff(node, nodeComputedStyle) {
        if (node === elementDocument.documentElement) return false;
        // Find the cached node (Array.prototype.find not available in IE9)
        for(var i = 0, length = isOffCache.length; i < length; i++){
            if (isOffCache[i][0] === node) return isOffCache[i][1];
        }
        nodeComputedStyle = nodeComputedStyle || elementDocument.defaultView.getComputedStyle(node);
        var result = false;
        if (nodeComputedStyle.display === 'none') result = true;
        else if (node.parentNode) result = isOff(node.parentNode);
        isOffCache.push([
            node,
            result
        ]);
        return result;
    }
    return function isUnavailable(node) {
        if (node === elementDocument.documentElement) return false;
        var computedStyle = elementDocument.defaultView.getComputedStyle(node);
        if (isOff(node, computedStyle)) return true;
        return computedStyle.visibility === 'hidden';
    };
}

});


parcelRegister("k9tnV", function(module, exports) {

$parcel$export(module.exports, "default", () => $eabb711d482d792e$export$2e2bcd8739ae039);

var $5pMPR = parcelRequire("5pMPR");
function $eabb711d482d792e$var$isOptionsObject(options) {
    return options === Object(options) && Object.keys(options).length !== 0;
}
function $eabb711d482d792e$var$defaultBehavior(actions, behavior) {
    if (behavior === void 0) behavior = 'auto';
    var canSmoothScroll = 'scrollBehavior' in document.body.style;
    actions.forEach(function(_ref) {
        var el = _ref.el, top = _ref.top, left = _ref.left;
        if (el.scroll && canSmoothScroll) el.scroll({
            top: top,
            left: left,
            behavior: behavior
        });
        else {
            el.scrollTop = top;
            el.scrollLeft = left;
        }
    });
}
function $eabb711d482d792e$var$getOptions(options) {
    if (options === false) return {
        block: 'end',
        inline: 'nearest'
    };
    if ($eabb711d482d792e$var$isOptionsObject(options)) return options;
    return {
        block: 'start',
        inline: 'nearest'
    };
}
function $eabb711d482d792e$var$scrollIntoView(target, options) {
    var targetIsDetached = !target.ownerDocument.documentElement.contains(target);
    if ($eabb711d482d792e$var$isOptionsObject(options) && typeof options.behavior === 'function') return options.behavior(targetIsDetached ? [] : (0, $5pMPR.default)(target, options));
    if (targetIsDetached) return;
    var computeOptions = $eabb711d482d792e$var$getOptions(options);
    return $eabb711d482d792e$var$defaultBehavior((0, $5pMPR.default)(target, computeOptions), computeOptions.behavior);
}
var $eabb711d482d792e$export$2e2bcd8739ae039 = $eabb711d482d792e$var$scrollIntoView;

});
parcelRegister("5pMPR", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f152b3d7b173718$export$2e2bcd8739ae039);
function $3f152b3d7b173718$var$isElement(el) {
    return el != null && typeof el === 'object' && el.nodeType === 1;
}
function $3f152b3d7b173718$var$canOverflow(overflow, skipOverflowHiddenElements) {
    if (skipOverflowHiddenElements && overflow === 'hidden') return false;
    return overflow !== 'visible' && overflow !== 'clip';
}
function $3f152b3d7b173718$var$getFrameElement(el) {
    if (!el.ownerDocument || !el.ownerDocument.defaultView) return null;
    return el.ownerDocument.defaultView.frameElement;
}
function $3f152b3d7b173718$var$isHiddenByFrame(el) {
    var frame = $3f152b3d7b173718$var$getFrameElement(el);
    if (!frame) return false;
    return frame.clientHeight < el.scrollHeight || frame.clientWidth < el.scrollWidth;
}
function $3f152b3d7b173718$var$isScrollable(el, skipOverflowHiddenElements) {
    if (el.clientHeight < el.scrollHeight || el.clientWidth < el.scrollWidth) {
        var style = getComputedStyle(el, null);
        return $3f152b3d7b173718$var$canOverflow(style.overflowY, skipOverflowHiddenElements) || $3f152b3d7b173718$var$canOverflow(style.overflowX, skipOverflowHiddenElements) || $3f152b3d7b173718$var$isHiddenByFrame(el);
    }
    return false;
}
function $3f152b3d7b173718$var$alignNearest(scrollingEdgeStart, scrollingEdgeEnd, scrollingSize, scrollingBorderStart, scrollingBorderEnd, elementEdgeStart, elementEdgeEnd, elementSize) {
    if (elementEdgeStart < scrollingEdgeStart && elementEdgeEnd > scrollingEdgeEnd || elementEdgeStart > scrollingEdgeStart && elementEdgeEnd < scrollingEdgeEnd) return 0;
    if (elementEdgeStart <= scrollingEdgeStart && elementSize <= scrollingSize || elementEdgeEnd >= scrollingEdgeEnd && elementSize >= scrollingSize) return elementEdgeStart - scrollingEdgeStart - scrollingBorderStart;
    if (elementEdgeEnd > scrollingEdgeEnd && elementSize < scrollingSize || elementEdgeStart < scrollingEdgeStart && elementSize > scrollingSize) return elementEdgeEnd - scrollingEdgeEnd + scrollingBorderEnd;
    return 0;
}
var $3f152b3d7b173718$export$2e2bcd8739ae039 = function(target, options) {
    var scrollMode = options.scrollMode, block = options.block, inline = options.inline, boundary = options.boundary, skipOverflowHiddenElements = options.skipOverflowHiddenElements;
    var checkBoundary = typeof boundary === 'function' ? boundary : function(node) {
        return node !== boundary;
    };
    if (!$3f152b3d7b173718$var$isElement(target)) throw new TypeError('Invalid target');
    var scrollingElement = document.scrollingElement || document.documentElement;
    var frames = [];
    var cursor = target;
    while($3f152b3d7b173718$var$isElement(cursor) && checkBoundary(cursor)){
        cursor = cursor.parentNode;
        if (cursor === scrollingElement) {
            frames.push(cursor);
            break;
        }
        if (cursor === document.body && $3f152b3d7b173718$var$isScrollable(cursor) && !$3f152b3d7b173718$var$isScrollable(document.documentElement)) continue;
        if ($3f152b3d7b173718$var$isScrollable(cursor, skipOverflowHiddenElements)) frames.push(cursor);
    }
    var viewportWidth = window.visualViewport ? visualViewport.width : innerWidth;
    var viewportHeight = window.visualViewport ? visualViewport.height : innerHeight;
    var viewportX = window.scrollX || pageXOffset;
    var viewportY = window.scrollY || pageYOffset;
    var _target$getBoundingCl = target.getBoundingClientRect(), targetHeight = _target$getBoundingCl.height, targetWidth = _target$getBoundingCl.width, targetTop = _target$getBoundingCl.top, targetRight = _target$getBoundingCl.right, targetBottom = _target$getBoundingCl.bottom, targetLeft = _target$getBoundingCl.left;
    var targetBlock = block === 'start' || block === 'nearest' ? targetTop : block === 'end' ? targetBottom : targetTop + targetHeight / 2;
    var targetInline = inline === 'center' ? targetLeft + targetWidth / 2 : inline === 'end' ? targetRight : targetLeft;
    var computations = [];
    for(var index = 0; index < frames.length; index++){
        var frame = frames[index];
        var _frame$getBoundingCli = frame.getBoundingClientRect(), height = _frame$getBoundingCli.height, width = _frame$getBoundingCli.width, top = _frame$getBoundingCli.top, right = _frame$getBoundingCli.right, bottom = _frame$getBoundingCli.bottom, left = _frame$getBoundingCli.left;
        if (scrollMode === 'if-needed' && targetTop >= 0 && targetLeft >= 0 && targetBottom <= viewportHeight && targetRight <= viewportWidth && targetTop >= top && targetBottom <= bottom && targetLeft >= left && targetRight <= right) return computations;
        var frameStyle = getComputedStyle(frame);
        var borderLeft = parseInt(frameStyle.borderLeftWidth, 10);
        var borderTop = parseInt(frameStyle.borderTopWidth, 10);
        var borderRight = parseInt(frameStyle.borderRightWidth, 10);
        var borderBottom = parseInt(frameStyle.borderBottomWidth, 10);
        var blockScroll = 0;
        var inlineScroll = 0;
        var scrollbarWidth = 'offsetWidth' in frame ? frame.offsetWidth - frame.clientWidth - borderLeft - borderRight : 0;
        var scrollbarHeight = 'offsetHeight' in frame ? frame.offsetHeight - frame.clientHeight - borderTop - borderBottom : 0;
        if (scrollingElement === frame) {
            if (block === 'start') blockScroll = targetBlock;
            else if (block === 'end') blockScroll = targetBlock - viewportHeight;
            else if (block === 'nearest') blockScroll = $3f152b3d7b173718$var$alignNearest(viewportY, viewportY + viewportHeight, viewportHeight, borderTop, borderBottom, viewportY + targetBlock, viewportY + targetBlock + targetHeight, targetHeight);
            else blockScroll = targetBlock - viewportHeight / 2;
            if (inline === 'start') inlineScroll = targetInline;
            else if (inline === 'center') inlineScroll = targetInline - viewportWidth / 2;
            else if (inline === 'end') inlineScroll = targetInline - viewportWidth;
            else inlineScroll = $3f152b3d7b173718$var$alignNearest(viewportX, viewportX + viewportWidth, viewportWidth, borderLeft, borderRight, viewportX + targetInline, viewportX + targetInline + targetWidth, targetWidth);
            blockScroll = Math.max(0, blockScroll + viewportY);
            inlineScroll = Math.max(0, inlineScroll + viewportX);
        } else {
            if (block === 'start') blockScroll = targetBlock - top - borderTop;
            else if (block === 'end') blockScroll = targetBlock - bottom + borderBottom + scrollbarHeight;
            else if (block === 'nearest') blockScroll = $3f152b3d7b173718$var$alignNearest(top, bottom, height, borderTop, borderBottom + scrollbarHeight, targetBlock, targetBlock + targetHeight, targetHeight);
            else blockScroll = targetBlock - (top + height / 2) + scrollbarHeight / 2;
            if (inline === 'start') inlineScroll = targetInline - left - borderLeft;
            else if (inline === 'center') inlineScroll = targetInline - (left + width / 2) + scrollbarWidth / 2;
            else if (inline === 'end') inlineScroll = targetInline - right + borderRight + scrollbarWidth;
            else inlineScroll = $3f152b3d7b173718$var$alignNearest(left, right, width, borderLeft, borderRight + scrollbarWidth, targetInline, targetInline + targetWidth, targetWidth);
            var scrollLeft = frame.scrollLeft, scrollTop = frame.scrollTop;
            blockScroll = Math.max(0, Math.min(scrollTop + blockScroll, frame.scrollHeight - height + scrollbarHeight));
            inlineScroll = Math.max(0, Math.min(scrollLeft + inlineScroll, frame.scrollWidth - width + scrollbarWidth));
            targetBlock += scrollTop - blockScroll;
            targetInline += scrollLeft - inlineScroll;
        }
        computations.push({
            el: frame,
            top: blockScroll,
            left: inlineScroll
        });
    }
    return computations;
};

});


parcelRegister("8r6xd", function(module, exports) {

$parcel$export(module.exports, "PendoChoreographerPlugin", () => $53b1d602a69e9a6f$export$3390a677f4025523);

var $TTRxY = parcelRequire("TTRxY");

var $4YUjU = parcelRequire("4YUjU");
class $53b1d602a69e9a6f$export$3390a677f4025523 extends (0, $4YUjU.ChoreographerPlugin) {
    constructor(envType, metaMetricsData = {}){
        super((0, $TTRxY.ProductIds).PENDO, envType, metaMetricsData), this.currentMessageId = '', this.getPendoConfig = (pendoConfig)=>{
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const pendoPlugin = this;
            return {
                ...pendoConfig,
                guides: {
                    ...pendoConfig.guides ?? {},
                    globalScripts: [
                        ...pendoConfig.guides?.globalScripts ?? [],
                        {
                            beforeMount (evnt) {
                                if (pendoPlugin.state.isDisabled) evnt.cancel = true;
                                else {
                                    pendoPlugin.currentMessageId = evnt.step.id;
                                    pendoPlugin.on(pendoPlugin.currentMessageId, {});
                                    pendoPlugin.startMessage(pendoPlugin.currentMessageId);
                                }
                            },
                            unmounted () {
                                pendoPlugin.stopMessage(pendoPlugin.currentMessageId);
                            }
                        }
                    ]
                }
            };
        };
    }
    isDisplayingMessage() {
        return Boolean(window.pendo?.getActiveGuide?.());
    }
}

});

parcelRegister("lD23V", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbeed703bb1aba42$export$2e2bcd8739ae039);
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $fbeed703bb1aba42$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return 'var(--c-, )';
}

});

parcelRegister("8Ec39", function(module, exports) {

$parcel$export(module.exports, "default", () => $114f26125c89a833$export$2e2bcd8739ae039);

var $ge1SS = parcelRequire("ge1SS");
var $114f26125c89a833$export$2e2bcd8739ae039 = (0, $ge1SS.default);

});
parcelRegister("ge1SS", function(module, exports) {

$parcel$export(module.exports, "default", () => $72b82d0e3dab161a$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $gg6CF = parcelRequire("gg6CF");

var $7Jxgt = parcelRequire("7Jxgt");

var $5gx4p = parcelRequire("5gx4p");

var $fe1wc = parcelRequire("fe1wc");

var $tcn7E = parcelRequire("tcn7E");

var $1tcYS = parcelRequire("1tcYS");

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");

var $9AgLs = parcelRequire("9AgLs");

var $kdJVm = parcelRequire("kdJVm");

var $aBI5P = parcelRequire("aBI5P");
let $72b82d0e3dab161a$var$tryCompleteHandle;

const $72b82d0e3dab161a$var$AsyncSegmentHighlight = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("dOOv1")).then((module)=>({
            default: module.SegmentHighlight
        })));
function $72b82d0e3dab161a$export$2e2bcd8739ae039({ name: segmentName, children: children, mode: mode = 'single' }) {
    const parentContext = (0, $5uXOq.useContext)((0, $1tcYS.default));
    const segmentIdMap = (0, $5uXOq.useMemo)(()=>{
        if (!parentContext?.segmentIdMap) return new Map();
        return parentContext.segmentIdMap;
    }, [
        parentContext
    ]);
    const segmentId = (0, $5uXOq.useMemo)(()=>{
        if (mode === 'single') return (0, $kdJVm.default)();
        if (segmentIdMap.has(segmentName)) return segmentIdMap.get(segmentName);
        const newSegmentId = (0, $kdJVm.default)();
        segmentIdMap.set(segmentName, newSegmentId);
        return newSegmentId;
    }, [
        mode,
        segmentName,
        segmentIdMap
    ]);
    const labelStack = (0, $5uXOq.useMemo)(()=>parentContext?.labelStack ? [
            ...parentContext.labelStack,
            {
                name: segmentName,
                segmentId: segmentId
            }
        ] : [
            {
                name: segmentName,
                segmentId: segmentId
            }
        ], [
        parentContext,
        segmentName,
        segmentId
    ]);
    const interactionId = (0, $5uXOq.useContext)((0, $1u4q7.default));
    const interactionContext = (0, $5uXOq.useMemo)(()=>{
        let lastCompleteEndTime = 0;
        function complete(endTime = performance.now()) {
            if (interactionId.current) {
                if (parentContext) parentContext.complete();
                else {
                    const capturedInteractionId = interactionId.current;
                    if (endTime > lastCompleteEndTime) lastCompleteEndTime = endTime;
                    if ($72b82d0e3dab161a$var$tryCompleteHandle) cancelAnimationFrame?.($72b82d0e3dab161a$var$tryCompleteHandle);
                    const onComplete = ()=>{
                        if (capturedInteractionId === interactionId.current) {
                            const isPageVisible = globalThis?.document?.visibilityState === 'visible';
                            const canDoRAF = typeof requestAnimationFrame !== 'undefined';
                            if (isPageVisible && canDoRAF) $72b82d0e3dab161a$var$tryCompleteHandle = requestAnimationFrame(()=>{
                                $72b82d0e3dab161a$var$tryCompleteHandle = requestAnimationFrame(()=>{
                                    if (capturedInteractionId === interactionId.current) (0, $bFU4G.tryComplete)(interactionId.current, lastCompleteEndTime);
                                });
                            });
                            else (0, $bFU4G.tryComplete)(interactionId.current, lastCompleteEndTime);
                        }
                    };
                    (0, $gg6CF.unstable_scheduleCallback)((0, $gg6CF.unstable_NormalPriority), onComplete);
                }
            }
        }
        function _internalHold(labelStack, name, experimental = false) {
            if (interactionId.current != null) {
                if (parentContext) return parentContext._internalHold(labelStack, name, experimental);
                else {
                    const capturedInteractionId = interactionId.current;
                    const disposeHold = (0, $bFU4G.addHold)(interactionId.current, labelStack, name, experimental);
                    return ()=>{
                        if (capturedInteractionId === interactionId.current) disposeHold();
                    };
                }
            }
        }
        function _internalHoldByID(labelStack, id, name, remove) {
            if (interactionId.current != null) {
                if (parentContext) {
                    parentContext._internalHoldByID(labelStack, name, id, remove);
                    return;
                }
                if (!remove) (0, $bFU4G.addHoldByID)(interactionId.current, labelStack, name, id);
                else (0, $bFU4G.removeHoldByID)(interactionId.current, id);
            }
        }
        if (parentContext) return {
            ...parentContext,
            labelStack: labelStack,
            complete: complete
        };
        return {
            labelStack: labelStack,
            segmentIdMap: segmentIdMap,
            hold (name = 'unknown') {
                return this._internalHold(this.labelStack, name);
            },
            holdExperimental (name = 'unknown') {
                return this._internalHold(this.labelStack, name, true);
            },
            addHoldByID (labelStack, id, name = 'unknown') {
                this._internalHoldByID(labelStack, id, name, false);
            },
            removeHoldByID (labelStack, id, name = 'unknown') {
                this._internalHoldByID(labelStack, id, name, true);
            },
            tracePress (name = 'unknown', timestamp) {
                if (interactionId.current != null) (0, $bFU4G.abortByNewInteraction)(interactionId.current, name);
                const rate = (0, $fe1wc.getInteractionRate)(name, 'press');
                if ((0, $5gx4p.default)(rate)) {
                    const startTimestamp = timestamp ?? performance.now();
                    const newId = (0, $7Jxgt.v4)();
                    interactionId.current = newId;
                    // covered experiences with tracing instrumentation:
                    // inline-result.global-issue.create-modal.submit
                    // inline-result.global-issue.create-modal-subsequent
                    (0, $tcn7E.setInteractionActiveTrace)(newId, 'press');
                    (0, $bFU4G.addNewInteraction)(newId, name, 'press', startTimestamp, rate, this.labelStack, (0, $9AgLs.default).current, (0, $tcn7E.getActiveTrace)());
                }
            },
            retainQuery (info) {
                if (interactionId.current != null) (0, $bFU4G.addRequestInfo)(interactionId.current, this.labelStack, info);
            },
            addPreload (moduleId, timestamp) {
                if (interactionId.current != null) (0, $bFU4G.addMark)(interactionId.current, 'bundle_preload', moduleId, this.labelStack, timestamp);
            },
            addLoad (identifier, start, end) {
                if (interactionId.current != null) {
                    const { labelStack: labelStack = [] } = this;
                    (0, $bFU4G.addSpan)(interactionId.current, 'bundle_load', identifier, labelStack, start, end);
                }
            },
            addMark (name, timestamp) {
                if (interactionId.current != null) {
                    const time = timestamp ?? performance.now();
                    (0, $bFU4G.addMark)(interactionId.current, 'custom', name, this.labelStack, time);
                }
            },
            addCustomData (customData) {
                if (interactionId.current != null) (0, $bFU4G.addCustomData)(interactionId.current, this.labelStack, customData);
            },
            addCustomTimings (customTimings) {
                if (interactionId.current != null) (0, $bFU4G.addCustomTiming)(interactionId.current, this.labelStack, customTimings);
            },
            addApdex (apdexInfo) {
                if (interactionId.current != null) {
                    const { key: key, stopTime: stopTime, startTime: startTime } = apdexInfo;
                    (0, $bFU4G.addApdex)(interactionId.current, {
                        key: key,
                        stopTime: stopTime,
                        startTime: startTime,
                        labelStack: this.labelStack
                    });
                }
            },
            onRender (phase, actualDuration, baseDuration, startTime, commitTime) {
                if (interactionId.current !== null) {
                    (0, $bFU4G.addProfilerTimings)(interactionId.current, this.labelStack, phase, actualDuration, baseDuration, startTime, commitTime);
                    (0, $aBI5P.default)(()=>{
                        const paintedTime = performance.now();
                        this.complete(paintedTime);
                    });
                }
            },
            _internalHold: _internalHold,
            _internalHoldByID: _internalHoldByID,
            complete: complete
        };
    }, [
        parentContext,
        labelStack,
        segmentIdMap,
        interactionId
    ]);
    const hasMounted = (0, $5uXOq.useRef)(false);
    const onRender = (0, $5uXOq.useCallback)((_id, phase, actualDuration, baseDuration, startTime, commitTime)=>{
        // Manually keep track of mount-phase, and ensure that every segment is always mounted at least once
        if ((0, $fe1wc.getConfig)()?.manuallyTrackReactProfilerMounts && !hasMounted.current) {
            interactionContext.onRender('mount', actualDuration, baseDuration, startTime, commitTime);
            hasMounted.current = true;
        } else interactionContext.onRender(phase, actualDuration, baseDuration, startTime, commitTime);
    }, [
        interactionContext
    ]);
    (0, $5uXOq.useEffect)(()=>{
        (0, $bFU4G.addSegment)(labelStack);
        return ()=>{
            (0, $bFU4G.removeSegment)(labelStack);
        };
    }, [
        interactionId,
        parentContext,
        interactionContext,
        labelStack
    ]);
    const reactProfilerId = (0, $5uXOq.useMemo)(()=>labelStack.map((l)=>l.name).join('/'), [
        labelStack
    ]);
    const enableSegmentHighlighting = (0, $fe1wc.getConfig)()?.enableSegmentHighlighting;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1tcYS.default).Provider, {
        value: interactionContext,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Profiler), {
            id: reactProfilerId,
            onRender: onRender,
            children: [
                children,
                enableSegmentHighlighting && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                    fallback: null,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)($72b82d0e3dab161a$var$AsyncSegmentHighlight, {
                        segmentName: segmentName
                    })
                })
            ]
        })
    });
}

});
parcelRegister("kdJVm", function(module, exports) {

$parcel$export(module.exports, "default", () => $20e4b4beffd8665a$export$2e2bcd8739ae039);
function $20e4b4beffd8665a$var$generateId(length = 7) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for(let i = 0; i < length; i++)result += characters.charAt(Math.floor(Math.random() * characters.length));
    return result;
}
var $20e4b4beffd8665a$export$2e2bcd8739ae039 = $20e4b4beffd8665a$var$generateId;

});

parcelRegister("aBI5P", function(module, exports) {

$parcel$export(module.exports, "default", () => $e966289ce908b8f9$export$2e2bcd8739ae039);
function $e966289ce908b8f9$var$scheduleOnPaint(callback) {
    if (globalThis.document?.visibilityState !== 'visible') {
        // last resort fallback
        setTimeout(callback, 100);
        return;
    }
    // Check if the Scheduler API is available
    if (typeof window.scheduler !== 'undefined' && typeof window.scheduler.postTask === 'function') // Use scheduler.postTask if available
    // https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API
    // Make sure we are scheduling this task before the browser paint the next frame
    requestAnimationFrame(()=>{
        window.scheduler.postTask(callback, {
            priority: 'user-visible'
        });
    });
    else if (typeof requestAnimationFrame !== 'undefined') // Fallback to using double requestAnimationFrame
    requestAnimationFrame(()=>{
        requestAnimationFrame(()=>{
            callback();
        });
    });
}
var $e966289ce908b8f9$export$2e2bcd8739ae039 = $e966289ce908b8f9$var$scheduleOnPaint;

});

parcelRegister("dOOv1", function(module, exports) {

let $a0f71df7efd623f2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a0f71df7efd623f2$var$load("6533T").then(()=>parcelRequire('2AmUl'));

});
parcelRegister("28QjX", function(module, exports) {
"use strict";


let $18f4e9fbd43d4c3b$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve(id), maxShards));
    };
module.exports = $18f4e9fbd43d4c3b$var$load;

});
parcelRegister("kPuw4", function(module, exports) {

$parcel$export(module.exports, "shardUrl", () => $f2a03df3e93d4e79$export$2bf9932c19d6a5d2, (v) => $f2a03df3e93d4e79$export$2bf9932c19d6a5d2 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $f2a03df3e93d4e79$export$2bf9932c19d6a5d2;
var $f2a03df3e93d4e79$export$1d37a31d51d1e3ed;
var $f2a03df3e93d4e79$export$b4cd98d62f81485f;
var $f2a03df3e93d4e79$export$108ff8fc702e621f;
var $f2a03df3e93d4e79$export$f6f4188f9108e61;
"use strict";
let $f2a03df3e93d4e79$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 *
 * @param {string} pathname
 * @returns {string}
 */ function $f2a03df3e93d4e79$var$getFilenameFromUrlPath(pathname) {
    let lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 *
 * @param {string} str
 * @param {number} maxShards
 * @returns {number}
 */ function $f2a03df3e93d4e79$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    let totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        let n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
let $f2a03df3e93d4e79$var$trailingShardRegex = /-\d+$/;
/**
 * @param {string} subdomain
 */ function $f2a03df3e93d4e79$var$removeTrailingShard(subdomain) {
    if (!$f2a03df3e93d4e79$var$trailingShardRegex.test(subdomain)) return subdomain;
    let shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 *
 * @param {string} domain
 * @param {number} shard
 */ function $f2a03df3e93d4e79$var$applyShardToDomain(domain, shard) {
    let i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    let shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$f2a03df3e93d4e79$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    let firstSubdomain = $f2a03df3e93d4e79$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $f2a03df3e93d4e79$var$shardUrlUnchecked(url, maxShards) {
    let parsedUrl = new URL(url);
    let fileName = $f2a03df3e93d4e79$var$getFilenameFromUrlPath(parsedUrl.pathname);
    let shardNumber = $f2a03df3e93d4e79$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $f2a03df3e93d4e79$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $f2a03df3e93d4e79$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$f2a03df3e93d4e79$var$globalKeyName]) return url;
    return $f2a03df3e93d4e79$var$shardUrlUnchecked(url, maxShards);
}
$f2a03df3e93d4e79$export$2bf9932c19d6a5d2 = $f2a03df3e93d4e79$var$shardUrl;
$f2a03df3e93d4e79$export$1d37a31d51d1e3ed = $f2a03df3e93d4e79$var$shardUrlUnchecked;
$f2a03df3e93d4e79$export$b4cd98d62f81485f = $f2a03df3e93d4e79$var$getDomainShardIndex;
$f2a03df3e93d4e79$export$108ff8fc702e621f = $f2a03df3e93d4e79$var$applyShardToDomain;
$f2a03df3e93d4e79$export$f6f4188f9108e61 = $f2a03df3e93d4e79$var$globalKeyName;

});

parcelRegister("dy9lH", function(module, exports) {

$parcel$export(module.exports, "register", () => $9dd5b3e06d7b5702$export$6503ec6e8aabbaf, (v) => $9dd5b3e06d7b5702$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $9dd5b3e06d7b5702$export$f7ad0328861e2f03, (v) => $9dd5b3e06d7b5702$export$f7ad0328861e2f03 = v);
var $9dd5b3e06d7b5702$export$6503ec6e8aabbaf;
var $9dd5b3e06d7b5702$export$f7ad0328861e2f03;
"use strict";
var $9dd5b3e06d7b5702$var$mapping = new Map();
function $9dd5b3e06d7b5702$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$9dd5b3e06d7b5702$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $9dd5b3e06d7b5702$var$resolve(id) {
    var resolved = $9dd5b3e06d7b5702$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$9dd5b3e06d7b5702$export$6503ec6e8aabbaf = $9dd5b3e06d7b5702$var$register;
$9dd5b3e06d7b5702$export$f7ad0328861e2f03 = $9dd5b3e06d7b5702$var$resolve;

});





parcelRegister("basmW", function(module, exports) {

var $2cFTm = parcelRequire("2cFTm");
/**
 * Creates a function that returns the result of invoking the given functions
 * with the `this` binding of the created function, where each successive
 * invocation is supplied the return value of the previous.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Util
 * @param {...(Function|Function[])} [funcs] The functions to invoke.
 * @returns {Function} Returns the new composite function.
 * @see _.flowRight
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var addSquare = _.flow([_.add, square]);
 * addSquare(1, 2);
 * // => 9
 */ var $8216a25e54656007$var$flow = $2cFTm();
module.exports = $8216a25e54656007$var$flow;

});
parcelRegister("2cFTm", function(module, exports) {

var $1WNhJ = parcelRequire("1WNhJ");

var $9SRAA = parcelRequire("9SRAA");

var $dzqxs = parcelRequire("dzqxs");

var $dJhFY = parcelRequire("dJhFY");

var $8LQ84 = parcelRequire("8LQ84");

var $2dCKt = parcelRequire("2dCKt");
/** Error message constants. */ var $19ad329dbed10597$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used to compose bitmasks for function metadata. */ var $19ad329dbed10597$var$WRAP_CURRY_FLAG = 8, $19ad329dbed10597$var$WRAP_PARTIAL_FLAG = 32, $19ad329dbed10597$var$WRAP_ARY_FLAG = 128, $19ad329dbed10597$var$WRAP_REARG_FLAG = 256;
/**
 * Creates a `_.flow` or `_.flowRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new flow function.
 */ function $19ad329dbed10597$var$createFlow(fromRight) {
    return $9SRAA(function(funcs) {
        var length = funcs.length, index = length, prereq = $1WNhJ.prototype.thru;
        if (fromRight) funcs.reverse();
        while(index--){
            var func = funcs[index];
            if (typeof func != 'function') throw new TypeError($19ad329dbed10597$var$FUNC_ERROR_TEXT);
            if (prereq && !wrapper && $dJhFY(func) == 'wrapper') var wrapper = new $1WNhJ([], true);
        }
        index = wrapper ? index : length;
        while(++index < length){
            func = funcs[index];
            var funcName = $dJhFY(func), data = funcName == 'wrapper' ? $dzqxs(func) : undefined;
            if (data && $2dCKt(data[0]) && data[1] == ($19ad329dbed10597$var$WRAP_ARY_FLAG | $19ad329dbed10597$var$WRAP_CURRY_FLAG | $19ad329dbed10597$var$WRAP_PARTIAL_FLAG | $19ad329dbed10597$var$WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[$dJhFY(data[0])].apply(wrapper, data[3]);
            else wrapper = func.length == 1 && $2dCKt(func) ? wrapper[funcName]() : wrapper.thru(func);
        }
        return function() {
            var args = arguments, value = args[0];
            if (wrapper && args.length == 1 && $8LQ84(value)) return wrapper.plant(value).value();
            var index = 0, result = length ? funcs[index].apply(this, args) : value;
            while(++index < length)result = funcs[index].call(this, result);
            return result;
        };
    });
}
module.exports = $19ad329dbed10597$var$createFlow;

});
parcelRegister("1WNhJ", function(module, exports) {

var $ady43 = parcelRequire("ady43");

var $dtL2K = parcelRequire("dtL2K");
/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */ function $16b170343299e90c$var$LodashWrapper(value, chainAll) {
    this.__wrapped__ = value;
    this.__actions__ = [];
    this.__chain__ = !!chainAll;
    this.__index__ = 0;
    this.__values__ = undefined;
}
$16b170343299e90c$var$LodashWrapper.prototype = $ady43($dtL2K.prototype);
$16b170343299e90c$var$LodashWrapper.prototype.constructor = $16b170343299e90c$var$LodashWrapper;
module.exports = $16b170343299e90c$var$LodashWrapper;

});
parcelRegister("dtL2K", function(module, exports) {
/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */ function $9d02799e26f2befc$var$baseLodash() {
// No operation performed.
}
module.exports = $9d02799e26f2befc$var$baseLodash;

});


parcelRegister("dzqxs", function(module, exports) {

var $hQCy5 = parcelRequire("hQCy5");

var $8Rkzz = parcelRequire("8Rkzz");
/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */ var $9e13214619654b13$var$getData = !$hQCy5 ? $8Rkzz : function(func) {
    return $hQCy5.get(func);
};
module.exports = $9e13214619654b13$var$getData;

});
parcelRegister("hQCy5", function(module, exports) {

var $kUWNo = parcelRequire("kUWNo");
/** Used to store function metadata. */ var $cfe531f816dee27d$var$metaMap = $kUWNo && new $kUWNo;
module.exports = $cfe531f816dee27d$var$metaMap;

});


parcelRegister("dJhFY", function(module, exports) {

var $b34cU = parcelRequire("b34cU");
/** Used for built-in method references. */ var $9fed306476bd143b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $9fed306476bd143b$var$hasOwnProperty = $9fed306476bd143b$var$objectProto.hasOwnProperty;
/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */ function $9fed306476bd143b$var$getFuncName(func) {
    var result = func.name + '', array = $b34cU[result], length = $9fed306476bd143b$var$hasOwnProperty.call($b34cU, result) ? array.length : 0;
    while(length--){
        var data = array[length], otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) return data.name;
    }
    return result;
}
module.exports = $9fed306476bd143b$var$getFuncName;

});
parcelRegister("b34cU", function(module, exports) {
/** Used to lookup unminified function names. */ var $80b33cfa5c78e39a$var$realNames = {};
module.exports = $80b33cfa5c78e39a$var$realNames;

});


parcelRegister("2dCKt", function(module, exports) {

var $gXHdK = parcelRequire("gXHdK");

var $dzqxs = parcelRequire("dzqxs");

var $dJhFY = parcelRequire("dJhFY");

var $h4Vl3 = parcelRequire("h4Vl3");
/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */ function $19dada4f3cc4c77d$var$isLaziable(func) {
    var funcName = $dJhFY(func), other = $h4Vl3[funcName];
    if (typeof other != 'function' || !(funcName in $gXHdK.prototype)) return false;
    if (func === other) return true;
    var data = $dzqxs(other);
    return !!data && func === data[0];
}
module.exports = $19dada4f3cc4c77d$var$isLaziable;

});
parcelRegister("gXHdK", function(module, exports) {

var $ady43 = parcelRequire("ady43");

var $dtL2K = parcelRequire("dtL2K");
/** Used as references for the maximum length and index of an array. */ var $c593aec8028eae80$var$MAX_ARRAY_LENGTH = 4294967295;
/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */ function $c593aec8028eae80$var$LazyWrapper(value) {
    this.__wrapped__ = value;
    this.__actions__ = [];
    this.__dir__ = 1;
    this.__filtered__ = false;
    this.__iteratees__ = [];
    this.__takeCount__ = $c593aec8028eae80$var$MAX_ARRAY_LENGTH;
    this.__views__ = [];
}
// Ensure `LazyWrapper` is an instance of `baseLodash`.
$c593aec8028eae80$var$LazyWrapper.prototype = $ady43($dtL2K.prototype);
$c593aec8028eae80$var$LazyWrapper.prototype.constructor = $c593aec8028eae80$var$LazyWrapper;
module.exports = $c593aec8028eae80$var$LazyWrapper;

});

parcelRegister("h4Vl3", function(module, exports) {

var $gXHdK = parcelRequire("gXHdK");

var $1WNhJ = parcelRequire("1WNhJ");

var $dtL2K = parcelRequire("dtL2K");

var $8LQ84 = parcelRequire("8LQ84");

var $fC1Kz = parcelRequire("fC1Kz");

var $6e2jm = parcelRequire("6e2jm");
/** Used for built-in method references. */ var $c6ef49a1bd112766$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c6ef49a1bd112766$var$hasOwnProperty = $c6ef49a1bd112766$var$objectProto.hasOwnProperty;
/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */ function $c6ef49a1bd112766$var$lodash(value) {
    if ($fC1Kz(value) && !$8LQ84(value) && !(value instanceof $gXHdK)) {
        if (value instanceof $1WNhJ) return value;
        if ($c6ef49a1bd112766$var$hasOwnProperty.call(value, '__wrapped__')) return $6e2jm(value);
    }
    return new $1WNhJ(value);
}
// Ensure wrappers are instances of `baseLodash`.
$c6ef49a1bd112766$var$lodash.prototype = $dtL2K.prototype;
$c6ef49a1bd112766$var$lodash.prototype.constructor = $c6ef49a1bd112766$var$lodash;
module.exports = $c6ef49a1bd112766$var$lodash;

});
parcelRegister("6e2jm", function(module, exports) {

var $gXHdK = parcelRequire("gXHdK");

var $1WNhJ = parcelRequire("1WNhJ");

var $jHlUS = parcelRequire("jHlUS");
/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */ function $4885d7df48eb0605$var$wrapperClone(wrapper) {
    if (wrapper instanceof $gXHdK) return wrapper.clone();
    var result = new $1WNhJ(wrapper.__wrapped__, wrapper.__chain__);
    result.__actions__ = $jHlUS(wrapper.__actions__);
    result.__index__ = wrapper.__index__;
    result.__values__ = wrapper.__values__;
    return result;
}
module.exports = $4885d7df48eb0605$var$wrapperClone;

});





parcelRegister("bPTaj", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5939bd216791b87$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cb25w = parcelRequire("cb25w");
var $c5939bd216791b87$export$2e2bcd8739ae039 = (InnerComponent)=>{
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class EngagementEventsWrapper extends (0, $5uXOq.Component) {
        UNSAFE_componentWillMount() {
            this.fireEvent('shown');
        }
        componentWillUnmount() {
            this.fireEvent('hidden');
        }
        fireEvent(action, properties = {}) {
            const { createAnalyticsEvent: createAnalyticsEvent, messageId: messageId, variationId: variationId, componentId: componentId, componentType: componentType, isLast: isLast } = this.props;
            const analyticsEvent = createAnalyticsEvent({
                action: action,
                ...properties
            });
            analyticsEvent.update({
                ekMessageId: messageId,
                ekVariationId: variationId,
                ekComponentId: componentId,
                ekComponentType: componentType,
                ekIsLast: isLast
            });
            analyticsEvent.fire('engagement');
        }
        render() {
            return /*#__PURE__*/ (0, $2OMIu.jsx)(InnerComponent, {
                ...this.props,
                fireClickEvent: this.fireClickEvent
            });
        }
        constructor(...args){
            super(...args), this.fireClickEvent = (clickType)=>{
                this.fireEvent('click', {
                    clickType: clickType
                });
            };
        }
    }
    return (0, $cb25w.default)()(EngagementEventsWrapper);
};

});

parcelRegister("f9Hff", function(module, exports) {

$parcel$export(module.exports, "default", () => $c73ca19cb8d0c3f2$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8rCP3 = parcelRequire("8rCP3");
var $c73ca19cb8d0c3f2$export$2e2bcd8739ae039 = (InnerComponent, componentType)=>{
    function isTargetComponent(message) {
        return message.componentType === componentType;
    }
    function computeNewState(state) {
        const current = state.current;
        if (current && isTargetComponent(current)) {
            let message;
            switch(current.componentType){
                case 'contextualSurvey':
                    message = {
                        ...current,
                        aaid: state.config.aaid,
                        cloudId: state.config.cloudId,
                        stargateUrl: state.config.stargateUrl,
                        product: state.config.product,
                        orgId: state.config.orgId,
                        workspaceId: state.config.workspaceId
                    };
                    break;
                default:
                    message = current;
            }
            return {
                message: message
            };
        }
        return {
            message: null
        };
    }
    function getComponentType() {
        return componentType;
    }
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class StoreWrapper extends (0, $5uXOq.Component) {
        static{
            this.contextTypes = {
                subscribeEngagementState: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).func,
                setComponentConfig: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).func
            };
        }
        UNSAFE_componentWillMount() {
            if (this.canSubscribe()) this.unsubscribe = this.subscribeToStore();
            if (this.canSetConfig()) this.removeConfig = this.setChoreographerConfig();
        }
        UNSAFE_componentWillReceiveProps(nextProps) {
            if (this.props?.engagementId !== nextProps?.engagementId && this.removeConfig && this.canSetConfig()) {
                this.removeConfig();
                this.removeConfig = this.setChoreographerConfig(nextProps);
            } else if ((this.props?.messageType !== nextProps?.messageType || this.props?.onMessageDisposition !== nextProps?.onMessageDisposition) && this.canSetConfig()) this.setChoreographerConfig(nextProps);
        }
        componentWillUnmount() {
            if (this.unsubscribe) this.unsubscribe();
            if (this.removeConfig) this.removeConfig();
        }
        canSetConfig() {
            return this.context && this.context.setComponentConfig;
        }
        setChoreographerConfig(props = this.props) {
            return this.context.setComponentConfig(getComponentType(), {
                messageType: props.messageType,
                onMessageDisposition: props.onMessageDisposition
            }, props.engagementId);
        }
        canSubscribe() {
            return this.context && this.context.subscribeEngagementState;
        }
        subscribeToStore() {
            return this.context.subscribeEngagementState(this.onStoreChange);
        }
        render() {
            const { children: children, engagementId: engagementId } = this.props;
            const { message: message } = this.state;
            if (!message) {
                if (componentType === 'inlineDialog') return children || null;
                return null;
            }
            if (engagementId && message !== null && message.target && engagementId !== message.target) return null;
            const messageKey = `${message.messageId}.${message.variationId}.${message.componentId}`;
            // Key is useful here to make sure that when the currently active
            // messages changes, the old component is unmounted (therefore
            // firing an analytic event for hiding the component) and mounting
            // a new component for the new message (firing a shown event for
            // the new message). Not using key would allow React to apply an
            // optimization that would reuse the current component for a new
            // message which would not call the normal mount and unmount
            // lifecycle methods.
            return /*#__PURE__*/ (0, $2OMIu.jsx)(InnerComponent, {
                ...this.props,
                ...message
            }, messageKey);
        }
        constructor(...args){
            super(...args), this.state = {
                message: null
            }, this.onStoreChange = (state)=>{
                this.setState(computeNewState(state));
            };
        }
    }
    return StoreWrapper;
};

});

parcelRegister("02CEF", function(module, exports) {

$parcel$export(module.exports, "buttonActionTypes", () => $88face119c13f52b$export$e7d79186651244da);
const $88face119c13f52b$export$e7d79186651244da = {
    LINK: 'link',
    DISMISS: 'dismiss'
};

});

parcelRegister("9pLR7", function(module, exports) {

$parcel$export(module.exports, "default", () => $8be30f37f56f96d5$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
class $8be30f37f56f96d5$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    render() {
        const { html: html } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            dangerouslySetInnerHTML: {
                __html: html
            }
        });
    }
}

});

parcelRegister("1c8Um", function(module, exports) {

$parcel$export(module.exports, "print", () => $0dedd2672864572f$export$c2d084dc44961371);

var $12QNw = parcelRequire("12QNw");

var $541Mz = parcelRequire("541Mz");
function $0dedd2672864572f$export$c2d084dc44961371(ast) {
    return (0, $12QNw.visit)(ast, {
        leave: $0dedd2672864572f$var$printDocASTReducer
    });
}
var $0dedd2672864572f$var$MAX_LINE_LENGTH = 80; // TODO: provide better type coverage in future
var $0dedd2672864572f$var$printDocASTReducer = {
    Name: function Name(node) {
        return node.value;
    },
    Variable: function Variable(node) {
        return '$' + node.name;
    },
    // Document
    Document: function Document(node) {
        return $0dedd2672864572f$var$join(node.definitions, '\n\n') + '\n';
    },
    OperationDefinition: function OperationDefinition(node) {
        var op = node.operation;
        var name = node.name;
        var varDefs = $0dedd2672864572f$var$wrap('(', $0dedd2672864572f$var$join(node.variableDefinitions, ', '), ')');
        var directives = $0dedd2672864572f$var$join(node.directives, ' ');
        var selectionSet = node.selectionSet; // Anonymous queries with no directives or variable definitions can use
        // the query short form.
        return !name && !directives && !varDefs && op === 'query' ? selectionSet : $0dedd2672864572f$var$join([
            op,
            $0dedd2672864572f$var$join([
                name,
                varDefs
            ]),
            directives,
            selectionSet
        ], ' ');
    },
    VariableDefinition: function VariableDefinition(_ref) {
        var variable = _ref.variable, type = _ref.type, defaultValue = _ref.defaultValue, directives = _ref.directives;
        return variable + ': ' + type + $0dedd2672864572f$var$wrap(' = ', defaultValue) + $0dedd2672864572f$var$wrap(' ', $0dedd2672864572f$var$join(directives, ' '));
    },
    SelectionSet: function SelectionSet(_ref2) {
        var selections = _ref2.selections;
        return $0dedd2672864572f$var$block(selections);
    },
    Field: function Field(_ref3) {
        var alias = _ref3.alias, name = _ref3.name, args = _ref3.arguments, directives = _ref3.directives, selectionSet = _ref3.selectionSet;
        var prefix = $0dedd2672864572f$var$wrap('', alias, ': ') + name;
        var argsLine = prefix + $0dedd2672864572f$var$wrap('(', $0dedd2672864572f$var$join(args, ', '), ')');
        if (argsLine.length > $0dedd2672864572f$var$MAX_LINE_LENGTH) argsLine = prefix + $0dedd2672864572f$var$wrap('(\n', $0dedd2672864572f$var$indent($0dedd2672864572f$var$join(args, '\n')), '\n)');
        return $0dedd2672864572f$var$join([
            argsLine,
            $0dedd2672864572f$var$join(directives, ' '),
            selectionSet
        ], ' ');
    },
    Argument: function Argument(_ref4) {
        var name = _ref4.name, value = _ref4.value;
        return name + ': ' + value;
    },
    // Fragments
    FragmentSpread: function FragmentSpread(_ref5) {
        var name = _ref5.name, directives = _ref5.directives;
        return '...' + name + $0dedd2672864572f$var$wrap(' ', $0dedd2672864572f$var$join(directives, ' '));
    },
    InlineFragment: function InlineFragment(_ref6) {
        var typeCondition = _ref6.typeCondition, directives = _ref6.directives, selectionSet = _ref6.selectionSet;
        return $0dedd2672864572f$var$join([
            '...',
            $0dedd2672864572f$var$wrap('on ', typeCondition),
            $0dedd2672864572f$var$join(directives, ' '),
            selectionSet
        ], ' ');
    },
    FragmentDefinition: function FragmentDefinition(_ref7) {
        var name = _ref7.name, typeCondition = _ref7.typeCondition, variableDefinitions = _ref7.variableDefinitions, directives = _ref7.directives, selectionSet = _ref7.selectionSet;
        return(// or removed in the future.
        "fragment ".concat(name).concat($0dedd2672864572f$var$wrap('(', $0dedd2672864572f$var$join(variableDefinitions, ', '), ')'), " ") + "on ".concat(typeCondition, " ").concat($0dedd2672864572f$var$wrap('', $0dedd2672864572f$var$join(directives, ' '), ' ')) + selectionSet);
    },
    // Value
    IntValue: function IntValue(_ref8) {
        var value = _ref8.value;
        return value;
    },
    FloatValue: function FloatValue(_ref9) {
        var value = _ref9.value;
        return value;
    },
    StringValue: function StringValue(_ref10, key) {
        var value = _ref10.value, isBlockString = _ref10.block;
        return isBlockString ? (0, $541Mz.printBlockString)(value, key === 'description' ? '' : '  ') : JSON.stringify(value);
    },
    BooleanValue: function BooleanValue(_ref11) {
        var value = _ref11.value;
        return value ? 'true' : 'false';
    },
    NullValue: function NullValue() {
        return 'null';
    },
    EnumValue: function EnumValue(_ref12) {
        var value = _ref12.value;
        return value;
    },
    ListValue: function ListValue(_ref13) {
        var values = _ref13.values;
        return '[' + $0dedd2672864572f$var$join(values, ', ') + ']';
    },
    ObjectValue: function ObjectValue(_ref14) {
        var fields = _ref14.fields;
        return '{' + $0dedd2672864572f$var$join(fields, ', ') + '}';
    },
    ObjectField: function ObjectField(_ref15) {
        var name = _ref15.name, value = _ref15.value;
        return name + ': ' + value;
    },
    // Directive
    Directive: function Directive(_ref16) {
        var name = _ref16.name, args = _ref16.arguments;
        return '@' + name + $0dedd2672864572f$var$wrap('(', $0dedd2672864572f$var$join(args, ', '), ')');
    },
    // Type
    NamedType: function NamedType(_ref17) {
        var name = _ref17.name;
        return name;
    },
    ListType: function ListType(_ref18) {
        var type = _ref18.type;
        return '[' + type + ']';
    },
    NonNullType: function NonNullType(_ref19) {
        var type = _ref19.type;
        return type + '!';
    },
    // Type System Definitions
    SchemaDefinition: $0dedd2672864572f$var$addDescription(function(_ref20) {
        var directives = _ref20.directives, operationTypes = _ref20.operationTypes;
        return $0dedd2672864572f$var$join([
            'schema',
            $0dedd2672864572f$var$join(directives, ' '),
            $0dedd2672864572f$var$block(operationTypes)
        ], ' ');
    }),
    OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
        var operation = _ref21.operation, type = _ref21.type;
        return operation + ': ' + type;
    },
    ScalarTypeDefinition: $0dedd2672864572f$var$addDescription(function(_ref22) {
        var name = _ref22.name, directives = _ref22.directives;
        return $0dedd2672864572f$var$join([
            'scalar',
            name,
            $0dedd2672864572f$var$join(directives, ' ')
        ], ' ');
    }),
    ObjectTypeDefinition: $0dedd2672864572f$var$addDescription(function(_ref23) {
        var name = _ref23.name, interfaces = _ref23.interfaces, directives = _ref23.directives, fields = _ref23.fields;
        return $0dedd2672864572f$var$join([
            'type',
            name,
            $0dedd2672864572f$var$wrap('implements ', $0dedd2672864572f$var$join(interfaces, ' & ')),
            $0dedd2672864572f$var$join(directives, ' '),
            $0dedd2672864572f$var$block(fields)
        ], ' ');
    }),
    FieldDefinition: $0dedd2672864572f$var$addDescription(function(_ref24) {
        var name = _ref24.name, args = _ref24.arguments, type = _ref24.type, directives = _ref24.directives;
        return name + ($0dedd2672864572f$var$hasMultilineItems(args) ? $0dedd2672864572f$var$wrap('(\n', $0dedd2672864572f$var$indent($0dedd2672864572f$var$join(args, '\n')), '\n)') : $0dedd2672864572f$var$wrap('(', $0dedd2672864572f$var$join(args, ', '), ')')) + ': ' + type + $0dedd2672864572f$var$wrap(' ', $0dedd2672864572f$var$join(directives, ' '));
    }),
    InputValueDefinition: $0dedd2672864572f$var$addDescription(function(_ref25) {
        var name = _ref25.name, type = _ref25.type, defaultValue = _ref25.defaultValue, directives = _ref25.directives;
        return $0dedd2672864572f$var$join([
            name + ': ' + type,
            $0dedd2672864572f$var$wrap('= ', defaultValue),
            $0dedd2672864572f$var$join(directives, ' ')
        ], ' ');
    }),
    InterfaceTypeDefinition: $0dedd2672864572f$var$addDescription(function(_ref26) {
        var name = _ref26.name, interfaces = _ref26.interfaces, directives = _ref26.directives, fields = _ref26.fields;
        return $0dedd2672864572f$var$join([
            'interface',
            name,
            $0dedd2672864572f$var$wrap('implements ', $0dedd2672864572f$var$join(interfaces, ' & ')),
            $0dedd2672864572f$var$join(directives, ' '),
            $0dedd2672864572f$var$block(fields)
        ], ' ');
    }),
    UnionTypeDefinition: $0dedd2672864572f$var$addDescription(function(_ref27) {
        var name = _ref27.name, directives = _ref27.directives, types = _ref27.types;
        return $0dedd2672864572f$var$join([
            'union',
            name,
            $0dedd2672864572f$var$join(directives, ' '),
            types && types.length !== 0 ? '= ' + $0dedd2672864572f$var$join(types, ' | ') : ''
        ], ' ');
    }),
    EnumTypeDefinition: $0dedd2672864572f$var$addDescription(function(_ref28) {
        var name = _ref28.name, directives = _ref28.directives, values = _ref28.values;
        return $0dedd2672864572f$var$join([
            'enum',
            name,
            $0dedd2672864572f$var$join(directives, ' '),
            $0dedd2672864572f$var$block(values)
        ], ' ');
    }),
    EnumValueDefinition: $0dedd2672864572f$var$addDescription(function(_ref29) {
        var name = _ref29.name, directives = _ref29.directives;
        return $0dedd2672864572f$var$join([
            name,
            $0dedd2672864572f$var$join(directives, ' ')
        ], ' ');
    }),
    InputObjectTypeDefinition: $0dedd2672864572f$var$addDescription(function(_ref30) {
        var name = _ref30.name, directives = _ref30.directives, fields = _ref30.fields;
        return $0dedd2672864572f$var$join([
            'input',
            name,
            $0dedd2672864572f$var$join(directives, ' '),
            $0dedd2672864572f$var$block(fields)
        ], ' ');
    }),
    DirectiveDefinition: $0dedd2672864572f$var$addDescription(function(_ref31) {
        var name = _ref31.name, args = _ref31.arguments, repeatable = _ref31.repeatable, locations = _ref31.locations;
        return 'directive @' + name + ($0dedd2672864572f$var$hasMultilineItems(args) ? $0dedd2672864572f$var$wrap('(\n', $0dedd2672864572f$var$indent($0dedd2672864572f$var$join(args, '\n')), '\n)') : $0dedd2672864572f$var$wrap('(', $0dedd2672864572f$var$join(args, ', '), ')')) + (repeatable ? ' repeatable' : '') + ' on ' + $0dedd2672864572f$var$join(locations, ' | ');
    }),
    SchemaExtension: function SchemaExtension(_ref32) {
        var directives = _ref32.directives, operationTypes = _ref32.operationTypes;
        return $0dedd2672864572f$var$join([
            'extend schema',
            $0dedd2672864572f$var$join(directives, ' '),
            $0dedd2672864572f$var$block(operationTypes)
        ], ' ');
    },
    ScalarTypeExtension: function ScalarTypeExtension(_ref33) {
        var name = _ref33.name, directives = _ref33.directives;
        return $0dedd2672864572f$var$join([
            'extend scalar',
            name,
            $0dedd2672864572f$var$join(directives, ' ')
        ], ' ');
    },
    ObjectTypeExtension: function ObjectTypeExtension(_ref34) {
        var name = _ref34.name, interfaces = _ref34.interfaces, directives = _ref34.directives, fields = _ref34.fields;
        return $0dedd2672864572f$var$join([
            'extend type',
            name,
            $0dedd2672864572f$var$wrap('implements ', $0dedd2672864572f$var$join(interfaces, ' & ')),
            $0dedd2672864572f$var$join(directives, ' '),
            $0dedd2672864572f$var$block(fields)
        ], ' ');
    },
    InterfaceTypeExtension: function InterfaceTypeExtension(_ref35) {
        var name = _ref35.name, interfaces = _ref35.interfaces, directives = _ref35.directives, fields = _ref35.fields;
        return $0dedd2672864572f$var$join([
            'extend interface',
            name,
            $0dedd2672864572f$var$wrap('implements ', $0dedd2672864572f$var$join(interfaces, ' & ')),
            $0dedd2672864572f$var$join(directives, ' '),
            $0dedd2672864572f$var$block(fields)
        ], ' ');
    },
    UnionTypeExtension: function UnionTypeExtension(_ref36) {
        var name = _ref36.name, directives = _ref36.directives, types = _ref36.types;
        return $0dedd2672864572f$var$join([
            'extend union',
            name,
            $0dedd2672864572f$var$join(directives, ' '),
            types && types.length !== 0 ? '= ' + $0dedd2672864572f$var$join(types, ' | ') : ''
        ], ' ');
    },
    EnumTypeExtension: function EnumTypeExtension(_ref37) {
        var name = _ref37.name, directives = _ref37.directives, values = _ref37.values;
        return $0dedd2672864572f$var$join([
            'extend enum',
            name,
            $0dedd2672864572f$var$join(directives, ' '),
            $0dedd2672864572f$var$block(values)
        ], ' ');
    },
    InputObjectTypeExtension: function InputObjectTypeExtension(_ref38) {
        var name = _ref38.name, directives = _ref38.directives, fields = _ref38.fields;
        return $0dedd2672864572f$var$join([
            'extend input',
            name,
            $0dedd2672864572f$var$join(directives, ' '),
            $0dedd2672864572f$var$block(fields)
        ], ' ');
    }
};
function $0dedd2672864572f$var$addDescription(cb) {
    return function(node) {
        return $0dedd2672864572f$var$join([
            node.description,
            cb(node)
        ], '\n');
    };
}
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $0dedd2672864572f$var$join(maybeArray) {
    var _maybeArray$filter$jo;
    var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter(function(x) {
        return x;
    }).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : '';
}
/**
 * Given array, print each item on its own line, wrapped in an
 * indented "{ }" block.
 */ function $0dedd2672864572f$var$block(array) {
    return $0dedd2672864572f$var$wrap('{\n', $0dedd2672864572f$var$indent($0dedd2672864572f$var$join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function $0dedd2672864572f$var$wrap(start, maybeString) {
    var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    return maybeString != null && maybeString !== '' ? start + maybeString + end : '';
}
function $0dedd2672864572f$var$indent(str) {
    return $0dedd2672864572f$var$wrap('  ', str.replace(/\n/g, '\n  '));
}
function $0dedd2672864572f$var$isMultiline(str) {
    return str.indexOf('\n') !== -1;
}
function $0dedd2672864572f$var$hasMultilineItems(maybeArray) {
    return maybeArray != null && maybeArray.some($0dedd2672864572f$var$isMultiline);
}

});
parcelRegister("12QNw", function(module, exports) {

$parcel$export(module.exports, "BREAK", () => $0c2eeee3dc68c900$export$a89c95c098ac2a58);
$parcel$export(module.exports, "visit", () => $0c2eeee3dc68c900$export$bf638b60ea8b89b7);

var $yEDl8 = parcelRequire("yEDl8");

var $98oUl = parcelRequire("98oUl");
var $0c2eeee3dc68c900$export$4fcd777a40ccf407 = {
    Name: [],
    Document: [
        'definitions'
    ],
    OperationDefinition: [
        'name',
        'variableDefinitions',
        'directives',
        'selectionSet'
    ],
    VariableDefinition: [
        'variable',
        'type',
        'defaultValue',
        'directives'
    ],
    Variable: [
        'name'
    ],
    SelectionSet: [
        'selections'
    ],
    Field: [
        'alias',
        'name',
        'arguments',
        'directives',
        'selectionSet'
    ],
    Argument: [
        'name',
        'value'
    ],
    FragmentSpread: [
        'name',
        'directives'
    ],
    InlineFragment: [
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    FragmentDefinition: [
        'name',
        // or removed in the future.
        'variableDefinitions',
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        'values'
    ],
    ObjectValue: [
        'fields'
    ],
    ObjectField: [
        'name',
        'value'
    ],
    Directive: [
        'name',
        'arguments'
    ],
    NamedType: [
        'name'
    ],
    ListType: [
        'type'
    ],
    NonNullType: [
        'type'
    ],
    SchemaDefinition: [
        'description',
        'directives',
        'operationTypes'
    ],
    OperationTypeDefinition: [
        'type'
    ],
    ScalarTypeDefinition: [
        'description',
        'name',
        'directives'
    ],
    ObjectTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    FieldDefinition: [
        'description',
        'name',
        'arguments',
        'type',
        'directives'
    ],
    InputValueDefinition: [
        'description',
        'name',
        'type',
        'defaultValue',
        'directives'
    ],
    InterfaceTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeDefinition: [
        'description',
        'name',
        'directives',
        'types'
    ],
    EnumTypeDefinition: [
        'description',
        'name',
        'directives',
        'values'
    ],
    EnumValueDefinition: [
        'description',
        'name',
        'directives'
    ],
    InputObjectTypeDefinition: [
        'description',
        'name',
        'directives',
        'fields'
    ],
    DirectiveDefinition: [
        'description',
        'name',
        'arguments',
        'locations'
    ],
    SchemaExtension: [
        'directives',
        'operationTypes'
    ],
    ScalarTypeExtension: [
        'name',
        'directives'
    ],
    ObjectTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    InterfaceTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeExtension: [
        'name',
        'directives',
        'types'
    ],
    EnumTypeExtension: [
        'name',
        'directives',
        'values'
    ],
    InputObjectTypeExtension: [
        'name',
        'directives',
        'fields'
    ]
};
var $0c2eeee3dc68c900$export$a89c95c098ac2a58 = Object.freeze({});
function $0c2eeee3dc68c900$export$bf638b60ea8b89b7(root, visitor) {
    var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $0c2eeee3dc68c900$export$4fcd777a40ccf407;
    /* eslint-disable no-undef-init */ var stack = undefined;
    var inArray = Array.isArray(root);
    var keys = [
        root
    ];
    var index = -1;
    var edits = [];
    var node = undefined;
    var key = undefined;
    var parent = undefined;
    var path = [];
    var ancestors = [];
    var newRoot = root;
    /* eslint-enable no-undef-init */ do {
        index++;
        var isLeaving = index === keys.length;
        var isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) node = node.slice();
                else {
                    var clone = {};
                    for(var _i2 = 0, _Object$keys2 = Object.keys(node); _i2 < _Object$keys2.length; _i2++){
                        var k = _Object$keys2[_i2];
                        clone[k] = node[k];
                    }
                    node = clone;
                }
                var editOffset = 0;
                for(var ii = 0; ii < edits.length; ii++){
                    var editKey = edits[ii][0];
                    var editValue = edits[ii][1];
                    if (inArray) editKey -= editOffset;
                    if (inArray && editValue === null) {
                        node.splice(editKey, 1);
                        editOffset++;
                    } else node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else {
            key = parent ? inArray ? index : keys[index] : undefined;
            node = parent ? parent[key] : newRoot;
            if (node === null || node === undefined) continue;
            if (parent) path.push(key);
        }
        var result = void 0;
        if (!Array.isArray(node)) {
            if (!(0, $98oUl.isNode)(node)) throw new Error("Invalid AST Node: ".concat((0, $yEDl8.default)(node), "."));
            var visitFn = $0c2eeee3dc68c900$export$c9c25cca74db6e70(visitor, node.kind, isLeaving);
            if (visitFn) {
                result = visitFn.call(visitor, node, key, parent, path, ancestors);
                if (result === $0c2eeee3dc68c900$export$a89c95c098ac2a58) break;
                if (result === false) {
                    if (!isLeaving) {
                        path.pop();
                        continue;
                    }
                } else if (result !== undefined) {
                    edits.push([
                        key,
                        result
                    ]);
                    if (!isLeaving) {
                        if ((0, $98oUl.isNode)(result)) node = result;
                        else {
                            path.pop();
                            continue;
                        }
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _visitorKeys$node$kin;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_visitorKeys$node$kin = visitorKeys[node.kind]) !== null && _visitorKeys$node$kin !== void 0 ? _visitorKeys$node$kin : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) newRoot = edits[edits.length - 1][1];
    return newRoot;
}
function $0c2eeee3dc68c900$export$728beebeea393478(visitors) {
    var skipping = new Array(visitors.length);
    return {
        enter: function enter(node) {
            for(var i = 0; i < visitors.length; i++)if (skipping[i] == null) {
                var fn = $0c2eeee3dc68c900$export$c9c25cca74db6e70(visitors[i], node.kind, /* isLeaving */ false);
                if (fn) {
                    var result = fn.apply(visitors[i], arguments);
                    if (result === false) skipping[i] = node;
                    else if (result === $0c2eeee3dc68c900$export$a89c95c098ac2a58) skipping[i] = $0c2eeee3dc68c900$export$a89c95c098ac2a58;
                    else if (result !== undefined) return result;
                }
            }
        },
        leave: function leave(node) {
            for(var i = 0; i < visitors.length; i++){
                if (skipping[i] == null) {
                    var fn = $0c2eeee3dc68c900$export$c9c25cca74db6e70(visitors[i], node.kind, /* isLeaving */ true);
                    if (fn) {
                        var result = fn.apply(visitors[i], arguments);
                        if (result === $0c2eeee3dc68c900$export$a89c95c098ac2a58) skipping[i] = $0c2eeee3dc68c900$export$a89c95c098ac2a58;
                        else if (result !== undefined && result !== false) return result;
                    }
                } else if (skipping[i] === node) skipping[i] = null;
            }
        }
    };
}
function $0c2eeee3dc68c900$export$c9c25cca74db6e70(visitor, kind, isLeaving) {
    var kindVisitor = visitor[kind];
    if (kindVisitor) {
        if (!isLeaving && typeof kindVisitor === 'function') // { Kind() {} }
        return kindVisitor;
        var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;
        if (typeof kindSpecificVisitor === 'function') // { Kind: { enter() {}, leave() {} } }
        return kindSpecificVisitor;
    } else {
        var specificVisitor = isLeaving ? visitor.leave : visitor.enter;
        if (specificVisitor) {
            if (typeof specificVisitor === 'function') // { enter() {}, leave() {} }
            return specificVisitor;
            var specificKindVisitor = specificVisitor[kind];
            if (typeof specificKindVisitor === 'function') // { enter: { Kind() {} }, leave: { Kind() {} } }
            return specificKindVisitor;
        }
    }
}

});
parcelRegister("yEDl8", function(module, exports) {

$parcel$export(module.exports, "default", () => $0682b20f61c706c4$export$2e2bcd8739ae039);

var $7NbHY = parcelRequire("7NbHY");
function $0682b20f61c706c4$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $0682b20f61c706c4$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $0682b20f61c706c4$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $0682b20f61c706c4$var$_typeof(obj);
}
var $0682b20f61c706c4$var$MAX_ARRAY_LENGTH = 10;
var $0682b20f61c706c4$var$MAX_RECURSIVE_DEPTH = 2;
function $0682b20f61c706c4$export$2e2bcd8739ae039(value) {
    return $0682b20f61c706c4$var$formatValue(value, []);
}
function $0682b20f61c706c4$var$formatValue(value, seenValues) {
    switch($0682b20f61c706c4$var$_typeof(value)){
        case 'string':
            return JSON.stringify(value);
        case 'function':
            return value.name ? "[function ".concat(value.name, "]") : '[function]';
        case 'object':
            if (value === null) return 'null';
            return $0682b20f61c706c4$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $0682b20f61c706c4$var$formatObjectValue(value, previouslySeenValues) {
    if (previouslySeenValues.indexOf(value) !== -1) return '[Circular]';
    var seenValues = [].concat(previouslySeenValues, [
        value
    ]);
    var customInspectFn = $0682b20f61c706c4$var$getCustomFn(value);
    if (customInspectFn !== undefined) {
        var customValue = customInspectFn.call(value); // check for infinite recursion
        if (customValue !== value) return typeof customValue === 'string' ? customValue : $0682b20f61c706c4$var$formatValue(customValue, seenValues);
    } else if (Array.isArray(value)) return $0682b20f61c706c4$var$formatArray(value, seenValues);
    return $0682b20f61c706c4$var$formatObject(value, seenValues);
}
function $0682b20f61c706c4$var$formatObject(object, seenValues) {
    var keys = Object.keys(object);
    if (keys.length === 0) return '{}';
    if (seenValues.length > $0682b20f61c706c4$var$MAX_RECURSIVE_DEPTH) return '[' + $0682b20f61c706c4$var$getObjectTag(object) + ']';
    var properties = keys.map(function(key) {
        var value = $0682b20f61c706c4$var$formatValue(object[key], seenValues);
        return key + ': ' + value;
    });
    return '{ ' + properties.join(', ') + ' }';
}
function $0682b20f61c706c4$var$formatArray(array, seenValues) {
    if (array.length === 0) return '[]';
    if (seenValues.length > $0682b20f61c706c4$var$MAX_RECURSIVE_DEPTH) return '[Array]';
    var len = Math.min($0682b20f61c706c4$var$MAX_ARRAY_LENGTH, array.length);
    var remaining = array.length - len;
    var items = [];
    for(var i = 0; i < len; ++i)items.push($0682b20f61c706c4$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push('... 1 more item');
    else if (remaining > 1) items.push("... ".concat(remaining, " more items"));
    return '[' + items.join(', ') + ']';
}
function $0682b20f61c706c4$var$getCustomFn(object) {
    var customInspectFn = object[String((0, $7NbHY.default))];
    if (typeof customInspectFn === 'function') return customInspectFn;
    if (typeof object.inspect === 'function') return object.inspect;
}
function $0682b20f61c706c4$var$getObjectTag(object) {
    var tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');
    if (tag === 'Object' && typeof object.constructor === 'function') {
        var name = object.constructor.name;
        if (typeof name === 'string' && name !== '') return name;
    }
    return tag;
}

});
parcelRegister("7NbHY", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ac63109fd04dae2$export$2e2bcd8739ae039);
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $5ac63109fd04dae2$var$nodejsCustomInspectSymbol = typeof Symbol === 'function' && typeof Symbol.for === 'function' ? Symbol.for('nodejs.util.inspect.custom') : undefined;
var $5ac63109fd04dae2$export$2e2bcd8739ae039 = $5ac63109fd04dae2$var$nodejsCustomInspectSymbol;

});


parcelRegister("98oUl", function(module, exports) {

$parcel$export(module.exports, "Location", () => $6a682e985d2af3c5$export$18a2be9195644f38);
$parcel$export(module.exports, "Token", () => $6a682e985d2af3c5$export$50792b0e93539fde);
$parcel$export(module.exports, "isNode", () => $6a682e985d2af3c5$export$8ee0fc9ee280b4ee);

var $520Pd = parcelRequire("520Pd");
var $6a682e985d2af3c5$export$18a2be9195644f38 = /*#__PURE__*/ function() {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ function Location(startToken, endToken, source) {
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    var _proto = Location.prototype;
    _proto.toJSON = function toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    };
    return Location;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $520Pd.default)($6a682e985d2af3c5$export$18a2be9195644f38);
var $6a682e985d2af3c5$export$50792b0e93539fde = /*#__PURE__*/ function() {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ function Token(kind, start, end, line, column, prev, value) {
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column;
        this.value = value;
        this.prev = prev;
        this.next = null;
    }
    var _proto2 = Token.prototype;
    _proto2.toJSON = function toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    };
    return Token;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $520Pd.default)($6a682e985d2af3c5$export$50792b0e93539fde);
function $6a682e985d2af3c5$export$8ee0fc9ee280b4ee(maybeNode) {
    return maybeNode != null && typeof maybeNode.kind === 'string';
} /**
 * The list of all possible AST node types.
 */ 

});
parcelRegister("520Pd", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a9dc77a0e8a6949$export$2e2bcd8739ae039);

var $fM9AB = parcelRequire("fM9AB");

var $7NbHY = parcelRequire("7NbHY");
function $3a9dc77a0e8a6949$export$2e2bcd8739ae039(classObject) {
    var fn = classObject.prototype.toJSON;
    typeof fn === 'function' || (0, $fM9AB.default)(0);
    classObject.prototype.inspect = fn; // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2317')
    if (0, $7NbHY.default) classObject.prototype[0, $7NbHY.default] = fn;
}

});
parcelRegister("fM9AB", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7c2c6f03066157d$export$2e2bcd8739ae039);
function $b7c2c6f03066157d$export$2e2bcd8739ae039(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message != null ? message : 'Unexpected invariant triggered.');
}

});




parcelRegister("541Mz", function(module, exports) {

$parcel$export(module.exports, "dedentBlockStringValue", () => $3afeb56b3b6851c5$export$fd88c0b652c46ccc);
$parcel$export(module.exports, "printBlockString", () => $3afeb56b3b6851c5$export$adb6ca997eeb1f45);
/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */ function $3afeb56b3b6851c5$export$fd88c0b652c46ccc(rawString) {
    // Expand a block string's raw value into independent lines.
    var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.
    var commonIndent = $3afeb56b3b6851c5$export$3c95bfdc680af0c(rawString);
    if (commonIndent !== 0) for(var i = 1; i < lines.length; i++)lines[i] = lines[i].slice(commonIndent);
     // Remove leading and trailing blank lines.
    var startLine = 0;
    while(startLine < lines.length && $3afeb56b3b6851c5$var$isBlank(lines[startLine]))++startLine;
    var endLine = lines.length;
    while(endLine > startLine && $3afeb56b3b6851c5$var$isBlank(lines[endLine - 1]))--endLine;
     // Return a string of the lines joined with U+000A.
    return lines.slice(startLine, endLine).join('\n');
}
function $3afeb56b3b6851c5$var$isBlank(str) {
    for(var i = 0; i < str.length; ++i){
        if (str[i] !== ' ' && str[i] !== '\t') return false;
    }
    return true;
}
function $3afeb56b3b6851c5$export$3c95bfdc680af0c(value) {
    var _commonIndent;
    var isFirstLine = true;
    var isEmptyLine = true;
    var indent = 0;
    var commonIndent = null;
    for(var i = 0; i < value.length; ++i)switch(value.charCodeAt(i)){
        case 13:
            //  \r
            if (value.charCodeAt(i + 1) === 10) ++i; // skip \r\n as one symbol
        // falls through
        case 10:
            //  \n
            isFirstLine = false;
            isEmptyLine = true;
            indent = 0;
            break;
        case 9:
        case 32:
            //  <space>
            ++indent;
            break;
        default:
            if (isEmptyLine && !isFirstLine && (commonIndent === null || indent < commonIndent)) commonIndent = indent;
            isEmptyLine = false;
    }
    return (_commonIndent = commonIndent) !== null && _commonIndent !== void 0 ? _commonIndent : 0;
}
function $3afeb56b3b6851c5$export$adb6ca997eeb1f45(value) {
    var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var preferMultipleLines = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isSingleLine = value.indexOf('\n') === -1;
    var hasLeadingSpace = value[0] === ' ' || value[0] === '\t';
    var hasTrailingQuote = value[value.length - 1] === '"';
    var hasTrailingSlash = value[value.length - 1] === '\\';
    var printAsMultipleLines = !isSingleLine || hasTrailingQuote || hasTrailingSlash || preferMultipleLines;
    var result = ''; // Format a multi-line block quote to account for leading space.
    if (printAsMultipleLines && !(isSingleLine && hasLeadingSpace)) result += '\n' + indentation;
    result += indentation ? value.replace(/\n/g, '\n' + indentation) : value;
    if (printAsMultipleLines) result += '\n';
    return '"""' + result.replace(/"""/g, '\\"""') + '"""';
}

});


parcelRegister("5cllN", function(module, exports) {

$parcel$export(module.exports, "gql", () => $3c8ea2810a9abcde$export$72e4926bf8358653);
$parcel$export(module.exports, "default", () => $3c8ea2810a9abcde$export$2e2bcd8739ae039);

var $3VFsf = parcelRequire("3VFsf");

var $8uUC9 = parcelRequire("8uUC9");
var $3c8ea2810a9abcde$var$docCache = new Map();
var $3c8ea2810a9abcde$var$fragmentSourceMap = new Map();
var $3c8ea2810a9abcde$var$printFragmentWarnings = true;
var $3c8ea2810a9abcde$var$experimentalFragmentVariables = false;
function $3c8ea2810a9abcde$var$normalize(string) {
    return string.replace(/[\s,]+/g, ' ').trim();
}
function $3c8ea2810a9abcde$var$cacheKeyFromLoc(loc) {
    return $3c8ea2810a9abcde$var$normalize(loc.source.body.substring(loc.start, loc.end));
}
function $3c8ea2810a9abcde$var$processFragments(ast) {
    var seenKeys = new Set();
    var definitions = [];
    ast.definitions.forEach(function(fragmentDefinition) {
        if (fragmentDefinition.kind === 'FragmentDefinition') {
            var fragmentName = fragmentDefinition.name.value;
            var sourceKey = $3c8ea2810a9abcde$var$cacheKeyFromLoc(fragmentDefinition.loc);
            var sourceKeySet = $3c8ea2810a9abcde$var$fragmentSourceMap.get(fragmentName);
            if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
                if ($3c8ea2810a9abcde$var$printFragmentWarnings) console.warn("Warning: fragment with name " + fragmentName + " already exists.\n" + "graphql-tag enforces all fragment names across your application to be unique; read more about\n" + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
            } else if (!sourceKeySet) $3c8ea2810a9abcde$var$fragmentSourceMap.set(fragmentName, sourceKeySet = new Set);
            sourceKeySet.add(sourceKey);
            if (!seenKeys.has(sourceKey)) {
                seenKeys.add(sourceKey);
                definitions.push(fragmentDefinition);
            }
        } else definitions.push(fragmentDefinition);
    });
    return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, ast), {
        definitions: definitions
    });
}
function $3c8ea2810a9abcde$var$stripLoc(doc) {
    var workSet = new Set(doc.definitions);
    workSet.forEach(function(node) {
        if (node.loc) delete node.loc;
        Object.keys(node).forEach(function(key) {
            var value = node[key];
            if (value && typeof value === 'object') workSet.add(value);
        });
    });
    var loc = doc.loc;
    if (loc) {
        delete loc.startToken;
        delete loc.endToken;
    }
    return doc;
}
function $3c8ea2810a9abcde$var$parseDocument(source) {
    var cacheKey = $3c8ea2810a9abcde$var$normalize(source);
    if (!$3c8ea2810a9abcde$var$docCache.has(cacheKey)) {
        var parsed = (0, $8uUC9.parse)(source, {
            experimentalFragmentVariables: $3c8ea2810a9abcde$var$experimentalFragmentVariables,
            allowLegacyFragmentVariables: $3c8ea2810a9abcde$var$experimentalFragmentVariables
        });
        if (!parsed || parsed.kind !== 'Document') throw new Error('Not a valid GraphQL document.');
        $3c8ea2810a9abcde$var$docCache.set(cacheKey, $3c8ea2810a9abcde$var$stripLoc($3c8ea2810a9abcde$var$processFragments(parsed)));
    }
    return $3c8ea2810a9abcde$var$docCache.get(cacheKey);
}
function $3c8ea2810a9abcde$export$72e4926bf8358653(literals) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (typeof literals === 'string') literals = [
        literals
    ];
    var result = literals[0];
    args.forEach(function(arg, i) {
        if (arg && arg.kind === 'Document') result += arg.loc.source.body;
        else result += arg;
        result += literals[i + 1];
    });
    return $3c8ea2810a9abcde$var$parseDocument(result);
}
function $3c8ea2810a9abcde$export$657554ef4dc7ac2d() {
    $3c8ea2810a9abcde$var$docCache.clear();
    $3c8ea2810a9abcde$var$fragmentSourceMap.clear();
}
function $3c8ea2810a9abcde$export$e4294e638636c6ab() {
    $3c8ea2810a9abcde$var$printFragmentWarnings = false;
}
function $3c8ea2810a9abcde$export$78cf889af350c840() {
    $3c8ea2810a9abcde$var$experimentalFragmentVariables = true;
}
function $3c8ea2810a9abcde$export$5290df9bbbd3cfa() {
    $3c8ea2810a9abcde$var$experimentalFragmentVariables = false;
}
var $3c8ea2810a9abcde$var$extras = {
    gql: $3c8ea2810a9abcde$export$72e4926bf8358653,
    resetCaches: $3c8ea2810a9abcde$export$657554ef4dc7ac2d,
    disableFragmentWarnings: $3c8ea2810a9abcde$export$e4294e638636c6ab,
    enableExperimentalFragmentVariables: $3c8ea2810a9abcde$export$78cf889af350c840,
    disableExperimentalFragmentVariables: $3c8ea2810a9abcde$export$5290df9bbbd3cfa
};
(function(gql_1) {
    gql_1.gql = $3c8ea2810a9abcde$var$extras.gql, gql_1.resetCaches = $3c8ea2810a9abcde$var$extras.resetCaches, gql_1.disableFragmentWarnings = $3c8ea2810a9abcde$var$extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = $3c8ea2810a9abcde$var$extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = $3c8ea2810a9abcde$var$extras.disableExperimentalFragmentVariables;
})($3c8ea2810a9abcde$export$72e4926bf8358653 || ($3c8ea2810a9abcde$export$72e4926bf8358653 = {}));
$3c8ea2810a9abcde$export$72e4926bf8358653["default"] = $3c8ea2810a9abcde$export$72e4926bf8358653;
var $3c8ea2810a9abcde$export$2e2bcd8739ae039 = $3c8ea2810a9abcde$export$72e4926bf8358653;

});
parcelRegister("8uUC9", function(module, exports) {

$parcel$export(module.exports, "parse", () => $62fd0a8327627af8$export$98e6a39c04603d36);

var $7ZXKi = parcelRequire("7ZXKi");

var $bzIlO = parcelRequire("bzIlO");

var $98oUl = parcelRequire("98oUl");

var $2z7TS = parcelRequire("2z7TS");

var $6vk4Q = parcelRequire("6vk4Q");

var $jADQJ = parcelRequire("jADQJ");

var $jkcJk = parcelRequire("jkcJk");
function $62fd0a8327627af8$export$98e6a39c04603d36(source, options) {
    var parser = new $62fd0a8327627af8$export$7acfa6ed01010e37(source, options);
    return parser.parseDocument();
}
function $62fd0a8327627af8$export$5303528d1070ff6f(source, options) {
    var parser = new $62fd0a8327627af8$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $2z7TS.TokenKind).SOF);
    var value = parser.parseValueLiteral(false);
    parser.expectToken((0, $2z7TS.TokenKind).EOF);
    return value;
}
function $62fd0a8327627af8$export$28b8f402ccc88182(source, options) {
    var parser = new $62fd0a8327627af8$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $2z7TS.TokenKind).SOF);
    var type = parser.parseTypeReference();
    parser.expectToken((0, $2z7TS.TokenKind).EOF);
    return type;
}
var $62fd0a8327627af8$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser(source, options) {
        var sourceObj = (0, $6vk4Q.isSource)(source) ? source : new (0, $6vk4Q.Source)(source);
        this._lexer = new (0, $jkcJk.Lexer)(sourceObj);
        this._options = options;
    }
    /**
   * Converts a name lex token into a name parse node.
   */ var _proto = Parser.prototype;
    _proto.parseName = function parseName() {
        var token = this.expectToken((0, $2z7TS.TokenKind).NAME);
        return {
            kind: (0, $bzIlO.Kind).NAME,
            value: token.value,
            loc: this.loc(token)
        };
    } // Implements the parsing rules in the Document section.
     /**
   * Document : Definition+
   */ ;
    _proto.parseDocument = function parseDocument() {
        var start = this._lexer.token;
        return {
            kind: (0, $bzIlO.Kind).DOCUMENT,
            definitions: this.many((0, $2z7TS.TokenKind).SOF, this.parseDefinition, (0, $2z7TS.TokenKind).EOF),
            loc: this.loc(start)
        };
    } /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   */ ;
    _proto.parseDefinition = function parseDefinition() {
        if (this.peek((0, $2z7TS.TokenKind).NAME)) switch(this._lexer.token.value){
            case 'query':
            case 'mutation':
            case 'subscription':
                return this.parseOperationDefinition();
            case 'fragment':
                return this.parseFragmentDefinition();
            case 'schema':
            case 'scalar':
            case 'type':
            case 'interface':
            case 'union':
            case 'enum':
            case 'input':
            case 'directive':
                return this.parseTypeSystemDefinition();
            case 'extend':
                return this.parseTypeSystemExtension();
        }
        else if (this.peek((0, $2z7TS.TokenKind).BRACE_L)) return this.parseOperationDefinition();
        else if (this.peekDescription()) return this.parseTypeSystemDefinition();
        throw this.unexpected();
    } // Implements the parsing rules in the Operations section.
     /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */ ;
    _proto.parseOperationDefinition = function parseOperationDefinition() {
        var start = this._lexer.token;
        if (this.peek((0, $2z7TS.TokenKind).BRACE_L)) return {
            kind: (0, $bzIlO.Kind).OPERATION_DEFINITION,
            operation: 'query',
            name: undefined,
            variableDefinitions: [],
            directives: [],
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        var operation = this.parseOperationType();
        var name;
        if (this.peek((0, $2z7TS.TokenKind).NAME)) name = this.parseName();
        return {
            kind: (0, $bzIlO.Kind).OPERATION_DEFINITION,
            operation: operation,
            name: name,
            variableDefinitions: this.parseVariableDefinitions(),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * OperationType : one of query mutation subscription
   */ ;
    _proto.parseOperationType = function parseOperationType() {
        var operationToken = this.expectToken((0, $2z7TS.TokenKind).NAME);
        switch(operationToken.value){
            case 'query':
                return 'query';
            case 'mutation':
                return 'mutation';
            case 'subscription':
                return 'subscription';
        }
        throw this.unexpected(operationToken);
    } /**
   * VariableDefinitions : ( VariableDefinition+ )
   */ ;
    _proto.parseVariableDefinitions = function parseVariableDefinitions() {
        return this.optionalMany((0, $2z7TS.TokenKind).PAREN_L, this.parseVariableDefinition, (0, $2z7TS.TokenKind).PAREN_R);
    } /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */ ;
    _proto.parseVariableDefinition = function parseVariableDefinition() {
        var start = this._lexer.token;
        return {
            kind: (0, $bzIlO.Kind).VARIABLE_DEFINITION,
            variable: this.parseVariable(),
            type: (this.expectToken((0, $2z7TS.TokenKind).COLON), this.parseTypeReference()),
            defaultValue: this.expectOptionalToken((0, $2z7TS.TokenKind).EQUALS) ? this.parseValueLiteral(true) : undefined,
            directives: this.parseDirectives(true),
            loc: this.loc(start)
        };
    } /**
   * Variable : $ Name
   */ ;
    _proto.parseVariable = function parseVariable() {
        var start = this._lexer.token;
        this.expectToken((0, $2z7TS.TokenKind).DOLLAR);
        return {
            kind: (0, $bzIlO.Kind).VARIABLE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } /**
   * SelectionSet : { Selection+ }
   */ ;
    _proto.parseSelectionSet = function parseSelectionSet() {
        var start = this._lexer.token;
        return {
            kind: (0, $bzIlO.Kind).SELECTION_SET,
            selections: this.many((0, $2z7TS.TokenKind).BRACE_L, this.parseSelection, (0, $2z7TS.TokenKind).BRACE_R),
            loc: this.loc(start)
        };
    } /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */ ;
    _proto.parseSelection = function parseSelection() {
        return this.peek((0, $2z7TS.TokenKind).SPREAD) ? this.parseFragment() : this.parseField();
    } /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */ ;
    _proto.parseField = function parseField() {
        var start = this._lexer.token;
        var nameOrAlias = this.parseName();
        var alias;
        var name;
        if (this.expectOptionalToken((0, $2z7TS.TokenKind).COLON)) {
            alias = nameOrAlias;
            name = this.parseName();
        } else name = nameOrAlias;
        return {
            kind: (0, $bzIlO.Kind).FIELD,
            alias: alias,
            name: name,
            arguments: this.parseArguments(false),
            directives: this.parseDirectives(false),
            selectionSet: this.peek((0, $2z7TS.TokenKind).BRACE_L) ? this.parseSelectionSet() : undefined,
            loc: this.loc(start)
        };
    } /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */ ;
    _proto.parseArguments = function parseArguments(isConst) {
        var item = isConst ? this.parseConstArgument : this.parseArgument;
        return this.optionalMany((0, $2z7TS.TokenKind).PAREN_L, item, (0, $2z7TS.TokenKind).PAREN_R);
    } /**
   * Argument[Const] : Name : Value[?Const]
   */ ;
    _proto.parseArgument = function parseArgument() {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $2z7TS.TokenKind).COLON);
        return {
            kind: (0, $bzIlO.Kind).ARGUMENT,
            name: name,
            value: this.parseValueLiteral(false),
            loc: this.loc(start)
        };
    };
    _proto.parseConstArgument = function parseConstArgument() {
        var start = this._lexer.token;
        return {
            kind: (0, $bzIlO.Kind).ARGUMENT,
            name: this.parseName(),
            value: (this.expectToken((0, $2z7TS.TokenKind).COLON), this.parseValueLiteral(true)),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Fragments section.
     /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */ ;
    _proto.parseFragment = function parseFragment() {
        var start = this._lexer.token;
        this.expectToken((0, $2z7TS.TokenKind).SPREAD);
        var hasTypeCondition = this.expectOptionalKeyword('on');
        if (!hasTypeCondition && this.peek((0, $2z7TS.TokenKind).NAME)) return {
            kind: (0, $bzIlO.Kind).FRAGMENT_SPREAD,
            name: this.parseFragmentName(),
            directives: this.parseDirectives(false),
            loc: this.loc(start)
        };
        return {
            kind: (0, $bzIlO.Kind).INLINE_FRAGMENT,
            typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */ ;
    _proto.parseFragmentDefinition = function parseFragmentDefinition() {
        var _this$_options;
        var start = this._lexer.token;
        this.expectKeyword('fragment'); // Experimental support for defining variables within fragments changes
        // the grammar of FragmentDefinition:
        //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
        if (((_this$_options = this._options) === null || _this$_options === void 0 ? void 0 : _this$_options.experimentalFragmentVariables) === true) return {
            kind: (0, $bzIlO.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            variableDefinitions: this.parseVariableDefinitions(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        return {
            kind: (0, $bzIlO.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * FragmentName : Name but not `on`
   */ ;
    _proto.parseFragmentName = function parseFragmentName() {
        if (this._lexer.token.value === 'on') throw this.unexpected();
        return this.parseName();
    } // Implements the parsing rules in the Values section.
     /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */ ;
    _proto.parseValueLiteral = function parseValueLiteral(isConst) {
        var token = this._lexer.token;
        switch(token.kind){
            case (0, $2z7TS.TokenKind).BRACKET_L:
                return this.parseList(isConst);
            case (0, $2z7TS.TokenKind).BRACE_L:
                return this.parseObject(isConst);
            case (0, $2z7TS.TokenKind).INT:
                this._lexer.advance();
                return {
                    kind: (0, $bzIlO.Kind).INT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $2z7TS.TokenKind).FLOAT:
                this._lexer.advance();
                return {
                    kind: (0, $bzIlO.Kind).FLOAT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $2z7TS.TokenKind).STRING:
            case (0, $2z7TS.TokenKind).BLOCK_STRING:
                return this.parseStringLiteral();
            case (0, $2z7TS.TokenKind).NAME:
                this._lexer.advance();
                switch(token.value){
                    case 'true':
                        return {
                            kind: (0, $bzIlO.Kind).BOOLEAN,
                            value: true,
                            loc: this.loc(token)
                        };
                    case 'false':
                        return {
                            kind: (0, $bzIlO.Kind).BOOLEAN,
                            value: false,
                            loc: this.loc(token)
                        };
                    case 'null':
                        return {
                            kind: (0, $bzIlO.Kind).NULL,
                            loc: this.loc(token)
                        };
                    default:
                        return {
                            kind: (0, $bzIlO.Kind).ENUM,
                            value: token.value,
                            loc: this.loc(token)
                        };
                }
            case (0, $2z7TS.TokenKind).DOLLAR:
                if (!isConst) return this.parseVariable();
                break;
        }
        throw this.unexpected();
    };
    _proto.parseStringLiteral = function parseStringLiteral() {
        var token = this._lexer.token;
        this._lexer.advance();
        return {
            kind: (0, $bzIlO.Kind).STRING,
            value: token.value,
            block: token.kind === (0, $2z7TS.TokenKind).BLOCK_STRING,
            loc: this.loc(token)
        };
    } /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */ ;
    _proto.parseList = function parseList(isConst) {
        var _this = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this.parseValueLiteral(isConst);
        };
        return {
            kind: (0, $bzIlO.Kind).LIST,
            values: this.any((0, $2z7TS.TokenKind).BRACKET_L, item, (0, $2z7TS.TokenKind).BRACKET_R),
            loc: this.loc(start)
        };
    } /**
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   */ ;
    _proto.parseObject = function parseObject(isConst) {
        var _this2 = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this2.parseObjectField(isConst);
        };
        return {
            kind: (0, $bzIlO.Kind).OBJECT,
            fields: this.any((0, $2z7TS.TokenKind).BRACE_L, item, (0, $2z7TS.TokenKind).BRACE_R),
            loc: this.loc(start)
        };
    } /**
   * ObjectField[Const] : Name : Value[?Const]
   */ ;
    _proto.parseObjectField = function parseObjectField(isConst) {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $2z7TS.TokenKind).COLON);
        return {
            kind: (0, $bzIlO.Kind).OBJECT_FIELD,
            name: name,
            value: this.parseValueLiteral(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Directives section.
     /**
   * Directives[Const] : Directive[?Const]+
   */ ;
    _proto.parseDirectives = function parseDirectives(isConst) {
        var directives = [];
        while(this.peek((0, $2z7TS.TokenKind).AT))directives.push(this.parseDirective(isConst));
        return directives;
    } /**
   * Directive[Const] : @ Name Arguments[?Const]?
   */ ;
    _proto.parseDirective = function parseDirective(isConst) {
        var start = this._lexer.token;
        this.expectToken((0, $2z7TS.TokenKind).AT);
        return {
            kind: (0, $bzIlO.Kind).DIRECTIVE,
            name: this.parseName(),
            arguments: this.parseArguments(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Types section.
     /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */ ;
    _proto.parseTypeReference = function parseTypeReference() {
        var start = this._lexer.token;
        var type;
        if (this.expectOptionalToken((0, $2z7TS.TokenKind).BRACKET_L)) {
            type = this.parseTypeReference();
            this.expectToken((0, $2z7TS.TokenKind).BRACKET_R);
            type = {
                kind: (0, $bzIlO.Kind).LIST_TYPE,
                type: type,
                loc: this.loc(start)
            };
        } else type = this.parseNamedType();
        if (this.expectOptionalToken((0, $2z7TS.TokenKind).BANG)) return {
            kind: (0, $bzIlO.Kind).NON_NULL_TYPE,
            type: type,
            loc: this.loc(start)
        };
        return type;
    } /**
   * NamedType : Name
   */ ;
    _proto.parseNamedType = function parseNamedType() {
        var start = this._lexer.token;
        return {
            kind: (0, $bzIlO.Kind).NAMED_TYPE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Type Definition section.
     /**
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */ ;
    _proto.parseTypeSystemDefinition = function parseTypeSystemDefinition() {
        // Many definitions begin with a description and require a lookahead.
        var keywordToken = this.peekDescription() ? this._lexer.lookahead() : this._lexer.token;
        if (keywordToken.kind === (0, $2z7TS.TokenKind).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaDefinition();
            case 'scalar':
                return this.parseScalarTypeDefinition();
            case 'type':
                return this.parseObjectTypeDefinition();
            case 'interface':
                return this.parseInterfaceTypeDefinition();
            case 'union':
                return this.parseUnionTypeDefinition();
            case 'enum':
                return this.parseEnumTypeDefinition();
            case 'input':
                return this.parseInputObjectTypeDefinition();
            case 'directive':
                return this.parseDirectiveDefinition();
        }
        throw this.unexpected(keywordToken);
    };
    _proto.peekDescription = function peekDescription() {
        return this.peek((0, $2z7TS.TokenKind).STRING) || this.peek((0, $2z7TS.TokenKind).BLOCK_STRING);
    } /**
   * Description : StringValue
   */ ;
    _proto.parseDescription = function parseDescription() {
        if (this.peekDescription()) return this.parseStringLiteral();
    } /**
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   */ ;
    _proto.parseSchemaDefinition = function parseSchemaDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('schema');
        var directives = this.parseDirectives(true);
        var operationTypes = this.many((0, $2z7TS.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, $2z7TS.TokenKind).BRACE_R);
        return {
            kind: (0, $bzIlO.Kind).SCHEMA_DEFINITION,
            description: description,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    } /**
   * OperationTypeDefinition : OperationType : NamedType
   */ ;
    _proto.parseOperationTypeDefinition = function parseOperationTypeDefinition() {
        var start = this._lexer.token;
        var operation = this.parseOperationType();
        this.expectToken((0, $2z7TS.TokenKind).COLON);
        var type = this.parseNamedType();
        return {
            kind: (0, $bzIlO.Kind).OPERATION_TYPE_DEFINITION,
            operation: operation,
            type: type,
            loc: this.loc(start)
        };
    } /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */ ;
    _proto.parseScalarTypeDefinition = function parseScalarTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('scalar');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $bzIlO.Kind).SCALAR_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */ ;
    _proto.parseObjectTypeDefinition = function parseObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('type');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $bzIlO.Kind).OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */ ;
    _proto.parseImplementsInterfaces = function parseImplementsInterfaces() {
        var _this$_options2;
        if (!this.expectOptionalKeyword('implements')) return [];
        if (((_this$_options2 = this._options) === null || _this$_options2 === void 0 ? void 0 : _this$_options2.allowLegacySDLImplementsInterfaces) === true) {
            var types = []; // Optional leading ampersand
            this.expectOptionalToken((0, $2z7TS.TokenKind).AMP);
            do types.push(this.parseNamedType());
            while (this.expectOptionalToken((0, $2z7TS.TokenKind).AMP) || this.peek((0, $2z7TS.TokenKind).NAME));
            return types;
        }
        return this.delimitedMany((0, $2z7TS.TokenKind).AMP, this.parseNamedType);
    } /**
   * FieldsDefinition : { FieldDefinition+ }
   */ ;
    _proto.parseFieldsDefinition = function parseFieldsDefinition() {
        var _this$_options3;
        // Legacy support for the SDL?
        if (((_this$_options3 = this._options) === null || _this$_options3 === void 0 ? void 0 : _this$_options3.allowLegacySDLEmptyFields) === true && this.peek((0, $2z7TS.TokenKind).BRACE_L) && this._lexer.lookahead().kind === (0, $2z7TS.TokenKind).BRACE_R) {
            this._lexer.advance();
            this._lexer.advance();
            return [];
        }
        return this.optionalMany((0, $2z7TS.TokenKind).BRACE_L, this.parseFieldDefinition, (0, $2z7TS.TokenKind).BRACE_R);
    } /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */ ;
    _proto.parseFieldDefinition = function parseFieldDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        this.expectToken((0, $2z7TS.TokenKind).COLON);
        var type = this.parseTypeReference();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $bzIlO.Kind).FIELD_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            type: type,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */ ;
    _proto.parseArgumentDefs = function parseArgumentDefs() {
        return this.optionalMany((0, $2z7TS.TokenKind).PAREN_L, this.parseInputValueDef, (0, $2z7TS.TokenKind).PAREN_R);
    } /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */ ;
    _proto.parseInputValueDef = function parseInputValueDef() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        this.expectToken((0, $2z7TS.TokenKind).COLON);
        var type = this.parseTypeReference();
        var defaultValue;
        if (this.expectOptionalToken((0, $2z7TS.TokenKind).EQUALS)) defaultValue = this.parseValueLiteral(true);
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $bzIlO.Kind).INPUT_VALUE_DEFINITION,
            description: description,
            name: name,
            type: type,
            defaultValue: defaultValue,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */ ;
    _proto.parseInterfaceTypeDefinition = function parseInterfaceTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('interface');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $bzIlO.Kind).INTERFACE_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */ ;
    _proto.parseUnionTypeDefinition = function parseUnionTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('union');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        return {
            kind: (0, $bzIlO.Kind).UNION_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    } /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */ ;
    _proto.parseUnionMemberTypes = function parseUnionMemberTypes() {
        return this.expectOptionalToken((0, $2z7TS.TokenKind).EQUALS) ? this.delimitedMany((0, $2z7TS.TokenKind).PIPE, this.parseNamedType) : [];
    } /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */ ;
    _proto.parseEnumTypeDefinition = function parseEnumTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('enum');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        return {
            kind: (0, $bzIlO.Kind).ENUM_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    } /**
   * EnumValuesDefinition : { EnumValueDefinition+ }
   */ ;
    _proto.parseEnumValuesDefinition = function parseEnumValuesDefinition() {
        return this.optionalMany((0, $2z7TS.TokenKind).BRACE_L, this.parseEnumValueDefinition, (0, $2z7TS.TokenKind).BRACE_R);
    } /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   *
   * EnumValue : Name
   */ ;
    _proto.parseEnumValueDefinition = function parseEnumValueDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $bzIlO.Kind).ENUM_VALUE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */ ;
    _proto.parseInputObjectTypeDefinition = function parseInputObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('input');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        return {
            kind: (0, $bzIlO.Kind).INPUT_OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * InputFieldsDefinition : { InputValueDefinition+ }
   */ ;
    _proto.parseInputFieldsDefinition = function parseInputFieldsDefinition() {
        return this.optionalMany((0, $2z7TS.TokenKind).BRACE_L, this.parseInputValueDef, (0, $2z7TS.TokenKind).BRACE_R);
    } /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */ ;
    _proto.parseTypeSystemExtension = function parseTypeSystemExtension() {
        var keywordToken = this._lexer.lookahead();
        if (keywordToken.kind === (0, $2z7TS.TokenKind).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaExtension();
            case 'scalar':
                return this.parseScalarTypeExtension();
            case 'type':
                return this.parseObjectTypeExtension();
            case 'interface':
                return this.parseInterfaceTypeExtension();
            case 'union':
                return this.parseUnionTypeExtension();
            case 'enum':
                return this.parseEnumTypeExtension();
            case 'input':
                return this.parseInputObjectTypeExtension();
        }
        throw this.unexpected(keywordToken);
    } /**
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   */ ;
    _proto.parseSchemaExtension = function parseSchemaExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('schema');
        var directives = this.parseDirectives(true);
        var operationTypes = this.optionalMany((0, $2z7TS.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, $2z7TS.TokenKind).BRACE_R);
        if (directives.length === 0 && operationTypes.length === 0) throw this.unexpected();
        return {
            kind: (0, $bzIlO.Kind).SCHEMA_EXTENSION,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    } /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */ ;
    _proto.parseScalarTypeExtension = function parseScalarTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('scalar');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        if (directives.length === 0) throw this.unexpected();
        return {
            kind: (0, $bzIlO.Kind).SCALAR_TYPE_EXTENSION,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */ ;
    _proto.parseObjectTypeExtension = function parseObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('type');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $bzIlO.Kind).OBJECT_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */ ;
    _proto.parseInterfaceTypeExtension = function parseInterfaceTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('interface');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $bzIlO.Kind).INTERFACE_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */ ;
    _proto.parseUnionTypeExtension = function parseUnionTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('union');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        if (directives.length === 0 && types.length === 0) throw this.unexpected();
        return {
            kind: (0, $bzIlO.Kind).UNION_TYPE_EXTENSION,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    } /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */ ;
    _proto.parseEnumTypeExtension = function parseEnumTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('enum');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        if (directives.length === 0 && values.length === 0) throw this.unexpected();
        return {
            kind: (0, $bzIlO.Kind).ENUM_TYPE_EXTENSION,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    } /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */ ;
    _proto.parseInputObjectTypeExtension = function parseInputObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('input');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        if (directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $bzIlO.Kind).INPUT_OBJECT_TYPE_EXTENSION,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   */ ;
    _proto.parseDirectiveDefinition = function parseDirectiveDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('directive');
        this.expectToken((0, $2z7TS.TokenKind).AT);
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        var repeatable = this.expectOptionalKeyword('repeatable');
        this.expectKeyword('on');
        var locations = this.parseDirectiveLocations();
        return {
            kind: (0, $bzIlO.Kind).DIRECTIVE_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            repeatable: repeatable,
            locations: locations,
            loc: this.loc(start)
        };
    } /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */ ;
    _proto.parseDirectiveLocations = function parseDirectiveLocations() {
        return this.delimitedMany((0, $2z7TS.TokenKind).PIPE, this.parseDirectiveLocation);
    } /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */ ;
    _proto.parseDirectiveLocation = function parseDirectiveLocation() {
        var start = this._lexer.token;
        var name = this.parseName();
        if ((0, $jADQJ.DirectiveLocation)[name.value] !== undefined) return name;
        throw this.unexpected(start);
    } // Core parsing utility functions
     /**
   * Returns a location object, used to identify the place in the source that created a given parsed object.
   */ ;
    _proto.loc = function loc(startToken) {
        var _this$_options4;
        if (((_this$_options4 = this._options) === null || _this$_options4 === void 0 ? void 0 : _this$_options4.noLocation) !== true) return new (0, $98oUl.Location)(startToken, this._lexer.lastToken, this._lexer.source);
    } /**
   * Determines if the next token is of a given kind
   */ ;
    _proto.peek = function peek(kind) {
        return this._lexer.token.kind === kind;
    } /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ ;
    _proto.expectToken = function expectToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        throw (0, $7ZXKi.syntaxError)(this._lexer.source, token.start, "Expected ".concat($62fd0a8327627af8$var$getTokenKindDesc(kind), ", found ").concat($62fd0a8327627af8$var$getTokenDesc(token), "."));
    } /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and return undefined.
   */ ;
    _proto.expectOptionalToken = function expectOptionalToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        return undefined;
    } /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ ;
    _proto.expectKeyword = function expectKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $2z7TS.TokenKind).NAME && token.value === value) this._lexer.advance();
        else throw (0, $7ZXKi.syntaxError)(this._lexer.source, token.start, "Expected \"".concat(value, "\", found ").concat($62fd0a8327627af8$var$getTokenDesc(token), "."));
    } /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ ;
    _proto.expectOptionalKeyword = function expectOptionalKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $2z7TS.TokenKind).NAME && token.value === value) {
            this._lexer.advance();
            return true;
        }
        return false;
    } /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */ ;
    _proto.unexpected = function unexpected(atToken) {
        var token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
        return (0, $7ZXKi.syntaxError)(this._lexer.source, token.start, "Unexpected ".concat($62fd0a8327627af8$var$getTokenDesc(token), "."));
    } /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.any = function any(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        while(!this.expectOptionalToken(closeKind))nodes.push(parseFn.call(this));
        return nodes;
    } /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.optionalMany = function optionalMany(openKind, parseFn, closeKind) {
        if (this.expectOptionalToken(openKind)) {
            var nodes = [];
            do nodes.push(parseFn.call(this));
            while (!this.expectOptionalToken(closeKind));
            return nodes;
        }
        return [];
    } /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.many = function many(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (!this.expectOptionalToken(closeKind));
        return nodes;
    } /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */ ;
    _proto.delimitedMany = function delimitedMany(delimiterKind, parseFn) {
        this.expectOptionalToken(delimiterKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (this.expectOptionalToken(delimiterKind));
        return nodes;
    };
    return Parser;
}();
/**
 * A helper function to describe a token as a string for debugging.
 */ function $62fd0a8327627af8$var$getTokenDesc(token) {
    var value = token.value;
    return $62fd0a8327627af8$var$getTokenKindDesc(token.kind) + (value != null ? " \"".concat(value, "\"") : '');
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */ function $62fd0a8327627af8$var$getTokenKindDesc(kind) {
    return (0, $jkcJk.isPunctuatorTokenKind)(kind) ? "\"".concat(kind, "\"") : kind;
}

});
parcelRegister("7ZXKi", function(module, exports) {

$parcel$export(module.exports, "syntaxError", () => $5d2c9324f08528ec$export$bbee0c6176c019d4);

var $g5yZB = parcelRequire("g5yZB");
function $5d2c9324f08528ec$export$bbee0c6176c019d4(source, position, description) {
    return new (0, $g5yZB.GraphQLError)("Syntax Error: ".concat(description), undefined, source, [
        position
    ]);
}

});
parcelRegister("g5yZB", function(module, exports) {

$parcel$export(module.exports, "GraphQLError", () => $bb6841c873fb42f5$export$92d6ed0888e7cb7f);

var $a1qmV = parcelRequire("a1qmV");

var $cJPdE = parcelRequire("cJPdE");

var $6DBwa = parcelRequire("6DBwa");

var $3DTMg = parcelRequire("3DTMg");

var $4Zjco = parcelRequire("4Zjco");
function $bb6841c873fb42f5$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $bb6841c873fb42f5$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $bb6841c873fb42f5$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $bb6841c873fb42f5$var$_typeof(obj);
}
function $bb6841c873fb42f5$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $bb6841c873fb42f5$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $bb6841c873fb42f5$var$ownKeys(Object(source), true).forEach(function(key) {
            $bb6841c873fb42f5$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $bb6841c873fb42f5$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $bb6841c873fb42f5$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $bb6841c873fb42f5$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $bb6841c873fb42f5$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $bb6841c873fb42f5$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $bb6841c873fb42f5$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $bb6841c873fb42f5$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $bb6841c873fb42f5$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $bb6841c873fb42f5$var$_setPrototypeOf(subClass, superClass);
}
function $bb6841c873fb42f5$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $bb6841c873fb42f5$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $bb6841c873fb42f5$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $bb6841c873fb42f5$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $bb6841c873fb42f5$var$_possibleConstructorReturn(this, result);
    };
}
function $bb6841c873fb42f5$var$_possibleConstructorReturn(self, call) {
    if (call && ($bb6841c873fb42f5$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $bb6841c873fb42f5$var$_assertThisInitialized(self);
}
function $bb6841c873fb42f5$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $bb6841c873fb42f5$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $bb6841c873fb42f5$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$bb6841c873fb42f5$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $bb6841c873fb42f5$var$_construct(Class, arguments, $bb6841c873fb42f5$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $bb6841c873fb42f5$var$_setPrototypeOf(Wrapper, Class);
    };
    return $bb6841c873fb42f5$var$_wrapNativeSuper(Class);
}
function $bb6841c873fb42f5$var$_construct(Parent, args, Class) {
    if ($bb6841c873fb42f5$var$_isNativeReflectConstruct()) $bb6841c873fb42f5$var$_construct = Reflect.construct;
    else $bb6841c873fb42f5$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $bb6841c873fb42f5$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $bb6841c873fb42f5$var$_construct.apply(null, arguments);
}
function $bb6841c873fb42f5$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $bb6841c873fb42f5$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $bb6841c873fb42f5$var$_setPrototypeOf(o, p) {
    $bb6841c873fb42f5$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $bb6841c873fb42f5$var$_setPrototypeOf(o, p);
}
function $bb6841c873fb42f5$var$_getPrototypeOf(o) {
    $bb6841c873fb42f5$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $bb6841c873fb42f5$var$_getPrototypeOf(o);
}
var $bb6841c873fb42f5$export$92d6ed0888e7cb7f = /*#__PURE__*/ function(_Error) {
    $bb6841c873fb42f5$var$_inherits(GraphQLError, _Error);
    var _super = $bb6841c873fb42f5$var$_createSuper(GraphQLError);
    /**
   * An array of { line, column } locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */ /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */ /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */ /**
   * The original error thrown from a field resolver during execution.
   */ /**
   * Extension fields to add to the formatted error.
   */ function GraphQLError(message, nodes, source, positions, path, originalError, extensions) {
        var _nodeLocations, _nodeLocations2, _nodeLocations3;
        var _this;
        $bb6841c873fb42f5$var$_classCallCheck(this, GraphQLError);
        _this = _super.call(this, message);
        _this.name = 'GraphQLError';
        _this.originalError = originalError !== null && originalError !== void 0 ? originalError : undefined; // Compute list of blame nodes.
        _this.nodes = $bb6841c873fb42f5$var$undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [
            nodes
        ] : undefined);
        var nodeLocations = [];
        for(var _i2 = 0, _ref3 = (_this$nodes = _this.nodes) !== null && _this$nodes !== void 0 ? _this$nodes : []; _i2 < _ref3.length; _i2++){
            var _this$nodes;
            var _ref4 = _ref3[_i2];
            var loc = _ref4.loc;
            if (loc != null) nodeLocations.push(loc);
        }
        nodeLocations = $bb6841c873fb42f5$var$undefinedIfEmpty(nodeLocations); // Compute locations in the source for the given nodes/positions.
        _this.source = source !== null && source !== void 0 ? source : (_nodeLocations = nodeLocations) === null || _nodeLocations === void 0 ? void 0 : _nodeLocations[0].source;
        _this.positions = positions !== null && positions !== void 0 ? positions : (_nodeLocations2 = nodeLocations) === null || _nodeLocations2 === void 0 ? void 0 : _nodeLocations2.map(function(loc) {
            return loc.start;
        });
        _this.locations = positions && source ? positions.map(function(pos) {
            return (0, $3DTMg.getLocation)(source, pos);
        }) : (_nodeLocations3 = nodeLocations) === null || _nodeLocations3 === void 0 ? void 0 : _nodeLocations3.map(function(loc) {
            return (0, $3DTMg.getLocation)(loc.source, loc.start);
        });
        _this.path = path !== null && path !== void 0 ? path : undefined;
        var originalExtensions = originalError === null || originalError === void 0 ? void 0 : originalError.extensions;
        if (extensions == null && (0, $cJPdE.default)(originalExtensions)) _this.extensions = $bb6841c873fb42f5$var$_objectSpread({}, originalExtensions);
        else _this.extensions = extensions !== null && extensions !== void 0 ? extensions : {};
         // By being enumerable, JSON.stringify will include bellow properties in the resulting output.
        // This ensures that the simplest possible GraphQL service adheres to the spec.
        Object.defineProperties($bb6841c873fb42f5$var$_assertThisInitialized(_this), {
            message: {
                enumerable: true
            },
            locations: {
                enumerable: _this.locations != null
            },
            path: {
                enumerable: _this.path != null
            },
            extensions: {
                enumerable: _this.extensions != null && Object.keys(_this.extensions).length > 0
            },
            name: {
                enumerable: false
            },
            nodes: {
                enumerable: false
            },
            source: {
                enumerable: false
            },
            positions: {
                enumerable: false
            },
            originalError: {
                enumerable: false
            }
        }); // Include (non-enumerable) stack trace.
        if (originalError !== null && originalError !== void 0 && originalError.stack) {
            Object.defineProperty($bb6841c873fb42f5$var$_assertThisInitialized(_this), 'stack', {
                value: originalError.stack,
                writable: true,
                configurable: true
            });
            return $bb6841c873fb42f5$var$_possibleConstructorReturn(_this);
        } // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
        if (Error.captureStackTrace) Error.captureStackTrace($bb6841c873fb42f5$var$_assertThisInitialized(_this), GraphQLError);
        else Object.defineProperty($bb6841c873fb42f5$var$_assertThisInitialized(_this), 'stack', {
            value: Error().stack,
            writable: true,
            configurable: true
        });
        return _this;
    }
    $bb6841c873fb42f5$var$_createClass(GraphQLError, [
        {
            key: "toString",
            value: function toString() {
                return $bb6841c873fb42f5$export$55ee1551a3f962e6(this);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return $bb6841c873fb42f5$export$7b5b869ee98c16ab(this);
            } // FIXME: workaround to not break chai comparisons, should be remove in v16
        },
        {
            key: (0, $6DBwa.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'Object';
            }
        }
    ]);
    return GraphQLError;
}(/*#__PURE__*/ $bb6841c873fb42f5$var$_wrapNativeSuper(Error));
function $bb6841c873fb42f5$var$undefinedIfEmpty(array) {
    return array === undefined || array.length === 0 ? undefined : array;
}
function $bb6841c873fb42f5$export$55ee1551a3f962e6(error) {
    var output = error.message;
    if (error.nodes) for(var _i4 = 0, _error$nodes2 = error.nodes; _i4 < _error$nodes2.length; _i4++){
        var node = _error$nodes2[_i4];
        if (node.loc) output += '\n\n' + (0, $4Zjco.printLocation)(node.loc);
    }
    else if (error.source && error.locations) for(var _i6 = 0, _error$locations2 = error.locations; _i6 < _error$locations2.length; _i6++){
        var location = _error$locations2[_i6];
        output += '\n\n' + (0, $4Zjco.printSourceLocation)(error.source, location);
    }
    return output;
}
function $bb6841c873fb42f5$export$7b5b869ee98c16ab(error) {
    var _error$message;
    error || (0, $a1qmV.default)(0, 'Received null or undefined error.');
    var message = (_error$message = error.message) !== null && _error$message !== void 0 ? _error$message : 'An unknown error occurred.';
    var locations = error.locations;
    var path = error.path;
    var extensions = error.extensions;
    return extensions && Object.keys(extensions).length > 0 ? {
        message: message,
        locations: locations,
        path: path,
        extensions: extensions
    } : {
        message: message,
        locations: locations,
        path: path
    };
} /**
 * @see https://github.com/graphql/graphql-spec/blob/master/spec/Section%207%20--%20Response.md#errors
 */ 

});
parcelRegister("a1qmV", function(module, exports) {

$parcel$export(module.exports, "default", () => $74be73ae076c40a2$export$2e2bcd8739ae039);
function $74be73ae076c40a2$export$2e2bcd8739ae039(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message);
}

});

parcelRegister("cJPdE", function(module, exports) {

$parcel$export(module.exports, "default", () => $94616b0c7295e50a$export$2e2bcd8739ae039);
function $94616b0c7295e50a$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $94616b0c7295e50a$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $94616b0c7295e50a$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $94616b0c7295e50a$var$_typeof(obj);
}
function $94616b0c7295e50a$export$2e2bcd8739ae039(value) {
    return $94616b0c7295e50a$var$_typeof(value) == 'object' && value !== null;
}

});

parcelRegister("6DBwa", function(module, exports) {

$parcel$export(module.exports, "SYMBOL_TO_STRING_TAG", () => $4d537cd703fb8e64$export$5deadc579ccc7c9c);
// In ES2015 (or a polyfilled) environment, this will be Symbol.iterator
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $4d537cd703fb8e64$export$f6cdee3c26d6da57 = typeof Symbol === 'function' && Symbol.iterator != null ? Symbol.iterator : '@@iterator'; // In ES2017 (or a polyfilled) environment, this will be Symbol.asyncIterator
var $4d537cd703fb8e64$export$8d0083df0471478e = typeof Symbol === 'function' && Symbol.asyncIterator != null ? Symbol.asyncIterator : '@@asyncIterator'; // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $4d537cd703fb8e64$export$5deadc579ccc7c9c = typeof Symbol === 'function' && Symbol.toStringTag != null ? Symbol.toStringTag : '@@toStringTag';

});

parcelRegister("3DTMg", function(module, exports) {

$parcel$export(module.exports, "getLocation", () => $2a7047dfe88e1e3e$export$e7fd20fad3cf4b5f);
/**
 * Represents a location in a Source.
 */ /**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */ function $2a7047dfe88e1e3e$export$e7fd20fad3cf4b5f(source, position) {
    var lineRegexp = /\r\n|[\n\r]/g;
    var line = 1;
    var column = position + 1;
    var match;
    while((match = lineRegexp.exec(source.body)) && match.index < position){
        line += 1;
        column = position + 1 - (match.index + match[0].length);
    }
    return {
        line: line,
        column: column
    };
}

});

parcelRegister("4Zjco", function(module, exports) {

$parcel$export(module.exports, "printLocation", () => $3a1bc06740b7fb42$export$96a9681e539deed);
$parcel$export(module.exports, "printSourceLocation", () => $3a1bc06740b7fb42$export$867940333fd9f869);

var $3DTMg = parcelRequire("3DTMg");
function $3a1bc06740b7fb42$export$96a9681e539deed(location) {
    return $3a1bc06740b7fb42$export$867940333fd9f869(location.source, (0, $3DTMg.getLocation)(location.source, location.start));
}
function $3a1bc06740b7fb42$export$867940333fd9f869(source, sourceLocation) {
    var firstLineColumnOffset = source.locationOffset.column - 1;
    var body = $3a1bc06740b7fb42$var$whitespace(firstLineColumnOffset) + source.body;
    var lineIndex = sourceLocation.line - 1;
    var lineOffset = source.locationOffset.line - 1;
    var lineNum = sourceLocation.line + lineOffset;
    var columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
    var columnNum = sourceLocation.column + columnOffset;
    var locationStr = "".concat(source.name, ":").concat(lineNum, ":").concat(columnNum, "\n");
    var lines = body.split(/\r\n|[\n\r]/g);
    var locationLine = lines[lineIndex]; // Special case for minified documents
    if (locationLine.length > 120) {
        var subLineIndex = Math.floor(columnNum / 80);
        var subLineColumnNum = columnNum % 80;
        var subLines = [];
        for(var i = 0; i < locationLine.length; i += 80)subLines.push(locationLine.slice(i, i + 80));
        return locationStr + $3a1bc06740b7fb42$var$printPrefixedLines([
            [
                "".concat(lineNum),
                subLines[0]
            ]
        ].concat(subLines.slice(1, subLineIndex + 1).map(function(subLine) {
            return [
                '',
                subLine
            ];
        }), [
            [
                ' ',
                $3a1bc06740b7fb42$var$whitespace(subLineColumnNum - 1) + '^'
            ],
            [
                '',
                subLines[subLineIndex + 1]
            ]
        ]));
    }
    return locationStr + $3a1bc06740b7fb42$var$printPrefixedLines([
        [
            "".concat(lineNum - 1),
            lines[lineIndex - 1]
        ],
        [
            "".concat(lineNum),
            locationLine
        ],
        [
            '',
            $3a1bc06740b7fb42$var$whitespace(columnNum - 1) + '^'
        ],
        [
            "".concat(lineNum + 1),
            lines[lineIndex + 1]
        ]
    ]);
}
function $3a1bc06740b7fb42$var$printPrefixedLines(lines) {
    var existingLines = lines.filter(function(_ref) {
        var _ = _ref[0], line = _ref[1];
        return line !== undefined;
    });
    var padLen = Math.max.apply(Math, existingLines.map(function(_ref2) {
        var prefix = _ref2[0];
        return prefix.length;
    }));
    return existingLines.map(function(_ref3) {
        var prefix = _ref3[0], line = _ref3[1];
        return $3a1bc06740b7fb42$var$leftPad(padLen, prefix) + (line ? ' | ' + line : ' |');
    }).join('\n');
}
function $3a1bc06740b7fb42$var$whitespace(len) {
    return Array(len + 1).join(' ');
}
function $3a1bc06740b7fb42$var$leftPad(len, str) {
    return $3a1bc06740b7fb42$var$whitespace(len - str.length) + str;
}

});



parcelRegister("bzIlO", function(module, exports) {

$parcel$export(module.exports, "Kind", () => $86d55dbd37d1d598$export$a84bdc57c5122798);
/**
 * The set of allowed kind values for AST nodes.
 */ var $86d55dbd37d1d598$export$a84bdc57c5122798 = Object.freeze({
    // Name
    NAME: 'Name',
    // Document
    DOCUMENT: 'Document',
    OPERATION_DEFINITION: 'OperationDefinition',
    VARIABLE_DEFINITION: 'VariableDefinition',
    SELECTION_SET: 'SelectionSet',
    FIELD: 'Field',
    ARGUMENT: 'Argument',
    // Fragments
    FRAGMENT_SPREAD: 'FragmentSpread',
    INLINE_FRAGMENT: 'InlineFragment',
    FRAGMENT_DEFINITION: 'FragmentDefinition',
    // Values
    VARIABLE: 'Variable',
    INT: 'IntValue',
    FLOAT: 'FloatValue',
    STRING: 'StringValue',
    BOOLEAN: 'BooleanValue',
    NULL: 'NullValue',
    ENUM: 'EnumValue',
    LIST: 'ListValue',
    OBJECT: 'ObjectValue',
    OBJECT_FIELD: 'ObjectField',
    // Directives
    DIRECTIVE: 'Directive',
    // Types
    NAMED_TYPE: 'NamedType',
    LIST_TYPE: 'ListType',
    NON_NULL_TYPE: 'NonNullType',
    // Type System Definitions
    SCHEMA_DEFINITION: 'SchemaDefinition',
    OPERATION_TYPE_DEFINITION: 'OperationTypeDefinition',
    // Type Definitions
    SCALAR_TYPE_DEFINITION: 'ScalarTypeDefinition',
    OBJECT_TYPE_DEFINITION: 'ObjectTypeDefinition',
    FIELD_DEFINITION: 'FieldDefinition',
    INPUT_VALUE_DEFINITION: 'InputValueDefinition',
    INTERFACE_TYPE_DEFINITION: 'InterfaceTypeDefinition',
    UNION_TYPE_DEFINITION: 'UnionTypeDefinition',
    ENUM_TYPE_DEFINITION: 'EnumTypeDefinition',
    ENUM_VALUE_DEFINITION: 'EnumValueDefinition',
    INPUT_OBJECT_TYPE_DEFINITION: 'InputObjectTypeDefinition',
    // Directive Definitions
    DIRECTIVE_DEFINITION: 'DirectiveDefinition',
    // Type System Extensions
    SCHEMA_EXTENSION: 'SchemaExtension',
    // Type Extensions
    SCALAR_TYPE_EXTENSION: 'ScalarTypeExtension',
    OBJECT_TYPE_EXTENSION: 'ObjectTypeExtension',
    INTERFACE_TYPE_EXTENSION: 'InterfaceTypeExtension',
    UNION_TYPE_EXTENSION: 'UnionTypeExtension',
    ENUM_TYPE_EXTENSION: 'EnumTypeExtension',
    INPUT_OBJECT_TYPE_EXTENSION: 'InputObjectTypeExtension'
}); /**
 * The enum type representing the possible kind values of AST nodes.
 */ 

});

parcelRegister("2z7TS", function(module, exports) {

$parcel$export(module.exports, "TokenKind", () => $1de4fa7b8080613f$export$8b9d26ab11394711);
/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */ var $1de4fa7b8080613f$export$8b9d26ab11394711 = Object.freeze({
    SOF: '<SOF>',
    EOF: '<EOF>',
    BANG: '!',
    DOLLAR: '$',
    AMP: '&',
    PAREN_L: '(',
    PAREN_R: ')',
    SPREAD: '...',
    COLON: ':',
    EQUALS: '=',
    AT: '@',
    BRACKET_L: '[',
    BRACKET_R: ']',
    BRACE_L: '{',
    PIPE: '|',
    BRACE_R: '}',
    NAME: 'Name',
    INT: 'Int',
    FLOAT: 'Float',
    STRING: 'String',
    BLOCK_STRING: 'BlockString',
    COMMENT: 'Comment'
}); /**
 * The enum type representing the token kinds values.
 */ 

});

parcelRegister("6vk4Q", function(module, exports) {

$parcel$export(module.exports, "Source", () => $4bc536350d5671b9$export$1d2df86270c81ecb);
$parcel$export(module.exports, "isSource", () => $4bc536350d5671b9$export$75135ee9ed6e435b);

var $6DBwa = parcelRequire("6DBwa");

var $yEDl8 = parcelRequire("yEDl8");

var $a1qmV = parcelRequire("a1qmV");

var $6B4dU = parcelRequire("6B4dU");
function $4bc536350d5671b9$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4bc536350d5671b9$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $4bc536350d5671b9$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4bc536350d5671b9$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
var $4bc536350d5671b9$export$1d2df86270c81ecb = /*#__PURE__*/ function() {
    function Source(body) {
        var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GraphQL request';
        var locationOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
            line: 1,
            column: 1
        };
        typeof body === 'string' || (0, $a1qmV.default)(0, "Body must be a string. Received: ".concat((0, $yEDl8.default)(body), "."));
        this.body = body;
        this.name = name;
        this.locationOffset = locationOffset;
        this.locationOffset.line > 0 || (0, $a1qmV.default)(0, 'line in locationOffset is 1-indexed and must be positive.');
        this.locationOffset.column > 0 || (0, $a1qmV.default)(0, 'column in locationOffset is 1-indexed and must be positive.');
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    $4bc536350d5671b9$var$_createClass(Source, [
        {
            key: (0, $6DBwa.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'Source';
            }
        }
    ]);
    return Source;
}();
function $4bc536350d5671b9$export$75135ee9ed6e435b(source) {
    return (0, $6B4dU.default)(source, $4bc536350d5671b9$export$1d2df86270c81ecb);
}

});
parcelRegister("6B4dU", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cd9796d6ab57d14$export$2e2bcd8739ae039);

function $4cd9796d6ab57d14$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $4cd9796d6ab57d14$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $4cd9796d6ab57d14$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $4cd9796d6ab57d14$var$_typeof(obj);
}
var /**
 * A replacement for instanceof which includes an error warning when multi-realm
 * constructors are detected.
 */ // See: https://expressjs.com/en/advanced/best-practice-performance.html#set-node_env-to-production
// See: https://webpack.js.org/guides/production/
$4cd9796d6ab57d14$export$2e2bcd8739ae039 = // eslint-disable-next-line no-shadow
function instanceOf(value, constructor) {
    return value instanceof constructor;
};

});


parcelRegister("jADQJ", function(module, exports) {

$parcel$export(module.exports, "DirectiveLocation", () => $e4304a67ae3cac6f$export$b45ffd2948484c41);
/**
 * The set of allowed directive location values.
 */ var $e4304a67ae3cac6f$export$b45ffd2948484c41 = Object.freeze({
    // Request Definitions
    QUERY: 'QUERY',
    MUTATION: 'MUTATION',
    SUBSCRIPTION: 'SUBSCRIPTION',
    FIELD: 'FIELD',
    FRAGMENT_DEFINITION: 'FRAGMENT_DEFINITION',
    FRAGMENT_SPREAD: 'FRAGMENT_SPREAD',
    INLINE_FRAGMENT: 'INLINE_FRAGMENT',
    VARIABLE_DEFINITION: 'VARIABLE_DEFINITION',
    // Type System Definitions
    SCHEMA: 'SCHEMA',
    SCALAR: 'SCALAR',
    OBJECT: 'OBJECT',
    FIELD_DEFINITION: 'FIELD_DEFINITION',
    ARGUMENT_DEFINITION: 'ARGUMENT_DEFINITION',
    INTERFACE: 'INTERFACE',
    UNION: 'UNION',
    ENUM: 'ENUM',
    ENUM_VALUE: 'ENUM_VALUE',
    INPUT_OBJECT: 'INPUT_OBJECT',
    INPUT_FIELD_DEFINITION: 'INPUT_FIELD_DEFINITION'
}); /**
 * The enum type representing the directive location values.
 */ 

});

parcelRegister("jkcJk", function(module, exports) {

$parcel$export(module.exports, "Lexer", () => $e119c27db9a87f5b$export$6168dc8908a6c652);
$parcel$export(module.exports, "isPunctuatorTokenKind", () => $e119c27db9a87f5b$export$59ac0f4da287406a);

var $7ZXKi = parcelRequire("7ZXKi");

var $98oUl = parcelRequire("98oUl");

var $2z7TS = parcelRequire("2z7TS");

var $541Mz = parcelRequire("541Mz");
var $e119c27db9a87f5b$export$6168dc8908a6c652 = /*#__PURE__*/ function() {
    /**
   * The previously focused non-ignored token.
   */ /**
   * The currently focused non-ignored token.
   */ /**
   * The (1-indexed) line containing the current token.
   */ /**
   * The character offset at which the current line begins.
   */ function Lexer(source) {
        var startOfFileToken = new (0, $98oUl.Token)((0, $2z7TS.TokenKind).SOF, 0, 0, 0, 0, null);
        this.source = source;
        this.lastToken = startOfFileToken;
        this.token = startOfFileToken;
        this.line = 1;
        this.lineStart = 0;
    }
    /**
   * Advances the token stream to the next non-ignored token.
   */ var _proto = Lexer.prototype;
    _proto.advance = function advance() {
        this.lastToken = this.token;
        var token = this.token = this.lookahead();
        return token;
    } /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */ ;
    _proto.lookahead = function lookahead() {
        var token = this.token;
        if (token.kind !== (0, $2z7TS.TokenKind).EOF) do {
            var _token$next;
            // Note: next is only mutable during parsing, so we cast to allow this.
            token = (_token$next = token.next) !== null && _token$next !== void 0 ? _token$next : token.next = $e119c27db9a87f5b$var$readToken(this, token);
        }while (token.kind === (0, $2z7TS.TokenKind).COMMENT);
        return token;
    };
    return Lexer;
}();
function $e119c27db9a87f5b$export$59ac0f4da287406a(kind) {
    return kind === (0, $2z7TS.TokenKind).BANG || kind === (0, $2z7TS.TokenKind).DOLLAR || kind === (0, $2z7TS.TokenKind).AMP || kind === (0, $2z7TS.TokenKind).PAREN_L || kind === (0, $2z7TS.TokenKind).PAREN_R || kind === (0, $2z7TS.TokenKind).SPREAD || kind === (0, $2z7TS.TokenKind).COLON || kind === (0, $2z7TS.TokenKind).EQUALS || kind === (0, $2z7TS.TokenKind).AT || kind === (0, $2z7TS.TokenKind).BRACKET_L || kind === (0, $2z7TS.TokenKind).BRACKET_R || kind === (0, $2z7TS.TokenKind).BRACE_L || kind === (0, $2z7TS.TokenKind).PIPE || kind === (0, $2z7TS.TokenKind).BRACE_R;
}
function $e119c27db9a87f5b$var$printCharCode(code) {
    return isNaN(code) ? (0, $2z7TS.TokenKind).EOF : code < 0x007f ? JSON.stringify(String.fromCharCode(code)) : "\"\\u".concat(('00' + code.toString(16).toUpperCase()).slice(-4), "\"");
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */ function $e119c27db9a87f5b$var$readToken(lexer, prev) {
    var source = lexer.source;
    var body = source.body;
    var bodyLength = body.length;
    var pos = prev.end;
    while(pos < bodyLength){
        var code = body.charCodeAt(pos);
        var _line = lexer.line;
        var _col = 1 + pos - lexer.lineStart; // SourceCharacter
        switch(code){
            case 0xfeff:
            case 9:
            case 32:
            case 44:
                //  ,
                ++pos;
                continue;
            case 10:
                //  \n
                ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 13:
                //  \r
                if (body.charCodeAt(pos + 1) === 10) pos += 2;
                else ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 33:
                //  !
                return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).BANG, pos, pos + 1, _line, _col, prev);
            case 35:
                //  #
                return $e119c27db9a87f5b$var$readComment(source, pos, _line, _col, prev);
            case 36:
                //  $
                return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).DOLLAR, pos, pos + 1, _line, _col, prev);
            case 38:
                //  &
                return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).AMP, pos, pos + 1, _line, _col, prev);
            case 40:
                //  (
                return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).PAREN_L, pos, pos + 1, _line, _col, prev);
            case 41:
                //  )
                return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).PAREN_R, pos, pos + 1, _line, _col, prev);
            case 46:
                //  .
                if (body.charCodeAt(pos + 1) === 46 && body.charCodeAt(pos + 2) === 46) return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).SPREAD, pos, pos + 3, _line, _col, prev);
                break;
            case 58:
                //  :
                return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).COLON, pos, pos + 1, _line, _col, prev);
            case 61:
                //  =
                return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).EQUALS, pos, pos + 1, _line, _col, prev);
            case 64:
                //  @
                return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).AT, pos, pos + 1, _line, _col, prev);
            case 91:
                //  [
                return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).BRACKET_L, pos, pos + 1, _line, _col, prev);
            case 93:
                //  ]
                return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).BRACKET_R, pos, pos + 1, _line, _col, prev);
            case 123:
                // {
                return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).BRACE_L, pos, pos + 1, _line, _col, prev);
            case 124:
                // |
                return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).PIPE, pos, pos + 1, _line, _col, prev);
            case 125:
                // }
                return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).BRACE_R, pos, pos + 1, _line, _col, prev);
            case 34:
                //  "
                if (body.charCodeAt(pos + 1) === 34 && body.charCodeAt(pos + 2) === 34) return $e119c27db9a87f5b$var$readBlockString(source, pos, _line, _col, prev, lexer);
                return $e119c27db9a87f5b$var$readString(source, pos, _line, _col, prev);
            case 45:
            case 48:
            case 49:
            case 50:
            case 51:
            case 52:
            case 53:
            case 54:
            case 55:
            case 56:
            case 57:
                //  9
                return $e119c27db9a87f5b$var$readNumber(source, pos, code, _line, _col, prev);
            case 65:
            case 66:
            case 67:
            case 68:
            case 69:
            case 70:
            case 71:
            case 72:
            case 73:
            case 74:
            case 75:
            case 76:
            case 77:
            case 78:
            case 79:
            case 80:
            case 81:
            case 82:
            case 83:
            case 84:
            case 85:
            case 86:
            case 87:
            case 88:
            case 89:
            case 90:
            case 95:
            case 97:
            case 98:
            case 99:
            case 100:
            case 101:
            case 102:
            case 103:
            case 104:
            case 105:
            case 106:
            case 107:
            case 108:
            case 109:
            case 110:
            case 111:
            case 112:
            case 113:
            case 114:
            case 115:
            case 116:
            case 117:
            case 118:
            case 119:
            case 120:
            case 121:
            case 122:
                // z
                return $e119c27db9a87f5b$var$readName(source, pos, _line, _col, prev);
        }
        throw (0, $7ZXKi.syntaxError)(source, pos, $e119c27db9a87f5b$var$unexpectedCharacterMessage(code));
    }
    var line = lexer.line;
    var col = 1 + pos - lexer.lineStart;
    return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).EOF, bodyLength, bodyLength, line, col, prev);
}
/**
 * Report a message that an unexpected character was encountered.
 */ function $e119c27db9a87f5b$var$unexpectedCharacterMessage(code) {
    if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) return "Cannot contain the invalid character ".concat($e119c27db9a87f5b$var$printCharCode(code), ".");
    if (code === 39) // '
    return 'Unexpected single quote character (\'), did you mean to use a double quote (")?';
    return "Cannot parse the unexpected character ".concat($e119c27db9a87f5b$var$printCharCode(code), ".");
}
/**
 * Reads a comment token from the source file.
 *
 * #[\u0009\u0020-\uFFFF]*
 */ function $e119c27db9a87f5b$var$readComment(source, start, line, col, prev) {
    var body = source.body;
    var code;
    var position = start;
    do code = body.charCodeAt(++position);
    while (!isNaN(code) && (code > 0x001f || code === 0x0009));
    return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).COMMENT, start, position, line, col, prev, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a float
 * or an int depending on whether a decimal point appears.
 *
 * Int:   -?(0|[1-9][0-9]*)
 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
 */ function $e119c27db9a87f5b$var$readNumber(source, start, firstCode, line, col, prev) {
    var body = source.body;
    var code = firstCode;
    var position = start;
    var isFloat = false;
    if (code === 45) // -
    code = body.charCodeAt(++position);
    if (code === 48) {
        // 0
        code = body.charCodeAt(++position);
        if (code >= 48 && code <= 57) throw (0, $7ZXKi.syntaxError)(source, position, "Invalid number, unexpected digit after 0: ".concat($e119c27db9a87f5b$var$printCharCode(code), "."));
    } else {
        position = $e119c27db9a87f5b$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 46) {
        // .
        isFloat = true;
        code = body.charCodeAt(++position);
        position = $e119c27db9a87f5b$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 69 || code === 101) {
        // E e
        isFloat = true;
        code = body.charCodeAt(++position);
        if (code === 43 || code === 45) // + -
        code = body.charCodeAt(++position);
        position = $e119c27db9a87f5b$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    } // Numbers cannot be followed by . or NameStart
    if (code === 46 || $e119c27db9a87f5b$var$isNameStart(code)) throw (0, $7ZXKi.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat($e119c27db9a87f5b$var$printCharCode(code), "."));
    return new (0, $98oUl.Token)(isFloat ? (0, $2z7TS.TokenKind).FLOAT : (0, $2z7TS.TokenKind).INT, start, position, line, col, prev, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading digits.
 */ function $e119c27db9a87f5b$var$readDigits(source, start, firstCode) {
    var body = source.body;
    var position = start;
    var code = firstCode;
    if (code >= 48 && code <= 57) {
        // 0 - 9
        do code = body.charCodeAt(++position);
        while (code >= 48 && code <= 57); // 0 - 9
        return position;
    }
    throw (0, $7ZXKi.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat($e119c27db9a87f5b$var$printCharCode(code), "."));
}
/**
 * Reads a string token from the source file.
 *
 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
 */ function $e119c27db9a87f5b$var$readString(source, start, line, col, prev) {
    var body = source.body;
    var position = start + 1;
    var chunkStart = position;
    var code = 0;
    var value = '';
    while(position < body.length && !isNaN(code = body.charCodeAt(position)) && // not LineTerminator
    code !== 0x000a && code !== 0x000d){
        // Closing Quote (")
        if (code === 34) {
            value += body.slice(chunkStart, position);
            return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).STRING, start, position + 1, line, col, prev, value);
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009) throw (0, $7ZXKi.syntaxError)(source, position, "Invalid character within String: ".concat($e119c27db9a87f5b$var$printCharCode(code), "."));
        ++position;
        if (code === 92) {
            // \
            value += body.slice(chunkStart, position - 1);
            code = body.charCodeAt(position);
            switch(code){
                case 34:
                    value += '"';
                    break;
                case 47:
                    value += '/';
                    break;
                case 92:
                    value += '\\';
                    break;
                case 98:
                    value += '\b';
                    break;
                case 102:
                    value += '\f';
                    break;
                case 110:
                    value += '\n';
                    break;
                case 114:
                    value += '\r';
                    break;
                case 116:
                    value += '\t';
                    break;
                case 117:
                    // uXXXX
                    var charCode = $e119c27db9a87f5b$var$uniCharCode(body.charCodeAt(position + 1), body.charCodeAt(position + 2), body.charCodeAt(position + 3), body.charCodeAt(position + 4));
                    if (charCode < 0) {
                        var invalidSequence = body.slice(position + 1, position + 5);
                        throw (0, $7ZXKi.syntaxError)(source, position, "Invalid character escape sequence: \\u".concat(invalidSequence, "."));
                    }
                    value += String.fromCharCode(charCode);
                    position += 4;
                    break;
                default:
                    throw (0, $7ZXKi.syntaxError)(source, position, "Invalid character escape sequence: \\".concat(String.fromCharCode(code), "."));
            }
            ++position;
            chunkStart = position;
        }
    }
    throw (0, $7ZXKi.syntaxError)(source, position, 'Unterminated string.');
}
/**
 * Reads a block string token from the source file.
 *
 * """("?"?(\\"""|\\(?!=""")|[^"\\]))*"""
 */ function $e119c27db9a87f5b$var$readBlockString(source, start, line, col, prev, lexer) {
    var body = source.body;
    var position = start + 3;
    var chunkStart = position;
    var code = 0;
    var rawValue = '';
    while(position < body.length && !isNaN(code = body.charCodeAt(position))){
        // Closing Triple-Quote (""")
        if (code === 34 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34) {
            rawValue += body.slice(chunkStart, position);
            return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).BLOCK_STRING, start, position + 3, line, col, prev, (0, $541Mz.dedentBlockStringValue)(rawValue));
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) throw (0, $7ZXKi.syntaxError)(source, position, "Invalid character within String: ".concat($e119c27db9a87f5b$var$printCharCode(code), "."));
        if (code === 10) {
            // new line
            ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 13) {
            // carriage return
            if (body.charCodeAt(position + 1) === 10) position += 2;
            else ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 92 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34 && body.charCodeAt(position + 3) === 34) {
            rawValue += body.slice(chunkStart, position) + '"""';
            position += 4;
            chunkStart = position;
        } else ++position;
    }
    throw (0, $7ZXKi.syntaxError)(source, position, 'Unterminated string.');
}
/**
 * Converts four hexadecimal chars to the integer that the
 * string represents. For example, uniCharCode('0','0','0','f')
 * will return 15, and uniCharCode('0','0','f','f') returns 255.
 *
 * Returns a negative number on error, if a char was invalid.
 *
 * This is implemented by noting that char2hex() returns -1 on error,
 * which means the result of ORing the char2hex() will also be negative.
 */ function $e119c27db9a87f5b$var$uniCharCode(a, b, c, d) {
    return $e119c27db9a87f5b$var$char2hex(a) << 12 | $e119c27db9a87f5b$var$char2hex(b) << 8 | $e119c27db9a87f5b$var$char2hex(c) << 4 | $e119c27db9a87f5b$var$char2hex(d);
}
/**
 * Converts a hex character to its integer value.
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 on error.
 */ function $e119c27db9a87f5b$var$char2hex(a) {
    return a >= 48 && a <= 57 ? a - 48 // 0-9
     : a >= 65 && a <= 70 ? a - 55 // A-F
     : a >= 97 && a <= 102 ? a - 87 // a-f
     : -1;
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * [_A-Za-z][_0-9A-Za-z]*
 */ function $e119c27db9a87f5b$var$readName(source, start, line, col, prev) {
    var body = source.body;
    var bodyLength = body.length;
    var position = start + 1;
    var code = 0;
    while(position !== bodyLength && !isNaN(code = body.charCodeAt(position)) && (code === 95 || // _
    code >= 48 && code <= 57 || // 0-9
    code >= 65 && code <= 90 || // A-Z
    code >= 97 && code <= 122 // a-z
    ))++position;
    return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).NAME, start, position, line, col, prev, body.slice(start, position));
} // _ A-Z a-z
function $e119c27db9a87f5b$var$isNameStart(code) {
    return code === 95 || code >= 65 && code <= 90 || code >= 97 && code <= 122;
}

});



parcelRegister("fwbX5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b4c31d9870379ac2$var$cloneObject;

var $b4c31d9870379ac2$var$_index = $b4c31d9870379ac2$var$_interopRequireDefault((parcelRequire("cpl5v")));
function $b4c31d9870379ac2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b4c31d9870379ac2$var$cloneObject(dirtyObject) {
    return (0, $b4c31d9870379ac2$var$_index.default)({}, dirtyObject);
}
module.exports = module.exports.default;

});
parcelRegister("cpl5v", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $90882d6ff669df4d$var$assign;
function $90882d6ff669df4d$var$assign(target, dirtyObject) {
    if (target == null) throw new TypeError('assign requires that input parameter not be null or undefined');
    dirtyObject = dirtyObject || {};
    for(var property in dirtyObject)if (Object.prototype.hasOwnProperty.call(dirtyObject, property)) target[property] = dirtyObject[property];
    return target;
}
module.exports = module.exports.default;

});


parcelRegister("aR9Qf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7e767cfeba790ebe$var$format;

var $7e767cfeba790ebe$var$_index = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("ck8JK")));

var $7e767cfeba790ebe$var$_index2 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("kvNR5")));

var $7e767cfeba790ebe$var$_index3 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("bQkcE")));

var $7e767cfeba790ebe$var$_index4 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("2pWQP")));

var $7e767cfeba790ebe$var$_index5 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("3ckvK")));

var $7e767cfeba790ebe$var$_index6 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("awKAW")));

var $7e767cfeba790ebe$var$_index7 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("jGQTC")));

var $5qguX = parcelRequire("5qguX");

var $7e767cfeba790ebe$var$_index9 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("aSksP")));

var $7e767cfeba790ebe$var$_index10 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $7e767cfeba790ebe$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $7e767cfeba790ebe$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $7e767cfeba790ebe$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $7e767cfeba790ebe$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $7e767cfeba790ebe$var$doubleQuoteRegExp = /''/g;
var $7e767cfeba790ebe$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 9. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The second argument is now required for the sake of explicitness.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   format(new Date(2016, 0, 1))
 *
 *   // v2.0.0 onward
 *   format(new Date(2016, 0, 1), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
 *   ```
 *
 * - New format string API for `format` function
 *   which is based on [Unicode Technical Standard #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table).
 *   See [this post](https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg) for more details.
 *
 * - Characters are now escaped using single quote symbols (`'`) instead of square brackets.
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://git.io/fxCyr
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://git.io/fxCyr
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * var result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * var result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */ function $7e767cfeba790ebe$var$format(dirtyDate, dirtyFormatStr, dirtyOptions) {
    (0, $7e767cfeba790ebe$var$_index10.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var locale = options.locale || $7e767cfeba790ebe$var$_index2.default;
    var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $7e767cfeba790ebe$var$_index9.default)(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $7e767cfeba790ebe$var$_index9.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, $7e767cfeba790ebe$var$_index9.default)(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, $7e767cfeba790ebe$var$_index9.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (!locale.localize) throw new RangeError('locale must contain localize property');
    if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
    var originalDate = (0, $7e767cfeba790ebe$var$_index4.default)(dirtyDate);
    if (!(0, $7e767cfeba790ebe$var$_index.default)(originalDate)) throw new RangeError('Invalid time value');
     // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $7e767cfeba790ebe$var$_index7.default)(originalDate);
    var utcDate = (0, $7e767cfeba790ebe$var$_index3.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($7e767cfeba790ebe$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = $7e767cfeba790ebe$var$_index6.default[firstCharacter];
            return longFormatter(substring, locale.formatLong, formatterOptions);
        }
        return substring;
    }).join('').match($7e767cfeba790ebe$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $7e767cfeba790ebe$var$cleanEscapedString(substring);
        var formatter = $7e767cfeba790ebe$var$_index5.default[firstCharacter];
        if (formatter) {
            if (!options.useAdditionalWeekYearTokens && (0, $5qguX.isProtectedWeekYearToken)(substring)) (0, $5qguX.throwProtectedError)(substring, dirtyFormatStr, dirtyDate);
            if (!options.useAdditionalDayOfYearTokens && (0, $5qguX.isProtectedDayOfYearToken)(substring)) (0, $5qguX.throwProtectedError)(substring, dirtyFormatStr, dirtyDate);
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($7e767cfeba790ebe$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        return substring;
    }).join('');
    return result;
}
function $7e767cfeba790ebe$var$cleanEscapedString(input) {
    return input.match($7e767cfeba790ebe$var$escapedStringRegExp)[1].replace($7e767cfeba790ebe$var$doubleQuoteRegExp, "'");
}
module.exports = module.exports.default;

});
parcelRegister("ck8JK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8f8e2146dfa1d727$var$isValid;

var $8f8e2146dfa1d727$var$_index = $8f8e2146dfa1d727$var$_interopRequireDefault((parcelRequire("2pWQP")));

var $8f8e2146dfa1d727$var$_index2 = $8f8e2146dfa1d727$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $8f8e2146dfa1d727$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - Now `isValid` doesn't throw an exception
 *   if the first argument is not an instance of Date.
 *   Instead, argument is converted beforehand using `toDate`.
 *
 *   Examples:
 *
 *   | `isValid` argument        | Before v2.0.0 | v2.0.0 onward |
 *   |---------------------------|---------------|---------------|
 *   | `new Date()`              | `true`        | `true`        |
 *   | `new Date('2016-01-01')`  | `true`        | `true`        |
 *   | `new Date('')`            | `false`       | `false`       |
 *   | `new Date(1488370835081)` | `true`        | `true`        |
 *   | `new Date(NaN)`           | `false`       | `false`       |
 *   | `'2016-01-01'`            | `TypeError`   | `false`       |
 *   | `''`                      | `TypeError`   | `false`       |
 *   | `1488370835081`           | `TypeError`   | `true`        |
 *   | `NaN`                     | `TypeError`   | `false`       |
 *
 *   We introduce this change to make *date-fns* consistent with ECMAScript behavior
 *   that try to coerce arguments to the expected type
 *   (which is also the case with other *date-fns* functions).
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * var result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * var result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * var result = isValid(new Date(''))
 * //=> false
 */ function $8f8e2146dfa1d727$var$isValid(dirtyDate) {
    (0, $8f8e2146dfa1d727$var$_index2.default)(1, arguments);
    var date = (0, $8f8e2146dfa1d727$var$_index.default)(dirtyDate);
    return !isNaN(date);
}
module.exports = module.exports.default;

});
parcelRegister("2pWQP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1c2b912e6615b0b5$var$toDate;

var $1c2b912e6615b0b5$var$_index = $1c2b912e6615b0b5$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $1c2b912e6615b0b5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */ function $1c2b912e6615b0b5$var$toDate(argument) {
    (0, $1c2b912e6615b0b5$var$_index.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument); // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}
module.exports = module.exports.default;

});
parcelRegister("6eBfj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $48a0f126c2293ab3$var$requiredArgs;
function $48a0f126c2293ab3$var$requiredArgs(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}
module.exports = module.exports.default;

});



parcelRegister("kvNR5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eeed6020e120f946$var$_index = $eeed6020e120f946$var$_interopRequireDefault((parcelRequire("5u9TK")));

var $eeed6020e120f946$var$_index2 = $eeed6020e120f946$var$_interopRequireDefault((parcelRequire("e7AgV")));

var $eeed6020e120f946$var$_index3 = $eeed6020e120f946$var$_interopRequireDefault((parcelRequire("8U2eY")));

var $eeed6020e120f946$var$_index4 = $eeed6020e120f946$var$_interopRequireDefault((parcelRequire("b9d75")));

var $eeed6020e120f946$var$_index5 = $eeed6020e120f946$var$_interopRequireDefault((parcelRequire("hHwuU")));
function $eeed6020e120f946$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $eeed6020e120f946$var$locale = {
    code: 'en-US',
    formatDistance: $eeed6020e120f946$var$_index.default,
    formatLong: $eeed6020e120f946$var$_index2.default,
    formatRelative: $eeed6020e120f946$var$_index3.default,
    localize: $eeed6020e120f946$var$_index4.default,
    match: $eeed6020e120f946$var$_index5.default,
    options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
    }
};
var $eeed6020e120f946$var$_default = $eeed6020e120f946$var$locale;
module.exports.default = $eeed6020e120f946$var$_default;
module.exports = module.exports.default;

});
parcelRegister("5u9TK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3fe76ea3cd34e32f$var$formatDistance;
var $3fe76ea3cd34e32f$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
};
function $3fe76ea3cd34e32f$var$formatDistance(token, count, options) {
    options = options || {};
    var result;
    if (typeof $3fe76ea3cd34e32f$var$formatDistanceLocale[token] === 'string') result = $3fe76ea3cd34e32f$var$formatDistanceLocale[token];
    else if (count === 1) result = $3fe76ea3cd34e32f$var$formatDistanceLocale[token].one;
    else result = $3fe76ea3cd34e32f$var$formatDistanceLocale[token].other.replace('{{count}}', count);
    if (options.addSuffix) {
        if (options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
}
module.exports = module.exports.default;

});

parcelRegister("e7AgV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a47ddb0366100c31$var$_index = $a47ddb0366100c31$var$_interopRequireDefault((parcelRequire("4raqC")));
function $a47ddb0366100c31$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $a47ddb0366100c31$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $a47ddb0366100c31$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $a47ddb0366100c31$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $a47ddb0366100c31$var$formatLong = {
    date: (0, $a47ddb0366100c31$var$_index.default)({
        formats: $a47ddb0366100c31$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $a47ddb0366100c31$var$_index.default)({
        formats: $a47ddb0366100c31$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $a47ddb0366100c31$var$_index.default)({
        formats: $a47ddb0366100c31$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $a47ddb0366100c31$var$_default = $a47ddb0366100c31$var$formatLong;
module.exports.default = $a47ddb0366100c31$var$_default;
module.exports = module.exports.default;

});
parcelRegister("4raqC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $33b1c5e9f7814c0e$var$buildFormatLongFn;
function $33b1c5e9f7814c0e$var$buildFormatLongFn(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}
module.exports = module.exports.default;

});


parcelRegister("8U2eY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $67b54aa1e07b4b42$var$formatRelative;
var $67b54aa1e07b4b42$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
function $67b54aa1e07b4b42$var$formatRelative(token, _date, _baseDate, _options) {
    return $67b54aa1e07b4b42$var$formatRelativeLocale[token];
}
module.exports = module.exports.default;

});

parcelRegister("b9d75", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $81dab50370972ecd$var$_index = $81dab50370972ecd$var$_interopRequireDefault((parcelRequire("llBmH")));
function $81dab50370972ecd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $81dab50370972ecd$var$eraValues = {
    narrow: [
        'B',
        'A'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        'Before Christ',
        'Anno Domini'
    ]
};
var $81dab50370972ecd$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1st quarter',
        '2nd quarter',
        '3rd quarter',
        '4th quarter'
    ]
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $81dab50370972ecd$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    wide: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
};
var $81dab50370972ecd$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],
    short: [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    wide: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]
};
var $81dab50370972ecd$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    }
};
var $81dab50370972ecd$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    }
};
function $81dab50370972ecd$var$ordinalNumber(dirtyNumber, _dirtyOptions) {
    var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`:
    //
    //   var options = dirtyOptions || {}
    //   var unit = String(options.unit)
    //
    // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'st';
        case 2:
            return number + 'nd';
        case 3:
            return number + 'rd';
    }
    return number + 'th';
}
var $81dab50370972ecd$var$localize = {
    ordinalNumber: $81dab50370972ecd$var$ordinalNumber,
    era: (0, $81dab50370972ecd$var$_index.default)({
        values: $81dab50370972ecd$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $81dab50370972ecd$var$_index.default)({
        values: $81dab50370972ecd$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $81dab50370972ecd$var$_index.default)({
        values: $81dab50370972ecd$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $81dab50370972ecd$var$_index.default)({
        values: $81dab50370972ecd$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $81dab50370972ecd$var$_index.default)({
        values: $81dab50370972ecd$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $81dab50370972ecd$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $81dab50370972ecd$var$_default = $81dab50370972ecd$var$localize;
module.exports.default = $81dab50370972ecd$var$_default;
module.exports = module.exports.default;

});
parcelRegister("llBmH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f8a88b0d5d631bc1$var$buildLocalizeFn;
function $f8a88b0d5d631bc1$var$buildLocalizeFn(args) {
    return function(dirtyIndex, dirtyOptions) {
        var options = dirtyOptions || {};
        var context = options.context ? String(options.context) : 'standalone';
        var valuesArray;
        if (context === 'formatting' && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challange you to try to remove it!
        return valuesArray[index];
    };
}
module.exports = module.exports.default;

});


parcelRegister("hHwuU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ce2fa922bf4a591b$var$_index = $ce2fa922bf4a591b$var$_interopRequireDefault((parcelRequire("1IY7t")));

var $ce2fa922bf4a591b$var$_index2 = $ce2fa922bf4a591b$var$_interopRequireDefault((parcelRequire("liduU")));
function $ce2fa922bf4a591b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $ce2fa922bf4a591b$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $ce2fa922bf4a591b$var$parseOrdinalNumberPattern = /\d+/i;
var $ce2fa922bf4a591b$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $ce2fa922bf4a591b$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $ce2fa922bf4a591b$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $ce2fa922bf4a591b$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $ce2fa922bf4a591b$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $ce2fa922bf4a591b$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $ce2fa922bf4a591b$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $ce2fa922bf4a591b$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $ce2fa922bf4a591b$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $ce2fa922bf4a591b$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $ce2fa922bf4a591b$var$match = {
    ordinalNumber: (0, $ce2fa922bf4a591b$var$_index.default)({
        matchPattern: $ce2fa922bf4a591b$var$matchOrdinalNumberPattern,
        parsePattern: $ce2fa922bf4a591b$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $ce2fa922bf4a591b$var$_index2.default)({
        matchPatterns: $ce2fa922bf4a591b$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $ce2fa922bf4a591b$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $ce2fa922bf4a591b$var$_index2.default)({
        matchPatterns: $ce2fa922bf4a591b$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $ce2fa922bf4a591b$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function(index) {
            return index + 1;
        }
    }),
    month: (0, $ce2fa922bf4a591b$var$_index2.default)({
        matchPatterns: $ce2fa922bf4a591b$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $ce2fa922bf4a591b$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $ce2fa922bf4a591b$var$_index2.default)({
        matchPatterns: $ce2fa922bf4a591b$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $ce2fa922bf4a591b$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $ce2fa922bf4a591b$var$_index2.default)({
        matchPatterns: $ce2fa922bf4a591b$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $ce2fa922bf4a591b$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $ce2fa922bf4a591b$var$_default = $ce2fa922bf4a591b$var$match;
module.exports.default = $ce2fa922bf4a591b$var$_default;
module.exports = module.exports.default;

});
parcelRegister("1IY7t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $141888fa04c95812$var$buildMatchPatternFn;
function $141888fa04c95812$var$buildMatchPatternFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
module.exports = module.exports.default;

});

parcelRegister("liduU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f805bfb7f96f3bcc$var$buildMatchFn;
function $f805bfb7f96f3bcc$var$buildMatchFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $f805bfb7f96f3bcc$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $f805bfb7f96f3bcc$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $f805bfb7f96f3bcc$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $f805bfb7f96f3bcc$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}
module.exports = module.exports.default;

});



parcelRegister("bQkcE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $89f438ee982b4fb2$var$subMilliseconds;

var $89f438ee982b4fb2$var$_index = $89f438ee982b4fb2$var$_interopRequireDefault((parcelRequire("aSksP")));

var $89f438ee982b4fb2$var$_index2 = $89f438ee982b4fb2$var$_interopRequireDefault((parcelRequire("7f9OM")));

var $89f438ee982b4fb2$var$_index3 = $89f438ee982b4fb2$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $89f438ee982b4fb2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */ function $89f438ee982b4fb2$var$subMilliseconds(dirtyDate, dirtyAmount) {
    (0, $89f438ee982b4fb2$var$_index3.default)(2, arguments);
    var amount = (0, $89f438ee982b4fb2$var$_index.default)(dirtyAmount);
    return (0, $89f438ee982b4fb2$var$_index2.default)(dirtyDate, -amount);
}
module.exports = module.exports.default;

});
parcelRegister("aSksP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7eaed23c7cdcf6c0$var$toInteger;
function $7eaed23c7cdcf6c0$var$toInteger(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}
module.exports = module.exports.default;

});

parcelRegister("7f9OM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $54618cc00c3fb8fc$var$addMilliseconds;

var $54618cc00c3fb8fc$var$_index = $54618cc00c3fb8fc$var$_interopRequireDefault((parcelRequire("aSksP")));

var $54618cc00c3fb8fc$var$_index2 = $54618cc00c3fb8fc$var$_interopRequireDefault((parcelRequire("2pWQP")));

var $54618cc00c3fb8fc$var$_index3 = $54618cc00c3fb8fc$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $54618cc00c3fb8fc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */ function $54618cc00c3fb8fc$var$addMilliseconds(dirtyDate, dirtyAmount) {
    (0, $54618cc00c3fb8fc$var$_index3.default)(2, arguments);
    var timestamp = (0, $54618cc00c3fb8fc$var$_index2.default)(dirtyDate).getTime();
    var amount = (0, $54618cc00c3fb8fc$var$_index.default)(dirtyAmount);
    return new Date(timestamp + amount);
}
module.exports = module.exports.default;

});


parcelRegister("3ckvK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2542672a600cd2b8$var$_index = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("kFGp1")));

var $2542672a600cd2b8$var$_index2 = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("3xdEO")));

var $2542672a600cd2b8$var$_index3 = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("6Falt")));

var $2542672a600cd2b8$var$_index4 = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("gUvh1")));

var $2542672a600cd2b8$var$_index5 = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("46m4m")));

var $2542672a600cd2b8$var$_index6 = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("3ihh3")));

var $2542672a600cd2b8$var$_index7 = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("bQ2eo")));
function $2542672a600cd2b8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $2542672a600cd2b8$var$dayPeriodEnum = {
    am: 'am',
    pm: 'pm',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $2542672a600cd2b8$var$formatters = {
    // Era
    G: function(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case 'G':
            case 'GG':
            case 'GGG':
                return localize.era(era, {
                    width: 'abbreviated'
                });
            // A, B
            case 'GGGGG':
                return localize.era(era, {
                    width: 'narrow'
                });
            // Anno Domini, Before Christ
            case 'GGGG':
            default:
                return localize.era(era, {
                    width: 'wide'
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === 'yo') {
            var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: 'year'
            });
        }
        return $2542672a600cd2b8$var$_index.default.y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        var signedWeekYear = (0, $2542672a600cd2b8$var$_index6.default)(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year
        if (token === 'YY') {
            var twoDigitYear = weekYear % 100;
            return (0, $2542672a600cd2b8$var$_index7.default)(twoDigitYear, 2);
        } // Ordinal number
        if (token === 'Yo') return localize.ordinalNumber(weekYear, {
            unit: 'year'
        });
         // Padding
        return (0, $2542672a600cd2b8$var$_index7.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        var isoWeekYear = (0, $2542672a600cd2b8$var$_index4.default)(date); // Padding
        return (0, $2542672a600cd2b8$var$_index7.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        var year = date.getUTCFullYear();
        return (0, $2542672a600cd2b8$var$_index7.default)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'Q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'QQ':
                return (0, $2542672a600cd2b8$var$_index7.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'Qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'QQQ':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'QQQQQ':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // 1st quarter, 2nd quarter, ...
            case 'QQQQ':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'qq':
                return (0, $2542672a600cd2b8$var$_index7.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'qqq':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'qqqqq':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // 1st quarter, 2nd quarter, ...
            case 'qqqq':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case 'M':
            case 'MM':
                return $2542672a600cd2b8$var$_index.default.M(date, token);
            // 1st, 2nd, ..., 12th
            case 'Mo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'MMM':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // J, F, ..., D
            case 'MMMMM':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // January, February, ..., December
            case 'MMMM':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case 'L':
                return String(month + 1);
            // 01, 02, ..., 12
            case 'LL':
                return (0, $2542672a600cd2b8$var$_index7.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case 'Lo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'LLL':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // J, F, ..., D
            case 'LLLLL':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // January, February, ..., December
            case 'LLLL':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        var week = (0, $2542672a600cd2b8$var$_index5.default)(date, options);
        if (token === 'wo') return localize.ordinalNumber(week, {
            unit: 'week'
        });
        return (0, $2542672a600cd2b8$var$_index7.default)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        var isoWeek = (0, $2542672a600cd2b8$var$_index3.default)(date);
        if (token === 'Io') return localize.ordinalNumber(isoWeek, {
            unit: 'week'
        });
        return (0, $2542672a600cd2b8$var$_index7.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
            unit: 'date'
        });
        return $2542672a600cd2b8$var$_index.default.d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        var dayOfYear = (0, $2542672a600cd2b8$var$_index2.default)(date);
        if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
            unit: 'dayOfYear'
        });
        return (0, $2542672a600cd2b8$var$_index7.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case 'E':
            case 'EE':
            case 'EEE':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'EEEEE':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'EEEEEE':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'EEEE':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case 'e':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'ee':
                return (0, $2542672a600cd2b8$var$_index7.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case 'eo':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'eee':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'eeeee':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'eeeeee':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'eeee':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case 'c':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'cc':
                return (0, $2542672a600cd2b8$var$_index7.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case 'co':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'ccc':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // T
            case 'ccccc':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // Tu
            case 'cccccc':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'standalone'
                });
            // Tuesday
            case 'cccc':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case 'i':
                return String(isoDayOfWeek);
            // 02
            case 'ii':
                return (0, $2542672a600cd2b8$var$_index7.default)(isoDayOfWeek, token.length);
            // 2nd
            case 'io':
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: 'day'
                });
            // Tue
            case 'iii':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'iiiii':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'iiiiii':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'iiii':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'aaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'aaaaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'aaaa':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $2542672a600cd2b8$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $2542672a600cd2b8$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'b':
            case 'bb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'bbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'bbbbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'bbbb':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $2542672a600cd2b8$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $2542672a600cd2b8$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $2542672a600cd2b8$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $2542672a600cd2b8$var$dayPeriodEnum.night;
        switch(token){
            case 'B':
            case 'BB':
            case 'BBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'BBBBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'BBBB':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === 'ho') {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
        }
        return $2542672a600cd2b8$var$_index.default.h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
            unit: 'hour'
        });
        return $2542672a600cd2b8$var$_index.default.H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === 'Ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $2542672a600cd2b8$var$_index7.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === 'ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $2542672a600cd2b8$var$_index7.default)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: 'minute'
        });
        return $2542672a600cd2b8$var$_index.default.m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: 'second'
        });
        return $2542672a600cd2b8$var$_index.default.s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return $2542672a600cd2b8$var$_index.default.S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $2542672a600cd2b8$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                // Hours and minutes without `:` delimiter
                return $2542672a600cd2b8$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $2542672a600cd2b8$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $2542672a600cd2b8$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                // Hours and minutes without `:` delimiter
                return $2542672a600cd2b8$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $2542672a600cd2b8$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $2542672a600cd2b8$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $2542672a600cd2b8$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return 'GMT' + $2542672a600cd2b8$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'zzzz':
            default:
                return 'GMT' + $2542672a600cd2b8$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $2542672a600cd2b8$var$_index7.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $2542672a600cd2b8$var$_index7.default)(timestamp, token.length);
    }
};
function $2542672a600cd2b8$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + (0, $2542672a600cd2b8$var$_index7.default)(minutes, 2);
}
function $2542672a600cd2b8$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + (0, $2542672a600cd2b8$var$_index7.default)(Math.abs(offset) / 60, 2);
    }
    return $2542672a600cd2b8$var$formatTimezone(offset, dirtyDelimiter);
}
function $2542672a600cd2b8$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = (0, $2542672a600cd2b8$var$_index7.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $2542672a600cd2b8$var$_index7.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $2542672a600cd2b8$var$_default = $2542672a600cd2b8$var$formatters;
module.exports.default = $2542672a600cd2b8$var$_default;
module.exports = module.exports.default;

});
parcelRegister("kFGp1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f0c88744bd108133$var$_index = $f0c88744bd108133$var$_interopRequireDefault((parcelRequire("bQ2eo")));
function $f0c88744bd108133$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $f0c88744bd108133$var$formatters = {
    // Year
    y: function(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $f0c88744bd108133$var$_index.default)(token === 'yy' ? year % 100 : year, token.length);
    },
    // Month
    M: function(date, token) {
        var month = date.getUTCMonth();
        return token === 'M' ? String(month + 1) : (0, $f0c88744bd108133$var$_index.default)(month + 1, 2);
    },
    // Day of the month
    d: function(date, token) {
        return (0, $f0c88744bd108133$var$_index.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return dayPeriodEnumValue.toUpperCase();
            case 'aaa':
                return dayPeriodEnumValue;
            case 'aaaaa':
                return dayPeriodEnumValue[0];
            case 'aaaa':
            default:
                return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
        }
    },
    // Hour [1-12]
    h: function(date, token) {
        return (0, $f0c88744bd108133$var$_index.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function(date, token) {
        return (0, $f0c88744bd108133$var$_index.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function(date, token) {
        return (0, $f0c88744bd108133$var$_index.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function(date, token) {
        return (0, $f0c88744bd108133$var$_index.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $f0c88744bd108133$var$_index.default)(fractionalSeconds, token.length);
    }
};
var $f0c88744bd108133$var$_default = $f0c88744bd108133$var$formatters;
module.exports.default = $f0c88744bd108133$var$_default;
module.exports = module.exports.default;

});
parcelRegister("bQ2eo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $89e6481d20123ee2$var$addLeadingZeros;
function $89e6481d20123ee2$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
module.exports = module.exports.default;

});


parcelRegister("3xdEO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $292f0c3a5495486a$var$getUTCDayOfYear;

var $292f0c3a5495486a$var$_index = $292f0c3a5495486a$var$_interopRequireDefault((parcelRequire("2pWQP")));

var $292f0c3a5495486a$var$_index2 = $292f0c3a5495486a$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $292f0c3a5495486a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $292f0c3a5495486a$var$MILLISECONDS_IN_DAY = 86400000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $292f0c3a5495486a$var$getUTCDayOfYear(dirtyDate) {
    (0, $292f0c3a5495486a$var$_index2.default)(1, arguments);
    var date = (0, $292f0c3a5495486a$var$_index.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $292f0c3a5495486a$var$MILLISECONDS_IN_DAY) + 1;
}
module.exports = module.exports.default;

});

parcelRegister("6Falt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4d9e98caba6dac2d$var$getUTCISOWeek;

var $4d9e98caba6dac2d$var$_index = $4d9e98caba6dac2d$var$_interopRequireDefault((parcelRequire("2pWQP")));

var $4d9e98caba6dac2d$var$_index2 = $4d9e98caba6dac2d$var$_interopRequireDefault((parcelRequire("6nDqw")));

var $4d9e98caba6dac2d$var$_index3 = $4d9e98caba6dac2d$var$_interopRequireDefault((parcelRequire("hI2kM")));

var $4d9e98caba6dac2d$var$_index4 = $4d9e98caba6dac2d$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $4d9e98caba6dac2d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $4d9e98caba6dac2d$var$MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $4d9e98caba6dac2d$var$getUTCISOWeek(dirtyDate) {
    (0, $4d9e98caba6dac2d$var$_index4.default)(1, arguments);
    var date = (0, $4d9e98caba6dac2d$var$_index.default)(dirtyDate);
    var diff = (0, $4d9e98caba6dac2d$var$_index2.default)(date).getTime() - (0, $4d9e98caba6dac2d$var$_index3.default)(date).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $4d9e98caba6dac2d$var$MILLISECONDS_IN_WEEK) + 1;
}
module.exports = module.exports.default;

});
parcelRegister("6nDqw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4a53796a96b58804$var$startOfUTCISOWeek;

var $4a53796a96b58804$var$_index = $4a53796a96b58804$var$_interopRequireDefault((parcelRequire("2pWQP")));

var $4a53796a96b58804$var$_index2 = $4a53796a96b58804$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $4a53796a96b58804$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $4a53796a96b58804$var$startOfUTCISOWeek(dirtyDate) {
    (0, $4a53796a96b58804$var$_index2.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $4a53796a96b58804$var$_index.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}
module.exports = module.exports.default;

});

parcelRegister("hI2kM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ce485b424b643216$var$startOfUTCISOWeekYear;

var $ce485b424b643216$var$_index = $ce485b424b643216$var$_interopRequireDefault((parcelRequire("gUvh1")));

var $ce485b424b643216$var$_index2 = $ce485b424b643216$var$_interopRequireDefault((parcelRequire("6nDqw")));

var $ce485b424b643216$var$_index3 = $ce485b424b643216$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $ce485b424b643216$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $ce485b424b643216$var$startOfUTCISOWeekYear(dirtyDate) {
    (0, $ce485b424b643216$var$_index3.default)(1, arguments);
    var year = (0, $ce485b424b643216$var$_index.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $ce485b424b643216$var$_index2.default)(fourthOfJanuary);
    return date;
}
module.exports = module.exports.default;

});
parcelRegister("gUvh1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c4fa22996f39566a$var$getUTCISOWeekYear;

var $c4fa22996f39566a$var$_index = $c4fa22996f39566a$var$_interopRequireDefault((parcelRequire("2pWQP")));

var $c4fa22996f39566a$var$_index2 = $c4fa22996f39566a$var$_interopRequireDefault((parcelRequire("6nDqw")));

var $c4fa22996f39566a$var$_index3 = $c4fa22996f39566a$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $c4fa22996f39566a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $c4fa22996f39566a$var$getUTCISOWeekYear(dirtyDate) {
    (0, $c4fa22996f39566a$var$_index3.default)(1, arguments);
    var date = (0, $c4fa22996f39566a$var$_index.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $c4fa22996f39566a$var$_index2.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $c4fa22996f39566a$var$_index2.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
module.exports = module.exports.default;

});



parcelRegister("46m4m", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2fc8d772b38d0976$var$getUTCWeek;

var $2fc8d772b38d0976$var$_index = $2fc8d772b38d0976$var$_interopRequireDefault((parcelRequire("2pWQP")));

var $2fc8d772b38d0976$var$_index2 = $2fc8d772b38d0976$var$_interopRequireDefault((parcelRequire("clhRK")));

var $2fc8d772b38d0976$var$_index3 = $2fc8d772b38d0976$var$_interopRequireDefault((parcelRequire("cbqvD")));

var $2fc8d772b38d0976$var$_index4 = $2fc8d772b38d0976$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $2fc8d772b38d0976$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $2fc8d772b38d0976$var$MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $2fc8d772b38d0976$var$getUTCWeek(dirtyDate, options) {
    (0, $2fc8d772b38d0976$var$_index4.default)(1, arguments);
    var date = (0, $2fc8d772b38d0976$var$_index.default)(dirtyDate);
    var diff = (0, $2fc8d772b38d0976$var$_index2.default)(date, options).getTime() - (0, $2fc8d772b38d0976$var$_index3.default)(date, options).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $2fc8d772b38d0976$var$MILLISECONDS_IN_WEEK) + 1;
}
module.exports = module.exports.default;

});
parcelRegister("clhRK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8fc54dfcfb604fc4$var$startOfUTCWeek;

var $8fc54dfcfb604fc4$var$_index = $8fc54dfcfb604fc4$var$_interopRequireDefault((parcelRequire("aSksP")));

var $8fc54dfcfb604fc4$var$_index2 = $8fc54dfcfb604fc4$var$_interopRequireDefault((parcelRequire("2pWQP")));

var $8fc54dfcfb604fc4$var$_index3 = $8fc54dfcfb604fc4$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $8fc54dfcfb604fc4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $8fc54dfcfb604fc4$var$startOfUTCWeek(dirtyDate, dirtyOptions) {
    (0, $8fc54dfcfb604fc4$var$_index3.default)(1, arguments);
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, $8fc54dfcfb604fc4$var$_index.default)(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, $8fc54dfcfb604fc4$var$_index.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $8fc54dfcfb604fc4$var$_index2.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}
module.exports = module.exports.default;

});

parcelRegister("cbqvD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8deb134e55cb5294$var$startOfUTCWeekYear;

var $8deb134e55cb5294$var$_index = $8deb134e55cb5294$var$_interopRequireDefault((parcelRequire("aSksP")));

var $8deb134e55cb5294$var$_index2 = $8deb134e55cb5294$var$_interopRequireDefault((parcelRequire("3ihh3")));

var $8deb134e55cb5294$var$_index3 = $8deb134e55cb5294$var$_interopRequireDefault((parcelRequire("clhRK")));

var $8deb134e55cb5294$var$_index4 = $8deb134e55cb5294$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $8deb134e55cb5294$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $8deb134e55cb5294$var$startOfUTCWeekYear(dirtyDate, dirtyOptions) {
    (0, $8deb134e55cb5294$var$_index4.default)(1, arguments);
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $8deb134e55cb5294$var$_index.default)(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $8deb134e55cb5294$var$_index.default)(options.firstWeekContainsDate);
    var year = (0, $8deb134e55cb5294$var$_index2.default)(dirtyDate, dirtyOptions);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $8deb134e55cb5294$var$_index3.default)(firstWeek, dirtyOptions);
    return date;
}
module.exports = module.exports.default;

});
parcelRegister("3ihh3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $266073c9a73c0f7b$var$getUTCWeekYear;

var $266073c9a73c0f7b$var$_index = $266073c9a73c0f7b$var$_interopRequireDefault((parcelRequire("aSksP")));

var $266073c9a73c0f7b$var$_index2 = $266073c9a73c0f7b$var$_interopRequireDefault((parcelRequire("2pWQP")));

var $266073c9a73c0f7b$var$_index3 = $266073c9a73c0f7b$var$_interopRequireDefault((parcelRequire("clhRK")));

var $266073c9a73c0f7b$var$_index4 = $266073c9a73c0f7b$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $266073c9a73c0f7b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $266073c9a73c0f7b$var$getUTCWeekYear(dirtyDate, dirtyOptions) {
    (0, $266073c9a73c0f7b$var$_index4.default)(1, arguments);
    var date = (0, $266073c9a73c0f7b$var$_index2.default)(dirtyDate, dirtyOptions);
    var year = date.getUTCFullYear();
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $266073c9a73c0f7b$var$_index.default)(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $266073c9a73c0f7b$var$_index.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $266073c9a73c0f7b$var$_index3.default)(firstWeekOfNextYear, dirtyOptions);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $266073c9a73c0f7b$var$_index3.default)(firstWeekOfThisYear, dirtyOptions);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
module.exports = module.exports.default;

});




parcelRegister("awKAW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
function $7aa109506ceedd4b$var$dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
}
function $7aa109506ceedd4b$var$timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
}
function $7aa109506ceedd4b$var$dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/);
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $7aa109506ceedd4b$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', $7aa109506ceedd4b$var$dateLongFormatter(datePattern, formatLong)).replace('{{time}}', $7aa109506ceedd4b$var$timeLongFormatter(timePattern, formatLong));
}
var $7aa109506ceedd4b$var$longFormatters = {
    p: $7aa109506ceedd4b$var$timeLongFormatter,
    P: $7aa109506ceedd4b$var$dateTimeLongFormatter
};
var $7aa109506ceedd4b$var$_default = $7aa109506ceedd4b$var$longFormatters;
module.exports.default = $7aa109506ceedd4b$var$_default;
module.exports = module.exports.default;

});

parcelRegister("jGQTC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e55af8a2cb6edd32$var$getTimezoneOffsetInMilliseconds;
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $e55af8a2cb6edd32$var$getTimezoneOffsetInMilliseconds(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}
module.exports = module.exports.default;

});

parcelRegister("5qguX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isProtectedDayOfYearToken = $3f2c2dab40599caa$var$isProtectedDayOfYearToken;
module.exports.isProtectedWeekYearToken = $3f2c2dab40599caa$var$isProtectedWeekYearToken;
module.exports.throwProtectedError = $3f2c2dab40599caa$var$throwProtectedError;
var $3f2c2dab40599caa$var$protectedDayOfYearTokens = [
    'D',
    'DD'
];
var $3f2c2dab40599caa$var$protectedWeekYearTokens = [
    'YY',
    'YYYY'
];
function $3f2c2dab40599caa$var$isProtectedDayOfYearToken(token) {
    return $3f2c2dab40599caa$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $3f2c2dab40599caa$var$isProtectedWeekYearToken(token) {
    return $3f2c2dab40599caa$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $3f2c2dab40599caa$var$throwProtectedError(token, format, input) {
    if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
}

});


parcelRegister("fwSAz", function(module, exports) {

$parcel$export(module.exports, "default", () => $6cdf5ede1a400c9d$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ujWmd = parcelRequire("ujWmd");


var $2w1D3 = parcelRequire("2w1D3");

var $ggnNZ = parcelRequire("ggnNZ");
const $6cdf5ede1a400c9d$export$ebe0b8fe8b6acbfd = `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`;
const $6cdf5ede1a400c9d$export$72502e51aebdd94e = `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$export$7c87d337fb91a97d)})`;
function $6cdf5ede1a400c9d$export$2e2bcd8739ae039({ testId: testId, src: src, size: size = 'medium', ...props }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ujWmd.default), {
        appearance: (0, $ggnNZ.isSquareIcon)(src) ? 'square' : 'circle',
        ...props,
        size: size,
        src: src,
        testId: `${testId}-team-avatar`,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2w1D3.TeamAvatarImage), {
            src: src,
            size: size,
            testId: testId
        })
    });
}

});
var $829f609a65d26a98$exports = {};

$parcel$export($829f609a65d26a98$exports, "R50", () => $829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", () => $829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", () => $829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", () => $829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", () => $829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", () => $829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", () => $829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", () => $829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", () => $829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", () => $829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", () => $829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", () => $829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", () => $829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", () => $829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", () => $829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", () => $829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", () => $829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", () => $829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", () => $829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", () => $829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", () => $829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", () => $829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", () => $829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", () => $829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", () => $829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", () => $829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", () => $829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", () => $829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", () => $829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", () => $829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", () => $829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", () => $829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", () => $829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", () => $829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", () => $829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", () => $829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", () => $829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", () => $829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", () => $829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", () => $829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", () => $829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", () => $829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", () => $829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", () => $829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", () => $829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", () => $829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", () => $829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", () => $829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", () => $829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", () => $829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", () => $829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", () => $829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", () => $829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", () => $829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", () => $829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", () => $829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", () => $829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", () => $829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", () => $829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", () => $829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", () => $829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", () => $829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", () => $829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", () => $829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", () => $829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", () => $829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", () => $829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", () => $829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", () => $829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", () => $829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", () => $829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", () => $829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", () => $829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", () => $829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", () => $829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", () => $829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", () => $829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", () => $829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", () => $829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", () => $829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", () => $829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", () => $829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", () => $829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", () => $829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", () => $829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", () => $829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", () => $829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", () => $829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", () => $829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", () => $829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", () => $829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", () => $829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", () => $829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", () => $829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", () => $829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", () => $829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", () => $829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", () => $829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", () => $829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", () => $829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", () => $829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", () => $829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", () => $829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", () => $829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", () => $829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", () => $829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", () => $829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", () => $829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", () => $829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", () => $829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", () => $829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", () => $829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", () => $829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", () => $829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", () => $829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", () => $829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", () => $829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", () => $829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", () => $829f609a65d26a98$export$95e26d54def96891);
// Reds
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';

parcelRegister("2w1D3", function(module, exports) {

$parcel$export(module.exports, "TeamAvatarImage", () => $7d2527153712d181$export$ac3673635a5387be);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $vIiRg = parcelRequire("vIiRg");
var $cEPfF = parcelRequire("cEPfF");

var $fptva = parcelRequire("fptva");

var $h8cgU = parcelRequire("h8cgU");

var $VSDnB = parcelRequire("VSDnB");


var $4jyNe = parcelRequire("4jyNe");

var $3WiFt = parcelRequire("3WiFt");
function $7d2527153712d181$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7d2527153712d181$var$ICON_BACKGROUND = `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`;
const $7d2527153712d181$var$ICON_COLOR = `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$export$7c87d337fb91a97d)})`;
// used in a size calculation so can't be a token. Without this the avatar looks very squished
const $7d2527153712d181$var$ICON_PADDING = 4;
const $7d2527153712d181$var$avatarDefaultIconStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    backgroundColor: $7d2527153712d181$var$ICON_COLOR,
    borderRadius: '50%',
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center'
});
const $7d2527153712d181$var$SIZES = {
    xsmall: 16,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 96,
    xxlarge: 128
};
const $7d2527153712d181$var$nestedAvatarStyles = Object.entries((0, $vIiRg.AVATAR_SIZES)).reduce((styles, [key, size])=>{
    return {
        ...styles,
        [key]: /*#__PURE__*/ (0, $f8Sb3.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            width: `${size}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: `${size}px`,
            // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '& svg': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: `${size - $7d2527153712d181$var$ICON_PADDING}px`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: `${size - $7d2527153712d181$var$ICON_PADDING}px`
            }
        })
    };
}, {});
const $7d2527153712d181$var$avatarImageStyles = {
    name: "n68006",
    styles: "display:flex;flex:1 1 100%;width:100%;height:100%"
};
const $7d2527153712d181$export$9cfabd93718c0a2e = ({ alt: alt = '', src: src, size: size, testId: testId })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $5uXOq.useState)(false);
    // If src changes, reset state
    (0, $5uXOq.useEffect)(()=>{
        setHasImageErrored(false);
    }, [
        src
    ]);
    if (!src || hasImageErrored) {
        if ((0, $VSDnB.fg)('enable-team-avatar-switch')) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4jyNe.FallbackAvatar), {
            "aria-label": alt,
            width: $7d2527153712d181$var$SIZES[size],
            height: $7d2527153712d181$var$SIZES[size],
            "data-testid": testId
        });
        return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
            css: [
                $7d2527153712d181$var$avatarDefaultIconStyles,
                $7d2527153712d181$var$nestedAvatarStyles[size]
            ]
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fptva))), {
            label: alt,
            color: $7d2527153712d181$var$ICON_BACKGROUND,
            LEGACY_secondaryColor: $7d2527153712d181$var$ICON_COLOR,
            testId: testId && `${testId}--team`,
            spacing: "spacious",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($h8cgU)))
        }));
    }
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $cEPfF.AvatarContent), null, /*#__PURE__*/ (0, $f8Sb3.jsx)("img", {
        src: src,
        alt: alt,
        "data-testid": testId && `${testId}--image`,
        css: $7d2527153712d181$var$avatarImageStyles,
        onError: ()=>setHasImageErrored(true)
    }));
};
const $7d2527153712d181$export$ac3673635a5387be = (props)=>{
    if ((0, $VSDnB.fg)('team-avatar-radii')) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3WiFt.TeamAvatarImage), props);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($7d2527153712d181$export$9cfabd93718c0a2e, props);
};

});
parcelRegister("4jyNe", function(module, exports) {

$parcel$export(module.exports, "FallbackAvatar", () => $c800ab58c4d12cbb$export$eb63dcc490f6bbcd);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");
const $c800ab58c4d12cbb$var$styles = {
    wrapper: "_1e0c1txw _19pkv77o _2hwxv77o _otyrv77o _18u0v77o"
};
function $c800ab58c4d12cbb$export$eb63dcc490f6bbcd(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: $c800ab58c4d12cbb$var$styles.wrapper,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            ...props,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
                    clipPath: "url(#clip0_2032_552)",
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                            width: "32",
                            height: "32",
                            rx: "4",
                            fill: "#DCDFE4"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M10.6666 12.6666C11.7712 12.6666 12.6666 11.7712 12.6666 10.6666C12.6666 9.56206 11.7712 8.66663 10.6666 8.66663C9.56202 8.66663 8.66658 9.56206 8.66658 10.6666C8.66658 11.7712 9.56202 12.6666 10.6666 12.6666ZM10.6666 14.6666C12.8757 14.6666 14.6666 12.8758 14.6666 10.6666C14.6666 8.45749 12.8757 6.66663 10.6666 6.66663C8.45745 6.66663 6.66658 8.45749 6.66658 10.6666C6.66658 12.8758 8.45745 14.6666 10.6666 14.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M21.3333 12.6666C22.4378 12.6666 23.3333 11.7712 23.3333 10.6666C23.3333 9.56206 22.4378 8.66663 21.3333 8.66663C20.2287 8.66663 19.3333 9.56206 19.3333 10.6666C19.3333 11.7712 20.2287 12.6666 21.3333 12.6666ZM21.3333 14.6666C23.5424 14.6666 25.3333 12.8758 25.3333 10.6666C25.3333 8.45749 23.5424 6.66663 21.3333 6.66663C19.1241 6.66663 17.3333 8.45749 17.3333 10.6666C17.3333 12.8758 19.1241 14.6666 21.3333 14.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            d: "M21.6666 16C24.4273 16.0004 26.6666 18.2385 26.6666 21V22.6666C26.6666 24.1394 25.4727 25.3333 23.9999 25.3333H20.135C18.0324 25.3333 16.1545 24.018 15.436 22.042L14.6843 19.9747C14.2531 18.7892 13.1264 18 11.8649 18H10.3333C8.6764 18 7.33325 19.3431 7.33325 21V22.6666C7.33325 23.0348 7.63173 23.3333 7.99992 23.3333H13.3333V25.3333H7.99992C6.52716 25.3333 5.33325 24.1394 5.33325 22.6666V21C5.33325 18.2385 7.57183 16 10.3333 16H11.8649C13.9674 16 15.8453 17.3153 16.5638 19.2913L17.3156 21.3585C17.7467 22.5441 18.8734 23.3333 20.135 23.3333H23.9999C24.3681 23.3333 24.6666 23.0348 24.6666 22.6666V21C24.6666 19.3437 23.3233 18.0004 21.6666 18H20.135V16H21.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            d: "M20.135 16C19.5972 16 18.7183 16.1407 18.0518 16.4564L18.908 18.2639C19.064 18.19 19.288 18.1205 19.537 18.0703C19.785 18.0203 20.0045 18 20.135 18V16Z",
                            fill: "#44546F"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("defs", {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("clipPath", {
                        id: "clip0_2032_552",
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                            width: "32",
                            height: "32",
                            rx: "4",
                            fill: "white"
                        })
                    })
                })
            ]
        })
    });
}

});

parcelRegister("3WiFt", function(module, exports) {

$parcel$export(module.exports, "TeamAvatarImage", () => $ed1385df3f8966b5$export$ac3673635a5387be);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $a9yTd = parcelRequire("a9yTd");
const $ed1385df3f8966b5$var$boxShadowCssVar = '--avatar-box-shadow';
const $ed1385df3f8966b5$var$bgColorCssVar = '--avatar-bg-color';
/**
 * We need to maintan the container styles manually until Avatar provides the correct border radius.
 * After that we can return to wrapping in <AvatarContent> rather than span
 */ const $ed1385df3f8966b5$var$containerStyles = {
    root: "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _v564ieh6 _1e0c1txw _kqswpfqs _4cvr1fhb _1bah1h6o _2lx21bp4 _80om1kw7 _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _t9ec1aqe _9v7aze3t _qc5o1p41 _z0ai1osq _18postnw _1hfk18uv _aetrf705 _1peqidpf _11fnglyw",
    circle: "_2rko1q5u _14mj1q5u",
    positionRelative: "_kqswh2mm",
    disabled: "_80om13gf _1hfkvuon _1peqs237"
};
const $ed1385df3f8966b5$var$unboundStyles = {
    root: "_vchh18uv _bfhkcxp3 _16qs1nhn",
    interactive: "_80omtlke _4tpuw83z _ez1ykb7n _gcm11et6 _eeh8kb7n _jlxit94y"
};
const $ed1385df3f8966b5$var$avatarImageStyles = {
    image: "_16jlkb7n _1o9zkb7n _i0dl1osq _1e0c1txw _1bsb1osq _4t3i1osq"
};
const $ed1385df3f8966b5$var$SIZES = {
    xsmall: 16,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 96,
    xxlarge: 128
};
const $ed1385df3f8966b5$var$borderRadiusMap = {
    xsmall: "_2rko1y44",
    small: "_2rkoi2wt",
    medium: "_2rkoftgi",
    large: "_2rko19bv",
    xlarge: "_2rko1tcg",
    xxlarge: "_2rkozwfg"
};
const $ed1385df3f8966b5$var$widthHeightMap = {
    xsmall: "_1bsb7vkz _4t3i7vkz",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
const $ed1385df3f8966b5$export$ac3673635a5387be = ({ alt: alt = '', src: src, size: size, testId: testId })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $5uXOq.useState)(false);
    // If src changes, reset state
    (0, $5uXOq.useEffect)(()=>{
        setHasImageErrored(false);
    }, [
        src
    ]);
    if (!src || hasImageErrored) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $a9yTd.FallbackAvatar), {
        "aria-label": alt,
        width: $ed1385df3f8966b5$var$SIZES[size],
        height: $ed1385df3f8966b5$var$SIZES[size],
        "data-testid": testId
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": testId,
        "aria-label": alt,
        className: (0, $bwpsq.default)([
            $ed1385df3f8966b5$var$unboundStyles.root,
            $ed1385df3f8966b5$var$containerStyles.root,
            $ed1385df3f8966b5$var$borderRadiusMap[size],
            $ed1385df3f8966b5$var$widthHeightMap[size]
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
            src: src,
            alt: alt,
            "data-testId": testId && `${testId}--image`,
            onError: ()=>setHasImageErrored(true),
            className: (0, $bwpsq.default)([
                $ed1385df3f8966b5$var$avatarImageStyles.image
            ])
        })
    });
};

});
parcelRegister("a9yTd", function(module, exports) {

$parcel$export(module.exports, "FallbackAvatar", () => $dc76f912cc56de65$export$eb63dcc490f6bbcd);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");
const $dc76f912cc56de65$var$styles = {
    wrapper: "_1e0c1txw _19pkv77o _2hwxv77o _otyrv77o _18u0v77o"
};
function $dc76f912cc56de65$export$eb63dcc490f6bbcd(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: $dc76f912cc56de65$var$styles.wrapper,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            ...props,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
                    clipPath: "url(#clip0_2032_552)",
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                            width: "32",
                            height: "32",
                            rx: "4",
                            fill: "#DCDFE4"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M10.6666 12.6666C11.7712 12.6666 12.6666 11.7712 12.6666 10.6666C12.6666 9.56206 11.7712 8.66663 10.6666 8.66663C9.56202 8.66663 8.66658 9.56206 8.66658 10.6666C8.66658 11.7712 9.56202 12.6666 10.6666 12.6666ZM10.6666 14.6666C12.8757 14.6666 14.6666 12.8758 14.6666 10.6666C14.6666 8.45749 12.8757 6.66663 10.6666 6.66663C8.45745 6.66663 6.66658 8.45749 6.66658 10.6666C6.66658 12.8758 8.45745 14.6666 10.6666 14.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M21.3333 12.6666C22.4378 12.6666 23.3333 11.7712 23.3333 10.6666C23.3333 9.56206 22.4378 8.66663 21.3333 8.66663C20.2287 8.66663 19.3333 9.56206 19.3333 10.6666C19.3333 11.7712 20.2287 12.6666 21.3333 12.6666ZM21.3333 14.6666C23.5424 14.6666 25.3333 12.8758 25.3333 10.6666C25.3333 8.45749 23.5424 6.66663 21.3333 6.66663C19.1241 6.66663 17.3333 8.45749 17.3333 10.6666C17.3333 12.8758 19.1241 14.6666 21.3333 14.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            d: "M21.6666 16C24.4273 16.0004 26.6666 18.2385 26.6666 21V22.6666C26.6666 24.1394 25.4727 25.3333 23.9999 25.3333H20.135C18.0324 25.3333 16.1545 24.018 15.436 22.042L14.6843 19.9747C14.2531 18.7892 13.1264 18 11.8649 18H10.3333C8.6764 18 7.33325 19.3431 7.33325 21V22.6666C7.33325 23.0348 7.63173 23.3333 7.99992 23.3333H13.3333V25.3333H7.99992C6.52716 25.3333 5.33325 24.1394 5.33325 22.6666V21C5.33325 18.2385 7.57183 16 10.3333 16H11.8649C13.9674 16 15.8453 17.3153 16.5638 19.2913L17.3156 21.3585C17.7467 22.5441 18.8734 23.3333 20.135 23.3333H23.9999C24.3681 23.3333 24.6666 23.0348 24.6666 22.6666V21C24.6666 19.3437 23.3233 18.0004 21.6666 18H20.135V16H21.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            d: "M20.135 16C19.5972 16 18.7183 16.1407 18.0518 16.4564L18.908 18.2639C19.064 18.19 19.288 18.1205 19.537 18.0703C19.785 18.0203 20.0045 18 20.135 18V16Z",
                            fill: "#44546F"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("defs", {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("clipPath", {
                        id: "clip0_2032_552",
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                            width: "32",
                            height: "32",
                            rx: "4",
                            fill: "white"
                        })
                    })
                })
            ]
        })
    });
}

});



parcelRegister("ggnNZ", function(module, exports) {

$parcel$export(module.exports, "isSquareIcon", () => $cf7e4fad001aa258$export$d5a05ffb65695bc0);

var $VSDnB = parcelRequire("VSDnB");
function $cf7e4fad001aa258$export$d5a05ffb65695bc0(src) {
    if (!src) return false;
    try {
        const url = new URL(src);
        const host = url.host;
        const path = url.pathname;
        if ((host.startsWith('ptc-directory-sited-static') || host.startsWith('teams-directory-frontend')) && path.includes('teams/avatars/v4') && (0, $VSDnB.fg)('enable-team-avatar-switch')) return true;
    } catch  {
    // The src wasn't a URL, so it's obviously not the refreshed avatar.
    }
    return false;
}

});


parcelRegister("kc9vJ", function(module, exports) {

$parcel$export(module.exports, "lazyForPaint", () => (parcelRequire("8DfXF")).lazyForPaint);
$parcel$export(module.exports, "lazyAfterPaint", () => (parcelRequire("8DfXF")).lazyAfterPaint);
$parcel$export(module.exports, "lazy", () => (parcelRequire("8DfXF")).lazy);
$parcel$export(module.exports, "LazySuspense", () => (parcelRequire("ihijj")).LazySuspense);
$parcel$export(module.exports, "useLazyPhase", () => (parcelRequire("7j6wR")).useLazyPhase);
parcelRequire("9tT5O");
var $0431B = parcelRequire("0431B");

var $bh45B = parcelRequire("bh45B");

var $8DfXF = parcelRequire("8DfXF");
parcelRequire("3iU61");
var $8gCAq = parcelRequire("8gCAq");
var $hxt6y = parcelRequire("hxt6y");
parcelRequire("41yqT");
var $ihijj = parcelRequire("ihijj");
parcelRequire("1Cn7k");
var $7j6wR = parcelRequire("7j6wR");

var $lUR7e = parcelRequire("lUR7e");

});
parcelRegister("9tT5O", function(module, exports) {

$parcel$export(module.exports, "getConfig", () => $6e718ebf0a3d5ffc$export$44487a86467333c3);
$parcel$export(module.exports, "setConfig", () => $6e718ebf0a3d5ffc$export$940a7873bb071df8);
$parcel$export(module.exports, "MODE", () => (parcelRequire("0431B")).MODE);

var $0431B = parcelRequire("0431B");
const $6e718ebf0a3d5ffc$var$DEFAULT_CROSS_ORIGIN = undefined;
const $6e718ebf0a3d5ffc$var$DEFAULT_MANIFEST = {
    publicPath: '/',
    assets: {}
};
const $6e718ebf0a3d5ffc$var$DEFAULT_MODE = (0, $0431B.MODE).HYDRATE;
const $6e718ebf0a3d5ffc$var$DEFAULT_RETRY = 2;
const $6e718ebf0a3d5ffc$var$config = {
    crossOrigin: $6e718ebf0a3d5ffc$var$DEFAULT_CROSS_ORIGIN,
    manifest: $6e718ebf0a3d5ffc$var$DEFAULT_MANIFEST,
    mode: $6e718ebf0a3d5ffc$var$DEFAULT_MODE,
    retry: $6e718ebf0a3d5ffc$var$DEFAULT_RETRY
};
const $6e718ebf0a3d5ffc$export$44487a86467333c3 = ()=>$6e718ebf0a3d5ffc$var$config;
const $6e718ebf0a3d5ffc$export$940a7873bb071df8 = (nextConfig)=>{
    var _nextConfig$crossOrig, _nextConfig$manifest, _nextConfig$mode, _nextConfig$retry;
    $6e718ebf0a3d5ffc$var$config.crossOrigin = (_nextConfig$crossOrig = nextConfig.crossOrigin) != null ? _nextConfig$crossOrig : $6e718ebf0a3d5ffc$var$DEFAULT_CROSS_ORIGIN;
    $6e718ebf0a3d5ffc$var$config.manifest = (_nextConfig$manifest = nextConfig.manifest) != null ? _nextConfig$manifest : $6e718ebf0a3d5ffc$var$DEFAULT_MANIFEST;
    $6e718ebf0a3d5ffc$var$config.mode = (_nextConfig$mode = nextConfig.mode) != null ? _nextConfig$mode : $6e718ebf0a3d5ffc$var$DEFAULT_MODE;
    $6e718ebf0a3d5ffc$var$config.retry = (_nextConfig$retry = nextConfig.retry) != null ? _nextConfig$retry : $6e718ebf0a3d5ffc$var$DEFAULT_RETRY;
};

});
parcelRegister("0431B", function(module, exports) {

$parcel$export(module.exports, "MODE", () => $00c2b881b8fbcee5$export$e48589d9e4824227);
const $00c2b881b8fbcee5$export$e48589d9e4824227 = {
    RENDER: 'RENDER',
    HYDRATE: 'HYDRATE'
};

});


parcelRegister("bh45B", function(module, exports) {

var $PZ2tE = parcelRequire("PZ2tE");

var $9tT5O = parcelRequire("9tT5O");
parcelRequire("1Cn7k");
var $7BvXL = parcelRequire("7BvXL");
var $7j6wR = parcelRequire("7j6wR");

var $fEDkH = parcelRequire("fEDkH");
const $83547451e376d6d0$export$33c5f161e1d4706 = {
    init: (config)=>{
        (0, $9tT5O.setConfig)(config);
        (0, $7BvXL.LISTENERS).length = 0;
        (0, $7j6wR.setCurrent)(0);
        if (!(0, $fEDkH.isNodeEnvironment)()) (0, $PZ2tE.collect)();
    }
};

});
parcelRegister("PZ2tE", function(module, exports) {

$parcel$export(module.exports, "collect", () => $09c41c99821e965e$export$bb44f104e3c54dae);

var $9tT5O = parcelRequire("9tT5O");
var $0431B = parcelRequire("0431B");

var $gRvGe = parcelRequire("gRvGe");

var $cIwb8 = parcelRequire("cIwb8");

var $916oJ = parcelRequire("916oJ");
const $09c41c99821e965e$export$bb44f104e3c54dae = ()=>{
    const markers = document.querySelectorAll('input[data-lazy-begin]');
    const { mode: mode } = (0, $9tT5O.getConfig)();
    for(let i = 0, j = markers.length; i < j; i += 1){
        const el = markers[i];
        const { lazyBegin: lazyBegin } = el.dataset || {};
        const value = mode === (0, $0431B.MODE).RENDER ? (0, $cIwb8.cloneElements)(markers[i], lazyBegin) : (0, $916oJ.refElements)(markers[i], lazyBegin);
        if ((0, $gRvGe.COLLECTED).has(lazyBegin)) (0, $gRvGe.COLLECTED).get(lazyBegin).push(value);
        else (0, $gRvGe.COLLECTED).set(lazyBegin, [
            value
        ]);
    }
};

});
parcelRegister("gRvGe", function(module, exports) {

$parcel$export(module.exports, "PHASE", () => $c46a2b9a383e79ee$export$2cc7a2eaaea7809f);
$parcel$export(module.exports, "COLLECTED", () => $c46a2b9a383e79ee$export$4831ef3968ea94ef);
const $c46a2b9a383e79ee$export$2cc7a2eaaea7809f = {
    PAINT: 0,
    AFTER_PAINT: 1,
    LAZY: 2
};
const $c46a2b9a383e79ee$export$4831ef3968ea94ef = new Map();

});

parcelRegister("cIwb8", function(module, exports) {

$parcel$export(module.exports, "cloneElements", () => $94228e13ffd964de$export$c42217d53a7ebafb);
const $94228e13ffd964de$export$c42217d53a7ebafb = (fromEl, id)=>{
    const fragment = document.createElement('div');
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break; // cloneNode is 50% faster than outerHTML/textContent
        fragment.appendChild(el.cloneNode(true));
    }
    return Array.from(fragment.childNodes);
};

});

parcelRegister("916oJ", function(module, exports) {

$parcel$export(module.exports, "refElements", () => $69092b84bd4d8839$export$c69443129766a7fc);
const $69092b84bd4d8839$export$c69443129766a7fc = (fromEl, id)=>{
    const result = [];
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break;
        result.push(el);
    }
    return result;
};

});


parcelRegister("1Cn7k", function(module, exports) {

$parcel$export(module.exports, "LazyPhaseContext", () => (parcelRequire("7j6wR")).LazyPhaseContext);
$parcel$export(module.exports, "setCurrent", () => (parcelRequire("7j6wR")).setCurrent);
$parcel$export(module.exports, "useLazyPhase", () => (parcelRequire("7j6wR")).useLazyPhase);
$parcel$export(module.exports, "LISTENERS", () => (parcelRequire("7BvXL")).LISTENERS);

var $7j6wR = parcelRequire("7j6wR");

var $7BvXL = parcelRequire("7BvXL");

var $hLAzE = parcelRequire("hLAzE");

});
parcelRegister("7j6wR", function(module, exports) {

$parcel$export(module.exports, "setCurrent", () => $551f5f4ab1e13682$export$5f80f094fd31fffd);
$parcel$export(module.exports, "LazyPhaseContext", () => $551f5f4ab1e13682$export$5a25eca35e5debcb);
$parcel$export(module.exports, "useLazyPhase", () => $551f5f4ab1e13682$export$1dc361b277327f88);

var $5uXOq = parcelRequire("5uXOq");

var $gRvGe = parcelRequire("gRvGe");

var $7BvXL = parcelRequire("7BvXL");

var $hLAzE = parcelRequire("hLAzE");
let $551f5f4ab1e13682$var$CURRENT_PHASE = (0, $gRvGe.PHASE).PAINT;
const $551f5f4ab1e13682$export$5f80f094fd31fffd = (phase)=>{
    $551f5f4ab1e13682$var$CURRENT_PHASE = phase;
    (0, $7BvXL.LISTENERS).slice(0).forEach((listener)=>listener(phase));
};
const $551f5f4ab1e13682$export$5a25eca35e5debcb = /*#__PURE__*/ (0, $5uXOq.createContext)({
    subscribe: (0, $hLAzE.createSubscribe)((0, $7BvXL.LISTENERS)),
    currentValue: ()=>$551f5f4ab1e13682$var$CURRENT_PHASE,
    api: {
        startNextPhase: ()=>{
            $551f5f4ab1e13682$export$5f80f094fd31fffd((0, $gRvGe.PHASE).AFTER_PAINT);
        },
        resetPhase: ()=>$551f5f4ab1e13682$export$5f80f094fd31fffd((0, $gRvGe.PHASE).PAINT)
    }
});
const $551f5f4ab1e13682$export$1dc361b277327f88 = ()=>{
    const v = (0, $5uXOq.useContext)($551f5f4ab1e13682$export$5a25eca35e5debcb);
    return v.api;
};

});
parcelRegister("7BvXL", function(module, exports) {

$parcel$export(module.exports, "LISTENERS", () => $5894c846af183bf2$export$81b9c458a026d68f);
const $5894c846af183bf2$export$81b9c458a026d68f = [];

});

parcelRegister("hLAzE", function(module, exports) {

$parcel$export(module.exports, "createSubscribe", () => $cef3324da336be99$export$364097d812234b3f);
const $cef3324da336be99$export$364097d812234b3f = (listeners)=>(listener)=>{
        listeners.push(listener);
        return ()=>{
            const index = listeners.indexOf(listener);
            if (index !== -1) listeners.splice(index, 1);
        };
    };

});



parcelRegister("fEDkH", function(module, exports) {

$parcel$export(module.exports, "getExport", () => $b6591a2169faf79a$export$d4c07b1daf44a7f);
$parcel$export(module.exports, "displayNameFromId", () => $b6591a2169faf79a$export$4429f98ef60d2d87);
$parcel$export(module.exports, "isNodeEnvironment", () => $b6591a2169faf79a$export$283635c04a02cc36);
$parcel$export(module.exports, "attrToProp", () => $b6591a2169faf79a$export$62bf630d0de3d781);
$parcel$export(module.exports, "hash", () => (parcelRequire("i0Mqq")).default);

var $i0Mqq = parcelRequire("i0Mqq");
const $b6591a2169faf79a$export$d4c07b1daf44a7f = (m)=>'default' in m ? m.default : m;
const $b6591a2169faf79a$export$4429f98ef60d2d87 = (id)=>{
    const fName = id.split('/').slice(-3).join('/');
    return fName || 'Component';
};
const $b6591a2169faf79a$export$283635c04a02cc36 = ()=>{
    if (typeof window === 'undefined') return true;
    if (window.name === 'nodejs') return true;
    return false;
};
function $b6591a2169faf79a$export$62bf630d0de3d781(props, attr) {
    switch(attr.name){
        case 'style':
            break;
        case 'class':
            props.className = attr.value;
            break;
        case 'crossorigin':
            props.crossOrigin = attr.value;
            break;
        default:
            props[attr.name] = attr.value;
    }
    return props;
}

});
parcelRegister("i0Mqq", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1cdca4fd0ee8fb9$export$2e2bcd8739ae039);
/* eslint-disable */ // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $d1cdca4fd0ee8fb9$export$2e2bcd8739ae039(str) {
    var l = str.length, h = l ^ l, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
}

});



parcelRegister("8DfXF", function(module, exports) {

$parcel$export(module.exports, "lazyForPaint", () => $648e58dc5a799d99$export$c952e5f94576010e);
$parcel$export(module.exports, "lazyAfterPaint", () => $648e58dc5a799d99$export$291dd592399bdafa);
$parcel$export(module.exports, "lazy", () => $648e58dc5a799d99$export$488013bae63b21da);

var $3aJOa = parcelRequire("3aJOa");

var $9tT5O = parcelRequire("9tT5O");

var $gRvGe = parcelRequire("gRvGe");

var $fEDkH = parcelRequire("fEDkH");
var $i0Mqq = parcelRequire("i0Mqq");

var $9Ww7D = parcelRequire("9Ww7D");

var $eqm16 = parcelRequire("eqm16");

var $3ro9P = parcelRequire("3ro9P");

var $5pJCH = parcelRequire("5pJCH");

var $2LsHW = parcelRequire("2LsHW");

var $gNYzn = parcelRequire("gNYzn");

var $gI8wo = parcelRequire("gI8wo");
function $648e58dc5a799d99$var$_extends() {
    $648e58dc5a799d99$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $648e58dc5a799d99$var$_extends.apply(this, arguments);
}
function $648e58dc5a799d99$var$lazyProxy(_loader, { defer: defer = (0, $gRvGe.PHASE).PAINT, moduleId: moduleId = '', ssr: ssr = true } = {}) {
    const isServer = (0, $fEDkH.isNodeEnvironment)();
    const dataLazyId = (0, $i0Mqq.default)(moduleId);
    const LazyInternal = isServer ? (0, $3ro9P.createComponentServer)({
        dataLazyId: dataLazyId,
        defer: defer,
        loader: _loader,
        moduleId: moduleId,
        ssr: ssr
    }) : (0, $eqm16.createComponentClient)({
        dataLazyId: dataLazyId,
        defer: defer,
        // We separate the preload from the retryable request, as we do not want the preload to contribute to retry
        // attempts, when the the loader fallback is used
        deferred: (0, $5pJCH.createDeferred)({
            loader: ()=>{
                const { retry: maxAttempts } = (0, $9tT5O.getConfig)();
                return (0, $gNYzn.retry)(_loader, {
                    delay: (0, $9Ww7D.RETRY_DELAY),
                    factor: (0, $9Ww7D.RETRY_FACTOR),
                    maxAttempts: maxAttempts
                });
            },
            preload: _loader
        }),
        moduleId: moduleId
    });
    LazyInternal.displayName = `Lazy(${(0, $fEDkH.displayNameFromId)(moduleId)})`;
    /**
   * Allows getting module chunks urls
   */ const getAssetUrls = ()=>{
        const { manifest: manifest } = (0, $9tT5O.getConfig)();
        return (0, $3aJOa.getAssetUrlsFromId)(manifest, moduleId);
    };
    /**
   * Allows imperatively preload/ prefetch the module chunk asset
   */ const preload = (priority)=>{
        const p = priority != null ? priority : defer === (0, $gRvGe.PHASE).PAINT ? (0, $9Ww7D.PRIORITY).HIGH : (0, $9Ww7D.PRIORITY).LOW;
        return (0, $2LsHW.preloadAsset)({
            loader: _loader,
            moduleId: moduleId,
            priority: p
        });
    };
    return Object.assign(LazyInternal, {
        getAssetUrls: getAssetUrls,
        preload: preload
    });
}
const $648e58dc5a799d99$export$93ca5d3f8675ae4c = {
    lazyForPaint: {
        ssr: true,
        defer: (0, $gRvGe.PHASE).PAINT
    },
    lazyAfterPaint: {
        ssr: true,
        defer: (0, $gRvGe.PHASE).AFTER_PAINT
    },
    lazy: {
        ssr: false,
        defer: (0, $gRvGe.PHASE).LAZY
    }
};
function $648e58dc5a799d99$export$c952e5f94576010e(loader, opts) {
    return $648e58dc5a799d99$var$lazyProxy(loader, $648e58dc5a799d99$var$_extends({}, $648e58dc5a799d99$export$93ca5d3f8675ae4c.lazyForPaint, opts || {}));
}
function $648e58dc5a799d99$export$291dd592399bdafa(loader, opts) {
    return $648e58dc5a799d99$var$lazyProxy(loader, $648e58dc5a799d99$var$_extends({}, $648e58dc5a799d99$export$93ca5d3f8675ae4c.lazyAfterPaint, opts || {}));
}
function $648e58dc5a799d99$export$488013bae63b21da(loader, opts) {
    return $648e58dc5a799d99$var$lazyProxy(loader, $648e58dc5a799d99$var$_extends({}, $648e58dc5a799d99$export$93ca5d3f8675ae4c.lazy, opts || {}));
}

});
parcelRegister("3aJOa", function(module, exports) {

$parcel$export(module.exports, "getAssetUrlsFromId", () => $24f5d6cbe7374307$export$303f43e55cf1ef2f);
const $24f5d6cbe7374307$export$303f43e55cf1ef2f = (manifest, id)=>{
    if (!manifest.assets || !manifest.assets[id]) return;
    return manifest.assets[id].map((asset)=>`${manifest.publicPath}${asset}`);
};

});

parcelRegister("9Ww7D", function(module, exports) {

$parcel$export(module.exports, "PRIORITY", () => $73d2729ff937408e$export$bb34f3538ba26c7e);
$parcel$export(module.exports, "RETRY_DELAY", () => $73d2729ff937408e$export$a339266ad71b2447);
$parcel$export(module.exports, "RETRY_FACTOR", () => $73d2729ff937408e$export$ba64c908e55507fe);
const $73d2729ff937408e$export$bb34f3538ba26c7e = {
    HIGH: 0,
    LOW: 2
};
const $73d2729ff937408e$export$a339266ad71b2447 = 300;
const $73d2729ff937408e$export$ba64c908e55507fe = 1;

});

parcelRegister("eqm16", function(module, exports) {

$parcel$export(module.exports, "createComponentClient", () => $a804927df56ebdb2$export$6898b5504b58699a);

var $5uXOq = parcelRequire("5uXOq");

var $9tT5O = parcelRequire("9tT5O");
var $0431B = parcelRequire("0431B");

var $gRvGe = parcelRequire("gRvGe");
parcelRequire("3iU61");
var $hxt6y = parcelRequire("hxt6y");
parcelRequire("1Cn7k");
var $7j6wR = parcelRequire("7j6wR");
parcelRequire("41yqT");
var $7t9v5 = parcelRequire("7t9v5");

var $gI8wo = parcelRequire("gI8wo");

var $b1mtW = parcelRequire("b1mtW");

var $2uJW6 = parcelRequire("2uJW6");

var $lUR7e = parcelRequire("lUR7e");

var $k8XtJ = parcelRequire("k8XtJ");
function $a804927df56ebdb2$export$6898b5504b58699a({ defer: defer, deferred: deferred, dataLazyId: dataLazyId, moduleId: moduleId }) {
    const ResolvedLazy = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>deferred.promise);
    return (props)=>{
        // use a single piece of state to hold info about progress or eventually
        // throw an error. We do change it via direct mutation as re-renders
        // break Suspense in React 18, making it lose hydration state
        const [status, bubbleError] = (0, $5uXOq.useState)(()=>({
                noWait: undefined,
                phase: defer === (0, $gRvGe.PHASE).AFTER_PAINT ? false : true,
                preloaded: defer === (0, $gRvGe.PHASE).AFTER_PAINT ? false : true,
                started: false
            }));
        const profiler = (0, $5uXOq.useContext)((0, $lUR7e.ProfilerContext)).current;
        const load = ()=>{
            if (status.started || !status.phase || !status.noWait) return;
            status.started = true;
            let onResolve;
            if (profiler) {
                const eventInfo = {
                    identifier: moduleId
                };
                onResolve = ()=>{
                    profiler.onLoadComplete(eventInfo);
                };
                profiler.onLoadStart(eventInfo);
            }
            const result = deferred.start().catch((err)=>{
                // Throw the error within the component lifecycle
                // refer to https://github.com/facebook/react/issues/11409
                bubbleError(()=>{
                    throw (0, $gI8wo.createLoaderError)(err);
                });
            });
            if (onResolve) result.then(onResolve);
        }; // Subscribe to LazyWait context, triggering load when until is true
        (0, $k8XtJ.useSubscription)({
            context: (0, $hxt6y.WaitContext),
            load: load,
            onValue: (v)=>status.noWait = v === 1
        });
        if (defer === (0, $gRvGe.PHASE).AFTER_PAINT) // Subscribe to LazyPhase context, triggering load when own phase starts
        (0, $k8XtJ.useSubscription)({
            context: (0, $7j6wR.LazyPhaseContext),
            load: load,
            onValue: (v)=>status.phase = v >= defer
        });
        const { setFallback: setFallback } = (0, $5uXOq.useContext)((0, $7t9v5.LazySuspenseContext));
        (0, $5uXOq.useMemo)(()=>{
            // find SSR content (or fallbacks) wrapped in inputs based on lazyId
            const content = ((0, $gRvGe.COLLECTED).get(dataLazyId) || []).shift();
            if (!content) return; // override Suspense fallback with magic input wrappers
            const component = (0, $9tT5O.getConfig)().mode === (0, $0431B.MODE).RENDER ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b1mtW.PlaceholderFallbackRender), {
                id: dataLazyId,
                content: content
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2uJW6.PlaceholderFallbackHydrate), {
                id: dataLazyId,
                content: content
            });
            setFallback(component);
        }, [
            setFallback
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ResolvedLazy, props);
    };
}

});
parcelRegister("3iU61", function(module, exports) {

$parcel$export(module.exports, "WaitContext", () => (parcelRequire("hxt6y")).WaitContext);

var $hxt6y = parcelRequire("hxt6y");

var $8gCAq = parcelRequire("8gCAq");

});
parcelRegister("hxt6y", function(module, exports) {

$parcel$export(module.exports, "WaitContext", () => $cc4c1850a13fcdaa$export$9ba3fe09d15de47b);

var $5uXOq = parcelRequire("5uXOq");

var $3Sq3c = parcelRequire("3Sq3c");
const $cc4c1850a13fcdaa$export$9ba3fe09d15de47b = /*#__PURE__*/ (0, $5uXOq.createContext)({
    subscribe: ()=>(0, $3Sq3c.noopCleanup),
    currentValue: ()=>1
});

});
parcelRegister("3Sq3c", function(module, exports) {

$parcel$export(module.exports, "noopCleanup", () => $2d2a9f5ddab5681f$export$276c7dbda7675aec);
const $2d2a9f5ddab5681f$export$276c7dbda7675aec = ()=>{};

});


parcelRegister("8gCAq", function(module, exports) {

var $5uXOq = parcelRequire("5uXOq");

var $hxt6y = parcelRequire("hxt6y");
const $604dbfd3e71469c9$export$7bf6cf03fd32cddb = ({ until: until, children: children })=>{
    const closestWait = (0, $5uXOq.useContext)((0, $hxt6y.WaitContext));
    const value = (0, $5uXOq.useRef)(until && closestWait.currentValue() ? 1 : 0);
    const subscribers = (0, $5uXOq.useRef)(new Set());
    const api = (0, $5uXOq.useRef)({
        subscribe: (subscriber)=>{
            subscribers.current.add(subscriber);
            return ()=>{
                subscribers.current.delete(subscriber);
            };
        },
        currentValue: ()=>value.current
    });
    (0, $5uXOq.useEffect)(()=>{
        // Notify subscribers when until prop or closest until value changes
        const notify = ()=>{
            value.current = closestWait.currentValue() && until ? 1 : 0;
            subscribers.current.forEach((subscriber)=>subscriber());
        };
        notify();
        return closestWait.subscribe(notify);
    }, [
        closestWait,
        until
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hxt6y.WaitContext).Provider, {
        value: api.current
    }, children);
};

});


parcelRegister("41yqT", function(module, exports) {

$parcel$export(module.exports, "LazySuspense", () => (parcelRequire("ihijj")).LazySuspense);
$parcel$export(module.exports, "LazySuspenseContext", () => (parcelRequire("7t9v5")).LazySuspenseContext);

var $ihijj = parcelRequire("ihijj");

var $7t9v5 = parcelRequire("7t9v5");

});
parcelRegister("ihijj", function(module, exports) {

$parcel$export(module.exports, "LazySuspense", () => $d4e8049b2be3a01c$export$256c542058532d6f);

var $5uXOq = parcelRequire("5uXOq");

var $fEDkH = parcelRequire("fEDkH");

var $7t9v5 = parcelRequire("7t9v5");
class $d4e8049b2be3a01c$export$256c542058532d6f extends (0, $5uXOq.Component) {
    constructor(props){
        super(props);
        this.state = {
            // Used on server to render fallback down the tree
            fallback: this.props.fallback,
            // Used on client to replace fallback with magic input
            setFallback: (fallback)=>{
                if (this.hydrationFallback === fallback) return;
                this.hydrationFallback = fallback; // Schedule an update so we force switch from the sibling tree
                // back to the suspense boundary
                if (this.mounted) this.forceUpdate();
            },
            name: this.props.name
        };
        this.hydrationFallback = null;
        this.mounted = false;
        this.DynamicFallback = ({ children: children, outsideSuspense: outsideSuspense })=>{
            // eslint-disable-next-line react-hooks/rules-of-hooks
            (0, $5uXOq.useLayoutEffect)(()=>{
                return ()=>{
                    // the effect cleanup is called by the Suspense boundary itself
                    // when both Lazy AND the eventual promises thrown are done
                    // so Suspense will re-render with actual content and we remove
                    // the hydration fallback at the same time
                    if (!outsideSuspense) this.state.setFallback(null);
                };
            }, [
                outsideSuspense
            ]);
            return outsideSuspense ? children(this.hydrationFallback ? this.hydrationFallback : null) : children(this.hydrationFallback ? null : this.props.fallback);
        };
        this.DynamicFallback.displayName = 'DynamicFallback';
    }
    componentDidMount() {
        this.mounted = true;
    }
    renderFallback(outsideSuspense) {
        const { DynamicFallback: DynamicFallback } = this; // Use render prop component to allow switch to hydration fallback
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(DynamicFallback, {
            outsideSuspense: outsideSuspense
        }, (fallback)=>fallback);
    }
    renderServer() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7t9v5.LazySuspenseContext).Provider, {
            value: this.state
        }, this.props.children);
    }
    renderClient() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7t9v5.LazySuspenseContext).Provider, {
            value: this.state
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
            fallback: this.renderFallback(false)
        }, this.props.children), (!this.mounted || this.hydrationFallback) && this.renderFallback(true));
    }
    render() {
        return (0, $fEDkH.isNodeEnvironment)() ? this.renderServer() : this.renderClient();
    }
}

});
parcelRegister("7t9v5", function(module, exports) {

$parcel$export(module.exports, "LazySuspenseContext", () => $57029c6f61e78061$export$c33990e84065970c);

var $5uXOq = parcelRequire("5uXOq");
const $57029c6f61e78061$export$c33990e84065970c = /*#__PURE__*/ (0, $5uXOq.createContext)({
    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), null),
    setFallback: ()=>{
        console.warn('Missing <LooselySuspense /> boundary');
    }
});

});



parcelRegister("gI8wo", function(module, exports) {

$parcel$export(module.exports, "createLoaderError", () => $c2a75d9d2b1d4ac6$export$c73a6a6f0bf7d425);
const $c2a75d9d2b1d4ac6$export$6aa69c1258005366 = Symbol.for('react-loosely-lazy/loader-error');
const $c2a75d9d2b1d4ac6$export$c73a6a6f0bf7d425 = (error)=>{
    if (typeof error === 'object') return Object.assign(error, {
        [$c2a75d9d2b1d4ac6$export$6aa69c1258005366]: true
    });
    return error;
};
const $c2a75d9d2b1d4ac6$export$16a03aca4a3508b4 = (error)=>Object.getOwnPropertySymbols(error).includes($c2a75d9d2b1d4ac6$export$6aa69c1258005366);

});

parcelRegister("b1mtW", function(module, exports) {

$parcel$export(module.exports, "PlaceholderFallbackRender", () => $80613a2b6be8c4b1$export$d55db778a3e1446b);

var $5uXOq = parcelRequire("5uXOq");

var $lUR7e = parcelRequire("lUR7e");
parcelRequire("3iU61");
var $hxt6y = parcelRequire("hxt6y");
parcelRequire("41yqT");
var $7t9v5 = parcelRequire("7t9v5");
function $80613a2b6be8c4b1$var$isLinkPrefetch(el) {
    return el.tagName === 'LINK' && el.rel === 'prefetch';
}
const $80613a2b6be8c4b1$var$usePlaceholderRender = (resolveId, content)=>{
    const hydrationRef = (0, $5uXOq.useRef)(null);
    const { current: ssrDomNodes } = (0, $5uXOq.useRef)(content || []);
    const profilerContext = (0, $5uXOq.useContext)((0, $lUR7e.ProfilerContext)).current;
    const waitContext = (0, $5uXOq.useContext)((0, $hxt6y.WaitContext));
    const suspenseContext = (0, $5uXOq.useContext)((0, $7t9v5.LazySuspenseContext));
    (0, $5uXOq.useLayoutEffect)(()=>{
        const element = hydrationRef.current;
        const { parentNode: parentNode } = element || {};
        profilerContext === null || profilerContext.placeholderFallBackMounted(resolveId, suspenseContext.name, !waitContext.currentValue());
        if (parentNode && !parentNode.contains(ssrDomNodes[0])) ssrDomNodes.reverse().forEach((node)=>{
            // this fixes an issue with Chrome that re-triggers and cancels prefetch
            // when node is appended again, making network panel quite noisy
            if ($80613a2b6be8c4b1$var$isLinkPrefetch(node)) node.rel = '';
            parentNode.insertBefore(node, element.nextSibling);
        });
        return ()=>{
            profilerContext === null || profilerContext.placeholderFallBackUnmounted(resolveId, suspenseContext.name, !waitContext.currentValue());
            ssrDomNodes.forEach((node)=>{
                var _node$parentNode;
                return (_node$parentNode = node.parentNode) == null ? void 0 : _node$parentNode.removeChild(node);
            });
        }; // [hydrationRef.current, ssrDomNodes] are expected to be stable
    // with the second one never changing by design and the first one changing after first render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return hydrationRef;
};
const $80613a2b6be8c4b1$export$d55db778a3e1446b = ({ id: id, content: content })=>{
    const placeholderRef = $80613a2b6be8c4b1$var$usePlaceholderRender(id, content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id,
        ref: placeholderRef
    });
};

});
parcelRegister("lUR7e", function(module, exports) {

$parcel$export(module.exports, "GlobalReactLooselyLazyProfiler", () => $ff4807977d1ff541$export$e2d53c0cbedd2710);
$parcel$export(module.exports, "ProfilerContext", () => $ff4807977d1ff541$export$8146ab57a3f7a7cb);

var $5uXOq = parcelRequire("5uXOq");
const $ff4807977d1ff541$export$e2d53c0cbedd2710 = {
    current: null
};
const $ff4807977d1ff541$export$8146ab57a3f7a7cb = /*#__PURE__*/ (0, $5uXOq.createContext)($ff4807977d1ff541$export$e2d53c0cbedd2710);

});


parcelRegister("2uJW6", function(module, exports) {

$parcel$export(module.exports, "PlaceholderFallbackHydrate", () => $1d1204150993c3dd$export$ca5b8fbc835d95e4);

var $5uXOq = parcelRequire("5uXOq");

var $fEDkH = parcelRequire("fEDkH");
function $1d1204150993c3dd$var$_extends() {
    $1d1204150993c3dd$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1d1204150993c3dd$var$_extends.apply(this, arguments);
}
const $1d1204150993c3dd$export$ca5b8fbc835d95e4 = ({ id: id, content: content })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id
    }), content.map((el, i)=>{
        const { tagName: tagName = '', childNodes: childNodes = [], attributes: attributes = [] } = el;
        const props = Array.from(attributes).reduce((0, $fEDkH.attrToProp), {
            key: String(i)
        }); // text node
        if (!tagName) return /*#__PURE__*/ (0, $5uXOq.createElement)((0, $5uXOq.Fragment), props, el.textContent); // childless tag
        if (!childNodes.length) return /*#__PURE__*/ (0, $5uXOq.createElement)(tagName.toLowerCase(), props); // tag with content
        return /*#__PURE__*/ (0, $5uXOq.createElement)(tagName.toLowerCase(), $1d1204150993c3dd$var$_extends({}, props, {
            dangerouslySetInnerHTML: {
                __html: ''
            },
            suppressHydrationWarning: true
        }));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("input", {
        type: "hidden",
        "data-lazy-end": id
    }));
};

});

parcelRegister("k8XtJ", function(module, exports) {

$parcel$export(module.exports, "useSubscription", () => $eaa2b1340dc6db34$export$368b4214baeb914c);

var $5uXOq = parcelRequire("5uXOq");
function $eaa2b1340dc6db34$export$368b4214baeb914c({ context: context, load: load, onValue: onValue }) {
    const { subscribe: subscribe, currentValue: currentValue } = (0, $5uXOq.useContext)(context);
    (0, $5uXOq.useMemo)(()=>{
        let unsubscribe = null;
        const check = ()=>{
            const done = onValue(currentValue());
            if (done) load();
            if (done && unsubscribe) unsubscribe();
            return done;
        };
        unsubscribe = !check() ? subscribe(check) : null; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}

});


parcelRegister("3ro9P", function(module, exports) {

$parcel$export(module.exports, "createComponentServer", () => $2816a1dec93a8449$export$eb2e4b04351cdd9e);

var $3aJOa = parcelRequire("3aJOa");

var $5uXOq = parcelRequire("5uXOq");

var $9tT5O = parcelRequire("9tT5O");

var $gRvGe = parcelRequire("gRvGe");
parcelRequire("41yqT");
var $7t9v5 = parcelRequire("7t9v5");

var $fEDkH = parcelRequire("fEDkH");

var $gI8wo = parcelRequire("gI8wo");
function $2816a1dec93a8449$var$load(moduleId, loader) {
    try {
        return (0, $fEDkH.getExport)(loader());
    } catch (err) {
        throw (0, $gI8wo.createLoaderError)(err);
    }
}
function $2816a1dec93a8449$export$eb2e4b04351cdd9e({ dataLazyId: dataLazyId, defer: defer, loader: loader, moduleId: moduleId, ssr: ssr }) {
    return (props)=>{
        var _getAssetUrlsFromId;
        const Resolved = ssr ? $2816a1dec93a8449$var$load(moduleId, loader) : null;
        const { fallback: fallback } = (0, $5uXOq.useContext)((0, $7t9v5.LazySuspenseContext));
        const { crossOrigin: crossOrigin, manifest: manifest } = (0, $9tT5O.getConfig)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("input", {
            type: "hidden",
            "data-lazy-begin": dataLazyId
        }), defer !== (0, $gRvGe.PHASE).LAZY && ((_getAssetUrlsFromId = (0, $3aJOa.getAssetUrlsFromId)(manifest, moduleId)) == null ? void 0 : _getAssetUrlsFromId.map((url)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("link", {
                key: url,
                rel: defer === (0, $gRvGe.PHASE).PAINT ? 'preload' : 'prefetch',
                href: url,
                crossOrigin: crossOrigin,
                as: "script"
            }))), Resolved ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Resolved, props) : fallback, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("input", {
            type: "hidden",
            "data-lazy-end": dataLazyId
        }));
    };
}

});

parcelRegister("5pJCH", function(module, exports) {

$parcel$export(module.exports, "createDeferred", () => $3f12ad617063b5b1$export$e673efccd97e4223);
const $3f12ad617063b5b1$export$e673efccd97e4223 = ({ loader: loader, preload: preload })=>{
    let resolve;
    const deferred = {
        promise: new Promise((res)=>{
            resolve = (m)=>{
                let withDefault;
                deferred.result = m;
                if (!m.default) withDefault = {
                    default: m
                };
                res(withDefault ? withDefault : m);
            };
        }),
        result: undefined,
        preload: function(_preload) {
            function preload() {
                return _preload.apply(this, arguments);
            }
            preload.toString = function() {
                return _preload.toString();
            };
            return preload;
        }(()=>{
            if (deferred.result) return;
            preload().then((m)=>{
                deferred.result = m;
            }).catch(()=>{});
        }),
        start: ()=>{
            if (deferred.result) {
                resolve(deferred.result);
                return Promise.resolve();
            } // Make a new loader request when none have started or resolved yet
            return loader().then(resolve);
        }
    };
    return deferred;
};

});

parcelRegister("2LsHW", function(module, exports) {

$parcel$export(module.exports, "preloadAsset", () => $20363d4ed5cd2af1$export$25bad4aa00c45355);

var $3aJOa = parcelRequire("3aJOa");

var $3Sq3c = parcelRequire("3Sq3c");

var $9tT5O = parcelRequire("9tT5O");

var $fEDkH = parcelRequire("fEDkH");

var $9Ww7D = parcelRequire("9Ww7D");

var $6MxP6 = parcelRequire("6MxP6");

var $lUR7e = parcelRequire("lUR7e");
function $20363d4ed5cd2af1$export$3af04dbcb01bad4d({ moduleId: moduleId, rel: rel }) {
    const { manifest: manifest } = (0, $9tT5O.getConfig)();
    const assets = (0, $3aJOa.getAssetUrlsFromId)(manifest, moduleId);
    if (!assets) throw new Error('Unsupported preload strategy');
    const cleanupLinkTags = assets.map((url)=>(0, $6MxP6.insertLinkTag)(url, rel));
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
const $20363d4ed5cd2af1$var$fakePromise = {
    then: ()=>$20363d4ed5cd2af1$var$fakePromise,
    catch: ()=>$20363d4ed5cd2af1$var$fakePromise,
    finally: ()=>$20363d4ed5cd2af1$var$fakePromise
};
function $20363d4ed5cd2af1$export$1046fd6a49d5e7a({ loader: loader, rel: rel }) {
    if (typeof __webpack_require__ === 'undefined' || typeof __webpack_get_script_filename__ === 'undefined') throw new Error('Unsupported preload strategy'); // Replace requireEnsure to create link tags instead of scripts
    const requireEnsure = __webpack_require__.e;
    const cleanupLinkTags = [];
    __webpack_require__.e = function requirePreload(chunkId) {
        const href = __webpack_get_script_filename__(chunkId);
        cleanupLinkTags.push((0, $6MxP6.insertLinkTag)(href, rel));
        return $20363d4ed5cd2af1$var$fakePromise;
    };
    try {
        loader();
    } catch (err) {} // Restore real webpack require ensure
    __webpack_require__.e = requireEnsure;
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
function $20363d4ed5cd2af1$export$eb05139fa4dcf992({ loader: loader }) {
    loader();
    return 0, $3Sq3c.noopCleanup;
}
function $20363d4ed5cd2af1$export$25bad4aa00c45355({ loader: loader, moduleId: moduleId, priority: priority }) {
    var _GlobalReactLooselyLa;
    if ((0, $fEDkH.isNodeEnvironment)()) return 0, $3Sq3c.noopCleanup;
    (_GlobalReactLooselyLa = (0, $lUR7e.GlobalReactLooselyLazyProfiler).current) == null || _GlobalReactLooselyLa.onPreload(moduleId, priority);
    const rel = priority === (0, $9Ww7D.PRIORITY).HIGH ? 'preload' : 'prefetch';
    const preloadStrategies = [
        $20363d4ed5cd2af1$export$3af04dbcb01bad4d,
        $20363d4ed5cd2af1$export$1046fd6a49d5e7a,
        $20363d4ed5cd2af1$export$eb05139fa4dcf992
    ];
    for (const strategy of preloadStrategies)try {
        return strategy({
            loader: loader,
            moduleId: moduleId,
            rel: rel
        });
    } catch (_) {}
    return 0, $3Sq3c.noopCleanup;
}

});
parcelRegister("6MxP6", function(module, exports) {

$parcel$export(module.exports, "insertLinkTag", () => $4f01765b3d259822$export$6610512821c8a4ce);

var $lUR7e = parcelRequire("lUR7e");

var $3Sq3c = parcelRequire("3Sq3c");

var $9tT5O = parcelRequire("9tT5O");
function $4f01765b3d259822$export$6610512821c8a4ce(href, rel) {
    var _document$head;
    // Skip if already preloaded, prefetched, or loaded
    if (document.querySelector(`link[href="${href}"]`) || document.querySelector(`script[src="${href}"]`)) return 0, $3Sq3c.noopCleanup;
    const { crossOrigin: crossOrigin } = (0, $9tT5O.getConfig)();
    const link = document.createElement('link');
    link.rel = rel;
    link.as = 'script';
    if (crossOrigin) link.crossOrigin = crossOrigin;
    link.href = href;
    const profiler = (0, $lUR7e.GlobalReactLooselyLazyProfiler).current;
    let removableListener = null;
    if (profiler) {
        const eventInfo = {
            identifier: href
        };
        const listener = ()=>{
            link.removeEventListener('onload', listener);
            removableListener = null;
            profiler.onLoadComplete(eventInfo);
        };
        link.addEventListener('onload', listener);
        removableListener = listener;
        profiler.onLoadStart(eventInfo);
    }
    (_document$head = document.head) == null || _document$head.appendChild(link);
    return ()=>{
        // Remove the link if it is still in the document head
        if (link.parentNode === document.head) {
            var _document$head2;
            (_document$head2 = document.head) == null || _document$head2.removeChild(link);
        }
        if (removableListener) link.removeEventListener('onload', removableListener);
    };
}

});


parcelRegister("gNYzn", function(module, exports) {

$parcel$export(module.exports, "retry", () => $032842ea9e8e4a24$export$9369b12211e1fce4);
const $032842ea9e8e4a24$var$calculateDelay = (context, policy)=>{
    const { attempt: attempt } = context;
    const { delay: delay, factor: factor } = policy;
    const retryAttempt = attempt - 1; // Do not use a delay on the first retry, or when the configured delay is 0
    if (retryAttempt === 1 || delay === 0) return 0;
     // Linear factor, like: https://github.com/Polly-Contrib/Polly.Contrib.WaitAndRetry#wait-and-retry-with-linear-back-off
    const add = factor * delay;
    return delay + add * (retryAttempt - 2);
};
const $032842ea9e8e4a24$var$sleep = (delay)=>new Promise((resolve)=>setTimeout(resolve, delay));
const $032842ea9e8e4a24$var$getPolicy = (configuration)=>{
    var _configuration$delay, _configuration$factor, _configuration$maxAtt;
    return {
        delay: Math.max(0, (_configuration$delay = configuration.delay) != null ? _configuration$delay : 0),
        factor: Math.max(0, (_configuration$factor = configuration.factor) != null ? _configuration$factor : 0),
        maxAttempts: Math.max(0, (_configuration$maxAtt = configuration.maxAttempts) != null ? _configuration$maxAtt : 0)
    };
};
function $032842ea9e8e4a24$export$9369b12211e1fce4(retryable, policyConfiguration = {}) {
    const policy = $032842ea9e8e4a24$var$getPolicy(policyConfiguration);
    const { maxAttempts: maxAttempts } = policy;
    const context = {
        attempt: 1,
        attemptsRemaining: maxAttempts
    };
    const onError = async (err)=>{
        if (context.attemptsRemaining === 0) throw err;
        context.attempt += 1;
        context.attemptsRemaining -= 1;
        const delay = $032842ea9e8e4a24$var$calculateDelay(context, policy);
        if (delay) await $032842ea9e8e4a24$var$sleep(delay);
        return retryable().catch(onError);
    };
    return retryable().catch(onError);
}

});



parcelRegister("96nTn", function(module, exports) {

$parcel$export(module.exports, "default", () => $a12211dcade02141$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $i5FdW = parcelRequire("i5FdW");

var $1LSM6 = parcelRequire("1LSM6");

var $gOOK6 = parcelRequire("gOOK6");
function $a12211dcade02141$export$2e2bcd8739ae039({ loaderFn: loaderFn, children: children, defaultMessages: defaultMessages }) {
    const intl = (0, $gOOK6.useSafeIntl)();
    const messages = (0, $1LSM6.useMessages)(intl.locale, loaderFn);
    /**
	 * IntlProvider does not inherit from upstream IntlProviders,
	 * we lookup messages in the context and pass them downstream
	 * This prevents the missing messages error
	 */ const mergedMessages = (0, $5uXOq.useMemo)(()=>{
        return {
            ...defaultMessages,
            ...intl.messages,
            ...messages
        };
    }, [
        intl,
        messages,
        defaultMessages
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
        defaultLocale: "en",
        locale: intl.locale,
        onError: intl.onError,
        messages: mergedMessages,
        children: children
    });
}

});
parcelRegister("1LSM6", function(module, exports) {

$parcel$export(module.exports, "useMessages", () => $8b0c0f17bd7df50e$export$4d17e2d9c5348842);

var $5uXOq = parcelRequire("5uXOq");

var $mqPQ8 = parcelRequire("mqPQ8");
const $8b0c0f17bd7df50e$export$4d17e2d9c5348842 = (locale, loaderFn)=>{
    const [localeState, setLocaleState] = (0, $5uXOq.useState)((0, $mqPQ8.DEFAULT_LOCALE_STATE));
    (0, $5uXOq.useEffect)(()=>{
        if (!localeState.messages || locale !== localeState.locale) {
            let current = true;
            loaderFn(locale).then((messages)=>{
                if (current) setLocaleState({
                    locale: locale,
                    messages: messages ?? {}
                });
            });
            return ()=>{
                current = false;
            };
        }
    }, [
        loaderFn,
        locale,
        localeState
    ]);
    return localeState.messages;
};

});
parcelRegister("mqPQ8", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_LOCALE_STATE", () => $ca64c7c64c62f0c7$export$79618bef82c02d4c);
const $ca64c7c64c62f0c7$export$79618bef82c02d4c = {
    locale: 'en',
    messages: {}
};

});


parcelRegister("gOOK6", function(module, exports) {

$parcel$export(module.exports, "useSafeIntl", () => $75954c8addb89719$export$f752ac21ea3960a5);

var $5uXOq = parcelRequire("5uXOq");

var $i5FdW = parcelRequire("i5FdW");
var $hTtGr = parcelRequire("hTtGr");
var $8RXs9 = parcelRequire("8RXs9");

var $mqPQ8 = parcelRequire("mqPQ8");
// Prevents memory leaks
const $75954c8addb89719$var$cache = (0, $hTtGr.createIntlCache)();
const $75954c8addb89719$export$f752ac21ea3960a5 = ()=>{
    const context = (0, $5uXOq.useContext)((0, $8RXs9.Context));
    if (!context) return (0, $i5FdW.createIntl)((0, $mqPQ8.DEFAULT_LOCALE_STATE), $75954c8addb89719$var$cache);
    return context;
};

});


parcelRegister("bWGt6", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b260dd1704e65ee$export$2e2bcd8739ae039);

var $bS32t = parcelRequire("bS32t");

var $5uXOq = parcelRequire("5uXOq");

var $bS0aY = parcelRequire("bS0aY");

var $f8Sb3 = parcelRequire("f8Sb3");

var $2cWYv = parcelRequire("2cWYv");

var $7PpcK = parcelRequire("7PpcK");

var $lDKn9 = parcelRequire("lDKn9");
var $8b260dd1704e65ee$var$testOmitPropsOnStringTag = (0, $bS0aY.default);
var $8b260dd1704e65ee$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $8b260dd1704e65ee$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $8b260dd1704e65ee$var$testOmitPropsOnStringTag : $8b260dd1704e65ee$var$testOmitPropsOnComponent;
};
var $8b260dd1704e65ee$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $8b260dd1704e65ee$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $8b260dd1704e65ee$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $2cWYv.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $lDKn9.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $2cWYv.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $8b260dd1704e65ee$var$createStyled = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $8b260dd1704e65ee$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $8b260dd1704e65ee$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class
        var Styled = (0, $f8Sb3.withEmotionCache)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = (0, $5uXOq.useContext)((0, $f8Sb3.ThemeContext));
            }
            if (typeof props.className === 'string') className = (0, $2cWYv.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $7PpcK.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $8b260dd1704e65ee$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            newProps.ref = ref;
            return /*#__PURE__*/ (0, $5uXOq.createElement)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $5uXOq.createElement)($8b260dd1704e65ee$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ (0, $5uXOq.createElement)(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, $bS32t.default)({}, options, nextOptions, {
                shouldForwardProp: $8b260dd1704e65ee$var$composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};
var $8b260dd1704e65ee$export$2e2bcd8739ae039 = $8b260dd1704e65ee$var$createStyled;

});
parcelRegister("bS0aY", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a44dfccbb21331d$export$2e2bcd8739ae039);

var $g3OeT = parcelRequire("g3OeT");
var $8a44dfccbb21331d$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $8a44dfccbb21331d$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $g3OeT.default)(function(prop) {
    return $8a44dfccbb21331d$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});
parcelRegister("g3OeT", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb13e59ea669960c$export$2e2bcd8739ae039);
function $bb13e59ea669960c$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRegister("7Z8dX", function(module, exports) {

$parcel$export(module.exports, "RovoPostMessagePubsubListener", () => $1067642daa65eae6$export$e5e1a9c59c299631);
$parcel$export(module.exports, "useRovoPostMessageToPubsub", () => $1067642daa65eae6$export$5340cc94dd0ecbea);

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $hjiMw = parcelRequire("hjiMw");
const $1067642daa65eae6$export$cabfb6cc8c48b099 = 'rovo-post-message';
const $1067642daa65eae6$export$25a11ea4740a334 = 'rovo-post-message-ack';
// allow subdomains of these domains
const $1067642daa65eae6$var$allowedSubdomains = [
    '.jira-dev.com',
    '.atlassian.com',
    '.atlassian.net',
    '.atl-paas.net'
];
const $1067642daa65eae6$var$allowedOrigins = [
    'bitbucket.org',
    'trello.com'
];
const $1067642daa65eae6$export$c9fe6aef04e3544f = (origin)=>{
    if (!origin) return false;
    const url = new URL(origin);
    const hostname = url.hostname;
    return hostname === 'localhost' || url.protocol === 'https:' && ($1067642daa65eae6$var$allowedSubdomains.some((subdomain)=>hostname.endsWith(subdomain)) || $1067642daa65eae6$var$allowedOrigins.includes(hostname));
};
const $1067642daa65eae6$export$e5e1a9c59c299631 = ()=>{
    const publish = (0, $hjiMw.usePublish)('ai-mate');
    (0, $5uXOq.useEffect)(()=>{
        const handlerUnbind = (0, $cBeZP.bind)(window, {
            type: 'message',
            listener: (event)=>{
                if (!$1067642daa65eae6$export$c9fe6aef04e3544f(event.origin)) return;
                if (event.data.eventType === $1067642daa65eae6$export$cabfb6cc8c48b099) {
                    const eventData = event.data;
                    const ackPayload = {
                        eventType: $1067642daa65eae6$export$25a11ea4740a334,
                        payloadId: eventData.payloadId
                    };
                    event.source?.postMessage(ackPayload);
                    publish(event.data.payload);
                }
            }
        });
        return handlerUnbind;
    }, [
        publish
    ]);
    return null;
};
const $1067642daa65eae6$var$TIMEOUT_WAIT_FOR_ACK = 100;
const $1067642daa65eae6$export$5340cc94dd0ecbea = ()=>{
    const onAcknowledgeTimeoutTimeoutRef = (0, $5uXOq.useRef)(null);
    const [isWaitingForAck, setIsWaitingForAck] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        const handlerUnbind = (0, $cBeZP.bind)(window, {
            type: 'message',
            // handler for acknowledgment from parent
            listener: (event)=>{
                if (!$1067642daa65eae6$export$c9fe6aef04e3544f(event.origin)) return;
                if (event.data.eventType !== $1067642daa65eae6$export$25a11ea4740a334 || onAcknowledgeTimeoutTimeoutRef.current === null) return;
                const eventData = event.data;
                // if the parent acknowledges different payload (e.g. from different hook instance)
                // disregard the event
                if (eventData.payloadId !== onAcknowledgeTimeoutTimeoutRef.current.lastPayloadId) return;
                // Clear the onAcknowledgeTimeoutTimeout if acknowledgment is received
                clearTimeout(onAcknowledgeTimeoutTimeoutRef.current.timeout);
                onAcknowledgeTimeoutTimeoutRef.current = null;
                setIsWaitingForAck(false);
            }
        });
        return handlerUnbind;
    }, []);
    const publishWithPostMessage = (0, $5uXOq.useCallback)(({ targetWindow: targetWindow = window.parent, payload: payload, onAcknowledgeTimeout: onAcknowledgeTimeout })=>{
        if (!targetWindow) return;
        const payloadId = Math.floor(Math.random() * 1e6).toString();
        targetWindow.postMessage({
            eventType: $1067642daa65eae6$export$cabfb6cc8c48b099,
            payload: payload,
            payloadId: payloadId
        }, '*');
        // waiting for acknowledgment from parent
        // if no acknowledgment is received, call onAcknowledgeTimeout
        setIsWaitingForAck(true);
        const timeout = window.setTimeout(()=>{
            onAcknowledgeTimeout({
                payload: payload
            });
            onAcknowledgeTimeoutTimeoutRef.current = null;
            setIsWaitingForAck(false);
        }, $1067642daa65eae6$var$TIMEOUT_WAIT_FOR_ACK);
        onAcknowledgeTimeoutTimeoutRef.current = {
            timeout: timeout,
            lastPayloadId: payloadId
        };
    }, []);
    return {
        publishWithPostMessage: publishWithPostMessage,
        isWaitingForAck: isWaitingForAck
    };
};

});
parcelRegister("hjiMw", function(module, exports) {

$parcel$export(module.exports, "useSubscribe", () => $775f1109619c4156$export$d3d523392640272);
$parcel$export(module.exports, "useSubscribeAll", () => $775f1109619c4156$export$2570c8aa24b6d327);
$parcel$export(module.exports, "usePublish", () => $775f1109619c4156$export$d55c81786220731c);
$parcel$export(module.exports, "Subscriber", () => $775f1109619c4156$export$60959659b2c22881);

var $5uXOq = parcelRequire("5uXOq");
const $775f1109619c4156$var$ignoredTriggerLatestEvents = new Set([
    'editor-context-payload',
    'agent-changed'
]);
const $775f1109619c4156$var$createPubSub = ()=>{
    let subscribedEvents = {};
    let publishQueue = {};
    let wildcardEvents = [];
    const subscribe = ({ topic: topic, triggerLatest: triggerLatest }, callback)=>{
        const events = subscribedEvents[topic] ?? [];
        const subId = events.length.toString();
        const subExists = events.some(({ id: id })=>id === subId);
        // Push to Topic stack if not already there
        if (!subExists) {
            subscribedEvents = {
                ...subscribedEvents,
                [topic]: [
                    ...events,
                    {
                        callback: callback,
                        id: subId
                    }
                ]
            };
            // If this Topic already has a published event and `triggerLatest` is true, trigger the callback then clear the publishQueue for that Topic
            if (triggerLatest && !!publishQueue[topic]) {
                const payload = publishQueue[topic];
                callback(payload);
                delete publishQueue[topic];
            }
        }
        return ()=>{
            // Remove from Topic stack
            subscribedEvents = {
                ...subscribedEvents,
                [topic]: (subscribedEvents[topic] || []).filter(({ id: id })=>id !== subId)
            };
        };
    };
    const subscribeAll = (callback)=>{
        const subId = wildcardEvents.length.toString();
        wildcardEvents = [
            ...wildcardEvents,
            {
                callback: callback,
                id: subId
            }
        ];
        return ()=>{
            wildcardEvents = wildcardEvents.filter(({ id: id })=>id !== subId);
        };
    };
    const publish = (topic, payload)=>{
        /**
		 * Log that this Topic received a published event, regardless of whether it has subscribers or not.
		 * This ensures new subscribers can trigger their callback if `triggerLatest` is true, and the event hasn't already been triggered.
		 */ // This `ignoredTriggerLatestEvents` is a quick fix to prevent triggering the latest event for certain events
        if (!$775f1109619c4156$var$ignoredTriggerLatestEvents.has(payload.type)) publishQueue[topic] = payload;
        // Notify `subscribeAll` subscribers as they are Topic agnostic
        wildcardEvents.forEach(({ callback: callback })=>callback(payload));
        const topicSubs = subscribedEvents[topic] || [];
        // If there are no subscribers for this Topic, nothing to do.
        if (!topicSubs.length) return;
        // Notify all Topic subscribers of this event
        topicSubs.forEach(({ callback: callback })=>callback(payload));
    };
    const flushQueue = ()=>{
        publishQueue = {};
    };
    return {
        subscribe: subscribe,
        subscribeAll: subscribeAll,
        publish: publish,
        flushQueue: flushQueue
    };
};
const $775f1109619c4156$var$pubSub = $775f1109619c4156$var$createPubSub();
const $775f1109619c4156$var$usePubSub = ()=>{
    return $775f1109619c4156$var$pubSub;
};
const $775f1109619c4156$export$d3d523392640272 = ({ topic: topic, triggerLatest: triggerLatest }, callback)=>{
    const { subscribe: subscribe } = $775f1109619c4156$var$usePubSub();
    const callbackRef = (0, $5uXOq.useRef)(callback);
    callbackRef.current = callback;
    (0, $5uXOq.useEffect)(()=>{
        const unsubscribe = subscribe({
            topic: topic,
            triggerLatest: triggerLatest
        }, (...args)=>callbackRef.current(...args));
        return unsubscribe;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        topic
    ]);
};
const $775f1109619c4156$export$2570c8aa24b6d327 = (callback)=>{
    const { subscribeAll: subscribeAll } = $775f1109619c4156$var$usePubSub();
    const callbackRef = (0, $5uXOq.useRef)(callback);
    callbackRef.current = callback;
    (0, $5uXOq.useEffect)(()=>{
        const unsubscribe = subscribeAll((...args)=>callbackRef.current(...args));
        return unsubscribe;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
};
const $775f1109619c4156$var$useFlushOnUnmount = (active = false)=>{
    const { flushQueue: flushQueue } = $775f1109619c4156$var$usePubSub();
    (0, $5uXOq.useLayoutEffect)(()=>{
        return ()=>{
            if (active) flushQueue();
        };
    }, [
        active,
        flushQueue
    ]);
};
const $775f1109619c4156$export$d55c81786220731c = (topic)=>{
    const { publish: publish } = $775f1109619c4156$var$usePubSub();
    const publishFn = (0, $5uXOq.useCallback)((payload)=>publish(topic, payload), [
        publish,
        topic
    ]);
    return publishFn;
};
const $775f1109619c4156$export$60959659b2c22881 = ({ topic: topic, triggerLatest: triggerLatest, onEvent: onEvent, flushQueueOnUnmount: flushQueueOnUnmount })=>{
    $775f1109619c4156$export$d3d523392640272({
        topic: topic,
        triggerLatest: triggerLatest
    }, onEvent);
    $775f1109619c4156$var$useFlushOnUnmount(flushQueueOnUnmount);
    return null;
};

});


parcelRegister("eIMrK", function(module, exports) {

$parcel$export(module.exports, "createCache", () => $26949c89be85980a$export$cf6fa0bbcc94b912);
function $26949c89be85980a$export$cf6fa0bbcc94b912(store) {
    return {
        get (key, supplier) {
            const value = store.get(key);
            if (value != null) return value;
            const v = supplier();
            store.set(key, v);
            return v;
        }
    };
}

});

parcelRegister("ce6VA", function(module, exports) {

$parcel$export(module.exports, "PreloadableJSResource", () => $0aceca9655b1ea8e$export$4fe5fba5bb1d3c09);

var $eYVtd = parcelRequire("eYVtd");
function $0aceca9655b1ea8e$export$4fe5fba5bb1d3c09(loader, opts) {
    const resource = (0, $eYVtd.JSResource)(loader, opts);
    return Object.assign(resource, {
        preload () {
            const jsModule = resource.getModuleIfRequired();
            if (jsModule != null) return;
            resource.load().catch(()=>{});
        }
    });
}

});
parcelRegister("eYVtd", function(module, exports) {

$parcel$export(module.exports, "JSResource", () => $0077c3a5c33c2d5c$export$148e45a6d4b4d65);

var $s9uRx = parcelRequire("s9uRx");

var $kqVcd = parcelRequire("kqVcd");

var $c8s79 = parcelRequire("c8s79");
function $0077c3a5c33c2d5c$export$148e45a6d4b4d65(loader, opts) {
    const { moduleId: moduleId, moduleName: moduleName } = opts;
    const listeners = new Set();
    let promise;
    let state = {
        type: 'init'
    };
    function createOnLoad(event) {
        return (module)=>{
            (0, $kqVcd.eventEmitter).emit('jsresource.load.complete', event);
            state = {
                type: 'module',
                module: module
            };
            for (const listener of listeners)listener.onLoad(module);
        };
    }
    function createOnError(event) {
        return (error)=>{
            (0, $kqVcd.eventEmitter).emit('jsresource.load.error', {
                ...event,
                error: error
            });
            state = {
                type: 'error',
                error: error
            };
            for (const listener of listeners)listener.onError?.(error);
        };
    }
    return {
        getModuleId () {
            return moduleId;
        },
        getModuleName () {
            return moduleName;
        },
        getModuleIfRequired () {
            if (state.type === 'error') throw state.error;
            return state.type === 'module' ? state.module : null;
        },
        load () {
            if (!promise) {
                const event = {
                    moduleId: moduleId,
                    transactionId: (0, $s9uRx.generateId)()
                };
                const onError = createOnError(event);
                const onLoad = createOnLoad(event);
                (0, $kqVcd.eventEmitter).emit('jsresource.load.start', event);
                try {
                    promise = loader().then((result)=>{
                        const module = (0, $c8s79.isJSModuleWithDefaultExport)(result) ? result.default : result;
                        onLoad(module);
                        return module;
                    }).catch((error)=>{
                        onError(error);
                        throw error;
                    });
                } catch (error) {
                    if (error instanceof Error) onError(error);
                    promise = Promise.reject(error);
                }
            }
            return promise;
        },
        onComplete (onLoad, onError) {
            if (state.type === 'module') {
                onLoad(state.module);
                return ()=>{};
            }
            if (state.type === 'error') {
                onError?.(state.error);
                return ()=>{};
            }
            const listener = {
                onError: onError,
                onLoad: onLoad
            };
            listeners.add(listener);
            return ()=>{
                listeners.delete(listener);
            };
        }
    };
}

});
parcelRegister("s9uRx", function(module, exports) {

$parcel$export(module.exports, "generateId", () => $7b3c882236d08e62$export$567fc7097e064344);
let $7b3c882236d08e62$var$id = 100000;
function $7b3c882236d08e62$export$567fc7097e064344() {
    $7b3c882236d08e62$var$id += 1;
    return $7b3c882236d08e62$var$id.toString();
}

});

parcelRegister("kqVcd", function(module, exports) {

$parcel$export(module.exports, "eventEmitter", () => $c1231136395d7ade$export$10dc3edfc20c8ff);
function $c1231136395d7ade$var$createEventEmitter() {
    const eventSubscribers = new Map();
    return {
        emit (eventName, event) {
            const subscribers = eventSubscribers.get(eventName);
            for (const subscriber of subscribers ?? [])subscriber(event);
        },
        on (eventName, subscriber) {
            if (!eventSubscribers.has(eventName)) eventSubscribers.set(eventName, new Set([
                subscriber
            ]));
            else eventSubscribers.get(eventName).add(subscriber);
            return ()=>{
                const set = eventSubscribers.get(eventName);
                set.delete(subscriber);
                if (set.size === 0) eventSubscribers.delete(eventName);
            };
        }
    };
}
const $c1231136395d7ade$export$10dc3edfc20c8ff = $c1231136395d7ade$var$createEventEmitter();

});

parcelRegister("c8s79", function(module, exports) {

$parcel$export(module.exports, "isJSModuleWithDefaultExport", () => $e831db33fb49cb12$export$3b514faac3ba993c);
function $e831db33fb49cb12$export$3b514faac3ba993c(module) {
    try {
        // This should be replaced with Object.hasOwn once it is more widely supported
        return Object.prototype.hasOwnProperty.call(module, 'default');
    } catch (_) {
        // This fallback will occur when module is undefined, or null after converting to Object.hasOwn
        return false;
    }
}

});



parcelRegister("j74qU", function(module, exports) {

$parcel$export(module.exports, "eocFetch", () => $e038c50dbacfc9f4$export$212b9c60150b5a0a);

var $VSDnB = parcelRequire("VSDnB");

var $tcn7E = parcelRequire("tcn7E");

var $bFU4G = parcelRequire("bFU4G");

var $aI12f = parcelRequire("aI12f");

var $030R0 = parcelRequire("030R0");
const $e038c50dbacfc9f4$export$212b9c60150b5a0a = (input, init)=>{
    let headers = init?.headers ?? {};
    let body = init?.body;
    // If there is no Content-Type we should add application/json
    // and if the body is not in the BodyInit format we should stringify it
    // Native fetch accepts headers as [['key1','value1'],['key2', 'value2']] so we don't want to modify header or body in this case
    if (!(window.Blob && body instanceof Blob || window.Int8Array && body instanceof Int8Array || window.Uint8Array && body instanceof Uint8Array || window.Uint8ClampedArray && body instanceof Uint8ClampedArray || window.Int16Array && body instanceof Int16Array || window.Uint16Array && body instanceof Uint16Array || window.Int32Array && body instanceof Int32Array || window.Uint32Array && body instanceof Uint32Array || window.Float32Array && body instanceof Float32Array || window.Float64Array && body instanceof Float64Array || window.ArrayBuffer && body instanceof ArrayBuffer || window.BigInt64Array && body instanceof BigInt64Array || window.BigUint64Array && body instanceof BigUint64Array || window.FormData && body instanceof FormData || window.URLSearchParams && body instanceof URLSearchParams || window.ReadableStream && body instanceof ReadableStream || window.Array && headers instanceof Array || typeof body === 'string') && headers['Content-Type'] === undefined && headers['content-type'] === undefined) {
        body = JSON.stringify(body);
        headers['Content-Type'] = 'application/json';
    }
    if (typeof input === 'string') {
        input = (0, $030R0.withPrefix)(input, init);
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $VSDnB.fg)('trace_id_header_update_in_the_eoc_fetch')) headers = {
            ...(0, $tcn7E.getActiveTraceHttpRequestHeaders)(input),
            ...headers
        };
    } else {
        input = {
            ...input,
            url: (0, $030R0.withPrefix)(input.url, init)
        };
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $VSDnB.fg)('trace_id_header_update_in_the_eoc_fetch')) headers = {
            ...(0, $tcn7E.getActiveTraceHttpRequestHeaders)(input.url),
            ...headers
        };
    }
    const errorTransformer = init?.errorTransformer ?? (0, $030R0.defaultErrorTransformer);
    const startTime = performance.now();
    return fetch(input, {
        headers: headers,
        ...init,
        body: body
    }).catch((error)=>{
        throw new (0, $aI12f.NetworkError)(error.name, error);
    }).then((response)=>{
        if (!response.ok) throw new (0, $aI12f.HTTPError)(response);
        const sanitizedUrl = (0, $030R0.sanitizeUrlString)((0, $030R0.getRequestUrl)(input));
        (0, $bFU4G.addSpanToAll)('fetch', sanitizedUrl, [
            {
                name: 'network'
            }
        ], startTime, performance.now());
        switch(init?.responseType){
            case undefined:
            case 'json':
                return response.json();
            case 'blob':
                return response.blob();
            case 'text':
                return response.text();
            case 'headers':
                return response;
        }
    }).catch((error)=>{
        if ((0, $aI12f.isNetworkError)(error)) {
            // Put it through the transformer and throw it when ready. Note that
            // it is still safe to throw in the transformer, it will just chain up
            // on the following handlers as usual.
            const transformerResult = errorTransformer(error);
            if (transformerResult instanceof Promise) return transformerResult.then((finalError)=>{
                throw finalError;
            });
            else throw transformerResult;
        }
        throw error;
    });
};

});
parcelRegister("aI12f", function(module, exports) {

$parcel$export(module.exports, "NetworkError", () => $c2cf5dfa0e96b9de$export$bae979e68e4dc802);
$parcel$export(module.exports, "HTTPError", () => $c2cf5dfa0e96b9de$export$aa9d629c530f62a7);
$parcel$export(module.exports, "StreamedHTTPError", () => $c2cf5dfa0e96b9de$export$c30b5b02747d791c);
$parcel$export(module.exports, "isHTTPError", () => $c2cf5dfa0e96b9de$export$6b7a49ce9c98a2f);
$parcel$export(module.exports, "isNetworkError", () => $c2cf5dfa0e96b9de$export$476aa014e2fd89d5);
$parcel$export(module.exports, "isStreamedHTTPError", () => $c2cf5dfa0e96b9de$export$4f52fcea95c8f97d);

var $60Rff = parcelRequire("60Rff");
class $c2cf5dfa0e96b9de$export$bae979e68e4dc802 extends Error {
    constructor(name, cause){
        super('Network Error!'), this.name = name, this.cause = cause;
    }
}
class $c2cf5dfa0e96b9de$export$aa9d629c530f62a7 extends $c2cf5dfa0e96b9de$export$bae979e68e4dc802 {
    constructor(response){
        // It is important to note that this can be shown to the user if the
        // default transformer is not used for some reason and the thrown error's
        // message is left as is.
        super((0, $60Rff.ERROR_NAMES).HTTPError);
        this.message = `HTTP Status Error: ${response.status} ${response.statusText}`;
        this.response = response;
    }
}
class $c2cf5dfa0e96b9de$export$c30b5b02747d791c extends $c2cf5dfa0e96b9de$export$aa9d629c530f62a7 {
    constructor(cause, data, message){
        super(cause.response), this.cause = cause, this.data = data, this.message = message;
        this.message = message;
        this.name = (0, $60Rff.ERROR_NAMES).StreamedHTTPError;
    }
}
const $c2cf5dfa0e96b9de$export$6b7a49ce9c98a2f = (candidate)=>candidate instanceof $c2cf5dfa0e96b9de$export$aa9d629c530f62a7 || [
        (0, $60Rff.ERROR_NAMES).HTTPError,
        (0, $60Rff.ERROR_NAMES).StreamedHTTPError
    ].includes(candidate.name);
const $c2cf5dfa0e96b9de$export$476aa014e2fd89d5 = (candidate)=>candidate instanceof $c2cf5dfa0e96b9de$export$bae979e68e4dc802 || [
        (0, $60Rff.ERROR_NAMES).NetworkError,
        (0, $60Rff.ERROR_NAMES).HTTPError,
        (0, $60Rff.ERROR_NAMES).StreamedHTTPError
    ].includes(candidate.name);
const $c2cf5dfa0e96b9de$export$4f52fcea95c8f97d = (candidate)=>candidate instanceof $c2cf5dfa0e96b9de$export$c30b5b02747d791c || candidate?.name === (0, $60Rff.ERROR_NAMES).StreamedHTTPError;

});
parcelRegister("60Rff", function(module, exports) {

$parcel$export(module.exports, "ERROR_NAMES", () => $3500a6ac498ab4f6$export$daceac3b97803ce1);
var $3500a6ac498ab4f6$export$daceac3b97803ce1 = /*#__PURE__*/ function(ERROR_NAMES) {
    ERROR_NAMES["HTTPError"] = "HTTPError";
    ERROR_NAMES["StreamedHTTPError"] = "StreamedHTTPError";
    ERROR_NAMES["NetworkError"] = "NetworkError";
    return ERROR_NAMES;
}({});

});


parcelRegister("030R0", function(module, exports) {

$parcel$export(module.exports, "getMeta", () => $bc491f1610486b68$export$c47913ca32a5c6f7);
$parcel$export(module.exports, "withPrefix", () => $bc491f1610486b68$export$44188c5f179c4553);
$parcel$export(module.exports, "defaultErrorTransformer", () => $bc491f1610486b68$export$270fcc0e5df09fdd);
$parcel$export(module.exports, "jsmErrorTransformer", () => $bc491f1610486b68$export$994cc82144d28ded);
$parcel$export(module.exports, "getRequestUrl", () => $bc491f1610486b68$export$14619c0eed01a470);
$parcel$export(module.exports, "sanitizeUrlString", () => $bc491f1610486b68$export$ceb09b958e605eff);

var $gIuON = parcelRequire("gIuON");

var $aI12f = parcelRequire("aI12f");

let $bc491f1610486b68$var$metaCloudId;
let $bc491f1610486b68$var$isJSMAvailable = true;
function $bc491f1610486b68$export$c47913ca32a5c6f7(name) {
    const globalVariable = window ?? $parcel$global;
    if ((0, $gIuON.isServer)() && globalVariable.ssr__metadata) return globalVariable.ssr__metadata[name];
    if ($bc491f1610486b68$var$metaCloudId) return $bc491f1610486b68$var$metaCloudId;
    if ($bc491f1610486b68$var$isJSMAvailable) {
        const element = document.querySelector(`meta[name="${name}"]`);
        $bc491f1610486b68$var$metaCloudId = element?.getAttribute('content') ?? undefined;
        $bc491f1610486b68$var$isJSMAvailable = !!$bc491f1610486b68$var$metaCloudId;
    }
    return $bc491f1610486b68$var$metaCloudId;
}
function $bc491f1610486b68$export$5a75f4aeb58ba80f(id) {
    $bc491f1610486b68$var$metaCloudId = id;
}
function $bc491f1610486b68$export$44188c5f179c4553(input, init) {
    if (init?.exactUrl) return input;
    // If current env is not opsgenie, we will add cloud id to base url of request.
    if (window.__OG__) return '/webapi' + input;
    const cloudId = $bc491f1610486b68$export$c47913ca32a5c6f7('ajs-cloud-id');
    if (cloudId) return (0, $2021409bef50eca5$export$3414665826fa030e) + cloudId + input;
    return input;
}
// https://www.rfc-editor.org/rfc/rfc9110.html#section-8.3
// This is not a full implementation, but should skip any unknown parameters
// and match the charset if it exists. In case there are multiple (which shouldn't) we still
// match the first occurence. If only application/json is returned, utf-8 is
// assumed as we will try to parse it as utf-8 json. This is probably our best
// guess without too much effort here.
const $bc491f1610486b68$var$mediaTypeRegex = /(^application\/json$)|(^application\/json([\s\t]?;.+?)*([\s\t]?;[\s\t]?charset=(("utf-8")|(utf-8))))/i;
const $bc491f1610486b68$export$270fcc0e5df09fdd = (e)=>{
    if (e instanceof (0, $aI12f.HTTPError)) {
        const contentType = e.response.headers.get('Content-Type');
        // The content type is application/json, and it is highly likely utf-8 encoded
        if (contentType && $bc491f1610486b68$var$mediaTypeRegex.test(contentType)) return e.response.json().then((data)=>new (0, $aI12f.StreamedHTTPError)(e, data, data.errorMessage ?? data.message));
        // For anything else, try to interpret it as utf8 text as best effort.
        return e.response.text().then((message)=>new (0, $aI12f.StreamedHTTPError)(e, message, message));
    }
    return e;
};
const $bc491f1610486b68$export$994cc82144d28ded = (error)=>{
    if (error instanceof (0, $aI12f.HTTPError)) {
        const contentType = error.response.headers.get('Content-Type');
        if (contentType && $bc491f1610486b68$var$mediaTypeRegex.test(contentType)) return error.response.json().then((data)=>new (0, $aI12f.StreamedHTTPError)(error, data, data.errorMessages.join(',')));
        return error.response.text().then((message)=>new (0, $aI12f.StreamedHTTPError)(error, message, message));
    }
    return error;
};
const $bc491f1610486b68$export$14619c0eed01a470 = (fetchInput)=>typeof fetchInput === 'string' ? fetchInput : fetchInput instanceof URL ? fetchInput.href : fetchInput.url;
const $bc491f1610486b68$export$ceb09b958e605eff = (url)=>{
    const urlWithoutQueryParams = url.replace(/\?.*$/, '');
    const urlWithoutUUIDs = urlWithoutQueryParams.replace(/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}(-[0-9a-f]{13})?/gi, '<uuid>');
    return urlWithoutUUIDs;
};

});
parcelRegister("gIuON", function(module, exports) {

$parcel$export(module.exports, "isServer", () => $a110d4649f6250fb$export$6acf61af03e62db);
const $a110d4649f6250fb$export$6acf61af03e62db = ()=>{
    try {
        //@ts-ignore: It defined from webpack on the Jira
        return false;
    } catch (error) {
        return globalThis.false ?? false;
    }
};

});

const $2021409bef50eca5$export$3414665826fa030e = '/gateway/api/jsm/ops/web/';



parcelRegister("icGZu", function(module, exports) {

var $2k3l6 = parcelRequire("2k3l6");

var $bxDef = parcelRequire("bxDef");

var $6kYP8 = parcelRequire("6kYP8");

var $8LQ84 = parcelRequire("8LQ84");

var $4rDUz = parcelRequire("4rDUz");
/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */ function $d40ab2104a331ebd$var$some(collection, predicate, guard) {
    var func = $8LQ84(collection) ? $2k3l6 : $6kYP8;
    if (guard && $4rDUz(collection, predicate, guard)) predicate = undefined;
    return func(collection, $bxDef(predicate, 3));
}
module.exports = $d40ab2104a331ebd$var$some;

});
parcelRegister("6kYP8", function(module, exports) {

var $e7pfQ = parcelRequire("e7pfQ");
/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $49d3cab0435826ab$var$baseSome(collection, predicate) {
    var result;
    $e7pfQ(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
    });
    return !!result;
}
module.exports = $49d3cab0435826ab$var$baseSome;

});


parcelRegister("9glig", function(module, exports) {

var $hlchF = parcelRequire("hlchF");

var $1nIHN = parcelRequire("1nIHN");

var $bxDef = parcelRequire("bxDef");

var $g7i7g = parcelRequire("g7i7g");
/** Error message constants. */ var $6be62026d39b34ea$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that iterates over `pairs` and invokes the corresponding
 * function of the first predicate to return truthy. The predicate-function
 * pairs are invoked with the `this` binding and arguments of the created
 * function.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {Array} pairs The predicate-function pairs.
 * @returns {Function} Returns the new composite function.
 * @example
 *
 * var func = _.cond([
 *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
 *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
 *   [_.stubTrue,                      _.constant('no match')]
 * ]);
 *
 * func({ 'a': 1, 'b': 2 });
 * // => 'matches A'
 *
 * func({ 'a': 0, 'b': 1 });
 * // => 'matches B'
 *
 * func({ 'a': '1', 'b': '2' });
 * // => 'no match'
 */ function $6be62026d39b34ea$var$cond(pairs) {
    var length = pairs == null ? 0 : pairs.length, toIteratee = $bxDef;
    pairs = !length ? [] : $1nIHN(pairs, function(pair) {
        if (typeof pair[1] != 'function') throw new TypeError($6be62026d39b34ea$var$FUNC_ERROR_TEXT);
        return [
            toIteratee(pair[0]),
            pair[1]
        ];
    });
    return $g7i7g(function(args) {
        var index = -1;
        while(++index < length){
            var pair = pairs[index];
            if ($hlchF(pair[0], this, args)) return $hlchF(pair[1], this, args);
        }
    });
}
module.exports = $6be62026d39b34ea$var$cond;

});

parcelRegister("hMlwW", function(module, exports) {
/**
 * This method returns `true`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `true`.
 * @example
 *
 * _.times(2, _.stubTrue);
 * // => [true, true]
 */ function $cf179ed6624748c2$var$stubTrue() {
    return true;
}
module.exports = $cf179ed6624748c2$var$stubTrue;

});

parcelRegister("1U4EY", function(module, exports) {

$parcel$export(module.exports, "ConfluenceIcon", () => $6fa7705f627142aa$export$68f3db7f6af48bcb);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::14eb3f225fbad52e87a8d60eac11ccca>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3Aqws = parcelRequire("3Aqws");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $6fa7705f627142aa$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1868db)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M17.888 14.461c-4.039-1.953-5.219-2.245-6.92-2.245-1.997 0-3.699.831-5.219 3.165l-.25.382c-.204.314-.249.426-.249.561s.068.247.318.404l2.564 1.594c.136.09.25.135.363.135.136 0 .226-.068.363-.27l.408-.628c.635-.966 1.203-1.28 1.928-1.28.636 0 1.385.18 2.315.629l2.677 1.257c.272.134.567.067.704-.247l1.27-2.783c.136-.315.046-.517-.272-.674M6.112 9.545c4.039 1.953 5.219 2.245 6.92 2.245 1.997 0 3.699-.83 5.219-3.165l.25-.381c.204-.315.249-.427.249-.562 0-.134-.068-.247-.318-.404L15.87 5.685c-.137-.09-.25-.135-.364-.135-.136 0-.226.067-.363.27l-.408.628c-.635.965-1.203 1.28-1.928 1.28-.636 0-1.385-.18-2.315-.63L7.814 5.843c-.272-.135-.567-.068-.703.247L5.84 8.872c-.136.314-.045.516.272.673"/>
</svg>
`;
const $6fa7705f627142aa$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-7.032 12.217c-1.997 0-3.699.83-5.219 3.165l-.249.38c-.204.315-.25.427-.25.562s.068.247.317.404l2.565 1.594c.136.09.249.135.362.135.136 0 .227-.068.363-.27l.409-.628c.635-.966 1.202-1.28 1.928-1.28.636 0 1.384.18 2.315.63l2.677 1.256c.273.134.568.067.704-.247l1.27-2.783c.136-.315.045-.517-.272-.674-4.039-1.953-5.219-2.244-6.92-2.244m4.538-6.667c-.136 0-.227.067-.363.27l-.409.628c-.635.965-1.202 1.28-1.928 1.28-.636 0-1.384-.18-2.315-.63L7.813 5.843c-.272-.135-.567-.067-.703.247L5.84 8.872c-.136.314-.045.517.272.674 4.039 1.953 5.219 2.244 6.92 2.244 1.997 0 3.699-.83 5.219-3.165l.249-.382c.204-.314.25-.426.25-.56s-.068-.248-.317-.405l-2.565-1.593c-.136-.09-.249-.135-.362-.135"/>
</svg>
`;
function $6fa7705f627142aa$export$68f3db7f6af48bcb({ size: size, appearance: appearance = 'brand', iconColor: iconColor, label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Aqws.IconWrapper), {
        svg: $6fa7705f627142aa$var$svg,
        customThemeSvg: $6fa7705f627142aa$var$customThemeSvg,
        size: size,
        appearance: appearance,
        iconColor: iconColor,
        label: label || 'Confluence',
        testId: testId
    });
}

});
parcelRegister("3Aqws", function(module, exports) {

$parcel$export(module.exports, "IconWrapper", () => $e3ca2e1e207b2e0a$export$be58b4326e23250f);
/* icon-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

const $e3ca2e1e207b2e0a$var$styles = {
    root: "_1e0c1o8l"
};
const $e3ca2e1e207b2e0a$var$sizeMap = {
    '12': "_4t3i1crf",
    '16': "_4t3i7vkz",
    '20': "_4t3igktf",
    '24': "_4t3i1tcg",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    '32': "_4t3izwfg"
};
function $e3ca2e1e207b2e0a$export$be58b4326e23250f({ size: size = '20', label: label, svg: svg, customThemeSvg: customThemeSvg, testId: userDefinedTestId, appearance: appearance = 'brand', iconColor: iconColor }) {
    const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
    const isCustomThemed = customThemeSvg && iconColor;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": testId,
        style: {
            // The 'legacy' appearance replaces icon colors with a blue tile and white icon, controlled via CSS variables
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            [(0, $f0aa1a5001d04852$export$4a6fae78114c6824)]: appearance === 'legacy' ? 'white' : 'initial',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            [(0, $f0aa1a5001d04852$export$c59811a1f25e6288)]: appearance === 'legacy' ? '#1868DB' : 'initial',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            [(0, $f0aa1a5001d04852$export$582e20fccfce3089)]: iconColor || 'initial'
        },
        // In some icons (such as the app switcher specific icons), the label is a consumer prop.
        // If the label is provided an empty string, we want to remove the element from the accessibility tree.
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        "aria-hidden": label === '' ? true : undefined,
        // We are using dangerouslySetInnerHTML here to tell React not to track changes to the SVG elements.
        // This is because the SVG elements are static and will not change, so we get a little performance benefit by
        // bypassing React.
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, $bwpsq.default)([
            $e3ca2e1e207b2e0a$var$styles.root,
            $e3ca2e1e207b2e0a$var$sizeMap[size]
        ])
    });
}

});
const $f0aa1a5001d04852$export$4a6fae78114c6824 = '--icon-color';
const $f0aa1a5001d04852$export$c59811a1f25e6288 = '--tile-color';
const $f0aa1a5001d04852$export$582e20fccfce3089 = '--themed-icon-color';
const $f0aa1a5001d04852$export$8344f093f1e14646 = '--themed-text-color';



parcelRegister("9bk6s", function(module, exports) {

$parcel$export(module.exports, "LoomIcon", () => $17fa971fcc6756de$export$8d789f76fde3e05);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::007b7c9ae404d7e182cd5156d58e4510>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3Aqws = parcelRequire("3Aqws");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $17fa971fcc6756de$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1868db)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M19.083 11.212h-4.142l3.588-2.071-.788-1.365-3.588 2.071 2.07-3.587-1.364-.788-2.071 3.587V4.917h-1.576v4.142L9.141 5.472l-1.365.787 2.071 3.588L6.26 7.776 5.472 9.14l3.587 2.07H4.917v1.577h4.142l-3.587 2.071.788 1.365 3.587-2.07-2.071 3.587 1.365.787 2.07-3.587v4.142h1.577V14.94l2.07 3.587 1.365-.787-2.07-3.588 3.587 2.071.788-1.365-3.587-2.07h4.142zM12 14.143a2.151 2.151 0 1 1 0-4.302 2.151 2.151 0 0 1 0 4.302"/>
</svg>
`;
function $17fa971fcc6756de$export$8d789f76fde3e05({ size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Aqws.IconWrapper), {
        svg: $17fa971fcc6756de$var$svg,
        size: size,
        appearance: appearance,
        label: label || 'Loom',
        testId: testId
    });
}

});

parcelRegister("by9zw", function(module, exports) {

$parcel$export(module.exports, "TeamsIcon", () => $1ccce0d623457e70$export$1bcbc9c337da86da);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bd9106694d7b58995aa8188c7ae50b4e>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3Aqws = parcelRequire("3Aqws");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $1ccce0d623457e70$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="#dddee1" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="#101214" d="M8.06 11.25a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m7.88 0a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m.17 1.31a2.89 2.89 0 0 1 2.89 2.9V18h-7.22l1.66-3.67a2.89 2.89 0 0 1 2.67-1.77M5 15.63V18h4.81l1.31-2.81a2.63 2.63 0 0 0-2.62-2.63h-.44A3.06 3.06 0 0 0 5 15.63"/>
</svg>
`;
function $1ccce0d623457e70$export$1bcbc9c337da86da({ size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Aqws.IconWrapper), {
        svg: $1ccce0d623457e70$var$svg,
        size: size,
        appearance: appearance,
        label: label || 'Teams',
        testId: testId
    });
}

});

parcelRegister("hT1xk", function(module, exports) {

$parcel$export(module.exports, "ProjectsIcon", () => $73551489ac46d8d3$export$5ed3e1bb3b04fc02);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a989d78aaf31b3624e87e7ef6b91d018>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3Aqws = parcelRequire("3Aqws");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $73551489ac46d8d3$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="#dddee1" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="#101214" fill-rule="evenodd" d="m5.106 14.44 1.856-1.856-1.856-1.856L6.653 9.18h3.712l2.784-2.784h4.332v4.33l-2.785 2.785v3.712L13.15 18.77l-1.857-1.856-1.856 1.856-1.7-1.7 2.784-2.784-.928-.928-2.784 2.784zm10.209-4.331a1.094 1.094 0 1 1-1.547-1.546 1.094 1.094 0 0 1 1.547 1.546" clip-rule="evenodd"/>
</svg>
`;
function $73551489ac46d8d3$export$5ed3e1bb3b04fc02({ size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Aqws.IconWrapper), {
        svg: $73551489ac46d8d3$var$svg,
        size: size,
        appearance: appearance,
        label: label || 'Projects',
        testId: testId
    });
}

});

parcelRegister("lV2o9", function(module, exports) {

$parcel$export(module.exports, "OpsgenieIcon", () => $b5b863bb7a5d2bd5$export$eeccc49dc7a12d9f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::87e97e46b64fbeadb6fd54184bae149c>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3Aqws = parcelRequire("3Aqws");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $b5b863bb7a5d2bd5$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M12.696 19.45c-.49.361-.749.336-1.24-.026-2.375-1.704-4.57-3.641-6.042-5.655-.155-.207-.078-.49.155-.62l2.685-1.678q.35-.233.62.077c1.033 1.188 2.04 2.35 3.202 3.176 1.162-.826 2.17-1.988 3.202-3.176q.272-.31.62-.078l2.686 1.679c.232.13.31.413.155.62-1.472 2.014-3.667 3.95-6.043 5.68m-.62-7.411c2.118 0 3.874-1.73 3.874-3.848s-1.756-3.9-3.874-3.9c-2.117 0-3.873 1.757-3.873 3.9s1.704 3.848 3.873 3.848"/>
</svg>
`;
function $b5b863bb7a5d2bd5$export$eeccc49dc7a12d9f({ size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Aqws.IconWrapper), {
        svg: $b5b863bb7a5d2bd5$var$svg,
        size: size,
        appearance: appearance,
        label: label || 'Opsgenie',
        testId: testId
    });
}

});

parcelRegister("bfgl4", function(module, exports) {

$parcel$export(module.exports, "AssetsIcon", () => $ed432c7714773bbf$export$d89497e7f33ca6f5);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::530fc3b1534a0773e9ce61bb3e3a4cd4>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3Aqws = parcelRequire("3Aqws");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $ed432c7714773bbf$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="#ffc716" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="#101214" fill-rule="evenodd" d="M8.34 11.495a3.64 3.64 0 0 0 3.155-3.154h2.3V6.523h-2.537a3.638 3.638 0 1 0-4.735 4.735v2.538H8.34zM7.887 9.25a1.364 1.364 0 1 0 0-2.727 1.364 1.364 0 0 0 0 2.727" clip-rule="evenodd"/>
    <path fill="#101214" d="M19.25 7.43a2.27 2.27 0 1 1-4.54 0 2.27 2.27 0 0 1 4.55 0M7.43 19.25a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m9.55-.01a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m-3.18-3.19h-3.18v1.82h3.18zm2.27-5.46v3.18h1.82v-3.18z"/>
</svg>
`;
const $ed432c7714773bbf$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM7.432 14.704a2.273 2.273 0 1 0 .001 4.547 2.273 2.273 0 0 0-.001-4.547m9.545 0a2.274 2.274 0 1 0 .001 4.548 2.274 2.274 0 0 0 0-4.548m-6.364 1.364v1.819h3.183v-1.819zM7.887 4.25a3.637 3.637 0 0 0-1.365 7.009v2.537h1.819v-2.302a3.64 3.64 0 0 0 3.153-3.153h2.302V6.522h-2.537A3.64 3.64 0 0 0 7.887 4.25m8.181 6.363v3.183h1.819v-3.183zm.91-5.454a2.273 2.273 0 1 0 0 4.547 2.273 2.273 0 0 0 0-4.547M7.887 6.522a1.364 1.364 0 1 1-.002 2.729 1.364 1.364 0 0 1 .002-2.729"/>
</svg>
`;
function $ed432c7714773bbf$export$d89497e7f33ca6f5({ size: size, appearance: appearance = 'brand', iconColor: iconColor, label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Aqws.IconWrapper), {
        svg: $ed432c7714773bbf$var$svg,
        customThemeSvg: $ed432c7714773bbf$var$customThemeSvg,
        size: size,
        appearance: appearance,
        iconColor: iconColor,
        label: label || 'Assets',
        testId: testId
    });
}

});

parcelRegister("8bDjo", function(module, exports) {

$parcel$export(module.exports, "GoalsIcon", () => $412d439e1eec0fbe$export$9eb74917ea768ed4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::30841e50445a212317d93c30c1f78dcf>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3Aqws = parcelRequire("3Aqws");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $412d439e1eec0fbe$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="#dddee1" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="#101214" d="M14.352 12a2.352 2.352 0 1 1-4.704 0 2.352 2.352 0 0 1 4.704 0"/>
    <path fill="#101214" fill-rule="evenodd" d="M12 18.563a6.562 6.562 0 1 0 0-13.125 6.562 6.562 0 0 0 0 13.125M16.102 12a4.102 4.102 0 1 1-8.204 0 4.102 4.102 0 0 1 8.204 0" clip-rule="evenodd"/>
</svg>
`;
function $412d439e1eec0fbe$export$9eb74917ea768ed4({ size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Aqws.IconWrapper), {
        svg: $412d439e1eec0fbe$var$svg,
        size: size,
        appearance: appearance,
        label: label || 'Goals',
        testId: testId
    });
}

});

parcelRegister("hNQvS", function(module, exports) {

$parcel$export(module.exports, "AccountNav3", () => $4f3d32bc0399b499$export$75dc45130eee4ebb);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $921sX = parcelRequire("921sX");

var $c3PJ4 = parcelRequire("c3PJ4");
const $4f3d32bc0399b499$export$75dc45130eee4ebb = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c3PJ4.AccountInternal), {
        ...props,
        AccountMenu: (0, $921sX.AccountMenuNav3)
    });
};

});
parcelRegister("921sX", function(module, exports) {

$parcel$export(module.exports, "AccountMenuNav3", () => $0203a463eaa24bfa$export$4ff56e5cf713dc64);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7pImm = parcelRequire("7pImm");

var $eUECn = parcelRequire("eUECn");

var $1bGms = parcelRequire("1bGms");
const $0203a463eaa24bfa$export$4ff56e5cf713dc64 = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1bGms.AccountMenu), {
        ...props,
        AccountMenuLoggedOutState: (0, $7pImm.AccountMenuLoggedOutStateNav3),
        AccountMenuTrigger: (0, $eUECn.AccountMenuTriggerNav3)
    });
};

});
parcelRegister("7pImm", function(module, exports) {

$parcel$export(module.exports, "AccountMenuLoggedOutStateNav3", () => $01c9ad3322260504$export$5e6158d2118ae4aa);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8Pko5 = parcelRequire("8Pko5");

var $pkYLA = parcelRequire("pkYLA");

var $71IBF = parcelRequire("71IBF");

var $kHCo7 = parcelRequire("kHCo7");

var $cvjqp = parcelRequire("cvjqp");
const $01c9ad3322260504$export$5e6158d2118ae4aa = ({ testId: testId, logInLink: logInLink })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $8Pko5.Profile), {
        testId: testId,
        href: logInLink,
        onClick: (event, analytics)=>{
            analytics.update({
                actionSubjectId: 'logInLink'
            }).fire((0, $kHCo7.NAVIGATION_CHANNEL));
        },
        tooltip: (0, $cvjqp.logInTooltip),
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($pkYLA))), {
            color: "currentColor",
            label: "",
            LEGACY_size: "medium",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($71IBF)))
        })
    });

});
parcelRegister("kHCo7", function(module, exports) {

$parcel$export(module.exports, "NAVIGATION_CHANNEL", () => $898ad1755d1c196d$export$515664faa1398f37);
$parcel$export(module.exports, "ANALYTICS_CONTEXT", () => $898ad1755d1c196d$export$3cbe56a0cabcff38);
const $898ad1755d1c196d$export$515664faa1398f37 = 'navigation';
const $898ad1755d1c196d$export$3cbe56a0cabcff38 = {
    source: 'atlassianAccountMenu',
    componentName: 'atlassianAccountMenu',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};

});

parcelRegister("cvjqp", function(module, exports) {

$parcel$export(module.exports, "logInTooltip", () => $eaae2451158aa9d2$export$b495e6c63a3a03c1);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
const $eaae2451158aa9d2$export$b495e6c63a3a03c1 = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
    id: "identity.account-menu.account-menu-logged-out-state.log-in",
    defaultMessage: "Log in",
    description: "Tooltip for log in button when user is logged out"
});

});


parcelRegister("eUECn", function(module, exports) {

$parcel$export(module.exports, "AccountMenuTriggerNav3", () => $315290d9faf728a7$export$89d857133932d6aa);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $koVbs = parcelRequire("koVbs");

var $8Pko5 = parcelRequire("8Pko5");

var $7FST0 = parcelRequire("7FST0");

var $ezSxh = parcelRequire("ezSxh");

var $c36kZ = parcelRequire("c36kZ");
function $315290d9faf728a7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $315290d9faf728a7$var$imgStyles = {
    name: "qlds6h",
    styles: "border-radius:50%;width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px)"
};
const $315290d9faf728a7$export$89d857133932d6aa = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(({ picture: picture, email: email, trustPicture: trustPicture = false, ...props }, ref)=>{
    const intl = (0, $koVbs.default)();
    const state = (0, $ezSxh.useImageState)(picture || '');
    const tooltip = intl.formatMessage((0, $c36kZ.messages).triggerTooltip);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $8Pko5.Profile), {
        ...props,
        ref: ref,
        tooltip: email || tooltip,
        icon: picture && (trustPicture || state === 'loaded') ? /*#__PURE__*/ (0, $f8Sb3.jsx)("img", {
            css: $315290d9faf728a7$var$imgStyles,
            src: picture,
            alt: tooltip
        }) : /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7FST0))), {
            color: "currentColor",
            label: tooltip,
            LEGACY_size: "medium",
            spacing: "spacious"
        })
    });
});

});
parcelRegister("ezSxh", function(module, exports) {

$parcel$export(module.exports, "useImageState", () => $18b3dc2a6224905c$export$2c1df3428fc3264c);

var $5uXOq = parcelRequire("5uXOq");
const $18b3dc2a6224905c$export$2c1df3428fc3264c = (src)=>{
    const [state, setState] = (0, $5uXOq.useState)('pending');
    const imgRef = (0, $5uXOq.useRef)();
    (0, $5uXOq.useEffect)(()=>{
        if (!imgRef.current) {
            imgRef.current = new Image();
            imgRef.current.onload = ()=>setState('loaded');
            imgRef.current.onerror = ()=>setState('error');
        }
        setState('pending');
        imgRef.current.src = src;
    }, [
        src
    ]);
    return state;
};

});

parcelRegister("c36kZ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a31c075742ae57a6$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $a31c075742ae57a6$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    triggerTooltip: {
        id: 'identity.account-menu.account-menu-popup.skeleton.tooltip',
        defaultMessage: 'Account',
        description: 'Tooltip and alt-text for the account menu item'
    }
});

});


parcelRegister("1bGms", function(module, exports) {

$parcel$export(module.exports, "AccountMenu", () => $eb480c5bace8303e$export$ff20d75d5eda4388);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $1PVpv = parcelRequire("1PVpv");

var $kHCo7 = parcelRequire("kHCo7");

var $6EBh3 = parcelRequire("6EBh3");

var $8NZjk = parcelRequire("8NZjk");

var $fnXLr = parcelRequire("fnXLr");
const $eb480c5bace8303e$export$ff20d75d5eda4388 = ({ testId: testId, name: name, picture: picture, email: email, managedBy: managedBy, manageProfileLink: manageProfileLink, viewProfileLink: viewProfileLink, onViewProfileClick: onViewProfileClick, switchAccountLink: switchAccountLink, logOutLink: logOutLink, logInLink: logInLink, onThemeChange: onThemeChange, currentTheme: currentTheme, extraMenuItems: extraMenuItems, trustPicture: trustPicture = false, AccountMenuLoggedOutState: AccountMenuLoggedOutState, AccountMenuTrigger: AccountMenuTrigger })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $1PVpv.NavigationAnalyticsContext), {
        data: (0, $kHCo7.ANALYTICS_CONTEXT),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8NZjk.AccountMenuIntlProvider), {
            children: logInLink ? /*#__PURE__*/ (0, $2OMIu.jsx)(AccountMenuLoggedOutState, {
                testId: testId && `${testId}--logged-out-state`,
                logInLink: logInLink
            }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fnXLr.AccountMenuPopup), {
                testId: testId,
                picture: picture,
                trustPicture: trustPicture,
                email: email,
                AccountMenuTrigger: AccountMenuTrigger,
                content: ({ onClose: closePopup })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $6EBh3.AccountMenuContent), {
                        testId: testId && `${testId}--content`,
                        closePopup: closePopup,
                        name: name,
                        picture: picture,
                        email: email,
                        managedBy: managedBy,
                        manageProfileLink: manageProfileLink,
                        viewProfileLink: viewProfileLink,
                        onViewProfileClick: onViewProfileClick,
                        switchAccountLink: switchAccountLink,
                        logOutLink: logOutLink,
                        onThemeChange: onThemeChange,
                        currentTheme: currentTheme,
                        extraMenuItems: extraMenuItems
                    })
            })
        })
    });

});
parcelRegister("6EBh3", function(module, exports) {

$parcel$export(module.exports, "AccountMenuContent", () => $174fca08ce98c8fc$export$49c2771125e1e9f1);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $ousew = parcelRequire("ousew");


var $2NMNM = parcelRequire("2NMNM");

var $6q3np = parcelRequire("6q3np");

var $k2tiP = parcelRequire("k2tiP");

var $fptva = parcelRequire("fptva");

var $1bKdn = parcelRequire("1bKdn");

var $bxqXD = parcelRequire("bxqXD");

var $dNE6G = parcelRequire("dNE6G");

var $d9wnW = parcelRequire("d9wnW");

var $3Z96c = parcelRequire("3Z96c");
var $eZUJu = parcelRequire("eZUJu");
var $9UCCQ = parcelRequire("9UCCQ");

var $k5uoT = parcelRequire("k5uoT");

var $kHCo7 = parcelRequire("kHCo7");

var $1j5Ak = parcelRequire("1j5Ak");

var $chqbk = parcelRequire("chqbk");

var $bWGt6 = parcelRequire("bWGt6");
const $174fca08ce98c8fc$export$49c2771125e1e9f1 = ({ testId: testId, closePopup: closePopup, name: name, picture: picture, email: email, managedBy: managedBy, manageProfileLink: manageProfileLink, viewProfileLink: viewProfileLink, onViewProfileClick: onViewProfileClick, switchAccountLink: switchAccountLink, logOutLink: logOutLink, onThemeChange: onThemeChange, currentTheme: currentTheme, extraMenuItems: extraMenuItems = null })=>{
    const themeSwitcherProps = onThemeChange && currentTheme;
    const shouldRenderProfileThemeSwitcherSection = Boolean(viewProfileLink || manageProfileLink || themeSwitcherProps);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($174fca08ce98c8fc$var$Container, {
        "data-testid": testId
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $eZUJu.default), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9UCCQ.default), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1j5Ak.AccountDetails), {
        testId: testId && `${testId}--details`,
        name: name,
        picture: picture,
        email: email,
        managedBy: managedBy
    })), shouldRenderProfileThemeSwitcherSection && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9UCCQ.default), null, viewProfileLink && /*#__PURE__*/ (0, $f8Sb3.jsx)($174fca08ce98c8fc$var$ViewProfileLink, {
        onClick: onViewProfileClick,
        testId: testId && `${testId}--view-profile`,
        href: viewProfileLink,
        closePopup: closePopup
    }), manageProfileLink && /*#__PURE__*/ (0, $f8Sb3.jsx)($174fca08ce98c8fc$var$ManageProfileLink, {
        testId: testId && `${testId}--manage-profile`,
        href: manageProfileLink,
        closePopup: closePopup
    }), themeSwitcherProps && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $chqbk.ThemeSwitcher), {
        testId: testId && `${testId}--theme-switcher`,
        onThemeChange: onThemeChange,
        currentTheme: currentTheme
    })), extraMenuItems, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9UCCQ.default), {
        hasSeparator: shouldRenderProfileThemeSwitcherSection
    }, switchAccountLink && /*#__PURE__*/ (0, $f8Sb3.jsx)($174fca08ce98c8fc$var$SwitchAccountLink, {
        testId: testId && `${testId}--switch-account`,
        href: switchAccountLink,
        closePopup: closePopup
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)($174fca08ce98c8fc$var$LogOutLink, {
        testId: testId && `${testId}--log-out`,
        href: logOutLink,
        closePopup: closePopup
    }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $174fca08ce98c8fc$var$Container = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "evherry0"
})({
    boxSizing: 'border-box',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minWidth: (0, $k5uoT.gridSize)() * 38
});
const $174fca08ce98c8fc$var$ViewProfileLink = ({ testId: testId, href: href, onClick: onClick, closePopup: closePopup })=>/*#__PURE__*/ (0, $f8Sb3.jsx)($174fca08ce98c8fc$var$Link, {
        testId: testId,
        href: href,
        onClick: onClick,
        icon: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1bKdn))), {
            color: "currentColor",
            label: "",
            LEGACY_size: "medium",
            LEGACY_fallbackIcon: (0, $dNE6G.default)
        }),
        closePopup: closePopup,
        actionSubjectId: "viewProfileLink"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ousew.default), {
        id: "identity.account-menu.account-details.view-profile-tooltip",
        defaultMessage: "Profile",
        description: "Text shown when hovering over profile information"
    }));
const $174fca08ce98c8fc$var$ManageProfileLink = ({ testId: testId, href: href, closePopup: closePopup })=>/*#__PURE__*/ (0, $f8Sb3.jsx)($174fca08ce98c8fc$var$Link, {
        testId: testId,
        href: href,
        icon: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($k2tiP))), {
            color: "currentColor",
            label: "",
            LEGACY_size: "medium"
        }),
        closePopup: closePopup,
        actionSubjectId: "manageProfileLink",
        target: "_blank",
        rel: "noopener"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ousew.default), {
        id: "identity.account-menu.account-details.manage-profile-link",
        defaultMessage: "Account settings",
        description: "Text for link to account management page"
    }));
const $174fca08ce98c8fc$var$SwitchAccountLink = ({ testId: testId, href: href, closePopup: closePopup })=>/*#__PURE__*/ (0, $f8Sb3.jsx)($174fca08ce98c8fc$var$Link, {
        testId: testId,
        icon: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fptva))), {
            color: "currentColor",
            label: "",
            LEGACY_size: "medium",
            LEGACY_fallbackIcon: (0, $bxqXD.default)
        }),
        href: href,
        closePopup: closePopup,
        actionSubjectId: "switchAccountLink"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ousew.default), {
        id: "identity.account-menu.account-menu-content.switch-account-button",
        defaultMessage: "Switch account",
        description: "Label for button in account menu to switch to another another account"
    }));
const $174fca08ce98c8fc$var$LogOutLink = ({ testId: testId, href: href, closePopup: closePopup })=>/*#__PURE__*/ (0, $f8Sb3.jsx)($174fca08ce98c8fc$var$Link, {
        testId: testId,
        icon: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6q3np))), {
            color: "currentColor",
            label: "",
            LEGACY_size: "medium",
            LEGACY_fallbackIcon: (0, $d9wnW.default)
        }),
        href: href,
        closePopup: closePopup,
        actionSubjectId: "logOutLink"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ousew.default), {
        id: "identity.account-menu.account-menu-content.log-out-button",
        defaultMessage: "Log out",
        description: "Label for button in account menu to log out"
    }));
const $174fca08ce98c8fc$var$Link = ({ testId: testId, closePopup: closePopup, icon: icon, href: href, onClick: onClick, actionSubjectId: actionSubjectId, children: children, ...props })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const handleClick = (0, $5uXOq.useCallback)((event)=>{
        const analyticsEvent = createAnalyticsEvent({
            eventType: (0, $676c5e519aa5ba55$export$a1562d08625f5d7e),
            action: 'clicked',
            actionSubject: 'menuLinkItem',
            actionSubjectId: actionSubjectId
        });
        const clone = analyticsEvent.clone();
        if (clone) clone.fire((0, $kHCo7.NAVIGATION_CHANNEL));
        onClick?.(event, analyticsEvent);
        closePopup?.(event);
    }, [
        createAnalyticsEvent,
        onClick,
        closePopup,
        actionSubjectId
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3Z96c.default), {
        testId: testId,
        iconBefore: icon,
        href: href,
        onClick: handleClick,
        ...props
    }, children);
};

});
// same types defined in analytics-web-client but avoid creating dependency with that
const $676c5e519aa5ba55$export$a1562d08625f5d7e = 'ui';
const $676c5e519aa5ba55$export$947dac6c72b26f81 = 'track';
const $676c5e519aa5ba55$export$f1d537d508d2945a = 'screen';
const $676c5e519aa5ba55$export$12346a674644c156 = 'operational';
const $676c5e519aa5ba55$export$b055de0e665cb20c = 'unknown';

parcelRegister("1j5Ak", function(module, exports) {

$parcel$export(module.exports, "AccountDetails", () => $44d42378b5c841d1$export$66e04d0aacdb3b2);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $ousew = parcelRequire("ousew");

var $1bKdn = parcelRequire("1bKdn");

var $dNE6G = parcelRequire("dNE6G");

var $dS3PR = parcelRequire("dS3PR");


var $k5uoT = parcelRequire("k5uoT");

var $aOl2M = parcelRequire("aOl2M");

var $9FNiA = parcelRequire("9FNiA");

var $bWGt6 = parcelRequire("bWGt6");
function $44d42378b5c841d1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $44d42378b5c841d1$export$66e04d0aacdb3b2 = ({ testId: testId, name: name, picture: picture, email: email, managedBy: managedBy })=>/*#__PURE__*/ (0, $f8Sb3.jsx)($44d42378b5c841d1$var$Container, {
        "data-testid": testId
    }, managedBy && /*#__PURE__*/ (0, $f8Sb3.jsx)($44d42378b5c841d1$var$ManagedBy, null, /*#__PURE__*/ (0, $f8Sb3.jsx)($44d42378b5c841d1$var$PersonIconWrapper, null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1bKdn))), {
        color: "currentColor",
        label: "",
        LEGACY_size: "small",
        LEGACY_fallbackIcon: (0, $dNE6G.default)
    })), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ousew.default), {
        id: "identity.account-menu.account-menu-details.managed-account",
        defaultMessage: "This account is managed by <b>{managedBy}</b>",
        description: "Label showing the user which organisation manages their Atlassian account",
        values: {
            b: (text)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dS3PR.default), {
                    as: "strong",
                    size: "small",
                    color: "inherit"
                }, text),
            managedBy: managedBy
        }
    })), /*#__PURE__*/ (0, $f8Sb3.jsx)($44d42378b5c841d1$var$Content, {
        hasHeader: !!managedBy
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)($44d42378b5c841d1$var$Profile, {
        testId: testId,
        name: name,
        picture: picture,
        email: email
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $44d42378b5c841d1$var$Container = /*#__PURE__*/ (0, $bWGt6.default)("section", {
    target: "e3lis067"
})({
    display: 'flex',
    flexDirection: 'column',
    margin: `0 ${"var(--ds-space-100, 8px)"}`
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $44d42378b5c841d1$var$ManagedBy = /*#__PURE__*/ (0, $bWGt6.default)("small", {
    target: "e3lis066"
})({
    display: 'box',
    margin: '0px',
    padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-100, 8px)"}`,
    textAlign: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `${(0, $k5uoT.borderRadius)()}px ${(0, $k5uoT.borderRadius)()}px 0 0`,
    background: `var(--ds-background-information, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
    color: "var(--ds-text-subtle, #44546F)"
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $44d42378b5c841d1$var$PersonIconWrapper = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "e3lis065"
})({
    name: "1d1sf9j",
    styles: "margin-right:var(--ds-space-050, 4px);& > span{width:12px;height:12px;}"
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $44d42378b5c841d1$var$Content = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e3lis064"
})({
    display: 'flex',
    flexDirection: 'column',
    background: `var(--ds-surface-sunken, ${(0, $829f609a65d26a98$export$8d43898f60b96a82)})`
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ hasHeader: hasHeader })=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderRadius: hasHeader ? `0 0 ${(0, $k5uoT.borderRadius)()}px ${(0, $k5uoT.borderRadius)()}px` : `${(0, $k5uoT.borderRadius)()}px`
    }));
const $44d42378b5c841d1$var$Profile = ({ name: name, email: email, picture: picture, testId: testId })=>/*#__PURE__*/ (0, $f8Sb3.jsx)($44d42378b5c841d1$var$ProfileWrapper, null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $aOl2M.ProfilePicture), {
        src: picture,
        size: (0, $k5uoT.gridSize)() * 8,
        testId: testId && `${testId}--picture`
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)($44d42378b5c841d1$var$NameAndEmail, null, /*#__PURE__*/ (0, $f8Sb3.jsx)($44d42378b5c841d1$var$DisplayName, {
        "data-testid": testId && `${testId}--name`
    }, name || /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9FNiA.SkeletonText), {
        length: "6em"
    })), /*#__PURE__*/ (0, $f8Sb3.jsx)($44d42378b5c841d1$var$EmailAddress, {
        "data-testid": testId && `${testId}--email`
    }, email || /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9FNiA.SkeletonText), {
        length: "10em"
    }))));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $44d42378b5c841d1$var$ProfileWrapper = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e3lis063"
})({
    display: 'flex',
    flexDirection: 'row',
    margin: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-200, 16px)"}`
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $44d42378b5c841d1$var$NameAndEmail = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e3lis062"
})({
    display: 'flex',
    flexDirection: 'column',
    margin: `auto 0 auto ${"var(--ds-space-200, 16px)"}`
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $44d42378b5c841d1$var$DisplayName = /*#__PURE__*/ (0, $bWGt6.default)("h3", {
    target: "e3lis061"
})({
    color: `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`,
    margin: 0
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $44d42378b5c841d1$var$EmailAddress = /*#__PURE__*/ (0, $bWGt6.default)("p", {
    target: "e3lis060"
})({
    name: "1e1erj1",
    styles: "margin-top:var(--ds-space-025, 2px);color:var(--ds-text-subtlest, #626F86);font-weight:var(--ds-font-weight-regular, 400)"
});

});
parcelRegister("aOl2M", function(module, exports) {

$parcel$export(module.exports, "ProfilePicture", () => $7e3ebb52190c5aa0$export$2d75367b6e042d67);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $7FST0 = parcelRequire("7FST0");


var $ezSxh = parcelRequire("ezSxh");
function $7e3ebb52190c5aa0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7e3ebb52190c5aa0$var$imgStyles = {
    name: "1b6qxg",
    styles: "display:block;border-radius:50%"
};
const $7e3ebb52190c5aa0$export$2d75367b6e042d67 = ({ testId: testId, src: src, size: size, className: className })=>{
    const state = (0, $ezSxh.useImageState)(src || '');
    const displayImage = src && state === 'loaded';
    const displayFallback = src && state === 'error';
    const displaySkeleton = !displayImage && !displayFallback;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: (0, $f8Sb3.css)({
            width: size,
            height: size,
            ...displaySkeleton && {
                borderRadius: '50%',
                backgroundColor: `var(--ds-background-neutral, ${0, $829f609a65d26a98$export$8d43898f60b96a82})`
            },
            '& svg, & img': {
                width: size,
                height: size
            }
        })
    }, displayImage && /*#__PURE__*/ (0, $f8Sb3.jsx)("img", {
        "data-testid": testId && `${testId}--img`,
        src: src,
        css: $7e3ebb52190c5aa0$var$imgStyles
    }), displayFallback && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7FST0))), {
        spacing: "spacious",
        testId: testId && `${testId}--fallback`,
        label: "",
        color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$7c87d337fb91a97d)})`,
        LEGACY_secondaryColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`
    }));
};

});

parcelRegister("9FNiA", function(module, exports) {

$parcel$export(module.exports, "SkeletonText", () => $bc870af4b63b46f6$export$cb6ddd830302c2a8);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $bWGt6 = parcelRequire("bWGt6");
const $bc870af4b63b46f6$export$cb6ddd830302c2a8 = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "ej73sxo0"
})({
    display: 'inline-block',
    height: '1em',
    borderRadius: '0.5em',
    backgroundColor: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$8d43898f60b96a82)})`
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
({ length: length })=>({
        width: length
    }));

});


parcelRegister("chqbk", function(module, exports) {

$parcel$export(module.exports, "ThemeSwitcher", () => $c95b2c70e6cea885$export$9d63163ee2173b37);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7VHMR = parcelRequire("7VHMR");
var $ousew = parcelRequire("ousew");

var $BLPHT = parcelRequire("BLPHT");
var $a5n5E = parcelRequire("a5n5E");

var $826f6 = parcelRequire("826f6");

var $hWZau = parcelRequire("hWZau");

var $ex8Nz = parcelRequire("ex8Nz");

var $kJpBP = parcelRequire("kJpBP");

var $alVRE = parcelRequire("alVRE");

var $cImN7 = parcelRequire("cImN7");

var $9DQk8 = parcelRequire("9DQk8");

var $bWGt6 = parcelRequire("bWGt6");
function $c95b2c70e6cea885$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c95b2c70e6cea885$export$9d63163ee2173b37 = ({ testId: testId, onThemeChange: onThemeChange, currentTheme: currentTheme })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $BLPHT.default), {
        testId: testId,
        placement: "auto-start",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $kJpBP.default), {
                ref: triggerRef,
                onClick: (event)=>event.stopPropagation(),
                iconBefore: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($826f6))), {
                    color: "currentColor",
                    label: "",
                    LEGACY_fallbackIcon: (0, $ex8Nz.default)
                }),
                iconAfter: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hWZau))), {
                    color: "currentColor",
                    label: ""
                }),
                ...props,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    id: "identity.account-menu.theme-switcher.theme-button",
                    defaultMessage: "Theme",
                    description: "Label for button in the account menu to switch to a different theme"
                })
            }),
        children: $c95b2c70e6cea885$var$themeOptions.map(({ label: label, value: value, thumbnail: thumbnail })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $a5n5E.default), {
                testId: `${testId}--radio-${value}`,
                id: value,
                onClick: ()=>onThemeChange(value),
                isSelected: currentTheme === value,
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)($c95b2c70e6cea885$var$RadioLabelContainer, {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
                            src: thumbnail,
                            width: 64,
                            height: 48,
                            alt: ""
                        }),
                        label
                    ]
                })
            }, value))
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c95b2c70e6cea885$var$RadioLabelContainer = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1q43w0o0"
})({
    name: "ql53ha",
    styles: "display:flex;align-items:center;gap:var(--ds-space-150, 12px)"
});
const $c95b2c70e6cea885$var$messages = (0, $7VHMR.defineMessages)({
    light: {
        id: 'identity.account-menu.theme-switcher.light.option',
        defaultMessage: 'Light',
        description: 'Label for the theme switcher light option'
    },
    dark: {
        id: 'identity.account-menu.theme-switcher.dark.option',
        defaultMessage: 'Dark',
        description: 'Label for the theme switcher dark option'
    },
    matchBrowser: {
        id: 'identity.account-menu.theme-switcher.match-browser.option',
        defaultMessage: 'Match browser',
        description: 'Label for the theme switcher match browser option'
    }
});
const $c95b2c70e6cea885$var$themeOptions = [
    {
        label: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...$c95b2c70e6cea885$var$messages.light
        }),
        value: 'light',
        thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($cImN7)))
    },
    {
        label: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...$c95b2c70e6cea885$var$messages.dark
        }),
        value: 'dark',
        thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($alVRE)))
    },
    {
        label: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...$c95b2c70e6cea885$var$messages.matchBrowser
        }),
        value: 'auto',
        thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($9DQk8)))
    }
];

});
parcelRegister("alVRE", function(module, exports) {
module.exports = new URL("dark-mode.fd95cecc.svg", import.meta.url).toString();

});

parcelRegister("cImN7", function(module, exports) {
module.exports = new URL("light-mode.9ae6186d.svg", import.meta.url).toString();

});

parcelRegister("9DQk8", function(module, exports) {
module.exports = new URL("match-browser.defc82cb.svg", import.meta.url).toString();

});



parcelRegister("8NZjk", function(module, exports) {

$parcel$export(module.exports, "AccountMenuIntlProvider", () => $ba982ee9af94b9bc$export$6c1f1571e3dd1b34);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $i5FdW = parcelRequire("i5FdW");
var $koVbs = parcelRequire("koVbs");

var $5ZCUE = parcelRequire("5ZCUE");
const $ba982ee9af94b9bc$export$6c1f1571e3dd1b34 = ({ children: children })=>{
    const { locale: locale } = (0, $koVbs.default)();
    const messages = $ba982ee9af94b9bc$var$useMessages(locale);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
        locale: locale,
        messages: messages,
        children: children
    });
};
const $ba982ee9af94b9bc$var$useMessages = (locale)=>{
    const [messages, setMessages] = (0, $5uXOq.useState)();
    (0, $5uXOq.useEffect)(()=>{
        if (/^en(-US)?$/i.exec(locale)) // Use fallback messages, which are already US English
        setMessages(undefined);
        else {
            let cancelled = false;
            $ba982ee9af94b9bc$var$loadMessages(locale).catch((_error)=>undefined) // TODO: Log error somehow (analytics?)
            .then((messages)=>{
                if (!cancelled) setMessages(messages);
            });
            return ()=>{
                cancelled = true;
            };
        }
    }, [
        locale,
        setMessages
    ]);
    return messages;
};
const $ba982ee9af94b9bc$var$loadMessages = async (locale)=>{
    let [language, region = ''] = locale.split('-', 2);
    language = language.toLowerCase();
    region = region.toUpperCase();
    return (await ((0, $5ZCUE.default)[`${language}_${region}`] || (0, $5ZCUE.default)[language])?.())?.default;
};

});
parcelRegister("5ZCUE", function(module, exports) {

$parcel$export(module.exports, "default", () => $7372768e0fc82eee$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated by scripts/generate-i18n-index.ts.
 * DO NOT UPDATE IT BY HAND. Instead, run yarn generate-i18n-index.
 */ 










































const $7372768e0fc82eee$var$lazyMessages = {
    cs: ()=>(parcelRequire("dg8vg")),
    cs_CZ: ()=>(parcelRequire("aPzeH")),
    da: ()=>(parcelRequire("joO78")),
    da_DK: ()=>(parcelRequire("aTL8U")),
    de: ()=>(parcelRequire("b6U8D")),
    de_DE: ()=>(parcelRequire("4BRjM")),
    en_GB: ()=>(parcelRequire("bi58P")),
    en_ZZ: ()=>(parcelRequire("j4b54")),
    es: ()=>(parcelRequire("gtHb1")),
    fi: ()=>(parcelRequire("aHsth")),
    fi_FI: ()=>(parcelRequire("jCRyS")),
    fr: ()=>(parcelRequire("5M2v4")),
    fr_FR: ()=>(parcelRequire("b5smI")),
    hu: ()=>(parcelRequire("iRPPk")),
    hu_HU: ()=>(parcelRequire("73FOZ")),
    it: ()=>(parcelRequire("cp0v0")),
    it_IT: ()=>(parcelRequire("fuPrz")),
    ja: ()=>(parcelRequire("cTa25")),
    ja_JP: ()=>(parcelRequire("bFB2v")),
    ko: ()=>(parcelRequire("4GDtF")),
    ko_KR: ()=>(parcelRequire("7JZZW")),
    nb: ()=>(parcelRequire("dfkGl")),
    nb_NO: ()=>(parcelRequire("f8G56")),
    nl: ()=>(parcelRequire("iuAyS")),
    nl_NL: ()=>(parcelRequire("6oDEt")),
    pl: ()=>(parcelRequire("Xr554")),
    pl_PL: ()=>(parcelRequire("IHcuD")),
    pt_BR: ()=>(parcelRequire("g4qqM")),
    ru: ()=>(parcelRequire("eHXys")),
    ru_RU: ()=>(parcelRequire("cLJff")),
    sv: ()=>(parcelRequire("eZGv3")),
    sv_SE: ()=>(parcelRequire("dbY0e")),
    th: ()=>(parcelRequire("ffign")),
    th_TH: ()=>(parcelRequire("1qVPX")),
    tr: ()=>(parcelRequire("lga5v")),
    tr_TR: ()=>(parcelRequire("7YbCt")),
    uk: ()=>(parcelRequire("ehr7b")),
    uk_UA: ()=>(parcelRequire("9qnRD")),
    vi: ()=>(parcelRequire("35biF")),
    vi_VN: ()=>(parcelRequire("lA13H")),
    zh: ()=>(parcelRequire("lUau8")),
    zh_CN: ()=>(parcelRequire("eLMj9")),
    zh_TW: ()=>(parcelRequire("lYmnt"))
};
var $7372768e0fc82eee$export$2e2bcd8739ae039 = $7372768e0fc82eee$var$lazyMessages;

});
parcelRegister("dg8vg", function(module, exports) {

let $9a735d90eed33ea5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9a735d90eed33ea5$var$load("6xsCn").then(()=>parcelRequire('be02C'));

});

parcelRegister("aPzeH", function(module, exports) {

let $7e29ffeeab6fd4f4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7e29ffeeab6fd4f4$var$load("bm3Jf").then(()=>parcelRequire('fEJZa'));

});

parcelRegister("joO78", function(module, exports) {

let $e1f721d41cff64b2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e1f721d41cff64b2$var$load("1dkiR").then(()=>parcelRequire('aOZ9H'));

});

parcelRegister("aTL8U", function(module, exports) {

let $7ef39bfd9a939d11$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7ef39bfd9a939d11$var$load("a1RPQ").then(()=>parcelRequire('45iy5'));

});

parcelRegister("b6U8D", function(module, exports) {

let $816bcd2373458453$var$load = (parcelRequire("28QjX"))(4);
module.exports = $816bcd2373458453$var$load("2aCrc").then(()=>parcelRequire('bkd7P'));

});

parcelRegister("4BRjM", function(module, exports) {

let $35b3f9f8068f299a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $35b3f9f8068f299a$var$load("2CfMk").then(()=>parcelRequire('9uLfO'));

});

parcelRegister("bi58P", function(module, exports) {

let $83855d1a23bef9eb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $83855d1a23bef9eb$var$load("enkb5").then(()=>parcelRequire('4deUn'));

});

parcelRegister("j4b54", function(module, exports) {

let $de16fc72a670fd1d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $de16fc72a670fd1d$var$load("u5NS4").then(()=>parcelRequire('5hPMC'));

});

parcelRegister("gtHb1", function(module, exports) {

let $bff0d8c31adda1e7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bff0d8c31adda1e7$var$load("3ikXM").then(()=>parcelRequire('3Nhdd'));

});

parcelRegister("aHsth", function(module, exports) {

let $7ca40155eb6cb6e6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7ca40155eb6cb6e6$var$load("d80uG").then(()=>parcelRequire('dQ2b1'));

});

parcelRegister("jCRyS", function(module, exports) {

let $e49b1d244219186b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e49b1d244219186b$var$load("cTfSM").then(()=>parcelRequire('8KVwU'));

});

parcelRegister("5M2v4", function(module, exports) {

let $43435ff008b696f6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $43435ff008b696f6$var$load("54XZx").then(()=>parcelRequire('cJg6M'));

});

parcelRegister("b5smI", function(module, exports) {

let $81262a1f3711af3a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $81262a1f3711af3a$var$load("3OwB4").then(()=>parcelRequire('7Cp6N'));

});

parcelRegister("iRPPk", function(module, exports) {

let $dbc560f506db244c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $dbc560f506db244c$var$load("2Ck49").then(()=>parcelRequire('S4yUH'));

});

parcelRegister("73FOZ", function(module, exports) {

let $523941129f8f2796$var$load = (parcelRequire("28QjX"))(4);
module.exports = $523941129f8f2796$var$load("7TFLj").then(()=>parcelRequire('7zGoD'));

});

parcelRegister("cp0v0", function(module, exports) {

let $907834ee7774558a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $907834ee7774558a$var$load("7sQIY").then(()=>parcelRequire('5i7M2'));

});

parcelRegister("fuPrz", function(module, exports) {

let $b481900215fa50bb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b481900215fa50bb$var$load("fERvE").then(()=>parcelRequire('43bOU'));

});

parcelRegister("cTa25", function(module, exports) {

let $9622675cd474bd69$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9622675cd474bd69$var$load("55BcE").then(()=>parcelRequire('6xXDZ'));

});

parcelRegister("bFB2v", function(module, exports) {

let $87f041510c7f7c13$var$load = (parcelRequire("28QjX"))(4);
module.exports = $87f041510c7f7c13$var$load("caNVK").then(()=>parcelRequire('4k0qc'));

});

parcelRegister("4GDtF", function(module, exports) {

let $3699b512ff7af082$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3699b512ff7af082$var$load("kWsEM").then(()=>parcelRequire('hiq6X'));

});

parcelRegister("7JZZW", function(module, exports) {

let $5a2cd3e910c09a58$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5a2cd3e910c09a58$var$load("bIh6w").then(()=>parcelRequire('9iT7G'));

});

parcelRegister("dfkGl", function(module, exports) {

let $9a4cb8111299ddef$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9a4cb8111299ddef$var$load("tpsMe").then(()=>parcelRequire('ay7Tg'));

});

parcelRegister("f8G56", function(module, exports) {

let $b0583ed4814d620f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b0583ed4814d620f$var$load("7veoT").then(()=>parcelRequire('emQME'));

});

parcelRegister("iuAyS", function(module, exports) {

let $d76763b465a1bf51$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d76763b465a1bf51$var$load("hUeST").then(()=>parcelRequire('og1G8'));

});

parcelRegister("6oDEt", function(module, exports) {

let $4a83bdfd30d488ad$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4a83bdfd30d488ad$var$load("g3oWc").then(()=>parcelRequire('blySf'));

});

parcelRegister("Xr554", function(module, exports) {

let $0b2a8483d3881654$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0b2a8483d3881654$var$load("4wfhj").then(()=>parcelRequire('az1yO'));

});

parcelRegister("IHcuD", function(module, exports) {

let $08659ee54416608d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $08659ee54416608d$var$load("e0n0c").then(()=>parcelRequire('dH96e'));

});

parcelRegister("g4qqM", function(module, exports) {

let $bb3185b28b36dcd9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bb3185b28b36dcd9$var$load("480TZ").then(()=>parcelRequire('ivYay'));

});

parcelRegister("eHXys", function(module, exports) {

let $ab53472bbaa677bd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ab53472bbaa677bd$var$load("7dBw2").then(()=>parcelRequire('82gce'));

});

parcelRegister("cLJff", function(module, exports) {

let $94bcf888f2439264$var$load = (parcelRequire("28QjX"))(4);
module.exports = $94bcf888f2439264$var$load("ihWrE").then(()=>parcelRequire('jwhuy'));

});

parcelRegister("eZGv3", function(module, exports) {

let $aea7bacde8cc784f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $aea7bacde8cc784f$var$load("lniNU").then(()=>parcelRequire('29C6m'));

});

parcelRegister("dbY0e", function(module, exports) {

let $99aad8bbb6bcbac5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $99aad8bbb6bcbac5$var$load("6nsC3").then(()=>parcelRequire('9c5wb'));

});

parcelRegister("ffign", function(module, exports) {

let $b1966c6396a75b9f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b1966c6396a75b9f$var$load("9y9OJ").then(()=>parcelRequire('coREq'));

});

parcelRegister("1qVPX", function(module, exports) {

let $10b515660e435076$var$load = (parcelRequire("28QjX"))(4);
module.exports = $10b515660e435076$var$load("hEl7z").then(()=>parcelRequire('9ajce'));

});

parcelRegister("lga5v", function(module, exports) {

let $f7a2eacd4a960559$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f7a2eacd4a960559$var$load("80pzY").then(()=>parcelRequire('4bIqg'));

});

parcelRegister("7YbCt", function(module, exports) {

let $5cd726641dc26979$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5cd726641dc26979$var$load("f95gj").then(()=>parcelRequire('ggsS6'));

});

parcelRegister("ehr7b", function(module, exports) {

let $a657afa9e93b3d97$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a657afa9e93b3d97$var$load("2S8nC").then(()=>parcelRequire('cupFd'));

});

parcelRegister("9qnRD", function(module, exports) {

let $6dc90da9be6d6872$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6dc90da9be6d6872$var$load("eYFe9").then(()=>parcelRequire('eMuwP'));

});

parcelRegister("35biF", function(module, exports) {

let $23ea9ab556f13770$var$load = (parcelRequire("28QjX"))(4);
module.exports = $23ea9ab556f13770$var$load("2GiCZ").then(()=>parcelRequire('ij9vB'));

});

parcelRegister("lA13H", function(module, exports) {

let $fb5dc7fe191d635a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fb5dc7fe191d635a$var$load("1QCBh").then(()=>parcelRequire('huT3J'));

});

parcelRegister("lUau8", function(module, exports) {

let $ff26f60bf8a6e852$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ff26f60bf8a6e852$var$load("2WqLS").then(()=>parcelRequire('bcwNS'));

});

parcelRegister("eLMj9", function(module, exports) {

let $ac0aed70268de9d2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ac0aed70268de9d2$var$load("eqBJY").then(()=>parcelRequire('aUjDR'));

});

parcelRegister("lYmnt", function(module, exports) {

let $0420c881413c373d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0420c881413c373d$var$load("l28up").then(()=>parcelRequire('ecDM5'));

});



parcelRegister("fnXLr", function(module, exports) {

$parcel$export(module.exports, "AccountMenuPopup", () => $8d206fa9e8c3fd62$export$473cb05bf335b0e1);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");


var $c543i = parcelRequire("c543i");

var $1I7E8 = parcelRequire("1I7E8");

var $kHCo7 = parcelRequire("kHCo7");
const $8d206fa9e8c3fd62$export$473cb05bf335b0e1 = ({ testId: testId, picture: picture, email: email, content: content, trustPicture: trustPicture = false, AccountMenuTrigger: AccountMenuTrigger })=>{
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const close = (0, $c543i.useCallbackWithAnalytics)(()=>setIsOpen(false), {
        eventType: (0, $676c5e519aa5ba55$export$a1562d08625f5d7e),
        action: 'closed',
        actionSubject: 'popup',
        actionSubjectId: 'accountMenu'
    }, (0, $kHCo7.NAVIGATION_CHANNEL));
    const open = (0, $c543i.useCallbackWithAnalytics)(()=>setIsOpen(true), {
        eventType: (0, $676c5e519aa5ba55$export$a1562d08625f5d7e),
        action: 'opened',
        actionSubject: 'popup',
        actionSubjectId: 'accountMenu'
    }, (0, $kHCo7.NAVIGATION_CHANNEL));
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1I7E8.default), {
        isOpen: isOpen,
        onClose: close,
        testId: testId,
        placement: "bottom",
        trigger: (triggerProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)(AccountMenuTrigger, {
                onClick: isOpen ? close : open,
                testId: testId && `${testId}--trigger`,
                picture: picture,
                email: email,
                trustPicture: trustPicture,
                ...triggerProps
            }),
        content: content
    });
};

});



parcelRegister("c3PJ4", function(module, exports) {

$parcel$export(module.exports, "AccountInternal", () => $143e7286324278e8$export$df97669773647652);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $I5fLT = parcelRequire("I5fLT");
const $143e7286324278e8$export$df97669773647652 = ({ identityEnvironment: identityEnvironment, application: application, continueUrl: continueUrl, logOutContinueUrl: logOutContinueUrl, isLoggedOut: isLoggedOut, disableSwitchAccountLink: disableSwitchAccountLink, AccountMenu: AccountMenu, ...props })=>{
    const links = (0, $I5fLT.useAccountLinks)({
        email: props.email,
        identityEnvironment: identityEnvironment,
        application: application,
        continueUrl: continueUrl,
        logOutContinueUrl: logOutContinueUrl,
        isLoggedOut: isLoggedOut,
        disableSwitchAccountLink: disableSwitchAccountLink
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)(AccountMenu, {
        ...props,
        ...links
    });
};

});
parcelRegister("I5fLT", function(module, exports) {

$parcel$export(module.exports, "useAccountLinks", () => $52b23487f27441d5$export$2afde6c526be23b9);

var $lemjl = parcelRequire("lemjl");
function $52b23487f27441d5$export$2afde6c526be23b9({ email: email, identityEnvironment: identityEnvironment, application: application, continueUrl: continueUrl, logOutContinueUrl: logOutContinueUrl, isLoggedOut: isLoggedOut, disableSwitchAccountLink: disableSwitchAccountLink }) {
    const { baseUrl: baseUrl } = (0, $lemjl.resolveEnvironment)(identityEnvironment);
    const applicationParam = `application=${encodeURIComponent(application)}`;
    const continueParam = `continue=${encodeURIComponent(continueUrl)}`;
    const logOutContinueParam = logOutContinueUrl ? `continue=${encodeURIComponent(logOutContinueUrl)}` : continueParam;
    const manageProfileUrl = `${baseUrl}/manage-profile`;
    const manageProfileLink = email ? `${baseUrl}/login?${applicationParam}&continue=${encodeURIComponent(manageProfileUrl)}&prompt=none&login_hint=${encodeURIComponent(email)}` : manageProfileUrl;
    return {
        manageProfileLink: manageProfileLink,
        switchAccountLink: disableSwitchAccountLink ? undefined : `${baseUrl}/login?${applicationParam}&${continueParam}&prompt=select_account`,
        logOutLink: `${baseUrl}/logout?${applicationParam}&${logOutContinueParam}` + (disableSwitchAccountLink ? '' : '&prompt=none'),
        logInLink: isLoggedOut ? `${baseUrl}/login?${applicationParam}&${continueParam}` : undefined
    };
}

});
parcelRegister("lemjl", function(module, exports) {

$parcel$export(module.exports, "resolveEnvironment", () => $5988642e4801aeb0$export$eabfcea451f48b90);
/**
 * An Identity environment to integrate with. Either a `"dev"`, `"fedex"`, `"staging"` or
 * `"prod"` for real Identity environments, or an `EnvironmentConfig` object for
 * using a fake environment (e.g. for local dev).
 */ const $5988642e4801aeb0$var$environmentConfigs = {
    dev: {
        baseUrl: 'https://id.dev.internal.atlassian.com'
    },
    fedex: {
        baseUrl: 'https://id.atlassian-fex.com'
    },
    staging: {
        baseUrl: 'https://id.stg.internal.atlassian.com'
    },
    'staging-fedramp-moderate': {
        baseUrl: 'https://id.stg.atlassian-us-gov-mod.com'
    },
    prod: {
        baseUrl: 'https://id.atlassian.com'
    },
    'prod-fedramp-moderate': {
        baseUrl: 'https://id.atlassian-us-gov-mod.com'
    }
};
function $5988642e4801aeb0$export$eabfcea451f48b90(identityEnvironment) {
    if (typeof identityEnvironment === 'string') return $5988642e4801aeb0$var$environmentConfigs[identityEnvironment];
    else return identityEnvironment;
}

});




parcelRegister("dBl98", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e6f224f96f6af0c$export$2e2bcd8739ae039);
function $9e6f224f96f6af0c$var$fromHex(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace("#", "").match(/.{2}/g);
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a], 16);
    switch(e){
        case "rgb":
            return {
                r: n[0],
                g: n[1],
                b: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                r: n[0],
                g: n[1],
                b: n[2]
            });
    }
}
function $9e6f224f96f6af0c$var$fromRgb(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "hex":
            return 1 == (g = Math.round(n.r).toString(16)).length && (g = "0" + g), 1 == (y = Math.round(n.g).toString(16)).length && (y = "0" + y), 1 == (_ = Math.round(n.b).toString(16)).length && (_ = "0" + _), "#" + g + y + _;
        case "cssrgb":
            return "rgb(" + Math.round(n.r) + "," + Math.round(n.g) + "," + Math.round(n.b) + ")";
        case "hsl":
            var a = [
                g = n.r / 255,
                y = n.g / 255,
                _ = n.b / 255
            ].sort(), i = (a[0] + a[2]) / 2 * 100;
            return a[0] == a[2] ? (b = 0, d = 0) : (b = i >= 50 ? (a[2] - a[0]) / (2 - a[2] - a[0]) * 100 : (a[2] - a[0]) / (a[2] + a[0]) * 100, (d = a[2] == g ? (y - _) / (a[2] - a[0]) * 60 : a[2] == y ? 60 * (2 + (_ - g) / (a[2] - a[0])) : 60 * (4 + (g - y) / (a[2] - a[0]))) < 0 ? d += 360 : d > 360 && (d %= 360)), {
                h: d,
                s: b,
                l: i
            };
        case "csshsl":
            var c = o.convert({
                conversions: t,
                helpers: s
            }, "hsl", n);
            return "hsl(" + Math.round(c.h) + "," + Math.round(c.s) + "%," + Math.round(c.l) + "%)";
        case "cmyk":
            var u = n.r / 255, l = n.g / 255, h = n.b / 255, v = 1 - Math.max(u, l, h);
            if (1 != v) var p = (1 - u - v) / (1 - v), f = (1 - l - v) / (1 - v), m = (1 - h - v) / (1 - v);
            else var p = 0, f = 0, m = 0;
            return {
                c: p,
                m: f,
                y: m,
                k: v
            };
        case "hsv":
            var d, b, g = n.r / 255, y = n.g / 255, _ = n.b / 255, M = Math.min(g, y, _), Y = Math.max(g, y, _), L = Y - M, X = Y;
            if (0 == L) d = 0, b = 0;
            else {
                b = L / Y;
                var Z = ((Y - g) / 6 + L / 2) / L, R = ((Y - y) / 6 + L / 2) / L, w = ((Y - _) / 6 + L / 2) / L;
                g == Y ? d = w - R : y == Y ? d = 1 / 3 + Z - w : _ == Y && (d = 2 / 3 + R - Z), d < 0 && (d += 1), d > 1 && (d -= 1);
            }
            return {
                h: 360 * d,
                s: 100 * b,
                v: 100 * X
            };
        case "yiq":
            var m = n.r / 255 * .299 + n.g / 255 * .587 + n.b / 255 * .114, C = n.r / 255 * .596 + n.g / 255 * -0.274 + n.b / 255 * -0.322, x = n.r / 255 * .211 + n.g / 255 * -0.523 + n.b / 255 * .312;
            return C = s.bounded(C, [
                -0.5957,
                .5957
            ]), x = s.bounded(x, [
                -0.5226,
                .5226
            ]), {
                y: m,
                i: C,
                q: x
            };
        case "XYZ":
            var A = [
                n.r,
                n.g,
                n.b
            ].map(function(r) {
                return r / 255;
            }).map(function(r) {
                return r <= .04045 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4);
            }), S = s.getTransform("SRGB_XYZ").map(function(r) {
                return A.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            }).map(function(r) {
                return 100 * r;
            }), O = $9e6f224f96f6af0c$var$slicedToArray(S, 3);
            return {
                X: O[0],
                Y: O[1],
                Z: O[2]
            };
        case "lms":
        case "cielab":
        case "cieluv":
        case "xyY":
            var I = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, I);
        case "cielch":
            var j = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cieluv", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, j);
        case "hsluv":
            var D = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cielch", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, D);
    }
}
function $9e6f224f96f6af0c$var$fromCssRgb(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace(/((rgb\(|\))|[\s]*)/g, "").split(",");
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a]);
    switch(e){
        case "rgb":
            return {
                r: n[0],
                g: n[1],
                b: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                r: n[0],
                g: n[1],
                b: n[2]
            });
    }
}
function $9e6f224f96f6af0c$var$fromHsl(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            if (0 == n.s) {
                var a = n.l / 100 * 255;
                return {
                    r: a,
                    g: a,
                    b: a
                };
            }
            var i, c, u;
            i = n.l >= 50 ? n.l / 100 + n.s / 100 - n.l / 100 * (n.s / 100) : n.l / 100 * (1 + n.s / 100), c = n.l / 100 * 2 - i;
            var l, h, v, p = ((u = n.h / 360) + .333) % 1, f = u, m = s.negMod(u - .333, 1);
            return l = 6 * p < 1 ? c + 6 * (i - c) * p : 2 * p < 1 ? i : 3 * p < 2 ? c + 6 * (.666 - p) * (i - c) : c, h = 6 * f < 1 ? c + 6 * (i - c) * f : 2 * f < 1 ? i : 3 * f < 2 ? c + 6 * (.666 - f) * (i - c) : c, v = 6 * m < 1 ? c + 6 * (i - c) * m : 2 * m < 1 ? i : 3 * m < 2 ? c + 6 * (.666 - m) * (i - c) : c, l < 0 && (l = 0), h < 0 && (h = 0), v < 0 && (v = 0), {
                r: 255 * l,
                g: 255 * h,
                b: 255 * v
            };
        case "csshsl":
            return "hsl(" + Math.round(n.h) + "," + Math.round(n.s) + "%," + Math.round(n.l) + "%)";
        case "hsv":
            n.s = n.s / 100, n.l = n.l / 100;
            var d = n.s * (n.l < .5 ? n.l : 1 - n.l);
            return {
                h: n.h,
                s: 100 * (2 * d / (n.l + d)),
                v: 100 * (n.l + d)
            };
        default:
            var b = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, b);
    }
}
function $9e6f224f96f6af0c$var$fromCssHsl(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace(/(hsl\(|\)|%|[\s]*)/g, "").split(",");
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a]);
    switch(e){
        case "hsl":
            return {
                h: n[0],
                s: n[1],
                l: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                h: n[0],
                s: n[1],
                l: n[2]
            });
    }
}
function $9e6f224f96f6af0c$var$fromHsv(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            var a, i, c;
            n.h = n.h / 360, n.s = n.s / 100, n.v = n.v / 100;
            var u = 6 * n.h;
            6 == u && (u = 0);
            var l, h, v, p = Math.round(u), f = n.v * (1 - n.s), m = n.v * (1 - n.s * (u - p)), d = n.v * (1 - n.s * (1 - (u - p)));
            return 0 == p ? (l = n.v, h = d, v = f) : 1 == p ? (l = m, h = n.v, v = f) : 2 == p ? (l = f, h = n.v, v = d) : 3 == p ? (l = f, h = m, v = n.v) : 4 == p ? (l = d, h = f, v = n.v) : (l = n.v, h = f, v = m), a = 255 * l, i = 255 * h, c = 255 * v, {
                r: a,
                g: i,
                b: c
            };
        case "hsl":
            n.h = n.h / 360, n.s = n.s / 100, n.v = n.v / 100;
            return {
                h: 360 * n.h,
                s: 100 * ((2 - n.s) * n.v < 1 ? n.s * n.v / ((2 - n.s) * n.v) : n.s * n.v / (2 - (2 - n.s) * n.v)),
                l: 100 * ((2 - n.s) * n.v / 2)
            };
        default:
            var b = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, b);
    }
}
function $9e6f224f96f6af0c$var$fromCmyk(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            return {
                r: a = 255 * (1 - n.c) * (1 - n.k),
                g: i = 255 * (1 - n.m) * (1 - n.k),
                b: c = 255 * (1 - n.y) * (1 - n.k)
            };
        case "cssrgb":
            var a = 255 * (1 - n.c) * (1 - n.k), i = 255 * (1 - n.m) * (1 - n.k), c = 255 * (1 - n.y) * (1 - n.k);
            return "rgb(" + Math.round(a) + "," + Math.round(i) + "," + Math.round(c) + ")";
        default:
            var u = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, u);
    }
}
function $9e6f224f96f6af0c$var$fromYiq(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(n.i = s.bounded(n.i, [
        -0.5957,
        .5957
    ]), n.q = s.bounded(n.q, [
        -0.5226,
        .5226
    ]), e){
        case "rgb":
            var a = 255 * (n.y + .956 * n.i + .621 * n.q), i = 255 * (n.y + -0.272 * n.i + -0.647 * n.q), c = 255 * (n.y + -1.106 * n.i + -1.703 * n.q);
            return a = s.bounded(a, [
                0,
                255
            ]), i = s.bounded(i, [
                0,
                255
            ]), c = s.bounded(c, [
                0,
                255
            ]), {
                r: a,
                g: i,
                b: c
            };
        default:
            var u = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, u);
    }
}
function $9e6f224f96f6af0c$var$fromXYZ(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers, a = s.getIlluminant("D65");
    switch(e){
        case "rgb":
            var i = [
                n.X,
                n.Y,
                n.Z
            ].map(function(r) {
                return r / 100;
            }), c = s.getTransform("INVERSE_SRGB_XYZ").map(function(r) {
                return i.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            }).map(function(r) {
                return r <= .0031308 ? 12.92 * r : 1.055 * Math.pow(r, 1 / 2.4) - .055;
            }).map(function(r) {
                return 255 * r;
            }), u = $9e6f224f96f6af0c$var$slicedToArray(c, 3), l = u[0], h = u[1], v = u[2];
            return s.boundedRgb({
                r: l,
                g: h,
                b: v
            });
        case "lms":
            var p = [
                n.X,
                n.Y,
                n.Z
            ].map(function(r) {
                return r / 100;
            }), f = s.getTransform("BRADFORD").map(function(r) {
                return p.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            });
            return {
                rho: f[0],
                gamma: f[1],
                beta: f[2]
            };
        case "cielab":
            var m = n.X / a.X, d = n.Y / a.Y, b = n.Z / a.Z, g = function(r) {
                return r > .008856 ? s.cbrt(r) : (903.3 * r + 16) / 116;
            }, y = g(m), _ = g(d);
            return {
                L: 116 * _ - 16,
                a: 500 * (y - _),
                b: 200 * (_ - g(b))
            };
        case "cieluv":
            var M = n.Y / a.Y, Y = M > .008856 ? 116 * s.cbrt(M) - 16 : 903.3 * M, L = function(r) {
                return 4 * r.X / (r.X + 15 * r.Y + 3 * r.Z);
            }, X = function(r) {
                return 9 * r.Y / (r.X + 15 * r.Y + 3 * r.Z);
            };
            return {
                L: Y,
                u: 13 * Y * (L(n) - L(a)),
                v: 13 * Y * (X(n) - X(a))
            };
        case "xyY":
            return {
                x: n.X / (n.X + n.Y + n.Z),
                y: n.Y / (n.X + n.Y + n.Z),
                Y: n.Y
            };
        default:
            var Z = s.boundedRgb(o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n));
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, Z);
    }
}
function $9e6f224f96f6af0c$var$fromxyY(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = n.Y / n.y * n.x, i = n.Y / n.y * (1 - n.x - n.y);
            return {
                X: a,
                Y: n.Y,
                Z: i
            };
        default:
            var c = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, c);
    }
}
function $9e6f224f96f6af0c$var$fromLms(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = [
                n.rho,
                n.gamma,
                n.beta
            ], i = s.getTransform("INVERSE_BRADFORD").map(function(r) {
                return a.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            });
            return {
                X: 100 * i[0],
                Y: 100 * i[1],
                Z: 100 * i[2]
            };
        default:
            var c = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, c);
    }
}
function $9e6f224f96f6af0c$var$fromCieLab(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = s.getIlluminant("D65"), i = (n.L + 16) / 116, c = n.a / 500 + i, u = i - n.b / 200, l = function(r) {
                return Math.pow(r, 3) > .008856 ? Math.pow(r, 3) : (116 * r - 16) / 903.3;
            }, h = l(c), v = l(u), p = n.L > 903.3 * .008856 ? Math.pow(i, 3) : n.L / 903.3;
            return {
                X: h * a.X,
                Y: p * a.Y,
                Z: v * a.Z
            };
        default:
            var f = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, f);
    }
}
function $9e6f224f96f6af0c$var$fromCieLuv(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = s.getIlluminant("D65"), i = function(r) {
                return 4 * r.X / (r.X + 15 * r.Y + 3 * r.Z);
            }(a), c = function(r) {
                return 9 * r.Y / (r.X + 15 * r.Y + 3 * r.Z);
            }(a), u = 1 / 3 * (52 * n.L / (n.u + 13 * n.L * i) - 1), l = n.L > 903.3 * .008856 ? Math.pow((n.L + 16) / 116, 3) : n.L / 903.3, h = -5 * l, v = (l * (39 * n.L / (n.v + 13 * n.L * c) - 5) - h) / (u - -1 / 3);
            return {
                X: 100 * v,
                Y: 100 * l,
                Z: 100 * (v * u + h)
            };
        case "cielch":
            var p = Math.sqrt(Math.pow(n.u, 2) + Math.pow(n.v, 2)), f = Math.atan2(n.v, n.u);
            return f < 0 && (f += 2 * Math.PI), f = s.toDeg(f), {
                L: n.L,
                C: p,
                h: f
            };
        default:
            var m = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, m);
    }
}
function $9e6f224f96f6af0c$var$fromCieLch(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "cieluv":
            var a = s.toRad(n.h), i = n.C * Math.cos(a), c = n.C * Math.sin(a);
            return {
                L: n.L,
                u: i,
                v: c
            };
        case "hsluv":
            if (n.L > 99.9999999) return {
                hu: n.h,
                s: 0,
                l: 100
            };
            if (n.L < 1e-8) return {
                hu: n.h,
                s: 0,
                l: 0
            };
            for(var u = (n.L + 16) / 1560896, l = u > .008856 ? u : n.L / 903.3, h = s.getTransform("INVERSE_SRGB_XYZ"), v = [], p = 0; p < 3; p++)for(var f = h[p][0], m = h[p][1], d = h[p][2], b = 0; b < 2; b++){
                var g = (284517 * f - 94839 * d) * l, y = (838422 * d + 769860 * m + 731718 * f) * n.L * l - 769860 * b * n.L, _ = (632260 * d - 126452 * m) * l + 126452 * b;
                v.push({
                    m: g / _,
                    b: y / _
                });
            }
            var M = Number.MAX_VALUE, Y = s.toRad(n.h);
            v.forEach(function(r) {
                var e = r.b / (Math.sin(Y) - r.m * Math.cos(Y));
                e >= 0 && (M = Math.min(M, e));
            });
            var L = M;
            return {
                hu: n.h,
                s: n.C / L * 100,
                l: n.L
            };
        default:
            var X = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cieluv", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, X);
    }
}
function $9e6f224f96f6af0c$var$fromCieLch$1(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "cielch":
            if (n.L > 99.9999999) return {
                L: 100,
                C: 0,
                h: n.hu
            };
            if (n.L < 1e-8) return {
                L: 0,
                C: 0,
                h: n.hu
            };
            for(var a = (n.l + 16) / 1560896, i = a > .008856 ? a : n.l / 903.3, c = s.getTransform("INVERSE_SRGB_XYZ"), u = [], l = 0; l < 3; l++)for(var h = c[l][0], v = c[l][1], p = c[l][2], f = 0; f < 2; f++){
                var m = (284517 * h - 94839 * p) * i, d = (838422 * p + 769860 * v + 731718 * h) * n.l * i - 769860 * f * n.l, b = (632260 * p - 126452 * v) * i + 126452 * f;
                u.push({
                    m: m / b,
                    b: d / b
                });
            }
            var g = Number.MAX_VALUE, y = s.toRad(n.hu);
            u.forEach(function(r) {
                var e = r.b / (Math.sin(y) - r.m * Math.cos(y));
                e >= 0 && (g = Math.min(g, e));
            });
            var _ = g;
            return {
                L: n.l,
                C: _ / 100 * n.s,
                h: n.hu
            };
        default:
            var M = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cielch", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, M);
    }
}
function $9e6f224f96f6af0c$var$contains(r, e) {
    return Object.keys(r).every(function(r) {
        return -1 !== e.indexOf(r);
    });
}
function $9e6f224f96f6af0c$var$adapt(r, e, n, t) {
    var o = r.operations.convert(r, "XYZ", e), s = r.operations.convert(r, "lms", n);
    if (t) a = r.operations.convert(r, "lms", t);
    else var a = r.operations.convert(r, "lms", r.helpers.getIlluminant("D65"));
    var i = r.helpers.getTransform("BRADFORD"), c = r.helpers.getTransform("INVERSE_BRADFORD"), u = [
        [
            s.rho / a.rho,
            0,
            0
        ],
        [
            0,
            s.gamma / a.gamma,
            0
        ],
        [
            0,
            0,
            s.beta / a.beta
        ]
    ], l = r.helpers.matrixMultiply(c, u), h = r.helpers.matrixMultiply(l, i), v = [
        [
            o.X
        ],
        [
            o.Y
        ],
        [
            o.Z
        ]
    ], p = r.helpers.matrixMultiply(h, v), f = {
        X: p[0][0],
        Y: p[1][0],
        Z: p[2][0]
    };
    return r.helpers.ready(r, f);
}
function $9e6f224f96f6af0c$var$adjacent(r, e, n, t) {
    for(var o = r.operations.convert(r, "hsl", t), s = [
        {
            h: o.h,
            s: o.s,
            l: o.l
        }
    ], a = 0; a < n - 1; a++)o.h = r.helpers.negMod(o.h + e, 360), s.push({
        h: o.h,
        s: o.s,
        l: o.l
    });
    return r.helpers.ready(r, s);
}
function $9e6f224f96f6af0c$var$brightness(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.l += e, t.l < 0 ? t.l = 0 : t.l > 100 && (t.l = 100), r.helpers.ready(r, t);
}
function $9e6f224f96f6af0c$var$complementary(r, e) {
    var n = r.operations.convert(r, "hsl", e);
    return n.h = (n.h + 180) % 360, r.helpers.ready(r, n);
}
function $9e6f224f96f6af0c$var$contrast(r, e, n) {
    var t = r.operations.convert(r, "rgb", n);
    return t.r = 255 * ((t.r / 255 - .5) * e + .5), t.r < 0 ? t.r = 0 : t.r > 255 && (t.r = 255), t.g = 255 * ((t.g / 255 - .5) * e + .5), t.g < 0 ? t.g = 0 : t.g > 255 && (t.g = 255), t.b = 255 * ((t.b / 255 - .5) * e + .5), t.b < 0 ? t.b = 0 : t.b > 255 && (t.b = 255), r.helpers.ready(r, t);
}
function $9e6f224f96f6af0c$var$contrastRatio(r, e) {
    var n = r.operations.convert(r, "rgb", e);
    return n = (299 * n.r + 587 * n.g + 114 * n.b) / 1e3 >= 128 ? {
        r: 0,
        g: 0,
        b: 0
    } : {
        r: 255,
        g: 255,
        b: 255
    }, r.helpers.ready(r, n);
}
function $9e6f224f96f6af0c$var$convert(r, e, n) {
    if (Object.keys(r.conversions).indexOf(e) > -1) {
        n.colour ? n = n.colour : n.colours && (n = n.colours);
        var t = r.helpers.determineMode(n);
        return t != e ? r.conversions[t].convert(r, e, n) : n;
    }
    return r.helpers.ready(r, e);
}
function $9e6f224f96f6af0c$var$difference(r, e, n, t, o) {
    t = t || 1, o = o || 1;
    var s = r.operations.convert(r, "cielab", e), a = r.operations.convert(r, "cielab", n), i = Math.sqrt(Math.pow(s.a, 2) + Math.pow(s.b, 2)), c = i - Math.sqrt(Math.pow(a.a, 2) + Math.pow(a.b, 2)), u = s.L - a.L, l = s.a - a.a, h = s.b - a.b, v = Math.sqrt(Math.pow(l, 2) + Math.pow(h, 2) - Math.pow(c, 2)), p = s.L < 16 ? .511 : .040975 * s.L / (1.01765 * s.L), f = .0638 * i / (1.0131 * i), m = Math.atan2(s.b, s.a), d = m >= 0 ? m : m + 360, b = 164 <= d && d <= 345 ? .56 + Math.abs(.2 * Math.cos(r.helpers.toRad(d + 168))) : .36 + Math.abs(.4 * Math.cos(r.helpers.toRad(d + 35))), g = Math.pow(i, 4) / (Math.pow(i, 4) + 1900), y = f * (g * b + 1 - g), _ = Math.pow(u / (t * p), 2);
    return Math.sqrt(_ + _ + _);
}
function $9e6f224f96f6af0c$var$fade(r, e, n, t) {
    var o = r.operations.convert(r, "rgb", n), s = r.operations.convert(r, "rgb", t), a = [
        o
    ];
    e -= 1;
    for(var i = (s.r - o.r) / e, c = (s.g - o.g) / e, u = (s.b - o.b) / e, l = {
        r: o.r,
        g: o.g,
        b: o.b
    }, h = 0; h < e - 1; h++)l.r = r.helpers.slopeMod(l.r + i, 255), l.g = r.helpers.slopeMod(l.g + c, 255), l.b = r.helpers.slopeMod(l.b + u, 255), a.push({
        r: l.r,
        g: l.g,
        b: l.b
    });
    return a.push(s), r.helpers.ready(r, a);
}
function $9e6f224f96f6af0c$var$greyscale(r, e) {
    var n = r.operations.convert(r, "rgb", e), t = (n.r + n.g + n.b) / 3;
    return n = {
        r: t,
        g: t,
        b: t
    }, r.helpers.ready(r, n);
}
function $9e6f224f96f6af0c$var$hue(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.h = r.helpers.negMod(t.h + e, 360), r.helpers.ready(r, t);
}
function $9e6f224f96f6af0c$var$invert(r, e) {
    var n = r.operations.convert(r, "rgb", e);
    return n.r = r.helpers.negMod(255 - n.r, 255), n.g = r.helpers.negMod(255 - n.g, 255), n.b = r.helpers.negMod(255 - n.b, 255), r.helpers.ready(r, n);
}
function $9e6f224f96f6af0c$var$invertLightness(r, e) {
    var n = r.operations.convert(r, "hsl", e);
    return n.l = 100 - n.l, r.helpers.ready(r, n);
}
function $9e6f224f96f6af0c$var$mid(r, e, n) {
    var t = r.operations.convert(r, "hsl", e), o = r.operations.convert(r, "hsl", n), s = {
        h: (t.h + o.h) / 2,
        s: (t.s + o.s) / 2,
        l: (t.l + o.l) / 2
    };
    return r.helpers.ready(r, s);
}
function $9e6f224f96f6af0c$var$multiply(r, e, n) {
    var t = r.operations.convert(r, "hsl", e), o = r.operations.convert(r, "hsl", n), s = {
        h: t.h,
        s: t.s,
        l: t.l / 100 * (o.l / 100) * 100
    };
    return s.l = s.l > 100 ? 100 : s.l, s.l = s.l < 0 ? 0 : s.l, r.helpers.ready(r, s);
}
function $9e6f224f96f6af0c$var$saturation(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.s += e, t.s < 0 ? t.s = 0 : t.s > 100 && (t.s = 100), r.helpers.ready(r, t);
}
function $9e6f224f96f6af0c$var$sepia(r, e) {
    var n = r.operations.convert(r, "rgb", e), t = {};
    return t.r = .393 * n.r + .769 * n.g + .189 * n.b, t.g = .349 * n.r + .686 * n.g + .168 * n.b, t.b = .272 * n.r + .534 * n.g + .131 * n.b, r.helpers.ready(r, t);
}
function $9e6f224f96f6af0c$var$shade(r, e, n) {
    var t = r.operations.convert(r, "hsv", n);
    return t.v += e, t.v < 0 ? t.v = 0 : t.v > 100 && (t.v = 100), r.helpers.ready(r, t);
}
function $9e6f224f96f6af0c$var$temperature(r, e) {
    var n = r.operations.convert(r, "xyY", e), t = (n.x - .332) / (n.y - .1858);
    return -449 * Math.pow(t, 3) + 3525 * Math.pow(t, 2) - 6823.3 * t + 5520.33;
}
function $9e6f224f96f6af0c$var$tetrad(r, e) {
    for(var n = r.operations.convert(r, "hsl", e), t = [
        {
            h: n.h,
            s: n.s,
            l: n.l
        }
    ], o = 0; o < 3; o++)n.h = (n.h + 90) % 360, t.push({
        h: n.h,
        s: n.s,
        l: n.l
    });
    return r.helpers.ready(r, t);
}
function $9e6f224f96f6af0c$var$triad(r, e) {
    for(var n = r.operations.convert(r, "hsl", e), t = [
        {
            h: n.h,
            s: n.s,
            l: n.l
        }
    ], o = 0; o < 2; o++)n.h = (n.h + 120) % 360, t.push({
        h: n.h,
        s: n.s,
        l: n.l
    });
    return r.helpers.ready(r, t);
}
var $9e6f224f96f6af0c$var$fromHex_1 = $9e6f224f96f6af0c$var$fromHex, $9e6f224f96f6af0c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(r) {
    return typeof r;
} : function(r) {
    return r && "function" == typeof Symbol && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
}, $9e6f224f96f6af0c$var$slicedToArray = function() {
    function r(r, e) {
        var n = [], t = !0, o = !1, s = void 0;
        try {
            for(var a, i = r[Symbol.iterator](); !(t = (a = i.next()).done) && (n.push(a.value), !e || n.length !== e); t = !0);
        } catch (r) {
            o = !0, s = r;
        } finally{
            try {
                !t && i.return && i.return();
            } finally{
                if (o) throw s;
            }
        }
        return n;
    }
    return function(e, n) {
        if (Array.isArray(e)) return e;
        if (Symbol.iterator in Object(e)) return r(e, n);
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}(), $9e6f224f96f6af0c$var$toConsumableArray = function(r) {
    if (Array.isArray(r)) {
        for(var e = 0, n = Array(r.length); e < r.length; e++)n[e] = r[e];
        return n;
    }
    return Array.from(r);
}, $9e6f224f96f6af0c$var$fromRgb_1 = $9e6f224f96f6af0c$var$fromRgb, $9e6f224f96f6af0c$var$fromCssRgb_1 = $9e6f224f96f6af0c$var$fromCssRgb, $9e6f224f96f6af0c$var$fromHsl_1 = $9e6f224f96f6af0c$var$fromHsl, $9e6f224f96f6af0c$var$fromCssHsl_1 = $9e6f224f96f6af0c$var$fromCssHsl, $9e6f224f96f6af0c$var$fromHsv_1 = $9e6f224f96f6af0c$var$fromHsv, $9e6f224f96f6af0c$var$fromCmyk_1 = $9e6f224f96f6af0c$var$fromCmyk, $9e6f224f96f6af0c$var$fromYiq_1 = $9e6f224f96f6af0c$var$fromYiq, $9e6f224f96f6af0c$var$fromXYZ_1 = $9e6f224f96f6af0c$var$fromXYZ, $9e6f224f96f6af0c$var$fromxyY_1 = $9e6f224f96f6af0c$var$fromxyY, $9e6f224f96f6af0c$var$fromLms_1 = $9e6f224f96f6af0c$var$fromLms, $9e6f224f96f6af0c$var$fromCieLab_1 = $9e6f224f96f6af0c$var$fromCieLab, $9e6f224f96f6af0c$var$fromCieLuv_1 = $9e6f224f96f6af0c$var$fromCieLuv, $9e6f224f96f6af0c$var$fromCieLch_1 = $9e6f224f96f6af0c$var$fromCieLch, $9e6f224f96f6af0c$var$fromHsluv = $9e6f224f96f6af0c$var$fromCieLch$1, $9e6f224f96f6af0c$var$index = {
    hex: {
        test: function(r) {
            return "string" == typeof r && "#" === r.slice(0, 1);
        },
        convert: $9e6f224f96f6af0c$var$fromHex_1
    },
    rgb: {
        test: function(r) {
            return $9e6f224f96f6af0c$var$contains(r, [
                "r",
                "g",
                "b"
            ]);
        },
        convert: $9e6f224f96f6af0c$var$fromRgb_1
    },
    cssrgb: {
        test: function(r) {
            return "string" == typeof r && "rgb(" === r.slice(0, 4);
        },
        convert: $9e6f224f96f6af0c$var$fromCssRgb_1
    },
    hsl: {
        test: function(r) {
            return $9e6f224f96f6af0c$var$contains(r, [
                "h",
                "s",
                "l"
            ]);
        },
        convert: $9e6f224f96f6af0c$var$fromHsl_1
    },
    csshsl: {
        test: function(r) {
            return "string" == typeof r && "hsl(" === r.slice(0, 4);
        },
        convert: $9e6f224f96f6af0c$var$fromCssHsl_1
    },
    hsv: {
        test: function(r) {
            return $9e6f224f96f6af0c$var$contains(r, [
                "h",
                "s",
                "v"
            ]);
        },
        convert: $9e6f224f96f6af0c$var$fromHsv_1
    },
    cmyk: {
        test: function(r) {
            return $9e6f224f96f6af0c$var$contains(r, [
                "c",
                "m",
                "y",
                "k"
            ]);
        },
        convert: $9e6f224f96f6af0c$var$fromCmyk_1
    },
    yiq: {
        test: function(r) {
            return $9e6f224f96f6af0c$var$contains(r, [
                "y",
                "i",
                "q"
            ]);
        },
        convert: $9e6f224f96f6af0c$var$fromYiq_1
    },
    XYZ: {
        test: function(r) {
            return $9e6f224f96f6af0c$var$contains(r, [
                "X",
                "Y",
                "Z"
            ]);
        },
        convert: $9e6f224f96f6af0c$var$fromXYZ_1
    },
    xyY: {
        test: function(r) {
            return $9e6f224f96f6af0c$var$contains(r, [
                "x",
                "y",
                "Y"
            ]);
        },
        convert: $9e6f224f96f6af0c$var$fromxyY_1
    },
    lms: {
        test: function(r) {
            return $9e6f224f96f6af0c$var$contains(r, [
                "rho",
                "gamma",
                "beta"
            ]);
        },
        convert: $9e6f224f96f6af0c$var$fromLms_1
    },
    cielab: {
        test: function(r) {
            return $9e6f224f96f6af0c$var$contains(r, [
                "L",
                "a",
                "b"
            ]);
        },
        convert: $9e6f224f96f6af0c$var$fromCieLab_1
    },
    cieluv: {
        test: function(r) {
            return $9e6f224f96f6af0c$var$contains(r, [
                "L",
                "u",
                "v"
            ]);
        },
        convert: $9e6f224f96f6af0c$var$fromCieLuv_1
    },
    cielch: {
        test: function(r) {
            return $9e6f224f96f6af0c$var$contains(r, [
                "L",
                "C",
                "h"
            ]);
        },
        convert: $9e6f224f96f6af0c$var$fromCieLch_1
    },
    hsluv: {
        test: function(r) {
            return $9e6f224f96f6af0c$var$contains(r, [
                "hu",
                "s",
                "l"
            ]);
        },
        convert: $9e6f224f96f6af0c$var$fromHsluv
    }
}, $9e6f224f96f6af0c$var$adapt_1 = $9e6f224f96f6af0c$var$adapt, $9e6f224f96f6af0c$var$adjacent_1 = $9e6f224f96f6af0c$var$adjacent, $9e6f224f96f6af0c$var$brightness_1 = $9e6f224f96f6af0c$var$brightness, $9e6f224f96f6af0c$var$complementary_1 = $9e6f224f96f6af0c$var$complementary, $9e6f224f96f6af0c$var$contrast_1 = $9e6f224f96f6af0c$var$contrast, $9e6f224f96f6af0c$var$contrastRatio_1 = $9e6f224f96f6af0c$var$contrastRatio, $9e6f224f96f6af0c$var$convert_1 = $9e6f224f96f6af0c$var$convert, $9e6f224f96f6af0c$var$difference_1 = $9e6f224f96f6af0c$var$difference, $9e6f224f96f6af0c$var$fade_1 = $9e6f224f96f6af0c$var$fade, $9e6f224f96f6af0c$var$greyscale_1 = $9e6f224f96f6af0c$var$greyscale, $9e6f224f96f6af0c$var$hue_1 = $9e6f224f96f6af0c$var$hue, $9e6f224f96f6af0c$var$invert_1 = $9e6f224f96f6af0c$var$invert, $9e6f224f96f6af0c$var$invertLightness_1 = $9e6f224f96f6af0c$var$invertLightness, $9e6f224f96f6af0c$var$mid_1 = $9e6f224f96f6af0c$var$mid, $9e6f224f96f6af0c$var$multiply_1 = $9e6f224f96f6af0c$var$multiply, $9e6f224f96f6af0c$var$saturation_1 = $9e6f224f96f6af0c$var$saturation, $9e6f224f96f6af0c$var$sepia_1 = $9e6f224f96f6af0c$var$sepia, $9e6f224f96f6af0c$var$shade_1 = $9e6f224f96f6af0c$var$shade, $9e6f224f96f6af0c$var$temperature_1 = $9e6f224f96f6af0c$var$temperature, $9e6f224f96f6af0c$var$tetrad_1 = $9e6f224f96f6af0c$var$tetrad, $9e6f224f96f6af0c$var$triad_1 = $9e6f224f96f6af0c$var$triad, $9e6f224f96f6af0c$var$index$2 = {
    adapt: $9e6f224f96f6af0c$var$adapt_1,
    adjacent: $9e6f224f96f6af0c$var$adjacent_1,
    brightness: $9e6f224f96f6af0c$var$brightness_1,
    complementary: $9e6f224f96f6af0c$var$complementary_1,
    contrast: $9e6f224f96f6af0c$var$contrast_1,
    contrastRatio: $9e6f224f96f6af0c$var$contrastRatio_1,
    convert: $9e6f224f96f6af0c$var$convert_1,
    difference: $9e6f224f96f6af0c$var$difference_1,
    fade: $9e6f224f96f6af0c$var$fade_1,
    greyscale: $9e6f224f96f6af0c$var$greyscale_1,
    hue: $9e6f224f96f6af0c$var$hue_1,
    invert: $9e6f224f96f6af0c$var$invert_1,
    invertLightness: $9e6f224f96f6af0c$var$invertLightness_1,
    mid: $9e6f224f96f6af0c$var$mid_1,
    multiply: $9e6f224f96f6af0c$var$multiply_1,
    saturation: $9e6f224f96f6af0c$var$saturation_1,
    sepia: $9e6f224f96f6af0c$var$sepia_1,
    shade: $9e6f224f96f6af0c$var$shade_1,
    temperature: $9e6f224f96f6af0c$var$temperature_1,
    tetrad: $9e6f224f96f6af0c$var$tetrad_1,
    triad: $9e6f224f96f6af0c$var$triad_1
}, $9e6f224f96f6af0c$var$constants = {
    ILLUMINANTS: {
        A: {
            X: 1.0985 * 100,
            Y: 100,
            Z: 35.585
        },
        B: {
            X: 99.072,
            Y: 100,
            Z: 85.223
        },
        C: {
            X: 98.074,
            Y: 100,
            Z: 118.232
        },
        D50: {
            X: 96.422,
            Y: 100,
            Z: 82.521
        },
        D55: {
            X: 95.682,
            Y: 100,
            Z: 92.149
        },
        D65: {
            X: 95.047,
            Y: 100,
            Z: 108.883
        },
        D75: {
            X: 94.972,
            Y: 100,
            Z: 122.638
        },
        E: {
            X: 100,
            Y: 100,
            Z: 100
        },
        F2: {
            X: .99186 * 100,
            Y: 100,
            Z: 67.393
        },
        F7: {
            X: 95.041,
            Y: 100,
            Z: 108.747
        },
        F11: {
            X: 1.00962 * 100,
            Y: 100,
            Z: 64.35
        }
    },
    TRANSFORMS: {
        BRADFORD: [
            [
                .8951,
                .2664,
                -0.1614
            ],
            [
                -0.7502,
                1.7135,
                .0367
            ],
            [
                .0389,
                -0.0685,
                1.0296
            ]
        ],
        INVERSE_BRADFORD: [
            [
                .9869929,
                -0.1470543,
                .1599627
            ],
            [
                .4323053,
                .5183603,
                .0492912
            ],
            [
                -0.0085287,
                .0400428,
                .9684867
            ]
        ],
        SRGB_XYZ: [
            [
                .4124,
                .3576,
                .1805
            ],
            [
                .2126,
                .7152,
                .0722
            ],
            [
                .0193,
                .1192,
                .9505
            ]
        ],
        INVERSE_SRGB_XYZ: [
            [
                3.2406,
                -1.5372,
                -0.4986
            ],
            [
                -0.9689,
                1.8758,
                .0415
            ],
            [
                .0557,
                -0.204,
                1.057
            ]
        ]
    }
}, $9e6f224f96f6af0c$var$api = function(r, e, n) {
    var t = Object.keys(r.operations).reduce(function(e, t) {
        var o = r.operations[t];
        return e[t] = function() {
            for(var e = arguments.length, t = Array(e), s = 0; s < e; s++)t[s] = arguments[s];
            var a = t.slice(0).map(function(r) {
                return "object" === (void 0 === r ? "undefined" : $9e6f224f96f6af0c$var$_typeof(r)) ? Object.assign({}, r) : r;
            });
            if (n && n.colours) return function e(n) {
                var t = n.map(function(n) {
                    if (Array.isArray(n)) {
                        var t = e(n);
                        return t.colours || t.colour;
                    }
                    var s = o.apply(void 0, [
                        r
                    ].concat($9e6f224f96f6af0c$var$toConsumableArray(a), [
                        n
                    ]));
                    return "object" === (void 0 === s ? "undefined" : $9e6f224f96f6af0c$var$_typeof(s)) ? s.colours || s.colour : s;
                });
                return "number" != typeof t[0] ? r.helpers.ready(r, t) : t;
            }(n.colours);
            return o.apply(void 0, [
                r
            ].concat($9e6f224f96f6af0c$var$toConsumableArray(a), [
                n ? n.colour : void 0
            ]));
        }, e;
    }, {});
    return n || (t = Object.assign(t, e)), t;
}, $9e6f224f96f6af0c$var$api_1 = $9e6f224f96f6af0c$var$api, $9e6f224f96f6af0c$var$helpers = {
    getIlluminant: function(r) {
        return $9e6f224f96f6af0c$var$constants.ILLUMINANTS[r];
    },
    getTransform: function(r) {
        return $9e6f224f96f6af0c$var$constants.TRANSFORMS[r];
    },
    matrixMultiply: function(r, e) {
        for(var n = [], t = 0; t < r.length; t++){
            n[t] = [];
            for(var o = 0; o < e[0].length; o++){
                for(var s = 0, a = 0; a < r[0].length; a++)s += r[t][a] * e[a][o];
                n[t][o] = s;
            }
        }
        return n;
    },
    cbrt: function(r) {
        if (Math.cbrt) return Math.cbrt(r);
        var e = Math.pow(Math.abs(r), 1 / 3);
        return r < 0 ? -e : e;
    },
    toRad: function(r) {
        return r * (Math.PI / 180);
    },
    toDeg: function(r) {
        return r * (180 / Math.PI);
    },
    negMod: function(r, e) {
        return (r % e + e) % e;
    },
    slopeMod: function(r) {
        function e(e, n) {
            return r.apply(this, arguments);
        }
        return e.toString = function() {
            return r.toString();
        }, e;
    }(function(r, e) {
        return r > 2 * e ? slopeMod(r - 2 * e, e) : r > e ? 2 * e - r : r < 0 ? slopeMod(r + 2 * e, e) : r;
    }),
    bounded: function(r, e) {
        return r < e[0] ? r = e[0] : r > e[1] && (r = e[1]), r;
    },
    boundedRgb: function(r) {
        var e = this, n = function(r) {
            return e.bounded(r, [
                0,
                255
            ]);
        };
        return {
            r: n(r.r),
            g: n(r.g),
            b: n(r.b)
        };
    },
    determineMode: function(r) {
        for(var e in $9e6f224f96f6af0c$var$index)if ($9e6f224f96f6af0c$var$index.hasOwnProperty(e) && $9e6f224f96f6af0c$var$index[e].test(r)) return e;
        return null;
    },
    ready: function(r, e) {
        var n = r.conversions, t = r.operations, o = r.helpers, s = {};
        switch(Object.prototype.toString.call(e)){
            case "[object Object]":
            case "[object String]":
                s.colour = e;
                for(var a in n)n.hasOwnProperty(a) && function(r) {
                    Object.defineProperty(s, r, {
                        get: function() {
                            o.determineMode(e);
                            return t.convert({
                                conversions: n,
                                operations: t,
                                helpers: o
                            }, r, e);
                        },
                        enumerable: !0
                    });
                }(a);
                return s = Object.assign(s, $9e6f224f96f6af0c$var$api_1({
                    conversions: n,
                    operations: t,
                    helpers: o
                }, $9e6f224f96f6af0c$var$constants, s));
            case "[object Array]":
                s.colours = e;
                for(var i in n)n.hasOwnProperty(i) && function(r) {
                    Object.defineProperty(s, r, {
                        get: function() {
                            return function e(s) {
                                return s.map(function(s) {
                                    return Array.isArray(s) ? e(s) : t.convert({
                                        conversions: n,
                                        operations: t,
                                        helpers: o
                                    }, r, s);
                                });
                            }(e);
                        },
                        enumerable: !0
                    });
                }(i);
                return s = Object.assign(s, $9e6f224f96f6af0c$var$api_1({
                    conversions: n,
                    operations: t,
                    helpers: o
                }, $9e6f224f96f6af0c$var$constants, s));
            default:
                return null;
        }
    }
}, $9e6f224f96f6af0c$var$helpers_1 = $9e6f224f96f6af0c$var$helpers, $9e6f224f96f6af0c$var$dependencies = {
    conversions: $9e6f224f96f6af0c$var$index,
    operations: $9e6f224f96f6af0c$var$index$2,
    helpers: $9e6f224f96f6af0c$var$helpers_1
}, $9e6f224f96f6af0c$var$entry = $9e6f224f96f6af0c$var$api_1($9e6f224f96f6af0c$var$dependencies, $9e6f224f96f6af0c$var$constants);
var $9e6f224f96f6af0c$export$2e2bcd8739ae039 = $9e6f224f96f6af0c$var$entry;

});

parcelRegister("hYRTO", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c991245d2b4e078$export$2e2bcd8739ae039);

var $4yzdo = parcelRequire("4yzdo");
var $4c991245d2b4e078$export$2e2bcd8739ae039 = (0, $4yzdo.default);

});
parcelRegister("4yzdo", function(module, exports) {

$parcel$export(module.exports, "default", () => $622bc2f4e61c3830$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fNobW = parcelRequire("fNobW");

var $3IRJU = parcelRequire("3IRJU");
var $kkxr3 = parcelRequire("kkxr3");
function $622bc2f4e61c3830$export$2e2bcd8739ae039({ name: name, children: children, fallback: fallback = null }) {
    const waitContext = (0, $5uXOq.useContext)((0, $kkxr3.WaitContext));
    const shouldHold = !waitContext || !!waitContext.currentValue();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3IRJU.LazySuspense), {
        fallback: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
            children: [
                fallback,
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fNobW.default), {
                    name: name,
                    hold: shouldHold
                })
            ]
        }),
        name: name,
        children: children
    });
}

});
parcelRegister("fNobW", function(module, exports) {

$parcel$export(module.exports, "default", () => $545cc6aa0f2abe1d$export$2e2bcd8739ae039);

var $eUQkk = parcelRequire("eUQkk");
var $545cc6aa0f2abe1d$export$2e2bcd8739ae039 = (0, $eUQkk.default);

});
parcelRegister("eUQkk", function(module, exports) {

$parcel$export(module.exports, "default", () => $934d1a8b664b9601$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");
const $934d1a8b664b9601$var$useLayoutEffectSAFE = typeof window === 'undefined' ? (0, $5uXOq.useEffect) : (0, $5uXOq.useLayoutEffect);
function $934d1a8b664b9601$export$2e2bcd8739ae039({ children: children, name: name, hold: hold = true, experimental: experimental = false }) {
    // react-18: useId instead
    const context = (0, $5uXOq.useContext)((0, $1tcYS.default));
    $934d1a8b664b9601$var$useLayoutEffectSAFE(()=>{
        if (hold && context != null) {
            if (experimental && context.holdExperimental) return context.holdExperimental(name);
            return context.hold(name);
        }
    }, [
        hold,
        context,
        name
    ]);
    // react-18: can return children directly
    return children != null ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    }) : null;
}

});


parcelRegister("3IRJU", function(module, exports) {

$parcel$export(module.exports, "LazySuspense", () => $3a440dc8cf81cf35$export$256c542058532d6f);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $3a440dc8cf81cf35$var$isNodeEnvironment = ()=>{
    return typeof window === 'undefined' || window.name === 'nodejs';
};
const $3a440dc8cf81cf35$var$LazySuspenseContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    fallback: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {}),
    setFallback: ()=>{
        // eslint-disable-next-line no-console
        console.warn('Missing <LooselySuspense /> boundary');
    },
    name: ''
});
const $3a440dc8cf81cf35$var$DynamicFallback = ({ children: children, outsideSuspense: outsideSuspense })=>{
    const { fallback: fallback, setFallback: setFallback } = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext($3a440dc8cf81cf35$var$LazySuspenseContext);
    (0, $5uXOq.useLayoutEffect)(()=>{
        return ()=>{
            if (!outsideSuspense) setFallback(null);
        };
    }, [
        outsideSuspense,
        setFallback
    ]);
    return children(outsideSuspense ? null : fallback);
};
$3a440dc8cf81cf35$var$DynamicFallback.displayName = 'DynamicFallback';
const $3a440dc8cf81cf35$export$256c542058532d6f = ({ fallback: fallback, children: children, name: name })=>{
    const [hydrationFallback, setHydrationFallback] = (0, $5uXOq.useState)(null);
    const mountedRef = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useLayoutEffect)(()=>{
        mountedRef.current = true;
        return ()=>{
            mountedRef.current = false;
        };
    }, []);
    const contextValue = (0, $5uXOq.useMemo)(()=>({
            fallback: fallback,
            setFallback: (newFallback)=>{
                if (hydrationFallback === newFallback) return;
                setHydrationFallback(newFallback);
            },
            name: name
        }), [
        fallback,
        hydrationFallback,
        name
    ]);
    const renderFallback = (outsideSuspense)=>/*#__PURE__*/ (0, $2OMIu.jsx)($3a440dc8cf81cf35$var$DynamicFallback, {
            outsideSuspense: outsideSuspense,
            children: (resolvedFallback)=>outsideSuspense && hydrationFallback ? hydrationFallback : resolvedFallback
        });
    return /*#__PURE__*/ (0, $2OMIu.jsx)($3a440dc8cf81cf35$var$LazySuspenseContext.Provider, {
        value: contextValue,
        children: $3a440dc8cf81cf35$var$isNodeEnvironment() ? children : /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                    fallback: renderFallback(false),
                    children: children
                }),
                (!mountedRef.current || hydrationFallback) && renderFallback(true)
            ]
        })
    });
};
$3a440dc8cf81cf35$export$256c542058532d6f.displayName = 'LazySuspense';

});

parcelRegister("kkxr3", function(module, exports) {

$parcel$export(module.exports, "WaitContext", () => $68c2fcae5074d5f5$export$9ba3fe09d15de47b);

var $5uXOq = parcelRequire("5uXOq");
const $68c2fcae5074d5f5$export$9ba3fe09d15de47b = /*#__PURE__*/ (0, $5uXOq.createContext)({
    subscribe: ()=>()=>{},
    currentValue: ()=>1
});

});



parcelRegister("lbWm4", function(module, exports) {

var $fmP8r = parcelRequire("fmP8r");

var $e7pfQ = parcelRequire("e7pfQ");

var $2KOtB = parcelRequire("2KOtB");

var $8LQ84 = parcelRequire("8LQ84");
/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */ function $f6d7e42845d7fe59$var$forEach(collection, iteratee) {
    var func = $8LQ84(collection) ? $fmP8r : $e7pfQ;
    return func(collection, $2KOtB(iteratee));
}
module.exports = $f6d7e42845d7fe59$var$forEach;

});
parcelRegister("2KOtB", function(module, exports) {

var $etyzk = parcelRequire("etyzk");
/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function $20170833518d35fe$var$castFunction(value) {
    return typeof value == 'function' ? value : $etyzk;
}
module.exports = $20170833518d35fe$var$castFunction;

});


parcelRegister("3T6Xo", function(module, exports) {

var $gDRiW = parcelRequire("gDRiW");
/**
 * Converts `string` to
 * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the kebab cased string.
 * @example
 *
 * _.kebabCase('Foo Bar');
 * // => 'foo-bar'
 *
 * _.kebabCase('fooBar');
 * // => 'foo-bar'
 *
 * _.kebabCase('__FOO_BAR__');
 * // => 'foo-bar'
 */ var $2d4be7a7064f22f9$var$kebabCase = $gDRiW(function(result, word, index) {
    return result + (index ? '-' : '') + word.toLowerCase();
});
module.exports = $2d4be7a7064f22f9$var$kebabCase;

});

parcelRegister("c74za", function(module, exports) {

var $dgvY6 = parcelRequire("dgvY6");
var $8d19ae39f7480d44$var$Global = $dgvY6.Global;
module.exports = {
    name: 'sessionStorage',
    read: $8d19ae39f7480d44$var$read,
    write: $8d19ae39f7480d44$var$write,
    each: $8d19ae39f7480d44$var$each,
    remove: $8d19ae39f7480d44$var$remove,
    clearAll: $8d19ae39f7480d44$var$clearAll
};
function $8d19ae39f7480d44$var$sessionStorage() {
    return $8d19ae39f7480d44$var$Global.sessionStorage;
}
function $8d19ae39f7480d44$var$read(key) {
    return $8d19ae39f7480d44$var$sessionStorage().getItem(key);
}
function $8d19ae39f7480d44$var$write(key, data) {
    return $8d19ae39f7480d44$var$sessionStorage().setItem(key, data);
}
function $8d19ae39f7480d44$var$each(fn) {
    for(var i = $8d19ae39f7480d44$var$sessionStorage().length - 1; i >= 0; i--){
        var key = $8d19ae39f7480d44$var$sessionStorage().key(i);
        fn($8d19ae39f7480d44$var$read(key), key);
    }
}
function $8d19ae39f7480d44$var$remove(key) {
    return $8d19ae39f7480d44$var$sessionStorage().removeItem(key);
}
function $8d19ae39f7480d44$var$clearAll() {
    return $8d19ae39f7480d44$var$sessionStorage().clear();
}

});

parcelRegister("hqTkp", function(module, exports) {

var $55pzo = parcelRequire("55pzo");

var $g7i7g = parcelRequire("g7i7g");

var $f3SOL = parcelRequire("f3SOL");
/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */ var $cb0fc8686550aa11$var$without = $g7i7g(function(array, values) {
    return $f3SOL(array) ? $55pzo(array, values) : [];
});
module.exports = $cb0fc8686550aa11$var$without;

});
parcelRegister("55pzo", function(module, exports) {

var $ijRUK = parcelRequire("ijRUK");

var $fUP98 = parcelRequire("fUP98");

var $dA3tP = parcelRequire("dA3tP");

var $1nIHN = parcelRequire("1nIHN");

var $cW28x = parcelRequire("cW28x");

var $40I25 = parcelRequire("40I25");
/** Used as the size to enable large array optimizations. */ var $3b41410a547f22d2$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */ function $3b41410a547f22d2$var$baseDifference(array, values, iteratee, comparator) {
    var index = -1, includes = $fUP98, isCommon = true, length = array.length, result = [], valuesLength = values.length;
    if (!length) return result;
    if (iteratee) values = $1nIHN(values, $cW28x(iteratee));
    if (comparator) {
        includes = $dA3tP;
        isCommon = false;
    } else if (values.length >= $3b41410a547f22d2$var$LARGE_ARRAY_SIZE) {
        includes = $40I25;
        isCommon = false;
        values = new $ijRUK(values);
    }
    outer: while(++index < length){
        var value = array[index], computed = iteratee == null ? value : iteratee(value);
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var valuesIndex = valuesLength;
            while(valuesIndex--){
                if (values[valuesIndex] === computed) continue outer;
            }
            result.push(value);
        } else if (!includes(values, computed, comparator)) result.push(value);
    }
    return result;
}
module.exports = $3b41410a547f22d2$var$baseDifference;

});


parcelRegister("f4cXA", function(module, exports) {

(function(global, factory) {
    factory(module.exports, (parcelRequire("5uXOq")));
})(module.exports, function(exports1, React) {
    'use strict';
    function _interopNamespace(e) {
        if (e && e.__esModule) return e;
        var n = Object.create(null);
        if (e) Object.keys(e).forEach(function(k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function() {
                        return e[k];
                    }
                });
            }
        });
        n["default"] = e;
        return Object.freeze(n);
    }
    var React__namespace = /*#__PURE__*/ _interopNamespace(React);
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _inheritsLoose(subClass, superClass) {
        subClass.prototype = Object.create(superClass.prototype);
        subClass.prototype.constructor = subClass;
        _setPrototypeOf(subClass, superClass);
    }
    var changedArray = function changedArray(a, b) {
        if (a === void 0) a = [];
        if (b === void 0) b = [];
        return a.length !== b.length || a.some(function(item, index) {
            return !Object.is(item, b[index]);
        });
    };
    var initialState = {
        error: null
    };
    var ErrorBoundary = /*#__PURE__*/ function(_React$Component) {
        _inheritsLoose(ErrorBoundary, _React$Component);
        function ErrorBoundary() {
            var _this;
            for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(_args)) || this;
            _this.state = initialState;
            _this.resetErrorBoundary = function() {
                var _this$props;
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                _this.props.onReset == null || (_this$props = _this.props).onReset.apply(_this$props, args);
                _this.reset();
            };
            return _this;
        }
        ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
            return {
                error: error
            };
        };
        var _proto = ErrorBoundary.prototype;
        _proto.reset = function reset() {
            this.setState(initialState);
        };
        _proto.componentDidCatch = function componentDidCatch(error, info) {
            var _this$props$onError, _this$props2;
            (_this$props$onError = (_this$props2 = this.props).onError) == null || _this$props$onError.call(_this$props2, error, info);
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            var error = this.state.error;
            var resetKeys = this.props.resetKeys; // There's an edge case where if the thing that triggered the error
            // happens to *also* be in the resetKeys array, we'd end up resetting
            // the error boundary immediately. This would likely trigger a second
            // error to be thrown.
            // So we make sure that we don't check the resetKeys on the first call
            // of cDU after the error is set
            if (error !== null && prevState.error !== null && changedArray(prevProps.resetKeys, resetKeys)) {
                var _this$props$onResetKe, _this$props3;
                (_this$props$onResetKe = (_this$props3 = this.props).onResetKeysChange) == null || _this$props$onResetKe.call(_this$props3, prevProps.resetKeys, resetKeys);
                this.reset();
            }
        };
        _proto.render = function render() {
            var error = this.state.error;
            var _this$props4 = this.props, fallbackRender = _this$props4.fallbackRender, FallbackComponent = _this$props4.FallbackComponent, fallback = _this$props4.fallback;
            if (error !== null) {
                var _props = {
                    error: error,
                    resetErrorBoundary: this.resetErrorBoundary
                };
                if (/*#__PURE__*/ React__namespace.isValidElement(fallback)) return fallback;
                else if (typeof fallbackRender === 'function') return fallbackRender(_props);
                else if (FallbackComponent) return /*#__PURE__*/ React__namespace.createElement(FallbackComponent, _props);
                else throw new Error('react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop');
            }
            return this.props.children;
        };
        return ErrorBoundary;
    }(React__namespace.Component);
    function withErrorBoundary(Component, errorBoundaryProps) {
        var Wrapped = function Wrapped(props) {
            return /*#__PURE__*/ React__namespace.createElement(ErrorBoundary, errorBoundaryProps, /*#__PURE__*/ React__namespace.createElement(Component, props));
        }; // Format for display in DevTools
        var name = Component.displayName || Component.name || 'Unknown';
        Wrapped.displayName = "withErrorBoundary(" + name + ")";
        return Wrapped;
    }
    function useErrorHandler(givenError) {
        var _React$useState = React__namespace.useState(null), error = _React$useState[0], setError = _React$useState[1];
        if (givenError != null) throw givenError;
        if (error != null) throw error;
        return setError;
    }
    /*
  eslint
    @typescript-eslint/sort-type-union-intersection-members: "off",
    @typescript-eslint/no-throw-literal: "off",
    @typescript-eslint/prefer-nullish-coalescing: "off"
  */ exports1.ErrorBoundary = ErrorBoundary;
    exports1.useErrorHandler = useErrorHandler;
    exports1.withErrorBoundary = withErrorBoundary;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});

});

parcelRegister("4dYas", function(module, exports) {

$parcel$export(module.exports, "blockDraggingToIFrames", () => (parcelRequire("kLEEo")).blockDraggingToIFrames);

var $kLEEo = parcelRequire("kLEEo");

});
parcelRegister("kLEEo", function(module, exports) {

$parcel$export(module.exports, "blockDraggingToIFrames", () => $85c97841a27447ca$export$6ae1d8fab001518c);

var $40DDD = parcelRequire("40DDD");

var $3zl3q = parcelRequire("3zl3q");
/**
 * Set a `style` property on a `HTMLElement`
 *
 * @returns a `cleanup` function to restore the `style` property to it's original state
 */ function $85c97841a27447ca$var$setStyle(el, { property: property, rule: rule, priority: priority = '' }) {
    const originalValue = el.style.getPropertyValue(property);
    const originalPriority = el.style.getPropertyPriority(property);
    el.style.setProperty(property, rule, priority);
    return function cleanup() {
        el.style.setProperty(property, originalValue, originalPriority);
    };
}
let $85c97841a27447ca$var$isActive = false;
/**
 * Start blocking dragging to iframes. Only to be called once a drag has started.
 */ function $85c97841a27447ca$var$tryStart() {
    // There can technically be multiple registrations on the same element.
    // Adding a guard to ensure that only one registration does the blocking.
    if ($85c97841a27447ca$var$isActive) return;
    $85c97841a27447ca$var$isActive = true;
    // At this stage, we are also not watching for new iframe elements being added to the page
    // (we _could_ do that as a future change)
    const iframeCleanups = Array.from(document.querySelectorAll('iframe')).map((iframe)=>$85c97841a27447ca$var$setStyle(iframe, {
            property: 'pointer-events',
            rule: 'none',
            priority: 'important'
        }));
    // Not returning the cleanup function.
    // This code will clean itself up when the interaction ends in `onDrop()`.
    // Once a drag has started we are blocking iframes until the interaction is finished.
    const cleanup = (0, $3zl3q.combine)(...iframeCleanups, // We only need this monitor for listening to the drop
    // as our monitor in `blockDraggingToIFrames()` will only
    // call this function when the drag has started
    (0, $40DDD.monitorForElements)({
        onDrop () {
            cleanup();
        }
    }), function release() {
        $85c97841a27447ca$var$isActive = false;
    });
}
function $85c97841a27447ca$export$6ae1d8fab001518c({ element: element }) {
    return (0, $40DDD.monitorForElements)({
        onGenerateDragPreview ({ source: source }) {
            // only starting if we are dragging the provided element
            if (source.element === element) $85c97841a27447ca$var$tryStart();
        }
    });
}

});


parcelRegister("hjhoK", function(module, exports) {

$parcel$export(module.exports, "disableNativeDragPreview", () => (parcelRequire("akFFC")).disableNativeDragPreview);

var $akFFC = parcelRequire("akFFC");

});
parcelRegister("akFFC", function(module, exports) {

$parcel$export(module.exports, "disableNativeDragPreview", () => $1774d76ee1100c7d$export$c588cb30ff3b876e);
// In order to disable the native drag preview you can
// use `event.dataTransfer.setDragImage()` to set a small
// invisible image as the drag preview.
// There are alternative techniques,
// (eg setting opacity to in onGenerateDragPreview and then 1 in onDragStart)
// but the technique in this file worked best across browsers and platforms
// Here we are preloading the image so that it is ready for the first drag.
// Even though the image is base64 encoded, the browser queues an async task
// to decode the image. The image needs to be decoded before it can be used
const $1774d76ee1100c7d$var$tinyTransparentImage = (()=>{
    // SSR safe
    if (typeof window === 'undefined') return null;
    // Image generated by: https://png-pixel.com/
    // It is a 1x1 transparent gif
    // It is the smallest possible transparent image we could find that works on all platforms
    // Note: using an encoded SVG would be nicer code, but it doesn't work on iOS
    const img = new Image();
    img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
    return img;
})();
function $1774d76ee1100c7d$export$c588cb30ff3b876e({ nativeSetDragImage: nativeSetDragImage }) {
    if (nativeSetDragImage && $1774d76ee1100c7d$var$tinyTransparentImage) nativeSetDragImage($1774d76ee1100c7d$var$tinyTransparentImage, 0, 0);
}

});


parcelRegister("fmZmH", function(module, exports) {

$parcel$export(module.exports, "preventUnhandled", () => (parcelRequire("3C4FG")).preventUnhandled);

var $3C4FG = parcelRequire("3C4FG");

});
parcelRegister("3C4FG", function(module, exports) {

$parcel$export(module.exports, "preventUnhandled", () => $bc1937186f99453b$export$453c0582481cc59d);

var $cBeZP = parcelRequire("cBeZP");

var $h5V4I = parcelRequire("h5V4I");
function $bc1937186f99453b$var$acceptDrop(event) {
    // if the event is already prevented the event we don't need to do anything
    if (event.defaultPrevented) return;
    // Using "move" as the drop effect as that uses the standard
    // cursor. Doing this so the user doesn't think they are dropping
    // on the page
    // Note: using "none" will not allow a "drop" to occur, so we are using "move"
    if (event.dataTransfer) event.dataTransfer.dropEffect = 'move';
    // cancel the default browser behaviour
    // doing this will tell the browser that we have handled the drop
    event.preventDefault();
}
let $bc1937186f99453b$var$unbindEvents = null;
/**
 * Block drag operations outside of `@atlaskit/pragmatic-drag-and-drop`
 */ function $bc1937186f99453b$var$start() {
    $bc1937186f99453b$var$cleanup();
    $bc1937186f99453b$var$unbindEvents = (0, $cBeZP.bindAll)(window, [
        {
            type: 'dragover',
            listener: $bc1937186f99453b$var$acceptDrop
        },
        {
            type: 'dragenter',
            listener: $bc1937186f99453b$var$acceptDrop
        },
        {
            type: 'drop',
            listener (event) {
                // our lifecycle manager already prevents events, but just being super safe
                event.preventDefault();
                // not setting dropEffect, as `drop.dropEffect` has already been published to the user
                // (lifecycle-manager binds events in the capture phase)
                // we don't need to wait for "dragend", and "dragend" might not even happen,
                // such as when the draggable has been removed during a drag.
                $bc1937186f99453b$var$cleanup();
            }
        },
        {
            type: 'dragend',
            listener: $bc1937186f99453b$var$cleanup
        },
        ...(0, $h5V4I.getBindingsForBrokenDrags)({
            onDragEnd: $bc1937186f99453b$var$cleanup
        })
    ], // being clear that these are added in the bubble phase
    {
        capture: false
    });
}
function $bc1937186f99453b$var$cleanup() {
    $bc1937186f99453b$var$unbindEvents?.();
    $bc1937186f99453b$var$unbindEvents = null;
}
/**
 * TODO: for next major, we could look at do the following:
 *
 * ```diff
 * - preventUnhandled.start();
 * - preventUnhandled.stop();
 * + const stop = preventUnhandled();
 * ```
 */ function $bc1937186f99453b$var$stop() {
    /**
	 * if `stop()` is called in a `"drop"` event, then `event.preventDefault()` won't be called.
	 * Our `"drop"` listener calls `event.preventDefault()` for handled drop events
	 * ("drop" events caused by dropping over a drop target)
	 * `preventUnhandled()` causes every element to become a drop target (according to the browser)
	 *
	 * To opt out of the default behaviour for a `"drop"` event, we need to make sure
	 * that we cancel it.
	 *
	 * The `"drop"` event listener in core is in the `capture` phase, so people calling
	 * `preventUnhandled.stop()` in `onDrop()` will remove the `"drop"` event listener in this
	 * file before it has the chance to cancel the event.
	 *
	 * Being sneaky and using the `window.event` global to sniff out the current event
	 */ if (window.event?.type === 'drop') window.event?.preventDefault();
    $bc1937186f99453b$var$cleanup();
}
const $bc1937186f99453b$export$453c0582481cc59d = {
    start: $bc1937186f99453b$var$start,
    stop: $bc1937186f99453b$var$stop
};

});


parcelRegister("eufEc", function(module, exports) {

$parcel$export(module.exports, "JSResourceForInteraction", () => $2236bb2e85f415e3$export$e83743682263315a);

var $eIMrK = parcelRequire("eIMrK");

var $ce6VA = parcelRequire("ce6VA");

var $iyWSs = parcelRequire("iyWSs");
const $2236bb2e85f415e3$var$cache = (0, $eIMrK.createCache)(new Map());
function $2236bb2e85f415e3$export$e83743682263315a(loader, opts) {
    return $2236bb2e85f415e3$var$cache.get(opts.moduleId, ()=>(0, $ce6VA.PreloadableJSResource)(()=>(0, $iyWSs.postTask)(loader, {
                priority: 'user-visible'
            }), opts));
}

});

parcelRegister("fEDBv", function(module, exports) {

$parcel$export(module.exports, "createEntryPoint", () => $9a10ed1d48ab8caa$export$fa00dd5c1a75592f);
function $9a10ed1d48ab8caa$export$fa00dd5c1a75592f(// The param types can only be inferred if the shape of the entrypoint (i.e. root and getPreloadProps) is specified
// within the function definition itself. Using EntryPoint, EntryPointComponent, or a custom EntryPointRepresentation
// in place of this will cause Root to be inferred as an 'unknown' type.
params) {
    return params;
}

});

parcelRegister("e7WVN", function(module, exports) {

$parcel$export(module.exports, "setInteractionError", () => $e56ceeea538fc730$export$5b689ca7b019e89f);

var $bFU4G = parcelRequire("bFU4G");
function $e56ceeea538fc730$export$5b689ca7b019e89f(interactionName, error) {
    const interaction = (0, $bFU4G.getActiveInteraction)();
    if (!interaction) return;
    if (interaction.ufoName !== interactionName) return;
    (0, $bFU4G.addError)(interaction.id, error.name, null, 'Manual interaction error', error.errorMessage, undefined, true);
}

});

parcelRegister("eTXmK", function(module, exports) {

$parcel$export(module.exports, "default", () => $21211904d99073e5$export$2e2bcd8739ae039);

var $7Jxgt = parcelRequire("7Jxgt");

var $5gx4p = parcelRequire("5gx4p");

var $fe1wc = parcelRequire("fe1wc");

var $tcn7E = parcelRequire("tcn7E");

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");

var $9AgLs = parcelRequire("9AgLs");
function $21211904d99073e5$var$traceUFOPress(name, timestamp) {
    const rate = (0, $fe1wc.getInteractionRate)(name, 'press');
    const pressInteractionsList = (0, $fe1wc.getDoNotAbortActivePressInteraction)();
    if (pressInteractionsList?.includes(name)) {
        const interaction = (0, $bFU4G.getActiveInteraction)();
        if (interaction?.ufoName !== 'unknown' && interaction?.type === 'press') return;
    }
    if ((0, $5gx4p.default)(rate)) {
        (0, $bFU4G.abortAll)('new_interaction', name);
        const startTimestamp = timestamp ?? performance.now();
        const newId = (0, $7Jxgt.v4)();
        // covered experiences with tracing instrumentation:
        // inline-result.inline-card-create-submit
        (0, $tcn7E.setInteractionActiveTrace)(newId, 'press');
        (0, $1u4q7.DefaultInteractionID).current = newId;
        (0, $bFU4G.addNewInteraction)(newId, name, 'press', startTimestamp, rate, [], (0, $9AgLs.default).current, (0, $tcn7E.getActiveTrace)());
    }
}
var $21211904d99073e5$export$2e2bcd8739ae039 = $21211904d99073e5$var$traceUFOPress;

});

parcelRegister("kMSay", function(module, exports) {

$parcel$export(module.exports, "default", () => $143a91bbcd4a2e96$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6wxJn = parcelRequire("6wxJn");
function $143a91bbcd4a2e96$export$2e2bcd8739ae039(name) {
    const context = (0, $5uXOq.useContext)((0, $6wxJn.default));
    const handleClick = (0, $5uXOq.useCallback)((timeStamp)=>{
        if (context) {
            const time = timeStamp || performance.now();
            context.tracePress(name, time);
        }
    }, [
        context,
        name
    ]);
    return handleClick;
}

});

parcelRegister("bWn3s", function(module, exports) {

$parcel$export(module.exports, "mergeRefs", () => $8b16fea90e636ddb$export$c9058316764c140e);

var $dv0OY = parcelRequire("dv0OY");

var $3XwZB = parcelRequire("3XwZB");
function $8b16fea90e636ddb$export$c9058316764c140e(refs) {
    return (0, $3XwZB.createCallbackRef)((newValue)=>refs.forEach((ref)=>(0, $dv0OY.assignRef)(ref, newValue)));
}

});
parcelRegister("3XwZB", function(module, exports) {

$parcel$export(module.exports, "createCallbackRef", () => $2e2079715de82b22$export$35a19128eb4acba4);
/**
 * creates a Ref object with on change callback
 * @param callback
 * @returns {RefObject}
 *
 * @see {@link useCallbackRef}
 * @see https://reactjs.org/docs/refs-and-the-dom.html#creating-refs
 */ function $2e2079715de82b22$export$35a19128eb4acba4(callback) {
    let current = null;
    return {
        get current () {
            return current;
        },
        set current (value){
            const last = current;
            if (last !== value) {
                current = value;
                callback(value, last);
            }
        }
    };
}

});


parcelRegister("FISJv", function(module, exports) {

var $g7i7g = parcelRequire("g7i7g");

var $5wIsF = parcelRequire("5wIsF");
/**
 * Removes all given values from `array` using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
 * to remove elements from an array by predicate.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {...*} [values] The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pull(array, 'a', 'c');
 * console.log(array);
 * // => ['b', 'b']
 */ var $07d6a509d0c9362c$var$pull = $g7i7g($5wIsF);
module.exports = $07d6a509d0c9362c$var$pull;

});
parcelRegister("5wIsF", function(module, exports) {

var $anVYT = parcelRequire("anVYT");
/**
 * This method is like `_.pull` except that it accepts an array of values to remove.
 *
 * **Note:** Unlike `_.difference`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pullAll(array, ['a', 'c']);
 * console.log(array);
 * // => ['b', 'b']
 */ function $40626e026fe1545a$var$pullAll(array, values) {
    return array && array.length && values && values.length ? $anVYT(array, values) : array;
}
module.exports = $40626e026fe1545a$var$pullAll;

});
parcelRegister("anVYT", function(module, exports) {

var $1nIHN = parcelRequire("1nIHN");

var $2wwA6 = parcelRequire("2wwA6");

var $jA03V = parcelRequire("jA03V");

var $cW28x = parcelRequire("cW28x");

var $jHlUS = parcelRequire("jHlUS");
/** Used for built-in method references. */ var $78f90735d44c9d27$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $78f90735d44c9d27$var$splice = $78f90735d44c9d27$var$arrayProto.splice;
/**
 * The base implementation of `_.pullAllBy` without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns `array`.
 */ function $78f90735d44c9d27$var$basePullAll(array, values, iteratee, comparator) {
    var indexOf = comparator ? $jA03V : $2wwA6, index = -1, length = values.length, seen = array;
    if (array === values) values = $jHlUS(values);
    if (iteratee) seen = $1nIHN(array, $cW28x(iteratee));
    while(++index < length){
        var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
        while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
            if (seen !== array) $78f90735d44c9d27$var$splice.call(seen, fromIndex, 1);
            $78f90735d44c9d27$var$splice.call(array, fromIndex, 1);
        }
    }
    return array;
}
module.exports = $78f90735d44c9d27$var$basePullAll;

});
parcelRegister("jA03V", function(module, exports) {
/**
 * This function is like `baseIndexOf` except that it accepts a comparator.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $e4116d7d57d0dfb7$var$baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (comparator(array[index], value)) return index;
    }
    return -1;
}
module.exports = $e4116d7d57d0dfb7$var$baseIndexOfWith;

});




parcelRegister("1RztZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9bf212dd22a18c20$export$2e2bcd8739ae039);
// eslint-disable-next-line import/no-extraneous-dependencies

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8GsOl = parcelRequire("8GsOl");


var $iufeS = parcelRequire("iufeS");

var $8RXs9 = parcelRequire("8RXs9");

var $5SFp9 = parcelRequire("5SFp9");

var $kxFlx = parcelRequire("kxFlx");

var $bjGSs = parcelRequire("bjGSs");

var $fVnbM = parcelRequire("fVnbM");

var $VSDnB = parcelRequire("VSDnB");

var $dC5iT = parcelRequire("dC5iT");
var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");
const $9bf212dd22a18c20$var$sucessWrapperStyles = (0, $8CUq3.xcss)({
    width: '26px',
    height: '26px',
    borderRadius: '100%',
    padding: 'space.0',
    // @ts-ignore --https://product-fabric.atlassian.net/browse/DSP-20920
    backgroundColor: "var(--ds-icon-success, #22A06B)",
    color: 'color.text.inverse',
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $9bf212dd22a18c20$var$discoveryWrapperStyles = (0, $8CUq3.xcss)({
    width: '26px',
    height: '26px',
    borderRadius: '100%',
    padding: 'space.0',
    // @ts-ignore --https://product-fabric.atlassian.net/browse/DSP-20920
    backgroundColor: "var(--ds-icon-discovery, #8270DB)",
    color: 'color.text.inverse',
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
var $9bf212dd22a18c20$export$2e2bcd8739ae039 = (0, $8RXs9.default)(({ isOpen: isOpen, title: title, completed: completed, onClick: onClick, onDismiss: onDismiss, intl: intl })=>{
    const hasDismissButton = typeof onDismiss === 'function';
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $iufeS.ChecklistButtonWrapper), {
        isOpen: isOpen,
        hasDismissButton: hasDismissButton,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $iufeS.ChecklistButton), {
                completed: Boolean(completed),
                onClick: onClick,
                hasDismissButton: hasDismissButton,
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8GsOl))), {
                        LEGACY_size: "medium",
                        color: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
                        spacing: "spacious",
                        label: ""
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iufeS.ButtonTitle), {
                        children: title
                    })
                ]
            }),
            hasDismissButton && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
                onClick: onDismiss,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                style: (0, $iufeS.dismissButtonInlineStyles),
                "aria-label": intl.formatMessage((0, $5SFp9.default).dismissButtonAria, {
                    title: title
                }),
                iconBefore: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                    children: (0, $VSDnB.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5ILhZ.default), {
                        xcss: completed ? $9bf212dd22a18c20$var$sucessWrapperStyles : $9bf212dd22a18c20$var$discoveryWrapperStyles,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bjGSs))), {
                            color: "currentColor",
                            label: ''
                        })
                    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kxFlx))), {
                        label: "",
                        LEGACY_size: "large",
                        color: completed ? `var(--ds-icon-success, ${(0, $829f609a65d26a98$exports).G500})` : `var(--ds-icon-discovery, ${(0, $829f609a65d26a98$exports).P500})`,
                        LEGACY_secondaryColor: completed ? `var(--ds-background-accent-green-subtlest, ${(0, $829f609a65d26a98$exports).G50})` : `var(--ds-background-accent-purple-subtlest, ${(0, $829f609a65d26a98$exports).P50})`,
                        "aria-hidden": "true"
                    })
                }),
                testId: 'checklist-button--dismiss-button'
            })
        ]
    });
});

});
parcelRegister("iufeS", function(module, exports) {

$parcel$export(module.exports, "ChecklistButton", () => $b5ea09f653dd0ddf$export$39831ffcddfb39de);
$parcel$export(module.exports, "ButtonTitle", () => $b5ea09f653dd0ddf$export$c72d460b11e49d5c);
$parcel$export(module.exports, "ChecklistButtonWrapper", () => $b5ea09f653dd0ddf$export$728120c5a1ef2e80);
$parcel$export(module.exports, "dismissButtonInlineStyles", () => $b5ea09f653dd0ddf$export$a66679212d4257fd);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

function $b5ea09f653dd0ddf$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b5ea09f653dd0ddf$var$buttonTitleStyles = (0, $8CUq3.xcss)({
    font: "var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    color: 'color.text.inverse',
    margin: '0',
    paddingLeft: 'space.050',
    paddingRight: 'space.100'
});
const $b5ea09f653dd0ddf$export$39831ffcddfb39de = ({ children: children, ...props })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("button", {
        onClick: props.onClick,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $f8Sb3.css)({
            borderRadius: '24px',
            font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
            border: 'none',
            outline: 'none',
            whiteSpace: 'nowrap',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            background: props.completed ? `var(--ds-background-success-bold, ${(0, $829f609a65d26a98$exports).G400})` : `var(--ds-background-discovery-bold, ${(0, $829f609a65d26a98$exports).P300})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            padding: props.hasDismissButton ? `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-500, 40px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-150, 12px)"}` : `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-150, 12px)"}`,
            boxShadow: `var(--ds-shadow-overlay, ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `0 8px 16px -4px ${(0, $829f609a65d26a98$exports).N50A}, 0 0 1px ${(0, $829f609a65d26a98$exports).N60A}`})`,
            transition: 'all 0.8s ease-in-out',
            display: 'inline-flex',
            alignItems: 'center',
            overflow: 'hidden',
            '&:hover': {
                cursor: 'pointer'
            }
        })
    }, children);
const $b5ea09f653dd0ddf$export$c72d460b11e49d5c = ({ children: children })=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dC5iT.default), {
        as: "h3",
        xcss: $b5ea09f653dd0ddf$var$buttonTitleStyles
    }, children);
const $b5ea09f653dd0ddf$var$fade = {
    name: "74uqaf",
    styles: "from{opacity:0;}to{opacity:1;}@keyframes fade{from{opacity:0;}to{opacity:1;}}animation:fade 0.6s ease-in-out"
};
const $b5ea09f653dd0ddf$var$getChecklistButtonWrapperDisplay = (props)=>{
    if (props.isOpen) {
        if (props.hasDismissButton) return 'inline-block';
        else // TODO: Check if we can simplify this logic, and have inline-block always
        // need to check confluence
        return 'block';
    } else return 'none';
};
const $b5ea09f653dd0ddf$export$728120c5a1ef2e80 = ({ children: children, ...props })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $f8Sb3.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        props.hasDismissButton && `position: relative;`, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            display: $b5ea09f653dd0ddf$var$getChecklistButtonWrapperDisplay(props)
        }, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        $b5ea09f653dd0ddf$var$fade)
    }, children);
const $b5ea09f653dd0ddf$export$a66679212d4257fd = {
    position: 'absolute',
    right: "var(--ds-space-075, 6px)",
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    top: '50%',
    transform: 'translateY(-50%)',
    borderRadius: '50%',
    width: '34px',
    height: '34px'
};

});

parcelRegister("5SFp9", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e1592727319fa87$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0e1592727319fa87$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    dismissButtonAria: {
        id: 'growth-checklist.dismissButtonAria',
        defaultMessage: 'Dismiss {title}',
        description: 'Text for screen readers only to describe that this will dismiss the button.'
    }
});

});


parcelRegister("bdDiz", function(module, exports) {
(function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory();
})(typeof self !== 'undefined' ? self : module.exports, function() {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                /******/ configurable: false,
                /******/ enumerable: true,
                /******/ get: getter
            });
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1['default'];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, 'a', getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = 3);
    /******/ }([
        /* 0 */ /***/ function(module1, exports, __webpack_require__) {
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            /* eslint-env commonjs, browser */ var RushaCore = __webpack_require__(5);
            var _require = __webpack_require__(1), toHex = _require.toHex, ceilHeapSize = _require.ceilHeapSize;
            var conv = __webpack_require__(6);
            // Calculate the length of buffer that the sha1 routine uses
            // including the padding.
            var padlen = function(len) {
                for(len += 9; len % 64 > 0; len += 1);
                return len;
            };
            var padZeroes = function(bin, len) {
                var h8 = new Uint8Array(bin.buffer);
                var om = len % 4, align = len - om;
                switch(om){
                    case 0:
                        h8[align + 3] = 0;
                    case 1:
                        h8[align + 2] = 0;
                    case 2:
                        h8[align + 1] = 0;
                    case 3:
                        h8[align + 0] = 0;
                }
                for(var i = (len >> 2) + 1; i < bin.length; i++)bin[i] = 0;
            };
            var padData = function(bin, chunkLen, msgLen) {
                bin[chunkLen >> 2] |= 0x80 << 24 - (chunkLen % 4 << 3);
                // To support msgLen >= 2 GiB, use a float division when computing the
                // high 32-bits of the big-endian message length in bits.
                bin[((chunkLen >> 2) + 2 & -16) + 14] = msgLen / 536870912 | 0;
                bin[((chunkLen >> 2) + 2 & -16) + 15] = msgLen << 3;
            };
            var getRawDigest = function(heap, padMaxChunkLen) {
                var io = new Int32Array(heap, padMaxChunkLen + 320, 5);
                var out = new Int32Array(5);
                var arr = new DataView(out.buffer);
                arr.setInt32(0, io[0], false);
                arr.setInt32(4, io[1], false);
                arr.setInt32(8, io[2], false);
                arr.setInt32(12, io[3], false);
                arr.setInt32(16, io[4], false);
                return out;
            };
            var Rusha = function() {
                function Rusha(chunkSize) {
                    _classCallCheck(this, Rusha);
                    chunkSize = chunkSize || 65536;
                    if (chunkSize % 64 > 0) throw new Error('Chunk size must be a multiple of 128 bit');
                    this._offset = 0;
                    this._maxChunkLen = chunkSize;
                    this._padMaxChunkLen = padlen(chunkSize);
                    // The size of the heap is the sum of:
                    // 1. The padded input message size
                    // 2. The extended space the algorithm needs (320 byte)
                    // 3. The 160 bit state the algoritm uses
                    this._heap = new ArrayBuffer(ceilHeapSize(this._padMaxChunkLen + 320 + 20));
                    this._h32 = new Int32Array(this._heap);
                    this._h8 = new Int8Array(this._heap);
                    this._core = new RushaCore({
                        Int32Array: Int32Array
                    }, {}, this._heap);
                }
                Rusha.prototype._initState = function _initState(heap, padMsgLen) {
                    this._offset = 0;
                    var io = new Int32Array(heap, padMsgLen + 320, 5);
                    io[0] = 1732584193;
                    io[1] = -271733879;
                    io[2] = -1732584194;
                    io[3] = 271733878;
                    io[4] = -1009589776;
                };
                Rusha.prototype._padChunk = function _padChunk(chunkLen, msgLen) {
                    var padChunkLen = padlen(chunkLen);
                    var view = new Int32Array(this._heap, 0, padChunkLen >> 2);
                    padZeroes(view, chunkLen);
                    padData(view, chunkLen, msgLen);
                    return padChunkLen;
                };
                Rusha.prototype._write = function _write(data, chunkOffset, chunkLen, off) {
                    conv(data, this._h8, this._h32, chunkOffset, chunkLen, off || 0);
                };
                Rusha.prototype._coreCall = function _coreCall(data, chunkOffset, chunkLen, msgLen, finalize) {
                    var padChunkLen = chunkLen;
                    this._write(data, chunkOffset, chunkLen);
                    if (finalize) padChunkLen = this._padChunk(chunkLen, msgLen);
                    this._core.hash(padChunkLen, this._padMaxChunkLen);
                };
                Rusha.prototype.rawDigest = function rawDigest(str) {
                    var msgLen = str.byteLength || str.length || str.size || 0;
                    this._initState(this._heap, this._padMaxChunkLen);
                    var chunkOffset = 0, chunkLen = this._maxChunkLen;
                    for(chunkOffset = 0; msgLen > chunkOffset + chunkLen; chunkOffset += chunkLen)this._coreCall(str, chunkOffset, chunkLen, msgLen, false);
                    this._coreCall(str, chunkOffset, msgLen - chunkOffset, msgLen, true);
                    return getRawDigest(this._heap, this._padMaxChunkLen);
                };
                Rusha.prototype.digest = function digest(str) {
                    return toHex(this.rawDigest(str).buffer);
                };
                Rusha.prototype.digestFromString = function digestFromString(str) {
                    return this.digest(str);
                };
                Rusha.prototype.digestFromBuffer = function digestFromBuffer(str) {
                    return this.digest(str);
                };
                Rusha.prototype.digestFromArrayBuffer = function digestFromArrayBuffer(str) {
                    return this.digest(str);
                };
                Rusha.prototype.resetState = function resetState() {
                    this._initState(this._heap, this._padMaxChunkLen);
                    return this;
                };
                Rusha.prototype.append = function append(chunk) {
                    var chunkOffset = 0;
                    var chunkLen = chunk.byteLength || chunk.length || chunk.size || 0;
                    var turnOffset = this._offset % this._maxChunkLen;
                    var inputLen = void 0;
                    this._offset += chunkLen;
                    while(chunkOffset < chunkLen){
                        inputLen = Math.min(chunkLen - chunkOffset, this._maxChunkLen - turnOffset);
                        this._write(chunk, chunkOffset, inputLen, turnOffset);
                        turnOffset += inputLen;
                        chunkOffset += inputLen;
                        if (turnOffset === this._maxChunkLen) {
                            this._core.hash(this._maxChunkLen, this._padMaxChunkLen);
                            turnOffset = 0;
                        }
                    }
                    return this;
                };
                Rusha.prototype.getState = function getState() {
                    var turnOffset = this._offset % this._maxChunkLen;
                    var heap = void 0;
                    if (!turnOffset) {
                        var io = new Int32Array(this._heap, this._padMaxChunkLen + 320, 5);
                        heap = io.buffer.slice(io.byteOffset, io.byteOffset + io.byteLength);
                    } else heap = this._heap.slice(0);
                    return {
                        offset: this._offset,
                        heap: heap
                    };
                };
                Rusha.prototype.setState = function setState(state) {
                    this._offset = state.offset;
                    if (state.heap.byteLength === 20) {
                        var io = new Int32Array(this._heap, this._padMaxChunkLen + 320, 5);
                        io.set(new Int32Array(state.heap));
                    } else this._h32.set(new Int32Array(state.heap));
                    return this;
                };
                Rusha.prototype.rawEnd = function rawEnd() {
                    var msgLen = this._offset;
                    var chunkLen = msgLen % this._maxChunkLen;
                    var padChunkLen = this._padChunk(chunkLen, msgLen);
                    this._core.hash(padChunkLen, this._padMaxChunkLen);
                    var result = getRawDigest(this._heap, this._padMaxChunkLen);
                    this._initState(this._heap, this._padMaxChunkLen);
                    return result;
                };
                Rusha.prototype.end = function end() {
                    return toHex(this.rawEnd().buffer);
                };
                return Rusha;
            }();
            module1.exports = Rusha;
            module1.exports._core = RushaCore;
        /***/ },
        /* 1 */ /***/ function(module1, exports) {
            /* eslint-env commonjs, browser */ //
            // toHex
            //
            var precomputedHex = new Array(256);
            for(var i = 0; i < 256; i++)precomputedHex[i] = (i < 0x10 ? '0' : '') + i.toString(16);
            module1.exports.toHex = function(arrayBuffer) {
                var binarray = new Uint8Array(arrayBuffer);
                var res = new Array(arrayBuffer.byteLength);
                for(var _i = 0; _i < res.length; _i++)res[_i] = precomputedHex[binarray[_i]];
                return res.join('');
            };
            //
            // ceilHeapSize
            //
            module1.exports.ceilHeapSize = function(v) {
                // The asm.js spec says:
                // The heap object's byteLength must be either
                // 2^n for n in [12, 24) or 2^24 * n for n ≥ 1.
                // Also, byteLengths smaller than 2^16 are deprecated.
                var p = 0;
                // If v is smaller than 2^16, the smallest possible solution
                // is 2^16.
                if (v <= 65536) return 65536;
                // If v < 2^24, we round up to 2^n,
                // otherwise we round up to 2^24 * n.
                if (v < 16777216) {
                    for(p = 1; p < v; p = p << 1);
                } else {
                    for(p = 16777216; p < v; p += 16777216);
                }
                return p;
            };
            //
            // isDedicatedWorkerScope
            //
            module1.exports.isDedicatedWorkerScope = function(self1) {
                var isRunningInWorker = 'WorkerGlobalScope' in self1 && self1 instanceof self1.WorkerGlobalScope;
                var isRunningInSharedWorker = 'SharedWorkerGlobalScope' in self1 && self1 instanceof self1.SharedWorkerGlobalScope;
                var isRunningInServiceWorker = 'ServiceWorkerGlobalScope' in self1 && self1 instanceof self1.ServiceWorkerGlobalScope;
                // Detects whether we run inside a dedicated worker or not.
                //
                // We can't just check for `DedicatedWorkerGlobalScope`, since IE11
                // has a bug where it only supports `WorkerGlobalScope`.
                //
                // Therefore, we consider us as running inside a dedicated worker
                // when we are running inside a worker, but not in a shared or service worker.
                //
                // When new types of workers are introduced, we will need to adjust this code.
                return isRunningInWorker && !isRunningInSharedWorker && !isRunningInServiceWorker;
            };
        /***/ },
        /* 2 */ /***/ function(module1, exports, __webpack_require__) {
            /* eslint-env commonjs, worker */ module1.exports = function() {
                var Rusha = __webpack_require__(0);
                var hashData = function(hasher, data, cb) {
                    try {
                        return cb(null, hasher.digest(data));
                    } catch (e) {
                        return cb(e);
                    }
                };
                var hashFile = function(hasher, readTotal, blockSize, file, cb) {
                    var reader = new self.FileReader();
                    reader.onloadend = function onloadend() {
                        if (reader.error) return cb(reader.error);
                        var buffer = reader.result;
                        readTotal += reader.result.byteLength;
                        try {
                            hasher.append(buffer);
                        } catch (e) {
                            cb(e);
                            return;
                        }
                        if (readTotal < file.size) hashFile(hasher, readTotal, blockSize, file, cb);
                        else cb(null, hasher.end());
                    };
                    reader.readAsArrayBuffer(file.slice(readTotal, readTotal + blockSize));
                };
                var workerBehaviourEnabled = true;
                self.onmessage = function(event) {
                    if (!workerBehaviourEnabled) return;
                    var data = event.data.data, file = event.data.file, id = event.data.id;
                    if (typeof id === 'undefined') return;
                    if (!file && !data) return;
                    var blockSize = event.data.blockSize || 4194304;
                    var hasher = new Rusha(blockSize);
                    hasher.resetState();
                    var done = function(err, hash) {
                        if (!err) self.postMessage({
                            id: id,
                            hash: hash
                        });
                        else self.postMessage({
                            id: id,
                            error: err.name
                        });
                    };
                    if (data) hashData(hasher, data, done);
                    if (file) hashFile(hasher, 0, blockSize, file, done);
                };
                return function() {
                    workerBehaviourEnabled = false;
                };
            };
        /***/ },
        /* 3 */ /***/ function(module1, exports, __webpack_require__) {
            /* eslint-env commonjs, browser */ var work = __webpack_require__(4);
            var Rusha = __webpack_require__(0);
            var createHash = __webpack_require__(7);
            var runWorker = __webpack_require__(2);
            var _require = __webpack_require__(1), isDedicatedWorkerScope = _require.isDedicatedWorkerScope;
            var isRunningInDedicatedWorker = typeof self !== 'undefined' && isDedicatedWorkerScope(self);
            Rusha.disableWorkerBehaviour = isRunningInDedicatedWorker ? runWorker() : function() {};
            Rusha.createWorker = function() {
                var worker = work(/*require.resolve*/ 2);
                var terminate = worker.terminate;
                worker.terminate = function() {
                    URL.revokeObjectURL(worker.objectURL);
                    terminate.call(worker);
                };
                return worker;
            };
            Rusha.createHash = createHash;
            module1.exports = Rusha;
        /***/ },
        /* 4 */ /***/ function(module1, exports, __webpack_require__) {
            function webpackBootstrapFunc(modules) {
                /******/ // The module cache
                /******/ var installedModules = {};
                /******/ // The require function
                /******/ function __webpack_require__(moduleId) {
                    /******/ // Check if module is in cache
                    /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
                    /******/ // Create a new module (and put it into the cache)
                    /******/ var module1 = installedModules[moduleId] = {
                        /******/ i: moduleId,
                        /******/ l: false,
                        /******/ exports: {}
                    };
                    /******/ // Execute the module function
                    /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
                    /******/ // Flag the module as loaded
                    /******/ module1.l = true;
                    /******/ // Return the exports of the module
                    /******/ return module1.exports;
                /******/ }
                /******/ // expose the modules object (__webpack_modules__)
                /******/ __webpack_require__.m = modules;
                /******/ // expose the module cache
                /******/ __webpack_require__.c = installedModules;
                /******/ // identity function for calling harmony imports with the correct context
                /******/ __webpack_require__.i = function(value) {
                    return value;
                };
                /******/ // define getter function for harmony exports
                /******/ __webpack_require__.d = function(exports, name, getter) {
                    /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                        /******/ configurable: false,
                        /******/ enumerable: true,
                        /******/ get: getter
                    });
                /******/ };
                /******/ // define __esModule on exports
                /******/ __webpack_require__.r = function(exports) {
                    /******/ Object.defineProperty(exports, '__esModule', {
                        value: true
                    });
                /******/ };
                /******/ // getDefaultExport function for compatibility with non-harmony modules
                /******/ __webpack_require__.n = function(module1) {
                    /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                        return module1['default'];
                    } : /******/ function getModuleExports() {
                        return module1;
                    };
                    /******/ __webpack_require__.d(getter, 'a', getter);
                    /******/ return getter;
                /******/ };
                /******/ // Object.prototype.hasOwnProperty.call
                /******/ __webpack_require__.o = function(object, property) {
                    return Object.prototype.hasOwnProperty.call(object, property);
                };
                /******/ // __webpack_public_path__
                /******/ __webpack_require__.p = "/";
                /******/ // on error function for async loading
                /******/ __webpack_require__.oe = function(err) {
                    console.error(err);
                    throw err;
                };
                var f = __webpack_require__(__webpack_require__.s = ENTRY_MODULE);
                return f.default || f // try to call default if defined to also support babel esmodule exports
                ;
            }
            var moduleNameReqExp = '[\\.|\\-|\\+|\\w|\/|@]+';
            var dependencyRegExp = '\\((\/\\*.*?\\*\/)?\s?.*?(' + moduleNameReqExp + ').*?\\)' // additional chars when output.pathinfo is true
            ;
            // http://stackoverflow.com/a/2593661/130442
            function quoteRegExp(str) {
                return (str + '').replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
            }
            function getModuleDependencies(sources, module1, queueName) {
                var retval = {};
                retval[queueName] = [];
                var fnString = module1.toString();
                var wrapperSignature = fnString.match(/^function\s?\(\w+,\s*\w+,\s*(\w+)\)/);
                if (!wrapperSignature) return retval;
                var webpackRequireName = wrapperSignature[1];
                // main bundle deps
                var re = new RegExp('(\\\\n|\\W)' + quoteRegExp(webpackRequireName) + dependencyRegExp, 'g');
                var match;
                while(match = re.exec(fnString)){
                    if (match[3] === 'dll-reference') continue;
                    retval[queueName].push(match[3]);
                }
                // dll deps
                re = new RegExp('\\(' + quoteRegExp(webpackRequireName) + '\\("(dll-reference\\s(' + moduleNameReqExp + '))"\\)\\)' + dependencyRegExp, 'g');
                while(match = re.exec(fnString)){
                    if (!sources[match[2]]) {
                        retval[queueName].push(match[1]);
                        sources[match[2]] = __webpack_require__(match[1]).m;
                    }
                    retval[match[2]] = retval[match[2]] || [];
                    retval[match[2]].push(match[4]);
                }
                return retval;
            }
            function hasValuesInQueues(queues) {
                var keys = Object.keys(queues);
                return keys.reduce(function(hasValues, key) {
                    return hasValues || queues[key].length > 0;
                }, false);
            }
            function getRequiredModules(sources, moduleId) {
                var modulesQueue = {
                    main: [
                        moduleId
                    ]
                };
                var requiredModules = {
                    main: []
                };
                var seenModules = {
                    main: {}
                };
                while(hasValuesInQueues(modulesQueue)){
                    var queues = Object.keys(modulesQueue);
                    for(var i = 0; i < queues.length; i++){
                        var queueName = queues[i];
                        var queue = modulesQueue[queueName];
                        var moduleToCheck = queue.pop();
                        seenModules[queueName] = seenModules[queueName] || {};
                        if (seenModules[queueName][moduleToCheck] || !sources[queueName][moduleToCheck]) continue;
                        seenModules[queueName][moduleToCheck] = true;
                        requiredModules[queueName] = requiredModules[queueName] || [];
                        requiredModules[queueName].push(moduleToCheck);
                        var newModules = getModuleDependencies(sources, sources[queueName][moduleToCheck], queueName);
                        var newModulesKeys = Object.keys(newModules);
                        for(var j = 0; j < newModulesKeys.length; j++){
                            modulesQueue[newModulesKeys[j]] = modulesQueue[newModulesKeys[j]] || [];
                            modulesQueue[newModulesKeys[j]] = modulesQueue[newModulesKeys[j]].concat(newModules[newModulesKeys[j]]);
                        }
                    }
                }
                return requiredModules;
            }
            module1.exports = function(moduleId, options) {
                options = options || {};
                var sources = {
                    main: __webpack_require__.m
                };
                var requiredModules = options.all ? {
                    main: Object.keys(sources)
                } : getRequiredModules(sources, moduleId);
                var src = '';
                Object.keys(requiredModules).filter(function(m) {
                    return m !== 'main';
                }).forEach(function(module1) {
                    var entryModule = 0;
                    while(requiredModules[module1][entryModule])entryModule++;
                    requiredModules[module1].push(entryModule);
                    sources[module1][entryModule] = '(function(module, exports, __webpack_require__) { module.exports = __webpack_require__; })';
                    src = src + 'var ' + module1 + ' = (' + webpackBootstrapFunc.toString().replace('ENTRY_MODULE', JSON.stringify(entryModule)) + ')({' + requiredModules[module1].map(function(id) {
                        return '' + JSON.stringify(id) + ': ' + sources[module1][id].toString();
                    }).join(',') + '});\n';
                });
                src = src + '(' + webpackBootstrapFunc.toString().replace('ENTRY_MODULE', JSON.stringify(moduleId)) + ')({' + requiredModules.main.map(function(id) {
                    return '' + JSON.stringify(id) + ': ' + sources.main[id].toString();
                }).join(',') + '})(self);';
                var blob = new window.Blob([
                    src
                ], {
                    type: 'text/javascript'
                });
                if (options.bare) return blob;
                var URL1 = window.URL || window.webkitURL || window.mozURL || window.msURL;
                var workerUrl = URL1.createObjectURL(blob);
                var worker = new window.Worker(workerUrl);
                worker.objectURL = workerUrl;
                return worker;
            };
        /***/ },
        /* 5 */ /***/ function(module1, exports) {
            // The low-level RushCore module provides the heart of Rusha,
            // a high-speed sha1 implementation working on an Int32Array heap.
            // At first glance, the implementation seems complicated, however
            // with the SHA1 spec at hand, it is obvious this almost a textbook
            // implementation that has a few functions hand-inlined and a few loops
            // hand-unrolled.
            module1.exports = function RushaCore(stdlib$846, foreign$847, heap$848) {
                'use asm';
                var H$849 = new stdlib$846.Int32Array(heap$848);
                function hash$850(k$851, x$852) {
                    // k in bytes
                    k$851 = k$851 | 0;
                    x$852 = x$852 | 0;
                    var i$853 = 0, j$854 = 0, y0$855 = 0, z0$856 = 0, y1$857 = 0, z1$858 = 0, y2$859 = 0, z2$860 = 0, y3$861 = 0, z3$862 = 0, y4$863 = 0, z4$864 = 0, t0$865 = 0, t1$866 = 0;
                    y0$855 = H$849[x$852 + 320 >> 2] | 0;
                    y1$857 = H$849[x$852 + 324 >> 2] | 0;
                    y2$859 = H$849[x$852 + 328 >> 2] | 0;
                    y3$861 = H$849[x$852 + 332 >> 2] | 0;
                    y4$863 = H$849[x$852 + 336 >> 2] | 0;
                    for(i$853 = 0; (i$853 | 0) < (k$851 | 0); i$853 = i$853 + 64 | 0){
                        z0$856 = y0$855;
                        z1$858 = y1$857;
                        z2$860 = y2$859;
                        z3$862 = y3$861;
                        z4$864 = y4$863;
                        for(j$854 = 0; (j$854 | 0) < 64; j$854 = j$854 + 4 | 0){
                            t1$866 = H$849[i$853 + j$854 >> 2] | 0;
                            t0$865 = ((y0$855 << 5 | y0$855 >>> 27) + (y1$857 & y2$859 | ~y1$857 & y3$861) | 0) + ((t1$866 + y4$863 | 0) + 1518500249 | 0) | 0;
                            y4$863 = y3$861;
                            y3$861 = y2$859;
                            y2$859 = y1$857 << 30 | y1$857 >>> 2;
                            y1$857 = y0$855;
                            y0$855 = t0$865;
                            H$849[k$851 + j$854 >> 2] = t1$866;
                        }
                        for(j$854 = k$851 + 64 | 0; (j$854 | 0) < (k$851 + 80 | 0); j$854 = j$854 + 4 | 0){
                            t1$866 = (H$849[j$854 - 12 >> 2] ^ H$849[j$854 - 32 >> 2] ^ H$849[j$854 - 56 >> 2] ^ H$849[j$854 - 64 >> 2]) << 1 | (H$849[j$854 - 12 >> 2] ^ H$849[j$854 - 32 >> 2] ^ H$849[j$854 - 56 >> 2] ^ H$849[j$854 - 64 >> 2]) >>> 31;
                            t0$865 = ((y0$855 << 5 | y0$855 >>> 27) + (y1$857 & y2$859 | ~y1$857 & y3$861) | 0) + ((t1$866 + y4$863 | 0) + 1518500249 | 0) | 0;
                            y4$863 = y3$861;
                            y3$861 = y2$859;
                            y2$859 = y1$857 << 30 | y1$857 >>> 2;
                            y1$857 = y0$855;
                            y0$855 = t0$865;
                            H$849[j$854 >> 2] = t1$866;
                        }
                        for(j$854 = k$851 + 80 | 0; (j$854 | 0) < (k$851 + 160 | 0); j$854 = j$854 + 4 | 0){
                            t1$866 = (H$849[j$854 - 12 >> 2] ^ H$849[j$854 - 32 >> 2] ^ H$849[j$854 - 56 >> 2] ^ H$849[j$854 - 64 >> 2]) << 1 | (H$849[j$854 - 12 >> 2] ^ H$849[j$854 - 32 >> 2] ^ H$849[j$854 - 56 >> 2] ^ H$849[j$854 - 64 >> 2]) >>> 31;
                            t0$865 = ((y0$855 << 5 | y0$855 >>> 27) + (y1$857 ^ y2$859 ^ y3$861) | 0) + ((t1$866 + y4$863 | 0) + 1859775393 | 0) | 0;
                            y4$863 = y3$861;
                            y3$861 = y2$859;
                            y2$859 = y1$857 << 30 | y1$857 >>> 2;
                            y1$857 = y0$855;
                            y0$855 = t0$865;
                            H$849[j$854 >> 2] = t1$866;
                        }
                        for(j$854 = k$851 + 160 | 0; (j$854 | 0) < (k$851 + 240 | 0); j$854 = j$854 + 4 | 0){
                            t1$866 = (H$849[j$854 - 12 >> 2] ^ H$849[j$854 - 32 >> 2] ^ H$849[j$854 - 56 >> 2] ^ H$849[j$854 - 64 >> 2]) << 1 | (H$849[j$854 - 12 >> 2] ^ H$849[j$854 - 32 >> 2] ^ H$849[j$854 - 56 >> 2] ^ H$849[j$854 - 64 >> 2]) >>> 31;
                            t0$865 = ((y0$855 << 5 | y0$855 >>> 27) + (y1$857 & y2$859 | y1$857 & y3$861 | y2$859 & y3$861) | 0) + ((t1$866 + y4$863 | 0) - 1894007588 | 0) | 0;
                            y4$863 = y3$861;
                            y3$861 = y2$859;
                            y2$859 = y1$857 << 30 | y1$857 >>> 2;
                            y1$857 = y0$855;
                            y0$855 = t0$865;
                            H$849[j$854 >> 2] = t1$866;
                        }
                        for(j$854 = k$851 + 240 | 0; (j$854 | 0) < (k$851 + 320 | 0); j$854 = j$854 + 4 | 0){
                            t1$866 = (H$849[j$854 - 12 >> 2] ^ H$849[j$854 - 32 >> 2] ^ H$849[j$854 - 56 >> 2] ^ H$849[j$854 - 64 >> 2]) << 1 | (H$849[j$854 - 12 >> 2] ^ H$849[j$854 - 32 >> 2] ^ H$849[j$854 - 56 >> 2] ^ H$849[j$854 - 64 >> 2]) >>> 31;
                            t0$865 = ((y0$855 << 5 | y0$855 >>> 27) + (y1$857 ^ y2$859 ^ y3$861) | 0) + ((t1$866 + y4$863 | 0) - 899497514 | 0) | 0;
                            y4$863 = y3$861;
                            y3$861 = y2$859;
                            y2$859 = y1$857 << 30 | y1$857 >>> 2;
                            y1$857 = y0$855;
                            y0$855 = t0$865;
                            H$849[j$854 >> 2] = t1$866;
                        }
                        y0$855 = y0$855 + z0$856 | 0;
                        y1$857 = y1$857 + z1$858 | 0;
                        y2$859 = y2$859 + z2$860 | 0;
                        y3$861 = y3$861 + z3$862 | 0;
                        y4$863 = y4$863 + z4$864 | 0;
                    }
                    H$849[x$852 + 320 >> 2] = y0$855;
                    H$849[x$852 + 324 >> 2] = y1$857;
                    H$849[x$852 + 328 >> 2] = y2$859;
                    H$849[x$852 + 332 >> 2] = y3$861;
                    H$849[x$852 + 336 >> 2] = y4$863;
                }
                return {
                    hash: hash$850
                };
            };
        /***/ },
        /* 6 */ /***/ function(module1, exports) {
            var _this = this;
            /* eslint-env commonjs, browser */ var reader = void 0;
            if (typeof self !== 'undefined' && typeof self.FileReaderSync !== 'undefined') reader = new self.FileReaderSync();
            // Convert a binary string and write it to the heap.
            // A binary string is expected to only contain char codes < 256.
            var convStr = function(str, H8, H32, start, len, off) {
                var i = void 0, om = off % 4, lm = (len + om) % 4, j = len - lm;
                switch(om){
                    case 0:
                        H8[off] = str.charCodeAt(start + 3);
                    case 1:
                        H8[off + 1 - (om << 1) | 0] = str.charCodeAt(start + 2);
                    case 2:
                        H8[off + 2 - (om << 1) | 0] = str.charCodeAt(start + 1);
                    case 3:
                        H8[off + 3 - (om << 1) | 0] = str.charCodeAt(start);
                }
                if (len < lm + (4 - om)) return;
                for(i = 4 - om; i < j; i = i + 4 | 0)H32[off + i >> 2] = str.charCodeAt(start + i) << 24 | str.charCodeAt(start + i + 1) << 16 | str.charCodeAt(start + i + 2) << 8 | str.charCodeAt(start + i + 3);
                switch(lm){
                    case 3:
                        H8[off + j + 1 | 0] = str.charCodeAt(start + j + 2);
                    case 2:
                        H8[off + j + 2 | 0] = str.charCodeAt(start + j + 1);
                    case 1:
                        H8[off + j + 3 | 0] = str.charCodeAt(start + j);
                }
            };
            // Convert a buffer or array and write it to the heap.
            // The buffer or array is expected to only contain elements < 256.
            var convBuf = function(buf, H8, H32, start, len, off) {
                var i = void 0, om = off % 4, lm = (len + om) % 4, j = len - lm;
                switch(om){
                    case 0:
                        H8[off] = buf[start + 3];
                    case 1:
                        H8[off + 1 - (om << 1) | 0] = buf[start + 2];
                    case 2:
                        H8[off + 2 - (om << 1) | 0] = buf[start + 1];
                    case 3:
                        H8[off + 3 - (om << 1) | 0] = buf[start];
                }
                if (len < lm + (4 - om)) return;
                for(i = 4 - om; i < j; i = i + 4 | 0)H32[off + i >> 2 | 0] = buf[start + i] << 24 | buf[start + i + 1] << 16 | buf[start + i + 2] << 8 | buf[start + i + 3];
                switch(lm){
                    case 3:
                        H8[off + j + 1 | 0] = buf[start + j + 2];
                    case 2:
                        H8[off + j + 2 | 0] = buf[start + j + 1];
                    case 1:
                        H8[off + j + 3 | 0] = buf[start + j];
                }
            };
            var convBlob = function(blob, H8, H32, start, len, off) {
                var i = void 0, om = off % 4, lm = (len + om) % 4, j = len - lm;
                var buf = new Uint8Array(reader.readAsArrayBuffer(blob.slice(start, start + len)));
                switch(om){
                    case 0:
                        H8[off] = buf[3];
                    case 1:
                        H8[off + 1 - (om << 1) | 0] = buf[2];
                    case 2:
                        H8[off + 2 - (om << 1) | 0] = buf[1];
                    case 3:
                        H8[off + 3 - (om << 1) | 0] = buf[0];
                }
                if (len < lm + (4 - om)) return;
                for(i = 4 - om; i < j; i = i + 4 | 0)H32[off + i >> 2 | 0] = buf[i] << 24 | buf[i + 1] << 16 | buf[i + 2] << 8 | buf[i + 3];
                switch(lm){
                    case 3:
                        H8[off + j + 1 | 0] = buf[j + 2];
                    case 2:
                        H8[off + j + 2 | 0] = buf[j + 1];
                    case 1:
                        H8[off + j + 3 | 0] = buf[j];
                }
            };
            module1.exports = function(data, H8, H32, start, len, off) {
                if (typeof data === 'string') return convStr(data, H8, H32, start, len, off);
                if (data instanceof Array) return convBuf(data, H8, H32, start, len, off);
                // Safely doing a Buffer check using "this" to avoid Buffer polyfill to be included in the dist
                if (_this && _this.Buffer && _this.Buffer.isBuffer(data)) return convBuf(data, H8, H32, start, len, off);
                if (data instanceof ArrayBuffer) return convBuf(new Uint8Array(data), H8, H32, start, len, off);
                if (data.buffer instanceof ArrayBuffer) return convBuf(new Uint8Array(data.buffer, data.byteOffset, data.byteLength), H8, H32, start, len, off);
                if (data instanceof Blob) return convBlob(data, H8, H32, start, len, off);
                throw new Error('Unsupported data type.');
            };
        /***/ },
        /* 7 */ /***/ function(module1, exports, __webpack_require__) {
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            /* eslint-env commonjs, browser */ var Rusha = __webpack_require__(0);
            var _require = __webpack_require__(1), toHex = _require.toHex;
            var Hash = function() {
                function Hash() {
                    _classCallCheck(this, Hash);
                    this._rusha = new Rusha();
                    this._rusha.resetState();
                }
                Hash.prototype.update = function update(data) {
                    this._rusha.append(data);
                    return this;
                };
                Hash.prototype.digest = function digest(encoding) {
                    var digest = this._rusha.rawEnd().buffer;
                    if (!encoding) return digest;
                    if (encoding === 'hex') return toHex(digest);
                    throw new Error('unsupported digest encoding');
                };
                return Hash;
            }();
            module1.exports = function() {
                return new Hash();
            };
        /***/ }
    ]);
});

});

parcelRegister("3SfKV", function(module, exports) {

$parcel$export(module.exports, "EditionAwarenessStandardPubTouchpoint", () => $74c3fdcf7561bd12$export$bf5f4133d9c358a3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $f4cXA = parcelRequire("f4cXA");

var $7VHMR = parcelRequire("7VHMR");
var $ousew = parcelRequire("ousew");

var $2NMNM = parcelRequire("2NMNM");

var $3u0c5 = parcelRequire("3u0c5");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");
const $74c3fdcf7561bd12$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    persistentUpgradeMenuItemStandardToPremiumPlanLabelExperiment: {
        id: 'persistent-upgrade.trial-plan-comparison.section.message.persistent-upgrade.menuitem.freeplan.label',
        defaultMessage: 'Try the Premium plan',
        description: 'Account profile menu item label for free plan.'
    },
    persistentUpgradeMenuItemStandardToPremiumPlanLozengeExperiment: {
        id: 'persistent-upgrade.trial-plan-comparison.section.message.persistent-upgrade.menuitem.freeplan.lozenge',
        defaultMessage: 'FREE 30-DAY TRIAL',
        description: 'Account profile menu item lozenge for free plan'
    }
});
const $74c3fdcf7561bd12$var$menuItemContentStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    flexWrap: 'nowrap'
});
const $74c3fdcf7561bd12$var$lozengeContainerStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.0',
    marginRight: 'space.0',
    marginBottom: 'space.0',
    marginLeft: 'space.100'
});
function $74c3fdcf7561bd12$var$EditionAwarenessStandardPubTouchpointImpl({ product: product, testId: testId, navVersion: navVersion }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'editionAwarenessStandardToPremiumPUB',
                attributes: {
                    source: 'EditionAwarenessStandardPubTouchpoint',
                    product: product,
                    navVersion: navVersion
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        product,
        navVersion
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $kgoHi.default), {
        xcss: $74c3fdcf7561bd12$var$menuItemContentStyles,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...$74c3fdcf7561bd12$export$defe85febe8b728c.persistentUpgradeMenuItemStandardToPremiumPlanLabelExperiment
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                xcss: $74c3fdcf7561bd12$var$lozengeContainerStyles,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3u0c5.default), {
                    appearance: "new",
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                        ...$74c3fdcf7561bd12$export$defe85febe8b728c.persistentUpgradeMenuItemStandardToPremiumPlanLozengeExperiment
                    })
                })
            })
        ]
    });
}
function $74c3fdcf7561bd12$export$bf5f4133d9c358a3(props) {
    const { product: product, navVersion: navVersion } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const handleOnError = (0, $5uXOq.useCallback)((error)=>{
        createAnalyticsEvent({
            eventType: 'operational',
            action: 'failed',
            actionSubject: '@atlassian/edition-awareness.edition-awareness',
            source: 'unknownErrorSource',
            attributes: {
                product: product,
                edition: 'standard',
                navVersion: navVersion,
                error: error.message
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        product,
        navVersion
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f4cXA.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {}),
        onError: handleOnError,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($74c3fdcf7561bd12$var$EditionAwarenessStandardPubTouchpointImpl, {
            ...props
        })
    });
}

});

parcelRegister("8XFbn", function(module, exports) {

$parcel$export(module.exports, "getHamsKey", () => $c47c0dbfbddbf4a9$export$291d012eb0744b34);
const $c47c0dbfbddbf4a9$var$ProductKeyToHAMSMap = {
    ['confluence']: 'confluence',
    ['jira']: 'jira-software',
    ['jira-product-discovery']: 'jira-product-discovery',
    ['jira-service-management']: 'jira-servicedesk'
};
const $c47c0dbfbddbf4a9$export$291d012eb0744b34 = (product)=>{
    return $c47c0dbfbddbf4a9$var$ProductKeyToHAMSMap[product];
};

});

parcelRegister("6Csk1", function(module, exports) {

var $hsOo6 = parcelRequire("hsOo6");

var $4NkAS = parcelRequire("4NkAS");

var $9MM2g = parcelRequire("9MM2g");

var $hTJwX = parcelRequire("hTJwX");

var $evszO = parcelRequire("evszO");

var $66FNL = parcelRequire("66FNL");
/** Used for built-in method references. */ var $4d1c42d4f14298ee$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $4d1c42d4f14298ee$var$hasOwnProperty = $4d1c42d4f14298ee$var$objectProto.hasOwnProperty;
/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */ var $4d1c42d4f14298ee$var$assign = $9MM2g(function(object, source) {
    if ($evszO(source) || $hTJwX(source)) {
        $4NkAS(source, $66FNL(source), object);
        return;
    }
    for(var key in source)if ($4d1c42d4f14298ee$var$hasOwnProperty.call(source, key)) $hsOo6(object, key, source[key]);
});
module.exports = $4d1c42d4f14298ee$var$assign;

});

parcelRegister("jFnH8", function(module, exports) {

$parcel$export(module.exports, "Behaviours", () => (parcelRequire("cJg0i")).Behaviours);
$parcel$export(module.exports, "TargetTabs", () => (parcelRequire("cJg0i")).TargetTabs);
$parcel$export(module.exports, "Prompts", () => (parcelRequire("cJg0i")).Prompts);
$parcel$export(module.exports, "createProvisioningPageExtensions", () => (parcelRequire("gP7sO")).createProvisioningPageExtensions);
$parcel$export(module.exports, "createProvisioningApiExtensions", () => (parcelRequire("jiQLJ")).createProvisioningApiExtensions);
$parcel$export(module.exports, "createRecommendationContextExtensions", () => (parcelRequire("bG1bs")).createRecommendationContextExtensions);

var $cJg0i = parcelRequire("cJg0i");

var $b1Kvi = parcelRequire("b1Kvi");

var $fh3Yg = parcelRequire("fh3Yg");

var $jaORC = parcelRequire("jaORC");

var $gP7sO = parcelRequire("gP7sO");

var $jiQLJ = parcelRequire("jiQLJ");

var $bG1bs = parcelRequire("bG1bs");

var $9xYqG = parcelRequire("9xYqG");

});
parcelRegister("cJg0i", function(module, exports) {

$parcel$export(module.exports, "Behaviours", () => $5fe0e6234d117982$export$993d0f36af4bf76f);
$parcel$export(module.exports, "TargetTabs", () => $5fe0e6234d117982$export$c57f0d43fd595f43);
$parcel$export(module.exports, "Prompts", () => $5fe0e6234d117982$export$d1609d6291f3d60d);
const $5fe0e6234d117982$export$696c71818ae3f184 = {
    FREE: 'free',
    STANDARD: 'standard',
    PREMIUM: 'premium',
    ESSENTIALS: 'essentials',
    ENTERPRISE: 'enterprise'
};
const $5fe0e6234d117982$export$993d0f36af4bf76f = {
    LAND: 'land',
    CLOSE: 'close'
};
const $5fe0e6234d117982$export$c57f0d43fd595f43 = {
    SAME: 'same',
    NEW: 'new'
};
const $5fe0e6234d117982$export$d1609d6291f3d60d = {
    NEXT: 'next',
    CLOSE: 'close',
    GO_TO_PRODUCT: 'go-to-product',
    RETURN_TO_PRODUCT: 'return-to-product'
};

});

parcelRegister("b1Kvi", function(module, exports) {

var $9xYqG = parcelRequire("9xYqG");

var $cJg0i = parcelRequire("cJg0i");
const $ad4411e35d2d8c65$export$196a138f6d49c2bb = [
    'edition'
];
const $ad4411e35d2d8c65$export$28c762e8047316d8 = (0, $9xYqG.createProductExtensions)($ad4411e35d2d8c65$export$196a138f6d49c2bb);

});
parcelRegister("9xYqG", function(module, exports) {

$parcel$export(module.exports, "createProductExtensions", () => $7b705e4156365c5d$export$42e62ee12e8ced48);
parcelRequire("jWY5k");
var $a0mnO = parcelRequire("a0mnO");
const $7b705e4156365c5d$export$9143c254bff9f7b7 = (object, propertyNames)=>propertyNames.reduce((accumulator, property)=>{
        const value = object[property];
        if (value !== undefined) accumulator[property] = value;
        return accumulator;
    }, {});
const $7b705e4156365c5d$export$42e62ee12e8ced48 = (extensionsWhitelist)=>(options)=>{
        const filteredOptions = $7b705e4156365c5d$export$9143c254bff9f7b7(options, extensionsWhitelist);
        return new (0, $a0mnO.CrossFlowExtensions)(filteredOptions);
    };
const $7b705e4156365c5d$export$86a865d89ef3c690 = (...extensions)=>{
    const combinedOptions = Object.assign({}, ...extensions);
    return new (0, $a0mnO.CrossFlowExtensions)(combinedOptions);
};

});
parcelRegister("jWY5k", function(module, exports) {

$parcel$export(module.exports, "CrossFlowExtensions", () => (parcelRequire("a0mnO")).CrossFlowExtensions);
$parcel$export(module.exports, "Targets", () => (parcelRequire("eGnH0")).Targets);

var $a0mnO = parcelRequire("a0mnO");

var $eGnH0 = parcelRequire("eGnH0");

});
parcelRegister("a0mnO", function(module, exports) {

$parcel$export(module.exports, "CrossFlowExtensions", () => $4d8edd1cb612639e$export$a5e53d1dcbd6eb61);
class $4d8edd1cb612639e$export$a5e53d1dcbd6eb61 {
    constructor(options){
        Object.assign(this, options);
        Object.freeze(this);
    }
}

});

parcelRegister("eGnH0", function(module, exports) {

$parcel$export(module.exports, "Targets", () => $f1c0dfa9569fbb1b$export$59a8eb9cff113544);
/**
 * We are keeping a manual list of targets for the purposes of type safety.
 */ const $f1c0dfa9569fbb1b$export$59a8eb9cff113544 = {
    CONFLUENCE: 'confluence.ondemand',
    JIRA_CORE: 'jira-core.ondemand',
    JIRA_SERVICE_DESK: 'jira-servicedesk.ondemand',
    JIRA_SOFTWARE: 'jira-software.ondemand',
    JIRA_PRODUCT_DISCOVERY: 'jira-product-discovery',
    JIRA_CUSTOMER_SERVICE: 'jira-customer-service',
    BITBUCKET: 'bitbucket.ondemand',
    TRELLO: 'trello',
    OPSGENIE: 'opsgenie',
    STATUSPAGE: 'statuspage',
    /**
	 * @private
	 * @deprecated Use ATLAS instead
	 */ TEAM_CENTRAL: 'townsquare',
    ATLAS: 'townsquare',
    /**
	 * @private
	 * @deprecated
	 */ AVOCADO: 'avocado',
    ANALYTICS: 'atlassian-analytics-free',
    COMPASS: 'compass',
    LOOM: 'loom',
    ROVO: 'rovo.ondemand'
};

});




parcelRegister("fh3Yg", function(module, exports) {

var $9xYqG = parcelRequire("9xYqG");

var $cJg0i = parcelRequire("cJg0i");
const $353da589146b832d$export$390f3b1f433f2095 = [
    'edition',
    'migrationSourceUuid',
    'grantAccessTo'
];
const $353da589146b832d$export$386012fe624cad4 = (0, $9xYqG.createProductExtensions)($353da589146b832d$export$390f3b1f433f2095);

});

parcelRegister("jaORC", function(module, exports) {

var $9xYqG = parcelRequire("9xYqG");

var $cJg0i = parcelRequire("cJg0i");
const $638bae63202e03ae$export$c41268b4369999ed = [
    'edition',
    'migrationSourceUuid'
];
const $638bae63202e03ae$export$a60e4abab2cc3b2b = (0, $9xYqG.createProductExtensions)($638bae63202e03ae$export$c41268b4369999ed);

});

parcelRegister("gP7sO", function(module, exports) {

$parcel$export(module.exports, "createProvisioningPageExtensions", () => $57002cfa239290dc$export$f05508383d0ca130);

var $9xYqG = parcelRequire("9xYqG");
const $57002cfa239290dc$export$99f81e179e225ceb = [
    'provisioningPageOptions'
];
const $57002cfa239290dc$export$f05508383d0ca130 = (options)=>(0, $9xYqG.createProductExtensions)($57002cfa239290dc$export$99f81e179e225ceb)({
        provisioningPageOptions: options
    });

});

parcelRegister("jiQLJ", function(module, exports) {

$parcel$export(module.exports, "createProvisioningApiExtensions", () => $8f278686bdd56b47$export$530ae557c94159b9);

var $9xYqG = parcelRequire("9xYqG");
const $8f278686bdd56b47$export$bba48927994d7f26 = [
    'provisioningApiParams'
];
const $8f278686bdd56b47$export$530ae557c94159b9 = (options)=>(0, $9xYqG.createProductExtensions)($8f278686bdd56b47$export$bba48927994d7f26)({
        provisioningApiParams: options
    });

});

parcelRegister("bG1bs", function(module, exports) {

$parcel$export(module.exports, "createRecommendationContextExtensions", () => $e4df05e4385e1ca7$export$d1baeed0bd0517aa);

var $9xYqG = parcelRequire("9xYqG");
const $e4df05e4385e1ca7$export$4227e3a27cbd377 = [
    'recommendationContext'
];
const $e4df05e4385e1ca7$export$d1baeed0bd0517aa = (options)=>(0, $9xYqG.createProductExtensions)($e4df05e4385e1ca7$export$4227e3a27cbd377)({
        recommendationContext: options
    });

});


parcelRegister("bHpB9", function(module, exports) {

$parcel$export(module.exports, "BaseCrossFlowApiProvider", () => (parcelRequire("7wLxr")).BaseCrossFlowApiProvider);
$parcel$export(module.exports, "useCrossFlow", () => (parcelRequire("7wLxr")).useCrossFlow);
$parcel$export(module.exports, "withCrossFlow", () => (parcelRequire("7wLxr")).withCrossFlow);
$parcel$export(module.exports, "Journeys", () => (parcelRequire("lEtNM")).Journeys);
$parcel$export(module.exports, "Reasons", () => (parcelRequire("lEtNM")).Reasons);

var $7wLxr = parcelRequire("7wLxr");

var $lEtNM = parcelRequire("lEtNM");

});
parcelRegister("7wLxr", function(module, exports) {

$parcel$export(module.exports, "BaseCrossFlowApiProvider", () => $df7415e1fd91aa6d$export$c0ddec072762f62a);
$parcel$export(module.exports, "useCrossFlow", () => $df7415e1fd91aa6d$export$6e7a10fe635a0dfc);
$parcel$export(module.exports, "withCrossFlow", () => $df7415e1fd91aa6d$export$655b6c19a0daddb8);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $aMvxT = parcelRequire("aMvxT");

var $8lCrJ = parcelRequire("8lCrJ");

var $lEtNM = parcelRequire("lEtNM");
const $df7415e1fd91aa6d$var$LATEST_VERSION = (0, $8lCrJ.VERSION);
/**
 * Private Cross Flow context
 *
 * Not to be used directly other than by useCrossFlow and BaseCrossFlowApiProvider
 */ const $df7415e1fd91aa6d$var$CrossFlowContext = /*#__PURE__*/ (0, $5uXOq.createContext)(()=>({
        isEnabled: false,
        reason: (0, $lEtNM.Reasons).NO_PROVIDER
    }));
const $df7415e1fd91aa6d$export$59ce2d27e6cd8c9 = (onOpen)=>(version)=>{
        switch(version){
            case 0, $8lCrJ.VERSION:
                return {
                    isEnabled: true,
                    api: (0, $aMvxT.createAPIv0)(onOpen),
                    apiV1: (0, $8lCrJ.createAPIv1)(onOpen)
                };
            default:
                return {
                    isEnabled: false,
                    reason: (0, $lEtNM.Reasons).NO_API_SUPPORT
                };
        }
    };
const $df7415e1fd91aa6d$export$c0ddec072762f62a = ({ onOpen: onOpen, children: children })=>{
    const negotiateApi = (0, $5uXOq.useMemo)(()=>$df7415e1fd91aa6d$export$59ce2d27e6cd8c9(onOpen), [
        onOpen
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($df7415e1fd91aa6d$var$CrossFlowContext.Provider, {
        value: negotiateApi,
        children: children
    });
};
const $df7415e1fd91aa6d$export$6e7a10fe635a0dfc = ()=>{
    const negotiateApi = (0, $5uXOq.useContext)($df7415e1fd91aa6d$var$CrossFlowContext);
    return (0, $5uXOq.useMemo)(()=>negotiateApi($df7415e1fd91aa6d$var$LATEST_VERSION), [
        negotiateApi
    ]);
};
function $df7415e1fd91aa6d$export$655b6c19a0daddb8(//component coming in here has no crossflow type yet, but expects it
WrappedComponent) {
    const ComponentWithCrossFlow = (props)=>{
        const crossFlow = $df7415e1fd91aa6d$export$6e7a10fe635a0dfc();
        return /*#__PURE__*/ (0, $2OMIu.jsx)(WrappedComponent, {
            ...props,
            crossFlow: crossFlow
        });
    };
    ComponentWithCrossFlow.displayName = `withCrossFlow(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
    return ComponentWithCrossFlow;
}

});
parcelRegister("aMvxT", function(module, exports) {

$parcel$export(module.exports, "createAPIv0", () => $626f88795be3264e$export$9ff7368ac93fcf2d);
const $626f88795be3264e$export$a4ad2735b021c132 = 0;
const $626f88795be3264e$export$9ff7368ac93fcf2d = (onOpen)=>({
        open (options) {
            return onOpen(options);
        }
    });

});

parcelRegister("8lCrJ", function(module, exports) {

$parcel$export(module.exports, "VERSION", () => $b436661ee398aae0$export$a4ad2735b021c132);
$parcel$export(module.exports, "createAPIv1", () => $b436661ee398aae0$export$8fd5792fc468459f);
const $b436661ee398aae0$export$a4ad2735b021c132 = 1;
const $b436661ee398aae0$export$8fd5792fc468459f = (onOpen)=>({
        open (options) {
            return onOpen(options);
        }
    });

});

parcelRegister("lEtNM", function(module, exports) {

$parcel$export(module.exports, "Journeys", () => $19f792998fd3f757$export$3411873bfd520bb6);
$parcel$export(module.exports, "Reasons", () => $19f792998fd3f757$export$da2d4f2f250d6f84);
const $19f792998fd3f757$export$3411873bfd520bb6 = {
    GET_STARTED: 'get-started',
    DECIDE: 'decide',
    DISCOVER: 'discover'
};
const $19f792998fd3f757$export$da2d4f2f250d6f84 = {
    NO_API_SUPPORT: 'Could not provide requested API version',
    NO_PROVIDER: 'Provider not found'
};

});



parcelRegister("cmVQ7", function(module, exports) {

$parcel$export(module.exports, "useFireCrossFlowAnalyticsEvents", () => $b1a1530bf65c0c61$export$c2095165ae2bdcda);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $iDfVE = parcelRequire("iDfVE");

var $jAXLO = parcelRequire("jAXLO");
function $b1a1530bf65c0c61$export$c2095165ae2bdcda() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const firedViewedScreenEventName = (0, $5uXOq.useRef)();
    const firedViewedUIEventId = (0, $5uXOq.useRef)();
    const mapToCcpProductKeys = (0, $5uXOq.useCallback)((recommendedProductIds, targetProductId)=>{
        const ccpProductIds = recommendedProductIds.reduce((acc, curr)=>{
            acc.push((0, $iDfVE.SURFACE_ANALYTICS_PRODUCT_MAP).products[curr] ?? curr);
            return acc;
        }, []);
        const ccpTargetProductId = targetProductId && (0, $iDfVE.SURFACE_ANALYTICS_PRODUCT_MAP).products[targetProductId];
        return {
            recommendedProductIds: ccpProductIds,
            targetProductId: ccpTargetProductId ?? targetProductId
        };
    }, []);
    const fireViewedScreenEvent = (0, $5uXOq.useCallback)((name, commonAttributes, attributes)=>{
        // Prevent duplicate events from firing
        if (firedViewedScreenEventName.current === name) return;
        const { recommendedProductIds: recommendedProductIds, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds } = mapToCcpProductKeys(recommendedProductIds);
        createAnalyticsEvent({
            eventType: (0, $jAXLO.eventTypes).SCREEN,
            name: name,
            attributes: {
                recommendedProductIds: ccpProductIds,
                ...rest,
                ...attributes
            }
        }).fire((0, $jAXLO.CROSS_FLOW_CHANNEL));
        // Record the screen name so we don't fire it again
        firedViewedScreenEventName.current = name;
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    const fireViewedUIEvent = (0, $5uXOq.useCallback)((event, commonAttributes, attributes)=>{
        // Prevent duplicate events from firing
        if (firedViewedUIEventId.current === event.actionSubjectId) return;
        const { source: source, recommendedProductIds: recommendedProductIds, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds } = mapToCcpProductKeys(recommendedProductIds);
        createAnalyticsEvent({
            eventType: (0, $jAXLO.eventTypes).UI,
            ...event,
            source: source,
            attributes: {
                recommendedProductIds: ccpProductIds,
                ...rest,
                ...attributes
            }
        }).fire((0, $jAXLO.CROSS_FLOW_CHANNEL));
        firedViewedUIEventId.current = event.actionSubjectId;
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    const fireInteractedUIEvent = (0, $5uXOq.useCallback)((event, commonAttributes, attributes)=>{
        const { source: source, recommendedProductIds: recommendedProductIds, targetProductId: targetProductId, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds, targetProductId: ccpTargetProductId } = mapToCcpProductKeys(recommendedProductIds ?? [], targetProductId);
        createAnalyticsEvent({
            eventType: (0, $jAXLO.eventTypes).UI,
            ...event,
            source: source,
            attributes: {
                recommendedProductIds: ccpProductIds,
                targetProductId: ccpTargetProductId,
                ...rest,
                ...attributes
            }
        }).fire((0, $jAXLO.CROSS_FLOW_CHANNEL));
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    return {
        fireViewedScreenEvent: fireViewedScreenEvent,
        fireViewedUIEvent: fireViewedUIEvent,
        fireInteractedUIEvent: fireInteractedUIEvent
    };
}

});
parcelRegister("iDfVE", function(module, exports) {

$parcel$export(module.exports, "FIRST_PARTY_CCP_PRODUCT_IDS", () => $b9514a810cbf7271$export$6c053e1694ef181c);
$parcel$export(module.exports, "SURFACE_ANALYTICS_PRODUCT_MAP", () => $b9514a810cbf7271$export$54e3fc09a2a3347a);
const $b9514a810cbf7271$export$31048cb2a0753b12 = {
    jira_software_cloud: 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
    jira_work_management_cloud: '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
    jira_service_management_cloud: 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
    jira_product_discovery: 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
    confluence_cloud: '6aab3f4e-cc71-474d-8d28-abef8b057808',
    opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551'
};
const $b9514a810cbf7271$export$9d8f18312db80469 = {
    jira_software_cloud: 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
    jira_work_management_cloud: '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
    jira_service_management_cloud: 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
    jira_product_discovery: 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
    confluence_cloud: '6aab3f4e-cc71-474d-8d28-abef8b057808',
    opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551'
};
const $b9514a810cbf7271$export$6c053e1694ef181c = {
    prod: $b9514a810cbf7271$export$31048cb2a0753b12,
    staging: $b9514a810cbf7271$export$9d8f18312db80469
};
const $b9514a810cbf7271$export$54e3fc09a2a3347a = {
    products: {
        'confluence.ondemand': '6aab3f4e-cc71-474d-8d28-abef8b057808',
        'jira-software.ondemand': 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
        'jira-servicedesk.ondemand': 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
        'jira-core.ondemand': '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
        opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551',
        statuspage: '0b8ea1e2-52df-11ea-8d77-2e728ce88125',
        townsquare: '7c917705-866d-4b6b-b266-0fc7633e8342',
        compass: '6bce2ccb-4f57-46f5-812a-9dbf02dc28f2',
        'jira-product-discovery': 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
        beacon: '0a0a31b0-3f5f-4693-b231-9a753bee012e',
        'atlassian-analytics-free': 'f44da23e-5907-4d81-8a78-33bedee10969',
        mercury: 'd16a2ba8-445f-4e83-9c7b-9bcf349ff905'
    }
};

});

parcelRegister("jAXLO", function(module, exports) {

$parcel$export(module.exports, "CROSS_FLOW_CHANNEL", () => $dc2b00b588a8d355$export$c536a7e29a0739b8);
$parcel$export(module.exports, "eventTypes", () => $dc2b00b588a8d355$export$285f3d0989f9023f);
const $dc2b00b588a8d355$export$c536a7e29a0739b8 = 'crossFlow';
var $dc2b00b588a8d355$export$285f3d0989f9023f = /*#__PURE__*/ function(eventTypes) {
    eventTypes["UI"] = "ui";
    eventTypes["SCREEN"] = "screen";
    return eventTypes;
}({});

});


parcelRegister("s7Ri8", function(module, exports) {

var $ck5fJ = parcelRequire("ck5fJ");

var $a1YLW = parcelRequire("a1YLW");

var $8LQ84 = parcelRequire("8LQ84");
/**
 * Creates an array of shuffled values, using a version of the
 * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to shuffle.
 * @returns {Array} Returns the new shuffled array.
 * @example
 *
 * _.shuffle([1, 2, 3, 4]);
 * // => [4, 1, 3, 2]
 */ function $0548b62ea127d690$var$shuffle(collection) {
    var func = $8LQ84(collection) ? $ck5fJ : $a1YLW;
    return func(collection);
}
module.exports = $0548b62ea127d690$var$shuffle;

});
parcelRegister("ck5fJ", function(module, exports) {

var $jHlUS = parcelRequire("jHlUS");

var $ifvdh = parcelRequire("ifvdh");
/**
 * A specialized version of `_.shuffle` for arrays.
 *
 * @private
 * @param {Array} array The array to shuffle.
 * @returns {Array} Returns the new shuffled array.
 */ function $8f8b6d61b1553b58$var$arrayShuffle(array) {
    return $ifvdh($jHlUS(array));
}
module.exports = $8f8b6d61b1553b58$var$arrayShuffle;

});
parcelRegister("ifvdh", function(module, exports) {

var $diicZ = parcelRequire("diicZ");
/**
 * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
 *
 * @private
 * @param {Array} array The array to shuffle.
 * @param {number} [size=array.length] The size of `array`.
 * @returns {Array} Returns `array`.
 */ function $d491d6fac47da618$var$shuffleSelf(array, size) {
    var index = -1, length = array.length, lastIndex = length - 1;
    size = size === undefined ? length : size;
    while(++index < size){
        var rand = $diicZ(index, lastIndex), value = array[rand];
        array[rand] = array[index];
        array[index] = value;
    }
    array.length = size;
    return array;
}
module.exports = $d491d6fac47da618$var$shuffleSelf;

});
parcelRegister("diicZ", function(module, exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var $9adb14a65c3f9737$var$nativeFloor = Math.floor, $9adb14a65c3f9737$var$nativeRandom = Math.random;
/**
 * The base implementation of `_.random` without support for returning
 * floating-point numbers.
 *
 * @private
 * @param {number} lower The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the random number.
 */ function $9adb14a65c3f9737$var$baseRandom(lower, upper) {
    return lower + $9adb14a65c3f9737$var$nativeFloor($9adb14a65c3f9737$var$nativeRandom() * (upper - lower + 1));
}
module.exports = $9adb14a65c3f9737$var$baseRandom;

});



parcelRegister("a1YLW", function(module, exports) {

var $ifvdh = parcelRequire("ifvdh");

var $dMEgP = parcelRequire("dMEgP");
/**
 * The base implementation of `_.shuffle`.
 *
 * @private
 * @param {Array|Object} collection The collection to shuffle.
 * @returns {Array} Returns the new shuffled array.
 */ function $74d923783422b512$var$baseShuffle(collection) {
    return $ifvdh($dMEgP(collection));
}
module.exports = $74d923783422b512$var$baseShuffle;

});


parcelRegister("6eBRn", function(module, exports) {
/**
 * The inverse of `_.toPairs`; this method returns an object composed
 * from key-value `pairs`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} pairs The key-value pairs.
 * @returns {Object} Returns the new object.
 * @example
 *
 * _.fromPairs([['a', 1], ['b', 2]]);
 * // => { 'a': 1, 'b': 2 }
 */ function $48a16b14c2519b21$var$fromPairs(pairs) {
    var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
    while(++index < length){
        var pair = pairs[index];
        result[pair[0]] = pair[1];
    }
    return result;
}
module.exports = $48a16b14c2519b21$var$fromPairs;

});

parcelRegister("1w9F2", function(module, exports) {

$parcel$export(module.exports, "EditionAwareness", () => $54026fbd3f0eaacb$export$a55b02efe3d62583);

var $2OMIu = parcelRequire("2OMIu");

var $9Arxj = parcelRequire("9Arxj");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $fNobW = parcelRequire("fNobW");

var $8Ec39 = parcelRequire("8Ec39");

var $jZw3S = parcelRequire("jZw3S");

var $3FEPM = parcelRequire("3FEPM");

var $jnVcb = parcelRequire("jnVcb");

var $lNbsr = parcelRequire("lNbsr");

var $9Jh23 = parcelRequire("9Jh23");

var $4o6si = parcelRequire("4o6si");

var $56xSH = parcelRequire("56xSH");

var $2VfNT = parcelRequire("2VfNT");

var $gsZRM = parcelRequire("gsZRM");
function $54026fbd3f0eaacb$var$getBillingSourceSystem(typename) {
    switch(typename){
        case 'CcpEntitlement':
            return 'CCP';
        case 'HamsEntitlement':
            return 'HAMS';
    }
}
/**
 * Edition awareness is used to communicate to customers about the current edition they have and if they should
 * - Add payment details
 * - Upgrade their edition
 *
 * This component deals with creating the context which is then used throughout the package to:
 * - Track analytics
 * - Know which product/edition/cloud id is being used
 * - Know when to show/hide the button
 */ function $54026fbd3f0eaacb$var$EditionAwarenessImpl({ trialButton: trialButton, PremiumWrapper: PremiumWrapper, ...props }) {
    const { edition: edition, product: product, cloudId: cloudId, navVersion: navVersion, accountId: accountId, environment: environment, userRoles: userRolesFromProduct, hasDismissedButton: hasDismissedButton, onDismissButton: onDismissButton, siteTraits: siteTraits = [], isInReverseTrial: isInReverseTrialFromProduct, onOpenOnboardingMenu: onOpenOnboardingMenu, premiumFeatureHighlightToggle: premiumFeatureHighlightToggle, shouldAutoOpen: shouldAutoOpen, onAutoOpen: onAutoOpen, canRender: canRender } = props;
    const { isSpotlightActive: isSpotlightActive, handleSetSpotlight: handleSetSpotlight } = (0, $4o6si.useSpotlight)();
    const queryConfig = (0, $jnVcb.getQueryConfig)(product, edition, cloudId, accountId);
    const data = (0, $8Uumt.useLazyLoadQuery)((0, $9Arxj.default), queryConfig);
    const entitlement = data?.tenantContexts?.[0]?.entitlementInfo?.entitlement;
    const isInvoiceable = entitlement?.subscription?.accountDetails?.invoiceGroup?.invoiceable;
    const isConfigurePaymentAvailable = entitlement?.subscription?.accountDetails?.invoiceGroup?.experienceCapabilities?.configurePaymentV2?.isAvailableToUser === true;
    const addPaymentDetailsExperienceUrl = entitlement?.subscription?.accountDetails?.invoiceGroup?.experienceCapabilities?.configurePaymentV2?.experienceUrl;
    const canAddPaymentDetails = Boolean(isConfigurePaymentAvailable && addPaymentDetailsExperienceUrl);
    const trialTimeLeft = entitlement?.subscription?.trial?.timeLeft ?? undefined;
    const trialDaysLeft = (0, $9Jh23.getTrialDaysLeft)(trialTimeLeft);
    const trialStartTimestamp = entitlement?.subscription?.trial?.startTimestamp;
    const trialStartDate = (0, $5uXOq.useMemo)(()=>trialStartTimestamp ? new Date(trialStartTimestamp) : undefined, [
        trialStartTimestamp
    ]);
    const trialEndTimestamp = entitlement?.subscription?.trial?.endTimestamp;
    const trialEndDate = (0, $5uXOq.useMemo)(()=>trialEndTimestamp ? new Date(trialEndTimestamp) : undefined, [
        trialEndTimestamp
    ]);
    const trialLengthDays = entitlement?.offering?.trial?.lengthDays ?? undefined;
    const isInTrial = Boolean(trialDaysLeft && trialDaysLeft > 0);
    const isInPredunning = entitlement?.preDunning?.status === 'IN_PRE_DUNNING' && !isInvoiceable;
    const isInReverseTrial = (isInTrial || isInPredunning) && (isInReverseTrialFromProduct !== undefined ? isInReverseTrialFromProduct : false);
    const isChangeOfferingAvailable = entitlement?.experienceCapabilities?.changeOfferingV2?.isAvailableToUser;
    const changeOfferingToStandardExperienceUrl = entitlement?.experienceCapabilities?.changeOfferingV2?.experienceUrl;
    const canUpgrade = Boolean(isChangeOfferingAvailable && changeOfferingToStandardExperienceUrl);
    const billingSourceSystem = $54026fbd3f0eaacb$var$getBillingSourceSystem(entitlement?.__typename);
    const isInTeamWorkCollection = (0, $5uXOq.useMemo)(()=>{
        const collectionEntitlement = entitlement?.relatesFromEntitlements?.find((item)=>item?.relationshipType === 'COLLECTION');
        return !!collectionEntitlement?.entitlementId;
    }, [
        entitlement?.relatesFromEntitlements
    ]);
    const userRoles = (0, $5uXOq.useMemo)(()=>{
        const roles = [];
        if (userRolesFromProduct?.includes('SITE_ADMIN')) roles.push('SITE_ADMIN');
        if (data?.tenantContexts?.[0]?.entitlementInfo?.entitlement?.transactionAccount?.isCurrentUserBillingAdmin) roles.push('BILLING_ADMIN');
        return roles;
    }, [
        data?.tenantContexts,
        userRolesFromProduct
    ]);
    const userEmail = data?.user?.email;
    // We need to use the `latestUsageForChargeElement` to get the licensed user count for both free and trialing customers
    const licensedUsersRaw = entitlement?.latestUsageForChargeElement;
    // Assumes that there are always at least one assigned user to cover scenarios
    const licensedUsers = Math.max(licensedUsersRaw || 0, 1);
    const storageUsageInGB = (0, $5uXOq.useMemo)(()=>{
        if (data.jira?.attachmentStorageUsed && [
            'jira',
            'jira-service-management',
            'jira-product-discovery'
        ].includes(product)) return (0, $jZw3S.bytesToGigabytes)(data.jira.attachmentStorageUsed);
        if (data.confluence_storage?.bytesUsed && product === 'confluence') return (0, $jZw3S.bytesToGigabytes)(data.confluence_storage.bytesUsed);
        return undefined;
    }, [
        data.jira?.attachmentStorageUsed,
        data.confluence_storage?.bytesUsed,
        product
    ]);
    const siteTraitsForContext = (0, $5uXOq.useMemo)(()=>(0, $lNbsr.getSiteTraitValues)(siteTraits), [
        siteTraits
    ]);
    const context = (0, $5uXOq.useMemo)(()=>{
        return {
            cloudId: cloudId,
            product: product,
            edition: edition,
            navVersion: navVersion,
            isInvoiceable: isInvoiceable,
            canAddPaymentDetails: canAddPaymentDetails,
            addPaymentDetailsExperienceUrl: addPaymentDetailsExperienceUrl,
            trialDaysLeft: trialDaysLeft,
            trialStartDate: trialStartDate,
            trialEndDate: trialEndDate,
            trialLengthDays: trialLengthDays,
            isInTrial: isInTrial,
            isInPredunning: isInPredunning,
            isInReverseTrial: isInReverseTrial,
            canUpgrade: canUpgrade,
            changeOfferingToStandardExperienceUrl: changeOfferingToStandardExperienceUrl,
            isInTeamWorkCollection: isInTeamWorkCollection,
            licensedUsers: licensedUsers,
            environment: environment,
            userEmail: userEmail,
            userRoles: userRoles,
            hasDismissedButton: hasDismissedButton,
            onDismissButton: onDismissButton,
            isSpotlightActive: isSpotlightActive,
            handleSetSpotlight: handleSetSpotlight,
            billingSourceSystem: billingSourceSystem,
            onOpenOnboardingMenu: onOpenOnboardingMenu,
            premiumFeatureHighlightToggle: premiumFeatureHighlightToggle,
            shouldAutoOpen: shouldAutoOpen,
            onAutoOpen: onAutoOpen,
            PremiumWrapper: PremiumWrapper,
            storageUsageInGB: storageUsageInGB,
            ...siteTraitsForContext
        };
    }, [
        cloudId,
        product,
        edition,
        navVersion,
        isInvoiceable,
        canAddPaymentDetails,
        addPaymentDetailsExperienceUrl,
        trialDaysLeft,
        trialStartDate,
        trialEndDate,
        trialLengthDays,
        isInTrial,
        isInPredunning,
        isInReverseTrial,
        canUpgrade,
        changeOfferingToStandardExperienceUrl,
        isInTeamWorkCollection,
        licensedUsers,
        environment,
        userEmail,
        userRoles,
        hasDismissedButton,
        onDismissButton,
        isSpotlightActive,
        handleSetSpotlight,
        billingSourceSystem,
        onOpenOnboardingMenu,
        premiumFeatureHighlightToggle,
        shouldAutoOpen,
        onAutoOpen,
        PremiumWrapper,
        storageUsageInGB,
        siteTraitsForContext
    ]);
    if (!canRender) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fNobW.default), {
        name: "edition-awareness-waiting-on-product"
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3FEPM.EditionAwarenessContext).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2VfNT.ErrorBoundary), {
            product: product,
            edition: edition,
            id: "audience-and-timing",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $56xSH.AudienceAndTiming), {
                    trialButton: trialButton
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gsZRM.Spotlight), {})
            ]
        })
    });
}
function $54026fbd3f0eaacb$export$a55b02efe3d62583(props) {
    const { product: product, edition: edition } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8Ec39.default), {
        name: "edition-awareness-platform",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2VfNT.ErrorBoundary), {
            product: product,
            edition: edition,
            id: "edition-awareness",
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)($54026fbd3f0eaacb$var$EditionAwarenessImpl, {
                    ...props
                })
            })
        })
    });
}

});
parcelRegister("9Arxj", function(module, exports) {

$parcel$export(module.exports, "default", () => $372fb9728b391b1f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c67049cec7bee5dc176297ec13fed118>>
 * @relayHash 76b09d7a7a8631b56e3f920421ad7dd8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 28235929068ee2b7213dfd8facfe98fc172a6bd9c001188ae345fe867e22b99a
const $372fb9728b391b1f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "accountId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "applicationKey"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "chargeElement"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entitlementFilter"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "productKey"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldCheckBillingAdmin"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldCheckForChangeOffering"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldCheckForChargeQuantities"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldCheckForStorageUsageConfluence"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldCheckForStorageUsageJira"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldCheckForTrial"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldCheckForTwc"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldCheckForUserEmail"
    }, v14 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldSkip"
    }, v15 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v16 = {
        "condition": "shouldCheckForStorageUsageJira",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "applicationKey",
                                "variableName": "applicationKey"
                            },
                            v15 /*: any*/ 
                        ],
                        "kind": "ScalarField",
                        "name": "attachmentStorageUsed"
                    }
                ]
            }
        ]
    }, v17 = {
        "condition": "shouldCheckForStorageUsageConfluence",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    v15 /*: any*/ 
                ],
                "concreteType": "ConfluenceStorage",
                "kind": "LinkedField",
                "name": "confluence_storage",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "bytesUsed"
                    }
                ]
            }
        ]
    }, v18 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v19 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "productKey"
        }
    ], v20 = [
        {
            "kind": "Variable",
            "name": "where",
            "variableName": "entitlementFilter"
        }
    ], v21 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v22 = [
        {
            "kind": "Literal",
            "name": "offeringName",
            "value": "Standard"
        }
    ], v23 = {
        "kind": "ScalarField",
        "name": "isAvailableToUser"
    }, v24 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v25 = {
        "condition": "shouldCheckForChargeQuantities",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "chargeElement",
                        "variableName": "chargeElement"
                    }
                ],
                "kind": "ScalarField",
                "name": "latestUsageForChargeElement"
            }
        ]
    }, v26 = {
        "kind": "ScalarField",
        "name": "status"
    }, v27 = {
        "kind": "ScalarField",
        "name": "timeLeft"
    }, v28 = {
        "kind": "ScalarField",
        "name": "startTimestamp"
    }, v29 = {
        "kind": "ScalarField",
        "name": "endTimestamp"
    }, v30 = {
        "kind": "ScalarField",
        "name": "invoiceable"
    }, v31 = {
        "kind": "ScalarField",
        "name": "lengthDays"
    }, v32 = {
        "kind": "ScalarField",
        "name": "isCurrentUserBillingAdmin"
    }, v33 = {
        "kind": "ScalarField",
        "name": "relationshipType"
    }, v34 = {
        "kind": "ScalarField",
        "name": "entitlementId"
    }, v35 = [
        {
            "kind": "Variable",
            "name": "accountId",
            "variableName": "accountId"
        }
    ], v36 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "email"
            }
        ],
        "type": "AtlassianAccountUser"
    }, v37 = {
        "kind": "ScalarField",
        "name": "id"
    }, v38 = [
        v37 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "editionAwarenessQuery",
            "selections": [
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                {
                    "condition": "shouldSkip",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v18 /*: any*/ ,
                            "concreteType": "TenantContext",
                            "kind": "LinkedField",
                            "name": "tenantContexts",
                            "plural": true,
                            "selections": [
                                {
                                    "args": v19 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "entitlementInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": v20 /*: any*/ ,
                                            "kind": "LinkedField",
                                            "name": "entitlement",
                                            "plural": false,
                                            "selections": [
                                                v21 /*: any*/ ,
                                                {
                                                    "condition": "shouldCheckForChangeOffering",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "experienceCapabilities",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "args": v22 /*: any*/ ,
                                                                    "kind": "LinkedField",
                                                                    "name": "changeOfferingV2",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v23 /*: any*/ ,
                                                                        v24 /*: any*/ 
                                                                    ],
                                                                    "storageKey": "changeOfferingV2(offeringName:\"Standard\")"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v25 /*: any*/ ,
                                                {
                                                    "condition": "shouldCheckForTrial",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "preDunning",
                                                            "plural": false,
                                                            "selections": [
                                                                v26 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "subscription",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "trial",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v27 /*: any*/ ,
                                                                        v28 /*: any*/ ,
                                                                        v29 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "accountDetails",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "invoiceGroup",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v30 /*: any*/ ,
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "experienceCapabilities",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "configurePaymentV2",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v24 /*: any*/ ,
                                                                                                v23 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "offering",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "trial",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v31 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "shouldCheckBillingAdmin",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "transactionAccount",
                                                            "plural": false,
                                                            "selections": [
                                                                v32 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "shouldCheckForTwc",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "relatesFromEntitlements",
                                                            "plural": true,
                                                            "selections": [
                                                                v33 /*: any*/ ,
                                                                v34 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "shouldCheckForUserEmail",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v35 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v36 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v3 /*: any*/ ,
                v5 /*: any*/ ,
                v7 /*: any*/ ,
                v11 /*: any*/ ,
                v14 /*: any*/ ,
                v8 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ ,
                v6 /*: any*/ ,
                v12 /*: any*/ ,
                v10 /*: any*/ ,
                v1 /*: any*/ ,
                v9 /*: any*/ ,
                v0 /*: any*/ ,
                v13 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "editionAwarenessQuery",
            "selections": [
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                {
                    "condition": "shouldSkip",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v18 /*: any*/ ,
                            "concreteType": "TenantContext",
                            "kind": "LinkedField",
                            "name": "tenantContexts",
                            "plural": true,
                            "selections": [
                                {
                                    "args": v19 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "entitlementInfo",
                                    "plural": false,
                                    "selections": [
                                        v21 /*: any*/ ,
                                        {
                                            "args": v20 /*: any*/ ,
                                            "kind": "LinkedField",
                                            "name": "entitlement",
                                            "plural": false,
                                            "selections": [
                                                v21 /*: any*/ ,
                                                {
                                                    "condition": "shouldCheckForChangeOffering",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "experienceCapabilities",
                                                            "plural": false,
                                                            "selections": [
                                                                v21 /*: any*/ ,
                                                                {
                                                                    "args": v22 /*: any*/ ,
                                                                    "kind": "LinkedField",
                                                                    "name": "changeOfferingV2",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v21 /*: any*/ ,
                                                                        v23 /*: any*/ ,
                                                                        v24 /*: any*/ 
                                                                    ],
                                                                    "storageKey": "changeOfferingV2(offeringName:\"Standard\")"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v25 /*: any*/ ,
                                                {
                                                    "condition": "shouldCheckForTrial",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "preDunning",
                                                            "plural": false,
                                                            "selections": [
                                                                v21 /*: any*/ ,
                                                                v26 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "subscription",
                                                            "plural": false,
                                                            "selections": [
                                                                v21 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "trial",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v21 /*: any*/ ,
                                                                        v27 /*: any*/ ,
                                                                        v28 /*: any*/ ,
                                                                        v29 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "accountDetails",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v21 /*: any*/ ,
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "invoiceGroup",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v21 /*: any*/ ,
                                                                                v30 /*: any*/ ,
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "experienceCapabilities",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v21 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "configurePaymentV2",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v21 /*: any*/ ,
                                                                                                v24 /*: any*/ ,
                                                                                                v23 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": v38 /*: any*/ ,
                                                                                    "type": "CcpInvoiceGroup"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v38 /*: any*/ ,
                                                                    "type": "CcpSubscription"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "offering",
                                                            "plural": false,
                                                            "selections": [
                                                                v21 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "trial",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v21 /*: any*/ ,
                                                                        v31 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v38 /*: any*/ ,
                                                                    "type": "Node",
                                                                    "abstractKey": "__isNode"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "shouldCheckBillingAdmin",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "transactionAccount",
                                                            "plural": false,
                                                            "selections": [
                                                                v21 /*: any*/ ,
                                                                v32 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v38 /*: any*/ ,
                                                                    "type": "CcpTransactionAccount"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "shouldCheckForTwc",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "relatesFromEntitlements",
                                                            "plural": true,
                                                            "selections": [
                                                                v21 /*: any*/ ,
                                                                v33 /*: any*/ ,
                                                                v34 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v37 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "shouldCheckForUserEmail",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v35 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v21 /*: any*/ ,
                                v36 /*: any*/ ,
                                v37 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "28235929068ee2b7213dfd8facfe98fc172a6bd9c001188ae345fe867e22b99a",
            "metadata": {},
            "name": "editionAwarenessQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$372fb9728b391b1f$var$node.hash = "6863184789a19588e6e7e7ececd2e238";
var $372fb9728b391b1f$export$2e2bcd8739ae039 = $372fb9728b391b1f$var$node;

});

parcelRegister("jZw3S", function(module, exports) {

$parcel$export(module.exports, "bytesToGigabytes", () => $944df11c6a805ec8$export$6f25243957146989);
/**
 * Most storage measurements are in gigabytes
 */ function $944df11c6a805ec8$export$6f25243957146989(bytes) {
    return bytes / 1000000000;
}

});

parcelRegister("3FEPM", function(module, exports) {

$parcel$export(module.exports, "EditionAwarenessContext", () => $2761dbba4f066eb6$export$ac3ca8c46f19a73f);
$parcel$export(module.exports, "useEditionAwareness", () => $2761dbba4f066eb6$export$5a5baedfe8151ce);

var $5uXOq = parcelRequire("5uXOq");
const $2761dbba4f066eb6$export$ac3ca8c46f19a73f = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
function $2761dbba4f066eb6$export$5a5baedfe8151ce() {
    const context = (0, $5uXOq.useContext)($2761dbba4f066eb6$export$ac3ca8c46f19a73f);
    if (!context) throw new Error('Missing context, please ensure this is used within EditionAwarenessContext');
    return context;
}

});

parcelRegister("jnVcb", function(module, exports) {

$parcel$export(module.exports, "getQueryConfig", () => $a6b373558895e639$export$bac5bb66ae1b635d);

var $VSDnB = parcelRequire("VSDnB");

var $eDHw9 = parcelRequire("eDHw9");

var $iENAf = parcelRequire("iENAf");

var $8XFbn = parcelRequire("8XFbn");
function $a6b373558895e639$export$bac5bb66ae1b635d(product, edition, cloudId, accountId) {
    const isStandardTrialsUserAndStorageLimitBreakersEnabledJira = product === 'jira' && edition === 'standard' && (0, $VSDnB.fg)('jira_edition_awareness_standard_trials_gate');
    const isStandardTrialsUserAndStorageLimitBreakersEnabledConnie = product === 'confluence' && edition === 'standard' && (0, $VSDnB.fg)('connie_edition_awareness_standard_trials_gate');
    const isStandardTrialsUserAndStorageLimitBreakersEnabled = isStandardTrialsUserAndStorageLimitBreakersEnabledJira || isStandardTrialsUserAndStorageLimitBreakersEnabledConnie;
    return {
        shouldSkip: product === 'jira-product-discovery' && (0, $VSDnB.fg)('jpd_disable_edition_awareness'),
        shouldCheckForChangeOffering: edition === 'free',
        shouldCheckForTrial: edition === 'premium' || edition === 'standard',
        cloudId: cloudId,
        productKey: (0, $8XFbn.getHamsKey)(product),
        shouldCheckForChargeQuantities: edition === 'free' || isStandardTrialsUserAndStorageLimitBreakersEnabled,
        // The entitlement filter ensures that we apply the `inTrialOrPreDunning` only when an entitlement is
        // on a non free edition. The filter is based on the trial end timestamp inside of TCS, this means that
        // if a customer downgrades their product to free while on a trial, then they will only show up
        // if inTrialOrPreDunning is set to true as the filter assumes they are still on trial.
        entitlementFilter: edition !== 'free' ? {
            inTrialOrPreDunning: true
        } : null,
        chargeElement: (0, $eDHw9.getChargeElementKey)(product),
        shouldCheckBillingAdmin: false,
        shouldCheckForTwc: (product === 'jira' || product === 'confluence') && (0, $VSDnB.fg)('teamwork_collection_ea_modal'),
        shouldCheckForStorageUsageJira: isStandardTrialsUserAndStorageLimitBreakersEnabledJira,
        applicationKey: (0, $iENAf.getJiraApplicationKey)(product) ?? 'JIRA_SOFTWARE',
        shouldCheckForStorageUsageConfluence: isStandardTrialsUserAndStorageLimitBreakersEnabledConnie,
        // AccountID is a required value, but the condition will ensure it is not used if undefined/null
        accountId: accountId ?? '',
        shouldCheckForUserEmail: !!accountId && product === 'jira' && edition === 'standard'
    };
}

});
parcelRegister("eDHw9", function(module, exports) {

$parcel$export(module.exports, "getChargeElementKey", () => $94eee0f9af6c569f$export$58e4e89574623b4);
const $94eee0f9af6c569f$var$PRODUCT_TO_CHARGE_ELEMENT = {
    ['confluence']: 'user',
    ['jira']: 'user',
    ['jira-product-discovery']: 'user',
    ['jira-service-management']: 'agent'
};
const $94eee0f9af6c569f$export$58e4e89574623b4 = (product)=>{
    return $94eee0f9af6c569f$var$PRODUCT_TO_CHARGE_ELEMENT[product];
};

});

parcelRegister("iENAf", function(module, exports) {

$parcel$export(module.exports, "getJiraApplicationKey", () => $452974a9bca5e81e$export$2fd6994252e4887f);
// We're explicitly excluding 'confluence' from this mapping as it's handled separately
const $452974a9bca5e81e$var$PRODUCT_TO_JIRA_APPLICATION_KEY = {
    ['jira']: 'JIRA_SOFTWARE',
    ['jira-product-discovery']: 'JIRA_PRODUCT_DISCOVERY',
    ['jira-service-management']: 'JIRA_SERVICE_DESK'
};
const $452974a9bca5e81e$export$2fd6994252e4887f = (product)=>{
    return $452974a9bca5e81e$var$PRODUCT_TO_JIRA_APPLICATION_KEY[product];
};

});


parcelRegister("lNbsr", function(module, exports) {

$parcel$export(module.exports, "getSiteTraitValues", () => $c58975f008d8a6ba$export$2a16c85f3c5d2302);
const $c58975f008d8a6ba$export$2a16c85f3c5d2302 = (traits)=>{
    if (traits.length === 0) return {
        siteType: null,
        automationWeeklyUsage: 0,
        automationDailyUsage: 0
    };
    const siteTypeTrait = traits.find((trait)=>trait.name === 'growth_discount_cohort');
    let siteType = null;
    if (siteTypeTrait) {
        if (siteTypeTrait.value === 'EDU' || siteTypeTrait.value === 'ORG') siteType = siteTypeTrait.value;
        else siteType = 'UNKNOWN';
    }
    // Hard coded limits while we refactor trait loading code
    const automationWeeklyUsage = 0;
    const automationDailyUsage = 0;
    return {
        siteType: siteType,
        automationWeeklyUsage: automationWeeklyUsage,
        automationDailyUsage: automationDailyUsage
    };
};

});

parcelRegister("9Jh23", function(module, exports) {

$parcel$export(module.exports, "getTrialDaysLeft", () => $309aab5bbbf171fb$export$954628993bf3188e);
const $309aab5bbbf171fb$var$MILLISECOND_IN_A_DAY = 86400000;
function $309aab5bbbf171fb$export$954628993bf3188e(timeLeft) {
    if (timeLeft === null || timeLeft === undefined) return undefined;
    if (timeLeft <= 0) return 0;
    // Use Math.ceil to round up for fractional days
    return Math.ceil(timeLeft / $309aab5bbbf171fb$var$MILLISECOND_IN_A_DAY);
}

});

parcelRegister("4o6si", function(module, exports) {

$parcel$export(module.exports, "useSpotlight", () => $0e54fa392d9bd459$export$cc7026713a353975);

var $5uXOq = parcelRequire("5uXOq");
function $0e54fa392d9bd459$export$cc7026713a353975() {
    const [isSpotlightActive, setIsSpotlightActive] = (0, $5uXOq.useState)(false);
    const handleSetSpotlight = (0, $5uXOq.useCallback)((isActive)=>{
        setIsSpotlightActive(isActive);
    }, [
        setIsSpotlightActive
    ]);
    return {
        isSpotlightActive: isSpotlightActive,
        handleSetSpotlight: handleSetSpotlight
    };
}

});

parcelRegister("56xSH", function(module, exports) {

$parcel$export(module.exports, "AudienceAndTiming", () => $96342859ab580836$export$d288e6ad7a0cf9f8);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $fK9DC = parcelRequire("fK9DC");

var $3FEPM = parcelRequire("3FEPM");

var $5Shw2 = parcelRequire("5Shw2");
/**
 * One off event which tracks when a customer is eligible/ineligible for edition awareness
 */ function $96342859ab580836$var$useTrackAudienceAndTiming(isEligible) {
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $fK9DC.useAnalytics)();
    const hasSent = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (hasSent.current) return;
        sendAnalyticsEvent({
            eventType: 'operational',
            actionSubject: 'audienceAndTiming',
            actionSubjectId: 'editionAwareness',
            action: 'checked',
            attributes: {
                isEligible: isEligible
            }
        });
        hasSent.current = true;
    }, [
        sendAnalyticsEvent,
        isEligible
    ]);
}
/**
 * Tracks when a user should see the edition awareness experience
 */ function $96342859ab580836$var$Analytics({ children: children }) {
    $96342859ab580836$var$useTrackAudienceAndTiming(true);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
        children: children
    });
}
/**
 * Just sends ineligibility info through a `eligibilityCriteria checked` event.
 * This exists so we can optionally render this component
 */ function $96342859ab580836$var$IneligibleAnalytics() {
    $96342859ab580836$var$useTrackAudienceAndTiming(false);
    return null;
}
function $96342859ab580836$export$d288e6ad7a0cf9f8({ trialButton: trialButton }) {
    const context = (0, $3FEPM.useEditionAwareness)();
    const { product: product, edition: edition, isInTrial: isInTrial, isInPredunning: isInPredunning, canUpgrade: canUpgrade, isInvoiceable: isInvoiceable, canAddPaymentDetails: canAddPaymentDetails } = context;
    const isInTrialOrPredunning = isInTrial || isInPredunning;
    if (product === 'jira-product-discovery' && (0, $VSDnB.fg)('jpd_disable_edition_awareness')) return null;
    if (edition === 'free' && canUpgrade) return /*#__PURE__*/ (0, $2OMIu.jsx)($96342859ab580836$var$Analytics, {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5Shw2.ActionsAndContent), {
            trialButton: trialButton
        })
    });
    if (edition === 'standard' && isInTrialOrPredunning && isInvoiceable === false && canAddPaymentDetails) return /*#__PURE__*/ (0, $2OMIu.jsx)($96342859ab580836$var$Analytics, {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5Shw2.ActionsAndContent), {
            trialButton: trialButton
        })
    });
    if (edition === 'premium' && [
        'jira',
        'jira-service-management'
    ].includes(product) && isInTrialOrPredunning && isInvoiceable === false && canAddPaymentDetails) return /*#__PURE__*/ (0, $2OMIu.jsx)($96342859ab580836$var$Analytics, {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5Shw2.ActionsAndContent), {
            trialButton: trialButton
        })
    });
    if (product === 'confluence' && edition === 'premium' && isInTrialOrPredunning) // Confluence will always show the button for premium while a customer is in a trial or in predunning
    // If the customer can add payment, that is checked as part of rendering the dialog (as the dialog
    // will still show to the customer if they can not add payment details)
    return /*#__PURE__*/ (0, $2OMIu.jsx)($96342859ab580836$var$Analytics, {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5Shw2.ActionsAndContent), {
            trialButton: trialButton
        })
    });
    if (edition === 'free' || isInTrialOrPredunning) // We're only firing the ineligible analytics when we could've shown the button, not all instances
    // this is to ensure we don't send the event on every page load
    return /*#__PURE__*/ (0, $2OMIu.jsx)($96342859ab580836$var$IneligibleAnalytics, {});
    return null;
}

});
parcelRegister("fK9DC", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $ed4593ed7d38e43c$export$85183a312807388d);
$parcel$export(module.exports, "getAttributesFromContexts", () => $ed4593ed7d38e43c$export$d97c97ed77ff09e8);
$parcel$export(module.exports, "defaultAttributes", () => $ed4593ed7d38e43c$export$38cd8db2db178f58);
$parcel$export(module.exports, "useAnalytics", () => $ed4593ed7d38e43c$export$e955abb82869dc84);

var $5uXOq = parcelRequire("5uXOq");

var $e8KHW = parcelRequire("e8KHW");

var $1SrMX = parcelRequire("1SrMX");
var $2NMNM = parcelRequire("2NMNM");

var $iEN9D = parcelRequire("iEN9D");

var $3FEPM = parcelRequire("3FEPM");
const $ed4593ed7d38e43c$export$85183a312807388d = (0, $e8KHW.FabricChannel).growth;
const $ed4593ed7d38e43c$export$d97c97ed77ff09e8 = (context)=>{
    if (!context || !Array.isArray(context)) return {};
    return context.reduce((acc, x)=>{
        if (x.attributes) return {
            ...acc,
            ...x.attributes
        };
        return {
            ...acc,
            ...x ?? {}
        };
    }, {});
};
const $ed4593ed7d38e43c$export$38cd8db2db178f58 = {
    packageName: '@atlassian/edition-awareness',
    source: 'editionAwareness',
    featureId: 'edition-awareness',
    growthPillar: 'BUY'
};
function $ed4593ed7d38e43c$export$e955abb82869dc84() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const editionAwarenessContext = (0, $3FEPM.useEditionAwareness)();
    const experimentMeta = (0, $5uXOq.useMemo)(()=>{
        // I wanted to reference the utility function but,
        // that file imports AtlBrowserStorageLocal which makes the VR tests to fail with timeout, even if is not executed on runtime
        //if (isFreeEduOrOrgSite(editionAwarenessContext)) {
        //Only add the metadata when the site may be eligible for the experiment
        if (editionAwarenessContext.edition === 'free' && (editionAwarenessContext.siteType === 'EDU' || editionAwarenessContext.siteType === 'ORG')) return [
            {
                key: 'offer_edu_org_discount',
                cohort: (0, $iEN9D.default).getExperimentValue('offer_edu_org_discount', 'cohort', 'not-enrolled'),
                siteType: editionAwarenessContext.siteType
            }
        ];
        return [];
    }, [
        editionAwarenessContext
    ]);
    const sendAnalyticsEvent = (0, $5uXOq.useCallback)((payload)=>{
        const editionAwarenessContextAttributes = {
            // Required properties
            cloudId: editionAwarenessContext.cloudId,
            product: editionAwarenessContext.product,
            currentProductEdition: editionAwarenessContext.edition,
            // Payment properties
            isInvoiceable: editionAwarenessContext.isInvoiceable,
            canAddPaymentDetails: editionAwarenessContext.canAddPaymentDetails,
            addPaymentDetailsExperienceUrl: editionAwarenessContext.addPaymentDetailsExperienceUrl,
            // Trial properties
            trialDaysLeft: editionAwarenessContext.trialDaysLeft,
            trialLengthDays: editionAwarenessContext.trialLengthDays,
            trialEndDate: editionAwarenessContext.trialEndDate,
            isInTrial: editionAwarenessContext.isInTrial,
            isInPredunning: editionAwarenessContext.isInPredunning,
            isInReverseTrial: editionAwarenessContext.isInReverseTrial,
            trialOfferingName: editionAwarenessContext.trialOfferingName,
            changeOfferingToStandardExperienceUrl: editionAwarenessContext.changeOfferingToStandardExperienceUrl,
            // Entitlement properties
            isInTeamWorkCollection: editionAwarenessContext.isInTeamWorkCollection,
            // User permissions properties
            canUpgrade: editionAwarenessContext.canUpgrade,
            userRoles: editionAwarenessContext.userRoles,
            userEmail: editionAwarenessContext.userEmail,
            // Site properties
            siteType: editionAwarenessContext.siteType,
            billingSourceSystem: editionAwarenessContext.billingSourceSystem,
            licensedUsers: editionAwarenessContext.licensedUsers,
            storageUsageInGB: editionAwarenessContext.storageUsageInGB,
            // Capabilities
            hasDismissedButton: editionAwarenessContext.hasDismissedButton,
            isSpotlightActive: editionAwarenessContext.isSpotlightActive,
            shouldAutoOpen: editionAwarenessContext.shouldAutoOpen
        };
        if (payload instanceof (0, $1SrMX.default)) {
            const contextAttributes = $ed4593ed7d38e43c$export$d97c97ed77ff09e8(payload.context);
            payload.update({
                ...payload.payload,
                attributes: {
                    ...contextAttributes,
                    ...$ed4593ed7d38e43c$export$38cd8db2db178f58,
                    ...payload.payload.attributes,
                    ...editionAwarenessContextAttributes,
                    experimentMeta: experimentMeta
                }
            }).fire($ed4593ed7d38e43c$export$85183a312807388d);
        } else {
            const event = createAnalyticsEvent({
                ...payload,
                attributes: {
                    ...$ed4593ed7d38e43c$export$38cd8db2db178f58,
                    ...payload.attributes,
                    ...editionAwarenessContextAttributes,
                    experimentMeta: experimentMeta
                }
            });
            const contextAttributes = $ed4593ed7d38e43c$export$d97c97ed77ff09e8(event.context);
            event.update({
                attributes: {
                    ...contextAttributes,
                    ...event.payload.attributes
                }
            }).fire($ed4593ed7d38e43c$export$85183a312807388d);
        }
    }, [
        createAnalyticsEvent,
        editionAwarenessContext,
        experimentMeta
    ]);
    return {
        sendAnalyticsEvent: sendAnalyticsEvent
    };
}
function $ed4593ed7d38e43c$export$b901544a79a3bbad({ name: name, attributes: attributes }) {
    const { sendAnalyticsEvent: sendAnalyticsEvent } = $ed4593ed7d38e43c$export$e955abb82869dc84();
    const hasSent = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (hasSent.current) return;
        sendAnalyticsEvent({
            eventType: 'screen',
            name: name,
            attributes: attributes
        });
        hasSent.current = true;
    }, [
        sendAnalyticsEvent,
        name,
        attributes
    ]);
    return null;
}

});

parcelRegister("5Shw2", function(module, exports) {

$parcel$export(module.exports, "ActionsAndContent", () => $3482a278540e0814$export$3bec899b1babe0fe);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $iEN9D = parcelRequire("iEN9D");

var $VSDnB = parcelRequire("VSDnB");

var $3bDjY = parcelRequire("3bDjY");

var $fLNQI = parcelRequire("fLNQI");

var $fK9DC = parcelRequire("fK9DC");

var $3FEPM = parcelRequire("3FEPM");

var $dTcX5 = parcelRequire("dTcX5");

var $7cGxK = parcelRequire("7cGxK");

var $3Ic4Z = parcelRequire("3Ic4Z");

var $d1IFL = parcelRequire("d1IFL");

var $kbMGT = parcelRequire("kbMGT");

var $lLXXb = parcelRequire("lLXXb");

var $glCOg = parcelRequire("glCOg");

var $7f9lz = parcelRequire("7f9lz");

var $8kHqB = parcelRequire("8kHqB");

var $d0sbz = parcelRequire("d0sbz");

var $cqUnB = parcelRequire("cqUnB");

var $atpKp = parcelRequire("atpKp");

var $26Yuk = parcelRequire("26Yuk");

var $dWrfe = parcelRequire("dWrfe");

var $58xN9 = parcelRequire("58xN9");

var $elt4i = parcelRequire("elt4i");

var $70SOi = parcelRequire("70SOi");

var $5yG9d = parcelRequire("5yG9d");
const $3482a278540e0814$var$AddPaymentLink = ()=>{
    const context = (0, $3FEPM.useEditionAwareness)();
    const { addPaymentDetailsExperienceUrl: addPaymentDetailsExperienceUrl } = context;
    // This information should always be available, given the prior checks to get here
    if (!addPaymentDetailsExperienceUrl) return /*#__PURE__*/ (0, $2OMIu.jsx)($3482a278540e0814$var$NoAction, {});
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            id: "@atlassian/edition-awareness.link.add-payment-tooltip",
            defaultMessage: "Add payment details to keep your subscription",
            description: "Tooltip for add payment details button"
        }),
        position: "bottom",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5yG9d.EditionAwarenessLink), {
            href: addPaymentDetailsExperienceUrl,
            target: "_blank",
            touchpointIntent: "addPaymentDetails",
            linkId: "predunning"
        })
    });
};
const $3482a278540e0814$var$JiraStandardTrialOverviewLink = ()=>{
    const { cloudId: cloudId, environment: environment, billingSourceSystem: billingSourceSystem, userEmail: userEmail } = (0, $3FEPM.useEditionAwareness)();
    // This information should always be available, given the prior checks to get here
    if (!environment || !billingSourceSystem || !userEmail) return /*#__PURE__*/ (0, $2OMIu.jsx)($3482a278540e0814$var$NoAction, {});
    const rawJstoUrl = `${(0, $lLXXb.WAC_URL)[environment]}/software/jira?ref=edition_awareness_standard_trial_` + `${billingSourceSystem.toLowerCase()}&cloudSiteId=${cloudId}`;
    const jstoUrl = (0, $dTcX5.getLoggedInPage)(userEmail, rawJstoUrl);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            id: "@atlassian/edition-awareness.link.jira-standard-trial-overview-tooltip",
            defaultMessage: "More about your trial and how to pay",
            description: "Tooltip for trial information button"
        }),
        position: "bottom",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5yG9d.EditionAwarenessLink), {
            href: jstoUrl,
            target: "_blank",
            touchpointIntent: "addPaymentDetails",
            linkId: "jsto"
        })
    });
};
/**
 * Sends an event when there is no action available for the customer to render. This is an error state
 * which means that audience and timing has passed a customer as eligible when they shouldn't have.
 *
 * Next iteration on this would be to return a safe default action for all customers
 */ function $3482a278540e0814$var$NoAction() {
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $fK9DC.useAnalytics)();
    const hasSent = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (hasSent.current) return;
        sendAnalyticsEvent({
            eventType: 'operational',
            actionSubject: 'actionsAndContent',
            actionSubjectId: 'editionAwareness',
            action: 'missed'
        });
        hasSent.current = true;
    }, [
        sendAnalyticsEvent
    ]);
    return null;
}
function $3482a278540e0814$var$FreeEdition() {
    const context = (0, $3FEPM.useEditionAwareness)();
    const { product: product, siteType: siteType, isInTeamWorkCollection: isInTeamWorkCollection } = context;
    if ([
        'jira',
        'confluence'
    ].includes(product) && isInTeamWorkCollection && (0, $VSDnB.fg)('teamwork_collection_ea_modal')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $atpKp.PlanSelectionPageDialog), {
        type: "twc"
    });
    if ((0, $d1IFL.isEligibleForEduDiscount)(context) && (0, $iEN9D.default).getExperimentValue('offer_edu_org_discount', 'cohort', 'not-enrolled') === 'variation') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fLNQI.FeatureExposedAnalytics), {
        flagKey: "offer_edu_org_discount",
        cohort: "variation",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7f9lz.EducationalDiscountDialog), {})
    });
    if ((0, $VSDnB.fg)('growth_automation_limits_kill_switch')) {
        if ((0, $7cGxK.isEligibleForAutomationLimits)(context)) {
            if ((0, $iEN9D.default).getExperimentValue('growth_automation_limits_experiment', 'cohort', 'not-enrolled') === 'variation') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fLNQI.FeatureExposedAnalytics), {
                flagKey: "growth_automation_limits",
                cohort: "variation",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $glCOg.AutomationLimitsDialog), {})
            });
        }
    }
    if (product === 'jira' && // We're excluding the edu experiment cohort from seeing the refresh experiment
    siteType !== 'EDU' && siteType !== 'ORG' && (0, $iEN9D.default).getExperimentValue('jira_free_ea_modal_refresh', 'cohort', 'not-enrolled', {
        // We only want to fire the exposure when they view the modal.
        // The control experience is still inside of the product.
        fireExperimentExposure: false
    }) === 'variation') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $d0sbz.FreeToStandardRefresh), {});
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8kHqB.FreeToStandardDialog), {});
}
function $3482a278540e0814$var$StandardEdition({ trialButton: trialButton }) {
    const context = (0, $3FEPM.useEditionAwareness)();
    const { product: product, isInTrial: isInTrial, isInPredunning: isInPredunning, isInvoiceable: isInvoiceable, canAddPaymentDetails: canAddPaymentDetails, isInTeamWorkCollection: isInTeamWorkCollection, userRoles: userRoles } = context;
    if ([
        'jira',
        'confluence'
    ].includes(product) && isInTeamWorkCollection && (0, $VSDnB.fg)('teamwork_collection_ea_modal')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $atpKp.PlanSelectionPageDialog), {
        type: "twc"
    });
    if ((isInTrial || isInPredunning) && isInvoiceable === false && canAddPaymentDetails) {
        if (// Only eligible for Confluence and Jira
        (0, $kbMGT.isEligibleForStandardTrialsUserAndStorageLimitBreakers)({
            context: context
        })) {
            const abExperimentKey = product === 'jira' ? 'jira_edition_awareness_standard_trials' : 'connie_edition_awareness_standard_trials';
            const abCohort = (0, $iEN9D.default).getExperimentValue(abExperimentKey, 'cohort', 'not-enrolled');
            if (abCohort === 'treatment') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fLNQI.FeatureExposedAnalytics), {
                flagKey: abExperimentKey,
                cohort: abCohort,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $70SOi.StandardTrialLimitBreakersDialog), {})
            });
            if (product === 'confluence' && (0, $VSDnB.fg)('new_ea_confluence_standard')) return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fLNQI.FeatureExposedAnalytics), {
                        flagKey: abExperimentKey,
                        cohort: abCohort
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $elt4i.StandardAddPayment), {})
                ]
            });
            // Jira Standard - Site admins get routed to JSTO, others to payment popup
            if (product === 'jira' && isInTrial && userRoles?.includes('SITE_ADMIN') && (0, $VSDnB.fg)('new_ea_jsto_link')) return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fLNQI.FeatureExposedAnalytics), {
                        flagKey: abExperimentKey,
                        cohort: abCohort
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)($3482a278540e0814$var$JiraStandardTrialOverviewLink, {})
                ]
            });
            if (product === 'jira' && isInTrial && !userRoles?.includes('SITE_ADMIN') && (0, $VSDnB.fg)('new_ea_jira_payment_details_popup')) return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fLNQI.FeatureExposedAnalytics), {
                        flagKey: abExperimentKey,
                        cohort: abCohort
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cqUnB.PaymentDetailsPopupDialog), {})
                ]
            });
            if (!trialButton) return /*#__PURE__*/ (0, $2OMIu.jsx)($3482a278540e0814$var$NoAction, {});
            return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fLNQI.FeatureExposedAnalytics), {
                        flagKey: abExperimentKey,
                        cohort: abCohort
                    }),
                    trialButton
                ]
            });
        }
        if (isInTrial && (product === 'jira-service-management' || product === 'jira-product-discovery')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $elt4i.StandardAddPayment), {});
        // Jira Standard - Site admins get routed to JSTO, others to payment popup
        if (product === 'jira' && isInTrial && userRoles?.includes('SITE_ADMIN') && (0, $VSDnB.fg)('new_ea_jsto_link')) return /*#__PURE__*/ (0, $2OMIu.jsx)($3482a278540e0814$var$JiraStandardTrialOverviewLink, {});
        if (product === 'jira' && isInTrial && !userRoles?.includes('SITE_ADMIN') && (0, $VSDnB.fg)('new_ea_jira_payment_details_popup')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cqUnB.PaymentDetailsPopupDialog), {});
        if (product === 'confluence' && (0, $VSDnB.fg)('new_ea_confluence_standard')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $elt4i.StandardAddPayment), {});
        if (isInPredunning && [
            'jira',
            'jira-service-management',
            'jira-product-discovery'
        ].includes(product) && (0, $VSDnB.fg)('new_ea_jsw_jsm_jpd_pre_dunning')) return /*#__PURE__*/ (0, $2OMIu.jsx)($3482a278540e0814$var$AddPaymentLink, {});
        if (!trialButton) return /*#__PURE__*/ (0, $2OMIu.jsx)($3482a278540e0814$var$NoAction, {});
        // trialButton is returned for all other products + Confluence and Jira sites not eligible
        return trialButton;
    }
    return /*#__PURE__*/ (0, $2OMIu.jsx)($3482a278540e0814$var$NoAction, {});
}
function $3482a278540e0814$var$PremiumEdition({ trialButton: trialButton }) {
    const context = (0, $3FEPM.useEditionAwareness)();
    const fireExperimentExposureEvent = (0, $fLNQI.useFeatureExposedAnalytics)();
    const { product: product, isInTrial: isInTrial, isInPredunning: isInPredunning, isInReverseTrial: isInReverseTrial, isInTeamWorkCollection: isInTeamWorkCollection, addPaymentDetailsExperienceUrl: addPaymentDetailsExperienceUrl } = context;
    if (product === 'jira' && (isInTrial || isInPredunning) && isInReverseTrial && (0, $VSDnB.fg)('jira_reverse_trial_ea_updates_during_trial_gate')) {
        if ((0, $iEN9D.default).getExperimentValue('jira_reverse_trial_ea_updates_during_trial', 'cohort', 'not-enrolled') === 'variation') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fLNQI.FeatureExposedAnalytics), {
            flagKey: "jira_reverse_trial_ea_updates_during_trial",
            cohort: "variation",
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $atpKp.PlanSelectionPageDialog), {
                type: "reverse-trial"
            })
        });
    }
    if ([
        'jira',
        'confluence'
    ].includes(product) && isInTeamWorkCollection && (0, $VSDnB.fg)('teamwork_collection_ea_modal')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $atpKp.PlanSelectionPageDialog), {
        type: "twc"
    });
    if (product === 'jira' && isInTrial && isInReverseTrial && (0, $VSDnB.fg)('new_ea_jira_reverse_trial_dropdown')) {
        // We can remove this check once we remove the final trialButton return
        if (!addPaymentDetailsExperienceUrl) return /*#__PURE__*/ (0, $2OMIu.jsx)($3482a278540e0814$var$NoAction, {});
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $58xN9.ReverseTrialPopupDialog), {});
    }
    if (product === 'jira' && isInTrial && !isInReverseTrial && (0, $VSDnB.fg)('new_ea_jira_payment_details_popup')) {
        // We can remove this check once we remove the final trialButton return
        if (!addPaymentDetailsExperienceUrl) return /*#__PURE__*/ (0, $2OMIu.jsx)($3482a278540e0814$var$NoAction, {});
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cqUnB.PaymentDetailsPopupDialog), {});
    }
    if (isInPredunning && [
        'jira',
        'jira-service-management'
    ].includes(product) && (0, $VSDnB.fg)('new_ea_jsw_jsm_jpd_pre_dunning')) return /*#__PURE__*/ (0, $2OMIu.jsx)($3482a278540e0814$var$AddPaymentLink, {});
    if ((0, $3Ic4Z.isEligibleForConfluenceBuyReverseTrialExperiment)({
        context: context
    }) && (0, $VSDnB.fg)('growth_confluence_buy_reverse_trials_fg')) {
        const aaCohort = (0, $iEN9D.default).getExperimentValue('growth_confluence_buy_reverse_trials_aa', 'cohort', 'not-enrolled');
        const abCohort = (0, $iEN9D.default).getExperimentValue('growth_confluence_buy_reverse_trials_ab', 'cohort', 'not-enrolled');
        fireExperimentExposureEvent('growth_confluence_buy_reverse_trials_aa', aaCohort, 'luna');
        fireExperimentExposureEvent('growth_confluence_buy_reverse_trials_ab', abCohort, 'luna');
        if (abCohort === 'variation') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $atpKp.PlanSelectionPageDialog), {
            type: "reverse-trial"
        });
    }
    if (product === 'confluence' && (isInTrial || isInPredunning) && (0, $VSDnB.fg)('new_ea_confluence_premium')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dWrfe.PremiumPopup), {});
    if (isInTrial && product === 'jira-service-management' && (0, $VSDnB.fg)('new_ea_jsm_premium')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $26Yuk.PremiumAddPayment), {});
    if (!trialButton) return /*#__PURE__*/ (0, $2OMIu.jsx)($3482a278540e0814$var$NoAction, {});
    // Until we migrate the rest of the products to the new button content we'll use the old one from product
    return trialButton;
}
function $3482a278540e0814$export$3bec899b1babe0fe({ trialButton: trialButton }) {
    const { edition: edition } = (0, $3FEPM.useEditionAwareness)();
    if (edition === 'free') return /*#__PURE__*/ (0, $2OMIu.jsx)($3482a278540e0814$var$FreeEdition, {});
    if (edition === 'standard') return /*#__PURE__*/ (0, $2OMIu.jsx)($3482a278540e0814$var$StandardEdition, {
        trialButton: trialButton
    });
    if (edition === 'premium') return /*#__PURE__*/ (0, $2OMIu.jsx)($3482a278540e0814$var$PremiumEdition, {
        trialButton: trialButton
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)($3482a278540e0814$var$NoAction, {});
}

});
parcelRegister("fLNQI", function(module, exports) {

$parcel$export(module.exports, "FeatureExposedAnalytics", () => $056bd2b126c27fc8$export$b12ce465f015026c);
$parcel$export(module.exports, "useFeatureExposedAnalytics", () => $056bd2b126c27fc8$export$5218ddb3d9c658c0);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fK9DC = parcelRequire("fK9DC");
function $056bd2b126c27fc8$export$b12ce465f015026c({ flagKey: flagKey, cohort: cohort, growthInitiative: growthInitiative, attributes: attributes, children: children }) {
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $fK9DC.useAnalytics)();
    const hasSent = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (hasSent.current) return;
        sendAnalyticsEvent({
            eventType: 'track',
            action: 'exposed',
            actionSubject: 'feature',
            attributes: {
                ...attributes,
                flagKey: flagKey,
                cohort: cohort,
                growthInitiative: growthInitiative
            }
        });
        hasSent.current = true;
    }, [
        sendAnalyticsEvent,
        flagKey,
        cohort,
        growthInitiative,
        attributes
    ]);
    if (!children) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
}
const $056bd2b126c27fc8$export$5218ddb3d9c658c0 = ()=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $fK9DC.useAnalytics)();
    const sentFlagKeys = (0, $5uXOq.useRef)([]);
    const fireExperimentExposureEvent = (0, $5uXOq.useCallback)((flagKey, cohort, growthInitiative, attributes)=>{
        if (sentFlagKeys.current.includes(flagKey)) return;
        sendAnalyticsEvent({
            eventType: 'track',
            action: 'exposed',
            actionSubject: 'feature',
            attributes: {
                ...attributes,
                flagKey: flagKey,
                cohort: cohort,
                growthInitiative: growthInitiative
            }
        });
        sentFlagKeys.current.push(flagKey);
    }, [
        sendAnalyticsEvent
    ]);
    return fireExperimentExposureEvent;
};

});

parcelRegister("dTcX5", function(module, exports) {

$parcel$export(module.exports, "getLoggedInPage", () => $140e3340cc71a8c9$export$30ac0f723bd6cc08);

var $5euJh = parcelRequire("5euJh");
function $140e3340cc71a8c9$export$30ac0f723bd6cc08(userEmail, pageUrl) {
    const encodedPageUrl = encodeURIComponent(pageUrl);
    const encodedUserEmail = encodeURIComponent(userEmail);
    // This URL will take them through the login flow (if necessary) then redirect them to the given (encoded) `pageUrl`.
    return `https://${(0, $5euJh.getATLContextDomain)('id')}/login?continue=${encodedPageUrl}&login_hint=${encodedUserEmail}&prompt=none`;
}

});

parcelRegister("7cGxK", function(module, exports) {

$parcel$export(module.exports, "isEligibleForAutomationLimits", () => $8fc03e1c9eab9170$export$cfee62bb1d1cd80d);
$parcel$export(module.exports, "isAutomationProjectedToBreach", () => $8fc03e1c9eab9170$export$c2831f4b556c6902);
$parcel$export(module.exports, "hasAutomationBreached", () => $8fc03e1c9eab9170$export$dc6f45a4f26c60c8);
const $8fc03e1c9eab9170$export$cfee62bb1d1cd80d = (context)=>{
    const { edition: edition, product: product, automationDailyUsage: automationDailyUsage, automationWeeklyUsage: automationWeeklyUsage } = context;
    return edition === 'free' && product === 'jira' && ($8fc03e1c9eab9170$export$c2831f4b556c6902(automationWeeklyUsage ?? 0) || $8fc03e1c9eab9170$export$dc6f45a4f26c60c8(automationDailyUsage ?? 0));
};
const $8fc03e1c9eab9170$export$c2831f4b556c6902 = (automationUsageWeekly)=>{
    // Based on the weekly usage from the first week, we calculate if the projected usage will exceed 80%
    return automationUsageWeekly / 7 * 30 > 80;
};
const $8fc03e1c9eab9170$export$dc6f45a4f26c60c8 = (automationUsageDaily)=>{
    return automationUsageDaily > 100;
};

});

parcelRegister("3Ic4Z", function(module, exports) {

$parcel$export(module.exports, "isEligibleForConfluenceBuyReverseTrialExperiment", () => $b3340c22ef929c7d$export$d8e323470f628b52);
function $b3340c22ef929c7d$export$d8e323470f628b52({ context: context }) {
    const { product: product, edition: edition, isInvoiceable: isInvoiceable, isInReverseTrial: isInReverseTrial, isInTrial: isInTrial, isInPredunning: isInPredunning, billingSourceSystem: billingSourceSystem } = context;
    return Boolean(product === 'confluence' && edition === 'premium' && (isInTrial || isInPredunning) && isInReverseTrial && isInvoiceable === false && billingSourceSystem === 'CCP');
}

});

parcelRegister("d1IFL", function(module, exports) {

$parcel$export(module.exports, "isEligibleForEduDiscount", () => $4b0d670097b8546c$export$331edc99898f4a8e);
//import { AtlBrowserStorageLocal } from '@atlassian/browser-storage-controls';

const $4b0d670097b8546c$export$331edc99898f4a8e = (context)=>{
    return $4b0d670097b8546c$export$f52e80ca0459b360(context) && $4b0d670097b8546c$export$eb0afc9e31269a96();
};
const $4b0d670097b8546c$export$f52e80ca0459b360 = (context)=>{
    const { edition: edition, siteType: siteType } = context;
    return edition === 'free' && (siteType === 'EDU' || siteType === 'ORG');
};
const $4b0d670097b8546c$export$eb0afc9e31269a96 = ()=>{
    // AtlBrowserStorageLocal even if is not executed, by just calling this file fails the VR test,
    //  until we have a fix, we can use the native one
    //AtlBrowserStorageLocal.getItem(PLATFORM_EDUCATIONAL_DISCOUNT_DISMISSED) !== 'true'
    try {
        return localStorage.getItem((0, $3fb654ba49d4caff$export$c5bc624b59af1952)) !== 'true';
    } catch (e) {
        return false;
    }
};

});
const $3fb654ba49d4caff$export$c5bc624b59af1952 = '__storejs_platform_educational_discount_dismissed';


parcelRegister("kbMGT", function(module, exports) {

$parcel$export(module.exports, "isEligibleForStandardTrialsUserAndStorageLimitBreakers", () => $e7554578a34e8a16$export$4ade6028e006f174);

var $VSDnB = parcelRequire("VSDnB");
function $e7554578a34e8a16$export$4ade6028e006f174({ context: context }) {
    const { product: product, edition: edition, isInTrial: isInTrial, isInPredunning: isInPredunning, isInvoiceable: isInvoiceable, licensedUsers: licensedUsers, canAddPaymentDetails: canAddPaymentDetails, trialDaysLeft: trialDaysLeft, storageUsageInGB: storageUsageInGB } = context;
    const isOnFirstTrialDay = !!(trialDaysLeft && trialDaysLeft === 14);
    const isOverUserLimit = !!(licensedUsers && licensedUsers > 10);
    const isOverStorageUsageLimit = !!(storageUsageInGB && storageUsageInGB > 2);
    if (product === 'confluence' && edition === 'standard' && (0, $VSDnB.fg)('connie_edition_awareness_standard_trials_gate')) return !!((isInTrial || isInPredunning) && isInvoiceable === false && canAddPaymentDetails && !isOnFirstTrialDay && (isOverUserLimit || isOverStorageUsageLimit));
    if (product === 'jira' && edition === 'standard' && (0, $VSDnB.fg)('jira_edition_awareness_standard_trials_gate')) return !!(isInTrial && isInvoiceable === false && canAddPaymentDetails && !isOnFirstTrialDay && (isOverUserLimit || isOverStorageUsageLimit));
    return false;
}

});

parcelRegister("lLXXb", function(module, exports) {

$parcel$export(module.exports, "WAC_URL", () => $065c6db6ca32f41a$export$5e8c8041aa206ba5);
const $065c6db6ca32f41a$export$5e8c8041aa206ba5 = {
    prod: 'https://www.atlassian.com',
    staging: 'https://wac.stg.internal.atlassian.com',
    dev: 'https://wac.stg.internal.atlassian.com',
    local: 'https://wac.stg.internal.atlassian.com'
};

});

parcelRegister("glCOg", function(module, exports) {

$parcel$export(module.exports, "AutomationLimitsDialog", () => $33975a205ad14c0f$export$c3bdc4a61d5d21ea);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $79ZRb = parcelRequire("79ZRb");

var $fqeRg = parcelRequire("fqeRg");

var $kDZBc = parcelRequire("kDZBc");

var $elAd3 = parcelRequire("elAd3");
function $33975a205ad14c0f$export$c3bdc4a61d5d21ea() {
    const onClose = (0, $79ZRb.useOnDismissDialog)({
        ...(0, $kDZBc.DIALOG_CONFIG)
    });
    const entryPointProps = (0, $5uXOq.useMemo)(()=>({
            onClose: onClose
        }), [
        onClose
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fqeRg.ModalEntryPoint), {
        entryPoint: (0, $elAd3.default),
        entryPointProps: entryPointProps,
        dialogConfig: (0, $kDZBc.DIALOG_CONFIG)
    });
}

});
parcelRegister("79ZRb", function(module, exports) {

$parcel$export(module.exports, "useOnDismissDialog", () => $d1a2b1a3036a1153$export$566c270c8354ea95);

var $5uXOq = parcelRequire("5uXOq");

var $fK9DC = parcelRequire("fK9DC");
const $d1a2b1a3036a1153$export$566c270c8354ea95 = ({ touchpointIntent: touchpointIntent, dialogType: dialogType, dialogId: dialogId, attributes: attributes, onClose: onClose })=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $fK9DC.useAnalytics)();
    return (0, $5uXOq.useCallback)(()=>{
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'editionAwarenessDialogDismissed',
            attributes: {
                touchpointIntent: touchpointIntent,
                dialogType: dialogType,
                dialogId: dialogId,
                ...attributes
            }
        });
        onClose && onClose();
    }, [
        sendAnalyticsEvent,
        touchpointIntent,
        dialogType,
        dialogId,
        attributes,
        onClose
    ]);
};

});

parcelRegister("fqeRg", function(module, exports) {

$parcel$export(module.exports, "ModalEntryPoint", () => $5bda78b2de6a2af6$export$50a5ec7edfae079b);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $daJ0i = parcelRequire("daJ0i");

var $6mahi = parcelRequire("6mahi");

var $2xaXo = parcelRequire("2xaXo");

var $MN7ms = parcelRequire("MN7ms");

var $5yG9d = parcelRequire("5yG9d");
function $5bda78b2de6a2af6$export$50a5ec7edfae079b(props) {
    const { dialogConfig: dialogConfig, ...rest } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $daJ0i.default), {
        data: dialogConfig,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($5bda78b2de6a2af6$var$ModalEntryPointInner, {
            ...rest
        })
    });
}
function $5bda78b2de6a2af6$var$ModalEntryPointInner(props) {
    const onError = (0, $MN7ms.useEntrypointErrorAnalytics)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6mahi.ModalContextProvider), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2xaXo.ModalTrigger), {
            ...props,
            onError: onError,
            children: ({ ref: ref })=>{
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5yG9d.EditionAwarenessButton), {
                    ref: ref
                });
            }
        })
    });
}

});
parcelRegister("6mahi", function(module, exports) {

$parcel$export(module.exports, "ModalContextProvider", () => $5faabe7a692a3c55$export$7c9538f5f3c365e9);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $i8Qvm = parcelRequire("i8Qvm");

var $6ekCG = parcelRequire("6ekCG");
const $5faabe7a692a3c55$var$RenderModal = ({ modal: modal })=>{
    const [shouldCloseOnOverlayClick, setShouldCloseOnOverlayClick] = (0, $5uXOq.useState)();
    const [shouldCloseOnEscapePress, setShouldCloseOnEscapePress] = (0, $5uXOq.useState)();
    const Component = modal.component;
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        onClose: modal.close,
        shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
        shouldCloseOnEscapePress: shouldCloseOnEscapePress,
        setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick,
        setShouldCloseOnEscapePress: setShouldCloseOnEscapePress
    });
};
function $5faabe7a692a3c55$export$7c9538f5f3c365e9({ children: children }) {
    const id = (0, $5uXOq.useRef)(1);
    const [modals, setModals] = (0, $5uXOq.useState)([]);
    const modalContext = (0, $5uXOq.useMemo)(()=>({
            openModal: (component)=>{
                const key = String(id.current++);
                const close = ()=>{
                    setModals((mdls)=>mdls.filter((d)=>d.key !== key));
                };
                setModals((mdls)=>[
                        ...mdls,
                        {
                            close: close,
                            component: component,
                            key: key
                        }
                    ]);
            }
        }), []);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $6ekCG.ModalContext).Provider, {
        value: modalContext,
        children: [
            children,
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i8Qvm.default), {
                children: modals.map((modal)=>/*#__PURE__*/ (0, $2OMIu.jsx)($5faabe7a692a3c55$var$RenderModal, {
                        modal: modal
                    }, modal.key))
            })
        ]
    });
}

});
parcelRegister("6ekCG", function(module, exports) {

$parcel$export(module.exports, "ModalContext", () => $820bf6641e73d83c$export$ab57792b9b6974a6);

var $5uXOq = parcelRequire("5uXOq");
const $820bf6641e73d83c$export$ab57792b9b6974a6 = (0, $5uXOq.createContext)({
    openModal: ()=>{
        throw new Error("To show the modal, wrap your app's root component with a <ModalContextProvider />. import { ModalContextProvider } from '@atlassian/entry-point-modal-context/ModalContextProvider';");
    }
});

});


parcelRegister("2xaXo", function(module, exports) {

$parcel$export(module.exports, "ModalTrigger", () => $e8a9a19812664108$export$fb10b32cfe19f1e);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $3Du7S = parcelRequire("3Du7S");

var $iwwXK = parcelRequire("iwwXK");

var $1R1Ge = parcelRequire("1R1Ge");
var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");

var $414Wj = parcelRequire("414Wj");

var $f1OUK = parcelRequire("f1OUK");

var $6ekCG = parcelRequire("6ekCG");

var $7F2yO = parcelRequire("7F2yO");

var $kKgGa = parcelRequire("kKgGa");

var $e2pRJ = parcelRequire("e2pRJ");
const $e8a9a19812664108$var$emptyEntryPointParams = {};
const $e8a9a19812664108$var$emptyEntryPointProps = {};
function $e8a9a19812664108$export$fb10b32cfe19f1e({ children: children, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, Fallback: Fallback, title: title, modalProps: modalProps, forwardedRef: forwardedRef, onError: onError }) {
    const { openModal: openModal } = (0, $5uXOq.useContext)((0, $6ekCG.ModalContext));
    const environmentProvider = (0, $e2pRJ.useRelayEnvironmentProvider)();
    const { ModalErrorFallback: ModalErrorFallback } = (0, $f1OUK.useEntryPointConfig)();
    const metricName = (0, $5uXOq.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    const load = (0, $5uXOq.useCallback)(()=>(0, $8Uumt.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $e8a9a19812664108$var$emptyEntryPointParams), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onLoad = (0, $5uXOq.useCallback)(({ reference: entryPointReference, dispose: dispose })=>{
        openModal(({ onClose: closeModal, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick, shouldCloseOnEscapePress: shouldCloseOnEscapePress, setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick, setShouldCloseOnEscapePress: setShouldCloseOnEscapePress })=>{
            const onClose = ()=>{
                entryPointProps?.onClose?.();
                closeModal();
                dispose();
            };
            const defaultFallback = /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jgVsb.default), {
                        children: title ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gofOI.default), {
                            children: title
                        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $414Wj.default), {
                            grow: "fill",
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iwwXK.default), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $7QSqG.default), {
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iwwXK.default), {}),
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iwwXK.default), {}),
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iwwXK.default), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $juxqI.default), {})
                ]
            });
            const container = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kKgGa.InternalEntryPointContainer), {
                entryPointReference: entryPointReference,
                errorFallback: ({ error: error })=>/*#__PURE__*/ (0, $2OMIu.jsx)(ModalErrorFallback, {
                        error: error
                    }),
                onError: ({ error: error, errorInfo: errorInfo })=>{
                    onError?.({
                        error: error,
                        errorInfo: errorInfo
                    });
                    closeModal();
                },
                fallback: Fallback ? /*#__PURE__*/ (0, $2OMIu.jsx)(Fallback, {
                    onClose: closeModal
                }) : defaultFallback,
                id: metricName,
                placeholderName: "modal-entry-point-pressable-trigger-container",
                runtimeProps: {
                    ...entryPointProps ?? $e8a9a19812664108$var$emptyEntryPointProps,
                    onClose: onClose,
                    setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick,
                    setShouldCloseOnEscapePress: setShouldCloseOnEscapePress,
                    shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
                    shouldCloseOnEscapePress: shouldCloseOnEscapePress
                }
            });
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1R1Ge.default), {
                ...modalProps,
                onClose: onClose,
                shouldCloseOnOverlayClick: shouldCloseOnOverlayClick ?? modalProps?.shouldCloseOnOverlayClick,
                shouldCloseOnEscapePress: shouldCloseOnEscapePress ?? modalProps?.shouldCloseOnEscapePress,
                children: container
            });
        });
    }, [
        openModal,
        title,
        modalProps,
        Fallback,
        metricName,
        entryPointProps,
        ModalErrorFallback,
        onError
    ]);
    const triggerRef = (0, $7F2yO.usePressablePreloadRef)({
        load: load,
        onLoad: onLoad
    });
    const mergedRef = (0, $3Du7S.useMergeRefs)([
        triggerRef,
        forwardedRef || null
    ]);
    return children({
        ref: mergedRef
    });
}

});
parcelRegister("f1OUK", function(module, exports) {

$parcel$export(module.exports, "initEntryPointConfig", () => $925e23725d503f1a$export$93a6801f9db838c4);
$parcel$export(module.exports, "useEntryPointConfig", () => $925e23725d503f1a$export$dfa96f26176fa91f);

var $hYRTO = parcelRequire("hYRTO");

var $8Ec39 = parcelRequire("8Ec39");
const $925e23725d503f1a$var$DefaultUFOSegmentComponent = (0, $8Ec39.default);
const $925e23725d503f1a$var$entryPointConfig = {
    PlaceholderComponent: (0, $hYRTO.default),
    UFOSegmentComponent: $925e23725d503f1a$var$DefaultUFOSegmentComponent,
    ModalErrorFallback: ()=>null
};
function $925e23725d503f1a$export$93a6801f9db838c4(overrides) {
    Object.assign($925e23725d503f1a$var$entryPointConfig, overrides);
    return $925e23725d503f1a$var$entryPointConfig;
}
function $925e23725d503f1a$export$dfa96f26176fa91f() {
    return $925e23725d503f1a$var$entryPointConfig;
}

});

parcelRegister("7F2yO", function(module, exports) {

$parcel$export(module.exports, "usePressablePreloadRef", () => $5e83173393ec1687$export$1ff47f24e06a5d2d);

var $5uXOq = parcelRequire("5uXOq");
const $5e83173393ec1687$var$PRELOAD_MAX_AGE = 300000; // 5 mins
const $5e83173393ec1687$var$TIME_TO_INTENT = 200;
function $5e83173393ec1687$export$1ff47f24e06a5d2d({ load: load, onLoad: onLoad, onBeforeLoad: onBeforeLoad }) {
    const ref = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        const el = ref.current;
        if (!el) return;
        const request = {};
        const clearPreloadTimeouts = ()=>{
            if (typeof request.preloadIntentTimeout === 'number') {
                clearTimeout(request.preloadIntentTimeout);
                delete request.preloadIntentTimeout;
            }
            if (typeof request.preloadMaxAgeTimeout === 'number') {
                clearTimeout(request.preloadMaxAgeTimeout);
                delete request.preloadMaxAgeTimeout;
            }
        };
        const cancelPreload = ()=>{
            clearPreloadTimeouts();
            request.preload?.dispose();
        };
        const loadReference = ()=>{
            if (request.load) return request.load;
            const reference = request.preload?.reference ?? load();
            if (request.preload) delete request.preload;
            request.load = {
                reference: reference,
                dispose () {
                    reference.dispose();
                    delete request.load;
                }
            };
            return request.load;
        };
        const clickListener = ()=>{
            clearPreloadTimeouts();
            if (onBeforeLoad) onBeforeLoad();
            onLoad(loadReference());
        };
        const mouseDownListener = ()=>{
            clearPreloadTimeouts();
            loadReference();
        };
        const preloadReference = ()=>{
            if (request.preloadIntentTimeout || request.preload) return;
            request.preloadIntentTimeout = setTimeout(()=>{
                delete request.preloadIntentTimeout;
                const reference = load();
                request.preload = {
                    reference: reference,
                    dispose () {
                        reference.dispose();
                        delete request.preload;
                    }
                };
                request.preloadMaxAgeTimeout = setTimeout(()=>{
                    delete request.preloadMaxAgeTimeout;
                    request.preload?.dispose();
                }, $5e83173393ec1687$var$PRELOAD_MAX_AGE);
            }, $5e83173393ec1687$var$TIME_TO_INTENT);
        };
        el.addEventListener('click', clickListener);
        el.addEventListener('mousedown', mouseDownListener);
        el.addEventListener('mouseenter', preloadReference);
        el.addEventListener('mouseleave', cancelPreload);
        return ()=>{
            cancelPreload();
            el.removeEventListener('click', clickListener);
            el.removeEventListener('mousedown', mouseDownListener);
            el.removeEventListener('mouseenter', preloadReference);
            el.removeEventListener('mouseleave', cancelPreload);
        };
    }, [
        load,
        onBeforeLoad,
        onLoad
    ]);
    return ref;
}

});

parcelRegister("kKgGa", function(module, exports) {

$parcel$export(module.exports, "InternalEntryPointContainer", () => $bbe4ac5c77ca0739$export$5d4dc37edd8a3adb);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $f4cXA = parcelRequire("f4cXA");

var $8Uumt = parcelRequire("8Uumt");

var $jMqau = parcelRequire("jMqau");

var $f1OUK = parcelRequire("f1OUK");
function $bbe4ac5c77ca0739$export$5d4dc37edd8a3adb({ entryPointReference: entryPointReference, errorFallback: errorFallback, /** Log and track errors */ onError: onErrorLocal, fallback: /** Loading fallback */ fallback, id: id, placeholderName: placeholderName, runtimeProps: runtimeProps }) {
    const { PlaceholderComponent: PlaceholderComponent, UFOSegmentComponent: UFOSegmentComponent } = (0, $f1OUK.useEntryPointConfig)();
    const onError = (0, $5uXOq.useCallback)((error, errorInfo)=>{
        onErrorLocal?.({
            error: error,
            errorInfo: errorInfo
        });
        (0, $jMqau.reportError)({
            error: error,
            errorInfo: errorInfo,
            interactionId: id
        });
    }, [
        onErrorLocal,
        id
    ]);
    const FallbackComponent = (0, $5uXOq.useCallback)(({ error: error })=>{
        return errorFallback ? errorFallback({
            error: error
        }) : null;
    }, [
        errorFallback
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)(UFOSegmentComponent, {
        name: id,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f4cXA.ErrorBoundary), {
            FallbackComponent: FallbackComponent,
            onError: onError,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)(PlaceholderComponent, {
                name: placeholderName ?? 'internal-internal-entry-point-container',
                fallback: fallback,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8Uumt.EntryPointContainer), {
                    entryPointReference: entryPointReference,
                    props: runtimeProps
                })
            })
        })
    });
}

});

parcelRegister("e2pRJ", function(module, exports) {

$parcel$export(module.exports, "RelayEnvironmentProvider", () => $f61a6caac921ade0$export$43b1f3e917d65526);
$parcel$export(module.exports, "useRelayEnvironmentProvider", () => $f61a6caac921ade0$export$e237a628f59c9f4e);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $eiowN = parcelRequire("eiowN");

var $6LmWt = parcelRequire("6LmWt");
const $f61a6caac921ade0$var$environment = new (0, $eiowN.Environment)((0, $6LmWt.getDefaultRelayEnvironmentConfig)({}));
const $f61a6caac921ade0$export$43b1f3e917d65526 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8Uumt.RelayEnvironmentProvider), {
        environment: $f61a6caac921ade0$var$environment,
        children: children
    });
};
function $f61a6caac921ade0$export$e237a628f59c9f4e() {
    const environment = (0, $8Uumt.useRelayEnvironment)();
    return (0, $5uXOq.useMemo)(()=>({
            getEnvironment () {
                return environment;
            }
        }), [
        environment
    ]);
}

});


parcelRegister("MN7ms", function(module, exports) {

$parcel$export(module.exports, "useEntrypointErrorAnalytics", () => $888a121fdcf492fb$export$f2e26e89f653216c);

var $5uXOq = parcelRequire("5uXOq");

var $fK9DC = parcelRequire("fK9DC");
function $888a121fdcf492fb$export$f2e26e89f653216c() {
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $fK9DC.useAnalytics)();
    const handleOnError = (0, $5uXOq.useCallback)(({ error: error, errorInfo: errorInfo })=>{
        sendAnalyticsEvent({
            eventType: 'operational',
            action: 'failed',
            actionSubject: '@atlassian/edition-awareness.edition-awareness',
            attributes: {
                error: error.message,
                errorStack: error.stack,
                errorName: error.name,
                errorComponentStack: errorInfo.componentStack,
                id: 'entrypointError'
            }
        });
    }, [
        sendAnalyticsEvent
    ]);
    return handleOnError;
}

});

parcelRegister("5yG9d", function(module, exports) {

$parcel$export(module.exports, "EditionAwarenessButton", () => $a39e25505699b400$export$57ddd9301662f8e4);
$parcel$export(module.exports, "EditionAwarenessLink", () => $a39e25505699b400$export$1bf8122badfd728c);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bOVbW = parcelRequire("bOVbW");

var $i7S2n = parcelRequire("i7S2n");

var $bZC6Q = parcelRequire("bZC6Q");

var $jhmo0 = parcelRequire("jhmo0");
var $dC5iT = parcelRequire("dC5iT");
var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");

var $Ee6JC = parcelRequire("Ee6JC");

var $7K1Hj = parcelRequire("7K1Hj");

var $hkdaM = parcelRequire("hkdaM");

var $fK9DC = parcelRequire("fK9DC");

var $1QnZd = parcelRequire("1QnZd");

var $WqpJ2 = parcelRequire("WqpJ2");
const $a39e25505699b400$var$buttonStyles = (0, $8CUq3.xcss)({
    borderWidth: 'border.width',
    font: 'font.body',
    fontWeight: 'font.weight.medium',
    borderStyle: 'solid',
    backgroundColor: 'elevation.surface',
    borderRadius: 'border.radius.100',
    paddingInline: 'space.150',
    paddingBlock: 'space.050',
    minHeight: '32px',
    color: 'color.text',
    transitionProperty: 'color, background-color',
    transitionDuration: '200ms',
    display: 'flex',
    gap: 'space.100',
    alignItems: 'center',
    textDecoration: 'none',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered',
        textDecoration: 'none',
        color: 'color.text'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed',
        textDecoration: 'none'
    }
});
const $a39e25505699b400$var$defaultStyles = (0, $8CUq3.xcss)({
    color: 'color.text.brand',
    borderColor: 'color.border.brand',
    ':hover': {
        color: 'color.text.brand'
    }
});
const $a39e25505699b400$var$warningStyles = (0, $8CUq3.xcss)({
    borderColor: 'color.border.warning'
});
const $a39e25505699b400$var$dangerStyles = (0, $8CUq3.xcss)({
    borderColor: 'color.border.danger'
});
const $a39e25505699b400$var$dismissibleStyles = (0, $8CUq3.xcss)({
    color: 'color.text.discovery',
    borderColor: 'color.border.discovery',
    borderTopRightRadius: '0',
    borderBottomRightRadius: '0',
    ':hover': {
        color: 'color.text.discovery',
        backgroundColor: 'color.background.accent.purple.subtlest.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.accent.purple.subtlest.pressed',
        textDecoration: 'none'
    }
});
const $a39e25505699b400$var$iconStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    // icon size cannot grow and shrink
    flexGrow: 0,
    flexShrink: 0,
    alignSelf: 'center',
    userSelect: 'none'
});
function $a39e25505699b400$var$Icon({ appearance: appearance, icon: icon, color: color }) {
    if (icon === 'warning') {
        const defaultColor = appearance === 'danger' ? "var(--ds-icon-danger, #C9372C)" : "var(--ds-icon-warning, #E56910)";
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bZC6Q))), {
            label: "",
            color: color ?? defaultColor
        });
    }
    if (icon === 'credit-card') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i7S2n))), {
        label: "",
        color: color ?? "var(--ds-icon-discovery, #8270DB)",
        LEGACY_size: "small"
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bOVbW))), {
        label: "",
        color: color ?? "var(--ds-icon-discovery, #8270DB)"
    });
}
const $a39e25505699b400$export$57ddd9301662f8e4 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function({ onClick: onClick, ...rest }, ref) {
    const buttonContent = (0, $1QnZd.useButtonContent)();
    if (buttonContent === null) throw new Error('The button content is null, please check the context');
    const { text: text, icon: icon, appearance: appearance = 'default', isDismissible: isDismissible, isEducationDiscount: isEducationDiscount } = buttonContent;
    const hasCustomTheme = (0, $7K1Hj.useHasCustomTheme)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $fK9DC.useAnalytics)();
    const analyticsAttributes = (0, $5uXOq.useMemo)(()=>({
            type: 'button',
            icon: icon,
            appearance: appearance,
            isEducationDiscount: isEducationDiscount
        }), [
        icon,
        appearance,
        isEducationDiscount
    ]);
    const handleOnClick = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        onClick?.(e, analyticsEvent);
        const updatedAnalyticsEvent = analyticsEvent.update((payload)=>({
                ...payload,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'editionAwareness',
                attributes: analyticsAttributes
            }));
        sendAnalyticsEvent(updatedAnalyticsEvent);
    }, [
        onClick,
        sendAnalyticsEvent,
        analyticsAttributes
    ]);
    if (hasCustomTheme) // When there's a custom theme applied we just return a button which gets styled by the theme
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $Ee6JC.Button), {
        ...rest,
        ref: ref,
        onClick: handleOnClick,
        iconBefore: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)($a39e25505699b400$var$Icon, {
                appearance: appearance,
                icon: icon,
                color: "currentColor"
            }),
        children: [
            text,
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hkdaM.UiViewedEvent), {
                actionSubjectId: "editionAwareness",
                actionSubject: "button",
                attributes: analyticsAttributes
            })
        ]
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5ILhZ.default), {
        ...rest,
        ref: ref,
        xcss: [
            $a39e25505699b400$var$buttonStyles,
            appearance === 'default' && $a39e25505699b400$var$defaultStyles,
            appearance === 'warning' && $a39e25505699b400$var$warningStyles,
            appearance === 'danger' && $a39e25505699b400$var$dangerStyles,
            isDismissible && $a39e25505699b400$var$dismissibleStyles
        ],
        onClick: handleOnClick,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                xcss: $a39e25505699b400$var$iconStyles,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)($a39e25505699b400$var$Icon, {
                    appearance: appearance,
                    icon: icon
                })
            }),
            text,
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hkdaM.UiViewedEvent), {
                actionSubjectId: "editionAwareness",
                actionSubject: "button",
                attributes: analyticsAttributes
            })
        ]
    });
});
const $a39e25505699b400$export$1bf8122badfd728c = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function({ onClick: onClick, href: href, touchpointIntent: touchpointIntent, linkId: linkId, ...rest }, ref) {
    const buttonContent = (0, $1QnZd.useButtonContent)();
    if (buttonContent === null) throw new Error('The button content is null, please check the context');
    const { text: text, icon: icon, appearance: appearance = 'default' } = buttonContent;
    const hasCustomTheme = (0, $7K1Hj.useHasCustomTheme)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $fK9DC.useAnalytics)();
    const { origin: origin, url: tracedUrl } = (0, $WqpJ2.useTracedUrl)(href);
    if (!tracedUrl) throw new Error('The link url is undefined, please check the context');
    const analyticsAttributes = (0, $5uXOq.useMemo)(()=>({
            type: 'link',
            icon: icon,
            appearance: appearance,
            touchpointIntent: touchpointIntent,
            linkId: linkId,
            ...origin.toAnalyticsAttributes()
        }), [
        icon,
        appearance,
        touchpointIntent,
        linkId,
        origin
    ]);
    const handleOnClick = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        onClick?.(e, analyticsEvent);
        const updatedAnalyticsEvent = analyticsEvent.update((payload)=>({
                ...payload,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'editionAwareness',
                attributes: analyticsAttributes
            }));
        sendAnalyticsEvent(updatedAnalyticsEvent);
    }, [
        onClick,
        sendAnalyticsEvent,
        analyticsAttributes
    ]);
    if (hasCustomTheme) // When there's a custom theme applied we just return a button which gets styled by the theme
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $Ee6JC.LinkButton), {
        ...rest,
        href: tracedUrl,
        ref: ref,
        onClick: handleOnClick,
        iconBefore: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)($a39e25505699b400$var$Icon, {
                appearance: appearance,
                icon: icon,
                color: "currentColor"
            }),
        children: [
            text,
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hkdaM.UiViewedEvent), {
                actionSubjectId: "editionAwareness",
                actionSubject: "button",
                attributes: analyticsAttributes
            })
        ]
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $jhmo0.default), {
        ...rest,
        href: tracedUrl,
        ref: ref,
        xcss: [
            $a39e25505699b400$var$buttonStyles,
            appearance === 'default' && $a39e25505699b400$var$defaultStyles,
            appearance === 'warning' && $a39e25505699b400$var$warningStyles,
            appearance === 'danger' && $a39e25505699b400$var$dangerStyles
        ],
        onClick: handleOnClick,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                xcss: $a39e25505699b400$var$iconStyles,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)($a39e25505699b400$var$Icon, {
                    appearance: appearance,
                    icon: icon
                })
            }),
            text,
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hkdaM.UiViewedEvent), {
                actionSubjectId: "editionAwareness",
                actionSubject: "button",
                attributes: analyticsAttributes
            })
        ]
    });
});

});
parcelRegister("hkdaM", function(module, exports) {

$parcel$export(module.exports, "UiViewedEvent", () => $3c394ebe94e56f51$export$d0a9edec5c713764);

var $5uXOq = parcelRequire("5uXOq");

var $fK9DC = parcelRequire("fK9DC");
function $3c394ebe94e56f51$export$d0a9edec5c713764({ actionSubjectId: actionSubjectId, actionSubject: actionSubject, attributes: attributes }) {
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $fK9DC.useAnalytics)();
    const hasSent = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (hasSent.current) return;
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'viewed',
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: attributes
        });
        hasSent.current = true;
    }, [
        sendAnalyticsEvent,
        actionSubject,
        actionSubjectId,
        attributes
    ]);
    return null;
}

});

parcelRegister("1QnZd", function(module, exports) {

$parcel$export(module.exports, "useButtonContent", () => $a7f04c3b22ba77ca$export$c810aba6284fa97d);

var $koVbs = parcelRequire("koVbs");

var $iEN9D = parcelRequire("iEN9D");

var $VSDnB = parcelRequire("VSDnB");

var $cTqug = parcelRequire("cTqug");

var $3FEPM = parcelRequire("3FEPM");

var $7cGxK = parcelRequire("7cGxK");

var $3Ic4Z = parcelRequire("3Ic4Z");

var $d1IFL = parcelRequire("d1IFL");

var $9o45M = parcelRequire("9o45M");

var $kbMGT = parcelRequire("kbMGT");

var $1afMW = parcelRequire("1afMW");
// TODO: `licensedUserLimit` should be fetched from the server
const $a7f04c3b22ba77ca$var$PRODUCT_LIMITS_MAP = {
    'jira-product-discovery': {
        licensedUserLimit: 3,
        warningUserLimit: 2
    },
    jira: {
        licensedUserLimit: 10,
        warningUserLimit: 7
    },
    confluence: {
        licensedUserLimit: 10,
        warningUserLimit: 3
    },
    'jira-service-management': {
        licensedUserLimit: 3,
        warningUserLimit: 2
    }
};
function $a7f04c3b22ba77ca$var$getFreeContent({ context: context, formatMessage: formatMessage }) {
    const { licensedUsers: licensedUsers, product: product, automationWeeklyUsage: automationWeeklyUsage, automationDailyUsage: automationDailyUsage } = context;
    const limits = $a7f04c3b22ba77ca$var$PRODUCT_LIMITS_MAP[product];
    // Education offer has a higher priority than all the other messages
    if ((0, $d1IFL.isEligibleForEduDiscount)(context) && (0, $iEN9D.default).getExperimentValue('offer_edu_org_discount', 'cohort', 'not-enrolled') === 'variation') return {
        text: formatMessage({
            id: '@atlassian/edition-awareness.button.education-offer',
            defaultMessage: 'Education discount',
            description: 'Informs the user that they may be are eligible for an education offer which is a discount on all products'
        }),
        appearance: 'default',
        icon: 'gem',
        isEducationDiscount: true
    };
    // Is legible for automation limits
    if ((0, $VSDnB.fg)('growth_automation_limits_kill_switch')) {
        if ((0, $7cGxK.isEligibleForAutomationLimits)(context)) {
            if ((0, $7cGxK.hasAutomationBreached)(automationDailyUsage ?? 0) && (0, $iEN9D.default).getExperimentValue('growth_automation_limits_experiment', 'cohort', 'not-enrolled') === 'variation') return {
                text: formatMessage({
                    id: '@atlassian/edition-awareness.button.automation-limits-breached',
                    defaultMessage: 'Limit reached',
                    description: 'Informs the user that they have breached their automation limits'
                }),
                appearance: 'danger',
                icon: 'warning'
            };
            if ((0, $7cGxK.isAutomationProjectedToBreach)(automationWeeklyUsage ?? 0) && (0, $iEN9D.default).getExperimentValue('growth_automation_limits_experiment', 'cohort', 'not-enrolled') === 'variation') return {
                text: formatMessage({
                    id: '@atlassian/edition-awareness.button.automation-near-limit',
                    defaultMessage: 'Near limit',
                    description: 'Informs the user that they are about to breach their automation limits'
                }),
                appearance: 'warning',
                icon: 'warning'
            };
        }
    }
    if ([
        'jira',
        'jira-service-management',
        'jira-product-discovery'
    ].includes(product) && licensedUsers) {
        if (licensedUsers >= limits.licensedUserLimit) return {
            text: formatMessage({
                id: '@atlassian/edition-awareness.button.jpd.no-creators-left',
                defaultMessage: 'No {product, select, jpd {creators} jsm {agents} jira {users} confluence {users} other {users}} left',
                description: 'Informs the user that there are no licensed users left and they may need to upgrade their product'
            }, {
                product: (0, $cTqug.getProductForTranslation)(product)
            }),
            appearance: product !== 'confluence' ? 'danger' : 'warning',
            icon: 'warning'
        };
        if (licensedUsers >= limits.warningUserLimit) return {
            text: formatMessage({
                id: '@atlassian/edition-awareness.button.jpd.limited-creators-left',
                defaultMessage: 'Limited {product, select, jpd {creators} jsm {agents} jira {users} confluence {users} other {users}} left',
                description: 'Informs the user that there are limited licensed users left before they need to upgrade their product'
            }, {
                product: (0, $cTqug.getProductForTranslation)(product)
            }),
            appearance: 'warning',
            icon: 'warning'
        };
    }
    let text = formatMessage({
        id: '@atlassian/edition-awareness.button.upgrade',
        defaultMessage: 'Upgrade',
        description: 'Informs the user that they can upgrade their product'
    });
    if (product === 'confluence' && licensedUsers && licensedUsers >= limits.warningUserLimit) // Confluence has its own variety when compared to the `userLimits` feature
    return {
        text: text,
        appearance: 'warning',
        icon: 'warning'
    };
    return {
        text: text,
        appearance: 'default',
        icon: 'gem'
    };
}
function $a7f04c3b22ba77ca$var$getTrialContent({ context: context, formatMessage: formatMessage }) {
    const { product: product, edition: edition, trialDaysLeft: trialDaysLeft, trialLengthDays: trialLengthDays, isInReverseTrial: isInReverseTrial } = context;
    let appearance = 'default';
    let icon = 'gem';
    const daysLeftText = formatMessage({
        id: '@atlassian/edition-awareness.button.daysLeft',
        defaultMessage: '{trialDaysLeft, plural, one {# day} other {# days}} left',
        description: 'Informs the user how many days they have left in trial'
    }, {
        trialDaysLeft: trialDaysLeft
    });
    if (product === 'jira' && (0, $kbMGT.isEligibleForStandardTrialsUserAndStorageLimitBreakers)({
        context: context
    }) && (0, $iEN9D.default).getExperimentValue('jira_edition_awareness_standard_trials', 'cohort', 'not-enrolled') === 'treatment') return {
        text: daysLeftText,
        appearance: trialDaysLeft && trialDaysLeft <= 3 ? 'danger' : 'warning',
        icon: 'warning'
    };
    if (product === 'confluence' && (0, $kbMGT.isEligibleForStandardTrialsUserAndStorageLimitBreakers)({
        context: context
    }) && (0, $iEN9D.default).getExperimentValue('connie_edition_awareness_standard_trials', 'cohort', 'not-enrolled') === 'treatment') return {
        text: daysLeftText,
        appearance: 'warning',
        icon: 'warning'
    };
    if ([
        'jira',
        'jira-service-management',
        'jira-product-discovery'
    ].includes(product)) {
        // Trial Countdown Experiment
        const trialCountdownExperimentEnabled = (0, $1afMW.isEligibleForTrialCountdown)(context) && (0, $iEN9D.default).getExperimentValue('jira_edition_awareness_trial_countdown', 'isEnabled', false);
        // If trial is 3 days or less, swap the button to the warning state
        if (trialCountdownExperimentEnabled && !!trialDaysLeft && trialDaysLeft <= 3) {
            appearance = 'warning';
            icon = 'warning';
        }
        // If trial is still in its first half, show trial message instead of trial days left
        const isInFirstHalfOfTrial = Boolean(trialCountdownExperimentEnabled && trialDaysLeft && trialLengthDays && trialDaysLeft > Math.ceil(trialLengthDays / 2));
        if (isInFirstHalfOfTrial) {
            if (edition === 'premium') {
                if (product === 'jira' && isInReverseTrial && (0, $VSDnB.fg)('jira_reverse_trial_ea_updates_during_trial_gate')) {
                    if ((0, $iEN9D.default).getExperimentValue('jira_reverse_trial_ea_updates_during_trial', 'cohort', 'not-enrolled') === 'variation') return {
                        text: formatMessage({
                            id: '@atlassian/edition-awareness.button.see-plans.not-final',
                            defaultMessage: 'See plans',
                            description: 'Informs the user that they are able to see plans'
                        }),
                        appearance: appearance,
                        icon: icon
                    };
                }
                return {
                    text: formatMessage({
                        id: '@atlassian/edition-awareness.button.premium-trial',
                        defaultMessage: 'Premium trial',
                        description: 'Informs the user that they are on a premium trial'
                    }),
                    appearance: appearance,
                    icon: icon
                };
            }
            if (edition === 'standard') return {
                text: formatMessage({
                    id: '@atlassian/edition-awareness.button.standard-trial',
                    defaultMessage: 'Standard trial',
                    description: 'Informs the user that they are on a standard trial'
                }),
                appearance: appearance,
                icon: icon
            };
        }
    }
    if ((0, $3Ic4Z.isEligibleForConfluenceBuyReverseTrialExperiment)({
        context: context
    }) && (0, $VSDnB.fg)('growth_confluence_buy_reverse_trials_fg')) {
        const abCohort = (0, $iEN9D.default).getExperimentValue('growth_confluence_buy_reverse_trials_ab', 'cohort', 'not-enrolled');
        if (abCohort === 'variation') {
            if (trialDaysLeft && trialDaysLeft > 3) return {
                text: formatMessage({
                    id: '@atlassian/edition-awareness.button.see-plans.cbrt.not-final',
                    defaultMessage: 'See plans',
                    description: 'Informs the user that they are able to see plans'
                }),
                appearance: appearance,
                icon: icon
            };
            return {
                text: formatMessage({
                    id: '@atlassian/edition-awareness.button.see-plans.cbrt.final',
                    defaultMessage: '{trialDaysLeft, plural, =1 {# day} other {# days}} left',
                    description: 'Indicates to the user how many days they have left in trial'
                }, {
                    trialDaysLeft: trialDaysLeft
                }),
                appearance: 'warning',
                icon: 'warning'
            };
        }
    }
    return {
        text: daysLeftText,
        appearance: appearance,
        icon: icon
    };
}
function $a7f04c3b22ba77ca$var$getPredunningContent({ context: context, formatMessage: formatMessage }) {
    const { edition: edition, product: product, isInReverseTrial: isInReverseTrial } = context;
    let appearance = 'default';
    let icon = 'credit-card';
    if ((0, $kbMGT.isEligibleForStandardTrialsUserAndStorageLimitBreakers)({
        context: context
    }) && (0, $iEN9D.default).getExperimentValue(product === 'jira' ? 'jira_edition_awareness_standard_trials' : 'connie_edition_awareness_standard_trials', 'cohort', 'not-enrolled') === 'treatment') {
        appearance = 'warning';
        icon = 'warning';
    }
    if (product === 'jira' && edition === 'premium' && isInReverseTrial && (0, $VSDnB.fg)('jira_reverse_trial_ea_updates_during_trial_gate')) {
        if ((0, $iEN9D.default).getExperimentValue('jira_reverse_trial_ea_updates_during_trial', 'cohort', 'not-enrolled') === 'variation') return {
            text: formatMessage({
                id: '@atlassian/edition-awareness.button.choose-plans.not-final',
                defaultMessage: 'Choose a plan',
                description: 'Informs the user that they are able to choose a plan'
            }),
            appearance: 'warning',
            icon: 'warning'
        };
    }
    if ((0, $3Ic4Z.isEligibleForConfluenceBuyReverseTrialExperiment)({
        context: context
    }) && (0, $VSDnB.fg)('growth_confluence_buy_reverse_trials_fg')) {
        if ((0, $iEN9D.default).getExperimentValue('growth_confluence_buy_reverse_trials_ab', 'cohort', 'not-enrolled') === 'variation') return {
            text: formatMessage({
                id: '@atlassian/edition-awareness.button.see-plans.final',
                defaultMessage: 'Choose a plan',
                description: 'Informs the user that they are able to choose a plan'
            }),
            appearance: 'warning',
            icon: 'warning'
        };
    }
    return {
        text: formatMessage({
            id: '@atlassian/edition-awareness.button.addPaymentDetails',
            defaultMessage: 'Add payment details',
            description: 'Informs the user how many days they have left in trial'
        }),
        appearance: appearance,
        icon: icon
    };
}
function $a7f04c3b22ba77ca$export$c810aba6284fa97d() {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const context = (0, $3FEPM.useEditionAwareness)();
    const { edition: edition, isInPredunning: isInPredunning, isInTrial: isInTrial } = context;
    if (edition === 'free') return $a7f04c3b22ba77ca$var$getFreeContent({
        context: context,
        formatMessage: formatMessage
    });
    if (isInTrial) return $a7f04c3b22ba77ca$var$getTrialContent({
        context: context,
        formatMessage: formatMessage
    });
    if (isInPredunning) return $a7f04c3b22ba77ca$var$getPredunningContent({
        context: context,
        formatMessage: formatMessage
    });
    if ((0, $9o45M.isEligibleForStandardToPremium)(context)) return {
        text: formatMessage({
            id: '@atlassian/edition-awareness.button.upgrade.standard-to-premium',
            defaultMessage: 'Upgrade',
            description: 'Informs the user that they can upgrade their product'
        }),
        appearance: 'default',
        icon: 'gem',
        isDismissible: true
    };
    return null;
}

});
parcelRegister("cTqug", function(module, exports) {

$parcel$export(module.exports, "getProductForTranslation", () => $a9f0f14d955225c0$export$fd45d905638d9909);
const $a9f0f14d955225c0$var$PRODUCT_TO_TRANSLATION_KEY = {
    jira: 'jira',
    'jira-service-management': 'jsm',
    'jira-product-discovery': 'jpd',
    confluence: 'confluence'
};
function $a9f0f14d955225c0$export$fd45d905638d9909(product) {
    return $a9f0f14d955225c0$var$PRODUCT_TO_TRANSLATION_KEY[product];
}

});

parcelRegister("9o45M", function(module, exports) {

$parcel$export(module.exports, "isEligibleForStandardToPremium", () => $5564c251c9100eb3$export$d58c0da339bf36d9);

var $VSDnB = parcelRequire("VSDnB");
function $5564c251c9100eb3$export$d58c0da339bf36d9({ product: product, edition: edition, userRoles: userRoles, trialOfferingName: trialOfferingName }) {
    if (edition === 'standard' && userRoles?.includes('SITE_ADMIN') && trialOfferingName === 'premium') {
        if (product === 'jira' && (0, $VSDnB.fg)('edition_awareness_upsell_jira_fg')) return true;
        if (product === 'jira-service-management' && (0, $VSDnB.fg)('edition_awareness_upsell_jsm_fg')) return true;
        if (product === 'confluence' && (0, $VSDnB.fg)('edition_awareness_standard_upsell_confluence_ab_fg')) return true;
    }
    return false;
}

});

parcelRegister("1afMW", function(module, exports) {

$parcel$export(module.exports, "isEligibleForTrialCountdown", () => $704eb02e2a7cd5f7$export$947e3549c8b868b2);
function $704eb02e2a7cd5f7$export$947e3549c8b868b2({ isInTrial: isInTrial, isInPredunning: isInPredunning, trialDaysLeft: trialDaysLeft, trialLengthDays: trialLengthDays, billingSourceSystem: billingSourceSystem }) {
    return Boolean(isInTrial && !isInPredunning && trialDaysLeft && trialLengthDays && billingSourceSystem === 'CCP');
}

});


parcelRegister("WqpJ2", function(module, exports) {

$parcel$export(module.exports, "useTracedUrl", () => $55bd0a2d6197e971$export$5eea7bde9861e87b);

var $5uXOq = parcelRequire("5uXOq");

var $2gQ83 = parcelRequire("2gQ83");

var $3FEPM = parcelRequire("3FEPM");
const $55bd0a2d6197e971$var$PRODUCT_TO_ORIGIN = {
    ['confluence']: 'confluence',
    ['jira']: 'jira',
    ['jira-product-discovery']: 'jira',
    ['jira-service-management']: 'jira'
};
function $55bd0a2d6197e971$export$5eea7bde9861e87b(untracedUrl) {
    const { product: product } = (0, $3FEPM.useEditionAwareness)();
    const origin = (0, $5uXOq.useMemo)(()=>new (0, $2gQ83.default)({
            product: $55bd0a2d6197e971$var$PRODUCT_TO_ORIGIN[product]
        }), [
        product
    ]);
    const url = (0, $5uXOq.useMemo)(()=>untracedUrl ? origin.addToUrl(untracedUrl) : undefined, [
        untracedUrl,
        origin
    ]);
    return {
        url: url,
        origin: origin
    };
}

});



parcelRegister("kDZBc", function(module, exports) {

$parcel$export(module.exports, "DIALOG_CONFIG", () => $afb90283c5e6318e$export$3b6761b6086f6dfd);
const $afb90283c5e6318e$export$3b6761b6086f6dfd = {
    touchpointIntent: 'startTrial',
    dialogId: 'automation-limits-modal',
    dialogType: 'modal'
};

});

parcelRegister("elAd3", function(module, exports) {

$parcel$export(module.exports, "default", () => $13f41a74b8017494$export$2e2bcd8739ae039);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $13f41a74b8017494$var$AutomationLimitsEntryPoint = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("9iW0L")), {
        moduleId: "5fda9d5c",
        moduleId: 'edition-awareness-automation-limits-modal'
    }),
    getPreloadProps: ()=>({
            entryPoints: {},
            extraProps: {},
            queries: {}
        })
});
var $13f41a74b8017494$export$2e2bcd8739ae039 = $13f41a74b8017494$var$AutomationLimitsEntryPoint;

});
parcelRegister("9iW0L", function(module, exports) {

let $6c62cb50228227e5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6c62cb50228227e5$var$load("1Ubng").then(()=>parcelRequire('keCPY'));

});



parcelRegister("7f9lz", function(module, exports) {

$parcel$export(module.exports, "EducationalDiscountDialog", () => $ea09eb44c81c0acd$export$adb3efabe141b521);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $79ZRb = parcelRequire("79ZRb");

var $3FEPM = parcelRequire("3FEPM");

var $8XFbn = parcelRequire("8XFbn");

var $fqeRg = parcelRequire("fqeRg");

var $ddn5Q = parcelRequire("ddn5Q");

var $am19W = parcelRequire("am19W");
function $ea09eb44c81c0acd$export$adb3efabe141b521() {
    const { product: product, cloudId: cloudId } = (0, $3FEPM.useEditionAwareness)();
    const onClose = (0, $79ZRb.useOnDismissDialog)({
        ...(0, $ddn5Q.DIALOG_CONFIG)
    });
    const entryPointProps = (0, $5uXOq.useMemo)(()=>({
            onClose: onClose
        }), [
        onClose
    ]);
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            hamsProductKey: (0, $8XFbn.getHamsKey)(product)
        }), [
        cloudId,
        product
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fqeRg.ModalEntryPoint), {
        entryPoint: (0, $am19W.default),
        entryPointParams: entryPointParams,
        entryPointProps: entryPointProps,
        dialogConfig: (0, $ddn5Q.DIALOG_CONFIG)
    });
}

});
parcelRegister("ddn5Q", function(module, exports) {

$parcel$export(module.exports, "DIALOG_CONFIG", () => $54cad9aa55c4620d$export$3b6761b6086f6dfd);
const $54cad9aa55c4620d$export$3b6761b6086f6dfd = {
    touchpointIntent: 'startTrial',
    dialogId: 'educational-discount-modal',
    dialogType: 'modal'
};

});

parcelRegister("am19W", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e226df5b3f8617d$export$2e2bcd8739ae039);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

var $eZFAk = parcelRequire("eZFAk");

const $4e226df5b3f8617d$var$EducationalDiscountEntryPoint = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("7xMZa")), {
        moduleId: "f8e44e05",
        moduleId: 'edition-awareness-educational-discount-modal-dialog'
    }),
    getPreloadProps: ({ cloudId: cloudId, hamsProductKey: hamsProductKey })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                tenantContexts: {
                    parameters: $eZFAk.default,
                    variables: {
                        cloudId: cloudId,
                        hamsProductKey: hamsProductKey
                    }
                }
            }
        })
});
var $4e226df5b3f8617d$export$2e2bcd8739ae039 = $4e226df5b3f8617d$var$EducationalDiscountEntryPoint;

});
parcelRegister("eZFAk", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea503736cb515dfb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<de281939d1647ab12360e5cb1137a0d1>>
 * @relayHash d2cd70c3b7892e3fd9793c1ba33f0af7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 092093bc1bea11a8b3077c854c7f7b25ea3881f3559f636dfc10b3c46c0ede43

var $eiowN = parcelRequire("eiowN");
const $ea503736cb515dfb$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hamsProductKey"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "dialogEducationalDiscountEditionAwarenessQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "dialogEducationalDiscountEditionAwarenessQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        v3 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "092093bc1bea11a8b3077c854c7f7b25ea3881f3559f636dfc10b3c46c0ede43",
            "metadata": {},
            "name": "dialogEducationalDiscountEditionAwarenessQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ea503736cb515dfb$var$node.hash = "5b3007c742556dcc0027824b57ed5a62";
(0, $eiowN.PreloadableQueryRegistry).set($ea503736cb515dfb$var$node.params.id, $ea503736cb515dfb$var$node);
var $ea503736cb515dfb$export$2e2bcd8739ae039 = $ea503736cb515dfb$var$node;

});

parcelRegister("7xMZa", function(module, exports) {

let $57e19cfd4981c56a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $57e19cfd4981c56a$var$load("43KAY").then(()=>parcelRequire('4yYoC'));

});



parcelRegister("8kHqB", function(module, exports) {

$parcel$export(module.exports, "FreeToStandardDialog", () => $04ecf9b305732dd4$export$5077353235cd2bbf);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $79ZRb = parcelRequire("79ZRb");

var $3FEPM = parcelRequire("3FEPM");

var $iENAf = parcelRequire("iENAf");

var $4olyx = parcelRequire("4olyx");

var $8XFbn = parcelRequire("8XFbn");

var $fqeRg = parcelRequire("fqeRg");

var $3dqIV = parcelRequire("3dqIV");

var $26Xej = parcelRequire("26Xej");

var $3JEjM = parcelRequire("3JEjM");
function $04ecf9b305732dd4$export$5077353235cd2bbf() {
    const { product: product, cloudId: cloudId } = (0, $3FEPM.useEditionAwareness)();
    const jiraApplicationKey = (0, $iENAf.getJiraApplicationKey)(product);
    const projectType = (0, $4olyx.getJiraProjectTypeKey)(product);
    const { aaCohort: aaCohort, abCohort: abCohort } = (0, $3JEjM.useNBEAExperiment)({
        fireExperimentExposure: false,
        product: product
    });
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            hamsProductKey: (0, $8XFbn.getHamsKey)(product),
            // Fallback to any valid value since this means that we're not using jira
            jiraApplicationKey: jiraApplicationKey ?? 'JIRA_SOFTWARE',
            // Fallback to any valid value since this means that we're not using jira
            projectType: projectType ?? 'SOFTWARE',
            isJira: product === 'jira' || product === 'jira-product-discovery' || product === 'jira-service-management',
            isConfluence: product === 'confluence',
            shouldIncludeGUPS: product === 'confluence' && (aaCohort === 'treatment' || abCohort === 'control' || abCohort === 'treatment')
        }), [
        aaCohort,
        abCohort,
        cloudId,
        product,
        projectType,
        jiraApplicationKey
    ]);
    const onClose = (0, $79ZRb.useOnDismissDialog)({
        ...(0, $3dqIV.DIALOG_CONFIG)
    });
    const entryPointProps = (0, $5uXOq.useMemo)(()=>({
            onClose: onClose
        }), [
        onClose
    ]);
    const modalProps = (0, $5uXOq.useMemo)(()=>({
            width: 'x-large',
            autoFocus: false
        }), []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fqeRg.ModalEntryPoint), {
        entryPointProps: entryPointProps,
        entryPoint: (0, $26Xej.entryPoint),
        entryPointParams: entryPointParams,
        modalProps: modalProps,
        dialogConfig: (0, $3dqIV.DIALOG_CONFIG)
    });
}

});
parcelRegister("4olyx", function(module, exports) {

$parcel$export(module.exports, "getJiraProjectTypeKey", () => $b06333016913fe73$export$600268f282087736);
// We're explicitly excluding 'confluence' from this mapping as it's handled separately
const $b06333016913fe73$var$PRODUCT_TO_JIRA_PROJECT_TYPE_KEY = {
    ['jira']: 'SOFTWARE',
    ['jira-product-discovery']: 'PRODUCT_DISCOVERY',
    ['jira-service-management']: 'SERVICE_DESK'
};
const $b06333016913fe73$export$600268f282087736 = (product)=>{
    return $b06333016913fe73$var$PRODUCT_TO_JIRA_PROJECT_TYPE_KEY[product];
};

});

parcelRegister("3dqIV", function(module, exports) {

$parcel$export(module.exports, "DIALOG_CONFIG", () => $472cbec39f5e4304$export$3b6761b6086f6dfd);
const $472cbec39f5e4304$export$3b6761b6086f6dfd = {
    touchpointIntent: 'startTrial',
    dialogId: 'free-to-standard',
    dialogType: 'modal'
};

});

parcelRegister("26Xej", function(module, exports) {

$parcel$export(module.exports, "entryPoint", () => $ab886833bd34df6b$export$6333901e831d7af0);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

var $gRhFq = parcelRequire("gRhFq");

const $ab886833bd34df6b$export$6333901e831d7af0 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("4Ex0N")), {
        moduleId: "f961beab",
        moduleId: 'edition-awareness-free-to-standard-jira-products-dialog'
    }),
    getPreloadProps: ({ cloudId: cloudId, hamsProductKey: hamsProductKey, projectType: projectType, jiraApplicationKey: jiraApplicationKey, isJira: isJira, isConfluence: isConfluence, shouldIncludeGUPS: shouldIncludeGUPS })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                tenantContexts: {
                    parameters: $gRhFq.default,
                    variables: {
                        cloudId: cloudId,
                        hamsProductKey: hamsProductKey,
                        jiraApplicationKey: jiraApplicationKey,
                        projectType: projectType,
                        isJira: isJira,
                        isConfluence: isConfluence,
                        shouldIncludeGUPS: shouldIncludeGUPS
                    }
                }
            }
        })
});

});
parcelRegister("gRhFq", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ccfd1ddb57d8985$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<887e6acd1be03175ba7187a23c835f09>>
 * @relayHash 0be5cb993518b92561cc393804097a02
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7e6236bea244c949cd60c0d29d63bf5da162472d4b2dcc6351f0dcb40e67c0ce

var $eiowN = parcelRequire("eiowN");
const $6ccfd1ddb57d8985$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hamsProductKey"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isConfluence"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isJira"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jiraApplicationKey"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectType"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldIncludeGUPS"
    }, v7 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v8 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v9 = [
        {
            "kind": "Literal",
            "name": "offeringName",
            "value": "Premium"
        }
    ], v10 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v11 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v12 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v13 = {
        "condition": "isConfluence",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    v11 /*: any*/ ,
                    {
                        "kind": "Literal",
                        "name": "cql",
                        "value": "type=user"
                    },
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 100
                    }
                ],
                "concreteType": "ConfluenceSearchConnection",
                "kind": "LinkedField",
                "name": "confluence_searchUser",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "ConfluenceSearchResponse",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "ConfluencePerson",
                                "kind": "LinkedField",
                                "name": "confluencePerson",
                                "plural": false,
                                "selections": [
                                    v12 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "displayName"
                                    },
                                    {
                                        "concreteType": "Icon",
                                        "kind": "LinkedField",
                                        "name": "profilePicture",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "path"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "concreteType": "ConfluenceStorage",
                "kind": "LinkedField",
                "name": "confluence_storage",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isUnlimited"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "bytesUsed"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "bytesLimit"
                    }
                ]
            }
        ]
    }, v14 = {
        "condition": "shouldIncludeGUPS",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "tenantId",
                        "variableName": "cloudId"
                    }
                ],
                "concreteType": "GrowthUnifiedProfileResult",
                "kind": "LinkedField",
                "name": "growthUnifiedProfile_getUnifiedProfile",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "GrowthUnifiedProfileSiteDetails",
                        "kind": "LinkedField",
                        "name": "sites",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "GrowthUnifiedProfileProductDetails",
                                "kind": "LinkedField",
                                "name": "products",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "productName"
                                    },
                                    {
                                        "concreteType": "GrowthUnifiedProfileProductNBE",
                                        "kind": "LinkedField",
                                        "name": "nbeRecommendation",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "edition"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "recommendationDate"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v15 = [
        {
            "kind": "Variable",
            "name": "applicationKey",
            "variableName": "jiraApplicationKey"
        },
        v11 /*: any*/ 
    ], v16 = {
        "args": v15 /*: any*/ ,
        "kind": "ScalarField",
        "name": "attachmentStorageAllowed"
    }, v17 = {
        "args": v15 /*: any*/ ,
        "kind": "ScalarField",
        "name": "attachmentStorageUsed"
    }, v18 = {
        "args": v15 /*: any*/ ,
        "kind": "ScalarField",
        "name": "attachmentStorageIsUnlimited"
    }, v19 = [
        v11 /*: any*/ ,
        {
            "fields": [
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "types.0",
                            "variableName": "projectType"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "types"
                }
            ],
            "kind": "ObjectValue",
            "name": "filter"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        }
    ], v20 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        }
    ], v21 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v22 = {
        "kind": "ScalarField",
        "name": "name"
    }, v23 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v24 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "dialogFreeToStandardEditionAwarenessQuery",
            "selections": [
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v8 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "condition": "isConfluence",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "alias": "changeOfferingPremium",
                                                            "args": v9 /*: any*/ ,
                                                            "kind": "LinkedField",
                                                            "name": "changeOfferingV2",
                                                            "plural": false,
                                                            "selections": [
                                                                v10 /*: any*/ 
                                                            ],
                                                            "storageKey": "changeOfferingV2(offeringName:\"Premium\")"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                {
                    "condition": "isJira",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                v16 /*: any*/ ,
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                {
                                    "args": v19 /*: any*/ ,
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "allJiraProjects",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "args": v20 /*: any*/ ,
                                                            "concreteType": "JiraAssignableUsersConnection",
                                                            "kind": "LinkedField",
                                                            "name": "assignableUsers",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraAssignableUsersEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v12 /*: any*/ ,
                                                                                v21 /*: any*/ ,
                                                                                v22 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "assignableUsers(first:10)"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "dialogFreeToStandardEditionAwarenessQuery",
            "selections": [
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v8 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v23 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v23 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v23 /*: any*/ ,
                                                {
                                                    "condition": "isConfluence",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "alias": "changeOfferingPremium",
                                                            "args": v9 /*: any*/ ,
                                                            "kind": "LinkedField",
                                                            "name": "changeOfferingV2",
                                                            "plural": false,
                                                            "selections": [
                                                                v23 /*: any*/ ,
                                                                v10 /*: any*/ 
                                                            ],
                                                            "storageKey": "changeOfferingV2(offeringName:\"Premium\")"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v24 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                {
                    "condition": "isJira",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                v16 /*: any*/ ,
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                {
                                    "args": v19 /*: any*/ ,
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "allJiraProjects",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "args": v20 /*: any*/ ,
                                                            "concreteType": "JiraAssignableUsersConnection",
                                                            "kind": "LinkedField",
                                                            "name": "assignableUsers",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraAssignableUsersEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v23 /*: any*/ ,
                                                                                v12 /*: any*/ ,
                                                                                v21 /*: any*/ ,
                                                                                v22 /*: any*/ ,
                                                                                v24 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "assignableUsers(first:10)"
                                                        },
                                                        v24 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "7e6236bea244c949cd60c0d29d63bf5da162472d4b2dcc6351f0dcb40e67c0ce",
            "metadata": {},
            "name": "dialogFreeToStandardEditionAwarenessQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$6ccfd1ddb57d8985$var$node.hash = "3c2df7c77327879f62c30b0b1b917ecf";
(0, $eiowN.PreloadableQueryRegistry).set($6ccfd1ddb57d8985$var$node.params.id, $6ccfd1ddb57d8985$var$node);
var $6ccfd1ddb57d8985$export$2e2bcd8739ae039 = $6ccfd1ddb57d8985$var$node;

});

parcelRegister("4Ex0N", function(module, exports) {

let $363481542bf574e8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $363481542bf574e8$var$load("adx5p").then(()=>parcelRequire('l5x5G'));

});


parcelRegister("3JEjM", function(module, exports) {

$parcel$export(module.exports, "useNBEAExperiment", () => $f872086930c6746f$export$d8f75705812ce676);

var $iEN9D = parcelRequire("iEN9D");

var $VSDnB = parcelRequire("VSDnB");
const $f872086930c6746f$export$d8f75705812ce676 = ({ fireExperimentExposure: fireExperimentExposure = false, product: product })=>{
    const aaExperimentKey = 'confluence_next_best_edition_recommend_aa';
    let aaCohort = 'not-enrolled';
    const abExperimentKey = 'confluence_next_best_edition_recommend';
    let abCohort = 'not-enrolled';
    if (product === 'confluence' && (0, $VSDnB.fg)('edition_awareness_confluence_next_best_rec_fg')) {
        aaCohort = (0, $iEN9D.default).getExperimentValue(aaExperimentKey, 'cohort', 'not-enrolled', {
            fireExperimentExposure: fireExperimentExposure
        });
        abCohort = (0, $iEN9D.default).getExperimentValue(abExperimentKey, 'cohort', 'not-enrolled', {
            fireExperimentExposure: fireExperimentExposure
        });
    }
    return {
        aaExperimentKey: aaExperimentKey,
        aaCohort: aaCohort,
        abExperimentKey: abExperimentKey,
        abCohort: abCohort
    };
};

});


parcelRegister("d0sbz", function(module, exports) {

$parcel$export(module.exports, "FreeToStandardRefresh", () => $9bbcbeec6e7e4444$export$31efb40bd42b4e9b);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $79ZRb = parcelRequire("79ZRb");

var $3FEPM = parcelRequire("3FEPM");

var $4olyx = parcelRequire("4olyx");

var $fqeRg = parcelRequire("fqeRg");

var $1ofzy = parcelRequire("1ofzy");

var $k4fyo = parcelRequire("k4fyo");
function $9bbcbeec6e7e4444$export$31efb40bd42b4e9b() {
    const { product: product, cloudId: cloudId } = (0, $3FEPM.useEditionAwareness)();
    const projectType = (0, $4olyx.getJiraProjectTypeKey)(product);
    if (!projectType) throw new Error('Tried to render free to standard refresh dialog for unsupported product');
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            projectType: projectType
        }), [
        cloudId,
        projectType
    ]);
    const onClose = (0, $79ZRb.useOnDismissDialog)({
        ...(0, $1ofzy.DIALOG_CONFIG)
    });
    const entryPointProps = (0, $5uXOq.useMemo)(()=>({
            onClose: onClose,
            product: product
        }), [
        onClose,
        product
    ]);
    const modalProps = (0, $5uXOq.useMemo)(()=>({
            width: 932,
            height: 500,
            autoFocus: false
        }), []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fqeRg.ModalEntryPoint), {
        entryPointProps: entryPointProps,
        entryPoint: (0, $k4fyo.entryPoint),
        entryPointParams: entryPointParams,
        modalProps: modalProps,
        dialogConfig: (0, $1ofzy.DIALOG_CONFIG)
    });
}

});
parcelRegister("1ofzy", function(module, exports) {

$parcel$export(module.exports, "DIALOG_CONFIG", () => $73880609f02e1e32$export$3b6761b6086f6dfd);
const $73880609f02e1e32$export$3b6761b6086f6dfd = {
    touchpointIntent: 'startTrial',
    dialogId: 'free-to-standard-refresh',
    dialogType: 'modal'
};

});

parcelRegister("k4fyo", function(module, exports) {

$parcel$export(module.exports, "entryPoint", () => $ac576afda71b88e0$export$6333901e831d7af0);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

var $5coyL = parcelRequire("5coyL");

const $ac576afda71b88e0$export$6333901e831d7af0 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("eGHsR")), {
        moduleId: "4435a54a",
        moduleId: 'edition-awareness-free-to-standard-refresh-modal'
    }),
    getPreloadProps: ({ cloudId: cloudId, projectType: projectType })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                tenantContexts: {
                    parameters: $5coyL.default,
                    variables: {
                        cloudId: cloudId,
                        projectType: projectType
                    }
                }
            }
        })
});

});
parcelRegister("5coyL", function(module, exports) {

$parcel$export(module.exports, "default", () => $437c9804aacd2f11$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fb082a16b8babbaed38b40ab7560fa9b>>
 * @relayHash 6875e4b1d761db52057afe4659d6499e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 678307635f93bf54a1d65db08f481a055b78530ce3ee7d21dcd481b76b58b40e

var $eiowN = parcelRequire("eiowN");
const $437c9804aacd2f11$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectType"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "fields": [
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "types.0",
                            "variableName": "projectType"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "types"
                }
            ],
            "kind": "ObjectValue",
            "name": "filter"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        }
    ], v2 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "freeToStandardRefreshModalEditionAwarenessQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "allJiraProjects",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v2 /*: any*/ ,
                                                    "concreteType": "JiraAssignableUsersConnection",
                                                    "kind": "LinkedField",
                                                    "name": "assignableUsers",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraAssignableUsersEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v3 /*: any*/ ,
                                                                        v4 /*: any*/ ,
                                                                        v5 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "assignableUsers(first:10)"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "freeToStandardRefreshModalEditionAwarenessQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "allJiraProjects",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v2 /*: any*/ ,
                                                    "concreteType": "JiraAssignableUsersConnection",
                                                    "kind": "LinkedField",
                                                    "name": "assignableUsers",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraAssignableUsersEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "__typename"
                                                                        },
                                                                        v3 /*: any*/ ,
                                                                        v4 /*: any*/ ,
                                                                        v5 /*: any*/ ,
                                                                        v6 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "assignableUsers(first:10)"
                                                },
                                                v6 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "678307635f93bf54a1d65db08f481a055b78530ce3ee7d21dcd481b76b58b40e",
            "metadata": {},
            "name": "freeToStandardRefreshModalEditionAwarenessQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$437c9804aacd2f11$var$node.hash = "bc088e6f37b5dce49eea046db90b5bd7";
(0, $eiowN.PreloadableQueryRegistry).set($437c9804aacd2f11$var$node.params.id, $437c9804aacd2f11$var$node);
var $437c9804aacd2f11$export$2e2bcd8739ae039 = $437c9804aacd2f11$var$node;

});

parcelRegister("eGHsR", function(module, exports) {

let $ab16b413bec8f964$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ab16b413bec8f964$var$load("aScGM").then(()=>parcelRequire('j2Q7A'));

});



parcelRegister("cqUnB", function(module, exports) {

$parcel$export(module.exports, "PaymentDetailsPopupDialog", () => $c706820ec700ea6d$export$ef0178c855cf2b43);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $79ZRb = parcelRequire("79ZRb");

var $jdrEY = parcelRequire("jdrEY");

var $g3dmM = parcelRequire("g3dmM");

var $7370u = parcelRequire("7370u");
function $c706820ec700ea6d$export$ef0178c855cf2b43() {
    const onClose = (0, $79ZRb.useOnDismissDialog)({
        ...(0, $g3dmM.DIALOG_CONFIG)
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jdrEY.PopupEntryPoint), {
        entryPoint: (0, $7370u.entryPoint),
        placement: 'bottom-start',
        onClose: onClose,
        dialogConfig: (0, $g3dmM.DIALOG_CONFIG)
    });
}

});
parcelRegister("jdrEY", function(module, exports) {

$parcel$export(module.exports, "PopupEntryPoint", () => $372cc0fa708c4601$export$e14c42e99b209c4d);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $daJ0i = parcelRequire("daJ0i");

var $dC5iT = parcelRequire("dC5iT");

var $eZJjh = parcelRequire("eZJjh");

var $epiY4 = parcelRequire("epiY4");

var $MN7ms = parcelRequire("MN7ms");

var $5yG9d = parcelRequire("5yG9d");
function $372cc0fa708c4601$export$e14c42e99b209c4d(props) {
    const { dialogConfig: dialogConfig, ...rest } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $daJ0i.default), {
        data: dialogConfig,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($372cc0fa708c4601$export$dece147acb9eddff, {
            ...rest
        })
    });
}
function $372cc0fa708c4601$export$dece147acb9eddff(props) {
    const onError = (0, $MN7ms.useEntrypointErrorAnalytics)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $epiY4.PopupTrigger), {
        ...props,
        shouldFitContainer: false,
        trigger: ({ ref: ref })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5yG9d.EditionAwarenessButton), {
                ref: ref
            }),
        fallback: /*#__PURE__*/ (0, $2OMIu.jsx)($372cc0fa708c4601$var$PopupFallback, {}),
        onError: onError
    });
}
const $372cc0fa708c4601$var$PopupFallback = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
        padding: "space.200",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {})
    });

});
parcelRegister("epiY4", function(module, exports) {

$parcel$export(module.exports, "PopupTrigger", () => $781807c7b62182e7$export$95d4acdbab2fc6ef);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $bWn3s = parcelRequire("bWn3s");

var $1I7E8 = parcelRequire("1I7E8");

var $eZJjh = parcelRequire("eZJjh");

var $7F2yO = parcelRequire("7F2yO");

var $kKgGa = parcelRequire("kKgGa");

var $e2pRJ = parcelRequire("e2pRJ");

var $h5nmx = parcelRequire("h5nmx");
const $781807c7b62182e7$var$emptyEntryPointParams = {};
const $781807c7b62182e7$var$emptyEntryPointProps = {};
function $781807c7b62182e7$export$95d4acdbab2fc6ef({ trigger: trigger, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, fallback: fallback, errorFallback: errorFallback, onError: onError, onClose: onClose, ...popupProps }) {
    const environmentProvider = (0, $e2pRJ.useRelayEnvironmentProvider)();
    const id = (0, $5uXOq.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const [content, setContent] = (0, $5uXOq.useState)(null);
    const handleOpen = (0, $5uXOq.useCallback)(()=>{
        setIsOpen(true);
    }, []);
    const handleClose = (0, $5uXOq.useCallback)((event, currentLevel)=>{
        setIsOpen(false);
        onClose?.(event, currentLevel);
    }, [
        onClose
    ]);
    const triggerCloseRef = (0, $h5nmx.useClickToCloseRef)({
        isOpen: isOpen,
        handleClose: handleClose
    });
    const load = (0, $5uXOq.useCallback)(()=>(0, $8Uumt.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $781807c7b62182e7$var$emptyEntryPointParams), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onLoad = (0, $5uXOq.useCallback)(({ reference: entryPointReference })=>{
        // avoid re-loading entry-point when closing popup
        if (isOpen) return;
        handleOpen();
        setContent(/*#__PURE__*/ (0, $2OMIu.jsx)((0, $kKgGa.InternalEntryPointContainer), {
            id: id,
            entryPointReference: entryPointReference,
            fallback: fallback || /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {}),
            errorFallback: errorFallback,
            runtimeProps: {
                ...entryPointProps ?? $781807c7b62182e7$var$emptyEntryPointProps,
                onClose: handleClose
            },
            onError: onError
        }));
    }, [
        setContent,
        id,
        isOpen,
        entryPointProps,
        fallback,
        errorFallback,
        handleOpen,
        onError,
        handleClose
    ]);
    const triggerRef = (0, $7F2yO.usePressablePreloadRef)({
        load: load,
        onLoad: onLoad
    });
    const popupTrigger = (0, $5uXOq.useCallback)((triggerProps)=>{
        const mergedRef = (0, $bWn3s.mergeRefs)([
            triggerRef,
            triggerProps.ref,
            triggerCloseRef
        ]);
        return trigger({
            ...triggerProps,
            ref: mergedRef
        });
    }, [
        trigger,
        triggerRef,
        triggerCloseRef
    ]);
    const popupContent = (0, $5uXOq.useCallback)(()=>{
        return content;
    }, [
        content
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1I7E8.Popup), {
        ...popupProps,
        isOpen: isOpen,
        onClose: handleClose,
        trigger: popupTrigger,
        content: popupContent
    });
}

});
parcelRegister("h5nmx", function(module, exports) {

$parcel$export(module.exports, "useClickToCloseRef", () => $650ad7aa5b0bf102$export$46ec6629f411921d);

var $5uXOq = parcelRequire("5uXOq");
function $650ad7aa5b0bf102$export$46ec6629f411921d({ isOpen: isOpen, handleClose: handleClose }) {
    const ref = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        const el = ref.current;
        if (!el) return;
        const clickListener = ()=>{
            if (isOpen) handleClose(null);
        };
        el.addEventListener('click', clickListener);
        return ()=>{
            el.removeEventListener('click', clickListener);
        };
    }, [
        isOpen,
        handleClose
    ]);
    return ref;
}

});



parcelRegister("g3dmM", function(module, exports) {

$parcel$export(module.exports, "DIALOG_CONFIG", () => $0057c556402c3c24$export$3b6761b6086f6dfd);
const $0057c556402c3c24$export$3b6761b6086f6dfd = {
    touchpointIntent: 'addPaymentDetails',
    dialogId: 'payment-details-popup',
    dialogType: 'pop-up'
};

});

parcelRegister("7370u", function(module, exports) {

$parcel$export(module.exports, "entryPoint", () => $a5bda9579c6f7760$export$6333901e831d7af0);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $a5bda9579c6f7760$export$6333901e831d7af0 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("6SEW3")), {
        moduleId: "eba6adb0",
        moduleId: 'edition-awareness-payment-details-jira-products-popup-dialog'
    }),
    getPreloadProps: ()=>({
            entryPoints: {},
            extraProps: {},
            queries: {}
        })
});

});
parcelRegister("6SEW3", function(module, exports) {

let $50278a23a0e46d7c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $50278a23a0e46d7c$var$load("78y5H").then(()=>parcelRequire('1q9sd'));

});



parcelRegister("atpKp", function(module, exports) {

$parcel$export(module.exports, "PlanSelectionPageDialog", () => $ce74530d6b1db893$export$130b11c8164da129);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $79ZRb = parcelRequire("79ZRb");

var $3FEPM = parcelRequire("3FEPM");

var $8XFbn = parcelRequire("8XFbn");

var $fqeRg = parcelRequire("fqeRg");

var $1wEVF = parcelRequire("1wEVF");

var $ljWQH = parcelRequire("ljWQH");
const $ce74530d6b1db893$var$MODAL_CONFIGS = {
    twc: {
        width: '968px',
        height: '808px'
    },
    'reverse-trial': {
        width: '990px',
        height: '740px'
    }
};
function $ce74530d6b1db893$export$130b11c8164da129({ type: type }) {
    const { cloudId: cloudId, product: product } = (0, $3FEPM.useEditionAwareness)();
    const { width: width, height: height } = $ce74530d6b1db893$var$MODAL_CONFIGS[type];
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            hamsProductKey: (0, $8XFbn.getHamsKey)(product)
        }), [
        cloudId,
        product
    ]);
    const onClose = (0, $79ZRb.useOnDismissDialog)({
        ...(0, $1wEVF.DIALOG_CONFIG)
    });
    const entryPointProps = (0, $5uXOq.useMemo)(()=>({
            onClose: onClose,
            type: type
        }), [
        onClose,
        type
    ]);
    const modalProps = (0, $5uXOq.useMemo)(()=>({
            width: width,
            height: height,
            autoFocus: false,
            shouldScrollInViewport: false,
            shouldCloseOnEscape: true
        }), [
        width,
        height
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fqeRg.ModalEntryPoint), {
        entryPointProps: entryPointProps,
        entryPoint: (0, $ljWQH.entryPoint),
        entryPointParams: entryPointParams,
        modalProps: modalProps,
        dialogConfig: (0, $1wEVF.DIALOG_CONFIG)
    });
}

});
parcelRegister("1wEVF", function(module, exports) {

$parcel$export(module.exports, "DIALOG_CONFIG", () => $6b62bad7ae06882e$export$3b6761b6086f6dfd);
const $6b62bad7ae06882e$export$3b6761b6086f6dfd = {
    touchpointIntent: 'startTrial',
    dialogId: 'plan-selection-page-modal',
    dialogType: 'modal'
};

});

parcelRegister("ljWQH", function(module, exports) {

$parcel$export(module.exports, "entryPoint", () => $b28200a9b93857a3$export$6333901e831d7af0);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

var $6hj94 = parcelRequire("6hj94");

const $b28200a9b93857a3$export$6333901e831d7af0 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("3LmPk")), {
        moduleId: "2b81ad54",
        moduleId: 'edition-awareness-plan-selection-page-modal'
    }),
    getPreloadProps: ({ cloudId: cloudId, hamsProductKey: hamsProductKey })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                tenantContexts: {
                    parameters: $6hj94.default,
                    variables: {
                        cloudId: cloudId,
                        hamsProductKey: hamsProductKey
                    }
                }
            }
        })
});

});
parcelRegister("6hj94", function(module, exports) {

$parcel$export(module.exports, "default", () => $cda79853d23ec8e4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6033d8d84f5415fe7ad64a12bc865a18>>
 * @relayHash 40b0b9ae683dc60dc693e08dd4d92289
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5f04cc2d4500313ab8b7523ccb126a9f011fce9747640d1cc090967d2e7c61c8

var $eiowN = parcelRequire("eiowN");
const $cda79853d23ec8e4$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hamsProductKey"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "isAvailableToUser"
    }, v4 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "dialogPlanSelectionPageModalQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "dialogPlanSelectionPageModalQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "5f04cc2d4500313ab8b7523ccb126a9f011fce9747640d1cc090967d2e7c61c8",
            "metadata": {},
            "name": "dialogPlanSelectionPageModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$cda79853d23ec8e4$var$node.hash = "9790aad2615e477150ecbf3725748065";
(0, $eiowN.PreloadableQueryRegistry).set($cda79853d23ec8e4$var$node.params.id, $cda79853d23ec8e4$var$node);
var $cda79853d23ec8e4$export$2e2bcd8739ae039 = $cda79853d23ec8e4$var$node;

});

parcelRegister("3LmPk", function(module, exports) {

let $2bd777d7558e1caa$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2bd777d7558e1caa$var$load("lGy4J").then(()=>parcelRequire('fvHde'));

});



parcelRegister("26Yuk", function(module, exports) {

$parcel$export(module.exports, "PremiumAddPayment", () => $78cfffba256e3622$export$379c828d9faf7dab);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $79ZRb = parcelRequire("79ZRb");

var $3FEPM = parcelRequire("3FEPM");

var $fqeRg = parcelRequire("fqeRg");

var $1WBkq = parcelRequire("1WBkq");

var $b437w = parcelRequire("b437w");
function $78cfffba256e3622$export$379c828d9faf7dab() {
    const { product: product } = (0, $3FEPM.useEditionAwareness)();
    const onClose = (0, $79ZRb.useOnDismissDialog)({
        ...(0, $1WBkq.DIALOG_CONFIG)
    });
    const entryPointProps = (0, $5uXOq.useMemo)(()=>({
            onClose: onClose,
            product: product
        }), [
        onClose,
        product
    ]);
    const modalProps = (0, $5uXOq.useMemo)(()=>({
            width: 968,
            height: 576,
            autoFocus: false
        }), []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fqeRg.ModalEntryPoint), {
        entryPointProps: entryPointProps,
        entryPoint: (0, $b437w.entryPoint),
        modalProps: modalProps,
        dialogConfig: (0, $1WBkq.DIALOG_CONFIG)
    });
}

});
parcelRegister("1WBkq", function(module, exports) {

$parcel$export(module.exports, "DIALOG_CONFIG", () => $c18b40ea437ebc40$export$3b6761b6086f6dfd);
const $c18b40ea437ebc40$export$3b6761b6086f6dfd = {
    touchpointIntent: 'addPaymentDetails',
    dialogId: 'premium-add-payment',
    dialogType: 'modal'
};

});

parcelRegister("b437w", function(module, exports) {

$parcel$export(module.exports, "entryPoint", () => $1a7caa7a7f52ea0d$export$6333901e831d7af0);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $1a7caa7a7f52ea0d$export$6333901e831d7af0 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("6D25d")), {
        moduleId: "40fe10f7",
        moduleId: 'edition-awareness-premium-add-payment-modal'
    }),
    getPreloadProps: ()=>({
            entryPoints: {},
            extraProps: {},
            queries: {}
        })
});

});
parcelRegister("6D25d", function(module, exports) {

let $4d38003dcc93400b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4d38003dcc93400b$var$load("5uGre").then(()=>parcelRequire('hofOI'));

});



parcelRegister("dWrfe", function(module, exports) {

$parcel$export(module.exports, "PremiumPopup", () => $382e4b9628fbf4f9$export$831a974b36144ba6);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $79ZRb = parcelRequire("79ZRb");

var $3FEPM = parcelRequire("3FEPM");

var $8XFbn = parcelRequire("8XFbn");

var $jdrEY = parcelRequire("jdrEY");

var $jAe9B = parcelRequire("jAe9B");

var $k3H5P = parcelRequire("k3H5P");

var $kgS3o = parcelRequire("kgS3o");
const $382e4b9628fbf4f9$export$831a974b36144ba6 = ()=>{
    const { cloudId: cloudId, product: product, PremiumWrapper: PremiumWrapper, trialDaysLeft: trialDaysLeft, userRoles: userRoles, shouldAutoOpen: shouldAutoOpen, onAutoOpen: onAutoOpen, isInTrial: isInTrial, isInReverseTrial: isInReverseTrial } = (0, $3FEPM.useEditionAwareness)();
    const [isPremiumModalOpen, setIsPremiumModalOpen] = (0, $5uXOq.useState)(false);
    const handleClosePremiumModal = (0, $5uXOq.useCallback)(()=>setIsPremiumModalOpen(false), []);
    const handleOpenPremiumModal = (0, $5uXOq.useCallback)(()=>setIsPremiumModalOpen(true), []);
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            isConfluence: product === 'confluence',
            cloudId: cloudId,
            hamsProductKey: (0, $8XFbn.getHamsKey)(product)
        }), [
        product,
        cloudId
    ]);
    const entryPointProps = (0, $5uXOq.useMemo)(()=>({
            handleOpenPremiumModal: handleOpenPremiumModal
        }), [
        handleOpenPremiumModal
    ]);
    const onDismiss = (0, $79ZRb.useOnDismissDialog)({
        ...(0, $k3H5P.DIALOG_CONFIG)
    });
    const onClose = (0, $5uXOq.useCallback)(()=>{
        onDismiss();
        // This will reset the auto open state from product
        onAutoOpen?.();
    }, [
        onDismiss,
        onAutoOpen
    ]);
    if (!PremiumWrapper) // Shouldn't happen, but if it does then we can at least still show the customer a dialog
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: shouldAutoOpen ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jAe9B.AutoOpenPopupTrigger), {
            entryPoint: (0, $kgS3o.entryPoint),
            entryPointParams: entryPointParams,
            entryPointProps: entryPointProps,
            placement: 'bottom-start',
            onClose: onClose,
            dialogConfig: (0, $k3H5P.DIALOG_CONFIG)
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jdrEY.PopupEntryPoint), {
            entryPoint: (0, $kgS3o.entryPoint),
            entryPointParams: entryPointParams,
            entryPointProps: entryPointProps,
            placement: 'bottom-start',
            onClose: onClose,
            dialogConfig: (0, $k3H5P.DIALOG_CONFIG)
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)(PremiumWrapper, {
            isInTrial: Boolean(isInTrial),
            isInReverseTrial: Boolean(isInReverseTrial),
            trialDaysLeft: trialDaysLeft,
            isSiteAdmin: !!userRoles?.includes('SITE_ADMIN'),
            isPremiumModalOpen: isPremiumModalOpen,
            onClosePremiumModal: handleClosePremiumModal,
            children: shouldAutoOpen ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jAe9B.AutoOpenPopupTrigger), {
                entryPoint: (0, $kgS3o.entryPoint),
                entryPointParams: entryPointParams,
                entryPointProps: entryPointProps,
                placement: 'bottom-start',
                onClose: onClose,
                dialogConfig: (0, $k3H5P.DIALOG_CONFIG)
            }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jdrEY.PopupEntryPoint), {
                entryPoint: (0, $kgS3o.entryPoint),
                entryPointParams: entryPointParams,
                entryPointProps: entryPointProps,
                placement: 'bottom-start',
                onClose: onClose,
                dialogConfig: (0, $k3H5P.DIALOG_CONFIG)
            })
        })
    });
};

});
parcelRegister("jAe9B", function(module, exports) {

$parcel$export(module.exports, "AutoOpenPopupTrigger", () => $ddc140c934736ab7$export$6189e5bf9171fa04);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $daJ0i = parcelRequire("daJ0i");

var $1I7E8 = parcelRequire("1I7E8");

var $dC5iT = parcelRequire("dC5iT");

var $eZJjh = parcelRequire("eZJjh");

var $kKgGa = parcelRequire("kKgGa");

var $e2pRJ = parcelRequire("e2pRJ");

var $MN7ms = parcelRequire("MN7ms");

var $5yG9d = parcelRequire("5yG9d");
const $ddc140c934736ab7$var$emptyEntryPointParams = {};
const $ddc140c934736ab7$var$emptyEntryPointProps = {};
function $ddc140c934736ab7$export$6189e5bf9171fa04(props) {
    const { dialogConfig: dialogConfig, ...rest } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $daJ0i.default), {
        data: dialogConfig,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($ddc140c934736ab7$var$AutoOpenPopupTriggerInner, {
            ...rest
        })
    });
}
/**
 * THIS IS A TEMPORARY IMPLEMENTATION, WILL BE REMOVED IN THE FUTURE
 * NOT RECOMMENDED FOR USE ANYWHERE ELSE
 * Supports the auto-open functionality for the Confluence Premium Popup
 */ function $ddc140c934736ab7$var$AutoOpenPopupTriggerInner({ entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, errorFallback: errorFallback, onClose: onClose, ...popupProps }) {
    const environmentProvider = (0, $e2pRJ.useRelayEnvironmentProvider)();
    const onError = (0, $MN7ms.useEntrypointErrorAnalytics)();
    const id = (0, $5uXOq.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const [content, setContent] = (0, $5uXOq.useState)(null);
    const handleOpen = (0, $5uXOq.useCallback)(()=>{
        setIsOpen(true);
    }, []);
    const handleClose = (0, $5uXOq.useCallback)((event, currentLevel)=>{
        setIsOpen(false);
        onClose?.(event, currentLevel);
    }, [
        onClose
    ]);
    const load = (0, $5uXOq.useCallback)(()=>(0, $8Uumt.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $ddc140c934736ab7$var$emptyEntryPointParams), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onLoad = (0, $5uXOq.useCallback)(({ reference: entryPointReference })=>{
        // avoid re-loading entry-point when closing popup
        if (isOpen) return;
        handleOpen();
        setContent(/*#__PURE__*/ (0, $2OMIu.jsx)((0, $kKgGa.InternalEntryPointContainer), {
            id: id,
            entryPointReference: entryPointReference,
            fallback: /*#__PURE__*/ (0, $2OMIu.jsx)($ddc140c934736ab7$var$PopupFallback, {}),
            errorFallback: errorFallback,
            runtimeProps: entryPointProps || $ddc140c934736ab7$var$emptyEntryPointProps,
            onError: onError
        }));
    }, [
        setContent,
        id,
        isOpen,
        entryPointProps,
        errorFallback,
        handleOpen,
        onError
    ]);
    const handleToggleAndLoad = (0, $5uXOq.useCallback)(()=>{
        if (isOpen) {
            handleClose(null);
            return;
        }
        handleOpen();
        onLoad({
            reference: load()
        });
    }, [
        isOpen,
        handleOpen,
        onLoad,
        load,
        handleClose
    ]);
    const popupTrigger = (0, $5uXOq.useCallback)((triggerProps)=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5yG9d.EditionAwarenessButton), {
            ...triggerProps,
            ref: triggerProps.ref,
            onClick: handleToggleAndLoad
        });
    }, [
        handleToggleAndLoad
    ]);
    const popupContent = (0, $5uXOq.useCallback)(()=>{
        return content;
    }, [
        content
    ]);
    const hasRun = (0, $5uXOq.useRef)(false);
    // Auto-open on load
    (0, $5uXOq.useEffect)(()=>{
        if (!hasRun.current) {
            handleToggleAndLoad?.();
            hasRun.current = true;
        }
    }, [
        handleToggleAndLoad
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1I7E8.Popup), {
        ...popupProps,
        isOpen: isOpen,
        onClose: handleClose,
        trigger: popupTrigger,
        content: popupContent,
        shouldFitContainer: false
    });
}
const $ddc140c934736ab7$var$PopupFallback = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
        padding: "space.200",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {})
    });

});

parcelRegister("k3H5P", function(module, exports) {

$parcel$export(module.exports, "DIALOG_CONFIG", () => $eade7cb58c8ed02d$export$3b6761b6086f6dfd);
const $eade7cb58c8ed02d$export$3b6761b6086f6dfd = {
    touchpointIntent: 'addPaymentDetails',
    dialogId: 'premium-popup',
    dialogType: 'pop-up'
};

});

parcelRegister("kgS3o", function(module, exports) {

$parcel$export(module.exports, "entryPoint", () => $6a5994877fa72183$export$6333901e831d7af0);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

var $8z0re = parcelRequire("8z0re");

const $6a5994877fa72183$export$6333901e831d7af0 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("8aG4r")), {
        moduleId: "2e144122",
        moduleId: 'edition-awareness-premium-popup-dialog'
    }),
    getPreloadProps: ({ cloudId: cloudId, hamsProductKey: hamsProductKey })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                confluencePremiumPopupEditionAwarenessQuery: {
                    parameters: $8z0re.default,
                    variables: {
                        cloudId: cloudId,
                        hamsProductKey: hamsProductKey
                    }
                }
            }
        })
});

});
parcelRegister("8z0re", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3f88aeb51ebaf11$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f42eb22761d87132087191e772b6529c>>
 * @relayHash ba117c6deb9d6d8baa580b9006b0fab9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d55d294917b3f620174898584471255b7ba2f3a66f2ddd731d4770ff35ff7721

var $eiowN = parcelRequire("eiowN");
const $a3f88aeb51ebaf11$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hamsProductKey"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "isAvailableToUser"
    }, v4 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "confluencePremiumPopupEditionAwarenessQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "confluencePremiumPopupEditionAwarenessQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d55d294917b3f620174898584471255b7ba2f3a66f2ddd731d4770ff35ff7721",
            "metadata": {},
            "name": "confluencePremiumPopupEditionAwarenessQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$a3f88aeb51ebaf11$var$node.hash = "922d33555a643b735c02d9535049b896";
(0, $eiowN.PreloadableQueryRegistry).set($a3f88aeb51ebaf11$var$node.params.id, $a3f88aeb51ebaf11$var$node);
var $a3f88aeb51ebaf11$export$2e2bcd8739ae039 = $a3f88aeb51ebaf11$var$node;

});

parcelRegister("8aG4r", function(module, exports) {

let $5f2fe43c5b4b92cf$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5f2fe43c5b4b92cf$var$load("3ua5Z").then(()=>parcelRequire('clUzg'));

});



parcelRegister("58xN9", function(module, exports) {

$parcel$export(module.exports, "ReverseTrialPopupDialog", () => $e48cce26789d8014$export$436172fa0e71e289);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $79ZRb = parcelRequire("79ZRb");

var $3FEPM = parcelRequire("3FEPM");

var $8XFbn = parcelRequire("8XFbn");

var $jdrEY = parcelRequire("jdrEY");

var $3tndl = parcelRequire("3tndl");

var $ibJH7 = parcelRequire("ibJH7");
function $e48cce26789d8014$export$436172fa0e71e289() {
    const { product: product, cloudId: cloudId } = (0, $3FEPM.useEditionAwareness)();
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            hamsProductKey: (0, $8XFbn.getHamsKey)(product)
        }), [
        cloudId,
        product
    ]);
    const onClose = (0, $79ZRb.useOnDismissDialog)({
        ...(0, $3tndl.DIALOG_CONFIG)
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jdrEY.PopupEntryPoint), {
        entryPoint: (0, $ibJH7.entryPoint),
        entryPointParams: entryPointParams,
        placement: 'bottom-end',
        onClose: onClose,
        dialogConfig: (0, $3tndl.DIALOG_CONFIG)
    });
}

});
parcelRegister("3tndl", function(module, exports) {

$parcel$export(module.exports, "DIALOG_CONFIG", () => $39d2e9c6d06ffc4a$export$3b6761b6086f6dfd);
const $39d2e9c6d06ffc4a$export$3b6761b6086f6dfd = {
    touchpointIntent: 'addPaymentDetails',
    dialogId: 'reverse-trial-popup',
    dialogType: 'pop-up'
};

});

parcelRegister("ibJH7", function(module, exports) {

$parcel$export(module.exports, "entryPoint", () => $f3acead4efc37e67$export$6333901e831d7af0);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

var $hqx9i = parcelRequire("hqx9i");

const $f3acead4efc37e67$export$6333901e831d7af0 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("2CXQp")), {
        moduleId: "7de08a47",
        moduleId: 'edition-awareness-reverse-trial-jira-products-popup-dialog'
    }),
    getPreloadProps: ({ cloudId: cloudId, hamsProductKey: hamsProductKey })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                tenantContexts: {
                    parameters: $hqx9i.default,
                    variables: {
                        cloudId: cloudId,
                        hamsProductKey: hamsProductKey
                    }
                }
            }
        })
});

});
parcelRegister("hqx9i", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a55ba8cb2372031$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9baf2e7494e77513a0123eabd435667d>>
 * @relayHash 15f4661c8008097f858290fee0257849
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0370abc7092db06ddab02c7127ae03713013e0fd991d19dedf8d5e8d86b63725

var $eiowN = parcelRequire("eiowN");
const $5a55ba8cb2372031$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hamsProductKey"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v3 = [
        {
            "kind": "Literal",
            "name": "offeringName",
            "value": "Free"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v5 = {
        "kind": "ScalarField",
        "name": "isAvailableToUser"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "dialogReverseTrialPopupEditionAwarenessQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v3 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ],
                                                    "storageKey": "changeOfferingV2(offeringName:\"Free\")"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "dialogReverseTrialPopupEditionAwarenessQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "args": v3 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ],
                                                    "storageKey": "changeOfferingV2(offeringName:\"Free\")"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "0370abc7092db06ddab02c7127ae03713013e0fd991d19dedf8d5e8d86b63725",
            "metadata": {},
            "name": "dialogReverseTrialPopupEditionAwarenessQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$5a55ba8cb2372031$var$node.hash = "9928b60f2d699770604b599a405dd81f";
(0, $eiowN.PreloadableQueryRegistry).set($5a55ba8cb2372031$var$node.params.id, $5a55ba8cb2372031$var$node);
var $5a55ba8cb2372031$export$2e2bcd8739ae039 = $5a55ba8cb2372031$var$node;

});

parcelRegister("2CXQp", function(module, exports) {

let $1e9d8d3bec46e2fc$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $1e9d8d3bec46e2fc$var$load("ffQaD"),
    $1e9d8d3bec46e2fc$var$load("kvRbA"),
    $1e9d8d3bec46e2fc$var$load("ccYl0")
]).then(()=>parcelRequire('2TsXy'));

});



parcelRegister("elt4i", function(module, exports) {

$parcel$export(module.exports, "StandardAddPayment", () => $eaa10ed5a23c07c1$export$23c2efc70269208f);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $79ZRb = parcelRequire("79ZRb");

var $3FEPM = parcelRequire("3FEPM");

var $eDHw9 = parcelRequire("eDHw9");

var $iENAf = parcelRequire("iENAf");

var $4olyx = parcelRequire("4olyx");

var $8XFbn = parcelRequire("8XFbn");

var $fqeRg = parcelRequire("fqeRg");

var $iE4MZ = parcelRequire("iE4MZ");

var $lBST2 = parcelRequire("lBST2");
function $eaa10ed5a23c07c1$export$23c2efc70269208f() {
    const { product: product, cloudId: cloudId } = (0, $3FEPM.useEditionAwareness)();
    const projectType = (0, $4olyx.getJiraProjectTypeKey)(product);
    const jiraApplicationKey = (0, $iENAf.getJiraApplicationKey)(product);
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            hamsProductKey: (0, $8XFbn.getHamsKey)(product),
            chargeElement: (0, $eDHw9.getChargeElementKey)(product),
            // Fallback to any valid value since this means that we're not using jira
            jiraApplicationKey: jiraApplicationKey ?? 'JIRA_SOFTWARE',
            // Fallback to any valid value since this means that we're not using jira
            projectType: projectType ?? 'SOFTWARE',
            isJira: product === 'jira' || product === 'jira-product-discovery' || product === 'jira-service-management',
            isConfluence: product === 'confluence'
        }), [
        cloudId,
        product,
        projectType,
        jiraApplicationKey
    ]);
    const onClose = (0, $79ZRb.useOnDismissDialog)({
        ...(0, $iE4MZ.DIALOG_CONFIG)
    });
    const entryPointProps = (0, $5uXOq.useMemo)(()=>({
            onClose: onClose,
            product: product
        }), [
        onClose,
        product
    ]);
    const modalProps = (0, $5uXOq.useMemo)(()=>{
        if (product === 'confluence') return {
            width: 1000,
            height: 600,
            autoFocus: false
        };
        return {
            width: 968,
            height: 576,
            autoFocus: false
        };
    }, [
        product
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fqeRg.ModalEntryPoint), {
        entryPointProps: entryPointProps,
        entryPoint: (0, $lBST2.entryPoint),
        entryPointParams: entryPointParams,
        modalProps: modalProps,
        dialogConfig: (0, $iE4MZ.DIALOG_CONFIG)
    });
}

});
parcelRegister("iE4MZ", function(module, exports) {

$parcel$export(module.exports, "DIALOG_CONFIG", () => $5869dc39adf4e363$export$3b6761b6086f6dfd);
const $5869dc39adf4e363$export$3b6761b6086f6dfd = {
    touchpointIntent: 'addPaymentDetails',
    dialogId: 'standard-add-payment',
    dialogType: 'modal'
};

});

parcelRegister("lBST2", function(module, exports) {

$parcel$export(module.exports, "entryPoint", () => $ba851635c0cfe322$export$6333901e831d7af0);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

var $7xG2s = parcelRequire("7xG2s");

const $ba851635c0cfe322$export$6333901e831d7af0 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("jrVEF")), {
        moduleId: "78a8c46f",
        moduleId: 'edition-awareness-standard-add-payment-modal'
    }),
    getPreloadProps: ({ cloudId: cloudId, hamsProductKey: hamsProductKey, projectType: projectType, chargeElement: chargeElement, jiraApplicationKey: jiraApplicationKey, isJira: isJira, isConfluence: isConfluence })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                tenantContexts: {
                    parameters: $7xG2s.default,
                    variables: {
                        cloudId: cloudId,
                        hamsProductKey: hamsProductKey,
                        chargeElement: chargeElement,
                        projectType: projectType,
                        jiraApplicationKey: jiraApplicationKey,
                        isJira: isJira,
                        isConfluence: isConfluence
                    }
                }
            }
        })
});

});
parcelRegister("7xG2s", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e475aeb5a6ade9f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f91fe950309252812e4764bd0564d139>>
 * @relayHash 2760406d0a0693b7629d65fc2d92c0b5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4fef9b760e15b6a666a32cb68a539a781cabed54b4f404bda221856bc0bcce5d

var $eiowN = parcelRequire("eiowN");
const $2e475aeb5a6ade9f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "chargeElement"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hamsProductKey"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isConfluence"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isJira"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jiraApplicationKey"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectType"
    }, v7 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v8 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v9 = {
        "args": [
            {
                "kind": "Variable",
                "name": "chargeElement",
                "variableName": "chargeElement"
            }
        ],
        "kind": "ScalarField",
        "name": "latestUsageForChargeElement"
    }, v10 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v11 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v12 = {
        "condition": "isConfluence",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    v10 /*: any*/ ,
                    {
                        "kind": "Literal",
                        "name": "cql",
                        "value": "type=user"
                    },
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 100
                    }
                ],
                "concreteType": "ConfluenceSearchConnection",
                "kind": "LinkedField",
                "name": "confluence_searchUser",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "ConfluenceSearchResponse",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "ConfluencePerson",
                                "kind": "LinkedField",
                                "name": "confluencePerson",
                                "plural": false,
                                "selections": [
                                    v11 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "displayName"
                                    },
                                    {
                                        "concreteType": "Icon",
                                        "kind": "LinkedField",
                                        "name": "profilePicture",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "path"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "concreteType": "ConfluenceStorage",
                "kind": "LinkedField",
                "name": "confluence_storage",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isUnlimited"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "bytesUsed"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "bytesLimit"
                    }
                ]
            }
        ]
    }, v13 = [
        {
            "kind": "Variable",
            "name": "applicationKey",
            "variableName": "jiraApplicationKey"
        },
        v10 /*: any*/ 
    ], v14 = {
        "args": v13 /*: any*/ ,
        "kind": "ScalarField",
        "name": "attachmentStorageAllowed"
    }, v15 = {
        "args": v13 /*: any*/ ,
        "kind": "ScalarField",
        "name": "attachmentStorageUsed"
    }, v16 = {
        "args": v13 /*: any*/ ,
        "kind": "ScalarField",
        "name": "attachmentStorageIsUnlimited"
    }, v17 = [
        v10 /*: any*/ ,
        {
            "fields": [
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "types.0",
                            "variableName": "projectType"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "types"
                }
            ],
            "kind": "ObjectValue",
            "name": "filter"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        }
    ], v18 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        }
    ], v19 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v20 = {
        "kind": "ScalarField",
        "name": "name"
    }, v21 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v22 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "standardAddPaymentModalEditionAwarenessQuery",
            "selections": [
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v8 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v12 /*: any*/ ,
                {
                    "condition": "isJira",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                {
                                    "args": v17 /*: any*/ ,
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "allJiraProjects",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "args": v18 /*: any*/ ,
                                                            "concreteType": "JiraAssignableUsersConnection",
                                                            "kind": "LinkedField",
                                                            "name": "assignableUsers",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraAssignableUsersEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v11 /*: any*/ ,
                                                                                v19 /*: any*/ ,
                                                                                v20 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "assignableUsers(first:10)"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "standardAddPaymentModalEditionAwarenessQuery",
            "selections": [
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v8 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v21 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v21 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v22 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v12 /*: any*/ ,
                {
                    "condition": "isJira",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                {
                                    "args": v17 /*: any*/ ,
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "allJiraProjects",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "args": v18 /*: any*/ ,
                                                            "concreteType": "JiraAssignableUsersConnection",
                                                            "kind": "LinkedField",
                                                            "name": "assignableUsers",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraAssignableUsersEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v21 /*: any*/ ,
                                                                                v11 /*: any*/ ,
                                                                                v19 /*: any*/ ,
                                                                                v20 /*: any*/ ,
                                                                                v22 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "assignableUsers(first:10)"
                                                        },
                                                        v22 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4fef9b760e15b6a666a32cb68a539a781cabed54b4f404bda221856bc0bcce5d",
            "metadata": {},
            "name": "standardAddPaymentModalEditionAwarenessQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$2e475aeb5a6ade9f$var$node.hash = "13491768eabb8f434054187792559cb6";
(0, $eiowN.PreloadableQueryRegistry).set($2e475aeb5a6ade9f$var$node.params.id, $2e475aeb5a6ade9f$var$node);
var $2e475aeb5a6ade9f$export$2e2bcd8739ae039 = $2e475aeb5a6ade9f$var$node;

});

parcelRegister("jrVEF", function(module, exports) {

let $e28d43041da0b8ff$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e28d43041da0b8ff$var$load("itRXp").then(()=>parcelRequire('g06Y9'));

});



parcelRegister("70SOi", function(module, exports) {

$parcel$export(module.exports, "StandardTrialLimitBreakersDialog", () => $a75bb0018d8c9fca$export$ca1bfac58e190135);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3FEPM = parcelRequire("3FEPM");

var $eDHw9 = parcelRequire("eDHw9");

var $iENAf = parcelRequire("iENAf");

var $4olyx = parcelRequire("4olyx");

var $8XFbn = parcelRequire("8XFbn");

var $fqeRg = parcelRequire("fqeRg");

var $nFmXe = parcelRequire("nFmXe");

var $dFJHz = parcelRequire("dFJHz");
function $a75bb0018d8c9fca$export$ca1bfac58e190135() {
    const { product: product, cloudId: cloudId } = (0, $3FEPM.useEditionAwareness)();
    const jiraApplicationKey = (0, $iENAf.getJiraApplicationKey)(product);
    const projectType = (0, $4olyx.getJiraProjectTypeKey)(product);
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            hamsProductKey: (0, $8XFbn.getHamsKey)(product),
            chargeElement: (0, $eDHw9.getChargeElementKey)(product),
            jiraApplicationKey: jiraApplicationKey ?? 'JIRA_SOFTWARE',
            projectType: projectType ?? 'SOFTWARE',
            shouldIncludeIfProductIsConfluence: product === 'confluence',
            shouldIncludeIfProductIsJiraSoftware: product === 'jira'
        }), [
        cloudId,
        product,
        projectType,
        jiraApplicationKey
    ]);
    const modalProps = (0, $5uXOq.useMemo)(()=>({
            width: 'x-large',
            autoFocus: false
        }), []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fqeRg.ModalEntryPoint), {
        entryPoint: (0, $dFJHz.entryPoint),
        entryPointParams: entryPointParams,
        modalProps: modalProps,
        dialogConfig: (0, $nFmXe.DIALOG_CONFIG)
    });
}

});
parcelRegister("nFmXe", function(module, exports) {

$parcel$export(module.exports, "DIALOG_CONFIG", () => $602ce1708c3fd603$export$3b6761b6086f6dfd);
const $602ce1708c3fd603$export$3b6761b6086f6dfd = {
    touchpointIntent: 'addPaymentDetails',
    dialogId: 'standard-trial-limit-breakers-modal',
    dialogType: 'modal'
};

});

parcelRegister("dFJHz", function(module, exports) {

$parcel$export(module.exports, "entryPoint", () => $a96ee1e53514afa0$export$6333901e831d7af0);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

var $9Kyzz = parcelRequire("9Kyzz");

const $a96ee1e53514afa0$export$6333901e831d7af0 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("KAUTd")), {
        moduleId: "ee84d4bb",
        moduleId: 'edition-awareness-standard-trial-limit-breakers-dialog'
    }),
    getPreloadProps: ({ cloudId: cloudId, jiraApplicationKey: jiraApplicationKey, projectType: projectType, shouldIncludeIfProductIsConfluence: shouldIncludeIfProductIsConfluence, shouldIncludeIfProductIsJiraSoftware: shouldIncludeIfProductIsJiraSoftware })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                tenantContexts: {
                    parameters: $9Kyzz.default,
                    variables: {
                        cloudId: cloudId,
                        jiraApplicationKey: jiraApplicationKey,
                        projectType: projectType,
                        shouldIncludeIfProductIsConfluence: shouldIncludeIfProductIsConfluence,
                        shouldIncludeIfProductIsJiraSoftware: shouldIncludeIfProductIsJiraSoftware
                    }
                }
            }
        })
});

});
parcelRegister("9Kyzz", function(module, exports) {

$parcel$export(module.exports, "default", () => $1784bd9d01683f8c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0c64952d57f1612b0b1478425c044dfa>>
 * @relayHash 23da067bdd715329f343ed959e89a964
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d6395fbe1c4fad28485fcf9af8bb24ab6aa8a80b64cca78d36aa60530bcd7412

var $eiowN = parcelRequire("eiowN");
const $1784bd9d01683f8c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "jiraApplicationKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectType"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldIncludeIfProductIsConfluence"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldIncludeIfProductIsJiraSoftware"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "applicationKey",
            "variableName": "jiraApplicationKey"
        },
        v1 /*: any*/ 
    ], v4 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "dialogStandardTrialLimitBreakersQuery",
            "selections": [
                {
                    "args": [
                        v1 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "jiraApplicationKey",
                            "variableName": "jiraApplicationKey"
                        },
                        {
                            "kind": "Variable",
                            "name": "projectType",
                            "variableName": "projectType"
                        },
                        {
                            "kind": "Variable",
                            "name": "shouldIncludeIfProductIsConfluence",
                            "variableName": "shouldIncludeIfProductIsConfluence"
                        },
                        {
                            "kind": "Variable",
                            "name": "shouldIncludeIfProductIsJiraSoftware",
                            "variableName": "shouldIncludeIfProductIsJiraSoftware"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "limitBreakersModal_AtlassianEditionAwareness"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "dialogStandardTrialLimitBreakersQuery",
            "selections": [
                {
                    "condition": "shouldIncludeIfProductIsConfluence",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                v1 /*: any*/ 
                            ],
                            "concreteType": "ConfluenceStorage",
                            "kind": "LinkedField",
                            "name": "confluence_storage",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isUnlimited"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "bytesLimit"
                                }
                            ]
                        },
                        {
                            "args": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "cql",
                                    "value": "type=user"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 200
                                }
                            ],
                            "concreteType": "ConfluenceSearchConnection",
                            "kind": "LinkedField",
                            "name": "confluence_searchUser",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ConfluenceSearchResponse",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "ConfluencePerson",
                                            "kind": "LinkedField",
                                            "name": "confluencePerson",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "displayName"
                                                },
                                                {
                                                    "concreteType": "Icon",
                                                    "kind": "LinkedField",
                                                    "name": "profilePicture",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "path"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "shouldIncludeIfProductIsJiraSoftware",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v3 /*: any*/ ,
                                    "kind": "ScalarField",
                                    "name": "attachmentStorageAllowed"
                                },
                                {
                                    "args": v3 /*: any*/ ,
                                    "kind": "ScalarField",
                                    "name": "attachmentStorageIsUnlimited"
                                },
                                {
                                    "args": [
                                        v1 /*: any*/ ,
                                        {
                                            "fields": [
                                                {
                                                    "items": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "types.0",
                                                            "variableName": "projectType"
                                                        }
                                                    ],
                                                    "kind": "ListValue",
                                                    "name": "types"
                                                }
                                            ],
                                            "kind": "ObjectValue",
                                            "name": "filter"
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 10
                                        }
                                    ],
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "allJiraProjects",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "first",
                                                                    "value": 20
                                                                }
                                                            ],
                                                            "concreteType": "JiraAssignableUsersConnection",
                                                            "kind": "LinkedField",
                                                            "name": "assignableUsers",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraAssignableUsersEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "__typename"
                                                                                },
                                                                                v2 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "name"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "picture"
                                                                                },
                                                                                v4 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "assignableUsers(first:20)"
                                                        },
                                                        v4 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d6395fbe1c4fad28485fcf9af8bb24ab6aa8a80b64cca78d36aa60530bcd7412",
            "metadata": {},
            "name": "dialogStandardTrialLimitBreakersQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$1784bd9d01683f8c$var$node.hash = "c0a85cbfe1a8730ecb9b9eb0454e24d0";
(0, $eiowN.PreloadableQueryRegistry).set($1784bd9d01683f8c$var$node.params.id, $1784bd9d01683f8c$var$node);
var $1784bd9d01683f8c$export$2e2bcd8739ae039 = $1784bd9d01683f8c$var$node;

});

parcelRegister("KAUTd", function(module, exports) {

let $08c0eedad74cf448$var$load = (parcelRequire("28QjX"))(4);
module.exports = $08c0eedad74cf448$var$load("9ofk6").then(()=>parcelRequire('9pMX2'));

});





parcelRegister("2VfNT", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $17101b2a8b1e705a$export$e926676385687eaf);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $f4cXA = parcelRequire("f4cXA");

var $1tcYS = parcelRequire("1tcYS");

var $bFU4G = parcelRequire("bFU4G");

var $gLHhx = parcelRequire("gLHhx");
const $17101b2a8b1e705a$export$e926676385687eaf = ({ children: children, product: product, edition: edition, id: id })=>{
    const handleOnError = (0, $gLHhx.useErrorAnalytics)({
        product: product,
        edition: edition,
        id: id
    });
    const ufoContext = (0, $1tcYS.useInteractionContext)();
    const onError = (0, $5uXOq.useCallback)((error)=>{
        const interaction = (0, $bFU4G.getActiveInteraction)();
        handleOnError(error);
        if (interaction && ufoContext) (0, $bFU4G.addError)(interaction?.id, error.name, ufoContext?.labelStack, 'interaction error', error.message, error.stack);
        else (0, $bFU4G.addErrorToAll)(`ErrorBoundary:${id}`, ufoContext?.labelStack || null, 'interaction error', error.message);
    }, [
        handleOnError,
        id,
        ufoContext
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f4cXA.ErrorBoundary), {
        onError: onError,
        fallback: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {}),
        children: children
    });
};

});
parcelRegister("gLHhx", function(module, exports) {

$parcel$export(module.exports, "useErrorAnalytics", () => $1ccc13a3ba7b3e4a$export$e2d4523bbccd2343);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $fK9DC = parcelRequire("fK9DC");
/**
 * This hook is designed to be used before contexts are initialized to avoid circular dependencies.
 */ function $1ccc13a3ba7b3e4a$var$useOperationalFailureAnalytics({ product: product, edition: edition }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return (0, $5uXOq.useCallback)((attributes)=>{
        const event = createAnalyticsEvent({
            eventType: 'operational',
            action: 'failed',
            actionSubject: '@atlassian/edition-awareness.edition-awareness',
            attributes: {
                ...(0, $fK9DC.defaultAttributes),
                product: product,
                currentProductEdition: edition,
                ...attributes
            }
        });
        const contextAttributes = (0, $fK9DC.getAttributesFromContexts)(event.context);
        event.update({
            attributes: {
                ...contextAttributes,
                ...event.payload.attributes
            }
        }).fire((0, $fK9DC.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        product,
        edition
    ]);
}
/**
 * These are errors which we ignore from SLO reporting to ensure we reporting on errors we can action
 */ const $1ccc13a3ba7b3e4a$var$nonSLOErrors = [
    /**
	 * These occur when the fetch request fails (usually this is because the users network is offline)
	 *
	 * This is usually thrown from inside of the products fetch handler
	 * e.g. jira/src/packages/platform/utils/fetch/src/utils/requests.tsx adds the handler which throws this error to every fetch request
	 */ /failed to fetch/i,
    /**
	 * These occur when the fetch request fails due to a server response (e.g. 401 due to the user needing to reauthenticate their session)
	 * e.g. jira/src/packages/platform/utils/fetch/src/utils/requests.tsx adds the handler which throws server errors after parsing the response headers
	 */ /Error server response:/i
];
function $1ccc13a3ba7b3e4a$var$isSLOError(error) {
    // Just checks that none of our non slo errors match the error
    return !$1ccc13a3ba7b3e4a$var$nonSLOErrors.some((msg)=>msg.test(error.message));
}
function $1ccc13a3ba7b3e4a$export$e2d4523bbccd2343({ product: product, edition: edition, id: id }) {
    const sendOperationalFailure = $1ccc13a3ba7b3e4a$var$useOperationalFailureAnalytics({
        product: product,
        edition: edition
    });
    return (0, $5uXOq.useCallback)((error)=>{
        sendOperationalFailure({
            error: error.message,
            errorStack: error.stack,
            errorName: error.name,
            id: id ?? 'unknownErrorId',
            isSLOError: $1ccc13a3ba7b3e4a$var$isSLOError(error)
        });
    }, [
        sendOperationalFailure,
        id
    ]);
}
function $1ccc13a3ba7b3e4a$export$45aafd752da9ba22({ product: product, edition: edition }) {
    const sendOperationalFailure = $1ccc13a3ba7b3e4a$var$useOperationalFailureAnalytics({
        product: product,
        edition: edition
    });
    return (0, $5uXOq.useCallback)((dataValidationError)=>{
        sendOperationalFailure({
            dataValidationError: dataValidationError,
            id: 'dataValidationError'
        });
    }, [
        sendOperationalFailure
    ]);
}

});


parcelRegister("gsZRM", function(module, exports) {

$parcel$export(module.exports, "Spotlight", () => $f936fed46fee814e$export$1033c28b5e1c2deb);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $7gs1W = parcelRequire("7gs1W");
var $1QiBP = parcelRequire("1QiBP");

var $3FEPM = parcelRequire("3FEPM");

var $9o45M = parcelRequire("9o45M");
function $f936fed46fee814e$export$1033c28b5e1c2deb() {
    const context = (0, $3FEPM.useEditionAwareness)();
    const { product: product, isSpotlightActive: isSpotlightActive, handleSetSpotlight: handleSetSpotlight } = context;
    const handleDismissSpotlight = (0, $5uXOq.useCallback)(()=>{
        handleSetSpotlight?.(false);
    }, [
        handleSetSpotlight
    ]);
    if ((0, $9o45M.isEligibleForStandardToPremium)(context)) {
        const target = product === 'confluence' ? 'nav-profile' : 'profile-spotlight';
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1QiBP.default), {
            children: isSpotlightActive && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7gs1W.default), {
                actions: [
                    {
                        onClick: handleDismissSpotlight,
                        text: 'Got it'
                    }
                ],
                target: target,
                targetRadius: 3,
                dialogWidth: 275,
                targetBgColor: "var(--ds-elevation-surface-current, #FFFFFF)",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    id: "@atlassian/edition-awareness.spotlight.message",
                    defaultMessage: "Not ready to upgrade? Return to your profile when you're ready.",
                    description: "Message to show in the spotlight on the profile menu icon when the user dismisses the EA pill and is eligible for standard to premium upsell"
                })
            }, target)
        });
    }
    return null;
}

});


parcelRegister("ksvM4", function(module, exports) {

$parcel$export(module.exports, "EditionAwarenessUpsell", () => $a619047c1df66de2$export$148b30c5d238daaa);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $daJ0i = parcelRequire("daJ0i");

var $iEN9D = parcelRequire("iEN9D");

var $8Ec39 = parcelRequire("8Ec39");

var $e2pRJ = parcelRequire("e2pRJ");

var $fLNQI = parcelRequire("fLNQI");

var $3FEPM = parcelRequire("3FEPM");

var $RKWjF = parcelRequire("RKWjF");

var $9o45M = parcelRequire("9o45M");

var $4o6si = parcelRequire("4o6si");

var $aH4Ca = parcelRequire("aH4Ca");

var $2VfNT = parcelRequire("2VfNT");

var $gsZRM = parcelRequire("gsZRM");
/**
 * Edition awareness upsell is an experimental EA implementtiona that has to be exported as its own component to avoid making ccp calls which are alerting VC90 mertics
 *
 * This component deals with creating the context which is then used throughout the package to:
 * - Track analytics
 * - Know which product/edition/cloud id is being used
 * - Know when to show/hide the button
 */ function $a619047c1df66de2$var$EditionAwarenessUpsellImpl({ edition: edition, product: product, cloudId: cloudId, userRoles: userRoles, hasDismissedButton: hasDismissedButton, onDismissButton: onDismissButton, navVersion: navVersion }) {
    const { isSpotlightActive: isSpotlightActive, handleSetSpotlight: handleSetSpotlight } = (0, $4o6si.useSpotlight)();
    const trialOfferingName = (0, $RKWjF.getTrialOfferingName)(product, edition);
    const context = (0, $5uXOq.useMemo)(()=>{
        return {
            cloudId: cloudId,
            product: product,
            edition: edition,
            userRoles: userRoles,
            hasDismissedButton: hasDismissedButton,
            onDismissButton: onDismissButton,
            isSpotlightActive: isSpotlightActive,
            handleSetSpotlight: handleSetSpotlight,
            trialOfferingName: trialOfferingName
        };
    }, [
        cloudId,
        product,
        edition,
        userRoles,
        hasDismissedButton,
        onDismissButton,
        isSpotlightActive,
        handleSetSpotlight,
        trialOfferingName
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3FEPM.EditionAwarenessContext).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $daJ0i.default), {
            data: {
                navVersion: navVersion
            },
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)($a619047c1df66de2$var$StandardEdition, {}),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gsZRM.Spotlight), {})
            ]
        })
    });
}
function $a619047c1df66de2$export$148b30c5d238daaa(props) {
    const { product: product, edition: edition } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e2pRJ.RelayEnvironmentProvider), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8Ec39.default), {
            name: "edition-awareness-upsell",
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2VfNT.ErrorBoundary), {
                product: product,
                edition: edition,
                id: "edition-awareness-upsell",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                    fallback: null,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)($a619047c1df66de2$var$EditionAwarenessUpsellImpl, {
                        ...props
                    })
                })
            })
        })
    });
}
function $a619047c1df66de2$var$StandardEdition() {
    const context = (0, $3FEPM.useEditionAwareness)();
    const { product: product, hasDismissedButton: hasDismissedButton } = context;
    if ((0, $9o45M.isEligibleForStandardToPremium)(context) && !hasDismissedButton) {
        const experimentKey = product === 'confluence' ? 'edition_awareness_standard_upsell_confluence_ab' : 'edition_awareness_upsell_jira_ab';
        const cohort = (0, $iEN9D.default).getExperimentValue(experimentKey, 'cohort', 'not-enrolled');
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
            children: [
                cohort === 'control' && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fLNQI.FeatureExposedAnalytics), {
                    flagKey: experimentKey,
                    cohort: cohort
                }),
                cohort === 'treatment' && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fLNQI.FeatureExposedAnalytics), {
                    flagKey: experimentKey,
                    cohort: cohort,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aH4Ca.StandardToPremiumDialog), {})
                })
            ]
        });
    }
    return null;
}

});
parcelRegister("RKWjF", function(module, exports) {

$parcel$export(module.exports, "getTrialOfferingName", () => $9022767753f2cb24$export$38ffae8c634274ba);

var $VSDnB = parcelRequire("VSDnB");
const $9022767753f2cb24$export$38ffae8c634274ba = (product, edition)=>{
    if (edition === 'standard') {
        if (product === 'jira' && (0, $VSDnB.fg)('edition_awareness_upsell_jira_fg')) return 'premium';
        if (product === 'jira-service-management' && (0, $VSDnB.fg)('edition_awareness_upsell_jsm_fg')) return 'premium';
        if (product === 'confluence' && (0, $VSDnB.fg)('edition_awareness_standard_upsell_confluence_ab_fg')) return 'premium';
    }
    return 'standard';
};

});

parcelRegister("aH4Ca", function(module, exports) {

$parcel$export(module.exports, "StandardToPremiumDialog", () => $18360df6fea73531$export$67151f73e55c3a51);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $79ZRb = parcelRequire("79ZRb");

var $3FEPM = parcelRequire("3FEPM");

var $8XFbn = parcelRequire("8XFbn");

var $giRpK = parcelRequire("giRpK");

var $aAbok = parcelRequire("aAbok");

var $hUlWX = parcelRequire("hUlWX");
function $18360df6fea73531$export$67151f73e55c3a51() {
    const { product: product, cloudId: cloudId } = (0, $3FEPM.useEditionAwareness)();
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            hamsProductKey: (0, $8XFbn.getHamsKey)(product)
        }), [
        cloudId,
        product
    ]);
    const onClose = (0, $79ZRb.useOnDismissDialog)({
        ...(0, $aAbok.DIALOG_CONFIG)
    });
    const entryPointProps = (0, $5uXOq.useMemo)(()=>({
            onClose: onClose
        }), [
        onClose
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $giRpK.DismissibleModalEntryPoint), {
        entryPoint: (0, $hUlWX.entryPoint),
        entryPointProps: entryPointProps,
        entryPointParams: entryPointParams,
        dialogConfig: (0, $aAbok.DIALOG_CONFIG)
    });
}

});
parcelRegister("giRpK", function(module, exports) {

$parcel$export(module.exports, "DismissibleModalEntryPoint", () => $43925d55c39183ba$export$3362d3660491ee6d);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $kgoHi = parcelRequire("kgoHi");

var $iNb86 = parcelRequire("iNb86");

var $fqeRg = parcelRequire("fqeRg");
function $43925d55c39183ba$export$3362d3660491ee6d(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $kgoHi.default), {
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fqeRg.ModalEntryPoint), {
                ...props
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iNb86.DismissMenu), {})
        ]
    });
}

});
parcelRegister("iNb86", function(module, exports) {

$parcel$export(module.exports, "DismissMenu", () => $52e1e788eba4639e$export$6c8332cc6beadf8a);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $8U6zd = parcelRequire("8U6zd");

var $e4yMr = parcelRequire("e4yMr");

var $dC5iT = parcelRequire("dC5iT");
var $5ILhZ = parcelRequire("5ILhZ");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $bdFM8 = parcelRequire("bdFM8");
var $cWTTi = parcelRequire("cWTTi");
var $iB3Ak = parcelRequire("iB3Ak");
var $G85VY = parcelRequire("G85VY");

var $UsPWm = parcelRequire("UsPWm");

var $3FEPM = parcelRequire("3FEPM");

var $RKWjF = parcelRequire("RKWjF");
const $52e1e788eba4639e$var$dismissMenuStyles = (0, $8CUq3.xcss)({
    borderWidth: 'border.width',
    font: 'font.body',
    fontWeight: 'font.weight.medium',
    borderStyle: 'solid',
    backgroundColor: 'elevation.surface',
    borderRadius: 'border.radius.100',
    paddingInline: 'space.100',
    paddingBlock: '0',
    minHeight: '32px',
    color: 'color.text',
    transitionProperty: 'color, background-color',
    transitionDuration: '200ms',
    display: 'flex',
    gap: 'space.100',
    alignItems: 'center',
    textDecoration: 'none',
    borderColor: 'color.border.discovery',
    borderLeftWidth: '0',
    borderTopLeftRadius: '0',
    borderBottomLeftRadius: '0',
    ':hover': {
        backgroundColor: 'color.background.accent.purple.subtlest.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.accent.purple.subtlest.pressed'
    }
});
const $52e1e788eba4639e$var$reasonsUlStyles = (0, $8CUq3.xcss)({
    marginTop: '0',
    marginLeft: 'space.200',
    paddingLeft: 'space.100'
});
const $52e1e788eba4639e$var$capitalizeName = (name)=>name.charAt(0).toUpperCase() + name.slice(1);
function $52e1e788eba4639e$export$6c8332cc6beadf8a() {
    const fireDismissMenuEvent = (0, $UsPWm.useOnClickDismissMenu)();
    const { product: product, edition: edition, onDismissButton: onDismissButton, handleSetSpotlight: handleSetSpotlight } = (0, $3FEPM.useEditionAwareness)();
    const trialOfferingName = (0, $RKWjF.getTrialOfferingName)(product, edition);
    const handleOnEvents = (0, $5uXOq.useCallback)((e)=>{
        if (e.type === 'DISMISS_SUCCEEDED' && onDismissButton) {
            onDismissButton();
            fireDismissMenuEvent('dismiss');
            handleSetSpotlight?.(true);
        }
        if (e.type === 'AD_CONTROL_DROP_DOWN_MENU_OPENED') fireDismissMenuEvent('openMenu');
        if (e.type === 'REASONS_BUTTON_CLICKED') fireDismissMenuEvent('learnMore');
    }, [
        onDismissButton,
        handleSetSpotlight,
        fireDismissMenuEvent
    ]);
    const getAdControlsTrigger = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5ILhZ.default), {
            ...props,
            ref: triggerRef,
            xcss: [
                $52e1e788eba4639e$var$dismissMenuStyles
            ],
            "aria-label": "More",
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8U6zd))), {
                label: "",
                spacing: "none",
                color: "var(--ds-icon-subtlest, #626F86)"
            })
        }), []);
    const offering = /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $cgL5K.default), {
        weight: "bold",
        children: [
            $52e1e788eba4639e$var$capitalizeName(product),
            " ",
            $52e1e788eba4639e$var$capitalizeName(trialOfferingName)
        ]
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cWTTi.default), {
        onEvents: (e)=>handleOnEvents(e),
        shouldShowDismissFlag: false,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bdFM8.default), {
            itemId: "default-item",
            trigger: getAdControlsTrigger,
            children: (props)=>/*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iB3Ak.default), {
                            ...props,
                            children: "Dismiss"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $G85VY.default), {
                            ...props,
                            modalProps: {
                                body: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $luBm6.default), {
                                    space: "space.150",
                                    children: [
                                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                                id: "@atlassian/edition-awareness.edition-awareness-dismiss-button.why-am-i-seeing-this",
                                                defaultMessage: "We think {offering} will improve your team's productivity. This recommendation is only shown to billing admins and is based on:",
                                                description: "A message that informs the user why they are seeing the current plan recommendation for their current product",
                                                values: {
                                                    offering: offering
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $luBm6.default), {
                                            as: "ul",
                                            xcss: $52e1e788eba4639e$var$reasonsUlStyles,
                                            children: [
                                                /*#__PURE__*/ (0, $2OMIu.jsx)("li", {
                                                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                                        id: "@atlassian/edition-awareness.edition-awareness-dismiss-button.reason-1",
                                                        defaultMessage: "the size of your team",
                                                        description: "A reason why the user is seeing the current plan recommendation"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $2OMIu.jsx)("li", {
                                                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                                        id: "@atlassian/edition-awareness.edition-awareness-dismiss-button.reason-2",
                                                        defaultMessage: "your existing Atlassian products",
                                                        description: "A reason why the user is seeing the current plan recommendation"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e4yMr.default), {
                                                appearance: "default",
                                                href: "https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers",
                                                target: "_blank",
                                                onClick: ()=>fireDismissMenuEvent('clickLink'),
                                                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                                    id: "@atlassian/edition-awareness.edition-awareness-dismiss-button.data-privacy.link",
                                                    defaultMessage: "Learn more about your data privacy with Atlassian",
                                                    description: "Link to Atlassian data privacy page"
                                                })
                                            })
                                        })
                                    ]
                                })
                            }
                        })
                    ]
                })
        })
    });
}

});
parcelRegister("bdFM8", function(module, exports) {

$parcel$export(module.exports, "default", () => $f01fbcffdc310c8b$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $BLPHT = parcelRequire("BLPHT");
var $aRoVz = parcelRequire("aRoVz");


var $2oDNf = parcelRequire("2oDNf");

var $7PL8F = parcelRequire("7PL8F");
const $f01fbcffdc310c8b$var$interactedUIEventAction = {
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'adControlsDropdown'
};
const $f01fbcffdc310c8b$var$AdControlDropdownMenu = ({ children: children, itemId: itemId, onOpenChange: onOpenChange = ()=>{}, ...rest })=>{
    const { createInteractedUIEvent: createInteractedUIEvent } = (0, $2oDNf.default)();
    const { createEventDispatcher: createEventDispatcher } = (0, $7PL8F.useAdControlProvider)();
    const eventDispatcher = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>createEventDispatcher(itemId), [
        createEventDispatcher,
        itemId
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $BLPHT.default), {
        ...rest,
        onOpenChange: (onOpenChangeArgs)=>{
            eventDispatcher.dispatch(onOpenChangeArgs.isOpen ? (0, $31d75b4fe1b5774a$export$17ff257e1f6e39f5) : (0, $31d75b4fe1b5774a$export$7fc09cf740f33ed4), createInteractedUIEvent($f01fbcffdc310c8b$var$interactedUIEventAction));
            onOpenChange(onOpenChangeArgs);
        },
        shouldFitContainer: false,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aRoVz.default), {
            children: typeof children === 'function' ? children({
                itemId: itemId
            }) : children
        })
    });
};
var $f01fbcffdc310c8b$export$2e2bcd8739ae039 = $f01fbcffdc310c8b$var$AdControlDropdownMenu;

});
// ACT Event types
// AdControlDropdownMenu
const $31d75b4fe1b5774a$export$17ff257e1f6e39f5 = 'AD_CONTROL_DROP_DOWN_MENU_OPENED';
const $31d75b4fe1b5774a$export$7fc09cf740f33ed4 = 'AD_CONTROL_DROP_DOWN_MENU_CLOSED';
const $31d75b4fe1b5774a$export$e33200507ac1d20a = 'DISMISS_STARTED';
const $31d75b4fe1b5774a$export$103f41d1f3bf374e = 'DISMISS_SUCCEEDED';
const $31d75b4fe1b5774a$export$6d3088110036f124 = 'DISMISS_FAILED';
const $31d75b4fe1b5774a$export$5595c6967e83d351 = 'REASONS_BUTTON_CLICKED';
const $31d75b4fe1b5774a$export$ff50ad60f08a4bc0 = 'REASONS_MODAL_SHOWN';
const $31d75b4fe1b5774a$export$6bd2d8eacca15ce1 = 'REASONS_MODAL_DISMISSED';
const $31d75b4fe1b5774a$export$5c5fc6956b7600ea = 'FLAG_DISMISSED';

parcelRegister("2oDNf", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d2cae71ad56ba41$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");


var $2NMNM = parcelRequire("2NMNM");
function $5d2cae71ad56ba41$export$2e2bcd8739ae039() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const createInteractedUIEvent = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((action)=>createAnalyticsEvent({
            eventType: (0, $676c5e519aa5ba55$export$a1562d08625f5d7e),
            ...action
        }), [
        createAnalyticsEvent
    ]);
    const createScreenUIEvent = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((name)=>createAnalyticsEvent({
            eventType: (0, $676c5e519aa5ba55$export$f1d537d508d2945a),
            name: name
        }), [
        createAnalyticsEvent
    ]);
    return {
        createInteractedUIEvent: createInteractedUIEvent,
        createScreenUIEvent: createScreenUIEvent
    };
}

});

parcelRegister("7PL8F", function(module, exports) {

$parcel$export(module.exports, "useAdControlProvider", () => $0ed4b49fdaa1ff5b$export$450072b04d50916);

var $5uXOq = parcelRequire("5uXOq");


var $lxmOh = parcelRequire("lxmOh");

var $3bxlB = parcelRequire("3bxlB");
function $0ed4b49fdaa1ff5b$export$450072b04d50916() {
    const { state: state, modalPropsRef: modalPropsRef, dispatch: dispatch, onEvents: onEvents, shouldShowDismissFlag: shouldShowDismissFlag } = (0, $3bxlB.useAdControlContext)();
    /**
	 * Add a flag with flagProps to state for the item was dismissed
	 * {@link https://atlassian.design/components/flag/examples}
	 */ const addFlag = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((itemId, flagProps)=>{
        dispatch({
            type: 'ADD_FLAG',
            payload: {
                itemId: itemId,
                flagProps: flagProps
            }
        });
    }, [
        dispatch
    ]);
    /**
	 * Open a modal and set the modal props reference
	 */ const openModal = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((modalProps, modalItemId)=>{
        modalPropsRef.current = modalProps;
        dispatch({
            type: 'OPEN_MODAL',
            payload: modalItemId
        });
    }, [
        dispatch,
        modalPropsRef
    ]);
    /**
	 * Close a modal and clear the modal props reference
	 */ const closeModal = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback(()=>{
        modalPropsRef.current = undefined;
        dispatch({
            type: 'CLOSE_MODAL'
        });
    }, [
        dispatch,
        modalPropsRef
    ]);
    /**
	 * The internal event handler that is used by the ACTEventDispatcher
	 */ const handleOnEvents = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((event)=>{
        // Handle the events that have side effects on the state.
        switch(event.type){
            case 0, $31d75b4fe1b5774a$export$5c5fc6956b7600ea:
                dispatch({
                    type: 'REMOVE_FLAG',
                    payload: event.itemId
                });
                break;
        }
        // Call the onEvents handler that is passed from the consumer.
        onEvents(event);
    }, [
        dispatch,
        onEvents
    ]);
    /**
	 * Create an event dispatcher for the given item id
	 */ const createEventDispatcher = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((itemId)=>{
        return new (0, $lxmOh.default)(itemId, handleOnEvents);
    }, [
        handleOnEvents
    ]);
    return {
        state: state,
        openModal: openModal,
        closeModal: closeModal,
        createEventDispatcher: createEventDispatcher,
        addFlag: addFlag,
        shouldShowDismissFlag: shouldShowDismissFlag
    };
}

});
parcelRegister("lxmOh", function(module, exports) {

$parcel$export(module.exports, "default", () => $9dd17db5a3b25b16$export$2e2bcd8739ae039);
class $9dd17db5a3b25b16$export$2e2bcd8739ae039 {
    constructor(itemId, handler){
        this.itemId = itemId;
        this.handler = handler;
    }
    dispatch(type, analyticsEvent) {
        this._dispatch({
            type: type,
            itemId: this.itemId,
            analyticsEvent: analyticsEvent
        });
    }
    dispatchError(type, error) {
        this._dispatch({
            type: type,
            itemId: this.itemId,
            error: error
        });
    }
    _dispatch(event) {
        if (this.handler) this.handler(event);
    }
}

});

parcelRegister("3bxlB", function(module, exports) {

$parcel$export(module.exports, "useAdControlContext", () => $6b83d9125d8db136$export$4e82dc865a56141b);

var $5uXOq = parcelRequire("5uXOq");

var $9a0CE = parcelRequire("9a0CE");
function $6b83d9125d8db136$export$4e82dc865a56141b() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext((0, $9a0CE.AdControlContext));
}

});
parcelRegister("9a0CE", function(module, exports) {

$parcel$export(module.exports, "AdControlContext", () => $6c4d44a0b878cedb$export$554b2f9bd0a293df);

var $5uXOq = parcelRequire("5uXOq");

var $csTpu = parcelRequire("csTpu");
const $6c4d44a0b878cedb$export$554b2f9bd0a293df = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({
    state: {
        ...(0, $csTpu.initialAdControlProviderState)
    },
    modalPropsRef: undefined,
    dispatch: ()=>{},
    onEvents: ()=>{},
    shouldShowDismissFlag: true
});

});
parcelRegister("csTpu", function(module, exports) {

$parcel$export(module.exports, "initialAdControlProviderState", () => $50e18fde0ce055e6$export$22776e7a42f7089d);
$parcel$export(module.exports, "adControlProviderReducer", () => $50e18fde0ce055e6$export$5f3557676ca801eb);
const $50e18fde0ce055e6$export$22776e7a42f7089d = {
    flags: new Map()
};
const $50e18fde0ce055e6$export$5f3557676ca801eb = (state, action)=>{
    switch(action.type){
        case 'ADD_FLAG':
            return {
                ...state,
                flags: new Map(state.flags).set(action.payload.itemId, action.payload.flagProps)
            };
        case 'REMOVE_FLAG':
            {
                // Clone the flags map and delete the flag
                const flags = new Map(state.flags);
                flags.delete(action.payload);
                return {
                    ...state,
                    flags: flags
                };
            }
        case 'OPEN_MODAL':
            return {
                ...state,
                modalItemId: action.payload
            };
        case 'CLOSE_MODAL':
            return {
                ...state,
                modalItemId: undefined
            };
        default:
            return state;
    }
};

});





parcelRegister("cWTTi", function(module, exports) {

$parcel$export(module.exports, "default", () => $caafb1275a9043be$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");

var $9a0CE = parcelRequire("9a0CE");

var $csTpu = parcelRequire("csTpu");

var $eW72t = parcelRequire("eW72t");

var $iWO3E = parcelRequire("iWO3E");

var $3rGmd = parcelRequire("3rGmd");
const $caafb1275a9043be$var$AdControlProvider = ({ children: children, onEvents: onEvents = ()=>{}, shouldShowDismissFlag: shouldShowDismissFlag = true })=>{
    const [state, dispatch] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useReducer((0, $csTpu.adControlProviderReducer), (0, $csTpu.initialAdControlProviderState));
    const modalPropsRef = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef();
    const modalProps = modalPropsRef.current ?? {
        body: '',
        title: ''
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eW72t.default), {
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $9a0CE.AdControlContext).Provider, {
            value: {
                state: state,
                modalPropsRef: modalPropsRef,
                dispatch: dispatch,
                onEvents: onEvents,
                shouldShowDismissFlag: shouldShowDismissFlag
            },
            children: [
                children,
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3rGmd.default), {
                    itemId: state.modalItemId,
                    ...modalProps
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                    fallback: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {}),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iWO3E.default), {})
                })
            ]
        })
    });
};
var $caafb1275a9043be$export$2e2bcd8739ae039 = $caafb1275a9043be$var$AdControlProvider;

});
parcelRegister("eW72t", function(module, exports) {

$parcel$export(module.exports, "default", () => $083a544524683d55$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $96nTn = parcelRequire("96nTn");

var $8FqfZ = parcelRequire("8FqfZ");

var $gP1fu = parcelRequire("gP1fu");
const $083a544524683d55$var$ActIntlProvider = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $96nTn.default), {
        defaultMessages: (0, $gP1fu.default),
        loaderFn: (0, $8FqfZ.fetchMessagesForLocale),
        children: children
    });
};
var $083a544524683d55$export$2e2bcd8739ae039 = $083a544524683d55$var$ActIntlProvider;

});
parcelRegister("8FqfZ", function(module, exports) {

$parcel$export(module.exports, "fetchMessagesForLocale", () => $ba5477c776593cbe$export$2b153a2030b0feb2);

var $55XL5 = parcelRequire("55XL5");

var $gP1fu = parcelRequire("gP1fu");
const $ba5477c776593cbe$var$localeMap = {
    pt: 'pt-BR',
    'pt-PT': 'pt-BR',
    'en-AU': 'en-GB'
};
const $ba5477c776593cbe$export$2b153a2030b0feb2 = async (locale)=>{
    try {
        const targetLocale = ($ba5477c776593cbe$var$localeMap[locale] ?? locale ?? '').replace('-', '_');
        if (targetLocale in (0, $55XL5.locales)) {
            const messages = await (0, $55XL5.locales)[targetLocale]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
    try {
        const parentLocale = locale.split(/[-_]/)[0];
        if (parentLocale in (0, $55XL5.locales)) {
            const messages = await (0, $55XL5.locales)[parentLocale]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
    /**
	 * English bundled by default as this is the majority of users
	 */ return 0, $gP1fu.default;
};

});
parcelRegister("55XL5", function(module, exports) {

$parcel$export(module.exports, "locales", () => $29a4ce0bd59e6338$export$df1c34db1371eeed);


























const $29a4ce0bd59e6338$export$df1c34db1371eeed = {
    cs: ()=>(parcelRequire("6rJdg")),
    da: ()=>(parcelRequire("iEvkU")),
    de: ()=>(parcelRequire("6yZ10")),
    en_GB: ()=>(parcelRequire("ah4Ew")),
    en_ZZ: ()=>(parcelRequire("fvugb")),
    en: ()=>Promise.resolve((parcelRequire("gP1fu"))),
    es: ()=>(parcelRequire("dytK2")),
    fi: ()=>(parcelRequire("cerZY")),
    fr: ()=>(parcelRequire("kjeqX")),
    hu: ()=>(parcelRequire("cNhfk")),
    it: ()=>(parcelRequire("cQlia")),
    ja: ()=>(parcelRequire("5Zdkj")),
    ko: ()=>(parcelRequire("jDh1Y")),
    nb: ()=>(parcelRequire("6PdFI")),
    nl: ()=>(parcelRequire("gVLkY")),
    pl: ()=>(parcelRequire("e9ZAS")),
    pt_BR: ()=>(parcelRequire("dNa0W")),
    ru: ()=>(parcelRequire("2M4RD")),
    sv: ()=>(parcelRequire("6ROqa")),
    th: ()=>(parcelRequire("loHgn")),
    tr: ()=>(parcelRequire("78S04")),
    uk: ()=>(parcelRequire("lbJZY")),
    vi: ()=>(parcelRequire("2BNWj")),
    zh_TW: ()=>(parcelRequire("cIPTd")),
    zh: ()=>(parcelRequire("20fua"))
};

});
parcelRegister("6rJdg", function(module, exports) {

let $4b18560515a1475c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4b18560515a1475c$var$load("5afiz").then(()=>parcelRequire('244Rz'));

});

parcelRegister("iEvkU", function(module, exports) {

let $d944451fe8a3fe37$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d944451fe8a3fe37$var$load("5NG15").then(()=>parcelRequire('byL9G'));

});

parcelRegister("6yZ10", function(module, exports) {

let $4c753f63cbae63ce$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4c753f63cbae63ce$var$load("8Ktoo").then(()=>parcelRequire('iPCdj'));

});

parcelRegister("ah4Ew", function(module, exports) {

let $77af19d4a9f74366$var$load = (parcelRequire("28QjX"))(4);
module.exports = $77af19d4a9f74366$var$load("wZhIp").then(()=>parcelRequire('jTiyz'));

});

parcelRegister("fvugb", function(module, exports) {

let $b4a139406aba4bee$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b4a139406aba4bee$var$load("4tsDS").then(()=>parcelRequire('knTYu'));

});

parcelRegister("dytK2", function(module, exports) {

let $9de58567a633e495$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9de58567a633e495$var$load("j9oSn").then(()=>parcelRequire('4k82d'));

});

parcelRegister("cerZY", function(module, exports) {

let $8e7c82c7081bc08f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8e7c82c7081bc08f$var$load("fOB9Y").then(()=>parcelRequire('48wMp'));

});

parcelRegister("kjeqX", function(module, exports) {

let $ec90c73efd10ff6a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ec90c73efd10ff6a$var$load("6RPKH").then(()=>parcelRequire('fc44T'));

});

parcelRegister("cNhfk", function(module, exports) {

let $9507705e17ed3d5c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9507705e17ed3d5c$var$load("gpgZU").then(()=>parcelRequire('kel6P'));

});

parcelRegister("cQlia", function(module, exports) {

let $959adb84e49fc50d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $959adb84e49fc50d$var$load("lRujw").then(()=>parcelRequire('4zI6N'));

});

parcelRegister("5Zdkj", function(module, exports) {

let $45bcfca6c275b3f5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $45bcfca6c275b3f5$var$load("fJEq7").then(()=>parcelRequire('1JqFz'));

});

parcelRegister("jDh1Y", function(module, exports) {

let $e4aeded0caf82d17$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e4aeded0caf82d17$var$load("PMoQX").then(()=>parcelRequire('h95YY'));

});

parcelRegister("6PdFI", function(module, exports) {

let $4f821c7517c11286$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4f821c7517c11286$var$load("e1ip1").then(()=>parcelRequire('gKNWn'));

});

parcelRegister("gVLkY", function(module, exports) {

let $c536b06b9489faae$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c536b06b9489faae$var$load("lDEAf").then(()=>parcelRequire('e5Htj'));

});

parcelRegister("e9ZAS", function(module, exports) {

let $a4f1af2e8aea71f7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a4f1af2e8aea71f7$var$load("4mNEp").then(()=>parcelRequire('6lCnn'));

});

parcelRegister("dNa0W", function(module, exports) {

let $a0a79e8dc73abd3e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a0a79e8dc73abd3e$var$load("i5Pyj").then(()=>parcelRequire('74uqO'));

});

parcelRegister("2M4RD", function(module, exports) {

let $2053d659c570db1b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2053d659c570db1b$var$load("2QiXa").then(()=>parcelRequire('lI543'));

});

parcelRegister("6ROqa", function(module, exports) {

let $4ffecddf1c885b0a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4ffecddf1c885b0a$var$load("5BkfB").then(()=>parcelRequire('6eQg4'));

});

parcelRegister("loHgn", function(module, exports) {

let $f93d6601af68deb9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f93d6601af68deb9$var$load("ab543").then(()=>parcelRequire('kBjTK'));

});

parcelRegister("78S04", function(module, exports) {

let $53332b0b5cc9368a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $53332b0b5cc9368a$var$load("1pkJr").then(()=>parcelRequire('cEoSm'));

});

parcelRegister("lbJZY", function(module, exports) {

let $f6ce4e6d2da03df6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f6ce4e6d2da03df6$var$load("kvSKH").then(()=>parcelRequire('372Q4'));

});

parcelRegister("2BNWj", function(module, exports) {

let $1e65c66a1fc44d4e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1e65c66a1fc44d4e$var$load("hHwia").then(()=>parcelRequire('chF8B'));

});

parcelRegister("cIPTd", function(module, exports) {

let $9431d84f2ef3ba7a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9431d84f2ef3ba7a$var$load("iGTFs").then(()=>parcelRequire('2qJyh'));

});

parcelRegister("20fua", function(module, exports) {

let $175797fa889e8e53$var$load = (parcelRequire("28QjX"))(4);
module.exports = $175797fa889e8e53$var$load("7nLOm").then(()=>parcelRequire('8A9An'));

});




parcelRegister("iWO3E", function(module, exports) {

$parcel$export(module.exports, "default", () => $89d58ca4a5288e3d$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $fWXJB = parcelRequire("fWXJB");
var $6ARj7 = parcelRequire("6ARj7");

var $dp5jO = parcelRequire("dp5jO");

var $MHKc7 = parcelRequire("MHKc7");



var $2oDNf = parcelRequire("2oDNf");

var $7PL8F = parcelRequire("7PL8F");

var $bjkOk = parcelRequire("bjkOk");

var $9BZKI = parcelRequire("9BZKI");
const $89d58ca4a5288e3d$var$ACT_FLAG_WRAPPER = 'act-flag-wrapper';
const $89d58ca4a5288e3d$var$interactedUIEventAction = {
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'adControlsFlagClose'
};
const $89d58ca4a5288e3d$var$DismissalFlagGroup = ()=>{
    (0, $9BZKI.overridePortalIndex)($89d58ca4a5288e3d$var$ACT_FLAG_WRAPPER);
    const { state: { flags: flags }, createEventDispatcher: createEventDispatcher } = (0, $7PL8F.useAdControlProvider)();
    const { createInteractedUIEvent: createInteractedUIEvent } = (0, $2oDNf.default)();
    const handleOnDismissed = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((id)=>{
        createEventDispatcher(id).dispatch((0, $31d75b4fe1b5774a$export$5c5fc6956b7600ea), createInteractedUIEvent($89d58ca4a5288e3d$var$interactedUIEventAction));
    }, [
        createEventDispatcher,
        createInteractedUIEvent
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6ARj7.default), {
        onDismissed: handleOnDismissed,
        children: Array.from(flags.entries()).map(([itemId, { actions: actions = [], ...flagProps } = {
            actions: []
        }], i)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                id: $89d58ca4a5288e3d$var$ACT_FLAG_WRAPPER,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fWXJB.default), {
                    id: itemId,
                    testId: `act-flag-${itemId}`,
                    icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dp5jO))), {
                        label: "Success",
                        spacing: "spacious",
                        color: `var(--ds-icon-success, ${(0, $829f609a65d26a98$export$940e1f69e873f202)})`
                    }),
                    title: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                        ...(0, $bjkOk.messages).notInterestedFlag
                    }),
                    description: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                        ...(0, $bjkOk.messages).dismissalMessage
                    }),
                    ...flagProps,
                    actions: actions.map((action)=>({
                            ...action,
                            onClick: (e)=>{
                                action.onClick?.(e, ()=>handleOnDismissed(itemId));
                            }
                        }))
                })
            }, i))
    });
};
var $89d58ca4a5288e3d$export$2e2bcd8739ae039 = $89d58ca4a5288e3d$var$DismissalFlagGroup;

});
parcelRegister("bjkOk", function(module, exports) {

$parcel$export(module.exports, "messages", () => $9491d2480bd43369$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $9491d2480bd43369$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    notInterested: {
        id: 'act.action.notInterested.button.text',
        defaultMessage: 'Not interested',
        description: 'The text of a button to indicate the users can dismiss the current component'
    },
    notInterestedFlag: {
        id: 'act.action.notInterestedFlag.flag.text',
        defaultMessage: 'Got it, thanks for letting us know',
        description: 'A message that informs the users the dismissal action is taken'
    },
    showReasons: {
        id: 'act.action.showReasons.common.text',
        defaultMessage: 'Why am I seeing this?',
        description: "The text of a button to indicate the users can click and see the reasons for a component's appearance"
    },
    dismissalMessage: {
        id: 'act.action.dismissalMessage.common.text',
        defaultMessage: "You won\u2019t see this here as often.",
        description: 'A message that informs the users the dismissal action is taken'
    },
    reasonsModalOkButton: {
        id: 'act.action.reasonsModalOkButton.common.text',
        defaultMessage: 'OK',
        description: 'The text of a button to indicate the users can dismiss the current modal'
    }
});

});

parcelRegister("9BZKI", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_PORTAL_OVERRIDE_INDEX", () => $05b6c23337aa70ff$export$335243096683aa37);
$parcel$export(module.exports, "overridePortalIndex", () => $05b6c23337aa70ff$export$61df98316049b30);
const $05b6c23337aa70ff$export$335243096683aa37 = 900;
function $05b6c23337aa70ff$export$61df98316049b30(elementId, index = $05b6c23337aa70ff$export$335243096683aa37) {
    setTimeout(()=>{
        if (typeof document !== 'undefined') {
            const parentPortal = $05b6c23337aa70ff$export$148feac3be949786(document.getElementById(elementId), '.atlaskit-portal');
            if (parentPortal) parentPortal.setAttribute('style', `z-index:${index};`);
        }
    }, 0);
}
function $05b6c23337aa70ff$var$collectionHas(all, curr) {
    for(let i = 0, len = all.length; i < len; i++){
        if (all[i] === curr) return true;
    }
    return false;
}
function $05b6c23337aa70ff$export$148feac3be949786(elm, selector) {
    let all = document.querySelectorAll(selector);
    let cur = elm?.parentNode;
    while(cur && !$05b6c23337aa70ff$var$collectionHas(all, cur))cur = cur.parentNode;
    return cur;
}

});


parcelRegister("3rGmd", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab01225816809c5d$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $eCeGD = parcelRequire("eCeGD");

var $1R1Ge = parcelRequire("1R1Ge");
var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");
var $i8Qvm = parcelRequire("i8Qvm");

var $MHKc7 = parcelRequire("MHKc7");


var $2oDNf = parcelRequire("2oDNf");

var $7PL8F = parcelRequire("7PL8F");

var $bjkOk = parcelRequire("bjkOk");

var $9BZKI = parcelRequire("9BZKI");
const $ab01225816809c5d$var$adControlScreenName = 'adControlsReasonsModal';
const $ab01225816809c5d$var$ACT_MODAL_CONTENT = 'ACT_MODAL_CONTENT';
const $ab01225816809c5d$var$ReasonsModal = ({ body: body, itemId: itemId, title: title, zIndexOverride: zIndexOverride = (0, $9BZKI.DEFAULT_PORTAL_OVERRIDE_INDEX), ...props })=>{
    const { closeModal: closeModal, createEventDispatcher: createEventDispatcher } = (0, $7PL8F.useAdControlProvider)();
    const { createScreenUIEvent: createScreenUIEvent } = (0, $2oDNf.default)();
    const isMounted = (0, $5uXOq.useRef)(false);
    const eventDispatcherRef = (0, $5uXOq.useRef)();
    eventDispatcherRef.current = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>itemId !== undefined ? createEventDispatcher(itemId) : eventDispatcherRef.current, [
        createEventDispatcher,
        itemId
    ]);
    const isOpen = itemId !== undefined;
    (0, $5uXOq.useEffect)(()=>{
        const eventDispatcher = eventDispatcherRef.current;
        if (!eventDispatcher) return;
        if (isOpen) eventDispatcher.dispatch((0, $31d75b4fe1b5774a$export$ff50ad60f08a4bc0), createScreenUIEvent($ab01225816809c5d$var$adControlScreenName));
        else if (isMounted.current && !isOpen) eventDispatcher.dispatch((0, $31d75b4fe1b5774a$export$6bd2d8eacca15ce1), createScreenUIEvent($ab01225816809c5d$var$adControlScreenName));
    }, [
        createScreenUIEvent,
        isOpen
    ]);
    (0, $5uXOq.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    // DO NOT MODIFY CODE BLOCK - temp fix for z-index issue in confluence
    if (isOpen && zIndexOverride) (0, $9BZKI.overridePortalIndex)($ab01225816809c5d$var$ACT_MODAL_CONTENT, zIndexOverride);
    // DO NOT MODIFY CODE BLOCK - temp fix for z-index issue in confluence
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i8Qvm.default), {
        children: isOpen && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1R1Ge.default), {
            shouldCloseOnEscapePress: true,
            onClose: closeModal,
            ...props,
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $MHKc7.default), {
                id: $ab01225816809c5d$var$ACT_MODAL_CONTENT,
                children: [
                    title !== null && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jgVsb.default), {
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gofOI.default), {
                            children: title ?? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                ...(0, $bjkOk.messages).showReasons
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7QSqG.default), {
                        children: body
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $juxqI.default), {
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCeGD.default), {
                            appearance: "primary",
                            onClick: closeModal,
                            autoFocus: true,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                ...(0, $bjkOk.messages).reasonsModalOkButton
                            })
                        })
                    })
                ]
            })
        })
    });
};
var $ab01225816809c5d$export$2e2bcd8739ae039 = $ab01225816809c5d$var$ReasonsModal;

});


parcelRegister("iB3Ak", function(module, exports) {

$parcel$export(module.exports, "default", () => $3438e1e7198567ad$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $6B7KL = parcelRequire("6B7KL");


var $2oDNf = parcelRequire("2oDNf");

var $7PL8F = parcelRequire("7PL8F");

var $bjkOk = parcelRequire("bjkOk");
const $3438e1e7198567ad$var$interactedUIEventAction = {
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'notInterested'
};
const $3438e1e7198567ad$var$DismissalButton = ({ itemId: itemId, onClick: onClick, children: children, flagProps: flagProps, ...props })=>{
    const { addFlag: addFlag, createEventDispatcher: createEventDispatcher, shouldShowDismissFlag: shouldShowDismissFlag } = (0, $7PL8F.useAdControlProvider)();
    const { createInteractedUIEvent: createInteractedUIEvent } = (0, $2oDNf.default)();
    const eventDispatcher = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>createEventDispatcher(itemId), [
        createEventDispatcher,
        itemId
    ]);
    const handleOnClick = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback(async (e)=>{
        eventDispatcher.dispatch((0, $31d75b4fe1b5774a$export$e33200507ac1d20a), createInteractedUIEvent($3438e1e7198567ad$var$interactedUIEventAction));
        shouldShowDismissFlag && addFlag(itemId, flagProps);
        try {
            await onClick?.(e, itemId);
            eventDispatcher.dispatch((0, $31d75b4fe1b5774a$export$103f41d1f3bf374e));
        } catch (e) {
            eventDispatcher.dispatchError((0, $31d75b4fe1b5774a$export$6d3088110036f124), e);
        }
    }, [
        addFlag,
        createInteractedUIEvent,
        eventDispatcher,
        flagProps,
        itemId,
        onClick,
        shouldShowDismissFlag
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6B7KL.default), {
        onClick: handleOnClick,
        ...props,
        children: children ?? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $bjkOk.messages).notInterested
        })
    });
};
var $3438e1e7198567ad$export$2e2bcd8739ae039 = $3438e1e7198567ad$var$DismissalButton;

});

parcelRegister("G85VY", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d5f846aab069a22$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $6B7KL = parcelRequire("6B7KL");


var $2oDNf = parcelRequire("2oDNf");

var $7PL8F = parcelRequire("7PL8F");

var $bjkOk = parcelRequire("bjkOk");
const $3d5f846aab069a22$var$interactedUIEventAction = {
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'adControlsReasons'
};
const $3d5f846aab069a22$var$ReasonsButton = ({ children: children, itemId: itemId, modalProps: modalProps, onClick: onClick, ...props })=>{
    const { createEventDispatcher: createEventDispatcher, openModal: openModal } = (0, $7PL8F.useAdControlProvider)();
    const { createInteractedUIEvent: createInteractedUIEvent } = (0, $2oDNf.default)();
    const eventDispatcher = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>createEventDispatcher(itemId), [
        createEventDispatcher,
        itemId
    ]);
    const handleOnClick = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((e)=>{
        eventDispatcher.dispatch((0, $31d75b4fe1b5774a$export$5595c6967e83d351), createInteractedUIEvent($3d5f846aab069a22$var$interactedUIEventAction));
        openModal(modalProps, itemId);
        onClick?.(e, itemId);
    }, [
        createInteractedUIEvent,
        eventDispatcher,
        itemId,
        modalProps,
        onClick,
        openModal
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6B7KL.default), {
        onClick: handleOnClick,
        ...props,
        children: children ?? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $bjkOk.messages).showReasons
        })
    });
};
var $3d5f846aab069a22$export$2e2bcd8739ae039 = $3d5f846aab069a22$var$ReasonsButton;

});

parcelRegister("UsPWm", function(module, exports) {

$parcel$export(module.exports, "useOnClickDismissMenu", () => $afc7c92a6d8e429c$export$d840cf3018e72a62);

var $5uXOq = parcelRequire("5uXOq");

var $fK9DC = parcelRequire("fK9DC");
const $afc7c92a6d8e429c$export$d840cf3018e72a62 = ()=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $fK9DC.useAnalytics)();
    return (0, $5uXOq.useCallback)((dismissMenuIntent)=>{
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'editionAwarenessDismissMenu',
            attributes: {
                dismissMenuIntent: dismissMenuIntent
            }
        });
    }, [
        sendAnalyticsEvent
    ]);
};

});



parcelRegister("aAbok", function(module, exports) {

$parcel$export(module.exports, "DIALOG_CONFIG", () => $562a4ca5ccb1c712$export$3b6761b6086f6dfd);
const $562a4ca5ccb1c712$export$3b6761b6086f6dfd = {
    touchpointIntent: 'startTrial',
    dialogId: 'standard-to-premium',
    dialogType: 'modal'
};

});

parcelRegister("hUlWX", function(module, exports) {

$parcel$export(module.exports, "entryPoint", () => $406b8fe51bacdc95$export$6333901e831d7af0);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

var $aLUVj = parcelRequire("aLUVj");

const $406b8fe51bacdc95$export$6333901e831d7af0 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("lpDD3")), {
        moduleId: "5d6f3a03",
        moduleId: 'edition-awareness-standard-to-premium-dialog'
    }),
    getPreloadProps: ({ cloudId: cloudId, hamsProductKey: hamsProductKey })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                tenantContexts: {
                    parameters: $aLUVj.default,
                    variables: {
                        cloudId: cloudId,
                        hamsProductKey: hamsProductKey
                    }
                }
            }
        })
});

});
parcelRegister("aLUVj", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b6013da5d7b54cf$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<682e1b9258283a7f09057adf30795f9d>>
 * @relayHash 07dc38bf96b6611a01f9767f7b407b8d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID dbf18c0421da822d19df28c840fae84cc019e38b8a514c0f675b1a9787b4a6ec

var $eiowN = parcelRequire("eiowN");
const $1b6013da5d7b54cf$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hamsProductKey"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v3 = [
        {
            "kind": "Literal",
            "name": "offeringName",
            "value": "Premium"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "dialogStandardToPremiumEditionAwarenessQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v3 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ 
                                                    ],
                                                    "storageKey": "changeOfferingV2(offeringName:\"Premium\")"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "dialogStandardToPremiumEditionAwarenessQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "args": v3 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v4 /*: any*/ 
                                                    ],
                                                    "storageKey": "changeOfferingV2(offeringName:\"Premium\")"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "dbf18c0421da822d19df28c840fae84cc019e38b8a514c0f675b1a9787b4a6ec",
            "metadata": {},
            "name": "dialogStandardToPremiumEditionAwarenessQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$1b6013da5d7b54cf$var$node.hash = "23572a45675a29460489ba03bc2ffca8";
(0, $eiowN.PreloadableQueryRegistry).set($1b6013da5d7b54cf$var$node.params.id, $1b6013da5d7b54cf$var$node);
var $1b6013da5d7b54cf$export$2e2bcd8739ae039 = $1b6013da5d7b54cf$var$node;

});

parcelRegister("lpDD3", function(module, exports) {

let $f96aac402ac2deb6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f96aac402ac2deb6$var$load("afLrO").then(()=>parcelRequire('7Janc'));

});




parcelRegister("cmYVy", function(module, exports) {

$parcel$export(module.exports, "FETCH_ERROR_NAME", () => $53696f7e5e263d8c$export$83179404a61b001a);
$parcel$export(module.exports, "FetchError", () => $53696f7e5e263d8c$export$26e841bcf1aeb894);
const $53696f7e5e263d8c$export$83179404a61b001a = 'FetchError';
class $53696f7e5e263d8c$export$26e841bcf1aeb894 extends Error {
    constructor(message, status){
        super(message), this.name = $53696f7e5e263d8c$export$83179404a61b001a;
        this.status = status;
    }
    static isFetchError(value) {
        return value instanceof $53696f7e5e263d8c$export$26e841bcf1aeb894;
    }
}

});

parcelRegister("ceimD", function(module, exports) {

$parcel$export(module.exports, "retryOnException", () => $9ef2d0ae385447e7$export$1d94629c94e7a17f);
const $9ef2d0ae385447e7$export$5c069c93d2b7493f = (ms)=>new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
const $9ef2d0ae385447e7$export$1d94629c94e7a17f = async (invokeOperation, config)=>{
    let nextMSInterval = 0;
    let error = new Error('No calls made');
    const retries = config.intervalsMS.length;
    while(nextMSInterval !== undefined)try {
        if (nextMSInterval > 0) {
            await $9ef2d0ae385447e7$export$5c069c93d2b7493f(nextMSInterval);
            if (config.onRetry) config.onRetry(error, retries - config.intervalsMS.length);
        }
        return await invokeOperation();
    } catch (e) {
        error = e;
        if (config.shouldRetryOnException && !config.shouldRetryOnException(error)) throw error;
        nextMSInterval = config.intervalsMS.shift();
    }
    throw error;
};

});

parcelRegister("4JKO4", function(module, exports) {

$parcel$export(module.exports, "Status", () => $82e51cfa01cc5ffa$export$96e9906d6d93a972);
$parcel$export(module.exports, "isComplete", () => $82e51cfa01cc5ffa$export$9569565a7ac14e8e);
$parcel$export(module.exports, "isError", () => $82e51cfa01cc5ffa$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "hasLoaded", () => $82e51cfa01cc5ffa$export$5fce62f50756dbf);
$parcel$export(module.exports, "default", () => $82e51cfa01cc5ffa$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jMc3y = parcelRequire("jMc3y");

var $cb25w = parcelRequire("cb25w");

var $3JMPn = parcelRequire("3JMPn");

var $ceimD = parcelRequire("ceimD");

var $9dCRm = parcelRequire("9dCRm");
const $82e51cfa01cc5ffa$var$DATA_PROVIDER_SUBJECT = 'atlassianSwitcherDataProvider';
var $82e51cfa01cc5ffa$export$96e9906d6d93a972 = /*#__PURE__*/ function(Status) {
    Status["LOADING"] = "loading";
    Status["COMPLETE"] = "complete";
    Status["ERROR"] = "error";
    return Status;
}({});
const $82e51cfa01cc5ffa$export$947ceca65da0e7a6 = (data)=>({
        status: "complete",
        data: data
    });
const $82e51cfa01cc5ffa$export$9569565a7ac14e8e = (result)=>result.status === "complete";
const $82e51cfa01cc5ffa$export$e6127cc7fe7395c3 = (result)=>result.status === "error";
const $82e51cfa01cc5ffa$export$20bb0d907fbbe433 = (result)=>result.status === "loading";
const $82e51cfa01cc5ffa$export$5fce62f50756dbf = (result)=>result.status !== "loading";
function $82e51cfa01cc5ffa$export$2e2bcd8739ae039(name, experienceMark, mapPropsToPromise, mapPropsToInitialValue, retryConfig, shouldUpdate) {
    const getInitialState = (props)=>{
        if (mapPropsToInitialValue) {
            const initialValue = mapPropsToInitialValue(props);
            if (initialValue !== undefined) return {
                status: "complete",
                data: initialValue
            };
        }
        return {
            status: "loading",
            data: null
        };
    };
    class DataProvider extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
        static{
            this.displayName = `DataProvider(${name})`;
        }
        componentWillUnmount() {
            /**
			 * Promise resolved after component is unmounted to be ignored
			 */ this.acceptResults = false;
        }
        componentDidMount() {
            this.props.experienceTracker.markStart(experienceMark);
            this.fetchData();
        }
        componentDidUpdate(prevProps) {
            if (shouldUpdate?.(prevProps.params, this.props.params)) this.fetchData();
        }
        fetchData() {
            (0, $ceimD.retryOnException)(()=>mapPropsToPromise(this.props.params), {
                intervalsMS: retryConfig?.intervalsMS || [],
                shouldRetryOnException: retryConfig?.shouldRetryOnException,
                onRetry: (previousException, retryCount)=>{
                    this.onRetry(previousException, retryCount);
                }
            }).then((result)=>{
                this.onResult(result);
            }).catch((error)=>{
                this.onError(error);
            });
        }
        onResult(value) {
            if (this.acceptResults) this.setState({
                data: value,
                status: "complete"
            });
            this.props.experienceTracker.markEnd(experienceMark);
            this.fireOperationalEvent({
                action: 'receivedResult',
                actionSubjectId: name,
                attributes: {
                    provider: name
                }
            });
        }
        onRetry(error, retryCount) {
            this.fireOperationalEvent({
                action: 'retried',
                actionSubjectId: name,
                attributes: {
                    provider: name,
                    reason: retryConfig?.customErrorToReason ? retryConfig.customErrorToReason(error) : (0, $3JMPn.errorToReason)(error),
                    retryCount: retryCount
                }
            });
        }
        onError(error) {
            /**
			 * Do not transition from "complete" state to "error"
			 */ if (this.acceptResults && !$82e51cfa01cc5ffa$export$9569565a7ac14e8e(this.state)) this.setState({
                error: error,
                status: "error",
                data: null
            });
            this.fireOperationalEvent({
                action: 'failed',
                actionSubjectId: name,
                attributes: {
                    provider: name,
                    reason: (0, $3JMPn.errorToReason)(error)
                }
            });
        }
        render() {
            return this.props.children(this.state);
        }
        constructor(...args){
            super(...args), this.acceptResults = true, this.state = getInitialState(this.props.params), this.fireOperationalEvent = (payload)=>{
                if (this.props.createAnalyticsEvent) this.props.createAnalyticsEvent({
                    eventType: (0, $676c5e519aa5ba55$export$12346a674644c156),
                    actionSubject: $82e51cfa01cc5ffa$var$DATA_PROVIDER_SUBJECT,
                    ...payload,
                    attributes: {
                        ...payload.attributes,
                        outdated: !this.acceptResults
                    }
                }).fire((0, $jMc3y.NAVIGATION_CHANNEL));
            };
        }
    }
    // In prefetch, we start with empty args {}, but when getting data from the cache in the data provider, extra args are injected by HOC withAnalyticsEvents and withExperienceTracker
    // This results in a cache miss due to a key mismatch.
    // The workaround here is to use a wrapper (OuterComponent) that passes the original props as a separate prop(params) to the underlying component(InnerComponent).
    // For more info: https://product-fabric.atlassian.net/browse/CXP-2697
    const InnerComponent = (0, $cb25w.default)()((0, $9dCRm.withExperienceTracker)(DataProvider));
    const OuterComponent = ({ children: children, ...params })=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)(InnerComponent, {
            params: params,
            children: children
        });
    };
    return OuterComponent;
}

});
parcelRegister("jMc3y", function(module, exports) {

$parcel$export(module.exports, "NAVIGATION_CHANNEL", () => $9e71ae1a8a0d4641$export$515664faa1398f37);
$parcel$export(module.exports, "SWITCHER_SUBJECT", () => $9e71ae1a8a0d4641$export$17ff9c46e41eb585);
$parcel$export(module.exports, "SWITCHER_ITEM_SUBJECT", () => $9e71ae1a8a0d4641$export$7598b001981cfda5);
$parcel$export(module.exports, "SWITCHER_ITEM_LOZENGES_SUBJECT", () => $9e71ae1a8a0d4641$export$c3c93e13b09d3ad9);
$parcel$export(module.exports, "SWITCHER_CHILD_ITEM_SUBJECT", () => $9e71ae1a8a0d4641$export$7d4d527df0e3789c);
$parcel$export(module.exports, "SWITCHER_ITEM_EXPAND_SUBJECT", () => $9e71ae1a8a0d4641$export$16cf10618135eb24);
$parcel$export(module.exports, "SWITCHER_COMPONENT", () => $9e71ae1a8a0d4641$export$2b570fc112cbca);
$parcel$export(module.exports, "SWITCHER_SOURCE", () => $9e71ae1a8a0d4641$export$5ed36c4d23de5568);
$parcel$export(module.exports, "TRIGGER_COMPONENT", () => $9e71ae1a8a0d4641$export$8d2f933bbd9e4f09);
$parcel$export(module.exports, "TRIGGER_SUBJECT", () => $9e71ae1a8a0d4641$export$d7029a5dc66b0736);
$parcel$export(module.exports, "SWITCHER_PARTIAL_RESULTS", () => $9e71ae1a8a0d4641$export$4649adbfda1b6a66);
$parcel$export(module.exports, "SWITCHER_ORG_ITEM", () => $9e71ae1a8a0d4641$export$6dd696c9ad636a67);
$parcel$export(module.exports, "SWITCHER_ORG_NAME_EXPAND_PANEL", () => $9e71ae1a8a0d4641$export$53f2256589c0fa08);
$parcel$export(module.exports, "SWITCHER_CURRENT_ORG", () => $9e71ae1a8a0d4641$export$44c7ac3fdc1d62b8);
$parcel$export(module.exports, "SWITCHER_ORG_LIST", () => $9e71ae1a8a0d4641$export$d9d2f872f3b91169);
$parcel$export(module.exports, "SWITCHER_JOINABLE_SITES", () => $9e71ae1a8a0d4641$export$5724539c9b1a3a5d);
$parcel$export(module.exports, "SWITCHER_AVAILABLE_PRODUCTS", () => $9e71ae1a8a0d4641$export$22f5f827d9934254);
$parcel$export(module.exports, "createAndFireNavigationEvent", () => $9e71ae1a8a0d4641$export$884b1a4c7ac9dd14);
$parcel$export(module.exports, "analyticsAttributes", () => $9e71ae1a8a0d4641$export$a305f130b289b818);
$parcel$export(module.exports, "withAnalyticsContextData", () => $9e71ae1a8a0d4641$export$97ebdd8e7274f18a);
$parcel$export(module.exports, "RenderTracker", () => $9e71ae1a8a0d4641$export$e09ad93c2b74b853);
$parcel$export(module.exports, "NotRenderedTracker", () => $9e71ae1a8a0d4641$export$95b1f1a72cad0dcb);
$parcel$export(module.exports, "ViewedTracker", () => $9e71ae1a8a0d4641$export$b3fd6624b6a6d057);
$parcel$export(module.exports, "getJoinableSitesRenderTracker", () => $9e71ae1a8a0d4641$export$e823e937102b322b);
$parcel$export(module.exports, "getCustomLinksRenderTracker", () => $9e71ae1a8a0d4641$export$d75a4f56d85f67ea);
$parcel$export(module.exports, "getItemAnalyticsContext", () => $9e71ae1a8a0d4641$export$6489efba2ca85102);
$parcel$export(module.exports, "withAnalyticsEvents", () => (parcelRequire("cb25w")).default);
$parcel$export(module.exports, "NavigationAnalyticsContext", () => (parcelRequire("1PVpv")).NavigationAnalyticsContext);
$parcel$export(module.exports, "OPERATIONAL_EVENT_TYPE", () => $676c5e519aa5ba55$export$12346a674644c156);
$parcel$export(module.exports, "UI_EVENT_TYPE", () => $676c5e519aa5ba55$export$a1562d08625f5d7e);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $1PVpv = parcelRequire("1PVpv");

var $gB4mS = parcelRequire("gB4mS");
var $cb25w = parcelRequire("cb25w");


var $4JKO4 = parcelRequire("4JKO4");

var $crCnP = parcelRequire("crCnP");

var $6WztE = parcelRequire("6WztE");
const $9e71ae1a8a0d4641$export$515664faa1398f37 = 'navigation';
const $9e71ae1a8a0d4641$export$17ff9c46e41eb585 = 'atlassianSwitcher';
const $9e71ae1a8a0d4641$export$7598b001981cfda5 = 'atlassianSwitcherItem';
const $9e71ae1a8a0d4641$export$c3c93e13b09d3ad9 = 'atlassianSwitcherItemLozenges';
const $9e71ae1a8a0d4641$export$7d4d527df0e3789c = 'atlassianSwitcherChildItem';
const $9e71ae1a8a0d4641$export$16cf10618135eb24 = 'atlassianSwitcherItemExpand';
const $9e71ae1a8a0d4641$export$2b570fc112cbca = 'atlassianSwitcher';
const $9e71ae1a8a0d4641$export$5ed36c4d23de5568 = 'atlassianSwitcher';
const $9e71ae1a8a0d4641$export$8d2f933bbd9e4f09 = 'atlassianSwitcherPrefetch';
const $9e71ae1a8a0d4641$export$d7029a5dc66b0736 = 'atlassianSwitcherPrefetch';
const $9e71ae1a8a0d4641$export$4649adbfda1b6a66 = 'atlassianSwitcherPartialResultError';
const $9e71ae1a8a0d4641$export$6dd696c9ad636a67 = 'atlassianSwitcherOrgItem';
const $9e71ae1a8a0d4641$export$53f2256589c0fa08 = 'atlassianSwitcherOrgNameExpandPanel';
const $9e71ae1a8a0d4641$export$44c7ac3fdc1d62b8 = 'atlassianSwitcherCurrentOrg';
const $9e71ae1a8a0d4641$export$d9d2f872f3b91169 = 'atlassianSwitcherOrganisationsList';
const $9e71ae1a8a0d4641$export$5724539c9b1a3a5d = 'atlassianSwitcherJoinableSites';
const $9e71ae1a8a0d4641$export$22f5f827d9934254 = 'atlassianSwitcherAvailableProducts';
const $9e71ae1a8a0d4641$var$SWITCHER_CUSTOM_LINKS = 'atlassianSwitcherCustomLinks';
const $9e71ae1a8a0d4641$var$RENDERED_ACTION = 'rendered';
const $9e71ae1a8a0d4641$var$NOT_RENDERED_ACTION = 'not_rendered';
const $9e71ae1a8a0d4641$var$VIEWED_ACTION = 'viewed';
const $9e71ae1a8a0d4641$export$884b1a4c7ac9dd14 = (0, $gB4mS.default)($9e71ae1a8a0d4641$export$515664faa1398f37);
const $9e71ae1a8a0d4641$export$a305f130b289b818 = (attributes)=>({
        attributes: attributes
    });
const $9e71ae1a8a0d4641$export$97ebdd8e7274f18a = function(mapPropsToContext) {
    return function(WrappedComponent) {
        return (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $1PVpv.NavigationAnalyticsContext), {
                data: mapPropsToContext(props),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)(WrappedComponent, {
                    ...props
                })
            });
    };
};
const $9e71ae1a8a0d4641$var$isValidDuration = (duration)=>{
    return duration !== null && duration !== undefined && duration >= 0;
};
const $9e71ae1a8a0d4641$export$e09ad93c2b74b853 = (0, $cb25w.default)({
    onRender: (createAnalyticsEvent, props)=>{
        const duration = props.data?.duration;
        return createAnalyticsEvent({
            eventType: (0, $676c5e519aa5ba55$export$12346a674644c156),
            action: $9e71ae1a8a0d4641$var$RENDERED_ACTION,
            actionSubject: props.subject,
            attributes: {
                ...props.data,
                ...$9e71ae1a8a0d4641$var$isValidDuration(duration) && {
                    bucket: (0, $6WztE.getMetricBucket)(duration, (0, $6WztE.RenderTrackerBuckets))
                }
            }
        }).fire($9e71ae1a8a0d4641$export$515664faa1398f37);
    }
})(class extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidMount() {
        this.props.onRender();
    }
    render() {
        return null;
    }
});
const $9e71ae1a8a0d4641$export$95b1f1a72cad0dcb = (0, $cb25w.default)({
    onRender: (createAnalyticsEvent, props)=>{
        return createAnalyticsEvent({
            eventType: (0, $676c5e519aa5ba55$export$12346a674644c156),
            action: $9e71ae1a8a0d4641$var$NOT_RENDERED_ACTION,
            actionSubject: props.subject,
            attributes: props.data
        }).fire($9e71ae1a8a0d4641$export$515664faa1398f37);
    }
})(class extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidMount() {
        this.props.onRender();
    }
    render() {
        return null;
    }
});
const $9e71ae1a8a0d4641$export$b3fd6624b6a6d057 = (0, $cb25w.default)({
    onRender: (createAnalyticsEvent, props)=>{
        return createAnalyticsEvent({
            eventType: (0, $676c5e519aa5ba55$export$a1562d08625f5d7e),
            action: $9e71ae1a8a0d4641$var$VIEWED_ACTION,
            actionSubject: props.subject,
            attributes: props.data
        }).fire($9e71ae1a8a0d4641$export$515664faa1398f37);
    }
})(class extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidMount() {
        this.props.onRender();
    }
    render() {
        return null;
    }
});
const $9e71ae1a8a0d4641$var$renderTrackerWithReason = ({ subject: subject, notRenderedReason: notRenderedReason, emptyRenderExpected: emptyRenderExpected, data: data })=>{
    if (notRenderedReason) return /*#__PURE__*/ (0, $2OMIu.jsx)($9e71ae1a8a0d4641$export$95b1f1a72cad0dcb, {
        subject: subject,
        data: {
            ...data,
            notRenderedReason: notRenderedReason
        }
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)($9e71ae1a8a0d4641$export$e09ad93c2b74b853, {
        subject: subject,
        data: {
            ...data,
            emptyRender: emptyRenderExpected
        }
    });
};
const $9e71ae1a8a0d4641$var$renderTracker = ({ subject: subject, providerFailed: providerFailed, emptyRenderExpected: emptyRenderExpected, linksRendered: linksRendered, data: data })=>{
    if (providerFailed || linksRendered.length === 0 && !emptyRenderExpected) return /*#__PURE__*/ (0, $2OMIu.jsx)($9e71ae1a8a0d4641$export$95b1f1a72cad0dcb, {
        subject: subject,
        data: {
            ...data,
            providerFailed: providerFailed
        }
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)($9e71ae1a8a0d4641$export$e09ad93c2b74b853, {
        subject: subject,
        data: {
            ...data,
            emptyRender: emptyRenderExpected
        }
    });
};
const $9e71ae1a8a0d4641$export$e823e937102b322b = (providerResult, joinableSiteLinks, data)=>{
    if (!(0, $4JKO4.hasLoaded)(providerResult)) return null;
    if (providerResult.data && !providerResult.data.sites) return null;
    // The render is considered failed when either the provider failed, or the provider returned a non-empty result but nothing was rendered
    const emptyRenderExpected = Boolean(providerResult.data && providerResult.data.sites && providerResult.data.sites.length === 0);
    return $9e71ae1a8a0d4641$var$renderTracker({
        subject: $9e71ae1a8a0d4641$export$5724539c9b1a3a5d,
        providerFailed: providerResult.data === null,
        emptyRenderExpected: emptyRenderExpected,
        linksRendered: joinableSiteLinks,
        data: data
    });
};
const $9e71ae1a8a0d4641$export$d75a4f56d85f67ea = (customLinksProviderResult, userSiteDataProviderResult, customLinks, data)=>{
    // The render is only considered failed when one of the providers failed, and empty render is a valid case
    if (!customLinksProviderResult) return;
    const emptyRenderExpected = customLinks.length === 0;
    function getNotRenderedReason() {
        if (customLinksProviderResult?.status === (0, $4JKO4.Status).ERROR) return 'custom_links_api_error';
        const error = userSiteDataProviderResult.error;
        if (!error) return null;
        if (error instanceof (0, $crCnP.UserSiteDataError)) return error.reason;
        else return 'usd_unknown';
    }
    const notRenderedReason = getNotRenderedReason();
    return $9e71ae1a8a0d4641$var$renderTrackerWithReason({
        subject: $9e71ae1a8a0d4641$var$SWITCHER_CUSTOM_LINKS,
        notRenderedReason: notRenderedReason,
        emptyRenderExpected: emptyRenderExpected,
        data: data
    });
};
const $9e71ae1a8a0d4641$export$6489efba2ca85102 = (groupIndex, id, type, productType, extraAttributes)=>({
        ...$9e71ae1a8a0d4641$export$a305f130b289b818({
            groupIndex: groupIndex,
            itemId: id,
            itemType: type,
            productType: productType,
            ...extraAttributes
        })
    });

});
parcelRegister("crCnP", function(module, exports) {

$parcel$export(module.exports, "UserSiteDataErrorReason", () => $f5aa30bcad5cbe4c$export$b08600051ba52198);
$parcel$export(module.exports, "UserSiteDataError", () => $f5aa30bcad5cbe4c$export$c460344055e97b1);
var $f5aa30bcad5cbe4c$export$b08600051ba52198 = /*#__PURE__*/ function(UserSiteDataErrorReason) {
    UserSiteDataErrorReason["APS_NO_SITE_MATCH"] = "aps_no_site_match";
    UserSiteDataErrorReason["APS_EMPTY_RESULT"] = "aps_empty_result";
    UserSiteDataErrorReason["APS_PARTIAL_EMPTY_RESULT"] = "aps_partial_response_empty_result";
    return UserSiteDataErrorReason;
}({});
class $f5aa30bcad5cbe4c$export$c460344055e97b1 extends Error {
    constructor(reason, message){
        super(message);
        this.name = 'UserSiteDataError';
        this.reason = reason;
    }
}

});

parcelRegister("6WztE", function(module, exports) {

$parcel$export(module.exports, "RenderTrackerBuckets", () => $511e8ab45352d11f$export$e59c24bc0768d568);
$parcel$export(module.exports, "getMetricBucket", () => $511e8ab45352d11f$export$b59492d26971ae92);
const $511e8ab45352d11f$var$INFINITY = '+Inf';
const $511e8ab45352d11f$export$e59c24bc0768d568 = [
    1000,
    900,
    800,
    700,
    600,
    500
];
const $511e8ab45352d11f$export$b59492d26971ae92 = (metricValue, buckets)=>{
    return metricValue >= 0 ? buckets.reduce((lowestBucket, currentBucket)=>{
        return metricValue <= currentBucket ? currentBucket.toString() : lowestBucket.toString();
    }, $511e8ab45352d11f$var$INFINITY) : null;
};

});


parcelRegister("3JMPn", function(module, exports) {

$parcel$export(module.exports, "errorToReason", () => $dc29284f7f5c6994$export$a3e288208721751b);
function $dc29284f7f5c6994$export$a3e288208721751b(error) {
    const { name: name = 'Unknown', status: status } = error || {};
    return {
        name: name,
        status: status
    };
}

});

parcelRegister("9dCRm", function(module, exports) {

$parcel$export(module.exports, "SwitcherExperienceTrackerContext", () => $fd97f7583b9f4485$export$3f3eebb4b8116461);
$parcel$export(module.exports, "useExperienceTracker", () => $fd97f7583b9f4485$export$cdefb2a8b53f879f);
$parcel$export(module.exports, "withExperienceTracker", () => $fd97f7583b9f4485$export$f88dde183f4d31cb);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $fd97f7583b9f4485$var$noop = ()=>{};
const $fd97f7583b9f4485$export$3f3eebb4b8116461 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    start: $fd97f7583b9f4485$var$noop,
    success: $fd97f7583b9f4485$var$noop,
    failure: $fd97f7583b9f4485$var$noop,
    failureAll: $fd97f7583b9f4485$var$noop,
    abort: $fd97f7583b9f4485$var$noop,
    abortAll: $fd97f7583b9f4485$var$noop,
    markStart: $fd97f7583b9f4485$var$noop,
    markEnd: $fd97f7583b9f4485$var$noop
});
const $fd97f7583b9f4485$export$cdefb2a8b53f879f = ()=>(0, $5uXOq.useContext)($fd97f7583b9f4485$export$3f3eebb4b8116461);
const $fd97f7583b9f4485$export$f88dde183f4d31cb = (Component)=>{
    const WithExperienceTracker = (props)=>{
        const experienceTracker = $fd97f7583b9f4485$export$cdefb2a8b53f879f();
        return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
            ...props,
            experienceTracker: experienceTracker
        });
    };
    WithExperienceTracker.displayName = `WithExperienceTracker(${Component.displayName})`;
    return WithExperienceTracker;
};

});


parcelRegister("7Ghqv", function(module, exports) {

$parcel$export(module.exports, "Permissions", () => $5da9cf836c48eef4$export$2d41982586bbb6be);
$parcel$export(module.exports, "Product", () => $5da9cf836c48eef4$export$264ad599d7cef668);
$parcel$export(module.exports, "Feature", () => $5da9cf836c48eef4$export$6e91cf7616333d5);
$parcel$export(module.exports, "AnalyticsItemType", () => $5da9cf836c48eef4$export$77f267162e8983fb);
$parcel$export(module.exports, "ProductKey", () => $5da9cf836c48eef4$export$f3a53bd43617a593);
var $5da9cf836c48eef4$export$2d41982586bbb6be = /*#__PURE__*/ function(Permissions) {
    Permissions["MANAGE"] = "manage";
    Permissions["CAN_INVITE_USERS"] = "invite-users";
    return Permissions;
}({});
var $5da9cf836c48eef4$export$264ad599d7cef668 = /*#__PURE__*/ function(Product) {
    Product["BITBUCKET"] = "bitbucket";
    Product["CONFLUENCE"] = "confluence";
    Product["HOME"] = "home";
    Product["JIRA"] = "jira";
    Product["SITE_ADMIN"] = "site-admin";
    Product["TRELLO"] = "trello";
    Product["START"] = "start";
    return Product;
}({});
var $5da9cf836c48eef4$export$6e91cf7616333d5 = /*#__PURE__*/ function(Feature) {
    Feature["isUFOEnabled"] = "isUFOEnabled";
    return Feature;
}({});
var $5da9cf836c48eef4$export$77f267162e8983fb = /*#__PURE__*/ function(AnalyticsItemType) {
    AnalyticsItemType["PRODUCT"] = "product";
    AnalyticsItemType["ADMIN"] = "admin";
    AnalyticsItemType["TRY"] = "try";
    AnalyticsItemType["JOIN"] = "join";
    AnalyticsItemType["CUSTOM_LINK"] = "customLink";
    AnalyticsItemType["EMPTY_STATE_EXPLORE_PRODUCTS"] = "empty-state-explore-products";
    return AnalyticsItemType;
}({});
var $5da9cf836c48eef4$export$f3a53bd43617a593 = /*#__PURE__*/ function(ProductKey) {
    ProductKey["CONFLUENCE"] = "confluence.ondemand";
    ProductKey["JIRA_CORE"] = "jira-core.ondemand";
    ProductKey["JIRA_SOFTWARE"] = "jira-software.ondemand";
    ProductKey["JIRA_SERVICE_DESK"] = "jira-servicedesk.ondemand";
    ProductKey["BITBUCKET"] = "bitbucket";
    ProductKey["OPSGENIE"] = "opsgenie";
    ProductKey["STATUSPAGE"] = "statuspage";
    ProductKey["TRELLO"] = "trello";
    ProductKey["COMPASS"] = "compass";
    ProductKey["TEAM_CENTRAL"] = "townsquare";
    ProductKey["JIRA_PRODUCT_DISCOVERY"] = "jira-product-discovery";
    return ProductKey;
}({});

});

parcelRegister("22RxY", function(module, exports) {

$parcel$export(module.exports, "Experience", () => $d270989e07823e37$export$c90b54e658fc4d7c);
$parcel$export(module.exports, "EXPERIENCE_CONFIGS", () => $d270989e07823e37$export$d54d7a2744fdf647);
$parcel$export(module.exports, "ExperienceMark", () => $d270989e07823e37$export$cbf1e672c3e37474);
$parcel$export(module.exports, "EXPERIENCES_TO_MARKS", () => $d270989e07823e37$export$755e75afbd377bc4);
$parcel$export(module.exports, "MARKS_TO_EXPERIENCES", () => $d270989e07823e37$export$805ed806e0769ee4);
$parcel$export(module.exports, "ExperienceMarkPhase", () => $d270989e07823e37$export$ec8391a70bbdbe59);
$parcel$export(module.exports, "AbortReason", () => $d270989e07823e37$export$279d6315a97b520d);
$parcel$export(module.exports, "SWITCHER_RENDER_START_PERFORMANCE_MARK", () => $d270989e07823e37$export$86919b84f9a64054);

var $atdLB = parcelRequire("atdLB");

var $g4yaf = parcelRequire("g4yaf");
var $d270989e07823e37$export$c90b54e658fc4d7c = /*#__PURE__*/ function(Experience) {
    Experience["RENDER_CUSTOM_LINKS_SECTION"] = "render-custom-links-section";
    Experience["RENDER_JOIN_SECTION"] = "render-join-section";
    Experience["RENDER_SWITCH_TO_SECTION"] = "render-switch-to-section";
    Experience["RENDER_SWITCHER_EMPTY_STATE"] = "render-switcher-empty-state";
    return Experience;
}({});
const $d270989e07823e37$export$d54d7a2744fdf647 = {
    ["render-custom-links-section"]: {
        type: (0, $atdLB.ExperienceTypes).Load,
        performanceType: (0, $atdLB.ExperiencePerformanceTypes).PageSegmentLoad
    },
    ["render-join-section"]: {
        type: (0, $atdLB.ExperienceTypes).Load,
        performanceType: (0, $atdLB.ExperiencePerformanceTypes).PageSegmentLoad
    },
    ["render-switch-to-section"]: {
        type: (0, $atdLB.ExperienceTypes).Load,
        performanceType: (0, $atdLB.ExperiencePerformanceTypes).PageSegmentLoad
    },
    ["render-switcher-empty-state"]: {
        type: (0, $atdLB.ExperienceTypes).Load,
        performanceType: (0, $atdLB.ExperiencePerformanceTypes).PageSegmentLoad
    }
};
var $d270989e07823e37$export$cbf1e672c3e37474 = /*#__PURE__*/ function(ExperienceMark) {
    ExperienceMark["API_APP_SWITCHER_BFF_AVAILABLE_PRODUCTS"] = "api-app-switcher-bff-available-products";
    ExperienceMark["API_CONFLUENCE_CUSTOM_LINKS"] = "api-confluence-custom-links";
    ExperienceMark["API_FLIGHT_DECK"] = "api-flight-deck";
    ExperienceMark["API_JIRA_CUSTOM_LINKS"] = "api-jira-custom-links";
    ExperienceMark["API_JOINABLE_SITES"] = "api-joinable-sites";
    ExperienceMark["API_PERMISSIONS"] = "api-permissions";
    ExperienceMark["SWITCHER_INITIAL_MOUNT"] = "switcher-initial-mount";
    ExperienceMark["SWITCHER_SKELETON_MOUNT"] = "switcher-skeleton-mount";
    // Mock for tests
    ExperienceMark["TEST_MARK"] = "test-mark";
    return ExperienceMark;
}({});
const $d270989e07823e37$var$allNonTestExperienceMarks = Object.values($d270989e07823e37$export$cbf1e672c3e37474).filter((mark)=>mark !== "test-mark");
const $d270989e07823e37$export$755e75afbd377bc4 = {
    ["render-custom-links-section"]: $d270989e07823e37$var$allNonTestExperienceMarks,
    ["render-join-section"]: $d270989e07823e37$var$allNonTestExperienceMarks,
    ["render-switch-to-section"]: $d270989e07823e37$var$allNonTestExperienceMarks,
    ["render-switcher-empty-state"]: $d270989e07823e37$var$allNonTestExperienceMarks
};
const $d270989e07823e37$export$805ed806e0769ee4 = (0, $g4yaf.invertRecordOfArrays)($d270989e07823e37$export$755e75afbd377bc4);
var $d270989e07823e37$export$ec8391a70bbdbe59 = /*#__PURE__*/ function(ExperienceMarkPhase) {
    ExperienceMarkPhase["START"] = "start";
    ExperienceMarkPhase["END"] = "end";
    return ExperienceMarkPhase;
}({});
var $d270989e07823e37$export$279d6315a97b520d = /*#__PURE__*/ function(AbortReason) {
    AbortReason["COMPONENT_UNMOUNTED"] = "component-unmounted";
    AbortReason["WINDOW_UNLOADING"] = "window-unloading";
    return AbortReason;
}({});
const $d270989e07823e37$export$86919b84f9a64054 = 'atlassianSwitcher.render.start';

});
parcelRegister("g4yaf", function(module, exports) {

$parcel$export(module.exports, "invertRecordOfArrays", () => $c43c26421979d057$export$c371a74fe5222b3);
function $c43c26421979d057$export$c371a74fe5222b3(record) {
    const invertedRecord = {};
    Object.entries(record).forEach(([key, values])=>{
        values.forEach((value)=>{
            if (!invertedRecord[value]) invertedRecord[value] = [];
            invertedRecord[value].push(key);
        });
    });
    return invertedRecord;
}

});


parcelRegister("7Fgjd", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d3d00b3a0083460$export$2e2bcd8739ae039);
/* skeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $4CjFb = parcelRequire("4CjFb");

var $47RdN = parcelRequire("47RdN");

var $22RxY = parcelRequire("22RxY");
var $hWyMn = parcelRequire("hWyMn");

var $koVbs = parcelRequire("koVbs");

var $11Xk0 = parcelRequire("11Xk0");
const $6d3d00b3a0083460$var$styles = {
    iconSkeleton: "_2rkopd34 _1e0c1o8l _1bsbzwfg _4t3izwfg _bfhkn82g",
    lineSkeleton: "_2rko1sit _1e0c1o8l _1bsb1uc6 _4t3i19bv _bfhkn82g"
};
const $6d3d00b3a0083460$var$iconSkeleton = /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
    className: (0, $bwpsq.default)([
        $6d3d00b3a0083460$var$styles.iconSkeleton
    ])
});
const $6d3d00b3a0083460$var$lineSkeleton = /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
    className: (0, $bwpsq.default)([
        $6d3d00b3a0083460$var$styles.lineSkeleton
    ])
});
var $6d3d00b3a0083460$export$2e2bcd8739ae039 = ()=>{
    (0, $hWyMn.useExperienceRenderAndMountMark)((0, $22RxY.ExperienceMark).SWITCHER_SKELETON_MOUNT);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $4CjFb.SectionContainer), {
        sectionId: "skeleton",
        title: $6d3d00b3a0083460$var$lineSkeleton,
        sectionRole: "alert",
        "aria-label": formatMessage((0, $11Xk0.default).skeletonLoaderAriaLabel),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $47RdN.default), {
                tag: "li",
                icon: $6d3d00b3a0083460$var$iconSkeleton,
                isDisabled: true,
                "aria-hidden": "true",
                children: $6d3d00b3a0083460$var$lineSkeleton
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $47RdN.default), {
                tag: "li",
                icon: $6d3d00b3a0083460$var$iconSkeleton,
                isDisabled: true,
                "aria-hidden": "true",
                children: $6d3d00b3a0083460$var$lineSkeleton
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $47RdN.default), {
                tag: "li",
                icon: $6d3d00b3a0083460$var$iconSkeleton,
                isDisabled: true,
                "aria-hidden": "true",
                children: $6d3d00b3a0083460$var$lineSkeleton
            })
        ]
    });
};

});
parcelRegister("4CjFb", function(module, exports) {

$parcel$export(module.exports, "SectionContainer", () => $c7c93e2870532b5e$export$be4c8679ebfd988);
/* section-container.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");

var $7paD5 = parcelRequire("7paD5");

var $jMc3y = parcelRequire("jMc3y");
var $1PVpv = parcelRequire("1PVpv");

var $fABEI = parcelRequire("fABEI");

var $l1lhL = parcelRequire("l1lhL");

var $7Ghqv = parcelRequire("7Ghqv");

var $l1N8i = parcelRequire("l1N8i");

var $4J7fp = parcelRequire("4J7fp");
const $c7c93e2870532b5e$var$styles = {
    sectionBase: "_ca0q12x7 _u5f3idpf _n3td12x7 _19bvidpf",
    sectionVisualRefresh: "_1reo15vq _18m915vq _x3dozgxb _ca0qu2gc _19pk1n1a",
    list: "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _2mzuglyw",
    box: "_18u0u2gc _2hwxu2gc _19pkidpf _otyru2gc",
    titleBase: "_1reo15vq _18m915vq _11c81o8v _1bto1l2s _1p1dangw _o5721q9c _19pkpxbi _18u0u2gc _syaz1gjq _k48pmoej _otyr1b66",
    titleRefresh: "_1reo15vq _18m915vq _19pk12x7 _18u0u2gc _otyr12x7 _1bto1l2s _o5721q9c _syaz131l _k48p1wq8"
};
const $c7c93e2870532b5e$export$7bb82566a1f2a4f5 = ({ title: title })=>{
    const isVisualRefreshEnabled = (0, $4J7fp.useIsSwitcherTeam25TestCohort)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
        as: "h2",
        size: "xxsmall",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
            xcss: isVisualRefreshEnabled ? $c7c93e2870532b5e$var$styles.titleRefresh : $c7c93e2870532b5e$var$styles.titleBase,
            children: title
        })
    });
};
const $c7c93e2870532b5e$var$SectionContainerComponent = ({ sectionId: sectionId, title: title, titleLink: titleLink, children: children, actionSubject: actionSubject, sectionRole: sectionRole, ariaLabel: ariaLabel })=>{
    const isVisualRefreshEnabled = (0, $4J7fp.useIsSwitcherTeam25TestCohort)();
    const hasChildren = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(children).some(Boolean);
    if (!hasChildren) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("section", {
        "data-testid": `${sectionId}__section`,
        role: sectionRole,
        "aria-label": ariaLabel,
        className: (0, $bwpsq.default)([
            isVisualRefreshEnabled ? $c7c93e2870532b5e$var$styles.sectionVisualRefresh : $c7c93e2870532b5e$var$styles.sectionBase
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $MHKc7.default), {
            xcss: isVisualRefreshEnabled ? $c7c93e2870532b5e$var$styles.box : undefined,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $fABEI.FadeIn), {
                    children: [
                        title && /*#__PURE__*/ (0, $2OMIu.jsx)($c7c93e2870532b5e$export$7bb82566a1f2a4f5, {
                            title: title
                        }),
                        titleLink && /*#__PURE__*/ (0, $2OMIu.jsx)($c7c93e2870532b5e$var$TitleLink, {
                            titleLink: titleLink,
                            actionSubject: actionSubject
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("ul", {
                    className: (0, $bwpsq.default)([
                        $c7c93e2870532b5e$var$styles.list
                    ]),
                    children: children
                })
            ]
        })
    });
};
const $c7c93e2870532b5e$var$TitleLink = ({ titleLink: titleLink, actionSubject: actionSubject })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $1PVpv.NavigationAnalyticsContext), {
        data: (0, $jMc3y.getItemAnalyticsContext)(0, titleLink.key, (0, $7Ghqv.AnalyticsItemType).PRODUCT, titleLink.productType),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1lhL.default), {
            href: titleLink.href,
            iconAfter: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7paD5))), {
                LEGACY_size: "small",
                color: "currentColor",
                label: ""
            }),
            label: titleLink.label,
            testId: "section-title__link",
            actionSubject: actionSubject,
            ariaLabel: titleLink.ariaLabel
        })
    }, titleLink.key);
const $c7c93e2870532b5e$export$be4c8679ebfd988 = (0, $jMc3y.withAnalyticsContextData)((props)=>(0, $jMc3y.analyticsAttributes)({
        group: props.sectionId,
        groupItemsCount: (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(props.children).filter((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement).length
    }))($c7c93e2870532b5e$var$SectionContainerComponent); /* eslint-enable */ 

});
parcelRegister("fABEI", function(module, exports) {

$parcel$export(module.exports, "FadeIn", () => $0474dc0fa8056512$export$bd7370ffb2917ab7);
/* fade-in.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");
parcelRequire("5uXOq");
const $0474dc0fa8056512$var$fadeIn = null;
const $0474dc0fa8056512$var$fadeInStyles = null;
const $0474dc0fa8056512$export$bd7370ffb2917ab7 = ({ children: children, className: className, tag: Tag = 'div' })=>/*#__PURE__*/ (0, $2OMIu.jsx)(Tag, {
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _j7hq16na _5sag1bs3 _1pgl5ucs _1o51q7pw _tzy4idpf _syaz1fxt",
            className
        ]),
        children: children
    });

});

parcelRegister("l1lhL", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e2ad39095fe6079$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $7paD5 = parcelRequire("7paD5");

var $cb25w = parcelRequire("cb25w");


var $jMc3y = parcelRequire("jMc3y");

var $ousew = parcelRequire("ousew");
const $6e2ad39095fe6079$var$ItemLink = ({ label: label, href: href, testId: testId, onClick: onClick, ariaLabel: ariaLabel })=>{
    const buttonProps = {
        appearance: 'link',
        href: href,
        className: 'section-link',
        target: '_blank',
        rel: 'noopener noreferrer',
        iconAfter: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7paD5))), {
            LEGACY_size: "small",
            color: "currentColor",
            label: ""
        }),
        onClick: onClick ? (e, a)=>onClick(e, a) : undefined,
        testId: testId
    };
    if (ariaLabel) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
        ...ariaLabel,
        children: (placeholder)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
                ...buttonProps,
                "aria-label": String(placeholder),
                children: label
            })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
        ...buttonProps,
        children: label
    });
};
var $6e2ad39095fe6079$export$2e2bcd8739ae039 = (0, $cb25w.default)({
    onClick: (0, $jMc3y.createAndFireNavigationEvent)({
        eventType: (0, $676c5e519aa5ba55$export$a1562d08625f5d7e),
        action: 'clicked',
        actionSubject: (0, $jMc3y.SWITCHER_ITEM_SUBJECT)
    })
})($6e2ad39095fe6079$var$ItemLink);

});

parcelRegister("4J7fp", function(module, exports) {

$parcel$export(module.exports, "SwitcherExperimentProvider", () => $9ff64ceacd523ad6$export$cd11e4cf103a20cf);
$parcel$export(module.exports, "useSwitcherTeam25Experiment", () => $9ff64ceacd523ad6$export$f0a8b7930250858a);
$parcel$export(module.exports, "useIsSwitcherTeam25TestCohort", () => $9ff64ceacd523ad6$export$3b522177296bf82b);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
// Temporary fix to enable the Growth team’s app recommendation section to access our experiment.
// TODO: https://hello.jira.atlassian.cloud/browse/NAVX-350
const $9ff64ceacd523ad6$var$storageKey = '@atlassian/switcher-team-25-experiment-cohort';
const $9ff64ceacd523ad6$export$fcdf652c4fd8e4c7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(undefined);
const $9ff64ceacd523ad6$export$cd11e4cf103a20cf = ({ children: children })=>{
    const [switcherTeam25ExperimentCohort, setSwitcherTeam25ExperimentCohort] = (0, $5uXOq.useState)();
    const contextValue = (0, $5uXOq.useMemo)(()=>({
            switcherTeam25ExperimentCohort: switcherTeam25ExperimentCohort,
            setSwitcherTeam25ExperimentCohort: setSwitcherTeam25ExperimentCohort
        }), [
        switcherTeam25ExperimentCohort,
        setSwitcherTeam25ExperimentCohort
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (window?.sessionStorage && switcherTeam25ExperimentCohort) window.sessionStorage.setItem($9ff64ceacd523ad6$var$storageKey, switcherTeam25ExperimentCohort);
    }, [
        switcherTeam25ExperimentCohort
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($9ff64ceacd523ad6$export$fcdf652c4fd8e4c7.Provider, {
        value: contextValue,
        children: children
    });
};
const $9ff64ceacd523ad6$export$3135e38521020087 = ()=>(0, $5uXOq.useContext)($9ff64ceacd523ad6$export$fcdf652c4fd8e4c7);
const $9ff64ceacd523ad6$export$f0a8b7930250858a = ()=>{
    const experimentContext = $9ff64ceacd523ad6$export$3135e38521020087();
    return {
        cohort: experimentContext?.switcherTeam25ExperimentCohort,
        setCohort: experimentContext ? experimentContext.setSwitcherTeam25ExperimentCohort : ()=>{}
    };
};
const $9ff64ceacd523ad6$export$3b522177296bf82b = ()=>{
    const { cohort: cohort } = $9ff64ceacd523ad6$export$f0a8b7930250858a();
    if (cohort) return cohort === 'test';
    // fallback to session storage
    return window?.sessionStorage?.getItem($9ff64ceacd523ad6$var$storageKey) === 'test';
};

});


parcelRegister("47RdN", function(module, exports) {

$parcel$export(module.exports, "LozengeType", () => $a9efd1840e3e9616$export$b95b532653e2b7f6);
$parcel$export(module.exports, "default", () => $a9efd1840e3e9616$export$2e2bcd8739ae039);
/* item.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @jsxFrag */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $3Z96c = parcelRequire("3Z96c");

var $jMc3y = parcelRequire("jMc3y");

var $fABEI = parcelRequire("fABEI");

var $3u0c5 = parcelRequire("3u0c5");

var $ousew = parcelRequire("ousew");

var $11Xk0 = parcelRequire("11Xk0");

var $5bUrR = parcelRequire("5bUrR");
var $a9efd1840e3e9616$export$b95b532653e2b7f6 = /*#__PURE__*/ function(LozengeType) {
    LozengeType["New"] = "new";
    LozengeType["NewBold"] = "new_bold";
    LozengeType["Try"] = "try";
    return LozengeType;
}({});
const $a9efd1840e3e9616$var$lozengeData = {
    ["new"]: {
        label: (0, $11Xk0.default).newLozenge,
        componentProps: {
            appearance: 'new'
        }
    },
    ["new_bold"]: {
        label: (0, $11Xk0.default).newLozenge,
        componentProps: {
            appearance: 'new',
            isBold: true
        }
    },
    ["try"]: {
        label: (0, $11Xk0.default).tryLozenge,
        componentProps: {
            appearance: 'new'
        }
    }
};
const $a9efd1840e3e9616$var$styles = {
    fadeIn: "_1bsb1osq",
    itemDescription: "_1reo15vq _18m915vq _1e0c1ule _2hwxxy5q _1bto1l2s",
    titleWrapper: "_1e0c1ule",
    hasDescription: "_19pk1i6y"
};
const $a9efd1840e3e9616$var$SwitcherItem = ({ icon: icon, description: description, elemAfter: elemAfter, shouldAllowMultiline: shouldAllowMultiline, onClick: onClick, children: children, lozenges: lozenges, product: product, createAnalyticsEvent: createAnalyticsEvent, tag: tag, href: href, ...rest })=>{
    const itemDescription = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(description) || typeof description === 'string') return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
            className: (0, $bwpsq.default)([
                $a9efd1840e3e9616$var$styles.itemDescription
            ]),
            children: description
        });
        return undefined;
    }, [
        description
    ]);
    const renderLozenges = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>{
        if (!lozenges?.length) return null;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5bUrR.default), {
            product: product,
            triggerSubject: "switcherItemLozengeErrorBoundary",
            hideFallbackUI: true,
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                children: [
                    lozenges.map((lozenge, index)=>{
                        const { componentProps: componentProps, label: label } = $a9efd1840e3e9616$var$lozengeData[lozenge];
                        return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                            style: {
                                marginLeft: "var(--ds-space-100, 8px)"
                            },
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3u0c5.default), {
                                ...componentProps,
                                testId: "switcher-item-lozenge",
                                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                    ...label
                                })
                            })
                        }, index);
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jMc3y.RenderTracker), {
                        subject: (0, $jMc3y.SWITCHER_ITEM_LOZENGES_SUBJECT),
                        data: {
                            product: product,
                            lozenges: lozenges,
                            children: children,
                            description: description
                        }
                    })
                ]
            })
        });
    }, [
        lozenges,
        product,
        children,
        description
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fABEI.FadeIn), {
        tag: tag,
        className: (0, $bwpsq.default)([
            $a9efd1840e3e9616$var$styles.fadeIn
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Z96c.default), {
            testId: "switcher-base-item",
            description: itemDescription,
            iconBefore: icon,
            shouldTitleWrap: false,
            shouldDescriptionWrap: false,
            iconAfter: elemAfter,
            target: "_blank",
            href: href ?? '#',
            onClick: (event)=>{
                // To prevent the page from reloading when using a fallback '#' in href, make sure to use preventDefault.
                if (!href) event.preventDefault();
                if (onClick) onClick(event);
            },
            ...rest,
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)("span", {
                className: (0, $bwpsq.default)([
                    $a9efd1840e3e9616$var$styles.titleWrapper,
                    itemDescription && $a9efd1840e3e9616$var$styles.hasDescription
                ]),
                children: [
                    children,
                    renderLozenges
                ]
            })
        })
    });
};
var $a9efd1840e3e9616$export$2e2bcd8739ae039 = $a9efd1840e3e9616$var$SwitcherItem;

});
parcelRegister("11Xk0", function(module, exports) {

$parcel$export(module.exports, "default", () => $089b654fda7941bd$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $089b654fda7941bd$var$messages = (0, $7VHMR.defineMessages)({
    newLozenge: {
        id: 'fabric.atlassianSwitcher.newLozenge',
        defaultMessage: 'New',
        description: 'The lozenge text for a lozenge indicating a new switcher item'
    },
    tryLozenge: {
        id: 'fabric.atlassianSwitcher.tryLozenge',
        defaultMessage: 'Try',
        description: 'Alternative lozenge text for a lozenge indicating a new switcher item'
    },
    sites: {
        id: 'fabric.atlassianSwitcher.sites',
        defaultMessage: '{productName} {numSites, plural, one {site} other {sites}}',
        description: 'The text of a toggle showing or hiding more site options'
    },
    skeletonLoaderAriaLabel: {
        id: 'fabric.atlassianSwitcher.skeletonLoaderAriaLabel',
        defaultMessage: 'The App Switcher is loading',
        description: 'The aria-label for the app switcher skeleton loader primative'
    }
});
var $089b654fda7941bd$export$2e2bcd8739ae039 = $089b654fda7941bd$var$messages;

});

parcelRegister("5bUrR", function(module, exports) {

$parcel$export(module.exports, "default", () => $205dd79fcd22fb9a$export$2e2bcd8739ae039);
/* error-boundary.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");
var $dS3PR = parcelRequire("dS3PR");

var $l1N8i = parcelRequire("l1N8i");

var $eCeGD = parcelRequire("eCeGD");
var $1GGwS = parcelRequire("1GGwS");

var $ousew = parcelRequire("ousew");
var $8RXs9 = parcelRequire("8RXs9");

var $jMc3y = parcelRequire("jMc3y");
var $cb25w = parcelRequire("cb25w");

var $lUEIX = parcelRequire("lUEIX");

var $3JMPn = parcelRequire("3JMPn");

var $2hJAu = parcelRequire("2hJAu");

var $7Ghqv = parcelRequire("7Ghqv");

var $86sdh = parcelRequire("86sdh");

var $cmYVy = parcelRequire("cmYVy");

var $kuB9l = parcelRequire("kuB9l");

var $8ksBL = parcelRequire("8ksBL");
const $205dd79fcd22fb9a$var$TRIGGER_SUBJECT = 'errorBoundary';
const $205dd79fcd22fb9a$var$ACTION_SUBJECT = 'rendered';
const $205dd79fcd22fb9a$var$styles = {
    robotsImg: "_4t3iuuw1",
    trelloErrorImg: "_1bsb11ux _4t3icmky",
    unverifiedUserImg: "_4t3i1w81",
    errorBoundaryBox: "_1e0c1txw _1bah1h6o _2lx21bp4 _y3gn1h6o _19pkoahv _otyroahv",
    errorContent: "_1e0c1txw _4cvr1h6o _2lx21bp4 _y3gn1h6o",
    errorHeading: "_p12fp3fh _19pkxy5q",
    errorMessage: "_p12fp3fh _19pk1ejb",
    loginButton: "_19pk1ejb _1bah1h6o _1wpz1fhb"
};
const $205dd79fcd22fb9a$var$ErrorMessage = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: $205dd79fcd22fb9a$var$styles.errorMessage,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
            as: "p",
            children: props.children
        })
    });
class $205dd79fcd22fb9a$var$ErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidCatch(error) {
        const reason = error instanceof (0, $86sdh.SwitcherLoadError) ? error.reason() : (0, $3JMPn.errorToReason)(error);
        this.setState({
            hasError: true,
            reason: reason
        }, ()=>{
            this.fireOperationalEvent({
                action: $205dd79fcd22fb9a$var$ACTION_SUBJECT,
                attributes: {
                    ...reason,
                    ...this.props.extraAnalyticProps
                }
            });
        });
        this.props.onErrorCallback?.(error);
    }
    renderErrorBody() {
        const { reason: reason } = this.state;
        if (!reason) return;
        if (reason.name === (0, $cmYVy.FETCH_ERROR_NAME)) {
            const isTrello = this.props.product === (0, $7Ghqv.Product).TRELLO;
            if (reason.status === 401) // Not authorised http error
            return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)($205dd79fcd22fb9a$var$ErrorMessage, {
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...(0, $2hJAu.default).errorTextLoggedOut
                        })
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                        xcss: $205dd79fcd22fb9a$var$styles.loginButton,
                        children: isTrello ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1GGwS.default), {
                            href: (0, $lUEIX.getLoginUrl)((0, $7Ghqv.Product).TRELLO),
                            onClick: this.handleLogin,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                ...(0, $2hJAu.default).login
                            })
                        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCeGD.default), {
                            onClick: this.handleLogin,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                ...(0, $2hJAu.default).login
                            })
                        })
                    })
                ]
            });
            if (reason.status === 403) return /*#__PURE__*/ (0, $2OMIu.jsx)($205dd79fcd22fb9a$var$ErrorMessage, {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $2hJAu.default).errorTextUnverified
                })
            });
            return /*#__PURE__*/ (0, $2OMIu.jsx)($205dd79fcd22fb9a$var$ErrorMessage, {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $2hJAu.default).errorTextNetwork
                })
            });
        }
        return /*#__PURE__*/ (0, $2OMIu.jsx)($205dd79fcd22fb9a$var$ErrorMessage, {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $2hJAu.default).errorText
            })
        });
    }
    renderErrorHeading() {
        const { reason: reason } = this.state;
        if (!reason) return;
        if (reason.name === (0, $cmYVy.FETCH_ERROR_NAME) && reason.status === 401) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $2hJAu.default).errorHeadingLoggedOut
        });
        if (reason.name === (0, $cmYVy.FETCH_ERROR_NAME) && reason.status === 403) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $2hJAu.default).errorHeadingUnverified
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $2hJAu.default).errorHeading
        });
    }
    renderErrorImage() {
        const { intl: intl, product: product } = this.props;
        const { reason: reason } = this.state;
        if (product === (0, $7Ghqv.Product).TRELLO) return /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
            src: (0, $kuB9l.default),
            alt: intl.formatMessage((0, $2hJAu.default).errorImageAltText),
            className: (0, $bwpsq.default)([
                $205dd79fcd22fb9a$var$styles.trelloErrorImg
            ])
        });
        if (reason.status === 403) return /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
            src: (0, $8ksBL.default),
            alt: intl.formatMessage((0, $2hJAu.default).errorImageAltText),
            className: (0, $bwpsq.default)([
                $205dd79fcd22fb9a$var$styles.unverifiedUserImg
            ])
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)($205dd79fcd22fb9a$var$RobotImage, {
            alt: intl.formatMessage((0, $2hJAu.default).errorImageAltText),
            className: (0, $bwpsq.default)([
                $205dd79fcd22fb9a$var$styles.robotsImg
            ])
        });
    }
    render() {
        const { hideFallbackUI: hideFallbackUI, children: children } = this.props;
        const { hasError: hasError } = this.state;
        if (hasError && hideFallbackUI) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {});
        if (hasError) return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            "data-testid": "error-boundary",
            className: (0, $bwpsq.default)([
                $205dd79fcd22fb9a$var$styles.errorBoundaryBox
            ]),
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                className: (0, $bwpsq.default)([
                    $205dd79fcd22fb9a$var$styles.errorContent
                ]),
                children: [
                    this.renderErrorImage(),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                        xcss: $205dd79fcd22fb9a$var$styles.errorHeading,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
                            size: "medium",
                            children: this.renderErrorHeading()
                        })
                    }),
                    this.renderErrorBody()
                ]
            })
        });
        return children;
    }
    constructor(...args){
        super(...args), this.state = {
            hasError: false
        }, this.fireOperationalEvent = (payload)=>{
            if (this.props.createAnalyticsEvent) this.props.createAnalyticsEvent({
                eventType: (0, $676c5e519aa5ba55$export$12346a674644c156),
                actionSubject: this.props.triggerSubject || $205dd79fcd22fb9a$var$TRIGGER_SUBJECT,
                ...payload
            }).fire((0, $jMc3y.NAVIGATION_CHANNEL));
        }, this.handleLogin = (_, analyticsEvent)=>{
            analyticsEvent.update({
                eventType: (0, $676c5e519aa5ba55$export$a1562d08625f5d7e),
                actionSubjectId: 'login'
            }).fire((0, $jMc3y.NAVIGATION_CHANNEL));
            if (this.props.product !== (0, $7Ghqv.Product).TRELLO) window.location.reload();
        };
    }
}

const $205dd79fcd22fb9a$var$RobotImage = (props)=>{
    const [imgSrc, setImgSrc] = (0, $5uXOq.useState)();
    (0, $5uXOq.useEffect)(()=>{
        (parcelRequire("12I5S")).then((src)=>setImgSrc(src.default));
    }, []);
    // eslint-disable-next-line jsx-a11y/alt-text
    return /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
        ...props,
        src: imgSrc
    });
};
var $205dd79fcd22fb9a$export$2e2bcd8739ae039 = (0, $cb25w.default)()((0, $8RXs9.default)($205dd79fcd22fb9a$var$ErrorBoundary));

});
parcelRegister("lUEIX", function(module, exports) {

$parcel$export(module.exports, "getLoginUrl", () => $3f150925525e8b07$export$8abe2e83e8d74da2);

var $7Ghqv = parcelRequire("7Ghqv");
var $3f150925525e8b07$export$7dc6752a22ab011a = /*#__PURE__*/ function(Environment) {
    Environment["Staging"] = "stg";
    Environment["Production"] = "prod";
    return Environment;
}({});
const $3f150925525e8b07$export$186d9db1ec46a9ca = (origin = window?.location?.origin)=>[
        'https://trello.com'
    ].includes(origin) ? "prod" : "stg";
const $3f150925525e8b07$var$getProduct = (product)=>{
    if (product) {
        const lowerJira = (0, $7Ghqv.Product).JIRA.toLowerCase();
        const lowerProduct = product.toLowerCase();
        if (lowerProduct.includes(lowerJira)) return lowerJira;
        return lowerProduct;
    }
};
const $3f150925525e8b07$export$8abe2e83e8d74da2 = (productType, env = $3f150925525e8b07$export$186d9db1ec46a9ca(), continueUrl = String(window.location), loginHint)=>{
    const baseUrl = env === "prod" ? 'https://id.atlassian.com/login' : 'https://id.stg.internal.atlassian.com/login';
    const product = $3f150925525e8b07$var$getProduct(productType);
    return `${baseUrl}?continue=${encodeURIComponent(continueUrl)}${product ? `&application=${encodeURIComponent(product)}` : ''}
  ${loginHint ? `&login_hint=${encodeURIComponent(loginHint)}` : ''}`;
};

});

parcelRegister("2hJAu", function(module, exports) {

$parcel$export(module.exports, "default", () => $45ca83ffaf39f0d0$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $45ca83ffaf39f0d0$var$messages = (0, $7VHMR.defineMessages)({
    emptyStateExploreProductsTitle: {
        id: 'fabric.atlassianSwitcher.emptyState.exploreProducts.title',
        defaultMessage: 'Get started with cloud',
        description: 'The title text for the empty state explore products content, which prompts users to try new products.'
    },
    emptyStateExploreProductsBody: {
        id: 'fabric.atlassianSwitcher.emptyState.exploreProducts.body',
        defaultMessage: 'Try a product to start collaborating with your team.',
        description: 'The body text for the empty state explore products content, which prompts users to try new products.'
    },
    emptyStateExploreProductsLink: {
        id: 'fabric.atlassianSwitcher.emptyState.exploreProducts.link',
        defaultMessage: 'Explore products',
        description: 'The text for the empty state explore products link, which prompts users to try new products.'
    },
    home: {
        id: 'fabric.atlassianSwitcher.atlassianHome',
        defaultMessage: 'Home',
        description: 'The text of a link redirecting the user to the Home site'
    },
    atlassianHome: {
        id: 'fabric.atlassianSwitcher.home',
        defaultMessage: 'Atlassian Home',
        description: 'The text of a link redirecting the user to the Home site'
    },
    atlassianStart: {
        id: 'fabric.atlassianSwitcher.start',
        defaultMessage: 'Atlassian Start',
        description: 'The text of a link redirecting the user to the Start site'
    },
    assets: {
        id: 'fabric.atlassianSwitcher.assets',
        defaultMessage: 'Assets',
        description: 'The text of a link redirecting the user to the Assets'
    },
    analytics: {
        id: 'fabric.atlassianSwitcher.analytics',
        defaultMessage: 'Analytics',
        description: 'The text of a link redirecting the user to the Analytics'
    },
    companyHub: {
        id: 'fabric.atlassianSwitcher.companyHub',
        defaultMessage: 'Company Hub',
        description: 'The text of a link redirecting the user to the Company Hub'
    },
    goals: {
        id: 'fabric.atlassianSwitcher.goals',
        defaultMessage: 'Goals',
        description: 'The text of a link redirecting the user to the Goals'
    },
    teams: {
        id: 'fabric.atlassianSwitcher.teams',
        defaultMessage: 'Teams',
        description: 'The text of a link redirecting the user to the Teams'
    },
    search: {
        id: 'fabric.atlassianSwitcher.search',
        defaultMessage: 'Search',
        description: 'The text of a link redirecting the user to the Search'
    },
    chat: {
        id: 'fabric.atlassianSwitcher.chat',
        defaultMessage: 'Chat',
        description: 'The text of a link redirecting the user to the Chat'
    },
    studio: {
        id: 'fabric.atlassianSwitcher.studio',
        defaultMessage: 'Studio',
        description: 'The text of a link redirecting the user to the Studio'
    },
    more: {
        id: 'fabric.atlassianSwitcher.more',
        defaultMessage: 'More',
        description: 'In a context in which users are able to view predefined custom links, this text is the title of the section displaying all existing custom links.'
    },
    manageList: {
        id: 'fabric.atlassianSwitcher.manageList',
        defaultMessage: 'Manage list',
        description: 'This text is for the action for a user to manage the values present in an editable list of links.'
    },
    jiraProject: {
        id: 'fabric.atlassianSwitcher.jiraProject',
        defaultMessage: 'Jira project',
        description: 'In a context in which several items are listed , this text describes that the specific type of a given item is a Jira project'
    },
    confluenceSpace: {
        id: 'fabric.atlassianSwitcher.confluenceSpace',
        defaultMessage: 'Confluence space',
        description: 'In a context in which several items are listed , this text describes that the specific type of a given item is a Confluence space'
    },
    errorEmptyPartialResults: {
        id: 'fabric.atlassianSwitcher.errorEmptyPartialResults',
        defaultMessage: "We can't display your apps right now.",
        description: 'Heading of the error message when available apps returns a partial result and no sites'
    },
    errorHeading: {
        id: 'fabric.atlassianSwitcher.errorHeading',
        defaultMessage: "Something\u2019s gone wrong",
        description: 'Heading of the error screen which is shown when an unknown error happens in the Atlassian Switcher. Usually due to failed network requests.'
    },
    errorText: {
        id: 'fabric.atlassianSwitcher.errorText',
        defaultMessage: "We keep track of these errors, but feel free to contact us if refreshing doesn\u2019t fix things",
        description: 'Text that is displayed when an unknown error happens in the Atlassian Switcher.'
    },
    errorImageAltText: {
        id: 'fabric.atlassianSwitcher.errorImageAltText',
        defaultMessage: 'A broken robot and a number of people busy fixing it.',
        description: 'Text displayed as alt text when an error occurs in the Atlassian Switcher'
    },
    errorTextNetwork: {
        id: 'fabric.atlassianSwitcher.errorTextNetwork',
        defaultMessage: "We couldn\u2019t load this list. Please reload the page and try again.",
        description: 'Text that is displayed when we detect a network issue.'
    },
    errorHeadingLoggedOut: {
        id: 'fabric.atlassianSwitcher.errorHeadingLoggedOut',
        defaultMessage: 'Your Atlassian account is logged out',
        description: 'Heading of the error screen which is shown when an unknown error happens in the Atlassian Switcher. Usually due to failed network requests.'
    },
    errorTextLoggedOut: {
        id: 'fabric.atlassianSwitcher.errorTextLoggedOut',
        defaultMessage: 'Log in again to use the Atlassian\u00A0switcher.',
        description: 'Text that is displayed when we detect user is logged out.'
    },
    errorHeadingUnverified: {
        id: 'fabric.atlassianSwitcher.errorHeadingUnverified',
        defaultMessage: 'Your account is unverified',
        description: 'Heading that is displayed when we detect user account is unverified.'
    },
    errorPartialResults: {
        id: 'fabric.atlassianSwitcher.errorPartialResults',
        defaultMessage: "We can't display some of your apps right now.",
        description: 'Heading of the error message when available apps returns a partial result and 1 or more sites'
    },
    errorPartialResultsRefresh: {
        id: 'fabric.atlassianSwitcher.errorPartialResultsRefresh',
        defaultMessage: 'Refresh the page, or try again later.',
        description: 'Subtitle of the error message when available products returns a partial result'
    },
    errorTextUnverified: {
        id: 'fabric.atlassianSwitcher.errorTextUnverified',
        defaultMessage: 'Please confirm your email address to view a list of available products.',
        description: 'Text that is displayed when we detect user account is unverified.'
    },
    login: {
        id: 'fabric.atlassianSwitcher.login',
        defaultMessage: 'Log in',
        description: 'Text in log in button.'
    },
    productDescriptionConfluence: {
        id: 'fabric.atlassianSwitcher.product.description.confluence',
        defaultMessage: 'Document collaboration',
        description: 'Text displayed under the Confluence product recommendation.'
    },
    productDescriptionJiraServiceManagement: {
        id: 'fabric.atlassianSwitcher.product.description.jsm',
        defaultMessage: 'Collaborative IT service management',
        description: 'Text displayed under the Jira Service Management product recommendation.'
    },
    productDescriptionJiraSoftware: {
        id: 'fabric.atlassianSwitcher.product.description.jsw',
        defaultMessage: 'Project and issue tracking',
        description: 'Text displayed under the Jira Software product recommendation.'
    },
    productDescriptionOpsgenie: {
        id: 'fabric.atlassianSwitcher.product.description.opsgenie',
        defaultMessage: 'Modern incident management',
        description: 'Text displayed under the Opsgenie product recommendation.'
    },
    productDescriptionCompass: {
        id: 'fabric.atlassianSwitcher.product.description.compass',
        defaultMessage: 'Component manager',
        description: 'Text displayed under the Compass product recommendation.'
    },
    join: {
        id: 'fabric.atlassianSwitcher.join',
        defaultMessage: 'Join',
        description: 'Section Header in Atlassian Switcher. To set the expectation of what items would be shown in following section. Shown when an user has at least one joinable site via Domain Enabled Sign up with common collaborators.'
    }
});
var $45ca83ffaf39f0d0$export$2e2bcd8739ae039 = $45ca83ffaf39f0d0$var$messages;

});

parcelRegister("86sdh", function(module, exports) {

$parcel$export(module.exports, "SwitcherLoadErrorReason", () => $8b4037d96fe40f63$export$2c6136f6e27d3fdd);
$parcel$export(module.exports, "SwitcherLoadError", () => $8b4037d96fe40f63$export$ff0950b3c2e7f03e);

var $3JMPn = parcelRequire("3JMPn");
var $8b4037d96fe40f63$export$2c6136f6e27d3fdd = /*#__PURE__*/ function(SwitcherLoadErrorReason) {
    SwitcherLoadErrorReason["AVAILABLE_PRODUCTS"] = "availableProducts";
    SwitcherLoadErrorReason["PRODUCT_CONFIGURATION"] = "productConfiguration";
    return SwitcherLoadErrorReason;
}({});
class $8b4037d96fe40f63$export$ff0950b3c2e7f03e extends Error {
    constructor(errorReason, resultError){
        super();
        this.errorReason = errorReason;
        this.resultError = resultError;
    }
    reason() {
        const potentialResultError = this.resultError;
        return {
            ...(0, $3JMPn.errorToReason)(potentialResultError.error ? potentialResultError.error : this.resultError),
            source: this.errorReason
        };
    }
}

});

parcelRegister("kuB9l", function(module, exports) {

$parcel$export(module.exports, "default", () => $03efcb50a6bfc07f$export$2e2bcd8739ae039);
var $03efcb50a6bfc07f$export$2e2bcd8739ae039 = 'data:image/svg+xml;base64,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';

});

parcelRegister("8ksBL", function(module, exports) {

$parcel$export(module.exports, "default", () => $921547bd229f5a4a$export$2e2bcd8739ae039);
var $921547bd229f5a4a$export$2e2bcd8739ae039 = `data:image/svg+xml;base64,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`;

});

parcelRegister("12I5S", function(module, exports) {

let $0c282e7a89623397$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0c282e7a89623397$var$load("4zcSg").then(()=>parcelRequire('dvSPx'));

});



parcelRegister("hWyMn", function(module, exports) {

$parcel$export(module.exports, "useExperienceSuccess", () => $bbee84552e9ea3c0$export$e94f0da4fc0603c6);
$parcel$export(module.exports, "useExperienceRenderAndMountMark", () => $bbee84552e9ea3c0$export$fb30551804b67d63);
/* eslint-disable no-console */ 
var $9dCRm = parcelRequire("9dCRm");

var $5uXOq = parcelRequire("5uXOq");

var $fH0uJ = parcelRequire("fH0uJ");
function $bbee84552e9ea3c0$export$675e0d25df38d426(experienceName, customStartTime) {
    const experienceTracker = (0, $9dCRm.useExperienceTracker)();
    (0, $fH0uJ.useOnceImmediately)(()=>experienceTracker.start(experienceName, customStartTime));
}
function $bbee84552e9ea3c0$export$e94f0da4fc0603c6(experience, attributes) {
    const experienceTracker = (0, $9dCRm.useExperienceTracker)();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $5uXOq.useLayoutEffect)(()=>experienceTracker.success(experience, attributes), []);
}
function $bbee84552e9ea3c0$export$fb30551804b67d63(mark) {
    const experienceTracker = (0, $9dCRm.useExperienceTracker)();
    (0, $fH0uJ.useOnceImmediately)(()=>experienceTracker.markStart(mark));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $5uXOq.useLayoutEffect)(()=>experienceTracker.markEnd(mark), []);
}

});
parcelRegister("fH0uJ", function(module, exports) {

$parcel$export(module.exports, "useSingleton", () => $6e9973cd590aa017$export$abf4268d2dd55708);
$parcel$export(module.exports, "useOnceImmediately", () => $6e9973cd590aa017$export$ad4f8d0eee7a0e24);

var $5uXOq = parcelRequire("5uXOq");
function $6e9973cd590aa017$export$abf4268d2dd55708(builder) {
    const ref = (0, $5uXOq.useRef)();
    if (!ref.current) ref.current = builder();
    return ref.current;
}
function $6e9973cd590aa017$export$ad4f8d0eee7a0e24(callback) {
    const wasCalledRef = (0, $5uXOq.useRef)(false);
    const result = (0, $5uXOq.useRef)();
    if (!wasCalledRef.current) {
        wasCalledRef.current = true;
        result.current = callback();
    }
    return result.current;
}

});



parcelRegister("99tqu", function(module, exports) {

$parcel$export(module.exports, "default", () => $adb5f42f21ad260c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $i5FdW = parcelRequire("i5FdW");
var $koVbs = parcelRequire("koVbs");

var $7Fgjd = parcelRequire("7Fgjd");


var $jMc3y = parcelRequire("jMc3y");

var $2NMNM = parcelRequire("2NMNM");






























function $adb5f42f21ad260c$var$fetchLanguageFile(locale) {
    switch(locale){
        case 'cs-CZ':
        case 'cs':
            return (parcelRequire("KNW7G"));
        case 'da-DK':
        case 'da':
            return (parcelRequire("616iu"));
        case 'de-DE':
        case 'de':
            return (parcelRequire("eVwst"));
        case 'en-GB':
            return (parcelRequire("aKczi"));
        case 'en-ZZ':
            return (parcelRequire("aNptR"));
        case 'en-US':
        case 'en':
            return (parcelRequire("6vz2D"));
        case 'es-ES':
        case 'es':
            return (parcelRequire("cFZTy"));
        case 'et':
            return (parcelRequire("kudIQ"));
        case 'fi-FI':
        case 'fi':
            return (parcelRequire("4EdQ1"));
        case 'fr-FR':
        case 'fr':
            return (parcelRequire("eAJNz"));
        case 'hu-HU':
        case 'hu':
            return (parcelRequire("f8s6f"));
        case 'is':
            return (parcelRequire("6fB4T"));
        case 'it-IT':
        case 'it':
            return (parcelRequire("3mSXm"));
        case 'ja-JP':
        case 'ja':
            return (parcelRequire("g0FP0"));
        case 'ko-KR':
        case 'ko':
            return (parcelRequire("hEHZ9"));
        case 'nb-NB':
        case 'nb':
            return (parcelRequire("61WSM"));
        case 'nl-NL':
        case 'nl':
            return (parcelRequire("bY9FY"));
        case 'pl-PL':
        case 'pl':
            return (parcelRequire("hHIVP"));
        case 'pt-BR':
        case 'pt':
            return (parcelRequire("1D1tZ"));
        case 'pt-PT':
            return (parcelRequire("dZx9E"));
        case 'ro':
            return (parcelRequire("ceoaX"));
        case 'ru-RU':
        case 'ru':
            return (parcelRequire("2ix3o"));
        case 'sk':
            return (parcelRequire("aiyfY"));
        case 'sv-SE':
        case 'sv':
            return (parcelRequire("5r0lB"));
        case 'th-TH':
        case 'th':
            return (parcelRequire("hmMXx"));
        case 'tr-TR':
        case 'tr':
            return (parcelRequire("fn2OB"));
        case 'uk-UK':
        case 'uk':
            return (parcelRequire("8mj86"));
        case 'vi-VI':
        case 'vi':
            return (parcelRequire("bUJp9"));
        case 'zh-TW':
        case 'zh-HK':
            return (parcelRequire("jMwqU"));
        case 'zh-ZH':
        case 'zh-CN':
        case 'zh':
            return (parcelRequire("31j8h"));
    }
    throw Error(`Unable to find translation for locale ${locale}`);
}
const $adb5f42f21ad260c$var$SwitcherIntlProvider = ({ children: children })=>{
    const { locale: locale } = (0, $koVbs.default)();
    // Intl.Locale doesn't like underscores
    const [isLocaleLoaded, setIsLocaleLoaded] = (0, $5uXOq.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [messages, setMessages] = (0, $5uXOq.useState)({});
    (0, $5uXOq.useEffect)(()=>{
        async function startToFetchMessagesByLocale() {
            const intlLocale = new Intl.Locale(locale.replace('_', '-'));
            try {
                const module = await $adb5f42f21ad260c$var$fetchLanguageFile(intlLocale.toString());
                const newMessages = module.default || module;
                setMessages(newMessages);
                setIsLocaleLoaded(true);
            } catch (e) {
                // fail to download message and do nothing because UI will use default language (English) to render
                setIsLocaleLoaded(true);
                createAnalyticsEvent({
                    eventType: (0, $676c5e519aa5ba55$export$12346a674644c156),
                    action: 'not_loaded',
                    actionSubject: 'i18n',
                    attributes: {
                        country: intlLocale.region,
                        language: intlLocale.language
                    }
                }).fire((0, $jMc3y.NAVIGATION_CHANNEL));
            }
        }
        startToFetchMessagesByLocale();
    }, [
        locale,
        createAnalyticsEvent
    ]);
    // delay loading until we have attempted to load the locale data otherwise we can flick from English to the user's language
    if (!isLocaleLoaded) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7Fgjd.default), {});
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
        locale: locale,
        messages: messages,
        children: children
    }, locale);
};
var $adb5f42f21ad260c$export$2e2bcd8739ae039 = $adb5f42f21ad260c$var$SwitcherIntlProvider;

});
parcelRegister("KNW7G", function(module, exports) {

let $08cb08558c7e4ba6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $08cb08558c7e4ba6$var$load("tK61O").then(()=>parcelRequire('lsGkk'));

});

parcelRegister("616iu", function(module, exports) {

let $4617b88b7b7ec3d5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4617b88b7b7ec3d5$var$load("gfZHZ").then(()=>parcelRequire('dQGRb'));

});

parcelRegister("eVwst", function(module, exports) {

let $addf91187cb55791$var$load = (parcelRequire("28QjX"))(4);
module.exports = $addf91187cb55791$var$load("gR5vk").then(()=>parcelRequire('iedeb'));

});

parcelRegister("aKczi", function(module, exports) {

let $7d27f3167fdb36c0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7d27f3167fdb36c0$var$load("lCLmp").then(()=>parcelRequire('ifzLW'));

});

parcelRegister("aNptR", function(module, exports) {

let $7dc23eeec5ad409e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7dc23eeec5ad409e$var$load("ke8sA").then(()=>parcelRequire('1xexx'));

});

parcelRegister("6vz2D", function(module, exports) {

let $4bd0d1dcc059fabe$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4bd0d1dcc059fabe$var$load("hE3hC").then(()=>parcelRequire('2ItOG'));

});

parcelRegister("cFZTy", function(module, exports) {

let $93a9536cde451f21$var$load = (parcelRequire("28QjX"))(4);
module.exports = $93a9536cde451f21$var$load("8PbNr").then(()=>parcelRequire('4AltF'));

});

parcelRegister("kudIQ", function(module, exports) {

let $eea140ef6641fb31$var$load = (parcelRequire("28QjX"))(4);
module.exports = $eea140ef6641fb31$var$load("6gJKb").then(()=>parcelRequire('9wotR'));

});

parcelRegister("4EdQ1", function(module, exports) {

let $3625a1caa684b5a7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3625a1caa684b5a7$var$load("3ohaj").then(()=>parcelRequire('bxuAW'));

});

parcelRegister("eAJNz", function(module, exports) {

let $a9f7f41a0050ad79$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a9f7f41a0050ad79$var$load("92y7G").then(()=>parcelRequire('byyT7'));

});

parcelRegister("f8s6f", function(module, exports) {

let $b04d6664af6108e6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b04d6664af6108e6$var$load("ccEIn").then(()=>parcelRequire('4Zoc6'));

});

parcelRegister("6fB4T", function(module, exports) {

let $48d0e7b17a87ca22$var$load = (parcelRequire("28QjX"))(4);
module.exports = $48d0e7b17a87ca22$var$load("iuHTy").then(()=>parcelRequire('02NP0'));

});

parcelRegister("3mSXm", function(module, exports) {

let $273e0e6255daf5a9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $273e0e6255daf5a9$var$load("bAegL").then(()=>parcelRequire('hUelS'));

});

parcelRegister("g0FP0", function(module, exports) {

let $ba7d1659f431a0c9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ba7d1659f431a0c9$var$load("2vCQH").then(()=>parcelRequire('6yL5N'));

});

parcelRegister("hEHZ9", function(module, exports) {

let $cda84aae38cbb10f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cda84aae38cbb10f$var$load("7AiJy").then(()=>parcelRequire('5qJOA'));

});

parcelRegister("61WSM", function(module, exports) {

let $464082e516c9ca89$var$load = (parcelRequire("28QjX"))(4);
module.exports = $464082e516c9ca89$var$load("k9OMD").then(()=>parcelRequire('428T7'));

});

parcelRegister("bY9FY", function(module, exports) {

let $8b6ccdc5f8c8a6d7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8b6ccdc5f8c8a6d7$var$load("h4hgp").then(()=>parcelRequire('lNp1U'));

});

parcelRegister("hHIVP", function(module, exports) {

let $ce394e4c857f5bdc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ce394e4c857f5bdc$var$load("kcoS1").then(()=>parcelRequire('bi7vZ'));

});

parcelRegister("1D1tZ", function(module, exports) {

let $12fa9566457e1892$var$load = (parcelRequire("28QjX"))(4);
module.exports = $12fa9566457e1892$var$load("2AAcl").then(()=>parcelRequire('4yqs9'));

});

parcelRegister("dZx9E", function(module, exports) {

let $a2fab0ac77118621$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a2fab0ac77118621$var$load("7qLIo").then(()=>parcelRequire('6NDIz'));

});

parcelRegister("ceoaX", function(module, exports) {

let $8e798b9f24cf23a9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8e798b9f24cf23a9$var$load("cfaqj").then(()=>parcelRequire('cikNC'));

});

parcelRegister("2ix3o", function(module, exports) {

let $1ac6e6fd1321737d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1ac6e6fd1321737d$var$load("8LHSz").then(()=>parcelRequire('ismI1'));

});

parcelRegister("aiyfY", function(module, exports) {

let $77f6287f0b8f408b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $77f6287f0b8f408b$var$load("fK0uX").then(()=>parcelRequire('4Img5'));

});

parcelRegister("5r0lB", function(module, exports) {

let $3f4fbe56041c5493$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3f4fbe56041c5493$var$load("4XTzY").then(()=>parcelRequire('5Bvqf'));

});

parcelRegister("hmMXx", function(module, exports) {

let $ca4a780e9f3b9cd7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ca4a780e9f3b9cd7$var$load("1Lp80").then(()=>parcelRequire('6Yr1v'));

});

parcelRegister("fn2OB", function(module, exports) {

let $b30b300506a894e8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b30b300506a894e8$var$load("8euIo").then(()=>parcelRequire('2jl59'));

});

parcelRegister("8mj86", function(module, exports) {

let $615f37965b49b313$var$load = (parcelRequire("28QjX"))(4);
module.exports = $615f37965b49b313$var$load("jPTPs").then(()=>parcelRequire('lOfXr'));

});

parcelRegister("bUJp9", function(module, exports) {

let $8ac8251964d2cee5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8ac8251964d2cee5$var$load("68CyJ").then(()=>parcelRequire('2Uk7p'));

});

parcelRegister("jMwqU", function(module, exports) {

let $e66ba88ac8b043be$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e66ba88ac8b043be$var$load("jM3fB").then(()=>parcelRequire('eTi98'));

});

parcelRegister("31j8h", function(module, exports) {

let $23304e7014cdc77a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $23304e7014cdc77a$var$load("99L3k").then(()=>parcelRequire('47XFm'));

});


parcelRegister("gTrd0", function(module, exports) {

$parcel$export(module.exports, "JiraProductDiscoveryIcon", () => $9298817d8a027e01$export$21bfbeb62fdcce8d);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7017771ac5780ac52b5d2d0fc081d840>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3Aqws = parcelRequire("3Aqws");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $9298817d8a027e01$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#c97cf4)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M13.467 4.882a9.47 9.47 0 0 0 5.422 0c.159-.035.265.07.23.229-.513 1.85-.513 3.558 0 5.408.035.14-.072.264-.23.211a10.1 10.1 0 0 0-5.422 0c-.142.053-.265-.07-.212-.211.476-1.85.476-3.559 0-5.408-.053-.159.07-.264.212-.23m.724 6.553v.3c0 1.39-.972 2.412-2.173 2.412a2.153 2.153 0 0 1-2.154-2.166c0-1.198.971-2.15 2.331-2.15h.353V5.62c-.176-.017-.353-.017-.53-.017a6.387 6.387 0 0 0-6.393 6.394 6.37 6.37 0 0 0 6.393 6.377c3.533 0 6.411-2.854 6.411-6.377v-.563z"/>
</svg>
`;
const $9298817d8a027e01$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-5.981 5.604a6.387 6.387 0 0 0-6.394 6.394 6.373 6.373 0 0 0 6.394 6.377c3.532 0 6.41-2.854 6.41-6.377v-.563H14.19v.3c0 1.39-.97 2.412-2.171 2.413a2.154 2.154 0 0 1-2.156-2.168c0-1.197.973-2.148 2.332-2.148h.353v-4.21c-.177-.018-.353-.018-.53-.018m6.87-.722a9.47 9.47 0 0 1-5.422 0c-.141-.035-.265.07-.212.228.477 1.85.477 3.559 0 5.409-.053.14.07.264.212.211a10.1 10.1 0 0 1 5.422 0c.159.053.265-.07.23-.211-.513-1.85-.513-3.56 0-5.409.034-.158-.072-.263-.23-.228"/>
</svg>
`;
function $9298817d8a027e01$export$21bfbeb62fdcce8d({ size: size, appearance: appearance = 'brand', iconColor: iconColor, label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Aqws.IconWrapper), {
        svg: $9298817d8a027e01$var$svg,
        customThemeSvg: $9298817d8a027e01$var$customThemeSvg,
        size: size,
        appearance: appearance,
        iconColor: iconColor,
        label: label || 'Jira Product Discovery',
        testId: testId
    });
}

});

parcelRegister("goJA6", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementIcon", () => $b7bf9194809d8218$export$3c6158790f5e01c4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f20eaf1874c6ccbf812f921695a8d7ed>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3Aqws = parcelRequire("3Aqws");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $b7bf9194809d8218$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M13.744 10.156h4.578c.688 0 .922.654.503 1.174l-7.16 8.837c-2.314-1.845-2.096-4.763-.402-6.892zm-3.538 3.521H5.63c-.688 0-.923-.654-.504-1.173l7.16-8.837c2.315 1.844 2.063 4.728.386 6.875z"/>
</svg>
`;
const $b7bf9194809d8218$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-4.256 10.156-2.481 3.12c-1.694 2.129-1.912 5.047.402 6.891l7.16-8.837c.42-.52.185-1.174-.503-1.174zm-8.619 2.348c-.419.52-.183 1.174.504 1.174h4.577l2.465-3.136c1.677-2.146 1.928-5.03-.386-6.875z"/>
</svg>
`;
function $b7bf9194809d8218$export$3c6158790f5e01c4({ size: size, appearance: appearance = 'brand', iconColor: iconColor, label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Aqws.IconWrapper), {
        svg: $b7bf9194809d8218$var$svg,
        customThemeSvg: $b7bf9194809d8218$var$customThemeSvg,
        size: size,
        appearance: appearance,
        iconColor: iconColor,
        label: label || 'Jira Service Management',
        testId: testId
    });
}

});

parcelRegister("kaR8K", function(module, exports) {

$parcel$export(module.exports, "JiraIcon", () => $be2c9fe02cc4b142$export$c4b5b1f965d8b3eb);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6ed28081978a6c48a565a9d868180d1c>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3Aqws = parcelRequire("3Aqws");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $be2c9fe02cc4b142$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1868db)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M9.051 15.434H7.734c-1.988 0-3.413-1.218-3.413-3h7.085c.367 0 .605.26.605.63v7.13c-1.772 0-2.96-1.435-2.96-3.434zm3.5-3.543h-1.318c-1.987 0-3.413-1.196-3.413-2.978h7.085c.367 0 .627.239.627.608v7.13c-1.772 0-2.981-1.435-2.981-3.434zm3.52-3.522h-1.317c-1.987 0-3.413-1.217-3.413-3h7.085c.367 0 .605.262.605.61v7.129c-1.771 0-2.96-1.435-2.96-3.434z"/>
</svg>
`;
const $be2c9fe02cc4b142$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM4.321 12.434c0 1.782 1.425 3 3.412 3h1.319v1.326c0 2 1.188 3.433 2.959 3.433v-7.129c0-.369-.238-.63-.605-.63zm3.5-3.52c0 1.781 1.425 2.977 3.412 2.977h1.318v1.326c0 2 1.21 3.433 2.98 3.433V9.521c0-.369-.259-.608-.626-.608zm3.52-3.544c0 1.782 1.426 3 3.413 3h1.317v1.304c0 2 1.188 3.433 2.96 3.433V5.98c0-.348-.238-.609-.605-.609z"/>
</svg>
`;
function $be2c9fe02cc4b142$export$c4b5b1f965d8b3eb({ size: size, appearance: appearance = 'brand', iconColor: iconColor, label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Aqws.IconWrapper), {
        svg: $be2c9fe02cc4b142$var$svg,
        customThemeSvg: $be2c9fe02cc4b142$var$customThemeSvg,
        size: size,
        appearance: appearance,
        iconColor: iconColor,
        label: label || 'Jira',
        testId: testId
    });
}

});

parcelRegister("5WNqJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2bf421fa15614840$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $2bf421fa15614840$var$messages = (0, $7VHMR.defineMessages)({
    autoProvisionedSwitcherItemConfluenceDescription: {
        id: 'fabric.atlassianSwitcher.autoProvConfluenceUiUpdateExperimentDescription',
        defaultMessage: 'Document collaboration',
        description: 'When a user gets auto-provisioned Confluence, this is the text that will be in the description of the new Switcher Item'
    },
    atlassianStart: {
        id: 'fabric.atlassianSwitcher.start',
        defaultMessage: 'Atlassian Start',
        description: 'The text of a link redirecting the user to the Start site'
    },
    atlassianStartAriaLabel: {
        id: 'fabric.atlassianSwitcher.startAriaLabel',
        defaultMessage: 'Atlassian Start opens in a new tab',
        description: 'Aria-label for a link redirecting the user to the Start site'
    },
    switchTo: {
        id: 'fabric.atlassianSwitcher.switchTo',
        defaultMessage: 'Switch to',
        description: 'In a context in which users are able to switch between products, this text is the title of the category displaying the products the user is able to switch to.'
    },
    switchToTooltip: {
        id: 'fabric.atlassianSwitcher.switchToTooltip',
        defaultMessage: "Switch to\u2026",
        description: 'This text appears as a tooltip when a user hovers over the atlassian switcher icon before clicking on it.'
    },
    yourApps: {
        id: 'fabric.atlassianSwitcher.yourApps',
        defaultMessage: 'Your apps',
        description: 'In a context in which users are able to switch between products, this text is the title of the category displaying the products the user is able to switch to.'
    },
    yourAppsTooltip: {
        id: 'fabric.atlassianSwitcher.yourAppsTooltip',
        defaultMessage: "Your apps\u2026",
        description: 'This text appears as a tooltip when a user hovers over the atlassian switcher icon before clicking on it.'
    },
    switchSitesOrAppsTooltip: {
        id: 'fabric.atlassianSwitcher.switchSitesOrAppsTooltip',
        defaultMessage: 'Switch sites or apps',
        description: 'This text appears as a tooltip when a user hovers over the atlassian switcher icon before clicking on it.'
    },
    jwmInactiveSwitcherWithJSWItemDescription: {
        id: 'fabric.atlassianSwitcher.jwmInactiveSwitcherWithJSWItemDescription',
        defaultMessage: 'Manage business projects, free with Jira Software',
        description: 'Description when a user has never used Jira Work Management but Jira Work Management has been activated and they have a Jira Software License'
    },
    jwmInactiveSwitcherWithDefaultItemDescription: {
        id: 'fabric.atlassianSwitcher.jwmInactiveSwitcherWithDefaultItemDescription',
        defaultMessage: 'Manage projects for business teams',
        description: 'Description when a user has never used Jira Work Management but Jira Work Management has been activated'
    },
    organisationsLabel: {
        id: 'fabric.atlassianSwitcher.organisationsLabel',
        defaultMessage: 'Organisations',
        description: 'The label of organisation tab list'
    },
    switcherModalLabel: {
        id: 'fabric.atlassianSwitcher.modalLabel',
        defaultMessage: 'Atlassian App Switcher',
        description: 'The label of the switcher modal'
    },
    resizeBarLabel: {
        id: 'fabric.atlassianSwitcher.resizeBarLabel',
        defaultMessage: 'Resize app switcher',
        description: 'The label of the resize bar'
    },
    resizeBarTooltipCollapsed: {
        id: 'fabric.atlassianSwitcher.resizeBarTooltipCollapsed',
        defaultMessage: 'Drag to resize{separator}Press to expand',
        description: 'The label of the resize bar tooltip when in collapsed state'
    },
    resizeBarTooltipExpanded: {
        id: 'fabric.atlassianSwitcher.resizeBarTooltipExpanded',
        defaultMessage: 'Drag to resize{separator}Press to collapse',
        description: 'The label of the resize bar tooltip when in expanded state'
    },
    resizeBarValueTextLabel: {
        id: 'fabric.atlassianSwitcher.resizeBarValueTextLabel',
        defaultMessage: 'Width',
        description: 'The value text label of the resize bar'
    },
    joinStatusText: {
        id: 'fabric.atlassianSwitcher.joinStatusText',
        defaultMessage: 'Join',
        description: 'The text displayed alongside a product to indicate the product is joinable.'
    },
    instantAccessStatusText: {
        id: 'fabric.atlassianSwitcher.instantAccessStatusText',
        defaultMessage: 'Instant access',
        description: 'The text displayed alongside a product to indicate the product is joinable.'
    },
    joinTeamStatusText: {
        id: 'fabric.atlassianSwitcher.joinTeamStatusText',
        defaultMessage: 'Join team',
        description: 'The text displayed alongside a product to indicate the product is joinable.'
    },
    jpdDescriptionText: {
        id: 'fabric.atlassianSwitcher.jpdDescriptionText',
        defaultMessage: 'Prioritize and plan new ideas',
        description: 'The description displayed for Jira Product Discovery.'
    },
    confluenceDescriptionText: {
        id: 'fabric.atlassianSwitcher.confluenceDescriptionText',
        defaultMessage: 'Document and collaborate',
        description: 'The description displayed for Confluence.'
    },
    jiraDescriptionText: {
        id: 'fabric.atlassianSwitcher.jiraDescriptionText',
        defaultMessage: 'Plan and track project delivery',
        description: 'The description displayed for Jira.'
    },
    jsmDescriptionText: {
        id: 'fabric.atlassianSwitcher.jsmDescriptionText',
        defaultMessage: 'Automate and deliver IT support',
        description: 'The description displayed for Jira Service Management.'
    },
    requestAccessStatusText: {
        id: 'fabric.atlassianSwitcher.requestAccessStatusText',
        defaultMessage: 'Request access',
        description: 'The text displayed alongside a product to indicate the user can request access for the product.'
    },
    requestSentStatusText: {
        id: 'fabric.atlassianSwitcher.requestSentStatusText',
        defaultMessage: 'Request sent',
        description: 'The text displayed alongside a product to indicate the user has requested access to the product.'
    },
    requestAccessPendingRequestFlagTitle: {
        id: 'fabric.atlassianSwitcher.successFlag.title',
        defaultMessage: 'Access request sent to Admin',
        description: 'Title shown when user has requested access to a product but the request is pending.'
    },
    requestAccessPendingRequestFlagDescription: {
        id: 'fabric.atlassianSwitcher.successFlag.description',
        defaultMessage: "You'll get an email once it's approved",
        description: 'Description shown when user has requested access to a product but the request is pending'
    },
    requestAccessPendingRequestFlagErrorTitle: {
        id: 'fabric.atlassianSwitcher.errorFlag.title',
        defaultMessage: `We couldn't add you to {product}`,
        description: 'Title shown when user has requested access to a product but the request has failed.'
    },
    requestAccessPendingRequestFlagErrorDescription: {
        id: 'fabric.atlassianSwitcher.errorFlag.description',
        defaultMessage: "Try again in a few minutes. If you still aren't able to join, <a>contact support</a>.",
        description: 'Description shown when user has requested access to a product but the request is pending'
    },
    // TBLZ-2123: Growth - Trailblazers experiment - More info at go/trailblazerexperiments
    experimentNudgeToJiraConfluenceDescription: {
        id: 'fabric.atlassianSwitcher.experimentNudgeToJiraConfluenceDescription',
        defaultMessage: 'Bring your projects and pages closer',
        description: 'Description for Jira when viewed from Confluence to encourage using Jira and Confluence together'
    },
    experimentNudgeToJiraDescription: {
        id: 'fabric.atlassianSwitcher.experimentNudgeToJiraConfluenceDescription',
        defaultMessage: 'See work in lists, boards, or backlogs',
        description: 'Description for Jira to encourage using Jira together with other products'
    }
});
var $2bf421fa15614840$export$2e2bcd8739ae039 = $2bf421fa15614840$var$messages;

});

parcelRegister("8Mq6c", function(module, exports) {

$parcel$export(module.exports, "default", () => $706129bebcc29179$export$2e2bcd8739ae039);

var $1gxex = parcelRequire("1gxex");

var $7CfdH = parcelRequire("7CfdH");
class $706129bebcc29179$export$2e2bcd8739ae039 {
    constructor(configOrCloudId, stargateUrl){
        let config;
        if (typeof configOrCloudId === 'string') config = {
            cloudId: configOrCloudId,
            stargateUrl: stargateUrl,
            isFedRAMPEnvironment: false
        };
        else config = configOrCloudId;
        if (!config.cloudId || !config.stargateUrl) throw new Error('Need a valid CloudId and Stargate url');
        this.cloudId = config.cloudId;
        this.stargateUrl = config.stargateUrl;
        this.orgId = config.orgId;
        this.workspaceId = config.workspaceId;
        this.coordinationOptions = config.coordinationOptions;
    }
    async start(messageId, variationId) {
        if (!(0, $7CfdH.isMessagingEnabled)()) return false;
        return (0, $1gxex.startMessage)({
            cloudId: this.cloudId,
            stargateUrl: this.stargateUrl,
            messageId: messageId,
            variationId: variationId,
            orgId: this.orgId,
            workspaceId: this.workspaceId
        }, this.coordinationOptions);
    }
    async stop(messageId) {
        if (!(0, $7CfdH.isMessagingEnabled)()) return false;
        return (0, $1gxex.stopMessage)({
            cloudId: this.cloudId,
            stargateUrl: this.stargateUrl,
            messageId: messageId,
            orgId: this.orgId,
            workspaceId: this.workspaceId
        }, this.coordinationOptions);
    }
}

});

parcelRegister("6HV40", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e2305dbe349082f$export$2e2bcd8739ae039);

var $eHiP8 = parcelRequire("eHiP8");

var $6fYNv = parcelRequire("6fYNv");

var $jtD64 = parcelRequire("jtD64");

var $fynqv = parcelRequire("fynqv");

var $lKWnb = parcelRequire("lKWnb");

var $4r7nA = parcelRequire("4r7nA");

var $814TT = parcelRequire("814TT");
function $4e2305dbe349082f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4e2305dbe349082f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4e2305dbe349082f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $eHiP8.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4e2305dbe349082f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $4e2305dbe349082f$var$STORAGE_KEY_BASE = "@atlassiansox/flight-deck-frontend-client";
const $4e2305dbe349082f$var$RETRIABLE_FD_ERROR_MESSAGES = [
    "Failed to fetch",
    "NetworkError when attempting to fetch resource.",
    "Load failed"
];
class $4e2305dbe349082f$export$2e2bcd8739ae039 {
    constructor(product, options = {
        handlers: {}
    }, fallbackArtifacts = []){
        (0, $eHiP8.default)(this, "fallbackArtifactMap", new Map());
        (0, $eHiP8.default)(this, "fetchFromFlightDeckPromises", new Map());
        this.expiryMS = options.expiryMS;
        this.handlers = options.handlers;
        this.product = product;
        this.storageClient = new (0, $jtD64.default)($4e2305dbe349082f$var$STORAGE_KEY_BASE, options);
        fallbackArtifacts.forEach((artifact)=>this.fallbackArtifactMap.set((0, $4r7nA.artifactKey)(artifact.name, artifact.dimensions), artifact.value));
        this.captureException = this.captureException.bind(this);
    }
    captureException(e, tags) {
        if (this.handlers.captureException) this.handlers.captureException(e, tags);
    }
    async fetchAndCacheArtifact(artifact, retryConfig) {
        const response = await (0, $6fYNv.retryOnException)(async ()=>{
            try {
                // await the result here so that we capture any errors
                const result = await (0, $fynqv.fetchFlightDeckConfiguration)(artifact.name, artifact.dimensions);
                return result;
            } catch (error) {
                throw new (0, $lKWnb.default)({
                    artifact: artifact.key,
                    dimensions: artifact.dimensions,
                    error: error
                });
            }
        }, {
            captureException: this.captureException,
            retryOn: (err)=>$4e2305dbe349082f$var$RETRIABLE_FD_ERROR_MESSAGES.includes(err.message),
            intervalsMS: retryConfig === null || retryConfig === void 0 ? void 0 : retryConfig.intervalsMS,
            onRetry: retryConfig === null || retryConfig === void 0 ? void 0 : retryConfig.onRetry
        });
        if (!response) {
            const missingArtifactError = new Error(`Missing artifact: ${artifact.key}`);
            this.captureException(missingArtifactError);
            throw missingArtifactError;
        }
        this.storageClient.setItemWithExpiry(artifact.key, response, this.expiryMS);
        // Clear the in-flight check
        this.fetchFromFlightDeckPromises.delete(artifact.key);
        return response;
    }
    async fetchArtifactPromise(artifact, retryConfig) {
        // Check for in-flight requests for this artifact
        if (this.fetchFromFlightDeckPromises.has(artifact.key)) return this.fetchFromFlightDeckPromises.get(artifact.key);
        const fetchPromise = this.fetchAndCacheArtifact(artifact, retryConfig);
        this.fetchFromFlightDeckPromises.set(artifact.key, fetchPromise);
        return fetchPromise;
    }
    async fetchConfigFromFlightDeck(artifact, retryConfig) {
        const experience = (0, $814TT.flightDeckClientExperience)();
        experience.start();
        try {
            const artifactWithKey = $4e2305dbe349082f$var$_objectSpread($4e2305dbe349082f$var$_objectSpread({}, artifact), {}, {
                key: (0, $4r7nA.artifactKey)(artifact.name, artifact.dimensions)
            });
            experience.addMetadata({
                key: artifactWithKey.key,
                product: this.product
            });
            // Create the promise to fetch the config, we only need to await this if we don't have local config
            const artifactPromise = this.fetchArtifactPromise(artifactWithKey, retryConfig);
            // Check local storage for the artifact
            const localConfig = this.storageClient.getItem(artifactWithKey.key);
            if (localConfig) {
                experience.addMetadata({
                    configSource: "localStorage"
                });
                return localConfig;
            }
            // Was a fallback config provided?
            if (this.fallbackArtifactMap.has(artifactWithKey.key)) {
                experience.addMetadata({
                    configSource: "fallback"
                });
                return this.fallbackArtifactMap.get(artifactWithKey.key);
            }
            experience.addMetadata({
                configSource: "fetch"
            });
            // No local copies of config, await FD fetch promise here so that we can capture any errors & fail the experience
            const result = await artifactPromise;
            return result;
        } catch (e) {
            experience.failure({
                metadata: {
                    error: (0, $814TT.exceptionToMetadata)(e)
                }
            });
            throw e;
        } finally{
            // if the experience has been failed in the "catch" block, calling "success" will have no effect
            experience.success();
        }
    }
}

});
parcelRegister("6fYNv", function(module, exports) {

$parcel$export(module.exports, "retryOnException", () => $0dab620feb4778b8$export$1d94629c94e7a17f);
$parcel$export(module.exports, "FailedFetchError", () => (parcelRequire("6sAya")).default);

var $lLItl = parcelRequire("lLItl");

var $daTxP = parcelRequire("daTxP");

var $6sAya = parcelRequire("6sAya");
const $0dab620feb4778b8$export$5c069c93d2b7493f = (ms)=>new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
const $0dab620feb4778b8$var$NO_CALLS_ERROR = 'No calls made';
const $0dab620feb4778b8$export$1d94629c94e7a17f = async (invokeOperation, { intervalsMS: intervalsMS = (0, $daTxP.NO_RETRIES), retryOn: retryOn = [
    (0, $6sAya.default)
], captureException: captureException, onRetry: onRetry })=>{
    const intervals = [
        ...intervalsMS
    ];
    let nextMSInterval = 0;
    let error = new Error($0dab620feb4778b8$var$NO_CALLS_ERROR);
    while(nextMSInterval !== undefined)try {
        if (nextMSInterval > 0) await $0dab620feb4778b8$export$5c069c93d2b7493f(nextMSInterval);
        if (onRetry && error.message !== $0dab620feb4778b8$var$NO_CALLS_ERROR) onRetry(error);
        return await invokeOperation();
    } catch (e) {
        error = (0, $lLItl.default)(e);
        if (captureException) captureException(error);
        // Retry ONLY when the error is an instance of one of the provided `retryOn` errors, or passes the `retryOn` test.
        // You need to ensure you are throwing one of the `retryOn` errors if that is the method you are using.
        if (typeof retryOn === 'function' ? retryOn(error) : retryOn.some((err)=>error instanceof err)) nextMSInterval = intervals.shift();
        else nextMSInterval = undefined;
    }
    throw error;
};

});
parcelRegister("lLItl", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7435f92b90f1f57$export$2e2bcd8739ae039);
const $b7435f92b90f1f57$var$convertToError = (e)=>{
    let error;
    if (e instanceof Error) error = e;
    else if (typeof e === 'string') error = new Error(e);
    else if (typeof e === 'object') try {
        error = new Error('Object error instance thrown for operation: ' + JSON.stringify(e));
    } catch (jsonError) {
        error = new Error('Object serialisation error thrown during operation: ' + String(e));
    }
    else error = new Error('No error instance thrown for operation: ' + String(e));
    return error;
};
var $b7435f92b90f1f57$export$2e2bcd8739ae039 = $b7435f92b90f1f57$var$convertToError;

});

parcelRegister("daTxP", function(module, exports) {

$parcel$export(module.exports, "NO_RETRIES", () => $6d1feaff7ce645cb$export$a0a1c8f90becc136);
const $6d1feaff7ce645cb$export$a0a1c8f90becc136 = [];
const $6d1feaff7ce645cb$export$972171517b12aa4 = [
    0,
    0
];
const $6d1feaff7ce645cb$export$746d2203ed8cdc40 = [
    0,
    50,
    100
];
const $6d1feaff7ce645cb$export$f6858378b665f957 = [
    100,
    500,
    1000
];

});

parcelRegister("6sAya", function(module, exports) {

$parcel$export(module.exports, "default", () => $b434fbcc8a3be4d5$export$2e2bcd8739ae039);
class $b434fbcc8a3be4d5$export$2e2bcd8739ae039 extends Error {
    constructor({ error: error, path: path, method: method }){
        super();
        this.name = 'FailedFetchError';
        this.message = error.message || 'Unknown fetch error';
        this.stack = error.stack;
        this.originalName = error.name;
        this.method = method;
        const p = path.split('?')[0];
        this.path = /^[/-a-z]+$/i.test(p) ? p : '';
    }
}

});


parcelRegister("jtD64", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fec5df08c1bfd78$export$2e2bcd8739ae039);

var $fvm5n = parcelRequire("fvm5n");
const $7fec5df08c1bfd78$var$DEFAULT_STORAGE_ENGINE = 'localStorage';
class $7fec5df08c1bfd78$export$2e2bcd8739ae039 {
    constructor(clientKey, options){
        this.getItem = (key, { useExpiredItem: useExpiredItem } = {
            useExpiredItem: false
        })=>{
            const item = this.client.getItem(this.itemKey(key));
            if (item) try {
                const parsedItem = JSON.parse(item);
                // item is expired
                if (parsedItem.expires && new Date(parsedItem.expires) < new Date()) {
                    /**
					 * Commented out removing this item, as it is a slightly different state
					 * to the item not existing that we may want to preserve.
					 *  this.client.removeItem(this.itemKey(key));
					 */ if (!useExpiredItem) return undefined;
                }
                return parsedItem.value;
            } catch (e) {
                this.captureException(e);
            }
            return undefined;
        };
        this.removeItem = (key)=>{
            try {
                this.client.removeItem(this.itemKey(key));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.setItemWithExpiry = (key, value, expireInMS)=>{
            const itemWithExpiry = {
                value: value,
                expires: typeof expireInMS === 'number' ? Date.now() + expireInMS : undefined
            };
            try {
                this.client.setItem(this.itemKey(key), JSON.stringify(itemWithExpiry));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.clientKey = clientKey;
        this.handlers = options?.handlers;
        const storageEngine = options?.storageEngine || $7fec5df08c1bfd78$var$DEFAULT_STORAGE_ENGINE;
        if (!Object.prototype.hasOwnProperty.call(window, storageEngine)) (0, $fvm5n.mockWindowStorage)([
            storageEngine
        ]);
        this.client = window[storageEngine];
    }
    captureException(e, tags) {
        if (this.handlers?.captureException) this.handlers?.captureException(e, tags);
    }
    itemKey(key) {
        return `${this.clientKey}_${key}`;
    }
}

});
parcelRegister("fvm5n", function(module, exports) {

$parcel$export(module.exports, "mockWindowStorage", () => $e2c0533271428186$export$efebfe7859cae3c7);
/**
 * This can be used to mock local storage for Edge and other browsers that have disabled local storage setting
 */ const $e2c0533271428186$export$c65e688d8b365035 = {
    _data: {},
    length: 0,
    setItem: function(id, val) {
        return this._data[id] = String(val);
    },
    getItem: function(id) {
        return this._data.hasOwnProperty(id) ? this._data[id] : undefined;
    },
    removeItem: function(id) {
        return delete this._data[id];
    },
    clear: function() {
        return this._data = {};
    },
    key: function(index) {
        return Object.keys(this._data)[index];
    }
};
const $e2c0533271428186$export$efebfe7859cae3c7 = (storageToMock = [
    'localStorage',
    'sessionStorage'
])=>{
    for (const storageToMockElement of storageToMock)Object.defineProperty(window, storageToMockElement, {
        value: {
            ...$e2c0533271428186$export$c65e688d8b365035
        },
        configurable: true
    });
};

});


parcelRegister("fynqv", function(module, exports) {

$parcel$export(module.exports, "fetchFlightDeckConfiguration", () => $b52c33ff29e619cd$export$6026918e023c9101);

var $euiLX = parcelRequire("euiLX");

var $6l8hg = parcelRequire("6l8hg");

var $3TdLx = parcelRequire("3TdLx");

var $3Oidj = parcelRequire("3Oidj");

var $d5LIN = parcelRequire("d5LIN");

var $95uqQ = parcelRequire("95uqQ");

var $kJG1r = parcelRequire("kJG1r");
/**
 * Arguments for passing in dimensions that the artifact might vary on.
 * For more details see: https://developer.atlassian.com/platform/flight-deck/getting-your-capability-onto-flight-deck/dimensions/
 */ /**
 * default to using prod instance since artifacts that don't depend on environment should be using the prod instance.
 */ const $b52c33ff29e619cd$var$defaultEnvType = "prod";
/**
 * default to using commercial instance.
 */ const $b52c33ff29e619cd$var$defaultPerimeter = "commercial";
async function $b52c33ff29e619cd$export$6026918e023c9101(artifactName, dim = {}) {
    var _dim$environmentType, _dim$perimeter;
    const environmentType = (_dim$environmentType = dim.environmentType) !== null && _dim$environmentType !== void 0 ? _dim$environmentType : $b52c33ff29e619cd$var$defaultEnvType;
    const perimeter = (_dim$perimeter = dim.perimeter) !== null && _dim$perimeter !== void 0 ? _dim$perimeter : $b52c33ff29e619cd$var$defaultPerimeter;
    const environment = $b52c33ff29e619cd$var$getEnvFromEnvType(environmentType);
    const locale = dim.locale && (0, $euiLX.default)(dim.locale);
    const artifactDimensions = {
        perimeter: perimeter,
        environment: environment,
        locale: locale
    };
    const client = await $b52c33ff29e619cd$var$getConfigClient(environmentType, perimeter);
    return client.getArtifact(artifactName, artifactDimensions);
}
async function $b52c33ff29e619cd$export$4abbe3ae0811355(dim = {}) {
    var _dim$environmentType2, _dim$perimeter2;
    const client = await $b52c33ff29e619cd$var$getConfigClient((_dim$environmentType2 = dim.environmentType) !== null && _dim$environmentType2 !== void 0 ? _dim$environmentType2 : $b52c33ff29e619cd$var$defaultEnvType, (_dim$perimeter2 = dim.perimeter) !== null && _dim$perimeter2 !== void 0 ? _dim$perimeter2 : $b52c33ff29e619cd$var$defaultPerimeter);
    return client.getLatestVersionMetadata();
}
async function $b52c33ff29e619cd$var$getConfigClient(env, perimeter) {
    const fetchArtifactExperience = await (0, $95uqQ.getFlightDeckFetchExperience)();
    const fetchVersionMetadataExperience = await (0, $95uqQ.getVersionMetadataFetchExperience)();
    return new (0, $d5LIN.ConfigClient)(new (0, $3TdLx.BifrostDataSource)(new (0, $3Oidj.BifrostHttpClientImpl)(env, perimeter), (0, $6l8hg.Versions).ManifestVersion), "Bifrost", fetchArtifactExperience, fetchVersionMetadataExperience);
}
/**
 *
 * This function is necessary since all artifacts are tagged using an environment,
 * so to get an artifact we need to specify an environment. However, users only
 * specify an environmentType since that's all that matters to them. Flight Deck
 * ensures that frontend artifacts don't vary based on region so this is safe to do.
 *
 * @param environmentDependentDimensions
 * @returns a specific environment that has that envtype
 */ function $b52c33ff29e619cd$var$getEnvFromEnvType(environment) {
    if (environment === undefined || environment === "prod") return "prod-west";
    switch(environment){
        case "stg":
            return "stg-west";
        case "adev":
            return "adev";
        case "ddev":
            return "ddev";
        case "pdev":
            return "pdev-apse2";
        case "fedex":
            return "stg-apse";
    }
}

});
parcelRegister("euiLX", function(module, exports) {

$parcel$export(module.exports, "default", () => $838bf5d423642311$export$2e2bcd8739ae039);
/**
 * This function is being used to address locale discrepancies in Atlassian products:
 * see: https://hello.atlassian.net/wiki/spaces/i18n/pages/528623554/Locale+Discrepancies+Across+Atlassian+Products+and+Platform+Areas
 */ const $838bf5d423642311$export$852ff24d0930c62f = (locale)=>{
    const standardizedLocale = locale.replace('_', '-');
    switch(standardizedLocale){
        case 'en-GB':
        case 'en-US':
        case 'en-XA':
        case 'en-XB':
        case 'en-ZZ':
        case 'pt-BR':
        case 'zh-CN':
        case 'zh-TW':
            return standardizedLocale;
        case 'en-UK':
            return 'en-GB';
        case 'en':
            return 'en-US';
        default:
            return standardizedLocale.split('-')[0];
    }
};
var $838bf5d423642311$export$2e2bcd8739ae039 = $838bf5d423642311$export$852ff24d0930c62f;

});

parcelRegister("6l8hg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Versions = module.exports.BaseUrls = module.exports.ConfigRegistryDataSource = module.exports.checkManifest = module.exports.parseVersionMetadata = module.exports.parseArtifactManifest = module.exports.tryGetArtifactData = module.exports.getArtifactFromSource = module.exports.Either = void 0;

var $auuB0 = parcelRequire("auuB0");
Object.defineProperty(module.exports, "Either", {
    enumerable: true,
    get: function() {
        return $auuB0.Either;
    }
});

var $2v7c1 = parcelRequire("2v7c1");
Object.defineProperty(module.exports, "getArtifactFromSource", {
    enumerable: true,
    get: function() {
        return $2v7c1.getArtifactFromSource;
    }
});
Object.defineProperty(module.exports, "tryGetArtifactData", {
    enumerable: true,
    get: function() {
        return $2v7c1.tryGetArtifactData;
    }
});

var $8Xjp5 = parcelRequire("8Xjp5");
Object.defineProperty(module.exports, "parseArtifactManifest", {
    enumerable: true,
    get: function() {
        return $8Xjp5.parseArtifactManifest;
    }
});

var $1NPzc = parcelRequire("1NPzc");
Object.defineProperty(module.exports, "parseVersionMetadata", {
    enumerable: true,
    get: function() {
        return $1NPzc.parseVersionMetadata;
    }
});

var $5LTws = parcelRequire("5LTws");
Object.defineProperty(module.exports, "checkManifest", {
    enumerable: true,
    get: function() {
        return $5LTws.checkManifest;
    }
});

var $6FHvZ = parcelRequire("6FHvZ");
Object.defineProperty(module.exports, "ConfigRegistryDataSource", {
    enumerable: true,
    get: function() {
        return $6FHvZ.ConfigRegistryDataSource;
    }
});

var $3ijEk = parcelRequire("3ijEk");
Object.defineProperty(module.exports, "BaseUrls", {
    enumerable: true,
    get: function() {
        return $3ijEk.BaseUrls;
    }
});
Object.defineProperty(module.exports, "Versions", {
    enumerable: true,
    get: function() {
        return $3ijEk.Versions;
    }
});

});
parcelRegister("auuB0", function(module, exports) {
"use strict";
var $7a34706d0f0f02a3$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Either = void 0;
var $7a34706d0f0f02a3$var$Either = /** @class */ function() {
    function Either() {}
    Either.prototype.map = function(f) {
        return this.flatMap(function(a) {
            return Either.right(f(a));
        });
    };
    Either.right = function(value) {
        return new $7a34706d0f0f02a3$var$Right(value);
    };
    Either.left = function(error) {
        return new $7a34706d0f0f02a3$var$Left(error);
    };
    return Either;
}();
module.exports.Either = $7a34706d0f0f02a3$var$Either;
var $7a34706d0f0f02a3$var$Right = /** @class */ function(_super) {
    $7a34706d0f0f02a3$var$__extends(Right, _super);
    function Right(r) {
        var _this = _super.call(this) || this;
        _this.right = r;
        return _this;
    }
    Right.prototype.bimap = function(_f, g) {
        return $7a34706d0f0f02a3$var$Either.right(g(this.right));
    };
    Right.prototype.flatMap = function(f) {
        return f(this.right);
    };
    Right.prototype.fold = function(_onLeft, onRight) {
        return onRight(this.right);
    };
    Right.prototype.leftMap = function(_f) {
        return $7a34706d0f0f02a3$var$Either.right(this.right);
    };
    return Right;
}($7a34706d0f0f02a3$var$Either);
var $7a34706d0f0f02a3$var$Left = /** @class */ function(_super) {
    $7a34706d0f0f02a3$var$__extends(Left, _super);
    function Left(e) {
        var _this = _super.call(this) || this;
        _this.left = e;
        return _this;
    }
    Left.prototype.bimap = function(f, _g) {
        return $7a34706d0f0f02a3$var$Either.left(f(this.left));
    };
    Left.prototype.flatMap = function(_f) {
        return $7a34706d0f0f02a3$var$Either.left(this.left);
    };
    Left.prototype.fold = function(onLeft, _onRight) {
        return onLeft(this.left);
    };
    Left.prototype.leftMap = function(f) {
        return $7a34706d0f0f02a3$var$Either.left(f(this.left));
    };
    return Left;
}($7a34706d0f0f02a3$var$Either);

});

parcelRegister("2v7c1", function(module, exports) {
"use strict";
var $1d240e683f64836f$var$__assign = module.exports && module.exports.__assign || function() {
    $1d240e683f64836f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1d240e683f64836f$var$__assign.apply(this, arguments);
};
var $1d240e683f64836f$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $1d240e683f64836f$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.tryGetArtifactData = module.exports.getArtifactFromSource = void 0;

var $hdDPm = parcelRequire("hdDPm");

var $6l8hg = parcelRequire("6l8hg");

var $9te7V = parcelRequire("9te7V");

var $9P145 = parcelRequire("9P145");

var $3evgk = parcelRequire("3evgk");
function $1d240e683f64836f$var$getArtifactFromSource(dataSource, specifiedDimensions, deniedArtifactType) {
    return $1d240e683f64836f$var$__awaiter(this, void 0, void 0, function() {
        var manifestResult;
        var _this = this;
        return $1d240e683f64836f$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        dataSource.getManifest(specifiedDimensions.name, specifiedDimensions.version)
                    ];
                case 1:
                    manifestResult = _a.sent();
                    return [
                        2 /*return*/ ,
                        manifestResult.fold(function(error) {
                            return Promise.resolve({
                                type: "manifest-fetch-error",
                                error: error
                            });
                        }, function(manifest) {
                            return $1d240e683f64836f$var$__awaiter(_this, void 0, void 0, function() {
                                var manifestCheckResult, publishMetadata, dimensionContextResult;
                                return $1d240e683f64836f$var$__generator(this, function(_a) {
                                    manifestCheckResult = (0, $6l8hg.checkManifest)(manifest, {
                                        name: specifiedDimensions.name,
                                        version: specifiedDimensions.version
                                    });
                                    if (manifestCheckResult.key !== "success") return [
                                        2 /*return*/ ,
                                        {
                                            type: manifestCheckResult.key
                                        }
                                    ];
                                    publishMetadata = manifest.publishMetadata;
                                    if (manifest.frontend && deniedArtifactType === "frontend") return [
                                        2 /*return*/ ,
                                        {
                                            type: "denied-artifact-type",
                                            deniedType: "frontend",
                                            publishMetadata: publishMetadata
                                        }
                                    ];
                                    else if (!manifest.frontend && deniedArtifactType === "backend") return [
                                        2 /*return*/ ,
                                        {
                                            type: "denied-artifact-type",
                                            deniedType: "backend",
                                            publishMetadata: publishMetadata
                                        }
                                    ];
                                    dimensionContextResult = (0, $9te7V.getDimensionContext)(specifiedDimensions, manifest);
                                    switch(dimensionContextResult.type){
                                        case "missing-dimension-specification":
                                            return [
                                                2 /*return*/ ,
                                                {
                                                    type: "missing-dimension-specification",
                                                    publishMetadata: publishMetadata
                                                }
                                            ];
                                        case "unsupported-value-specified-for-supported-dimension":
                                            return [
                                                2 /*return*/ ,
                                                {
                                                    type: "unsupported-value-specified-for-supported-dimension",
                                                    publishMetadata: publishMetadata
                                                }
                                            ];
                                        case "success":
                                            return [
                                                2 /*return*/ ,
                                                $1d240e683f64836f$var$getArtifact(dataSource, manifest, dimensionContextResult.dimensionContext)
                                            ];
                                        default:
                                            (0, $9P145.assertUnreachable)(dimensionContextResult);
                                    }
                                    return [
                                        2 /*return*/ 
                                    ];
                                });
                            });
                        })
                    ];
            }
        });
    });
}
module.exports.getArtifactFromSource = $1d240e683f64836f$var$getArtifactFromSource;
function $1d240e683f64836f$var$getArtifact(dataSource, manifest, dimensionContext) {
    return $1d240e683f64836f$var$__awaiter(this, void 0, void 0, function() {
        var publishMetadata, tag, artifactResult;
        var _this = this;
        return $1d240e683f64836f$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    publishMetadata = manifest.publishMetadata;
                    try {
                        tag = (0, $hdDPm.interpolateTagScheme)(manifest.tagScheme, $1d240e683f64836f$var$__assign($1d240e683f64836f$var$__assign({}, dimensionContext), {
                            name: manifest.name
                        }));
                    } catch (e) {
                        return [
                            2 /*return*/ ,
                            {
                                type: "tag-scheme-interpolation-error",
                                publishMetadata: publishMetadata
                            }
                        ];
                    }
                    return [
                        4 /*yield*/ ,
                        dataSource.getArtifact(manifest.name, tag)
                    ];
                case 1:
                    artifactResult = _a.sent();
                    return [
                        2 /*return*/ ,
                        artifactResult.fold(function(error) {
                            return Promise.resolve({
                                type: "artifact-fetch-error",
                                error: error,
                                publishMetadata: publishMetadata
                            });
                        }, function(data) {
                            return $1d240e683f64836f$var$__awaiter(_this, void 0, void 0, function() {
                                return $1d240e683f64836f$var$__generator(this, function(_a) {
                                    return [
                                        2 /*return*/ ,
                                        {
                                            type: "success",
                                            data: data,
                                            publishMetadata: publishMetadata,
                                            artifactVersion: dimensionContext["version"]
                                        }
                                    ];
                                });
                            });
                        })
                    ];
            }
        });
    });
}
function $1d240e683f64836f$var$tryGetArtifactData(artifact, dataSourceName) {
    switch(artifact.type){
        case "manifest-fetch-error":
            throw new Error("Unable to fetch manifest due to ".concat(dataSourceName, " response error: ").concat((0, $3evgk.toPrettyJson)(artifact.error)));
        case "artifact-fetch-error":
            throw new Error("Unable to fetch artifact due to ".concat(dataSourceName, " response error: ").concat((0, $3evgk.toPrettyJson)(artifact.error)));
        case "denied-artifact-type":
            throw new Error("No artifacts should be denied, but type ".concat(artifact.deniedType, " was denied."));
        case "unsupported-value-specified-for-supported-dimension":
            throw new Error("An unsupported value was specified for a supported dimension");
        case "missing-dimension-specification":
            throw new Error("A required dimension specification was missing");
        case "tag-scheme-interpolation-error":
            throw new Error("Ran into failure when trying to interpolate tag scheme");
        case "mismatched-manifest-name":
            throw new Error("Manifest has been corrupted. Manifest name is mismatched.");
        case "mismatched-manifest-version":
            throw new Error("Manifest has been corrupted. Manifest version is mismatched.");
        case "success":
            return artifact.data;
        default:
            (0, $9P145.assertUnreachable)(artifact);
    }
}
module.exports.tryGetArtifactData = $1d240e683f64836f$var$tryGetArtifactData;

});
parcelRegister("hdDPm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getVersionMetadataTag = module.exports.getDataTagForManifest = module.exports.getDimensionsFromTagScheme = module.exports.generateTagScheme = module.exports.interpolateTagScheme = void 0;
const $c8928b7419a5cc69$var$TAG_SCHEME_VERSION = 2;
function $c8928b7419a5cc69$var$interpolateTagScheme(tagSchema, context) {
    const dimensions = Array.from($c8928b7419a5cc69$var$getDimensionsFromTagScheme(tagSchema));
    return dimensions.reduce((interpolatedTagScheme, dimension)=>{
        if (context.hasOwnProperty(dimension)) return interpolatedTagScheme.replace(new RegExp(`\\$${dimension}\\$`, "g"), context[dimension]);
        else {
            const contextAsJson = $c8928b7419a5cc69$var$toPrettyJson(context);
            throw new Error(`Bad variable "${dimension}" found enclosed in '$', so cannot infer
                     filename for artifact from tag schema: was expecting that
                     '${dimension}' would be a known dimension passed in context. This
                     is most likely a bug in Flight Deck. To help you debug, the Context
                     received was:\n"${contextAsJson}"\nOne of the keys in that object should
                     have been '${contextAsJson}'.`);
        }
    }, tagSchema);
}
module.exports.interpolateTagScheme = $c8928b7419a5cc69$var$interpolateTagScheme;
/**
 *
 * @param dimensions - the dimensions that this tag scheme needs to use
 *
 * @param supportedDimensionPrefixes - a map of those dimensions to
 * shortened versions (ie name to n)
 *
 *  @param effectiveContextDimension - maps dimensions down into dimensions supported
 *  by original context. NOTE:
 *
 *  There is only 1 correct implementation of this function, but
 *  it is not defined in this module because the most typesafe
 *  (least error prone) definition of this function requires referencing
 *  the specific dimension types (specific available dimensions), and
 *  we are intentionally keeping this module unaware of the specific
 *  dimensions to enable adding/changing dimensions easily in consumers
 *  which use this tags library. So therefore we define effectiveContextDimension
 *  outside of this package, but accept it as an argument. Note that in this
 *  package we redefine the meaning of common Flight Deck types (e.g.
 *  Dimension == string, rather than the specific subset of supported
 *  dimension strings), so when generateTagScheme is called then effectiveContextDimension
 *  needs to be cast (using `as`) in order to have the types
 *
 * @returns a generated schema
 */ function $c8928b7419a5cc69$var$generateTagScheme(dimensions, supportedDimensionPrefixes, effectiveContextDimension = (d)=>d) {
    const effectiveDimensions = new Set([
        ...dimensions
    ].map(effectiveContextDimension));
    for (const dimensionToInclude of effectiveDimensions){
        if (!supportedDimensionPrefixes.has(effectiveContextDimension(dimensionToInclude))) throw new Error([
            `Building a tag scheme failed! The dimension '${dimensionToInclude}' is not `,
            `recognized as a dimension (known dimensions are ${[
                ...supportedDimensionPrefixes.keys()
            ].join(", ")}!`
        ].join(" "));
    }
    // pad the version number to 3 digits (e.g. 001, 002, 003, etc) so that artifacts will sort by
    // version when sorted lexicographically (helpful for debugging)
    const padded_version = $c8928b7419a5cc69$var$TAG_SCHEME_VERSION.toString().padStart(3, "0");
    // IMPORTANT! Update {@link TAG_SCHEME_VERSION} if you change the tagging scheme logic!
    let tagScheme = `v${padded_version}`;
    for (const entry of supportedDimensionPrefixes.entries()){
        const [dimension, prefix] = entry;
        if (effectiveDimensions.has(dimension)) // We avoid using `:` or `/` or `\` as separator characters because these characters have
        // meaning on certain filesystems that make them painful to work with; we also don't use
        // ` ` or similar because whitespace characters are the default values used by shells
        // to word-split, which makes scripting harder (see https://bash.cyberciti.biz/guide/$IFS ).
        tagScheme += `-${prefix}_$${dimension}$`;
    }
    return tagScheme;
}
module.exports.generateTagScheme = $c8928b7419a5cc69$var$generateTagScheme;
// Important! Context: Front end client will be using old version of tags.When we make changes to this function
// we need to be extra cautious that it will be compatible with older versions
// Step -1
// we have test in frontend package :integration-test/frontend/frontend-fetch.spec.ts to test oldest front end client
// make sure we add sample artifact to the test which will test newest functionality against oldest client
// Step-2
// Update manifest version across flight-deck
// step-3
// update manifest version in poop-deck repo
// step-4
// communicate with external customers and #flight-deck channel announcements
// step-5
// Update oldest supported version in integration-test/frontend/frontend-fetch.spec.ts and the test will be passed
function $c8928b7419a5cc69$var$getDimensionsFromTagScheme(tagSchema) {
    // regex to get all dimensions
    // for a dimension:
    // \$ means the expression starts with a `$` sign
    // [A-Za-z]+ means dollar sign is followed by one or more alphabetical chars
    // \$ means the dimension ends with a `$` sign
    const dimensionsFormat = /\$([A-Za-z]+)\$/g;
    // regex to ensure that we have the right format
    // for the dimension format:
    // ^v means it must start with a v
    // \d{3} means it is followed by three digits
    // ?: tries to match the expression without capturing the group
    // -[a-z]_ means expression starts with `-<single lowercase a-z char>_`
    // (\$[A-Za-z]+\$) defines that a dimension is in the format `<one or more alphabetical chars>` and this group is captured.
    // + means we could have one or more dimensions.
    // $ means we must end at the end of a dimension.
    const tagSchemeFormat = /^v\d{3}(?:-[a-z]_(\$[A-Za-z]+\$))+$/;
    const isValidTag = tagSchemeFormat.test(tagSchema);
    if (!isValidTag) throw new Error(`The provided tag scheme: "${tagSchema}" is invalid.
                Tag schemes must have the following format:
                v<3 digit number>-<letter>$<dimension_name>$
                where -<letter>$<dimension_name>$ can be repeated
                and all characters of <letter> and <dimension_name>
                must be alphabetical characters
                e.g "v001-n_$name$-d_$dimension$" is a valid tag scheme`);
    const allDim = Array.from(tagSchema.matchAll(dimensionsFormat));
    try {
        // Grab the second element of each element in matches
        const captures = allDim.map(([_, capture])=>capture);
        const dimensions = new Set(captures);
        return dimensions;
    } catch (e) {
        throw new Error(`Could not capture dimensions. Expected dimension format to look like 
             ${dimensionsFormat}`);
    }
}
module.exports.getDimensionsFromTagScheme = $c8928b7419a5cc69$var$getDimensionsFromTagScheme;
function $c8928b7419a5cc69$var$getDataTagForManifest(artifactName, manifestVersion, artifactVersion) {
    return artifactVersion === undefined ? `${artifactName}_manifest_${manifestVersion}` : `${artifactName}_${artifactVersion}_manifest_${manifestVersion}`;
}
module.exports.getDataTagForManifest = $c8928b7419a5cc69$var$getDataTagForManifest;
function $c8928b7419a5cc69$var$getVersionMetadataTag(version) {
    return version ? `version_metadata_${version}` : "version_metadata";
}
module.exports.getVersionMetadataTag = $c8928b7419a5cc69$var$getVersionMetadataTag;
function $c8928b7419a5cc69$var$toPrettyJson(obj) {
    return JSON.stringify(obj, null, 2);
}

});

parcelRegister("9te7V", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getDimensionContext = void 0;
/**
 * Resolves a record of Dimensions and their values based on the manifest
 * and the user specified dimensions values.
 *
 * If a dimension is not specified by the user, then the fallback value
 * will be used as the value for that dimension. If the fallback value
 * does not exist in this case, then a "missing-dimension-specification"
 * result will be reported.
 *
 * If a dimension value specified by the user is not part of the list
 * of supported values, then the dimension value will be the fallback
 * value defined. If a fallback value does not exist for that dimension,
 * then an "unsupported-value-specified-for-supported-dimension" result
 * will be reported.
 *
 * Otherwise, a "success" result will be reported on a valid context
 * resolution.
 *
 * @param specifiedDimensions the dimensions the user specified
 * @param manifest the manifest to validate and fallback user specifications
 * @returns a record of Dimensions and their valid values, or an error type
 *      if a record of valid values could not be derived from the user input
 */ function $6e51c7c28a67d567$var$getDimensionContext(specifiedDimensions, manifest) {
    var dimensionToValues = {};
    for(var dimension in manifest.dimensions){
        var manifestDimensionSpecs = manifest.dimensions[dimension];
        var dimensionValue = specifiedDimensions[dimension];
        var fallback = manifestDimensionSpecs.fallback;
        if (dimensionValue === undefined) {
            if (fallback === undefined) return {
                type: "missing-dimension-specification"
            };
            else dimensionValue = fallback;
        }
        if (!manifestDimensionSpecs.supported.includes(dimensionValue)) {
            if (fallback === undefined) return {
                type: "unsupported-value-specified-for-supported-dimension"
            };
            else dimensionValue = fallback;
        }
        dimensionToValues[dimension] = dimensionValue;
    }
    return {
        type: "success",
        dimensionContext: dimensionToValues
    };
}
module.exports.getDimensionContext = $6e51c7c28a67d567$var$getDimensionContext;

});

parcelRegister("9P145", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assertUnreachable = void 0;
function $7269b3f523ad10e5$var$assertUnreachable(_x) {
    throw new Error("This function should never be called. This is for yielding compile errors on non-exhaustive case checking.");
}
module.exports.assertUnreachable = $7269b3f523ad10e5$var$assertUnreachable;

});

parcelRegister("3evgk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toPrettyJson = module.exports.toJson = void 0;
function $25aaedf68a816fe7$var$toJson(buffer) {
    return JSON.parse(buffer.toString());
}
module.exports.toJson = $25aaedf68a816fe7$var$toJson;
function $25aaedf68a816fe7$var$toPrettyJson(obj) {
    return JSON.stringify(obj, null, 2);
}
module.exports.toPrettyJson = $25aaedf68a816fe7$var$toPrettyJson;

});


parcelRegister("8Xjp5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseArtifactManifest = void 0;

var $4DuZk = parcelRequire("4DuZk");
function $6852e290d659d0bd$var$parseMetricTags(metricTags) {
    var unparsedMetricTags = (0, $4DuZk.parseUnknownObject)(metricTags);
    var parsedMetricTags = {};
    for(var _i = 0, _a = Object.keys(unparsedMetricTags); _i < _a.length; _i++){
        var key = _a[_i];
        var tag = (0, $4DuZk.parseString)(unparsedMetricTags[key]);
        parsedMetricTags[key] = tag;
    }
    return parsedMetricTags;
}
function $6852e290d659d0bd$var$parsePublishMetadata(publishMetadata) {
    var unparsedPublishMetadata = (0, $4DuZk.parseUnknownObject)(publishMetadata);
    var metricTags = "metricTags" in unparsedPublishMetadata ? $6852e290d659d0bd$var$parseMetricTags(unparsedPublishMetadata.metricTags) : undefined;
    return {
        metricTags: metricTags
    };
}
function $6852e290d659d0bd$var$parseDimensions(dimensions) {
    var unparsedDimensions = (0, $4DuZk.parseUnknownObject)(dimensions);
    var supported = (0, $4DuZk.parseArray)(unparsedDimensions.supported).map($4DuZk.parseString);
    var fallback = (0, $4DuZk.parseUndefinedOr)($4DuZk.parseString, unparsedDimensions.fallback);
    return {
        fallback: fallback,
        supported: supported
    };
}
function $6852e290d659d0bd$var$parseDimensionsRecord(dimensionRecord) {
    var parsedDimensionRecord = {};
    var unparsedDimensionRecord = (0, $4DuZk.parseUnknownObject)(dimensionRecord);
    for(var _i = 0, _a = Object.keys(unparsedDimensionRecord); _i < _a.length; _i++){
        var key = _a[_i];
        var dimensionsSpec = $6852e290d659d0bd$var$parseDimensions(unparsedDimensionRecord[key]);
        parsedDimensionRecord[key] = dimensionsSpec;
    }
    return parsedDimensionRecord;
}
function $6852e290d659d0bd$var$parseArtifactManifest(potentialArtifactManifest) {
    var unparsedArtifactManifest = (0, $4DuZk.parseUnknownObject)(potentialArtifactManifest);
    var name = (0, $4DuZk.parseString)(unparsedArtifactManifest.name);
    var tagScheme = (0, $4DuZk.parseString)(unparsedArtifactManifest.tagScheme);
    var frontend = (0, $4DuZk.parseUndefinedOr)($4DuZk.parseBoolean, unparsedArtifactManifest.frontend);
    var dimensions = $6852e290d659d0bd$var$parseDimensionsRecord(unparsedArtifactManifest.dimensions);
    var publishMetadata = $6852e290d659d0bd$var$parsePublishMetadata(unparsedArtifactManifest.publishMetadata);
    return {
        name: name,
        frontend: frontend,
        tagScheme: tagScheme,
        dimensions: dimensions,
        publishMetadata: publishMetadata
    };
}
module.exports.parseArtifactManifest = $6852e290d659d0bd$var$parseArtifactManifest;

});
parcelRegister("4DuZk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseUndefinedOr = module.exports.parseUnknownObject = module.exports.parseBoolean = module.exports.parseArray = module.exports.parseString = void 0;
function $3602d78656005db6$var$parseString(string) {
    if (typeof string === "string") return string;
    throw new Error("Couldn't parse String");
}
module.exports.parseString = $3602d78656005db6$var$parseString;
function $3602d78656005db6$var$parseArray(array) {
    if (Array.isArray(array)) return array;
    throw new Error("Couldn't parse List or Undefined");
}
module.exports.parseArray = $3602d78656005db6$var$parseArray;
function $3602d78656005db6$var$parseBoolean(boolean) {
    if (typeof boolean === "boolean") return boolean;
    throw new Error("Couldn't parse Boolean or undefined");
}
module.exports.parseBoolean = $3602d78656005db6$var$parseBoolean;
function $3602d78656005db6$var$parseUnknownObject(object) {
    if (typeof object === "object") return object;
    throw new Error("Couldn't parse object");
}
module.exports.parseUnknownObject = $3602d78656005db6$var$parseUnknownObject;
function $3602d78656005db6$var$parseUndefinedOr(parse, thing) {
    if (typeof thing === "undefined") return thing;
    else return parse(thing);
}
module.exports.parseUndefinedOr = $3602d78656005db6$var$parseUndefinedOr;

});


parcelRegister("1NPzc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseVersionMetadata = void 0;

var $4DuZk = parcelRequire("4DuZk");
function $15025e265438bcca$var$parseVersionMetadata(possiblyVersionMetadata) {
    var unknownObject = (0, $4DuZk.parseUnknownObject)(possiblyVersionMetadata);
    var version = (0, $4DuZk.parseString)(unknownObject.version);
    var publishTime = new Date((0, $4DuZk.parseString)(unknownObject.publishTime));
    var sidecarImageDigestVersion = (0, $4DuZk.parseString)(unknownObject.sidecarImageDigestVersion);
    return {
        version: version,
        publishTime: publishTime,
        sidecarImageDigestVersion: sidecarImageDigestVersion
    };
}
module.exports.parseVersionMetadata = $15025e265438bcca$var$parseVersionMetadata;

});

parcelRegister("5LTws", function(module, exports) {
"use strict";
var $433c69239a917447$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.checkManifest = void 0;
/**
 * @param manifest manifest retrieved from data source
 * @param request request used to retrieve manifest (ie the artifact name and version specified)
 * @returns the manifest, but now it is guaranteed that the manifest name is the same as the requested name,
 * the version is the same as the requested version (if one is requested) and the version dimension (if it exists)
 * specifies exactly one version
 */ function $433c69239a917447$var$checkManifest(manifest, request) {
    if (manifest.name !== request.name) return {
        key: "mismatched-manifest-name"
    };
    var manifestVersionDimension = manifest.dimensions.version;
    if (request.version) {
        var manifestVersions = manifestVersionDimension ? $433c69239a917447$var$__spreadArray([
            manifestVersionDimension === null || manifestVersionDimension === void 0 ? void 0 : manifestVersionDimension.fallback
        ], manifestVersionDimension === null || manifestVersionDimension === void 0 ? void 0 : manifestVersionDimension.supported, true).filter(function(s) {
            return !!s;
        }) : [];
        var allVersionsMatch = manifestVersions.every(function(v) {
            return v === request.version;
        });
        if (!allVersionsMatch || manifestVersions.length === 0) return {
            key: "mismatched-manifest-version"
        };
    }
    return {
        key: "success"
    };
}
module.exports.checkManifest = $433c69239a917447$var$checkManifest;

});

parcelRegister("6FHvZ", function(module, exports) {
"use strict";
var $4db8538ddb439aee$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $4db8538ddb439aee$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConfigRegistryDataSource = void 0;

var $hdDPm = parcelRequire("hdDPm");

var $auuB0 = parcelRequire("auuB0");

var $8Xjp5 = parcelRequire("8Xjp5");

var $1NPzc = parcelRequire("1NPzc");
var $4db8538ddb439aee$var$ConfigRegistryDataSource = /** @class */ function() {
    function ConfigRegistryDataSource(manifestVersion, configRegistryHttpClient) {
        this.manifestVersion = manifestVersion;
        this.configRegistryHttpClient = configRegistryHttpClient;
    }
    ConfigRegistryDataSource.prototype.getManifest = function(artifactName, artifactVersion) {
        return $4db8538ddb439aee$var$__awaiter(this, void 0, void 0, function() {
            var tag, configRegistryResponse, e_1;
            return $4db8538ddb439aee$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        tag = (0, $hdDPm.getDataTagForManifest)(artifactName, this.manifestVersion, artifactVersion);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(tag)
                        ];
                    case 2:
                        configRegistryResponse = _a.sent();
                        return [
                            2 /*return*/ ,
                            configRegistryResponse.leftMap(function(e) {
                                return e;
                            }).map($8Xjp5.parseArtifactManifest)
                        ];
                    case 3:
                        e_1 = _a.sent();
                        return [
                            2 /*return*/ ,
                            $auuB0.Either.left({
                                key: "config-registry-error",
                                error: e_1
                            })
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    ConfigRegistryDataSource.prototype.getArtifact = function(_artifactName, tag) {
        return $4db8538ddb439aee$var$__awaiter(this, void 0, void 0, function() {
            return $4db8538ddb439aee$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(tag)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    ConfigRegistryDataSource.prototype.getLatestVersionMetadata = function() {
        return $4db8538ddb439aee$var$__awaiter(this, void 0, void 0, function() {
            var dataTag, configRegistryResponse;
            return $4db8538ddb439aee$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        dataTag = (0, $hdDPm.getVersionMetadataTag)();
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(dataTag)
                        ];
                    case 1:
                        configRegistryResponse = _a.sent();
                        return [
                            2 /*return*/ ,
                            configRegistryResponse.bimap(function(error) {
                                return error;
                            }, function(response) {
                                return (0, $1NPzc.parseVersionMetadata)(response);
                            })
                        ];
                }
            });
        });
    };
    return ConfigRegistryDataSource;
}();
module.exports.ConfigRegistryDataSource = $4db8538ddb439aee$var$ConfigRegistryDataSource;

});

parcelRegister("3ijEk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Versions = module.exports.BaseUrls = void 0;
var $26624b831163931e$var$BaseUrls = /** @class */ function() {
    function BaseUrls() {}
    BaseUrls.ConfigRegistryProd = "https://config-registry.prod.atl-paas.net";
    return BaseUrls;
}();
module.exports.BaseUrls = $26624b831163931e$var$BaseUrls;
var $26624b831163931e$var$Versions = /** @class */ function() {
    function Versions() {}
    Versions.ManifestVersion = "v1";
    return Versions;
}();
module.exports.Versions = $26624b831163931e$var$Versions;

});


parcelRegister("3TdLx", function(module, exports) {

$parcel$export(module.exports, "BifrostDataSource", () => $2d512fbe779401ec$export$2cb8d79200775058);

var $6l8hg = parcelRequire("6l8hg");

var $hdDPm = parcelRequire("hdDPm");
class $2d512fbe779401ec$export$2cb8d79200775058 {
    constructor(bifrostClient, manifestVersion){
        this.bifrostClient = bifrostClient;
        this.manifestVersion = manifestVersion;
    }
    async getLatestVersionMetadata() {
        const tag = (0, $hdDPm.getVersionMetadataTag)();
        const bifrostResponse = await this.bifrostClient.getBlob(`${tag}.json`);
        return bifrostResponse.fold((error)=>{
            return (0, $6l8hg.Either).left(error);
        }, (response)=>{
            try {
                const parsedVersionMetadata = (0, $6l8hg.parseVersionMetadata)(response);
                return (0, $6l8hg.Either).right(parsedVersionMetadata);
            } catch (e) {
                const error = {
                    key: "invalid-version-metadata"
                };
                return (0, $6l8hg.Either).left(error);
            }
        });
    }
    async getManifest(artifactName, artifactVersion) {
        const manifestTag = (0, $hdDPm.getDataTagForManifest)(artifactName, this.manifestVersion, artifactVersion);
        const bifrostResponse = await this.bifrostClient.getBlob(`${manifestTag}.json`, artifactName);
        return bifrostResponse.fold((error)=>{
            return (0, $6l8hg.Either).left(error);
        }, (response)=>{
            try {
                const parsedArtifact = (0, $6l8hg.parseArtifactManifest)(response);
                return (0, $6l8hg.Either).right(parsedArtifact);
            } catch (e) {
                const error = {
                    key: "invalid-manifest"
                };
                return (0, $6l8hg.Either).left(error);
            }
        });
    }
    async getArtifact(artifactName, tag) {
        return this.bifrostClient.getBlob(`${tag}.json`, artifactName);
    }
}

});

parcelRegister("3Oidj", function(module, exports) {

$parcel$export(module.exports, "BifrostHttpClientImpl", () => $2c642b791ff52615$export$45c6d12ca9c14f83);

var $6l8hg = parcelRequire("6l8hg");
function $2c642b791ff52615$export$f654b28f82155665(env, perimeter) {
    if (perimeter === "commercial") switch(env){
        case "adev":
        case "ddev":
        case "pdev":
        case "stg":
            return "https://fd-config-bifrost.stg-east.frontend.public.atl-paas.net";
        case "prod":
            return "https://fd-config-bifrost.prod-east.frontend.public.atl-paas.net";
    }
    else if (perimeter === "fedramp-moderate") switch(env){
        case "stg":
            return "https://fd-config-bifrost.stg.frontend.cdn.atlassian-us-gov-mod.com";
        case "prod":
            return "https://fd-config-bifrost.frontend.cdn.atlassian-us-gov-mod.com";
    }
    return "https://fd-config-bifrost.prod-east.frontend.public.atl-paas.net";
}
class $2c642b791ff52615$export$45c6d12ca9c14f83 {
    constructor(env, perimeter){
        this.baseUrl = $2c642b791ff52615$export$f654b28f82155665(env, perimeter);
    }
    async getBlob(tag) {
        const endpoint = `${this.baseUrl}/assets/${tag}`;
        return new Promise((resolve)=>fetch(endpoint).then((response)=>{
                if (!response.ok) resolve((0, $6l8hg.Either).left({
                    key: "unexpected-response-code",
                    httpResponseCode: response.status,
                    httpResponseStatusText: response.statusText
                }));
                response.json().then((json)=>resolve((0, $6l8hg.Either).right(json)));
            }).catch((error)=>resolve((0, $6l8hg.Either).left({
                    key: "failed-fetch",
                    error: "message" in error ? error.message : "unknown error"
                }))));
    }
}

});

parcelRegister("d5LIN", function(module, exports) {

$parcel$export(module.exports, "ConfigClient", () => $9880c2778e17f5cd$export$8489e2f039bfcc4c);

var $eHiP8 = parcelRequire("eHiP8");

var $6l8hg = parcelRequire("6l8hg");

var $4gZ5I = parcelRequire("4gZ5I");
function $9880c2778e17f5cd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9880c2778e17f5cd$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9880c2778e17f5cd$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $eHiP8.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9880c2778e17f5cd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $9880c2778e17f5cd$export$8489e2f039bfcc4c {
    constructor(dataSource, dataSourceName, fetchArtifactExperience, versionMetadataExperience){
        this.fetchArtifactExperience = fetchArtifactExperience;
        this.versionMetadataExperience = versionMetadataExperience;
        this.dataSource = new (0, $4gZ5I.ExperienceDataSourceWrapper)(dataSource, this.fetchArtifactExperience, this.versionMetadataExperience);
        this.dataSourceName = dataSourceName;
    }
    async getArtifact(artifactName, dimensions) {
        this.fetchArtifactExperience.addMetadata(dimensions);
        this.fetchArtifactExperience.start();
        const specifiedDimensions = $9880c2778e17f5cd$var$_objectSpread($9880c2778e17f5cd$var$_objectSpread({}, dimensions), {}, {
            name: artifactName
        });
        const artifact = await (0, $6l8hg.getArtifactFromSource)(this.dataSource, specifiedDimensions, "backend").catch((e)=>({
                type: "artifact-fetch-error",
                publishMetadata: {},
                error: {
                    key: "unexpected-error",
                    error: e
                }
            }));
        if (artifact.type === "success") this.fetchArtifactExperience.success();
        else {
            this.fetchArtifactExperience.addMetadata({
                errorType: artifact.type,
                error: "error" in artifact ? artifact.error.key : undefined
            });
            this.fetchArtifactExperience.failure();
        }
        return (0, $6l8hg.tryGetArtifactData)(artifact, this.dataSourceName);
    }
    async getLatestVersionMetadata() {
        this.versionMetadataExperience.start();
        const getVersionMetadataResult = await this.dataSource.getLatestVersionMetadata();
        return getVersionMetadataResult.fold((error)=>{
            this.versionMetadataExperience.addMetadata({
                error: error.key
            });
            this.versionMetadataExperience.failure();
            throw new Error(`Unable to get latest version metadata from ${this.dataSourceName} due to error: ${error.key}`);
        }, (data)=>{
            this.versionMetadataExperience.success();
            return data;
        });
    }
}

});
parcelRegister("4gZ5I", function(module, exports) {

$parcel$export(module.exports, "ExperienceDataSourceWrapper", () => $31c80b8146ec82d5$export$1cc944571619e6e8);
/**
 * Wraps a standard Datasource as defined by @atlassiansox/flight-deck-core && uses
 * the experience to mark when events happen.
 */ class $31c80b8146ec82d5$export$1cc944571619e6e8 {
    constructor(dataSource, artifactExperience, versionMetadataExperience){
        this.dataSource = dataSource;
        this.artifactExperience = artifactExperience;
        this.versionMetadataExperience = versionMetadataExperience;
    }
    getLatestVersionMetadata() {
        this.versionMetadataExperience.mark("start-fetch-metadata");
        const result = this.dataSource.getLatestVersionMetadata();
        this.versionMetadataExperience.mark("end-fetch-metadata");
        return result;
    }
    async getManifest(artifactName, artifactVersion) {
        this.artifactExperience.mark("start-fetch-artifact");
        const result = await this.dataSource.getManifest(artifactName, artifactVersion);
        result.leftMap((error)=>{
            this.artifactExperience.addMetadata({
                getManifestError: error
            });
            return error;
        });
        this.artifactExperience.mark("end-fetch-artifact");
        return result;
    }
    async getArtifact(artifactName, tag) {
        this.artifactExperience.mark("start-fetch-manifest");
        const result = await this.dataSource.getArtifact(artifactName, tag);
        result.leftMap((error)=>{
            this.artifactExperience.addMetadata({
                getArtifactError: error
            });
            return error;
        });
        this.artifactExperience.mark("end-fetch-manifest");
        return result;
    }
}

});


parcelRegister("95uqQ", function(module, exports) {

$parcel$export(module.exports, "getFlightDeckFetchExperience", () => $69dc2fdcb553c857$export$a3006f8f221c0a3b);
$parcel$export(module.exports, "getVersionMetadataFetchExperience", () => $69dc2fdcb553c857$export$c3ac7702bfd47c1b);
const $69dc2fdcb553c857$var$SAMPLING_RATE = 10;
class $69dc2fdcb553c857$var$UFOExperienceWrapper {
    constructor(experience){
        this.experience = experience;
    }
    start(startTime) {
        return this.experience.start(startTime);
    }
    success() {
        return this.experience.success();
    }
    failure() {
        return this.experience.failure();
    }
    addMetadata(data) {
        return this.experience.addMetadata(data);
    }
    mark(mark) {
        return this.experience.mark(mark);
    }
}
class $69dc2fdcb553c857$export$5e7536cf7bc56fee {
    start() {
        return Promise.resolve();
    }
    success() {
        return Promise.resolve(null);
    }
    failure() {
        return Promise.resolve(null);
    }
    mark() {
        return;
    }
    addMetadata() {
        return;
    }
}

async function $69dc2fdcb553c857$var$flightDeckSDKOperationExperience(id, timings, metadata) {
    try {
        // only emit metrics 1 in every 10 times a Flight Deck Configuration is fetched
        // to not flood Perf Portal with logs.
        if (Math.random() * 100 > $69dc2fdcb553c857$var$SAMPLING_RATE) return new $69dc2fdcb553c857$export$5e7536cf7bc56fee();
        const { UFOExperience: UFOExperience, ExperienceTypes: ExperienceTypes, ExperiencePerformanceTypes: ExperiencePerformanceTypes } = await (parcelRequire("3fucY"));
        const ufoExperience = new UFOExperience(id, {
            type: ExperienceTypes.Operation,
            performanceType: ExperiencePerformanceTypes.Custom,
            platform: {
                component: "flight-deck-client"
            },
            timings: timings
        });
        ufoExperience.addMetadata(metadata);
        return new $69dc2fdcb553c857$var$UFOExperienceWrapper(ufoExperience);
    } catch (_unused) {
        return new $69dc2fdcb553c857$export$5e7536cf7bc56fee();
    }
}
const $69dc2fdcb553c857$export$a3006f8f221c0a3b = ()=>$69dc2fdcb553c857$var$flightDeckSDKOperationExperience("fetch", [
        {
            key: "fetch-artifact",
            endMark: "end-fetch-artifact",
            startMark: "start-fetch-artifact"
        },
        {
            key: "fetch-manifest",
            endMark: "end-fetch-manifest",
            startMark: "start-fetch-manifest"
        }
    ], {});
const $69dc2fdcb553c857$export$c3ac7702bfd47c1b = ()=>$69dc2fdcb553c857$var$flightDeckSDKOperationExperience("fetch-version-metadata", [
        {
            key: "fetch-metadata",
            startMark: "start-fetch-metadata",
            endMark: "end-fetch-metadata"
        }
    ], {});

});
parcelRegister("3fucY", function(module, exports) {

let $25da34894d2180a6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $25da34894d2180a6$var$load("zeQjY").then(()=>parcelRequire('8GXI8'));

});


parcelRegister("kJG1r", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TargetedConfig = module.exports.parseConfigWithTargeting = void 0;

var $fiwxX = parcelRequire("fiwxX");
Object.defineProperty(module.exports, "parseConfigWithTargeting", {
    enumerable: true,
    get: function() {
        return $fiwxX.parseConfigWithTargeting;
    }
});

var $hTlW1 = parcelRequire("hTlW1");
Object.defineProperty(module.exports, "TargetedConfig", {
    enumerable: true,
    get: function() {
        return $hTlW1.TargetedConfig;
    }
});

});
parcelRegister("fiwxX", function(module, exports) {
"use strict";
var $b231c88986716fb9$var$__assign = module.exports && module.exports.__assign || function() {
    $b231c88986716fb9$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b231c88986716fb9$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseConfigWithTargeting = void 0;

var $hTlW1 = parcelRequire("hTlW1");
/**
 * For a given configuration, return the same configuration back
 * with {@link TargetedConfig} substituted where applicable.
 *
 * So anywhere in the JSON that has the objects:
 * ```
 * {
 *   "defaultConfig": ...
 * }
 * ```
 *
 * OR
 *
 * ```
 * {
 *   "defaultConfig": ...
 *   "targeting": {
 *     "targets": [...]
 *     "targetedConfig": ...
 *   }
 * }
 * ```
 *
 * become an instance of {@link TargetedConfig}.
 *
 * @param config configuration that may contain unparsed {@link TargetedConfig}
 * @returns the same configuration with targeted config sub-objects transformed
 *     into {@link TargetedConfig}
 */ function $b231c88986716fb9$var$parseConfigWithTargeting(data) {
    // All "object" types will also need to have a null check because null is an "object", but an
    // invalid one for this use case.
    if (typeof data === "object") {
        if (Array.isArray(data)) return data.map(function(element) {
            return $b231c88986716fb9$var$parseConfigWithTargeting(element);
        });
        else if (data) {
            var parsedObject_1 = data;
            var keys = Object.keys(parsedObject_1);
            if (keys.length === 1 && parsedObject_1.defaultConfig) return new $hTlW1.TargetedConfig({
                defaultConfig: $b231c88986716fb9$var$parseConfigWithTargeting(parsedObject_1.defaultConfig)
            });
            else if (keys.length === 2 && parsedObject_1.defaultConfig && parsedObject_1.targeting) {
                var parseResult = $b231c88986716fb9$var$parseTargeting(parsedObject_1.targeting);
                if (parseResult.type === "match") return new $hTlW1.TargetedConfig({
                    targeting: parseResult.result,
                    defaultConfig: $b231c88986716fb9$var$parseConfigWithTargeting(parsedObject_1.defaultConfig)
                });
            }
            return keys.reduce(function(accObject, key) {
                var _a;
                return $b231c88986716fb9$var$__assign($b231c88986716fb9$var$__assign({}, accObject), (_a = {}, _a[key] = $b231c88986716fb9$var$parseConfigWithTargeting(parsedObject_1[key]), _a));
            }, {});
        } else return null;
    } else return data;
}
module.exports.parseConfigWithTargeting = $b231c88986716fb9$var$parseConfigWithTargeting;
function $b231c88986716fb9$var$parseTargeting(targeting) {
    if (typeof targeting === "object" && targeting && !Array.isArray(targeting)) {
        var targetingKeyValue = targeting;
        var targetingKeys = Object.keys(targetingKeyValue);
        if (targetingKeys.length == 2 && targetingKeyValue.targets && targetingKeyValue.targetedConfig) return {
            type: "match",
            result: {
                targets: $b231c88986716fb9$var$parseTargets(targetingKeyValue.targets),
                targetedConfig: $b231c88986716fb9$var$parseConfigWithTargeting(targetingKeyValue.targetedConfig)
            }
        };
    }
    return {
        type: "no-match"
    };
}
function $b231c88986716fb9$var$parseTargets(targets) {
    if (Array.isArray(targets)) return targets.map(function(target) {
        return {
            orgIds: $b231c88986716fb9$var$parseIdentifierList(target.orgIds),
            siteIds: $b231c88986716fb9$var$parseIdentifierList(target.siteIds),
            userIds: $b231c88986716fb9$var$parseIdentifierList(target.userIds)
        };
    });
    else throw new Error("The targets for Flight Deck targeted configuration must come in an array.");
}
function $b231c88986716fb9$var$parseIdentifierList(identifierList) {
    if (identifierList === undefined) return undefined;
    if (Array.isArray(identifierList)) return identifierList.map(function(id) {
        if (typeof id === "string") return id;
        else throw new Error("Identifiers for targets must be strings!");
    });
    else throw new Error("Identifier list must be an array!");
}

});
parcelRegister("hTlW1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TargetedConfig = void 0;
/**
 * Defines a part of the overall configuration that has different
 * values based on the intended target. The target is a specification
 * of a combination of site id, user id and org id.
 */ var $d068968b22fc3b5a$var$TargetedConfig = /** @class */ function() {
    function TargetedConfig(targetedConfigDefinition) {
        this.targetedConfigDefinition = targetedConfigDefinition;
    }
    /**
     * Determines whether to use the targeted configuration value or the default value
     * depending on whether the specified values match any of the target's rules.
     *
     * @param target the values to use to evaluate the config
     * @returns the {@link TargetingResult}, which would be the default value
     *     if the specified target did not match, or the targeted value if there
     *     was a match
     */ TargetedConfig.prototype.resolve = function(target) {
        var targeting = this.targetedConfigDefinition.targeting;
        if (targeting) {
            var targeted = targeting.targets.some(function(configuredTarget) {
                var criteria = [];
                if (configuredTarget.orgIds) criteria.push({
                    allowList: configuredTarget.orgIds,
                    identifier: target.orgId
                });
                if (configuredTarget.siteIds) criteria.push({
                    allowList: configuredTarget.siteIds,
                    identifier: target.siteId
                });
                if (configuredTarget.userIds) criteria.push({
                    allowList: configuredTarget.userIds,
                    identifier: target.userId
                });
                if (criteria.length === 0) return false;
                else return criteria.every(function(criteria) {
                    return $d068968b22fc3b5a$var$resolveForTargetCriteria(criteria);
                });
            });
            if (targeted) return {
                type: "targeted",
                value: targeting.targetedConfig
            };
        }
        return {
            type: "default",
            value: this.targetedConfigDefinition.defaultConfig
        };
    };
    return TargetedConfig;
}();
module.exports.TargetedConfig = $d068968b22fc3b5a$var$TargetedConfig;
function $d068968b22fc3b5a$var$resolveForTargetCriteria(criteria) {
    return !!criteria.identifier && criteria.allowList.includes(criteria.identifier);
}

});




parcelRegister("lKWnb", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd6b2c7e02ec3fe7$export$2e2bcd8739ae039);
class $fd6b2c7e02ec3fe7$export$2e2bcd8739ae039 extends Error {
    constructor({ artifact: artifact, dimensions: dimensions, error: error }){
        super(error instanceof Error && error.message ? error.message : "Unknown Flight Deck SDK error");
        this.name = "FlightDeckSDKError";
        this.error = error;
        this.artifact = artifact;
        this.environmentType = dimensions === null || dimensions === void 0 ? void 0 : dimensions.environmentType;
        this.locale = dimensions === null || dimensions === void 0 ? void 0 : dimensions.locale;
    }
}
const $fd6b2c7e02ec3fe7$export$1d76d155060824c9 = (e)=>e instanceof $fd6b2c7e02ec3fe7$export$2e2bcd8739ae039;

});

parcelRegister("4r7nA", function(module, exports) {

$parcel$export(module.exports, "artifactKey", () => $33af6871e9658618$export$e3553dc63541d477);
const $33af6871e9658618$export$e3553dc63541d477 = (artifactName, dimensions)=>{
    return `${artifactName}${dimensions ? "_" + Object.keys(dimensions).sort().map((key)=>dimensions[key]).filter(Boolean).join("_") : ""}`;
};

});

parcelRegister("814TT", function(module, exports) {

$parcel$export(module.exports, "flightDeckClientExperience", () => $5d6237e1ec8a6bfc$export$1e3a41a51f6457c5);
$parcel$export(module.exports, "exceptionToMetadata", () => $5d6237e1ec8a6bfc$export$f33622abb5224195);

var $eHiP8 = parcelRequire("eHiP8");

var $atdLB = parcelRequire("atdLB");
var $duUGa = parcelRequire("duUGa");
function $5d6237e1ec8a6bfc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5d6237e1ec8a6bfc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5d6237e1ec8a6bfc$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $eHiP8.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5d6237e1ec8a6bfc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $5d6237e1ec8a6bfc$export$6061a1a9a61f2e21 = ()=>new (0, $duUGa.UFOExperience)("fetch", {
        type: (0, $atdLB.ExperienceTypes).Operation,
        performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom,
        platform: {
            component: "flight-deck-client"
        }
    });
const $5d6237e1ec8a6bfc$export$1e3a41a51f6457c5 = ()=>new (0, $duUGa.UFOExperience)("retrieve-artifact", {
        type: (0, $atdLB.ExperienceTypes).Operation,
        performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom,
        platform: {
            component: "flight-deck-client"
        }
    });
const $5d6237e1ec8a6bfc$export$f33622abb5224195 = (e)=>{
    return e instanceof Error ? $5d6237e1ec8a6bfc$var$_objectSpread($5d6237e1ec8a6bfc$var$_objectSpread({}, e), {}, {
        cause: undefined
    }) : "unknown";
};

});


parcelRegister("3j5Ay", function(module, exports) {

$parcel$export(module.exports, "SwitchToTooltipText", () => $b102069bd48b9b82$export$c5ef4d14b7e18cbd);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $99tqu = parcelRequire("99tqu");

var $5WNqJ = parcelRequire("5WNqJ");
const $b102069bd48b9b82$export$c5ef4d14b7e18cbd = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $99tqu.default), {
    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
        ...(0, $5WNqJ.default).switchSitesOrAppsTooltip
    })
});

});

parcelRegister("jcYbC", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e3fbc9fddcea1b7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
class $1e3fbc9fddcea1b7$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    static{
        this.defaultProps = {
            fallback: null
        };
    }
    async componentDidMount() {
        const { client: client, messageId: messageId } = this.props;
        try {
            const started = await client.start(messageId);
            if (started) // eslint-disable-next-line react/no-did-mount-set-state
            this.setState({
                shouldRenderChildren: true
            });
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error(`Unable to start flow message ${messageId}. ${err}`);
        }
    }
    injectStop(children) {
        return /*#__PURE__*/ (0, $5uXOq.cloneElement)(children, {
            stop: this.stop
        });
    }
    render() {
        const { fallback: fallback, children: children } = this.props;
        const { shouldRenderChildren: shouldRenderChildren } = this.state;
        return shouldRenderChildren ? this.injectStop(children) : fallback;
    }
    constructor(...args){
        super(...args), this.state = {
            shouldRenderChildren: false
        }, this.stop = async ()=>{
            const { client: client, messageId: messageId } = this.props;
            try {
                await client.stop(messageId);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error(`Unable to stop flow message ${messageId}. ${err}`);
            }
        };
    }
}

});

parcelRegister("jZ4fr", function(module, exports) {

$parcel$export(module.exports, "EngagementSpotlight", () => $bfd4434fdcf1c696$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $1QiBP = parcelRequire("1QiBP");

var $gPtFm = parcelRequire("gPtFm");

var $bPTaj = parcelRequire("bPTaj");

var $f9Hff = parcelRequire("f9Hff");

var $iQWvK = parcelRequire("iQWvK");
const $bfd4434fdcf1c696$var$SpotlightWithVariables = (0, $gPtFm.default)((0, $iQWvK.default));
const $bfd4434fdcf1c696$export$f57123e11f24bec9 = (0, $bPTaj.default)($bfd4434fdcf1c696$var$SpotlightWithVariables);
const $bfd4434fdcf1c696$var$SpotlightWithMessage = (0, $f9Hff.default)($bfd4434fdcf1c696$export$f57123e11f24bec9, 'spotlight');
function $bfd4434fdcf1c696$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1QiBP.default), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($bfd4434fdcf1c696$var$SpotlightWithMessage, {
            ...props
        })
    });
}

});
parcelRegister("gPtFm", function(module, exports) {

$parcel$export(module.exports, "default", () => $aefa8c8d82352ccc$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $5yTPS = parcelRequire("5yTPS");
function $aefa8c8d82352ccc$export$2e2bcd8739ae039(TargetComponent) {
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class WithVariables extends (0, $5uXOq.Component) {
        static{
            this.displayName = `${TargetComponent.displayName || TargetComponent.name || ''}WithEPVariables`;
        }
        render() {
            const props = $aefa8c8d82352ccc$var$runMessagePropsReplacement(this.props);
            if (!props) return null;
            return /*#__PURE__*/ (0, $2OMIu.jsx)(TargetComponent, {
                ...props
            });
        }
    }
    return WithVariables;
}
/**
 * Runs replacement over spotlight message properties.
 * Returns null if replacement fails.
 */ function $aefa8c8d82352ccc$var$runMessagePropsReplacement(props) {
    const { variables: variables, ...otherProps } = props;
    const { title: title, body: body, primaryText: primaryText, primaryAction: primaryAction, secondaryText: secondaryText, secondaryAction: secondaryAction } = props;
    const inputs = {
        title: title,
        body: body,
        primaryText: primaryText,
        primaryActionUrl: primaryAction && primaryAction.data && primaryAction.data.url,
        secondaryText: secondaryText,
        secondaryActionUrl: secondaryAction && secondaryAction.data && secondaryAction.data.url
    };
    const replacedInputs = (0, $5yTPS.runTemplateOnInputs)(variables || {}, inputs);
    if (!replacedInputs) return null;
    const outputProps = {
        ...otherProps,
        title: replacedInputs.title,
        body: replacedInputs.body,
        primaryText: replacedInputs.primaryText,
        secondaryText: replacedInputs.secondaryText
    };
    if (primaryAction) outputProps.primaryAction = (0, $5yTPS.rebuildButtonAction)(replacedInputs.primaryActionUrl, primaryAction);
    if (secondaryAction) outputProps.secondaryAction = (0, $5yTPS.rebuildButtonAction)(replacedInputs.secondaryActionUrl, secondaryAction);
    return outputProps;
}

});
parcelRegister("5yTPS", function(module, exports) {

$parcel$export(module.exports, "rebuildButtonAction", () => $622ebbd98b1631f7$export$5d0ec4f796aceeb1);
$parcel$export(module.exports, "runTemplateOnInputs", () => $622ebbd98b1631f7$export$d808999430a3f186);

var $4KQrx = parcelRequire("4KQrx");
function $622ebbd98b1631f7$export$5d0ec4f796aceeb1(replacedUrl, action) {
    return {
        ...action,
        data: action.data && {
            ...action.data,
            url: replacedUrl
        }
    };
}
function $622ebbd98b1631f7$export$d808999430a3f186(variables, messageInputs) {
    const keys = Object.keys(messageInputs);
    const output = {};
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const input = messageInputs[key];
        if (input) {
            const isUrl = key === 'primaryActionUrl' || key === 'secondaryActionUrl';
            const replacedInput = isUrl ? (0, $4KQrx.runTemplateForUrl)(input, variables) : (0, $4KQrx.runTemplateForHtml)(input, variables);
            if (replacedInput.type === (0, $c9ec58d20996f864$export$edb46161045fece7)) return null;
            output[key] = replacedInput.result;
        }
    }
    return output;
}

});
const $c9ec58d20996f864$export$e26f00bd90899835 = 'success';
const $c9ec58d20996f864$export$edb46161045fece7 = 'error';

parcelRegister("4KQrx", function(module, exports) {

$parcel$export(module.exports, "runTemplateForUrl", () => $ac5798f8b467fc46$export$416b2ef51d91ea20);
$parcel$export(module.exports, "runTemplateForHtml", () => $ac5798f8b467fc46$export$5681b97796b74884);

var $aw4un = parcelRequire("aw4un");

var $jgdnH = parcelRequire("jgdnH");


var $9OzUk = parcelRequire("9OzUk");
function $ac5798f8b467fc46$export$5d49303889cd00ad(template) {
    const parsedTemplate = (0, $aw4un.default)(template);
    return (0, $9OzUk.getRequiredVariablesFromTemplate)(parsedTemplate);
}
function $ac5798f8b467fc46$export$416b2ef51d91ea20(template, variables) {
    const epTemplate = (0, $aw4un.default)(template);
    return (0, $jgdnH.replaceForUrl)(epTemplate, variables);
}
function $ac5798f8b467fc46$export$5681b97796b74884(template, variables) {
    const epTemplate = (0, $aw4un.default)(template);
    return (0, $jgdnH.replaceForHtml)(epTemplate, variables);
}

});
parcelRegister("aw4un", function(module, exports) {

$parcel$export(module.exports, "default", () => $66b88773aebc8159$export$2e2bcd8739ae039);

var $2zjmT = parcelRequire("2zjmT");
/**
 * This is regular expression to parse double and triple bracket variables.
 * We should replace this with an imperative parser or a library if we want to
 * add more functionality, but this is simple enough as it is.
 *
 * The regular expression is:
 *
 * # Try to match triple bracket variables in a capture group:
 * (
 *   {{{ # Start matching on leading "{{{"
 *     (
 *       # Match on 1+ inner characters
 *       (
 *         # Do negative look-ahead for closing brackets '}}}'.
 *         # Then match on any character. What this means is, match on any
 *         # character that isn't a bracket followed by two other brackets.
 *         # So, first check if we're not at the end of the tag, otherwise
 *         # match.
 *         # Negative look-ahead won't collect the character, just fail if it's
 *         # the triple bracket sequence.
 *         (?!}}}).
 *       )+
 *     ) # Finish `UNESCAPED_GROUP_CONTENTS`, which is our UNESCAPED variable
 *       # name capture group
 *   }}}
 * )
 *
 * | # OR try matching the double bracket variables
 *
 * # The logic is the same, throughout
 * (
 *   {{
 *     (
 *       (
 *         (?!}}).
 *       )+
 *     ) # Finish `ESCAPED_GROUP_CONTENTS`, which is our ESCAPED variable name
 *       # capture group
 *   }}
 * )
 *
 * See https://regex101.com/r/Eo26HD/1 too.
 *
 * Group indexes are named bellow.
 */ const $66b88773aebc8159$var$PARSE_VARIABLES_REGEXP = /({{{(((?!}}}).)+)}}})|({{(((?!}}).)+)}})/g;
const $66b88773aebc8159$var$UNESCAPED_MATCH = 1;
const $66b88773aebc8159$var$UNESCAPED_GROUP_CONTENTS = 2;
const $66b88773aebc8159$var$ESCAPED_GROUP_CONTENTS = 5;
function $66b88773aebc8159$export$2e2bcd8739ae039(template) {
    const parts = (0, $2zjmT.regexpParts)(template, $66b88773aebc8159$var$PARSE_VARIABLES_REGEXP);
    return {
        parts: parts.map((regexpPart)=>{
            if (regexpPart.type === 'text') return regexpPart;
            if (regexpPart.match[$66b88773aebc8159$var$UNESCAPED_MATCH]) return {
                type: 'unescaped',
                variableName: regexpPart.match[$66b88773aebc8159$var$UNESCAPED_GROUP_CONTENTS] || ''
            };
            return {
                type: 'escaped',
                variableName: regexpPart.match[$66b88773aebc8159$var$ESCAPED_GROUP_CONTENTS] || ''
            };
        })
    };
}

});
parcelRegister("2zjmT", function(module, exports) {

$parcel$export(module.exports, "regexpParts", () => $08d9fc1afbfb58e1$export$b16d411b3b6d6dff);
function $08d9fc1afbfb58e1$export$b16d411b3b6d6dff(input, regexp) {
    const allMatches = $08d9fc1afbfb58e1$export$1ab25a4faafb1ac3(input, regexp);
    const state = allMatches.reduce((memo, matchResult)=>{
        const leadingIndex = matchResult.index || 0;
        const leading = input.slice(memo.currentPosition, leadingIndex);
        if (leading) memo.result.push({
            type: 'text',
            text: leading
        });
        memo.result.push({
            type: 'match',
            match: matchResult
        });
        return {
            currentPosition: leadingIndex + $08d9fc1afbfb58e1$export$3aff5fb0c83cea11(matchResult),
            result: memo.result
        };
    }, {
        currentPosition: 0,
        result: []
    });
    const trailing = input.slice(state.currentPosition, input.length);
    if (trailing) state.result.push({
        type: 'text',
        text: trailing
    });
    return state.result;
}
function $08d9fc1afbfb58e1$export$1ab25a4faafb1ac3(input, regexp) {
    const result = [];
    for(let m = regexp.exec(input); m; m = regexp.exec(input))result.push(m);
    return result;
}
function $08d9fc1afbfb58e1$export$3aff5fb0c83cea11(matchResult) {
    return matchResult[0] ? matchResult[0].length : 0;
}

});


parcelRegister("jgdnH", function(module, exports) {

$parcel$export(module.exports, "replaceForUrl", () => $05830e2163b9771d$export$d10ae881b12b8ef2);
$parcel$export(module.exports, "replaceForHtml", () => $05830e2163b9771d$export$ca536300dbd6350);

var $9OzUk = parcelRequire("9OzUk");

var $e4chf = parcelRequire("e4chf");
/**
 * Runs variable validation and if successful calls the provided function and
 * wraps it in a result object, otherwise returns a failure.
 */ function $05830e2163b9771d$var$withVariableValidation(template, variables, fn) {
    const requiredKeys = (0, $9OzUk.getRequiredVariablesFromTemplate)(template);
    const missingKeys = requiredKeys.filter((variableName)=>!variables[variableName]);
    if (missingKeys.length) return {
        type: 'error',
        errorType: 'missing-variables-error',
        missingVariables: missingKeys
    };
    return {
        type: 'success',
        result: fn(template, variables)
    };
}
/**
 * Replaces variables onto a template, using the provided escaping function.
 */ function $05830e2163b9771d$var$rawReplaceVariables(template, variables, escapeFn) {
    return template.parts.map((templatePart)=>{
        if (templatePart.type === 'text') return templatePart.text;
        if (templatePart.type === 'escaped') return escapeFn(variables[templatePart.variableName]);
        return variables[templatePart.variableName];
    }).join('');
}
/**
 * Without validation, runs a template with URI escaping.
 */ function $05830e2163b9771d$var$rawReplaceVariablesForUrl(template, variables) {
    return $05830e2163b9771d$var$rawReplaceVariables(template, variables, encodeURIComponent);
}
/**
 * Without validation, runs a template with HTML escaping.
 */ function $05830e2163b9771d$var$rawReplaceVariablesForHtml(template, variables) {
    return $05830e2163b9771d$var$rawReplaceVariables(template, variables, (0, $e4chf.default));
}
function $05830e2163b9771d$export$d10ae881b12b8ef2(template, variables) {
    return $05830e2163b9771d$var$withVariableValidation(template, variables, $05830e2163b9771d$var$rawReplaceVariablesForUrl);
}
function $05830e2163b9771d$export$ca536300dbd6350(template, variables) {
    return $05830e2163b9771d$var$withVariableValidation(template, variables, $05830e2163b9771d$var$rawReplaceVariablesForHtml);
}

});
parcelRegister("9OzUk", function(module, exports) {

$parcel$export(module.exports, "getRequiredVariablesFromTemplate", () => $e84b2def1adf6c31$export$4a33186abb06007b);

var $49Drv = parcelRequire("49Drv");
function $e84b2def1adf6c31$export$bf97a83dc861479c(template) {
    const variableParts = template.parts.filter((part)=>part.type === 'escaped' || part.type === 'unescaped');
    return variableParts;
}
function $e84b2def1adf6c31$export$4a33186abb06007b(template) {
    const variableParts = $e84b2def1adf6c31$export$bf97a83dc861479c(template);
    const variableNames = variableParts.map((part)=>part.variableName);
    return (0, $49Drv.uniqStrings)(variableNames);
}

});
parcelRegister("49Drv", function(module, exports) {

$parcel$export(module.exports, "uniqStrings", () => $87c69c0fd6ae5d16$export$c150c7c1a29f33d8);
/**
 * Removes duplicate strings from an array.
 */ function $87c69c0fd6ae5d16$export$c150c7c1a29f33d8(strings) {
    const ourSet = {};
    for(let i = 0; i < strings.length; i++)ourSet[strings[i]] = null;
    return Object.keys(ourSet);
}

});


parcelRegister("e4chf", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9ff333996c100ad$export$2e2bcd8739ae039);
/**
 * Escapes an HTML string.
 *
 * @param {String} input
 * @return {String}
 */ function $a9ff333996c100ad$export$2e2bcd8739ae039(input) {
    return input.replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39');
}

});





parcelRegister("iQWvK", function(module, exports) {

$parcel$export(module.exports, "default", () => $80ccf854c3896af1$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $7gs1W = parcelRequire("7gs1W");

var $02CEF = parcelRequire("02CEF");

var $9pLR7 = parcelRequire("9pLR7");
class $80ccf854c3896af1$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            fireClickEvent: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    getButtonClickHandler(buttonType, action) {
        const { fireClickEvent: fireClickEvent } = this.props;
        switch(action.type){
            case (0, $02CEF.buttonActionTypes).LINK:
                return ()=>{
                    fireClickEvent(`${buttonType}`);
                    window.open(action.data.url, action.data.target);
                };
            default:
                return ()=>{
                    fireClickEvent(`${buttonType}`);
                };
        }
    }
    getButtonActions() {
        const { primaryAction: primaryAction, primaryText: primaryText, secondaryAction: secondaryAction, secondaryText: secondaryText } = this.props;
        const actions = [];
        if (secondaryAction && secondaryText) actions.push({
            onClick: this.getButtonClickHandler('secondary', secondaryAction),
            text: secondaryText,
            appearance: secondaryAction.appearance
        });
        if (primaryAction && primaryText) actions.push({
            onClick: this.getButtonClickHandler('primary', primaryAction),
            text: primaryText,
            appearance: primaryAction.appearance,
            autoFocus: true
        });
        return actions;
    }
    render() {
        const { body: body, dialogPlacement: dialogPlacement, dialogWidth: dialogWidth, title: title, image: image, pulse: pulse, target: target, targetBgColor: targetBgColor, targetRadius: targetRadius } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7gs1W.default), {
            actions: this.getButtonActions(),
            dialogPlacement: dialogPlacement,
            dialogWidth: dialogWidth,
            heading: title,
            image: image,
            pulse: pulse,
            target: target,
            targetBgColor: targetBgColor,
            targetRadius: targetRadius,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9pLR7.default), {
                html: body
            })
        });
    }
}

});


parcelRegister("8BADj", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfb4f957faa4666a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");


var $ff95y = parcelRequire("ff95y");

var $l87SR = parcelRequire("l87SR");

var $4uVQz = parcelRequire("4uVQz");

var $cXqc2 = parcelRequire("cXqc2");
const $bfb4f957faa4666a$var$useRecommendations = ({ endpoint: endpoint = '/gateway/api/graphql', contextResolver: contextResolver })=>{
    /**
	 * Fetch recommendations for a given context
	 */ const getRecommendations = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((args, deprecatedRerank = [])=>{
        // Deconstruct the args object with deprecated arguments to make it backwards compatible
        const { first: first, rerank: rerank, config: { cacheConfig: cacheConfig } = {
            cacheConfig: undefined
        } } = typeof args === 'number' ? {
            first: args,
            rerank: deprecatedRerank
        } : args;
        const recommendationRequestMaker = new (0, $l87SR.default)(endpoint);
        const requester = new (0, $cXqc2.default)(new (0, $4uVQz.RecommendationsRequestBroker)());
        const context = (0, $ff95y.getContext)(contextResolver);
        return requester.fetch(recommendationRequestMaker.makeRequest({
            contextResolver: contextResolver,
            first: first,
            rerank: rerank
        }), {
            cacheConfig: cacheConfig ? {
                ...cacheConfig,
                cacheName: (0, $da4e8aad466a0810$export$14b7e2c312f27acd),
                useCase: context.useCase
            } : undefined
        });
    }, [
        contextResolver,
        endpoint
    ]);
    return {
        getRecommendations: getRecommendations
    };
};
var $bfb4f957faa4666a$export$2e2bcd8739ae039 = $bfb4f957faa4666a$var$useRecommendations;

});
// Events
const $da4e8aad466a0810$export$38f20466f22f45f0 = 'CLICK_PRIVACY_POLICY_LINK';
const $da4e8aad466a0810$export$836f30b3a88d4259 = 'UNDO_DISMISSAL_STARTED';
const $da4e8aad466a0810$export$5ee3f53555c01a95 = 'UNDO_DISMISSAL_SUCCEEDED';
const $da4e8aad466a0810$export$eebf6a2671000e28 = 'UNDO_DISMISSAL_FAILED';
const $da4e8aad466a0810$export$14b7e2c312f27acd = 'atlassian-growth-recos';

parcelRegister("ff95y", function(module, exports) {

$parcel$export(module.exports, "isNotEmpty", () => $ee009361a69048d3$export$a079a83b07f794bf);
$parcel$export(module.exports, "getContext", () => $ee009361a69048d3$export$31553aaa555c1514);
function $ee009361a69048d3$export$a079a83b07f794bf(value) {
    if (value === null || value === undefined || value === '') return false;
    if (Array.isArray(value) && value.length === 0) return false;
    if (typeof value === 'object' && Object.keys(value).length === 0) return false;
    return true;
}
function $ee009361a69048d3$export$31553aaa555c1514(contextResolver, checkUseCase = true) {
    const context = typeof contextResolver === 'function' ? contextResolver() : contextResolver;
    if (checkUseCase && (typeof context?.useCase !== 'string' || context?.useCase.trim().length === 0)) throw new Error('useCase is required');
    return context;
}

});

parcelRegister("l87SR", function(module, exports) {

$parcel$export(module.exports, "default", () => $8604759809cc2eda$export$2e2bcd8739ae039);

var $fTyJz = parcelRequire("fTyJz");
class $8604759809cc2eda$export$2e2bcd8739ae039 extends (0, $fTyJz.default) {
    makeRequest(makeRequestParams) {
        const { contextResolver: contextResolver, first: first, rerank: rerank } = makeRequestParams;
        return new Request(this.endpoint, {
            method: 'POST',
            credentials: 'include',
            mode: 'cors',
            headers: this.getHeaders(),
            body: JSON.stringify({
                query: $8604759809cc2eda$var$recommendationsQuery,
                variables: {
                    first: first,
                    context: this.getContext(contextResolver),
                    rerank: rerank
                }
            })
        });
    }
}
const $8604759809cc2eda$var$recommendationsQuery = `
query GrowthRecQuery($context: GrowthRecContext!, $first: Int!, $rerank: [GrowthRecRerankCandidate!]) {
  growthRecommendations {
    recommendations(context: $context, first: $first, rerank: $rerank) {
      ... on GrowthRecRecommendations {
        __typename
        data {
          __typename
          entityId
          reasons
        }
      }
      ... on QueryError {
        __typename
        identifier
        message
        extensions {
          __typename
          statusCode
          errorType
        }
      }
    }
  }
}
`;

});
parcelRegister("fTyJz", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec31d8e456e3aee1$export$2e2bcd8739ae039);

var $ff95y = parcelRequire("ff95y");
class $ec31d8e456e3aee1$export$2e2bcd8739ae039 {
    constructor(endpoint){
        this.endpoint = endpoint;
    }
    getHeaders() {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        return headers;
    }
    getContext(contextResolver) {
        return (0, $ff95y.getContext)(contextResolver);
    }
}

});


parcelRegister("4uVQz", function(module, exports) {

$parcel$export(module.exports, "RecommendationsRequestBroker", () => $aa387ceef604bdbc$export$7f19312509e0d2c0);

var $kUq2S = parcelRequire("kUq2S");
class $aa387ceef604bdbc$export$7f19312509e0d2c0 {
    extract(response) {
        return response?.recommendations?.data ?? [];
    }
    getSuccessResultCreator(response, result) {
        return new (0, $kUq2S.RecommendationSuccessResultCreator)(response, result);
    }
}

});
parcelRegister("kUq2S", function(module, exports) {

$parcel$export(module.exports, "RecommendationSuccessResultCreator", () => $02dd3dd5e410d55c$export$c02f0b31b3b527a3);

var $hGfBp = parcelRequire("hGfBp");
class $02dd3dd5e410d55c$export$c02f0b31b3b527a3 extends (0, $hGfBp.QuerySuccessResultCreator) {
    constructor(response, data){
        super(response, data), this.response = response;
    }
    makeQueryResult() {
        return new (0, $hGfBp.GraphQlQueryResult)(this.response.status, this.response.statusText, {
            data: this.data
        });
    }
}

});
parcelRegister("hGfBp", function(module, exports) {

$parcel$export(module.exports, "GraphQlQueryResult", () => $8830fb3ab4a1cf4d$export$d0a1abfd57dc5018);
$parcel$export(module.exports, "NonOkQueryResultCreator", () => $8830fb3ab4a1cf4d$export$ad7cb7f4450dd7c4);
$parcel$export(module.exports, "GeneralQueryErrorResultCreator", () => $8830fb3ab4a1cf4d$export$553722ecbbe27276);
$parcel$export(module.exports, "MissingQueryDataResultCreator", () => $8830fb3ab4a1cf4d$export$ff264bfdc9a404eb);
$parcel$export(module.exports, "QuerySuccessResultCreator", () => $8830fb3ab4a1cf4d$export$6b16771e962990ff);
class $8830fb3ab4a1cf4d$export$d0a1abfd57dc5018 {
    constructor(code, reason, response){
        this.code = code;
        this.reason = reason;
        this.response = response;
    }
}
class $8830fb3ab4a1cf4d$var$QueryResultCreator {
}
class $8830fb3ab4a1cf4d$export$ad7cb7f4450dd7c4 extends $8830fb3ab4a1cf4d$var$QueryResultCreator {
    constructor(fetchResponse){
        super(), this.fetchResponse = fetchResponse;
    }
    makeQueryResult() {
        return new $8830fb3ab4a1cf4d$export$d0a1abfd57dc5018(this.fetchResponse.status, this.fetchResponse.statusText);
    }
}
class $8830fb3ab4a1cf4d$export$553722ecbbe27276 extends $8830fb3ab4a1cf4d$var$QueryResultCreator {
    constructor(errors){
        super(), this.errors = errors;
    }
    makeQueryResult() {
        const [{ extensions: extensions }] = this.errors;
        const [{ statusCode: statusCode, errorType: errorType }] = Array.isArray(extensions) ? extensions : [
            extensions
        ];
        return new $8830fb3ab4a1cf4d$export$d0a1abfd57dc5018(statusCode, errorType, {
            errors: this.errors.map((error)=>error.message)
        });
    }
}
class $8830fb3ab4a1cf4d$export$ff264bfdc9a404eb extends $8830fb3ab4a1cf4d$var$QueryResultCreator {
    constructor(fetchResponse){
        super(), this.fetchResponse = fetchResponse;
    }
    makeQueryResult() {
        return new $8830fb3ab4a1cf4d$export$d0a1abfd57dc5018(this.fetchResponse.status, this.fetchResponse.statusText, {
            errors: [
                'Received data has missing attributes'
            ]
        });
    }
}
class $8830fb3ab4a1cf4d$export$6b16771e962990ff extends $8830fb3ab4a1cf4d$var$QueryResultCreator {
    constructor(response, data){
        super(), this.response = response, this.data = data;
    }
}

});



parcelRegister("cXqc2", function(module, exports) {

$parcel$export(module.exports, "default", () => $90ccf5794fa0d0ad$export$2e2bcd8739ae039);

var $hGfBp = parcelRequire("hGfBp");

var $fq6vo = parcelRequire("fq6vo");
class $90ccf5794fa0d0ad$export$2e2bcd8739ae039 {
    constructor(broker){
        this.broker = broker;
    }
    /**
	 * Fetches the response by the given request from the cache or the API
	 * the cache config is optional, if not provided, the response will not be cached
	 *
	 * @param request The request to fetch the response from
	 * @param cacheConfig The cache configuration to use
	 * @returns The query result
	 */ fetch(request, { cacheConfig: cacheConfig } = {}) {
        return new Promise(async (resolve, reject)=>{
            const response = await this.getResponse(request, cacheConfig);
            if (!response.ok) return reject(new (0, $hGfBp.NonOkQueryResultCreator)(response).makeQueryResult());
            const json = await response.json();
            if (json.errors) return reject(new (0, $hGfBp.GeneralQueryErrorResultCreator)(json.errors).makeQueryResult());
            const schemaResponse = json?.data?.growthRecommendations;
            const queryRes = this.broker.extract(schemaResponse);
            // Undefined is not expected as a valid response from GraphQL
            if (queryRes === undefined) return reject(new (0, $hGfBp.MissingQueryDataResultCreator)(response).makeQueryResult());
            return resolve(this.broker.getSuccessResultCreator(response, queryRes).makeQueryResult());
        });
    }
    /**
	 * Fetches the response by tha given request from the cache or the API
	 * the cache config is optional, if not provided, the response will not be cached
	 *
	 * @param request The request to fetch the response from
	 * @param cacheConfig The cache configuration to use
	 * @returns The response from the request
	 */ async getResponse(request, cacheConfig) {
        const cacheProvider = (0, $fq6vo.default).resolve(cacheConfig);
        const cachedResponse = await cacheProvider.get(request);
        // If the response is cached, return it
        if (cachedResponse) return cachedResponse;
        // Clone the request before it being used to be able to use it multiple times
        const clonedRequest = request.clone();
        return fetch(request).then((response)=>{
            // Cache response only if the response is ok
            if (response.ok) cacheProvider.set(clonedRequest, response.clone());
            return response;
        });
    }
}

});
parcelRegister("fq6vo", function(module, exports) {

$parcel$export(module.exports, "default", () => $9484e774818fc57c$export$2e2bcd8739ae039);

var $2KliV = parcelRequire("2KliV");

var $6W2gk = parcelRequire("6W2gk");
class $9484e774818fc57c$export$2e2bcd8739ae039 {
    /**
	 * Returns the cache provider based on the given cache configuration
	 *
	 * @param cacheConfig The cache configuration to use
	 * @returns The cache provider
	 */ static resolve(cacheConfig) {
        if (cacheConfig) return new (0, $6W2gk.default)(cacheConfig);
        return new (0, $2KliV.default)();
    }
}

});
parcelRegister("2KliV", function(module, exports) {

$parcel$export(module.exports, "default", () => $bddf34f841fe4c17$export$2e2bcd8739ae039);
class $bddf34f841fe4c17$export$2e2bcd8739ae039 {
    async get(request) {
        return undefined;
    }
    async set(request, response) {
        return;
    }
    async delete(request) {
        return true;
    }
}

});

parcelRegister("6W2gk", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6e575cd1ebbba04$export$2e2bcd8739ae039);

var $hiBPg = parcelRequire("hiBPg");

var $7NYdH = parcelRequire("7NYdH");
class $a6e575cd1ebbba04$export$2e2bcd8739ae039 {
    /**
	 * Initialise the WebCacheStorage
	 * @param cacheName The name of the cache to use. See {@link https://developer.mozilla.org/en-US/docs/Web/API/CacheStorage/open}
	 * @param onError a callback when any error occurs
	 */ constructor(cacheProviderConfig){
        this.supported = typeof caches === 'object' && typeof caches.open === 'function';
        this.cacheConfig = new (0, $hiBPg.default)(cacheProviderConfig);
        this.expiryStorage = new (0, $7NYdH.default)(this.cacheConfig);
    }
    /**
	 * Get cached response
	 */ async get(request) {
        if (!this.supported) return undefined;
        try {
            const cache = await caches.open(this.cacheConfig.cacheName);
            const expired = await this.isExpired(request);
            if (expired) {
                await this.delete(request);
                return undefined;
            }
            return cache.match(this.getCacheKey(request));
        } catch (e) {
            this.cacheConfig.onError(e);
        }
    }
    /**
	 * Put response in cache
	 */ async set(request, response) {
        if (!this.supported) return;
        try {
            const cache = await caches.open(this.cacheConfig.cacheName);
            const expiryDate = Date.now() + this.cacheConfig.ttl * 1000;
            await this.expiryStorage.setExpiry(this.getStoreKey(request), expiryDate);
            await cache.put(this.getCacheKey(request), response);
        } catch (e) {
            this.cacheConfig.onError(e);
        }
    }
    /**
	 * Delete cached response
	 */ async delete(request) {
        if (!this.supported) return true;
        try {
            return caches.open(this.cacheConfig.cacheName).then(async (cache)=>{
                await cache.delete(this.getCacheKey(request));
                await this.expiryStorage.deleteExpiry(this.getStoreKey(request));
                return true;
            });
        } catch (e) {
            this.cacheConfig.onError(e);
            return false;
        }
    }
    /**
	 * Check if the cached response is expired
	 */ async isExpired(request) {
        try {
            const key = this.getStoreKey(request);
            const expiry = await this.expiryStorage.getExpiry(key);
            return Date.now() > (expiry ?? 0);
        } catch (error) {
            this.cacheConfig.onError(error instanceof Error ? error : new Error('Error checking expiry'));
            return true;
        }
    }
    /**
	 * Compose the URL and the use case as the search params to cache the response
	 */ getCacheKey(request) {
        const url = new URL(request.url);
        url.searchParams.set('useCase', this.cacheConfig.useCase);
        return url;
    }
    /**
	 * Get the key to store the response
	 * Interally, it hashes the request body to get a unique key
	 */ getStoreKey(request) {
        return this.getCacheKey(request).toString();
    }
}

});
parcelRegister("hiBPg", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ca080c3cdea390f$export$2e2bcd8739ae039);
const $3ca080c3cdea390f$var$DEFAULT_TTL = 60;
class $3ca080c3cdea390f$export$2e2bcd8739ae039 {
    constructor(cacheProviderConfig){
        this.cacheProviderConfig = cacheProviderConfig;
    }
    get cacheName() {
        return this.cacheProviderConfig.cacheName;
    }
    get useCase() {
        return this.cacheProviderConfig.useCase;
    }
    get ttl() {
        return this.cacheProviderConfig.ttl ?? $3ca080c3cdea390f$var$DEFAULT_TTL;
    }
    get onError() {
        return this.cacheProviderConfig.onError ?? (()=>{});
    }
}

});

parcelRegister("7NYdH", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fe5637855449f67$export$2e2bcd8739ae039);
class $3fe5637855449f67$export$2e2bcd8739ae039 {
    /**
	 * Initialise the ExpiryStorage
	 */ constructor(cacheConfig){
        this.cacheConfig = cacheConfig;
        this.expiryStoreName = 'expiries';
    }
    /**
	 * Set the expiry date of the cached response
	 */ async setExpiry(key, expireAt) {
        return new Promise((resolve, reject)=>{
            const dbRequest = this.initDb();
            dbRequest.onsuccess = ()=>{
                const store = this.getObjectStore(dbRequest, 'readwrite');
                store.put(expireAt, key);
                resolve();
            };
            dbRequest.onerror = ()=>{
                if (dbRequest.error) reject(dbRequest.error);
            };
        });
    }
    /**
	 * Get the expiry date of the cached response
	 */ async getExpiry(key) {
        return new Promise((resolve, reject)=>{
            const dbRequest = this.initDb();
            dbRequest.onsuccess = ()=>{
                const store = this.getObjectStore(dbRequest, 'readonly');
                const storeRequest = store.get(key);
                storeRequest.onsuccess = ()=>{
                    resolve(Number(storeRequest.result ?? 0));
                };
            };
            dbRequest.onerror = ()=>{
                if (dbRequest.error) reject(dbRequest.error);
            };
        });
    }
    async deleteExpiry(key) {
        return new Promise((resolve, reject)=>{
            const dbRequest = this.initDb();
            dbRequest.onsuccess = ()=>{
                const store = this.getObjectStore(dbRequest, 'readwrite');
                store.delete(key);
                resolve();
            };
            dbRequest.onerror = ()=>{
                if (dbRequest.error) reject(dbRequest.error);
            };
        });
    }
    /**
	 * Initialise the IndexedDB
	 */ initDb() {
        const dbRequest = indexedDB.open(`${this.cacheConfig.cacheName}-expiry`);
        dbRequest.onupgradeneeded = ()=>{
            const db = dbRequest.result;
            db.createObjectStore(this.expiryStoreName);
        };
        return dbRequest;
    }
    /**
	 * Get the object store from the IndexedDB
	 */ getObjectStore(dbRequest, mode = 'readwrite') {
        const db = dbRequest.result;
        return db.transaction(this.expiryStoreName, mode).objectStore(this.expiryStoreName);
    }
}

});





parcelRegister("bHDKL", function(module, exports) {

$parcel$export(module.exports, "ARTICLE_TYPE", () => $d93cba26535df61b$export$a72bfd9b1e5592c8);
var $d93cba26535df61b$export$a72bfd9b1e5592c8 = /*#__PURE__*/ function(ARTICLE_TYPE) {
    ARTICLE_TYPE["HELP_ARTICLE"] = "HELP_ARTICLE";
    ARTICLE_TYPE["WHATS_NEW"] = "WHATS_NEW";
    return ARTICLE_TYPE;
}({});

});

parcelRegister("1pgoX", function(module, exports) {

$parcel$export(module.exports, "NotificationLogClient", () => (parcelRequire("5s0dN")).default);

var $5s0dN = parcelRequire("5s0dN");

});
parcelRegister("5s0dN", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc40da511b16d48e$export$2e2bcd8739ae039);

var $dS9cn = parcelRequire("dS9cn");
const $bc40da511b16d48e$export$b055de0e665cb20c = 'atlaskitNotificationLogClient';
class $bc40da511b16d48e$export$2e2bcd8739ae039 {
    constructor(baseUrl, cloudId, source = $bc40da511b16d48e$export$b055de0e665cb20c){
        this.serviceConfig = {
            url: baseUrl
        };
        this.cloudId = cloudId;
        this.source = source;
    }
    async countUnseenNotifications(options = {}) {
        const mergedOptions = {
            path: '/api/3/notifications/count/unseen',
            ...options,
            queryParams: {
                ...this.cloudId && {
                    cloudId: this.cloudId
                },
                source: this.source,
                ...options.queryParams || {}
            },
            requestInit: {
                mode: 'cors',
                headers: {
                    'x-app-version': `${"0.0.0-use.local"}-${$bc40da511b16d48e$export$b055de0e665cb20c}`
                },
                ...options.requestInit || {}
            }
        };
        return (0, $dS9cn.utils).requestService(this.serviceConfig, mergedOptions);
    }
}

});
parcelRegister("dS9cn", function(module, exports) {
$parcel$export(module.exports, "AbstractResource", () => (parcelRequire("99RON")).AbstractResource);

$parcel$export(module.exports, "utils", () => $6539d5230a113c0b$export$eab97d15b1788b8d);
parcelRequire("3bFmZ");
parcelRequire("99RON");

var $aF8YM = parcelRequire("aF8YM");

var $8Q0SU = parcelRequire("8Q0SU");
const $6539d5230a113c0b$export$eab97d15b1788b8d = $aF8YM;
const $6539d5230a113c0b$export$3b4c04cf7dad0e50 = $8Q0SU;

});
parcelRegister("3bFmZ", function(module, exports) {

$parcel$export(module.exports, "buildCredentials", () => $1dde2ae50887ec17$export$2ac26f1ab7eda637);
const $1dde2ae50887ec17$export$2ac26f1ab7eda637 = (secOptions)=>{
    return secOptions && secOptions.omitCredentials ? 'omit' : 'include';
};

});

parcelRegister("99RON", function(module, exports) {

$parcel$export(module.exports, "AbstractResource", () => $e1e58db2ea52ba80$export$4529f10aed0950d4);
class $e1e58db2ea52ba80$export$4529f10aed0950d4 {
    subscribe(onChange) {
        this.listeners.add(onChange);
        if (this.lastResult) // Notify subscribe of last result (i.e. initial state)
        onChange.result(this.lastResult);
    }
    unsubscribe(onChange) {
        this.listeners.delete(onChange);
    }
    notifyResult(result) {
        this.listeners.forEach((onChange)=>{
            onChange.result(result);
        });
    }
    notifyError(error) {
        this.listeners.forEach((onChange)=>{
            if (onChange.error) onChange.error(error);
        });
    }
    notifyInfo(info) {
        this.listeners.forEach((onChange)=>{
            if (onChange.info) onChange.info(info);
        });
    }
    notifyNotReady() {
        this.listeners.forEach((onChange)=>{
            if (onChange.notReady) onChange.notReady();
        });
    }
    constructor(){
        this.listeners = new Set();
    }
}

});

parcelRegister("aF8YM", function(module, exports) {

$parcel$export(module.exports, "requestService", () => $4cb3782fbf0bac5b$export$97bfde5a702aaeca);

var $tcn7E = parcelRequire("tcn7E");

var $VSDnB = parcelRequire("VSDnB");

var $gSA3s = parcelRequire("gSA3s");

var $3bFmZ = parcelRequire("3bFmZ");

var $2HFDN = parcelRequire("2HFDN");
const $4cb3782fbf0bac5b$export$97bfde5a702aaeca = (serviceConfig, options)=>{
    const { url: url, securityProvider: securityProvider, refreshedSecurityProvider: refreshedSecurityProvider } = serviceConfig;
    const { path: path, queryParams: queryParams, requestInit: requestInit } = options || (0, $2HFDN.defaultRequestServiceOptions);
    const secOptions = securityProvider && securityProvider();
    const requestUrl = (0, $2HFDN.buildUrl)(url, path, queryParams, secOptions);
    const headers = (0, $2HFDN.buildHeaders)(secOptions, requestInit && requestInit.headers);
    const credentials = (0, $3bFmZ.buildCredentials)(secOptions);
    const ignoreResponsePayload = options?.ignoreResponsePayload || false;
    // Get tracing headers from UFO
    const TRACING_HEADER_FOR_SERVICE_UTIL = 'platform_collab_provider_tracingheaders';
    const tracingHeaderEnabled = (0, $VSDnB.fg)('platform_collab_provider_tracingheaders');
    (0, $gSA3s.addFeatureFlagAccessed)(TRACING_HEADER_FOR_SERVICE_UTIL, tracingHeaderEnabled);
    let tracingHeaders = {};
    if (tracingHeaderEnabled) tracingHeaders = (0, $tcn7E.getActiveTraceHttpRequestHeaders)(url);
    const requestOptions = {
        ...requestInit,
        // populate headers mainly for the collab provider however
        // other components which uses this util can get the header as well.
        // Those tracing headers shall not incur any issues as long as backends handle them properly
        headers: {
            ...headers,
            ...tracingHeaders
        },
        credentials: credentials
    };
    return fetch(requestUrl, requestOptions).then((response)=>{
        if (response.status === 204) return Promise.resolve();
        else if (response.ok) return ignoreResponsePayload ? Promise.resolve() : response.json();
        else if (response.status === 401 && refreshedSecurityProvider) // auth issue - try once
        return refreshedSecurityProvider().then((newSecOptions)=>{
            const retryServiceConfig = {
                url: url,
                securityProvider: ()=>newSecOptions
            };
            return $4cb3782fbf0bac5b$export$97bfde5a702aaeca(retryServiceConfig, options);
        });
        return Promise.reject({
            code: response.status,
            reason: response.statusText
        });
    });
};

});
parcelRegister("2HFDN", function(module, exports) {

$parcel$export(module.exports, "defaultRequestServiceOptions", () => $d06f18f7b97ba436$export$160dbda113bfad3b);
$parcel$export(module.exports, "buildUrl", () => $d06f18f7b97ba436$export$b5cd97dee32de81d);
$parcel$export(module.exports, "buildHeaders", () => $d06f18f7b97ba436$export$7d6ed858a91629c3);
const $d06f18f7b97ba436$export$160dbda113bfad3b = {};
const $d06f18f7b97ba436$export$b5cd97dee32de81d = (baseUrl, path = '', queryParams, secOptions)=>{
    const searchParam = new URLSearchParams(// For relative urls, the URL class requires base to be set. It's ignored if a url is not relative.
    // Since we only care about search params it is fine to have any base url here.
    new URL(baseUrl, 'https://BASE_FALLBACK').search || undefined);
    baseUrl = baseUrl.split('?')[0];
    if (queryParams) {
        for(const key in queryParams)if (({}).hasOwnProperty.call(queryParams, key)) searchParam.append(key, queryParams[key]);
    }
    if (secOptions && secOptions.params) {
        for(const key in secOptions.params)if (({}).hasOwnProperty.call(secOptions.params, key)) {
            const values = secOptions.params[key];
            if (Array.isArray(values)) for(let i = 0; i < values.length; i++)searchParam.append(key, values[i]);
            else searchParam.append(key, values);
        }
    }
    let separator = '';
    if (path && baseUrl.substr(-1) !== '/' && !path.startsWith('/')) separator = '/';
    let params = searchParam.toString();
    if (params) params = '?' + params;
    return `${baseUrl}${separator}${path}${params}`;
};
const $d06f18f7b97ba436$var$addToHeaders = (headers, keyValues)=>{
    if (keyValues) {
        for(const key in keyValues)if (({}).hasOwnProperty.call(keyValues, key)) {
            const values = keyValues[key];
            if (Array.isArray(values)) for(let i = 0; i < values.length; i++)headers[key] = values[i];
            else headers[key] = values;
        }
    }
};
const $d06f18f7b97ba436$export$7d6ed858a91629c3 = (secOptions, extraHeaders)=>{
    const headers = {};
    $d06f18f7b97ba436$var$addToHeaders(headers, extraHeaders);
    if (secOptions) $d06f18f7b97ba436$var$addToHeaders(headers, secOptions.headers);
    return headers;
};

});


parcelRegister("8Q0SU", function(module, exports) {

$parcel$export(module.exports, "requestServiceMultipart", () => $6251c78b414c941c$export$8b13532c81e8ac89);

var $lGkPt = parcelRequire("lGkPt");

var $3bFmZ = parcelRequire("3bFmZ");

var $2HFDN = parcelRequire("2HFDN");

var $VSDnB = parcelRequire("VSDnB");

var $gSA3s = parcelRequire("gSA3s");

var $tcn7E = parcelRequire("tcn7E");
const $6251c78b414c941c$export$8b13532c81e8ac89 = async (serviceConfig, options = (0, $2HFDN.defaultRequestServiceOptions))=>{
    const { url: url, securityProvider: securityProvider, refreshedSecurityProvider: refreshedSecurityProvider } = serviceConfig;
    const { path: path, queryParams: queryParams, requestInit: requestInit } = options;
    const secOptions = securityProvider && securityProvider();
    const requestUrl = (0, $2HFDN.buildUrl)(url, path, queryParams, secOptions);
    const headers = (0, $2HFDN.buildHeaders)(secOptions, requestInit && requestInit.headers);
    const credentials = (0, $3bFmZ.buildCredentials)(secOptions);
    // Get tracing headers from UFO
    const TRACING_HEADER_FOR_SERVICE_UTIL = 'platform_collab_provider_tracingheaders';
    const tracingHeaderEnabled = (0, $VSDnB.fg)('platform_collab_provider_tracingheaders');
    (0, $gSA3s.addFeatureFlagAccessed)(TRACING_HEADER_FOR_SERVICE_UTIL, tracingHeaderEnabled);
    let tracingHeaders = {};
    if (tracingHeaderEnabled) tracingHeaders = (0, $tcn7E.getActiveTraceHttpRequestHeaders)(url);
    const requestOptions = {
        ...requestInit,
        // populate headers mainly for the collab provider however
        // other components which uses this util can get the header as well.
        // Those tracing headers shall not incur any issues as long as backends handle them properly
        headers: {
            ...headers,
            ...tracingHeaders
        },
        credentials: credentials
    };
    const fetchResponse = await fetch(requestUrl, requestOptions);
    const parts = await (0, $lGkPt.meros)(fetchResponse);
    if (fetchResponse.ok && fetchResponse.status !== 204) {
        if (parts[Symbol.asyncIterator] < 'u') // this lets us know that the response is multipart
        //
        // 	((parts as PartsGenerator)[Symbol.asyncIterator] as any) < 'u' came from the `meros` docs:
        //	https://github.com/maraisr/meros/blob/dec4feaa24090b94e8ac42fab1aff38a1e521680/readme.md
        // 	Look for expand section `If the content-type is NOT a multipart, then meros will resolve with the response argument.`
        return {
            isMultipart: true,
            parts: parts
        };
        return {
            isMultipart: false,
            body: await parts.json()
        };
    } else if (fetchResponse.status === 401 && refreshedSecurityProvider) // auth issue - try once
    return refreshedSecurityProvider().then((newSecOptions)=>{
        const retryServiceConfig = {
            url: url,
            securityProvider: ()=>newSecOptions
        };
        return $6251c78b414c941c$export$8b13532c81e8ac89(retryServiceConfig, options);
    });
    return Promise.reject({
        code: fetchResponse.status,
        reason: fetchResponse.statusText
    });
};

});
parcelRegister("lGkPt", function(module, exports) {

$parcel$export(module.exports, "meros", () => $fc8dad7b24d7fa67$export$74e0a034be2368c7);
var $fc8dad7b24d7fa67$var$e = new TextDecoder;
async function $fc8dad7b24d7fa67$export$74e0a034be2368c7(t, n) {
    if (!t.ok || !t.body || t.bodyUsed) return t;
    let i = t.headers.get("content-type");
    if (!i || !~i.indexOf("multipart/")) return t;
    let l = i.indexOf("boundary="), r = "-";
    if (~l) {
        let e = l + 9, t = i.indexOf(";", e);
        r = i.slice(e, t > -1 ? t : void 0).trim().replace(/"/g, "");
    }
    return async function*(t, n, i) {
        let l, r, d, o = t.getReader(), a = !i || !i.multiple, f = n.length, s = "", c = [];
        try {
            let t;
            e: for(; !(t = await o.read()).done;){
                let i = $fc8dad7b24d7fa67$var$e.decode(t.value);
                l = s.length, s += i;
                let o = i.indexOf(n);
                for(~o ? l += o : l = s.indexOf(n), c = []; ~l;){
                    let e = s.slice(0, l), t = s.slice(l + f);
                    if (r) {
                        let n = e.indexOf("\r\n\r\n") + 4, i = e.lastIndexOf("\r\n", n), l = !1, r = e.slice(n, i > -1 ? void 0 : i), o = String(e.slice(0, n)).trim().split("\r\n"), f = {}, s = o.length;
                        for(; d = o[--s]; d = d.split(": "), f[d.shift().toLowerCase()] = d.join(": "));
                        if (d = f["content-type"], d && ~d.indexOf("application/json")) try {
                            r = JSON.parse(r), l = !0;
                        } catch (e) {}
                        if (d = {
                            headers: f,
                            body: r,
                            json: l
                        }, a ? yield d : c.push(d), "--" === t.slice(0, 2)) break e;
                    } else n = "\r\n" + n, r = f += 2;
                    s = t, l = s.indexOf(n);
                }
                c.length && (yield c);
            }
        } finally{
            c.length && (yield c), await o.cancel();
        }
    }(t.body, `--${r}`, n);
}

});





parcelRegister("e2ecT", function(module, exports) {

$parcel$export(module.exports, "JiraLogo", () => $4fb076f76caca502$export$17d3acb0b4379d02);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::63c9fb9062623a5cb540009a26c04896>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $mfib2 = parcelRequire("mfib2");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $4fb076f76caca502$var$svg = `<svg width="56" viewBox="0 0 56 24">
    <path fill="var(--tile-color,#1868db)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M9.051 15.434H7.734c-1.988 0-3.413-1.218-3.413-3h7.085c.367 0 .605.26.605.63v7.13c-1.772 0-2.96-1.435-2.96-3.434zm3.5-3.543h-1.318c-1.987 0-3.413-1.196-3.413-2.978h7.085c.367 0 .627.239.627.608v7.13c-1.772 0-2.981-1.435-2.981-3.434zm3.52-3.522h-1.317c-1.987 0-3.413-1.217-3.413-3h7.085c.367 0 .605.262.605.61v7.129c-1.771 0-2.96-1.435-2.96-3.434z"/>
    <path fill="var(--ds-text, #292a2e)" d="M50.89 17.13a2.9 2.9 0 0 1-1.59-.46q-.7-.46-1.12-1.33-.41-.88-.41-2.15 0-1.29.42-2.17.42-.87 1.14-1.32a2.9 2.9 0 0 1 1.58-.44q.66 0 1.09.23.43.22.69.54t.4.61h.08V9.36h1.91V17h-1.9v-1.22h-.08a2.6 2.6 0 0 1-.41.61q-.27.32-.7.53t-1.08.21m.57-1.55q.55 0 .94-.3.38-.3.58-.84.21-.54.21-1.25 0-.72-.2-1.25t-.58-.83q-.38-.29-.94-.29-.57 0-.96.3-.38.3-.58.83a3.6 3.6 0 0 0-.19 1.23q0 .69.2 1.23t.58.85q.39.31.95.31M42.78 17V9.36h1.87v1.31h.08q.21-.68.71-1.05a1.93 1.93 0 0 1 1.16-.36q.15 0 .34.02.19.01.32.04v1.74a2 2 0 0 0-.38-.07 5 5 0 0 0-.48-.03q-.48 0-.86.21a1.5 1.5 0 0 0-.6.57 1.65 1.65 0 0 0-.21.85V17zm-3.73 0V9.36h1.93V17zm-.02-8.73V6.52h1.98v1.75zm-5.17 8.87q-1.55 0-2.45-.82-.9-.83-.9-2.35v-.59h1.96v.61q0 .77.38 1.16t1.02.39 1-.39q.38-.4.38-1.16V6.82h1.94v7.14q0 1.52-.9 2.35-.89.83-2.43.83"/>
</svg>
`;
const $4fb076f76caca502$var$customThemeSvg = `<svg width="56" viewBox="0 0 56 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM4.321 12.434c0 1.782 1.425 3 3.412 3h1.319v1.326c0 2 1.188 3.433 2.959 3.433v-7.129c0-.369-.238-.63-.605-.63zm3.5-3.52c0 1.781 1.425 2.977 3.412 2.977h1.318v1.326c0 2 1.21 3.433 2.98 3.433V9.521c0-.369-.259-.608-.626-.608zm3.52-3.544c0 1.782 1.426 3 3.413 3h1.317v1.304c0 2 1.188 3.433 2.96 3.433V5.98c0-.348-.238-.609-.605-.609z"/>
    <path fill="var(--themed-text-color, currentcolor)" d="M50.89 17.13a2.9 2.9 0 0 1-1.59-.46q-.7-.46-1.12-1.33-.41-.88-.41-2.15 0-1.29.42-2.17.42-.87 1.14-1.32a2.9 2.9 0 0 1 1.58-.44q.66 0 1.09.23.43.22.69.54t.4.61h.08V9.36h1.91V17h-1.9v-1.22h-.08a2.6 2.6 0 0 1-.41.61q-.27.32-.7.53t-1.08.21m.57-1.55q.55 0 .94-.3.38-.3.58-.84.21-.54.21-1.25 0-.72-.2-1.25t-.58-.83q-.38-.29-.94-.29-.57 0-.96.3-.38.3-.58.83a3.6 3.6 0 0 0-.19 1.23q0 .69.2 1.23t.58.85q.39.31.95.31M42.78 17V9.36h1.87v1.31h.08q.21-.68.71-1.05a1.93 1.93 0 0 1 1.16-.36q.15 0 .34.02.19.01.32.04v1.74a2 2 0 0 0-.38-.07 5 5 0 0 0-.48-.03q-.48 0-.86.21a1.5 1.5 0 0 0-.6.57 1.65 1.65 0 0 0-.21.85V17zm-3.73 0V9.36h1.93V17zm-.02-8.73V6.52h1.98v1.75zm-5.17 8.87q-1.55 0-2.45-.82-.9-.83-.9-2.35v-.59h1.96v.61q0 .77.38 1.16t1.02.39 1-.39q.38-.4.38-1.16V6.82h1.94v7.14q0 1.52-.9 2.35-.89.83-2.43.83"/>
</svg>
`;
function $4fb076f76caca502$export$17d3acb0b4379d02({ iconColor: iconColor, textColor: textColor, label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $mfib2.LogoWrapper), {
        svg: $4fb076f76caca502$var$svg,
        customThemeSvg: $4fb076f76caca502$var$customThemeSvg,
        iconColor: iconColor,
        textColor: textColor,
        label: label || 'Jira',
        testId: testId
    });
}

});
parcelRegister("mfib2", function(module, exports) {

$parcel$export(module.exports, "LogoWrapper", () => $7f732cdd59e88d7f$export$f827d3c5a9c3f644);
/* logo-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hxoiH = parcelRequire("hxoiH");

const $7f732cdd59e88d7f$var$styles = {
    root: "_1e0c1o8l _vwz4idpf"
}; // These styles set the `color` property so that the child SVG can inherit the correct text color using "currentColor"
const $7f732cdd59e88d7f$var$logoTextColorMap = {
    light: "_syazqlpt",
    dark: "_syazz6c6"
};
function $7f732cdd59e88d7f$export$f827d3c5a9c3f644({ svg: svg, customThemeSvg: customThemeSvg, label: label, testId: userDefinedTestId, iconColor: iconColor, textColor: textColor }) {
    const { colorMode: colorMode } = (0, $hxoiH.default)();
    const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
    const isCustomThemed = customThemeSvg && (iconColor || textColor);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        style: {
            // Nav v3 passes in "inherit" incorrectly for iconColor, so we fall back to textColor when this happens.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            [(0, $f0aa1a5001d04852$export$582e20fccfce3089)]: iconColor === 'inherit' ? textColor : iconColor || 'initial',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            [(0, $f0aa1a5001d04852$export$8344f093f1e14646)]: textColor || 'initial'
        },
        "data-testid": testId,
        "aria-label": label,
        role: label ? 'img' : undefined,
        "aria-hidden": label === '' ? true : undefined,
        // This is because the SVG elements are static and will not change, so we get a little performance benefit by
        // bypassing React.
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, $bwpsq.default)([
            $7f732cdd59e88d7f$var$styles.root,
            // Setting the color so that the SVG can inherit the correct text color using "currentColor"
            $7f732cdd59e88d7f$var$logoTextColorMap[colorMode ?? 'light']
        ])
    });
}

});


parcelRegister("in1mr", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementLogo", () => $076101c0fca1455b$export$dabef2be6cd28c20);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7af7e653533de47cd6bae0ea0ef0ce7c>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $mfib2 = parcelRequire("mfib2");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $076101c0fca1455b$var$svg = `<svg width="206" viewBox="0 0 206 24">
    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M13.744 10.156h4.578c.688 0 .922.654.503 1.174l-7.16 8.837c-2.314-1.845-2.096-4.763-.402-6.892zm-3.538 3.521H5.63c-.688 0-.923-.654-.504-1.173l7.16-8.837c2.315 1.844 2.063 4.728.386 6.875z"/>
    <path fill="var(--ds-text, #292a2e)" d="M205.27 9.36v1.48h-4.44V9.36zm-3.38-1.82h1.92v7.27q0 .38.17.57t.56.19a3 3 0 0 0 .32-.03 5 5 0 0 0 .32-.06l.29 1.46q-.31.1-.64.13a5 5 0 0 1-.62.04q-1.13 0-1.73-.55-.59-.56-.59-1.59zm-7.02 5.01V17h-1.93V9.36h1.82l.03 1.9h-.13q.31-.97.92-1.48.62-.51 1.57-.51.79 0 1.37.34.6.34.92.98.33.64.33 1.55V17h-1.92v-4.54q0-.74-.38-1.16t-1.05-.42q-.45 0-.81.2a1.35 1.35 0 0 0-.55.57q-.2.37-.2.9m-6.81 4.6q-1.16 0-2-.48a3.25 3.25 0 0 1-1.29-1.37q-.45-.88-.45-2.08 0-1.18.44-2.06a3.4 3.4 0 0 1 1.26-1.39q.82-.5 1.93-.5.73 0 1.36.23.64.23 1.13.71.49.47.77 1.2t.28 1.72v.57h-6.34v-1.25h5.39l-.9.35q0-.62-.19-1.08a1.54 1.54 0 0 0-.57-.72q-.37-.26-.93-.26-.55 0-.94.26t-.59.7-.2.99v.88q0 .69.23 1.17.24.47.66.71t.98.24q.37 0 .68-.11t.53-.31q.22-.21.34-.52l1.75.34q-.18.62-.64 1.09-.45.46-1.13.73-.68.25-1.54.25M171.93 17V9.36h1.8l.08 1.87h-.14q.17-.7.51-1.13.35-.44.81-.64.47-.21.97-.21.83 0 1.33.52.51.52.73 1.57h-.22q.16-.71.55-1.18.39-.46.91-.69.53-.23 1.12-.23.69 0 1.24.3t.87.88.32 1.42V17h-1.92v-4.82q0-.67-.37-1a1.32 1.32 0 0 0-.9-.32q-.4 0-.7.18a1.2 1.2 0 0 0-.46.49q-.16.32-.16.73V17h-1.87v-4.89q0-.57-.35-.91-.34-.34-.89-.34a1.4 1.4 0 0 0-.68.17 1.2 1.2 0 0 0-.49.51q-.18.33-.18.81V17zm-4.89.15q-1.16 0-2-.48a3.26 3.26 0 0 1-1.29-1.37q-.45-.88-.45-2.08 0-1.18.44-2.06A3.4 3.4 0 0 1 165 9.77q.82-.5 1.93-.5.72 0 1.36.23t1.14.71q.49.47.77 1.2t.28 1.72v.57h-6.34v-1.25h5.39l-.9.35a2.8 2.8 0 0 0-.19-1.08 1.55 1.55 0 0 0-.57-.72q-.37-.26-.93-.26T166 11q-.39.26-.59.7t-.2.99v.88q0 .69.23 1.17.24.47.66.71t.98.24q.37 0 .68-.11a1.5 1.5 0 0 0 .53-.31q.22-.21.33-.52l1.75.34q-.18.62-.63 1.09-.45.46-1.13.73-.68.25-1.54.25m-8.91 2.86q-.94 0-1.63-.24-.69-.23-1.13-.65a2.3 2.3 0 0 1-.62-.94l1.64-.51q.11.21.31.42.21.21.55.35.35.14.87.14.81 0 1.28-.38.47-.37.47-1.16v-1.41h-.15a2.3 2.3 0 0 1-.4.58q-.25.29-.68.48-.42.19-1.07.19a3.1 3.1 0 0 1-1.58-.41q-.7-.41-1.13-1.24-.42-.83-.42-2.08 0-1.28.42-2.15t1.14-1.31q.71-.44 1.58-.44.66 0 1.09.23.44.22.7.54.27.32.4.61h.09V9.36h1.89v7.62q0 1.02-.47 1.7-.46.68-1.29 1-.82.33-1.88.33m.03-4.62q.55 0 .94-.27.38-.27.58-.77.21-.5.21-1.21 0-.7-.2-1.22-.2-.53-.58-.81-.38-.29-.94-.29-.57 0-.96.3a1.86 1.86 0 0 0-.58.83 3.5 3.5 0 0 0-.19 1.2q0 .68.2 1.19t.58.79q.39.27.95.27m-9.36 1.73a2.9 2.9 0 0 1-1.59-.46q-.7-.46-1.12-1.33-.41-.88-.41-2.15 0-1.29.42-2.17.42-.87 1.14-1.32.71-.44 1.58-.44.66 0 1.09.23.43.22.69.54t.4.61h.08V9.36h1.91V17h-1.9v-1.22h-.08a2.7 2.7 0 0 1-.41.61 2.1 2.1 0 0 1-.7.53q-.43.21-1.08.21m.57-1.55q.56 0 .94-.3t.58-.84q.21-.54.21-1.25 0-.72-.2-1.25t-.58-.83-.94-.29q-.57 0-.96.3-.38.3-.58.83a3.7 3.7 0 0 0-.19 1.23q0 .69.2 1.23t.58.85q.39.31.95.31m-10.13-3.02V17h-1.93V9.36h1.82l.03 1.9h-.13q.31-.97.92-1.48.62-.51 1.57-.51.79 0 1.37.34.6.34.92.98.33.64.33 1.55V17h-1.92v-4.54q0-.74-.38-1.16t-1.05-.42q-.45 0-.81.2a1.34 1.34 0 0 0-.55.57q-.2.37-.2.9m-7.9 4.58a2.9 2.9 0 0 1-1.59-.46q-.7-.46-1.12-1.33-.41-.88-.41-2.15 0-1.29.42-2.17.42-.87 1.14-1.32.71-.44 1.58-.44.66 0 1.09.23.43.22.69.54t.4.61h.08V9.36h1.91V17h-1.9v-1.22h-.08a2.6 2.6 0 0 1-.41.61q-.27.32-.7.53t-1.08.21m.57-1.55q.55 0 .94-.3.38-.3.58-.84t.21-1.25q0-.72-.2-1.25t-.58-.83q-.38-.29-.94-.29-.57 0-.96.3a1.85 1.85 0 0 0-.58.83 3.6 3.6 0 0 0-.19 1.23q0 .69.2 1.23t.58.85q.39.31.95.31M115.65 17V6.81h2.99l1.78 4.95q.1.31.23.81a47 47 0 0 1 .52 2.17q.12.54.2.94h-.39q.08-.39.2-.92a93 93 0 0 1 .53-2.18q.13-.5.23-.81l1.76-4.95h2.99V17h-1.96v-4.96q0-.33.01-.81l.03-1.04.03-1.13q.01-.57.01-1.07h.14q-.14.55-.3 1.14l-.31 1.14a44 44 0 0 1-.55 1.76L122.01 17h-1.66l-1.8-4.96q-.1-.29-.25-.74l-.3-1a129 129 0 0 1-.64-2.29h.16l.02 1.03.03 1.12.02 1.05q.01.49.01.83V17zm-8.37.15q-1.16 0-2-.48a3.26 3.26 0 0 1-1.29-1.37q-.45-.88-.45-2.08 0-1.18.45-2.06.45-.9 1.26-1.39.82-.5 1.93-.5.72 0 1.36.23a3.1 3.1 0 0 1 1.14.71q.49.47.77 1.2t.28 1.72v.57h-6.34v-1.25h5.39l-.9.35a2.8 2.8 0 0 0-.19-1.08 1.55 1.55 0 0 0-.57-.72q-.37-.26-.93-.26-.55 0-.94.26a1.66 1.66 0 0 0-.59.7q-.2.44-.2.99v.88q0 .69.23 1.17.24.47.66.71t.99.24q.37 0 .68-.11a1.5 1.5 0 0 0 .53-.31q.22-.21.34-.52l1.75.34q-.18.62-.64 1.09-.45.46-1.13.73-.68.25-1.54.25m-8.31-.01q-1.13 0-1.96-.49a3.3 3.3 0 0 1-1.28-1.38q-.45-.89-.45-2.06 0-1.18.45-2.07.45-.9 1.28-1.39t1.96-.49q.66 0 1.22.17t1 .49.73.78.41 1.03l-1.8.36q-.06-.3-.2-.54a1.5 1.5 0 0 0-.33-.4 1.3 1.3 0 0 0-.44-.26 1.6 1.6 0 0 0-.56-.09q-.58 0-.97.31t-.59.86q-.2.54-.2 1.24t.2 1.24.59.86q.39.31.97.31.32 0 .57-.09.26-.09.46-.27a1.6 1.6 0 0 0 .34-.42q.14-.25.2-.56l1.79.35q-.12.6-.4 1.06t-.73.79a3.3 3.3 0 0 1-1 .51q-.56.17-1.23.17M91.92 17V9.36h1.93V17zm-.02-8.73V6.52h1.98v1.75zM85.77 17l-2.83-7.64h2.04l1.34 4.05q.24.74.41 1.49l.37 1.54h-.44q.19-.79.36-1.54t.41-1.49l1.33-4.05h2.02L87.95 17zm-8.01 0V9.36h1.87v1.31h.08q.21-.68.71-1.05a1.93 1.93 0 0 1 1.16-.36q.15 0 .34.02.18.01.32.04v1.74a2 2 0 0 0-.38-.07 5 5 0 0 0-.49-.03q-.48 0-.86.21a1.5 1.5 0 0 0-.6.57 1.65 1.65 0 0 0-.21.85V17zm-4.89.15q-1.16 0-2-.48a3.26 3.26 0 0 1-1.29-1.37q-.45-.88-.45-2.08 0-1.18.44-2.06a3.4 3.4 0 0 1 1.26-1.39q.82-.5 1.93-.5.72 0 1.36.23t1.14.71q.49.47.77 1.2t.28 1.72v.57h-6.34v-1.25h5.39l-.9.35a2.8 2.8 0 0 0-.19-1.08 1.55 1.55 0 0 0-.57-.72q-.37-.26-.93-.26-.55 0-.94.26t-.59.7q-.21.44-.21.99v.88q0 .69.23 1.17.24.47.66.71t.98.24q.37 0 .68-.11t.53-.31a1.4 1.4 0 0 0 .34-.52l1.75.34q-.18.62-.64 1.09-.45.46-1.13.73-.68.25-1.54.25m-8.87-.01q-1.2 0-2.09-.37t-1.39-1.09q-.5-.73-.53-1.77h1.92q.04.53.32.88t.74.53q.46.17 1.03.17t1.01-.17q.44-.18.68-.49.25-.31.25-.72a.9.9 0 0 0-.22-.62 1.7 1.7 0 0 0-.62-.42 5.3 5.3 0 0 0-.96-.31l-1.13-.29q-1.28-.32-2.01-.99-.72-.67-.72-1.76 0-.91.49-1.59t1.35-1.06 1.94-.38q1.11 0 1.93.38.83.38 1.3 1.06.47.67.49 1.54h-1.9q-.06-.64-.55-.98-.48-.35-1.29-.35a2.5 2.5 0 0 0-.94.17q-.39.16-.6.44a1.06 1.06 0 0 0-.2.64q0 .4.24.66.25.26.63.42.39.16.81.26l.94.23a6.5 6.5 0 0 1 1.15.38q.55.24.97.6.42.35.66.84t.24 1.14q0 .91-.46 1.59t-1.33 1.06-2.1.38m-13.18-.03a2.9 2.9 0 0 1-1.59-.46q-.7-.46-1.12-1.33-.41-.88-.41-2.15 0-1.29.42-2.17.42-.87 1.14-1.32a2.9 2.9 0 0 1 1.58-.44q.66 0 1.09.23.43.22.69.54t.4.61h.08V9.36h1.91V17h-1.9v-1.22h-.08a2.6 2.6 0 0 1-.41.61q-.27.32-.7.53t-1.08.21m.57-1.55q.55 0 .94-.3.38-.3.58-.84.21-.54.21-1.25 0-.72-.2-1.25t-.58-.83q-.38-.29-.94-.29-.57 0-.96.3-.38.3-.58.83a3.6 3.6 0 0 0-.19 1.23q0 .69.2 1.23t.58.85q.39.31.95.31M42.78 17V9.36h1.87v1.31h.08q.21-.68.71-1.05a1.93 1.93 0 0 1 1.16-.36q.15 0 .34.02.19.01.32.04v1.74a2 2 0 0 0-.38-.07 5 5 0 0 0-.48-.03q-.48 0-.86.21a1.5 1.5 0 0 0-.6.57 1.65 1.65 0 0 0-.21.85V17zm-3.73 0V9.36h1.93V17zm-.02-8.73V6.52h1.98v1.75zm-5.17 8.87q-1.55 0-2.45-.82-.9-.83-.9-2.35v-.59h1.96v.61q0 .77.38 1.16t1.02.39 1-.39q.38-.4.38-1.16V6.82h1.94v7.14q0 1.52-.9 2.35-.89.83-2.43.83"/>
</svg>
`;
const $076101c0fca1455b$var$customThemeSvg = `<svg width="206" viewBox="0 0 206 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-4.256 10.156-2.481 3.12c-1.694 2.129-1.912 5.047.402 6.891l7.16-8.837c.42-.52.185-1.174-.503-1.174zm-8.619 2.348c-.419.52-.183 1.174.504 1.174h4.577l2.465-3.136c1.677-2.146 1.928-5.03-.386-6.875z"/>
    <path fill="var(--themed-text-color, currentcolor)" d="M205.27 9.36v1.48h-4.44V9.36zm-3.38-1.82h1.92v7.27q0 .38.17.57t.56.19a3 3 0 0 0 .32-.03 5 5 0 0 0 .32-.06l.29 1.46q-.31.1-.64.13a5 5 0 0 1-.62.04q-1.13 0-1.73-.55-.59-.56-.59-1.59zm-7.02 5.01V17h-1.93V9.36h1.82l.03 1.9h-.13q.31-.97.92-1.48.62-.51 1.57-.51.79 0 1.37.34.6.34.92.98.33.64.33 1.55V17h-1.92v-4.54q0-.74-.38-1.16t-1.05-.42q-.45 0-.81.2a1.35 1.35 0 0 0-.55.57q-.2.37-.2.9m-6.81 4.6q-1.16 0-2-.48a3.25 3.25 0 0 1-1.29-1.37q-.45-.88-.45-2.08 0-1.18.44-2.06a3.4 3.4 0 0 1 1.26-1.39q.82-.5 1.93-.5.73 0 1.36.23.64.23 1.13.71.49.47.77 1.2t.28 1.72v.57h-6.34v-1.25h5.39l-.9.35q0-.62-.19-1.08a1.54 1.54 0 0 0-.57-.72q-.37-.26-.93-.26-.55 0-.94.26t-.59.7-.2.99v.88q0 .69.23 1.17.24.47.66.71t.98.24q.37 0 .68-.11t.53-.31q.22-.21.34-.52l1.75.34q-.18.62-.64 1.09-.45.46-1.13.73-.68.25-1.54.25M171.93 17V9.36h1.8l.08 1.87h-.14q.17-.7.51-1.13.35-.44.81-.64.47-.21.97-.21.83 0 1.33.52.51.52.73 1.57h-.22q.16-.71.55-1.18.39-.46.91-.69.53-.23 1.12-.23.69 0 1.24.3t.87.88.32 1.42V17h-1.92v-4.82q0-.67-.37-1a1.32 1.32 0 0 0-.9-.32q-.4 0-.7.18a1.2 1.2 0 0 0-.46.49q-.16.32-.16.73V17h-1.87v-4.89q0-.57-.35-.91-.34-.34-.89-.34a1.4 1.4 0 0 0-.68.17 1.2 1.2 0 0 0-.49.51q-.18.33-.18.81V17zm-4.89.15q-1.16 0-2-.48a3.26 3.26 0 0 1-1.29-1.37q-.45-.88-.45-2.08 0-1.18.44-2.06A3.4 3.4 0 0 1 165 9.77q.82-.5 1.93-.5.72 0 1.36.23t1.14.71q.49.47.77 1.2t.28 1.72v.57h-6.34v-1.25h5.39l-.9.35a2.8 2.8 0 0 0-.19-1.08 1.55 1.55 0 0 0-.57-.72q-.37-.26-.93-.26T166 11q-.39.26-.59.7t-.2.99v.88q0 .69.23 1.17.24.47.66.71t.98.24q.37 0 .68-.11a1.5 1.5 0 0 0 .53-.31q.22-.21.33-.52l1.75.34q-.18.62-.63 1.09-.45.46-1.13.73-.68.25-1.54.25m-8.91 2.86q-.94 0-1.63-.24-.69-.23-1.13-.65a2.3 2.3 0 0 1-.62-.94l1.64-.51q.11.21.31.42.21.21.55.35.35.14.87.14.81 0 1.28-.38.47-.37.47-1.16v-1.41h-.15a2.3 2.3 0 0 1-.4.58q-.25.29-.68.48-.42.19-1.07.19a3.1 3.1 0 0 1-1.58-.41q-.7-.41-1.13-1.24-.42-.83-.42-2.08 0-1.28.42-2.15t1.14-1.31q.71-.44 1.58-.44.66 0 1.09.23.44.22.7.54.27.32.4.61h.09V9.36h1.89v7.62q0 1.02-.47 1.7-.46.68-1.29 1-.82.33-1.88.33m.03-4.62q.55 0 .94-.27.38-.27.58-.77.21-.5.21-1.21 0-.7-.2-1.22-.2-.53-.58-.81-.38-.29-.94-.29-.57 0-.96.3a1.86 1.86 0 0 0-.58.83 3.5 3.5 0 0 0-.19 1.2q0 .68.2 1.19t.58.79q.39.27.95.27m-9.36 1.73a2.9 2.9 0 0 1-1.59-.46q-.7-.46-1.12-1.33-.41-.88-.41-2.15 0-1.29.42-2.17.42-.87 1.14-1.32.71-.44 1.58-.44.66 0 1.09.23.43.22.69.54t.4.61h.08V9.36h1.91V17h-1.9v-1.22h-.08a2.7 2.7 0 0 1-.41.61 2.1 2.1 0 0 1-.7.53q-.43.21-1.08.21m.57-1.55q.56 0 .94-.3t.58-.84q.21-.54.21-1.25 0-.72-.2-1.25t-.58-.83-.94-.29q-.57 0-.96.3-.38.3-.58.83a3.7 3.7 0 0 0-.19 1.23q0 .69.2 1.23t.58.85q.39.31.95.31m-10.13-3.02V17h-1.93V9.36h1.82l.03 1.9h-.13q.31-.97.92-1.48.62-.51 1.57-.51.79 0 1.37.34.6.34.92.98.33.64.33 1.55V17h-1.92v-4.54q0-.74-.38-1.16t-1.05-.42q-.45 0-.81.2a1.34 1.34 0 0 0-.55.57q-.2.37-.2.9m-7.9 4.58a2.9 2.9 0 0 1-1.59-.46q-.7-.46-1.12-1.33-.41-.88-.41-2.15 0-1.29.42-2.17.42-.87 1.14-1.32.71-.44 1.58-.44.66 0 1.09.23.43.22.69.54t.4.61h.08V9.36h1.91V17h-1.9v-1.22h-.08a2.6 2.6 0 0 1-.41.61q-.27.32-.7.53t-1.08.21m.57-1.55q.55 0 .94-.3.38-.3.58-.84t.21-1.25q0-.72-.2-1.25t-.58-.83q-.38-.29-.94-.29-.57 0-.96.3a1.85 1.85 0 0 0-.58.83 3.6 3.6 0 0 0-.19 1.23q0 .69.2 1.23t.58.85q.39.31.95.31M115.65 17V6.81h2.99l1.78 4.95q.1.31.23.81a47 47 0 0 1 .52 2.17q.12.54.2.94h-.39q.08-.39.2-.92a93 93 0 0 1 .53-2.18q.13-.5.23-.81l1.76-4.95h2.99V17h-1.96v-4.96q0-.33.01-.81l.03-1.04.03-1.13q.01-.57.01-1.07h.14q-.14.55-.3 1.14l-.31 1.14a44 44 0 0 1-.55 1.76L122.01 17h-1.66l-1.8-4.96q-.1-.29-.25-.74l-.3-1a129 129 0 0 1-.64-2.29h.16l.02 1.03.03 1.12.02 1.05q.01.49.01.83V17zm-8.37.15q-1.16 0-2-.48a3.26 3.26 0 0 1-1.29-1.37q-.45-.88-.45-2.08 0-1.18.45-2.06.45-.9 1.26-1.39.82-.5 1.93-.5.72 0 1.36.23a3.1 3.1 0 0 1 1.14.71q.49.47.77 1.2t.28 1.72v.57h-6.34v-1.25h5.39l-.9.35a2.8 2.8 0 0 0-.19-1.08 1.55 1.55 0 0 0-.57-.72q-.37-.26-.93-.26-.55 0-.94.26a1.66 1.66 0 0 0-.59.7q-.2.44-.2.99v.88q0 .69.23 1.17.24.47.66.71t.99.24q.37 0 .68-.11a1.5 1.5 0 0 0 .53-.31q.22-.21.34-.52l1.75.34q-.18.62-.64 1.09-.45.46-1.13.73-.68.25-1.54.25m-8.31-.01q-1.13 0-1.96-.49a3.3 3.3 0 0 1-1.28-1.38q-.45-.89-.45-2.06 0-1.18.45-2.07.45-.9 1.28-1.39t1.96-.49q.66 0 1.22.17t1 .49.73.78.41 1.03l-1.8.36q-.06-.3-.2-.54a1.5 1.5 0 0 0-.33-.4 1.3 1.3 0 0 0-.44-.26 1.6 1.6 0 0 0-.56-.09q-.58 0-.97.31t-.59.86q-.2.54-.2 1.24t.2 1.24.59.86q.39.31.97.31.32 0 .57-.09.26-.09.46-.27a1.6 1.6 0 0 0 .34-.42q.14-.25.2-.56l1.79.35q-.12.6-.4 1.06t-.73.79a3.3 3.3 0 0 1-1 .51q-.56.17-1.23.17M91.92 17V9.36h1.93V17zm-.02-8.73V6.52h1.98v1.75zM85.77 17l-2.83-7.64h2.04l1.34 4.05q.24.74.41 1.49l.37 1.54h-.44q.19-.79.36-1.54t.41-1.49l1.33-4.05h2.02L87.95 17zm-8.01 0V9.36h1.87v1.31h.08q.21-.68.71-1.05a1.93 1.93 0 0 1 1.16-.36q.15 0 .34.02.18.01.32.04v1.74a2 2 0 0 0-.38-.07 5 5 0 0 0-.49-.03q-.48 0-.86.21a1.5 1.5 0 0 0-.6.57 1.65 1.65 0 0 0-.21.85V17zm-4.89.15q-1.16 0-2-.48a3.26 3.26 0 0 1-1.29-1.37q-.45-.88-.45-2.08 0-1.18.44-2.06a3.4 3.4 0 0 1 1.26-1.39q.82-.5 1.93-.5.72 0 1.36.23t1.14.71q.49.47.77 1.2t.28 1.72v.57h-6.34v-1.25h5.39l-.9.35a2.8 2.8 0 0 0-.19-1.08 1.55 1.55 0 0 0-.57-.72q-.37-.26-.93-.26-.55 0-.94.26t-.59.7q-.21.44-.21.99v.88q0 .69.23 1.17.24.47.66.71t.98.24q.37 0 .68-.11t.53-.31a1.4 1.4 0 0 0 .34-.52l1.75.34q-.18.62-.64 1.09-.45.46-1.13.73-.68.25-1.54.25m-8.87-.01q-1.2 0-2.09-.37t-1.39-1.09q-.5-.73-.53-1.77h1.92q.04.53.32.88t.74.53q.46.17 1.03.17t1.01-.17q.44-.18.68-.49.25-.31.25-.72a.9.9 0 0 0-.22-.62 1.7 1.7 0 0 0-.62-.42 5.3 5.3 0 0 0-.96-.31l-1.13-.29q-1.28-.32-2.01-.99-.72-.67-.72-1.76 0-.91.49-1.59t1.35-1.06 1.94-.38q1.11 0 1.93.38.83.38 1.3 1.06.47.67.49 1.54h-1.9q-.06-.64-.55-.98-.48-.35-1.29-.35a2.5 2.5 0 0 0-.94.17q-.39.16-.6.44a1.06 1.06 0 0 0-.2.64q0 .4.24.66.25.26.63.42.39.16.81.26l.94.23a6.5 6.5 0 0 1 1.15.38q.55.24.97.6.42.35.66.84t.24 1.14q0 .91-.46 1.59t-1.33 1.06-2.1.38m-13.18-.03a2.9 2.9 0 0 1-1.59-.46q-.7-.46-1.12-1.33-.41-.88-.41-2.15 0-1.29.42-2.17.42-.87 1.14-1.32a2.9 2.9 0 0 1 1.58-.44q.66 0 1.09.23.43.22.69.54t.4.61h.08V9.36h1.91V17h-1.9v-1.22h-.08a2.6 2.6 0 0 1-.41.61q-.27.32-.7.53t-1.08.21m.57-1.55q.55 0 .94-.3.38-.3.58-.84.21-.54.21-1.25 0-.72-.2-1.25t-.58-.83q-.38-.29-.94-.29-.57 0-.96.3-.38.3-.58.83a3.6 3.6 0 0 0-.19 1.23q0 .69.2 1.23t.58.85q.39.31.95.31M42.78 17V9.36h1.87v1.31h.08q.21-.68.71-1.05a1.93 1.93 0 0 1 1.16-.36q.15 0 .34.02.19.01.32.04v1.74a2 2 0 0 0-.38-.07 5 5 0 0 0-.48-.03q-.48 0-.86.21a1.5 1.5 0 0 0-.6.57 1.65 1.65 0 0 0-.21.85V17zm-3.73 0V9.36h1.93V17zm-.02-8.73V6.52h1.98v1.75zm-5.17 8.87q-1.55 0-2.45-.82-.9-.83-.9-2.35v-.59h1.96v.61q0 .77.38 1.16t1.02.39 1-.39q.38-.4.38-1.16V6.82h1.94v7.14q0 1.52-.9 2.35-.89.83-2.43.83"/>
</svg>
`;
function $076101c0fca1455b$export$dabef2be6cd28c20({ iconColor: iconColor, textColor: textColor, label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $mfib2.LogoWrapper), {
        svg: $076101c0fca1455b$var$svg,
        customThemeSvg: $076101c0fca1455b$var$customThemeSvg,
        iconColor: iconColor,
        textColor: textColor,
        label: label || 'Jira Service Management',
        testId: testId
    });
}

});

parcelRegister("37H9V", function(module, exports) {

$parcel$export(module.exports, "JiraProductDiscoveryLogo", () => $33d3b4c3481bd349$export$c49a2b642fe9eef4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8745b2602d93d7792ce2eec3da4fd6da>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $mfib2 = parcelRequire("mfib2");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $33d3b4c3481bd349$var$svg = `<svg width="186" viewBox="0 0 186 24">
    <path fill="var(--tile-color,#c97cf4)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M13.467 4.882a9.47 9.47 0 0 0 5.422 0c.159-.035.265.07.23.229-.513 1.85-.513 3.558 0 5.408.035.14-.072.264-.23.211a10.1 10.1 0 0 0-5.422 0c-.142.053-.265-.07-.212-.211.476-1.85.476-3.559 0-5.408-.053-.159.07-.264.212-.23m.724 6.553v.3c0 1.39-.972 2.412-2.173 2.412a2.153 2.153 0 0 1-2.154-2.166c0-1.198.971-2.15 2.331-2.15h.353V5.62c-.176-.017-.353-.017-.53-.017a6.387 6.387 0 0 0-6.393 6.394 6.37 6.37 0 0 0 6.393 6.377c3.533 0 6.411-2.854 6.411-6.377v-.563z"/>
    <path fill="var(--ds-text, #292a2e)" d="m177.61 17.71.45-1.47.23.06q.41.11.73.06a.83.83 0 0 0 .52-.27q.21-.22.27-.62l.08-.44-2.88-7.67h2.04l1.34 4.05q.24.75.39 1.49.16.75.34 1.54h-.47l.37-1.54q.18-.75.43-1.49l1.4-4.05h2.02l-3.26 8.58q-.23.62-.59 1.06a2.3 2.3 0 0 1-.88.68q-.52.24-1.25.24-.4 0-.74-.06a2.5 2.5 0 0 1-.53-.14m-5.8-2.72V7.36h1.87v1.31h.08q.2-.68.71-1.05a1.93 1.93 0 0 1 1.16-.36q.15 0 .34.02.18.01.32.04v1.74a2 2 0 0 0-.38-.07 5 5 0 0 0-.48-.03q-.48 0-.86.21a1.5 1.5 0 0 0-.6.57 1.65 1.65 0 0 0-.21.85V15zm-4.89.15q-1.16 0-2-.48a3.25 3.25 0 0 1-1.29-1.37q-.45-.88-.45-2.08 0-1.18.44-2.06a3.4 3.4 0 0 1 1.26-1.39q.82-.5 1.93-.5.73 0 1.36.23.64.23 1.13.71.49.47.77 1.2t.28 1.72v.57h-6.34v-1.25h5.39l-.9.35q0-.62-.19-1.08a1.55 1.55 0 0 0-.57-.72q-.37-.26-.93-.26-.55 0-.94.26t-.59.7-.2.99v.88q0 .69.23 1.17.24.47.66.71t.98.24q.37 0 .68-.11t.53-.31q.22-.21.34-.52l1.75.34q-.18.62-.64 1.09-.45.47-1.13.73-.68.25-1.54.25m-9.33-.16-2.83-7.64h2.04l1.34 4.05q.24.74.41 1.49l.37 1.54h-.44l.36-1.54q.17-.75.41-1.49l1.33-4.05h2.02L159.79 15zm-7.09.15q-1.13 0-1.97-.49a3.3 3.3 0 0 1-1.28-1.38q-.45-.89-.45-2.06 0-1.18.45-2.07a3.3 3.3 0 0 1 1.28-1.39q.83-.49 1.97-.49t1.96.49q.84.49 1.29 1.39.45.89.45 2.07t-.45 2.07a3.3 3.3 0 0 1-1.28 1.38q-.83.49-1.96.49m0-1.53q.58 0 .97-.31.39-.32.58-.87a3.7 3.7 0 0 0 .19-1.23 3.7 3.7 0 0 0-.19-1.23q-.19-.55-.58-.86-.39-.32-.97-.32t-.97.32q-.38.32-.58.86-.19.54-.19 1.23 0 .68.19 1.23.2.55.58.87.39.31.97.31m-8.22 1.52q-1.13 0-1.96-.49a3.3 3.3 0 0 1-1.28-1.38q-.45-.89-.45-2.06 0-1.18.45-2.07a3.3 3.3 0 0 1 1.28-1.39q.83-.49 1.96-.49.66 0 1.22.17t1 .49.73.78.41 1.03l-1.8.36q-.06-.3-.2-.54a1.5 1.5 0 0 0-.33-.4 1.3 1.3 0 0 0-.44-.26 1.6 1.6 0 0 0-.56-.09q-.58 0-.97.31t-.59.86q-.2.54-.2 1.24t.2 1.24.59.86.97.31q.31 0 .57-.09t.46-.27a1.6 1.6 0 0 0 .34-.42q.14-.25.2-.56l1.79.35q-.12.6-.4 1.06t-.73.79a3.3 3.3 0 0 1-1 .51q-.56.17-1.23.17m-8.2-.02q-.9 0-1.6-.25a2.85 2.85 0 0 1-1.14-.75 2.5 2.5 0 0 1-.57-1.2l1.8-.32q.15.55.54.82t1.02.27q.62 0 .98-.24t.36-.61q0-.31-.25-.51t-.76-.31l-1.31-.27q-1.09-.23-1.63-.77t-.54-1.39q0-.72.4-1.24.4-.53 1.1-.81.71-.29 1.65-.29.89 0 1.53.25a2.6 2.6 0 0 1 1.05.7q.4.44.55 1.06l-1.71.31a1.3 1.3 0 0 0-.46-.66q-.33-.27-.92-.27-.53 0-.9.23-.35.23-.35.59 0 .32.23.52.24.2.8.33l1.34.27q1.09.23 1.63.74t.54 1.33q0 .74-.43 1.3-.43.55-1.19.87-.75.31-1.74.31m-6.73-.16V7.36h1.93V15zm-.02-8.73V4.51h1.98v1.76zM120.9 15h-2.6v-1.69h2.52q1.02 0 1.71-.37t1.03-1.12q.35-.76.35-1.91t-.35-1.9a2.32 2.32 0 0 0-1.03-1.12q-.68-.37-1.69-.37h-2.6v-1.7h2.71q1.52 0 2.62.61a4.1 4.1 0 0 1 1.69 1.75q.59 1.14.59 2.73t-.59 2.74a4.1 4.1 0 0 1-1.7 1.76q-1.11.61-2.66.61m-1.55-10.19V15h-1.96V4.81zm-6.81 2.53v1.48h-4.44V7.36zm-3.38-1.82h1.92v7.27q0 .38.17.57t.56.19q.12 0 .32-.03a5 5 0 0 0 .32-.06l.29 1.46a3.4 3.4 0 0 1-.64.13 5 5 0 0 1-.62.04q-1.13 0-1.73-.55-.59-.55-.59-1.59zm-5.13 9.61q-1.13 0-1.96-.49a3.3 3.3 0 0 1-1.28-1.38q-.45-.89-.45-2.06 0-1.18.45-2.07a3.3 3.3 0 0 1 1.28-1.39q.83-.49 1.96-.49.66 0 1.22.17t1 .49.73.78.41 1.03l-1.8.36q-.06-.3-.2-.54a1.5 1.5 0 0 0-.33-.4 1.3 1.3 0 0 0-.44-.26 1.6 1.6 0 0 0-.56-.09q-.58 0-.97.31t-.59.86q-.2.54-.2 1.24t.2 1.24.59.86.97.31q.32 0 .57-.09.26-.09.46-.27a1.6 1.6 0 0 0 .34-.42q.14-.25.2-.56l1.79.35q-.11.6-.4 1.06-.29.47-.73.79a3.3 3.3 0 0 1-1 .51q-.56.17-1.23.17m-9.43-.07q-.79 0-1.39-.34a2.34 2.34 0 0 1-.92-.98q-.33-.65-.33-1.55V7.37h1.93v4.54q0 .75.38 1.16.38.42 1.05.42.46 0 .81-.19.35-.2.55-.57t.2-.9V7.38h1.93V15h-1.83L97 13.1h.12q-.31.98-.93 1.49t-1.56.51m-8.61.03a2.9 2.9 0 0 1-1.6-.46q-.71-.46-1.12-1.33-.41-.88-.41-2.15 0-1.29.42-2.17.42-.87 1.13-1.32a2.9 2.9 0 0 1 1.57-.44q.66 0 1.09.23.43.22.69.54.27.32.4.61h.07V4.81h1.92V15h-1.89v-1.22h-.1a2.8 2.8 0 0 1-.4.61q-.27.31-.7.53-.43.21-1.07.21m.56-1.55q.55 0 .94-.3.38-.3.58-.84a3.5 3.5 0 0 0 .21-1.25q0-.72-.2-1.25t-.59-.83q-.38-.29-.94-.29-.57 0-.95.31a1.85 1.85 0 0 0-.58.83 3.6 3.6 0 0 0-.19 1.22q0 .69.19 1.23.2.54.58.85.39.31.95.31m-8.55 1.58q-1.13 0-1.97-.49a3.3 3.3 0 0 1-1.28-1.38q-.45-.89-.45-2.06 0-1.18.45-2.07.45-.9 1.28-1.39t1.97-.49 1.96.49q.83.49 1.29 1.39.45.89.45 2.07t-.45 2.07T80 14.67t-1.96.49m0-1.53q.58 0 .97-.31.39-.32.58-.87a3.7 3.7 0 0 0 .19-1.23 3.7 3.7 0 0 0-.19-1.23 1.87 1.87 0 0 0-.59-.88q-.39-.32-.97-.32t-.97.32q-.38.32-.58.86-.19.54-.19 1.23 0 .68.19 1.23.2.55.58.87.39.31.97.31M69.35 15V7.36h1.87v1.31h.08q.21-.68.71-1.05a1.93 1.93 0 0 1 1.16-.36q.15 0 .34.02.18.01.32.04v1.74a2 2 0 0 0-.38-.07 5 5 0 0 0-.49-.03q-.48 0-.86.21a1.5 1.5 0 0 0-.6.57 1.65 1.65 0 0 0-.21.85V15zm-8.98 0V4.81h3.9q1.16 0 1.97.45.81.44 1.22 1.21.42.77.42 1.76t-.42 1.76-1.24 1.2q-.81.43-1.99.43H61.7v-1.6h2.25q.66 0 1.09-.22.43-.23.64-.64a2.05 2.05 0 0 0 .21-.93q0-.53-.2-.93a1.44 1.44 0 0 0-.64-.63q-.43-.23-1.09-.23h-1.6V15zm-9.48.13a2.9 2.9 0 0 1-1.59-.46q-.7-.46-1.12-1.33-.41-.88-.41-2.15 0-1.29.42-2.17.42-.87 1.14-1.32a2.9 2.9 0 0 1 1.58-.44q.66 0 1.09.23.43.22.69.54t.4.61h.08V7.36h1.91V15h-1.9v-1.22h-.08a2.6 2.6 0 0 1-.41.61q-.27.32-.7.53t-1.08.21m.57-1.55q.55 0 .94-.3.38-.3.58-.84.21-.54.21-1.25 0-.72-.2-1.25t-.58-.83q-.38-.29-.94-.29-.57 0-.96.3-.38.3-.58.83a3.6 3.6 0 0 0-.19 1.23q0 .69.2 1.23t.58.85q.39.31.95.31M42.78 15V7.36h1.87v1.31h.08q.21-.68.71-1.05a1.93 1.93 0 0 1 1.16-.36q.15 0 .34.02.19.01.32.04v1.74a2 2 0 0 0-.38-.07 5 5 0 0 0-.48-.03q-.48 0-.86.21a1.5 1.5 0 0 0-.6.57 1.65 1.65 0 0 0-.21.85V15zm-3.73 0V7.36h1.93V15zm-.02-8.73V4.51h1.98v1.76zm-5.17 8.87q-1.55 0-2.45-.82-.9-.83-.9-2.35v-.59h1.96v.61q0 .77.38 1.16t1.02.39 1-.39q.38-.4.38-1.16V4.82h1.94v7.14q0 1.52-.9 2.35-.89.83-2.43.83"/>
</svg>
`;
const $33d3b4c3481bd349$var$customThemeSvg = `<svg width="186" viewBox="0 0 186 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-5.981 5.604a6.387 6.387 0 0 0-6.394 6.394 6.373 6.373 0 0 0 6.394 6.377c3.532 0 6.41-2.854 6.41-6.377v-.563H14.19v.3c0 1.39-.97 2.412-2.171 2.413a2.154 2.154 0 0 1-2.156-2.168c0-1.197.973-2.148 2.332-2.148h.353v-4.21c-.177-.018-.353-.018-.53-.018m6.87-.722a9.47 9.47 0 0 1-5.422 0c-.141-.035-.265.07-.212.228.477 1.85.477 3.559 0 5.409-.053.14.07.264.212.211a10.1 10.1 0 0 1 5.422 0c.159.053.265-.07.23-.211-.513-1.85-.513-3.56 0-5.409.034-.158-.072-.263-.23-.228"/>
    <path fill="var(--themed-text-color, currentcolor)" d="m177.61 19.71.45-1.47.23.06q.41.11.73.06a.83.83 0 0 0 .52-.27q.21-.22.27-.62l.08-.44-2.88-7.67h2.04l1.34 4.05q.24.75.39 1.49.16.75.34 1.54h-.47l.37-1.54q.18-.75.43-1.49l1.4-4.05h2.02l-3.26 8.58q-.23.62-.59 1.06a2.3 2.3 0 0 1-.88.68q-.52.24-1.25.24-.4 0-.74-.06a2.5 2.5 0 0 1-.53-.14m-5.8-2.72V9.36h1.87v1.31h.08q.2-.68.71-1.05a1.93 1.93 0 0 1 1.16-.36q.15 0 .34.02.18.01.32.04v1.74a2 2 0 0 0-.38-.07 5 5 0 0 0-.48-.03q-.48 0-.86.21a1.5 1.5 0 0 0-.6.57 1.65 1.65 0 0 0-.21.85V17zm-4.89.15q-1.16 0-2-.48a3.25 3.25 0 0 1-1.29-1.37q-.45-.88-.45-2.08 0-1.18.44-2.06a3.4 3.4 0 0 1 1.26-1.39q.82-.5 1.93-.5.73 0 1.36.23.64.23 1.13.71.49.47.77 1.2t.28 1.72v.57h-6.34v-1.25h5.39l-.9.35q0-.62-.19-1.08a1.55 1.55 0 0 0-.57-.72q-.37-.26-.93-.26-.55 0-.94.26t-.59.7-.2.99v.88q0 .69.23 1.17.24.47.66.71t.98.24q.37 0 .68-.11t.53-.31q.22-.21.34-.52l1.75.34q-.18.62-.64 1.09-.45.46-1.13.73-.68.25-1.54.25m-9.33-.16-2.83-7.64h2.04l1.34 4.05q.24.74.41 1.49l.37 1.54h-.44q.18-.79.36-1.54.17-.75.41-1.49l1.33-4.05h2.02L159.79 17zm-7.09.15q-1.13 0-1.97-.49a3.3 3.3 0 0 1-1.28-1.38q-.45-.89-.45-2.06 0-1.18.45-2.07a3.3 3.3 0 0 1 1.28-1.39q.83-.49 1.97-.49t1.96.49q.84.49 1.29 1.39.45.89.45 2.07t-.45 2.07a3.3 3.3 0 0 1-1.28 1.38q-.83.49-1.96.49m0-1.53q.58 0 .97-.31.39-.32.58-.87a3.7 3.7 0 0 0 .19-1.23 3.7 3.7 0 0 0-.19-1.23q-.19-.55-.58-.86-.39-.32-.97-.32t-.97.32q-.38.32-.58.86-.19.54-.19 1.23 0 .68.19 1.23.2.55.58.87.39.31.97.31m-8.22 1.52q-1.13 0-1.96-.49a3.3 3.3 0 0 1-1.28-1.38q-.45-.89-.45-2.06 0-1.18.45-2.07a3.3 3.3 0 0 1 1.28-1.39q.83-.49 1.96-.49.66 0 1.22.17t1 .49.73.78.41 1.03l-1.8.36q-.06-.3-.2-.54a1.5 1.5 0 0 0-.33-.4 1.3 1.3 0 0 0-.44-.26 1.6 1.6 0 0 0-.56-.09q-.58 0-.97.31t-.59.86q-.2.54-.2 1.24t.2 1.24.59.86.97.31q.31 0 .57-.09t.46-.27a1.6 1.6 0 0 0 .34-.42q.14-.25.2-.56l1.79.35q-.12.6-.4 1.06t-.73.79a3.3 3.3 0 0 1-1 .51q-.56.17-1.23.17m-8.2-.02q-.9 0-1.6-.25a2.85 2.85 0 0 1-1.14-.75 2.5 2.5 0 0 1-.57-1.2l1.8-.32q.15.55.54.82t1.02.27q.62 0 .98-.24t.36-.61q0-.31-.25-.51t-.76-.31l-1.31-.27q-1.09-.23-1.63-.77t-.54-1.39q0-.72.4-1.24.4-.53 1.1-.81.71-.29 1.65-.29.89 0 1.53.25a2.6 2.6 0 0 1 1.05.7q.4.44.55 1.06l-1.71.31a1.3 1.3 0 0 0-.46-.66q-.33-.27-.92-.27-.53 0-.9.23-.35.23-.35.6 0 .32.23.52.24.2.8.33l1.34.27q1.09.23 1.63.74t.54 1.33q0 .74-.43 1.3-.43.55-1.19.87-.75.31-1.74.31m-6.73-.17V9.36h1.93V17zm-.02-8.73V6.52h1.98v1.75zM120.9 17h-2.6v-1.69h2.52q1.02 0 1.71-.37t1.03-1.12q.35-.76.35-1.91t-.35-1.9a2.32 2.32 0 0 0-1.03-1.12q-.68-.37-1.69-.37h-2.6v-1.7h2.71q1.52 0 2.62.61a4.1 4.1 0 0 1 1.69 1.75q.59 1.14.59 2.73t-.59 2.74a4.1 4.1 0 0 1-1.7 1.76q-1.11.61-2.66.61m-1.55-10.19V17h-1.96V6.81zm-6.81 2.53v1.48h-4.44V9.36zm-3.38-1.82h1.92v7.27q0 .38.17.57t.56.19q.12 0 .32-.03a5 5 0 0 0 .32-.06l.29 1.46a3.4 3.4 0 0 1-.64.13 5 5 0 0 1-.62.04q-1.13 0-1.73-.55-.59-.56-.59-1.59zm-5.13 9.61q-1.13 0-1.96-.49a3.3 3.3 0 0 1-1.28-1.38q-.45-.89-.45-2.06 0-1.18.45-2.07a3.3 3.3 0 0 1 1.28-1.39q.83-.49 1.96-.49.66 0 1.22.17t1 .49.73.78.41 1.03l-1.8.36q-.06-.3-.2-.54a1.5 1.5 0 0 0-.33-.4 1.3 1.3 0 0 0-.44-.26 1.6 1.6 0 0 0-.56-.09q-.58 0-.97.31t-.59.86q-.2.54-.2 1.24t.2 1.24.59.86.97.31q.32 0 .57-.09.26-.09.46-.27a1.6 1.6 0 0 0 .34-.42q.14-.25.2-.56l1.79.35q-.11.6-.4 1.06-.29.47-.73.79a3.3 3.3 0 0 1-1 .51q-.56.17-1.23.17m-9.43-.07q-.79 0-1.39-.34a2.34 2.34 0 0 1-.92-.98q-.33-.65-.33-1.55V9.37h1.93v4.54q0 .75.38 1.16.38.42 1.05.42.46 0 .81-.19.35-.2.55-.57t.2-.9V9.38h1.93V17h-1.83L97 15.1h.12q-.31.98-.93 1.49t-1.56.51m-8.61.03a2.9 2.9 0 0 1-1.6-.46q-.71-.46-1.12-1.33-.41-.88-.41-2.15 0-1.29.42-2.17.42-.87 1.13-1.32a2.9 2.9 0 0 1 1.57-.44q.66 0 1.09.23.43.22.69.54.27.32.4.61h.07V6.81h1.92V17h-1.89v-1.22h-.1a2.8 2.8 0 0 1-.4.61q-.27.31-.7.53-.43.21-1.07.21m.56-1.55q.55 0 .94-.3.38-.3.58-.84a3.5 3.5 0 0 0 .21-1.25q0-.72-.2-1.25t-.59-.83q-.38-.29-.94-.29-.57 0-.95.31a1.85 1.85 0 0 0-.58.83 3.6 3.6 0 0 0-.19 1.22q0 .69.19 1.23.2.54.58.85.39.31.95.31m-8.55 1.58q-1.13 0-1.97-.49a3.3 3.3 0 0 1-1.28-1.38q-.45-.89-.45-2.06 0-1.18.45-2.07.45-.9 1.28-1.39t1.97-.49 1.96.49q.83.49 1.29 1.39.45.89.45 2.07t-.45 2.07T80 16.67t-1.96.49m0-1.53q.58 0 .97-.31.39-.32.58-.87a3.7 3.7 0 0 0 .19-1.23 3.7 3.7 0 0 0-.19-1.23 1.87 1.87 0 0 0-.58-.86q-.39-.32-.97-.32t-.97.32q-.38.32-.58.86-.19.54-.19 1.23 0 .68.19 1.23.2.55.58.87.39.31.97.31M69.35 17V9.36h1.87v1.31h.08q.21-.68.71-1.05a1.93 1.93 0 0 1 1.16-.36q.15 0 .34.02.18.01.32.04v1.74a2 2 0 0 0-.38-.07 5 5 0 0 0-.49-.03q-.48 0-.86.21a1.5 1.5 0 0 0-.6.57 1.65 1.65 0 0 0-.21.85V17zm-8.98 0V6.81h3.9q1.16 0 1.97.45.81.44 1.22 1.21.42.77.42 1.76t-.42 1.76a3 3 0 0 1-1.24 1.2q-.81.43-1.99.43H61.7v-1.6h2.25q.66 0 1.09-.22.43-.23.64-.64a2.05 2.05 0 0 0 .21-.93q0-.53-.2-.93a1.44 1.44 0 0 0-.64-.63q-.43-.23-1.09-.23h-1.6V17zm-9.48.13a2.9 2.9 0 0 1-1.59-.46q-.7-.46-1.12-1.33-.41-.88-.41-2.15 0-1.29.42-2.17.42-.87 1.14-1.32a2.9 2.9 0 0 1 1.58-.44q.66 0 1.09.23.43.22.69.54t.4.61h.08V9.36h1.91V17h-1.9v-1.22h-.08a2.6 2.6 0 0 1-.41.61q-.27.32-.7.53t-1.08.21m.57-1.55q.55 0 .94-.3.38-.3.58-.84.21-.54.21-1.25 0-.72-.2-1.25t-.58-.83q-.38-.29-.94-.29-.57 0-.96.3-.38.3-.58.83a3.6 3.6 0 0 0-.19 1.23q0 .69.2 1.23t.58.85q.39.31.95.31M42.78 17V9.36h1.87v1.31h.08q.21-.68.71-1.05a1.93 1.93 0 0 1 1.16-.36q.15 0 .34.02.19.01.32.04v1.74a2 2 0 0 0-.38-.07 5 5 0 0 0-.48-.03q-.48 0-.86.21a1.5 1.5 0 0 0-.6.57 1.65 1.65 0 0 0-.21.85V17zm-3.73 0V9.36h1.93V17zm-.02-8.73V6.52h1.98v1.75zm-5.17 8.87q-1.55 0-2.45-.82-.9-.83-.9-2.35v-.59h1.96v.61q0 .77.38 1.16t1.02.39 1-.39q.38-.4.38-1.16V6.82h1.94v7.14q0 1.52-.9 2.35-.89.83-2.43.83"/>
</svg>
`;
function $33d3b4c3481bd349$export$c49a2b642fe9eef4({ iconColor: iconColor, textColor: textColor, label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $mfib2.LogoWrapper), {
        svg: $33d3b4c3481bd349$var$svg,
        customThemeSvg: $33d3b4c3481bd349$var$customThemeSvg,
        iconColor: iconColor,
        textColor: textColor,
        label: label || 'Jira Product Discovery',
        testId: testId
    });
}

});

parcelRegister("2HThS", function(module, exports) {

$parcel$export(module.exports, "CustomerServiceManagementIcon", () => $e34734ab954d32d0$export$6da5aa77c402ba0f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fdfb8863e0f63e79e9b498e13d2a8308>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3Aqws = parcelRequire("3Aqws");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $e34734ab954d32d0$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="#ffc716" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="#101214" d="M16.43 17.42A6.97 6.97 0 0 1 12 19H6.4v-.47l3.84-3.78a3.25 3.25 0 0 0 1.76.52c.65 0 1.25-.19 1.76-.51zm.99-.99A6.97 6.97 0 0 0 19 12a6.97 6.97 0 0 0-1.58-4.43l-2.67 2.67c.33.51.52 1.11.52 1.76s-.19 1.25-.51 1.76zm-.99-9.85-2.67 2.67A3.25 3.25 0 0 0 12 8.73c-.65 0-1.25.19-1.76.52L7.57 6.58A6.97 6.97 0 0 1 12 5c1.68 0 3.22.59 4.43 1.58m-9.85.99A6.97 6.97 0 0 0 5 12c0 1.68.59 3.22 1.58 4.43l2.67-2.67A3.25 3.25 0 0 1 8.73 12c0-.65.19-1.25.52-1.76z"/>
</svg>
`;
const $e34734ab954d32d0$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-4.238 14.751a3.25 3.25 0 0 1-1.762.516 3.25 3.25 0 0 1-1.762-.515L6.4 18.533V19H12a6.97 6.97 0 0 0 4.43-1.58zM6.58 7.571A6.97 6.97 0 0 0 5 12a6.97 6.97 0 0 0 1.58 4.43l2.669-2.668A3.25 3.25 0 0 1 8.733 12c0-.649.19-1.253.516-1.762zm8.172 2.667c.326.508.515 1.113.515 1.762s-.189 1.254-.515 1.762l2.668 2.668A6.97 6.97 0 0 0 19 12a6.97 6.97 0 0 0-1.58-4.43zM12 5a6.97 6.97 0 0 0-4.43 1.58l2.668 2.668A3.25 3.25 0 0 1 12 8.733c.649 0 1.253.19 1.762.516L16.43 6.58A6.97 6.97 0 0 0 12 5"/>
</svg>
`;
function $e34734ab954d32d0$export$6da5aa77c402ba0f({ size: size, appearance: appearance = 'brand', iconColor: iconColor, label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Aqws.IconWrapper), {
        svg: $e34734ab954d32d0$var$svg,
        customThemeSvg: $e34734ab954d32d0$var$customThemeSvg,
        size: size,
        appearance: appearance,
        iconColor: iconColor,
        label: label || 'Customer Service Management',
        testId: testId
    });
}

});

parcelRegister("8QdPr", function(module, exports) {

$parcel$export(module.exports, "CustomerServiceManagementLogo", () => $778042e341d749ff$export$abc95e6180bb1d88);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1fa51cb8a152e7d9c8a3aaaa06199d8f>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $mfib2 = parcelRequire("mfib2");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $778042e341d749ff$var$svg = `<svg width="247" viewBox="0 0 247 24">
    <path fill="#ffc716" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="#101214" d="M16.43 17.42A6.97 6.97 0 0 1 12 19H6.4v-.47l3.84-3.78a3.25 3.25 0 0 0 1.76.52c.65 0 1.25-.19 1.76-.51zm.99-.99A6.97 6.97 0 0 0 19 12a6.97 6.97 0 0 0-1.58-4.43l-2.67 2.67c.33.51.52 1.11.52 1.76s-.19 1.25-.51 1.76zm-.99-9.85-2.67 2.67A3.25 3.25 0 0 0 12 8.73c-.65 0-1.25.19-1.76.52L7.57 6.58A6.97 6.97 0 0 1 12 5c1.68 0 3.22.59 4.43 1.58m-9.85.99A6.97 6.97 0 0 0 5 12c0 1.68.59 3.22 1.58 4.43l2.67-2.67A3.25 3.25 0 0 1 8.73 12c0-.65.19-1.25.52-1.76z"/>
    <path fill="var(--ds-text, #292a2e)" d="M246.18 9.36v1.48h-4.44V9.36zm-3.38-1.82h1.92v7.27q0 .38.17.57t.56.19q.12 0 .32-.03.21-.03.32-.06l.29 1.46q-.31.1-.64.13a5 5 0 0 1-.62.04q-1.13 0-1.73-.55-.59-.56-.59-1.59zm-7.02 5.01V17h-1.93V9.36h1.82l.03 1.9h-.13q.31-.97.92-1.48.62-.51 1.57-.51.79 0 1.37.34.6.34.92.98.33.64.33 1.55V17h-1.92v-4.54q0-.74-.38-1.16t-1.05-.42q-.45 0-.81.2a1.34 1.34 0 0 0-.55.57q-.2.37-.2.9m-6.81 4.6q-1.16 0-2-.48a3.25 3.25 0 0 1-1.29-1.37q-.45-.88-.45-2.08 0-1.18.44-2.06a3.4 3.4 0 0 1 1.26-1.39q.82-.5 1.93-.5.72 0 1.36.23t1.14.71q.49.47.77 1.2t.28 1.72v.57h-6.34v-1.25h5.39l-.9.35q0-.62-.19-1.08a1.54 1.54 0 0 0-.57-.72q-.37-.26-.93-.26-.55 0-.94.26t-.59.7-.2.99v.88q0 .69.23 1.17.24.47.66.71t.98.24q.37 0 .68-.11t.53-.31q.22-.21.34-.52l1.75.34a2.66 2.66 0 0 1-.63 1.09q-.45.46-1.13.73-.68.25-1.54.25M212.83 17V9.36h1.8l.08 1.87h-.14q.17-.7.51-1.13.35-.44.81-.64.47-.21.97-.21.83 0 1.33.52.51.52.73 1.57h-.22q.16-.71.55-1.18.39-.46.91-.69.53-.23 1.12-.23.69 0 1.24.3t.87.88.32 1.42V17h-1.92v-4.82q0-.67-.37-1a1.32 1.32 0 0 0-.9-.32q-.4 0-.7.18a1.2 1.2 0 0 0-.46.49q-.16.32-.16.73V17h-1.87v-4.89q0-.57-.35-.91-.34-.34-.89-.34-.37 0-.68.17a1.2 1.2 0 0 0-.49.51q-.18.33-.18.81V17zm-4.88.15q-1.16 0-2-.48a3.26 3.26 0 0 1-1.29-1.37q-.45-.88-.45-2.08 0-1.18.45-2.06.45-.9 1.26-1.39.82-.5 1.93-.5.72 0 1.36.23a3.1 3.1 0 0 1 1.14.71q.49.47.77 1.2t.28 1.72v.57h-6.34v-1.25h5.39l-.9.35a2.8 2.8 0 0 0-.19-1.08 1.55 1.55 0 0 0-.57-.72q-.37-.26-.93-.26-.55 0-.94.26a1.66 1.66 0 0 0-.59.7q-.2.44-.2.99v.88q0 .69.23 1.17.24.47.66.71t.99.24q.37 0 .68-.11a1.5 1.5 0 0 0 .53-.31q.22-.21.34-.52l1.75.34q-.18.62-.64 1.09-.45.46-1.13.73-.68.25-1.54.25m-8.93 2.86q-.94 0-1.63-.24-.69-.23-1.13-.65a2.26 2.26 0 0 1-.61-.94l1.64-.51q.11.21.32.42.2.21.55.35t.87.14q.81 0 1.28-.38.47-.37.47-1.16v-1.41h-.15q-.14.29-.4.58a2 2 0 0 1-.68.48q-.42.19-1.07.19a3.1 3.1 0 0 1-1.58-.41q-.7-.41-1.13-1.24-.42-.83-.42-2.08 0-1.28.42-2.15t1.14-1.31q.71-.44 1.58-.44.66 0 1.09.23.44.22.7.54.27.32.4.61h.09V9.36h1.89v7.62q0 1.02-.47 1.7-.46.68-1.29 1-.82.33-1.88.33m.03-4.62q.55 0 .94-.27.38-.27.58-.77.21-.5.21-1.21 0-.7-.2-1.22-.2-.53-.58-.81-.38-.29-.94-.29-.57 0-.96.3-.38.3-.58.83a3.5 3.5 0 0 0-.19 1.2q0 .68.2 1.19t.58.79q.39.27.95.27m-9.38 1.73a2.9 2.9 0 0 1-1.59-.46q-.7-.46-1.12-1.33-.41-.88-.41-2.15 0-1.29.42-2.17.42-.87 1.14-1.32.71-.44 1.58-.44.66 0 1.09.23.43.22.69.54t.4.61h.08V9.36h1.91V17h-1.9v-1.22h-.08a2.7 2.7 0 0 1-.41.61q-.27.32-.7.53t-1.08.21m.57-1.55q.55 0 .94-.3.38-.3.58-.84.21-.54.21-1.25 0-.72-.2-1.25t-.58-.83-.94-.29q-.57 0-.96.3-.38.3-.58.83a3.6 3.6 0 0 0-.19 1.23q0 .69.2 1.23t.58.85q.39.31.95.31m-10.13-3.02V17h-1.93V9.36h1.82l.03 1.9h-.13q.31-.97.92-1.48.62-.51 1.57-.51.79 0 1.37.34.6.34.92.98.33.64.33 1.55V17h-1.92v-4.54q0-.74-.38-1.16t-1.05-.42q-.45 0-.81.2a1.35 1.35 0 0 0-.55.57q-.2.37-.2.9m-7.91 4.58a2.9 2.9 0 0 1-1.59-.46q-.7-.46-1.12-1.33-.41-.88-.41-2.15 0-1.29.42-2.17.42-.87 1.14-1.32.71-.44 1.58-.44.66 0 1.09.23.43.22.69.54t.4.61h.08V9.36h1.91V17h-1.9v-1.22h-.08a2.7 2.7 0 0 1-.41.61 2.1 2.1 0 0 1-.7.53q-.43.21-1.08.21m.57-1.55q.56 0 .94-.3t.58-.84q.21-.54.21-1.25 0-.72-.2-1.25t-.58-.83-.94-.29q-.57 0-.96.3a1.85 1.85 0 0 0-.58.83 3.7 3.7 0 0 0-.19 1.23q0 .69.2 1.23t.58.85q.39.31.95.31M156.56 17V6.81h2.99l1.78 4.95q.1.31.23.81a47 47 0 0 1 .52 2.17q.12.54.2.94h-.39q.08-.39.2-.92a77 77 0 0 1 .53-2.18q.13-.5.23-.81l1.76-4.95h3V17h-1.96v-4.96q0-.33.01-.81a304 304 0 0 0 .05-2.17q.01-.57.01-1.07h.14q-.14.55-.3 1.14l-.31 1.14q-.16.55-.3 1-.14.46-.25.76L162.91 17h-1.66l-1.8-4.96q-.1-.29-.25-.74l-.3-1q-.16-.55-.32-1.13a94 94 0 0 1-.31-1.15h.16l.02 1.03.03 1.12.02 1.05q.01.49.01.83V17zm-8.37.15q-1.16 0-2-.48a3.25 3.25 0 0 1-1.29-1.37q-.45-.88-.45-2.08 0-1.18.45-2.06a3.4 3.4 0 0 1 1.26-1.39q.82-.5 1.93-.5.73 0 1.36.23.64.23 1.13.71.49.47.77 1.2t.28 1.72v.57h-6.34v-1.25h5.39l-.9.35q0-.62-.19-1.08a1.56 1.56 0 0 0-.57-.72q-.37-.26-.93-.26-.55 0-.94.26t-.59.7-.2.99v.88q0 .69.23 1.17.24.47.66.71t.99.24q.37 0 .68-.11t.53-.31q.22-.21.34-.52l1.75.34q-.18.62-.64 1.09-.45.46-1.13.73-.68.25-1.54.25m-8.3-.01q-1.13 0-1.96-.49a3.3 3.3 0 0 1-1.28-1.38q-.45-.89-.45-2.06 0-1.18.45-2.07a3.3 3.3 0 0 1 1.28-1.39q.83-.49 1.96-.49.66 0 1.22.17t1 .49.73.78.41 1.03l-1.8.36q-.06-.3-.2-.54a1.5 1.5 0 0 0-.33-.4 1.3 1.3 0 0 0-.44-.26 1.6 1.6 0 0 0-.56-.09q-.58 0-.97.31t-.59.86a3.6 3.6 0 0 0-.2 1.24q0 .7.2 1.24t.59.86.97.31q.32 0 .57-.09.26-.09.46-.27t.34-.42q.14-.25.2-.56l1.79.35q-.12.6-.4 1.06-.29.47-.73.79a3.3 3.3 0 0 1-1 .51q-.56.17-1.23.17m-7.13-.17V9.36h1.93V17zm-.02-8.73V6.52h1.98v1.75zM126.68 17l-2.83-7.64h2.04l1.34 4.05q.24.74.41 1.49l.37 1.54h-.44q.19-.79.36-1.54t.41-1.49l1.33-4.05h2.02L128.85 17zm-8.02 0V9.36h1.87v1.31h.08q.21-.68.71-1.05a1.94 1.94 0 0 1 1.16-.36q.15 0 .34.02.18.01.32.04v1.74a2 2 0 0 0-.38-.07 5 5 0 0 0-.48-.03 1.8 1.8 0 0 0-.86.21 1.5 1.5 0 0 0-.6.57 1.64 1.64 0 0 0-.21.85V17zm-4.89.15q-1.16 0-2-.48a3.26 3.26 0 0 1-1.29-1.37q-.45-.88-.45-2.08 0-1.18.45-2.06.45-.9 1.26-1.39.82-.5 1.93-.5.73 0 1.36.23a3.1 3.1 0 0 1 1.14.71q.49.47.77 1.2t.28 1.72v.57h-6.34v-1.25h5.39l-.9.35q0-.62-.19-1.08a1.56 1.56 0 0 0-.57-.72q-.37-.26-.93-.26-.55 0-.94.26t-.59.7-.2.99v.88q0 .69.23 1.17.24.47.66.71t.99.24q.37 0 .68-.11t.53-.31q.22-.21.34-.52l1.75.34q-.18.62-.64 1.09-.45.46-1.13.73-.68.25-1.54.25m-8.89-.01q-1.2 0-2.09-.37t-1.39-1.09q-.5-.73-.53-1.77h1.92q.04.53.31.88.28.35.74.53.46.17 1.02.17.57 0 1.01-.17.44-.18.68-.49.25-.31.25-.72a.9.9 0 0 0-.22-.62 1.7 1.7 0 0 0-.62-.42 5.3 5.3 0 0 0-.96-.31l-1.13-.29q-1.28-.32-2.01-.99-.72-.67-.72-1.76 0-.91.49-1.59t1.35-1.06 1.94-.38q1.11 0 1.93.38.83.38 1.3 1.06.47.67.49 1.54h-1.9q-.06-.64-.55-.98-.48-.35-1.29-.35a2.5 2.5 0 0 0-.94.17 1.36 1.36 0 0 0-.6.44 1.07 1.07 0 0 0-.2.64q0 .4.24.66.25.26.63.42.39.16.81.26l.94.23q.61.14 1.15.38.55.24.97.6.42.35.66.84t.24 1.14q0 .91-.46 1.59t-1.33 1.06-2.1.38M92.15 17V9.36h1.87v1.31h.08q.2-.68.71-1.05a1.93 1.93 0 0 1 1.16-.36q.15 0 .34.02.19.01.32.04v1.74a2 2 0 0 0-.38-.07 5 5 0 0 0-.48-.03q-.48 0-.86.21a1.5 1.5 0 0 0-.6.57 1.65 1.65 0 0 0-.21.85V17zm-4.88.15q-1.16 0-2-.48a3.26 3.26 0 0 1-1.29-1.37q-.45-.88-.45-2.08 0-1.18.44-2.06a3.4 3.4 0 0 1 1.26-1.39q.82-.5 1.93-.5.73 0 1.36.23.64.23 1.14.71.49.47.77 1.2t.28 1.72v.57h-6.35v-1.25h5.39l-.9.35a2.8 2.8 0 0 0-.19-1.08 1.55 1.55 0 0 0-.57-.72q-.37-.26-.93-.26-.55 0-.94.26t-.59.7-.2.99v.88q0 .69.23 1.17.24.47.66.71t.98.24q.37 0 .68-.11t.53-.31a1.4 1.4 0 0 0 .34-.52l1.75.34q-.18.62-.64 1.09-.45.46-1.13.73-.68.25-1.54.25M71.14 17V9.36h1.8l.08 1.87h-.14q.17-.7.51-1.13.35-.44.81-.64.47-.21.97-.21.83 0 1.33.52.51.52.73 1.57h-.22q.16-.71.55-1.18.39-.46.91-.69.53-.23 1.12-.23.69 0 1.24.3.56.3.87.88.32.58.32 1.42V17H80.1v-4.82q0-.67-.37-1a1.32 1.32 0 0 0-.89-.32q-.4 0-.7.18a1.2 1.2 0 0 0-.46.49q-.16.32-.16.73V17h-1.87v-4.89q0-.57-.35-.91-.34-.34-.89-.34-.37 0-.68.17a1.2 1.2 0 0 0-.49.51q-.18.33-.18.81V17zm-5.18.15q-1.13 0-1.97-.49a3.3 3.3 0 0 1-1.28-1.38q-.45-.89-.45-2.06 0-1.18.45-2.07.45-.9 1.28-1.39t1.97-.49 1.96.49q.83.49 1.29 1.39.45.89.45 2.07t-.45 2.07-1.29 1.38q-.83.49-1.96.49m0-1.53q.58 0 .97-.31.39-.32.58-.87a3.7 3.7 0 0 0 .19-1.23 3.7 3.7 0 0 0-.19-1.23 1.87 1.87 0 0 0-.58-.86q-.39-.32-.97-.32t-.97.32q-.38.32-.58.86-.19.54-.19 1.23 0 .68.19 1.23.2.55.58.87.39.31.97.31m-4.61-6.27v1.48h-4.44V9.36zm-3.38-1.82h1.92v7.27q0 .38.17.57t.56.19q.12 0 .32-.03.21-.03.32-.06l.29 1.46q-.31.1-.64.13a5 5 0 0 1-.62.04q-1.13 0-1.73-.55-.59-.56-.59-1.59zm-5.1 9.61q-.9 0-1.6-.25a2.84 2.84 0 0 1-1.14-.75 2.5 2.5 0 0 1-.57-1.2l1.8-.32q.15.55.54.82t1.02.27q.62 0 .98-.24t.36-.61q0-.31-.25-.51t-.76-.31l-1.31-.27q-1.09-.23-1.63-.77t-.54-1.39q0-.72.4-1.24.4-.53 1.1-.81.71-.29 1.65-.29.89 0 1.53.25.65.25 1.05.7.4.44.55 1.06l-1.71.31a1.3 1.3 0 0 0-.46-.66q-.33-.27-.92-.27-.53 0-.9.23-.35.23-.35.6 0 .32.23.52.24.2.8.33l1.34.27q1.09.23 1.63.74t.54 1.33q0 .74-.43 1.3-.43.55-1.19.87-.75.31-1.74.31m-9.02-.07q-.79 0-1.39-.34a2.34 2.34 0 0 1-.92-.98q-.33-.65-.33-1.55V9.37h1.93v4.54q0 .75.38 1.16t1.05.42q.46 0 .81-.19.35-.2.55-.57t.2-.9V9.38h1.93V17h-1.82l-.02-1.9h.12q-.31.98-.93 1.49t-1.56.51m-8.5.04q-1.35 0-2.41-.62t-1.67-1.79-.61-2.82.62-2.82q.62-1.18 1.68-1.79 1.07-.62 2.4-.62.85 0 1.59.24.75.24 1.32.7t.94 1.12.49 1.51h-1.98a2.2 2.2 0 0 0-.28-.77 2 2 0 0 0-.51-.57q-.3-.24-.69-.36a2.8 2.8 0 0 0-.83-.12q-.81 0-1.43.41-.62.4-.97 1.18-.34.78-.34 1.89 0 1.13.35 1.91.35.77.96 1.17a2.6 2.6 0 0 0 1.43.4q.45 0 .83-.12.39-.12.7-.36.32-.24.52-.57.21-.34.29-.77h1.98q-.09.72-.43 1.36a4.2 4.2 0 0 1-.9 1.15 4.2 4.2 0 0 1-1.32.79q-.76.28-1.69.28"/>
</svg>
`;
const $778042e341d749ff$var$customThemeSvg = `<svg width="247" viewBox="0 0 247 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-4.238 14.751a3.25 3.25 0 0 1-1.762.516 3.25 3.25 0 0 1-1.762-.515L6.4 18.533V19H12a6.97 6.97 0 0 0 4.43-1.58zM6.58 7.571A6.97 6.97 0 0 0 5 12a6.97 6.97 0 0 0 1.58 4.43l2.669-2.668A3.25 3.25 0 0 1 8.733 12c0-.649.19-1.253.516-1.762zm8.172 2.667c.326.508.515 1.113.515 1.762s-.189 1.254-.515 1.762l2.668 2.668A6.97 6.97 0 0 0 19 12a6.97 6.97 0 0 0-1.58-4.43zM12 5a6.97 6.97 0 0 0-4.43 1.58l2.668 2.668A3.25 3.25 0 0 1 12 8.733c.649 0 1.253.19 1.762.516L16.43 6.58A6.97 6.97 0 0 0 12 5"/>
    <path fill="var(--themed-text-color, currentcolor)" d="M246.18 9.36v1.48h-4.44V9.36zm-3.38-1.82h1.92v7.27q0 .38.17.57t.56.19q.12 0 .32-.03.21-.03.32-.06l.29 1.46q-.31.1-.64.13a5 5 0 0 1-.62.04q-1.13 0-1.73-.55-.59-.56-.59-1.59zm-7.02 5.01V17h-1.93V9.36h1.82l.03 1.9h-.13q.31-.97.92-1.48.62-.51 1.57-.51.79 0 1.37.34.6.34.92.98.33.64.33 1.55V17h-1.92v-4.54q0-.74-.38-1.16t-1.05-.42q-.45 0-.81.2a1.34 1.34 0 0 0-.55.57q-.2.37-.2.9m-6.81 4.6q-1.16 0-2-.48a3.25 3.25 0 0 1-1.29-1.37q-.45-.88-.45-2.08 0-1.18.44-2.06a3.4 3.4 0 0 1 1.26-1.39q.82-.5 1.93-.5.72 0 1.36.23t1.14.71q.49.47.77 1.2t.28 1.72v.57h-6.34v-1.25h5.39l-.9.35q0-.62-.19-1.08a1.54 1.54 0 0 0-.57-.72q-.37-.26-.93-.26-.55 0-.94.26t-.59.7-.2.99v.88q0 .69.23 1.17.24.47.66.71t.98.24q.37 0 .68-.11t.53-.31q.22-.21.34-.52l1.75.34a2.66 2.66 0 0 1-.63 1.09q-.45.46-1.13.73-.68.25-1.54.25M212.83 17V9.36h1.8l.08 1.87h-.14q.17-.7.51-1.13.35-.44.81-.64.47-.21.97-.21.83 0 1.33.52.51.52.73 1.57h-.22q.16-.71.55-1.18.39-.46.91-.69.53-.23 1.12-.23.69 0 1.24.3t.87.88.32 1.42V17h-1.92v-4.82q0-.67-.37-1a1.32 1.32 0 0 0-.9-.32q-.4 0-.7.18a1.2 1.2 0 0 0-.46.49q-.16.32-.16.73V17h-1.87v-4.89q0-.57-.35-.91-.34-.34-.89-.34-.37 0-.68.17a1.2 1.2 0 0 0-.49.51q-.18.33-.18.81V17zm-4.88.15q-1.16 0-2-.48a3.26 3.26 0 0 1-1.29-1.37q-.45-.88-.45-2.08 0-1.18.45-2.06.45-.9 1.26-1.39.82-.5 1.93-.5.72 0 1.36.23a3.1 3.1 0 0 1 1.14.71q.49.47.77 1.2t.28 1.72v.57h-6.34v-1.25h5.39l-.9.35a2.8 2.8 0 0 0-.19-1.08 1.55 1.55 0 0 0-.57-.72q-.37-.26-.93-.26-.55 0-.94.26a1.66 1.66 0 0 0-.59.7q-.2.44-.2.99v.88q0 .69.23 1.17.24.47.66.71t.99.24q.37 0 .68-.11a1.5 1.5 0 0 0 .53-.31q.22-.21.34-.52l1.75.34q-.18.62-.64 1.09-.45.46-1.13.73-.68.25-1.54.25m-8.93 2.86q-.94 0-1.63-.24-.69-.23-1.13-.65a2.26 2.26 0 0 1-.61-.94l1.64-.51q.11.21.32.42.2.21.55.35t.87.14q.81 0 1.28-.38.47-.37.47-1.16v-1.41h-.15q-.14.29-.4.58a2 2 0 0 1-.68.48q-.42.19-1.07.19a3.1 3.1 0 0 1-1.58-.41q-.7-.41-1.13-1.24-.42-.83-.42-2.08 0-1.28.42-2.15t1.14-1.31q.71-.44 1.58-.44.66 0 1.09.23.44.22.7.54.27.32.4.61h.09V9.36h1.89v7.62q0 1.02-.47 1.7-.46.68-1.29 1-.82.33-1.88.33m.03-4.62q.55 0 .94-.27.38-.27.58-.77.21-.5.21-1.21 0-.7-.2-1.22-.2-.53-.58-.81-.38-.29-.94-.29-.57 0-.96.3-.38.3-.58.83a3.5 3.5 0 0 0-.19 1.2q0 .68.2 1.19t.58.79q.39.27.95.27m-9.38 1.73a2.9 2.9 0 0 1-1.59-.46q-.7-.46-1.12-1.33-.41-.88-.41-2.15 0-1.29.42-2.17.42-.87 1.14-1.32.71-.44 1.58-.44.66 0 1.09.23.43.22.69.54t.4.61h.08V9.36h1.91V17h-1.9v-1.22h-.08a2.7 2.7 0 0 1-.41.61q-.27.32-.7.53t-1.08.21m.57-1.55q.55 0 .94-.3.38-.3.58-.84.21-.54.21-1.25 0-.72-.2-1.25t-.58-.83-.94-.29q-.57 0-.96.3-.38.3-.58.83a3.6 3.6 0 0 0-.19 1.23q0 .69.2 1.23t.58.85q.39.31.95.31m-10.13-3.02V17h-1.93V9.36h1.82l.03 1.9h-.13q.31-.97.92-1.48.62-.51 1.57-.51.79 0 1.37.34.6.34.92.98.33.64.33 1.55V17h-1.92v-4.54q0-.74-.38-1.16t-1.05-.42q-.45 0-.81.2a1.35 1.35 0 0 0-.55.57q-.2.37-.2.9m-7.91 4.58a2.9 2.9 0 0 1-1.59-.46q-.7-.46-1.12-1.33-.41-.88-.41-2.15 0-1.29.42-2.17.42-.87 1.14-1.32.71-.44 1.58-.44.66 0 1.09.23.43.22.69.54t.4.61h.08V9.36h1.91V17h-1.9v-1.22h-.08a2.7 2.7 0 0 1-.41.61 2.1 2.1 0 0 1-.7.53q-.43.21-1.08.21m.57-1.55q.56 0 .94-.3t.58-.84q.21-.54.21-1.25 0-.72-.2-1.25t-.58-.83-.94-.29q-.57 0-.96.3a1.85 1.85 0 0 0-.58.83 3.7 3.7 0 0 0-.19 1.23q0 .69.2 1.23t.58.85q.39.31.95.31M156.56 17V6.81h2.99l1.78 4.95q.1.31.23.81a47 47 0 0 1 .52 2.17q.12.54.2.94h-.39q.08-.39.2-.92a77 77 0 0 1 .53-2.18q.13-.5.23-.81l1.76-4.95h3V17h-1.96v-4.96q0-.33.01-.81a304 304 0 0 0 .05-2.17q.01-.57.01-1.07h.14q-.14.55-.3 1.14l-.31 1.14q-.16.55-.3 1-.14.46-.25.76L162.91 17h-1.66l-1.8-4.96q-.1-.29-.25-.74l-.3-1q-.16-.55-.32-1.13a94 94 0 0 1-.31-1.15h.16l.02 1.03.03 1.12.02 1.05q.01.49.01.83V17zm-8.37.15q-1.16 0-2-.48a3.25 3.25 0 0 1-1.29-1.37q-.45-.88-.45-2.08 0-1.18.45-2.06a3.4 3.4 0 0 1 1.26-1.39q.82-.5 1.93-.5.73 0 1.36.23.64.23 1.13.71.49.47.77 1.2t.28 1.72v.57h-6.34v-1.25h5.39l-.9.35q0-.62-.19-1.08a1.56 1.56 0 0 0-.57-.72q-.37-.26-.93-.26-.55 0-.94.26t-.59.7-.2.99v.88q0 .69.23 1.17.24.47.66.71t.99.24q.37 0 .68-.11t.53-.31q.22-.21.34-.52l1.75.34q-.18.62-.64 1.09-.45.46-1.13.73-.68.25-1.54.25m-8.3-.01q-1.13 0-1.96-.49a3.3 3.3 0 0 1-1.28-1.38q-.45-.89-.45-2.06 0-1.18.45-2.07a3.3 3.3 0 0 1 1.28-1.39q.83-.49 1.96-.49.66 0 1.22.17t1 .49.73.78.41 1.03l-1.8.36q-.06-.3-.2-.54a1.5 1.5 0 0 0-.33-.4 1.3 1.3 0 0 0-.44-.26 1.6 1.6 0 0 0-.56-.09q-.58 0-.97.31t-.59.86a3.6 3.6 0 0 0-.2 1.24q0 .7.2 1.24t.59.86.97.31q.32 0 .57-.09.26-.09.46-.27t.34-.42q.14-.25.2-.56l1.79.35q-.12.6-.4 1.06-.29.47-.73.79a3.3 3.3 0 0 1-1 .51q-.56.17-1.23.17m-7.13-.17V9.36h1.93V17zm-.02-8.73V6.52h1.98v1.75zM126.68 17l-2.83-7.64h2.04l1.34 4.05q.24.74.41 1.49l.37 1.54h-.44q.19-.79.36-1.54t.41-1.49l1.33-4.05h2.02L128.85 17zm-8.02 0V9.36h1.87v1.31h.08q.21-.68.71-1.05a1.94 1.94 0 0 1 1.16-.36q.15 0 .34.02.18.01.32.04v1.74a2 2 0 0 0-.38-.07 5 5 0 0 0-.48-.03 1.8 1.8 0 0 0-.86.21 1.5 1.5 0 0 0-.6.57 1.64 1.64 0 0 0-.21.85V17zm-4.89.15q-1.16 0-2-.48a3.26 3.26 0 0 1-1.29-1.37q-.45-.88-.45-2.08 0-1.18.45-2.06.45-.9 1.26-1.39.82-.5 1.93-.5.73 0 1.36.23a3.1 3.1 0 0 1 1.14.71q.49.47.77 1.2t.28 1.72v.57h-6.34v-1.25h5.39l-.9.35q0-.62-.19-1.08a1.56 1.56 0 0 0-.57-.72q-.37-.26-.93-.26-.55 0-.94.26t-.59.7-.2.99v.88q0 .69.23 1.17.24.47.66.71t.99.24q.37 0 .68-.11t.53-.31q.22-.21.34-.52l1.75.34q-.18.62-.64 1.09-.45.46-1.13.73-.68.25-1.54.25m-8.89-.01q-1.2 0-2.09-.37t-1.39-1.09q-.5-.73-.53-1.77h1.92q.04.53.31.88.28.35.74.53.46.17 1.02.17.57 0 1.01-.17.44-.18.68-.49.25-.31.25-.72a.9.9 0 0 0-.22-.62 1.7 1.7 0 0 0-.62-.42 5.3 5.3 0 0 0-.96-.31l-1.13-.29q-1.28-.32-2.01-.99-.72-.67-.72-1.76 0-.91.49-1.59t1.35-1.06 1.94-.38q1.11 0 1.93.38.83.38 1.3 1.06.47.67.49 1.54h-1.9q-.06-.64-.55-.98-.48-.35-1.29-.35a2.5 2.5 0 0 0-.94.17 1.36 1.36 0 0 0-.6.44 1.07 1.07 0 0 0-.2.64q0 .4.24.66.25.26.63.42.39.16.81.26l.94.23q.61.14 1.15.38.55.24.97.6.42.35.66.84t.24 1.14q0 .91-.46 1.59t-1.33 1.06-2.1.38M92.15 17V9.36h1.87v1.31h.08q.2-.68.71-1.05a1.93 1.93 0 0 1 1.16-.36q.15 0 .34.02.19.01.32.04v1.74a2 2 0 0 0-.38-.07 5 5 0 0 0-.48-.03q-.48 0-.86.21a1.5 1.5 0 0 0-.6.57 1.65 1.65 0 0 0-.21.85V17zm-4.88.15q-1.16 0-2-.48a3.26 3.26 0 0 1-1.29-1.37q-.45-.88-.45-2.08 0-1.18.44-2.06a3.4 3.4 0 0 1 1.26-1.39q.82-.5 1.93-.5.73 0 1.36.23.64.23 1.14.71.49.47.77 1.2t.28 1.72v.57h-6.35v-1.25h5.39l-.9.35a2.8 2.8 0 0 0-.19-1.08 1.55 1.55 0 0 0-.57-.72q-.37-.26-.93-.26-.55 0-.94.26t-.59.7-.2.99v.88q0 .69.23 1.17.24.47.66.71t.98.24q.37 0 .68-.11t.53-.31a1.4 1.4 0 0 0 .34-.52l1.75.34q-.18.62-.64 1.09-.45.46-1.13.73-.68.25-1.54.25M71.14 17V9.36h1.8l.08 1.87h-.14q.17-.7.51-1.13.35-.44.81-.64.47-.21.97-.21.83 0 1.33.52.51.52.73 1.57h-.22q.16-.71.55-1.18.39-.46.91-.69.53-.23 1.12-.23.69 0 1.24.3.56.3.87.88.32.58.32 1.42V17H80.1v-4.82q0-.67-.37-1a1.32 1.32 0 0 0-.89-.32q-.4 0-.7.18a1.2 1.2 0 0 0-.46.49q-.16.32-.16.73V17h-1.87v-4.89q0-.57-.35-.91-.34-.34-.89-.34-.37 0-.68.17a1.2 1.2 0 0 0-.49.51q-.18.33-.18.81V17zm-5.18.15q-1.13 0-1.97-.49a3.3 3.3 0 0 1-1.28-1.38q-.45-.89-.45-2.06 0-1.18.45-2.07.45-.9 1.28-1.39t1.97-.49 1.96.49q.83.49 1.29 1.39.45.89.45 2.07t-.45 2.07-1.29 1.38q-.83.49-1.96.49m0-1.53q.58 0 .97-.31.39-.32.58-.87a3.7 3.7 0 0 0 .19-1.23 3.7 3.7 0 0 0-.19-1.23 1.87 1.87 0 0 0-.58-.86q-.39-.32-.97-.32t-.97.32q-.38.32-.58.86-.19.54-.19 1.23 0 .68.19 1.23.2.55.58.87.39.31.97.31m-4.61-6.27v1.48h-4.44V9.36zm-3.38-1.82h1.92v7.27q0 .38.17.57t.56.19q.12 0 .32-.03.21-.03.32-.06l.29 1.46q-.31.1-.64.13a5 5 0 0 1-.62.04q-1.13 0-1.73-.55-.59-.56-.59-1.59zm-5.1 9.61q-.9 0-1.6-.25a2.84 2.84 0 0 1-1.14-.75 2.5 2.5 0 0 1-.57-1.2l1.8-.32q.15.55.54.82t1.02.27q.62 0 .98-.24t.36-.61q0-.31-.25-.51t-.76-.31l-1.31-.27q-1.09-.23-1.63-.77t-.54-1.39q0-.72.4-1.24.4-.53 1.1-.81.71-.29 1.65-.29.89 0 1.53.25.65.25 1.05.7.4.44.55 1.06l-1.71.31a1.3 1.3 0 0 0-.46-.66q-.33-.27-.92-.27-.53 0-.9.23-.35.23-.35.6 0 .32.23.52.24.2.8.33l1.34.27q1.09.23 1.63.74t.54 1.33q0 .74-.43 1.3-.43.55-1.19.87-.75.31-1.74.31m-9.02-.07q-.79 0-1.39-.34a2.34 2.34 0 0 1-.92-.98q-.33-.65-.33-1.55V9.37h1.93v4.54q0 .75.38 1.16t1.05.42q.46 0 .81-.19.35-.2.55-.57t.2-.9V9.38h1.93V17h-1.82l-.02-1.9h.12q-.31.98-.93 1.49t-1.56.51m-8.5.04q-1.35 0-2.41-.62t-1.67-1.79-.61-2.82.62-2.82q.62-1.18 1.68-1.79 1.07-.62 2.4-.62.85 0 1.59.24.75.24 1.32.7t.94 1.12.49 1.51h-1.98a2.2 2.2 0 0 0-.28-.77 2 2 0 0 0-.51-.57q-.3-.24-.69-.36a2.8 2.8 0 0 0-.83-.12q-.81 0-1.43.41-.62.4-.97 1.18-.34.78-.34 1.89 0 1.13.35 1.91.35.77.96 1.17a2.6 2.6 0 0 0 1.43.4q.45 0 .83-.12.39-.12.7-.36.32-.24.52-.57.21-.34.29-.77h1.98q-.09.72-.43 1.36a4.2 4.2 0 0 1-.9 1.15 4.2 4.2 0 0 1-1.32.79q-.76.28-1.69.28"/>
</svg>
`;
function $778042e341d749ff$export$abc95e6180bb1d88({ iconColor: iconColor, textColor: textColor, label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $mfib2.LogoWrapper), {
        svg: $778042e341d749ff$var$svg,
        customThemeSvg: $778042e341d749ff$var$customThemeSvg,
        iconColor: iconColor,
        textColor: textColor,
        label: label || 'Customer Service Management',
        testId: testId
    });
}

});

parcelRegister("1Y49U", function(module, exports) {

$parcel$export(module.exports, "JiraServicedeskQueueAri", () => $16ee9eeb56acb423$export$555c8ae00f64ebff);

var $IfwMb = parcelRequire("IfwMb");

var $9KGzW = parcelRequire("9KGzW");

var $1C2Ux = parcelRequire("1C2Ux");
// src/jira-servicedesk/queue/manifest.ts
var $16ee9eeb56acb423$var$jiraServicedeskQueueAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $IfwMb.JiraServicedeskQueueAriResourceOwner),
    resourceType: (0, $IfwMb.JiraServicedeskQueueAriResourceType),
    resourceIdSlug: "activation/{activationId}/{queueId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        queueId: /[0-9]+/
    }
};
// src/jira-servicedesk/queue/index.ts
var $16ee9eeb56acb423$export$555c8ae00f64ebff = class _JiraServicedeskQueueAri extends (0, $9KGzW.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._queueId = opts.resourceIdSegmentValues.queueId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get queueId() {
        return this._queueId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $16ee9eeb56acb423$var$jiraServicedeskQueueAriStaticOpts.qualifier,
            platformQualifier: $16ee9eeb56acb423$var$jiraServicedeskQueueAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $16ee9eeb56acb423$var$jiraServicedeskQueueAriStaticOpts.resourceOwner,
            resourceType: $16ee9eeb56acb423$var$jiraServicedeskQueueAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.queueId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                queueId: opts.queueId
            }
        }, ariOpts = (0, $1C2Ux.AriParser).fromOpts(derivedOpts, $16ee9eeb56acb423$var$jiraServicedeskQueueAriStaticOpts);
        return new _JiraServicedeskQueueAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $1C2Ux.AriParser).fromString(maybeAri, $16ee9eeb56acb423$var$jiraServicedeskQueueAriStaticOpts);
        return new _JiraServicedeskQueueAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            queueId: this.queueId
        };
    }
};

});
parcelRegister("IfwMb", function(module, exports) {

$parcel$export(module.exports, "JiraServicedeskQueueAriResourceOwner", () => $085027a493012871$export$704112eeb385ceab);
$parcel$export(module.exports, "JiraServicedeskQueueAriResourceType", () => $085027a493012871$export$6adb8c07b8bc2c5a);
// src/jira-servicedesk/queue/types.ts
var $085027a493012871$export$704112eeb385ceab = "jira-servicedesk", $085027a493012871$export$6adb8c07b8bc2c5a = "queue";

});


parcelRegister("1WQct", function(module, exports) {

$parcel$export(module.exports, "JiraSoftwareBoardAri", () => $16b3b3167d49c971$export$fcd404066e55a7a8);

var $8ANGM = parcelRequire("8ANGM");

var $9KGzW = parcelRequire("9KGzW");

var $1C2Ux = parcelRequire("1C2Ux");
// src/jira-software/board/manifest.ts
var $16b3b3167d49c971$var$jiraSoftwareBoardAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $8ANGM.JiraSoftwareBoardAriResourceOwner),
    resourceType: (0, $8ANGM.JiraSoftwareBoardAriResourceType),
    resourceIdSlug: "{boardId}",
    resourceIdSegmentFormats: {
        boardId: /[!a-zA-Z0-9\-_.~@:{}=]+(\/[!a-zA-Z0-9\-_.~@:{}=]+)*/
    }
};
// src/jira-software/board/index.ts
var $16b3b3167d49c971$export$fcd404066e55a7a8 = class _JiraSoftwareBoardAri extends (0, $9KGzW.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._boardId = opts.resourceIdSegmentValues.boardId;
    }
    get siteId() {
        return this._siteId;
    }
    get boardId() {
        return this._boardId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $16b3b3167d49c971$var$jiraSoftwareBoardAriStaticOpts.qualifier,
            platformQualifier: $16b3b3167d49c971$var$jiraSoftwareBoardAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $16b3b3167d49c971$var$jiraSoftwareBoardAriStaticOpts.resourceOwner,
            resourceType: $16b3b3167d49c971$var$jiraSoftwareBoardAriStaticOpts.resourceType,
            resourceId: `${opts.boardId}`,
            resourceIdSegmentValues: {
                boardId: opts.boardId
            }
        }, ariOpts = (0, $1C2Ux.AriParser).fromOpts(derivedOpts, $16b3b3167d49c971$var$jiraSoftwareBoardAriStaticOpts);
        return new _JiraSoftwareBoardAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $1C2Ux.AriParser).fromString(maybeAri, $16b3b3167d49c971$var$jiraSoftwareBoardAriStaticOpts);
        return new _JiraSoftwareBoardAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            boardId: this.boardId
        };
    }
};

});
parcelRegister("8ANGM", function(module, exports) {

$parcel$export(module.exports, "JiraSoftwareBoardAriResourceOwner", () => $64183abbeecc9672$export$d716ba4f5572ec86);
$parcel$export(module.exports, "JiraSoftwareBoardAriResourceType", () => $64183abbeecc9672$export$d4b70c04cf2221a5);
// src/jira-software/board/types.ts
var $64183abbeecc9672$export$d716ba4f5572ec86 = "jira-software", $64183abbeecc9672$export$d4b70c04cf2221a5 = "board";

});


parcelRegister("k0goX", function(module, exports) {

$parcel$export(module.exports, "JiraDashboardAri", () => $e90087bcd5853238$export$b7d4016f0f5da5b8);

var $6H9w3 = parcelRequire("6H9w3");

var $9KGzW = parcelRequire("9KGzW");

var $1C2Ux = parcelRequire("1C2Ux");
// src/jira/dashboard/manifest.ts
var $e90087bcd5853238$var$jiraDashboardAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $6H9w3.JiraDashboardAriResourceOwner),
    resourceType: (0, $6H9w3.JiraDashboardAriResourceType),
    resourceIdSlug: "activation/{activationId}/{dashboardId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        dashboardId: /[!a-zA-Z0-9\-_.~@:{}=]+(\/[!a-zA-Z0-9\-_.~@:{}=]+)*/
    }
};
// src/jira/dashboard/index.ts
var $e90087bcd5853238$export$b7d4016f0f5da5b8 = class _JiraDashboardAri extends (0, $9KGzW.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._dashboardId = opts.resourceIdSegmentValues.dashboardId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get dashboardId() {
        return this._dashboardId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $e90087bcd5853238$var$jiraDashboardAriStaticOpts.qualifier,
            platformQualifier: $e90087bcd5853238$var$jiraDashboardAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $e90087bcd5853238$var$jiraDashboardAriStaticOpts.resourceOwner,
            resourceType: $e90087bcd5853238$var$jiraDashboardAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.dashboardId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                dashboardId: opts.dashboardId
            }
        }, ariOpts = (0, $1C2Ux.AriParser).fromOpts(derivedOpts, $e90087bcd5853238$var$jiraDashboardAriStaticOpts);
        return new _JiraDashboardAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $1C2Ux.AriParser).fromString(maybeAri, $e90087bcd5853238$var$jiraDashboardAriStaticOpts);
        return new _JiraDashboardAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            dashboardId: this.dashboardId
        };
    }
};

});
parcelRegister("6H9w3", function(module, exports) {

$parcel$export(module.exports, "JiraDashboardAriResourceOwner", () => $014208d660d71eea$export$62c1deae25c41d24);
$parcel$export(module.exports, "JiraDashboardAriResourceType", () => $014208d660d71eea$export$e4e3a57a5e435aff);
// src/jira/dashboard/types.ts
var $014208d660d71eea$export$62c1deae25c41d24 = "jira", $014208d660d71eea$export$e4e3a57a5e435aff = "dashboard";

});


parcelRegister("89DrR", function(module, exports) {

$parcel$export(module.exports, "JiraPlanAri", () => $5efdc39c8e0dee87$export$6d2eb3641569f26);

var $fi2nK = parcelRequire("fi2nK");

var $9KGzW = parcelRequire("9KGzW");

var $1C2Ux = parcelRequire("1C2Ux");
// src/jira/plan/manifest.ts
var $5efdc39c8e0dee87$var$jiraPlanAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $fi2nK.JiraPlanAriResourceOwner),
    resourceType: (0, $fi2nK.JiraPlanAriResourceType),
    resourceIdSlug: "activation/{activationId}/{planId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        planId: /[0-9]+/
    }
};
// src/jira/plan/index.ts
var $5efdc39c8e0dee87$export$6d2eb3641569f26 = class _JiraPlanAri extends (0, $9KGzW.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._planId = opts.resourceIdSegmentValues.planId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get planId() {
        return this._planId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $5efdc39c8e0dee87$var$jiraPlanAriStaticOpts.qualifier,
            platformQualifier: $5efdc39c8e0dee87$var$jiraPlanAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $5efdc39c8e0dee87$var$jiraPlanAriStaticOpts.resourceOwner,
            resourceType: $5efdc39c8e0dee87$var$jiraPlanAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.planId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                planId: opts.planId
            }
        }, ariOpts = (0, $1C2Ux.AriParser).fromOpts(derivedOpts, $5efdc39c8e0dee87$var$jiraPlanAriStaticOpts);
        return new _JiraPlanAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $1C2Ux.AriParser).fromString(maybeAri, $5efdc39c8e0dee87$var$jiraPlanAriStaticOpts);
        return new _JiraPlanAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            planId: this.planId
        };
    }
};

});
parcelRegister("fi2nK", function(module, exports) {

$parcel$export(module.exports, "JiraPlanAriResourceOwner", () => $b21a627cc548ba69$export$bfd26af3c5e1b90d);
$parcel$export(module.exports, "JiraPlanAriResourceType", () => $b21a627cc548ba69$export$d6abe08eb30f433d);
// src/jira/plan/types.ts
var $b21a627cc548ba69$export$bfd26af3c5e1b90d = "jira", $b21a627cc548ba69$export$d6abe08eb30f433d = "plan";

});


parcelRegister("j5YhT", function(module, exports) {

$parcel$export(module.exports, "JiraProjectAri", () => $de6d3fcbf97a80dc$export$75a0a0a7cb0a58ae);

var $FYyiD = parcelRequire("FYyiD");

var $9KGzW = parcelRequire("9KGzW");

var $1C2Ux = parcelRequire("1C2Ux");
// src/jira/project/manifest.ts
var $de6d3fcbf97a80dc$var$jiraProjectAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $FYyiD.JiraProjectAriResourceOwner),
    resourceType: (0, $FYyiD.JiraProjectAriResourceType),
    resourceIdSlug: "{projectId}",
    resourceIdSegmentFormats: {
        projectId: /[0-9]+/
    }
};
// src/jira/project/index.ts
var $de6d3fcbf97a80dc$export$75a0a0a7cb0a58ae = class _JiraProjectAri extends (0, $9KGzW.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._projectId = opts.resourceIdSegmentValues.projectId;
    }
    get siteId() {
        return this._siteId;
    }
    get projectId() {
        return this._projectId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $de6d3fcbf97a80dc$var$jiraProjectAriStaticOpts.qualifier,
            platformQualifier: $de6d3fcbf97a80dc$var$jiraProjectAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $de6d3fcbf97a80dc$var$jiraProjectAriStaticOpts.resourceOwner,
            resourceType: $de6d3fcbf97a80dc$var$jiraProjectAriStaticOpts.resourceType,
            resourceId: `${opts.projectId}`,
            resourceIdSegmentValues: {
                projectId: opts.projectId
            }
        }, ariOpts = (0, $1C2Ux.AriParser).fromOpts(derivedOpts, $de6d3fcbf97a80dc$var$jiraProjectAriStaticOpts);
        return new _JiraProjectAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $1C2Ux.AriParser).fromString(maybeAri, $de6d3fcbf97a80dc$var$jiraProjectAriStaticOpts);
        return new _JiraProjectAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            projectId: this.projectId
        };
    }
};

});
parcelRegister("FYyiD", function(module, exports) {

$parcel$export(module.exports, "JiraProjectAriResourceOwner", () => $07e2ccdc15c7364e$export$99d538a3b04916b1);
$parcel$export(module.exports, "JiraProjectAriResourceType", () => $07e2ccdc15c7364e$export$736763838d3aa22e);
// src/jira/project/types.ts
var $07e2ccdc15c7364e$export$99d538a3b04916b1 = "jira", $07e2ccdc15c7364e$export$736763838d3aa22e = "project";

});


parcelRegister("jFpmD", function(module, exports) {

$parcel$export(module.exports, "useActivityClient", () => $7287efdb57b3bb52$export$6620595b7f837f8f);

var $5uXOq = parcelRequire("5uXOq");

var $btDaU = parcelRequire("btDaU");

var $3LJ9C = parcelRequire("3LJ9C");

var $hoYXe = parcelRequire("hoYXe");
const $7287efdb57b3bb52$export$6620595b7f837f8f = (version, product, logger, baseUrl)=>{
    const { getArtifact: getArtifact } = (0, $btDaU.useFlightDeckContext)();
    return (0, $5uXOq.useMemo)(()=>(0, $hoYXe.createActivityClient)(version, product, logger, baseUrl, // If the rw-client is wrapped in a FD provider, use the provided fetch function
        getArtifact ? ()=>getArtifact((0, $3LJ9C.FD_CLIENT_FETCH_PROPS).name, (0, $3LJ9C.FD_CLIENT_FETCH_PROPS).dimensions) : undefined), [
        version,
        product,
        logger,
        baseUrl,
        getArtifact
    ]);
};

});
parcelRegister("btDaU", function(module, exports) {

$parcel$export(module.exports, "FlightDeckProvider", () => $85b0ca77dee62619$export$56da85ac9d40dbcd);
$parcel$export(module.exports, "useFlightDeckContext", () => $85b0ca77dee62619$export$73c96350a5e69ec);
$parcel$export(module.exports, "useFlightDeckArtifact", () => $85b0ca77dee62619$export$3b241cde208d2c5e);

var $5uXOq = parcelRequire("5uXOq");

var $6HV40 = parcelRequire("6HV40");
const $85b0ca77dee62619$export$ca1b33377afa620 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({
    getArtifact: null
});
function $85b0ca77dee62619$export$56da85ac9d40dbcd({ children: children, product: product, config: config, fallbackArtifacts: fallbackArtifacts }) {
    const flightDeckClient = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>{
        return new (0, $6HV40.default)(product, {
            handlers: {
                captureException: config === null || config === void 0 ? void 0 : config.captureException
            }
        }, fallbackArtifacts);
    }, [
        product,
        config === null || config === void 0 ? void 0 : config.captureException,
        fallbackArtifacts
    ]);
    const getArtifact = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback(async (name, dimensions)=>{
        return flightDeckClient.fetchConfigFromFlightDeck({
            name: name,
            dimensions: dimensions
        });
    }, [
        flightDeckClient
    ]);
    const providerValue = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>({
            getArtifact: getArtifact
        }), [
        getArtifact
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($85b0ca77dee62619$export$ca1b33377afa620.Provider, {
        value: providerValue
    }, children);
}
const $85b0ca77dee62619$export$73c96350a5e69ec = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext($85b0ca77dee62619$export$ca1b33377afa620);
function $85b0ca77dee62619$export$3b241cde208d2c5e(key, dimensions) {
    const [artifact, setArtifact] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState();
    const { getArtifact: getArtifact } = $85b0ca77dee62619$export$73c96350a5e69ec();
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        if (!getArtifact) throw new Error("Flight Deck Context not provided");
        getArtifact(key, dimensions).then((resp)=>setArtifact(resp))// we don't need to do anything with the error as it is already instrumented in the flightDeckClient
        .catch();
    }, [
        dimensions,
        key,
        getArtifact,
        setArtifact
    ]);
    return artifact;
}

});

parcelRegister("3LJ9C", function(module, exports) {

$parcel$export(module.exports, "FD_CLIENT_FETCH_PROPS", () => $974e1d856d308c8e$export$c270c412a04ff3e6);
$parcel$export(module.exports, "default", () => $974e1d856d308c8e$export$2e2bcd8739ae039);

var $6HV40 = parcelRequire("6HV40");

var $4Zo3D = parcelRequire("4Zo3D");
const $974e1d856d308c8e$var$RECENT_WORK_ARTIFACT = 'recent-work-service';
const $974e1d856d308c8e$var$FD_ENVIRONMENT = 'prod';
const $974e1d856d308c8e$export$c270c412a04ff3e6 = {
    name: $974e1d856d308c8e$var$RECENT_WORK_ARTIFACT,
    dimensions: {
        environmentType: $974e1d856d308c8e$var$FD_ENVIRONMENT
    }
};
class $974e1d856d308c8e$export$2e2bcd8739ae039 {
    constructor(handlers, product, artifactFetch){
        this.fetchConfig = async ()=>{
            const artifact = await this.fetchArtifact();
            const { queryFragments: fragments, hydrators: hydrators } = artifact;
            return {
                fragments: fragments,
                hydrators: hydrators
            };
        };
        this.flightDeck = new (0, $6HV40.default)(product || 'recent-work-client', {
            handlers: handlers
        }, [
            {
                name: 'recent-work-service',
                dimensions: {
                    environmentType: $974e1d856d308c8e$var$FD_ENVIRONMENT
                },
                value: (0, $4Zo3D.default)
            }
        ]);
        this.artifactFetch = artifactFetch;
    }
    async fetchArtifact() {
        if (this.artifactFetch) return this.artifactFetch();
        return this.flightDeck.fetchConfigFromFlightDeck($974e1d856d308c8e$export$c270c412a04ff3e6, // Retries are for the background refresh, so not too aggressive
        {
            intervalsMS: [
                100,
                500
            ]
        });
    }
}

});
parcelRegister("4Zo3D", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc65f19f715aa294$export$2e2bcd8739ae039);
var $cc65f19f715aa294$export$2e2bcd8739ae039 = {
    localization: {
        eventTypes: {
            commented: {
                absolute: 'You commented on {absoluteTime}',
                relative: 'You commented {relativeTime}',
                standalone: 'You commented',
                multiAbsolute: 'Commented on {absoluteTime}',
                multiRelative: 'Commented {relativeTime}',
                multiStandalone: 'Commented'
            },
            created: {
                absolute: 'You created on {absoluteTime}',
                relative: 'You created {relativeTime}',
                standalone: 'You created',
                multiAbsolute: 'Created on {absoluteTime}',
                multiRelative: 'Created {relativeTime}',
                multiStandalone: 'Created'
            },
            edited: {
                absolute: 'You edited on {absoluteTime}',
                relative: 'You edited {relativeTime}',
                standalone: 'You edited',
                multiAbsolute: 'Edited on {absoluteTime}',
                multiRelative: 'Edited {relativeTime}',
                multiStandalone: 'Edited'
            },
            published: {
                absolute: 'You published on {absoluteTime}',
                relative: 'You published {relativeTime}',
                standalone: 'You published',
                multiAbsolute: 'Published on {absoluteTime}',
                multiRelative: 'Published {relativeTime}',
                multiStandalone: 'Published'
            },
            updated: {
                absolute: 'You updated on {absoluteTime}',
                relative: 'You updated {relativeTime}',
                standalone: 'You updated',
                multiAbsolute: 'Updated on {absoluteTime}',
                multiRelative: 'Updated {relativeTime}',
                multiStandalone: 'Updated'
            },
            viewed: {
                absolute: 'You viewed on {absoluteTime}',
                relative: 'You viewed {relativeTime}',
                standalone: 'You viewed',
                multiAbsolute: 'Viewed on {absoluteTime}',
                multiRelative: 'Viewed {relativeTime}',
                multiStandalone: 'Viewed'
            }
        }
    },
    hydrators: {
        TownsquareGoal: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                key: [
                    'key'
                ],
                name: [
                    'name'
                ],
                url: [
                    'url'
                ],
                icon: [
                    'iconData'
                ]
            }
        },
        TownsquareProject: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                key: [
                    'key'
                ],
                name: [
                    'name'
                ],
                url: [
                    'url'
                ],
                icon: [
                    'iconData'
                ]
            }
        },
        TownsquareComment: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                key: [
                    'container.key'
                ],
                name: [
                    'container.name'
                ],
                url: [
                    'container.url'
                ],
                icon: [
                    'container.iconData'
                ],
                deduplicateId: [
                    'container.id'
                ]
            }
        },
        ConfluencePage: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'title'
                ],
                localResourceId: [
                    'pageId'
                ],
                subtype: [
                    'subtype'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'space.name'
                ]
            },
            staticFallbacks: {
                icon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg',
                confluenceLiveDocIcon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/live-doc.svg'
            }
        },
        ConfluenceBlogPost: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'title'
                ],
                localResourceId: [
                    'blogPostId'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'space.name'
                ]
            },
            staticFallbacks: {
                icon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/blogpost.svg'
            }
        },
        ConfluenceComment: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'container.title'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'container.space.name'
                ],
                deduplicateId: [
                    'container.id'
                ]
            },
            staticFallbacks: {
                icon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg',
                confluenceBlogIcon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/blogpost.svg',
                confluencePageIcon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg'
            }
        },
        ConfluenceFooterComment: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'container.title'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'container.space.name'
                ],
                deduplicateId: [
                    'container.id'
                ]
            },
            staticFallbacks: {
                icon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg',
                confluenceBlogIcon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/blogpost.svg',
                confluencePageIcon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg'
            }
        },
        ConfluenceInlineComment: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'container.title'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'container.space.name'
                ],
                deduplicateId: [
                    'container.id'
                ]
            },
            staticFallbacks: {
                icon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg',
                confluenceBlogIcon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/blogpost.svg',
                confluencePageIcon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg'
            }
        },
        JiraIssue: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'fieldsById.edges(node.fieldId: "summary").node.text'
                ],
                url: [
                    'webUrl'
                ],
                containers: [
                    'fieldsById.edges(node.fieldId: "project").node.project.name'
                ],
                icon: [
                    'fieldsById.edges(node.fieldId: "issuetype").node.issueType.avatar.xsmall'
                ],
                key: [
                    'key'
                ]
            }
        },
        JiraPlatformComment: {
            hydratorPaths: {
                id: [
                    'commentId'
                ],
                name: [
                    'issue.fieldsById.edges(node.fieldId: "summary").node.text'
                ],
                url: [
                    'webUrl'
                ],
                containers: [
                    'issue.fieldsById.edges(node.fieldId: "project").node.project.name'
                ],
                icon: [
                    'issue.fieldsById.edges(node.fieldId: "issuetype").node.issueType.avatar.xsmall'
                ],
                key: [
                    'issue.key'
                ],
                deduplicateId: [
                    'issue.id'
                ]
            }
        },
        JiraServiceManagementComment: {
            hydratorPaths: {
                id: [
                    'commentId'
                ],
                name: [
                    'issue.fieldsById.edges(node.fieldId: "summary").node.text'
                ],
                url: [
                    'webUrl'
                ],
                containers: [
                    'issue.fieldsById.edges(node.fieldId: "project").node.project.name'
                ],
                icon: [
                    'issue.fieldsById.edges(node.fieldId: "issuetype").node.issueType.avatar.xsmall'
                ],
                key: [
                    'issue.key'
                ],
                deduplicateId: [
                    'issue.id'
                ]
            }
        }
    },
    queryFragments: '\n\n  fragment townsquareGoal on TownsquareGoal {\n    id\n    key\n    name\n    url\n    iconData\n  }\n\n\n  fragment townsquareProject on TownsquareProject {\n    id\n    key\n    name\n    url\n    iconData\n  }\n\n\n  fragment townsquareComment on TownsquareComment {\n    id\n    url\n    container {\n      __typename\n      ...townsquareGoal\n      ...townsquareProject\n    }\n  }\n\n\n  fragment confluencePage on ConfluencePage {\n    id\n    title\n    pageId\n    links {\n      base\n      webUi\n    }\n    space {\n      name\n    }\n  }\n\n\n  fragment confluenceBlogPost on ConfluenceBlogPost {\n    id\n    title\n    blogPostId\n    links {\n      base\n      webUi\n    }\n    space {\n      name\n    }\n  }\n\n\n  fragment confluenceComment on ConfluenceComment {\n    id\n    links {\n      base\n      webUi\n    }\n    container {\n      __typename\n      ...confluenceBlogPost\n      ...confluencePage\n    }\n  }\n\n\n  fragment confluenceFooterComment on ConfluenceFooterComment {\n    id\n    links {\n      base\n      webUi\n    }\n    container {\n      __typename\n      ...confluenceBlogPost\n      ...confluencePage\n    }\n  }\n\n\n  fragment confluenceInlineComment on ConfluenceInlineComment {\n    id\n    links {\n      base\n      webUi\n    }\n    container {\n      __typename\n      ...confluenceBlogPost\n      ...confluencePage\n    }\n  }\n\n\nfragment jiraIssue on JiraIssue {\n  id\n  key\n  webUrl\n  fieldsById(ids: ["summary", "issuetype", "project"]) {\n    edges {\n      node {\n        __typename\n        fieldId\n        ...jiraSingleLineTextField\n        ...jiraIssueTypeField\n        ...jiraProjectField\n      }\n    }\n  }\n}\nfragment jiraSingleLineTextField on JiraSingleLineTextField {\n  text\n}\nfragment jiraIssueTypeField on JiraIssueTypeField {\n  issueType {\n    avatar {\n      xsmall\n    }\n  }\n}\nfragment jiraProjectField on JiraProjectField {\n  project {\n    name\n  }\n}\n\n\nfragment jiraPlatformComment on JiraPlatformComment {\n  commentId\n  webUrl\n  issue {\n    ...jiraIssue\n  }\n}\n\n\nfragment jiraServiceManagementComment on JiraServiceManagementComment {\n  commentId\n  webUrl\n  issue {\n    ...jiraIssue\n  }\n}\n\nfragment activityItemEdge on ActivityItemEdge {\n  cursor\n  node {\n    id\n    object {\n      id\n      type\n      product\n      subProduct\n      rootContainerId\n      contributors {\n        profile {\n          name\n          picture\n          accountId\n        }\n      }\n      data {\n        __typename\n\t...townsquareGoal\n\t...townsquareProject\n\t...townsquareComment\n\t...confluencePage\n\t...confluenceBlogPost\n\t...confluenceComment\n\t...confluenceFooterComment\n\t...confluenceInlineComment\n\t...jiraIssue\n\t...jiraPlatformComment\n\t...jiraServiceManagementComment\n      }\n    }\n    event {\n      id\n      timestamp\n      eventType\n      actor {\n        name\n        picture\n        accountId\n      }\n    }\n  }\n}\nfragment activityItemConnection on ActivityConnection {\n  edges {\n    ...activityItemEdge\n  }\n}\n\n'
};

});


parcelRegister("hoYXe", function(module, exports) {

$parcel$export(module.exports, "createActivityClient", () => $30574e88272de3f4$export$224367b01f71f2aa);

var $9yZqs = parcelRequire("9yZqs");

var $7trIV = parcelRequire("7trIV");
let $30574e88272de3f4$var$previousClientVersion;
const $30574e88272de3f4$export$224367b01f71f2aa = (version, product, logger, baseUrl, configFetch)=>{
    if ($30574e88272de3f4$var$previousClientVersion && $30574e88272de3f4$var$previousClientVersion !== version && logger?.captureWarning) logger.captureWarning(`ActivityClient version has changed, is this intentional?`);
    $30574e88272de3f4$var$previousClientVersion = version || 'v3';
    if (version === 'v2') return new (0, $9yZqs.ActivityClientV2)(product, baseUrl);
    return new (0, $7trIV.ActivityClientV3)(product, baseUrl, logger, configFetch);
};

});
parcelRegister("9yZqs", function(module, exports) {

$parcel$export(module.exports, "ActivityClientV2", () => $fff1f13eb7277558$export$330ab0047f2fb745);

var $cXq43 = parcelRequire("cXq43");

var $3Bknq = parcelRequire("3Bknq");

var $gVYg8 = parcelRequire("gVYg8");
class $fff1f13eb7277558$export$330ab0047f2fb745 extends (0, $3Bknq.ActivityClient) {
    constructor(product, baseUrl){
        super('v2', product, undefined, baseUrl), this.fetchActivities = async (retryMS, filters, activityQueries)=>{
            return (0, $cXq43.fetchActivitiesWithExperience)((experience)=>(0, $gVYg8.fetchActivitiesV2)({
                    experience: experience,
                    product: this.product,
                    retryMS: retryMS,
                    filters: filters,
                    activityQueries: activityQueries,
                    baseUrl: this.baseUrl
                }), 'v2');
        }, this.setProduct = (product)=>{
            this.product = product;
        };
    }
}

});
parcelRegister("cXq43", function(module, exports) {

$parcel$export(module.exports, "fetchActivitiesWithExperience", () => $12ea6ddffbcd8f57$export$4a906f16800734f3);

var $iFmUA = parcelRequire("iFmUA");

var $1b4ym = parcelRequire("1b4ym");

var $4cDQS = parcelRequire("4cDQS");
async function $12ea6ddffbcd8f57$export$4a906f16800734f3(fetchActivities, clientVersion) {
    const experience = clientVersion === 'v2' ? (0, $4cDQS.recentWorkClientExperienceV2)() : (0, $4cDQS.recentWorkClientExperienceV3)();
    try {
        experience.start();
        experience.addMetadata({
            clientVersion: clientVersion,
            packageName: $1b4ym.packageName,
            packageVersion: $1b4ym.packageVersion
        });
        const data = await fetchActivities(experience);
        experience.success();
        return data;
    } catch (e) {
        experience.failure({
            metadata: {
                error: $12ea6ddffbcd8f57$export$f33622abb5224195(e)
            }
        });
        throw e;
    }
}
const $12ea6ddffbcd8f57$export$f33622abb5224195 = (e)=>{
    if (e instanceof (0, $iFmUA.default)) return {
        ...e,
        xRequestId: e.xRequestId ?? undefined,
        cause: undefined
    };
    return e instanceof Error ? {
        ...e,
        cause: undefined
    } : 'unknown';
};

});
parcelRegister("iFmUA", function(module, exports) {

$parcel$export(module.exports, "default", () => $0aef1aaaf8d64fa1$export$2e2bcd8739ae039);
class $0aef1aaaf8d64fa1$export$2e2bcd8739ae039 extends Error {
    constructor({ message: message, statusCode: statusCode, path: path, method: method, xRequestId: xRequestId, headers: headers }){
        super();
        this.name = 'HttpError';
        this.message = message;
        const p = path.split('?')[0];
        this.path = /^[/-a-z]+$/i.test(p) ? p : '';
        this.method = method;
        this.statusCode = statusCode;
        this.xRequestId = xRequestId;
        // @ts-ignore - Property 'entries' does not exist on type 'Headers'.
        // This was added when enrolling `@atlassian/recent-work-client` into JFE local consumption
        this.headers = Array.from(headers.entries()).map((value, key)=>`${key}:${value}`).sort().join(',');
    }
}
const $0aef1aaaf8d64fa1$export$97b788730ba59845 = (e)=>e instanceof $0aef1aaaf8d64fa1$export$2e2bcd8739ae039;

});

parcelRegister("1b4ym", function(module, exports) {

$parcel$export(module.exports, "packageName", () => $42bb1ba4b82855c2$export$9345d7360ffe0722);
$parcel$export(module.exports, "packageVersion", () => $42bb1ba4b82855c2$export$91546b032799aa40);
const $42bb1ba4b82855c2$export$9345d7360ffe0722 = "platform-pkg";
const $42bb1ba4b82855c2$export$91546b032799aa40 = "0.0.0-use.local";

});

parcelRegister("4cDQS", function(module, exports) {

$parcel$export(module.exports, "recentWorkClientExperienceV2", () => $cf5f22aa1bc15bc4$export$d7769758f5eaa63b);
$parcel$export(module.exports, "recentWorkClientExperienceV3", () => $cf5f22aa1bc15bc4$export$9e32a4ed888f4717);

var $atdLB = parcelRequire("atdLB");
var $duUGa = parcelRequire("duUGa");
const $cf5f22aa1bc15bc4$var$keyToTiming = (key)=>({
        key: key,
        startMark: `${key}_start`,
        endMark: `${key}_end`
    });
const $cf5f22aa1bc15bc4$var$timings = [
    'FetchedActivities',
    'TransformedActivityItems',
    'GeneratedQueryWithFilters'
].map($cf5f22aa1bc15bc4$var$keyToTiming);
const $cf5f22aa1bc15bc4$export$d7769758f5eaa63b = ()=>{
    return new (0, $duUGa.UFOExperience)('client', {
        type: (0, $atdLB.ExperienceTypes).Load,
        performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom,
        platform: {
            component: 'recent-work'
        },
        timings: $cf5f22aa1bc15bc4$var$timings
    });
};
const $cf5f22aa1bc15bc4$export$9e32a4ed888f4717 = ()=>new (0, $duUGa.UFOExperience)('client-v3', {
        type: (0, $atdLB.ExperienceTypes).Load,
        performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom,
        platform: {
            component: 'recent-work'
        },
        timings: $cf5f22aa1bc15bc4$var$timings
    });

});


parcelRegister("3Bknq", function(module, exports) {

$parcel$export(module.exports, "ActivityClient", () => $d3363d88c8d5ff9b$export$157740f5433f3dbe);

var $3l0ly = parcelRequire("3l0ly");
class $d3363d88c8d5ff9b$export$157740f5433f3dbe {
    constructor(clientVersion, product, headers, baseUrl){
        this.product = 'unknown';
        this.baseUrl = (0, $3l0ly.GRAPHQL_GATEWAY_PATH);
        if (product) this.product = product;
        this.clientVersion = clientVersion;
        this.headers = headers ?? {};
        if (baseUrl) this.baseUrl = baseUrl;
    }
}

});
parcelRegister("3l0ly", function(module, exports) {

$parcel$export(module.exports, "GRAPHQL_GATEWAY_PATH", () => $4167449aedd1da1b$export$851c5df667ca24c8);
$parcel$export(module.exports, "WORKED_EVENT", () => $4167449aedd1da1b$export$eb4e9f525aef1cc3);
const $4167449aedd1da1b$export$851c5df667ca24c8 = '/gateway/api/graphql';
var $4167449aedd1da1b$export$d245b105c09339d8 = /*#__PURE__*/ function(VIEWED_EVENT) {
    VIEWED_EVENT["VIEWED"] = "viewed";
    return VIEWED_EVENT;
}({});
var $4167449aedd1da1b$export$eb4e9f525aef1cc3 = /*#__PURE__*/ function(WORKED_EVENT) {
    WORKED_EVENT["COMMENTED"] = "commented";
    WORKED_EVENT["CREATED"] = "created";
    WORKED_EVENT["EDITED"] = "edited";
    WORKED_EVENT["PUBLISHED"] = "published";
    WORKED_EVENT["UPDATED"] = "updated";
    return WORKED_EVENT;
}({});
var $4167449aedd1da1b$export$d02a56686be43f69 = /*#__PURE__*/ function(ActivityObjectType) {
    ActivityObjectType["BLOGPOST"] = "BLOGPOST";
    ActivityObjectType["COMMENT"] = "COMMENT";
    ActivityObjectType["ISSUE"] = "ISSUE";
    ActivityObjectType["PAGE"] = "PAGE";
    ActivityObjectType["PROJECT"] = "PROJECT";
    ActivityObjectType["SITE"] = "SITE";
    ActivityObjectType["SPACE"] = "SPACE";
    ActivityObjectType["TASK"] = "TASK";
    return ActivityObjectType;
}({});

});


parcelRegister("gVYg8", function(module, exports) {

$parcel$export(module.exports, "fetchActivitiesV2", () => $9bc87a88656ac7d1$export$750ec7816fdd2f9e);

var $f3gfD = parcelRequire("f3gfD");

var $e35Gx = parcelRequire("e35Gx");

var $aHtVh = parcelRequire("aHtVh");

var $lB6CZ = parcelRequire("lB6CZ");
const $9bc87a88656ac7d1$var$ACTIVITIES_LIMIT = 50;
// typescript guard for validating the activities connection type
const $9bc87a88656ac7d1$var$isMyActivitiesConnection = (activities)=>{
    return activities.myActivities !== undefined;
};
const $9bc87a88656ac7d1$var$V2_AVAILABLE_PRODUCTS = [
    'teamCentral',
    'editor',
    'people',
    'jira',
    'townsquare',
    'apOnboarding',
    'worklens',
    'confluence',
    'start'
];
const $9bc87a88656ac7d1$export$750ec7816fdd2f9e = async ({ experience: experience, product: product, retryMS: retryMS, filters: filters = {}, activityQueries: activityQueries, baseUrl: baseUrl })=>{
    const { limit: // we want to default limit if not applied
    limit = $9bc87a88656ac7d1$var$ACTIVITIES_LIMIT, ...restFilters } = filters;
    experience.mark('GeneratedQueryWithFilters_start');
    const { query: query, queryFilters: queryFilters } = (0, $aHtVh.generateActivityQueryWithFilters)(product, restFilters, activityQueries);
    experience.mark('GeneratedQueryWithFilters_end');
    // This is to make v2 forwards compatible. Defaulting to start as the product
    const operationProduct = $9bc87a88656ac7d1$var$V2_AVAILABLE_PRODUCTS.includes(product) ? product : 'start';
    experience.mark('FetchedActivities_start');
    let response;
    try {
        response = await (0, $e35Gx.postResource)(baseUrl, {
            operationName: (0, $f3gfD.getOperationName)(operationProduct),
            query: query,
            variables: {
                first: limit,
                filters: queryFilters
            }
        }, retryMS);
    } catch (error) {
        if (!error || error.statusCode !== 401 && error.message !== 'The operation was aborted.') throw error;
    }
    experience.mark('FetchedActivities_end');
    let workedOn = [], viewed = [], all = [];
    if (!response || !response.data?.activities) return {
        all: all,
        workedOn: workedOn,
        viewed: viewed
    };
    experience.mark('TransformedActivityItems_start');
    if ($9bc87a88656ac7d1$var$isMyActivitiesConnection(response.data.activities)) {
        if (response.data.activities.myActivities.workedOn && activityQueries.includes('workedOn')) workedOn = (0, $lB6CZ.transformActivitiesItems)('workedOn', response.data.activities.myActivities.workedOn);
        if (response.data.activities.myActivities.viewed && activityQueries.includes('viewed')) viewed = (0, $lB6CZ.transformActivitiesItems)('viewed', response.data.activities.myActivities.viewed);
        if (response.data.activities.myActivities.all && activityQueries.includes('all')) all = (0, $lB6CZ.transformActivitiesItems)('all', response.data.activities.myActivities.all);
    } else {
        if (response.data.activities.workedOn && activityQueries.includes('workedOn')) workedOn = (0, $lB6CZ.transformActivitiesItems)('workedOn', response.data.activities.workedOn);
        if (response.data.activities.all && activityQueries.includes('all')) all = (0, $lB6CZ.transformActivitiesItems)('all', response.data.activities.all);
    }
    experience.mark('TransformedActivityItems_end');
    return {
        all: all,
        viewed: viewed,
        workedOn: workedOn
    };
};

});
parcelRegister("f3gfD", function(module, exports) {

$parcel$export(module.exports, "getOperationName", () => $461d79ecc23ca794$export$41bca9dc6871dd4e);

var $e4eHl = parcelRequire("e4eHl");
const $461d79ecc23ca794$export$ad1e21d37f385bcb = (product)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))(product);
};
const $461d79ecc23ca794$export$41bca9dc6871dd4e = (product)=>{
    return `${$461d79ecc23ca794$export$ad1e21d37f385bcb(product)}_activity_recentWorkClient`;
};

});

parcelRegister("e35Gx", function(module, exports) {

$parcel$export(module.exports, "postResource", () => $e89fe5eb68802860$export$2ff3e1f219ccfad6);
parcelRequire("6fYNv");
var $6sAya = parcelRequire("6sAya");
var $6fYNv = parcelRequire("6fYNv");

var $lP65p = parcelRequire("lP65p");

var $iFmUA = parcelRequire("iFmUA");
const $e89fe5eb68802860$var$fetchResource = async (path, method, options = {})=>{
    const url = (0, $lP65p.getFullUrl)(path);
    const response = await fetch(url, {
        credentials: 'include',
        method: method,
        ...options
    }).catch((error)=>{
        throw new (0, $6sAya.default)({
            error: error,
            path: path,
            method: method
        });
    });
    const statusCode = response.status;
    if (!response.ok) {
        statusCode;
        const text = $e89fe5eb68802860$var$scrubTimestampFromErrorBody(await response.text());
        const httpError = new (0, $iFmUA.default)({
            message: text,
            method: method,
            path: path,
            statusCode: statusCode,
            xRequestId: response.headers.get('x-request-id'),
            headers: response.headers
        });
        throw httpError;
    }
    return response;
};
const $e89fe5eb68802860$var$makeJsonRquest = async (path, method, additionalFetchOptions = {})=>{
    const response = await $e89fe5eb68802860$var$fetchResource(path, method, additionalFetchOptions);
    const text = await response.text();
    // trying to parse empty response as JSON throws an error, but endpoints can return empty response in case of success
    return text ? JSON.parse(text) : {};
};
const $e89fe5eb68802860$export$2ff3e1f219ccfad6 = async (path, data, retryMS, extraHeaders)=>(0, $6fYNv.retryOnException)(()=>$e89fe5eb68802860$var$makeJsonRquest(path, 'POST', {
            body: JSON.stringify(data),
            headers: {
                'content-type': 'application/json',
                ...extraHeaders
            }
        }), {
        intervalsMS: retryMS ?? []
    });
// to dedup sentry, scrub non-unique 'timestamp' field from the error body
function $e89fe5eb68802860$var$scrubTimestampFromErrorBody(text) {
    let json;
    try {
        json = JSON.parse(text);
    } catch (err) {
        return text;
    }
    delete json.timestamp;
    return JSON.stringify(json);
}

});
parcelRegister("lP65p", function(module, exports) {

$parcel$export(module.exports, "getFullUrl", () => $196111106f21b511$export$2414511207262909);
const $196111106f21b511$var$urlRegex = new RegExp(/^https?:\/\//);
function $196111106f21b511$export$2414511207262909(path, // Add this param so we can test this function better
hostConfig = {
    host: window.location.hostname,
    port: window.location.port
}) {
    // always return a just the URL if one is provided
    if ($196111106f21b511$var$urlRegex.test(path)) return path;
    return hostConfig.host === 'localhost' ? `http://${hostConfig.host}:${hostConfig.port}${path}` : path;
}

});


parcelRegister("aHtVh", function(module, exports) {

$parcel$export(module.exports, "generateActivityQueryWithFilters", () => $3a68129fd7fbdd1f$export$855cd08371c65b8c);

var $f3gfD = parcelRequire("f3gfD");

var $dcvAS = parcelRequire("dcvAS");
const $3a68129fd7fbdd1f$var$ACTIVITIES = `
  nodes {
    id
    timestamp
    object {
      id
      name
      cloudId
      localResourceId
      product
      type
      url
      iconUrl
      containers {
        name
      }
      contributors {
        profile {
          accountId
          name
          picture
        }
      }
      events {
        eventType
      }
      extension {
        ... on ActivitiesJiraIssue {
          issueKey
        }
      }
    }
  }
`;
const $3a68129fd7fbdd1f$var$WORKED_ON_QUERY = `
   workedOn(first: $first, filters: $filters) {
     ${$3a68129fd7fbdd1f$var$ACTIVITIES}
   }
`;
const $3a68129fd7fbdd1f$var$VIEWED__QUERY = `
   viewed(first: $first, filters: $filters) {
     ${$3a68129fd7fbdd1f$var$ACTIVITIES}
   }
`;
const $3a68129fd7fbdd1f$var$ALL__QUERY = `
    all(first: $first, filters: $filters) {
      ${$3a68129fd7fbdd1f$var$ACTIVITIES}
    }
`;
const $3a68129fd7fbdd1f$var$activityQueryMap = new Map([
    [
        'workedOn',
        $3a68129fd7fbdd1f$var$WORKED_ON_QUERY
    ],
    [
        'viewed',
        $3a68129fd7fbdd1f$var$VIEWED__QUERY
    ],
    [
        'all',
        $3a68129fd7fbdd1f$var$ALL__QUERY
    ]
]);
const $3a68129fd7fbdd1f$var$getMyActivitiesQuery = (queries)=>`
      myActivities {
        ${queries.join('\n')}
      }
`;
const $3a68129fd7fbdd1f$var$getActivitiesQuery = (product, content)=>`
    query ${(0, $f3gfD.getOperationName)(product)}($first: Int, $filters: [ActivitiesFilter!]) {
      activities {
        ${content}
      }
    }
`;
const $3a68129fd7fbdd1f$export$855cd08371c65b8c = (product, filters, activityQueries)=>{
    /**
	 * If we are filtering by `accountIds` then we can't use the `myActivity` query.
	 */ if (Array.isArray(filters.actors)) {
        // you can't view `viewed` events for other accounts
        const filteredAccountQueries = activityQueries.filter((query)=>query !== 'viewed');
        return {
            query: $3a68129fd7fbdd1f$var$getActivitiesQuery(product, filteredAccountQueries.map((query)=>$3a68129fd7fbdd1f$var$activityQueryMap.get(query)).join('\n')),
            queryFilters: (0, $dcvAS.ACTIVITY_FILTER_COLLECTION).v2.get('activities')(filters)
        };
    } else return {
        query: $3a68129fd7fbdd1f$var$getActivitiesQuery(product, $3a68129fd7fbdd1f$var$getMyActivitiesQuery(activityQueries.map((query)=>$3a68129fd7fbdd1f$var$activityQueryMap.get(query)))),
        queryFilters: (0, $dcvAS.ACTIVITY_FILTER_COLLECTION).v2.get('myActivity')(filters)
    };
};

});
parcelRegister("dcvAS", function(module, exports) {

$parcel$export(module.exports, "ACTIVITY_FILTER_COLLECTION", () => $1d4997441d4b8586$export$5201d39848130041);

var $1THyP = parcelRequire("1THyP");

var $62oeH = parcelRequire("62oeH");
const $1d4997441d4b8586$export$5201d39848130041 = {
    v2: (0, $1THyP.ACTIVITY_FILTER_V2_MAP),
    v3: (0, $62oeH.ACTIVITY_FILTER_V3_MAP)
};

});
parcelRegister("1THyP", function(module, exports) {

$parcel$export(module.exports, "ACTIVITY_FILTER_V2_MAP", () => $a1a68e27645236e3$export$1dca7bc1ec360897);

var $4hkqF = parcelRequire("4hkqF");

var $afWIG = parcelRequire("afWIG");
const $a1a68e27645236e3$export$1dca7bc1ec360897 = new Map([
    [
        'myActivity',
        (0, $afWIG.default)
    ],
    [
        'activities',
        (0, $4hkqF.default)
    ]
]);

});
parcelRegister("4hkqF", function(module, exports) {

$parcel$export(module.exports, "default", () => $46c6a95053cc1f7b$export$2e2bcd8739ae039);

var $74JGD = parcelRequire("74JGD");
/**
 * This is the query builder for the v2 - activities API
 *
 * @param filters
 */ const $46c6a95053cc1f7b$var$generateV2ActivitiesFilters = (filters = {})=>{
    const { limit: // discard as these aren't supported by this query
    limit, // TODO: Enable the below code as we support multi-user queries and enable them in the main ActivityFilters interface
    // actors,
    // rootContainerIds,
    ...restFilters } = filters;
    return (0, $74JGD.generateActivityFiltersV2)(restFilters);
};
var $46c6a95053cc1f7b$export$2e2bcd8739ae039 = $46c6a95053cc1f7b$var$generateV2ActivitiesFilters;

});
parcelRegister("74JGD", function(module, exports) {

$parcel$export(module.exports, "generateActivityFiltersV2", () => $683b63762cac319c$export$ebef9c1f1e15c057);

var $MQuHl = parcelRequire("MQuHl");
// in V2 API the values for certain filters should be in UPPERCASE as are ENUMs in the GraphQL
// likewise for the V3 handler we should ensure we do appropriate lowercase conversion
const $683b63762cac319c$var$FILTERS_TO_TRANSFORM__UPPERCASE = [
    'products',
    'eventTypes',
    'objectTypes'
];
const $683b63762cac319c$var$KEYS_TO_TRANSFROM = new Map([
    [
        'actors',
        'accountIds'
    ]
]);
const $683b63762cac319c$export$ebef9c1f1e15c057 = (filters = {})=>(0, $MQuHl.generateActivityFilters)(filters, (originalkey, originalFilter)=>{
        const filter = Array.isArray(originalFilter) && $683b63762cac319c$var$FILTERS_TO_TRANSFORM__UPPERCASE.includes(originalkey) ? originalFilter.map((f)=>f.toUpperCase()) : originalFilter;
        const key = $683b63762cac319c$var$KEYS_TO_TRANSFROM.has(originalkey) ? $683b63762cac319c$var$KEYS_TO_TRANSFROM.get(originalkey) : originalkey;
        return {
            [key]: filter
        };
    });

});
parcelRegister("MQuHl", function(module, exports) {

$parcel$export(module.exports, "generateActivityFilters", () => $0ef7a6884f8128bf$export$23c75313f46dd54e);
const $0ef7a6884f8128bf$export$23c75313f46dd54e = (filters = {}, transform, rootLevelFilters)=>{
    return Object.entries(filters).reduce((acc, [key, filter])=>{
        const entry = transform ? transform(key, filter) : {
            [key]: filter
        };
        return rootLevelFilters?.includes(key) ? {
            ...acc,
            ...entry
        } : {
            ...acc,
            arguments: {
                ...acc.arguments,
                ...entry
            }
        };
    }, {
        type: 'AND',
        arguments: {}
    });
};

});



parcelRegister("afWIG", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3c453a00bc0f6ca$export$2e2bcd8739ae039);

var $74JGD = parcelRequire("74JGD");
/**
 * This is the query builder for the v2 - myActivity API
 *
 * @param filters
 */ const $b3c453a00bc0f6ca$var$generateV2MyActivityFilters = (filters = {})=>{
    const { limit: // discard as these aren't supported by this query
    limit, actors: actors, // TODO: Enable the below code as we support multi-user queries and enable them in the main ActivityFilters interface
    // actors,
    // rootContainerIds,
    ...restFilters } = filters;
    return (0, $74JGD.generateActivityFiltersV2)(restFilters);
};
var $b3c453a00bc0f6ca$export$2e2bcd8739ae039 = $b3c453a00bc0f6ca$var$generateV2MyActivityFilters;

});


parcelRegister("62oeH", function(module, exports) {

$parcel$export(module.exports, "ACTIVITY_FILTER_V3_MAP", () => $a356d323f8207676$export$9a1782843b6e99d2);

var $hU3MB = parcelRequire("hU3MB");

var $gQxYK = parcelRequire("gQxYK");
const $a356d323f8207676$export$9a1782843b6e99d2 = new Map([
    [
        'myActivity',
        (0, $gQxYK.default)
    ],
    [
        'activities',
        (0, $hU3MB.default)
    ]
]);

});
parcelRegister("hU3MB", function(module, exports) {

$parcel$export(module.exports, "default", () => $84a6b56b296ed055$export$2e2bcd8739ae039);

var $glhs7 = parcelRequire("glhs7");
/**
 * This is the query builder for the v3 - activities API
 *
 * @param filters
 */ const $84a6b56b296ed055$var$generateV3ActivityFilters = (filters = {})=>{
    const { limit: // discard as these aren't supported by this query
    limit, ...restFilters } = filters;
    return (0, $glhs7.generateActivityFiltersV3)(restFilters);
};
var $84a6b56b296ed055$export$2e2bcd8739ae039 = $84a6b56b296ed055$var$generateV3ActivityFilters;

});
parcelRegister("glhs7", function(module, exports) {

$parcel$export(module.exports, "generateActivityFiltersV3", () => $3cb34394a8624fd6$export$e73fe7ded3fe2664);

var $MQuHl = parcelRequire("MQuHl");
// in V2 API the values for certain filters should be in UPPERCASE as are ENUMs in the GraphQL
// likewise for the V3 handler we should ensure we do appropriate lowercase conversion
const $3cb34394a8624fd6$var$FILTERS_TO_TRANSFORM__LOWERCASE = [
    'products',
    'eventTypes',
    'objectTypes'
];
const $3cb34394a8624fd6$var$ROOT_LEVEL_FILTERS = [
    'actors',
    'rootContainerIds'
];
const $3cb34394a8624fd6$export$e73fe7ded3fe2664 = (filters = {})=>(0, $MQuHl.generateActivityFilters)(filters, (key, filter)=>Array.isArray(filter) && $3cb34394a8624fd6$var$FILTERS_TO_TRANSFORM__LOWERCASE.includes(key) ? {
            [key]: filter.map((f)=>f.toLowerCase())
        } : {
            [key]: filter
        }, $3cb34394a8624fd6$var$ROOT_LEVEL_FILTERS);

});


parcelRegister("gQxYK", function(module, exports) {

$parcel$export(module.exports, "default", () => $840ac7ca8bd740a4$export$2e2bcd8739ae039);

var $glhs7 = parcelRequire("glhs7");
/**
 * This is the query builder for the v3 - myActivity API
 *
 * @param filters
 */ const $840ac7ca8bd740a4$var$generateV3MyActivityFilters = (filters = {})=>{
    const { limit: // discard as these aren't supported by this query
    limit, actors: actors, ...restFilters } = filters;
    return (0, $glhs7.generateActivityFiltersV3)(restFilters);
};
var $840ac7ca8bd740a4$export$2e2bcd8739ae039 = $840ac7ca8bd740a4$var$generateV3MyActivityFilters;

});




parcelRegister("lB6CZ", function(module, exports) {

$parcel$export(module.exports, "transformActivitiesItems", () => $ccb3637438790056$export$306a8b649360ca6f);
const $ccb3637438790056$var$SITE_ARI_PREFIX = 'ari:cloud:platform::site/';
function $ccb3637438790056$export$306a8b649360ca6f(query, activities = {}) {
    if (!activities || !activities.nodes) return [];
    return activities.nodes.map((item)=>{
        const { object: object, timestamp: timestamp } = item;
        const { cloudId: cloudId, events: events, extension: extension, iconUrl: iconUrl, id: id, localResourceId: localResourceId, name: name, product: product, url: url, type: type } = object;
        // V2 returns eventType captilised, V3 returns lowercase
        const eventType = events[0].eventType.toLowerCase();
        const issueKey = extension && extension.issueKey;
        let containers = [];
        if (issueKey) containers.push({
            name: issueKey
        });
        if (Array.isArray(object.containers)) containers = containers.concat(object.containers);
        containers = containers.filter((container)=>!!container.name);
        return {
            query: query,
            containers: containers,
            contributors: (object.contributors || []).reduce((contributors, contributor)=>{
                if (contributor.profile) {
                    const { accountId: accountId, picture: picture } = contributor.profile;
                    contributors.push({
                        accountId: accountId,
                        name: contributor.profile.name,
                        picture: picture
                    });
                }
                return contributors;
            }, []),
            eventType: eventType,
            object: {
                rootContainerIdentifier: {
                    id: cloudId,
                    type: 'SITE',
                    ari: `${$ccb3637438790056$var$SITE_ARI_PREFIX}${cloudId}`
                },
                deduplicateId: id,
                icon: {
                    type: 'URL',
                    value: iconUrl
                },
                id: id,
                localResourceId: localResourceId,
                name: name,
                product: product,
                subProduct: null,
                type: type,
                url: url
            },
            timestamp: timestamp
        };
    });
}

});



parcelRegister("7trIV", function(module, exports) {

$parcel$export(module.exports, "ActivityClientV3", () => $36bf5d2659940c95$export$3c3c237c92ca1fb9);

var $6fYNv = parcelRequire("6fYNv");

var $VSDnB = parcelRequire("VSDnB");

var $3l0ly = parcelRequire("3l0ly");

var $1b4ym = parcelRequire("1b4ym");

var $cXq43 = parcelRequire("cXq43");

var $e35Gx = parcelRequire("e35Gx");

var $dMJiM = parcelRequire("dMJiM");

var $4HxlV = parcelRequire("4HxlV");

var $fTeQf = parcelRequire("fTeQf");

var $jkCM1 = parcelRequire("jkCM1");

var $65vGW = parcelRequire("65vGW");

var $3LJ9C = parcelRequire("3LJ9C");

var $3Bknq = parcelRequire("3Bknq");

var $55Gxu = parcelRequire("55Gxu");

var $66K4V = parcelRequire("66K4V");

var $hTLIi = parcelRequire("hTLIi");
const $36bf5d2659940c95$var$CONFLUENCE_COMMENT_TYPENAMES = [
    'ConfluenceComment',
    'ConfluenceFooterComment',
    'ConfluenceInlineComment'
];
const $36bf5d2659940c95$var$IGNORED_HTTP_ERRORS = new Map([
    // ignore all 401 errors
    [
        401,
        [
            /.*/
        ]
    ],
    [
        403,
        [
            /Invalid CORS request/
        ]
    ]
]);
const $36bf5d2659940c95$var$IGNORED_ERROR_MESSAGES = [
    'The operation was aborted.'
];
const $36bf5d2659940c95$var$DEFAULT_TAGS = {
    source: (0, $1b4ym.packageName),
    sourcePackageVersion: (0, $1b4ym.packageVersion)
};
class $36bf5d2659940c95$export$3c3c237c92ca1fb9 extends (0, $3Bknq.ActivityClient) {
    constructor(product, baseUrl, logger, configFetch){
        super('v3', product, {
            'X-ExperimentalApi': 'ActivityV3Api'
        }, baseUrl), this.setProduct = (product)=>{
            this.product = product;
        }, this.captureException = (error, tags)=>{
            if (this.clientHandlers) this.clientHandlers.captureException(error, {
                ...$36bf5d2659940c95$var$DEFAULT_TAGS,
                ...tags
            });
        }, this.captureWarning = (message, tags)=>{
            if (this.clientHandlers) this.clientHandlers.captureWarning(message, {
                ...$36bf5d2659940c95$var$DEFAULT_TAGS,
                ...tags
            });
        }, this.fetchHydratorConfig = async ()=>await this.hydratorConfigClient.fetchConfig(), this.handleGraphQLErrors = (errors)=>{
            const invalidFragments = [];
            if (Array.isArray(errors)) {
                for (const err of errors){
                    this.captureException(new (0, $4HxlV.GraphQLJSError)(err));
                    const invalidFragment = (0, $55Gxu.default)(err);
                    if (invalidFragment) invalidFragments.push(invalidFragment);
                }
                return invalidFragments;
            }
            return [];
        }, this.fetchActivitiesV3 = async (experience, retryMS, filters, activityQueries, deduplicateActivities = true)=>{
            let { fragments: fragments, hydrators: hydrators } = await this.fetchHydratorConfig();
            experience.mark('GeneratedQueryWithFilters_start');
            let response;
            try {
                response = await (0, $6fYNv.retryOnException)(async ()=>{
                    const request = (0, $66K4V.generateGraphQLRequest)(this.product, filters, activityQueries, fragments);
                    experience.mark('GeneratedQueryWithFilters_end');
                    experience.mark('FetchedActivities_start');
                    experience.addMetadata({
                        filters: (0, $hTLIi.filtersToMetadata)(filters)
                    });
                    const res = await (0, $e35Gx.postResource)(this.baseUrl, request, retryMS, {
                        ...this.headers
                    });
                    experience.mark('FetchedActivities_end');
                    const invalidFragments = this.handleGraphQLErrors(res?.errors);
                    if (invalidFragments.length > 0) {
                        fragments = (0, $hTLIi.filterInvalidFragments)(invalidFragments, fragments);
                        throw new (0, $dMJiM.GraphQLFragmentError)(`Missing fragments: [${invalidFragments.toString()}]`);
                    }
                    return res;
                }, {
                    intervalsMS: [
                        0,
                        0,
                        0
                    ],
                    retryOn: (err)=>[
                            (0, $dMJiM.GraphQLFragmentError)
                        ].some((retriableErr)=>err instanceof retriableErr),
                    captureException: this.captureException
                });
            } catch (error) {
                if (!error || !$36bf5d2659940c95$var$IGNORED_HTTP_ERRORS.get(error.statusCode)?.some((regExp)=>regExp.test(error.message)) && !$36bf5d2659940c95$var$IGNORED_ERROR_MESSAGES.includes(error.message)) throw error;
            }
            if ((0, $hTLIi.isEmptyActivitiesWithErrorsResponse)(response)) throw new (0, $fTeQf.GraphQLNoResultsError)(response.errors);
            if (!response || !response.data?.activity) return {
                workedOn: [],
                viewed: [],
                all: []
            };
            experience.mark('TransformedActivityItems_start');
            const workedOn = $36bf5d2659940c95$var$transformActivityItem('workedOn', (0, $hTLIi.activityRoot)(response.data.activity)?.workedOn?.edges || [], hydrators, this.captureException);
            // We don't need the activity root function here as viewed only exists on myActivity
            const viewed = $36bf5d2659940c95$var$transformActivityItem('viewed', response.data.activity?.myActivity?.viewed?.edges || [], hydrators, this.captureException);
            const all = $36bf5d2659940c95$var$transformActivityItem('all', (0, $hTLIi.activityRoot)(response.data.activity)?.all?.edges || [], hydrators, this.captureException);
            experience.mark('TransformedActivityItems_end');
            const activities = {
                viewed: viewed,
                workedOn: workedOn,
                all: all
            };
            return deduplicateActivities ? (0, $hTLIi.rollupActivitiesData)(activities) : activities;
        }, this.fetchActivities = async (retryMS, filters, activityQueries, deduplicateActivities = true)=>{
            return (0, $cXq43.fetchActivitiesWithExperience)((experience)=>this.fetchActivitiesV3(experience, retryMS, filters, activityQueries, deduplicateActivities), 'v3');
        };
        this.clientHandlers = logger;
        this.hydratorConfigClient = new (0, $3LJ9C.default)({
            captureException: this.captureException,
            captureWarning: this.captureWarning
        }, product, configFetch);
    }
}
const $36bf5d2659940c95$var$setIconHydration = (object, hydratedData)=>{
    const isLiveDoc = object.data.__typename === 'ConfluencePage' && (0, $65vGW.hydratedValueToString)(hydratedData.subtype) === 'LIVE';
    if (isLiveDoc && (0, $VSDnB.fg)('platform_support_live_doc_icons_in_link_picker')) return (0, $65vGW.hydrateIcon)(hydratedData.icon, hydratedData.staticFallbacks, 'confluenceLiveDocIcon');
    return $36bf5d2659940c95$var$CONFLUENCE_COMMENT_TYPENAMES.includes(object.data.__typename) ? (0, $65vGW.hydrateConfluenceIcon)(object.data?.container?.__typename || object.data.__typename, hydratedData.icon, hydratedData.staticFallbacks) : (0, $65vGW.hydrateIcon)(hydratedData.icon, hydratedData.staticFallbacks);
};
function $36bf5d2659940c95$var$transformActivityItem(query, activities, hydrators, captureException) {
    return activities.reduce((acc, item)=>{
        if (item && item.node && item.node.object && item.node.event) {
            const { object: object, event: event } = item.node;
            if (!object.product || !object.type) return acc;
            const containers = [];
            let c = object.contributors || [];
            const contributors = c.reduce((contributors, contributor)=>{
                if (contributor.profile) {
                    const { accountId: accountId, picture: picture } = contributor.profile;
                    contributors.push({
                        accountId: accountId,
                        name: contributor.profile.name,
                        picture: picture
                    });
                }
                return contributors;
            }, []);
            const hydratedData = (0, $jkCM1.hydratePolymorphicData)(hydrators, object.data, captureException);
            if (hydratedData) {
                if (hydratedData.key) containers.push({
                    name: (0, $65vGW.hydratedValueToString)(hydratedData.key, ' ')
                });
                if (hydratedData.containers) containers.push({
                    name: (0, $65vGW.hydratedValueToString)(hydratedData.containers, ' ')
                });
                const actor = event.actor ? {
                    name: event.actor.name,
                    picture: event.actor.picture,
                    accountId: event.actor.accountId
                } : undefined;
                // The V3 API returns "Created" for a new comment, we want this to display as "Commented"
                const eventType = object.type === 'comment' && event.eventType === (0, $3l0ly.WORKED_EVENT).CREATED ? (0, $3l0ly.WORKED_EVENT).COMMENTED : event.eventType;
                acc.push({
                    actor: actor,
                    query: query,
                    containers: containers,
                    contributors: contributors,
                    eventType: eventType,
                    object: {
                        rootContainerIdentifier: (0, $hTLIi.parseRootContainerARI)(object.rootContainerId),
                        icon: $36bf5d2659940c95$var$setIconHydration(object, hydratedData),
                        id: object.id,
                        deduplicateId: (0, $65vGW.hydratedValueToString)(hydratedData.deduplicateId) || object.id,
                        localResourceId: (0, $65vGW.hydratedValueToString)(hydratedData.localResourceId),
                        name: (0, $65vGW.hydratedValueToString)(hydratedData.name, ' '),
                        product: object.product,
                        subProduct: object.subProduct,
                        type: object.type,
                        subtype: object.data.subtype,
                        url: (0, $65vGW.hydratedValueToString)(hydratedData.url),
                        objectTypeName: (0, $65vGW.hydratedValueToString)(hydratedData.objectTypeName)
                    },
                    timestamp: event.timestamp
                });
            }
        }
        return acc;
    }, []);
}

});
parcelRegister("dMJiM", function(module, exports) {

$parcel$export(module.exports, "GraphQLFragmentError", () => $37a211a3da9949b9$export$2d1b192199788179);
class $37a211a3da9949b9$export$2d1b192199788179 extends Error {
    constructor(message){
        super(message);
        this.name = 'GraphQLFragmentError';
        this.message = message;
    }
}

});

parcelRegister("4HxlV", function(module, exports) {

$parcel$export(module.exports, "GraphQLJSError", () => $098e0a3de69a420c$export$8d4af49ee2a0fbe2);
class $098e0a3de69a420c$export$8d4af49ee2a0fbe2 extends Error {
    constructor(graphQLError){
        super(graphQLError.message);
        this.name = 'GraphQLJSError';
        this.error = graphQLError;
        this.message = graphQLError.message;
    }
}

});

parcelRegister("fTeQf", function(module, exports) {

$parcel$export(module.exports, "GraphQLNoResultsError", () => $9ec383f2a327fd66$export$3f19ff30d409b70);
class $9ec383f2a327fd66$export$3f19ff30d409b70 extends Error {
    constructor(graphQLErrors){
        super();
        this.name = 'GraphQLNoResultsError';
        this.errors = graphQLErrors;
        this.message = 'GraphQL returned errors & no results';
        this.errorMessages = graphQLErrors.map((error)=>error.message);
    }
}

});

parcelRegister("jkCM1", function(module, exports) {

$parcel$export(module.exports, "hydratePolymorphicData", () => $d64b966f022ff0ad$export$d658049bf1a63492);

var $9XE6b = parcelRequire("9XE6b");

var $9cIED = parcelRequire("9cIED");
const $d64b966f022ff0ad$export$d658049bf1a63492 = (hydrators, data, captureException)=>{
    if (data) {
        if ('__typename' in data) {
            const hydrator = hydrators[data.__typename];
            if (hydrator) try {
                return $d64b966f022ff0ad$var$hydrateData(data, hydrator);
            } catch (error) {
                captureException && captureException(new (0, $9cIED.default)({
                    error: error,
                    message: `Hydrator failed for [${data.__typename}].`
                }));
            }
            else captureException && captureException(new (0, $9cIED.default)({
                message: `Missing hydrator for [${data.__typename}].`
            }));
        } else captureException && captureException(new (0, $9cIED.default)({
            message: `Missing [__typename] field from data.`
        }));
    }
    return null;
};
function $d64b966f022ff0ad$var$getOrSearch(object, path) {
    if (!object) return object;
    if (path.includes(':')) {
        const [searchField, searchValue] = path.split(':');
        return $d64b966f022ff0ad$var$findNodeByField(object, searchField.trim(), searchValue.trim().replace(/"/g, ''));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(object, path);
}
function $d64b966f022ff0ad$var$resolvePath(object, path) {
    // Split the path on each bracket
    const splitPath = path.split(/\(|\)./);
    // Traverse the split path as a tree, resolving as we go
    let current = object;
    for (const split of splitPath)current = $d64b966f022ff0ad$var$getOrSearch(current, split);
    return current;
}
function $d64b966f022ff0ad$var$findNodeByField(edges, fieldId, searchValue) {
    return edges.find((edge)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(edge, fieldId) === searchValue);
}
function $d64b966f022ff0ad$export$a5c4301012ad6f07(object, paths) {
    return paths.map((path)=>$d64b966f022ff0ad$var$resolvePath(object, path));
}
const $d64b966f022ff0ad$var$hydrateData = (data, hydrator)=>{
    const { hydratorPaths: hydratorPaths, staticFallbacks: staticFallbacks } = hydrator;
    return {
        staticFallbacks: staticFallbacks,
        ...Object.entries(hydratorPaths).reduce((acc, [key, dataValue])=>{
            const item = $d64b966f022ff0ad$export$a5c4301012ad6f07(data, dataValue);
            if (item) acc[key] = item;
            else throw new Error(`Bad hydrator path: ${key}`);
            return acc;
        }, {})
    };
};

});
parcelRegister("9cIED", function(module, exports) {

$parcel$export(module.exports, "default", () => $5eebec53575108e7$export$2e2bcd8739ae039);
class $5eebec53575108e7$export$2e2bcd8739ae039 extends Error {
    constructor({ error: error, message: message }){
        super();
        const err = error instanceof Error ? error : new Error();
        this.name = 'HydratorError';
        this.message = message;
        this.originalMessage = err.message;
        this.stack = err.stack;
        this.originalName = err.name;
    }
}

});


parcelRegister("65vGW", function(module, exports) {

$parcel$export(module.exports, "hydratedValueToString", () => $e885246460d7ca94$export$c5cea44a1f75b431);
$parcel$export(module.exports, "hydrateConfluenceIcon", () => $e885246460d7ca94$export$86b9f44277b105a6);
$parcel$export(module.exports, "hydrateIcon", () => $e885246460d7ca94$export$a328b2bb0d21d984);
const $e885246460d7ca94$export$c5cea44a1f75b431 = (value, separator = '')=>{
    if (!value) return null;
    return Array.isArray(value) ? value.join(separator) : value;
};
function $e885246460d7ca94$var$isURL(icon) {
    return typeof icon === 'string';
}
function $e885246460d7ca94$var$isValidEmoji(icon) {
    return typeof icon === 'object' && icon.value !== undefined && !!icon.value;
}
const $e885246460d7ca94$export$86b9f44277b105a6 = (confluenceContainerType, icons, fallbacks)=>{
    switch(confluenceContainerType){
        case 'ConfluenceBlogPost':
            return $e885246460d7ca94$export$a328b2bb0d21d984(icons, fallbacks, 'confluenceBlogIcon') || $e885246460d7ca94$export$a328b2bb0d21d984(icons, fallbacks);
        case 'ConfluencePage':
            return $e885246460d7ca94$export$a328b2bb0d21d984(icons, fallbacks, 'confluencePageIcon') || $e885246460d7ca94$export$a328b2bb0d21d984(icons, fallbacks);
        default:
            return $e885246460d7ca94$export$a328b2bb0d21d984(icons, fallbacks);
    }
};
const $e885246460d7ca94$export$a328b2bb0d21d984 = (icons, fallbacks, fallbackKey = 'icon')=>{
    if (Array.isArray(icons) && icons.length > 0) {
        const emojiIcons = icons.filter($e885246460d7ca94$var$isValidEmoji);
        if (emojiIcons.length > 0) return {
            type: 'EMOJI',
            value: emojiIcons[0].value,
            fallback: fallbacks?.[fallbackKey]
        };
        const urlIcons = icons.filter($e885246460d7ca94$var$isURL);
        if (urlIcons.length > 0) {
            const hydratedIcons = $e885246460d7ca94$export$c5cea44a1f75b431(urlIcons);
            if (hydratedIcons !== null) return {
                type: 'URL',
                value: hydratedIcons
            };
        }
    }
    if (fallbacks && fallbackKey in fallbacks && fallbacks[fallbackKey]) return {
        type: 'URL',
        value: fallbacks[fallbackKey]
    };
    return null;
};

});

parcelRegister("55Gxu", function(module, exports) {

$parcel$export(module.exports, "default", () => $33cd97b94b378eac$export$2e2bcd8739ae039);

var $fQ0JV = parcelRequire("fQ0JV");
const $33cd97b94b378eac$var$errorHandlerMap = new Map([
    [
        'ValidationError',
        (0, $fQ0JV.default)
    ]
]);
const $33cd97b94b378eac$var$graphQLErrorHandler = (err)=>{
    const errorHandler = $33cd97b94b378eac$var$errorHandlerMap.get(err.extensions.classification);
    if (typeof errorHandler === 'function') return errorHandler(err);
    return null;
};
var $33cd97b94b378eac$export$2e2bcd8739ae039 = $33cd97b94b378eac$var$graphQLErrorHandler;

});
parcelRegister("fQ0JV", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc94d91a337842e7$export$2e2bcd8739ae039);
/**
 * ^Validation error - look for validation errors from the start
 * .*?@ ' - look through everything up to the first instance of "@ '"
 * (\w+) - capture the first word, that's our invalid fragment
 */ const $cc94d91a337842e7$var$captureRegex = new RegExp(/^Validation error.*?@ '(\w+)/);
const $cc94d91a337842e7$var$validationErrorHandler = (graphQLError)=>{
    const invalidFragmentMatch = $cc94d91a337842e7$var$captureRegex.exec(graphQLError.message);
    if (Array.isArray(invalidFragmentMatch)) {
        const invalidFragment = invalidFragmentMatch[1];
        if (invalidFragment) return invalidFragment;
    }
    return null;
};
var $cc94d91a337842e7$export$2e2bcd8739ae039 = $cc94d91a337842e7$var$validationErrorHandler;

});


parcelRegister("66K4V", function(module, exports) {

$parcel$export(module.exports, "generateGraphQLRequest", () => $cf1fca899d4c9068$export$7489a6ef09862e48);

var $f3gfD = parcelRequire("f3gfD");

var $dcvAS = parcelRequire("dcvAS");
const $cf1fca899d4c9068$var$ACTIVITIES_LIMIT = 50;
const $cf1fca899d4c9068$var$WORKED_ON_QUERY = `
   workedOn(first: $first, filter: $filter) {
     ...activityItemConnection
   }
`;
const $cf1fca899d4c9068$var$VIEWED__QUERY = `
   viewed(first: $first, filter: $filter) {
     ...activityItemConnection
   }
`;
const $cf1fca899d4c9068$var$ALL__QUERY = `
    all(first: $first, filter: $filter) {
      ...activityItemConnection
    }
`;
const $cf1fca899d4c9068$var$activityQueryMap = new Map([
    [
        'workedOn',
        $cf1fca899d4c9068$var$WORKED_ON_QUERY
    ],
    [
        'viewed',
        $cf1fca899d4c9068$var$VIEWED__QUERY
    ],
    [
        'all',
        $cf1fca899d4c9068$var$ALL__QUERY
    ]
]);
const $cf1fca899d4c9068$var$getMyActivitiesQuery = (queries)=>`
      myActivity {
        ${queries.join('\n')}
      }
`;
const $cf1fca899d4c9068$var$getActivitiesQuery = (product, content, fragments, activityFilterType = 'ActivityFilter')=>`
    query ${(0, $f3gfD.getOperationName)(product)}($first: Int, $filter: ${activityFilterType}) {
      activity {
        ${content}
      }
    }
${fragments}
`;
const $cf1fca899d4c9068$export$855cd08371c65b8c = (product, filters, activityQueries, fragments)=>{
    /**
	 * If we are filtering by `actors` then we can't use the `myActivity` query.
	 */ if (Array.isArray(filters.actors)) {
        // you can't view `viewed` events for other accounts
        const filteredAccountQueries = activityQueries.filter((query)=>query !== 'viewed');
        return {
            query: $cf1fca899d4c9068$var$getActivitiesQuery(product, filteredAccountQueries.map((query)=>$cf1fca899d4c9068$var$activityQueryMap.get(query)).join('\n'), fragments, 'ActivityFilter'),
            queryFilters: (0, $dcvAS.ACTIVITY_FILTER_COLLECTION).v3.get('activities')(filters)
        };
    } else return {
        query: $cf1fca899d4c9068$var$getActivitiesQuery(product, $cf1fca899d4c9068$var$getMyActivitiesQuery(activityQueries.map((query)=>$cf1fca899d4c9068$var$activityQueryMap.get(query))), fragments, 'MyActivityFilter'),
        queryFilters: (0, $dcvAS.ACTIVITY_FILTER_COLLECTION).v3.get('myActivity')(filters)
    };
};
const $cf1fca899d4c9068$export$7489a6ef09862e48 = (product, filters, activityQueries, fragments)=>{
    const { limit: // we want to default limit if not applied
    limit = $cf1fca899d4c9068$var$ACTIVITIES_LIMIT, ...restFilters } = filters;
    const { query: query, queryFilters: queryFilters } = $cf1fca899d4c9068$export$855cd08371c65b8c(product, restFilters, activityQueries, fragments);
    return {
        operationName: (0, $f3gfD.getOperationName)(product),
        query: query,
        variables: {
            first: limit,
            filter: queryFilters
        }
    };
};

});

parcelRegister("hTLIi", function(module, exports) {

$parcel$export(module.exports, "rollupActivitiesData", () => $56093000e314999c$export$750d93207e30f59a);
$parcel$export(module.exports, "activityRoot", () => $56093000e314999c$export$ea55e8e0446efa94);
$parcel$export(module.exports, "parseRootContainerARI", () => $56093000e314999c$export$788e6013936a6bb4);
$parcel$export(module.exports, "filtersToMetadata", () => $56093000e314999c$export$e8f56bed6776c7ea);
$parcel$export(module.exports, "filterInvalidFragments", () => $56093000e314999c$export$e22863ec502608d2);
$parcel$export(module.exports, "isEmptyActivitiesWithErrorsResponse", () => $56093000e314999c$export$c939d6148e47244a);
function $56093000e314999c$export$750d93207e30f59a(activitiesData) {
    const { all: all, viewed: viewed, workedOn: workedOn } = activitiesData;
    return {
        all: $56093000e314999c$var$rollUpActivityItems(all),
        viewed: $56093000e314999c$var$rollUpActivityItems(viewed),
        workedOn: $56093000e314999c$var$rollUpActivityItems(workedOn)
    };
}
function $56093000e314999c$var$rollUpActivityItems(activityItems) {
    // https://stackoverflow.com/a/49460534
    // creates an ordered 'hashmap' containing unique ids in the same order that the activity items appear
    const latestActivityItemsObjectWithLatestTimestamp = activityItems.reduce((acc, activityItem)=>{
        const deduplicateId = activityItem.object.deduplicateId || activityItem.object.id;
        const existingItem = acc[deduplicateId];
        if (existingItem) {
            const aggregatedItems = existingItem.aggregatedActivityItems || [];
            if (Date.parse(existingItem.timestamp) < Date.parse(activityItem.timestamp)) {
                activityItem.aggregatedActivityItems = [
                    ...aggregatedItems,
                    existingItem
                ];
                // remove the current activity for that id so when we add the more recent activity it is in the order that it appears
                delete acc[deduplicateId];
                acc[deduplicateId] = activityItem;
            } else acc[deduplicateId].aggregatedActivityItems = [
                ...aggregatedItems,
                activityItem
            ];
        } else acc[deduplicateId] = activityItem;
        return acc;
    }, {});
    return Object.values(latestActivityItemsObjectWithLatestTimestamp);
}
const $56093000e314999c$export$213ba2e9f2d143b9 = (key)=>{
    return new RegExp(`fragment ${$56093000e314999c$var$fragmentName(key)} on ${$56093000e314999c$var$fragmentType(key)} ({(.|\\n)+?(?=fragment))`, 'gm');
};
const $56093000e314999c$var$fragmentName = (key)=>key.charAt(0).toLowerCase() + key.slice(1);
const $56093000e314999c$var$fragmentType = (key)=>key.charAt(0).toUpperCase() + key.slice(1);
const $56093000e314999c$export$ea55e8e0446efa94 = (activity)=>{
    if (activity.myActivity) return activity.myActivity;
    return activity;
};
const $56093000e314999c$var$SITE_ARI_PREFIX = 'ari:cloud:platform::site/';
const $56093000e314999c$var$containerMapTypes = new Map([
    [
        $56093000e314999c$var$SITE_ARI_PREFIX,
        'SITE'
    ]
]);
function $56093000e314999c$export$788e6013936a6bb4(rootContainerARI) {
    // the "ID" portion of the ARI begins after the first '/'
    const ariSplitIndex = rootContainerARI.indexOf('/');
    return {
        ari: rootContainerARI,
        id: rootContainerARI.slice(ariSplitIndex + 1),
        type: $56093000e314999c$var$containerMapTypes.get(rootContainerARI.slice(0, ariSplitIndex + 1)) || 'OTHER'
    };
}
function $56093000e314999c$export$e8f56bed6776c7ea(filters) {
    return {
        ...filters,
        // These have V high cardinality, so using a length
        actors: filters.actors?.length,
        containerIds: filters.containerIds?.length,
        // comma separated lists
        products: filters.products?.join(','),
        eventTypes: filters.eventTypes?.join(','),
        objectTypes: filters.objectTypes?.join(','),
        rootContainerIds: filters.rootContainerIds?.join(',')
    };
}
/**
 * These fragments are the core of our query, without them it will always fail,
 * so we shouldn't remove them. It is possible that removing other offending fragments
 * will fix the error in these core fragments. (e.g. Field conflict)
 */ const $56093000e314999c$var$RESTRICTED_FRAGMENTS = [
    'activity',
    'all',
    'myActivity',
    'workedOn',
    'viewed',
    'activityItemConnection',
    'activityItemEdge'
];
function $56093000e314999c$export$e22863ec502608d2(invalidFragments, allFragments) {
    return invalidFragments.filter((fragment)=>!$56093000e314999c$var$RESTRICTED_FRAGMENTS.includes(fragment)).reduce((acc, invalidFragment)=>{
        return acc.replace(new RegExp(`...${invalidFragment}\n`, 'g'), '').replace($56093000e314999c$export$213ba2e9f2d143b9(invalidFragment), '');
    }, allFragments);
}
const $56093000e314999c$var$IGNORED_ERROR_CLASSIFICATIONS = [
    'IncorrectAuthException'
];
function $56093000e314999c$export$c939d6148e47244a(response) {
    if (!response?.data || !Array.isArray(response.errors)) return false;
    const filteredAggErrors = response.errors.filter((e)=>!e.extensions.classification || !$56093000e314999c$var$IGNORED_ERROR_CLASSIFICATIONS.includes(e.extensions.classification));
    return filteredAggErrors.length > 0 && $56093000e314999c$export$884573c560ed3600(response.data);
}
function $56093000e314999c$export$884573c560ed3600(queryData) {
    return !queryData.activity || $56093000e314999c$export$ea55e8e0446efa94(queryData.activity).all?.edges?.length === 0 && $56093000e314999c$export$ea55e8e0446efa94(queryData.activity).workedOn?.edges?.length === 0 && queryData.activity?.myActivity?.viewed?.edges?.length === 0;
}

});




parcelRegister("ce4pa", function(module, exports) {

$parcel$export(module.exports, "ExperienceSuccess", () => $a91ff3a48261deb0$export$4962f3898bd5c829);

var $5uXOq = parcelRequire("5uXOq");
const $a91ff3a48261deb0$export$4962f3898bd5c829 = ({ experience: experience })=>{
    (0, $5uXOq.useLayoutEffect)(()=>{
        experience.success();
    }, [
        experience
    ]);
    return null;
};

});

parcelRegister("0Wtmq", function(module, exports) {

$parcel$export(module.exports, "PeopleAndTeamsConfigurationProvider", () => $7fcc2b6dd0426004$export$d3f5bd36d1c6597e);
$parcel$export(module.exports, "usePeopleAndTeamsConfigurationContext", () => $7fcc2b6dd0426004$export$130340d16a670190);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $btDaU = parcelRequire("btDaU");

var $fkT8h = parcelRequire("fkT8h");

var $9Xnkh = parcelRequire("9Xnkh");

var $epGv3 = parcelRequire("epGv3");
const $7fcc2b6dd0426004$export$8a37839ac1e08b25 = /*#__PURE__*/ (0, $5uXOq.createContext)((0, $9Xnkh.DEFAULT_CONTEXT));
const $7fcc2b6dd0426004$export$3bf19eb896b777b8 = ({ children: children, locale: locale, product: product, teamPermissions: teamPermissions, orgId: orgId, teamPermissionCheckEnabled: teamPermissionCheckEnabled = false })=>{
    const overrides = (0, $epGv3.usePeopleAndTeamsConfigurationOverrides)(teamPermissionCheckEnabled, orgId, teamPermissions);
    const artifact = (0, $fkT8h.usePeopleAndTeamsRemoteArtifact)(product, locale, overrides);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($7fcc2b6dd0426004$export$8a37839ac1e08b25.Provider, {
        value: artifact || (0, $9Xnkh.DEFAULT_CONTEXT),
        children: children
    });
};
const $7fcc2b6dd0426004$export$d3f5bd36d1c6597e = ({ children: children, locale: locale, product: product, teamPermissions: teamPermissions, teamPermissionCheckEnabled: teamPermissionCheckEnabled, orgId: orgId, ...flightDeckProps })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $btDaU.FlightDeckProvider), {
        product: product,
        ...flightDeckProps,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($7fcc2b6dd0426004$export$3bf19eb896b777b8, {
            locale: locale,
            product: product,
            teamPermissions: teamPermissions,
            teamPermissionCheckEnabled: teamPermissionCheckEnabled,
            orgId: orgId,
            children: children
        })
    });
};
const $7fcc2b6dd0426004$export$130340d16a670190 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext($7fcc2b6dd0426004$export$8a37839ac1e08b25);

});
parcelRegister("fkT8h", function(module, exports) {

$parcel$export(module.exports, "usePeopleAndTeamsRemoteArtifact", () => $540fc5e41500614e$export$233293b7afb7b362);

var $5uXOq = parcelRequire("5uXOq");

var $btDaU = parcelRequire("btDaU");

var $a5HGt = parcelRequire("a5HGt");
const $540fc5e41500614e$var$transformArtifactsWithOverrides = (artifact, overrideKeys)=>{
    if (!artifact?.overrides?.length || overrideKeys.length === 0) return artifact;
    return overrideKeys.reduce((acc, overrideKey)=>{
        return {
            ...acc,
            ...artifact.overrides && artifact.overrides.find((override)=>override.key === overrideKey)?.item || null
        };
    }, artifact);
};
const $540fc5e41500614e$export$233293b7afb7b362 = (product, locale, overridesKeys)=>{
    const dimensions = (0, $5uXOq.useMemo)(()=>({
            ...(0, $a5HGt.FD_CLIENT_FETCH_PROPS).dimensions,
            locale: locale
        }), [
        locale
    ]);
    const artifact = (0, $btDaU.useFlightDeckArtifact)((0, $a5HGt.FD_CLIENT_FETCH_PROPS).name, dimensions);
    /**
	 * FlightDeck doesn't allow custom, a 'product', dimension so we must handle this ourselves.
	 * We can probably remove this memo once that functionality is available
	 */ return (0, $5uXOq.useMemo)(()=>{
        const productArtifact = artifact ? product in artifact['people-menu'] ? artifact['people-menu'][product] : artifact['people-menu'].default : null;
        return {
            ['people-menu']: $540fc5e41500614e$var$transformArtifactsWithOverrides(productArtifact, overridesKeys ? overridesKeys['people-menu'] : [])
        };
    }, [
        artifact,
        product,
        overridesKeys
    ]);
};

});
parcelRegister("a5HGt", function(module, exports) {

$parcel$export(module.exports, "FD_CLIENT_FETCH_PROPS", () => $72142315cc1ea029$export$c270c412a04ff3e6);

var $c04PQ = parcelRequire("c04PQ");
const $72142315cc1ea029$export$953923d576277fd6 = 'people-and-teams-configuration-service';
const $72142315cc1ea029$export$71f196808ce40e60 = 'prod';
const $72142315cc1ea029$export$6392ca3738ed1e9 = 'fedramp-moderate';
const $72142315cc1ea029$export$e836203c1e95eac3 = 'commercial';
const $72142315cc1ea029$export$c270c412a04ff3e6 = {
    name: $72142315cc1ea029$export$953923d576277fd6,
    dimensions: {
        environmentType: $72142315cc1ea029$export$71f196808ce40e60,
        perimeter: (0, $c04PQ.isFedRamp)() ? $72142315cc1ea029$export$6392ca3738ed1e9 : $72142315cc1ea029$export$e836203c1e95eac3
    }
};

});


parcelRegister("9Xnkh", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_CONTEXT", () => $68376ad28bbe1625$export$9c542858adf7dcd0);
const $68376ad28bbe1625$export$9c542858adf7dcd0 = {
    ['people-menu']: null
};

});

parcelRegister("epGv3", function(module, exports) {

$parcel$export(module.exports, "usePeopleAndTeamsConfigurationOverrides", () => $9b52f5c51e77c65a$export$66d7d96ce076bcd6);

var $95nUS = parcelRequire("95nUS");

var $5wXDQ = parcelRequire("5wXDQ");
const $9b52f5c51e77c65a$export$66d7d96ce076bcd6 = (teamPermissionCheckEnabled, orgId, teamPermissionsProps)=>{
    const { permissions: teamPermissionsFromHook } = (0, $95nUS.useTeamsPermissionsService)(orgId, {
        enabled: teamPermissionCheckEnabled && !teamPermissionsProps
    });
    const teamPermissions = teamPermissionsProps || teamPermissionsFromHook;
    return {
        'people-menu': [
            ...!teamPermissions?.canCreateTeams ? [
                (0, $5wXDQ.PeopleMenuOverrides).createTeamsDisabled
            ] : [],
            ...!teamPermissions?.canViewTeams ? [
                (0, $5wXDQ.PeopleMenuOverrides).viewTeamsDisabled
            ] : []
        ]
    };
};

});
parcelRegister("95nUS", function(module, exports) {

$parcel$export(module.exports, "useTeamsPermissionsService", () => $6e4bacc142514b25$export$b24dcbe1ec677a8);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $3mE7N = parcelRequire("3mE7N");

var $lXyXX = parcelRequire("lXyXX");
const $6e4bacc142514b25$export$b24dcbe1ec677a8 = (scope, { enabled: enabled, attributes: attributes } = {
    enabled: false,
    attributes: {}
})=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    // backwards compatibility allow orgId to be passed as a string
    const { orgId: orgId, cloudId: cloudId } = typeof scope === 'string' || !scope ? {
        orgId: scope,
        cloudId: undefined
    } : scope;
    const [state, { getPermissions: getPermissions }] = (0, $lXyXX.useTeamsPermissionsStore)();
    const fetchData = (0, $5uXOq.useCallback)(async ()=>{
        getPermissions({
            orgId: orgId,
            cloudId: cloudId,
            enabled: enabled
        }, {
            onFetch: ()=>(0, $3mE7N.fireOperationalEvent)(createAnalyticsEvent, {
                    action: 'fetched',
                    actionSubject: 'use-team-permissions',
                    attributes: {
                        userId: attributes?.userId,
                        orgId: orgId,
                        cloudId: cloudId
                    }
                })
        });
    }, [
        orgId,
        cloudId,
        enabled,
        getPermissions,
        createAnalyticsEvent,
        attributes?.userId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        fetchData();
    }, [
        fetchData
    ]);
    return {
        loading: state.isLoading,
        data: state.permissionsResponse,
        error: state.error,
        ...state
    };
};

});
parcelRegister("3mE7N", function(module, exports) {

$parcel$export(module.exports, "fireOperationalEvent", () => $f93bde5d7fdaaaab$export$a1fb57756f0de62b);
$parcel$export(module.exports, "fireScreenEvent", () => $f93bde5d7fdaaaab$export$59608e0169622110);
$parcel$export(module.exports, "fireTrackEvent", () => $f93bde5d7fdaaaab$export$574d2f19a52d67ca);
$parcel$export(module.exports, "fireUIEvent", () => $f93bde5d7fdaaaab$export$7eca133280843f9e);
$parcel$export(module.exports, "isSeriousError", () => $f93bde5d7fdaaaab$export$91c413c8a5c77e19);
const $f93bde5d7fdaaaab$var$ANALYTICS_CHANNEL = 'peopleTeams';
const $f93bde5d7fdaaaab$var$runItLater = (cb)=>{
    if (window.requestIdleCallback === 'function') return window.requestIdleCallback(cb);
    if (typeof window.requestAnimationFrame === 'function') return window.requestAnimationFrame(cb);
    return ()=>setTimeout(cb);
};
const $f93bde5d7fdaaaab$var$fireEvent = (kind)=>(createAnalyticsEvent, body)=>{
        if (!createAnalyticsEvent) return;
        $f93bde5d7fdaaaab$var$runItLater(()=>{
            createAnalyticsEvent({
                eventType: kind,
                ...body
            }).fire($f93bde5d7fdaaaab$var$ANALYTICS_CHANNEL);
        });
    };
const $f93bde5d7fdaaaab$export$a1fb57756f0de62b = $f93bde5d7fdaaaab$var$fireEvent('operational');
const $f93bde5d7fdaaaab$export$59608e0169622110 = $f93bde5d7fdaaaab$var$fireEvent('screen');
const $f93bde5d7fdaaaab$export$574d2f19a52d67ca = $f93bde5d7fdaaaab$var$fireEvent('track');
const $f93bde5d7fdaaaab$export$7eca133280843f9e = $f93bde5d7fdaaaab$var$fireEvent('ui');
const $f93bde5d7fdaaaab$export$91c413c8a5c77e19 = (error)=>{
    if (!error) return false;
    // Check for ' 403' with space beforehand to not count urls containing 403 in cloud or team id
    if ('status' in error && error['status'] === 403 || error.message.includes(' 403')) return false;
    if ('status' in error && error['status'] === 401 || error.message.includes(' 401')) return false;
    if ('status' in error && error['status'] === 429 || error.message.includes(' 429')) return false;
    if (error.message === 'Failed to fetch') return false;
    return true;
};

});

parcelRegister("lXyXX", function(module, exports) {

$parcel$export(module.exports, "useTeamsPermissionsStore", () => $20332b07e72ce3e2$export$4e7a1c55cba5a168);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $1K4T6 = parcelRequire("1K4T6");
var $dmOdc = parcelRequire("dmOdc");

var $ddoT6 = parcelRequire("ddoT6");
const $20332b07e72ce3e2$var$actions = {
    getPermissions: ({ orgId: orgId, cloudId: cloudId, enabled: enabled }, { onFetch: onFetch })=>async ({ setState: setState, getState: getState, dispatch: dispatch })=>{
            const { hasLoaded: hasLoaded, isLoading: isLoading } = getState();
            if (hasLoaded || isLoading || !enabled || !orgId || !cloudId) return;
            try {
                setState({
                    isLoading: true
                });
                (0, $dmOdc.teamsClient).setContext({
                    orgId: orgId,
                    cloudId: cloudId
                });
                const response = await (0, $dmOdc.teamsClient).getPermissions();
                dispatch($20332b07e72ce3e2$var$actions.setPermissions(response.permissions));
                onFetch?.();
            } catch (error) {
                dispatch($20332b07e72ce3e2$var$actions.setError(error instanceof (0, $1K4T6.HttpError) ? error : new Error('Failed to fetch permissions')));
            }
        },
    setError: (error)=>({ setState: setState })=>{
            setState({
                hasLoaded: true,
                isLoading: false,
                error: error
            });
        },
    setLoading: (isLoading)=>({ setState: setState })=>{
            setState({
                isLoading: isLoading
            });
        },
    setPermissions: (permissions)=>({ setState: setState })=>{
            setState({
                hasLoaded: true,
                isLoading: false,
                permissions: (0, $ddoT6.transformPermissions)(permissions),
                permissionsResponse: {
                    permissions: permissions
                }
            });
        }
};
const $20332b07e72ce3e2$var$Store = (0, $iXqE5.createStore)({
    initialState: {
        error: undefined,
        hasLoaded: false,
        isLoading: false,
        permissions: {
            canCreateTeams: true,
            canViewTeams: true,
            canAdminTeams: false
        }
    },
    actions: $20332b07e72ce3e2$var$actions,
    name: 'teams-permissions'
});
const $20332b07e72ce3e2$export$4e7a1c55cba5a168 = (0, $3sQ5x.createHook)($20332b07e72ce3e2$var$Store);

});
parcelRegister("1K4T6", function(module, exports) {

$parcel$export(module.exports, "StatusCode", () => $5767c51dc6f9e25d$export$f66f92b8741acd5b);
$parcel$export(module.exports, "isAuthError", () => $5767c51dc6f9e25d$export$cde1786a482f9a1c);
$parcel$export(module.exports, "isErrorStatusCode", () => $5767c51dc6f9e25d$export$9677d7c364ada66c);
$parcel$export(module.exports, "DefaultError", () => $5767c51dc6f9e25d$export$c73ca302efeda3b4);
$parcel$export(module.exports, "SLOIgnoreError", () => $5767c51dc6f9e25d$export$d87f401f8106d7a2);
$parcel$export(module.exports, "HttpError", () => $5767c51dc6f9e25d$export$65bd6083489bd8bb);
$parcel$export(module.exports, "SLOIgnoreHttpError", () => $5767c51dc6f9e25d$export$826a3d65b8435adf);
$parcel$export(module.exports, "GraphQLError", () => $5767c51dc6f9e25d$export$92d6ed0888e7cb7f);
$parcel$export(module.exports, "isNetworkError", () => $5767c51dc6f9e25d$export$476aa014e2fd89d5);
var $5767c51dc6f9e25d$export$fe4bb20808298551 = /*#__PURE__*/ function(ErrorCategory) {
    ErrorCategory["NotFound"] = "NotFound";
    ErrorCategory["NotPermitted"] = "NotPermitted";
    ErrorCategory["MalformedInput"] = "MalformedInput";
    ErrorCategory["Internal"] = "Internal";
    return ErrorCategory;
}({});
var $5767c51dc6f9e25d$export$f66f92b8741acd5b = /*#__PURE__*/ function(StatusCode) {
    StatusCode[StatusCode["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    StatusCode[StatusCode["FORBIDDEN"] = 403] = "FORBIDDEN";
    StatusCode[StatusCode["TIMEOUT"] = 408] = "TIMEOUT";
    StatusCode[StatusCode["GONE"] = 410] = "GONE";
    StatusCode[StatusCode["PAYLOAD_TOO_LARGE"] = 413] = "PAYLOAD_TOO_LARGE";
    return StatusCode;
}({});
function $5767c51dc6f9e25d$export$cde1786a482f9a1c(error) {
    return $5767c51dc6f9e25d$export$9677d7c364ada66c(401, error) || $5767c51dc6f9e25d$export$9677d7c364ada66c(403, error);
}
function $5767c51dc6f9e25d$export$9677d7c364ada66c(statusCode, error) {
    if (!error) return false;
    if (error['status'] === statusCode || // error can be `ProperNetworkError` from `packages/graphql-client/src/links/error.ts`
    error['statusCode'] === statusCode) return true;
    const reg = new RegExp(`status (code)?.*(${statusCode})`);
    return !!error?.message?.match(reg);
}
function $5767c51dc6f9e25d$export$7c7624f23566b6ff(statusCode, message) {
    const reg = new RegExp(`status .*(${statusCode})`);
    return reg.test(message);
}
var $5767c51dc6f9e25d$export$c33cd4757598521c = /*#__PURE__*/ function(TeamErrorType) {
    TeamErrorType["TEAM_NOT_ACTIVE"] = "Team must be active";
    return TeamErrorType;
}({});
// Extending new custom Error types with `Object.setPrototypeOf`
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/setPrototypeOf
class $5767c51dc6f9e25d$var$CommonError extends Error {
    constructor(message){
        super(message);
        this.name = this.constructor.name;
        this.message = message || 'UnknownError';
        this.stack = new Error(message).stack || '';
    }
}
class $5767c51dc6f9e25d$export$c73ca302efeda3b4 extends $5767c51dc6f9e25d$var$CommonError {
    constructor({ message: message }){
        super(message || 'UnknownError');
        Object.setPrototypeOf(this, $5767c51dc6f9e25d$export$c73ca302efeda3b4.prototype);
    }
}
class $5767c51dc6f9e25d$export$d87f401f8106d7a2 extends $5767c51dc6f9e25d$var$CommonError {
    constructor({ message: message }){
        super(`SentryIgnore: ${message || 'UnknownError'}`);
        Object.setPrototypeOf(this, $5767c51dc6f9e25d$export$d87f401f8106d7a2.prototype);
    }
}
class $5767c51dc6f9e25d$export$65bd6083489bd8bb extends $5767c51dc6f9e25d$var$CommonError {
    constructor({ message: message, status: status, traceId: traceId, path: path }){
        super(message);
        Object.setPrototypeOf(this, $5767c51dc6f9e25d$export$65bd6083489bd8bb.prototype);
        this.status = status;
        this.traceId = traceId;
        this.path = path;
    }
}
class $5767c51dc6f9e25d$export$826a3d65b8435adf extends $5767c51dc6f9e25d$export$65bd6083489bd8bb {
    constructor(props){
        super(props);
        Object.setPrototypeOf(this, $5767c51dc6f9e25d$export$826a3d65b8435adf.prototype);
    }
}
class $5767c51dc6f9e25d$export$92d6ed0888e7cb7f extends $5767c51dc6f9e25d$var$CommonError {
    constructor({ message: message, category: category = 'default', fields: fields }){
        super(message);
        Object.setPrototypeOf(this, $5767c51dc6f9e25d$export$92d6ed0888e7cb7f.prototype);
        this.category = category;
        if (fields) this.fields = fields;
    }
    static{
        this.from = (rawErrors)=>{
            const firstError = rawErrors[0];
            const errorData = {
                category: firstError.category,
                message: firstError.message
            };
            if (firstError.fields) errorData.fields = firstError.fields.reduce((obj, item)=>{
                obj[item.field] = item.message;
                return obj;
            }, {});
            return new $5767c51dc6f9e25d$export$92d6ed0888e7cb7f(errorData);
        };
    }
}
function $5767c51dc6f9e25d$export$476aa014e2fd89d5(error) {
    return error && !!error.message && // Firefox
    (error.message.includes('NetworkError') || // Chrome
    error.message.startsWith('Failed to fetch') || error.message.includes('GraphQL error: Failed to fetch') || // cancel by users or unknown reason
    error.message.includes('GraphQL error: The operation was aborted') || error.message.includes('GraphQL error: cancelled') || error.message.includes('Abgebrochen') || error.message.includes("\u043E\u0442\u043C\u0435\u043D\u0435\u043D\u043E") || error.message.includes("\u0421\u0435\u0442\u0435\u0432\u043E\u0435 \u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435 \u043F\u043E\u0442\u0435\u0440\u044F\u043D\u043E.") || error.message.includes('anulowane') || error.message.includes("annul\xe9") || error.message.includes("\u5DF2\u53D6\u6D88") || error.message.includes('cancelado') || error.message.includes("\u30AD\u30E3\u30F3\u30BB\u30EB\u3057\u307E\u3057\u305F") || error.message.includes('cancelled') || error.message.includes('Network error') || // GraphQL-wrapping network error
    !!(error['graphQLErrors'] && error['networkError']));
}

});

parcelRegister("dmOdc", function(module, exports) {

$parcel$export(module.exports, "teamsClient", () => $1a92ea71d53eeb2b$export$5ed932c3646b89c6);

var $hzxsr = parcelRequire("hzxsr");

var $gTh2z = parcelRequire("gTh2z");

var $cHmJ2 = parcelRequire("cHmJ2");

var $49fYn = parcelRequire("49fYn");

var $gnKBB = parcelRequire("gnKBB");

var $7pLOg = parcelRequire("7pLOg");

var $8MCmh = parcelRequire("8MCmh");

var $13Kx5 = parcelRequire("13Kx5");

var $h46cM = parcelRequire("h46cM");

var $1B4EX = parcelRequire("1B4EX");

var $7thbw = parcelRequire("7thbw");

var $doDlD = parcelRequire("doDlD");

var $93qCC = parcelRequire("93qCC");

var $9zuJU = parcelRequire("9zuJU");
class $1a92ea71d53eeb2b$export$db59823f35bf78ce {
    constructor(/**
		 * @param {ClientContextProps} context - Context including CloudId & OrgId to be used for all requests
		 */ context){
        this._aggClient = (0, $gTh2z.aggClient);
        this._directoryClient = (0, $49fYn.directoryClient);
        this._legionClient = (0, $8MCmh.defaultLegionClient);
        this._mutabilityClient = (0, $13Kx5.default);
        this._permsClient = (0, $1B4EX.default);
        this._publicApiClient = (0, $7thbw.default);
        this._invitationsClient = (0, $7pLOg.default);
        this._userPreferencesClient = (0, $9zuJU.default);
        this._objectResolverClient = (0, $h46cM.default);
        this._teamsInSlackClient = (0, $93qCC.default);
        this._collaborationGraphClient = (0, $cHmJ2.default);
        this._identityClient = (0, $gnKBB.default);
        this._teamCentralClient = (0, $doDlD.default);
        if (context) this.setContext(context);
    }
    async measurePerformance(name, fn) {
        const exp = (0, $hzxsr.TEAMS_CLIENT_EXPERIENCES).get(name);
        if (!exp) return fn();
        exp.start();
        try {
            const result = await fn();
            exp.success();
            return result;
        } catch (e) {
            exp.failWithError(e);
            throw e;
        }
    }
    /**
	 * Sets the base URL to be used in the client requests
	 * @param {string} baseUrl - The new base URL
	 */ setBaseUrl(baseUrl) {
        this._aggClient.setBaseUrl(baseUrl);
        this._directoryClient.setBaseUrl(baseUrl);
    }
    /**
	 * Sets context including CloudId & OrgId to be used for all requests
	 */ setContext(context) {
        this._aggClient.setContext(context);
        this._directoryClient.setContext(context);
        this._legionClient.setContext(context);
        this._permsClient.setContext(context);
        this._mutabilityClient.setContext(context);
        this._publicApiClient.setContext(context);
        this._invitationsClient.setContext(context);
    }
    setTeamCentralContext(baseUrl, context) {
        this._teamCentralClient.setContext(context);
        this._teamCentralClient.setBaseUrl(baseUrl);
    }
    /**
	 * @private
	 * @deprecated use setBaseUrl instead
	 */ setDirectoryBaseUrl(baseUrl) {
        // eslint-disable-next-line no-console
        console.warn('setDirectoryBaseUrl is deprecated, use setBaseUrl instead');
        return this._directoryClient.setBaseUrl(baseUrl);
    }
    /**
	 * Fetches Browse user settings
	 */ async querySettings(cloudId, product) {
        if (cloudId) this.setContext({
            cloudId: cloudId
        });
        return this.measurePerformance('querySettings', async ()=>{
            if (!product) throw new Error('Product is required');
            const response = await this._legionClient.retrieveBrowseUserPermission(product);
            return {
                'internal.browse-users-allowed': response.canSearchUsers
            };
        });
    }
    /**
	 * This will return all of the teams-related permissions that your user has for the org and site in the client context.
	 */ async getPermissions() {
        return this.measurePerformance('getPermissions', ()=>this._legionClient.getPermissions());
    }
    /**
	 * Fetches feature flags from Directory
	 * @deprecated As part of decommisioning pf-directoy
	 */ async queryFeatureFlags(...args) {
        return this.measurePerformance('queryFeatureFlags', ()=>this._directoryClient.queryFeatureFlags(...args));
    }
    /**
	 * Get user information of members of a team, paginated
	 * @param {string} teamId
	 * @returns {Promise}
	 */ async queryTeamMemberships(teamId, membershipState = [
        'FULL_MEMBER'
    ], pageInfo = {
        first: 100
    }) {
        return this._aggClient.queryTeamMemberships(teamId, membershipState, pageInfo);
    }
    /**
	 * Get user information given an user id
	 * @param {string} userId
	 * @returns {Promise}
	 */ async queryAGGUser(userId) {
        return this._aggClient.queryAGGUser(userId);
    }
    /**
	 * Get user information of a member of a team
	 * @param {string} userId
	 * @returns {Promise<CloudUser>}
	 */ queryUser(...args) {
        return this.measurePerformance('queryUser', ()=>this._directoryClient.queryUser(...args));
    }
    setLegionRootUrl(url) {
        return this._legionClient.setRootUrl(url);
    }
    /**
	 *
	 * @param teamId
	 * @returns {Promise<TeamWithImageUrls>}
	 */ async getTeamById(teamId) {
        return this.measurePerformance('getTeamById', ()=>this._legionClient.getTeamById(teamId));
    }
    /**
	 * Search teams based on query
	 */ async getAllTeams(...args) {
        return this.measurePerformance('getAllTeams', ()=>this._legionClient.getAllTeams(...args));
    }
    /**
	 * Update team details
	 */ async updateTeamById(...args) {
        return this.measurePerformance('updateTeamById', ()=>this._legionClient.updateTeamById(...args));
    }
    /**
	 * @private
	 * @deprecated use addUsersToTeam instead
	 */ async inviteUsersToTeam(...args) {
        return this.measurePerformance('inviteUsersToTeam', ()=>this._legionClient.inviteUsersToTeam(...args));
    }
    /**
	 * Get the current user's team membership
	 */ async getMyTeamMembership(...args) {
        return this.measurePerformance('getMyTeamMembership', ()=>this._legionClient.getMyTeamMembership(...args));
    }
    /**
	 * Get a teams "Links"
	 */ async getTeamLinksByTeamId(teamId) {
        return this.measurePerformance('getTeamLinksByTeamId', ()=>this._legionClient.getTeamLinksByTeamId(teamId));
    }
    /**
	 * Create a team link
	 */ async createTeamLink(...args) {
        return this.measurePerformance('createTeamLink', ()=>this._legionClient.createTeamLink(...args));
    }
    /**
	 * Update a team link
	 */ async updateTeamLink(...args) {
        return this.measurePerformance('updateTeamLink', ()=>this._legionClient.updateTeamLink(...args));
    }
    /**
	 * Delete a team link
	 */ async deleteTeamLink(...args) {
        return this.measurePerformance('deleteTeamLink', ()=>this._legionClient.deleteTeamLink(...args));
    }
    /**
	 * Reorder a team link
	 */ async reorderTeamLink(...args) {
        return this.measurePerformance('reorderTeamLink', ()=>this._legionClient.reorderTeamLink(...args));
    }
    /**
	 * Get org's eligibility for managed teams
	 */ async getOrgEligibilityForManagedTeams() {
        return this.measurePerformance('getOrgEligibilityForManagedTeams', ()=>this._legionClient.getOrgEligibilityForManagedTeams());
    }
    /**
	 * @deprecated Invitation status no longer exists
	 * Accept a team invitation
	 */ async acceptTeamInvitation(...args) {
        return this.measurePerformance('acceptTeamInvitation', ()=>this._legionClient.acceptTeamInvitation(...args));
    }
    /**
	 * @deprecated Invitation status no longer exists
	 * Decline a team invitation
	 */ async declineTeamInvitation(...args) {
        return this.measurePerformance('declineTeamInvitation', ()=>this._legionClient.declineTeamInvitation(...args));
    }
    /**
	 * Add current user to a team
	 */ async selfJoinTeam(...args) {
        return this.measurePerformance('selfJoinTeam', ()=>this._legionClient.selfJoinTeam(...args));
    }
    /**
	 * Cancel a join request to a private team
	 */ async cancelJoinRequest(teamId) {
        return this.measurePerformance('cancelJoinRequest', ()=>this._legionClient.cancelJoinRequest(teamId));
    }
    /**
	 * Accept a join request to a private team
	 */ async acceptJoinRequest(...args) {
        return this.measurePerformance('acceptJoinRequest', ()=>this._legionClient.acceptJoinRequest(...args));
    }
    /**
	 * Decline a join request to a private team
	 */ async declineJoinRequest(...args) {
        return this.measurePerformance('declineJoinRequest', ()=>this._legionClient.declineJoinRequest(...args));
    }
    /**
	 * @deprecated use removeTeamMemberships instead
	 */ async deleteTeamMembership(...args) {
        return this.measurePerformance('deleteTeamMembership', ()=>this._legionClient.deleteTeamMembership(...args));
    }
    /**
	 * @deprecated INVITED status has been deprecated
	 */ async revokeTeamInvite(...args) {
        return this.measurePerformance('revokeTeamInvite', ()=>this._legionClient.revokeTeamInvite(...args));
    }
    /**
	 * Delete a team
	 */ async deleteTeam(teamId) {
        return this.measurePerformance('deleteTeam', ()=>this._legionClient.deleteTeam(teamId));
    }
    /**
	 * @private
	 * @deprecated should be other means to solve this issue
	 */ async isSingleFullMemberTeam(teamId) {
        return this._legionClient.isSingleFullMemberTeam(teamId);
    }
    /**
	 * Create a team
	 */ async createTeam(...args) {
        return this.measurePerformance('createTeam', ()=>this._legionClient.createTeam(...args));
    }
    /**
	 * Create a external team
	 * @param {string} groupDescription - The description of the group, which will be used as the team description. The group name will be fetched from the identity service, so it does not need to be provided.
	 * @param {ExternalReference} externalReference
	 */ async createExternalTeam(...args) {
        return this.measurePerformance('createExternalTeam', ()=>this._legionClient.createExternalTeam(...args));
    }
    /**
	 * Get linked teams for a groups in bulk
	 * @param {string} groupIds - The group ids to fetch linked teams for
	 */ async getLinkedTeamsBulk(...args) {
        return this.measurePerformance('getLinkedTeamsBulk', ()=>this._legionClient.getLinkedTeamsBulk(...args));
    }
    /**
	 * Get Org scope
	 */ async getOrgScope(...args) {
        return this.measurePerformance('getOrgScope', ()=>this._legionClient.getOrgScope(...args));
    }
    /**
	 * Restore soft-deleted team and sync to group
	 */ async restoreTeamToSyncedGroup(...args) {
        return this.measurePerformance('restoreTeamToSyncedGroup', ()=>this._legionClient.restoreTeamToSyncedGroup(...args));
    }
    /**
	 * Get the difference between a team and a group
	 * @param teamId
	 * @param {ExternalReference} externalReference
	 * @returns {Promise<TeamAndGroupDifference>}
	 */ async getTeamAndGroupDiff(...args) {
        return this.measurePerformance('getTeamAndGroupDiff', ()=>this._legionClient.getTeamAndGroupDiff(...args));
    }
    /**
	 * Link an existing team to a group
	 * @param teamId
	 * @param {ExternalReference} externalReference
	 */ async linkExistingTeamToGroup(...args) {
        return this.measurePerformance('linkExistingTeamToGroup', ()=>this._legionClient.linkExistingTeamToGroup(...args));
    }
    /**
	 *
	 * @param teamId
	 * @returns {Promise<LinkedTeamsProfileDetails>}
	 */ async getTeamProfileDetailsByTeamId(...args) {
        return this.measurePerformance('getTeamProfileDetails', ()=>this._legionClient.getTeamProfileDetails(...args));
    }
    /**
	 *
	 * @param teamId
	 * @returns {Promise<SoftDeletedTeam>}
	 */ async getSoftDeletdTeamById(teamId) {
        return this.measurePerformance('getSoftDeletedTeamById', ()=>this._legionClient.getSoftDeletedTeamById(teamId));
    }
    /**
	 * Shoud only be used within Teams (P&T) packages
	 * @param userId
	 * @returns {Promise<SoftDeletedTeam>}
	 */ async getUserInSiteUserBase(userId) {
        return this.measurePerformance('getUserInSiteUserBase', ()=>this._legionClient.getUserInSiteUserBase(userId));
    }
    trimTeamARI(teamId = '') {
        return this._legionClient.trimTeamARI(teamId);
    }
    /**
	 * Get user profile with mutability constraints
	 */ async getProfileWithMutability(...args) {
        return this.measurePerformance('getProfileWithMutability', ()=>this._mutabilityClient.getProfileWithMutability(...args));
    }
    /**
	 * Is the current user a site admin
	 */ getIsSiteAdmin(...args) {
        return this.measurePerformance('getIsSiteAdmin', ()=>this._permsClient.getIsSiteAdmin(...args));
    }
    /**
	 * Add users to a team
	 */ addUsersToTeam(...args) {
        return this.measurePerformance('addUsersToTeam', ()=>this._publicApiClient.addUsersToTeam(...args));
    }
    /**
	 * Remove users from a team
	 */ removeTeamMemberships(...args) {
        return this.measurePerformance('removeTeamMemberships', ()=>this._publicApiClient.removeTeamMemberships(...args));
    }
    /**
	 * Restore a deleted team
	 */ restoreTeam(...args) {
        return this.measurePerformance('restoreTeam', ()=>this._publicApiClient.restoreTeam(...args));
    }
    getRecommendedProducts(...args) {
        return this.measurePerformance('getRecommendedProducts', ()=>this._invitationsClient.getProductRecommendations(...args));
    }
    joinOrRequestDefaultAccessToProductsBulk(...args) {
        return this.measurePerformance('joinOrRequestDefaultAccessToProductsBulk', ()=>this._invitationsClient.joinOrRequestDefaultAccessToProductsBulk(...args));
    }
    /**
	 * Get token to upload media for a team
	 */ async getWriteTeamMediaToken() {
        return this.measurePerformance('getWriteTeamMediaToken', ()=>this._legionClient.getWriteMediaToken());
    }
    /**
	 * Get token to read media for a user
	 */ async getReadMediaToken(...args) {
        return this.measurePerformance('getReadMediaToken', ()=>this._userPreferencesClient.getReadMediaToken(...args));
    }
    /**
	 * Get token to upload media for a user
	 */ async getWriteUserMediaToken() {
        return this.measurePerformance('getWriteUserMediaToken', ()=>this._userPreferencesClient.getWriteMediaToken());
    }
    /**
	 * Update header image for a user
	 */ async updateUserHeaderImage(headerImageId) {
        return this.measurePerformance('updateUserHeaderImage', ()=>this._userPreferencesClient.updateUserHeaderImage(headerImageId));
    }
    /**
	 * Fetch user containers from collboration graph
	 */ async getUserContainers(...args) {
        return this.measurePerformance('getUserContainers', ()=>this._collaborationGraphClient.getUserContainers(...args));
    }
    /**
	 * Fetch mutatability of external managed user fields
	 */ async getUserManageConfig(...args) {
        return this.measurePerformance('getUserManageConfig', ()=>this._identityClient.getUserManageConfig(...args));
    }
    /**
	 * Fetch user avatar uploaded status
	 */ async getMyAvatarUploadedStatus(...args) {
        return this.measurePerformance('getMyAvatarUploadedStatus', ()=>this._identityClient.getMyAvatarUploadedStatus(...args));
    }
    /**
	 * Delete user avatar
	 */ async deleteAvatar(...args) {
        return this.measurePerformance('deleteUserAvatar', ()=>this._identityClient.deleteAvatar(...args));
    }
    async fetchUserAvatarInfo(...args) {
        return this.measurePerformance('fetchUserAvatarInfo', ()=>this._identityClient.fetchUserAvatarInfo(...args));
    }
    /**
	 * Fetch Team link icons
	 */ async getTeamLinkIcons(...args) {
        return this.measurePerformance('getTeamLinkIcons', ()=>this._objectResolverClient.getTeamLinkIcons(...args));
    }
    /**
	 * Fetch team in slack details
	 */ async getTeamInSlack(...args) {
        return this.measurePerformance('getTeamInSlack', ()=>this._teamsInSlackClient.getTeamInSlack(...args));
    }
    /**
	 * Delete team in slack
	 */ async disconnectTeamInSlack(...args) {
        return this.measurePerformance('disconnectTeamInSlack', ()=>this._teamsInSlackClient.disconnectTeamInSlack(...args));
    }
    /**
	 * Update team in slack
	 */ async updateTeamInSlack(...args) {
        return this.measurePerformance('updateTeamInSlack', ()=>this._teamsInSlackClient.updateTeamInSlack(...args));
    }
    /**
	 * Update user details
	 */ async updateUser(...args) {
        return this.measurePerformance('updateUser', ()=>this._identityClient.updateUser(...args));
    }
    async updateUserAvatar(...args) {
        return this.measurePerformance('updateUserAvatar', ()=>this._identityClient.updateUserAvatar(...args));
    }
    async addTeamWatcher(...args) {
        return this._teamCentralClient.addTeamWatcher(...args);
    }
    async removeTeamWatcher(...args) {
        return this._teamCentralClient.removeTeamWatcher(...args);
    }
    async deleteKudos(...args) {
        return this._teamCentralClient.deleteKudos(...args);
    }
    async queryTagList(...args) {
        return this._teamCentralClient.queryTagList(...args);
    }
    async createTag(...args) {
        return this._teamCentralClient.createTag(...args);
    }
    async createHelpPointer(...args) {
        return this._teamCentralClient.createHelpPointer(...args);
    }
    async updateHelpPointer(...args) {
        return this._teamCentralClient.updateHelpPointer(...args);
    }
    async deleteHelpPointer(...args) {
        return this._teamCentralClient.deleteHelpPointer(...args);
    }
}
const $1a92ea71d53eeb2b$export$5ed932c3646b89c6 = new $1a92ea71d53eeb2b$export$db59823f35bf78ce();

});
parcelRegister("hzxsr", function(module, exports) {

$parcel$export(module.exports, "TEAMS_CLIENT_EXPERIENCES", () => $e069606520fb7fe4$export$879344107b04120c);

var $7Zbvr = parcelRequire("7Zbvr");

var $baNgi = parcelRequire("baNgi");
const $e069606520fb7fe4$var$TeamsClientExperienceKeyList = [
    'getAllTeams',
    'getTeamById',
    'updateTeamById',
    'querySettings',
    'queryFeatureFlags',
    'queryTeamMemberships',
    'queryUser',
    'inviteUsersToTeam',
    'getMyTeamMembership',
    'getTeamLinksByTeamId',
    'createTeamLink',
    'updateTeamLink',
    'deleteTeamLink',
    'reorderTeamLink',
    'acceptTeamInvitation',
    'declineTeamInvitation',
    'selfJoinTeam',
    'cancelJoinRequest',
    'acceptJoinRequest',
    'declineJoinRequest',
    'deleteTeamMembership',
    'revokeTeamInvite',
    'deleteTeam',
    'isSingleFullMemberTeam',
    'createTeam',
    'createExternalTeam',
    'getProfileWithMutability',
    'getIsSiteAdmin',
    'addUsersToTeam',
    'removeTeamMemberships',
    'getRecommendedProducts',
    'joinOrRequestDefaultAccessToProductsBulk',
    'getReadMediaToken',
    'getWriteUserMediaToken',
    'updateUserHeaderImage',
    'getWriteTeamMediaToken',
    'getSoftDeletedTeamById',
    'restoreTeam',
    'getUserInSiteUserBase',
    'getLinkedTeamsBulk',
    'getTeamProfileDetails',
    'getUserContainers',
    'getPermissions',
    'getUserManageConfig',
    'getMyAvatarUploadedStatus',
    'deleteUserAvatar',
    'getTeamLinkIcons',
    'getTeamInSlack',
    'getOrgScope',
    'restoreTeamToSyncedGroup',
    'getTeamAndGroupDiff',
    'linkExistingTeamToGroup',
    'fetchUserAvatarInfo',
    'getOrgEligibilityForManagedTeams',
    'updateUser',
    'updateUserAvatar',
    'disconnectTeamInSlack',
    'updateTeamInSlack'
];
const $e069606520fb7fe4$export$879344107b04120c = new Map([
    ...$e069606520fb7fe4$var$TeamsClientExperienceKeyList.map((key)=>[
            key,
            // camelCase to kebab-case
            new (0, $baNgi.TeamsUFOExperience)(`teams-client-${key.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase()}`, {
                type: (0, $7Zbvr.ExperienceTypes).Operation,
                performanceType: (0, $7Zbvr.ExperiencePerformanceTypes).Custom,
                platform: {
                    component: 'people'
                }
            })
        ])
]);

});
parcelRegister("7Zbvr", function(module, exports) {

$parcel$export(module.exports, "ExperienceTypes", () => $e40e68027603de60$export$994164cf3ae1cc9a);
$parcel$export(module.exports, "ExperiencePerformanceTypes", () => $e40e68027603de60$export$cc26007c03242fff);
var $e40e68027603de60$export$994164cf3ae1cc9a = /*#__PURE__*/ function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
    return ExperienceTypes;
}({});
var $e40e68027603de60$export$cc26007c03242fff = /*#__PURE__*/ function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
    return ExperiencePerformanceTypes;
}({});

});

parcelRegister("baNgi", function(module, exports) {

$parcel$export(module.exports, "TeamsUFOExperience", () => $01e6318fcd37fd21$export$9a18529d1e90e81a);

var $boHLC = parcelRequire("boHLC");

var $1K4T6 = parcelRequire("1K4T6");

var $139Gm = parcelRequire("139Gm");
class $01e6318fcd37fd21$export$9a18529d1e90e81a extends (0, $boHLC.UFOExperience) {
    abortWithError(error, reason) {
        return super.abort({
            metadata: {
                error: (0, $139Gm.createErrorMetadata)(error),
                reason: reason
            }
        });
    }
    failWithError(error) {
        if (error instanceof Error) {
            if ((0, $1K4T6.isAuthError)(error)) return this.abortWithError(error, 'Abort due to user unauthenticated');
            if ((0, $1K4T6.isErrorStatusCode)((0, $1K4T6.StatusCode).GONE, error)) return this.abortWithError(error, 'Abort due to unavailable resource');
            if ((0, $139Gm.isIgnoredError)(error)) return this.abortWithError(error, 'Abort due to an error in ignore list');
            if ((0, $1K4T6.isNetworkError)(error)) return this.abortWithError(error, 'Abort due to network error');
            return super.failure({
                metadata: {
                    error: (0, $139Gm.createErrorMetadata)(error),
                    packageVersion: "0.0.0-use.local",
                    packageName: "platform-pkg"
                }
            });
        }
        return super.failure({
            metadata: {
                error: 'unknown error',
                packageVersion: "0.0.0-use.local",
                packageName: "platform-pkg"
            }
        });
    }
}

});
parcelRegister("boHLC", function(module, exports) {

$parcel$export(module.exports, "UFOExperience", () => $69d53cdb5241e240$export$c00d22927c60484a);

var $iLwDN = parcelRequire("iLwDN");
class $69d53cdb5241e240$export$c00d22927c60484a extends (0, $iLwDN.UFOAbstractExperience) {
}

});
parcelRegister("iLwDN", function(module, exports) {

$parcel$export(module.exports, "UFOAbstractExperience", () => $cc70575b2203e361$export$d31c89db257648c);

var $7Jxgt = parcelRequire("7Jxgt");


var $1vlV8 = parcelRequire("1vlV8");

var $dCAsn = parcelRequire("dCAsn");

var $dlucd = parcelRequire("dlucd");

var $blQsS = parcelRequire("blQsS");

var $9tjMO = parcelRequire("9tjMO");

var $1CRHx = parcelRequire("1CRHx");

var $jZA09 = parcelRequire("jZA09");

var $hM2B6 = parcelRequire("hM2B6");

var $7Zbvr = parcelRequire("7Zbvr");
const $cc70575b2203e361$var$getPageVisibleState = ()=>{
    return !(0, $1CRHx.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, $blQsS.PageVisibleState).VISIBLE : (0, $blQsS.PageVisibleState).HIDDEN;
};
const $cc70575b2203e361$export$c753e8669d30c8ad = (timestamp)=>{
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $9tjMO.roundPerfNow)();
};
class $cc70575b2203e361$export$d31c89db257648c {
    constructor(id, config, instanceId = null){
        this.state = (0, $jZA09.UFOExperienceState).NOT_STARTED;
        this.instanceId = null // for concurrent
        ;
        this.parent = null;
        this.category = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.explicitTimings = {};
        // @todo move to page load experience when proper classes/inheritance prepared
        this.isSSROutputAsFMP = false;
        this.uuid = null;
        this._until = null;
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this.performanceConfig = {};
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = (0, $blQsS.PageVisibleState).MIXED;
            (0, $dlucd.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        };
        this.id = id;
        this.category = config?.category || null;
        this.until = config?.until || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $cc70575b2203e361$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $7Zbvr.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $7Zbvr.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
    async transition(newState, timestamp) {
        (0, $dCAsn.ufolog)('async transition', this.id, this.state.id, newState.id);
        if ((0, $hM2B6.canTransition)(this.state, newState)) {
            (0, $dCAsn.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} successful`, this.state.final, !newState.final);
            if (newState === (0, $jZA09.UFOExperienceState).STARTED) this._reset();
            if (this.state.final && !newState.final) {
                this.metrics.startTime = $cc70575b2203e361$export$c753e8669d30c8ad(timestamp);
                this.uuid = (0, $7Jxgt.v4)();
            }
            this.state = newState;
            if (newState.final) {
                this.metrics.endTime = $cc70575b2203e361$export$c753e8669d30c8ad(timestamp);
                if (!this._isManualStateEnabled()) (0, $1vlV8.getGlobalEventStream)().push((0, $1vlV8.unsubscribeEvent)((0, $blQsS.SUBSCRIBE_ALL), this.handleDoneBind));
                const data = await this.exportData();
                (0, $dCAsn.ufolog)('this.parent', this.parent);
                (0, $1vlV8.getGlobalEventStream)().push((0, $1vlV8.experiencePayloadEvent)(data));
            }
            return true;
        }
        (0, $dCAsn.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} unsuccessful`);
        (0, $dCAsn.ufowarn)(`transition of ${this.id} from ${this.state} to ${newState} is not possible`);
        return false;
    }
    async start(startTime) {
        const transitionSuccessful = await this.transition((0, $jZA09.UFOExperienceState).STARTED, startTime);
        if (transitionSuccessful) {
            this.pageVisibleState = $cc70575b2203e361$var$getPageVisibleState();
            (0, $dlucd.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
            if (!this._isManualStateEnabled()) {
                (0, $dCAsn.ufolog)('subscribed', this.id);
                (0, $1vlV8.getGlobalEventStream)().push((0, $1vlV8.subscribeEvent)((0, $blQsS.SUBSCRIBE_ALL), this.handleDoneBind));
            }
        }
    }
    mark(name, timestamp) {
        if (name !== (0, $blQsS.FMP_MARK) && name !== (0, $blQsS.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
        else (0, $dCAsn.ufowarn)('please use markFMP or markInlineResponse for specialised marks');
    }
    _mark(name, timestamp) {
        this.metrics.marks.push({
            name: name,
            time: $cc70575b2203e361$export$c753e8669d30c8ad(timestamp)
        });
        this.transition((0, $jZA09.UFOExperienceState).IN_PROGRESS);
    }
    markFMP(timestamp) {
        this._mark((0, $blQsS.FMP_MARK), timestamp);
    }
    markInlineResponse(timestamp) {
        this._mark((0, $blQsS.INLINE_RESPONSE_MARK), timestamp);
    }
    _isManualStateEnabled() {
        return this.until === null;
    }
    _validateManualState() {
        if (!this._isManualStateEnabled()) {
            (0, $dCAsn.ufowarn)('manual change of state not allowed as "until" is defined');
            return false;
        }
        return true;
    }
    switchToEndState(state, config) {
        if (!config?.force && !this._validateManualState()) return null;
        if (config?.metadata) this.addMetadata(config.metadata);
        (0, $dlucd.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        return this.transition(state);
    }
    async success(config) {
        return this.switchToEndState((0, $jZA09.UFOExperienceState).SUCCEEDED, config);
    }
    async failure(config) {
        return this.switchToEndState((0, $jZA09.UFOExperienceState).FAILED, config);
    }
    async abort(config) {
        return this.switchToEndState((0, $jZA09.UFOExperienceState).ABORTED, config);
    }
    addMetadata(data) {
        Object.assign(this.metadata, data);
    }
    _handleDoneExperience(data) {
        (0, $dCAsn.ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
        if (data.state.final) {
            if (this._until !== null) {
                const { done: done, state: state } = this._until(data);
                if (done && !this.state.final) this.transition(state);
            }
        }
    }
    async getId() {
        return this.id;
    }
    async exportData() {
        return {
            id: await this.getId(),
            uuid: this.uuid,
            type: this.type,
            schemaVersion: (0, $bbbd8b5766b053fb$export$2295b861f318254a) || 'unknown',
            performanceType: this.performanceType,
            category: this.category,
            state: this.state,
            metadata: {
                ...this.metadata
            },
            metrics: {
                ...this.metrics
            },
            children: [
                ...this.childExperiences
            ],
            result: {
                success: !!this.state.success,
                startTime: this.metrics.startTime,
                duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
            },
            platform: this.config.platform || null,
            pageVisibleState: this.pageVisibleState,
            featureFlags: this.featureFlags,
            isSSROutputAsFMP: this.isSSROutputAsFMP,
            timings: this.timings,
            explicitTimings: this.explicitTimings,
            performanceConfig: this.performanceConfig
        };
    }
    _reset() {
        this.parent = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this._until = this.until ? this.until() : null;
    }
}

});
// temp solution until we can get it automated
const $bbbd8b5766b053fb$export$2295b861f318254a = '0.1.5';

parcelRegister("1vlV8", function(module, exports) {

$parcel$export(module.exports, "getGlobalEventStream", () => $d117cb8be5e8747a$export$6123a44dc2384540);
$parcel$export(module.exports, "subscribeEvent", () => $d117cb8be5e8747a$export$37863216db4b714d);
$parcel$export(module.exports, "unsubscribeEvent", () => $d117cb8be5e8747a$export$ee1a7bd1fc9ea85e);
$parcel$export(module.exports, "experiencePayloadEvent", () => $d117cb8be5e8747a$export$7c957416596ca127);

var $dCAsn = parcelRequire("dCAsn");

var $blQsS = parcelRequire("blQsS");
const $d117cb8be5e8747a$var$MAX_EARLY_QUEUE_LENGTH = 250;
const $d117cb8be5e8747a$export$6123a44dc2384540 = ()=>{
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        const earlyStream = (()=>{
            const stream = [];
            return {
                __buffer_only__: true,
                push: (event)=>{
                    if (stream.length < $d117cb8be5e8747a$var$MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                },
                getStream: ()=>stream
            };
        })();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};
const $d117cb8be5e8747a$export$c1522520b417b066 = (eventStream)=>{
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) {
        (0, $dCAsn.ufowarn)('Global Event Stream already initialised. Ignoring new event stream setup');
        return;
    }
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
    globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
};
const $d117cb8be5e8747a$export$37863216db4b714d = (experienceId, callback)=>{
    return {
        type: (0, $blQsS.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $d117cb8be5e8747a$export$ee1a7bd1fc9ea85e = (experienceId, callback)=>{
    return {
        type: (0, $blQsS.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $d117cb8be5e8747a$export$7c957416596ca127 = (data)=>{
    return {
        type: (0, $blQsS.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};

});
parcelRegister("dCAsn", function(module, exports) {

$parcel$export(module.exports, "ufolog", () => $c8856379f9e2d7e8$export$b4958caff08a0960);
$parcel$export(module.exports, "ufowarn", () => $c8856379f9e2d7e8$export$d53d07b6034c4560);
class $c8856379f9e2d7e8$var$UFOLogger {
    static{
        this.UFOprefix = "[ufo\uD83D\uDEF8]";
    }
    log(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.log($c8856379f9e2d7e8$var$UFOLogger.UFOprefix, ...args);
    }
    warn(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.warn($c8856379f9e2d7e8$var$UFOLogger.UFOprefix, ...args);
    }
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
    constructor(){
        this.enabled = false;
    }
}
const $c8856379f9e2d7e8$export$4ab84f6f04f6566d = new $c8856379f9e2d7e8$var$UFOLogger();
const $c8856379f9e2d7e8$export$b4958caff08a0960 = (...args)=>{
    $c8856379f9e2d7e8$export$4ab84f6f04f6566d.log(...args);
};
const $c8856379f9e2d7e8$export$d53d07b6034c4560 = (...args)=>{
    $c8856379f9e2d7e8$export$4ab84f6f04f6566d.warn(...args);
};

});

parcelRegister("blQsS", function(module, exports) {

$parcel$export(module.exports, "UFOGlobalEventStreamEventType", () => $2d245cff606eb60d$export$96253c35c37cf96b);
$parcel$export(module.exports, "PageVisibleState", () => $2d245cff606eb60d$export$a12c67b37a306b13);
$parcel$export(module.exports, "SUBSCRIBE_ALL", () => $2d245cff606eb60d$export$79bf131685ad41d7);
$parcel$export(module.exports, "FMP_MARK", () => $2d245cff606eb60d$export$9f2bf58999404c75);
$parcel$export(module.exports, "INLINE_RESPONSE_MARK", () => $2d245cff606eb60d$export$837e0f79a8056912);
var $2d245cff606eb60d$export$96253c35c37cf96b = /*#__PURE__*/ function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
    return UFOGlobalEventStreamEventType;
}({});
var $2d245cff606eb60d$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
    return PageVisibleState;
}({});
var $2d245cff606eb60d$export$66b33c055cbb625e = /*#__PURE__*/ function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
    return PageLoadMetrics;
}({});
var $2d245cff606eb60d$export$3ce489cbe02dc21b = /*#__PURE__*/ function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
    return PageSegmentLoadMetrics;
}({});
var $2d245cff606eb60d$export$341b330828bd3906 = /*#__PURE__*/ function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
    return InteractionMetrics;
}({});
var $2d245cff606eb60d$export$b9b20160f581e4f8 = /*#__PURE__*/ function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
    return CustomMetrics;
}({});
const $2d245cff606eb60d$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
const $2d245cff606eb60d$export$9f2bf58999404c75 = 'fmp';
const $2d245cff606eb60d$export$837e0f79a8056912 = 'inline-response';

});


parcelRegister("dlucd", function(module, exports) {

$parcel$export(module.exports, "visibilityChangeObserver", () => $46b8336a04974a29$export$13e680397ec8f3eb);

var $1CRHx = parcelRequire("1CRHx");
class $46b8336a04974a29$var$VisibilityChangeObserver {
    start() {
        if (this.started) return;
        this.started = true;
        document.addEventListener('visibilitychange', this.broadcast);
        /**
		 * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
		 * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
		 * so for that case, you need to also include code to listen for the pagehide event.
		 */ if ((0, $1CRHx.isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.started = false;
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $46b8336a04974a29$export$13e680397ec8f3eb = new $46b8336a04974a29$var$VisibilityChangeObserver();

});
parcelRegister("1CRHx", function(module, exports) {

$parcel$export(module.exports, "isWindowObjectAvailable", () => $5d24ea5e24f61a4f$export$15e172712955e18f);
const $5d24ea5e24f61a4f$export$15e172712955e18f = ()=>{
    return typeof window !== 'undefined';
};

});


parcelRegister("9tjMO", function(module, exports) {

$parcel$export(module.exports, "roundPerfNow", () => $29608d3bcf65c265$export$5f490af6b2b115cf);
const $29608d3bcf65c265$export$5f490af6b2b115cf = ()=>~~performance.now();

});

parcelRegister("jZA09", function(module, exports) {

$parcel$export(module.exports, "UFOExperienceState", () => $175f7a63840c5fab$export$81b70111112841a0);
const $175f7a63840c5fab$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};

});

parcelRegister("hM2B6", function(module, exports) {

$parcel$export(module.exports, "canTransition", () => $6edf4365ea9733d4$export$178881f329fdb81f);

var $jZA09 = parcelRequire("jZA09");
const $6edf4365ea9733d4$var$UFOStateAvailableTransitions = {
    [(0, $jZA09.UFOExperienceState).NOT_STARTED.id]: [
        (0, $jZA09.UFOExperienceState).STARTED.id
    ],
    [(0, $jZA09.UFOExperienceState).STARTED.id]: [
        (0, $jZA09.UFOExperienceState).IN_PROGRESS.id,
        (0, $jZA09.UFOExperienceState).BLOCKED.id,
        (0, $jZA09.UFOExperienceState).SUCCEEDED.id,
        (0, $jZA09.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $jZA09.UFOExperienceState).FAILED.id,
        (0, $jZA09.UFOExperienceState).ABORTED.id
    ],
    [(0, $jZA09.UFOExperienceState).IN_PROGRESS.id]: [
        (0, $jZA09.UFOExperienceState).BLOCKED.id,
        (0, $jZA09.UFOExperienceState).SUCCEEDED.id,
        (0, $jZA09.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $jZA09.UFOExperienceState).FAILED.id,
        (0, $jZA09.UFOExperienceState).ABORTED.id
    ],
    [(0, $jZA09.UFOExperienceState).BLOCKED.id]: [
        (0, $jZA09.UFOExperienceState).RECOVERED.id,
        (0, $jZA09.UFOExperienceState).ABORTED.id
    ],
    [(0, $jZA09.UFOExperienceState).RECOVERED.id]: [
        (0, $jZA09.UFOExperienceState).STARTED.id,
        (0, $jZA09.UFOExperienceState).SUCCEEDED.id,
        (0, $jZA09.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $jZA09.UFOExperienceState).FAILED.id,
        (0, $jZA09.UFOExperienceState).ABORTED.id
    ],
    [(0, $jZA09.UFOExperienceState).SUCCEEDED.id]: [
        (0, $jZA09.UFOExperienceState).STARTED.id
    ],
    [(0, $jZA09.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id]: [
        (0, $jZA09.UFOExperienceState).SUCCEEDED.id,
        (0, $jZA09.UFOExperienceState).FAILED.id,
        (0, $jZA09.UFOExperienceState).ABORTED.id
    ],
    [(0, $jZA09.UFOExperienceState).FAILED.id]: [
        (0, $jZA09.UFOExperienceState).STARTED.id
    ],
    [(0, $jZA09.UFOExperienceState).ABORTED.id]: [
        (0, $jZA09.UFOExperienceState).STARTED.id
    ]
};
const $6edf4365ea9733d4$export$178881f329fdb81f = (state1, state2)=>{
    return $6edf4365ea9733d4$var$UFOStateAvailableTransitions[state1.id] && $6edf4365ea9733d4$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};

});



parcelRegister("139Gm", function(module, exports) {

$parcel$export(module.exports, "createErrorMetadata", () => $07d4c8a32da63d6e$export$7286a0fb7b5aab6b);
$parcel$export(module.exports, "isIgnoredError", () => $07d4c8a32da63d6e$export$a8da197a8bcc7e95);

var $1K4T6 = parcelRequire("1K4T6");
const $07d4c8a32da63d6e$export$7286a0fb7b5aab6b = (error)=>({
        error: {
            name: error.name,
            message: error.message,
            stack: error.stack,
            traceId: error instanceof (0, $1K4T6.HttpError) ? error.traceId : undefined,
            status: error instanceof (0, $1K4T6.HttpError) ? error.status : undefined
        }
    });
const $07d4c8a32da63d6e$var$ignoredErrors = [
    'SLOIgnoreError',
    'SLOIgnoreHttpError'
];
const $07d4c8a32da63d6e$export$a8da197a8bcc7e95 = (error)=>{
    const errorName = error?.constructor.name;
    if (!errorName) return false;
    return $07d4c8a32da63d6e$var$ignoredErrors.includes(errorName);
};

});



parcelRegister("gTh2z", function(module, exports) {

$parcel$export(module.exports, "aggClient", () => $68dbf55e48e6d3f1$export$464c991dbf0b2393);

var $7FbBq = parcelRequire("7FbBq");

var $aOgFy = parcelRequire("aOgFy");

var $cPPyF = parcelRequire("cPPyF");

var $6laLp = parcelRequire("6laLp");

var $7KcJC = parcelRequire("7KcJC");

var $iPviR = parcelRequire("iPviR");

var $dEcp8 = parcelRequire("dEcp8");
class $68dbf55e48e6d3f1$export$b44e5dafe13af7b3 extends (0, $cPPyF.BaseGraphQlClient) {
    constructor(baseUrl, config){
        super(`${baseUrl}/graphql`, config);
    }
    setBaseUrl(baseUrl) {
        this.setServiceUrl(`${baseUrl}/graphql`);
    }
    async queryTeamMemberships(teamId, membershipState = [
        'FULL_MEMBER'
    ], pageInfo = {
        first: 100
    }) {
        const response = await this.makeGraphQLRequest({
            query: (0, $7KcJC.default),
            variables: {
                teamId: teamId,
                membershipState: membershipState,
                siteId: this.getCloudId(),
                ...pageInfo
            }
        }, {
            operationName: 'TeamMembership'
        });
        return {
            edges: response.team.teamV2.members.edges.map(({ node: node })=>({
                    membershipId: {
                        teamId: teamId,
                        memberId: (0, $7FbBq.toUserId)(node.member.id)
                    },
                    state: node.state,
                    role: node.role,
                    user: {
                        id: (0, $7FbBq.toUserId)(node.member.id),
                        fullName: node.member.name,
                        avatarUrl: node.member.picture,
                        status: node.member.accountStatus,
                        title: node.member.extendedProfile?.jobTitle ?? undefined,
                        userType: (0, $dEcp8.toUserType)({
                            appType: node.member.appType
                        })
                    }
                })),
            pageInfo: response.team.teamV2.members.pageInfo
        };
    }
    async queryAGGUser(userId) {
        const response = await this.makeGraphQLRequest({
            query: (0, $iPviR.TeamsUserQuery),
            variables: {
                userId: userId
            }
        }, {
            operationName: 'TeamsUserQuery'
        });
        return response.user;
    }
}
const $68dbf55e48e6d3f1$export$464c991dbf0b2393 = new $68dbf55e48e6d3f1$export$b44e5dafe13af7b3((0, $aOgFy.DEFAULT_CONFIG).stargateRoot, {
    logException: $6laLp.logException
});

});
parcelRegister("7FbBq", function(module, exports) {

$parcel$export(module.exports, "toUserId", () => $17ec50633f4e2e7f$export$1d0eef1d33b05366);
$parcel$export(module.exports, "toTeamARI", () => $17ec50633f4e2e7f$export$2bcc6e4924859c6f);

const $17ec50633f4e2e7f$export$caac29844ad91f64 = (ari)=>ari.startsWith((0, $11a0bc56687bdc88$export$470b0d72e4fdc43a));
const $17ec50633f4e2e7f$export$1d0eef1d33b05366 = (ari)=>{
    if ($17ec50633f4e2e7f$export$caac29844ad91f64(ari)) return ari.replace((0, $11a0bc56687bdc88$export$470b0d72e4fdc43a), '');
    throw new Error('Invalid UserARI');
};
const $17ec50633f4e2e7f$export$fca6a88adb58674a = (userId)=>{
    return $17ec50633f4e2e7f$export$caac29844ad91f64(userId) ? userId : `${0, $11a0bc56687bdc88$export$470b0d72e4fdc43a}${userId}`;
};
const $17ec50633f4e2e7f$export$7b81d5dfd83c8166 = (ari)=>ari.startsWith((0, $11a0bc56687bdc88$export$cfedc369802e0c68));
const $17ec50633f4e2e7f$export$e78216c959b9f3af = (ari)=>{
    if ($17ec50633f4e2e7f$export$7b81d5dfd83c8166(ari)) return ari.replace((0, $11a0bc56687bdc88$export$cfedc369802e0c68), '');
    throw new Error('Invalid TeamARI');
};
const $17ec50633f4e2e7f$export$2bcc6e4924859c6f = (teamId)=>{
    return $17ec50633f4e2e7f$export$7b81d5dfd83c8166(teamId) ? teamId : `${0, $11a0bc56687bdc88$export$cfedc369802e0c68}${teamId}`;
};

});
const $11a0bc56687bdc88$export$470b0d72e4fdc43a = 'ari:cloud:identity::user/';
const $11a0bc56687bdc88$export$cfedc369802e0c68 = 'ari:cloud:identity::team/';


parcelRegister("aOgFy", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_CONFIG", () => $63e5f3a0103519a1$export$c2f8e0cc249a8d8f);
const $63e5f3a0103519a1$export$c2f8e0cc249a8d8f = {
    stargateRoot: '/gateway/api',
    permsServiceUrl: '/gateway/api/permissions',
    publicApiRoot: '/gateway/api/public',
    invitationsServiceUrl: '/gateway/api/invitations',
    collaborationGraphUrl: '/gateway/api/collaboration'
};

});

parcelRegister("cPPyF", function(module, exports) {

$parcel$export(module.exports, "BaseGraphQlClient", () => $50423a8c851cd9c1$export$42f6d6baced34b2d);

var $1K4T6 = parcelRequire("1K4T6");

var $cIUqK = parcelRequire("cIUqK");

var $e5X66 = parcelRequire("e5X66");
class $50423a8c851cd9c1$export$42f6d6baced34b2d extends (0, $cIUqK.BaseClient) {
    constructor(serviceUrl, config){
        super(config);
        this.serviceUrl = serviceUrl;
    }
    setServiceUrl(serviceUrl) {
        this.serviceUrl = serviceUrl;
    }
    async makeGraphQLRequest(body, options = {}) {
        try {
            return (0, $e5X66.handleGraphQLRequest)(this.serviceUrl, body, options);
        } catch (error) {
            if (error instanceof (0, $1K4T6.GraphQLError)) throw error;
            this.logException(error, 'UnknownError in GraphQLClient.makeGraphQLRequestWithoutRetries');
            throw new (0, $1K4T6.DefaultError)({});
        }
    }
}

});
parcelRegister("cIUqK", function(module, exports) {

$parcel$export(module.exports, "BaseClient", () => $f6a5ca6563f596bf$export$4f22f74eddb7716a);

var $6laLp = parcelRequire("6laLp");
class $f6a5ca6563f596bf$export$4f22f74eddb7716a {
    constructor(config){
        this.cache = {};
        this.logException = (ex, name, context)=>{
            (0, $6laLp.logException)(ex, name, context);
            this.config.logException(ex, name, context);
        };
        this.config = config;
        this.context = {
            cloudId: 'None'
        };
    }
    setContext(context) {
        this.context = {
            ...context,
            cloudId: context.cloudId || 'None'
        };
    }
    getContext() {
        return this.context;
    }
    /**
	 *
	 * @param localValue is used for backwards compatibility
	 * @returns
	 */ getOrgId(localValue) {
        const orgId = localValue || this.getContext().orgId;
        if (!orgId) {
            const err = new Error('No orgId set');
            this.logException(err, 'No orgId set');
            throw err;
        }
        return orgId;
    }
    /**
	 *
	 * @param localValue is used for backwards compatibility
	 * @returns
	 */ getCloudId(localValue) {
        return localValue || this.getContext().cloudId;
    }
    keyWithContext(key) {
        return `${this.getContext().cloudId}-${this.getContext().orgId ?? 'no-org-id'}-${this.getContext().userId ?? 'no-user-id'}-${key}`;
    }
    // Default expiration is 5 minutes
    cacheValue(key, value, expiryMs = 300000) {
        this.cache[this.keyWithContext(key)] = {
            data: value,
            expiration: Date.now() + expiryMs
        };
    }
    getCachedValue(key) {
        const record = this.cache[this.keyWithContext(key)];
        if (record && record.expiration > Date.now()) return record.data;
        return undefined;
    }
}

});
parcelRegister("6laLp", function(module, exports) {

$parcel$export(module.exports, "logException", () => $b8ae333ac130caf8$export$f86b2a1a2ce291b3);
$parcel$export(module.exports, "logErrorMessage", () => $b8ae333ac130caf8$export$ece28f5cfa04608);
$parcel$export(module.exports, "logInfoMessage", () => $b8ae333ac130caf8$export$386587bcf05ee8ea);
$parcel$export(module.exports, "logExceptionWithPackageContext", () => $b8ae333ac130caf8$export$7208e9272a946c36);
$parcel$export(module.exports, "logErrorMessageWithPackageContext", () => $b8ae333ac130caf8$export$dbd2da61a76fb8d2);
$parcel$export(module.exports, "logInfoMessageWithPackageContext", () => $b8ae333ac130caf8$export$f242834c5699e597);
$parcel$export(module.exports, "createErrorHandlerWithPackageContext", () => $b8ae333ac130caf8$export$6b2a307bf7c6c1dc);
$parcel$export(module.exports, "addBreadcrumb", () => $b8ae333ac130caf8$export$efda9a273d7a036d);
// See Sentry accepted options in here https://docs.sentry.io/error-reporting/configuration/?platform=javascript

var $6jQUd = parcelRequire("6jQUd");
function $b8ae333ac130caf8$var$decorateScope(scope, context) {
    const { tags: tags, ...otherContext } = context;
    if (tags) scope.setTags(tags);
    if (Object.keys(otherContext).length) scope.setExtras(otherContext);
    return scope;
}
async function $b8ae333ac130caf8$export$f86b2a1a2ce291b3(ex, name, context = {}) {
    try {
        const sentryClient = await (0, $6jQUd.getSentryClient)();
        if (!sentryClient || typeof sentryClient.captureException !== 'function') return;
        sentryClient.withScope((scope)=>{
            $b8ae333ac130caf8$var$decorateScope(scope, context);
            scope.setTag('name', name);
            scope.setTag('packageName', context.packageName ?? 'unknown');
            scope.setTag('packageVersion', context.packageVersion ?? 'unknown');
            sentryClient.captureException(ex, scope);
        });
    } catch  {
    // silence sentry exceptions
    }
}
async function $b8ae333ac130caf8$var$logMessage(severity, message, context = {}) {
    const sentryClient = await (0, $6jQUd.getSentryClient)();
    if (!sentryClient || typeof sentryClient.captureException !== 'function') return;
    sentryClient.withScope((scope)=>{
        $b8ae333ac130caf8$var$decorateScope(scope, context);
        // The Severity enum is being replaced by SeverityLevel type in v7 anyway
        scope.setLevel(severity);
        scope.setTag('packageName', context.packageName ?? 'unknown');
        scope.setTag('packageVersion', context.packageVersion ?? 'unknown');
        sentryClient.captureMessage(message, scope);
    });
}
function $b8ae333ac130caf8$export$ece28f5cfa04608(message, context = {}) {
    $b8ae333ac130caf8$var$logMessage('error', message, context).catch(()=>{});
}
function $b8ae333ac130caf8$export$386587bcf05ee8ea(message, context = {}) {
    $b8ae333ac130caf8$var$logMessage('info', message, context).catch(()=>{});
}
const $b8ae333ac130caf8$export$9edc7d6f1c33ddc = (details)=>{
    return (error, message, tags = {})=>{
        $b8ae333ac130caf8$export$f86b2a1a2ce291b3(error, message, {
            tags: {
                ...details,
                ...tags
            }
        });
    };
};
const $b8ae333ac130caf8$export$7208e9272a946c36 = (packageContext)=>(...args)=>{
        // Intentionally not awaiting the promise here as we don't need the result
        $b8ae333ac130caf8$export$f86b2a1a2ce291b3(args[0], args[1], {
            ...args[2],
            packageName: packageContext.packageName,
            packageVersion: packageContext.packageVersion
        });
    };
const $b8ae333ac130caf8$export$dbd2da61a76fb8d2 = (packageContext)=>(...args)=>{
        // Intentionally not awaiting the promise here as we don't need the result
        $b8ae333ac130caf8$export$ece28f5cfa04608(args[0], {
            ...args[1],
            packageName: packageContext.packageName,
            packageVersion: packageContext.packageVersion
        });
    };
const $b8ae333ac130caf8$export$f242834c5699e597 = (packageContext)=>(...args)=>{
        // Intentionally not awaiting the promise here as we don't need the result
        $b8ae333ac130caf8$export$386587bcf05ee8ea(args[0], {
            ...args[1],
            packageName: packageContext.packageName,
            packageVersion: packageContext.packageVersion
        });
    };
const $b8ae333ac130caf8$export$6b2a307bf7c6c1dc = (packageContext)=>(...args)=>$b8ae333ac130caf8$export$9edc7d6f1c33ddc({
            ...args[0],
            packageName: packageContext.packageName,
            packageVersion: packageContext.packageVersion
        });
async function $b8ae333ac130caf8$export$efda9a273d7a036d(crumb) {
    const sentryClient = await (0, $6jQUd.getSentryClient)();
    sentryClient.withScope((scope)=>{
        scope.addBreadcrumb(typeof crumb === 'string' ? {
            message: crumb
        } : crumb);
    });
}

});
parcelRegister("6jQUd", function(module, exports) {

$parcel$export(module.exports, "sentryClient", () => $1a080a899118f506$export$ac71c212168fcd2b);
$parcel$export(module.exports, "setSentryClient", () => $1a080a899118f506$export$7d446c6f4e54de82);
$parcel$export(module.exports, "getSentryClient", () => $1a080a899118f506$export$f553e8b08ef59d31);
$parcel$export(module.exports, "setupSentryClient", () => $1a080a899118f506$export$d8bd0edf6c978788);

var $cESX7 = parcelRequire("cESX7");

var $f90f5 = parcelRequire("f90f5");
let $1a080a899118f506$export$ac71c212168fcd2b;
const $1a080a899118f506$export$7d446c6f4e54de82 = (client)=>{
    $1a080a899118f506$export$ac71c212168fcd2b = client;
};
const $1a080a899118f506$export$f553e8b08ef59d31 = async ()=>{
    if (!$1a080a899118f506$export$ac71c212168fcd2b) await $1a080a899118f506$export$d8bd0edf6c978788({});
    return $1a080a899118f506$export$ac71c212168fcd2b;
};
async function $1a080a899118f506$export$d8bd0edf6c978788({ appName: appName, env: env }) {
    const sentryClient = await $1a080a899118f506$var$requireSentryLib();
    if (!sentryClient) return;
    // initialiseSentry sets the sentry client
    (0, $f90f5.initialiseSentry)(sentryClient, {
        initialScope: {
            tags: {
                renderMode: appName || 'unknown',
                productBuild: // @ts-ignore Jira  - window.BUILD_KEY, confluence - window.__buildInfo
                window.BUILD_KEY || window.__buildInfo?.FRONTEND_VERSION || 'unknown',
                product: $1a080a899118f506$var$getProduct()
            }
        },
        env: env,
        noGlobals: true,
        dsn: (0, $cESX7.SENTRY_DSN),
        attachStacktrace: true
    });
}

async function $1a080a899118f506$var$requireSentryLib() {
    // saving ~40K
    try {
        return (parcelRequire("61QSy"));
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn('Ignoring rejected promise when loading sentry resource.', error);
    }
}
function $1a080a899118f506$var$getProduct() {
    const path = window.location.pathname;
    if (path.includes('/jira/people')) return 'jira';
    else if (path.includes('/wiki/people')) return 'confluence';
    return 'unknown';
}

});
parcelRegister("cESX7", function(module, exports) {

$parcel$export(module.exports, "SENTRY_DSN", () => $7172257c54583cfa$export$6faa4a850bc4d0ce);

var $c04PQ = parcelRequire("c04PQ");
const $7172257c54583cfa$export$9cf97fd92bea5d81 = '1dc056d49dfe4df8961dc1b810e4620d';
const $7172257c54583cfa$export$68c35ed3898e185a = '5988845';
const $7172257c54583cfa$export$b03be5cdb5af5197 = '067abcc494be9a87b3cdf9416f2b97d5';
const $7172257c54583cfa$export$97db6664a1e55fa6 = '47';
const $7172257c54583cfa$var$SENTRY_COMMERCIAL_DSN = `https://${$7172257c54583cfa$export$9cf97fd92bea5d81}@o55978.ingest.sentry.io/${$7172257c54583cfa$export$68c35ed3898e185a}`;
const $7172257c54583cfa$var$SENTRY_FEDRAMP_DSN = `https://${$7172257c54583cfa$export$b03be5cdb5af5197}@sentry.atlassian-us-gov-mod.com/${$7172257c54583cfa$export$97db6664a1e55fa6}`;
const $7172257c54583cfa$export$6faa4a850bc4d0ce = (0, $c04PQ.isFedRamp)() ? $7172257c54583cfa$var$SENTRY_FEDRAMP_DSN : $7172257c54583cfa$var$SENTRY_COMMERCIAL_DSN;

});

parcelRegister("f90f5", function(module, exports) {

$parcel$export(module.exports, "initialiseSentry", () => $bb873a2430dbd9e0$export$357606956af25316);

var $lqMqM = parcelRequire("lqMqM");

var $6jQUd = parcelRequire("6jQUd");
const $bb873a2430dbd9e0$var$DISABLED_INTEGRATIONS = [
    'onerror',
    'onunhandledrejection',
    // In Jira this integration is being initialised twice, resulting in no events being sent to Sentry
    'Dedupe'
];
async function $bb873a2430dbd9e0$export$357606956af25316(client, options) {
    if (0, $6jQUd.sentryClient) return;
    if (!client) return;
    (0, $6jQUd.setSentryClient)(client);
    const sentryConfig = (0, $lqMqM.getSentryConfig)(options);
    (0, $6jQUd.sentryClient).init({
        ...sentryConfig,
        integrations: function(integrations) {
            return integrations.filter(function(integration) {
                return $bb873a2430dbd9e0$var$DISABLED_INTEGRATIONS.indexOf(integration.name) === -1;
            });
        }
    });
}

});
parcelRegister("lqMqM", function(module, exports) {

$parcel$export(module.exports, "getSentryConfig", () => $0ea77fabdacad2ed$export$5580e6304e95c792);

var $cESX7 = parcelRequire("cESX7");
const $0ea77fabdacad2ed$var$DEFAULT_SENTRY_CONFIG = {
    whitelistUrls: [
        /atl-paas.net/,
        // test local host
        /localhost/
    ],
    ignoreErrors: [
        /^SentryIgnore:/,
        // Network related errors
        'The operation was aborted',
        'Software caused connection abort',
        'GraphQL error: Failed to fetch',
        'TypeError: Failed to fetch',
        'TypeError: NetworkError when attempting to fetch resource.',
        'AbortError: The user aborted a request.',
        /^network error/i,
        /^network failure/i,
        /^NetworkError/i,
        /^Unexpected token ..*/
    ],
    ignoreUrls: [
        // Chrome extensions
        /extensions\//i,
        /^chrome:\/\//i
    ],
    dsn: (0, $cESX7.SENTRY_DSN),
    attachStacktrace: true
};
function $0ea77fabdacad2ed$export$5580e6304e95c792(options) {
    const { env: env, version: version, noGlobals: _, ...otherOptions } = options;
    return {
        ...otherOptions,
        ...$0ea77fabdacad2ed$var$DEFAULT_SENTRY_CONFIG,
        // Standalone __VERSION__ is set from `bin/set-release-version.sh`
        // when building to deploy to production
        release: `${"platform-pkg"}@${"0.0.0-use.local"}` || // @ts-ignore Jira  - window.BUILD_KEY
        window.BUILD_KEY || // @ts-ignore Confluence - window.__buildInfo
        window.__buildInfo?.FRONTEND_VERSION || '---',
        environment: env || 'prod'
    };
}

});


parcelRegister("61QSy", function(module, exports) {

let $463bdab5e8d2e224$var$load = (parcelRequire("28QjX"))(4);
module.exports = $463bdab5e8d2e224$var$load("cc1Au").then(()=>parcelRequire('godCI'));

});




parcelRegister("e5X66", function(module, exports) {

$parcel$export(module.exports, "handleGraphQLRequest", () => $dacc5a55576333f2$export$7feffc86760ee7ce);

var $1K4T6 = parcelRequire("1K4T6");

var $4F5SC = parcelRequire("4F5SC");

var $hdjej = parcelRequire("hdjej");
async function $dacc5a55576333f2$export$93d33e3b46bf00e7(serviceUrl, body, options = {}) {
    const operationNameQuery = options.operationName ? `?q=${options.operationName}` : '';
    const errorPolicy = options.errorPolicy || 'none';
    const url = serviceUrl + operationNameQuery;
    const request = fetch(url, {
        method: 'POST',
        headers: new Headers({
            'Content-Type': 'application/json'
        }),
        credentials: 'include',
        body: JSON.stringify(body)
    }).then((res)=>{
        if (res.status < 300 || res.status === 400) return res.json();
        else throw res;
    });
    try {
        const response = await request;
        const errors = response.errors;
        if (errors) {
            if (errorPolicy === 'none') throw (0, $1K4T6.GraphQLError).from(errors);
            else if (errorPolicy === 'all') // Set timeout will postpone error throwing and de-touch it to another event loop,
            // so we can return data along with throwing error
            return new Promise((resolve, reject)=>{
                setTimeout(()=>{
                    reject((0, $1K4T6.GraphQLError).from(errors));
                }, 0);
            });
        }
        return response.data;
    } catch (error) {
        if (error instanceof Response) return {
            response: error
        };
        if (Object(error).hasOwnProperty('response')) throw error;
        return error;
    }
}
async function $dacc5a55576333f2$export$7feffc86760ee7ce(serviceUrl, body, options = {}) {
    const makeGraphQLRequestWithRetries = (0, $4F5SC.withExponentialBackoff)($dacc5a55576333f2$export$93d33e3b46bf00e7, {
        initial: (0, $4F5SC.EXPONENTIAL_BACKOFF_RETRY_POLICY).INITIAL_DELAY,
        jitter: (0, $4F5SC.EXPONENTIAL_BACKOFF_RETRY_POLICY).JITTER,
        max: (0, $4F5SC.EXPONENTIAL_BACKOFF_RETRY_POLICY).MAX_RETRIES,
        retryIf: (data)=>{
            return (0, $4F5SC.isFetchResponse)(data) && (0, $4F5SC.is5xx)(data.response.status);
        }
    });
    const result = await makeGraphQLRequestWithRetries(serviceUrl, body, options);
    const response = result?.response;
    if (response) {
        const status = response.status;
        const statusText = response.statusText;
        const traceId = response.headers.get('atl-traceid');
        (0, $hdjej.handleResponse)(response);
        if (status > 400 && status <= 599) throw new (0, $1K4T6.HttpError)({
            message: statusText,
            status: status,
            traceId: traceId ?? undefined
        });
    }
    return result;
}

});
parcelRegister("4F5SC", function(module, exports) {

$parcel$export(module.exports, "EXPONENTIAL_BACKOFF_RETRY_POLICY", () => $0bcb1394a3249358$export$8f4286bf21155381);
$parcel$export(module.exports, "is5xx", () => $0bcb1394a3249358$export$55b2fbd5d4a32495);
$parcel$export(module.exports, "isFetchResponse", () => $0bcb1394a3249358$export$81f27058be86d7ea);
$parcel$export(module.exports, "withExponentialBackoff", () => $0bcb1394a3249358$export$20eaa22f2295996f);
$parcel$export(module.exports, "fetchWithExponentialBackoff", () => $0bcb1394a3249358$export$b4c0bf5325504bf3);
const $0bcb1394a3249358$export$8f4286bf21155381 = {
    INITIAL_DELAY: 200,
    MAX_RETRIES: 5,
    JITTER: true
};
function $0bcb1394a3249358$export$55b2fbd5d4a32495(status) {
    return 500 <= status && status <= 599;
}
function $0bcb1394a3249358$export$81f27058be86d7ea(data) {
    if (!data || !data.hasOwnProperty('response')) return false;
    return data.response instanceof Response;
}
// tslint:disable-next-line no-any
const $0bcb1394a3249358$var$defaultRetryIfCallback = (a)=>!a;
const $0bcb1394a3249358$var$defaultOptions = {
    initial: 200,
    jitter: false,
    max: 5,
    retryIf: $0bcb1394a3249358$var$defaultRetryIfCallback
};
function $0bcb1394a3249358$export$20eaa22f2295996f(toTry, hofOptions = $0bcb1394a3249358$var$defaultOptions) {
    const { initial: initial, jitter: jitter, max: max, retryIf: retryIf } = hofOptions;
    // Initialize max retry decrementing counter (range of max...0)
    let attemptsRemaining = max;
    // Initialize delay. This will exponentially increase each retry (delay = intial * 2^n)
    let delay = initial;
    /**
	 * This function calls itself recursively until `retryIf` evaluates false or the retry limit is reached.
	 * The functioned-to-be-retried is called on each recursion.
	 */ return async function tryWithExponentialBackoff(...args) {
        // "An attempt was made"
        const result = await toTry(...args);
        --attemptsRemaining;
        // If tried function was unsuccessful and there are still retries remaining, retry!
        if (retryIf && retryIf(result) && attemptsRemaining > 0) {
            // Wait for delay
            await new Promise((resolve)=>setTimeout(resolve, jitter ? Math.random() * delay : delay));
            // Exponentially increase delay
            delay *= 2;
            // Initiate retry
            return tryWithExponentialBackoff(...args);
        }
        // Return result of tried function if it is successful or if the retry limit
        // was reached regardless of success.
        return result;
    };
}
const $0bcb1394a3249358$export$b4c0bf5325504bf3 = $0bcb1394a3249358$export$20eaa22f2295996f((url, init)=>fetch(url, init), {
    initial: $0bcb1394a3249358$export$8f4286bf21155381.INITIAL_DELAY,
    jitter: $0bcb1394a3249358$export$8f4286bf21155381.JITTER,
    max: $0bcb1394a3249358$export$8f4286bf21155381.MAX_RETRIES,
    retryIf: (response)=>$0bcb1394a3249358$export$55b2fbd5d4a32495(response.status)
});

});

parcelRegister("hdjej", function(module, exports) {

$parcel$export(module.exports, "handleResponse", () => $9c1b9c6605e9f581$export$c113a67a6762ad2e);
/**
 * Our REST clients are initialised when their module loads which makes it tricky for them to consume the `statusCodeHandlers` prop passed to App from the host application.
 * This is a temporary measure to enable the clients to consume `statusCodeHandlers`.
 * The long term solution is to replace our REST clients with Apollo client custom resolvers
 * This will unify all remote data handling under the apollo-client module which is able to easily receive `statusCodeHandlers` as it is initialised within the React portion of our app.
 */ const $9c1b9c6605e9f581$export$8c005e458e12d501 = {
    handlers: {},
    get () {
        return $9c1b9c6605e9f581$export$8c005e458e12d501.handlers;
    },
    setHandlers (handlers) {
        $9c1b9c6605e9f581$export$8c005e458e12d501.handlers = handlers;
    }
};
function $9c1b9c6605e9f581$export$c113a67a6762ad2e(response) {
    const { status: status } = response;
    const handler = $9c1b9c6605e9f581$export$8c005e458e12d501.get()[status];
    if (typeof handler === 'function') handler(response);
}

});



parcelRegister("7KcJC", function(module, exports) {

$parcel$export(module.exports, "default", () => $db20d2370669efd9$export$2e2bcd8739ae039);
const $db20d2370669efd9$var$TeamMembershipQuery = `query app_user_characteristics($teamId: ID!, $siteId: String!, $membershipState: [TeamMembershipState!]!, $first: Int!, $after: String) {
    team {
      teamV2(
        id: $teamId
        siteId: $siteId
      ) @optIn(to: "Team-v2") {
        members(state: $membershipState, first: $first, after: $after) {
          edges {
            node {
              member {
                id
                name
                picture
                accountStatus
                ... on AtlassianAccountUser {
                  extendedProfile {
                    jobTitle
                  }
                }
                ... on AppUser {
                  appType
                }
              }
              role
              state
            }
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
      }
    }
  }`;
var $db20d2370669efd9$export$2e2bcd8739ae039 = $db20d2370669efd9$var$TeamMembershipQuery;

});

parcelRegister("iPviR", function(module, exports) {

$parcel$export(module.exports, "TeamsUserQuery", () => $35ae14e4e07b2810$export$9963ed3cbf7b791c);

var $1c8Um = parcelRequire("1c8Um");

var $5cllN = parcelRequire("5cllN");
const $35ae14e4e07b2810$export$9963ed3cbf7b791c = (0, $1c8Um.print)((0, $5cllN.default)`
	query TeamsUserQuery($userId: ID!) {
		user(accountId: $userId) {
			id
			name
			picture
			accountStatus
			__typename
			... on AtlassianAccountUser {
				email
				nickname
				locale
				zoneinfo
				extendedProfile {
					jobTitle
					organization
					department
					location
					phoneNumbers {
						type
						value
					}
					closedDate
					inactiveDate
				}
			}
			... on CustomerUser {
				email
				locale
				zoneinfo
			}
			... on AppUser {
				appType
			}
		}
	}
`);

});

parcelRegister("dEcp8", function(module, exports) {

$parcel$export(module.exports, "toUserType", () => $ed1cf12a11d1cbd9$export$6b53fef091c7e27d);
function $ed1cf12a11d1cbd9$export$6b53fef091c7e27d({ isBot: isBot, appType: appType }) {
    // Note, the order of these checks is important
    if (appType?.toLocaleLowerCase() === 'agent') return 'agent';
    if (isBot) return 'bot';
    return 'user';
}

});


parcelRegister("cHmJ2", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a1db79055c7f98d$export$2e2bcd8739ae039);

var $aOgFy = parcelRequire("aOgFy");

var $hrPaF = parcelRequire("hrPaF");
var $6a1db79055c7f98d$var$CONTAINER_TYPE = /*#__PURE__*/ function(CONTAINER_TYPE) {
    CONTAINER_TYPE["JIRA_PROJECT"] = "jiraProject";
    CONTAINER_TYPE["CONFLUENCE_SPACE"] = "confluenceSpace";
    return CONTAINER_TYPE;
}($6a1db79055c7f98d$var$CONTAINER_TYPE || {});
var $6a1db79055c7f98d$var$ENTITY_TYPE = /*#__PURE__*/ function(ENTITY_TYPE) {
    ENTITY_TYPE["CONTAINER"] = "CONTAINER";
    ENTITY_TYPE["USER"] = "USER";
    return ENTITY_TYPE;
}($6a1db79055c7f98d$var$ENTITY_TYPE || {});
class $6a1db79055c7f98d$export$cd5b4a06db0ea4e2 extends (0, $hrPaF.RestClient) {
    getUserContainers({ userId: userId, principalId: principalId, siteId: siteId, sessionId: sessionId, maxNumberOfResults: maxNumberOfResults }) {
        return this.postResource('/v1/collaborationgraph/user/container', {
            context: {
                contextType: 'atlassianDirectory',
                principalId: principalId,
                siteId: siteId,
                sessionId: sessionId
            },
            containerTypes: [
                'confluenceSpace',
                'jiraProject'
            ],
            maxNumberOfResults: maxNumberOfResults,
            userId: userId,
            expanded: true
        });
    }
}
var $6a1db79055c7f98d$export$2e2bcd8739ae039 = new $6a1db79055c7f98d$export$cd5b4a06db0ea4e2({
    serviceUrl: (0, $aOgFy.DEFAULT_CONFIG).collaborationGraphUrl
});

});
parcelRegister("hrPaF", function(module, exports) {

$parcel$export(module.exports, "RestClient", () => $0c6f97fa956e6402$export$ea8b5b3aea9558ce);

var $bxYf9 = parcelRequire("bxYf9");

var $1K4T6 = parcelRequire("1K4T6");

var $4F5SC = parcelRequire("4F5SC");

var $hdjej = parcelRequire("hdjej");

var $cIUqK = parcelRequire("cIUqK");

var $9WYOs = parcelRequire("9WYOs");

var $gnGnQ = parcelRequire("gnGnQ");

var $cKoHA = parcelRequire("cKoHA");

var $3lXoL = parcelRequire("3lXoL");
const $0c6f97fa956e6402$var$defaultFetchOptions = {
    credentials: 'include',
    headers: {
        Accept: 'application/json'
    },
    mode: 'cors'
};
let $0c6f97fa956e6402$var$incrementRedirectCount;
let $0c6f97fa956e6402$var$clearRedirectCount;
$0c6f97fa956e6402$export$7a0fc52d8c359feb();
function $0c6f97fa956e6402$export$7a0fc52d8c359feb() {
    $0c6f97fa956e6402$var$incrementRedirectCount = (0, (/*@__PURE__*/$parcel$interopDefault($bxYf9)))(()=>(0, $9WYOs.setCookie)((0, $9WYOs.REDIRECT_COUNT), (0, $9WYOs.getCookieAsInteger)((0, $9WYOs.REDIRECT_COUNT)) + 1));
    $0c6f97fa956e6402$var$clearRedirectCount = (0, (/*@__PURE__*/$parcel$interopDefault($bxYf9)))(()=>(0, $9WYOs.clearCookie)((0, $9WYOs.REDIRECT_COUNT)));
}
class $0c6f97fa956e6402$export$ea8b5b3aea9558ce extends (0, $cIUqK.BaseClient) {
    constructor({ serviceUrl: serviceUrl = '', config: config = {
        logException: ()=>{}
    } }){
        super(config), /**
	 * This function is necessary for if `statusCodeHandler` prescribes a login
	 * redirect upon a 401 response.
	 * While the default redirect behaviour may be overriden, this function has
	 * been kept separate to ensure it cannot be overriden, lest a host
	 * application supply embeddable-directory with a custom handler that suffers
	 * the infinite redirect bug.
	 */ this.preventInfiniteRedirectLoop = (response)=>{
            if (!response.ok) {
                const responseStatusCode = response.status;
                if (responseStatusCode === 401) $0c6f97fa956e6402$var$incrementRedirectCount();
            } else $0c6f97fa956e6402$var$clearRedirectCount();
        };
        this.serviceUrl = serviceUrl;
    }
    setServiceUrl(serviceUrl) {
        this.serviceUrl = serviceUrl;
    }
    async getResource(path, fetchOptions = {}) {
        return this.makeRequest(path, fetchOptions);
    }
    async getResourceCached(path, fetchOptions = {}, cacheOptions) {
        const cacheKey = path;
        const cacheRecord = this.getCachedValue(cacheKey);
        if (cacheRecord) return cacheRecord;
        const response = await this.getResource(path, fetchOptions);
        this.cacheValue(cacheKey, response, cacheOptions?.expiration);
        return response;
    }
    async postResource(path, data, fetchOptions = {}) {
        return this.postResourceRaw(path, JSON.stringify(data), fetchOptions);
    }
    async postResourceRaw(path, data, fetchOptions = {}) {
        fetchOptions = {
            method: 'post',
            headers: {},
            ...fetchOptions
        };
        if (data) fetchOptions = {
            body: data,
            ...fetchOptions,
            headers: {
                'Content-Type': 'application/json',
                ...fetchOptions.headers
            }
        };
        return this.makeRequest(path, fetchOptions);
    }
    async patchResource(path, data) {
        let fetchOptions = {
            /**
			 * PATCH must be uppercase as per fetch spec only
			 * DELETE, GET, HEAD, OPTIONS, POST, and PUT methods
			 * are normalised to uppercase.
			 *
			 * https://github.com/github/fetch/issues/37
			 * https://fetch.spec.whatwg.org/#methods
			 */ method: 'PATCH'
        };
        if (data) fetchOptions = {
            ...fetchOptions,
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        };
        return this.makeRequest(path, fetchOptions);
    }
    async putResource(path, data, additionalFetchOptions = {}) {
        const fetchOptions = {
            method: 'put'
        };
        if (data) Object.assign(fetchOptions, {
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return this.makeRequest(path, {
            ...fetchOptions,
            ...additionalFetchOptions
        });
    }
    async deleteResource(path, options = {}) {
        const fetchOptions = {
            ...options,
            method: 'delete'
        };
        return this.makeRequest(path, fetchOptions);
    }
    async makeRequest(path, additionalFetchOptions = {
        shouldLogError: (e)=>e.status !== 429
    }) {
        const url = this.serviceUrl + path;
        const options = {
            ...$0c6f97fa956e6402$var$defaultFetchOptions,
            ...additionalFetchOptions
        };
        const response = await (0, $4F5SC.fetchWithExponentialBackoff)(url, options);
        this.preventInfiniteRedirectLoop(response);
        (0, $hdjej.handleResponse)(response);
        const responseStatusCode = response.status;
        const traceId = response.headers.get('atl-traceid');
        if (!response.ok) {
            if (responseStatusCode === 401) throw new (0, $1K4T6.SLOIgnoreError)({
                message: 'Unauthorized Request - incrementing redirect count'
            });
            else {
                const message = await (0, $gnGnQ.parseErrorMessage)(response);
                const httpError = new (0, $1K4T6.HttpError)({
                    message: message,
                    status: responseStatusCode,
                    traceId: traceId ?? undefined,
                    path: path
                });
                if (options.shouldLogError && options.shouldLogError(httpError)) this.logException(httpError, (0, $3lXoL.stripUUIDFromPath)(path), {
                    method: options.method || 'GET',
                    url: url,
                    status: responseStatusCode
                });
                throw httpError;
            }
        }
        return additionalFetchOptions.ignoreResponse ? null : (0, $cKoHA.parseResponse)(response);
    }
}

});
parcelRegister("9WYOs", function(module, exports) {

$parcel$export(module.exports, "REDIRECT_COUNT", () => $bf41c8766f9a88e5$export$f6101897f0230549);
$parcel$export(module.exports, "setCookie", () => $bf41c8766f9a88e5$export$110700823644f4a6);
$parcel$export(module.exports, "getCookieAsInteger", () => $bf41c8766f9a88e5$export$6a289e5003f59269);
$parcel$export(module.exports, "clearCookie", () => $bf41c8766f9a88e5$export$ad3506281d5a5e5d);
const $bf41c8766f9a88e5$export$f6101897f0230549 = 'redirectCount';
const $bf41c8766f9a88e5$export$5a7d8afb87170e45 = 'avatar.csrf.token';
function $bf41c8766f9a88e5$export$110700823644f4a6(key, value) {
    document.cookie = `${key}=${value};path=/;max-age=30`;
}
function $bf41c8766f9a88e5$export$6a289e5003f59269(key, defaultValue = 0) {
    const regex = new RegExp(`${key}=(\\d+)`);
    const result = document.cookie.match(regex);
    return result ? parseInt(result[1], 10) : defaultValue;
}
function $bf41c8766f9a88e5$export$ad3506281d5a5e5d(key) {
    document.cookie = `${key}=doesntmatter;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT`;
}

});

parcelRegister("gnGnQ", function(module, exports) {

$parcel$export(module.exports, "parseErrorMessage", () => $dbd61437f2184940$export$91c32f1b22d29b2d);
async function $dbd61437f2184940$export$91c32f1b22d29b2d(response) {
    let json;
    const text = await response.text();
    try {
        json = JSON.parse(text);
    } catch (err) {
        return text;
    }
    delete json.timestamp; // to dedupe sentry, scrub non-unique 'timestamp' field from the error body
    if (json.error) return `${json.status || 'UNKNOWN_STATUS'} ${json.error || 'MISSING_ERROR_MESSAGE'}`;
    else if (json.status) return `${json.status} MISSING_ERROR_MESSAGE`;
    else if (json.errors) {
        const errs = json.errors.map((error)=>typeof error === 'string' ? error : error.code || error.message || 'MISSING_ERROR_MESSAGE');
        return errs.join('\n - ');
    }
    return JSON.stringify(json);
}

});

parcelRegister("cKoHA", function(module, exports) {

$parcel$export(module.exports, "parseResponse", () => $571f67df8e1c13fb$export$ba14d9a5a581e827);
function $571f67df8e1c13fb$export$ba14d9a5a581e827(response) {
    const responseStatusCode = response.status;
    if (responseStatusCode === 204 || responseStatusCode === 202) return null;
    const contentType = response.headers.get('content-type');
    if (!contentType || contentType.includes('text/html') || contentType.includes('text/plain')) return response.text();
    if (contentType.includes('application/json')) return response.json();
    return null;
}

});

parcelRegister("3lXoL", function(module, exports) {

$parcel$export(module.exports, "stripUUIDFromPath", () => $a95ff77b07a38502$export$6bd073e2c6dda996);
const $a95ff77b07a38502$var$UUID_REGEX = new RegExp(/((\w{4,12}-?)){5}/g);
const $a95ff77b07a38502$export$6bd073e2c6dda996 = (path)=>{
    return path.replace($a95ff77b07a38502$var$UUID_REGEX, '<UUID>');
};

});



parcelRegister("49fYn", function(module, exports) {

$parcel$export(module.exports, "directoryClient", () => $4b31d9e631f37e0f$export$ead519165de472de);

var $aOgFy = parcelRequire("aOgFy");

var $cPPyF = parcelRequire("cPPyF");

var $6laLp = parcelRequire("6laLp");
const $4b31d9e631f37e0f$export$28456d095a642fd = 'internal.browse-users-allowed';
const $4b31d9e631f37e0f$var$buildTeamMembershipQuery = (teamId, membershipState)=>({
        query: `query TeamMembership($teamId: String!, $membershipState: [TeamMembershipStatus]) {
    TeamMembership: TeamMembership(teamId: $teamId, membershipStates: $membershipState) {
      user: profile {
        id,
        fullName,
        title,
        avatarUrl,
        timezone,
        status
      },
      state:membershipStatus,
      role,
      membershipId {
        teamId, memberId
      }
    }
  }`,
        variables: {
            teamId: teamId,
            membershipState: membershipState
        }
    });
const $4b31d9e631f37e0f$var$buildUserQuery = (userId, cloudId)=>({
        query: `query CloudUser($userId: String!, $cloudId: String!) {
    CloudUser(userId: $userId, cloudId: $cloudId) {
      avatarUrl
      id
      fullName
      title
    }
  }`,
        variables: {
            userId: userId,
            cloudId: cloudId
        }
    });
const $4b31d9e631f37e0f$var$delay = (millis)=>new Promise((resolve)=>{
        setTimeout(resolve, millis);
    });
class $4b31d9e631f37e0f$export$c8a50bf6c196fc10 extends (0, $cPPyF.BaseGraphQlClient) {
    constructor(baseUrl, config){
        super(`${baseUrl}/directory/graphql`, config);
    }
    setBaseUrl(baseUrl) {
        this.setServiceUrl(`${baseUrl}/directory/graphql`);
    }
    async queryFeatureFlags(/**
   * @private
   * @deprecated don't need to pass param, value is taken from `this.getCloudId()` instead
   */ cloudId, flags) {
        const queryFeatureFlags = {
            query: `query FeatureFlags($cloudId: String!, $flags: [String]!) {
        FeatureFlags(cloudId: $cloudId, flags: $flags) {
          flag
          enabled
        }
      }`,
            variables: {
                cloudId: this.getCloudId(cloudId),
                flags: flags
            }
        };
        const { FeatureFlags: FeatureFlags } = await this.makeGraphQLRequest(queryFeatureFlags, {
            operationName: 'FeatureFlags'
        });
        return FeatureFlags.map(({ flag: flag, enabled: enabled })=>[
                flag,
                enabled
            ]).reduce((acc, val)=>(acc[val[0]] = val[1], acc), {});
    }
    canRetryError(pendingRetries, error) {
        return pendingRetries > 0 && !!error && typeof error === 'object' && 'category' in error && error.category === 'NotFound';
    }
    /**
   * Get user information of all members of a team
   * @param {string} teamId
   * @returns {Promise}
   * @private
   * @deprecated use AGG instead
   */ queryTeamMemberships(teamId, membershipStatus = [
        'FULL_MEMBER'
    ]) {
        // eslint-disable-next-line no-console
        console.warn('Directory queryTeamMemberships is deprecated, use AGG instead');
        const teamMembershipsQuery = $4b31d9e631f37e0f$var$buildTeamMembershipQuery(teamId, membershipStatus);
        const performRequest = async (pendingRetries = 3, backoffMaxDelay = 2000)=>{
            try {
                return await this.makeGraphQLRequest(teamMembershipsQuery, {
                    operationName: 'TeamMembership'
                });
            } catch (error) {
                if (this.canRetryError(pendingRetries, error)) {
                    await $4b31d9e631f37e0f$var$delay(backoffMaxDelay / pendingRetries);
                    return performRequest(pendingRetries - 1);
                }
                throw error;
            }
        };
        return performRequest().then(({ TeamMembership: TeamMembership })=>TeamMembership);
    }
    /**
   * Get user information of all members of a team
   * @param {string} userId
   * @returns {Promise}
   */ queryUser(userId, /**
   * @private
   * @deprecated don't need to pass param, value is taken from `this.getCloudId()` instead
   */ cloudId) {
        const userQuery = $4b31d9e631f37e0f$var$buildUserQuery(userId, this.getCloudId(cloudId));
        const performRequest = async (pendingRetries = 3, backoffMaxDelay = 2000)=>{
            try {
                return await this.makeGraphQLRequest(userQuery, {
                    operationName: 'CloudUser'
                });
            } catch (error) {
                if (this.canRetryError(pendingRetries, error)) {
                    await $4b31d9e631f37e0f$var$delay(backoffMaxDelay / pendingRetries);
                    return performRequest(pendingRetries - 1);
                }
                throw error;
            }
        };
        return performRequest();
    }
}
const $4b31d9e631f37e0f$export$ead519165de472de = new $4b31d9e631f37e0f$export$c8a50bf6c196fc10((0, $aOgFy.DEFAULT_CONFIG).stargateRoot, {
    logException: $6laLp.logException
});

});

parcelRegister("gnKBB", function(module, exports) {

$parcel$export(module.exports, "default", () => $38997081039c300e$export$2e2bcd8739ae039);

var $aOgFy = parcelRequire("aOgFy");

var $hrPaF = parcelRequire("hrPaF");

var $hcbtx = parcelRequire("hcbtx");
const $38997081039c300e$var$defaultConfig = {
    serviceUrl: `${(0, $aOgFy.DEFAULT_CONFIG).stargateRoot}/users`
};
class $38997081039c300e$export$f9c003efee04f318 extends (0, $hrPaF.RestClient) {
    constructor(config = {}){
        super({
            ...$38997081039c300e$var$defaultConfig,
            ...config
        });
    }
    async getUserManageConfig(userId) {
        return this.getResourceCached(`/${userId}/manage`).then((resp)=>{
            return (0, $hcbtx.transformUserManageConfig)(resp);
        });
    }
    /**
	 * @deprecated
	 * User fetchUserAvatarInfo instead
	 */ async getMyAvatarUploadedStatus(userId) {
        return this.fetchUserAvatarInfo(userId);
    }
    async deleteAvatar(userId) {
        return this.deleteResource(`/${userId}/manage/avatar`);
    }
    async fetchUserAvatarInfo(userId) {
        return this.getResource(`/${userId}/manage/avatar`);
    }
    async updateUser({ id: id, ...user }) {
        return this.patchResource(`/${id}/manage/profile`, (0, $hcbtx.toManageAPIInput)(user));
    }
    async updateUserAvatar({ id: id, fileURI: fileURI }) {
        const fileObject = (0, $hcbtx.dataURItoFile)(fileURI);
        const formData = new FormData();
        formData.append('file', fileObject);
        const response = await this.makeRequest(`/${id}/manage/avatar`, {
            method: 'PUT',
            body: formData
        });
        return response.url;
    }
}
var $38997081039c300e$export$2e2bcd8739ae039 = new $38997081039c300e$export$f9c003efee04f318();

});
parcelRegister("hcbtx", function(module, exports) {

$parcel$export(module.exports, "transformUserManageConfig", () => $e90b5aaa9134b760$export$d7725d3d27b80a68);
$parcel$export(module.exports, "toManageAPIInput", () => $e90b5aaa9134b760$export$7b103107c889cb67);
$parcel$export(module.exports, "dataURItoFile", () => $e90b5aaa9134b760$export$80d19edb7b1ae293);
parcelRequire("fzTVj");
var $iwMEb = parcelRequire("iwMEb");
// Key (left-side) is field name which is used in our app.
// Value (right-side) is field name which is used by data in services
const $e90b5aaa9134b760$var$PROFILE_PROPS_MAP = new Map([
    [
        'id',
        'account_id'
    ],
    [
        'fullName',
        'name'
    ],
    [
        'nickname',
        'nickname'
    ],
    [
        'timezone',
        'zoneinfo'
    ],
    [
        'locale',
        'locale'
    ],
    [
        'avatarUrl',
        'picture'
    ],
    [
        'email',
        'email'
    ]
]);
// Key (left-side) is field name which is used in our app.
// Value (right-side) is field name which is used by data in services
const $e90b5aaa9134b760$var$EXTENDED_PROFILE_PROPS_MAP = new Map([
    [
        'title',
        'job_title'
    ],
    [
        'department',
        'department'
    ],
    [
        'companyName',
        'organization'
    ],
    [
        'location',
        'location'
    ],
    [
        'phoneNumber',
        'phone_number'
    ]
]);
const $e90b5aaa9134b760$export$5299664357e4f3dd = (res)=>{
    const data = res.account;
    const extendedData = data && data.extended_profile || {};
    if (!data) return null;
    const timeZone = data.zoneinfo;
    const localTime = ({ format: format })=>{
        if (!timeZone) return null;
        try {
            return (0, $iwMEb.default)(new Date(), timeZone, format);
        } catch (error) {
            // TODO: PTC-4908 send error to sentry for reporting
            return null;
        }
    };
    const profileProps = Array.from($e90b5aaa9134b760$var$PROFILE_PROPS_MAP.keys()).reduce((acc, key)=>{
        if ($e90b5aaa9134b760$var$PROFILE_PROPS_MAP.has(key)) acc[key] = data[$e90b5aaa9134b760$var$PROFILE_PROPS_MAP.get(key)];
        return acc;
    }, {});
    const extendedProfileProps = Array.from($e90b5aaa9134b760$var$EXTENDED_PROFILE_PROPS_MAP.keys()).reduce((acc, key)=>{
        if ($e90b5aaa9134b760$var$EXTENDED_PROFILE_PROPS_MAP.has(key)) acc[key] = extendedData[$e90b5aaa9134b760$var$EXTENDED_PROFILE_PROPS_MAP.get(key)];
        return acc;
    }, {});
    return {
        ...profileProps,
        ...extendedProfileProps,
        localTime: localTime
    };
};
var $e90b5aaa9134b760$export$ed12481c953b8653 = /*#__PURE__*/ function(FieldType) {
    FieldType["FullName"] = "fullName";
    FieldType["Nickname"] = "nickname";
    FieldType["Title"] = "title";
    FieldType["Department"] = "department";
    FieldType["CompanyName"] = "companyName";
    FieldType["Location"] = "location";
    FieldType["Timezone"] = "timezone";
    FieldType["Email"] = "email";
    FieldType["PhoneNumber"] = "phoneNumber";
    FieldType["Avatar"] = "picture";
    FieldType["Language"] = "language";
    FieldType["LocalTime"] = "localTime";
    FieldType["RemoteWeekdayIndex"] = "remoteWeekdayIndex";
    FieldType["RemoteWeekdayString"] = "remoteWeekdayString";
    FieldType["RemoteTimeString"] = "remoteTimeString";
    return FieldType;
}({});
const $e90b5aaa9134b760$export$78158d2c2c6998d9 = {
    fullName: 'name',
    nickname: 'nickname',
    timezone: 'zoneinfo',
    locale: 'locale',
    email: 'email',
    // extended profile
    title: 'extended_profile.job_title',
    phoneNumber: 'extended_profile.phone_number',
    companyName: 'extended_profile.organization',
    department: 'extended_profile.department',
    location: 'extended_profile.location'
};
const $e90b5aaa9134b760$export$2ff7b92b9e1bb4d2 = {
    email: 'email.initiateChange',
    picture: 'avatar'
};
const $e90b5aaa9134b760$var$getFieldConfig = (data, field)=>{
    if ((field === 'email' || field === 'picture') && $e90b5aaa9134b760$export$2ff7b92b9e1bb4d2[field]) return data[$e90b5aaa9134b760$export$2ff7b92b9e1bb4d2[field]];
    const mappedFieldKey = field in $e90b5aaa9134b760$export$78158d2c2c6998d9 ? $e90b5aaa9134b760$export$78158d2c2c6998d9[field] : undefined;
    if (!mappedFieldKey) return undefined;
    const profileWrite = data['profile.write'];
    return profileWrite[mappedFieldKey];
};
const $e90b5aaa9134b760$var$convertFieldKeyToFieldType = (key)=>{
    // Check if the key can be mapped to a FieldType value
    if (Object.values($e90b5aaa9134b760$export$ed12481c953b8653).includes(key)) return key;
    return undefined;
};
const $e90b5aaa9134b760$var$getMutabilityConstraintFor = (data, field)=>{
    const fieldConfig = $e90b5aaa9134b760$var$getFieldConfig(data, field);
    if (!fieldConfig || fieldConfig.allowed) return undefined;
    const convertedField = $e90b5aaa9134b760$var$convertFieldKeyToFieldType(field);
    if (!convertedField) return undefined;
    const reason = fieldConfig.reason;
    return {
        field: convertedField,
        reason: reason && reason.key || null
    };
};
const $e90b5aaa9134b760$export$d7725d3d27b80a68 = (data)=>({
        mutabilityConstraints: Object.keys($e90b5aaa9134b760$export$78158d2c2c6998d9).map((field)=>$e90b5aaa9134b760$var$getMutabilityConstraintFor(data, field)).filter((constraint)=>constraint !== undefined)
    });
const $e90b5aaa9134b760$export$7b103107c889cb67 = (input)=>{
    const output = {
        extended_profile: {}
    };
    Object.keys(input).forEach((key)=>{
        if ($e90b5aaa9134b760$var$PROFILE_PROPS_MAP.has(key)) output[$e90b5aaa9134b760$var$PROFILE_PROPS_MAP.get(key)] = input[key];
        if ($e90b5aaa9134b760$var$EXTENDED_PROFILE_PROPS_MAP.has(key)) output.extended_profile[$e90b5aaa9134b760$var$EXTENDED_PROFILE_PROPS_MAP.get(key)] = input[key];
    });
    return output;
};
function $e90b5aaa9134b760$export$80d19edb7b1ae293(dataURI, filename = 'untitled') {
    if (dataURI.length === 0) throw new Error('dataURI not found');
    // convert base64/URLEncoded data component to raw binary data held in a string
    const byteString = dataURI.split(',')[0].includes('base64') ? atob(dataURI.split(',')[1]) : decodeURIComponent(dataURI.split(',')[1]);
    // separate out the mime component
    let mimeString;
    try {
        mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    } catch (e) {
        mimeString = 'unknown';
    }
    // write the bytes of the string to a typed array
    const intArray = new Uint8Array(byteString.length);
    for(let i = 0; i < byteString.length; i++)intArray[i] = byteString.charCodeAt(i);
    const blob = new Blob([
        intArray
    ], {
        type: mimeString
    });
    try {
        return new File([
            blob
        ], filename, {
            type: mimeString
        });
    } catch (e) {
        // IE11 and Safari does not support the File constructor.
        return blob;
    }
}

});
parcelRegister("fzTVj", function(module, exports) {

$parcel$export(module.exports, "formatInTimeZone", () => (parcelRequire("iwMEb")).default);
// This file is generated automatically by `scripts/build/indices.js`. Please, don't change it.


var $iwMEb = parcelRequire("iwMEb");





});
parcelRegister("iwMEb", function(module, exports) {

$parcel$export(module.exports, "default", () => $037b1cb35b9ac277$export$2e2bcd8739ae039);

var $fwbX5 = parcelRequire("fwbX5");

var $3bby5 = parcelRequire("3bby5");

var $iEBtW = parcelRequire("iEBtW");
function $037b1cb35b9ac277$export$2e2bcd8739ae039(date, timeZone, formatStr, options) {
    var extendedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($fwbX5)))(options);
    extendedOptions.timeZone = timeZone;
    extendedOptions.originalDate = date;
    return (0, $3bby5.default)((0, $iEBtW.default)(date, timeZone), formatStr, extendedOptions);
}

});
parcelRegister("3bby5", function(module, exports) {

$parcel$export(module.exports, "default", () => $250b5b880d4c3a29$export$2e2bcd8739ae039);

var $aR9Qf = parcelRequire("aR9Qf");

var $5wWnR = parcelRequire("5wWnR");

var $sNI8p = parcelRequire("sNI8p");
var $250b5b880d4c3a29$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function $250b5b880d4c3a29$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var matches = formatStr.match($250b5b880d4c3a29$var$tzFormattingTokensRegExp);
    if (matches) {
        var date = (0, $sNI8p.default)(options.originalDate || dirtyDate, options);
        // Work through each match and replace the tz token in the format string with the quoted
        // formatted time zone so the remaining tokens can be filled in by date-fns#format.
        formatStr = matches.reduce(function(result, token) {
            if (token[0] === "'") return result // This is a quoted portion, matched only to ensure we don't match inside it
            ;
            var pos = result.indexOf(token);
            var precededByQuotedSection = result[pos - 1] === "'";
            var replaced = result.replace(token, "'" + (0, $5wWnR.default)[token[0]](date, token, null, options) + "'");
            // If the replacement results in two adjoining quoted strings, the back to back quotes
            // are removed, so it doesn't look like an escaped quote.
            return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($aR9Qf)))(dirtyDate, formatStr, options);
}

});
parcelRegister("5wWnR", function(module, exports) {

$parcel$export(module.exports, "default", () => $406d3abc4f70c331$export$2e2bcd8739ae039);

var $1nruv = parcelRequire("1nruv");

var $6ZkUj = parcelRequire("6ZkUj");
var $406d3abc4f70c331$var$MILLISECONDS_IN_MINUTE = 60000;
var $406d3abc4f70c331$var$formatters = {
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, localize, options) {
        var timezoneOffset = $406d3abc4f70c331$var$getTimeZoneOffset(options.timeZone, date);
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $406d3abc4f70c331$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                return $406d3abc4f70c331$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $406d3abc4f70c331$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, localize, options) {
        var timezoneOffset = $406d3abc4f70c331$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $406d3abc4f70c331$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                return $406d3abc4f70c331$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $406d3abc4f70c331$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, localize, options) {
        var timezoneOffset = $406d3abc4f70c331$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $406d3abc4f70c331$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $406d3abc4f70c331$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, localize, options) {
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return (0, $1nruv.default)('short', date, options);
            // Long
            case 'zzzz':
            default:
                return (0, $1nruv.default)('long', date, options);
        }
    }
};
function $406d3abc4f70c331$var$getTimeZoneOffset(timeZone, originalDate) {
    var timeZoneOffset = timeZone ? (0, $6ZkUj.default)(timeZone, originalDate, true) / $406d3abc4f70c331$var$MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
    if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
    return timeZoneOffset;
}
function $406d3abc4f70c331$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
function $406d3abc4f70c331$var$formatTimezone(offset, dirtyDelimeter) {
    var delimeter = dirtyDelimeter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = $406d3abc4f70c331$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
    var minutes = $406d3abc4f70c331$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
    return sign + hours + delimeter + minutes;
}
function $406d3abc4f70c331$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + $406d3abc4f70c331$var$addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return $406d3abc4f70c331$var$formatTimezone(offset, dirtyDelimeter);
}
function $406d3abc4f70c331$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + $406d3abc4f70c331$var$addLeadingZeros(minutes, 2);
}
var $406d3abc4f70c331$export$2e2bcd8739ae039 = $406d3abc4f70c331$var$formatters;

});
parcelRegister("1nruv", function(module, exports) {

$parcel$export(module.exports, "default", () => $100d43922c522b8e$export$2e2bcd8739ae039);
/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */ function $100d43922c522b8e$export$2e2bcd8739ae039(length, date, options) {
    var dtf = $100d43922c522b8e$var$getDTF(length, options.timeZone, options.locale);
    return dtf.formatToParts ? $100d43922c522b8e$var$partsTimeZone(dtf, date) : $100d43922c522b8e$var$hackyTimeZone(dtf, date);
}
function $100d43922c522b8e$var$partsTimeZone(dtf, date) {
    var formatted = dtf.formatToParts(date);
    for(var i = formatted.length - 1; i >= 0; --i){
        if (formatted[i].type === 'timeZoneName') return formatted[i].value;
    }
}
function $100d43922c522b8e$var$hackyTimeZone(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, '');
    var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
    return tzNameMatch ? tzNameMatch[0].substr(1) : '';
}
// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function $100d43922c522b8e$var$getDTF(length, timeZone, locale) {
    if (locale && !locale.code) throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
    return new Intl.DateTimeFormat(locale ? [
        locale.code,
        'en-US'
    ] : undefined, {
        timeZone: timeZone,
        timeZoneName: length
    });
}

});

parcelRegister("6ZkUj", function(module, exports) {

$parcel$export(module.exports, "default", () => $5168a8572a4ea5fa$export$2e2bcd8739ae039);

var $lLNDp = parcelRequire("lLNDp");

var $h3kEp = parcelRequire("h3kEp");
var $5168a8572a4ea5fa$var$MILLISECONDS_IN_HOUR = 3600000;
var $5168a8572a4ea5fa$var$MILLISECONDS_IN_MINUTE = 60000;
var $5168a8572a4ea5fa$var$patterns = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function $5168a8572a4ea5fa$export$2e2bcd8739ae039(timezoneString, date, isUtcDate) {
    var token;
    var absoluteOffset;
    // Empty string
    if (!timezoneString) return 0;
    // Z
    token = $5168a8572a4ea5fa$var$patterns.timezoneZ.exec(timezoneString);
    if (token) return 0;
    var hours;
    // ±hh
    token = $5168a8572a4ea5fa$var$patterns.timezoneHH.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        if (!$5168a8572a4ea5fa$var$validateTimezone(hours)) return NaN;
        return -(hours * $5168a8572a4ea5fa$var$MILLISECONDS_IN_HOUR);
    }
    // ±hh:mm or ±hhmm
    token = $5168a8572a4ea5fa$var$patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        hours = parseInt(token[2], 10);
        var minutes = parseInt(token[3], 10);
        if (!$5168a8572a4ea5fa$var$validateTimezone(hours, minutes)) return NaN;
        absoluteOffset = Math.abs(hours) * $5168a8572a4ea5fa$var$MILLISECONDS_IN_HOUR + minutes * $5168a8572a4ea5fa$var$MILLISECONDS_IN_MINUTE;
        return token[1] === '+' ? -absoluteOffset : absoluteOffset;
    }
    // IANA time zone
    if ($5168a8572a4ea5fa$var$isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        var utcDate = isUtcDate ? date : $5168a8572a4ea5fa$var$toUtcDate(date);
        var offset = $5168a8572a4ea5fa$var$calcOffset(utcDate, timezoneString);
        var fixedOffset = isUtcDate ? offset : $5168a8572a4ea5fa$var$fixOffset(date, offset, timezoneString);
        return -fixedOffset;
    }
    return NaN;
}
function $5168a8572a4ea5fa$var$toUtcDate(date) {
    return (0, $h3kEp.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function $5168a8572a4ea5fa$var$calcOffset(date, timezoneString) {
    var tokens = (0, $lLNDp.default)(date, timezoneString);
    // ms dropped because it's not provided by tzTokenizeDate
    var asUTC = (0, $h3kEp.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
    var asTS = date.getTime();
    var over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return asUTC - asTS;
}
function $5168a8572a4ea5fa$var$fixOffset(date, offset, timezoneString) {
    var localTS = date.getTime();
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - offset;
    // Test whether the zone matches the offset for this ts
    var o2 = $5168a8572a4ea5fa$var$calcOffset(new Date(utcGuess), timezoneString);
    // If so, offset didn't change, and we're done
    if (offset === o2) return offset;
    // If not, change the ts by the difference in the offset
    utcGuess -= o2 - offset;
    // If that gives us the local time we want, we're done
    var o3 = $5168a8572a4ea5fa$var$calcOffset(new Date(utcGuess), timezoneString);
    if (o2 === o3) return o2;
    // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
    return Math.max(o2, o3);
}
function $5168a8572a4ea5fa$var$validateTimezone(hours, minutes) {
    return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
var $5168a8572a4ea5fa$var$validIANATimezoneCache = {};
function $5168a8572a4ea5fa$var$isValidTimezoneIANAString(timeZoneString) {
    if ($5168a8572a4ea5fa$var$validIANATimezoneCache[timeZoneString]) return true;
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZoneString
        });
        $5168a8572a4ea5fa$var$validIANATimezoneCache[timeZoneString] = true;
        return true;
    } catch (error) {
        return false;
    }
}

});
parcelRegister("lLNDp", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd947d245dec6ea5$export$2e2bcd8739ae039);
/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */ function $fd947d245dec6ea5$export$2e2bcd8739ae039(date, timeZone) {
    var dtf = $fd947d245dec6ea5$var$getDateTimeFormat(timeZone);
    return dtf.formatToParts ? $fd947d245dec6ea5$var$partsOffset(dtf, date) : $fd947d245dec6ea5$var$hackyOffset(dtf, date);
}
var $fd947d245dec6ea5$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function $fd947d245dec6ea5$var$partsOffset(dtf, date) {
    try {
        var formatted = dtf.formatToParts(date);
        var filled = [];
        for(var i = 0; i < formatted.length; i++){
            var pos = $fd947d245dec6ea5$var$typeToPos[formatted[i].type];
            if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
        }
        return filled;
    } catch (error) {
        if (error instanceof RangeError) return [
            NaN
        ];
        throw error;
    }
}
function $fd947d245dec6ea5$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date);
    var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
    // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
    return [
        parsed[3],
        parsed[1],
        parsed[2],
        parsed[4],
        parsed[5],
        parsed[6]
    ];
}
// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
var $fd947d245dec6ea5$var$dtfCache = {};
function $fd947d245dec6ea5$var$getDateTimeFormat(timeZone) {
    if (!$fd947d245dec6ea5$var$dtfCache[timeZone]) {
        // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
        var testDateFormatted = new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: 'America/New_York',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }).format(new Date('2014-06-25T04:00:00.123Z'));
        var hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
        $fd947d245dec6ea5$var$dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }) : new Intl.DateTimeFormat('en-US', {
            hour12: false,
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    }
    return $fd947d245dec6ea5$var$dtfCache[timeZone];
}

});

parcelRegister("h3kEp", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6a2bc4b1d0fb732$export$2e2bcd8739ae039);
/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */ function $c6a2bc4b1d0fb732$export$2e2bcd8739ae039(fullYear, month, day, hour, minute, second, millisecond) {
    var utcDate = new Date(0);
    utcDate.setUTCFullYear(fullYear, month, day);
    utcDate.setUTCHours(hour, minute, second, millisecond);
    return utcDate;
}

});



parcelRegister("sNI8p", function(module, exports) {

$parcel$export(module.exports, "default", () => $05692d2dadd400c6$export$2e2bcd8739ae039);

var $aSksP = parcelRequire("aSksP");

var $jGQTC = parcelRequire("jGQTC");

var $6ZkUj = parcelRequire("6ZkUj");

var $7koqM = parcelRequire("7koqM");
var $05692d2dadd400c6$var$MILLISECONDS_IN_HOUR = 3600000;
var $05692d2dadd400c6$var$MILLISECONDS_IN_MINUTE = 60000;
var $05692d2dadd400c6$var$DEFAULT_ADDITIONAL_DIGITS = 2;
var $05692d2dadd400c6$var$patterns = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: (0, $7koqM.default)
};
function $05692d2dadd400c6$export$2e2bcd8739ae039(argument, dirtyOptions) {
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    if (argument === null) return new Date(NaN);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? $05692d2dadd400c6$var$DEFAULT_ADDITIONAL_DIGITS : (0, (/*@__PURE__*/$parcel$interopDefault($aSksP)))(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
    else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $05692d2dadd400c6$var$splitDateString(argument);
    var parseYearResult = $05692d2dadd400c6$var$parseYear(dateStrings.date, additionalDigits);
    var year = parseYearResult.year;
    var restDateString = parseYearResult.restDateString;
    var date = $05692d2dadd400c6$var$parseDate(restDateString, year);
    if (isNaN(date)) return new Date(NaN);
    if (date) {
        var timestamp = date.getTime();
        var time = 0;
        var offset;
        if (dateStrings.time) {
            time = $05692d2dadd400c6$var$parseTime(dateStrings.time);
            if (isNaN(time)) return new Date(NaN);
        }
        if (dateStrings.timeZone || options.timeZone) {
            offset = (0, $6ZkUj.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
            if (isNaN(offset)) return new Date(NaN);
        } else {
            // get offset accurate to hour in time zones that change offset
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($jGQTC)))(new Date(timestamp + time));
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($jGQTC)))(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
    } else return new Date(NaN);
}
function $05692d2dadd400c6$var$splitDateString(dateString) {
    var dateStrings = {};
    var parts = $05692d2dadd400c6$var$patterns.dateTimePattern.exec(dateString);
    var timeString;
    if (!parts) {
        parts = $05692d2dadd400c6$var$patterns.datePattern.exec(dateString);
        if (parts) {
            dateStrings.date = parts[1];
            timeString = parts[2];
        } else {
            dateStrings.date = null;
            timeString = dateString;
        }
    } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
    }
    if (timeString) {
        var token = $05692d2dadd400c6$var$patterns.timeZone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timeZone = token[1].trim();
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $05692d2dadd400c6$var$parseYear(dateString, additionalDigits) {
    var patternYYY = $05692d2dadd400c6$var$patterns.YYY[additionalDigits];
    var patternYYYYY = $05692d2dadd400c6$var$patterns.YYYYY[additionalDigits];
    var token;
    // YYYY or ±YYYYY
    token = $05692d2dadd400c6$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
    if (token) {
        var yearString = token[1];
        return {
            year: parseInt(yearString, 10),
            restDateString: dateString.slice(yearString.length)
        };
    }
    // YY or ±YYY
    token = $05692d2dadd400c6$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
    if (token) {
        var centuryString = token[1];
        return {
            year: parseInt(centuryString, 10) * 100,
            restDateString: dateString.slice(centuryString.length)
        };
    }
    // Invalid ISO-formatted year
    return {
        year: null
    };
}
function $05692d2dadd400c6$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    var token;
    var date;
    var month;
    var week;
    // YYYY
    if (dateString.length === 0) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    // YYYY-MM
    token = $05692d2dadd400c6$var$patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!$05692d2dadd400c6$var$validateDate(year, month)) return new Date(NaN);
        date.setUTCFullYear(year, month);
        return date;
    }
    // YYYY-DDD or YYYYDDD
    token = $05692d2dadd400c6$var$patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        var dayOfYear = parseInt(token[1], 10);
        if (!$05692d2dadd400c6$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    // yyyy-MM-dd or YYYYMMDD
    token = $05692d2dadd400c6$var$patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        var day = parseInt(token[2], 10);
        if (!$05692d2dadd400c6$var$validateDate(year, month, day)) return new Date(NaN);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    // YYYY-Www or YYYYWww
    token = $05692d2dadd400c6$var$patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!$05692d2dadd400c6$var$validateWeekDate(year, week)) return new Date(NaN);
        return $05692d2dadd400c6$var$dayOfISOWeekYear(year, week);
    }
    // YYYY-Www-D or YYYYWwwD
    token = $05692d2dadd400c6$var$patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        var dayOfWeek = parseInt(token[2], 10) - 1;
        if (!$05692d2dadd400c6$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $05692d2dadd400c6$var$dayOfISOWeekYear(year, week, dayOfWeek);
    }
    // Invalid ISO-formatted date
    return null;
}
function $05692d2dadd400c6$var$parseTime(timeString) {
    var token;
    var hours;
    var minutes;
    // hh
    token = $05692d2dadd400c6$var$patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(',', '.'));
        if (!$05692d2dadd400c6$var$validateTime(hours)) return NaN;
        return hours % 24 * $05692d2dadd400c6$var$MILLISECONDS_IN_HOUR;
    }
    // hh:mm or hhmm
    token = $05692d2dadd400c6$var$patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(',', '.'));
        if (!$05692d2dadd400c6$var$validateTime(hours, minutes)) return NaN;
        return hours % 24 * $05692d2dadd400c6$var$MILLISECONDS_IN_HOUR + minutes * $05692d2dadd400c6$var$MILLISECONDS_IN_MINUTE;
    }
    // hh:mm:ss or hhmmss
    token = $05692d2dadd400c6$var$patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        var seconds = parseFloat(token[3].replace(',', '.'));
        if (!$05692d2dadd400c6$var$validateTime(hours, minutes, seconds)) return NaN;
        return hours % 24 * $05692d2dadd400c6$var$MILLISECONDS_IN_HOUR + minutes * $05692d2dadd400c6$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    // Invalid ISO-formatted time
    return null;
}
function $05692d2dadd400c6$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    week = week || 0;
    day = day || 0;
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
var $05692d2dadd400c6$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $05692d2dadd400c6$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $05692d2dadd400c6$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $05692d2dadd400c6$var$validateDate(year, month, date) {
    if (month < 0 || month > 11) return false;
    if (date != null) {
        if (date < 1) return false;
        var isLeapYear = $05692d2dadd400c6$var$isLeapYearIndex(year);
        if (isLeapYear && date > $05692d2dadd400c6$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
        if (!isLeapYear && date > $05692d2dadd400c6$var$DAYS_IN_MONTH[month]) return false;
    }
    return true;
}
function $05692d2dadd400c6$var$validateDayOfYearDate(year, dayOfYear) {
    if (dayOfYear < 1) return false;
    var isLeapYear = $05692d2dadd400c6$var$isLeapYearIndex(year);
    if (isLeapYear && dayOfYear > 366) return false;
    if (!isLeapYear && dayOfYear > 365) return false;
    return true;
}
function $05692d2dadd400c6$var$validateWeekDate(year, week, day) {
    if (week < 0 || week > 52) return false;
    if (day != null && (day < 0 || day > 6)) return false;
    return true;
}
function $05692d2dadd400c6$var$validateTime(hours, minutes, seconds) {
    if (hours != null && (hours < 0 || hours >= 25)) return false;
    if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
    if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
    return true;
}

});
parcelRegister("7koqM", function(module, exports) {

$parcel$export(module.exports, "default", () => $555d5a1d4b17cc17$export$2e2bcd8739ae039);
/** Regex to identify the presence of a time zone specifier in a date string */ var $555d5a1d4b17cc17$var$tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
var $555d5a1d4b17cc17$export$2e2bcd8739ae039 = $555d5a1d4b17cc17$var$tzPattern;

});



parcelRegister("iEBtW", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9490987520dece7$export$2e2bcd8739ae039);

var $6ZkUj = parcelRequire("6ZkUj");

var $sNI8p = parcelRequire("sNI8p");
function $d9490987520dece7$export$2e2bcd8739ae039(dirtyDate, timeZone, options) {
    var date = (0, $sNI8p.default)(dirtyDate, options);
    var offsetMilliseconds = (0, $6ZkUj.default)(timeZone, date, true);
    var d = new Date(date.getTime() - offsetMilliseconds);
    var resultDate = new Date(0);
    resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
    return resultDate;
}

});





parcelRegister("7pLOg", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9ae585c7017b5f5$export$2e2bcd8739ae039);

var $aOgFy = parcelRequire("aOgFy");

var $hrPaF = parcelRequire("hrPaF");

var $6laLp = parcelRequire("6laLp");

var $9yQ7J = parcelRequire("9yQ7J");
const $b9ae585c7017b5f5$var$PRODUCT_RECCOMENDATIONS = '/v1/product-recommendations';
const $b9ae585c7017b5f5$var$PRODUCT_JOIN_OR_REQUEST_BULK = '/v1/access-requests/bulk/request';
const $b9ae585c7017b5f5$var$ALL_SUPPORTED_PRODUCTS = [
    'confluence',
    'jira',
    'jira-core',
    'jira-servicedesk',
    'jira-software',
    'jira-incident-manager',
    'jira-product-discovery',
    'opsgenie',
    'statuspage',
    'avocado',
    'townsquare',
    'compass',
    'avp',
    'beacon',
    'mercury'
];
class $b9ae585c7017b5f5$export$3209eb31343f39d extends (0, $hrPaF.RestClient) {
    constructor(serviceUrl, config){
        super({
            serviceUrl: serviceUrl,
            config: config
        });
    }
    async getProductRecommendationsInner(supportedProducts = $b9ae585c7017b5f5$var$ALL_SUPPORTED_PRODUCTS, capabilities) {
        try {
            const orgId = this.getOrgId();
            const queryProducts = supportedProducts && supportedProducts.length > 0 ? supportedProducts : $b9ae585c7017b5f5$var$ALL_SUPPORTED_PRODUCTS;
            const productQueryParams = queryProducts.map((product)=>`product=${product}`).join('&');
            const capabilityQueryParams = capabilities && capabilities.length > 0 ? '&' + capabilities.map((capability)=>`capability=${capability}`).join('&') : '';
            const url = `${$b9ae585c7017b5f5$var$PRODUCT_RECCOMENDATIONS}?orgId=${orgId}&${productQueryParams}${capabilityQueryParams}`;
            return await this.getResource(url);
        } catch (error) {
            this.logException(error, 'An error occurred while getting product recommendations.');
            throw error;
        }
    }
    async getProductRecommendations(supportedProducts = $b9ae585c7017b5f5$var$ALL_SUPPORTED_PRODUCTS, capabilities) {
        // This endpoint may return duplicate resource ARIs with a different mode.
        const result = await this.getProductRecommendationsInner(supportedProducts, capabilities);
        try {
            const deduplicatedResult = (0, $9yQ7J.removeDuplicateRecommendations)(result);
            return deduplicatedResult;
        } catch (error) {
            this.logException(error, 'An error occurred while deduplicating product recommendations.');
            throw error;
        }
    }
    async joinOrRequestDefaultAccessToProductsBulk(simplifiedRequest) {
        if (simplifiedRequest.productAris.length === 0) return Promise.resolve([]);
        try {
            const resources = simplifiedRequest.productAris.map((ari)=>({
                    ari: ari,
                    role: 'product/member'
                }));
            const request = {
                resources: resources,
                note: simplifiedRequest.note,
                accessMode: simplifiedRequest.accessMode,
                source: simplifiedRequest.source
            };
            return await this.postResource($b9ae585c7017b5f5$var$PRODUCT_JOIN_OR_REQUEST_BULK, request);
        } catch (error) {
            this.logException(error, 'An error occurred while joining or requesting access to products.');
            throw error;
        }
    }
}
var // eslint-disable-next-line import/no-anonymous-default-export
$b9ae585c7017b5f5$export$2e2bcd8739ae039 = new $b9ae585c7017b5f5$export$3209eb31343f39d((0, $aOgFy.DEFAULT_CONFIG).invitationsServiceUrl, {
    logException: $6laLp.logException
});

});
parcelRegister("9yQ7J", function(module, exports) {

$parcel$export(module.exports, "removeDuplicateRecommendations", () => $3c835b25600ef74b$export$d9d1c981635dd213);
/**
 * Determines which capability is more desirable.
 * Users desire direct access over request access since it's instant.
 * @returns 0 if equal, -1 if a is more desirable, 1 if b is more desirable.
 */ const $3c835b25600ef74b$var$compareCapability = (a, b)=>{
    if (a === b) return 0;
    return a === 'DIRECT_ACCESS' ? -1 : 1;
};
/**
 * Determines which mode is more desirable.
 * Atlassian prefers to provide open access over domain restricted access.
 * Both of these modes have already been enabled by an admin.
 * If mode is undefined, it is deemed least desirable.
 * @returns 0 if equal, -1 if a is more open, 1 if b is more open.
 */ const $3c835b25600ef74b$var$compareMode = (a, b)=>{
    if (a === b) return 0;
    if (!a) return 1;
    if (!b) return -1;
    return a === 'OPEN' ? -1 : 1;
};
/**
 * Determine if a recommendation is more desirable than another.
 * Atlassian prefers a better capability over any mode setting.
 * The mode will only be compared if the capabilities are equal.
 * If both capability and mode are equal, the recommendations are considered the same.
 *
 * Assumes recommendations have the same resource ID.
 * Do not compare recommendations with different resource IDs, as it does not make sense.
 *
 * @returns 0 if capability and mode are equal, -1 if a is more desirable, 1 if b is more desirable.
 */ const $3c835b25600ef74b$var$compareRecommendations = (a, b)=>{
    if (a.resourceId !== b.resourceId) throw new Error('Recommendations must have the same resource ID');
    if ($3c835b25600ef74b$var$compareCapability(a.capability, b.capability) < 0) return -1;
    else if ($3c835b25600ef74b$var$compareCapability(a.capability, b.capability) > 0) return 1;
    else if ($3c835b25600ef74b$var$compareMode(a.mode, b.mode) < 0) return -1;
    else if ($3c835b25600ef74b$var$compareMode(a.mode, b.mode) > 0) return 1;
    return 0;
};
const $3c835b25600ef74b$var$toRecommendation = (recommendation)=>{
    const { capability: capability, ...rest } = recommendation;
    return {
        ...rest
    };
};
const $3c835b25600ef74b$export$d9d1c981635dd213 = (recommendations)=>{
    const { DIRECT_ACCESS: DIRECT_ACCESS, REQUEST_ACCESS: REQUEST_ACCESS } = recommendations.capability;
    const uniqueRecommendations = {};
    const allRecommendations = [
        ...DIRECT_ACCESS.map((recommendation)=>({
                ...recommendation,
                capability: 'DIRECT_ACCESS'
            })),
        ...REQUEST_ACCESS.map((recommendation)=>({
                ...recommendation,
                capability: 'REQUEST_ACCESS'
            }))
    ];
    allRecommendations.forEach((recommendation)=>{
        const existing = uniqueRecommendations[recommendation.resourceId];
        if (existing && $3c835b25600ef74b$var$compareRecommendations(existing, recommendation) <= 0) return;
        uniqueRecommendations[recommendation.resourceId] = recommendation;
    });
    const allUniqueRecommendations = Object.values(uniqueRecommendations);
    return {
        capability: {
            DIRECT_ACCESS: allUniqueRecommendations.filter((recommendation)=>recommendation.capability === 'DIRECT_ACCESS').map($3c835b25600ef74b$var$toRecommendation),
            REQUEST_ACCESS: allUniqueRecommendations.filter((recommendation)=>recommendation.capability === 'REQUEST_ACCESS').map($3c835b25600ef74b$var$toRecommendation)
        }
    };
};

});


parcelRegister("8MCmh", function(module, exports) {

$parcel$export(module.exports, "defaultLegionClient", () => $2443af7a75778c61$export$95c697fe95d86a77);

var $aOgFy = parcelRequire("aOgFy");

var $hrPaF = parcelRequire("hrPaF");
const $2443af7a75778c61$var$v3UrlPath = `/v3/teams`;
const $2443af7a75778c61$var$v4UrlPath = `/v4/teams`;
class $2443af7a75778c61$export$68a6a391e3cf23be extends (0, $hrPaF.RestClient) {
    constructor(serviceUrl){
        super({
            serviceUrl: serviceUrl
        });
        this.serviceUrlRoot = serviceUrl;
    }
    setRootUrl(url) {
        if (url === this.serviceUrlRoot) return;
        this.serviceUrlRoot = url;
        this.setServiceUrl(url);
    }
    async getTeamById(teamId) {
        const siteId = this.getCloudId();
        const teamResponse = await this.getResource(`${$2443af7a75778c61$var$v4UrlPath}/${this.trimTeamARI(teamId)}?siteId=${siteId}`);
        return this.mapTeamResponseV4ToTeam(teamResponse);
    }
    async getAllTeams(allTeamsQuery) {
        try {
            const orgId = this.getOrgId(allTeamsQuery.orgId);
            const siteId = this.getCloudId();
            const { entities: entities, cursor: cursor } = await this.postResource(`${$2443af7a75778c61$var$v4UrlPath}/search`, {
                organizationId: orgId,
                siteId: siteId,
                limit: allTeamsQuery.limit,
                query: allTeamsQuery.searchQuery,
                cursor: allTeamsQuery.cursor || '',
                sortBy: allTeamsQuery.useDefaultSort ? null : [
                    {
                        field: 'displayName',
                        order: 'asc'
                    }
                ],
                membership: {
                    memberAccountIds: allTeamsQuery.memberAccountIds
                },
                showEmptyTeams: allTeamsQuery.showEmptyTeams
            });
            const teams = entities.map((t)=>this.mapTeamSearchResponseV4ToTeamWithMembership(t));
            return {
                cursor: cursor,
                teams: teams
            };
        } catch (error) {
            this.logException(error, 'getAllTeams');
            return {
                cursor: '',
                teams: [],
                error: error instanceof Error ? error : undefined
            };
        }
    }
    async updateTeamById(teamId, data) {
        const teamResponse = await this.patchResource(`${$2443af7a75778c61$var$v4UrlPath}/${this.trimTeamARI(teamId)}`, data);
        return this.mapTeamResponseV4ToTeam(teamResponse);
    }
    /**
	 * @private
	 * @deprecated use publicApiClient.addUsersToTeam instead
	 */ async inviteUsersToTeam(teamId, users, originQuery) {
        if (!users || users.length === 0) return Promise.resolve([]);
        const emails = [];
        const ids = [];
        users.forEach((user)=>{
            if (user.id) ids.push(user.id);
            else if (user.email) emails.push(user.email);
        });
        const url = `${$2443af7a75778c61$var$v3UrlPath}/ui/${this.trimTeamARI(teamId)}/membership/invite?${this.constructProductOriginParams(originQuery)}`;
        return this.postResource(url, {
            emailAddresses: emails,
            atlassianAccounts: ids
        });
    }
    async getMyTeamMembership(teamId) {
        return this.getResource(`${$2443af7a75778c61$var$v4UrlPath}/${this.trimTeamARI(teamId)}/membership/me?siteId=${this.getCloudId()}`, {
            shouldLogError: (e)=>e.status !== 400
        });
    }
    async getTeamLinksByTeamId(teamId) {
        let siteId = this.getCloudId();
        let response = await this.getResource(`${$2443af7a75778c61$var$v4UrlPath}/${this.trimTeamARI(teamId)}/links?siteId=${siteId}`);
        return this.mapLegionTeamLinksResponseV4ToTeamLinkResponse(response);
    }
    async createTeamLink(teamId, link) {
        const sanitisedTeamLink = {
            contentTitle: link.contentTitle.trim(),
            linkUri: link.linkUri.trim(),
            description: link.description.trim(),
            ...link.creationTime ? {
                creationTime: link.creationTime.trim()
            } : {},
            ...link.teamId ? {
                teamId: link.teamId.trim()
            } : {}
        };
        const response = await this.postResource(`${$2443af7a75778c61$var$v4UrlPath}/${this.trimTeamARI(teamId)}/links`, sanitisedTeamLink);
        return this.mapLegionTeamLinkResponseV4ToTeamLink(response);
    }
    async updateTeamLink(teamId, linkId, { linkUri: linkUri, ...linkFields }) {
        const response = await this.putResource(`${$2443af7a75778c61$var$v4UrlPath}/${this.trimTeamARI(teamId)}/links/${linkId}`, {
            linkUri: linkUri.trim(),
            ...linkFields
        });
        return this.mapLegionTeamLinkResponseV4ToTeamLink(response);
    }
    async deleteTeamLink(teamId, linkId) {
        return this.deleteResource(`${$2443af7a75778c61$var$v4UrlPath}/${this.trimTeamARI(teamId)}/links/${linkId}`);
    }
    async reorderTeamLink(teamId, linkId, newPosition) {
        const queryArgs = `?linkId=${linkId}&newPosition=${newPosition}`;
        return this.postResource(`${$2443af7a75778c61$var$v4UrlPath}/${this.trimTeamARI(teamId)}/links/order${queryArgs}`);
    }
    async getOrgEligibilityForManagedTeams() {
        const orgId = this.getOrgId();
        if (!orgId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'getOrgEligibilityForManagedTeams');
            throw err;
        }
        return this.getResourceCached(`${$2443af7a75778c61$var$v4UrlPath}/org/${orgId}/premium/eligibility`);
    }
    /**
	 * @private
	 * @deprecated in V4, as no invitation status for team membership anymore.
	 */ async acceptTeamInvitation(teamId) {
        return this.postResource(`${$2443af7a75778c61$var$v3UrlPath}/ui/${this.trimTeamARI(teamId)}/membership/accept`);
    }
    /**
	 * @private
	 * @deprecated in V4, as no invitation status for team membership anymore.
	 */ async declineTeamInvitation(teamId) {
        return this.postResource(`${$2443af7a75778c61$var$v3UrlPath}/ui/${this.trimTeamARI(teamId)}/membership/decline`);
    }
    async selfJoinTeam(// TODO Test me
    teamId, originQuery) {
        const url = `${$2443af7a75778c61$var$v4UrlPath}/${this.trimTeamARI(teamId)}/membership/join?${this.constructProductOriginParams(originQuery)}`;
        return this.postResource(url);
    }
    async cancelJoinRequest(teamId) {
        return this.deleteResource(`${$2443af7a75778c61$var$v4UrlPath}/${this.trimTeamARI(teamId)}/membership/request`);
    }
    async acceptJoinRequest(teamId, memberId) {
        return this.postResource(`${$2443af7a75778c61$var$v4UrlPath}/${this.trimTeamARI(teamId)}/membership/${memberId}/request/accept`);
    }
    async declineJoinRequest(teamId, memberId) {
        return this.postResource(`${$2443af7a75778c61$var$v4UrlPath}/${this.trimTeamARI(teamId)}/membership/${memberId}/request/decline`);
    }
    /**
	 * @private
	 * @deprecated use publicApiClient.removeTeamMemberships instead
	 */ async deleteTeamMembership(teamId, memberId) {
        return this.deleteResource(`${$2443af7a75778c61$var$v3UrlPath}/${this.trimTeamARI(teamId)}/members/${memberId}`);
    }
    /**
	 * @private
	 * @deprecated INVITED status has been deprecated
	 */ async revokeTeamInvite(teamId, memberId) {
        return this.deleteResource(`${$2443af7a75778c61$var$v3UrlPath}/ui/${this.trimTeamARI(teamId)}/membership/${memberId}/revoke`);
    }
    async deleteTeam(teamId) {
        return this.deleteResource(`${$2443af7a75778c61$var$v4UrlPath}/${this.trimTeamARI(teamId)}`);
    }
    /**
	 * @private
	 * @deprecated should be other means to solve this issue
	 */ async isSingleFullMemberTeam(teamId) {
        // This is still not working...
        const members = await this.getResource(`${$2443af7a75778c61$var$v4UrlPath}/${this.trimTeamARI(teamId)}/members?size=2&membershipState=FULL_MEMBER&siteId=${this.getCloudId()}`);
        return members.entities.length === 1;
    }
    async createTeam(displayName, originQuery, members, membershipSettings = 'OPEN') {
        const organizationId = this.getContext().orgId;
        if (!organizationId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'createTeam');
            throw err;
        }
        const url = `${$2443af7a75778c61$var$v4UrlPath}?${this.constructProductOriginParams(originQuery)}`;
        const legionTeam = await this.postResource(url, {
            displayName: displayName,
            description: '',
            membershipSettings: membershipSettings,
            siteId: this.getCloudId(),
            organizationId: organizationId,
            members: [
                ...new Set(members)
            ]
        });
        return this.mapTeamCreateResponseV4ToTeam(legionTeam);
    }
    async createExternalTeam(description, externalReference, teamName, siteId) {
        const organizationId = this.getContext().orgId;
        const cloudId = this.getContext().cloudId;
        if (!organizationId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'createTeam');
            throw err;
        }
        const url = `${$2443af7a75778c61$var$v4UrlPath}/external?origin.cloudId=${encodeURIComponent(this.getCloudId(siteId || cloudId))}`;
        const legionExternalTeam = await this.postResource(url, {
            description: description,
            externalReference: externalReference,
            organizationId: organizationId,
            siteId: siteId || cloudId,
            displayName: teamName
        });
        return this.mapTeamCreateResponseV4ToTeam(legionExternalTeam);
    }
    async getTeamAndGroupDiff(teamId, externalReference) {
        const siteId = this.getCloudId();
        return this.postResource(`${$2443af7a75778c61$var$v4UrlPath}/${this.trimTeamARI(teamId)}/external/diff`, {
            siteId: siteId,
            externalReference: externalReference
        });
    }
    async linkExistingTeamToGroup(teamId, externalReference) {
        const siteId = this.getCloudId();
        return this.postResource(`${$2443af7a75778c61$var$v4UrlPath}/${this.trimTeamARI(teamId)}/external/link`, {
            externalReference: externalReference,
            siteId: siteId
        });
    }
    async getWriteMediaToken() {
        return this.getResource('/v4/teams/header-image/media-upload').then((response)=>({
                ...response,
                baseUrl: response.baseUrl?.endsWith('/') ? response.baseUrl.slice(0, -1) : response.baseUrl
            }));
    }
    async getSoftDeletedTeamById(teamId) {
        const orgId = this.getOrgId();
        const siteId = this.getCloudId();
        return this.getResource(`${$2443af7a75778c61$var$v4UrlPath}/org/${orgId}/soft-deleted/${this.trimTeamARI(teamId)}?siteId=${siteId}`).then((response)=>({
                ...response.teamResponse,
                id: teamId
            }));
    }
    /**
	 * Shoud only be used within Teams (P&T) packages
	 */ async getUserInSiteUserBase(userId) {
        const siteId = this.getCloudId();
        return this.getResource(`/teams/site/${siteId}/users/${userId}/exists`, {
            headers: {
                Accept: 'application/json',
                'X-header-client-id': 'ptc-fe'
            }
        });
    }
    async retrieveBrowseUserPermission(product) {
        return this.getResourceCached(`/teams/site/${this.getCloudId()}/canSearchUsers?product=${product}`, undefined, // 2 minute expiration, resolves duplicate calls in initial load
        {
            expiration: 120000
        });
    }
    async getPermissions() {
        const orgId = this.getContext().orgId;
        const siteId = this.getCloudId();
        if (!orgId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'getPermissions');
            throw err;
        }
        return this.getResourceCached(`${$2443af7a75778c61$var$v4UrlPath}/permission/self/organization/${orgId}?siteId=${siteId}`);
    }
    async getLinkedTeamsBulk(groupIds) {
        const organizationId = this.getContext().orgId;
        if (!organizationId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'getLinkedTeamsBulk');
            throw err;
        }
        const legionExternalTeam = await this.postResource(`${$2443af7a75778c61$var$v4UrlPath}/external/bulk`, {
            organizationId: organizationId,
            source: 'ATLASSIAN_GROUP',
            externalIds: groupIds
        });
        return legionExternalTeam;
    }
    async getTeamProfileDetails(teamId) {
        const siteId = this.getCloudId();
        if (!siteId) {
            const err = new Error('Site ID is required');
            this.logException(err, 'getTeamProfileDetails');
            throw err;
        }
        const linkedTeamsProfileDetails = await this.getResource(`${$2443af7a75778c61$var$v4UrlPath}/${teamId}/profile?siteId=${this.getCloudId()}`);
        return linkedTeamsProfileDetails;
    }
    async getOrgScope() {
        const orgId = this.getContext().orgId;
        if (!orgId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'getOrgScope');
            throw err;
        }
        const orgScope = await this.getResourceCached(`${$2443af7a75778c61$var$v4UrlPath}/org/${orgId}/scope`);
        return orgScope;
    }
    async restoreTeamToSyncedGroup(teamId, externalReference) {
        const siteId = this.getCloudId();
        return await this.postResource(`${$2443af7a75778c61$var$v4UrlPath}/${teamId}/external/restore`, {
            externalReference: externalReference,
            siteId: siteId
        });
    }
    // some Legion APIs return team id with the team ARI
    trimTeamARI(teamId = '') {
        const OLD_TEAM_ARI_PREFIX = 'ari:cloud:teams::team/';
        const TEAM_ARI_PREFIX = 'ari:cloud:identity::team/';
        return teamId.replace(TEAM_ARI_PREFIX, '').replace(OLD_TEAM_ARI_PREFIX, ''); // PTC-4213 will remove the references to the old team ARI
    }
    constructProductOriginParams(originQuery) {
        const product = (originQuery.product || '').toUpperCase();
        const queries = [
            `origin.cloudId=${encodeURIComponent(this.getCloudId(originQuery.cloudId))}`
        ];
        if (product) queries.push(`origin.product=${encodeURIComponent(product)}`);
        return queries.join('&');
    }
    mapTeamResponseV4ToTeam(teamResponse) {
        return {
            id: teamResponse.id,
            displayName: teamResponse.displayName,
            description: teamResponse.description,
            state: teamResponse.state,
            membershipSettings: teamResponse.membershipSettings,
            organizationId: teamResponse.organizationId,
            restriction: 'ORG_MEMBERS',
            creatorId: teamResponse.creatorId,
            permission: teamResponse.permission,
            orgId: teamResponse.organizationId,
            smallHeaderImageUrl: teamResponse.smallHeaderImageUrl,
            largeHeaderImageUrl: teamResponse.largeHeaderImageUrl,
            smallAvatarImageUrl: teamResponse.smallAvatarImageUrl,
            largeAvatarImageUrl: teamResponse.largeAvatarImageUrl,
            scopeMode: teamResponse.scopeMode,
            isVerified: teamResponse.isVerified
        };
    }
    mapTeamCreateResponseV4ToTeam(teamResponse) {
        return {
            id: teamResponse.id,
            displayName: teamResponse.displayName,
            description: teamResponse.description,
            state: teamResponse.state,
            membershipSettings: teamResponse.membershipSettings,
            organizationId: teamResponse.organizationId,
            restriction: 'ORG_MEMBERS',
            creatorId: teamResponse.creatorId,
            permission: teamResponse.permission,
            orgId: teamResponse.organizationId,
            memberIds: teamResponse.membership?.members?.map((m)=>m.membershipId.memberId) || [],
            membership: teamResponse.membership
        };
    }
    mapTeamSearchResponseV4ToTeamWithMembership(teamResponse) {
        return {
            id: teamResponse.id,
            displayName: teamResponse.displayName,
            description: teamResponse.description,
            state: teamResponse.state,
            membershipSettings: teamResponse.membershipSettings,
            organizationId: teamResponse.organizationId,
            restriction: 'ORG_MEMBERS',
            smallHeaderImageUrl: teamResponse.smallHeaderImageUrl,
            largeAvatarImageUrl: teamResponse.largeAvatarImageUrl,
            smallAvatarImageUrl: teamResponse.smallAvatarImageUrl,
            largeHeaderImageUrl: teamResponse.largeHeaderImageUrl,
            memberCount: teamResponse.memberCount,
            includesYou: teamResponse.includesYou,
            memberIds: [],
            members: [],
            membership: {
                members: [],
                errors: []
            },
            isVerified: teamResponse.isVerified
        };
    }
    mapLegionTeamLinksResponseV3ToTeamLinkResponse(response) {
        return {
            entities: response.entities.map(this.mapLegionTeamLinkResponseV3ToTeamLink)
        };
    }
    mapLegionTeamLinksResponseV4ToTeamLinkResponse(response) {
        return {
            entities: response.entities.map(this.mapLegionTeamLinkResponseV4ToTeamLink)
        };
    }
    mapLegionTeamLinkResponseV3ToTeamLink(legionLinkResponseV3) {
        return {
            contentTitle: legionLinkResponseV3.contentTitle,
            description: legionLinkResponseV3.description,
            creationTime: legionLinkResponseV3.creationTime,
            linkUri: legionLinkResponseV3.linkUri,
            linkId: legionLinkResponseV3.linkId,
            teamId: legionLinkResponseV3.teamId
        };
    }
    mapLegionTeamLinkResponseV4ToTeamLink(legionLinkResponseV4) {
        return {
            contentTitle: legionLinkResponseV4.contentTitle,
            description: legionLinkResponseV4.description,
            linkUri: legionLinkResponseV4.linkUri,
            linkId: legionLinkResponseV4.linkId,
            teamId: legionLinkResponseV4.teamId
        };
    }
}
const $2443af7a75778c61$export$95c697fe95d86a77 = new $2443af7a75778c61$export$68a6a391e3cf23be((0, $aOgFy.DEFAULT_CONFIG).stargateRoot);

});

parcelRegister("13Kx5", function(module, exports) {

$parcel$export(module.exports, "default", () => $96e9f24df4d329d9$export$2e2bcd8739ae039);

var $1K4T6 = parcelRequire("1K4T6");

var $aOgFy = parcelRequire("aOgFy");

var $hrPaF = parcelRequire("hrPaF");
const $96e9f24df4d329d9$var$defaultConfig = {
    serviceUrl: `${(0, $aOgFy.DEFAULT_CONFIG).stargateRoot}/users/manage`
};
const $96e9f24df4d329d9$var$NOT_EDITABLE = 'not_editable';
const $96e9f24df4d329d9$var$NOT_EDITABLE_FIELD = 'field';
const $96e9f24df4d329d9$var$NOT_EDITABLE_REASON = 'reason';
class $96e9f24df4d329d9$export$1f387592ab3ca6d0 extends (0, $hrPaF.RestClient) {
    constructor(config = {}){
        super({
            ...$96e9f24df4d329d9$var$defaultConfig,
            ...config
        });
    }
    async getProfileWithMutability(userId) {
        return this.getResource(`/${userId}/profile`).then((resp)=>{
            return $96e9f24df4d329d9$var$mapToMutabilityConstraints(resp);
        });
    }
}
function $96e9f24df4d329d9$var$mapToMutabilityConstraints(json) {
    let constraints = [];
    if (json[$96e9f24df4d329d9$var$NOT_EDITABLE] != null) for (const value of json[$96e9f24df4d329d9$var$NOT_EDITABLE])constraints = constraints.concat({
        field: value[$96e9f24df4d329d9$var$NOT_EDITABLE_FIELD],
        reason: $96e9f24df4d329d9$var$determineReason(value[$96e9f24df4d329d9$var$NOT_EDITABLE_REASON])
    });
    return constraints;
}
function $96e9f24df4d329d9$var$determineReason(value) {
    switch(value){
        case 'managed':
        case 'ext.dir.scim':
        case 'ext.dir.google':
            return value;
        default:
            throw new (0, $1K4T6.DefaultError)({
                message: `Unknown mutability constraint reason: ${value}`
            });
    }
}
var // eslint-disable-next-line import/no-anonymous-default-export
$96e9f24df4d329d9$export$2e2bcd8739ae039 = new $96e9f24df4d329d9$export$1f387592ab3ca6d0();

});

parcelRegister("h46cM", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f2e78061b0eb028$export$2e2bcd8739ae039);

var $aOgFy = parcelRequire("aOgFy");

var $hrPaF = parcelRequire("hrPaF");

var $hjCdE = parcelRequire("hjCdE");
const $6f2e78061b0eb028$var$defaultConfig = {
    serviceUrl: `${(0, $aOgFy.DEFAULT_CONFIG).stargateRoot}`
};
class $6f2e78061b0eb028$export$a78b00aedb6cb3e9 extends (0, $hrPaF.RestClient) {
    constructor(config = {}){
        super({
            ...$6f2e78061b0eb028$var$defaultConfig,
            ...config
        });
    }
    async getTeamLinkIcons(teamLinkUrls) {
        const requestBody = teamLinkUrls.map((url)=>({
                resourceUrl: url
            }));
        return this.postResourceRaw(`/object-resolver/resolve/batch`, JSON.stringify(requestBody)).then((0, $hjCdE.transformIconData));
    }
}
var $6f2e78061b0eb028$export$2e2bcd8739ae039 = new $6f2e78061b0eb028$export$a78b00aedb6cb3e9();

});
parcelRegister("hjCdE", function(module, exports) {

$parcel$export(module.exports, "transformIconData", () => $9290a635b7c41737$export$39f4468adf4cb57c);

var $FZDfl = parcelRequire("FZDfl");
const $9290a635b7c41737$export$c64ca1c808335e8b = (jsonLd)=>{
    const { url: url, generator: { name: name, icon: icon } } = jsonLd;
    switch(name){
        case (0, $FZDfl.ProviderNames).CONFLUENCE:
            return {
                linkUrl: url,
                iconUrl: $9290a635b7c41737$var$getConfluenceFavicon(url),
                productName: name
            };
        case (0, $FZDfl.ProviderNames).JIRA:
            return {
                linkUrl: url,
                iconUrl: $9290a635b7c41737$var$getJiraFavicon(url),
                productName: name
            };
        default:
            return {
                linkUrl: url,
                iconUrl: typeof icon === 'object' ? icon['url'] : icon,
                productName: name
            };
    }
};
const $9290a635b7c41737$var$isIconItemSuccess = (response)=>{
    return response.status === 200;
};
const $9290a635b7c41737$export$39f4468adf4cb57c = (batchResp)=>batchResp.filter($9290a635b7c41737$var$isIconItemSuccess).map((resp)=>resp.body.data).map($9290a635b7c41737$export$c64ca1c808335e8b).filter((linkIconData)=>linkIconData.iconUrl !== undefined);
const $9290a635b7c41737$var$getConfluenceFavicon = (url)=>`https://${new URL(url).hostname}/wiki/favicon.ico`;
const $9290a635b7c41737$var$getJiraFavicon = (url)=>`https://${new URL(url).hostname}/favicon.ico`;

});
parcelRegister("FZDfl", function(module, exports) {

$parcel$export(module.exports, "ProviderNames", () => $584160994f259bf9$export$132d457a8475f4c8);
/**
 * This type matches the props for the TeamLinkIcon component in embeddable-directory
 */ var $584160994f259bf9$export$132d457a8475f4c8 = /*#__PURE__*/ function(ProviderNames) {
    ProviderNames["CONFLUENCE"] = "Confluence";
    ProviderNames["JIRA"] = "Jira";
    return ProviderNames;
}({});

});



parcelRegister("1B4EX", function(module, exports) {

$parcel$export(module.exports, "default", () => $4da5dc8a7e4131fb$export$2e2bcd8739ae039);

var $aOgFy = parcelRequire("aOgFy");

var $hrPaF = parcelRequire("hrPaF");
class $4da5dc8a7e4131fb$export$23820d8d740dd467 extends (0, $hrPaF.RestClient) {
    getIsSiteAdmin(/**
		 * @private
		 * @deprecated don't need to pass param, value is taken from `this.getCloudId()` instead
		 */ cloudId) {
        return this.postResource('/permitted', {
            permissionId: 'manage',
            resourceId: `ari:cloud:platform::site/${this.getCloudId(cloudId)}`
        }).then((response)=>response.permitted);
    }
}
var /**
 * REST Client to make calls to resources on the activity service.
 *
 * @type {RestClient}
 */ // eslint-disable-next-line import/no-anonymous-default-export
$4da5dc8a7e4131fb$export$2e2bcd8739ae039 = new $4da5dc8a7e4131fb$export$23820d8d740dd467({
    serviceUrl: (0, $aOgFy.DEFAULT_CONFIG).permsServiceUrl
});

});

parcelRegister("7thbw", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc096c4ff7130f7b$export$2e2bcd8739ae039);

var $1K4T6 = parcelRequire("1K4T6");

var $aOgFy = parcelRequire("aOgFy");

var $hrPaF = parcelRequire("hrPaF");
const $cc096c4ff7130f7b$var$V1_URL = '/teams/v1';
const $cc096c4ff7130f7b$var$SENTRY_IGNORED_ERROR_MESSAGES_CREATE = [
    'TEAM_NOT_FOUND'
];
class $cc096c4ff7130f7b$export$38575d07403d67c extends (0, $hrPaF.RestClient) {
    constructor(serviceUrlRoot){
        super({
            serviceUrl: serviceUrlRoot
        });
    }
    async addUsersToTeam(teamId, members) {
        if (!members || members.length === 0) {
            const missingMembersError = new Error('Missing members to add');
            this.logException(missingMembersError, 'addUsersToTeam');
            throw missingMembersError;
        }
        const membersWithIds = members.filter((member)=>!!member.accountId);
        if (membersWithIds.length !== members.length) this.logException(new Error('Missing accountIds for some members'), 'addUsersToTeam');
        if (membersWithIds.length === 0) {
            const missingMembersError = new Error('Missing accountIds for all members');
            this.logException(missingMembersError, 'addUsersToTeam');
            throw missingMembersError;
        }
        try {
            const orgId = this.getOrgId();
            const url = `${$cc096c4ff7130f7b$var$V1_URL}/org/${orgId}/teams/${teamId}/members/add`;
            const response = await this.postResource(url, {
                members: membersWithIds
            });
            return response;
        } catch (e) {
            this.logException(e, 'addUsersToTeam');
            if (e instanceof (0, $1K4T6.HttpError) && $cc096c4ff7130f7b$var$SENTRY_IGNORED_ERROR_MESSAGES_CREATE.includes(e.message)) throw new (0, $1K4T6.SLOIgnoreHttpError)(e);
            throw e;
        }
    }
    async removeTeamMemberships(teamId, members) {
        if (!members || members.length === 0) {
            const missingMembersError = new Error('Missing members to remove');
            this.logException(missingMembersError, 'removeTeamMemberships');
            throw missingMembersError;
        }
        const membersWithIds = members.filter((member)=>!!member.accountId);
        if (membersWithIds.length !== members.length) this.logException(new Error('Missing accountIds for some members'), 'addUsersToTeam');
        if (membersWithIds.length === 0) {
            const missingMembersError = new Error('Missing accountIds for all members');
            this.logException(missingMembersError, 'removeTeamMemberships');
            throw missingMembersError;
        }
        try {
            const orgId = this.getOrgId();
            const url = `${$cc096c4ff7130f7b$var$V1_URL}/org/${orgId}/teams/${teamId}/members/remove`;
            const response = await this.postResource(url, {
                members: membersWithIds
            });
            return response;
        } catch (e) {
            this.logException(e, 'removeTeamMemberships');
            throw e;
        }
    }
    async getTeamDetails(teamId) {
        try {
            const orgId = this.getOrgId();
            const url = `${$cc096c4ff7130f7b$var$V1_URL}/org/${orgId}/teams/${teamId}`;
            const response = await this.getResource(url);
            return response;
        } catch (e) {
            this.logException(e, 'getTeamDetails');
            throw e;
        }
    }
    async getTeamMembers(teamId, first = 50, after) {
        try {
            const orgId = this.getOrgId();
            const url = `${$cc096c4ff7130f7b$var$V1_URL}/org/${orgId}/teams/${teamId}/members`;
            const response = await this.postResource(url, {
                after: after,
                first: first
            });
            return response;
        } catch (e) {
            this.logException(e, 'getTeamMembers');
            throw e;
        }
    }
    async restoreTeam(teamId) {
        try {
            const orgId = this.getOrgId();
            const url = `${$cc096c4ff7130f7b$var$V1_URL}/org/${orgId}/teams/${teamId}/restore`;
            return this.postResource(url);
        } catch (e) {
            this.logException(e, 'restoreTeam');
            throw e;
        }
    }
}
var // eslint-disable-next-line import/no-anonymous-default-export
$cc096c4ff7130f7b$export$2e2bcd8739ae039 = new $cc096c4ff7130f7b$export$38575d07403d67c((0, $aOgFy.DEFAULT_CONFIG).publicApiRoot);

});

parcelRegister("doDlD", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d5edd21520bfcf7$export$2e2bcd8739ae039);

var $aOgFy = parcelRequire("aOgFy");

var $cPPyF = parcelRequire("cPPyF");

var $6laLp = parcelRequire("6laLp");

var $5q4oc = parcelRequire("5q4oc");

var $7HzJi = parcelRequire("7HzJi");

var $6MiDV = parcelRequire("6MiDV");

var $9rfX5 = parcelRequire("9rfX5");

var $1KerR = parcelRequire("1KerR");

var $ey2Vf = parcelRequire("ey2Vf");

var $h8V8v = parcelRequire("h8V8v");

var $7sahj = parcelRequire("7sahj");

var $1jHJB = parcelRequire("1jHJB");
class $7d5edd21520bfcf7$export$de0359e19b851166 extends (0, $cPPyF.BaseGraphQlClient) {
    constructor(baseUrl, config){
        super((0, $1jHJB.getUnshardedTeamCentralGraphqlUrl)(baseUrl), config);
    }
    // Team central url is a bit special, that it depends on cloudId.
    setBaseUrl(baseUrl) {
        const cloudId = this.getCloudId();
        this.setServiceUrl(cloudId && cloudId !== 'None' ? (0, $1jHJB.getTeamCentralGraphqlUrl)(baseUrl, cloudId) : (0, $1jHJB.getUnshardedTeamCentralGraphqlUrl)(baseUrl));
    }
    async addTeamWatcher(teamId, cloudId) {
        const response = await this.makeGraphQLRequest({
            query: (0, $5q4oc.AddTeamWatcherMutation),
            variables: {
                teamId: teamId,
                cloudId: cloudId
            }
        }, {
            operationName: 'addTeamWatcher'
        });
        return response.addTeamWatcher;
    }
    async removeTeamWatcher(teamId, cloudId) {
        const response = await this.makeGraphQLRequest({
            query: (0, $h8V8v.RemoveTeamWatcherMutation),
            variables: {
                teamId: teamId,
                cloudId: cloudId
            }
        }, {
            operationName: 'removeTeamWatcher'
        });
        return response.removeTeamWatcher;
    }
    async deleteKudos(id) {
        const response = await this.makeGraphQLRequest({
            query: (0, $ey2Vf.KudosDeleteMutation),
            variables: {
                id: id
            }
        }, {
            operationName: 'DeleteKudos'
        });
        return response.deleteKudos;
    }
    async queryTagList(variables) {
        const response = await this.makeGraphQLRequest({
            query: (0, $7sahj.TagListQuery),
            variables: variables
        }, {
            operationName: 'TagListByCloudId'
        });
        return response.tagSearchByCloudId;
    }
    async createTag(variables) {
        const response = await this.makeGraphQLRequest({
            query: (0, $7HzJi.CreateTagMutation),
            variables: variables
        }, {
            operationName: 'createTagForCloudId'
        });
        return response.createTagForCloudId;
    }
    async createHelpPointer(variables) {
        const response = await this.makeGraphQLRequest({
            query: (0, $6MiDV.HelpPointerCreateMutation),
            variables: variables
        }, {
            operationName: 'CreateHelpPointer'
        });
        return response.createHelpPointer;
    }
    async updateHelpPointer(variables) {
        const response = await this.makeGraphQLRequest({
            query: (0, $1KerR.HelpPointerUpdateMutation),
            variables: variables
        }, {
            operationName: 'UpdateHelpPointer'
        });
        return response.updateHelpPointer;
    }
    async deleteHelpPointer(variables) {
        const response = await this.makeGraphQLRequest({
            query: (0, $9rfX5.HelpPointerDeleteMutation),
            variables: variables
        }, {
            operationName: 'DeleteHelpPointer'
        });
        return response.deleteHelpPointer;
    }
}
var $7d5edd21520bfcf7$export$2e2bcd8739ae039 = new $7d5edd21520bfcf7$export$de0359e19b851166((0, $aOgFy.DEFAULT_CONFIG).stargateRoot, {
    logException: $6laLp.logException
});

});
parcelRegister("5q4oc", function(module, exports) {

$parcel$export(module.exports, "AddTeamWatcherMutation", () => $7a30a844cfa52ad0$export$2af9f827ad8bcf83);

var $1c8Um = parcelRequire("1c8Um");

var $5cllN = parcelRequire("5cllN");
const $7a30a844cfa52ad0$export$2af9f827ad8bcf83 = (0, $1c8Um.print)((0, $5cllN.default)`
	mutation addTeamWatcher($teamId: String!, $cloudId: String) {
		addTeamWatcher(input: { teamId: $teamId, cloudId: $cloudId }) {
			isWatching
			__typename
		}
	}
`);

});

parcelRegister("7HzJi", function(module, exports) {

$parcel$export(module.exports, "CreateTagMutation", () => $794445a2ca2b8bda$export$5e59562b4f09e8ef);

var $1c8Um = parcelRequire("1c8Um");

var $5cllN = parcelRequire("5cllN");
const $794445a2ca2b8bda$export$5e59562b4f09e8ef = (0, $1c8Um.print)((0, $5cllN.default)`
	mutation createTagForCloudId($name: String!, $cloudId: String!) {
		createTagForCloudId(input: { name: $name, cloudId: $cloudId }) {
			tag {
				id
				uuid
				name
			}
		}
	}
`);

});

parcelRegister("6MiDV", function(module, exports) {

$parcel$export(module.exports, "HelpPointerCreateMutation", () => $b73f166b153fa007$export$a563da8c932d52b1);

var $1c8Um = parcelRequire("1c8Um");

var $5cllN = parcelRequire("5cllN");
const $b73f166b153fa007$export$a563da8c932d52b1 = (0, $1c8Um.print)((0, $5cllN.default)`
	mutation CreateHelpPointer(
		$cloudId: String!
		$description: String
		$icon: IconInput
		$tagUuids: [UUID]
		$link: String!
		$name: String!
		$teamId: String!
		$type: HelpPointerType!
	) {
		createHelpPointer(
			input: {
				cloudId: $cloudId
				description: $description
				icon: $icon
				tagUuids: $tagUuids
				link: $link
				name: $name
				teamId: $teamId
				type: $type
			}
		) {
			helpPointer {
				id
			}
		}
	}
`);

});

parcelRegister("9rfX5", function(module, exports) {

$parcel$export(module.exports, "HelpPointerDeleteMutation", () => $666c98623886084e$export$558c9434019572a1);

var $1c8Um = parcelRequire("1c8Um");

var $5cllN = parcelRequire("5cllN");
const $666c98623886084e$export$558c9434019572a1 = (0, $1c8Um.print)((0, $5cllN.default)`
	mutation DeleteHelpPointer($id: ID!) {
		deleteHelpPointer(input: { id: $id }) {
			success
		}
	}
`);

});

parcelRegister("1KerR", function(module, exports) {

$parcel$export(module.exports, "HelpPointerUpdateMutation", () => $32a0765e7f988b7b$export$95b572ae48a37250);

var $1c8Um = parcelRequire("1c8Um");

var $5cllN = parcelRequire("5cllN");
const $32a0765e7f988b7b$export$95b572ae48a37250 = (0, $1c8Um.print)((0, $5cllN.default)`
	mutation UpdateHelpPointer(
		$id: ID!
		$description: String
		$teamId: String
		$newTeamName: String
		$icon: IconInput
		$tagUuids: [UUID]
		$link: String
		$name: String
		$type: HelpPointerType
	) {
		updateHelpPointer(
			input: {
				id: $id
				description: $description
				icon: $icon
				tagUuids: $tagUuids
				link: $link
				teamId: $teamId
				newTeamName: $newTeamName
				name: $name
				type: $type
			}
		) {
			helpPointer {
				id
			}
		}
	}
`);

});

parcelRegister("ey2Vf", function(module, exports) {

$parcel$export(module.exports, "KudosDeleteMutation", () => $affb8baa13372318$export$fc4c702e715ad2a4);

var $1c8Um = parcelRequire("1c8Um");

var $5cllN = parcelRequire("5cllN");
const $affb8baa13372318$export$fc4c702e715ad2a4 = (0, $1c8Um.print)((0, $5cllN.default)`
	mutation DeleteKudos($id: ID!) {
		deleteKudos(input: { id: $id }) {
			success
			kudos {
				id
			}
		}
	}
`);

});

parcelRegister("h8V8v", function(module, exports) {

$parcel$export(module.exports, "RemoveTeamWatcherMutation", () => $d9ec6e4b42d9aba6$export$d1957676c49feb6a);

var $1c8Um = parcelRequire("1c8Um");

var $5cllN = parcelRequire("5cllN");
const $d9ec6e4b42d9aba6$export$d1957676c49feb6a = (0, $1c8Um.print)((0, $5cllN.default)`
	mutation removeTeamWatcher($teamId: String!, $cloudId: String) {
		removeTeamWatcher(input: { teamId: $teamId, cloudId: $cloudId }) {
			isWatching
			__typename
		}
	}
`);

});

parcelRegister("7sahj", function(module, exports) {

$parcel$export(module.exports, "TagListQuery", () => $9c83200124dcc1a5$export$2c592b5c06672873);

var $1c8Um = parcelRequire("1c8Um");

var $5cllN = parcelRequire("5cllN");
const $9c83200124dcc1a5$export$2c592b5c06672873 = (0, $1c8Um.print)((0, $5cllN.default)`
	query TagListByCloudId($q: String!, $cloudId: String!, $first: Int) {
		tagSearchByCloudId(q: $q, cloudId: $cloudId, first: $first) {
			edges {
				node {
					id
					uuid
					name
					projects {
						count
					}

					goals {
						count
					}

					helpLinks {
						count
					}
				}
			}
		}
	}
`);

});

parcelRegister("1jHJB", function(module, exports) {

$parcel$export(module.exports, "getTeamCentralGraphqlUrl", () => $b11c2e8c473887f3$export$ada1892306a6b676);
$parcel$export(module.exports, "getUnshardedTeamCentralGraphqlUrl", () => $b11c2e8c473887f3$export$71356c4826ea823a);
const $b11c2e8c473887f3$export$ada1892306a6b676 = (baseUrl, cloudId)=>`${baseUrl}/townsquare/s/${cloudId}/graphql`;
const $b11c2e8c473887f3$export$71356c4826ea823a = (baseUrl)=>`${baseUrl}/watermelon/graphql`;

});


parcelRegister("93qCC", function(module, exports) {

$parcel$export(module.exports, "default", () => $105914cb6e0318f1$export$2e2bcd8739ae039);

var $aOgFy = parcelRequire("aOgFy");

var $hrPaF = parcelRequire("hrPaF");
const $105914cb6e0318f1$var$defaultConfig = {
    serviceUrl: `${(0, $aOgFy.DEFAULT_CONFIG).stargateRoot}/teamsslack/api/team`
};
class $105914cb6e0318f1$export$9509cbc6b0605446 extends (0, $hrPaF.RestClient) {
    constructor(config = {}){
        super({
            ...$105914cb6e0318f1$var$defaultConfig,
            ...config
        });
    }
    async getTeamInSlack(teamId, teamName) {
        return this.getResource(`/${teamId}?teamName=${encodeURIComponent(teamName)}`).then((response)=>({
                id: teamId,
                ...response
            }));
    }
    async disconnectTeamInSlack(teamId) {
        return this.deleteResource(`/${teamId}`).then((response)=>({
                id: teamId,
                ...response
            }));
    }
    async updateTeamInSlack(teamId, channelId, usergroupHandle) {
        return this.postResource(`/${teamId}?channel=${channelId}&groupName=${usergroupHandle}`).then((response)=>({
                id: teamId,
                ...response
            }));
    }
}
var $105914cb6e0318f1$export$2e2bcd8739ae039 = new $105914cb6e0318f1$export$9509cbc6b0605446();

});

parcelRegister("9zuJU", function(module, exports) {

$parcel$export(module.exports, "default", () => $257161ecf26ea5c9$export$2e2bcd8739ae039);

var $aOgFy = parcelRequire("aOgFy");

var $hrPaF = parcelRequire("hrPaF");
const $257161ecf26ea5c9$var$buildGetReadTokenURL = (accountId)=>`/api/user-image/${accountId}/header-image/read`;
class $257161ecf26ea5c9$export$3c27e20d1b94924 extends (0, $hrPaF.RestClient) {
    async getReadMediaToken(accountId) {
        return this.getResource($257161ecf26ea5c9$var$buildGetReadTokenURL(accountId)).then((response)=>response);
    }
    async getWriteMediaToken() {
        return this.getResource('/api/user-image/header-image/write').then((response)=>response);
    }
    async updateUserHeaderImage(headerImageId) {
        return await this.putResource('/api/user-image/self/header-image', {
            headerImageId: headerImageId
        });
    }
}
var $257161ecf26ea5c9$export$2e2bcd8739ae039 = new $257161ecf26ea5c9$export$3c27e20d1b94924({
    serviceUrl: (0, $aOgFy.DEFAULT_CONFIG).stargateRoot
});

});


parcelRegister("ddoT6", function(module, exports) {

$parcel$export(module.exports, "transformPermissions", () => $e6270b31ac69c64a$export$7fe0bfa353103198);
const $e6270b31ac69c64a$export$7fe0bfa353103198 = (permissions)=>{
    return permissions.reduce((acc, permission)=>{
        switch(permission){
            case 'CAN_CREATE_TEAMS':
                return {
                    ...acc,
                    canCreateTeams: true
                };
            case 'CAN_VIEW_TEAMS':
                return {
                    ...acc,
                    canViewTeams: true
                };
            case 'CAN_ADMIN_TEAMS':
                return {
                    ...acc,
                    canAdminTeams: true
                };
            default:
                return acc;
        }
    }, {
        canCreateTeams: false,
        canViewTeams: false,
        canAdminTeams: false
    });
};

});



parcelRegister("5wXDQ", function(module, exports) {

$parcel$export(module.exports, "PeopleMenuOverrides", () => $0d7d2d743503c251$export$c6e6fe52d34907dc);
var $0d7d2d743503c251$export$c6e6fe52d34907dc = /*#__PURE__*/ function(PeopleMenuOverrides) {
    PeopleMenuOverrides["createTeamsDisabled"] = "create-teams-disabled";
    PeopleMenuOverrides["viewTeamsDisabled"] = "view-teams-disabled";
    return PeopleMenuOverrides;
}({});

});



parcelRegister("9dZ1c", function(module, exports) {

$parcel$export(module.exports, "useNudgeController", () => $6a0467752d0c968a$export$9a533735412babca);
$parcel$export(module.exports, "useRegisterNudgeTarget", () => $6a0467752d0c968a$export$eb8a96124d659f2d);

var $5uXOq = parcelRequire("5uXOq");
/**
 * This class tracks nudge target HTML DOM elements by ID.
 * It also tracks subscribers to updates of these elements.
 *  See some of the history here https://hello.atlassian.net/wiki/spaces/~620663553/pages/2896059847/Shipit+57+-+Out+of+Tree+Nudges
 */ class $6a0467752d0c968a$var$NudgeController {
    static{
        /**
	 * Singleton instance of this class.
	 * Alternatively multiple instances would be created and passed through context.
	 */ this.instance = new $6a0467752d0c968a$var$NudgeController();
    }
    /**
	 * Register the HTML DOM node for an ID
	 */ registerNudgeTarget(id, ref) {
        this.nudgeTargetsMap.set(id, ref);
        this.notifySubscribers(id);
        // Return a cleanup function that will remove this ID from the map
        return ()=>{
            this.nudgeTargetsMap.delete(id);
        };
    }
    /**
	 * Subscribe to updates to a certain DOM node
	 */ subscribe(id, callback) {
        const subscribers = this.subscribers.get(id) ?? [];
        subscribers.push(callback);
        this.subscribers.set(id, subscribers);
        // Return a cleanup function that will remove this callback from the list of subscribers
        return ()=>{
            const subscribersOnCleanup = this.subscribers.get(id) ?? [];
            this.subscribers.set(id, subscribersOnCleanup.filter((cb)=>cb !== callback));
        };
    }
    /**
	 * Notify subscribers that the HTML DOM node for an ID has been updated.
	 */ notifySubscribers(id) {
        const subscribers = this.subscribers.get(id) ?? [];
        subscribers.forEach((subscriber)=>{
            subscriber();
        });
    }
    constructor(){
        this.nudgeTargetsMap = new Map();
        this.subscribers = new Map();
    }
}
const $6a0467752d0c968a$export$9a533735412babca = ()=>$6a0467752d0c968a$var$NudgeController.instance;
const $6a0467752d0c968a$export$eb8a96124d659f2d = (id, shouldRegister = true)=>{
    const controller = $6a0467752d0c968a$export$9a533735412babca();
    const ref = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (shouldRegister) {
            const unregister = controller.registerNudgeTarget(id, ref);
            return ()=>{
                unregister();
            };
        }
    }, [
        controller,
        id,
        shouldRegister
    ]);
    return {
        ref: ref
    };
};

});

parcelRegister("fSeA2", function(module, exports) {

$parcel$export(module.exports, "default", () => $38abab37a6ae6abe$export$2e2bcd8739ae039);
// export main component

var $8D6em = parcelRequire("8D6em");
var $38abab37a6ae6abe$export$2e2bcd8739ae039 = (0, $8D6em.default);

});
parcelRegister("8D6em", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b76e34713086949$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cb25w = parcelRequire("cb25w");

var $2bzBV = parcelRequire("2bzBV");

var $1I7E8 = parcelRequire("1I7E8");

var $hEofo = parcelRequire("hEofo");

var $5iwOw = parcelRequire("5iwOw");

var $dS8wI = parcelRequire("dS8wI");

var $gFH8O = parcelRequire("gFH8O");

var $9iwCj = parcelRequire("9iwCj");

var $jHmRo = parcelRequire("jHmRo");

var $7U5E9 = parcelRequire("7U5E9");

var $4144s = parcelRequire("4144s");

var $4AXtg = parcelRequire("4AXtg");

var $14DM3 = parcelRequire("14DM3");
// if `@atlaskit/popup` is upgraded from 0.6.x to 1.x,
// we may need to change this to an array of numbers like [0, 12];.
const $8b76e34713086949$var$OFFSET_FOR_MORE_BUTTON_VIEW = '12px -11px';
const $8b76e34713086949$var$eventuallyClearHoverMeasure = ()=>{
    setTimeout(()=>{
        (0, $gFH8O.clearMeasure)('hoverAndClick');
    }, 5 * $8b76e34713086949$var$SECOND);
};
const $8b76e34713086949$var$SECOND = 1000;
function $8b76e34713086949$export$b26ac1e1a63fbe24(props) {
    const { customChevronIcon: customChevronIcon, isHighlighted: isHighlighted, enablePreFetchingByHovering: enablePreFetchingByHovering, createAnalyticsEvent: createAnalyticsEvent, peopleText: peopleText, onClick: onClick = (0, $dS8wI.VOID_FUNC) } = props;
    const [canPrefetch, setCanPrefetch] = (0, $5uXOq.useState)(false);
    const { testId: testId, isPeopleMenuOpen: isPeopleMenuOpen, isSSR: isSSR, cloudId: cloudId, orgId: orgId, userId: userId, product: product, tenantUrl: tenantUrl, togglePeopleMenu: togglePeopleMenu = (0, $dS8wI.VOID_FUNC), shouldRenderToParent: shouldRenderToParent = false } = (0, $5uXOq.useContext)((0, $hEofo.PeopleMenuContext));
    const { isVisible: isVisible } = (0, $2bzBV.useOverflowStatus)();
    const closeMenu = (0, $5uXOq.useCallback)(()=>togglePeopleMenu(false), [
        togglePeopleMenu
    ]);
    const handleClickOnTriggerButton = (0, $5uXOq.useCallback)(()=>{
        onClick(!isPeopleMenuOpen);
        togglePeopleMenu(!isPeopleMenuOpen);
        // measure duration of click and show menu
        (0, $gFH8O.startMeasure)('clickAndShow');
        (0, $gFH8O.stopMeasure)('hoverAndClick', (duration, startTime)=>{
            (0, $9iwCj.triggerAnalyticsForHoverAndClick)(createAnalyticsEvent, duration, startTime);
        });
    }, [
        createAnalyticsEvent,
        isPeopleMenuOpen,
        onClick,
        togglePeopleMenu
    ]);
    const handleMouseEnterTriggerButton = (0, $5uXOq.useCallback)(()=>{
        (0, $jHmRo.MenuContent).preload();
        if (!canPrefetch) {
            setCanPrefetch(true);
            // measure duration time between hovering and clicking
            (0, $gFH8O.startMeasure)('hoverAndClick');
            // clear all unwanted hovering after 5 seconds
            $8b76e34713086949$var$eventuallyClearHoverMeasure();
        }
    }, [
        canPrefetch,
        setCanPrefetch
    ]);
    const buttonProps = {
        isSelected: isPeopleMenuOpen,
        onClick: handleClickOnTriggerButton,
        onMouseEnter: handleMouseEnterTriggerButton,
        testId: `${testId}-people-primary-button`,
        peopleText: peopleText
    };
    const PopupContent = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $7U5E9.PeopleMenuContentInternal), {}), []);
    if (isSSR) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4AXtg.PeopleMenuTriggerSSR), {
        testId: testId,
        peopleText: peopleText
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1I7E8.default), {
                // @ts-ignore
                offset: isVisible ? undefined : $8b76e34713086949$var$OFFSET_FOR_MORE_BUTTON_VIEW,
                content: PopupContent,
                isOpen: isPeopleMenuOpen,
                placement: isVisible ? 'bottom-start' : 'right-start',
                onClose: closeMenu,
                shouldRenderToParent: shouldRenderToParent,
                trigger: (triggerProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $4AXtg.default), {
                        isVisible: isVisible,
                        isHighlighted: isHighlighted,
                        customChevronIcon: customChevronIcon,
                        triggerProps: triggerProps,
                        ...buttonProps
                    })
            }),
            enablePreFetchingByHovering && canPrefetch && (0, $5iwOw.isCachedDataClear)() && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $14DM3.UsersTeamsPreFetch), {
                cloudId: cloudId,
                orgId: orgId,
                userId: userId,
                product: product,
                tenantUrl: tenantUrl
            })
        ]
    });
}
const $8b76e34713086949$var$PeopleMenuInternalWithAnalytics = (0, $cb25w.default)()($8b76e34713086949$export$b26ac1e1a63fbe24);
function $8b76e34713086949$export$2e2bcd8739ae039(props) {
    const { isHighlighted: isHighlighted, onClick: onClick, enablePreFetchingByHovering: enablePreFetchingByHovering, customChevronIcon: customChevronIcon, peopleText: peopleText, ...providerProps } = {
        ...props
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4144s.default), {
        ...providerProps,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($8b76e34713086949$var$PeopleMenuInternalWithAnalytics, {
            customChevronIcon: customChevronIcon,
            isHighlighted: isHighlighted,
            onClick: onClick,
            enablePreFetchingByHovering: enablePreFetchingByHovering,
            peopleText: peopleText
        })
    });
}

});
parcelRegister("hEofo", function(module, exports) {

$parcel$export(module.exports, "PeopleMenuContext", () => $04cbb00093c742e6$export$c92ff8b73313c89);
$parcel$export(module.exports, "PeopleMenuContextProvider", () => $04cbb00093c742e6$export$4e812997de4564ae);
$parcel$export(module.exports, "usePeopleMenuContext", () => $04cbb00093c742e6$export$c8d82c28669da5dc);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
parcelRequire("9iwCj");
var $7kP9q = parcelRequire("7kP9q");

const $04cbb00093c742e6$var$AKModalTransition = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("5LSAq")).then((module)=>({
            default: module.ModalTransition
        })));

const $04cbb00093c742e6$var$TeamCreateDialog = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("PB8Ru")).then((module)=>({
            default: module.TeamCreateDialog
        })));
// this wrapper is for preventing changing layout of around elements
const $04cbb00093c742e6$var$DialogWrapper = (0, $8CUq3.xcss)({
    width: 'space.0',
    height: 'space.0',
    margin: '0',
    padding: '0',
    '::before': {
        width: 'space.0',
        height: 'space.0',
        margin: '0',
        padding: '0'
    },
    '::after': {
        width: 'space.0',
        height: 'space.0',
        margin: '0',
        padding: '0'
    }
});
const $04cbb00093c742e6$var$analyticsAttrsTeamCreateDialog = {
    ref: (0, $7kP9q.AnalyticsSource).PEOPLE_MENU
};
const $04cbb00093c742e6$export$c92ff8b73313c89 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({
    orgId: '',
    cloudId: '',
    userId: '',
    product: 'confluence',
    testId: '',
    isPeopleMenuOpen: false,
    isSSR: false,
    onClickedItem: ()=>undefined,
    pushRoute: ()=>undefined,
    togglePeopleMenu: ()=>undefined,
    toggleTeamCreateDialog: ()=>undefined,
    _hasError: undefined,
    teamCreateDialogProps: {},
    shouldRenderToParent: false,
    isSectionList: false
});
function $04cbb00093c742e6$export$4e812997de4564ae(props) {
    const { isSSR: isSSR = false } = props;
    const [isOpenTeamCreateDialog, toggleOpenTeamCreateDialog] = (0, $5uXOq.useState)(false);
    const { children: children, isOpen: isOpen, onOpen: onOpen, onClose: onClose, ...otherProps } = props;
    const pendingUsers = undefined;
    const togglePeopleMenu = (0, $5uXOq.useCallback)((newState)=>{
        if (newState === isOpen) return;
        if (newState) onOpen();
        else onClose();
    }, [
        isOpen,
        onClose,
        onOpen
    ]);
    const toggleTeamCreateDialog = (0, $5uXOq.useCallback)((isOpen)=>{
        toggleOpenTeamCreateDialog(isOpen);
    }, [
        toggleOpenTeamCreateDialog
    ]);
    const values = (0, $5uXOq.useMemo)(()=>({
            teamCreateDialogProps: {},
            ...otherProps,
            // extra props
            isPeopleMenuOpen: isOpen,
            togglePeopleMenu: togglePeopleMenu,
            toggleTeamCreateDialog: toggleTeamCreateDialog,
            pendingUsers: pendingUsers
        }), [
        otherProps,
        isOpen,
        togglePeopleMenu,
        toggleTeamCreateDialog,
        pendingUsers
    ]);
    const closeTeamCreateDialog = (0, $5uXOq.useCallback)(()=>{
        toggleOpenTeamCreateDialog(false);
        if (typeof values.teamCreateDialogProps?.onClose === 'function') values.teamCreateDialogProps.onClose();
    }, [
        toggleOpenTeamCreateDialog,
        values.teamCreateDialogProps
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)($04cbb00093c742e6$export$c92ff8b73313c89.Provider, {
        value: values,
        children: [
            children,
            !isSSR && isOpenTeamCreateDialog && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                xcss: $04cbb00093c742e6$var$DialogWrapper,
                testId: `${otherProps.testId}-team-create-dialog-wrapper`,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                    fallback: null,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)($04cbb00093c742e6$var$AKModalTransition, {
                        children: isOpenTeamCreateDialog && /*#__PURE__*/ (0, $2OMIu.jsx)($04cbb00093c742e6$var$TeamCreateDialog, {
                            cloudId: values.cloudId,
                            orgId: values.orgId,
                            product: values.product,
                            principalId: values.userId,
                            addFlag: values.addFlag,
                            pushRoute: values.pushRoute,
                            extraAnalyticsAttrs: $04cbb00093c742e6$var$analyticsAttrsTeamCreateDialog,
                            ...values.teamCreateDialogProps,
                            onClose: closeTeamCreateDialog
                        })
                    })
                })
            })
        ]
    });
}
const $04cbb00093c742e6$export$c8d82c28669da5dc = ()=>(0, $5uXOq.useContext)($04cbb00093c742e6$export$c92ff8b73313c89);

});
parcelRegister("9iwCj", function(module, exports) {

$parcel$export(module.exports, "triggerAnalyticsForClickCreateNewTeam", () => $36e53a66a40086f1$export$c22050996e7c2c8a);
$parcel$export(module.exports, "triggerAnalyticsForMenuLink", () => $36e53a66a40086f1$export$e2de484c93cb7dd8);
$parcel$export(module.exports, "triggerAnalyticsForClickViewDirectory", () => $36e53a66a40086f1$export$e3be20a27c367b1d);
$parcel$export(module.exports, "triggerAnalyticsForClickInvitePeople", () => $36e53a66a40086f1$export$bb6086ba6d61c34e);
$parcel$export(module.exports, "triggerAnalyticsForClickOnPeople", () => $36e53a66a40086f1$export$8c5588f22f5cd9d8);
$parcel$export(module.exports, "triggerAnalyticsForClickOnTeam", () => $36e53a66a40086f1$export$580e4977bd9f636d);
$parcel$export(module.exports, "triggerAnalyticsForViewedPeopleMenu", () => $36e53a66a40086f1$export$b7b4061d9dd52eb9);
$parcel$export(module.exports, "triggerAnalyticsForRenderedInvitePeople", () => $36e53a66a40086f1$export$3e9b11df8135b7cb);
$parcel$export(module.exports, "triggerAnalyticsForPreFetchData", () => $36e53a66a40086f1$export$750c07c02477d2f7);
$parcel$export(module.exports, "triggerAnalyticsForLoadingIndicator", () => $36e53a66a40086f1$export$d88a623841ba7b50);
$parcel$export(module.exports, "triggerAnalyticsForFetchingData", () => $36e53a66a40086f1$export$bda81aea2199d550);
$parcel$export(module.exports, "triggerAnalyticsForHoverAndClick", () => $36e53a66a40086f1$export$f2cf5fec906275c6);
$parcel$export(module.exports, "triggerAnalyticsForViewedFullUsersAndTeams", () => $36e53a66a40086f1$export$589011fd49e3f6d6);
$parcel$export(module.exports, "triggerAnalyticsForNoBrowsePeoplePermission", () => $36e53a66a40086f1$export$1eb2f70fed6b75f7);
$parcel$export(module.exports, "triggerAnalyticsForRenotifyFetchInactiveUsersSucceeded", () => $36e53a66a40086f1$export$736bb3246fa74c1f);
$parcel$export(module.exports, "triggerAnalyticsForRenotifyFetchInactiveUsersFailed", () => $36e53a66a40086f1$export$794d511945a81231);
$parcel$export(module.exports, "triggerAnalyticsForRenotifyNotEligible", () => $36e53a66a40086f1$export$644347da17a1bc39);
$parcel$export(module.exports, "AnalyticsActionSubject", () => (parcelRequire("7kP9q")).AnalyticsActionSubject);
$parcel$export(module.exports, "AnalyticsAction", () => (parcelRequire("7kP9q")).AnalyticsAction);
$parcel$export(module.exports, "AnalyticsSource", () => (parcelRequire("7kP9q")).AnalyticsSource);

var $3mE7N = parcelRequire("3mE7N");

var $7kP9q = parcelRequire("7kP9q");

var $6uNb2 = parcelRequire("6uNb2");
const $36e53a66a40086f1$export$c22050996e7c2c8a = (createAnalyticsEvent)=>{
    (0, $3mE7N.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $7kP9q.AnalyticsActionSubject).CREATE_NEW_TEAM_LINK,
        action: (0, $7kP9q.AnalyticsAction).CLICKED
    });
};
const $36e53a66a40086f1$export$e2de484c93cb7dd8 = (additionalLinkId, action, createAnalyticsEvent, attributes)=>{
    (0, $3mE7N.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $7kP9q.AnalyticsActionSubject).VIEW_PEOPLE_ADDITIONAL_LINK,
        actionSubjectId: additionalLinkId,
        action: action,
        attributes: {
            integration: 'peopleMenu',
            ...attributes
        }
    });
};
const $36e53a66a40086f1$export$e3be20a27c367b1d = (createAnalyticsEvent, isLeftClick = false)=>{
    (0, $3mE7N.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $7kP9q.AnalyticsActionSubject).VIEW_PEOPLE_DIRECTORY_LINK,
        action: (0, $7kP9q.AnalyticsAction).CLICKED,
        attributes: {
            isLeftClick: isLeftClick
        }
    });
};
const $36e53a66a40086f1$export$bb6086ba6d61c34e = (createAnalyticsEvent, attributes)=>{
    (0, $3mE7N.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $7kP9q.AnalyticsActionSubject).NAVIGATION_MENU_ITEM,
        actionSubjectId: 'addPeopleNavigationMenuItem',
        action: (0, $7kP9q.AnalyticsAction).CLICKED,
        attributes: {
            integration: 'peopleMenu',
            ...attributes
        }
    });
};
const $36e53a66a40086f1$export$8c5588f22f5cd9d8 = (createAnalyticsEvent, isLeftClick = false)=>{
    (0, $3mE7N.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $7kP9q.AnalyticsActionSubject).PEOPLE_MENU_LINK,
        action: (0, $7kP9q.AnalyticsAction).CLICKED,
        attributes: {
            isLeftClick: isLeftClick
        }
    });
};
const $36e53a66a40086f1$export$580e4977bd9f636d = (createAnalyticsEvent, isLeftClick = false)=>{
    (0, $3mE7N.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $7kP9q.AnalyticsActionSubject).TEAM_MENU_LINK,
        action: (0, $7kP9q.AnalyticsAction).CLICKED,
        attributes: {
            isLeftClick: isLeftClick
        }
    });
};
const $36e53a66a40086f1$export$b7b4061d9dd52eb9 = (createAnalyticsEvent, isCacheEmpty = false)=>{
    (0, $3mE7N.fireScreenEvent)(createAnalyticsEvent, {
        name: 'peopleMenu',
        attributes: {
            isCacheEmpty: isCacheEmpty
        }
    });
};
const $36e53a66a40086f1$export$3e9b11df8135b7cb = (createAnalyticsEvent)=>{
    (0, $3mE7N.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: 'addPeopleNavigationItem',
        action: (0, $7kP9q.AnalyticsAction).RENDERED
    });
};
const $36e53a66a40086f1$export$750c07c02477d2f7 = (createAnalyticsEvent)=>{
    (0, $3mE7N.fireTrackEvent)(createAnalyticsEvent, {
        actionSubject: (0, $7kP9q.AnalyticsActionSubject).PRE_FETCH_DATA,
        action: (0, $7kP9q.AnalyticsAction).TRIGGERED
    });
};
const $36e53a66a40086f1$export$d88a623841ba7b50 = (createAnalyticsEvent, duration = 0, startTime = 0)=>{
    (0, $3mE7N.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $7kP9q.AnalyticsActionSubject).PEOPLE_MENU,
        actionSubjectId: 'loadingIndicator',
        action: (0, $7kP9q.AnalyticsAction).VIEWED,
        attributes: {
            duration: duration,
            startTime: startTime
        }
    });
};
const $36e53a66a40086f1$export$bda81aea2199d550 = (createAnalyticsEvent, duration = 0, startTime = 0)=>{
    (0, $3mE7N.fireTrackEvent)(createAnalyticsEvent, {
        actionSubject: (0, $7kP9q.AnalyticsActionSubject).FETCHING_USERS_TEAMS_DATA,
        action: (0, $7kP9q.AnalyticsAction).MEASURED,
        attributes: {
            duration: duration,
            startTime: startTime
        }
    });
};
const $36e53a66a40086f1$export$f2cf5fec906275c6 = (createAnalyticsEvent, duration = 0, startTime = 0)=>{
    (0, $3mE7N.fireTrackEvent)(createAnalyticsEvent, {
        actionSubject: (0, $7kP9q.AnalyticsActionSubject).HOVER_AND_CLICK_PEOPLE_BUTTON,
        action: (0, $7kP9q.AnalyticsAction).MEASURED,
        attributes: {
            duration: duration,
            startTime: startTime
        }
    });
};
const $36e53a66a40086f1$export$589011fd49e3f6d6 = (createAnalyticsEvent, usersCount = 0, teamsCount = 0, duration = 0, startTime = 0)=>{
    (0, $3mE7N.fireTrackEvent)(createAnalyticsEvent, {
        actionSubject: (0, $7kP9q.AnalyticsActionSubject).PEOPLE_MENU,
        action: (0, $7kP9q.AnalyticsAction).SUCCEEDED,
        attributes: {
            usersCount: usersCount,
            teamsCount: teamsCount,
            duration: duration,
            startTime: startTime
        }
    });
};
const $36e53a66a40086f1$export$1eb2f70fed6b75f7 = (createAnalyticsEvent)=>{
    (0, $3mE7N.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $7kP9q.AnalyticsActionSubject).PEOPLE_MENU,
        action: (0, $7kP9q.AnalyticsAction).VIEWED,
        actionSubjectId: 'noBrowsePermission'
    });
};
const $36e53a66a40086f1$export$a5bdd25287196af4 = (createAnalyticsEvent)=>{
    (0, $3mE7N.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $7kP9q.AnalyticsActionSubject).BUTTON,
        action: (0, $7kP9q.AnalyticsAction).CLICKED,
        actionSubjectId: 'dismissButton',
        source: (0, $7kP9q.AnalyticsSource).RENOTIFY_MESSAGE
    });
};
const $36e53a66a40086f1$export$881b6b12fd147cc = (createAnalyticsEvent)=>{
    (0, $3mE7N.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $7kP9q.AnalyticsActionSubject).BUTTON,
        action: (0, $7kP9q.AnalyticsAction).CLICKED,
        actionSubjectId: 'remindTeamMembersButton',
        source: (0, $7kP9q.AnalyticsSource).RENOTIFY_MESSAGE
    });
};
const $36e53a66a40086f1$export$451dcd11e28959 = (createAnalyticsEvent)=>{
    (0, $3mE7N.fireScreenEvent)(createAnalyticsEvent, {
        action: (0, $7kP9q.AnalyticsAction).VIEWED,
        name: (0, $7kP9q.AnalyticsSource).RENOTIFY_MESSAGE
    });
};
const $36e53a66a40086f1$export$fdfb31060bc22a02 = (createAnalyticsEvent)=>{
    (0, $3mE7N.fireScreenEvent)(createAnalyticsEvent, {
        action: (0, $7kP9q.AnalyticsAction).VIEWED,
        name: (0, $7kP9q.AnalyticsSource).RENOTIFY_MODAL
    });
};
const $36e53a66a40086f1$export$5deab56d147776ca = (createAnalyticsEvent, attributes)=>{
    (0, $3mE7N.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $7kP9q.AnalyticsActionSubject).BUTTON,
        action: (0, $7kP9q.AnalyticsAction).CLICKED,
        actionSubjectId: 'copyInviteLinkButton',
        source: (0, $7kP9q.AnalyticsSource).RENOTIFY_MODAL,
        attributes: attributes
    });
};
const $36e53a66a40086f1$export$a4a63a010743799d = (createAnalyticsEvent)=>{
    (0, $3mE7N.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $7kP9q.AnalyticsActionSubject).BUTTON,
        action: (0, $7kP9q.AnalyticsAction).CLICKED,
        actionSubjectId: 'dismissButton',
        source: (0, $7kP9q.AnalyticsSource).RENOTIFY_MODAL
    });
};
const $36e53a66a40086f1$export$faf6c5030f38bba5 = (createAnalyticsEvent, attributes)=>{
    (0, $3mE7N.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $7kP9q.AnalyticsActionSubject).BUTTON,
        action: (0, $7kP9q.AnalyticsAction).CLICKED,
        actionSubjectId: 'sendReminderButton',
        source: (0, $7kP9q.AnalyticsSource).RENOTIFY_MODAL,
        attributes: attributes
    });
};
const $36e53a66a40086f1$export$736bb3246fa74c1f = (createAnalyticsEvent, attributes)=>{
    (0, $3mE7N.fireOperationalEvent)(createAnalyticsEvent, {
        actionSubject: (0, $7kP9q.AnalyticsActionSubject).FETCH_INACTIVE_USERS_DATA,
        action: (0, $7kP9q.AnalyticsAction).SUCCEEDED,
        source: (0, $7kP9q.AnalyticsSource).RENOTIFY_MODAL,
        attributes: attributes
    });
};
const $36e53a66a40086f1$export$794d511945a81231 = (createAnalyticsEvent)=>{
    (0, $3mE7N.fireOperationalEvent)(createAnalyticsEvent, {
        actionSubject: (0, $7kP9q.AnalyticsActionSubject).FETCH_INACTIVE_USERS_DATA,
        action: (0, $7kP9q.AnalyticsAction).FAILED,
        source: (0, $7kP9q.AnalyticsSource).RENOTIFY_MODAL
    });
};
const $36e53a66a40086f1$export$866a7379b396a7e3 = (createAnalyticsEvent, attributes)=>{
    (0, $3mE7N.fireOperationalEvent)(createAnalyticsEvent, {
        actionSubject: (0, $7kP9q.AnalyticsActionSubject).SEND_REINVITES,
        action: (0, $7kP9q.AnalyticsAction).SUCCEEDED,
        source: (0, $7kP9q.AnalyticsSource).RENOTIFY_MODAL,
        attributes: attributes
    });
};
const $36e53a66a40086f1$export$498c81c82596e8ea = (createAnalyticsEvent, attributes)=>{
    (0, $3mE7N.fireOperationalEvent)(createAnalyticsEvent, {
        actionSubject: (0, $7kP9q.AnalyticsActionSubject).SEND_REINVITES,
        action: (0, $7kP9q.AnalyticsAction).FAILED,
        source: (0, $7kP9q.AnalyticsSource).RENOTIFY_MODAL,
        attributes: attributes
    });
};
const $36e53a66a40086f1$export$644347da17a1bc39 = (createAnalyticsEvent, attributes)=>{
    (0, $3mE7N.fireTrackEvent)(createAnalyticsEvent, {
        actionSubject: (0, $7kP9q.AnalyticsActionSubject).RENOTIFY_EXPERIMENT,
        action: (0, $7kP9q.AnalyticsAction).INELIGIBLE,
        source: (0, $7kP9q.AnalyticsSource).RENOTIFY_MESSAGE,
        attributes: attributes
    });
};
const $36e53a66a40086f1$export$68b8d9efc6f7f58f = (createAnalyticsEvent)=>{
    (0, $3mE7N.fireScreenEvent)(createAnalyticsEvent, {
        action: (0, $7kP9q.AnalyticsAction).VIEWED,
        name: (0, $7kP9q.AnalyticsSource).RENOTIFY_SPOTLIGHT
    });
};
const $36e53a66a40086f1$export$f900d0881e38df06 = (createAnalyticsEvent)=>{
    (0, $3mE7N.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $7kP9q.AnalyticsActionSubject).BUTTON,
        action: (0, $7kP9q.AnalyticsAction).CLICKED,
        actionSubjectId: 'renotifySpotlightDismissButton',
        source: (0, $7kP9q.AnalyticsSource).RENOTIFY_SPOTLIGHT
    });
};
const $36e53a66a40086f1$export$acbad06cf5c53b17 = (createAnalyticsEvent)=>{
    (0, $3mE7N.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $7kP9q.AnalyticsActionSubject).BUTTON,
        action: (0, $7kP9q.AnalyticsAction).CLICKED,
        actionSubjectId: 'renotifySpotlightConfirmButton',
        source: (0, $7kP9q.AnalyticsSource).RENOTIFY_SPOTLIGHT
    });
};

});
parcelRegister("7kP9q", function(module, exports) {

$parcel$export(module.exports, "AnalyticsActionSubject", () => $2156eaa79e4b3f27$export$4bce2c1f3a5d9f61);
$parcel$export(module.exports, "AnalyticsAction", () => $2156eaa79e4b3f27$export$30c16f5c43437fd7);
$parcel$export(module.exports, "AnalyticsSource", () => $2156eaa79e4b3f27$export$6890652a1aff7d1c);
var $2156eaa79e4b3f27$export$4bce2c1f3a5d9f61 = /*#__PURE__*/ function(AnalyticsActionSubject) {
    AnalyticsActionSubject["ERROR_BOUNDARY"] = "errorBoundary";
    AnalyticsActionSubject["VIEW_PEOPLE_ADDITIONAL_LINK"] = "additionalMenuLink";
    AnalyticsActionSubject["VIEW_PEOPLE_DIRECTORY_LINK"] = "viewAllPeopleDirectory";
    AnalyticsActionSubject["CREATE_NEW_TEAM_LINK"] = "createNewTeamLink";
    AnalyticsActionSubject["PEOPLE_MENU_LINK"] = "peopleMenuLink";
    AnalyticsActionSubject["TEAM_MENU_LINK"] = "teamMenuLink";
    AnalyticsActionSubject["PEOPLE_MENU"] = "peopleMenu";
    AnalyticsActionSubject["NAVIGATION_MENU_ITEM"] = "navigationMenuItem";
    AnalyticsActionSubject["PRE_FETCH_DATA"] = "preFetchData";
    AnalyticsActionSubject["FETCHING_USERS_TEAMS_DATA"] = "fetchingUsersTeamsData";
    AnalyticsActionSubject["HOVER_AND_CLICK_PEOPLE_BUTTON"] = "hoverAndClickPeopleButton";
    AnalyticsActionSubject["BUTTON"] = "button";
    AnalyticsActionSubject["FETCH_INACTIVE_USERS_DATA"] = "fetchInactiveUsersData";
    AnalyticsActionSubject["SEND_REINVITES"] = "sendReinvites";
    AnalyticsActionSubject["RENOTIFY_EXPERIMENT"] = "renotifyExperiment";
    return AnalyticsActionSubject;
}({});
var $2156eaa79e4b3f27$export$30c16f5c43437fd7 = /*#__PURE__*/ function(AnalyticsAction) {
    AnalyticsAction["RENDERED"] = "rendered";
    AnalyticsAction["CLICKED"] = "clicked";
    AnalyticsAction["EXPOSED"] = "exposed";
    AnalyticsAction["FAILED"] = "failed";
    AnalyticsAction["SUCCEEDED"] = "succeeded";
    AnalyticsAction["VIEWED"] = "viewed";
    AnalyticsAction["TRIGGERED"] = "triggered";
    AnalyticsAction["MEASURED"] = "measured";
    AnalyticsAction["INELIGIBLE"] = "ineligible";
    return AnalyticsAction;
}({});
var $2156eaa79e4b3f27$export$6890652a1aff7d1c = /*#__PURE__*/ function(AnalyticsSource) {
    AnalyticsSource["PEOPLE_MENU"] = "peopleMenu";
    AnalyticsSource["RENOTIFY_MESSAGE"] = "renotifyMessage";
    AnalyticsSource["RENOTIFY_MODAL"] = "renotifyModal";
    AnalyticsSource["RENOTIFY_SPOTLIGHT"] = "renotifySpotlight";
    return AnalyticsSource;
}({});

});

parcelRegister("6uNb2", function(module, exports) {

$parcel$export(module.exports, "triggerAnalyticsForLoadedPeople", () => $9ae06323a5a66ecb$export$62ecc9342d32a444);
$parcel$export(module.exports, "triggerAnalyticsForLoadedTeam", () => $9ae06323a5a66ecb$export$e648838c8bbef986);

var $3mE7N = parcelRequire("3mE7N");
parcelRequire("9iwCj");
var $7kP9q = parcelRequire("7kP9q");
const $9ae06323a5a66ecb$export$62ecc9342d32a444 = (action, createAnalyticsEvent, status, error)=>{
    (0, $3mE7N.fireOperationalEvent)(createAnalyticsEvent, {
        actionSubject: (0, $7kP9q.AnalyticsActionSubject).PEOPLE_MENU_LINK,
        action: action === 'succeeded' ? (0, $7kP9q.AnalyticsAction).SUCCEEDED : (0, $7kP9q.AnalyticsAction).FAILED,
        attributes: {
            status: status,
            error: error?.message || JSON.stringify(error)
        }
    });
};
const $9ae06323a5a66ecb$export$e648838c8bbef986 = (action, createAnalyticsEvent, status, error)=>{
    (0, $3mE7N.fireOperationalEvent)(createAnalyticsEvent, {
        actionSubject: (0, $7kP9q.AnalyticsActionSubject).TEAM_MENU_LINK,
        action: action === 'succeeded' ? (0, $7kP9q.AnalyticsAction).SUCCEEDED : (0, $7kP9q.AnalyticsAction).FAILED,
        attributes: {
            status: status,
            error: error?.message || JSON.stringify(error)
        }
    });
};

});


parcelRegister("5LSAq", function(module, exports) {

let $433baf47b06abf01$var$load = (parcelRequire("28QjX"))(4);
module.exports = $433baf47b06abf01$var$load("jELnc").then(()=>parcelRequire('3YJEd'));

});

parcelRegister("PB8Ru", function(module, exports) {

let $09b19326192e4974$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $09b19326192e4974$var$load("ffQaD"),
    $09b19326192e4974$var$load("kvRbA"),
    $09b19326192e4974$var$load("kNFvF"),
    $09b19326192e4974$var$load("3L2aP")
]).then(()=>parcelRequire('8degK'));

});


parcelRegister("5iwOw", function(module, exports) {

$parcel$export(module.exports, "isCachedDataClear", () => $b65fff219f4109a7$export$cee8b843259f0f74);
$parcel$export(module.exports, "default", () => $b65fff219f4109a7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $jm65K = parcelRequire("jm65K");
var $hOaMz = parcelRequire("hOaMz");
const $b65fff219f4109a7$export$50fd3325777ce4bc = new Map();
const $b65fff219f4109a7$export$cd84c175965a58da = 'collaborators';
const $b65fff219f4109a7$export$b5c382592ac689a7 = 'teams';
const $b65fff219f4109a7$var$ONE_SEC = 1000;
const $b65fff219f4109a7$var$ONE_MINUTE = $b65fff219f4109a7$var$ONE_SEC * 60;
const $b65fff219f4109a7$var$REQUEST_CACHE_TIMEOUT_TEAMS = $b65fff219f4109a7$var$ONE_MINUTE;
const $b65fff219f4109a7$var$REQUEST_CACHE_TIMEOUT_USERS = $b65fff219f4109a7$var$ONE_MINUTE * 5;
function $b65fff219f4109a7$export$cee8b843259f0f74() {
    return $b65fff219f4109a7$export$50fd3325777ce4bc.size === 0;
}
function $b65fff219f4109a7$export$2e2bcd8739ae039(cloudId, userId, product, tenantUrl, requestCacheTimeout, orgId) {
    const [dataUsers, setDataUsers] = (0, $5uXOq.useState)(undefined);
    const [dataTeams, setDataTeams] = (0, $5uXOq.useState)(undefined);
    const { loading: isLoadingUsers, error: errorUsers, data: users } = (0, $jm65K.useCollaboratorsService)(cloudId, 'context', tenantUrl, requestCacheTimeout === undefined ? $b65fff219f4109a7$var$REQUEST_CACHE_TIMEOUT_USERS : requestCacheTimeout);
    const { loading: isLoadingTeams, error: errorTeams, data: teams } = (0, $hOaMz.useTeamsOfService)(userId, cloudId, product, tenantUrl, requestCacheTimeout === undefined ? $b65fff219f4109a7$var$REQUEST_CACHE_TIMEOUT_TEAMS : requestCacheTimeout, orgId);
    // after the service return the latest data,
    // we store users data in cache store.
    (0, $5uXOq.useEffect)(()=>{
        if (!users || isLoadingUsers || errorUsers) return;
        $b65fff219f4109a7$export$50fd3325777ce4bc.set($b65fff219f4109a7$export$cd84c175965a58da, users);
        setDataUsers(users);
    }, [
        users,
        isLoadingUsers,
        errorUsers
    ]);
    // after the service return the latest data,
    // store teams data in cache store.
    (0, $5uXOq.useEffect)(()=>{
        if (!teams || isLoadingTeams || errorTeams) return;
        $b65fff219f4109a7$export$50fd3325777ce4bc.set($b65fff219f4109a7$export$b5c382592ac689a7, teams);
        setDataTeams(teams);
    }, [
        teams,
        isLoadingTeams,
        errorTeams
    ]);
    return {
        users: dataUsers && dataUsers.length ? dataUsers : $b65fff219f4109a7$export$50fd3325777ce4bc.get($b65fff219f4109a7$export$cd84c175965a58da),
        teams: dataTeams && dataTeams.length ? dataTeams : $b65fff219f4109a7$export$50fd3325777ce4bc.get($b65fff219f4109a7$export$b5c382592ac689a7),
        errorTeams: errorTeams,
        errorUsers: errorUsers,
        isLoading: isLoadingUsers || isLoadingTeams
    };
}

});
parcelRegister("jm65K", function(module, exports) {

$parcel$export(module.exports, "useCollaboratorsService", () => $a01b882127eb026f$export$979a4f9449b8be53);

var $5uXOq = parcelRequire("5uXOq");

var $7j6lB = parcelRequire("7j6lB");

var $4QMKv = parcelRequire("4QMKv");

var $jFIGx = parcelRequire("jFIGx");

var $lKN3j = parcelRequire("lKN3j");
const $a01b882127eb026f$var$mapFetchCollaboratorsFnByTimeout = new Map();
function $a01b882127eb026f$var$getFetchCollaboratorsCachedFn(timeout = (0, $jFIGx.DEFAULT_RELEASE_RESOLVED_PROMISE_DELAY)) {
    let fn = $a01b882127eb026f$var$mapFetchCollaboratorsFnByTimeout.get(timeout);
    if (fn) return fn;
    fn = (0, $jFIGx.withCached)((0, $7j6lB.fetchCollaborators), timeout);
    $a01b882127eb026f$var$mapFetchCollaboratorsFnByTimeout.set(timeout, fn);
    return fn;
}
function $a01b882127eb026f$export$979a4f9449b8be53(cloudId, userId = 'context', tenantUrl = '', cacheTimeout) {
    const request = (0, $5uXOq.useCallback)(()=>{
        if (cacheTimeout) {
            const fn = $a01b882127eb026f$var$getFetchCollaboratorsCachedFn(cacheTimeout);
            return fn(cloudId, userId, tenantUrl);
        }
        return (0, $7j6lB.fetchCollaborators)(cloudId, userId, tenantUrl);
    }, [
        cacheTimeout,
        cloudId,
        userId,
        tenantUrl
    ]);
    const { loading: loading, error: error, data: data, fetchData: fetchData } = (0, $lKN3j.useService)(request, {
        loading: true
    });
    // For reusable services, it is better not to hardcode fetching on mount, to make them more flexible. When possible, add this code to component which calls service instead.
    (0, $5uXOq.useEffect)(()=>{
        fetchData();
    /*
      NOTE: If you add `fetchData` to the dependency list (in this component or its children) - you have to define `request` function you pass to `useService()` via `useCallback()`.
      Otherwise you may get an infinite loop.
    */ }, [
        fetchData
    ]);
    const memoizedData = (0, $5uXOq.useMemo)(()=>(0, $4QMKv.transformCollabsDataToUsers)(data), [
        data
    ]);
    return {
        loading: loading,
        error: error,
        data: memoizedData,
        fetchData: fetchData
    };
}

});
parcelRegister("7j6lB", function(module, exports) {

$parcel$export(module.exports, "fetchCollaborators", () => $1e130a4c1c3e3780$export$cadad85c3acf2ad8);

var $jtAXU = parcelRequire("jtAXU");
const $1e130a4c1c3e3780$export$42623aff9edf525f = '/gateway/api/collaboration/v1/collaborationgraph/user/user';
const $1e130a4c1c3e3780$var$LIMIT_RESULTS = 5;
const $1e130a4c1c3e3780$export$cadad85c3acf2ad8 = (cloudId, userId = 'context', tenantUrl = '')=>(0, $jtAXU.postJson)(`${tenantUrl}${$1e130a4c1c3e3780$export$42623aff9edf525f}`, {
        context: {
            contextType: 'atlassianPeoplePackage',
            principalId: userId,
            siteId: cloudId
        },
        maxNumberOfResults: $1e130a4c1c3e3780$var$LIMIT_RESULTS,
        userId: userId,
        expanded: true
    });

});
parcelRegister("jtAXU", function(module, exports) {

$parcel$export(module.exports, "fetchJson", () => $ce30f9eae95058a3$export$6d71b655afe1638d);
$parcel$export(module.exports, "postJson", () => $ce30f9eae95058a3$export$c776284ef4b1209a);
const $ce30f9eae95058a3$export$83179404a61b001a = 'FetchError';
function $ce30f9eae95058a3$export$847691ec04985fa0(error, status, traceId) {
    return {
        name: $ce30f9eae95058a3$export$83179404a61b001a,
        message: error.message,
        stack: error.stack,
        status: status,
        traceId: traceId
    };
}
const $ce30f9eae95058a3$export$6d71b655afe1638d = (url, init)=>{
    return fetch(url, {
        credentials: 'include',
        ...init
    }).then((response)=>{
        if (response.ok) return response.json();
        const traceId = response?.headers?.get('atl-traceid') || undefined;
        throw $ce30f9eae95058a3$export$847691ec04985fa0(new Error(`Unable to fetch ${url} ${response.status} ${response.statusText}`), response.status, traceId);
    });
};
const $ce30f9eae95058a3$export$c776284ef4b1209a = (url, data, headers)=>$ce30f9eae95058a3$export$6d71b655afe1638d(url, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            ...headers
        },
        body: JSON.stringify(data)
    });

});


parcelRegister("4QMKv", function(module, exports) {

$parcel$export(module.exports, "transformCollabsDataToUsers", () => $33301444de547d8e$export$1eb7590d078520b8);

var $dt9VY = parcelRequire("dt9VY");
const $33301444de547d8e$var$userMapper = (user)=>{
    const { userProfile: userProfile, entityType: entityType } = user;
    if (!userProfile || entityType !== (0, $dt9VY.ENTITY_TYPE).USER) return null;
    return {
        id: user.id,
        fullName: userProfile.name,
        nickname: userProfile.nickname,
        email: userProfile.email,
        avatarUrl: userProfile.picture,
        collaborationGraphScore: user.score,
        status: userProfile.account_status
    };
};
const $33301444de547d8e$export$1eb7590d078520b8 = (data)=>{
    if (!data) return [];
    const { collaborationGraphEntities: collaborationGraphEntities = [] } = data;
    return collaborationGraphEntities.map($33301444de547d8e$var$userMapper).filter((item)=>item) || [];
};

});
parcelRegister("dt9VY", function(module, exports) {

$parcel$export(module.exports, "ENTITY_TYPE", () => $c64d873f35a96cde$export$49be827a0aef75dd);
var $c64d873f35a96cde$export$49be827a0aef75dd = /*#__PURE__*/ function(ENTITY_TYPE) {
    ENTITY_TYPE["CONTAINER"] = "CONTAINER";
    ENTITY_TYPE["USER"] = "USER";
    return ENTITY_TYPE;
}({});
var $c64d873f35a96cde$export$fba7c3adda5094d9 = /*#__PURE__*/ function(CONTAINER_TYPE) {
    CONTAINER_TYPE["JIRA_PROJECT"] = "jiraProject";
    CONTAINER_TYPE["CONFLUENCE_SPACE"] = "confluenceSpace";
    return CONTAINER_TYPE;
}({});

});


parcelRegister("jFIGx", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_RELEASE_RESOLVED_PROMISE_DELAY", () => $66b55f654aa333ec$export$d8b1aa62ff4847fc);
$parcel$export(module.exports, "withCached", () => $66b55f654aa333ec$export$7f51828d6b6af163);
const $66b55f654aa333ec$var$ONE_SECOND = 1000;
const $66b55f654aa333ec$export$d8b1aa62ff4847fc = 5 * $66b55f654aa333ec$var$ONE_SECOND;
const $66b55f654aa333ec$var$isPromise = (p)=>{
    return p !== undefined && typeof p.then === 'function' && typeof p.catch === 'function';
};
const $66b55f654aa333ec$export$7f51828d6b6af163 = (fn, timeout = $66b55f654aa333ec$export$d8b1aa62ff4847fc)=>{
    const resultCache = new Map();
    const promiseCache = new Map();
    function getCacheKey(...args) {
        return JSON.stringify(args);
    }
    const cached = (...args)=>{
        const cacheKey = getCacheKey(...args);
        return resultCache.get(cacheKey);
    };
    const reset = ()=>{
        resultCache.clear();
        promiseCache.clear();
    };
    const execute = (...args)=>{
        const cacheKey = getCacheKey(...args);
        const cachedPromise = promiseCache.get(cacheKey);
        if (cachedPromise !== undefined) return cachedPromise;
        const maybePromise = fn(...args);
        // we don't handle non-promise data so skip it
        if ($66b55f654aa333ec$var$isPromise(maybePromise)) {
            promiseCache.set(cacheKey, maybePromise);
            maybePromise.then((result)=>{
                resultCache.set(cacheKey, result);
                setTimeout(()=>{
                    promiseCache.delete(cacheKey);
                    resultCache.delete(cacheKey);
                }, timeout);
            }).catch(()=>{
                promiseCache.delete(cacheKey);
                resultCache.delete(cacheKey);
            });
        }
        return maybePromise;
    };
    return Object.assign(execute, fn, {
        cached: cached,
        reset: reset
    });
};

});

parcelRegister("lKN3j", function(module, exports) {

$parcel$export(module.exports, "useService", () => $72edefc047c53cbc$export$6de4685a6c88b4e9);

var $5uXOq = parcelRequire("5uXOq");
const $72edefc047c53cbc$export$6de4685a6c88b4e9 = (request, initialState = {})=>{
    const [state, setStateRaw] = (0, $5uXOq.useState)({
        loading: false,
        ...initialState
    });
    const isMounted = (0, $5uXOq.useRef)(true);
    (0, $5uXOq.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    });
    const setState = (0, $5uXOq.useCallback)((state)=>{
        if (isMounted.current) setStateRaw(state);
    }, []);
    const fetchData = (0, $5uXOq.useCallback)(async ()=>{
        setState({
            loading: true,
            error: undefined,
            data: undefined
        });
        try {
            const data = await request();
            setState({
                loading: false,
                error: undefined,
                data: data
            });
        } catch (error) {
            setState({
                loading: false,
                error: error,
                data: undefined
            });
        }
    }, [
        request,
        setState
    ]);
    return {
        ...state,
        fetchData: fetchData
    };
};

});


parcelRegister("hOaMz", function(module, exports) {

$parcel$export(module.exports, "useTeamsOfService", () => $71e3afc4a862a4a9$export$668750a034956301);

var $5uXOq = parcelRequire("5uXOq");

var $b8vEv = parcelRequire("b8vEv");

var $eS2nd = parcelRequire("eS2nd");

var $jFIGx = parcelRequire("jFIGx");

var $lKN3j = parcelRequire("lKN3j");
const $71e3afc4a862a4a9$var$mapFetchMyTeamsFnByTimeout = new Map();
function $71e3afc4a862a4a9$var$getFetchMyTeamsCachedFn(timeout = (0, $jFIGx.DEFAULT_RELEASE_RESOLVED_PROMISE_DELAY)) {
    let fn = $71e3afc4a862a4a9$var$mapFetchMyTeamsFnByTimeout.get(timeout);
    if (fn) return fn;
    fn = (0, $jFIGx.withCached)((0, $b8vEv.searchTeamsOfUser), timeout);
    $71e3afc4a862a4a9$var$mapFetchMyTeamsFnByTimeout.set(timeout, fn);
    return fn;
}
function $71e3afc4a862a4a9$export$668750a034956301(userId, cloudId, product, tenantUrl = '', cacheTimeout, orgId) {
    const request = (0, $5uXOq.useCallback)(()=>{
        if (cacheTimeout) {
            const fn = $71e3afc4a862a4a9$var$getFetchMyTeamsCachedFn(cacheTimeout);
            return fn(userId, cloudId, product, tenantUrl, orgId);
        }
        return (0, $b8vEv.searchTeamsOfUser)(userId, cloudId, product, tenantUrl, orgId);
    }, [
        cacheTimeout,
        userId,
        cloudId,
        product,
        tenantUrl,
        orgId
    ]);
    const { loading: loading, error: error, data: data, fetchData: fetchData } = (0, $lKN3j.useService)(request, {
        loading: true
    });
    // For reusable services, it is better not to hardcode fetching on mount, to make them more flexible. When possible, add this code to component which calls service instead.
    (0, $5uXOq.useEffect)(()=>{
        fetchData();
    /*
      NOTE: If you add `fetchData` to the dependency list (in this component or its children) - you have to define `request` function you pass to `useService()` via `useCallback()`.
      Otherwise you may get an infinite loop.
    */ }, [
        fetchData
    ]);
    const memoizedData = (0, $5uXOq.useMemo)(()=>(0, $eS2nd.transformTeams)(data), [
        data
    ]);
    return {
        loading: loading,
        error: error,
        data: memoizedData,
        fetchData: fetchData
    };
}

});
parcelRegister("b8vEv", function(module, exports) {

$parcel$export(module.exports, "searchTeamsOfUser", () => $5b88913fa719a883$export$c52386bca71fd065);
$parcel$export(module.exports, "postCreateTeam", () => $5b88913fa719a883$export$db3c0c162386baf4);

var $dmOdc = parcelRequire("dmOdc");

var $3ys0B = parcelRequire("3ys0B");

var $1XkTN = parcelRequire("1XkTN");

var $v6X2P = parcelRequire("v6X2P");

var $jtAXU = parcelRequire("jtAXU");
const $5b88913fa719a883$var$LIMIT_RESULTS = 5;
const $5b88913fa719a883$export$51eb1e4b266d279a = '/gateway/api';
const $5b88913fa719a883$export$a6635dd972d6facf = `${$5b88913fa719a883$export$51eb1e4b266d279a}/v3/teams`;
const $5b88913fa719a883$export$8ebb304bc6fdbba2 = `${$5b88913fa719a883$export$51eb1e4b266d279a}/v4/teams`;
const $5b88913fa719a883$export$d6cee1ef1aa86c6d = `${$5b88913fa719a883$export$a6635dd972d6facf}/of-user`;
const $5b88913fa719a883$export$5c5040d455d75334 = `${$5b88913fa719a883$export$8ebb304bc6fdbba2}/search`;
const $5b88913fa719a883$export$2964ca5e058bf0b = (userId, cloudId, product, tenantUrl = '', orgId)=>{
    const params = [
        `limit=${$5b88913fa719a883$var$LIMIT_RESULTS}`,
        'cursor=',
        `organizationId=${orgId ?? ''}`,
        `origin.cloudId=${cloudId}`,
        `origin.product=${product.toUpperCase()}`
    ];
    return `${tenantUrl}${$5b88913fa719a883$export$d6cee1ef1aa86c6d}/${userId}?&${params.join('&')}`;
};
const $5b88913fa719a883$export$8c9e20a1ace4ac54 = (cloudId, product, tenantUrl = '')=>`${tenantUrl}${$5b88913fa719a883$export$5c5040d455d75334}${(0, $3ys0B.constructProductOriginParams)({
        product: product,
        cloudId: cloudId
    })}`;
const $5b88913fa719a883$export$d084da02a78b32a4 = (userId, cloudId, product, tenantUrl = '', orgId)=>orgId ? (0, $jtAXU.fetchJson)($5b88913fa719a883$export$2964ca5e058bf0b(userId, cloudId, product, tenantUrl, orgId)) : new Promise(()=>{});
const $5b88913fa719a883$export$c52386bca71fd065 = (userId, cloudId, product, tenantUrl = '', orgId)=>{
    if (!userId || !cloudId || !orgId) throw new (0, $v6X2P.ErrorWithContext)('Missing parameters', {
        userId: userId,
        cloudId: cloudId,
        orgId: orgId,
        product: product,
        tenantUrl: tenantUrl
    });
    const url = $5b88913fa719a883$export$8c9e20a1ace4ac54(cloudId, product, tenantUrl);
    const postData = {
        organizationId: orgId,
        siteId: cloudId,
        limit: $5b88913fa719a883$var$LIMIT_RESULTS,
        membership: {
            memberAccountIds: [
                userId
            ]
        }
    };
    return (0, $jtAXU.postJson)(url, postData);
};
const $5b88913fa719a883$export$db3c0c162386baf4 = async (teamName, membershipSettings, metaData)=>{
    (0, $dmOdc.teamsClient).setContext({
        cloudId: metaData.cloudId,
        orgId: metaData.orgId
    });
    (0, $dmOdc.teamsClient).setBaseUrl(`${metaData.tenantUrl ?? ''}${$5b88913fa719a883$export$51eb1e4b266d279a}`);
    const result = await (0, $dmOdc.teamsClient).createTeam(teamName, {
        product: metaData.product
    }, [
        ...new Set(metaData.members)
    ], membershipSettings === (0, $1XkTN.TeamMembershipSettings).OPEN ? 'OPEN' : 'MEMBER_INVITE');
    return {
        id: result.id,
        displayName: result.displayName,
        description: result.description,
        state: result.state === 'ACTIVE' ? (0, $1XkTN.TeamState).ACTIVE : (0, $1XkTN.TeamState).PURGED,
        membershipSettings: result.membershipSettings === 'OPEN' ? (0, $1XkTN.TeamMembershipSettings).OPEN : (0, $1XkTN.TeamMembershipSettings).INVITE_ONLY,
        memberCount: result.memberIds?.length ?? 0,
        teamAri: `ari:cloud:teams::team/${result.id}`,
        discoverable: (0, $1XkTN.TeamDiscoverability).DISCOVERABLE,
        organizationId: result.organizationId,
        restriction: (0, $1XkTN.TeamRestriction).NO_RESTRICTION,
        creatorId: result.creatorId,
        memberIds: result.memberIds,
        permission: result.permission === 'FULL_WRITE' ? (0, $1XkTN.TeamPermission).FULL_WRITE : result.permission === 'FULL_READ' ? (0, $1XkTN.TeamPermission).FULL_READ : (0, $1XkTN.TeamPermission).NONE
    };
};
const $5b88913fa719a883$export$76780145274bc285 = (teamId, { product: product, cloudId: cloudId, tenantUrl: tenantUrl = '' })=>{
    return `${tenantUrl}${$5b88913fa719a883$export$a6635dd972d6facf}/ui/${teamId}/membership/invite${(0, $3ys0B.constructProductOriginParams)({
        product: product,
        cloudId: cloudId
    })}`;
};
const $5b88913fa719a883$export$9cb3b92426f8e2eb = async (teamId, users, metaData)=>{
    if (!users || users.length === 0) return Promise.resolve(undefined);
    const emails = [];
    const ids = [];
    users.forEach((user)=>{
        if (user.id) ids.push(user.id);
        else if (user.email) emails.push(user.email);
    });
    const url = $5b88913fa719a883$export$76780145274bc285(teamId, metaData);
    const postData = {
        emailAddresses: emails,
        atlassianAccounts: ids
    };
    return (0, $jtAXU.postJson)(url, postData);
};

});
parcelRegister("3ys0B", function(module, exports) {

$parcel$export(module.exports, "constructProductOriginParams", () => $3d96dc0719b6030c$export$d479c7e8f449d360);
$parcel$export(module.exports, "getPeopleDirectoryHomePageWithOrgId", () => $3d96dc0719b6030c$export$873f5b458fb2c7bd);
$parcel$export(module.exports, "getPeopleProfilePage", () => $3d96dc0719b6030c$export$8d1c08ae3a193cc5);
$parcel$export(module.exports, "getTeamProfilePageLinkWithOrgId", () => $3d96dc0719b6030c$export$143be302a1686103);
$parcel$export(module.exports, "trimLastForwardSlash", () => $3d96dc0719b6030c$export$41ba1f3da3359c4);
function $3d96dc0719b6030c$var$toStrParams(obj) {
    const str = Object.keys(obj).map((k)=>{
        const v = obj[k];
        return v ? `${k}=${encodeURIComponent(v)}` : undefined;
    }).filter((it)=>!!it).join('&');
    return str ? `?${str}` : '';
}
function $3d96dc0719b6030c$export$d479c7e8f449d360(originQuery) {
    return $3d96dc0719b6030c$var$toStrParams({
        'origin.cloudId': originQuery.cloudId,
        'origin.product': originQuery.product?.toUpperCase() || ''
    });
}
function $3d96dc0719b6030c$export$575daf737e125483(remoteConfigResources) {
    return remoteConfigResources?.baseUrl || '';
}
function $3d96dc0719b6030c$export$873f5b458fb2c7bd({ remoteConfigResources: remoteConfigResources, orgId: orgId, ref: ref, src: src }) {
    const params = {
        ref: ref,
        src: src
    };
    return `${$3d96dc0719b6030c$export$575daf737e125483(remoteConfigResources)}${(remoteConfigResources?.peopleDirectoryHome || '').replace(':orgId', orgId ?? '')}${$3d96dc0719b6030c$var$toStrParams(params)}`;
}
function $3d96dc0719b6030c$export$a8c794e14e33c8e9(remoteConfigResources, ref, src) {
    const params = {
        ref: ref,
        src: src
    };
    return `${$3d96dc0719b6030c$export$575daf737e125483(remoteConfigResources)}${remoteConfigResources?.peopleDirectoryHome || ''}${$3d96dc0719b6030c$var$toStrParams(params)}`;
}
function $3d96dc0719b6030c$export$8d1c08ae3a193cc5(remoteConfigResources, userId, ref, src) {
    const params = {
        ref: ref,
        src: src
    };
    return `${$3d96dc0719b6030c$export$575daf737e125483(remoteConfigResources)}${(remoteConfigResources?.peopleProfile || '').replace(':userId', userId)}${$3d96dc0719b6030c$var$toStrParams(params)}`;
}
function $3d96dc0719b6030c$export$143be302a1686103({ remoteConfigResources: remoteConfigResources, teamId: teamId, orgId: orgId, ref: ref, src: src }) {
    const params = {
        ref: ref,
        src: src
    };
    return `${$3d96dc0719b6030c$export$575daf737e125483(remoteConfigResources)}${(remoteConfigResources?.teamProfile || '').replace(':teamId', teamId).replace(':orgId', orgId ?? '')}${$3d96dc0719b6030c$var$toStrParams(params)}`;
}
function $3d96dc0719b6030c$export$8b8a898467a65284(remoteConfigResources, teamId, ref, src) {
    const params = {
        ref: ref,
        src: src
    };
    return `${$3d96dc0719b6030c$export$575daf737e125483(remoteConfigResources)}${(remoteConfigResources?.teamProfile || '').replace(':teamId', teamId)}${$3d96dc0719b6030c$var$toStrParams(params)}`;
}
function $3d96dc0719b6030c$export$41ba1f3da3359c4(url = '') {
    if (url[url.length - 1] === '/') return url.slice(0, -1);
    return url;
}

});

parcelRegister("1XkTN", function(module, exports) {

$parcel$export(module.exports, "TeamState", () => $2e4d2173f996bc4f$export$c5c56131401e0716);
$parcel$export(module.exports, "TeamMembershipSettings", () => $2e4d2173f996bc4f$export$93b1c6cf9d16dce6);
$parcel$export(module.exports, "TeamDiscoverability", () => $2e4d2173f996bc4f$export$c698762b98da6685);
$parcel$export(module.exports, "TeamRestriction", () => $2e4d2173f996bc4f$export$e94592bde85a4d74);
$parcel$export(module.exports, "TeamPermission", () => $2e4d2173f996bc4f$export$4db108522156032a);
// raw data is returned from Legion API
var $2e4d2173f996bc4f$export$c5c56131401e0716 = /*#__PURE__*/ function(TeamState) {
    TeamState["ACTIVE"] = "ACTIVE";
    TeamState["DISBANDED"] = "DISBANDED";
    TeamState["PURGED"] = "PURGED";
    return TeamState;
}({});
var $2e4d2173f996bc4f$export$93b1c6cf9d16dce6 = /*#__PURE__*/ function(TeamMembershipSettings) {
    TeamMembershipSettings["OPEN"] = "OPEN";
    TeamMembershipSettings["INVITE_ONLY"] = "MEMBER_INVITE";
    TeamMembershipSettings["EXTERNAL"] = "EXTERNAL";
    return TeamMembershipSettings;
}({});
var $2e4d2173f996bc4f$export$c698762b98da6685 = /*#__PURE__*/ function(TeamDiscoverability) {
    TeamDiscoverability["DISCOVERABLE"] = "DISCOVERABLE";
    return TeamDiscoverability;
}({});
var $2e4d2173f996bc4f$export$e94592bde85a4d74 = /*#__PURE__*/ function(TeamRestriction) {
    TeamRestriction["ORG_MEMBERS"] = "ORG_MEMBERS";
    TeamRestriction["NO_RESTRICTION"] = "NO_RESTRICTION";
    return TeamRestriction;
}({});
var $2e4d2173f996bc4f$export$4db108522156032a = /*#__PURE__*/ function(TeamPermission) {
    TeamPermission["FULL_WRITE"] = "FULL_WRITE";
    TeamPermission["FULL_READ"] = "FULL_READ";
    TeamPermission["NONE"] = "NONE";
    return TeamPermission;
}({});

});

parcelRegister("v6X2P", function(module, exports) {

$parcel$export(module.exports, "ErrorWithContext", () => $f420277b82de59c9$export$6e749dfbce027249);
class $f420277b82de59c9$export$6e749dfbce027249 extends Error {
    constructor(message, context){
        super(message);
        this.context = context;
    }
}

});


parcelRegister("eS2nd", function(module, exports) {

$parcel$export(module.exports, "trimTeamAriInObject", () => $d1bcb2947e62ab7a$export$c75c12ecb0b3724e);
$parcel$export(module.exports, "transformTeams", () => $d1bcb2947e62ab7a$export$fd398a52d6f57b46);
function $d1bcb2947e62ab7a$export$c75c12ecb0b3724e(team) {
    if (!team) return team;
    return {
        ...team,
        id: team.id.replace('ari:cloud:teams::team/', '').replace('ari:cloud:identity::team/', '')
    };
}
const $d1bcb2947e62ab7a$export$fd398a52d6f57b46 = (data)=>{
    if (!data || !data.entities) return [];
    return data.entities.map($d1bcb2947e62ab7a$export$c75c12ecb0b3724e);
};

});



parcelRegister("dS8wI", function(module, exports) {

$parcel$export(module.exports, "VOID_FUNC", () => $83eda9ae9b3c8996$export$7e6ba5d480e9bd2f);
const $83eda9ae9b3c8996$export$53bb833296af4a30 = 5;
const $83eda9ae9b3c8996$export$88d6945644578407 = 3;
const $83eda9ae9b3c8996$export$7e6ba5d480e9bd2f = ()=>undefined;

});

parcelRegister("gFH8O", function(module, exports) {

$parcel$export(module.exports, "startMeasure", () => $b257cb8dc2555f00$export$b62aa2130c86b59b);
$parcel$export(module.exports, "stopMeasure", () => $b257cb8dc2555f00$export$37c25be427bec097);
$parcel$export(module.exports, "clearMeasure", () => $b257cb8dc2555f00$export$6f766653554dac02);
const $b257cb8dc2555f00$var$isPerformanceAPIAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType'
    ].every((api)=>!!performance[api]);
};
const $b257cb8dc2555f00$var$hasPerformanceAPIAvailable = $b257cb8dc2555f00$var$isPerformanceAPIAvailable();
const $b257cb8dc2555f00$var$measureMap = new Map();
function $b257cb8dc2555f00$export$b62aa2130c86b59b(measureName) {
    if (!$b257cb8dc2555f00$var$hasPerformanceAPIAvailable) return;
    performance.mark(`${measureName}::start`);
    $b257cb8dc2555f00$var$measureMap.set(measureName, performance.now());
}
function $b257cb8dc2555f00$export$37c25be427bec097(measureName, onMeasureComplete) {
    if (!$b257cb8dc2555f00$var$hasPerformanceAPIAvailable) return;
    // `startMeasure` is not called with `measureName` before.
    if (!$b257cb8dc2555f00$var$measureMap.get(measureName)) return;
    performance.mark(`${measureName}::end`);
    const start = onMeasureComplete ? $b257cb8dc2555f00$var$measureMap.get(measureName) : undefined;
    try {
        performance.measure(measureName, `${measureName}::start`, `${measureName}::end`);
    } catch (error) {} finally{
        if (onMeasureComplete) {
            const entry = performance.getEntriesByName(measureName).pop();
            if (entry) onMeasureComplete(entry.duration, entry.startTime);
            else if (start) onMeasureComplete(performance.now() - start, start);
        }
        $b257cb8dc2555f00$export$6f766653554dac02(measureName);
    }
}
function $b257cb8dc2555f00$export$6f766653554dac02(measureName) {
    if (!$b257cb8dc2555f00$var$hasPerformanceAPIAvailable) return;
    $b257cb8dc2555f00$var$measureMap.delete(measureName);
    performance.clearMarks(`${measureName}::start`);
    performance.clearMarks(`${measureName}::end`);
    performance.clearMeasures(measureName);
}

});

parcelRegister("jHmRo", function(module, exports) {

$parcel$export(module.exports, "MenuContent", () => $f5293b335fdac1fe$export$479f0f2f71193efe);
$parcel$export(module.exports, "MenuContentFallback", () => $f5293b335fdac1fe$export$48b47052ec2aea7f);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
parcelRequire("kc9vJ");
var $8DfXF = parcelRequire("8DfXF");

var $eZUJu = parcelRequire("eZUJu");

var $hEofo = parcelRequire("hEofo");

var $5iwOw = parcelRequire("5iwOw");

var $ihfgn = parcelRequire("ihfgn");

var $5IiJH = parcelRequire("5IiJH");

const $f5293b335fdac1fe$export$479f0f2f71193efe = (0, $8DfXF.lazyForPaint)(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("1x4s1")));
const $f5293b335fdac1fe$export$b0396be60c0e9152 = 480;
const $f5293b335fdac1fe$export$3f133812f81dfa49 = 320;
const $f5293b335fdac1fe$export$94aaf6acd960c412 = 'calc(100vh - 79px)';
function $f5293b335fdac1fe$export$48b47052ec2aea7f() {
    const { cloudId: cloudId, tenantUrl: tenantUrl, userId: userId, product: product, testId: testId, orgId: orgId } = (0, $5uXOq.useContext)((0, $hEofo.PeopleMenuContext));
    // kick off some requests sooner
    (0, $5iwOw.default)(cloudId, userId, product, tenantUrl, undefined, orgId);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $eZUJu.default), {
        testId: `${testId}-group-loading`,
        maxWidth: $f5293b335fdac1fe$export$b0396be60c0e9152,
        maxHeight: $f5293b335fdac1fe$export$94aaf6acd960c412,
        minWidth: $f5293b335fdac1fe$export$3f133812f81dfa49,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ihfgn.MenuGroupPeople), {
                isLoading: true
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5IiJH.MenuGroupTeams), {
                isLoading: true
            })
        ]
    });
}

});
parcelRegister("ihfgn", function(module, exports) {

$parcel$export(module.exports, "MenuGroupPeople", () => $96009d3d2861caf5$export$c521b8e86241ef89);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $cb25w = parcelRequire("cb25w");

var $3Z96c = parcelRequire("3Z96c");

var $fWjEu = parcelRequire("fWjEu");

var $3ys0B = parcelRequire("3ys0B");

var $hEofo = parcelRequire("hEofo");

var $dS8wI = parcelRequire("dS8wI");

var $c5ORg = parcelRequire("c5ORg");
parcelRequire("9iwCj");
var $7kP9q = parcelRequire("7kP9q");
var $9iwCj = parcelRequire("9iwCj");

var $ckanx = parcelRequire("ckanx");

var $cf0l8 = parcelRequire("cf0l8");

var $c2P5e = parcelRequire("c2P5e");
const $96009d3d2861caf5$export$2e63129145f0c868 = (props)=>{
    const intl = (0, $koVbs.default)();
    const { users: users = [], createAnalyticsEvent: createAnalyticsEvent, isLoading: isLoading, remoteConfig: remoteConfig } = props;
    const { testId: testId, product: product, onClickedItem: onClickedItem = (0, $dS8wI.VOID_FUNC), pushRoute: pushRoute = (0, $dS8wI.VOID_FUNC), togglePeopleMenu: togglePeopleMenu = (0, $dS8wI.VOID_FUNC) } = (0, $5uXOq.useContext)((0, $hEofo.PeopleMenuContext));
    const handleClickOnPeople = (0, $5uXOq.useCallback)((id)=>(event)=>{
            const isLeftClick = !(0, $c5ORg.isModifiedEvent)(event);
            (0, $9iwCj.triggerAnalyticsForClickOnPeople)(createAnalyticsEvent, isLeftClick);
            onClickedItem(id, 'people', event);
            if (isLeftClick) {
                const peopleProfilePage = (0, $3ys0B.getPeopleProfilePage)(remoteConfig.resources, id, product, (0, $7kP9q.AnalyticsActionSubject).PEOPLE_MENU);
                pushRoute(peopleProfilePage);
                event.preventDefault();
            }
            togglePeopleMenu(false);
        }, [
        createAnalyticsEvent,
        onClickedItem,
        product,
        pushRoute,
        remoteConfig.resources,
        togglePeopleMenu
    ]);
    if (!remoteConfig.sections.collaborators.enabled) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cf0l8.MenuGroupSection), {
        title: remoteConfig.sections.collaborators.label ?? intl.formatMessage((0, $ckanx.messages).yourCollab),
        testId: `${testId}-people-section`,
        isLoading: isLoading,
        isEmpty: users.length === 0,
        sectionType: 'user',
        maxItems: remoteConfig.sections.collaborators.maxItems,
        children: users.slice(0, remoteConfig.sections.collaborators.maxItems).map((user)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Z96c.default), {
                iconBefore: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c2P5e.ImgIcon), {
                    src: user.avatarUrl,
                    alt: ""
                }),
                testId: `${testId}-people-item`,
                href: (0, $3ys0B.getPeopleProfilePage)(remoteConfig.resources, user.id, product, (0, $7kP9q.AnalyticsActionSubject).PEOPLE_MENU),
                onClick: handleClickOnPeople(user.id),
                children: user.fullName
            }, user.id))
    });
};
const $96009d3d2861caf5$export$c521b8e86241ef89 = (0, $cb25w.default)()((0, $fWjEu.withMandatoryPeopleMenuConfiguration)($96009d3d2861caf5$export$2e63129145f0c868));

});
parcelRegister("fWjEu", function(module, exports) {

$parcel$export(module.exports, "usePeopleAndTeamsPeopleMenuConfiguration", () => $8887fdd411539e99$export$c616dd7f2557d148);
$parcel$export(module.exports, "withMandatoryPeopleMenuConfiguration", () => $8887fdd411539e99$export$aecb6ab9d1724228);

var $0Wtmq = parcelRequire("0Wtmq");
var $lQhhz = parcelRequire("lQhhz");
const $8887fdd411539e99$var$KEY = 'people-menu';
const $8887fdd411539e99$export$c616dd7f2557d148 = ()=>{
    const configuration = (0, $0Wtmq.usePeopleAndTeamsConfigurationContext)();
    return configuration[$8887fdd411539e99$var$KEY];
};
const $8887fdd411539e99$export$aecb6ab9d1724228 = (WrappedComponent)=>(0, $lQhhz.withMandatoryPeopleAndTeamsConfiguration)(WrappedComponent, $8887fdd411539e99$var$KEY);

});
parcelRegister("lQhhz", function(module, exports) {

$parcel$export(module.exports, "withMandatoryPeopleAndTeamsConfiguration", () => $d501cd0f5e905518$export$aead0eac38c797a5);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $0Wtmq = parcelRequire("0Wtmq");
function $d501cd0f5e905518$var$isMandatoryPeopleAndTeamsConfiguration(context) {
    return Boolean(context);
}
const $d501cd0f5e905518$export$aead0eac38c797a5 = (WrappedComponent, key)=>(props)=>{
        const remoteConfig = (0, $0Wtmq.usePeopleAndTeamsConfigurationContext)();
        if (!remoteConfig) return null;
        const keyedConfig = remoteConfig[key];
        if (!$d501cd0f5e905518$var$isMandatoryPeopleAndTeamsConfiguration(keyedConfig)) return null;
        return /*#__PURE__*/ (0, $2OMIu.jsx)(WrappedComponent, {
            remoteConfig: keyedConfig,
            ...props
        });
    };

});


parcelRegister("c5ORg", function(module, exports) {

$parcel$export(module.exports, "isModifiedEvent", () => $5872d4f5b124a4bb$export$642c6f14f6d4bbd5);
const $5872d4f5b124a4bb$export$642c6f14f6d4bbd5 = (event)=>!!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);

});

parcelRegister("ckanx", function(module, exports) {

$parcel$export(module.exports, "messages", () => $dce0e5ac2ce66eb1$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $dce0e5ac2ce66eb1$var$PREFIX = 'ptc.pm';
const $dce0e5ac2ce66eb1$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    yourCollab: {
        id: `${$dce0e5ac2ce66eb1$var$PREFIX}.collaborators.title`,
        defaultMessage: 'Your Collaborators',
        description: 'A title of Your-Collaborators section in People Menu dropdown'
    },
    yourTeams: {
        id: `${$dce0e5ac2ce66eb1$var$PREFIX}.your-teams.title`,
        defaultMessage: 'Your Teams',
        description: 'A title of a Your-Teams section in People Menu dropdown'
    },
    viewYourProfile: {
        id: `${$dce0e5ac2ce66eb1$var$PREFIX}.view-your-profile`,
        defaultMessage: 'View your profile',
        description: 'A link in People Menu. Clicking on it will navigate the user to their personal profile'
    },
    errorHeading: {
        id: `${$dce0e5ac2ce66eb1$var$PREFIX}.error-heading`,
        defaultMessage: "Something\u2019s gone wrong",
        description: 'Heading of the error screen which is shown when an unknown error happens in the People Menu. Usually due to failed network requests.'
    },
    errorText: {
        id: `${$dce0e5ac2ce66eb1$var$PREFIX}.error-text`,
        defaultMessage: "We keep track of these errors, but feel free to contact us if refreshing doesn\u2019t fix things",
        description: 'Text that is displayed when an unknown error happens in the People Menu.'
    },
    errorImageAltText: {
        id: `${$dce0e5ac2ce66eb1$var$PREFIX}.error-image-alt-text`,
        defaultMessage: 'A broken robot and a number of people busy fixing it.',
        description: 'Text displayed as alt text when an error occurs in the People Menu'
    },
    people: {
        id: `${$dce0e5ac2ce66eb1$var$PREFIX}.people`,
        defaultMessage: 'People',
        description: 'A default title of primary People menu'
    },
    teams: {
        id: `${$dce0e5ac2ce66eb1$var$PREFIX}.teams`,
        defaultMessage: 'Teams',
        description: 'A new default title of primary People menu'
    },
    numMembers: {
        id: `${$dce0e5ac2ce66eb1$var$PREFIX}.num-members`,
        defaultMessage: `{memberCount, plural,
    one {# member}
    other {# members}
}`,
        description: 'Subtext of the number of members belonging to a team'
    }
});

});

parcelRegister("cf0l8", function(module, exports) {

$parcel$export(module.exports, "MenuGroupSection", () => $69942e80fb1d50dd$export$33b4adfb29dd0d95);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $9UCCQ = parcelRequire("9UCCQ");
var $eaGfl = parcelRequire("eaGfl");

var $hEofo = parcelRequire("hEofo");

var $9hDzh = parcelRequire("9hDzh");
const $69942e80fb1d50dd$export$33b4adfb29dd0d95 = ({ title: title, isEmpty: isEmpty, isLoading: isLoading, children: children, testId: testId, maxItems: maxItems, sectionType: sectionType })=>{
    const { isSectionList: isSectionList = false } = (0, $5uXOq.useContext)((0, $hEofo.PeopleMenuContext));
    if (!isLoading && isEmpty) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9UCCQ.default), {
        // title is undefined if we are loading as we show the heading skeleton below
        title: isLoading ? undefined : title,
        testId: testId,
        isList: isSectionList,
        children: isLoading ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eaGfl.default), {
                    testId: `${sectionType}-skeleton-heading`
                }),
                Array(maxItems).fill(undefined).map((_, index)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $9hDzh.default), {}, `${sectionType}-${index}`))
            ]
        }) : children
    });
};

});
parcelRegister("9hDzh", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c4742eecef207b9$export$2e2bcd8739ae039);
/* LoadingSkeletonItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $iwwXK = parcelRequire("iwwXK");
const $7c4742eecef207b9$var$styles = {
    skeletonItem: "_mf8oze3t _7x0autpp _1xp3zwfg _da2vzwfg"
};
function $7c4742eecef207b9$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            $7c4742eecef207b9$var$styles.skeletonItem
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iwwXK.default), {
            hasAvatar: true,
            testId: "people-menu-skeleton-item"
        })
    });
}

});


parcelRegister("c2P5e", function(module, exports) {

$parcel$export(module.exports, "MAX_POPUP_WIDTH", () => $13590cfc2fac79d5$export$b0396be60c0e9152);
$parcel$export(module.exports, "MIN_POPUP_WIDTH", () => $13590cfc2fac79d5$export$3f133812f81dfa49);
$parcel$export(module.exports, "MAX_POPUP_HEIGHT", () => $13590cfc2fac79d5$export$94aaf6acd960c412);
$parcel$export(module.exports, "ImgIcon", () => $13590cfc2fac79d5$export$804b6389edcac2c2);
$parcel$export(module.exports, "Buggy", () => $13590cfc2fac79d5$export$6b52db8960fbef38);
$parcel$export(module.exports, "fireRenderPeopleNavMenuFail", () => $13590cfc2fac79d5$export$5884f4bd467a603a);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $fwSAz = parcelRequire("fwSAz");

var $v6X2P = parcelRequire("v6X2P");

var $6IwYZ = parcelRequire("6IwYZ");
const $13590cfc2fac79d5$export$91a15f1424900d33 = 32;
const $13590cfc2fac79d5$export$b0396be60c0e9152 = 480;
const $13590cfc2fac79d5$export$3f133812f81dfa49 = 320;
const $13590cfc2fac79d5$export$94aaf6acd960c412 = 'calc(100vh - 79px)';
function $13590cfc2fac79d5$export$804b6389edcac2c2({ src: src, alt: alt }) {
    if ((0, $VSDnB.fg)('enable-team-avatar-switch')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fwSAz.default), {
        size: "medium",
        src: src
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
        src: src || '',
        alt: alt,
        height: $13590cfc2fac79d5$export$91a15f1424900d33,
        width: $13590cfc2fac79d5$export$91a15f1424900d33,
        style: {
            borderRadius: $13590cfc2fac79d5$export$91a15f1424900d33 / 2
        }
    });
}
function $13590cfc2fac79d5$export$6b52db8960fbef38() {
    (0, $5uXOq.useEffect)(()=>{
        throw new Error('Something wrong inside People menu.');
    });
    return null;
}
const $13590cfc2fac79d5$export$5884f4bd467a603a = (error)=>{
    (0, $6IwYZ.renderPeopleNavMenuExp).failure({
        metadata: {
            ...error && 'status' in error ? {
                status: error.status
            } : {},
            ...error instanceof (0, $v6X2P.ErrorWithContext) ? {
                context: error.context
            } : {},
            error: error?.message
        }
    });
};

});
parcelRegister("6IwYZ", function(module, exports) {

$parcel$export(module.exports, "renderPeopleNavMenuExp", () => $0c056f8279034760$export$a0db9187c809008d);

var $atdLB = parcelRequire("atdLB");
var $duUGa = parcelRequire("duUGa");

var $bSD7G = parcelRequire("bSD7G");
class $0c056f8279034760$var$UFOExperienceWithPackageContext extends (0, $duUGa.UFOExperience) {
    async success() {
        return super.success({
            metadata: {
                ...(0, $bSD7G.packageContext)
            }
        });
    }
    async failure(config) {
        return super.failure({
            force: config?.force,
            metadata: {
                ...config?.metadata ?? {},
                ...(0, $bSD7G.packageContext)
            }
        });
    }
    async abort() {
        return super.abort({
            metadata: {
                ...(0, $bSD7G.packageContext)
            }
        });
    }
}
const $0c056f8279034760$export$a0db9187c809008d = new $0c056f8279034760$var$UFOExperienceWithPackageContext('render-people-nav-menu', {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: 'people'
    }
});

});
parcelRegister("bSD7G", function(module, exports) {

$parcel$export(module.exports, "packageContext", () => $7c6b76e7041bc9a3$export$beac86d91b8e8b21);
const $7c6b76e7041bc9a3$export$beac86d91b8e8b21 = {
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};

});




parcelRegister("5IiJH", function(module, exports) {

$parcel$export(module.exports, "MenuGroupTeams", () => $bb1377fb4ffc4d3f$export$c3915c5ac3f99d49);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $cb25w = parcelRequire("cb25w");

var $3Z96c = parcelRequire("3Z96c");

var $fWjEu = parcelRequire("fWjEu");

var $3ys0B = parcelRequire("3ys0B");

var $hEofo = parcelRequire("hEofo");

var $dS8wI = parcelRequire("dS8wI");

var $c5ORg = parcelRequire("c5ORg");
parcelRequire("9iwCj");
var $7kP9q = parcelRequire("7kP9q");
var $9iwCj = parcelRequire("9iwCj");

var $ckanx = parcelRequire("ckanx");

var $cf0l8 = parcelRequire("cf0l8");

var $c2P5e = parcelRequire("c2P5e");
const $bb1377fb4ffc4d3f$export$86c994b04df922e = (props)=>{
    const intl = (0, $koVbs.default)();
    const { orgId: orgId } = (0, $hEofo.usePeopleMenuContext)();
    const { teams: teams = [], createAnalyticsEvent: createAnalyticsEvent, isLoading: isLoading, remoteConfig: remoteConfig } = props;
    const { testId: testId, product: product, onClickedItem: onClickedItem = (0, $dS8wI.VOID_FUNC), pushRoute: pushRoute = (0, $dS8wI.VOID_FUNC), togglePeopleMenu: togglePeopleMenu = (0, $dS8wI.VOID_FUNC) } = (0, $5uXOq.useContext)((0, $hEofo.PeopleMenuContext));
    const handleClickOnTeam = (0, $5uXOq.useCallback)((id)=>(event)=>{
            const isLeftClick = !(0, $c5ORg.isModifiedEvent)(event);
            (0, $9iwCj.triggerAnalyticsForClickOnTeam)(createAnalyticsEvent, isLeftClick);
            onClickedItem(id, 'team', event);
            if (isLeftClick) {
                const teamUrl = (0, $3ys0B.getTeamProfilePageLinkWithOrgId)({
                    remoteConfigResources: remoteConfig.resources,
                    teamId: id,
                    orgId: orgId,
                    ref: product,
                    src: (0, $7kP9q.AnalyticsActionSubject).PEOPLE_MENU
                });
                pushRoute(teamUrl);
                event.preventDefault();
            }
            togglePeopleMenu(false);
        }, [
        createAnalyticsEvent,
        onClickedItem,
        orgId,
        product,
        pushRoute,
        remoteConfig.resources,
        togglePeopleMenu
    ]);
    if (!remoteConfig.sections.teams.enabled) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cf0l8.MenuGroupSection), {
        title: remoteConfig.sections.teams.label ?? intl.formatMessage((0, $ckanx.messages).yourTeams),
        testId: `${testId}-teams-section`,
        isLoading: isLoading,
        isEmpty: teams.length === 0,
        sectionType: 'team',
        maxItems: remoteConfig.sections.teams.maxItems,
        children: teams.slice(0, remoteConfig.sections.teams.maxItems).map((team)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Z96c.default), {
                href: (0, $3ys0B.getTeamProfilePageLinkWithOrgId)({
                    remoteConfigResources: remoteConfig.resources,
                    teamId: team.id,
                    orgId: orgId
                }),
                onClick: handleClickOnTeam(team.id),
                iconBefore: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c2P5e.ImgIcon), {
                    src: team.smallAvatarImageUrl || team.smallHeaderImageUrl,
                    alt: team.displayName
                }),
                description: intl.formatMessage((0, $ckanx.messages).numMembers, {
                    memberCount: team.memberCount ?? 1
                }),
                testId: `${testId}-team-item`,
                children: team.displayName
            }, team.id))
    });
};
const $bb1377fb4ffc4d3f$export$c3915c5ac3f99d49 = (0, $cb25w.default)()((0, $fWjEu.withMandatoryPeopleMenuConfiguration)($bb1377fb4ffc4d3f$export$86c994b04df922e));

});

parcelRegister("1x4s1", function(module, exports) {

let $11dc535c455f011b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $11dc535c455f011b$var$load("93JHA").then(()=>parcelRequire('gRkfD'));

});


parcelRegister("7U5E9", function(module, exports) {

$parcel$export(module.exports, "PeopleMenuContentInternal", () => $912805c3f7a736e5$export$78306a734b6419e6);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
parcelRequire("kc9vJ");
var $ihijj = parcelRequire("ihijj");

var $hEofo = parcelRequire("hEofo");

var $nRreb = parcelRequire("nRreb");

var $dS8wI = parcelRequire("dS8wI");

var $jHmRo = parcelRequire("jHmRo");

var $4144s = parcelRequire("4144s");
const $912805c3f7a736e5$var$stopPropagation = (e)=>e.stopPropagation();
const $912805c3f7a736e5$export$78306a734b6419e6 = /*#__PURE__*/ (0, $5uXOq.memo)(()=>{
    const { isBrowseUsersEnabled: isBrowseUsersEnabled } = (0, $5uXOq.useContext)((0, $hEofo.PeopleMenuContext));
    const { loading: isLoadingPermission, hasPermission: hasPermission } = (0, $nRreb.default)(isBrowseUsersEnabled);
    return(// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        onClick: $912805c3f7a736e5$var$stopPropagation,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ihijj.LazySuspense), {
            fallback: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jHmRo.MenuContentFallback), {}),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jHmRo.MenuContent), {
                isLoadingPermission: isLoadingPermission,
                hasPermission: hasPermission
            })
        })
    }));
});
const $912805c3f7a736e5$var$PeopleMenuContent = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4144s.default), {
        isOpen: true,
        onOpen: (0, $dS8wI.VOID_FUNC),
        onClose: (0, $dS8wI.VOID_FUNC),
        ...props,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($912805c3f7a736e5$export$78306a734b6419e6, {})
    });
};
var $912805c3f7a736e5$export$2e2bcd8739ae039 = $912805c3f7a736e5$var$PeopleMenuContent;

});
parcelRegister("nRreb", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbf7656828aeee5c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $fbf7656828aeee5c$export$2e2bcd8739ae039(permissionPromise) {
    const noQuery = !permissionPromise;
    const [hasPermission, setPermission] = (0, $5uXOq.useState)(noQuery);
    const [loading, setLoading] = (0, $5uXOq.useState)(!noQuery);
    (0, $5uXOq.useEffect)(()=>{
        if (permissionPromise) permissionPromise().then((permissionResult)=>{
            setPermission(permissionResult);
            setLoading(false);
        }).catch(()=>{
            setPermission(false);
            setLoading(false);
        });
    }, [
        permissionPromise,
        setLoading,
        setPermission
    ]);
    return {
        loading: loading,
        hasPermission: hasPermission
    };
}

});

parcelRegister("4144s", function(module, exports) {

$parcel$export(module.exports, "default", () => $c08e04c739d3d984$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $daJ0i = parcelRequire("daJ0i");

var $cISRa = parcelRequire("cISRa");

var $3ys0B = parcelRequire("3ys0B");

var $hEofo = parcelRequire("hEofo");

var $bSD7G = parcelRequire("bSD7G");
parcelRequire("9iwCj");
var $7kP9q = parcelRequire("7kP9q");

var $2eTLr = parcelRequire("2eTLr");
const $c08e04c739d3d984$var$defaultProps = {
    onClickedMenuLink: ()=>Promise.reject('No handler defined. Using default props value.'),
    testId: 'menu',
    isSSR: false
};
/**
 * There are some essential higher components wrapping an actual PeopleMenu component:
 * - PeopleMenuContext: is used to avoid passing common props like cloudId
 * - IntlProvider: to make i18n working
 * - AnalyticsContext: is used to avoid passing many props for triggering analytics events
 * - ErrorBoundary: to capture any errors inside actual PeopleMenu component
 */ const $c08e04c739d3d984$var$PeopleMenuProviders = (props)=>{
    const { children: children, product: product, subProduct: subProduct, cloudId: cloudId, orgId: orgId, userId: userId, isBrowseUsersEnabled: isBrowseUsersEnabled, testId: testId, tenantUrl: tenantUrl, onClickedItem: onClickedItem, onClickedMenuLink: onClickedMenuLink, invitePeopleHandlers: invitePeopleHandlers, onOpen: onOpen, onClose: onClose, pushRoute: pushRoute, _hasError: _hasError, addFlag: addFlag, isOpen: isOpen, isSSR: isSSR, teamCreateDialogProps: teamCreateDialogProps, shouldRenderToParent: shouldRenderToParent, isSectionList: isSectionList } = {
        ...$c08e04c739d3d984$var$defaultProps,
        ...props
    };
    const analyticsContextData = {
        product: product,
        source: (0, $7kP9q.AnalyticsSource).PEOPLE_MENU,
        componentName: (0, $7kP9q.AnalyticsSource).PEOPLE_MENU,
        ...(0, $bSD7G.packageContext)
    };
    const commonPropsInContext = {
        cloudId: cloudId,
        orgId: orgId,
        product: product,
        subProduct: subProduct,
        userId: userId,
        isBrowseUsersEnabled: isBrowseUsersEnabled,
        isSSR: isSSR,
        testId: testId,
        tenantUrl: (0, $3ys0B.trimLastForwardSlash)(tenantUrl),
        onClickedItem: onClickedItem,
        onClickedMenuLink: onClickedMenuLink,
        invitePeopleHandlers: invitePeopleHandlers,
        onOpen: onOpen,
        onClose: onClose,
        pushRoute: pushRoute,
        _hasError: _hasError,
        addFlag: addFlag,
        isPeopleMenuOpen: false,
        isOpen: isOpen,
        teamCreateDialogProps: teamCreateDialogProps,
        shouldRenderToParent: shouldRenderToParent,
        isSectionList: isSectionList
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hEofo.PeopleMenuContextProvider), {
        ...commonPropsInContext,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cISRa.LazyIntlProvider), {
            fetchLanguageFile: (0, $2eTLr.fetchLanguageFile),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $daJ0i.default), {
                data: analyticsContextData,
                children: children
            })
        })
    });
};
var $c08e04c739d3d984$export$2e2bcd8739ae039 = $c08e04c739d3d984$var$PeopleMenuProviders;

});
parcelRegister("cISRa", function(module, exports) {

$parcel$export(module.exports, "LazyIntlProvider", () => $765cbbd932b03192$export$b4f1ecc6daf5eb10);

var $5uXOq = parcelRequire("5uXOq");

var $i5FdW = parcelRequire("i5FdW");
var $koVbs = parcelRequire("koVbs");
const $765cbbd932b03192$export$94d2d72df36bbb16 = [
    'cs-CZ',
    'da-DK',
    'de-DE',
    'es-ES',
    'et-EE',
    'fi-FI',
    'fr-FR',
    'hu-HU',
    'is-IS',
    'it-IT',
    'ja-JP',
    'ko-KR',
    'nb-NB',
    'nl-NL',
    'pl-PL',
    'pt-BR',
    'pt-PT',
    'ro-RO',
    'ru-RU',
    'sk-SK',
    'sv-SE',
    'tr-TR',
    'th-TH',
    'uk-UK',
    'vi-VI',
    'zh-TW',
    'zh-HK',
    'zh-ZH',
    'zh-CN'
];
const $765cbbd932b03192$export$4d25b49b6dc1b540 = (locale)=>{
    const match = /([a-z]*)[_-]?([A-Z]*)/i.exec(locale);
    if (!match) throw Error('Unable to get language and country from invalid Locale');
    const [, language, country] = match;
    return {
        language: language.toLowerCase(),
        // when country code is missed, let it empty and we will use language/locale to find language file
        country: country ? country.toUpperCase() : ''
    };
};
function $765cbbd932b03192$export$5ac26fa9b941854e(locale, fetchLanguageFile) {
    const [messages, setMessages] = (0, $5uXOq.useState)({});
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        async function startToFetchMessagesByLocale() {
            const { language: language, country: country } = $765cbbd932b03192$export$4d25b49b6dc1b540(locale);
            // don't load English messages
            if (language === 'en') return;
            try {
                setIsLoading(true);
                const finalLocale = country ? `${language}-${country}` : language;
                const module = await fetchLanguageFile(finalLocale);
                const newMessages = module.default || module;
                setMessages(newMessages);
            } catch (e) {
            // fail to download message and do nothing because UI will use default language (English) to render
            } finally{
                setIsLoading(false);
            }
        }
        startToFetchMessagesByLocale();
    }, [
        locale,
        fetchLanguageFile
    ]);
    return {
        messages: messages,
        isLoading: isLoading
    };
}
const $765cbbd932b03192$export$b4f1ecc6daf5eb10 = (props)=>{
    const { children: children, fetchLanguageFile: fetchLanguageFile, ...rest } = props;
    const { locale: locale, messages: allMessages = {} } = (0, $koVbs.default)();
    const { messages: messages } = $765cbbd932b03192$export$5ac26fa9b941854e(locale, fetchLanguageFile);
    // Product might have already provided messages.
    // In the server-side environment, useFetchMessagesByLocale is noop we are relying on product to provide messages.
    for(const key in messages)if (!allMessages[key]) allMessages[key] = messages[key];
    return /*#__PURE__*/ (0, $5uXOq.createElement)((0, $i5FdW.default), {
        ...rest,
        messages: allMessages,
        key: locale,
        locale: locale,
        defaultLocale: "en-US"
    }, children);
};

});

parcelRegister("2eTLr", function(module, exports) {

$parcel$export(module.exports, "fetchLanguageFile", () => $97c2677f18f80a57$export$c08b58fa4727b0d2);

var $dX8RA = parcelRequire("dX8RA");
function $97c2677f18f80a57$export$c08b58fa4727b0d2(locale) {
    switch(locale){
        case 'cs-CZ':
        case 'cs':
            return $dX8RA.cs();
        case 'da-DK':
        case 'da':
            return $dX8RA.da();
        case 'de-DE':
        case 'de':
            return $dX8RA.de();
        case 'en-GB':
            return $dX8RA.engb();
        case 'en-US':
        case 'en':
            return $dX8RA.en();
        case 'en-ZZ':
            return $dX8RA.enzz();
        case 'es-ES':
        case 'es':
            return $dX8RA.es();
        case 'et-EE':
        case 'et':
            return $dX8RA.et();
        case 'fi-FI':
        case 'fi':
            return $dX8RA.fi();
        case 'fr-FR':
        case 'fr':
            return $dX8RA.fr();
        case 'hu-HU':
        case 'hu':
            return $dX8RA.hu();
        case 'is-IS':
        case 'is':
            return $dX8RA.is();
        case 'it-IT':
        case 'it':
            return $dX8RA.it();
        case 'ja-JP':
        case 'ja':
            return $dX8RA.ja();
        case 'ko-KR':
        case 'ko':
            return $dX8RA.ko();
        case 'nb-NB':
        case 'nb':
            return $dX8RA.nb();
        case 'nl-NL':
        case 'nl':
            return $dX8RA.nl();
        case 'pl-PL':
        case 'pl':
            return $dX8RA.pl();
        case 'pt-PT':
        case 'pt_PT':
        case 'pt':
            return $dX8RA.pt();
        case 'pt-BR':
        case 'pt_BR':
            return $dX8RA.ptbr();
        case 'ro-RO':
        case 'ro':
            return $dX8RA.ro();
        case 'ru-RU':
        case 'ru':
            return $dX8RA.ru();
        case 'sk-SK':
        case 'sk':
            return $dX8RA.sk();
        case 'sv-SE':
        case 'sv':
            return $dX8RA.sv();
        case 'tr-TR':
        case 'tr':
            return $dX8RA.tr();
        case 'th-TH':
        case 'th':
            return $dX8RA.th();
        case 'uk-UK':
        case 'uk':
            return $dX8RA.uk();
        case 'vi-VI':
        case 'vi':
            return $dX8RA.vi();
        case 'zh-TW':
        case 'zh-HK':
            return $dX8RA.zhtw();
        case 'zh-ZH':
        case 'zh-CN':
        case 'zh':
            return $dX8RA.zh();
    }
    return $dX8RA.fallback();
}

});
parcelRegister("dX8RA", function(module, exports) {

$parcel$export(module.exports, "fallback", () => $2bfa8f80c65d815a$export$bcd1dd1f397bba12);
$parcel$export(module.exports, "cs", () => $2bfa8f80c65d815a$export$bde1ed0f60b38f2f);
$parcel$export(module.exports, "da", () => $2bfa8f80c65d815a$export$8c8450b83b664ba4);
$parcel$export(module.exports, "de", () => $2bfa8f80c65d815a$export$2fa162a495d26869);
$parcel$export(module.exports, "en", () => $2bfa8f80c65d815a$export$84584c2a98eb6753);
$parcel$export(module.exports, "engb", () => $2bfa8f80c65d815a$export$141cd05f569bae45);
$parcel$export(module.exports, "enzz", () => $2bfa8f80c65d815a$export$a3f288d6c3177b8a);
$parcel$export(module.exports, "es", () => $2bfa8f80c65d815a$export$ca5e4045a55e76d2);
$parcel$export(module.exports, "et", () => $2bfa8f80c65d815a$export$457177dcde8472be);
$parcel$export(module.exports, "fi", () => $2bfa8f80c65d815a$export$ed5179c818622fb);
$parcel$export(module.exports, "fr", () => $2bfa8f80c65d815a$export$acb2a88f7d552ebf);
$parcel$export(module.exports, "hu", () => $2bfa8f80c65d815a$export$9901d21957972d53);
$parcel$export(module.exports, "is", () => $2bfa8f80c65d815a$export$226b3eccf92c9ed9);
$parcel$export(module.exports, "it", () => $2bfa8f80c65d815a$export$3486a10f30cf1ee4);
$parcel$export(module.exports, "ja", () => $2bfa8f80c65d815a$export$8c6f505e9474ce90);
$parcel$export(module.exports, "ko", () => $2bfa8f80c65d815a$export$798cf677954c9533);
$parcel$export(module.exports, "nb", () => $2bfa8f80c65d815a$export$38ef0e3f791a121e);
$parcel$export(module.exports, "nl", () => $2bfa8f80c65d815a$export$9c64ee4d84d79ce1);
$parcel$export(module.exports, "pl", () => $2bfa8f80c65d815a$export$6ea5311eda92944f);
$parcel$export(module.exports, "pt", () => $2bfa8f80c65d815a$export$84175d5f1cb4e39d);
$parcel$export(module.exports, "ptbr", () => $2bfa8f80c65d815a$export$82924b14976e7373);
$parcel$export(module.exports, "ro", () => $2bfa8f80c65d815a$export$ea30ec7f37fb148d);
$parcel$export(module.exports, "ru", () => $2bfa8f80c65d815a$export$cf48009033a0126b);
$parcel$export(module.exports, "sk", () => $2bfa8f80c65d815a$export$d608fa5b5bfd2021);
$parcel$export(module.exports, "sv", () => $2bfa8f80c65d815a$export$65540e5f7f6e7dce);
$parcel$export(module.exports, "tr", () => $2bfa8f80c65d815a$export$72451b88a72ad9c2);
$parcel$export(module.exports, "th", () => $2bfa8f80c65d815a$export$d657bc098992a431);
$parcel$export(module.exports, "uk", () => $2bfa8f80c65d815a$export$312745a8a3013c00);
$parcel$export(module.exports, "vi", () => $2bfa8f80c65d815a$export$e3786bf10a8abdf2);
$parcel$export(module.exports, "zh", () => $2bfa8f80c65d815a$export$b65a7f08f2280505);
$parcel$export(module.exports, "zhtw", () => $2bfa8f80c65d815a$export$41779e6acd26e15f);
/* istanbul ignore file */ const $2bfa8f80c65d815a$export$bcd1dd1f397bba12 = ()=>Promise.resolve({
        default: {}
    });

const $2bfa8f80c65d815a$export$bde1ed0f60b38f2f = ()=>(parcelRequire("1pN5l"));

const $2bfa8f80c65d815a$export$8c8450b83b664ba4 = ()=>(parcelRequire("1Hhcx"));

const $2bfa8f80c65d815a$export$2fa162a495d26869 = ()=>(parcelRequire("aJArm"));

const $2bfa8f80c65d815a$export$84584c2a98eb6753 = ()=>(parcelRequire("5zlkE"));

const $2bfa8f80c65d815a$export$141cd05f569bae45 = ()=>(parcelRequire("k0K3o"));

const $2bfa8f80c65d815a$export$a3f288d6c3177b8a = ()=>(parcelRequire("cn8Hy"));

const $2bfa8f80c65d815a$export$ca5e4045a55e76d2 = ()=>(parcelRequire("bZV9z"));

const $2bfa8f80c65d815a$export$457177dcde8472be = ()=>(parcelRequire("973X5"));

const $2bfa8f80c65d815a$export$ed5179c818622fb = ()=>(parcelRequire("lDqwo"));

const $2bfa8f80c65d815a$export$acb2a88f7d552ebf = ()=>(parcelRequire("91PBO"));

const $2bfa8f80c65d815a$export$9901d21957972d53 = ()=>(parcelRequire("5aNrK"));

const $2bfa8f80c65d815a$export$226b3eccf92c9ed9 = ()=>(parcelRequire("efsbl"));

const $2bfa8f80c65d815a$export$3486a10f30cf1ee4 = ()=>(parcelRequire("e9OPu"));

const $2bfa8f80c65d815a$export$8c6f505e9474ce90 = ()=>(parcelRequire("d5cLH"));

const $2bfa8f80c65d815a$export$798cf677954c9533 = ()=>(parcelRequire("9aaTw"));

const $2bfa8f80c65d815a$export$38ef0e3f791a121e = ()=>(parcelRequire("1gMCW"));

const $2bfa8f80c65d815a$export$9c64ee4d84d79ce1 = ()=>(parcelRequire("3X78k"));

const $2bfa8f80c65d815a$export$6ea5311eda92944f = ()=>(parcelRequire("lvGag"));

const $2bfa8f80c65d815a$export$84175d5f1cb4e39d = ()=>(parcelRequire("9HZGf"));

const $2bfa8f80c65d815a$export$82924b14976e7373 = ()=>(parcelRequire("io1jH"));

const $2bfa8f80c65d815a$export$ea30ec7f37fb148d = ()=>(parcelRequire("27SkM"));

const $2bfa8f80c65d815a$export$cf48009033a0126b = ()=>(parcelRequire("32C38"));

const $2bfa8f80c65d815a$export$d608fa5b5bfd2021 = ()=>(parcelRequire("4fcA2"));

const $2bfa8f80c65d815a$export$65540e5f7f6e7dce = ()=>(parcelRequire("kr8oc"));

const $2bfa8f80c65d815a$export$72451b88a72ad9c2 = ()=>(parcelRequire("cu66e"));

const $2bfa8f80c65d815a$export$d657bc098992a431 = ()=>(parcelRequire("anfPE"));

const $2bfa8f80c65d815a$export$312745a8a3013c00 = ()=>(parcelRequire("9X1Qp"));

const $2bfa8f80c65d815a$export$e3786bf10a8abdf2 = ()=>(parcelRequire("guhN0"));

const $2bfa8f80c65d815a$export$b65a7f08f2280505 = ()=>(parcelRequire("3V1E5"));

const $2bfa8f80c65d815a$export$41779e6acd26e15f = ()=>(parcelRequire("kR1Xs"));

});
parcelRegister("1pN5l", function(module, exports) {

let $107e33848c314706$var$load = (parcelRequire("28QjX"))(4);
module.exports = $107e33848c314706$var$load("bzPrt").then(()=>parcelRequire('fExJZ'));

});

parcelRegister("1Hhcx", function(module, exports) {

let $13c726634256996c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $13c726634256996c$var$load("cAcaY").then(()=>parcelRequire('h49zj'));

});

parcelRegister("aJArm", function(module, exports) {

let $7d0a5fa356a4eb8a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7d0a5fa356a4eb8a$var$load("kpct2").then(()=>parcelRequire('ksdj2'));

});

parcelRegister("5zlkE", function(module, exports) {

let $40e0c4ba9a57d63a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $40e0c4ba9a57d63a$var$load("bKLJ9").then(()=>parcelRequire('9S4eI'));

});

parcelRegister("k0K3o", function(module, exports) {

let $e917880e5ea9008f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e917880e5ea9008f$var$load("kNq8n").then(()=>parcelRequire('jR0Em'));

});

parcelRegister("cn8Hy", function(module, exports) {

let $901e61f9bff73dd8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $901e61f9bff73dd8$var$load("h6lR9").then(()=>parcelRequire('cpC58'));

});

parcelRegister("bZV9z", function(module, exports) {

let $8bc1b9ab9a87b1a0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8bc1b9ab9a87b1a0$var$load("cMAwR").then(()=>parcelRequire('hXLvF'));

});

parcelRegister("973X5", function(module, exports) {

let $6a27d54f40b6a83b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6a27d54f40b6a83b$var$load("kafKa").then(()=>parcelRequire('3jxEi'));

});

parcelRegister("lDqwo", function(module, exports) {

let $fc01d0186ff47c8d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fc01d0186ff47c8d$var$load("j3PEW").then(()=>parcelRequire('bem9x'));

});

parcelRegister("91PBO", function(module, exports) {

let $692c3d7bb91972ab$var$load = (parcelRequire("28QjX"))(4);
module.exports = $692c3d7bb91972ab$var$load("dJhw2").then(()=>parcelRequire('1Z04w'));

});

parcelRegister("5aNrK", function(module, exports) {

let $3c443df9a636d69c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3c443df9a636d69c$var$load("9KyV4").then(()=>parcelRequire('ddvLU'));

});

parcelRegister("efsbl", function(module, exports) {

let $a5f853c5820ffce0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a5f853c5820ffce0$var$load("e0KhN").then(()=>parcelRequire('iuYhr'));

});

parcelRegister("e9OPu", function(module, exports) {

let $a4e9559ac1b6dee4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a4e9559ac1b6dee4$var$load("3ORi1").then(()=>parcelRequire('kjLAT'));

});

parcelRegister("d5cLH", function(module, exports) {

let $9865a5857c342072$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9865a5857c342072$var$load("03LHp").then(()=>parcelRequire('j9DVR'));

});

parcelRegister("9aaTw", function(module, exports) {

let $6abd7fad78ae7584$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6abd7fad78ae7584$var$load("9202h").then(()=>parcelRequire('7zgXj'));

});

parcelRegister("1gMCW", function(module, exports) {

let $0ecd0167c5662a20$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0ecd0167c5662a20$var$load("clYHT").then(()=>parcelRequire('aXlfw'));

});

parcelRegister("3X78k", function(module, exports) {

let $2e0c6a511151b327$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2e0c6a511151b327$var$load("6aSvJ").then(()=>parcelRequire('71H9N'));

});

parcelRegister("lvGag", function(module, exports) {

let $fa8d3335ba7aceb0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fa8d3335ba7aceb0$var$load("aC90a").then(()=>parcelRequire('ljJMk'));

});

parcelRegister("9HZGf", function(module, exports) {

let $7117f9a25f4bc383$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7117f9a25f4bc383$var$load("2OZrA").then(()=>parcelRequire('9c3LE'));

});

parcelRegister("io1jH", function(module, exports) {

let $d62b7d577736e3f4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d62b7d577736e3f4$var$load("fGIvQ").then(()=>parcelRequire('h7Z1H'));

});

parcelRegister("27SkM", function(module, exports) {

let $18c661dbeb9b2ea1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $18c661dbeb9b2ea1$var$load("ixZBE").then(()=>parcelRequire('llnnW'));

});

parcelRegister("32C38", function(module, exports) {

let $236f12d62644aed1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $236f12d62644aed1$var$load("8Eo9v").then(()=>parcelRequire('jsirv'));

});

parcelRegister("4fcA2", function(module, exports) {

let $3172525666aad141$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3172525666aad141$var$load("4TfrF").then(()=>parcelRequire('7s028'));

});

parcelRegister("kr8oc", function(module, exports) {

let $ee0cd634477b402e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ee0cd634477b402e$var$load("9elLh").then(()=>parcelRequire('8Tuck'));

});

parcelRegister("cu66e", function(module, exports) {

let $916d049c44492d4b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $916d049c44492d4b$var$load("hhiQq").then(()=>parcelRequire('1czcz'));

});

parcelRegister("anfPE", function(module, exports) {

let $78d85543d00f8d49$var$load = (parcelRequire("28QjX"))(4);
module.exports = $78d85543d00f8d49$var$load("fLvHn").then(()=>parcelRequire('ciBsY'));

});

parcelRegister("9X1Qp", function(module, exports) {

let $73eb0df726f1e6a0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $73eb0df726f1e6a0$var$load("3PkAh").then(()=>parcelRequire('9Ej9o'));

});

parcelRegister("guhN0", function(module, exports) {

let $c00d3f4efc04bfc6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c00d3f4efc04bfc6$var$load("6TcvA").then(()=>parcelRequire('3IrzE'));

});

parcelRegister("3V1E5", function(module, exports) {

let $2da7f8bf33ea9888$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2da7f8bf33ea9888$var$load("8lxaY").then(()=>parcelRequire('eveoR'));

});

parcelRegister("kR1Xs", function(module, exports) {

let $f2ea46b5ebf354d0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f2ea46b5ebf354d0$var$load("geQMt").then(()=>parcelRequire('k9Nyn'));

});





parcelRegister("4AXtg", function(module, exports) {

$parcel$export(module.exports, "PeopleMenuTriggerSSR", () => $176dc84aa3d064ce$export$7e1e2ab520ce5d59);
$parcel$export(module.exports, "default", () => $176dc84aa3d064ce$export$2e2bcd8739ae039);
// eslint-disable @atlaskit/design-system/no-legacy-icons

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $7ownK = parcelRequire("7ownK");

var $ebd3R = parcelRequire("ebd3R");

var $3dGN0 = parcelRequire("3dGN0");

var $kJpBP = parcelRequire("kJpBP");

var $fWjEu = parcelRequire("fWjEu");

var $ckanx = parcelRequire("ckanx");
function $176dc84aa3d064ce$export$7e1e2ab520ce5d59({ testId: testId, peopleText: peopleText }) {
    const remoteConfig = (0, $fWjEu.usePeopleAndTeamsPeopleMenuConfiguration)();
    const navLabel = remoteConfig?.navLabel || peopleText;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7ownK.PrimaryDropdownButton), {
        testId: `${testId}-people-primary-button-ssr`,
        children: navLabel ? navLabel : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $ckanx.messages).teams
        })
    });
}
function $176dc84aa3d064ce$var$PeopleMenuTrigger(props) {
    const { isVisible: isVisible, isHighlighted: isHighlighted, customChevronIcon: customChevronIcon, triggerProps: triggerProps, onClick: onClick, onMouseEnter: onMouseEnter, testId: testId, isSelected: isSelected, peopleText: peopleText } = props;
    const buttonProps = (0, $5uXOq.useMemo)(()=>({
            isSelected: isSelected,
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            testId: testId
        }), [
        isSelected,
        onClick,
        onMouseEnter,
        testId
    ]);
    const remoteConfig = (0, $fWjEu.usePeopleAndTeamsPeopleMenuConfiguration)();
    const navLabel = remoteConfig?.navLabel || peopleText;
    const chevron = customChevronIcon || /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3dGN0))), {
        label: "dropdown-chevron",
        spacing: "spacious",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($ebd3R)))
    });
    const renderPrimaryDropDownButton = (0, $5uXOq.useCallback)(()=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7ownK.PrimaryDropdownButton), {
            isHighlighted: isHighlighted,
            ...buttonProps,
            ...triggerProps,
            children: navLabel || /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $ckanx.messages).teams
            })
        });
    }, [
        buttonProps,
        isHighlighted,
        navLabel,
        triggerProps
    ]);
    if (isVisible) return renderPrimaryDropDownButton();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kJpBP.default), {
        iconAfter: chevron,
        ...triggerProps,
        ...buttonProps,
        children: navLabel || /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $ckanx.messages).teams
        })
    });
}
var $176dc84aa3d064ce$export$2e2bcd8739ae039 = $176dc84aa3d064ce$var$PeopleMenuTrigger;

});

parcelRegister("14DM3", function(module, exports) {

$parcel$export(module.exports, "UsersTeamsPreFetch", () => $018d7b56116a683b$export$ffb64487c0de3976);

var $5uXOq = parcelRequire("5uXOq");

var $cb25w = parcelRequire("cb25w");

var $eSTPq = parcelRequire("eSTPq");

var $5iwOw = parcelRequire("5iwOw");

var $gFH8O = parcelRequire("gFH8O");

var $9iwCj = parcelRequire("9iwCj");
function $018d7b56116a683b$export$50ca75733630fce1({ cloudId: cloudId, orgId: orgId, userId: userId, product: product, tenantUrl: tenantUrl, createAnalyticsEvent: createAnalyticsEvent }) {
    (0, $5uXOq.useEffect)(()=>{
        (0, $9iwCj.triggerAnalyticsForPreFetchData)(createAnalyticsEvent);
        // measure duration time of fetching users and teams data
        (0, $gFH8O.startMeasure)('fetchingData');
    }, [
        createAnalyticsEvent
    ]);
    const { isLoading: isLoading } = (0, $5iwOw.default)(cloudId, userId, product, tenantUrl, undefined, orgId);
    /*
	 * This hook checks the renotify experiments eligibility passed from Jira
	 * and will only take action if enrolled. It makes a single call to
	 * Experiment-API which proxies a call to Hydra and Identity Gatekeeper
	 * to return users who have been invited to Jira but not accepted.
	 */ (0, $eSTPq.usePendingUsers)({
        cloudId: cloudId,
        startFetching: true
    });
    // stop to measure fetching data time when isLoading is finished.
    (0, $5uXOq.useEffect)(()=>{
        if (!isLoading) (0, $gFH8O.stopMeasure)('fetchingData', (duration, startTime)=>{
            (0, $9iwCj.triggerAnalyticsForFetchingData)(createAnalyticsEvent, duration, startTime);
        });
    }, [
        createAnalyticsEvent,
        isLoading
    ]);
    return null;
}
const $018d7b56116a683b$export$ffb64487c0de3976 = (0, $cb25w.default)()($018d7b56116a683b$export$50ca75733630fce1);

});
parcelRegister("eSTPq", function(module, exports) {

$parcel$export(module.exports, "usePendingUsers", () => $f55d0919c5fd27e7$export$8d720c7cdd23491d);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $9iwCj = parcelRequire("9iwCj");

var $5hWD5 = parcelRequire("5hWD5");
const $f55d0919c5fd27e7$export$50fd3325777ce4bc = new Map();
const $f55d0919c5fd27e7$export$7149af0c7f6b6e85 = 'pendingUsers';
const $f55d0919c5fd27e7$export$c9c3fbf7cb17786e = 'renotifyEligibility';
var $f55d0919c5fd27e7$export$e1b7db4c83021afe = /*#__PURE__*/ function(RenotifyStatus) {
    RenotifyStatus["IS_LOADING"] = "isLoading";
    RenotifyStatus["ELIGIBLE"] = "eligible";
    RenotifyStatus["INELIGIBLE"] = "ineligible";
    RenotifyStatus["ERROR"] = "error";
    return RenotifyStatus;
}({});
const $f55d0919c5fd27e7$var$REQUEST_CACHE_TIMEOUT_PENDING_USERS = 600000; // 10 minutes
function $f55d0919c5fd27e7$export$8d720c7cdd23491d({ cloudId: cloudId, startFetching: startFetching, renotifyExperiment: renotifyExperiment, product: product, requestCacheTimeout: requestCacheTimeout }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [pendingUsers, setPendingUsers] = (0, $5uXOq.useState)($f55d0919c5fd27e7$export$50fd3325777ce4bc.get($f55d0919c5fd27e7$export$7149af0c7f6b6e85));
    const [renotifyEligible, setRenotifyEligibility] = (0, $5uXOq.useState)($f55d0919c5fd27e7$export$50fd3325777ce4bc.get($f55d0919c5fd27e7$export$c9c3fbf7cb17786e));
    const { loading: pendingUsersLoading, error: pendingUsersError, data: pendingUsersData, fetchData: fetchPendingUsers } = (0, $5hWD5.usePendingUsersService)(cloudId, requestCacheTimeout === undefined ? $f55d0919c5fd27e7$var$REQUEST_CACHE_TIMEOUT_PENDING_USERS : requestCacheTimeout, product);
    (0, $5uXOq.useEffect)(()=>{
        if (renotifyEligible !== undefined || renotifyExperiment?.isLoading || !startFetching) return;
        if (renotifyExperiment?.isEnrolled) fetchPendingUsers();
        else {
            $f55d0919c5fd27e7$export$50fd3325777ce4bc.set($f55d0919c5fd27e7$export$c9c3fbf7cb17786e, false);
            setRenotifyEligibility(false);
        }
    }, [
        renotifyEligible,
        fetchPendingUsers,
        renotifyExperiment?.isLoading,
        renotifyExperiment?.isEnrolled,
        startFetching
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (pendingUsersError) {
            (0, $9iwCj.triggerAnalyticsForRenotifyFetchInactiveUsersFailed)(createAnalyticsEvent);
            $f55d0919c5fd27e7$export$50fd3325777ce4bc.set($f55d0919c5fd27e7$export$c9c3fbf7cb17786e, false);
            setRenotifyEligibility(false);
            return;
        }
        if (pendingUsersData === undefined || pendingUsersLoading) return;
        $f55d0919c5fd27e7$export$50fd3325777ce4bc.set($f55d0919c5fd27e7$export$7149af0c7f6b6e85, pendingUsersData);
        setPendingUsers(pendingUsersData);
        if (pendingUsersData?.length) {
            (0, $9iwCj.triggerAnalyticsForRenotifyFetchInactiveUsersSucceeded)(createAnalyticsEvent, {
                numberOfInviteeEmails: pendingUsersData?.length
            });
            $f55d0919c5fd27e7$export$50fd3325777ce4bc.set($f55d0919c5fd27e7$export$c9c3fbf7cb17786e, true);
            if (renotifyExperiment?.isEnrolled) setRenotifyEligibility(true);
        } else {
            (0, $9iwCj.triggerAnalyticsForRenotifyNotEligible)(createAnalyticsEvent, {
                reason: 'No pending users'
            });
            $f55d0919c5fd27e7$export$50fd3325777ce4bc.set($f55d0919c5fd27e7$export$c9c3fbf7cb17786e, false);
            setRenotifyEligibility(false);
        }
    }, [
        createAnalyticsEvent,
        pendingUsersData,
        pendingUsersError,
        pendingUsersLoading,
        renotifyExperiment
    ]);
    if (pendingUsersLoading || renotifyExperiment?.isLoading) return {
        status: "isLoading",
        isLoading: true
    };
    if (pendingUsersError) return {
        status: "error",
        pendingUsersError: pendingUsersError ?? new Error('Invalid pending user response'),
        isLoading: false
    };
    if (renotifyEligible === false || !pendingUsers) return {
        status: "ineligible",
        isLoading: false
    };
    return {
        status: "eligible",
        isLoading: false,
        pendingUsers: pendingUsers
    };
}

});
parcelRegister("5hWD5", function(module, exports) {

$parcel$export(module.exports, "usePendingUsersService", () => $b6986ac8ac2209a9$export$4e16c66a0a5052e1);

var $5uXOq = parcelRequire("5uXOq");

var $jFIGx = parcelRequire("jFIGx");

var $lKN3j = parcelRequire("lKN3j");

var $dCmT9 = parcelRequire("dCmT9");

var $hEofo = parcelRequire("hEofo");
const $b6986ac8ac2209a9$var$mapFetchInactiveUserFnByTimeout = new Map();
function $b6986ac8ac2209a9$var$getFetchInactiveUsersCachedFn(timeout = (0, $jFIGx.DEFAULT_RELEASE_RESOLVED_PROMISE_DELAY)) {
    let fn = $b6986ac8ac2209a9$var$mapFetchInactiveUserFnByTimeout.get(timeout);
    if (fn) return fn;
    fn = (0, $jFIGx.withCached)((0, $dCmT9.fetchInactiveUsers), timeout);
    $b6986ac8ac2209a9$var$mapFetchInactiveUserFnByTimeout.set(timeout, fn);
    return fn;
}
function $b6986ac8ac2209a9$export$4e16c66a0a5052e1(cloudId, cacheTimeout, product) {
    const { product: contextProduct } = (0, $hEofo.usePeopleMenuContext)();
    const request = (0, $5uXOq.useCallback)(()=>{
        if (cacheTimeout) {
            const fn = $b6986ac8ac2209a9$var$getFetchInactiveUsersCachedFn(cacheTimeout);
            return fn(cloudId, product ?? contextProduct);
        }
        return (0, $dCmT9.fetchInactiveUsers)(cloudId, product ?? contextProduct);
    }, [
        cacheTimeout,
        cloudId,
        product,
        contextProduct
    ]);
    const { loading: loading, error: error, data: data, fetchData: fetchData } = (0, $lKN3j.useService)(request);
    return {
        loading: loading,
        error: error,
        data: data?.users,
        fetchData: fetchData
    };
}

});
parcelRegister("dCmT9", function(module, exports) {

$parcel$export(module.exports, "fetchInactiveUsers", () => $133024ceef7b0aad$export$b6000772b84436c7);

var $g1fRS = parcelRequire("g1fRS");
const $133024ceef7b0aad$var$EXPERIMENT_API_BASE = '/gateway/api/growth/';
const $133024ceef7b0aad$var$getExperimentAPICommonPath = (product)=>`${$133024ceef7b0aad$var$EXPERIMENT_API_BASE}${product === 'confluence' ? 'notify-if-invitee-never-logged-in-confluence' : 'notify-if-invitee-never-logged-in'}`;
const $133024ceef7b0aad$var$getInactiveUsersUrl = (cloudId, product)=>`${$133024ceef7b0aad$var$getExperimentAPICommonPath(product)}/get-inactive-users?cloudId=${cloudId}`;
const $133024ceef7b0aad$export$b6000772b84436c7 = (cloudId, product)=>(0, $g1fRS.fetchJson)($133024ceef7b0aad$var$getInactiveUsersUrl(cloudId, product));
const $133024ceef7b0aad$var$getReinviteUrl = (product)=>`${$133024ceef7b0aad$var$getExperimentAPICommonPath(product)}/reinvite`;
const $133024ceef7b0aad$export$df764bf7318de5 = (cloudId, reInvites, product)=>{
    return (0, $g1fRS.postJson)($133024ceef7b0aad$var$getReinviteUrl(product), {
        owner: `ari:cloud:platform::site/${cloudId}`,
        reInvites: reInvites.map(({ userId: userId, continueUrl: continueUrl })=>({
                inviteeId: `ari:cloud:identity::user/${userId}`,
                continueUrl: continueUrl
            }))
    });
};

});
parcelRegister("g1fRS", function(module, exports) {

$parcel$export(module.exports, "fetchJson", () => $267b2825c14900b3$export$6d71b655afe1638d);
$parcel$export(module.exports, "postJson", () => $267b2825c14900b3$export$c776284ef4b1209a);
const $267b2825c14900b3$export$83179404a61b001a = 'FetchError';
function $267b2825c14900b3$export$847691ec04985fa0(error, status) {
    return {
        name: $267b2825c14900b3$export$83179404a61b001a,
        message: error.message,
        stack: error.stack,
        status: status
    };
}
const $267b2825c14900b3$export$6d71b655afe1638d = (url, init)=>fetch(url, {
        credentials: 'include',
        ...init
    }).then((response)=>{
        if (response.ok) return response.json();
        throw $267b2825c14900b3$export$847691ec04985fa0(new Error(`Unable to fetch ${url} ${response.status} ${response.statusText}`), response.status);
    });
const $267b2825c14900b3$export$c776284ef4b1209a = (url, data)=>$267b2825c14900b3$export$6d71b655afe1638d(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });

});







parcelRegister("fElvF", function(module, exports) {

$parcel$export(module.exports, "InvitePeopleModalContext", () => $075d48b841fc8ac5$export$be58429061ae5194);
$parcel$export(module.exports, "InvitePeopleModalContextProvider", () => $075d48b841fc8ac5$export$496e4f58036bb94d);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

const $075d48b841fc8ac5$var$AKInvitePeopleModal = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("gB5co")));

const $075d48b841fc8ac5$var$AKModalTransition = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("5LSAq")).then((module)=>({
            default: module.ModalTransition
        })));
const $075d48b841fc8ac5$export$be58429061ae5194 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isOpen: false,
    openModal: ()=>undefined,
    closeModal: ()=>undefined
});
const $075d48b841fc8ac5$export$496e4f58036bb94d = (invitePeopleModalContextProviderProps)=>{
    const { children: children } = invitePeopleModalContextProviderProps;
    const [invitePeopleState, setInvitePeopleState] = (0, $5uXOq.useState)({
        isOpen: false
    });
    const openModal = (invitePeopleProps, onClose)=>{
        setInvitePeopleState({
            isOpen: true,
            props: invitePeopleProps,
            onClose: onClose
        });
    };
    const closeModal = (0, $5uXOq.useCallback)((trigger)=>{
        if (!invitePeopleState.isOpen) return;
        invitePeopleState.onClose?.(trigger);
        setInvitePeopleState({
            previousProps: invitePeopleState.props,
            isOpen: false
        });
    }, [
        invitePeopleState
    ]);
    const reopenModal = (0, $5uXOq.useCallback)(()=>{
        // Reopen function can only reopen invite people if openModal has been called once with props
        setInvitePeopleState((prevState)=>!prevState.isOpen && prevState.previousProps ? {
                props: prevState.previousProps,
                isOpen: true
            } : prevState);
    }, []);
    const context = (0, $5uXOq.useMemo)(()=>({
            openModal: openModal,
            closeModal: closeModal,
            isOpen: invitePeopleState.isOpen
        }), [
        closeModal,
        invitePeopleState.isOpen
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)($075d48b841fc8ac5$export$be58429061ae5194.Provider, {
        value: context,
        children: [
            children,
            invitePeopleState.isOpen && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)($075d48b841fc8ac5$var$AKModalTransition, {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)($075d48b841fc8ac5$var$AKInvitePeopleModal, {
                        onCloseHandler: closeModal,
                        experimental_onReopenHandler: reopenModal,
                        ...invitePeopleState.props
                    })
                })
            })
        ]
    });
};

});
parcelRegister("gB5co", function(module, exports) {

let $c1542268c9fd1eb6$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $c1542268c9fd1eb6$var$load("ffQaD"),
    $c1542268c9fd1eb6$var$load("kvRbA"),
    $c1542268c9fd1eb6$var$load("kNFvF"),
    $c1542268c9fd1eb6$var$load("3GGfo")
]).then(()=>parcelRequire('h8XS8'));

});


parcelRegister("2JsdQ", function(module, exports) {

$parcel$export(module.exports, "useInvitePeopleModal", () => $e68e6d998c14d38d$export$b9ec44715ae5ad99);

var $5uXOq = parcelRequire("5uXOq");

var $fElvF = parcelRequire("fElvF");
const $e68e6d998c14d38d$export$b9ec44715ae5ad99 = (useInvitePeopleModalProps)=>{
    const { onClose: onClose, ...invitePeopleProps } = useInvitePeopleModalProps;
    const { openModal: openModal, closeModal: closeModal, isOpen: isOpen } = (0, $5uXOq.useContext)((0, $fElvF.InvitePeopleModalContext));
    return {
        // this is experimental only and should not be used without consulting !core-invtes in #groot-techops
        experimental_openModal: (propsOverride)=>openModal({
                ...invitePeopleProps,
                ...propsOverride
            }, onClose),
        openModal: ()=>openModal(invitePeopleProps, onClose),
        closeModal: closeModal,
        isOpen: isOpen
    };
};

});

parcelRegister("e3a3O", function(module, exports) {

$parcel$export(module.exports, "NetworkStatus", () => $02a3c2aebc919401$export$bd096ddbd246c79c);
$parcel$export(module.exports, "isApolloError", () => $02a3c2aebc919401$export$17f5e6bd290bb15d);
$parcel$export(module.exports, "ApolloError", () => $02a3c2aebc919401$export$26a337512320b8c6);
$parcel$export(module.exports, "ApolloClient", () => $02a3c2aebc919401$export$13f5a5f0f1dbab88);

var $3VFsf = parcelRequire("3VFsf");

var $jojW6 = parcelRequire("jojW6");
var $bqMzA = parcelRequire("bqMzA");

var $clSzL = parcelRequire("clSzL");
var $aS6b9 = parcelRequire("aS6b9");

var $ebaCz = parcelRequire("ebaCz");

var $1DiV8 = parcelRequire("1DiV8");

var $12QNw = parcelRequire("12QNw");
var $02a3c2aebc919401$export$bd096ddbd246c79c;
(function(NetworkStatus) {
    NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    NetworkStatus[NetworkStatus["error"] = 8] = "error";
})($02a3c2aebc919401$export$bd096ddbd246c79c || ($02a3c2aebc919401$export$bd096ddbd246c79c = {}));
function $02a3c2aebc919401$var$isNetworkRequestInFlight(networkStatus) {
    return networkStatus < 7;
}
var $02a3c2aebc919401$var$Observable = function(_super) {
    (0, $3VFsf.__extends)(Observable, _super);
    function Observable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Observable.prototype[0, $ebaCz.default] = function() {
        return this;
    };
    Observable.prototype['@@observable'] = function() {
        return this;
    };
    return Observable;
}((0, $aS6b9.default));
function $02a3c2aebc919401$var$isNonEmptyArray(value) {
    return Array.isArray(value) && value.length > 0;
}
function $02a3c2aebc919401$export$17f5e6bd290bb15d(err) {
    return err.hasOwnProperty('graphQLErrors');
}
var $02a3c2aebc919401$var$generateErrorMessage = function(err) {
    var message = '';
    if ($02a3c2aebc919401$var$isNonEmptyArray(err.graphQLErrors)) err.graphQLErrors.forEach(function(graphQLError) {
        var errorMessage = graphQLError ? graphQLError.message : 'Error message not found.';
        message += "GraphQL error: " + errorMessage + "\n";
    });
    if (err.networkError) message += 'Network error: ' + err.networkError.message + '\n';
    message = message.replace(/\n$/, '');
    return message;
};
var $02a3c2aebc919401$export$26a337512320b8c6 = function(_super) {
    (0, $3VFsf.__extends)(ApolloError, _super);
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.graphQLErrors = graphQLErrors || [];
        _this.networkError = networkError || null;
        if (!errorMessage) _this.message = $02a3c2aebc919401$var$generateErrorMessage(_this);
        else _this.message = errorMessage;
        _this.extraInfo = extraInfo;
        _this.__proto__ = ApolloError.prototype;
        return _this;
    }
    return ApolloError;
}(Error);
var $02a3c2aebc919401$export$160bafb6ac1e0641;
(function(FetchType) {
    FetchType[FetchType["normal"] = 1] = "normal";
    FetchType[FetchType["refetch"] = 2] = "refetch";
    FetchType[FetchType["poll"] = 3] = "poll";
})($02a3c2aebc919401$export$160bafb6ac1e0641 || ($02a3c2aebc919401$export$160bafb6ac1e0641 = {}));
var $02a3c2aebc919401$var$hasError = function(storeValue, policy) {
    if (policy === void 0) policy = 'none';
    return storeValue && (storeValue.networkError || policy === 'none' && $02a3c2aebc919401$var$isNonEmptyArray(storeValue.graphQLErrors));
};
var $02a3c2aebc919401$export$6c1b56eac59c9584 = function(_super) {
    (0, $3VFsf.__extends)(ObservableQuery, _super);
    function ObservableQuery(_a) {
        var queryManager = _a.queryManager, options = _a.options, _b = _a.shouldSubscribe, shouldSubscribe = _b === void 0 ? true : _b;
        var _this = _super.call(this, function(observer) {
            return _this.onSubscribe(observer);
        }) || this;
        _this.observers = new Set();
        _this.subscriptions = new Set();
        _this.isTornDown = false;
        _this.options = options;
        _this.variables = options.variables || {};
        _this.queryId = queryManager.generateQueryId();
        _this.shouldSubscribe = shouldSubscribe;
        var opDef = (0, $jojW6.getOperationDefinition)(options.query);
        _this.queryName = opDef && opDef.name && opDef.name.value;
        _this.queryManager = queryManager;
        return _this;
    }
    ObservableQuery.prototype.result = function() {
        var _this = this;
        return new Promise(function(resolve, reject) {
            var observer = {
                next: function(result) {
                    resolve(result);
                    _this.observers.delete(observer);
                    if (!_this.observers.size) _this.queryManager.removeQuery(_this.queryId);
                    setTimeout(function() {
                        subscription.unsubscribe();
                    }, 0);
                },
                error: reject
            };
            var subscription = _this.subscribe(observer);
        });
    };
    ObservableQuery.prototype.currentResult = function() {
        var result = this.getCurrentResult();
        if (result.data === undefined) result.data = {};
        return result;
    };
    ObservableQuery.prototype.getCurrentResult = function() {
        if (this.isTornDown) {
            var lastResult = this.lastResult;
            return {
                data: !this.lastError && lastResult && lastResult.data || void 0,
                error: this.lastError,
                loading: false,
                networkStatus: $02a3c2aebc919401$export$bd096ddbd246c79c.error
            };
        }
        var _a = this.queryManager.getCurrentQueryResult(this), data = _a.data, partial = _a.partial;
        var queryStoreValue = this.queryManager.queryStore.get(this.queryId);
        var result;
        var fetchPolicy = this.options.fetchPolicy;
        var isNetworkFetchPolicy = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
        if (queryStoreValue) {
            var networkStatus = queryStoreValue.networkStatus;
            if ($02a3c2aebc919401$var$hasError(queryStoreValue, this.options.errorPolicy)) return {
                data: void 0,
                loading: false,
                networkStatus: networkStatus,
                error: new $02a3c2aebc919401$export$26a337512320b8c6({
                    graphQLErrors: queryStoreValue.graphQLErrors,
                    networkError: queryStoreValue.networkError
                })
            };
            if (queryStoreValue.variables) {
                this.options.variables = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.options.variables), queryStoreValue.variables);
                this.variables = this.options.variables;
            }
            result = {
                data: data,
                loading: $02a3c2aebc919401$var$isNetworkRequestInFlight(networkStatus),
                networkStatus: networkStatus
            };
            if (queryStoreValue.graphQLErrors && this.options.errorPolicy === 'all') result.errors = queryStoreValue.graphQLErrors;
        } else {
            var loading = isNetworkFetchPolicy || partial && fetchPolicy !== 'cache-only';
            result = {
                data: data,
                loading: loading,
                networkStatus: loading ? $02a3c2aebc919401$export$bd096ddbd246c79c.loading : $02a3c2aebc919401$export$bd096ddbd246c79c.ready
            };
        }
        if (!partial) this.updateLastResult((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, result), {
            stale: false
        }));
        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, result), {
            partial: partial
        });
    };
    ObservableQuery.prototype.isDifferentFromLastResult = function(newResult) {
        var snapshot = this.lastResultSnapshot;
        return !(snapshot && newResult && snapshot.networkStatus === newResult.networkStatus && snapshot.stale === newResult.stale && (0, $bqMzA.equal)(snapshot.data, newResult.data));
    };
    ObservableQuery.prototype.getLastResult = function() {
        return this.lastResult;
    };
    ObservableQuery.prototype.getLastError = function() {
        return this.lastError;
    };
    ObservableQuery.prototype.resetLastResults = function() {
        delete this.lastResult;
        delete this.lastResultSnapshot;
        delete this.lastError;
        this.isTornDown = false;
    };
    ObservableQuery.prototype.resetQueryStoreErrors = function() {
        var queryStore = this.queryManager.queryStore.get(this.queryId);
        if (queryStore) {
            queryStore.networkError = null;
            queryStore.graphQLErrors = [];
        }
    };
    ObservableQuery.prototype.refetch = function(variables) {
        var fetchPolicy = this.options.fetchPolicy;
        if (fetchPolicy === 'cache-only') return Promise.reject(new (0, $1DiV8.InvariantError)(1));
        if (fetchPolicy !== 'no-cache' && fetchPolicy !== 'cache-and-network') fetchPolicy = 'network-only';
        if (!(0, $bqMzA.equal)(this.variables, variables)) this.variables = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.variables), variables);
        if (!(0, $bqMzA.equal)(this.options.variables, this.variables)) this.options.variables = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.options.variables), this.variables);
        return this.queryManager.fetchQuery(this.queryId, (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.options), {
            fetchPolicy: fetchPolicy
        }), $02a3c2aebc919401$export$160bafb6ac1e0641.refetch);
    };
    ObservableQuery.prototype.fetchMore = function(fetchMoreOptions) {
        var _this = this;
        (0, $1DiV8.invariant)(fetchMoreOptions.updateQuery, 2);
        var combinedOptions = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, fetchMoreOptions.query ? fetchMoreOptions : (0, $3VFsf.__assign)((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.options), fetchMoreOptions), {
            variables: (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.variables), fetchMoreOptions.variables)
        })), {
            fetchPolicy: 'network-only'
        });
        var qid = this.queryManager.generateQueryId();
        return this.queryManager.fetchQuery(qid, combinedOptions, $02a3c2aebc919401$export$160bafb6ac1e0641.normal, this.queryId).then(function(fetchMoreResult) {
            _this.updateQuery(function(previousResult) {
                return fetchMoreOptions.updateQuery(previousResult, {
                    fetchMoreResult: fetchMoreResult.data,
                    variables: combinedOptions.variables
                });
            });
            _this.queryManager.stopQuery(qid);
            return fetchMoreResult;
        }, function(error) {
            _this.queryManager.stopQuery(qid);
            throw error;
        });
    };
    ObservableQuery.prototype.subscribeToMore = function(options) {
        var _this = this;
        var subscription = this.queryManager.startGraphQLSubscription({
            query: options.document,
            variables: options.variables
        }).subscribe({
            next: function(subscriptionData) {
                var updateQuery = options.updateQuery;
                if (updateQuery) _this.updateQuery(function(previous, _a) {
                    var variables = _a.variables;
                    return updateQuery(previous, {
                        subscriptionData: subscriptionData,
                        variables: variables
                    });
                });
            },
            error: function(err) {
                if (options.onError) {
                    options.onError(err);
                    return;
                }
            }
        });
        this.subscriptions.add(subscription);
        return function() {
            if (_this.subscriptions.delete(subscription)) subscription.unsubscribe();
        };
    };
    ObservableQuery.prototype.setOptions = function(opts) {
        var oldFetchPolicy = this.options.fetchPolicy;
        this.options = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.options), opts);
        if (opts.pollInterval) this.startPolling(opts.pollInterval);
        else if (opts.pollInterval === 0) this.stopPolling();
        var fetchPolicy = opts.fetchPolicy;
        return this.setVariables(this.options.variables, oldFetchPolicy !== fetchPolicy && (oldFetchPolicy === 'cache-only' || oldFetchPolicy === 'standby' || fetchPolicy === 'network-only'), opts.fetchResults);
    };
    ObservableQuery.prototype.setVariables = function(variables, tryFetch, fetchResults) {
        if (tryFetch === void 0) tryFetch = false;
        if (fetchResults === void 0) fetchResults = true;
        this.isTornDown = false;
        variables = variables || this.variables;
        if (!tryFetch && (0, $bqMzA.equal)(variables, this.variables)) return this.observers.size && fetchResults ? this.result() : Promise.resolve();
        this.variables = this.options.variables = variables;
        if (!this.observers.size) return Promise.resolve();
        return this.queryManager.fetchQuery(this.queryId, this.options);
    };
    ObservableQuery.prototype.updateQuery = function(mapFn) {
        var queryManager = this.queryManager;
        var _a = queryManager.getQueryWithPreviousResult(this.queryId), previousResult = _a.previousResult, variables = _a.variables, document = _a.document;
        var newResult = (0, $jojW6.tryFunctionOrLogError)(function() {
            return mapFn(previousResult, {
                variables: variables
            });
        });
        if (newResult) {
            queryManager.dataStore.markUpdateQueryResult(document, variables, newResult);
            queryManager.broadcastQueries();
        }
    };
    ObservableQuery.prototype.stopPolling = function() {
        this.queryManager.stopPollingQuery(this.queryId);
        this.options.pollInterval = undefined;
    };
    ObservableQuery.prototype.startPolling = function(pollInterval) {
        $02a3c2aebc919401$var$assertNotCacheFirstOrOnly(this);
        this.options.pollInterval = pollInterval;
        this.queryManager.startPollingQuery(this.options, this.queryId);
    };
    ObservableQuery.prototype.updateLastResult = function(newResult) {
        var previousResult = this.lastResult;
        this.lastResult = newResult;
        this.lastResultSnapshot = this.queryManager.assumeImmutableResults ? newResult : (0, $jojW6.cloneDeep)(newResult);
        return previousResult;
    };
    ObservableQuery.prototype.onSubscribe = function(observer) {
        var _this = this;
        try {
            var subObserver = observer._subscription._observer;
            if (subObserver && !subObserver.error) subObserver.error = $02a3c2aebc919401$var$defaultSubscriptionObserverErrorCallback;
        } catch (_a) {}
        var first = !this.observers.size;
        this.observers.add(observer);
        if (observer.next && this.lastResult) observer.next(this.lastResult);
        if (observer.error && this.lastError) observer.error(this.lastError);
        if (first) this.setUpQuery();
        return function() {
            if (_this.observers.delete(observer) && !_this.observers.size) _this.tearDownQuery();
        };
    };
    ObservableQuery.prototype.setUpQuery = function() {
        var _this = this;
        var _a = this, queryManager = _a.queryManager, queryId = _a.queryId;
        if (this.shouldSubscribe) queryManager.addObservableQuery(queryId, this);
        if (this.options.pollInterval) {
            $02a3c2aebc919401$var$assertNotCacheFirstOrOnly(this);
            queryManager.startPollingQuery(this.options, queryId);
        }
        var onError = function(error) {
            _this.updateLastResult((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, _this.lastResult), {
                errors: error.graphQLErrors,
                networkStatus: $02a3c2aebc919401$export$bd096ddbd246c79c.error,
                loading: false
            }));
            $02a3c2aebc919401$var$iterateObserversSafely(_this.observers, 'error', _this.lastError = error);
        };
        queryManager.observeQuery(queryId, this.options, {
            next: function(result) {
                if (_this.lastError || _this.isDifferentFromLastResult(result)) {
                    var previousResult_1 = _this.updateLastResult(result);
                    var _a = _this.options, query_1 = _a.query, variables = _a.variables, fetchPolicy_1 = _a.fetchPolicy;
                    if (queryManager.transform(query_1).hasClientExports) queryManager.getLocalState().addExportedVariables(query_1, variables).then(function(variables) {
                        var previousVariables = _this.variables;
                        _this.variables = _this.options.variables = variables;
                        if (!result.loading && previousResult_1 && fetchPolicy_1 !== 'cache-only' && queryManager.transform(query_1).serverQuery && !(0, $bqMzA.equal)(previousVariables, variables)) _this.refetch();
                        else $02a3c2aebc919401$var$iterateObserversSafely(_this.observers, 'next', result);
                    });
                    else $02a3c2aebc919401$var$iterateObserversSafely(_this.observers, 'next', result);
                }
            },
            error: onError
        }).catch(onError);
    };
    ObservableQuery.prototype.tearDownQuery = function() {
        var queryManager = this.queryManager;
        this.isTornDown = true;
        queryManager.stopPollingQuery(this.queryId);
        this.subscriptions.forEach(function(sub) {
            return sub.unsubscribe();
        });
        this.subscriptions.clear();
        queryManager.removeObservableQuery(this.queryId);
        queryManager.stopQuery(this.queryId);
        this.observers.clear();
    };
    return ObservableQuery;
}($02a3c2aebc919401$var$Observable);
function $02a3c2aebc919401$var$defaultSubscriptionObserverErrorCallback(error) {}
function $02a3c2aebc919401$var$iterateObserversSafely(observers, method, argument) {
    var observersWithMethod = [];
    observers.forEach(function(obs) {
        return obs[method] && observersWithMethod.push(obs);
    });
    observersWithMethod.forEach(function(obs) {
        return obs[method](argument);
    });
}
function $02a3c2aebc919401$var$assertNotCacheFirstOrOnly(obsQuery) {
    var fetchPolicy = obsQuery.options.fetchPolicy;
    (0, $1DiV8.invariant)(fetchPolicy !== 'cache-first' && fetchPolicy !== 'cache-only', 3);
}
var $02a3c2aebc919401$var$MutationStore = function() {
    function MutationStore() {
        this.store = {};
    }
    MutationStore.prototype.getStore = function() {
        return this.store;
    };
    MutationStore.prototype.get = function(mutationId) {
        return this.store[mutationId];
    };
    MutationStore.prototype.initMutation = function(mutationId, mutation, variables) {
        this.store[mutationId] = {
            mutation: mutation,
            variables: variables || {},
            loading: true,
            error: null
        };
    };
    MutationStore.prototype.markMutationError = function(mutationId, error) {
        var mutation = this.store[mutationId];
        if (mutation) {
            mutation.loading = false;
            mutation.error = error;
        }
    };
    MutationStore.prototype.markMutationResult = function(mutationId) {
        var mutation = this.store[mutationId];
        if (mutation) {
            mutation.loading = false;
            mutation.error = null;
        }
    };
    MutationStore.prototype.reset = function() {
        this.store = {};
    };
    return MutationStore;
}();
var $02a3c2aebc919401$var$QueryStore = function() {
    function QueryStore() {
        this.store = {};
    }
    QueryStore.prototype.getStore = function() {
        return this.store;
    };
    QueryStore.prototype.get = function(queryId) {
        return this.store[queryId];
    };
    QueryStore.prototype.initQuery = function(query) {
        var previousQuery = this.store[query.queryId];
        (0, $1DiV8.invariant)(!previousQuery || previousQuery.document === query.document || (0, $bqMzA.equal)(previousQuery.document, query.document), 19);
        var isSetVariables = false;
        var previousVariables = null;
        if (query.storePreviousVariables && previousQuery && previousQuery.networkStatus !== $02a3c2aebc919401$export$bd096ddbd246c79c.loading) {
            if (!(0, $bqMzA.equal)(previousQuery.variables, query.variables)) {
                isSetVariables = true;
                previousVariables = previousQuery.variables;
            }
        }
        var networkStatus;
        if (isSetVariables) networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.setVariables;
        else if (query.isPoll) networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.poll;
        else if (query.isRefetch) networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.refetch;
        else networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.loading;
        var graphQLErrors = [];
        if (previousQuery && previousQuery.graphQLErrors) graphQLErrors = previousQuery.graphQLErrors;
        this.store[query.queryId] = {
            document: query.document,
            variables: query.variables,
            previousVariables: previousVariables,
            networkError: null,
            graphQLErrors: graphQLErrors,
            networkStatus: networkStatus,
            metadata: query.metadata
        };
        if (typeof query.fetchMoreForQueryId === 'string' && this.store[query.fetchMoreForQueryId]) this.store[query.fetchMoreForQueryId].networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.fetchMore;
    };
    QueryStore.prototype.markQueryResult = function(queryId, result, fetchMoreForQueryId) {
        if (!this.store || !this.store[queryId]) return;
        this.store[queryId].networkError = null;
        this.store[queryId].graphQLErrors = $02a3c2aebc919401$var$isNonEmptyArray(result.errors) ? result.errors : [];
        this.store[queryId].previousVariables = null;
        this.store[queryId].networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.ready;
        if (typeof fetchMoreForQueryId === 'string' && this.store[fetchMoreForQueryId]) this.store[fetchMoreForQueryId].networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.ready;
    };
    QueryStore.prototype.markQueryError = function(queryId, error, fetchMoreForQueryId) {
        if (!this.store || !this.store[queryId]) return;
        this.store[queryId].networkError = error;
        this.store[queryId].networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.error;
        if (typeof fetchMoreForQueryId === 'string') this.markQueryResultClient(fetchMoreForQueryId, true);
    };
    QueryStore.prototype.markQueryResultClient = function(queryId, complete) {
        var storeValue = this.store && this.store[queryId];
        if (storeValue) {
            storeValue.networkError = null;
            storeValue.previousVariables = null;
            if (complete) storeValue.networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.ready;
        }
    };
    QueryStore.prototype.stopQuery = function(queryId) {
        delete this.store[queryId];
    };
    QueryStore.prototype.reset = function(observableQueryIds) {
        var _this = this;
        Object.keys(this.store).forEach(function(queryId) {
            if (observableQueryIds.indexOf(queryId) < 0) _this.stopQuery(queryId);
            else _this.store[queryId].networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.loading;
        });
    };
    return QueryStore;
}();
function $02a3c2aebc919401$var$capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
var $02a3c2aebc919401$var$LocalState = function() {
    function LocalState(_a) {
        var cache = _a.cache, client = _a.client, resolvers = _a.resolvers, fragmentMatcher = _a.fragmentMatcher;
        this.cache = cache;
        if (client) this.client = client;
        if (resolvers) this.addResolvers(resolvers);
        if (fragmentMatcher) this.setFragmentMatcher(fragmentMatcher);
    }
    LocalState.prototype.addResolvers = function(resolvers) {
        var _this = this;
        this.resolvers = this.resolvers || {};
        if (Array.isArray(resolvers)) resolvers.forEach(function(resolverGroup) {
            _this.resolvers = (0, $jojW6.mergeDeep)(_this.resolvers, resolverGroup);
        });
        else this.resolvers = (0, $jojW6.mergeDeep)(this.resolvers, resolvers);
    };
    LocalState.prototype.setResolvers = function(resolvers) {
        this.resolvers = {};
        this.addResolvers(resolvers);
    };
    LocalState.prototype.getResolvers = function() {
        return this.resolvers || {};
    };
    LocalState.prototype.runResolvers = function(_a) {
        var document = _a.document, remoteResult = _a.remoteResult, context = _a.context, variables = _a.variables, _b = _a.onlyRunForcedResolvers, onlyRunForcedResolvers = _b === void 0 ? false : _b;
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            return (0, $3VFsf.__generator)(this, function(_c) {
                if (document) return [
                    2,
                    this.resolveDocument(document, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function(localResult) {
                        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, remoteResult), {
                            data: localResult.result
                        });
                    })
                ];
                return [
                    2,
                    remoteResult
                ];
            });
        });
    };
    LocalState.prototype.setFragmentMatcher = function(fragmentMatcher) {
        this.fragmentMatcher = fragmentMatcher;
    };
    LocalState.prototype.getFragmentMatcher = function() {
        return this.fragmentMatcher;
    };
    LocalState.prototype.clientQuery = function(document) {
        if ((0, $jojW6.hasDirectives)([
            'client'
        ], document)) {
            if (this.resolvers) return document;
        }
        return null;
    };
    LocalState.prototype.serverQuery = function(document) {
        return this.resolvers ? (0, $jojW6.removeClientSetsFromDocument)(document) : document;
    };
    LocalState.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var cache = this.cache;
        var newContext = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, context), {
            cache: cache,
            getCacheKey: function(obj) {
                if (cache.config) return cache.config.dataIdFromObject(obj);
                else (0, $1DiV8.invariant)(false, 6);
            }
        });
        return newContext;
    };
    LocalState.prototype.addExportedVariables = function(document, variables, context) {
        if (variables === void 0) variables = {};
        if (context === void 0) context = {};
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            return (0, $3VFsf.__generator)(this, function(_a) {
                if (document) return [
                    2,
                    this.resolveDocument(document, this.buildRootValueFromCache(document, variables) || {}, this.prepareContext(context), variables).then(function(data) {
                        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, variables), data.exportedVariables);
                    })
                ];
                return [
                    2,
                    (0, $3VFsf.__assign)({}, variables)
                ];
            });
        });
    };
    LocalState.prototype.shouldForceResolvers = function(document) {
        var forceResolvers = false;
        (0, $12QNw.visit)(document, {
            Directive: {
                enter: function(node) {
                    if (node.name.value === 'client' && node.arguments) {
                        forceResolvers = node.arguments.some(function(arg) {
                            return arg.name.value === 'always' && arg.value.kind === 'BooleanValue' && arg.value.value === true;
                        });
                        if (forceResolvers) return 0, $12QNw.BREAK;
                    }
                }
            }
        });
        return forceResolvers;
    };
    LocalState.prototype.buildRootValueFromCache = function(document, variables) {
        return this.cache.diff({
            query: (0, $jojW6.buildQueryFromSelectionSet)(document),
            variables: variables,
            returnPartialData: true,
            optimistic: false
        }).result;
    };
    LocalState.prototype.resolveDocument = function(document, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
        if (context === void 0) context = {};
        if (variables === void 0) variables = {};
        if (fragmentMatcher === void 0) fragmentMatcher = function() {
            return true;
        };
        if (onlyRunForcedResolvers === void 0) onlyRunForcedResolvers = false;
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            var mainDefinition, fragments, fragmentMap, definitionOperation, defaultOperationType, _a, cache, client, execContext;
            return (0, $3VFsf.__generator)(this, function(_b) {
                mainDefinition = (0, $jojW6.getMainDefinition)(document);
                fragments = (0, $jojW6.getFragmentDefinitions)(document);
                fragmentMap = (0, $jojW6.createFragmentMap)(fragments);
                definitionOperation = mainDefinition.operation;
                defaultOperationType = definitionOperation ? $02a3c2aebc919401$var$capitalizeFirstLetter(definitionOperation) : 'Query';
                _a = this, cache = _a.cache, client = _a.client;
                execContext = {
                    fragmentMap: fragmentMap,
                    context: (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, context), {
                        cache: cache,
                        client: client
                    }),
                    variables: variables,
                    fragmentMatcher: fragmentMatcher,
                    defaultOperationType: defaultOperationType,
                    exportedVariables: {},
                    onlyRunForcedResolvers: onlyRunForcedResolvers
                };
                return [
                    2,
                    this.resolveSelectionSet(mainDefinition.selectionSet, rootValue, execContext).then(function(result) {
                        return {
                            result: result,
                            exportedVariables: execContext.exportedVariables
                        };
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSelectionSet = function(selectionSet, rootValue, execContext) {
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            var fragmentMap, context, variables, resultsToMerge, execute;
            var _this = this;
            return (0, $3VFsf.__generator)(this, function(_a) {
                fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
                resultsToMerge = [
                    rootValue
                ];
                execute = function(selection) {
                    return (0, $3VFsf.__awaiter)(_this, void 0, void 0, function() {
                        var fragment, typeCondition;
                        return (0, $3VFsf.__generator)(this, function(_a) {
                            if (!(0, $jojW6.shouldInclude)(selection, variables)) return [
                                2
                            ];
                            if ((0, $jojW6.isField)(selection)) return [
                                2,
                                this.resolveField(selection, rootValue, execContext).then(function(fieldResult) {
                                    var _a;
                                    if (typeof fieldResult !== 'undefined') resultsToMerge.push((_a = {}, _a[(0, $jojW6.resultKeyNameFromField)(selection)] = fieldResult, _a));
                                })
                            ];
                            if ((0, $jojW6.isInlineFragment)(selection)) fragment = selection;
                            else {
                                fragment = fragmentMap[selection.name.value];
                                (0, $1DiV8.invariant)(fragment, 7);
                            }
                            if (fragment && fragment.typeCondition) {
                                typeCondition = fragment.typeCondition.name.value;
                                if (execContext.fragmentMatcher(rootValue, typeCondition, context)) return [
                                    2,
                                    this.resolveSelectionSet(fragment.selectionSet, rootValue, execContext).then(function(fragmentResult) {
                                        resultsToMerge.push(fragmentResult);
                                    })
                                ];
                            }
                            return [
                                2
                            ];
                        });
                    });
                };
                return [
                    2,
                    Promise.all(selectionSet.selections.map(execute)).then(function() {
                        return (0, $jojW6.mergeDeepArray)(resultsToMerge);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveField = function(field, rootValue, execContext) {
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;
            var _this = this;
            return (0, $3VFsf.__generator)(this, function(_a) {
                variables = execContext.variables;
                fieldName = field.name.value;
                aliasedFieldName = (0, $jojW6.resultKeyNameFromField)(field);
                aliasUsed = fieldName !== aliasedFieldName;
                defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
                resultPromise = Promise.resolve(defaultResult);
                if (!execContext.onlyRunForcedResolvers || this.shouldForceResolvers(field)) {
                    resolverType = rootValue.__typename || execContext.defaultOperationType;
                    resolverMap = this.resolvers && this.resolvers[resolverType];
                    if (resolverMap) {
                        resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];
                        if (resolve) resultPromise = Promise.resolve(resolve(rootValue, (0, $jojW6.argumentsObjectFromField)(field, variables), execContext.context, {
                            field: field,
                            fragmentMap: execContext.fragmentMap
                        }));
                    }
                }
                return [
                    2,
                    resultPromise.then(function(result) {
                        if (result === void 0) result = defaultResult;
                        if (field.directives) field.directives.forEach(function(directive) {
                            if (directive.name.value === 'export' && directive.arguments) directive.arguments.forEach(function(arg) {
                                if (arg.name.value === 'as' && arg.value.kind === 'StringValue') execContext.exportedVariables[arg.value.value] = result;
                            });
                        });
                        if (!field.selectionSet) return result;
                        if (result == null) return result;
                        if (Array.isArray(result)) return _this.resolveSubSelectedArray(field, result, execContext);
                        if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, result, execContext);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSubSelectedArray = function(field, result, execContext) {
        var _this = this;
        return Promise.all(result.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return _this.resolveSubSelectedArray(field, item, execContext);
            if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, item, execContext);
        }));
    };
    return LocalState;
}();
function $02a3c2aebc919401$var$multiplex(inner) {
    var observers = new Set();
    var sub = null;
    return new $02a3c2aebc919401$var$Observable(function(observer) {
        observers.add(observer);
        sub = sub || inner.subscribe({
            next: function(value) {
                observers.forEach(function(obs) {
                    return obs.next && obs.next(value);
                });
            },
            error: function(error) {
                observers.forEach(function(obs) {
                    return obs.error && obs.error(error);
                });
            },
            complete: function() {
                observers.forEach(function(obs) {
                    return obs.complete && obs.complete();
                });
            }
        });
        return function() {
            if (observers.delete(observer) && !observers.size && sub) {
                sub.unsubscribe();
                sub = null;
            }
        };
    });
}
function $02a3c2aebc919401$var$asyncMap(observable, mapFn) {
    return new $02a3c2aebc919401$var$Observable(function(observer) {
        var next = observer.next, error = observer.error, complete = observer.complete;
        var activeNextCount = 0;
        var completed = false;
        var handler = {
            next: function(value) {
                ++activeNextCount;
                new Promise(function(resolve) {
                    resolve(mapFn(value));
                }).then(function(result) {
                    --activeNextCount;
                    next && next.call(observer, result);
                    completed && handler.complete();
                }, function(e) {
                    --activeNextCount;
                    error && error.call(observer, e);
                });
            },
            error: function(e) {
                error && error.call(observer, e);
            },
            complete: function() {
                completed = true;
                if (!activeNextCount) complete && complete.call(observer);
            }
        };
        var sub = observable.subscribe(handler);
        return function() {
            return sub.unsubscribe();
        };
    });
}
var $02a3c2aebc919401$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $02a3c2aebc919401$var$QueryManager = function() {
    function QueryManager(_a) {
        var link = _a.link, _b = _a.queryDeduplication, queryDeduplication = _b === void 0 ? false : _b, store = _a.store, _c = _a.onBroadcast, onBroadcast = _c === void 0 ? function() {
            return undefined;
        } : _c, _d = _a.ssrMode, ssrMode = _d === void 0 ? false : _d, _e = _a.clientAwareness, clientAwareness = _e === void 0 ? {} : _e, localState = _a.localState, assumeImmutableResults = _a.assumeImmutableResults;
        this.mutationStore = new $02a3c2aebc919401$var$MutationStore();
        this.queryStore = new $02a3c2aebc919401$var$QueryStore();
        this.clientAwareness = {};
        this.idCounter = 1;
        this.queries = new Map();
        this.fetchQueryRejectFns = new Map();
        this.transformCache = new ((0, $jojW6.canUseWeakMap) ? WeakMap : Map)();
        this.inFlightLinkObservables = new Map();
        this.pollingInfoByQueryId = new Map();
        this.link = link;
        this.queryDeduplication = queryDeduplication;
        this.dataStore = store;
        this.onBroadcast = onBroadcast;
        this.clientAwareness = clientAwareness;
        this.localState = localState || new $02a3c2aebc919401$var$LocalState({
            cache: store.getCache()
        });
        this.ssrMode = ssrMode;
        this.assumeImmutableResults = !!assumeImmutableResults;
    }
    QueryManager.prototype.stop = function() {
        var _this = this;
        this.queries.forEach(function(_info, queryId) {
            _this.stopQueryNoBroadcast(queryId);
        });
        this.fetchQueryRejectFns.forEach(function(reject) {
            reject(new (0, $1DiV8.InvariantError)(8));
        });
    };
    QueryManager.prototype.mutate = function(_a) {
        var mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, updateQueriesByName = _a.updateQueries, _b = _a.refetchQueries, refetchQueries = _b === void 0 ? [] : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, updateWithProxyFn = _a.update, _d = _a.errorPolicy, errorPolicy = _d === void 0 ? 'none' : _d, fetchPolicy = _a.fetchPolicy, _e = _a.context, context = _e === void 0 ? {} : _e;
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            var mutationId, generateUpdateQueriesInfo, self;
            var _this = this;
            return (0, $3VFsf.__generator)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        (0, $1DiV8.invariant)(mutation, 9);
                        (0, $1DiV8.invariant)(!fetchPolicy || fetchPolicy === 'no-cache', 10);
                        mutationId = this.generateQueryId();
                        mutation = this.transform(mutation).document;
                        this.setQuery(mutationId, function() {
                            return {
                                document: mutation
                            };
                        });
                        variables = this.getVariables(mutation, variables);
                        if (!this.transform(mutation).hasClientExports) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this.localState.addExportedVariables(mutation, variables, context)
                        ];
                    case 1:
                        variables = _f.sent();
                        _f.label = 2;
                    case 2:
                        generateUpdateQueriesInfo = function() {
                            var ret = {};
                            if (updateQueriesByName) _this.queries.forEach(function(_a, queryId) {
                                var observableQuery = _a.observableQuery;
                                if (observableQuery) {
                                    var queryName = observableQuery.queryName;
                                    if (queryName && $02a3c2aebc919401$var$hasOwnProperty.call(updateQueriesByName, queryName)) ret[queryId] = {
                                        updater: updateQueriesByName[queryName],
                                        query: _this.queryStore.get(queryId)
                                    };
                                }
                            });
                            return ret;
                        };
                        this.mutationStore.initMutation(mutationId, mutation, variables);
                        this.dataStore.markMutationInit({
                            mutationId: mutationId,
                            document: mutation,
                            variables: variables,
                            updateQueries: generateUpdateQueriesInfo(),
                            update: updateWithProxyFn,
                            optimisticResponse: optimisticResponse
                        });
                        this.broadcastQueries();
                        self = this;
                        return [
                            2,
                            new Promise(function(resolve, reject) {
                                var storeResult;
                                var error;
                                self.getObservableFromLink(mutation, (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, context), {
                                    optimisticResponse: optimisticResponse
                                }), variables, false).subscribe({
                                    next: function(result) {
                                        if ((0, $jojW6.graphQLResultHasError)(result) && errorPolicy === 'none') {
                                            error = new $02a3c2aebc919401$export$26a337512320b8c6({
                                                graphQLErrors: result.errors
                                            });
                                            return;
                                        }
                                        self.mutationStore.markMutationResult(mutationId);
                                        if (fetchPolicy !== 'no-cache') self.dataStore.markMutationResult({
                                            mutationId: mutationId,
                                            result: result,
                                            document: mutation,
                                            variables: variables,
                                            updateQueries: generateUpdateQueriesInfo(),
                                            update: updateWithProxyFn
                                        });
                                        storeResult = result;
                                    },
                                    error: function(err) {
                                        self.mutationStore.markMutationError(mutationId, err);
                                        self.dataStore.markMutationComplete({
                                            mutationId: mutationId,
                                            optimisticResponse: optimisticResponse
                                        });
                                        self.broadcastQueries();
                                        self.setQuery(mutationId, function() {
                                            return {
                                                document: null
                                            };
                                        });
                                        reject(new $02a3c2aebc919401$export$26a337512320b8c6({
                                            networkError: err
                                        }));
                                    },
                                    complete: function() {
                                        if (error) self.mutationStore.markMutationError(mutationId, error);
                                        self.dataStore.markMutationComplete({
                                            mutationId: mutationId,
                                            optimisticResponse: optimisticResponse
                                        });
                                        self.broadcastQueries();
                                        if (error) {
                                            reject(error);
                                            return;
                                        }
                                        if (typeof refetchQueries === 'function') refetchQueries = refetchQueries(storeResult);
                                        var refetchQueryPromises = [];
                                        if ($02a3c2aebc919401$var$isNonEmptyArray(refetchQueries)) refetchQueries.forEach(function(refetchQuery) {
                                            if (typeof refetchQuery === 'string') self.queries.forEach(function(_a) {
                                                var observableQuery = _a.observableQuery;
                                                if (observableQuery && observableQuery.queryName === refetchQuery) refetchQueryPromises.push(observableQuery.refetch());
                                            });
                                            else {
                                                var queryOptions = {
                                                    query: refetchQuery.query,
                                                    variables: refetchQuery.variables,
                                                    fetchPolicy: 'network-only'
                                                };
                                                if (refetchQuery.context) queryOptions.context = refetchQuery.context;
                                                refetchQueryPromises.push(self.query(queryOptions));
                                            }
                                        });
                                        Promise.all(awaitRefetchQueries ? refetchQueryPromises : []).then(function() {
                                            self.setQuery(mutationId, function() {
                                                return {
                                                    document: null
                                                };
                                            });
                                            if (errorPolicy === 'ignore' && storeResult && (0, $jojW6.graphQLResultHasError)(storeResult)) delete storeResult.errors;
                                            resolve(storeResult);
                                        });
                                    }
                                });
                            })
                        ];
                }
            });
        });
    };
    QueryManager.prototype.fetchQuery = function(queryId, options, fetchType, fetchMoreForQueryId) {
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            var _a, metadata, _b, fetchPolicy, _c, context, query, variables, storeResult, isNetworkOnly, needToFetch, _d, complete, result, shouldFetch, requestId, cancel, networkResult;
            var _this = this;
            return (0, $3VFsf.__generator)(this, function(_e) {
                switch(_e.label){
                    case 0:
                        _a = options.metadata, metadata = _a === void 0 ? null : _a, _b = options.fetchPolicy, fetchPolicy = _b === void 0 ? 'cache-first' : _b, _c = options.context, context = _c === void 0 ? {} : _c;
                        query = this.transform(options.query).document;
                        variables = this.getVariables(query, options.variables);
                        if (!this.transform(query).hasClientExports) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this.localState.addExportedVariables(query, variables, context)
                        ];
                    case 1:
                        variables = _e.sent();
                        _e.label = 2;
                    case 2:
                        options = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
                            variables: variables
                        });
                        isNetworkOnly = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
                        needToFetch = isNetworkOnly;
                        if (!isNetworkOnly) {
                            _d = this.dataStore.getCache().diff({
                                query: query,
                                variables: variables,
                                returnPartialData: true,
                                optimistic: false
                            }), complete = _d.complete, result = _d.result;
                            needToFetch = !complete || fetchPolicy === 'cache-and-network';
                            storeResult = result;
                        }
                        shouldFetch = needToFetch && fetchPolicy !== 'cache-only' && fetchPolicy !== 'standby';
                        if ((0, $jojW6.hasDirectives)([
                            'live'
                        ], query)) shouldFetch = true;
                        requestId = this.idCounter++;
                        cancel = fetchPolicy !== 'no-cache' ? this.updateQueryWatch(queryId, query, options) : undefined;
                        this.setQuery(queryId, function() {
                            return {
                                document: query,
                                lastRequestId: requestId,
                                invalidated: true,
                                cancel: cancel
                            };
                        });
                        this.invalidate(fetchMoreForQueryId);
                        this.queryStore.initQuery({
                            queryId: queryId,
                            document: query,
                            storePreviousVariables: shouldFetch,
                            variables: variables,
                            isPoll: fetchType === $02a3c2aebc919401$export$160bafb6ac1e0641.poll,
                            isRefetch: fetchType === $02a3c2aebc919401$export$160bafb6ac1e0641.refetch,
                            metadata: metadata,
                            fetchMoreForQueryId: fetchMoreForQueryId
                        });
                        this.broadcastQueries();
                        if (shouldFetch) {
                            networkResult = this.fetchRequest({
                                requestId: requestId,
                                queryId: queryId,
                                document: query,
                                options: options,
                                fetchMoreForQueryId: fetchMoreForQueryId
                            }).catch(function(error) {
                                if ($02a3c2aebc919401$export$17f5e6bd290bb15d(error)) throw error;
                                else {
                                    if (requestId >= _this.getQuery(queryId).lastRequestId) {
                                        _this.queryStore.markQueryError(queryId, error, fetchMoreForQueryId);
                                        _this.invalidate(queryId);
                                        _this.invalidate(fetchMoreForQueryId);
                                        _this.broadcastQueries();
                                    }
                                    throw new $02a3c2aebc919401$export$26a337512320b8c6({
                                        networkError: error
                                    });
                                }
                            });
                            if (fetchPolicy !== 'cache-and-network') return [
                                2,
                                networkResult
                            ];
                            networkResult.catch(function() {});
                        }
                        this.queryStore.markQueryResultClient(queryId, !shouldFetch);
                        this.invalidate(queryId);
                        this.invalidate(fetchMoreForQueryId);
                        if (this.transform(query).hasForcedResolvers) return [
                            2,
                            this.localState.runResolvers({
                                document: query,
                                remoteResult: {
                                    data: storeResult
                                },
                                context: context,
                                variables: variables,
                                onlyRunForcedResolvers: true
                            }).then(function(result) {
                                _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                                _this.broadcastQueries();
                                return result;
                            })
                        ];
                        this.broadcastQueries();
                        return [
                            2,
                            {
                                data: storeResult
                            }
                        ];
                }
            });
        });
    };
    QueryManager.prototype.markQueryResult = function(queryId, result, _a, fetchMoreForQueryId) {
        var fetchPolicy = _a.fetchPolicy, variables = _a.variables, errorPolicy = _a.errorPolicy;
        if (fetchPolicy === 'no-cache') this.setQuery(queryId, function() {
            return {
                newData: {
                    result: result.data,
                    complete: true
                }
            };
        });
        else this.dataStore.markQueryResult(result, this.getQuery(queryId).document, variables, fetchMoreForQueryId, errorPolicy === 'ignore' || errorPolicy === 'all');
    };
    QueryManager.prototype.queryListenerForObserver = function(queryId, options, observer) {
        var _this = this;
        function invoke(method, argument) {
            if (observer[method]) try {
                observer[method](argument);
            } catch (e) {}
            else method;
        }
        return function(queryStoreValue, newData) {
            _this.invalidate(queryId, false);
            if (!queryStoreValue) return;
            var _a = _this.getQuery(queryId), observableQuery = _a.observableQuery, document = _a.document;
            var fetchPolicy = observableQuery ? observableQuery.options.fetchPolicy : options.fetchPolicy;
            if (fetchPolicy === 'standby') return;
            var loading = $02a3c2aebc919401$var$isNetworkRequestInFlight(queryStoreValue.networkStatus);
            var lastResult = observableQuery && observableQuery.getLastResult();
            var networkStatusChanged = !!(lastResult && lastResult.networkStatus !== queryStoreValue.networkStatus);
            var shouldNotifyIfLoading = options.returnPartialData || !newData && queryStoreValue.previousVariables || networkStatusChanged && options.notifyOnNetworkStatusChange || fetchPolicy === 'cache-only' || fetchPolicy === 'cache-and-network';
            if (loading && !shouldNotifyIfLoading) return;
            var hasGraphQLErrors = $02a3c2aebc919401$var$isNonEmptyArray(queryStoreValue.graphQLErrors);
            var errorPolicy = observableQuery && observableQuery.options.errorPolicy || options.errorPolicy || 'none';
            if (errorPolicy === 'none' && hasGraphQLErrors || queryStoreValue.networkError) return invoke('error', new $02a3c2aebc919401$export$26a337512320b8c6({
                graphQLErrors: queryStoreValue.graphQLErrors,
                networkError: queryStoreValue.networkError
            }));
            try {
                var data = void 0;
                var isMissing = void 0;
                if (newData) {
                    if (fetchPolicy !== 'no-cache' && fetchPolicy !== 'network-only') _this.setQuery(queryId, function() {
                        return {
                            newData: null
                        };
                    });
                    data = newData.result;
                    isMissing = !newData.complete;
                } else {
                    var lastError = observableQuery && observableQuery.getLastError();
                    var errorStatusChanged = errorPolicy !== 'none' && (lastError && lastError.graphQLErrors) !== queryStoreValue.graphQLErrors;
                    if (lastResult && lastResult.data && !errorStatusChanged) {
                        data = lastResult.data;
                        isMissing = false;
                    } else {
                        var diffResult = _this.dataStore.getCache().diff({
                            query: document,
                            variables: queryStoreValue.previousVariables || queryStoreValue.variables,
                            returnPartialData: true,
                            optimistic: true
                        });
                        data = diffResult.result;
                        isMissing = !diffResult.complete;
                    }
                }
                var stale = isMissing && !(options.returnPartialData || fetchPolicy === 'cache-only');
                var resultFromStore = {
                    data: stale ? lastResult && lastResult.data : data,
                    loading: loading,
                    networkStatus: queryStoreValue.networkStatus,
                    stale: stale
                };
                if (errorPolicy === 'all' && hasGraphQLErrors) resultFromStore.errors = queryStoreValue.graphQLErrors;
                invoke('next', resultFromStore);
            } catch (networkError) {
                invoke('error', new $02a3c2aebc919401$export$26a337512320b8c6({
                    networkError: networkError
                }));
            }
        };
    };
    QueryManager.prototype.transform = function(document) {
        var transformCache = this.transformCache;
        if (!transformCache.has(document)) {
            var cache = this.dataStore.getCache();
            var transformed = cache.transformDocument(document);
            var forLink = (0, $jojW6.removeConnectionDirectiveFromDocument)(cache.transformForLink(transformed));
            var clientQuery = this.localState.clientQuery(transformed);
            var serverQuery = this.localState.serverQuery(forLink);
            var cacheEntry_1 = {
                document: transformed,
                hasClientExports: (0, $jojW6.hasClientExports)(transformed),
                hasForcedResolvers: this.localState.shouldForceResolvers(transformed),
                clientQuery: clientQuery,
                serverQuery: serverQuery,
                defaultVars: (0, $jojW6.getDefaultValues)((0, $jojW6.getOperationDefinition)(transformed))
            };
            var add = function(doc) {
                if (doc && !transformCache.has(doc)) transformCache.set(doc, cacheEntry_1);
            };
            add(document);
            add(transformed);
            add(clientQuery);
            add(serverQuery);
        }
        return transformCache.get(document);
    };
    QueryManager.prototype.getVariables = function(document, variables) {
        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.transform(document).defaultVars), variables);
    };
    QueryManager.prototype.watchQuery = function(options, shouldSubscribe) {
        if (shouldSubscribe === void 0) shouldSubscribe = true;
        (0, $1DiV8.invariant)(options.fetchPolicy !== 'standby', 11);
        options.variables = this.getVariables(options.query, options.variables);
        if (typeof options.notifyOnNetworkStatusChange === 'undefined') options.notifyOnNetworkStatusChange = false;
        var transformedOptions = (0, $3VFsf.__assign)({}, options);
        return new $02a3c2aebc919401$export$6c1b56eac59c9584({
            queryManager: this,
            options: transformedOptions,
            shouldSubscribe: shouldSubscribe
        });
    };
    QueryManager.prototype.query = function(options) {
        var _this = this;
        (0, $1DiV8.invariant)(options.query, 12);
        (0, $1DiV8.invariant)(options.query.kind === 'Document', 13);
        (0, $1DiV8.invariant)(!options.returnPartialData, 14);
        (0, $1DiV8.invariant)(!options.pollInterval, 15);
        return new Promise(function(resolve, reject) {
            var watchedQuery = _this.watchQuery(options, false);
            _this.fetchQueryRejectFns.set("query:" + watchedQuery.queryId, reject);
            watchedQuery.result().then(resolve, reject).then(function() {
                return _this.fetchQueryRejectFns.delete("query:" + watchedQuery.queryId);
            });
        });
    };
    QueryManager.prototype.generateQueryId = function() {
        return String(this.idCounter++);
    };
    QueryManager.prototype.stopQueryInStore = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryInStoreNoBroadcast = function(queryId) {
        this.stopPollingQuery(queryId);
        this.queryStore.stopQuery(queryId);
        this.invalidate(queryId);
    };
    QueryManager.prototype.addQueryListener = function(queryId, listener) {
        this.setQuery(queryId, function(_a) {
            var listeners = _a.listeners;
            listeners.add(listener);
            return {
                invalidated: false
            };
        });
    };
    QueryManager.prototype.updateQueryWatch = function(queryId, document, options) {
        var _this = this;
        var cancel = this.getQuery(queryId).cancel;
        if (cancel) cancel();
        var previousResult = function() {
            var previousResult = null;
            var observableQuery = _this.getQuery(queryId).observableQuery;
            if (observableQuery) {
                var lastResult = observableQuery.getLastResult();
                if (lastResult) previousResult = lastResult.data;
            }
            return previousResult;
        };
        return this.dataStore.getCache().watch({
            query: document,
            variables: options.variables,
            optimistic: true,
            previousResult: previousResult,
            callback: function(newData) {
                _this.setQuery(queryId, function() {
                    return {
                        invalidated: true,
                        newData: newData
                    };
                });
            }
        });
    };
    QueryManager.prototype.addObservableQuery = function(queryId, observableQuery) {
        this.setQuery(queryId, function() {
            return {
                observableQuery: observableQuery
            };
        });
    };
    QueryManager.prototype.removeObservableQuery = function(queryId) {
        var cancel = this.getQuery(queryId).cancel;
        this.setQuery(queryId, function() {
            return {
                observableQuery: null
            };
        });
        if (cancel) cancel();
    };
    QueryManager.prototype.clearStore = function() {
        this.fetchQueryRejectFns.forEach(function(reject) {
            reject(new (0, $1DiV8.InvariantError)(16));
        });
        var resetIds = [];
        this.queries.forEach(function(_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery) resetIds.push(queryId);
        });
        this.queryStore.reset(resetIds);
        this.mutationStore.reset();
        return this.dataStore.reset();
    };
    QueryManager.prototype.resetStore = function() {
        var _this = this;
        return this.clearStore().then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    QueryManager.prototype.reFetchObservableQueries = function(includeStandby) {
        var _this = this;
        if (includeStandby === void 0) includeStandby = false;
        var observableQueryPromises = [];
        this.queries.forEach(function(_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery) {
                var fetchPolicy = observableQuery.options.fetchPolicy;
                observableQuery.resetLastResults();
                if (fetchPolicy !== 'cache-only' && (includeStandby || fetchPolicy !== 'standby')) observableQueryPromises.push(observableQuery.refetch());
                _this.setQuery(queryId, function() {
                    return {
                        newData: null
                    };
                });
                _this.invalidate(queryId);
            }
        });
        this.broadcastQueries();
        return Promise.all(observableQueryPromises);
    };
    QueryManager.prototype.observeQuery = function(queryId, options, observer) {
        this.addQueryListener(queryId, this.queryListenerForObserver(queryId, options, observer));
        return this.fetchQuery(queryId, options);
    };
    QueryManager.prototype.startQuery = function(queryId, options, listener) {
        this.addQueryListener(queryId, listener);
        this.fetchQuery(queryId, options).catch(function() {
            return undefined;
        });
        return queryId;
    };
    QueryManager.prototype.startGraphQLSubscription = function(_a) {
        var _this = this;
        var query = _a.query, fetchPolicy = _a.fetchPolicy, variables = _a.variables;
        query = this.transform(query).document;
        variables = this.getVariables(query, variables);
        var makeObservable = function(variables) {
            return _this.getObservableFromLink(query, {}, variables, false).map(function(result) {
                if (!fetchPolicy || fetchPolicy !== 'no-cache') {
                    _this.dataStore.markSubscriptionResult(result, query, variables);
                    _this.broadcastQueries();
                }
                if ((0, $jojW6.graphQLResultHasError)(result)) throw new $02a3c2aebc919401$export$26a337512320b8c6({
                    graphQLErrors: result.errors
                });
                return result;
            });
        };
        if (this.transform(query).hasClientExports) {
            var observablePromise_1 = this.localState.addExportedVariables(query, variables).then(makeObservable);
            return new $02a3c2aebc919401$var$Observable(function(observer) {
                var sub = null;
                observablePromise_1.then(function(observable) {
                    return sub = observable.subscribe(observer);
                }, observer.error);
                return function() {
                    return sub && sub.unsubscribe();
                };
            });
        }
        return makeObservable(variables);
    };
    QueryManager.prototype.stopQuery = function(queryId) {
        this.stopQueryNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryNoBroadcast = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.removeQuery(queryId);
    };
    QueryManager.prototype.removeQuery = function(queryId) {
        this.fetchQueryRejectFns.delete("query:" + queryId);
        this.fetchQueryRejectFns.delete("fetchRequest:" + queryId);
        this.getQuery(queryId).subscriptions.forEach(function(x) {
            return x.unsubscribe();
        });
        this.queries.delete(queryId);
    };
    QueryManager.prototype.getCurrentQueryResult = function(observableQuery, optimistic) {
        if (optimistic === void 0) optimistic = true;
        var _a = observableQuery.options, variables = _a.variables, query = _a.query, fetchPolicy = _a.fetchPolicy, returnPartialData = _a.returnPartialData;
        var lastResult = observableQuery.getLastResult();
        var newData = this.getQuery(observableQuery.queryId).newData;
        if (newData && newData.complete) return {
            data: newData.result,
            partial: false
        };
        if (fetchPolicy === 'no-cache' || fetchPolicy === 'network-only') return {
            data: undefined,
            partial: false
        };
        var _b = this.dataStore.getCache().diff({
            query: query,
            variables: variables,
            previousResult: lastResult ? lastResult.data : undefined,
            returnPartialData: true,
            optimistic: optimistic
        }), result = _b.result, complete = _b.complete;
        return {
            data: complete || returnPartialData ? result : void 0,
            partial: !complete
        };
    };
    QueryManager.prototype.getQueryWithPreviousResult = function(queryIdOrObservable) {
        var observableQuery;
        if (typeof queryIdOrObservable === 'string') {
            var foundObserveableQuery = this.getQuery(queryIdOrObservable).observableQuery;
            (0, $1DiV8.invariant)(foundObserveableQuery, 17);
            observableQuery = foundObserveableQuery;
        } else observableQuery = queryIdOrObservable;
        var _a = observableQuery.options, variables = _a.variables, query = _a.query;
        return {
            previousResult: this.getCurrentQueryResult(observableQuery, false).data,
            variables: variables,
            document: query
        };
    };
    QueryManager.prototype.broadcastQueries = function() {
        var _this = this;
        this.onBroadcast();
        this.queries.forEach(function(info, id) {
            if (info.invalidated) info.listeners.forEach(function(listener) {
                if (listener) listener(_this.queryStore.get(id), info.newData);
            });
        });
    };
    QueryManager.prototype.getLocalState = function() {
        return this.localState;
    };
    QueryManager.prototype.getObservableFromLink = function(query, context, variables, deduplication) {
        var _this = this;
        if (deduplication === void 0) deduplication = this.queryDeduplication;
        var observable;
        var serverQuery = this.transform(query).serverQuery;
        if (serverQuery) {
            var _a = this, inFlightLinkObservables_1 = _a.inFlightLinkObservables, link = _a.link;
            var operation = {
                query: serverQuery,
                variables: variables,
                operationName: (0, $jojW6.getOperationName)(serverQuery) || void 0,
                context: this.prepareContext((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, context), {
                    forceFetch: !deduplication
                }))
            };
            context = operation.context;
            if (deduplication) {
                var byVariables_1 = inFlightLinkObservables_1.get(serverQuery) || new Map();
                inFlightLinkObservables_1.set(serverQuery, byVariables_1);
                var varJson_1 = JSON.stringify(variables);
                observable = byVariables_1.get(varJson_1);
                if (!observable) {
                    byVariables_1.set(varJson_1, observable = $02a3c2aebc919401$var$multiplex((0, $clSzL.execute)(link, operation)));
                    var cleanup = function() {
                        byVariables_1.delete(varJson_1);
                        if (!byVariables_1.size) inFlightLinkObservables_1.delete(serverQuery);
                        cleanupSub_1.unsubscribe();
                    };
                    var cleanupSub_1 = observable.subscribe({
                        next: cleanup,
                        error: cleanup,
                        complete: cleanup
                    });
                }
            } else observable = $02a3c2aebc919401$var$multiplex((0, $clSzL.execute)(link, operation));
        } else {
            observable = $02a3c2aebc919401$var$Observable.of({
                data: {}
            });
            context = this.prepareContext(context);
        }
        var clientQuery = this.transform(query).clientQuery;
        if (clientQuery) observable = $02a3c2aebc919401$var$asyncMap(observable, function(result) {
            return _this.localState.runResolvers({
                document: clientQuery,
                remoteResult: result,
                context: context,
                variables: variables
            });
        });
        return observable;
    };
    QueryManager.prototype.fetchRequest = function(_a) {
        var _this = this;
        var requestId = _a.requestId, queryId = _a.queryId, document = _a.document, options = _a.options, fetchMoreForQueryId = _a.fetchMoreForQueryId;
        var variables = options.variables, _b = options.errorPolicy, errorPolicy = _b === void 0 ? 'none' : _b, fetchPolicy = options.fetchPolicy;
        var resultFromStore;
        var errorsFromStore;
        return new Promise(function(resolve, reject) {
            var observable = _this.getObservableFromLink(document, options.context, variables);
            var fqrfId = "fetchRequest:" + queryId;
            _this.fetchQueryRejectFns.set(fqrfId, reject);
            var cleanup = function() {
                _this.fetchQueryRejectFns.delete(fqrfId);
                _this.setQuery(queryId, function(_a) {
                    var subscriptions = _a.subscriptions;
                    subscriptions.delete(subscription);
                });
            };
            var subscription = observable.map(function(result) {
                if (requestId >= _this.getQuery(queryId).lastRequestId) {
                    _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                    _this.queryStore.markQueryResult(queryId, result, fetchMoreForQueryId);
                    _this.invalidate(queryId);
                    _this.invalidate(fetchMoreForQueryId);
                    _this.broadcastQueries();
                }
                if (errorPolicy === 'none' && $02a3c2aebc919401$var$isNonEmptyArray(result.errors)) return reject(new $02a3c2aebc919401$export$26a337512320b8c6({
                    graphQLErrors: result.errors
                }));
                if (errorPolicy === 'all') errorsFromStore = result.errors;
                if (fetchMoreForQueryId || fetchPolicy === 'no-cache') resultFromStore = result.data;
                else {
                    var _a = _this.dataStore.getCache().diff({
                        variables: variables,
                        query: document,
                        optimistic: false,
                        returnPartialData: true
                    }), result_1 = _a.result, complete = _a.complete;
                    if (complete || options.returnPartialData) resultFromStore = result_1;
                }
            }).subscribe({
                error: function(error) {
                    cleanup();
                    reject(error);
                },
                complete: function() {
                    cleanup();
                    resolve({
                        data: resultFromStore,
                        errors: errorsFromStore,
                        loading: false,
                        networkStatus: $02a3c2aebc919401$export$bd096ddbd246c79c.ready,
                        stale: false
                    });
                }
            });
            _this.setQuery(queryId, function(_a) {
                var subscriptions = _a.subscriptions;
                subscriptions.add(subscription);
            });
        });
    };
    QueryManager.prototype.getQuery = function(queryId) {
        return this.queries.get(queryId) || {
            listeners: new Set(),
            invalidated: false,
            document: null,
            newData: null,
            lastRequestId: 1,
            observableQuery: null,
            subscriptions: new Set()
        };
    };
    QueryManager.prototype.setQuery = function(queryId, updater) {
        var prev = this.getQuery(queryId);
        var newInfo = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, prev), updater(prev));
        this.queries.set(queryId, newInfo);
    };
    QueryManager.prototype.invalidate = function(queryId, invalidated) {
        if (invalidated === void 0) invalidated = true;
        if (queryId) this.setQuery(queryId, function() {
            return {
                invalidated: invalidated
            };
        });
    };
    QueryManager.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var newContext = this.localState.prepareContext(context);
        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, newContext), {
            clientAwareness: this.clientAwareness
        });
    };
    QueryManager.prototype.checkInFlight = function(queryId) {
        var query = this.queryStore.get(queryId);
        return query && query.networkStatus !== $02a3c2aebc919401$export$bd096ddbd246c79c.ready && query.networkStatus !== $02a3c2aebc919401$export$bd096ddbd246c79c.error;
    };
    QueryManager.prototype.startPollingQuery = function(options, queryId, listener) {
        var _this = this;
        var pollInterval = options.pollInterval;
        (0, $1DiV8.invariant)(pollInterval, 18);
        if (!this.ssrMode) {
            var info = this.pollingInfoByQueryId.get(queryId);
            if (!info) this.pollingInfoByQueryId.set(queryId, info = {});
            info.interval = pollInterval;
            info.options = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
                fetchPolicy: 'network-only'
            });
            var maybeFetch_1 = function() {
                var info = _this.pollingInfoByQueryId.get(queryId);
                if (info) {
                    if (_this.checkInFlight(queryId)) poll_1();
                    else _this.fetchQuery(queryId, info.options, $02a3c2aebc919401$export$160bafb6ac1e0641.poll).then(poll_1, poll_1);
                }
            };
            var poll_1 = function() {
                var info = _this.pollingInfoByQueryId.get(queryId);
                if (info) {
                    clearTimeout(info.timeout);
                    info.timeout = setTimeout(maybeFetch_1, info.interval);
                }
            };
            if (listener) this.addQueryListener(queryId, listener);
            poll_1();
        }
        return queryId;
    };
    QueryManager.prototype.stopPollingQuery = function(queryId) {
        this.pollingInfoByQueryId.delete(queryId);
    };
    return QueryManager;
}();
var $02a3c2aebc919401$var$DataStore = function() {
    function DataStore(initialCache) {
        this.cache = initialCache;
    }
    DataStore.prototype.getCache = function() {
        return this.cache;
    };
    DataStore.prototype.markQueryResult = function(result, document, variables, fetchMoreForQueryId, ignoreErrors) {
        if (ignoreErrors === void 0) ignoreErrors = false;
        var writeWithErrors = !(0, $jojW6.graphQLResultHasError)(result);
        if (ignoreErrors && (0, $jojW6.graphQLResultHasError)(result) && result.data) writeWithErrors = true;
        if (!fetchMoreForQueryId && writeWithErrors) this.cache.write({
            result: result.data,
            dataId: 'ROOT_QUERY',
            query: document,
            variables: variables
        });
    };
    DataStore.prototype.markSubscriptionResult = function(result, document, variables) {
        if (!(0, $jojW6.graphQLResultHasError)(result)) this.cache.write({
            result: result.data,
            dataId: 'ROOT_SUBSCRIPTION',
            query: document,
            variables: variables
        });
    };
    DataStore.prototype.markMutationInit = function(mutation) {
        var _this = this;
        if (mutation.optimisticResponse) {
            var optimistic_1;
            if (typeof mutation.optimisticResponse === 'function') optimistic_1 = mutation.optimisticResponse(mutation.variables);
            else optimistic_1 = mutation.optimisticResponse;
            this.cache.recordOptimisticTransaction(function(c) {
                var orig = _this.cache;
                _this.cache = c;
                try {
                    _this.markMutationResult({
                        mutationId: mutation.mutationId,
                        result: {
                            data: optimistic_1
                        },
                        document: mutation.document,
                        variables: mutation.variables,
                        updateQueries: mutation.updateQueries,
                        update: mutation.update
                    });
                } finally{
                    _this.cache = orig;
                }
            }, mutation.mutationId);
        }
    };
    DataStore.prototype.markMutationResult = function(mutation) {
        var _this = this;
        if (!(0, $jojW6.graphQLResultHasError)(mutation.result)) {
            var cacheWrites_1 = [
                {
                    result: mutation.result.data,
                    dataId: 'ROOT_MUTATION',
                    query: mutation.document,
                    variables: mutation.variables
                }
            ];
            var updateQueries_1 = mutation.updateQueries;
            if (updateQueries_1) Object.keys(updateQueries_1).forEach(function(id) {
                var _a = updateQueries_1[id], query = _a.query, updater = _a.updater;
                var _b = _this.cache.diff({
                    query: query.document,
                    variables: query.variables,
                    returnPartialData: true,
                    optimistic: false
                }), currentQueryResult = _b.result, complete = _b.complete;
                if (complete) {
                    var nextQueryResult = (0, $jojW6.tryFunctionOrLogError)(function() {
                        return updater(currentQueryResult, {
                            mutationResult: mutation.result,
                            queryName: (0, $jojW6.getOperationName)(query.document) || undefined,
                            queryVariables: query.variables
                        });
                    });
                    if (nextQueryResult) cacheWrites_1.push({
                        result: nextQueryResult,
                        dataId: 'ROOT_QUERY',
                        query: query.document,
                        variables: query.variables
                    });
                }
            });
            this.cache.performTransaction(function(c) {
                cacheWrites_1.forEach(function(write) {
                    return c.write(write);
                });
                var update = mutation.update;
                if (update) (0, $jojW6.tryFunctionOrLogError)(function() {
                    return update(c, mutation.result);
                });
            });
        }
    };
    DataStore.prototype.markMutationComplete = function(_a) {
        var mutationId = _a.mutationId, optimisticResponse = _a.optimisticResponse;
        if (optimisticResponse) this.cache.removeOptimistic(mutationId);
    };
    DataStore.prototype.markUpdateQueryResult = function(document, variables, newResult) {
        this.cache.write({
            result: newResult,
            dataId: 'ROOT_QUERY',
            variables: variables,
            query: document
        });
    };
    DataStore.prototype.reset = function() {
        return this.cache.reset();
    };
    return DataStore;
}();
var $02a3c2aebc919401$var$version = "2.6.10";
var $02a3c2aebc919401$var$hasSuggestedDevtools = false;
var $02a3c2aebc919401$export$13f5a5f0f1dbab88 = function() {
    function ApolloClient(options) {
        var _this = this;
        this.defaultOptions = {};
        this.resetStoreCallbacks = [];
        this.clearStoreCallbacks = [];
        var cache = options.cache, _a = options.ssrMode, ssrMode = _a === void 0 ? false : _a, _b = options.ssrForceFetchDelay, ssrForceFetchDelay = _b === void 0 ? 0 : _b, connectToDevTools = options.connectToDevTools, _c = options.queryDeduplication, queryDeduplication = _c === void 0 ? true : _c, defaultOptions = options.defaultOptions, _d = options.assumeImmutableResults, assumeImmutableResults = _d === void 0 ? false : _d, resolvers = options.resolvers, typeDefs = options.typeDefs, fragmentMatcher = options.fragmentMatcher, clientAwarenessName = options.name, clientAwarenessVersion = options.version;
        var link = options.link;
        if (!link && resolvers) link = (0, $clSzL.ApolloLink).empty();
        if (!link || !cache) throw new (0, $1DiV8.InvariantError)(4);
        this.link = link;
        this.cache = cache;
        this.store = new $02a3c2aebc919401$var$DataStore(cache);
        this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
        this.queryDeduplication = queryDeduplication;
        this.defaultOptions = defaultOptions || {};
        this.typeDefs = typeDefs;
        if (ssrForceFetchDelay) setTimeout(function() {
            return _this.disableNetworkFetches = false;
        }, ssrForceFetchDelay);
        this.watchQuery = this.watchQuery.bind(this);
        this.query = this.query.bind(this);
        this.mutate = this.mutate.bind(this);
        this.resetStore = this.resetStore.bind(this);
        this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
        var defaultConnectToDevTools = false;
        if (typeof connectToDevTools === 'undefined' ? defaultConnectToDevTools : connectToDevTools && typeof window !== 'undefined') window.__APOLLO_CLIENT__ = this;
        this.version = $02a3c2aebc919401$var$version;
        this.localState = new $02a3c2aebc919401$var$LocalState({
            cache: cache,
            client: this,
            resolvers: resolvers,
            fragmentMatcher: fragmentMatcher
        });
        this.queryManager = new $02a3c2aebc919401$var$QueryManager({
            link: this.link,
            store: this.store,
            queryDeduplication: queryDeduplication,
            ssrMode: ssrMode,
            clientAwareness: {
                name: clientAwarenessName,
                version: clientAwarenessVersion
            },
            localState: this.localState,
            assumeImmutableResults: assumeImmutableResults,
            onBroadcast: function() {
                if (_this.devToolsHookCb) _this.devToolsHookCb({
                    action: {},
                    state: {
                        queries: _this.queryManager.queryStore.getStore(),
                        mutations: _this.queryManager.mutationStore.getStore()
                    },
                    dataWithOptimisticResults: _this.cache.extract(true)
                });
            }
        });
    }
    ApolloClient.prototype.stop = function() {
        this.queryManager.stop();
    };
    ApolloClient.prototype.watchQuery = function(options) {
        if (this.defaultOptions.watchQuery) options = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.defaultOptions.watchQuery), options);
        if (this.disableNetworkFetches && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
            fetchPolicy: 'cache-first'
        });
        return this.queryManager.watchQuery(options);
    };
    ApolloClient.prototype.query = function(options) {
        if (this.defaultOptions.query) options = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.defaultOptions.query), options);
        (0, $1DiV8.invariant)(options.fetchPolicy !== 'cache-and-network', 5);
        if (this.disableNetworkFetches && options.fetchPolicy === 'network-only') options = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
            fetchPolicy: 'cache-first'
        });
        return this.queryManager.query(options);
    };
    ApolloClient.prototype.mutate = function(options) {
        if (this.defaultOptions.mutate) options = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.defaultOptions.mutate), options);
        return this.queryManager.mutate(options);
    };
    ApolloClient.prototype.subscribe = function(options) {
        return this.queryManager.startGraphQLSubscription(options);
    };
    ApolloClient.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readQuery(options, optimistic);
    };
    ApolloClient.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readFragment(options, optimistic);
    };
    ApolloClient.prototype.writeQuery = function(options) {
        var result = this.cache.writeQuery(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.writeFragment = function(options) {
        var result = this.cache.writeFragment(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.writeData = function(options) {
        var result = this.cache.writeData(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.__actionHookForDevTools = function(cb) {
        this.devToolsHookCb = cb;
    };
    ApolloClient.prototype.__requestRaw = function(payload) {
        return (0, $clSzL.execute)(this.link, payload);
    };
    ApolloClient.prototype.initQueryManager = function() {
        return this.queryManager;
    };
    ApolloClient.prototype.resetStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore();
        }).then(function() {
            return Promise.all(_this.resetStoreCallbacks.map(function(fn) {
                return fn();
            }));
        }).then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    ApolloClient.prototype.clearStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore();
        }).then(function() {
            return Promise.all(_this.clearStoreCallbacks.map(function(fn) {
                return fn();
            }));
        });
    };
    ApolloClient.prototype.onResetStore = function(cb) {
        var _this = this;
        this.resetStoreCallbacks.push(cb);
        return function() {
            _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    ApolloClient.prototype.onClearStore = function(cb) {
        var _this = this;
        this.clearStoreCallbacks.push(cb);
        return function() {
            _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    ApolloClient.prototype.reFetchObservableQueries = function(includeStandby) {
        return this.queryManager.reFetchObservableQueries(includeStandby);
    };
    ApolloClient.prototype.extract = function(optimistic) {
        return this.cache.extract(optimistic);
    };
    ApolloClient.prototype.restore = function(serializedState) {
        return this.cache.restore(serializedState);
    };
    ApolloClient.prototype.addResolvers = function(resolvers) {
        this.localState.addResolvers(resolvers);
    };
    ApolloClient.prototype.setResolvers = function(resolvers) {
        this.localState.setResolvers(resolvers);
    };
    ApolloClient.prototype.getResolvers = function() {
        return this.localState.getResolvers();
    };
    ApolloClient.prototype.setLocalStateFragmentMatcher = function(fragmentMatcher) {
        this.localState.setFragmentMatcher(fragmentMatcher);
    };
    return ApolloClient;
}();
var $02a3c2aebc919401$export$2e2bcd8739ae039 = $02a3c2aebc919401$export$13f5a5f0f1dbab88;

});
parcelRegister("jojW6", function(module, exports) {

$parcel$export(module.exports, "storeKeyNameFromField", () => $e1dfb923a27ca793$export$54be8689c65f3b56);
$parcel$export(module.exports, "getStoreKeyName", () => $e1dfb923a27ca793$export$3cdb6c178b88cabe);
$parcel$export(module.exports, "argumentsObjectFromField", () => $e1dfb923a27ca793$export$3f5a60fb6a781b4f);
$parcel$export(module.exports, "resultKeyNameFromField", () => $e1dfb923a27ca793$export$7d1ad22471852218);
$parcel$export(module.exports, "isField", () => $e1dfb923a27ca793$export$fb56ad75dd311c12);
$parcel$export(module.exports, "isInlineFragment", () => $e1dfb923a27ca793$export$22a1cdafaf27bcff);
$parcel$export(module.exports, "isIdValue", () => $e1dfb923a27ca793$export$e33b89a9aa87695);
$parcel$export(module.exports, "toIdValue", () => $e1dfb923a27ca793$export$b124f125e34d720a);
$parcel$export(module.exports, "isJsonValue", () => $e1dfb923a27ca793$export$226c1c6d1a5b660a);
$parcel$export(module.exports, "getDirectiveInfoFromField", () => $e1dfb923a27ca793$export$2a7f471142984a91);
$parcel$export(module.exports, "shouldInclude", () => $e1dfb923a27ca793$export$3dc388a5f013b4a5);
$parcel$export(module.exports, "hasDirectives", () => $e1dfb923a27ca793$export$2dafb573e282fe8d);
$parcel$export(module.exports, "hasClientExports", () => $e1dfb923a27ca793$export$8d1e9e5bbfa5d09a);
$parcel$export(module.exports, "getFragmentQueryDocument", () => $e1dfb923a27ca793$export$abbf37c7cf644e41);
$parcel$export(module.exports, "assign", () => $e1dfb923a27ca793$export$e6e34fd1f2686227);
$parcel$export(module.exports, "checkDocument", () => $e1dfb923a27ca793$export$a7d0d8111d2386df);
$parcel$export(module.exports, "getOperationDefinition", () => $e1dfb923a27ca793$export$7a5b1fa979d2c158);
$parcel$export(module.exports, "getOperationName", () => $e1dfb923a27ca793$export$41bca9dc6871dd4e);
$parcel$export(module.exports, "getFragmentDefinitions", () => $e1dfb923a27ca793$export$5320a7ba9466a3df);
$parcel$export(module.exports, "getQueryDefinition", () => $e1dfb923a27ca793$export$d96b2213c1b9d3a9);
$parcel$export(module.exports, "getMainDefinition", () => $e1dfb923a27ca793$export$f431198736b7f96d);
$parcel$export(module.exports, "createFragmentMap", () => $e1dfb923a27ca793$export$193789b4c8246dd4);
$parcel$export(module.exports, "getDefaultValues", () => $e1dfb923a27ca793$export$84c19026e616569e);
$parcel$export(module.exports, "removeDirectivesFromDocument", () => $e1dfb923a27ca793$export$e5ae0530da5fe96c);
$parcel$export(module.exports, "addTypenameToDocument", () => $e1dfb923a27ca793$export$43b332f87950a467);
$parcel$export(module.exports, "removeConnectionDirectiveFromDocument", () => $e1dfb923a27ca793$export$74985f3324559867);
$parcel$export(module.exports, "buildQueryFromSelectionSet", () => $e1dfb923a27ca793$export$57c368c23873f32b);
$parcel$export(module.exports, "removeClientSetsFromDocument", () => $e1dfb923a27ca793$export$8eae69e876ee321e);
$parcel$export(module.exports, "canUseWeakMap", () => $e1dfb923a27ca793$export$772fbc04a0ad4ce9);
$parcel$export(module.exports, "cloneDeep", () => $e1dfb923a27ca793$export$629a2bd3f5a49ecc);
$parcel$export(module.exports, "isProduction", () => $e1dfb923a27ca793$export$f15d00aa73aafac4);
$parcel$export(module.exports, "isTest", () => $e1dfb923a27ca793$export$410cbc2864fa25b5);
$parcel$export(module.exports, "tryFunctionOrLogError", () => $e1dfb923a27ca793$export$50a91acae4904909);
$parcel$export(module.exports, "graphQLResultHasError", () => $e1dfb923a27ca793$export$b4df399e879e53ab);
$parcel$export(module.exports, "mergeDeep", () => $e1dfb923a27ca793$export$dd702b3c8240390c);
$parcel$export(module.exports, "mergeDeepArray", () => $e1dfb923a27ca793$export$160070228be94b08);

var $12QNw = parcelRequire("12QNw");

var $1DiV8 = parcelRequire("1DiV8");

var $3VFsf = parcelRequire("3VFsf");

var $fkrBp = parcelRequire("fkrBp");

var $bqMzA = parcelRequire("bqMzA");

var $6cAn5 = parcelRequire("6cAn5");
function $e1dfb923a27ca793$export$dc071f102752d0eb(value) {
    return [
        'StringValue',
        'BooleanValue',
        'EnumValue'
    ].indexOf(value.kind) > -1;
}
function $e1dfb923a27ca793$export$3ff5e9927c3257c6(value) {
    return [
        'IntValue',
        'FloatValue'
    ].indexOf(value.kind) > -1;
}
function $e1dfb923a27ca793$var$isStringValue(value) {
    return value.kind === 'StringValue';
}
function $e1dfb923a27ca793$var$isBooleanValue(value) {
    return value.kind === 'BooleanValue';
}
function $e1dfb923a27ca793$var$isIntValue(value) {
    return value.kind === 'IntValue';
}
function $e1dfb923a27ca793$var$isFloatValue(value) {
    return value.kind === 'FloatValue';
}
function $e1dfb923a27ca793$var$isVariable(value) {
    return value.kind === 'Variable';
}
function $e1dfb923a27ca793$var$isObjectValue(value) {
    return value.kind === 'ObjectValue';
}
function $e1dfb923a27ca793$var$isListValue(value) {
    return value.kind === 'ListValue';
}
function $e1dfb923a27ca793$var$isEnumValue(value) {
    return value.kind === 'EnumValue';
}
function $e1dfb923a27ca793$var$isNullValue(value) {
    return value.kind === 'NullValue';
}
function $e1dfb923a27ca793$export$a1dab82d368d6525(argObj, name, value, variables) {
    if ($e1dfb923a27ca793$var$isIntValue(value) || $e1dfb923a27ca793$var$isFloatValue(value)) argObj[name.value] = Number(value.value);
    else if ($e1dfb923a27ca793$var$isBooleanValue(value) || $e1dfb923a27ca793$var$isStringValue(value)) argObj[name.value] = value.value;
    else if ($e1dfb923a27ca793$var$isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function(obj) {
            return $e1dfb923a27ca793$export$a1dab82d368d6525(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    } else if ($e1dfb923a27ca793$var$isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    } else if ($e1dfb923a27ca793$var$isListValue(value)) argObj[name.value] = value.values.map(function(listValue) {
        var nestedArgArrayObj = {};
        $e1dfb923a27ca793$export$a1dab82d368d6525(nestedArgArrayObj, name, listValue, variables);
        return nestedArgArrayObj[name.value];
    });
    else if ($e1dfb923a27ca793$var$isEnumValue(value)) argObj[name.value] = value.value;
    else if ($e1dfb923a27ca793$var$isNullValue(value)) argObj[name.value] = null;
    else throw new (0, $1DiV8.InvariantError)(17);
}
function $e1dfb923a27ca793$export$54be8689c65f3b56(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function(directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) directive.arguments.forEach(function(_a) {
                var name = _a.name, value = _a.value;
                return $e1dfb923a27ca793$export$a1dab82d368d6525(directivesObj[directive.name.value], name, value, variables);
            });
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $e1dfb923a27ca793$export$a1dab82d368d6525(argObj, name, value, variables);
        });
    }
    return $e1dfb923a27ca793$export$3cdb6c178b88cabe(field.name.value, argObj, directivesObj);
}
var $e1dfb923a27ca793$var$KNOWN_DIRECTIVES = [
    'connection',
    'include',
    'skip',
    'client',
    'rest',
    'export'
];
function $e1dfb923a27ca793$export$3cdb6c178b88cabe(fieldName, args, directives) {
    if (directives && directives['connection'] && directives['connection']['key']) {
        if (directives['connection']['filter'] && directives['connection']['filter'].length > 0) {
            var filterKeys = directives['connection']['filter'] ? directives['connection']['filter'] : [];
            filterKeys.sort();
            var queryArgs_1 = args;
            var filteredArgs_1 = {};
            filterKeys.forEach(function(key) {
                filteredArgs_1[key] = queryArgs_1[key];
            });
            return directives['connection']['key'] + "(" + JSON.stringify(filteredArgs_1) + ")";
        } else return directives['connection']['key'];
    }
    var completeFieldName = fieldName;
    if (args) {
        var stringifiedArgs = (0, (/*@__PURE__*/$parcel$interopDefault($fkrBp)))(args);
        completeFieldName += "(" + stringifiedArgs + ")";
    }
    if (directives) Object.keys(directives).forEach(function(key) {
        if ($e1dfb923a27ca793$var$KNOWN_DIRECTIVES.indexOf(key) !== -1) return;
        if (directives[key] && Object.keys(directives[key]).length) completeFieldName += "@" + key + "(" + JSON.stringify(directives[key]) + ")";
        else completeFieldName += "@" + key;
    });
    return completeFieldName;
}
function $e1dfb923a27ca793$export$3f5a60fb6a781b4f(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $e1dfb923a27ca793$export$a1dab82d368d6525(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function $e1dfb923a27ca793$export$7d1ad22471852218(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function $e1dfb923a27ca793$export$fb56ad75dd311c12(selection) {
    return selection.kind === 'Field';
}
function $e1dfb923a27ca793$export$22a1cdafaf27bcff(selection) {
    return selection.kind === 'InlineFragment';
}
function $e1dfb923a27ca793$export$e33b89a9aa87695(idObject) {
    return idObject && idObject.type === 'id' && typeof idObject.generated === 'boolean';
}
function $e1dfb923a27ca793$export$b124f125e34d720a(idConfig, generated) {
    if (generated === void 0) generated = false;
    return (0, $3VFsf.__assign)({
        type: 'id',
        generated: generated
    }, typeof idConfig === 'string' ? {
        id: idConfig,
        typename: undefined
    } : idConfig);
}
function $e1dfb923a27ca793$export$226c1c6d1a5b660a(jsonObject) {
    return jsonObject != null && typeof jsonObject === 'object' && jsonObject.type === 'json';
}
function $e1dfb923a27ca793$var$defaultValueFromVariable(node) {
    throw new (0, $1DiV8.InvariantError)(18);
}
function $e1dfb923a27ca793$export$b3db129ed867b445(node, onVariable) {
    if (onVariable === void 0) onVariable = $e1dfb923a27ca793$var$defaultValueFromVariable;
    switch(node.kind){
        case 'Variable':
            return onVariable(node);
        case 'NullValue':
            return null;
        case 'IntValue':
            return parseInt(node.value, 10);
        case 'FloatValue':
            return parseFloat(node.value);
        case 'ListValue':
            return node.values.map(function(v) {
                return $e1dfb923a27ca793$export$b3db129ed867b445(v, onVariable);
            });
        case 'ObjectValue':
            var value = {};
            for(var _i = 0, _a = node.fields; _i < _a.length; _i++){
                var field = _a[_i];
                value[field.name.value] = $e1dfb923a27ca793$export$b3db129ed867b445(field.value, onVariable);
            }
            return value;
        default:
            return node.value;
    }
}
function $e1dfb923a27ca793$export$2a7f471142984a91(field, variables) {
    if (field.directives && field.directives.length) {
        var directiveObj_1 = {};
        field.directives.forEach(function(directive) {
            directiveObj_1[directive.name.value] = $e1dfb923a27ca793$export$3f5a60fb6a781b4f(directive, variables);
        });
        return directiveObj_1;
    }
    return null;
}
function $e1dfb923a27ca793$export$3dc388a5f013b4a5(selection, variables) {
    if (variables === void 0) variables = {};
    return $e1dfb923a27ca793$export$b7bdffb7e6f1ef53(selection.directives).every(function(_a) {
        var directive = _a.directive, ifArgument = _a.ifArgument;
        var evaledValue = false;
        if (ifArgument.value.kind === 'Variable') {
            evaledValue = variables[ifArgument.value.name.value];
            (0, $1DiV8.invariant)(evaledValue !== void 0, 13);
        } else evaledValue = ifArgument.value.value;
        return directive.name.value === 'skip' ? !evaledValue : evaledValue;
    });
}
function $e1dfb923a27ca793$export$1b217de6ce18b9a(doc) {
    var names = [];
    (0, $12QNw.visit)(doc, {
        Directive: function(node) {
            names.push(node.name.value);
        }
    });
    return names;
}
function $e1dfb923a27ca793$export$2dafb573e282fe8d(names, doc) {
    return $e1dfb923a27ca793$export$1b217de6ce18b9a(doc).some(function(name) {
        return names.indexOf(name) > -1;
    });
}
function $e1dfb923a27ca793$export$8d1e9e5bbfa5d09a(document) {
    return document && $e1dfb923a27ca793$export$2dafb573e282fe8d([
        'client'
    ], document) && $e1dfb923a27ca793$export$2dafb573e282fe8d([
        'export'
    ], document);
}
function $e1dfb923a27ca793$var$isInclusionDirective(_a) {
    var value = _a.name.value;
    return value === 'skip' || value === 'include';
}
function $e1dfb923a27ca793$export$b7bdffb7e6f1ef53(directives) {
    return directives ? directives.filter($e1dfb923a27ca793$var$isInclusionDirective).map(function(directive) {
        var directiveArguments = directive.arguments;
        var directiveName = directive.name.value;
        (0, $1DiV8.invariant)(directiveArguments && directiveArguments.length === 1, 14);
        var ifArgument = directiveArguments[0];
        (0, $1DiV8.invariant)(ifArgument.name && ifArgument.name.value === 'if', 15);
        var ifValue = ifArgument.value;
        (0, $1DiV8.invariant)(ifValue && (ifValue.kind === 'Variable' || ifValue.kind === 'BooleanValue'), 16);
        return {
            directive: directive,
            ifArgument: ifArgument
        };
    }) : [];
}
function $e1dfb923a27ca793$export$abbf37c7cf644e41(document, fragmentName) {
    var actualFragmentName = fragmentName;
    var fragments = [];
    document.definitions.forEach(function(definition) {
        if (definition.kind === 'OperationDefinition') throw new (0, $1DiV8.InvariantError)(11);
        if (definition.kind === 'FragmentDefinition') fragments.push(definition);
    });
    if (typeof actualFragmentName === 'undefined') {
        (0, $1DiV8.invariant)(fragments.length === 1, 12);
        actualFragmentName = fragments[0].name.value;
    }
    var query = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, document), {
        definitions: (0, $3VFsf.__spreadArrays)([
            {
                kind: 'OperationDefinition',
                operation: 'query',
                selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                        {
                            kind: 'FragmentSpread',
                            name: {
                                kind: 'Name',
                                value: actualFragmentName
                            }
                        }
                    ]
                }
            }
        ], document.definitions)
    });
    return query;
}
function $e1dfb923a27ca793$export$e6e34fd1f2686227(target) {
    var sources = [];
    for(var _i = 1; _i < arguments.length; _i++)sources[_i - 1] = arguments[_i];
    sources.forEach(function(source) {
        if (typeof source === 'undefined' || source === null) return;
        Object.keys(source).forEach(function(key) {
            target[key] = source[key];
        });
    });
    return target;
}
function $e1dfb923a27ca793$export$a92e7a440b22bdf0(doc) {
    $e1dfb923a27ca793$export$a7d0d8111d2386df(doc);
    var mutationDef = doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition' && definition.operation === 'mutation';
    })[0];
    (0, $1DiV8.invariant)(mutationDef, 1);
    return mutationDef;
}
function $e1dfb923a27ca793$export$a7d0d8111d2386df(doc) {
    (0, $1DiV8.invariant)(doc && doc.kind === 'Document', 2);
    var operations = doc.definitions.filter(function(d) {
        return d.kind !== 'FragmentDefinition';
    }).map(function(definition) {
        if (definition.kind !== 'OperationDefinition') throw new (0, $1DiV8.InvariantError)(3);
        return definition;
    });
    (0, $1DiV8.invariant)(operations.length <= 1, 4);
    return doc;
}
function $e1dfb923a27ca793$export$7a5b1fa979d2c158(doc) {
    $e1dfb923a27ca793$export$a7d0d8111d2386df(doc);
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition';
    })[0];
}
function $e1dfb923a27ca793$export$78a8e95d8d43ad7f(document) {
    var def = $e1dfb923a27ca793$export$7a5b1fa979d2c158(document);
    (0, $1DiV8.invariant)(def, 5);
    return def;
}
function $e1dfb923a27ca793$export$41bca9dc6871dd4e(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition' && definition.name;
    }).map(function(x) {
        return x.name.value;
    })[0] || null;
}
function $e1dfb923a27ca793$export$5320a7ba9466a3df(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'FragmentDefinition';
    });
}
function $e1dfb923a27ca793$export$d96b2213c1b9d3a9(doc) {
    var queryDef = $e1dfb923a27ca793$export$7a5b1fa979d2c158(doc);
    (0, $1DiV8.invariant)(queryDef && queryDef.operation === 'query', 6);
    return queryDef;
}
function $e1dfb923a27ca793$export$772111caef41b3f5(doc) {
    (0, $1DiV8.invariant)(doc.kind === 'Document', 7);
    (0, $1DiV8.invariant)(doc.definitions.length <= 1, 8);
    var fragmentDef = doc.definitions[0];
    (0, $1DiV8.invariant)(fragmentDef.kind === 'FragmentDefinition', 9);
    return fragmentDef;
}
function $e1dfb923a27ca793$export$f431198736b7f96d(queryDoc) {
    $e1dfb923a27ca793$export$a7d0d8111d2386df(queryDoc);
    var fragmentDefinition;
    for(var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++){
        var definition = _a[_i];
        if (definition.kind === 'OperationDefinition') {
            var operation = definition.operation;
            if (operation === 'query' || operation === 'mutation' || operation === 'subscription') return definition;
        }
        if (definition.kind === 'FragmentDefinition' && !fragmentDefinition) fragmentDefinition = definition;
    }
    if (fragmentDefinition) return fragmentDefinition;
    throw new (0, $1DiV8.InvariantError)(10);
}
function $e1dfb923a27ca793$export$193789b4c8246dd4(fragments) {
    if (fragments === void 0) fragments = [];
    var symTable = {};
    fragments.forEach(function(fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function $e1dfb923a27ca793$export$84c19026e616569e(definition) {
    if (definition && definition.variableDefinitions && definition.variableDefinitions.length) {
        var defaultValues = definition.variableDefinitions.filter(function(_a) {
            var defaultValue = _a.defaultValue;
            return defaultValue;
        }).map(function(_a) {
            var variable = _a.variable, defaultValue = _a.defaultValue;
            var defaultValueObj = {};
            $e1dfb923a27ca793$export$a1dab82d368d6525(defaultValueObj, variable.name, defaultValue);
            return defaultValueObj;
        });
        return $e1dfb923a27ca793$export$e6e34fd1f2686227.apply(void 0, (0, $3VFsf.__spreadArrays)([
            {}
        ], defaultValues));
    }
    return {};
}
function $e1dfb923a27ca793$export$55ead6c9e4eac970(operation) {
    var names = new Set();
    if (operation.variableDefinitions) for(var _i = 0, _a = operation.variableDefinitions; _i < _a.length; _i++){
        var definition = _a[_i];
        names.add(definition.variable.name.value);
    }
    return names;
}
function $e1dfb923a27ca793$var$filterInPlace(array, test, context) {
    var target = 0;
    array.forEach(function(elem, i) {
        if (test.call(this, elem, i, array)) array[target++] = elem;
    }, context);
    array.length = target;
    return array;
}
var $e1dfb923a27ca793$var$TYPENAME_FIELD = {
    kind: 'Field',
    name: {
        kind: 'Name',
        value: '__typename'
    }
};
function $e1dfb923a27ca793$var$isEmpty(op, fragments) {
    return op.selectionSet.selections.every(function(selection) {
        return selection.kind === 'FragmentSpread' && $e1dfb923a27ca793$var$isEmpty(fragments[selection.name.value], fragments);
    });
}
function $e1dfb923a27ca793$var$nullIfDocIsEmpty(doc) {
    return $e1dfb923a27ca793$var$isEmpty($e1dfb923a27ca793$export$7a5b1fa979d2c158(doc) || $e1dfb923a27ca793$export$772111caef41b3f5(doc), $e1dfb923a27ca793$export$193789b4c8246dd4($e1dfb923a27ca793$export$5320a7ba9466a3df(doc))) ? null : doc;
}
function $e1dfb923a27ca793$var$getDirectiveMatcher(directives) {
    return function directiveMatcher(directive) {
        return directives.some(function(dir) {
            return dir.name && dir.name === directive.name.value || dir.test && dir.test(directive);
        });
    };
}
function $e1dfb923a27ca793$export$e5ae0530da5fe96c(directives, doc) {
    var variablesInUse = Object.create(null);
    var variablesToRemove = [];
    var fragmentSpreadsInUse = Object.create(null);
    var fragmentSpreadsToRemove = [];
    var modifiedDoc = $e1dfb923a27ca793$var$nullIfDocIsEmpty((0, $12QNw.visit)(doc, {
        Variable: {
            enter: function(node, _key, parent) {
                if (parent.kind !== 'VariableDefinition') variablesInUse[node.name.value] = true;
            }
        },
        Field: {
            enter: function(node) {
                if (directives && node.directives) {
                    var shouldRemoveField = directives.some(function(directive) {
                        return directive.remove;
                    });
                    if (shouldRemoveField && node.directives && node.directives.some($e1dfb923a27ca793$var$getDirectiveMatcher(directives))) {
                        if (node.arguments) node.arguments.forEach(function(arg) {
                            if (arg.value.kind === 'Variable') variablesToRemove.push({
                                name: arg.value.name.value
                            });
                        });
                        if (node.selectionSet) $e1dfb923a27ca793$var$getAllFragmentSpreadsFromSelectionSet(node.selectionSet).forEach(function(frag) {
                            fragmentSpreadsToRemove.push({
                                name: frag.name.value
                            });
                        });
                        return null;
                    }
                }
            }
        },
        FragmentSpread: {
            enter: function(node) {
                fragmentSpreadsInUse[node.name.value] = true;
            }
        },
        Directive: {
            enter: function(node) {
                if ($e1dfb923a27ca793$var$getDirectiveMatcher(directives)(node)) return null;
            }
        }
    }));
    if (modifiedDoc && $e1dfb923a27ca793$var$filterInPlace(variablesToRemove, function(v) {
        return !variablesInUse[v.name];
    }).length) modifiedDoc = $e1dfb923a27ca793$export$ecd5bb739c4a8b38(variablesToRemove, modifiedDoc);
    if (modifiedDoc && $e1dfb923a27ca793$var$filterInPlace(fragmentSpreadsToRemove, function(fs) {
        return !fragmentSpreadsInUse[fs.name];
    }).length) modifiedDoc = $e1dfb923a27ca793$export$7c9d17c333033c13(fragmentSpreadsToRemove, modifiedDoc);
    return modifiedDoc;
}
function $e1dfb923a27ca793$export$43b332f87950a467(doc) {
    return (0, $12QNw.visit)($e1dfb923a27ca793$export$a7d0d8111d2386df(doc), {
        SelectionSet: {
            enter: function(node, _key, parent) {
                if (parent && parent.kind === 'OperationDefinition') return;
                var selections = node.selections;
                if (!selections) return;
                var skip = selections.some(function(selection) {
                    return $e1dfb923a27ca793$export$fb56ad75dd311c12(selection) && (selection.name.value === '__typename' || selection.name.value.lastIndexOf('__', 0) === 0);
                });
                if (skip) return;
                var field = parent;
                if ($e1dfb923a27ca793$export$fb56ad75dd311c12(field) && field.directives && field.directives.some(function(d) {
                    return d.name.value === 'export';
                })) return;
                return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, node), {
                    selections: (0, $3VFsf.__spreadArrays)(selections, [
                        $e1dfb923a27ca793$var$TYPENAME_FIELD
                    ])
                });
            }
        }
    });
}
var $e1dfb923a27ca793$var$connectionRemoveConfig = {
    test: function(directive) {
        var willRemove = directive.name.value === 'connection';
        if (willRemove) !directive.arguments || directive.arguments.some(function(arg) {
            return arg.name.value === 'key';
        });
        return willRemove;
    }
};
function $e1dfb923a27ca793$export$74985f3324559867(doc) {
    return $e1dfb923a27ca793$export$e5ae0530da5fe96c([
        $e1dfb923a27ca793$var$connectionRemoveConfig
    ], $e1dfb923a27ca793$export$a7d0d8111d2386df(doc));
}
function $e1dfb923a27ca793$var$hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    return selectionSet && selectionSet.selections && selectionSet.selections.some(function(selection) {
        return $e1dfb923a27ca793$var$hasDirectivesInSelection(directives, selection, nestedCheck);
    });
}
function $e1dfb923a27ca793$var$hasDirectivesInSelection(directives, selection, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    if (!$e1dfb923a27ca793$export$fb56ad75dd311c12(selection)) return true;
    if (!selection.directives) return false;
    return selection.directives.some($e1dfb923a27ca793$var$getDirectiveMatcher(directives)) || nestedCheck && $e1dfb923a27ca793$var$hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck);
}
function $e1dfb923a27ca793$export$deed3420cb5d2e1d(directives, doc) {
    $e1dfb923a27ca793$export$a7d0d8111d2386df(doc);
    var parentPath;
    return $e1dfb923a27ca793$var$nullIfDocIsEmpty((0, $12QNw.visit)(doc, {
        SelectionSet: {
            enter: function(node, _key, _parent, path) {
                var currentPath = path.join('-');
                if (!parentPath || currentPath === parentPath || !currentPath.startsWith(parentPath)) {
                    if (node.selections) {
                        var selectionsWithDirectives = node.selections.filter(function(selection) {
                            return $e1dfb923a27ca793$var$hasDirectivesInSelection(directives, selection);
                        });
                        if ($e1dfb923a27ca793$var$hasDirectivesInSelectionSet(directives, node, false)) parentPath = currentPath;
                        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, node), {
                            selections: selectionsWithDirectives
                        });
                    } else return null;
                }
            }
        }
    }));
}
function $e1dfb923a27ca793$var$getArgumentMatcher(config) {
    return function argumentMatcher(argument) {
        return config.some(function(aConfig) {
            return argument.value && argument.value.kind === 'Variable' && argument.value.name && (aConfig.name === argument.value.name.value || aConfig.test && aConfig.test(argument));
        });
    };
}
function $e1dfb923a27ca793$export$ecd5bb739c4a8b38(config, doc) {
    var argMatcher = $e1dfb923a27ca793$var$getArgumentMatcher(config);
    return $e1dfb923a27ca793$var$nullIfDocIsEmpty((0, $12QNw.visit)(doc, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, node), {
                    variableDefinitions: node.variableDefinitions.filter(function(varDef) {
                        return !config.some(function(arg) {
                            return arg.name === varDef.variable.name.value;
                        });
                    })
                });
            }
        },
        Field: {
            enter: function(node) {
                var shouldRemoveField = config.some(function(argConfig) {
                    return argConfig.remove;
                });
                if (shouldRemoveField) {
                    var argMatchCount_1 = 0;
                    node.arguments.forEach(function(arg) {
                        if (argMatcher(arg)) argMatchCount_1 += 1;
                    });
                    if (argMatchCount_1 === 1) return null;
                }
            }
        },
        Argument: {
            enter: function(node) {
                if (argMatcher(node)) return null;
            }
        }
    }));
}
function $e1dfb923a27ca793$export$7c9d17c333033c13(config, doc) {
    function enter(node) {
        if (config.some(function(def) {
            return def.name === node.name.value;
        })) return null;
    }
    return $e1dfb923a27ca793$var$nullIfDocIsEmpty((0, $12QNw.visit)(doc, {
        FragmentSpread: {
            enter: enter
        },
        FragmentDefinition: {
            enter: enter
        }
    }));
}
function $e1dfb923a27ca793$var$getAllFragmentSpreadsFromSelectionSet(selectionSet) {
    var allFragments = [];
    selectionSet.selections.forEach(function(selection) {
        if (($e1dfb923a27ca793$export$fb56ad75dd311c12(selection) || $e1dfb923a27ca793$export$22a1cdafaf27bcff(selection)) && selection.selectionSet) $e1dfb923a27ca793$var$getAllFragmentSpreadsFromSelectionSet(selection.selectionSet).forEach(function(frag) {
            return allFragments.push(frag);
        });
        else if (selection.kind === 'FragmentSpread') allFragments.push(selection);
    });
    return allFragments;
}
function $e1dfb923a27ca793$export$57c368c23873f32b(document) {
    var definition = $e1dfb923a27ca793$export$f431198736b7f96d(document);
    var definitionOperation = definition.operation;
    if (definitionOperation === 'query') return document;
    var modifiedDoc = (0, $12QNw.visit)(document, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, node), {
                    operation: 'query'
                });
            }
        }
    });
    return modifiedDoc;
}
function $e1dfb923a27ca793$export$8eae69e876ee321e(document) {
    $e1dfb923a27ca793$export$a7d0d8111d2386df(document);
    var modifiedDoc = $e1dfb923a27ca793$export$e5ae0530da5fe96c([
        {
            test: function(directive) {
                return directive.name.value === 'client';
            },
            remove: true
        }
    ], document);
    if (modifiedDoc) modifiedDoc = (0, $12QNw.visit)(modifiedDoc, {
        FragmentDefinition: {
            enter: function(node) {
                if (node.selectionSet) {
                    var isTypenameOnly = node.selectionSet.selections.every(function(selection) {
                        return $e1dfb923a27ca793$export$fb56ad75dd311c12(selection) && selection.name.value === '__typename';
                    });
                    if (isTypenameOnly) return null;
                }
            }
        }
    });
    return modifiedDoc;
}
var $e1dfb923a27ca793$export$772fbc04a0ad4ce9 = typeof WeakMap === 'function' && !(typeof navigator === 'object' && navigator.product === 'ReactNative');
var $e1dfb923a27ca793$var$toString = Object.prototype.toString;
function $e1dfb923a27ca793$export$629a2bd3f5a49ecc(value) {
    return $e1dfb923a27ca793$var$cloneDeepHelper(value, new Map());
}
function $e1dfb923a27ca793$var$cloneDeepHelper(val, seen) {
    switch($e1dfb923a27ca793$var$toString.call(val)){
        case "[object Array]":
            if (seen.has(val)) return seen.get(val);
            var copy_1 = val.slice(0);
            seen.set(val, copy_1);
            copy_1.forEach(function(child, i) {
                copy_1[i] = $e1dfb923a27ca793$var$cloneDeepHelper(child, seen);
            });
            return copy_1;
        case "[object Object]":
            if (seen.has(val)) return seen.get(val);
            var copy_2 = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy_2);
            Object.keys(val).forEach(function(key) {
                copy_2[key] = $e1dfb923a27ca793$var$cloneDeepHelper(val[key], seen);
            });
            return copy_2;
        default:
            return val;
    }
}
function $e1dfb923a27ca793$export$4bd44a2aa29d3d6e() {
    if (typeof $6cAn5 !== 'undefined' && "production") return "production";
    return 'development';
}
function $e1dfb923a27ca793$export$f0cb0fda19c18b37(env) {
    return $e1dfb923a27ca793$export$4bd44a2aa29d3d6e() === env;
}
function $e1dfb923a27ca793$export$f15d00aa73aafac4() {
    return $e1dfb923a27ca793$export$f0cb0fda19c18b37('production') === true;
}
function $e1dfb923a27ca793$export$df77466336fe5355() {
    return $e1dfb923a27ca793$export$f0cb0fda19c18b37('development') === true;
}
function $e1dfb923a27ca793$export$410cbc2864fa25b5() {
    return $e1dfb923a27ca793$export$f0cb0fda19c18b37('test') === true;
}
function $e1dfb923a27ca793$export$50a91acae4904909(f) {
    try {
        return f();
    } catch (e) {
        if (console.error) console.error(e);
    }
}
function $e1dfb923a27ca793$export$b4df399e879e53ab(result) {
    return result.errors && result.errors.length;
}
function $e1dfb923a27ca793$var$deepFreeze(o) {
    Object.freeze(o);
    Object.getOwnPropertyNames(o).forEach(function(prop) {
        if (o[prop] !== null && (typeof o[prop] === 'object' || typeof o[prop] === 'function') && !Object.isFrozen(o[prop])) $e1dfb923a27ca793$var$deepFreeze(o[prop]);
    });
    return o;
}
function $e1dfb923a27ca793$export$7f9c177735b71f18(obj) {
    if ($e1dfb923a27ca793$export$df77466336fe5355() || $e1dfb923a27ca793$export$410cbc2864fa25b5()) {
        var symbolIsPolyfilled = typeof Symbol === 'function' && typeof Symbol('') === 'string';
        if (!symbolIsPolyfilled) return $e1dfb923a27ca793$var$deepFreeze(obj);
    }
    return obj;
}
var $e1dfb923a27ca793$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $e1dfb923a27ca793$export$dd702b3c8240390c() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    return $e1dfb923a27ca793$export$160070228be94b08(sources);
}
function $e1dfb923a27ca793$export$160070228be94b08(sources) {
    var target = sources[0] || {};
    var count = sources.length;
    if (count > 1) {
        var pastCopies = [];
        target = $e1dfb923a27ca793$var$shallowCopyForMerge(target, pastCopies);
        for(var i = 1; i < count; ++i)target = $e1dfb923a27ca793$var$mergeHelper(target, sources[i], pastCopies);
    }
    return target;
}
function $e1dfb923a27ca793$var$isObject(obj) {
    return obj !== null && typeof obj === 'object';
}
function $e1dfb923a27ca793$var$mergeHelper(target, source, pastCopies) {
    if ($e1dfb923a27ca793$var$isObject(source) && $e1dfb923a27ca793$var$isObject(target)) {
        if (Object.isExtensible && !Object.isExtensible(target)) target = $e1dfb923a27ca793$var$shallowCopyForMerge(target, pastCopies);
        Object.keys(source).forEach(function(sourceKey) {
            var sourceValue = source[sourceKey];
            if ($e1dfb923a27ca793$var$hasOwnProperty.call(target, sourceKey)) {
                var targetValue = target[sourceKey];
                if (sourceValue !== targetValue) target[sourceKey] = $e1dfb923a27ca793$var$mergeHelper($e1dfb923a27ca793$var$shallowCopyForMerge(targetValue, pastCopies), sourceValue, pastCopies);
            } else target[sourceKey] = sourceValue;
        });
        return target;
    }
    return source;
}
function $e1dfb923a27ca793$var$shallowCopyForMerge(value, pastCopies) {
    if (value !== null && typeof value === 'object' && pastCopies.indexOf(value) < 0) {
        if (Array.isArray(value)) value = value.slice(0);
        else value = (0, $3VFsf.__assign)({
            __proto__: Object.getPrototypeOf(value)
        }, value);
        pastCopies.push(value);
    }
    return value;
}
var $e1dfb923a27ca793$var$haveWarned = Object.create({});
function $e1dfb923a27ca793$export$49d47c8e549bfaf9(msg, type) {
    if (type === void 0) type = 'warn';
    if (!$e1dfb923a27ca793$export$f15d00aa73aafac4() && !$e1dfb923a27ca793$var$haveWarned[msg]) {
        if (!$e1dfb923a27ca793$export$410cbc2864fa25b5()) $e1dfb923a27ca793$var$haveWarned[msg] = true;
        if (type === 'error') console.error(msg);
        else console.warn(msg);
    }
}
function $e1dfb923a27ca793$export$c54efeba029d4fe8(data) {
    return JSON.parse(JSON.stringify(data));
}

});
parcelRegister("1DiV8", function(module, exports) {

$parcel$export(module.exports, "InvariantError", () => $13081c324be1f9ab$export$cea12affaee22fe8);
$parcel$export(module.exports, "invariant", () => $13081c324be1f9ab$export$f5708dca728d7177);

var $3VFsf = parcelRequire("3VFsf");

var $6cAn5 = parcelRequire("6cAn5");
var $13081c324be1f9ab$var$genericMessage = "Invariant Violation";
var $13081c324be1f9ab$var$_a = Object.setPrototypeOf, $13081c324be1f9ab$var$setPrototypeOf = $13081c324be1f9ab$var$_a === void 0 ? function(obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : $13081c324be1f9ab$var$_a;
var $13081c324be1f9ab$export$cea12affaee22fe8 = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) message = $13081c324be1f9ab$var$genericMessage;
        var _this = _super.call(this, typeof message === "number" ? $13081c324be1f9ab$var$genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
        _this.framesToPop = 1;
        _this.name = $13081c324be1f9ab$var$genericMessage;
        $13081c324be1f9ab$var$setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error);
function $13081c324be1f9ab$export$f5708dca728d7177(condition, message) {
    if (!condition) throw new $13081c324be1f9ab$export$cea12affaee22fe8(message);
}
function $13081c324be1f9ab$var$wrapConsoleMethod(method) {
    return function() {
        return console[method].apply(console, arguments);
    };
}
(function(invariant) {
    invariant.warn = $13081c324be1f9ab$var$wrapConsoleMethod("warn");
    invariant.error = $13081c324be1f9ab$var$wrapConsoleMethod("error");
})($13081c324be1f9ab$export$f5708dca728d7177 || ($13081c324be1f9ab$export$f5708dca728d7177 = {}));
// Code that uses ts-invariant with rollup-plugin-invariant may want to
// import this process stub to avoid errors evaluating process.env.NODE_ENV.
// However, because most ESM-to-CJS compilers will rewrite the process import
// as tsInvariant.process, which prevents proper replacement by minifiers, we
// also attempt to define the stub globally when it is not already defined.
var $13081c324be1f9ab$export$e54fe5b0f43758f7 = {
    env: {}
};
if (typeof $6cAn5 === "object") $13081c324be1f9ab$export$e54fe5b0f43758f7 = $6cAn5;
else try {
    // Using Function to evaluate this assignment in global scope also escapes
    // the strict mode of the current module, thereby allowing the assignment.
    // Inspired by https://github.com/facebook/regenerator/pull/369.
    Function("stub", "process = stub")($13081c324be1f9ab$export$e54fe5b0f43758f7);
} catch (atLeastWeTried) {
// The assignment can fail if a Content Security Policy heavy-handedly
// forbids Function usage. In those environments, developers should take
// extra care to replace process.env.NODE_ENV in their production builds,
// or define an appropriate global.process polyfill.
}
var $13081c324be1f9ab$var$invariant$1 = $13081c324be1f9ab$export$f5708dca728d7177;
var $13081c324be1f9ab$export$2e2bcd8739ae039 = $13081c324be1f9ab$var$invariant$1;

});

parcelRegister("fkrBp", function(module, exports) {
'use strict';
module.exports = function(data, opts) {
    if (!opts) opts = {};
    if (typeof opts === 'function') opts = {
        cmp: opts
    };
    var cycles = typeof opts.cycles === 'boolean' ? opts.cycles : false;
    var cmp = opts.cmp && function(f) {
        return function(node) {
            return function(a, b) {
                var aobj = {
                    key: a,
                    value: node[a]
                };
                var bobj = {
                    key: b,
                    value: node[b]
                };
                return f(aobj, bobj);
            };
        };
    }(opts.cmp);
    var seen = [];
    return function stringify(node) {
        if (node && node.toJSON && typeof node.toJSON === 'function') node = node.toJSON();
        if (node === undefined) return;
        if (typeof node == 'number') return isFinite(node) ? '' + node : 'null';
        if (typeof node !== 'object') return JSON.stringify(node);
        var i, out;
        if (Array.isArray(node)) {
            out = '[';
            for(i = 0; i < node.length; i++){
                if (i) out += ',';
                out += stringify(node[i]) || 'null';
            }
            return out + ']';
        }
        if (node === null) return 'null';
        if (seen.indexOf(node) !== -1) {
            if (cycles) return JSON.stringify('__cycle__');
            throw new TypeError('Converting circular structure to JSON');
        }
        var seenIndex = seen.push(node) - 1;
        var keys = Object.keys(node).sort(cmp && cmp(node));
        out = '';
        for(i = 0; i < keys.length; i++){
            var key = keys[i];
            var value = stringify(node[key]);
            if (!value) continue;
            if (out) out += ',';
            out += JSON.stringify(key) + ':' + value;
        }
        seen.splice(seenIndex, 1);
        return '{' + out + '}';
    }(data);
};

});

parcelRegister("bqMzA", function(module, exports) {

$parcel$export(module.exports, "equal", () => $8527cd05038b1b96$export$411ce8e5a71e3069);
var $8527cd05038b1b96$var$_a = Object.prototype, $8527cd05038b1b96$var$toString = $8527cd05038b1b96$var$_a.toString, $8527cd05038b1b96$var$hasOwnProperty = $8527cd05038b1b96$var$_a.hasOwnProperty;
var $8527cd05038b1b96$var$previousComparisons = new Map();
/**
 * Performs a deep equality check on two JavaScript values, tolerating cycles.
 */ function $8527cd05038b1b96$export$411ce8e5a71e3069(a, b) {
    try {
        return $8527cd05038b1b96$var$check(a, b);
    } finally{
        $8527cd05038b1b96$var$previousComparisons.clear();
    }
}
function $8527cd05038b1b96$var$check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) return true;
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    var aTag = $8527cd05038b1b96$var$toString.call(a);
    var bTag = $8527cd05038b1b96$var$toString.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) return false;
    switch(aTag){
        case '[object Array]':
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length) return false;
        // Fall through to object case...
        case '[object Object]':
            if ($8527cd05038b1b96$var$previouslyCompared(a, b)) return true;
            var aKeys = Object.keys(a);
            var bKeys = Object.keys(b);
            // If `a` and `b` have a different number of enumerable keys, they
            // must be different.
            var keyCount = aKeys.length;
            if (keyCount !== bKeys.length) return false;
            // Now make sure they have the same keys.
            for(var k = 0; k < keyCount; ++k){
                if (!$8527cd05038b1b96$var$hasOwnProperty.call(b, aKeys[k])) return false;
            }
            // Finally, check deep equality of all child properties.
            for(var k = 0; k < keyCount; ++k){
                var key = aKeys[k];
                if (!$8527cd05038b1b96$var$check(a[key], b[key])) return false;
            }
            return true;
        case '[object Error]':
            return a.name === b.name && a.message === b.message;
        case '[object Number]':
            // Handle NaN, which is !== itself.
            if (a !== a) return b !== b;
        // Fall through to shared +a === +b case...
        case '[object Boolean]':
        case '[object Date]':
            return +a === +b;
        case '[object RegExp]':
        case '[object String]':
            return a == "" + b;
        case '[object Map]':
        case '[object Set]':
            if (a.size !== b.size) return false;
            if ($8527cd05038b1b96$var$previouslyCompared(a, b)) return true;
            var aIterator = a.entries();
            var isMap = aTag === '[object Map]';
            while(true){
                var info = aIterator.next();
                if (info.done) break;
                // If a instanceof Set, aValue === aKey.
                var _a = info.value, aKey = _a[0], aValue = _a[1];
                // So this works the same way for both Set and Map.
                if (!b.has(aKey)) return false;
                // However, we care about deep equality of values only when dealing
                // with Map structures.
                if (isMap && !$8527cd05038b1b96$var$check(aValue, b.get(aKey))) return false;
            }
            return true;
    }
    // Otherwise the values are not equal.
    return false;
}
function $8527cd05038b1b96$var$previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    var bSet = $8527cd05038b1b96$var$previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b)) return true;
    } else $8527cd05038b1b96$var$previousComparisons.set(a, bSet = new Set);
    bSet.add(b);
    return false;
}
var $8527cd05038b1b96$export$2e2bcd8739ae039 = $8527cd05038b1b96$export$411ce8e5a71e3069;

});


parcelRegister("clSzL", function(module, exports) {

$parcel$export(module.exports, "fromError", () => fromError);
$parcel$export(module.exports, "ApolloLink", () => ApolloLink);
$parcel$export(module.exports, "from", () => from);
$parcel$export(module.exports, "execute", () => execute);
$parcel$export(module.exports, "Observable", () => (parcelRequire("aS6b9")).default);

var $aS6b9 = parcelRequire("aS6b9");

var $1DiV8 = parcelRequire("1DiV8");

var $3VFsf = parcelRequire("3VFsf");

var $jojW6 = parcelRequire("jojW6");
function validateOperation(operation) {
    var OPERATION_FIELDS = [
        'query',
        'operationName',
        'variables',
        'extensions',
        'context'
    ];
    for(var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++){
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) throw new (0, $1DiV8.InvariantError)(2);
    }
    return operation;
}
var LinkError = function(_super) {
    (0, $3VFsf.__extends)(LinkError, _super);
    function LinkError(message, link) {
        var _this = _super.call(this, message) || this;
        _this.link = link;
        return _this;
    }
    return LinkError;
}(Error);
function isTerminating(link) {
    return link.request.length <= 1;
}
function toPromise(observable) {
    var completed = false;
    return new Promise(function(resolve, reject) {
        observable.subscribe({
            next: function(data) {
                if (completed) ;
                else {
                    completed = true;
                    resolve(data);
                }
            },
            error: reject
        });
    });
}
var makePromise = toPromise;
function fromPromise(promise) {
    return new (0, $aS6b9.default)(function(observer) {
        promise.then(function(value) {
            observer.next(value);
            observer.complete();
        }).catch(observer.error.bind(observer));
    });
}
function fromError(errorValue) {
    return new (0, $aS6b9.default)(function(observer) {
        observer.error(errorValue);
    });
}
function transformOperation(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query
    };
    if (!transformedOperation.operationName) transformedOperation.operationName = typeof transformedOperation.query !== 'string' ? (0, $jojW6.getOperationName)(transformedOperation.query) : '';
    return transformedOperation;
}
function createOperation(starting, operation) {
    var context = (0, $3VFsf.__assign)({}, starting);
    var setContext = function(next) {
        if (typeof next === 'function') context = (0, $3VFsf.__assign)({}, context, next(context));
        else context = (0, $3VFsf.__assign)({}, context, next);
    };
    var getContext = function() {
        return (0, $3VFsf.__assign)({}, context);
    };
    Object.defineProperty(operation, 'setContext', {
        enumerable: false,
        value: setContext
    });
    Object.defineProperty(operation, 'getContext', {
        enumerable: false,
        value: getContext
    });
    Object.defineProperty(operation, 'toKey', {
        enumerable: false,
        value: function() {
            return getKey(operation);
        }
    });
    return operation;
}
function getKey(operation) {
    var query = operation.query, variables = operation.variables, operationName = operation.operationName;
    return JSON.stringify([
        operationName,
        query,
        variables
    ]);
}
function passthrough(op, forward) {
    return forward ? forward(op) : (0, $aS6b9.default).of();
}
function toLink(handler) {
    return typeof handler === 'function' ? new ApolloLink(handler) : handler;
}
function empty() {
    return new ApolloLink(function() {
        return (0, $aS6b9.default).of();
    });
}
function from(links) {
    if (links.length === 0) return empty();
    return links.map(toLink).reduce(function(x, y) {
        return x.concat(y);
    });
}
function split(test, left, right) {
    var leftLink = toLink(left);
    var rightLink = toLink(right || new ApolloLink(passthrough));
    if (isTerminating(leftLink) && isTerminating(rightLink)) return new ApolloLink(function(operation) {
        return test(operation) ? leftLink.request(operation) || (0, $aS6b9.default).of() : rightLink.request(operation) || (0, $aS6b9.default).of();
    });
    else return new ApolloLink(function(operation, forward) {
        return test(operation) ? leftLink.request(operation, forward) || (0, $aS6b9.default).of() : rightLink.request(operation, forward) || (0, $aS6b9.default).of();
    });
}
var concat = function(first, second) {
    var firstLink = toLink(first);
    if (isTerminating(firstLink)) return firstLink;
    var nextLink = toLink(second);
    if (isTerminating(nextLink)) return new ApolloLink(function(operation) {
        return firstLink.request(operation, function(op) {
            return nextLink.request(op) || (0, $aS6b9.default).of();
        }) || (0, $aS6b9.default).of();
    });
    else return new ApolloLink(function(operation, forward) {
        return firstLink.request(operation, function(op) {
            return nextLink.request(op, forward) || (0, $aS6b9.default).of();
        }) || (0, $aS6b9.default).of();
    });
};
var ApolloLink = function() {
    function ApolloLink(request) {
        if (request) this.request = request;
    }
    ApolloLink.prototype.split = function(test, left, right) {
        return this.concat(split(test, left, right || new ApolloLink(passthrough)));
    };
    ApolloLink.prototype.concat = function(next) {
        return concat(this, next);
    };
    ApolloLink.prototype.request = function(operation, forward) {
        throw new (0, $1DiV8.InvariantError)(1);
    };
    ApolloLink.empty = empty;
    ApolloLink.from = from;
    ApolloLink.split = split;
    ApolloLink.execute = execute;
    return ApolloLink;
}();
function execute(link, operation) {
    return link.request(createOperation(operation.context, transformOperation(validateOperation(operation)))) || (0, $aS6b9.default).of();
}

});
parcelRegister("aS6b9", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ea3bd7f736c1eb4$export$2e2bcd8739ae039);

var $4osjv = parcelRequire("4osjv");
var $7ea3bd7f736c1eb4$export$77cea355fa80b5f4 = (0, (/*@__PURE__*/$parcel$interopDefault($4osjv)));
var $7ea3bd7f736c1eb4$export$2e2bcd8739ae039 = $7ea3bd7f736c1eb4$export$77cea355fa80b5f4;

});
parcelRegister("4osjv", function(module, exports) {

module.exports = (parcelRequire("k0hXK")).Observable;

});
parcelRegister("k0hXK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Observable = void 0;
function $e901bdc1c9a5edd7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e901bdc1c9a5edd7$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $e901bdc1c9a5edd7$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $e901bdc1c9a5edd7$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $e901bdc1c9a5edd7$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
// === Symbol Support ===
var $e901bdc1c9a5edd7$var$hasSymbols = function() {
    return typeof Symbol === 'function';
};
var $e901bdc1c9a5edd7$var$hasSymbol = function(name) {
    return $e901bdc1c9a5edd7$var$hasSymbols() && Boolean(Symbol[name]);
};
var $e901bdc1c9a5edd7$var$getSymbol = function(name) {
    return $e901bdc1c9a5edd7$var$hasSymbol(name) ? Symbol[name] : '@@' + name;
};
if ($e901bdc1c9a5edd7$var$hasSymbols() && !$e901bdc1c9a5edd7$var$hasSymbol('observable')) Symbol.observable = Symbol('observable');
var $e901bdc1c9a5edd7$var$SymbolIterator = $e901bdc1c9a5edd7$var$getSymbol('iterator');
var $e901bdc1c9a5edd7$var$SymbolObservable = $e901bdc1c9a5edd7$var$getSymbol('observable');
var $e901bdc1c9a5edd7$var$SymbolSpecies = $e901bdc1c9a5edd7$var$getSymbol('species'); // === Abstract Operations ===
function $e901bdc1c9a5edd7$var$getMethod(obj, key) {
    var value = obj[key];
    if (value == null) return undefined;
    if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
    return value;
}
function $e901bdc1c9a5edd7$var$getSpecies(obj) {
    var ctor = obj.constructor;
    if (ctor !== undefined) {
        ctor = ctor[$e901bdc1c9a5edd7$var$SymbolSpecies];
        if (ctor === null) ctor = undefined;
    }
    return ctor !== undefined ? ctor : $e901bdc1c9a5edd7$var$Observable;
}
function $e901bdc1c9a5edd7$var$isObservable(x) {
    return x instanceof $e901bdc1c9a5edd7$var$Observable; // SPEC: Brand check
}
function $e901bdc1c9a5edd7$var$hostReportError(e) {
    if ($e901bdc1c9a5edd7$var$hostReportError.log) $e901bdc1c9a5edd7$var$hostReportError.log(e);
    else setTimeout(function() {
        throw e;
    });
}
function $e901bdc1c9a5edd7$var$enqueue(fn) {
    Promise.resolve().then(function() {
        try {
            fn();
        } catch (e) {
            $e901bdc1c9a5edd7$var$hostReportError(e);
        }
    });
}
function $e901bdc1c9a5edd7$var$cleanupSubscription(subscription) {
    var cleanup = subscription._cleanup;
    if (cleanup === undefined) return;
    subscription._cleanup = undefined;
    if (!cleanup) return;
    try {
        if (typeof cleanup === 'function') cleanup();
        else {
            var unsubscribe = $e901bdc1c9a5edd7$var$getMethod(cleanup, 'unsubscribe');
            if (unsubscribe) unsubscribe.call(cleanup);
        }
    } catch (e) {
        $e901bdc1c9a5edd7$var$hostReportError(e);
    }
}
function $e901bdc1c9a5edd7$var$closeSubscription(subscription) {
    subscription._observer = undefined;
    subscription._queue = undefined;
    subscription._state = 'closed';
}
function $e901bdc1c9a5edd7$var$flushSubscription(subscription) {
    var queue = subscription._queue;
    if (!queue) return;
    subscription._queue = undefined;
    subscription._state = 'ready';
    for(var i = 0; i < queue.length; ++i){
        $e901bdc1c9a5edd7$var$notifySubscription(subscription, queue[i].type, queue[i].value);
        if (subscription._state === 'closed') break;
    }
}
function $e901bdc1c9a5edd7$var$notifySubscription(subscription, type, value) {
    subscription._state = 'running';
    var observer = subscription._observer;
    try {
        var m = $e901bdc1c9a5edd7$var$getMethod(observer, type);
        switch(type){
            case 'next':
                if (m) m.call(observer, value);
                break;
            case 'error':
                $e901bdc1c9a5edd7$var$closeSubscription(subscription);
                if (m) m.call(observer, value);
                else throw value;
                break;
            case 'complete':
                $e901bdc1c9a5edd7$var$closeSubscription(subscription);
                if (m) m.call(observer);
                break;
        }
    } catch (e) {
        $e901bdc1c9a5edd7$var$hostReportError(e);
    }
    if (subscription._state === 'closed') $e901bdc1c9a5edd7$var$cleanupSubscription(subscription);
    else if (subscription._state === 'running') subscription._state = 'ready';
}
function $e901bdc1c9a5edd7$var$onNotify(subscription, type, value) {
    if (subscription._state === 'closed') return;
    if (subscription._state === 'buffering') {
        subscription._queue.push({
            type: type,
            value: value
        });
        return;
    }
    if (subscription._state !== 'ready') {
        subscription._state = 'buffering';
        subscription._queue = [
            {
                type: type,
                value: value
            }
        ];
        $e901bdc1c9a5edd7$var$enqueue(function() {
            return $e901bdc1c9a5edd7$var$flushSubscription(subscription);
        });
        return;
    }
    $e901bdc1c9a5edd7$var$notifySubscription(subscription, type, value);
}
var $e901bdc1c9a5edd7$var$Subscription = /*#__PURE__*/ function() {
    function Subscription(observer, subscriber) {
        $e901bdc1c9a5edd7$var$_classCallCheck(this, Subscription);
        // ASSERT: observer is an object
        // ASSERT: subscriber is callable
        this._cleanup = undefined;
        this._observer = observer;
        this._queue = undefined;
        this._state = 'initializing';
        var subscriptionObserver = new $e901bdc1c9a5edd7$var$SubscriptionObserver(this);
        try {
            this._cleanup = subscriber.call(undefined, subscriptionObserver);
        } catch (e) {
            subscriptionObserver.error(e);
        }
        if (this._state === 'initializing') this._state = 'ready';
    }
    $e901bdc1c9a5edd7$var$_createClass(Subscription, [
        {
            key: "unsubscribe",
            value: function unsubscribe() {
                if (this._state !== 'closed') {
                    $e901bdc1c9a5edd7$var$closeSubscription(this);
                    $e901bdc1c9a5edd7$var$cleanupSubscription(this);
                }
            }
        },
        {
            key: "closed",
            get: function() {
                return this._state === 'closed';
            }
        }
    ]);
    return Subscription;
}();
var $e901bdc1c9a5edd7$var$SubscriptionObserver = /*#__PURE__*/ function() {
    function SubscriptionObserver(subscription) {
        $e901bdc1c9a5edd7$var$_classCallCheck(this, SubscriptionObserver);
        this._subscription = subscription;
    }
    $e901bdc1c9a5edd7$var$_createClass(SubscriptionObserver, [
        {
            key: "next",
            value: function next(value) {
                $e901bdc1c9a5edd7$var$onNotify(this._subscription, 'next', value);
            }
        },
        {
            key: "error",
            value: function error(value) {
                $e901bdc1c9a5edd7$var$onNotify(this._subscription, 'error', value);
            }
        },
        {
            key: "complete",
            value: function complete() {
                $e901bdc1c9a5edd7$var$onNotify(this._subscription, 'complete');
            }
        },
        {
            key: "closed",
            get: function() {
                return this._subscription._state === 'closed';
            }
        }
    ]);
    return SubscriptionObserver;
}();
var $e901bdc1c9a5edd7$var$Observable = /*#__PURE__*/ function() {
    function Observable(subscriber) {
        $e901bdc1c9a5edd7$var$_classCallCheck(this, Observable);
        if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');
        if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
        this._subscriber = subscriber;
    }
    $e901bdc1c9a5edd7$var$_createClass(Observable, [
        {
            key: "subscribe",
            value: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) observer = {
                    next: observer,
                    error: arguments[1],
                    complete: arguments[2]
                };
                return new $e901bdc1c9a5edd7$var$Subscription(observer, this._subscriber);
            }
        },
        {
            key: "forEach",
            value: function forEach(fn) {
                var _this = this;
                return new Promise(function(resolve, reject) {
                    if (typeof fn !== 'function') {
                        reject(new TypeError(fn + ' is not a function'));
                        return;
                    }
                    function done() {
                        subscription.unsubscribe();
                        resolve();
                    }
                    var subscription = _this.subscribe({
                        next: function(value) {
                            try {
                                fn(value, done);
                            } catch (e) {
                                reject(e);
                                subscription.unsubscribe();
                            }
                        },
                        error: reject,
                        complete: resolve
                    });
                });
            }
        },
        {
            key: "map",
            value: function map(fn) {
                var _this2 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $e901bdc1c9a5edd7$var$getSpecies(this);
                return new C(function(observer) {
                    return _this2.subscribe({
                        next: function(value) {
                            try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "filter",
            value: function filter(fn) {
                var _this3 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $e901bdc1c9a5edd7$var$getSpecies(this);
                return new C(function(observer) {
                    return _this3.subscribe({
                        next: function(value) {
                            try {
                                if (!fn(value)) return;
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "reduce",
            value: function reduce(fn) {
                var _this4 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $e901bdc1c9a5edd7$var$getSpecies(this);
                var hasSeed = arguments.length > 1;
                var hasValue = false;
                var seed = arguments[1];
                var acc = seed;
                return new C(function(observer) {
                    return _this4.subscribe({
                        next: function(value) {
                            var first = !hasValue;
                            hasValue = true;
                            if (!first || hasSeed) try {
                                acc = fn(acc, value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            else acc = value;
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
                            observer.next(acc);
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "concat",
            value: function concat() {
                var _this5 = this;
                for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
                var C = $e901bdc1c9a5edd7$var$getSpecies(this);
                return new C(function(observer) {
                    var subscription;
                    var index = 0;
                    function startNext(next) {
                        subscription = next.subscribe({
                            next: function(v) {
                                observer.next(v);
                            },
                            error: function(e) {
                                observer.error(e);
                            },
                            complete: function() {
                                if (index === sources.length) {
                                    subscription = undefined;
                                    observer.complete();
                                } else startNext(C.from(sources[index++]));
                            }
                        });
                    }
                    startNext(_this5);
                    return function() {
                        if (subscription) {
                            subscription.unsubscribe();
                            subscription = undefined;
                        }
                    };
                });
            }
        },
        {
            key: "flatMap",
            value: function flatMap(fn) {
                var _this6 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $e901bdc1c9a5edd7$var$getSpecies(this);
                return new C(function(observer) {
                    var subscriptions = [];
                    var outer = _this6.subscribe({
                        next: function(value) {
                            if (fn) try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            var inner = C.from(value).subscribe({
                                next: function(value) {
                                    observer.next(value);
                                },
                                error: function(e) {
                                    observer.error(e);
                                },
                                complete: function() {
                                    var i = subscriptions.indexOf(inner);
                                    if (i >= 0) subscriptions.splice(i, 1);
                                    completeIfDone();
                                }
                            });
                            subscriptions.push(inner);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            completeIfDone();
                        }
                    });
                    function completeIfDone() {
                        if (outer.closed && subscriptions.length === 0) observer.complete();
                    }
                    return function() {
                        subscriptions.forEach(function(s) {
                            return s.unsubscribe();
                        });
                        outer.unsubscribe();
                    };
                });
            }
        },
        {
            key: $e901bdc1c9a5edd7$var$SymbolObservable,
            value: function() {
                return this;
            }
        }
    ], [
        {
            key: "from",
            value: function from(x) {
                var C = typeof this === 'function' ? this : Observable;
                if (x == null) throw new TypeError(x + ' is not an object');
                var method = $e901bdc1c9a5edd7$var$getMethod(x, $e901bdc1c9a5edd7$var$SymbolObservable);
                if (method) {
                    var observable = method.call(x);
                    if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
                    if ($e901bdc1c9a5edd7$var$isObservable(observable) && observable.constructor === C) return observable;
                    return new C(function(observer) {
                        return observable.subscribe(observer);
                    });
                }
                if ($e901bdc1c9a5edd7$var$hasSymbol('iterator')) {
                    method = $e901bdc1c9a5edd7$var$getMethod(x, $e901bdc1c9a5edd7$var$SymbolIterator);
                    if (method) return new C(function(observer) {
                        $e901bdc1c9a5edd7$var$enqueue(function() {
                            if (observer.closed) return;
                            var _iteratorNormalCompletion = true;
                            var _didIteratorError = false;
                            var _iteratorError = undefined;
                            try {
                                for(var _iterator = method.call(x)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _item = _step.value;
                                    observer.next(_item);
                                    if (observer.closed) return;
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) _iterator.return();
                                } finally{
                                    if (_didIteratorError) throw _iteratorError;
                                }
                            }
                            observer.complete();
                        });
                    });
                }
                if (Array.isArray(x)) return new C(function(observer) {
                    $e901bdc1c9a5edd7$var$enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < x.length; ++i){
                            observer.next(x[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
                throw new TypeError(x + ' is not observable');
            }
        },
        {
            key: "of",
            value: function of() {
                for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
                var C = typeof this === 'function' ? this : Observable;
                return new C(function(observer) {
                    $e901bdc1c9a5edd7$var$enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < items.length; ++i){
                            observer.next(items[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
            }
        },
        {
            key: $e901bdc1c9a5edd7$var$SymbolSpecies,
            get: function() {
                return this;
            }
        }
    ]);
    return Observable;
}();
module.exports.Observable = $e901bdc1c9a5edd7$var$Observable;
if ($e901bdc1c9a5edd7$var$hasSymbols()) Object.defineProperty($e901bdc1c9a5edd7$var$Observable, Symbol('extensions'), {
    value: {
        symbol: $e901bdc1c9a5edd7$var$SymbolObservable,
        hostReportError: $e901bdc1c9a5edd7$var$hostReportError
    },
    configurable: true
});

});





parcelRegister("hJCUd", function(module, exports) {

var $hlchF = parcelRequire("hlchF");

var $g7i7g = parcelRequire("g7i7g");

var $3KORh = parcelRequire("3KORh");

var $3dHKF = parcelRequire("3dHKF");
/**
 * This method is like `_.defaults` except that it recursively assigns
 * default properties.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaults
 * @example
 *
 * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
 * // => { 'a': { 'b': 2, 'c': 3 } }
 */ var $ce94d17a4ae582d5$var$defaultsDeep = $g7i7g(function(args) {
    args.push(undefined, $3KORh);
    return $hlchF($3dHKF, undefined, args);
});
module.exports = $ce94d17a4ae582d5$var$defaultsDeep;

});
parcelRegister("3KORh", function(module, exports) {

var $1m1GH = parcelRequire("1m1GH");

var $k0qYG = parcelRequire("k0qYG");
/**
 * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
 * objects into destination objects that are passed thru.
 *
 * @private
 * @param {*} objValue The destination value.
 * @param {*} srcValue The source value.
 * @param {string} key The key of the property to merge.
 * @param {Object} object The parent object of `objValue`.
 * @param {Object} source The parent object of `srcValue`.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 * @returns {*} Returns the value to assign.
 */ function $2bbd1e633373e9a1$var$customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
    if ($k0qYG(objValue) && $k0qYG(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        $1m1GH(objValue, srcValue, undefined, $2bbd1e633373e9a1$var$customDefaultsMerge, stack);
        stack['delete'](srcValue);
    }
    return objValue;
}
module.exports = $2bbd1e633373e9a1$var$customDefaultsMerge;

});

parcelRegister("3dHKF", function(module, exports) {

var $1m1GH = parcelRequire("1m1GH");

var $9MM2g = parcelRequire("9MM2g");
/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */ var $2584862af7fb4983$var$mergeWith = $9MM2g(function(object, source, srcIndex, customizer) {
    $1m1GH(object, source, srcIndex, customizer);
});
module.exports = $2584862af7fb4983$var$mergeWith;

});


parcelRegister("bPysz", function(module, exports) {

$parcel$export(module.exports, "ProductSearchInputSkeleton", () => $f7d66de1ed5c4c15$export$91fb362ea940bd8b);
/*
 * Minimalistic version of the search dialog, that provides a ready-only view
 * to be used as a loading component in async components and SSR.
 */ 
var $2OMIu = parcelRequire("2OMIu");

var $cFUJK = parcelRequire("cFUJK");
var $2AbEM = parcelRequire("2AbEM");
parcelRequire("5uXOq");
const $f7d66de1ed5c4c15$export$91fb362ea940bd8b = ({ theme: theme, ...rest })=>{
    if (theme) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2AbEM.ThemeProvider), {
        partialSearchCSS: theme,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cFUJK.default), {
            ...rest
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cFUJK.default), {
        ...rest
    });
};

});
parcelRegister("cFUJK", function(module, exports) {

$parcel$export(module.exports, "default", () => $de03a6aae28371f7$export$2e2bcd8739ae039);
/*
 * Skeleton consumed by product-search-dialog only,
 * check the comments in packages/product-search-dialog/src/common/product-search-input/product-search-input-skeleton.tsx.
 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $2AbEM = parcelRequire("2AbEM");

var $b9NEf = parcelRequire("b9NEf");

var $hLeR9 = parcelRequire("hLeR9");

var $6I8Kl = parcelRequire("6I8Kl");

var $42CjB = parcelRequire("42CjB");

var $j1SOM = parcelRequire("j1SOM");

var $8I7W7 = parcelRequire("8I7W7");
const $de03a6aae28371f7$var$MAX_INPUT_LENGTH = 500;
const $de03a6aae28371f7$export$9b2f977cfc67f251 = (props)=>{
    const theme = (0, $2AbEM.useTheme)();
    const { forwardRef: forwardRef, features: features, shouldFillContainer: shouldFillContainer, placeholder: nonFeaturesPlaceholder, ariaLabel: ariaLabel, dataSsrPlaceholder: dataSsrPlaceholder } = props;
    const { enabled: enabled, advancedSearchUrl: advancedSearchUrl, placeholder: placeholder, customScriptDataAttributes: customScriptDataAttributes } = features?.interactiveSkeleton || {};
    if (enabled || (0, $j1SOM.getInputSkeletonFocus)()) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8I7W7.SSRsearchInput), {
        shouldFillContainer: shouldFillContainer,
        advancedSearchUrl: advancedSearchUrl,
        placeholder: placeholder || nonFeaturesPlaceholder,
        customScriptDataAttributes: customScriptDataAttributes,
        theme: theme
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hLeR9.SearchAnchorWrapper), {
        shouldFillContainer: shouldFillContainer,
        "data-ssr-placeholder": dataSsrPlaceholder,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $b9NEf.SearchInputContainer), {
            ...theme,
            shouldFillContainer: shouldFillContainer,
            isExpanded: false,
            role: "search",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b9NEf.MobileSearchIconWrapper), {
                    isExpanded: false,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                        label: "Search",
                        icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $6I8Kl.SearchIcon), {
                                theme: theme,
                                isExpanded: false,
                                size: "medium"
                            })
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b9NEf.DesktopSearchIconWrapper), {
                    ...theme,
                    isExpanded: false,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6I8Kl.SearchIcon), {
                        theme: theme,
                        isExpanded: false
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b9NEf.SearchInputField), {
                    "data-test-id": "search-dialog-search-skeleton",
                    isExpanded: false,
                    placeholder: nonFeaturesPlaceholder || placeholder,
                    ref: forwardRef || undefined,
                    disabled: true,
                    value: "",
                    maxLength: $de03a6aae28371f7$var$MAX_INPUT_LENGTH,
                    onChange: ()=>{},
                    "aria-label": ariaLabel || nonFeaturesPlaceholder || placeholder,
                    ...theme
                })
            ]
        })
    });
};
var $de03a6aae28371f7$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>/*#__PURE__*/ (0, $2OMIu.jsx)($de03a6aae28371f7$export$9b2f977cfc67f251, {
        ...props,
        forwardRef: ref
    }));

});
parcelRegister("2AbEM", function(module, exports) {

$parcel$export(module.exports, "ThemeProvider", () => $7a9ddac47e3fba86$export$d8964aec282183a3);
$parcel$export(module.exports, "useTheme", () => $7a9ddac47e3fba86$export$93d4e7f90805808f);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $1UikQ = parcelRequire("1UikQ");

/**
 * Pls see the function generateTheme inside - atlassian-frontend/packages/navigation/atlassian-navigation/src/theme/themeGenerator.ts
 * This default generator should overwrite the exact same properties which are being produced by the theme generator.
 */ const $7a9ddac47e3fba86$export$e6c62eb05a8288ed = {
    default: {
        default: {
            backgroundColor: `var(--ds-background-input, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
            color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`,
            borderColor: `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
            borderWidth: "var(--ds-border-width, 1px)",
            iconColor: `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$export$7090862dc3038a9f)})`
        },
        focus: {
            borderColor: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`,
            backgroundColor: `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`}`
        },
        hover: {
            backgroundColor: "var(--ds-background-input-hovered, rgba(222, 235, 255, 0.9))"
        }
    }
};
const $7a9ddac47e3fba86$var$getTheme = (searchCSS)=>{
    if (!searchCSS) return $7a9ddac47e3fba86$export$e6c62eb05a8288ed.default;
    return (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, $7a9ddac47e3fba86$export$e6c62eb05a8288ed.default, searchCSS);
};
const $7a9ddac47e3fba86$var$ctx = /*#__PURE__*/ (0, $5uXOq.createContext)($7a9ddac47e3fba86$export$e6c62eb05a8288ed.default);
const $7a9ddac47e3fba86$export$d8964aec282183a3 = ({ value: value, partialSearchCSS: partialSearchCSS, children: children })=>{
    const theme = $7a9ddac47e3fba86$var$getTheme(partialSearchCSS || value);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($7a9ddac47e3fba86$var$ctx.Provider, {
        value: theme,
        children: children
    });
};
const $7a9ddac47e3fba86$export$93d4e7f90805808f = ()=>{
    return (0, $5uXOq.useContext)($7a9ddac47e3fba86$var$ctx);
};
// todo - deprecate (requires product update)
// eslint-disable-next-line
const $7a9ddac47e3fba86$export$f9bb738f552c610d = $7a9ddac47e3fba86$var$ctx;
// todo - deprecate (requires product update)
// eslint-disable-next-line
const $7a9ddac47e3fba86$export$62640b580a501775 = (suppliedTheme)=>{
    return suppliedTheme;
};

});

parcelRegister("b9NEf", function(module, exports) {

$parcel$export(module.exports, "MobileSearchIconWrapper", () => $978931f79bc05084$export$63e083aca343a6ae);
$parcel$export(module.exports, "DesktopSearchIconWrapper", () => $978931f79bc05084$export$9673cb6b61244e6e);
$parcel$export(module.exports, "InputBoxOverlayRight", () => $978931f79bc05084$export$1da38d078e896a10);
$parcel$export(module.exports, "ClearIconWrapper", () => $978931f79bc05084$export$ff9b1a25d343474d);
$parcel$export(module.exports, "ArrowIconWrapper", () => $978931f79bc05084$export$54c466678ae7c638);
$parcel$export(module.exports, "SearchInputContainer", () => $978931f79bc05084$export$c2b37b18a8b54130);
$parcel$export(module.exports, "SearchInputField", () => $978931f79bc05084$export$b6261a2c5ea449d);
$parcel$export(module.exports, "HiddenTooltip", () => $978931f79bc05084$export$ca6fe3402791d08e);
$parcel$export(module.exports, "SSRsearchInputField", () => $978931f79bc05084$export$6d53dccb772ed720);
$parcel$export(module.exports, "SSRsearchInputWrapper", () => $978931f79bc05084$export$c47d4a3e1f1297f1);
$parcel$export(module.exports, "SSRformContainer", () => $978931f79bc05084$export$58ae19ee1fc7be8a);
$parcel$export(module.exports, "SSRsearchInputContainer", () => $978931f79bc05084$export$b40f2abde293e8e4);
$parcel$export(module.exports, "SSRdesktopSearchIconWrapper", () => $978931f79bc05084$export$eb4e9f55bbe045df);
$parcel$export(module.exports, "SSRmobileSearchIconWrapper", () => $978931f79bc05084$export$3f33ed4b273b43d);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $btzsC = parcelRequire("btzsC");

var $3JZ8k = parcelRequire("3JZ8k");


var $h9kUS = parcelRequire("h9kUS");

var $VSDnB = parcelRequire("VSDnB");

var $gJ29f = parcelRequire("gJ29f");

var $bWGt6 = parcelRequire("bWGt6");
function $978931f79bc05084$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $978931f79bc05084$var$expandedPlaceholderColor = "var(--ds-text-subtlest, #B5BEC9)";
const $978931f79bc05084$export$63e083aca343a6ae = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "eq4kchp14"
})("display:none;@media screen and (max-width: ", (0, $3JZ8k.dialogPageTakeoverWidth), "px){display:", (props)=>props.isExpanded ? 'none' : 'block', ";}");
const $978931f79bc05084$export$9673cb6b61244e6e = /*#__PURE__*/ (0, $bWGt6.default)('span', {
    target: "eq4kchp13"
})("width:", (0, $3JZ8k.grid).multiple(2).px, ";height:", (0, $3JZ8k.grid).multiple(2).px, ";position:absolute;top:", (0, $3JZ8k.grid).px, ";left:", (0, $3JZ8k.grid).px, ";color:", (props)=>props.isExpanded ? `var(--ds-text, ${0, $829f609a65d26a98$export$fbda843f0a27fe96})` : props.default.color, ";display:inline-flex;align-items:baseline;:focus{box-shadow:0 0 0 2px ", `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`, ";border-radius:100%;outline:none;}&>span[role='img']{line-height:0;}@media screen and (max-width: ", (0, $3JZ8k.dialogPageTakeoverWidth), "px){display:none;}");
const $978931f79bc05084$export$1da38d078e896a10 = /*#__PURE__*/ (0, $bWGt6.default)('div', {
    target: "eq4kchp12"
})("position:absolute;display:flex;top:0;right:0;height:100%;align-items:center;margin:auto 0;@media screen and (max-width: ", (0, $3JZ8k.dialogPageTakeoverWidth), "px){right:24px;}");
const $978931f79bc05084$export$ff9b1a25d343474d = /*#__PURE__*/ (0, $bWGt6.default)('div', {
    target: "eq4kchp11"
})("width:", (0, $3JZ8k.grid).multiple(2).px, ";height:", (0, $3JZ8k.grid).multiple(2).px, ";padding:5px var(--ds-space-075, 6px);color:", `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)})`, ";background-color:transparent;@media screen and (max-width: ", (0, $3JZ8k.dialogPageTakeoverWidth), "px){display:none;}:hover{cursor:pointer;color:", `var(--ds-icon, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`, ";}&>span>svg{vertical-align:unset;}");
const $978931f79bc05084$export$54c466678ae7c638 = /*#__PURE__*/ (0, $bWGt6.default)('div', {
    target: "eq4kchp10"
})("display:none;margin:0 ", (0, $3JZ8k.grid).px, ";height:", (0, $3JZ8k.grid).multiple(4).px, ";padding-bottom:", (0, $3JZ8k.grid).multiple(0.25).px, ";color:", (props)=>props.default.color, ";@media screen and (max-width: ", (0, $3JZ8k.dialogPageTakeoverWidth), "px){display:flex;align-items:center;}:hover{border-radius:100%;background-color:", (props)=>props.hover.backgroundColor, ";color:", (props)=>props.hover.color, ";}");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
var $978931f79bc05084$var$_ref = {
    name: "1d3w5wq",
    styles: "width:100%"
};
const $978931f79bc05084$export$c2b37b18a8b54130 = /*#__PURE__*/ (0, $bWGt6.default)('div', {
    target: "eq4kchp9"
})(/*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
(0, $f8Sb3.css)("position:relative;max-width:100%; @media screen and (max-width: ", (0, $3JZ8k.dialogPageTakeoverWidth), "px){ width:100%;}"), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>{
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    const boundedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        width: props.isExpanded ? (0, $3JZ8k.dialogWidth) : (0, $3JZ8k.collapsedSearchInputWidth)
    });
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    const fluidStyles = $978931f79bc05084$var$_ref;
    const styles = props.shouldFillContainer ? fluidStyles : boundedStyles;
    // todo - this should be another class
    if (props.isExpanded) // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $f8Sb3.css)(styles, " @media screen and (max-width: ", (0, $3JZ8k.dialogPageTakeoverWidth), "px){width:100%;height:", (0, $3JZ8k.atlassianNavigationHeight), ";background-color:", props.default.backgroundColor, "; display:flex;align-items:center;max-width:initial;}");
    return styles;
});
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $978931f79bc05084$var$SearchInputFieldOld = /*#__PURE__*/ (0, $bWGt6.default)("input", {
    target: "eq4kchp8"
})("height:", (0, $3JZ8k.inputFieldHeight).px, ";width:100%;padding:0px var(--ds-space-150, 12px) 0px 30px;box-sizing:border-box;outline:none;border-radius:5px;font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);", (props)=>`
    border: ${"var(--ds-border-width, 1px)"} solid ${props.isExpanded ? props.focus.borderColor : props.default.borderColor};
    box-shadow: ${props.isExpanded ? `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${props.focus.borderColor}, -12px 0 24px 0 ${props.default.backgroundColor}` : 'none'};
    background-color: ${props.isExpanded ? props.focus.backgroundColor : props.default.backgroundColor};
    color: ${props.isExpanded ? props.focus.color : props.default.color};

    &::placeholder {
      color: ${props.isExpanded ? $978931f79bc05084$var$expandedPlaceholderColor : props.default.color};
    }
    :focus {
      border: ${"var(--ds-border-width, 1px)"} solid ${props.focus.borderColor};
    }
    @media screen and (max-width: ${0, $3JZ8k.dialogPageTakeoverWidth}px) {
      ${props.isExpanded ? `
            padding: 0 ${(0, $3JZ8k.grid).multiple(1.5).px} ${(0, $3JZ8k.grid).multiple(0.25).px};
            margin: 0 ${(0, $3JZ8k.grid).multiple(3).px} 0 0;` : `
            display: none;
          `}
    }
  `, ";");
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $978931f79bc05084$var$SearchInputFieldWithMobileFix = /*#__PURE__*/ (0, $bWGt6.default)("input", {
    target: "eq4kchp7"
})("height:", (0, $3JZ8k.inputFieldHeight).px, ";width:100%;padding:0px var(--ds-space-150, 12px) 0px 30px;box-sizing:border-box;outline:none;border-radius:5px;/* Refer to @atlaskit/textfield for more details */font:var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);", (props)=>`
    border: ${"var(--ds-border-width, 1px)"} solid ${props.isExpanded ? props.focus.borderColor : props.default.borderColor};
    box-shadow: ${props.isExpanded ? `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${props.focus.borderColor}, -12px 0 24px 0 ${props.default.backgroundColor}` : 'none'};
    background-color: ${props.isExpanded ? props.focus.backgroundColor : props.default.backgroundColor};
    color: ${props.isExpanded ? props.focus.color : props.default.color};

    &::placeholder {
      color: ${props.isExpanded ? $978931f79bc05084$var$expandedPlaceholderColor : props.default.color};
    }
    :focus {
      border: ${"var(--ds-border-width, 1px)"} solid ${props.focus.borderColor};
    }
    @media screen and (max-width: ${0, $3JZ8k.dialogPageTakeoverWidth}px) {
      ${props.isExpanded ? `
            padding: 0 ${(0, $3JZ8k.grid).multiple(1.5).px} ${(0, $3JZ8k.grid).multiple(0.25).px};
            margin: 0 ${(0, $3JZ8k.grid).multiple(3).px} 0 0;` : `
            display: none;
          `}
    }
  `, " ", (0, $h9kUS.media).above.xs, "{font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);}");
const $978931f79bc05084$export$b6261a2c5ea449d = (0, $gJ29f.componentWithCondition)(()=>(0, $VSDnB.fg)('jira_mobile_search_responsiveness'), $978931f79bc05084$var$SearchInputFieldWithMobileFix, $978931f79bc05084$var$SearchInputFieldOld);
const $978931f79bc05084$export$ca6fe3402791d08e = /*#__PURE__*/ (0, $bWGt6.default)((0, $btzsC.default), {
    target: "eq4kchp6"
})({
    name: "eivff4",
    styles: "display:none"
});
const $978931f79bc05084$export$6d53dccb772ed720 = /*#__PURE__*/ (0, $bWGt6.default)('input', {
    target: "eq4kchp5"
})("height:", (0, $3JZ8k.inputFieldHeight).px, ";width:100%;padding:0px var(--ds-space-150, 12px) 0px 30px;box-sizing:border-box;outline:none;border-radius:5px;font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);border:", ()=>`${"var(--ds-border-width, 1px)"} solid ${`var(--ds-border-input, ${0, $829f609a65d26a98$export$d6447c357493214f})`}`, ";background-color:var(--ds-background-input, rgb(255, 255, 255));color:", `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`, ";:hover{background-color:var(--ds-background-input-hovered, rgb(255, 255, 255));}:focus{color:", `var(--ds-text, ${(0, $829f609a65d26a98$export$fbda843f0a27fe96)})`, ";box-shadow:", ()=>`inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-input, ${0, $829f609a65d26a98$export$d6447c357493214f})`}`, ";}@media screen and (max-width: ", (0, $3JZ8k.dialogPageTakeoverWidth), "px){display:none;}");
const $978931f79bc05084$export$c47d4a3e1f1297f1 = /*#__PURE__*/ (0, $bWGt6.default)('div', {
    target: "eq4kchp4"
})("position:relative;height:32px;@media screen and (min-width: 781px){min-width:", (props)=>props.shouldFillContainer ? '100%' : '200px', ";}", (props)=>props.shouldFillContainer ? 'width: 100%;' : '', ";");
const $978931f79bc05084$export$58ae19ee1fc7be8a = /*#__PURE__*/ (0, $bWGt6.default)('div', {
    target: "eq4kchp3"
})({
    name: "bjn8wh",
    styles: "position:relative"
});
const $978931f79bc05084$export$b40f2abde293e8e4 = /*#__PURE__*/ (0, $bWGt6.default)('div', {
    target: "eq4kchp2"
})("position:relative;max-width:100%;@media screen and (max-width: ", (0, $3JZ8k.dialogPageTakeoverWidth), "px){width:100%;}width:", (props)=>{
    if (props.shouldFillContainer) return '100%';
    return 0, $3JZ8k.collapsedSearchInputWidth;
}, ";");
const $978931f79bc05084$export$eb4e9f55bbe045df = /*#__PURE__*/ (0, $bWGt6.default)('span', {
    target: "eq4kchp1"
})("width:", (0, $3JZ8k.grid).multiple(2).px, ";height:", (0, $3JZ8k.grid).multiple(2).px, ";position:absolute;top:", (0, $3JZ8k.grid).px, ";left:", (0, $3JZ8k.grid).px, ";color:rgb(107, 119, 140);display:inline-flex;align-items:baseline;@media screen and (max-width: ", (0, $3JZ8k.dialogPageTakeoverWidth), "px){display:none;}");
const $978931f79bc05084$export$3f33ed4b273b43d = /*#__PURE__*/ (0, $bWGt6.default)('span', {
    target: "eq4kchp0"
})("display:none;padding:", (0, $3JZ8k.grid).multiple(0.5).px, ";padding-right:var(--ds-space-025, 2px);color:rgb(52, 69, 99);@media screen and (max-width: ", (0, $3JZ8k.dialogPageTakeoverWidth), "px){display:flex;}");

});
parcelRegister("3JZ8k", function(module, exports) {

$parcel$export(module.exports, "zIndex", () => $f8d02d6b2df072ff$export$56446adcecbeec34);
$parcel$export(module.exports, "grid", () => $f8d02d6b2df072ff$export$85fc379452d91af0);
$parcel$export(module.exports, "atlassianNavigationHeight", () => $f8d02d6b2df072ff$export$b9930dabfa4a3a3);
$parcel$export(module.exports, "collapsedSearchInputWidth", () => $f8d02d6b2df072ff$export$f6af7620e8789c39);
$parcel$export(module.exports, "dialogWidth", () => $f8d02d6b2df072ff$export$a3da89b899389ed8);
$parcel$export(module.exports, "dialogPageTakeoverWidth", () => $f8d02d6b2df072ff$export$ce4512df260a325a);
$parcel$export(module.exports, "dialogPageCentreWidth", () => $f8d02d6b2df072ff$export$a406031ed42c8e02);
$parcel$export(module.exports, "inputFieldHeight", () => $f8d02d6b2df072ff$export$e00021bea368c518);
$parcel$export(module.exports, "enlargedInputFieldHeight", () => $f8d02d6b2df072ff$export$30310ee354b45eb0);
$parcel$export(module.exports, "primaryTextColour", () => $f8d02d6b2df072ff$export$eeb0307e2964e28d);
$parcel$export(module.exports, "itemLinkSecondaryColor", () => $f8d02d6b2df072ff$export$7168c0a11fb9ab29);
$parcel$export(module.exports, "itemHighlightColor", () => $f8d02d6b2df072ff$export$4ac85ff259fe4fce);
$parcel$export(module.exports, "visitedLinkColor", () => $f8d02d6b2df072ff$export$271fb8b1437b1d62);
$parcel$export(module.exports, "nowrapEllipsis", () => $f8d02d6b2df072ff$export$b6b16ffe83ef4b56);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $k5uoT = parcelRequire("k5uoT");

function $f8d02d6b2df072ff$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f8d02d6b2df072ff$var$GRID_UNIT = (0, $k5uoT.gridSize)();
const $f8d02d6b2df072ff$var$AkGrid = (num = 1)=>({
        px: `${num * $f8d02d6b2df072ff$var$GRID_UNIT}px`,
        unitless: num * $f8d02d6b2df072ff$var$GRID_UNIT,
        multiple: (multiplier)=>$f8d02d6b2df072ff$var$AkGrid(multiplier * num),
        half: ()=>$f8d02d6b2df072ff$var$AkGrid(0.5 * num),
        twice: ()=>$f8d02d6b2df072ff$var$AkGrid(2 * num)
    });
const $f8d02d6b2df072ff$export$56446adcecbeec34 = {
    searchDialog: (0, $k5uoT.layers).dialog()
};
const $f8d02d6b2df072ff$export$85fc379452d91af0 = $f8d02d6b2df072ff$var$AkGrid(1);
const $f8d02d6b2df072ff$export$b9930dabfa4a3a3 = '56px';
const $f8d02d6b2df072ff$export$f6af7620e8789c39 = '200px';
const $f8d02d6b2df072ff$export$64d8573e83b64ff8 = '150px';
const $f8d02d6b2df072ff$export$a3da89b899389ed8 = '780px';
const $f8d02d6b2df072ff$export$ce4512df260a325a = 780;
const $f8d02d6b2df072ff$export$a406031ed42c8e02 = '1130px';
const $f8d02d6b2df072ff$export$e00021bea368c518 = $f8d02d6b2df072ff$export$85fc379452d91af0.multiple(4);
const $f8d02d6b2df072ff$export$30310ee354b45eb0 = $f8d02d6b2df072ff$export$85fc379452d91af0.multiple(6);
const $f8d02d6b2df072ff$export$eeb0307e2964e28d = `var(--ds-text, ${(0, $829f609a65d26a98$export$fbda843f0a27fe96)})`;
const $f8d02d6b2df072ff$export$7168c0a11fb9ab29 = `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`;
const $f8d02d6b2df072ff$export$4ac85ff259fe4fce = `var(--ds-background-neutral-subtle-hovered, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`;
const $f8d02d6b2df072ff$export$271fb8b1437b1d62 = `var(--ds-link-visited, ${(0, $829f609a65d26a98$export$b48405b95304b5a1)})`;
const $f8d02d6b2df072ff$export$b6b16ffe83ef4b56 = {
    name: "sqm42b",
    styles: "text-overflow:ellipsis;white-space:nowrap;overflow:hidden"
};

});

parcelRegister("gJ29f", function(module, exports) {

$parcel$export(module.exports, "componentWithCondition", () => $dc1469b3f4efbf3b$export$6e8ea24b15199873);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
function $dc1469b3f4efbf3b$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>condition() ? /*#__PURE__*/ (0, $2OMIu.jsx)(ComponentTrue, {
            ...props,
            ref: ref
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}

});


parcelRegister("hLeR9", function(module, exports) {

$parcel$export(module.exports, "AbsoluteContainer", () => $0b21a022edbcff7e$export$36aa0f4a98890c96);
$parcel$export(module.exports, "SearchDialogAnchor", () => $0b21a022edbcff7e$export$f565ce1043dae7c9);
$parcel$export(module.exports, "SearchAnchorWrapper", () => $0b21a022edbcff7e$export$dfece74a62f1398d);
$parcel$export(module.exports, "EnlargedSearchAnchorWrapper", () => $0b21a022edbcff7e$export$5566658d36f6ca7b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $3JZ8k = parcelRequire("3JZ8k");

var $bWGt6 = parcelRequire("bWGt6");
const $0b21a022edbcff7e$export$36aa0f4a98890c96 = /*#__PURE__*/ (0, $bWGt6.default)('div', {
    target: "exl9bxq3"
})("", (props)=>{
    if (props.isExpanded) // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $f8Sb3.css)({
        position: 'absolute',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        ...props.shouldFillContainer && {
            left: 0
        },
        right: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: (0, $3JZ8k.zIndex).searchDialog
    });
    return {};
});
const $0b21a022edbcff7e$export$f565ce1043dae7c9 = /*#__PURE__*/ (0, $bWGt6.default)('div', {
    target: "exl9bxq2"
})("position:relative;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>{
    if (props.isExpanded) // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $f8Sb3.css)("@media screen and (max-width: ", (0, $3JZ8k.dialogPageCentreWidth), "){ position:", props.shouldFillContainer ? 'static' : 'fixed', "; z-index:", (0, $3JZ8k.zIndex).searchDialog, ";left:calc((100% - ", (0, $3JZ8k.dialogWidth), ") / 2);;}@media screen and (max-width: ", (0, $3JZ8k.dialogPageTakeoverWidth), "px){ ", props.shouldFillContainer && 'position: fixed;', ";top:0;right:0;bottom:0;left:0;display:flex;flex-direction:column;overflow:auto;}");
    return {};
});
const $0b21a022edbcff7e$export$dfece74a62f1398d = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "exl9bxq1"
})("position:relative;@media screen and (min-width: ", (0, $3JZ8k.dialogPageTakeoverWidth) + 1, "px){", (props)=>props.shouldFillContainer ? 'width: 100%;' : 'min-width: 200px;', ";}", (props)=>props.shouldFillContainer ? 'max-width: 780px;' : '', " width:", (0, $3JZ8k.inputFieldHeight).px, ";height:", (0, $3JZ8k.inputFieldHeight).px, ";");
const $0b21a022edbcff7e$export$5566658d36f6ca7b = /*#__PURE__*/ (0, $bWGt6.default)($0b21a022edbcff7e$export$dfece74a62f1398d, {
    target: "exl9bxq0"
})("height:", (props)=>props.isExpanded ? (0, $3JZ8k.enlargedInputFieldHeight).px : (0, $3JZ8k.inputFieldHeight).px, ";");

});

parcelRegister("6I8Kl", function(module, exports) {

$parcel$export(module.exports, "SearchIcon", () => $4439160c76b81f6f$export$82eafebb825fc23f);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $26g7Y = parcelRequire("26g7Y");

const $4439160c76b81f6f$export$82eafebb825fc23f = ({ isExpanded: isExpanded, theme: theme, size: size = 'small', primaryColor: primaryColor = `var(--ds-text, ${0, $829f609a65d26a98$export$7d61b15e0da132af})`, label: label = '' })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($26g7Y))), {
        label: label,
        LEGACY_primaryColor: isExpanded ? primaryColor : theme.default.color,
        LEGACY_size: size,
        // NOTE: color do not accept string type but here primaryColor is string, so need to use any
        color: isExpanded ? primaryColor : theme.default.color
    });

});

parcelRegister("j1SOM", function(module, exports) {

$parcel$export(module.exports, "getInputSkeletonQuery", () => $a306a1ec994c7560$export$b8b6c2e7a0664212);
$parcel$export(module.exports, "setInputSkeletonQuery", () => $a306a1ec994c7560$export$baa1c819dd4691f3);
$parcel$export(module.exports, "getInputSkeletonFocus", () => $a306a1ec994c7560$export$38fcbc98be180790);
$parcel$export(module.exports, "setInputSkeletonIsFocus", () => $a306a1ec994c7560$export$d3c6894b4e9af000);
$parcel$export(module.exports, "getInputSkeletonSelection", () => $a306a1ec994c7560$export$a0c71b3bd9ec143c);
$parcel$export(module.exports, "setInputSkeletonSelection", () => $a306a1ec994c7560$export$e0d745255b135363);
$parcel$export(module.exports, "resetInputSkeletonState", () => $a306a1ec994c7560$export$c89dd2d5d4024c5e);
$parcel$export(module.exports, "removeInputSkeletonEventListeners", () => $a306a1ec994c7560$export$166ce39761ad7743);
$parcel$export(module.exports, "removeInputSkeletonState", () => $a306a1ec994c7560$export$c830bcf42e072a93);
const $a306a1ec994c7560$export$b8b6c2e7a0664212 = ()=>{
    return window?.inputSkeletonState?.query || '';
};
const $a306a1ec994c7560$export$baa1c819dd4691f3 = (newQuery)=>{
    if (window?.inputSkeletonState) window.inputSkeletonState.query = newQuery;
};
const $a306a1ec994c7560$export$38fcbc98be180790 = ()=>{
    return window?.inputSkeletonState?.isFocused || false;
};
const $a306a1ec994c7560$export$d3c6894b4e9af000 = (newIsFocused)=>{
    if (window?.inputSkeletonState) window.inputSkeletonState.isFocused = newIsFocused;
};
const $a306a1ec994c7560$export$a0c71b3bd9ec143c = ()=>{
    const selectionStart = window?.inputSkeletonState?.selectionStart || 0;
    const selectionEnd = window?.inputSkeletonState?.selectionEnd || 0;
    const selectionDirection = window?.inputSkeletonState?.selectionDirection || 'none';
    return {
        selectionStart: selectionStart,
        selectionEnd: selectionEnd,
        selectionDirection: selectionDirection
    };
};
const $a306a1ec994c7560$export$e0d745255b135363 = (newSelectionStart, newSelectionEnd, newSelectionDirection)=>{
    if (window?.inputSkeletonState) {
        window.inputSkeletonState.selectionStart = newSelectionStart;
        window.inputSkeletonState.selectionEnd = newSelectionEnd;
        window.inputSkeletonState.selectionDirection = newSelectionDirection;
    }
};
const $a306a1ec994c7560$export$c89dd2d5d4024c5e = ()=>{
    window.inputSkeletonState = {
        query: '',
        placeholder: '',
        isFocused: false,
        selectionStart: 0,
        selectionEnd: 0,
        selectionDirection: 'none',
        listeners: []
    };
};
const $a306a1ec994c7560$export$166ce39761ad7743 = ()=>{
    if (window.inputSkeletonState) {
        window.inputSkeletonState.listeners.forEach((ssrEventListener)=>{
            const [target, event, handler] = ssrEventListener;
            target.removeEventListener(event, handler);
        });
        window.inputSkeletonState.listeners = [];
    }
};
const $a306a1ec994c7560$export$c830bcf42e072a93 = ()=>{
    if (window['inputSkeletonState']) {
        $a306a1ec994c7560$export$166ce39761ad7743();
        delete window['inputSkeletonState'];
    }
};

});

parcelRegister("8I7W7", function(module, exports) {

$parcel$export(module.exports, "SSRsearchInput", () => SSRsearchInput);
/* eslint-disable import/extensions */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $b9NEf = parcelRequire("b9NEf");


var $6I8Kl = parcelRequire("6I8Kl");
const SSRsearchInput = ({ advancedSearchUrl, placeholder, customScriptDataAttributes, theme, shouldFillContainer })=>{
    const scriptRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useLayoutEffect)(()=>{
        const current = scriptRef?.current;
        if (current) // eslint-disable-next-line
        eval(current.innerHTML);
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b9NEf.SSRsearchInputWrapper), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            id: "ssr-search-input-popout-container",
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b9NEf.SSRformContainer), {
                id: "ssr-form-container",
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)("form", {
                    method: "get",
                    action: advancedSearchUrl,
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $b9NEf.SSRsearchInputContainer), {
                            shouldFillContainer: shouldFillContainer,
                            id: "ssr-input-container",
                            role: "search",
                            children: [
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b9NEf.SSRmobileSearchIconWrapper), {
                                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6I8Kl.SearchIcon), {
                                        theme: theme,
                                        isExpanded: false,
                                        size: "medium"
                                    })
                                }),
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b9NEf.SSRdesktopSearchIconWrapper), {
                                    id: "ssr-search-icon-wrapper",
                                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6I8Kl.SearchIcon), {
                                        theme: theme,
                                        isExpanded: false
                                    })
                                }),
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b9NEf.SSRsearchInputField), {
                                    id: "ssr-search-input",
                                    name: "text",
                                    placeholder: placeholder,
                                    autoComplete: "off",
                                    "aria-label": placeholder
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("script", {
                            "data-test-id": "ssr-scripts-init",
                            ref: scriptRef,
                            dangerouslySetInnerHTML: {
                                __html: (0, $9b06243a4405ae90$export$bc237d627614fc48)
                            },
                            ...customScriptDataAttributes
                        })
                    ]
                })
            })
        })
    });
};

});
/* eslint-disable */ // @ts-ignore
const $9b06243a4405ae90$export$bc237d627614fc48 = `(function(document,window){var _a;var getWeakRef=function(queryId){var element=document.getElementById(queryId);if(!element){return null}return new WeakRef(element)};var currentInput=getWeakRef("ssr-search-input");var container=getWeakRef("ssr-input-container");var topContainer=getWeakRef("ssr-search-input-popout-container");var iconWrapper=getWeakRef("ssr-search-icon-wrapper");var formContainer=getWeakRef("ssr-form-container");var pageWidth=window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth;if(window["inputSkeletonState"]){for(var _i=0,_b=window["inputSkeletonState"].listeners;_i<_b.length;_i++){var listener=_b[_i];var target=listener[0],event_1=listener[1],handler=listener[2];target.removeEventListener(event_1,handler)}window["inputSkeletonState"].listeners=[]}function setExpandedStyles(){var _a,_b,_c,_d,_e,_f;(_a=iconWrapper===null||iconWrapper===void 0?void 0:iconWrapper.deref())===null||_a===void 0?void 0:_a.setAttribute("style","color: rgb(9, 30, 66);");if(pageWidth<=1130){(_b=topContainer===null||topContainer===void 0?void 0:topContainer.deref())===null||_b===void 0?void 0:_b.setAttribute("style","position: absolute;right: 0px;z-index: 300;");(_c=formContainer===null||formContainer===void 0?void 0:formContainer.deref())===null||_c===void 0?void 0:_c.setAttribute("style","position: fixed;z-index: 300;left: calc((100% - 780px) / 2);");(_d=container===null||container===void 0?void 0:container.deref())===null||_d===void 0?void 0:_d.setAttribute("style","position: relative;max-width: 100%;width: 780px;")}else{(_e=topContainer===null||topContainer===void 0?void 0:topContainer.deref())===null||_e===void 0?void 0:_e.setAttribute("style","position: absolute; right:0px; z-index:300;");(_f=container===null||container===void 0?void 0:container.deref())===null||_f===void 0?void 0:_f.setAttribute("style","width: 780px;")}}function resetInputSkeleton(){window["inputSkeletonState"]={query:"",placeholder:"",isFocused:false,selectionStart:0,selectionEnd:0,selectionDirection:"none",listeners:[]}}if(window["inputSkeletonState"]){var inputRef=currentInput===null||currentInput===void 0?void 0:currentInput.deref();if(window.inputSkeletonState.isFocused&&inputRef){inputRef.value=window.inputSkeletonState.query;inputRef.placeholder=window.inputSkeletonState.placeholder;inputRef.focus();inputRef.setSelectionRange(window.inputSkeletonState.selectionStart,window.inputSkeletonState.selectionEnd,window.inputSkeletonState.selectionDirection);setExpandedStyles()}}else{resetInputSkeleton()}var queryValue=window.sessionStorage.getItem("atlassian.search-dialog-query");if(window.sessionStorage.getItem("atlassian.search-dialog-sticky")==="true"&&!!queryValue){var inputRef=currentInput===null||currentInput===void 0?void 0:currentInput.deref();if(inputRef){inputRef.value=queryValue}}var mediaQuery=window.matchMedia("(max-width: 1130px)");function handleSmallScreen(){var _a,_b,_c;if(window["inputSkeletonState"]){if(window.inputSkeletonState.isFocused){(_a=topContainer===null||topContainer===void 0?void 0:topContainer.deref())===null||_a===void 0?void 0:_a.setAttribute("style","position: absolute;right: 0px;z-index: 300;");(_b=formContainer===null||formContainer===void 0?void 0:formContainer.deref())===null||_b===void 0?void 0:_b.setAttribute("style","position: fixed;z-index: 300;left: calc((100% - 780px) / 2);");(_c=container===null||container===void 0?void 0:container.deref())===null||_c===void 0?void 0:_c.setAttribute("style","position: relative;max-width: 100%;width: 780px;")}}}(_a=mediaQuery===null||mediaQuery===void 0?void 0:mediaQuery.addEventListener)===null||_a===void 0?void 0:_a.call(mediaQuery,"change",function(){return handleSmallScreen()});function changeHandler(e){var input=e.target;if(window.inputSkeletonState){window.inputSkeletonState.query=input===null||input===void 0?void 0:input.value;if(window.sessionStorage.getItem("atlassian.search-dialog-sticky")==="true"){window.sessionStorage.setItem("atlassian.search-dialog-query",input.value)}var inputRef=currentInput===null||currentInput===void 0?void 0:currentInput.deref();if(inputRef){window.inputSkeletonState.selectionStart=inputRef.selectionStart||0;window.inputSkeletonState.selectionEnd=inputRef.selectionEnd||0;window.inputSkeletonState.selectionDirection=inputRef.selectionDirection||"none"}}}function focusHandler(e){if(window.inputSkeletonState){window.inputSkeletonState.isFocused=true;var inputRef=currentInput===null||currentInput===void 0?void 0:currentInput.deref();if(inputRef){window.inputSkeletonState.placeholder=inputRef.placeholder}}setExpandedStyles()}function blurClickHandler(e){var _a,_b,_c,_d,_e;var inputRef=currentInput===null||currentInput===void 0?void 0:currentInput.deref();if(!inputRef){return}if(currentInput&&e.target===inputRef&&window.inputSkeletonState){window.inputSkeletonState.selectionStart=inputRef.selectionStart||0;window.inputSkeletonState.selectionEnd=inputRef.selectionEnd||0;window.inputSkeletonState.selectionDirection=inputRef.selectionDirection||"none";if(!((_a=topContainer===null||topContainer===void 0?void 0:topContainer.deref())===null||_a===void 0?void 0:_a.hasAttribute("style"))){window.inputSkeletonState.isFocused=true;setExpandedStyles()}}if(currentInput&&e.target!==inputRef){resetInputSkeleton();var sessionQuery=window.sessionStorage.getItem("atlassian.search-dialog-query");if(window.sessionStorage.getItem("atlassian.search-dialog-sticky")==="true"&&!!sessionQuery){inputRef.value=sessionQuery}else{inputRef.value=""}(_b=topContainer===null||topContainer===void 0?void 0:topContainer.deref())===null||_b===void 0?void 0:_b.removeAttribute("style");(_c=container===null||container===void 0?void 0:container.deref())===null||_c===void 0?void 0:_c.removeAttribute("style");(_d=iconWrapper===null||iconWrapper===void 0?void 0:iconWrapper.deref())===null||_d===void 0?void 0:_d.removeAttribute("style");inputRef.removeAttribute("style");(_e=formContainer===null||formContainer===void 0?void 0:formContainer.deref())===null||_e===void 0?void 0:_e.removeAttribute("style")}}function addListener(target,event,handler){var _a;target.addEventListener(event,handler);(_a=window===null||window===void 0?void 0:window.inputSkeletonState)===null||_a===void 0?void 0:_a.listeners.push([target,event,handler])}{var inputRef=currentInput===null||currentInput===void 0?void 0:currentInput.deref();if(inputRef){addListener(inputRef,"input",changeHandler);addListener(inputRef,"select",changeHandler);addListener(inputRef,"keydown",changeHandler);addListener(inputRef,"focus",focusHandler)}}addListener(document,"click",blurClickHandler)})(document,window);`;




parcelRegister("4eq41", function(module, exports) {

$parcel$export(module.exports, "AI_MATE_ATTRIBUTES", () => $3d29cfe9cceaa0f2$export$8cffc8b2c93affd4);
/**
 * NOTE: Some of these fields are used to track AI MAU
 * See this page for more details: https://hello.atlassian.net/wiki/spaces/AAI/pages/3770721410/Unified+event+Instrumentation+for+AI
 */ const $3d29cfe9cceaa0f2$export$8cffc8b2c93affd4 = {
    agentCreatorType: 'agentCreatorType',
    agentId: 'agentId',
    agentVisibility: 'agentVisibility',
    agentExternalConfigReference: 'agentExternalConfigReference',
    agentActions: 'agentActions',
    agentIsDefault: 'agentIsDefault',
    conversationChannelId: 'conversationChannelId',
    experienceId: 'experienceId',
    fullScreen: 'fullScreen',
    product: 'product',
    productHeader: 'productHeader',
    singleInstrumentationID: 'singleInstrumentationID'
};

});

parcelRegister("jSnf2", function(module, exports) {

$parcel$export(module.exports, "useAnalytics", () => $dfca0822997e10b2$export$e955abb82869dc84);

var $5uXOq = parcelRequire("5uXOq");

var $1SrMX = parcelRequire("1SrMX");
var $2NMNM = parcelRequire("2NMNM");

var $aFWqW = parcelRequire("aFWqW");

var $4eq41 = parcelRequire("4eq41");

var $VdqAi = parcelRequire("VdqAi");

var $eZRED = parcelRequire("eZRED");
const $dfca0822997e10b2$var$isTownSquareEvent = ()=>[
        'home.atlassian.com',
        'team.atlassian.com'
    ].some((host)=>window.location?.host.includes(host));
const $dfca0822997e10b2$var$DEFAULT_TAGS = [
    'atlaskit',
    'aiMate'
];
const $dfca0822997e10b2$export$e955abb82869dc84 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { propertiesRef: propertiesRef } = (0, $aFWqW.useAnalyticsPropertiesContext)();
    // TODO: Improve this functionality, potentially with a higher order provider for tags or similar
    // This is a temporary solution to add the 'townsquare' tag to operational events so Experience Tracker works in Atlas
    const maybeAtlasOperationalTags = (0, $5uXOq.useCallback)((inputPayload)=>{
        const payload = inputPayload instanceof (0, $1SrMX.default) ? inputPayload.payload : inputPayload;
        if (payload.actionSubject === 'ui' && payload.eventType === 'operational' && $dfca0822997e10b2$var$isTownSquareEvent()) return [
            'townsquare'
        ];
        return [];
    }, []);
    const getDefaultAttributes = (0, $5uXOq.useCallback)(()=>{
        const { agentCreatorType: agentCreatorType, agentId: agentId, agentVisibility: agentVisibility, agentExternalConfigReference: agentExternalConfigReference, agentActions: agentActions, agentIsDefault: agentIsDefault, conversationChannelId: conversationChannelId, experienceId: experienceId, fullScreen: fullScreen, product: product, productHeader: productHeader } = propertiesRef.current;
        return {
            [(0, $4eq41.AI_MATE_ATTRIBUTES).agentCreatorType]: agentCreatorType,
            [(0, $4eq41.AI_MATE_ATTRIBUTES).agentId]: agentId,
            [(0, $4eq41.AI_MATE_ATTRIBUTES).agentVisibility]: agentVisibility,
            [(0, $4eq41.AI_MATE_ATTRIBUTES).conversationChannelId]: conversationChannelId,
            [(0, $4eq41.AI_MATE_ATTRIBUTES).experienceId]: experienceId,
            [(0, $4eq41.AI_MATE_ATTRIBUTES).fullScreen]: fullScreen,
            [(0, $4eq41.AI_MATE_ATTRIBUTES).product]: product,
            [(0, $4eq41.AI_MATE_ATTRIBUTES).productHeader]: productHeader,
            [(0, $4eq41.AI_MATE_ATTRIBUTES).singleInstrumentationID]: conversationChannelId,
            [(0, $4eq41.AI_MATE_ATTRIBUTES).agentExternalConfigReference]: agentExternalConfigReference,
            [(0, $4eq41.AI_MATE_ATTRIBUTES).agentActions]: agentActions,
            [(0, $4eq41.AI_MATE_ATTRIBUTES).agentIsDefault]: agentIsDefault
        };
    }, [
        propertiesRef
    ]);
    const trackAIMAUEvent = (0, $5uXOq.useCallback)((payload)=>{
        // Handle tags
        const tags = [
            ...$dfca0822997e10b2$var$DEFAULT_TAGS
        ];
        if ($dfca0822997e10b2$var$isTownSquareEvent()) tags.push('townsquare');
        const { source: source, subjectId: subjectId, proactive: proactive, userGenerated: userGenerated, messageId: messageId, messageActions: messageActions, singleInstrumentationID: singleInstrumentationID, timestamp: timestamp, citedProductList: citedProductList, citedProduct: citedProduct, invokedPlugins: invokedPlugins } = payload;
        let attributes = {
            ...getDefaultAttributes(),
            isAIFeature: 1,
            proactiveAIGenerated: proactive ? 1 : 0,
            userGeneratedAI: userGenerated ? 1 : 0,
            aiFeatureName: 'aiChat',
            citedProductList: citedProductList,
            citedProduct: citedProduct
        };
        if (messageId) attributes.messageId = messageId;
        if (messageActions) attributes.messageActions = messageActions;
        if (timestamp) attributes.timestamp = timestamp;
        if (singleInstrumentationID) attributes.singleInstrumentationID = singleInstrumentationID;
        if (invokedPlugins) attributes.invokedPlugins = invokedPlugins;
        // Core AI MAU payload
        let eventPayload = {
            eventType: 'track',
            tags: tags,
            source: source,
            actionSubjectId: subjectId,
            attributes: attributes
        };
        // Handle specific AI MAU events
        switch(payload.type){
            case 'initiated':
                eventPayload = {
                    ...eventPayload,
                    actionSubject: 'aiInteraction',
                    action: 'initiated'
                };
                break;
            case 'viewed':
                eventPayload = {
                    ...eventPayload,
                    actionSubject: 'aiResult',
                    action: 'viewed'
                };
                break;
            case 'error':
                eventPayload = {
                    ...eventPayload,
                    actionSubject: 'aiResult',
                    action: 'error'
                };
                break;
            case 'dismissed':
                eventPayload = {
                    ...eventPayload,
                    actionSubject: 'aiInteraction',
                    action: 'dismissed'
                };
                break;
            case 'actioned':
                eventPayload = {
                    ...eventPayload,
                    actionSubject: 'aiResult',
                    action: 'actioned',
                    attributes: {
                        ...eventPayload.attributes,
                        aiResultAction: payload.actionResult
                    }
                };
                break;
            case 'feedback':
                eventPayload = {
                    ...eventPayload,
                    actionSubject: 'aiFeedback',
                    action: 'submitted',
                    attributes: {
                        ...eventPayload.attributes,
                        aiFeedbackResult: payload.feedbackResult
                    }
                };
                break;
        }
        // Build event and apply context attributes
        const event = createAnalyticsEvent(eventPayload);
        const aiMateContextAttributes = (0, $eZRED.getAttributesFromContexts)(event.context);
        // Fire
        event.update({
            attributes: {
                ...event.payload.attributes,
                ...aiMateContextAttributes
            }
        }).fire((0, $VdqAi.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        getDefaultAttributes
    ]);
    const sendAnalyticsEvent = (0, $5uXOq.useCallback)((payload, options)=>{
        const extraTags = options?.removeDefaultTags ? [] : $dfca0822997e10b2$var$DEFAULT_TAGS;
        const allTags = Array.from(new Set([
            ...extraTags,
            ...payload.tags || [],
            ...maybeAtlasOperationalTags(payload)
        ]));
        const defaultAttributes = getDefaultAttributes();
        if (payload instanceof (0, $1SrMX.default)) {
            const aiMateContextAttributes = (0, $eZRED.getAttributesFromContexts)(payload.context);
            payload.update({
                ...payload.payload,
                tags: allTags,
                attributes: {
                    ...defaultAttributes,
                    ...payload.payload.attributes,
                    ...aiMateContextAttributes
                }
            }).fire((0, $VdqAi.ANALYTICS_CHANNEL));
        } else {
            const event = createAnalyticsEvent({
                ...payload,
                tags: allTags,
                attributes: {
                    ...defaultAttributes,
                    ...payload.attributes
                }
            });
            const aiMateContextAttributes = (0, $eZRED.getAttributesFromContexts)(event.context);
            event.update({
                attributes: {
                    ...event.payload.attributes,
                    ...aiMateContextAttributes
                }
            }).fire((0, $VdqAi.ANALYTICS_CHANNEL));
        }
    }, [
        createAnalyticsEvent,
        maybeAtlasOperationalTags,
        getDefaultAttributes
    ]);
    return {
        sendAnalyticsEvent: sendAnalyticsEvent,
        trackAIMAUEvent: trackAIMAUEvent
    };
};

});
parcelRegister("aFWqW", function(module, exports) {

$parcel$export(module.exports, "AnalyticsContextWithSourceAndProperties", () => $ff5d4fd37d27263a$export$a00cd3c213413389);
$parcel$export(module.exports, "useAnalyticsPropertiesContext", () => $ff5d4fd37d27263a$export$ab8aa3dfd687f012);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $daJ0i = parcelRequire("daJ0i");
const $ff5d4fd37d27263a$var$initialState = {
    conversationChannelId: '',
    experienceId: '',
    product: '',
    productHeader: '',
    agentId: null,
    agentExternalConfigReference: null,
    agentActions: [],
    agentIsDefault: null,
    fullScreen: false,
    agentCreatorType: '',
    agentVisibility: '',
    singleInstrumentationID: ''
};
const $ff5d4fd37d27263a$var$AnalyticsPropertiesContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    propertiesRef: {
        current: {
            ...$ff5d4fd37d27263a$var$initialState
        }
    },
    setAnalyticsPropertiesWithoutRerender: ()=>{}
});
const $ff5d4fd37d27263a$export$1aefd27d2ed3c1c9 = ({ children: children })=>{
    const propertiesRef = (0, $5uXOq.useRef)({
        ...$ff5d4fd37d27263a$var$initialState
    });
    const setAnalyticsPropertiesWithoutRerender = (0, $5uXOq.useCallback)((properties)=>{
        propertiesRef.current = {
            ...propertiesRef.current,
            ...properties
        };
    }, []);
    const value = (0, $5uXOq.useMemo)(()=>({
            propertiesRef: propertiesRef,
            setAnalyticsPropertiesWithoutRerender: setAnalyticsPropertiesWithoutRerender
        }), [
        setAnalyticsPropertiesWithoutRerender
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($ff5d4fd37d27263a$var$AnalyticsPropertiesContext.Provider, {
        value: value,
        children: children
    });
};
const $ff5d4fd37d27263a$export$a00cd3c213413389 = ({ source: source, children: children })=>{
    const data = (0, $5uXOq.useMemo)(()=>({
            source: source
        }), [
        source
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $daJ0i.default), {
        data: data,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($ff5d4fd37d27263a$export$1aefd27d2ed3c1c9, {
            children: children
        })
    });
};
const $ff5d4fd37d27263a$export$ab8aa3dfd687f012 = ()=>{
    return (0, $5uXOq.useContext)($ff5d4fd37d27263a$var$AnalyticsPropertiesContext);
};

});

parcelRegister("VdqAi", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $0a756ecf0a3a3690$export$85183a312807388d);

var $e8KHW = parcelRequire("e8KHW");
const $0a756ecf0a3a3690$export$85183a312807388d = (0, $e8KHW.FabricChannel).aiMate;

});

parcelRegister("eZRED", function(module, exports) {

$parcel$export(module.exports, "getAttributesFromContexts", () => $177e3d94a217ad2a$export$d97c97ed77ff09e8);

var $1PVpv = parcelRequire("1PVpv");
const $177e3d94a217ad2a$var$isSourceAndAttributes = (x)=>{
    if (typeof x !== 'object' || x === null) return false;
    if (!('source' in x) || !('attributes' in x) || typeof x.attributes !== 'object' || x.attributes === null) return false;
    return true;
};
const $177e3d94a217ad2a$export$d97c97ed77ff09e8 = (context)=>{
    if (!context || !Array.isArray(context)) return {};
    let aiMateOnly = context.filter((x)=>$177e3d94a217ad2a$var$isSourceAndAttributes(x) && x.source === 'AIMate' || x[0, $1PVpv.AI_MATE_CONTEXT]);
    return aiMateOnly.reduce((acc, x)=>{
        return {
            ...acc,
            ...x[0, $1PVpv.AI_MATE_CONTEXT]?.attributes ?? {},
            ...x.attributes ?? {}
        };
    }, {});
};

});


parcelRegister("5i4cN", function(module, exports) {

$parcel$export(module.exports, "ChatOpenerSubscriber", () => $f445f44794d90802$export$6fa95a645837361b);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $9oBwb = parcelRequire("9oBwb");
var $7Z8dX = parcelRequire("7Z8dX");
var $hjiMw = parcelRequire("hjiMw");

var $jSnf2 = parcelRequire("jSnf2");
// TODO: Deprecated; teams integrating this event should opt-out of chat open using `openChat` on the core event payload
// Once all teams have opted out the ignoredEvents logic can be removed
const $f445f44794d90802$var$ignoredEvents = new Set([
    'editor-context-payload',
    'browser-context-payload',
    'agent-changed'
]);
const $f445f44794d90802$var$eventsToSkipAnalytics = new Set([
    // This event is fired way too often https://atlassian.slack.com/archives/C06PKQPN8BF/p1729569226011399
    'editor-context-payload',
    'agent-changed'
]);
const $f445f44794d90802$export$6fa95a645837361b = ({ onTriggerOpeningChat: onTriggerOpeningChat })=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $jSnf2.useAnalytics)();
    const [triggerOpen, setTriggerOpen] = (0, $5uXOq.useState)(!!(0, $9oBwb.getRovoParams)()?.triggerOpen);
    // Trigger open rovo sidebar if not already open via URL param
    (0, $5uXOq.useEffect)(()=>{
        try {
            if (!triggerOpen) return;
            onTriggerOpeningChat();
            setTriggerOpen(false);
        } catch (error) {
        // Fail silently
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        triggerOpen
    ]);
    (0, $hjiMw.useSubscribeAll)((payload)=>{
        const { type: type, source: source, openChat: openChat = true } = payload;
        const preventOpen = !openChat || $f445f44794d90802$var$ignoredEvents.has(type);
        if (!$f445f44794d90802$var$eventsToSkipAnalytics.has(type)) sendAnalyticsEvent({
            action: 'eventReceived',
            actionSubject: 'aiMatePubSubEvent',
            source: source,
            attributes: {
                publisherSource: source,
                payloadType: type,
                eventTriggersChatOpen: !preventOpen
            }
        });
        if (preventOpen) return;
        onTriggerOpeningChat();
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7Z8dX.RovoPostMessagePubsubListener), {})
    });
};

});
parcelRegister("9oBwb", function(module, exports) {

$parcel$export(module.exports, "getRovoParams", () => $527b3a92d6af9e9e$export$6405071f390601f7);
$parcel$export(module.exports, "addRovoParamsToUrl", () => $527b3a92d6af9e9e$export$ef04687636c850fe);
$parcel$export(module.exports, "encodeRovoParams", () => $527b3a92d6af9e9e$export$eddc20a009406015);

var $hhCQV = parcelRequire("hhCQV");
const $527b3a92d6af9e9e$export$fda91e425d265029 = (str)=>str.charAt(0).toUpperCase() + str.slice(1);
const $527b3a92d6af9e9e$export$858653b7ee3cbb17 = (str)=>str.charAt(0).toLowerCase() + str.slice(1);
const $527b3a92d6af9e9e$var$isValidURL = (url)=>{
    try {
        new URL(url);
        return true;
    } catch (error) {
        return false;
    }
};
const $527b3a92d6af9e9e$export$9748efee331ec573 = (param)=>`${0, $hhCQV.ROVO_PARAM_PREFIX}${$527b3a92d6af9e9e$export$fda91e425d265029(param)}`;
const $527b3a92d6af9e9e$export$f2888183a34644d4 = (param)=>{
    return $527b3a92d6af9e9e$export$858653b7ee3cbb17(param.replace((0, $hhCQV.ROVO_PARAM_PREFIX), ''));
};
// Creates RovoChatParams from URLSearchParams
// Optionally filter to specific params
const $527b3a92d6af9e9e$var$processParams = (input, options = {
    filter: []
})=>{
    const output = {};
    const safeSearchParamsInput = typeof input === 'string' ? $527b3a92d6af9e9e$var$isValidURL(input) ? new URLSearchParams(new URL(input).search) : new URLSearchParams(input) : input;
    const processedInput = new URLSearchParams(safeSearchParamsInput);
    const extracted = new URLSearchParams();
    safeSearchParamsInput.forEach((value, key)=>{
        // Only look at rovoChat params
        if (!key.startsWith((0, $hhCQV.ROVO_PARAM_PREFIX))) return;
        const paramKey = $527b3a92d6af9e9e$export$f2888183a34644d4(key);
        if (options?.filter?.length) {
            if (options.filter.includes(paramKey)) {
                output[paramKey] = decodeURIComponent(value);
                extracted.append(key, value);
            }
        } else output[paramKey] = decodeURIComponent(value);
        // Remove rovoParam from processed input
        processedInput.delete(key);
    });
    const combinedQueryString = [
        processedInput,
        extracted
    ].map((params)=>params.toString()).filter((part)=>part.length > 0).join('&');
    return {
        processed: processedInput,
        rovoParams: output,
        combinedQueryString: combinedQueryString
    };
};
const $527b3a92d6af9e9e$export$6405071f390601f7 = (url)=>{
    try {
        const search = url ? new URL(url).search : window.location.search;
        const q = new URLSearchParams(search);
        return $527b3a92d6af9e9e$var$processParams(q).rovoParams;
    } catch (error) {
        return {};
    }
};
const $527b3a92d6af9e9e$export$4a302fc7d977f7b3 = (params)=>{
    window.history.pushState({}, '', $527b3a92d6af9e9e$export$ef04687636c850fe(window.location.pathname, params));
};
const $527b3a92d6af9e9e$export$ef04687636c850fe = (url, params)=>{
    const { processed: processed, rovoParams: rovoParams } = $527b3a92d6af9e9e$var$processParams(url);
    const rovoParamsWithExisting = {
        ...rovoParams,
        ...params
    };
    const baseUrl = url.includes('?') ? url.split('?')[0] : url;
    const baseQuery = Array.from(processed).length ? `?${processed.toString()}&` : '?';
    const updatedRovoParamsString = $527b3a92d6af9e9e$export$eddc20a009406015(rovoParamsWithExisting);
    return `${baseUrl}${baseQuery}${updatedRovoParamsString}`;
};
const $527b3a92d6af9e9e$export$eddc20a009406015 = (params, encodeAsObject)=>{
    if (encodeAsObject) return Object.entries(params).reduce((acc, [key, value])=>{
        acc[$527b3a92d6af9e9e$export$9748efee331ec573(key)] = encodeURIComponent(value);
        return acc;
    }, {});
    return Object.entries(params).map(([key, value])=>{
        return `${$527b3a92d6af9e9e$export$9748efee331ec573(key)}=${encodeURIComponent(value)}`;
    }).join('&');
};
const $527b3a92d6af9e9e$export$ad5179fba4239081 = (params, fields)=>{
    return Object.entries(params).every(([key, value])=>{
        const field = fields.find((field)=>field === key);
        if (field) return value !== undefined;
        else return value === undefined;
    });
};
const $527b3a92d6af9e9e$export$9c55b0deb4e0c7df = ({ resourceRouterQuery: resourceRouterQuery = false } = {})=>{
    /*
	For products using react-resource-router (e.g Atlas) to
	pass as the value of `query` on the route definition. It ensures that our parameters
	are not stripped from the URL when loading the page, or through redirect hops
	Any new parameters we want to maintain should be added here as well, which means
	only a version bump is needed in those products to support the latest param list
	The !=false simply means that the parameter is supported but is optional, and should
	not contain a value of 'false'
	*/ const suffix = resourceRouterQuery ? '!=false' : '';
    return (0, $hhCQV.ROVO_VALID_PARAMS).map((param)=>`${$527b3a92d6af9e9e$export$9748efee331ec573(param)}${suffix}`);
};

});
parcelRegister("hhCQV", function(module, exports) {

$parcel$export(module.exports, "ROVO_PARAM_PREFIX", () => $782eed6f93424f0d$export$5a550907ffbc9119);
$parcel$export(module.exports, "ROVO_VALID_PARAMS", () => $782eed6f93424f0d$export$3cd6b610e7ede579);
const $782eed6f93424f0d$export$5a550907ffbc9119 = 'rovoChat';
const $782eed6f93424f0d$export$3cd6b610e7ede579 = [
    'pathway',
    'agentId',
    'conversationId',
    'prompt',
    'cloudId',
    'triggerOpen'
];

});



parcelRegister("h4rOi", function(module, exports) {

$parcel$export(module.exports, "useRovoEntitlement", () => $15b18b9de1edfe29$export$66d5dd4be64dea43);
$parcel$export(module.exports, "useRovoEntitlementActions", () => $15b18b9de1edfe29$export$8004893135276275);
$parcel$export(module.exports, "RovoEntitlementSetter", () => $15b18b9de1edfe29$export$d03a05ad8547472c);

var $5uXOq = parcelRequire("5uXOq");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $15b18b9de1edfe29$var$rovoEntitlementStore = (0, $iXqE5.createStore)({
    initialState: {
        isRovoEnabled: false
    },
    name: 'RovoEntitlementStore',
    actions: {
        setIsRovoEnabled: (isRovoEnabled, reason)=>({ setState: setState })=>{
                setState({
                    isRovoEnabled: isRovoEnabled,
                    reason: reason
                });
            }
    }
});
const $15b18b9de1edfe29$var$useStateHook = (0, $3sQ5x.createStateHook)($15b18b9de1edfe29$var$rovoEntitlementStore);
const $15b18b9de1edfe29$export$66d5dd4be64dea43 = ()=>{
    const result = $15b18b9de1edfe29$var$useStateHook();
    return {
        ...result,
        isRovoEnabled: result.isRovoEnabled
    };
};
const $15b18b9de1edfe29$export$8004893135276275 = (0, $3sQ5x.createActionsHook)($15b18b9de1edfe29$var$rovoEntitlementStore);
const $15b18b9de1edfe29$export$d03a05ad8547472c = ({ isRovoEnabled: isRovoEnabled })=>{
    const { setIsRovoEnabled: setIsRovoEnabled } = $15b18b9de1edfe29$export$8004893135276275();
    (0, $5uXOq.useMemo)(()=>{
        setIsRovoEnabled(isRovoEnabled);
    }, [
        isRovoEnabled,
        setIsRovoEnabled
    ]);
    return null;
};

});

parcelRegister("4QAPb", function(module, exports) {

$parcel$export(module.exports, "ChatContextSubscriber", () => $1af6b8e2e84b8435$export$29ff0802eb3bb217);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $hjiMw = parcelRequire("hjiMw");

var $1YYCC = parcelRequire("1YYCC");
const $1af6b8e2e84b8435$export$29ff0802eb3bb217 = ()=>{
    const { setEditorContext: setEditorContext, setBrowserContext: setBrowserContext, setJiraWorkflowContext: setJiraWorkflowContext } = (0, $1YYCC.useChatContextStoreActions)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hjiMw.Subscriber), {
        topic: "ai-mate",
        onEvent: async (payload)=>{
            // TODO https://product-fabric.atlassian.net/browse/AIM-1989 implement experience tracker
            try {
                switch(payload.type){
                    case 'editor-context-payload':
                        setEditorContext(payload.data);
                        break;
                    case 'browser-context-payload':
                        setBrowserContext(payload.data);
                        break;
                    case 'jira-workflow-wizard-actions':
                        (0, $VSDnB.fg)('enable_jira_workflow_wizard_agent_in_wf_editor') && setJiraWorkflowContext(payload.data);
                        break;
                    default:
                }
            } catch (error) {}
        }
    });
};

});
parcelRegister("1YYCC", function(module, exports) {

$parcel$export(module.exports, "useChatContextStoreActions", () => $ae2e3376a10d914c$export$53bf948a400e8426);
$parcel$export(module.exports, "useChatContextEditorContext", () => $ae2e3376a10d914c$export$9465f65715425f1b);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $ae2e3376a10d914c$var$store = (0, $iXqE5.createStore)({
    initialState: {
        editorContext: undefined,
        browserContext: undefined,
        jiraWorkflowContext: undefined
    },
    actions: {
        getJiraWorkflowContext: ()=>({ getState: getState })=>getState().jiraWorkflowContext,
        setJiraWorkflowContext: (jiraWorkflowContext)=>({ setState: setState })=>{
                setState({
                    jiraWorkflowContext: jiraWorkflowContext
                });
            },
        getEditorContext: ()=>({ getState: getState })=>getState().editorContext,
        setEditorContext: (editorContext)=>({ setState: setState })=>{
                setState({
                    editorContext: editorContext
                });
            },
        getBrowserContext: ()=>({ getState: getState })=>getState().browserContext,
        setBrowserContext: (browserContext)=>({ setState: setState })=>{
                setState({
                    browserContext: browserContext
                });
            }
    }
});
const $ae2e3376a10d914c$export$53bf948a400e8426 = (0, $3sQ5x.createActionsHook)($ae2e3376a10d914c$var$store);
const $ae2e3376a10d914c$export$9465f65715425f1b = (0, $3sQ5x.createHook)($ae2e3376a10d914c$var$store, {
    selector: (state)=>state.editorContext
});

});


parcelRegister("hlVrS", function(module, exports) {

$parcel$export(module.exports, "ConversationAssistantButton", () => $00f6bc802b15a660$export$7c328c0993982813);
$parcel$export(module.exports, "ConversationAssistantButtonNav4", () => $00f6bc802b15a660$export$25e85d244cbf7845);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jZ4fr = parcelRequire("jZ4fr");
var $kbqIt = parcelRequire("kbqIt");

var $koVbs = parcelRequire("koVbs");

var $gKZoD = parcelRequire("gKZoD");

var $711X2 = parcelRequire("711X2");

var $iEN9D = parcelRequire("iEN9D");

var $imZsD = parcelRequire("imZsD");
var $k6T4f = parcelRequire("k6T4f");
var $5Fk4Z = parcelRequire("5Fk4Z");

var $VSDnB = parcelRequire("VSDnB");

var $3bDjY = parcelRequire("3bDjY");

var $jSnf2 = parcelRequire("jSnf2");

var $fsNoS = parcelRequire("fsNoS");
var $5KAqU = parcelRequire("5KAqU");
var $9p6hi = parcelRequire("9p6hi");

var $Ee6JC = parcelRequire("Ee6JC");

var $dMUIg = parcelRequire("dMUIg");

var $cccYj = parcelRequire("cccYj");
const $00f6bc802b15a660$var$defaultButtonStyles = {
    paddingInline: '8px'
};
const $00f6bc802b15a660$var$inactiveButtonStyles = {
    background: "var(--ds-background-neutral, #091E420F)"
};
const $00f6bc802b15a660$var$disabledButtonStyles = {
    background: "var(--ds-background-disabled, #091E4208)",
    color: "var(--ds-text-disabled, #091E424F)"
};
const $00f6bc802b15a660$export$39aecc95f0365819 = ({ condition: condition, wrapper: wrapper, children: children })=>condition ? wrapper(children) : children;
const $00f6bc802b15a660$var$getConversationAssistantButton = (Button = (0, $711X2.PrimaryButton))=>({ testId: testId, isActive: isActive, isDisabled: isDisabled = false, onClick: onClickProp, tooltipContent: tooltipContent, siteId: siteId, productKey: productKey })=>{
        (0, $gKZoD.di)((0, $kbqIt.useCoordination), (0, $9p6hi.useCoordinationClient), (0, $iEN9D.default));
        const { formatMessage: formatMessage } = (0, $koVbs.default)();
        const { start: start } = (0, $5KAqU.useConversationAssistantSpotlightActions)();
        const [shouldShowMessage, setShouldShowMessage] = (0, $5uXOq.useState)(false);
        const messageId = productKey === 'confluence' ? 'confluence_rovo_chat_agents_spotlight_ga' : productKey === 'jira' ? 'jira_rovo_chat_agents_spotlight_ga' : '';
        const shouldUseCoordination = !!messageId;
        const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $jSnf2.useAnalytics)();
        const openRovoChat = (event, analyticsEvent)=>{
            if (!isActive && onClick) onClick(event, analyticsEvent);
        };
        const onClick = (0, $5uXOq.useCallback)((...params)=>{
            sendAnalyticsEvent({
                eventType: 'ui',
                action: 'clicked',
                actionSubject: 'rovoChatButton',
                attributes: {
                    isActive: isActive,
                    isDisabled: isDisabled,
                    productKey: productKey
                }
            });
            return onClickProp?.(...params);
        }, [
            isActive,
            isDisabled,
            onClickProp,
            productKey,
            sendAnalyticsEvent
        ]);
        const interactionName = isActive ? 'close-rovo-chat-nav-button' : 'open-rovo-chat-nav-button';
        const getChildren = ()=>{
            return /*#__PURE__*/ (0, $2OMIu.jsx)(Button, {
                onMouseEnter: ()=>{
                    if (shouldShowMessage) {
                        sendAnalyticsEvent({
                            eventType: 'ui',
                            action: 'hovered',
                            actionSubject: 'rovoChatButtonSpotlight'
                        });
                        start();
                    }
                },
                testId: testId,
                isSelected: isActive,
                onClick: onClick,
                isDisabled: isDisabled,
                tooltip: tooltipContent ?? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
                    children: (0, $VSDnB.fg)('rovo_chat_top_nav_button_label') ? formatMessage((0, $cccYj.messages).rovoChatButtonLabel) : formatMessage((0, $cccYj.messages).buttonLabel)
                }),
                style: {
                    /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766 */ ...$00f6bc802b15a660$var$defaultButtonStyles,
                    ...!isActive && $00f6bc802b15a660$var$inactiveButtonStyles,
                    ...isDisabled && $00f6bc802b15a660$var$disabledButtonStyles
                },
                iconBefore: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dMUIg.ChatIcon), {}),
                interactionName: interactionName,
                children: (0, $VSDnB.fg)('rovo_chat_top_nav_button_label') ? formatMessage((0, $cccYj.messages).rovoChatButtonLabel) : formatMessage((0, $cccYj.messages).buttonLabel)
            });
        };
        return shouldUseCoordination ? /*#__PURE__*/ (0, $2OMIu.jsx)($00f6bc802b15a660$export$de76c194bfb85689, {
            setShouldShowMessage: setShouldShowMessage,
            messageId: messageId,
            siteId: siteId,
            children: getChildren(),
            shouldShowMessage: shouldShowMessage,
            openRovoChat: openRovoChat
        }) : getChildren();
    };
const $00f6bc802b15a660$export$7c328c0993982813 = $00f6bc802b15a660$var$getConversationAssistantButton((0, $711X2.PrimaryButton));
const $00f6bc802b15a660$export$25e85d244cbf7845 = $00f6bc802b15a660$var$getConversationAssistantButton(function Nav4Button({ tooltip: tooltip, ...props }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        content: tooltip,
        // This button's visible text matches the tooltip
        // Announcing the tooltip means 'Chat' would be announced twice
        isScreenReaderAnnouncementDisabled: true,
        children: ({ ref: ref, ...triggerProps })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $Ee6JC.Button), {
                interactionName: props?.interactionName,
                ref: ref,
                ...triggerProps,
                ...props,
                onClick: (event, analyticsEvent)=>{
                    props.onClick?.(event, analyticsEvent);
                    triggerProps.onClick?.(event);
                },
                iconBefore: ()=>props.iconBefore || null
            })
    });
});
const $00f6bc802b15a660$export$de76c194bfb85689 = ({ children: children, messageId: messageId, siteId: siteId, setShouldShowMessage: setShouldShowMessage, shouldShowMessage: shouldShowMessage, openRovoChat: openRovoChat })=>{
    const { activeSpotlight: activeSpotlight } = (0, $5KAqU.useConversationAssistantSpotlightState)();
    const coordinationClient = (0, $9p6hi.useCoordinationClient)(siteId);
    const [onboardingStarted, stopOnboarding] = (0, $kbqIt.useCoordination)(coordinationClient, messageId);
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $jSnf2.useAnalytics)();
    const onDismissMessage = ()=>{
        setShouldShowMessage(false);
        stopOnboarding();
    };
    (0, $5uXOq.useEffect)(()=>{
        if (shouldShowMessage && activeSpotlight !== null) sendAnalyticsEvent({
            eventType: 'ui',
            action: 'shown',
            actionSubject: 'rovoChatButtonSpotlight'
        });
    }, [
        shouldShowMessage,
        activeSpotlight,
        sendAnalyticsEvent
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (onboardingStarted) setShouldShowMessage(true);
    }, [
        onboardingStarted,
        setShouldShowMessage
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($00f6bc802b15a660$export$39aecc95f0365819, {
        condition: shouldShowMessage,
        wrapper: (children)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $imZsD.default), {
                blanketIsTinted: true,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5Fk4Z.default), {
                    name: (0, $aa59d7827e216af2$export$12496216771c6bdd),
                    children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $k6T4f.Pulse), {
                        radius: 3,
                        pulse: activeSpotlight === null,
                        children: [
                            children,
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fsNoS.ConversationAssistantOnboardingSpotlight), {
                                onDismiss: onDismissMessage,
                                openRovoChat: openRovoChat
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jZ4fr.EngagementSpotlight), {
                                engagementId: (0, $aa59d7827e216af2$export$12496216771c6bdd)
                            })
                        ]
                    })
                })
            }),
        children: children
    });
};

});
parcelRegister("kbqIt", function(module, exports) {

$parcel$export(module.exports, "useCoordination", () => $88a44f4ad6e3d72a$export$3c29cca421979b0e);

var $5uXOq = parcelRequire("5uXOq");
const $88a44f4ad6e3d72a$export$3c29cca421979b0e = (coordinationClient, messageId)=>{
    const [started, setStarted] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        (async ()=>{
            try {
                const started = await coordinationClient.start(messageId);
                if (started) setStarted(true);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error(`Unable to start flow message ${messageId}. ${err}`);
            }
        })();
    }, [
        coordinationClient,
        messageId
    ]);
    const stop = (0, $5uXOq.useCallback)(async (force)=>{
        if (!force && !started) return;
        try {
            await coordinationClient.stop(messageId);
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error(`Unable to stop flow message ${messageId}. ${err}`);
        }
    }, [
        started,
        coordinationClient,
        messageId
    ]);
    return [
        started,
        stop
    ];
};

});

parcelRegister("fsNoS", function(module, exports) {

$parcel$export(module.exports, "ConversationAssistantOnboardingSpotlight", () => $7622f7ff4a4a9070$export$e4abc8af2fc5e2ac);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $gKZoD = parcelRequire("gKZoD");

var $7gs1W = parcelRequire("7gs1W");

var $jSnf2 = parcelRequire("jSnf2");

var $5KAqU = parcelRequire("5KAqU");


var $idu9A = parcelRequire("idu9A");
const $7622f7ff4a4a9070$export$e4abc8af2fc5e2ac = ({ openRovoChat: openRovoChat, openAgentSelectorMenu: openAgentSelectorMenu, onDismiss: onDismiss })=>{
    (0, $gKZoD.di)((0, $5KAqU.useConversationAssistantSpotlightState));
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { end: end } = (0, $5KAqU.useConversationAssistantSpotlightActions)();
    const { activeSpotlight: activeSpotlight } = (0, $5KAqU.useConversationAssistantSpotlightState)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $jSnf2.useAnalytics)();
    const renderActiveSpotlight = ()=>{
        const spotlights = [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7gs1W.default), {
                actions: [
                    {
                        onClick: (event, analyticsEvent)=>{
                            if (openRovoChat) openRovoChat(event, analyticsEvent);
                            end();
                            onDismiss();
                            sendAnalyticsEvent({
                                eventType: 'ui',
                                // this is more of 'chatButtonClicked'
                                action: 'dismissed',
                                actionSubject: 'rovoChatButtonSpotlight'
                            });
                        },
                        text: formatMessage((0, $idu9A.default).tryChat)
                    },
                    {
                        onClick: ()=>{
                            end();
                            onDismiss();
                            sendAnalyticsEvent({
                                eventType: 'ui',
                                action: 'dismissButtonClicked',
                                actionSubject: 'rovoChatButtonSpotlight'
                            });
                        },
                        text: formatMessage((0, $idu9A.default).dismissOnboarding),
                        appearance: 'subtle'
                    }
                ],
                heading: formatMessage((0, $idu9A.default).onboardingHeading),
                target: (0, $aa59d7827e216af2$export$12496216771c6bdd),
                targetRadius: 3,
                children: formatMessage((0, $idu9A.default).onboardingDescription)
            }, (0, $aa59d7827e216af2$export$12496216771c6bdd))
        ];
        if (activeSpotlight === null) return null;
        return spotlights[activeSpotlight];
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
        children: renderActiveSpotlight()
    });
};

});
parcelRegister("5KAqU", function(module, exports) {

$parcel$export(module.exports, "useConversationAssistantSpotlightActions", () => $c316b97c3ee7919f$export$283f4929c8863814);
$parcel$export(module.exports, "useConversationAssistantSpotlightState", () => $c316b97c3ee7919f$export$258c2a6b93cdef4a);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $c316b97c3ee7919f$var$initialState = {
    activeSpotlight: null
};
const $c316b97c3ee7919f$var$actions = {
    start: ()=>({ setState: setState })=>{
            setState({
                activeSpotlight: 0
            });
        },
    next: ()=>({ setState: setState, getState: getState })=>{
            setState({
                activeSpotlight: (getState().activeSpotlight || 0) + 1
            });
        },
    end: ()=>({ setState: setState })=>{
            setState({
                activeSpotlight: null
            });
        }
};
const $c316b97c3ee7919f$var$ConversationAssistantSpotlightStore = (0, $iXqE5.createStore)({
    initialState: $c316b97c3ee7919f$var$initialState,
    actions: $c316b97c3ee7919f$var$actions,
    name: 'ConversationAssistantSpotlightStore'
});
const $c316b97c3ee7919f$export$283f4929c8863814 = (0, $3sQ5x.createActionsHook)($c316b97c3ee7919f$var$ConversationAssistantSpotlightStore);
const $c316b97c3ee7919f$export$258c2a6b93cdef4a = (0, $3sQ5x.createStateHook)($c316b97c3ee7919f$var$ConversationAssistantSpotlightStore);

});

const $aa59d7827e216af2$export$12496216771c6bdd = 'rovo-chat-button';

parcelRegister("idu9A", function(module, exports) {

$parcel$export(module.exports, "default", () => $817b3ce69fd4391b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $817b3ce69fd4391b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    tryChat: {
        id: 'rovo-onboarding-try-chat',
        defaultMessage: 'Chat now',
        description: 'Action button for rovo onboarding spotlight'
    },
    dismissOnboarding: {
        id: 'rovo-onboarding-dismiss',
        defaultMessage: 'Dismiss',
        description: 'Dismiss button for rovo onboarding spotlight'
    },
    onboardingHeading: {
        id: 'rovo-onboarding-heading',
        defaultMessage: 'Chat with AI',
        description: 'Onboarding step heading'
    },
    onboardingDescription: {
        id: 'rovo-onboarding-description',
        defaultMessage: 'With Rovo Chat, use AI to explore company knowledge, create new things, and collaborate on your work.',
        description: 'Onboarding step description'
    }
});

});


parcelRegister("9p6hi", function(module, exports) {

$parcel$export(module.exports, "useCoordinationClient", () => $9751ca993e8ba900$export$ddc368dc94a41e62);

var $5uXOq = parcelRequire("5uXOq");

var $8Mq6c = parcelRequire("8Mq6c");
const $9751ca993e8ba900$export$ddc368dc94a41e62 = (cloudId, workspaceId, orgId)=>{
    return (0, $5uXOq.useMemo)(()=>new (0, $8Mq6c.default)({
            cloudId: cloudId,
            stargateUrl: '/gateway/api',
            workspaceId: workspaceId,
            orgId: orgId
        }), [
        cloudId,
        workspaceId,
        orgId
    ]);
};

});

parcelRegister("dMUIg", function(module, exports) {

$parcel$export(module.exports, "ChatIcon", () => $93d65af90b1ed4ae$export$52cd484a7ef4f2b9);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
const $93d65af90b1ed4ae$export$52cd484a7ef4f2b9 = ()=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    d: "M10.4489 3.4504L7.75593 4.49767C7.75381 4.4985 7.75381 4.5015 7.75593 4.50233L10.4489 5.5496C10.4496 5.54986 10.4501 5.55037 10.4503 5.55103L11.4976 8.24401C11.4984 8.24613 11.5014 8.24613 11.5023 8.24401L12.5495 5.55103C12.5498 5.55037 12.5503 5.54986 12.551 5.5496L15.2439 4.50233C15.2461 4.5015 15.2461 4.4985 15.2439 4.49767L12.551 3.4504C12.5503 3.45014 12.5498 3.44963 12.5495 3.44897L11.5023 0.755991C11.5014 0.753866 11.4984 0.753866 11.4976 0.755991L10.4503 3.44897C10.4501 3.44963 10.4496 3.45014 10.4489 3.4504Z",
                    stroke: "currentColor",
                    strokeWidth: "1.5"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M0 3.125C0 1.67525 1.17525 0.5 2.625 0.5H7.5V2H2.625C2.00368 2 1.5 2.50368 1.5 3.125V13.9576L4.05083 12.5H13.375C13.9963 12.5 14.5 11.9963 14.5 11.375V9H16V11.375C16 12.8247 14.8247 14 13.375 14H4.44917L1.12584 15.899C0.624381 16.1856 0 15.8237 0 15.2457V3.125Z",
                    fill: "currentColor"
                })
            ]
        })
    });
};

});

parcelRegister("cccYj", function(module, exports) {

$parcel$export(module.exports, "messages", () => $772596c67e72ecec$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $772596c67e72ecec$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    buttonLabel: {
        id: 'conversation-assistant-button.label',
        defaultMessage: 'Chat',
        description: 'Label for the button that opens the conversation assistant'
    },
    rovoChatButtonLabel: {
        id: 'conversation-assistant-button.rovo-label',
        defaultMessage: 'Rovo chat',
        description: 'Label for the button that opens the conversation assistant'
    }
});

});


parcelRegister("j2niS", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddc047cf9e7996a6$export$2e2bcd8739ae039);
function $ddc047cf9e7996a6$export$2e2bcd8739ae039(fn, arity, a) {
    a = a || [];
    if (a.length >= arity) return fn.apply(null, a.slice(0, arity).reverse());
    return function() {
        var args = Array.prototype.slice.call(arguments);
        return $ddc047cf9e7996a6$export$2e2bcd8739ae039(fn, arity, a.concat(args));
    };
}

});

parcelRegister("59y5F", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c083ca41bc0ca78$export$2e2bcd8739ae039);
// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.

var $jovBr = parcelRequire("jovBr");

var $j2niS = parcelRequire("j2niS");
var $3c083ca41bc0ca78$var$isValid = (0, $j2niS.default)((0, $jovBr.default), 1);
var $3c083ca41bc0ca78$export$2e2bcd8739ae039 = $3c083ca41bc0ca78$var$isValid;

});

parcelRegister("dQChl", function(module, exports) {

$parcel$export(module.exports, "default", () => $a14dd31138eb438e$export$2e2bcd8739ae039);
// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.

var $lb7qa = parcelRequire("lb7qa");

var $j2niS = parcelRequire("j2niS");
var $a14dd31138eb438e$var$isWithinInterval = (0, $j2niS.default)((0, $lb7qa.default), 2);
var $a14dd31138eb438e$export$2e2bcd8739ae039 = $a14dd31138eb438e$var$isWithinInterval;

});

parcelRegister("2xkYZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d8ef08fb2404f13$export$2e2bcd8739ae039);
// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.

var $gn1v9 = parcelRequire("gn1v9");

var $j2niS = parcelRequire("j2niS");
var $1d8ef08fb2404f13$var$sub = (0, $j2niS.default)((0, $gn1v9.default), 2);
var $1d8ef08fb2404f13$export$2e2bcd8739ae039 = $1d8ef08fb2404f13$var$sub;

});

const $90de389b166e701f$export$42f4885608027d0c = 'non_boolean';

const $6e65040b988c460f$export$f636b5b56f1d624a = 'Screen';
const $6e65040b988c460f$export$9d2de6eebf7462b5 = 'Drawer';
const $6e65040b988c460f$export$1171103ea9083ffa = 'Modal';
const $6e65040b988c460f$export$cae2783c9279926 = 'InlineDialog';
const $6e65040b988c460f$export$d1123261ca8831d2 = 'Dropdown';
const $6e65040b988c460f$export$a1562d08625f5d7e = 'UI';
const $6e65040b988c460f$export$947dac6c72b26f81 = 'TRACK';
const $6e65040b988c460f$export$f1d537d508d2945a = 'SCREEN';
const $6e65040b988c460f$export$12346a674644c156 = 'OPERATIONAL';
const $6e65040b988c460f$export$2ceccf177fae277c = 'analyticsBridge';

const $af03419a6de12610$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
const $af03419a6de12610$export$72f415121273627e = 'body > .atlaskit-portal-container';
const $af03419a6de12610$export$13f57c02915787b3 = 'atlaskit-portal';

const $edbbaf000cbe1dd7$export$ed5835cc67e87f72 = 'akPortalMount';
const $edbbaf000cbe1dd7$export$80816bd900e5bd00 = 'akPortalUnmount';

/**
 * Character key codes which can be used in keyboard events.
 */ const $5e71d9a7b5ef77ee$export$390330c10ff2b9a1 = 'ArrowUp';
const $5e71d9a7b5ef77ee$export$a80636c6f41931fe = 'ArrowDown';
const $5e71d9a7b5ef77ee$export$4af703091671bc = 'Home';
const $5e71d9a7b5ef77ee$export$e2bc30913faa5db7 = 'End';
const $5e71d9a7b5ef77ee$export$10f6869ed0a7d75b = 'Tab';
const $5e71d9a7b5ef77ee$export$8152f929a25a0ff4 = 'Enter';
const $5e71d9a7b5ef77ee$export$e51a3576c045c8d5 = 'Space';
const $5e71d9a7b5ef77ee$export$2bb790b9008907b4 = 'Escape';

// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
const $b276966247f2f12d$export$70df29c238ba7306 = 'mediaCtx'; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx

const $636842cf8e8f850b$export$b98e411ae80c806f = '/';

const $b2e0d12d54fddedd$export$cf090d5281b5ae06 = 10000;
const $b2e0d12d54fddedd$export$8575e30be0feb909 = 30000;

const $eba99f58997c09b3$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $eba99f58997c09b3$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $eba99f58997c09b3$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';
const $eba99f58997c09b3$export$45db2fc2f15997e7 = 'cubic-bezier(0,0,1,1)';

const $ff8b18549b2c06bf$export$d6830277b06edd6 = 'normal';

const $8acc83d90e579622$export$30fa7cc5f2690a43 = 56;
const $8acc83d90e579622$export$4033a111ca79977d = 1280;
const $8acc83d90e579622$export$24ec62cee78b7042 = 1130;
const $8acc83d90e579622$export$d8bde68ac946124f = '--ds--ans--fbc';
const $8acc83d90e579622$export$73e44f54603a0964 = '--ds--ans--hbgc';
const $8acc83d90e579622$export$13f8aa8f663f4c99 = '--ds--ans--bgc';
const $8acc83d90e579622$export$d81606c1fc5119bc = '--ds--ans--c';
const $8acc83d90e579622$export$65f656ad520ea71 = '--ds--ans--bc';

// dimension vars
const $565cb8192fc4e070$export$cbfb0f5b2869b17b = 'leftPanelWidth';
const $565cb8192fc4e070$export$a30f2e00489a8957 = 'leftSidebarWidth';
const $565cb8192fc4e070$export$c103b605cd368aed = 'rightSidebarWidth';
const $565cb8192fc4e070$export$fa34f417972d6341 = 'rightPanelWidth';
const $565cb8192fc4e070$export$3a6a779d9181047c = 'topNavigationHeight';
const $565cb8192fc4e070$export$bcd94a6a792e7f96 = 'bannerHeight';
const $565cb8192fc4e070$export$b6744d31294864fd = 'leftSidebarFlyoutWidth';
const $565cb8192fc4e070$export$344062f7cfc9528e = 'left-panel';
const $565cb8192fc4e070$export$c7139cc2d6110b5f = 'right-panel';
const $565cb8192fc4e070$export$238d30785c4bca84 = 'banner';
const $565cb8192fc4e070$export$bec6dca2e63de4ae = 'top-navigation';
const $565cb8192fc4e070$export$d1213e82613ff4df = 'content';
const $565cb8192fc4e070$export$be83e7118304b28e = 56;
const $565cb8192fc4e070$export$4a98ee0bd1ae362 = 56;
const $565cb8192fc4e070$export$539e68c09584883a = 240;
const $565cb8192fc4e070$export$b92df8810d2fcd01 = 280;
const $565cb8192fc4e070$export$c3e41153b9288bcf = 368;
const $565cb8192fc4e070$export$c4d6152f86ea28f6 = 368;
const $565cb8192fc4e070$export$46acf8758e9e2636 = 20;
const $565cb8192fc4e070$export$70740f5ad8360a78 = 16;
const $565cb8192fc4e070$export$991d5285ad765a3d = 240;
const $565cb8192fc4e070$export$6949d4f32b161684 = 200;
const $565cb8192fc4e070$export$d6e7e8af042815bb = 350;
const $565cb8192fc4e070$export$3749e1104328fde4 = 300;
const $565cb8192fc4e070$export$1074d925b0b82be5 = 200;
const $565cb8192fc4e070$export$451e84a45a9e4a75 = 'DS_PAGE_LAYOUT_UI_STATE';
const $565cb8192fc4e070$export$802bb2c050f3db5c = 'data-is-sidebar-dragging';
const $565cb8192fc4e070$export$5e5e1875c3fd8f4f = 'data-is-sidebar-collapsing';
const $565cb8192fc4e070$export$70c702a8c5895f03 = 'data-grab-area-line';
const $565cb8192fc4e070$export$48a43f91e4becf4e = 'data-grab-area';
const $565cb8192fc4e070$export$dac2fb31a9f6844d = 'data-resize-button';
const $565cb8192fc4e070$export$9ecd22db14e6c70e = 'data-resize-control';
const $565cb8192fc4e070$export$5253dd9707b8c3ba = 'data-ds--page-layout--slot';
const $565cb8192fc4e070$export$206a08f7f8beb554 = 'Skip to:';
const $565cb8192fc4e070$export$659ee746b31b360d = 'data-layout-container';
const $565cb8192fc4e070$export$f963aecf2d4465bd = `var(--${$565cb8192fc4e070$export$cbfb0f5b2869b17b}, 0px)`;
const $565cb8192fc4e070$export$750459958906793 = `var(--${$565cb8192fc4e070$export$fa34f417972d6341}, 0px)`;
const $565cb8192fc4e070$export$f897e1ed9f8ed251 = `var(--${$565cb8192fc4e070$export$a30f2e00489a8957}, 0px)`;
const $565cb8192fc4e070$export$b44ab66843c05a69 = `var(--${$565cb8192fc4e070$export$c103b605cd368aed}, 0px)`;
const $565cb8192fc4e070$export$aeff86a16f13529 = `var(--${$565cb8192fc4e070$export$3a6a779d9181047c}, 0px)`;
const $565cb8192fc4e070$export$ed7cc0d417ee89e = `var(--${$565cb8192fc4e070$export$bcd94a6a792e7f96}, 0px)`;
const $565cb8192fc4e070$export$d2fa14f05b61e66 = `var(--${$565cb8192fc4e070$export$b6744d31294864fd}, ${$565cb8192fc4e070$export$991d5285ad765a3d}px)`;

// Note: this value has been pulled into a separate file to better
// support testing with Playwright. Playwright did not like importing
// an exported value from `sidenav.tsx` which has `@jsxRuntime classic`.
//
// Error:
// > importSource cannot be set when runtime is classic.
/**
 * How long the flyout should remain open after the users
 * pointer has left the side nav flyout
 */ const $94307ebc0fda0ded$export$a7801e29f563faad = 400;

const $da88f8f66d8f0f0a$export$3288b14b6745c572 = 204;
const $da88f8f66d8f0f0a$export$c09e7ea0fc79f34f = 409;
const $da88f8f66d8f0f0a$export$974c37534b0191b1 = 503;

// Exported through entry point /src/utils.
/**
 * Used as the identifier for container on the consumer side.
 *
 * Example:
 * ```
 * <div id={CONVERSATION_ASSISTANT_CONTAINER_ID}>
 *  <ConversationAssistant />
 * </div>
 * ```
 */ const $1cb976721581e2e6$export$dffb4ed44e20ea9a = 'ai-mate-container';
const $1cb976721581e2e6$export$64aee74ba59709e5 = 439; // px
const $1cb976721581e2e6$export$1c07393c5bb1bc27 = 439; // px
const $1cb976721581e2e6$export$aa3478deee7adbeb = 350; // px
const $1cb976721581e2e6$export$21e515a86cd1733b = 'Chat';


$parcel$global.rlb("l253H")
//# sourceMappingURL=shared~atlassian-navigation~vendor~ar.05cb6f16.js.map
